// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7f1Tj":[function(require,module,exports,__globalThis) {
//import React from "react";
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDocTitle", ()=>setDocTitle);
parcelHelpers.export(exports, "switchToPresetForm", ()=>switchToPresetForm);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../common/common_utils");
var _seshTypes = require("../../../common/sesh_types");
var _dashboardScss = require("../../css/dashboard.scss");
var _dashboardUtils = require("./dashboard_utils");
var _seshRouter = require("./sesh_router");
var _seshRouterDefault = parcelHelpers.interopDefault(_seshRouter);
var _signUpPresets = require("./sign_up_presets");
var _trpc = require("./utils/trpc");
var _reactQuery = require("@tanstack/react-query");
var _client1 = require("@trpc/client");
// Create root once for the entire app
const rootContainer = document.getElementById("root");
const root = rootContainer ? (0, _client.createRoot)(rootContainer) : null;
function setDocTitle(info, guild_name) {
    const strings = [
        info
    ];
    if (guild_name) strings.push(guild_name);
    strings.push("sesh.fyi");
    document.title = strings.join(" - ");
}
async function onLoad() {
    root?.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {}));
    const query = new URLSearchParams(window.location.search);
    const is_on_sesh_fyi_production = window?.location?.host?.includes("sesh.fyi") && !window?.location?.host?.includes("beta");
    let client_id = is_on_sesh_fyi_production ? "616754792965865495" : await (await fetch(`/api/get_bot_client_id`)).text();
    let access_token = null;
    let token_type = null;
    let state;
    let state_string;
    if (query.has("state")) {
        // quick fix for + being converted to a space in query.get()
        state_string = query.get("state").replace(" ", "+");
        state = JSON.parse(atob(state_string));
    }
    if (query.has("code") && state?.code_source === "discord") {
        localStorage.clear();
        const code = query.get("code");
        // Remove code from URL
        const url = new URL(window.location.href);
        url.search = "";
        window.history.replaceState({}, "", url);
        // Exchange code for token
        const response = await fetch("/api/token", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                code
            })
        });
        if (!response.ok) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Failed to exchange code for token");
            return;
        }
        const tokenData = await response.json();
        access_token = tokenData.access_token;
        token_type = tokenData.token_type;
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("token_type", token_type);
    } else {
        access_token = localStorage.getItem("access_token");
        token_type = localStorage.getItem("token_type");
    }
    let redirect_uri;
    if (state) switch(state.dashboard_type){
        case (0, _seshTypes.WebDashboardType).Redirect:
            redirect_uri = state.redirect;
            break;
        case (0, _seshTypes.WebDashboardType).Guild_Selection:
            redirect_uri = "/dashboard";
            break;
        case (0, _seshTypes.WebDashboardType).Event:
            {
                // old behavior: `!create` => creates an event with a link to the channel, but event channel overrides it
                // new behavior: `!create` => creates an event with a link to the channel, but event channel does not override it?
                let new_url;
                if (state.event_message_id) new_url = (0, _commonUtils.common_utils).getEventEditURL(state.guild_id, state.event_message_id);
                else new_url = (0, _commonUtils.common_utils).getEventCreateURL(state.guild_id, state.original_channel_id);
                redirect_uri = new_url;
                break;
            }
        case (0, _seshTypes.WebDashboardType).Poll:
            {
                let new_url;
                if (state.message_id) new_url = (0, _commonUtils.common_utils).getPollEditURL(state.guild_id, state.message_id);
                else new_url = (0, _commonUtils.common_utils).getPollCreateURL(state.guild_id, state.original_channel_id);
                redirect_uri = new_url;
            }
            break;
        case (0, _seshTypes.WebDashboardType).Poll_Results:
            if (access_token && token_type) {
                const poll_id = Boolean(state.poll_id) ? state.poll_id : state.extra_state.poll_id;
                if (!poll_id) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("ERROR: No Poll ID Found.");
                    return;
                }
                const request_body = {
                    access_token,
                    token_type,
                    message_id: state.poll_id ?? state.extra_state.poll_id
                };
                const result = await fetch(`/api/get_guild_id_from_poll_id`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(request_body)
                });
                const guild_id = (await result.json()).guild_id;
                redirect_uri = (0, _commonUtils.common_utils).getPollResultsURL(guild_id, poll_id);
            } else {
                redirect_uri = window.location.toString();
                // no access token
                (0, _seshRouter.redirectToDiscordAuth)(client_id, access_token, redirect_uri, (0, _seshTypes.WebDashboardType).Poll_Results, {
                    poll_id: state.poll_id
                });
                return;
            }
            break;
        case (0, _seshTypes.WebDashboardType).Server_Settings:
            redirect_uri = (0, _commonUtils.common_utils).getGuildSettingsURL(state.guild_id);
            break;
        default:
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Invalid dashboard type");
            return;
    }
    if (!access_token || !token_type) {
        (0, _seshRouter.redirectToDiscordAuth)(client_id, access_token, window.location.pathname + window.location.search);
        return;
    }
    if (redirect_uri) history.pushState(null, null, redirect_uri);
    const discord_auth_token = {
        access_token,
        token_type
    };
    root?.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {
        discord_auth_token: discord_auth_token,
        sesh_client_id: client_id
    }));
}
window.onload = ()=>{
    // clear session cache on refresh
    for (let key of (0, _dashboardUtils.DashboardUtils).SESSION_CACHE_KEYS)window.sessionStorage.removeItem(key);
    onLoad();
};
async function switchToPresetForm(props, auth_token) {
    root?.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signUpPresets.SignUpOptionsForm), {
        ...props,
        auth_token: auth_token
    }));
}
function App(props) {
    const [queryClient] = (0, _react.useState)(()=>new (0, _reactQuery.QueryClient)({
            defaultOptions: {
                queries: {
                    onError: (error)=>{
                        const errorMessage = error?.message || "An unexpected error occurred";
                        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(errorMessage, "API Error");
                    }
                },
                mutations: {
                    onError: (error)=>{
                        const errorMessage = error?.message || "An unexpected error occurred";
                        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(errorMessage, "API Error");
                    }
                }
            }
        }));
    const [trpcClient] = (0, _react.useState)(()=>(0, _trpc.trpc).createClient({
            links: [
                (0, _client1.httpBatchLink)({
                    url: "/trpc",
                    headers () {
                        return {
                            access_token: props.discord_auth_token.access_token,
                            token_type: props.discord_auth_token.token_type
                        };
                    }
                })
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trpc.trpc).Provider, {
        client: trpcClient,
        queryClient: queryClient,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
            client: queryClient,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshRouterDefault.default), {
                    initial_token: props.discord_auth_token,
                    sesh_client_id: props.sesh_client_id
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-dom/client":"i3gF3","react-router-dom":"3XSn5","../../../common/common_utils":"gACUC","../../../common/sesh_types":"aUAOg","../../css/dashboard.scss":"bI26A","./dashboard_utils":"jvA8A","./sesh_router":"hfnpE","./sign_up_presets":"ij2CK","./utils/trpc":"dyYvM","@tanstack/react-query":[["QueryClient","jC0Ps"],["QueryClientProvider","dHYz4"]],"@trpc/client":"98Zm4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bI26A":[function() {},{}],"hfnpE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>UserContext);
parcelHelpers.export(exports, "GuildRolesAndChannelContext", ()=>GuildRolesAndChannelContext);
parcelHelpers.export(exports, "GuildListContext", ()=>GuildListContext);
parcelHelpers.export(exports, "redirectToDiscordAuth", ()=>redirectToDiscordAuth);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../common/common_utils");
var _seshTypes = require("../../../common/sesh_types");
var _dashboardUtils = require("./dashboard_utils");
var _eventCreation = require("./event_creation");
var _eventCreationDefault = parcelHelpers.interopDefault(_eventCreation);
var _channelSettingsPicker = require("./forms/channel_settings_picker");
var _adminPage = require("./forms/improved_components/admin/admin_page");
var _dstFixPageImproved = require("./forms/improved_components/dst_fix_page/dst_fix_page_improved");
var _dstFixPageImprovedDefault = parcelHelpers.interopDefault(_dstFixPageImproved);
var _useGuildMembers = require("./forms/improved_components/hooks/use_guild_members");
var _useTemplateId = require("./forms/improved_components/hooks/use_template_id");
var _useUserPreferencesModal = require("./forms/improved_components/hooks/use_user_preferences_modal");
var _calendarSettingsPage = require("./forms/improved_components/listings_form/event/calendar/components/calendar_settings_page");
var _eventListBase = require("./forms/improved_components/listings_form/event/event_list_base");
var _pollListingForm = require("./forms/improved_components/listings_form/poll_listing_form/poll_listing_form");
var _pollListingFormDefault = parcelHelpers.interopDefault(_pollListingForm);
var _navbar = require("./forms/improved_components/navbar");
var _premiumPage = require("./forms/improved_components/premium_page/premium_page");
var _stripeRedirectPage = require("./forms/improved_components/premium_page/stripe_redirect_page");
var _rsvpDisplayFormPage = require("./forms/improved_components/rsvp_display_form/rsvp_display_form_page");
var _statusBanner = require("./forms/improved_components/status_banner");
var _userPreferencesModal = require("./forms/improved_components/user_preferences/user_preferences_modal");
var _guildOptions = require("./guild_options");
var _guildSelect = require("./guild_select");
var _googleRedirectPage = require("./guild_settings/google_redirect_page");
var _googleRedirectPageDefault = parcelHelpers.interopDefault(_googleRedirectPage);
var _guildSettings = require("./guild_settings/guild_settings");
var _pollCreation = require("./poll_creation");
var _pollCreationDefault = parcelHelpers.interopDefault(_pollCreation);
var _pollResults = require("./poll_results");
var _trpc = require("./utils/trpc");
var _blurbWrapper = require("./forms/improved_components/blurb/blurb_wrapper");
var _timeFinderDashboard = require("./forms/improved_components/time-finder/time_finder_dashboard");
var _seshToaster = require("./forms/improved_components/sesh_toaster");
const UserContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
const GuildRolesAndChannelContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
const GuildListContext = /*#__PURE__*/ (0, _reactDefault.default).createContext([]);
async function redirectToDiscordAuth(client_id, access_token, desired_redirect_uri, dashboard_type = (0, _seshTypes.WebDashboardType).Redirect, extra_state) {
    const prefix = location.protocol + "//" + location.host;
    const base_redirect_uri = encodeURIComponent(prefix + "/dashboard/");
    const state = {
        redirect: desired_redirect_uri,
        dashboard_type: dashboard_type,
        extra_state: extra_state,
        code_source: "discord"
    };
    const encoded_state = (0, _commonUtils.common_utils).encode_state(state);
    const auth_uri = `https://discord.com/api/oauth2/authorize?client_id=${client_id}&redirect_uri=${base_redirect_uri}&response_type=code&scope=identify%20guilds%20email&state=${encoded_state}&test=hello`;
    localStorage.clear();
    if (access_token) {
        const clear_token_body = {
            access_token
        };
        await fetch(`/api/clear_token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(clear_token_body)
        }).catch(()=>{});
    }
    window.location.replace(auth_uri);
}
function InitGuildSelect(props) {
    if (!props.list_of_guilds) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSelect.GuildSelectForm), {
        list_of_guilds: props.list_of_guilds,
        auth_token: props.discord_auth_token,
        bot_client_id: props.sesh_client_id
    });
}
function InitPollListings() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollListingFormDefault.default), {});
}
function InitGuildSettings(props) {
    let { server_id } = (0, _reactRouterDom.useParams)();
    const history = (0, _reactRouterDom.useHistory)();
    const location1 = (0, _reactRouterDom.useLocation)();
    const match = (0, _reactRouterDom.useRouteMatch)();
    if (!props.settings_data || !props.roles_and_channels_cache.has(server_id)) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const roles_and_channels_data = props.roles_and_channels_cache.get(server_id);
    const poll_channel = roles_and_channels_data.channels.find((val)=>props.settings_data.initial_poll_channel_id == val.id);
    const event_channel = roles_and_channels_data.channels.find((val)=>props.settings_data.initial_event_channel_id == val.id);
    const guild_settings = {
        ...props.settings_data.original_guild_settings,
        event_channel,
        poll_channel
    };
    const settings_form_props = {
        ...props.settings_data,
        original_guild_settings: guild_settings,
        all_text_channels: roles_and_channels_data.channels,
        all_voice_channels: roles_and_channels_data.voice_channels,
        roles: roles_and_channels_data.roles,
        sesh_has_manage_roles: roles_and_channels_data.sesh_has_manage_roles,
        sesh_has_manage_events: roles_and_channels_data.sesh_has_manage_events,
        user_has_manage_events: roles_and_channels_data.user_has_manage_events,
        sesh_role_name: roles_and_channels_data.sesh_role_name,
        on_save_func: props.on_save_func,
        on_premium_modified_func: props.on_premium_modified_func
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSettings.GuildSettingsForm), {
        ...settings_form_props,
        auth_token: props.discord_auth_token,
        clear_parents_settings_data_func: props.clear_settings_data_func,
        history: history,
        location: location1,
        match: match
    });
}
function InitGuildChannelSettings(props) {
    let { server_id, channel_id } = (0, _reactRouterDom.useParams)();
    const history = (0, _reactRouterDom.useHistory)();
    const location1 = (0, _reactRouterDom.useLocation)();
    const match = (0, _reactRouterDom.useRouteMatch)();
    if (!props.channel_settings_overrides || !props.guild_settings_data || !props.roles_and_channels_cache.has(server_id)) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const roles_and_channels_data = props.roles_and_channels_cache.get(server_id);
    const poll_channel = roles_and_channels_data.channels.find((val)=>props.guild_settings_data.initial_poll_channel_id === val.id);
    const event_channel = roles_and_channels_data.channels.find((val)=>props.guild_settings_data.initial_event_channel_id === val.id);
    const guild_settings = {
        ...props.guild_settings_data.original_guild_settings,
        event_channel,
        poll_channel
    };
    const settings_form_props = {
        ...props.guild_settings_data,
        original_guild_settings: guild_settings,
        all_text_channels: roles_and_channels_data.channels,
        all_voice_channels: roles_and_channels_data.voice_channels,
        roles: roles_and_channels_data.roles,
        sesh_has_manage_roles: roles_and_channels_data.sesh_has_manage_roles,
        sesh_has_manage_events: roles_and_channels_data.sesh_has_manage_events,
        user_has_manage_events: roles_and_channels_data.user_has_manage_events,
        sesh_role_name: roles_and_channels_data.sesh_role_name,
        on_save_func: props.on_save_func
    };
    const individual_channel_settings_overrides = props.channel_settings_overrides.overrides[channel_id];
    const channel_we_are_overriding_settings_for = roles_and_channels_data.channels.find((val)=>channel_id === val.id);
    if (!channel_we_are_overriding_settings_for) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderDashboardErrorPage, {
        title: "Error 404",
        text: `Channel ID ${channel_id} not found`
    });
    if (channel_we_are_overriding_settings_for.type === "Thread") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderDashboardErrorPage, {
        title: "Error",
        text: `Can not override settings on a thread. Change the parent channel's settings instead.`
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSettings.GuildSettingsForm), {
        ...settings_form_props,
        auth_token: props.discord_auth_token,
        clear_parents_settings_data_func: props.clear_settings_data_func,
        history: history,
        location: location1,
        match: match,
        is_channel_settings_overrides_page: true,
        individual_channel_id: channel_id,
        individual_channel_settings_overrides: individual_channel_settings_overrides
    });
}
function InitGuildChannelPicker(props) {
    let { server_id } = (0, _reactRouterDom.useParams)();
    let history = (0, _reactRouterDom.useHistory)();
    const guild_data = props.list_of_guilds.find((val)=>val.id === server_id);
    if (!guild_data) {
        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(`Invalid server id: ${server_id}`);
        history.replace("/dashboard/");
        return null;
    }
    if (!props.channel_settings_data || !props.roles_and_channels_cache.has(server_id)) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const roles_and_channels_data = props.roles_and_channels_cache.get(server_id);
    // const poll_channel = roles_and_channels_data.channels.find(
    // 	(val) => props.settings_data.initial_poll_channel_id == val.id
    // );
    // const event_channel = roles_and_channels_data.channels.find(
    // 	(val) => props.settings_data.initial_event_channel_id == val.id
    // );
    // const attendee_role_data_with_ids =
    // 	props.settings_data.initial_attendee_role_data;
    // const attendee_role_data: AttendeeRoleData = {
    // 	remove_on_end: attendee_role_data_with_ids.remove_on_end,
    // 	role_add_time: attendee_role_data_with_ids.role_add_time,
    // 	roles: attendee_role_data_with_ids.role_ids.map((role_id) =>
    // 		roles_and_channels_data.roles.find((role) => role.id === role_id)
    // 	),
    // };
    // const guild_settings: GuildSettings = {
    // 	...props.settings_data.guild_settings,
    // 	event_channel,
    // 	poll_channel,
    // 	attendee_role_data,
    // };
    // const settings_form_props: GuildSettingsProps = {
    // 	...props.settings_data,
    // 	guild_settings,
    // 	channels: roles_and_channels_data.channels,
    // 	roles: roles_and_channels_data.roles,
    // 	sesh_has_manage_roles: roles_and_channels_data.sesh_has_manage_roles,
    // 	sesh_role_name: roles_and_channels_data.sesh_role_name,
    // };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelSettingsPicker.ChannelSettingsPickerForm), {
        guild_data: guild_data,
        channel_settings_overrides: props.channel_settings_data,
        roles_and_channels: roles_and_channels_data,
        auth_token: props.discord_auth_token,
        on_save_func: props.on_save_func
    });
}
function InitPollResults() {
    let { server_id, message_id } = (0, _reactRouterDom.useParams)();
    const guild_list = (0, _react.useContext)(GuildListContext);
    const guild_data = guild_list?.find((val)=>val.id === server_id);
    const get_list_item_query = (0, _trpc.trpc).poll.getListItem.useQuery({
        guild_id: server_id,
        message_id: message_id
    });
    const options_query = (0, _trpc.trpc).poll.votesOverview.useQuery({
        guild_id: server_id,
        message_id: message_id
    });
    const unique_vote_count_query = (0, _trpc.trpc).poll.uniqueVoteCount.useQuery({
        guild_id: server_id,
        message_id: message_id
    });
    if (!guild_data || !get_list_item_query.isSuccess || !options_query.isSuccess || !unique_vote_count_query.isSuccess) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    // if we do not have voter names, we need to wait for members data
    // if we do have voter names, we do not need to wait
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollResults.PollResultsForm), {
        guild_data: guild_data,
        poll: get_list_item_query.data,
        options: options_query.data,
        unique_vote_count: unique_vote_count_query.data
    });
}
function InitPollCreation(props) {
    let { server_id, message_id } = (0, _reactRouterDom.useParams)();
    // only wait for poll data
    if (!props.poll_data_cache.has(server_id)) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const poll_data = props.poll_data_cache.get(server_id);
    if (message_id) {
        if (poll_data.edit_data?.poll_message_id !== message_id) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    }
    const roles_and_channels_data = props.roles_and_channels_cache.get(server_id);
    const poll_creation_props = {
        ...poll_data,
        roles: roles_and_channels_data?.roles,
        all_channel_data: roles_and_channels_data?.channels,
        auth_token: props.discord_auth_token,
        is_edit: props.is_edit,
        edit_data: props.is_edit ? poll_data.edit_data : undefined,
        on_unmount: Boolean(props.on_unmount) ? ()=>props.on_unmount(server_id) : undefined,
        on_poll_edited_func: props.on_poll_edited_func
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollCreationDefault.default), {
        ...poll_creation_props
    });
}
function InitEventCreation(props) {
    let { server_id, message_id } = (0, _reactRouterDom.useParams)();
    const [template_id, type, id] = (0, _useTemplateId.useTemplateId)();
    // State is used for event templates to force a rerender when same template is selected
    const state = (0, _reactRouterDom.useLocation)().state;
    // Ensure this is not an edit via checking for message id existence
    const has_template = Boolean(template_id) && !Boolean(message_id);
    const template_query = (0, _trpc.trpc).event_template.get.useQuery({
        guild_id: server_id,
        message_id: type === "event" ? id : undefined,
        template_id: type === "template" ? id : undefined
    }, {
        enabled: has_template
    });
    // only wait for event data
    if (!props.event_data_cache.has(server_id)) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    if (has_template && !template_query.isSuccess) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const event_data = props.event_data_cache.get(server_id);
    const roles_and_channels_data = props.roles_and_channels_cache.get(server_id);
    if (event_data.is_premium && !roles_and_channels_data) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    if (message_id) {
        if (event_data.edit_data?.event_message_id !== message_id) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    }
    const event_creation_props = {
        ...event_data,
        template_data: has_template ? template_query.data : undefined,
        roles: roles_and_channels_data?.roles,
        all_text_channels: roles_and_channels_data?.channels,
        sesh_has_manage_roles: roles_and_channels_data?.sesh_has_manage_roles,
        sesh_has_manage_events: roles_and_channels_data?.sesh_has_manage_events,
        user_has_manage_events: roles_and_channels_data?.user_has_manage_events,
        sesh_role_name: roles_and_channels_data?.sesh_role_name,
        all_voice_channels: roles_and_channels_data?.voice_channels,
        auth_token: props.discord_auth_token,
        is_edit: props.is_edit,
        edit_data: props.is_edit ? event_data.edit_data : undefined,
        on_event_edited_func: props.on_event_edited_func,
        on_unmount: Boolean(props.on_unmount) ? ()=>props.on_unmount(server_id) : undefined
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventCreationDefault.default), {
        ...event_creation_props
    }, template_id ? `${state?.uuid}_${template_id}` : "no-template");
}
function InitGuildOptions(props) {
    let { server_id } = (0, _reactRouterDom.useParams)();
    let history = (0, _reactRouterDom.useHistory)();
    const location1 = (0, _reactRouterDom.useLocation)();
    const match = (0, _reactRouterDom.useRouteMatch)();
    if (!props.list_of_guilds) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const guild_data = props.list_of_guilds?.find((val)=>val.id === server_id);
    if (!guild_data) {
        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(`Invalid server id: ${server_id}`);
        history.replace("/dashboard/");
        return null;
    }
    const guild_select_props = {
        auth_token: props.auth_token,
        guild_data,
        history,
        location: location1,
        match
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildOptions.GuildOptionsForm), {
        ...guild_select_props
    });
}
function createCacheData() {
    return {
        currently_being_fetched: false,
        cache: new Map()
    };
}
class SeshRouter extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props), this.PathData = {
            guild_select: {
                path: "/dashboard",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildDataAndUpdateState(true);
                },
                title: "Server Select"
            },
            google_redirect: {
                path: "/dashboard/google",
                exact: true
            },
            premium: {
                path: "/dashboard/premium",
                exact: true,
                title: "Premium"
            },
            stripe_redirect: {
                path: "/dashboard/premium/stripe",
                exact: true
            },
            guild_options: {
                path: "/dashboard/:server_id",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildDataAndUpdateState(true);
                },
                title: ""
            },
            guild_settings: {
                path: "/dashboard/:server_id/settings",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildSettingsAndUpdateState(params.server_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Settings"
            },
            guild_calendar_settings: {
                path: "/dashboard/:server_id/settings/calendar",
                exact: true,
                title: "Settings"
            },
            guild_channel_settings_picker: {
                path: "/dashboard/:server_id/settings/channels",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildChannelSettingsAndUpdateState(params.server_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Settings"
            },
            guild_channel_settings: {
                path: "/dashboard/:server_id/settings/channels/:channel_id",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildSettingsAndUpdateState(params.server_id);
                    this.fetchGuildChannelSettingsAndUpdateState(params.server_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Settings"
            },
            guild_channel: {
                path: "/dashboard/:server_id/settings/channels",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildChannelSettingsAndUpdateState(params.server_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Settings"
            },
            event_creation: {
                path: "/dashboard/:server_id/events/create",
                redirect_url_data: {
                    path_generate_func: (params, query)=>{
                        const channel_id = query.get("channel_id");
                        return (0, _commonUtils.common_utils).getEventCreateURL(params.server_id, channel_id);
                    },
                    urls_that_should_redirect: [
                        "/dashboard/:server_id/create_event"
                    ]
                },
                title: "Creating Event",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchEventDataAndUpdateState(params.server_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                }
            },
            event_listings: {
                path: "/dashboard/:server_id/events",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Events"
            },
            time_finder: {
                path: "/dashboard/:server_id/time-finder",
                exact: true,
                title: "Time Finder"
            },
            time_finder_create: {
                path: "/dashboard/:server_id/time-finder/create",
                exact: true,
                title: "Create Time Finder",
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                }
            },
            time_finder_view: {
                path: "/dashboard/:server_id/time-finder/view/:instance_id",
                exact: true,
                title: "View Time Finder",
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                }
            },
            time_finder_list: {
                path: "/dashboard/:server_id/time-finder/view",
                exact: true,
                title: "Time Finder List"
            },
            time_finder_edit: {
                path: "/dashboard/:server_id/time-finder/edit/:instance_id",
                exact: true,
                title: "Edit Time Finder",
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                }
            },
            event_attendees: {
                path: "/dashboard/:server_id/events/attendees/:message_id",
                exact: true,
                title: "Event Attendees"
            },
            event_editing: {
                path: "/dashboard/:server_id/events/edit/:message_id",
                redirect_url_data: {
                    path_generate_func: (params)=>(0, _commonUtils.common_utils).getEventEditURL(params.server_id, params.message_id),
                    urls_that_should_redirect: [
                        "/dashboard/:server_id/edit_event/:message_id"
                    ]
                },
                title: "Editing Event",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchEventDataAndUpdateState(params.server_id, params.message_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                }
            },
            poll_creation: {
                path: "/dashboard/:server_id/polls/create",
                redirect_url_data: {
                    path_generate_func: (params, query)=>{
                        const channel_id = query.get("channel_id");
                        return (0, _commonUtils.common_utils).getPollCreateURL(params.server_id, channel_id);
                    },
                    urls_that_should_redirect: [
                        "/dashboard/:server_id/create_poll"
                    ]
                },
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchPollDataAndUpdateState(params.server_id, params.message_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Creating Poll"
            },
            poll_listings: {
                path: "/dashboard/:server_id/polls",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Polls"
            },
            poll_editing: {
                path: "/dashboard/:server_id/polls/edit/:message_id",
                exact: true,
                redirect_url_data: {
                    path_generate_func: (params)=>(0, _commonUtils.common_utils).getPollEditURL(params.server_id, params.message_id),
                    urls_that_should_redirect: [
                        "/dashboard/:server_id/edit_poll/:message_id"
                    ]
                },
                switch_func: (params, query)=>{
                    this.fetchPollDataAndUpdateState(params.server_id, params.message_id);
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "Editing Poll"
            },
            poll_results: {
                path: "/dashboard/:server_id/polls/results/:message_id",
                redirect_url_data: {
                    path_generate_func: (params)=>(0, _commonUtils.common_utils).getPollResultsURL(params.server_id, params.message_id),
                    urls_that_should_redirect: [
                        "/dashboard/:server_id/poll_results/:message_id"
                    ]
                },
                exact: true,
                title: "Poll Results"
            },
            dst_fix: {
                path: "/dashboard/:server_id/events/dst_fix",
                exact: true,
                switch_func: (params, query)=>{
                    this.fetchGuildRolesAndChannelsAndUpdateState(params.server_id);
                },
                title: "DST Fix"
            }
        };
        const cached_user_data = (0, _dashboardUtils.DashboardUtils).GetParsedValueFromLocalStorage((0, _dashboardUtils.DashboardUtils).USER_DATA_CACHE_KEY);
        const guild_data = (0, _dashboardUtils.DashboardUtils).GetParsedValueFromLocalStorage((0, _dashboardUtils.DashboardUtils).GUILD_DATA_CACHE_KEY)?.guild_data;
        this.state = {
            discord_auth_token: this.props.initial_token,
            user_data: cached_user_data,
            list_of_guilds_data: {
                list: guild_data,
                already_fetched: false,
                currently_being_fetched: false
            },
            event_data_cache: createCacheData(),
            poll_data_cache: createCacheData(),
            guild_roles_and_channels_cache: createCacheData(),
            poll_listings_cache: createCacheData(),
            members: new Map(),
            is_user_preferences_open: false
        };
        this.fetchEventDataAndUpdateState = this.fetchEventDataAndUpdateState.bind(this);
        this.onPollCreatedOrEdited = this.onPollCreatedOrEdited.bind(this);
    }
    componentDidMount() {
        // this.props.history.replace({
        // 	pathname: "/dashboard/",
        // 	search: "?" + new URLSearchParams({ clientId: "test" }).toString(),
        // });
        fetch("https://discord.com/api/users/@me", {
            headers: {
                authorization: `${this.state.discord_auth_token.token_type} ${this.state.discord_auth_token.access_token}`
            }
        }).then(async (response)=>{
            let user_response = await response.json();
            if (!user_response.id) {
                redirectToDiscordAuth(this.props.sesh_client_id, this.state.discord_auth_token.access_token, this.props.location.pathname + window.location.search);
                return;
            }
            const avatar_uri = user_response.avatar ? `https://cdn.discordapp.com/avatars/${user_response.id}/${user_response.avatar}.png?size=64` : `https://cdn.discordapp.com/embed/avatars/${Number(BigInt(user_response.id) >> 22n) % 6}.png`;
            const user_data = {
                id: user_response.id,
                avatar_uri: avatar_uri,
                discriminator: user_response.discriminator,
                username: user_response.username
            };
            localStorage.setItem((0, _dashboardUtils.DashboardUtils).USER_DATA_CACHE_KEY, JSON.stringify(user_data));
            this.setState({
                user_data
            });
            this.matchPathAndCallSwitchFuncs();
            this.fetchGuildDataAndUpdateState(true);
        }).catch((err)=>{
            console.log(err);
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Make sure you do not have any browser extensions blocking Discord API calls.", "Discord API Fetch Error").then(()=>{
                redirectToDiscordAuth(this.props.sesh_client_id, this.state.discord_auth_token.access_token);
            });
        });
    }
    fetchGuildDataAndUpdateState(page_requires_guild_data = false) {
        // store guild data on sesh router, only fetch if we're on a page that needs it
        // if cache is empty, fetch regardless
        const should_fetch = page_requires_guild_data && !this.state.list_of_guilds_data.already_fetched || !Boolean(this.state.list_of_guilds_data.list);
        if (!should_fetch) //console.log("Guild List from Cache");
        return;
        if (this.state.list_of_guilds_data.currently_being_fetched) //console.log("Guild List Duplicate Fetch (Aborting)");
        return;
        //console.log("Fetching Guild List");
        // update it instantly because setState is not guaranteed to be instant
        this.state.list_of_guilds_data.currently_being_fetched = true;
        if (this.state.list_of_guilds_data.already_fetched) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Duplicate guild data fetch. Aborting.");
            return;
        }
        this.setState({
            list_of_guilds_data: {
                currently_being_fetched: true,
                list: this.state.list_of_guilds_data.list,
                already_fetched: this.state.list_of_guilds_data.already_fetched
            }
        });
        (0, _dashboardUtils.DashboardUtils).FetchUsersGuildData(this.state.discord_auth_token).then((val)=>{
            this.setState({
                list_of_guilds_data: {
                    list: val?.props ?? this.state.list_of_guilds_data.list,
                    already_fetched: true,
                    currently_being_fetched: false
                }
            });
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname != prevProps.location.pathname) this.matchPathAndCallSwitchFuncs();
    }
    matchPathAndCallSwitchFuncs() {
        const query = new URLSearchParams(location.search);
        for(let k in this.PathData){
            const current_path_data = this.PathData[k];
            if (current_path_data.switch_func) {
                let path_matches = (0, _reactRouterDom.matchPath)(this.props.location.pathname, {
                    path: current_path_data.path,
                    exact: current_path_data.exact
                });
                if (!path_matches && current_path_data.redirect_url_data) for (let url of current_path_data.redirect_url_data.urls_that_should_redirect){
                    path_matches = (0, _reactRouterDom.matchPath)(this.props.location.pathname, {
                        path: url,
                        exact: current_path_data.exact
                    });
                    if (path_matches) {
                        this.props.history.replace(current_path_data.redirect_url_data.path_generate_func(path_matches.params, query));
                        //this.props.history.push(current_path_data.path);
                        return;
                    }
                }
                if (path_matches) {
                    current_path_data.switch_func(path_matches.params, query);
                    return;
                }
            }
        }
    }
    fetchGuildRolesAndChannelsAndUpdateState(guild_id, force) {
        if (this.state.guild_roles_and_channels_cache.cache.has(guild_id) && !force) //console.log(guild_id, "Roles/Channels Cache");
        return;
        if (this.state.guild_roles_and_channels_cache.currently_being_fetched) //console.log(guild_id, "Roles/Channels Duplicate Fetch (Aborting)");
        return;
        //console.log(guild_id, "Fetching Roles/Channels");
        // update it instantly because setState is not guaranteed to be instant
        this.state.guild_roles_and_channels_cache.currently_being_fetched = true;
        this.setState({
            guild_roles_and_channels_cache: {
                currently_being_fetched: true,
                cache: this.state.guild_roles_and_channels_cache.cache
            }
        });
        return (0, _dashboardUtils.DashboardUtils).FetchGuildRolesAndChannels(this.state.discord_auth_token, guild_id).then((val)=>{
            this.state.guild_roles_and_channels_cache.cache.set(guild_id, val);
            this.setState({
                guild_roles_and_channels_cache: {
                    currently_being_fetched: false,
                    cache: this.state.guild_roles_and_channels_cache.cache
                }
            });
        });
    }
    async onPollCreatedOrEdited(guild_id, display_data) {
        if (!this.state.poll_listings_cache.cache.has(guild_id)) return;
        const roles_and_channels_cache = this.state.guild_roles_and_channels_cache.cache.get(guild_id);
        if (!roles_and_channels_cache.channels?.find((val)=>val.id === display_data.channel_id)) await this.fetchGuildRolesAndChannelsAndUpdateState(guild_id, true);
        const listing_cache = this.state.poll_listings_cache.cache.get(guild_id);
        const poll_index = listing_cache.findIndex((val)=>val.message_id === display_data.message_id);
        if (poll_index > -1) listing_cache[poll_index] = display_data;
        else listing_cache.push(display_data);
        this.setState({
            poll_listings_cache: {
                currently_being_fetched: this.state.poll_listings_cache.currently_being_fetched,
                cache: this.state.poll_listings_cache.cache
            }
        });
    }
    fetchPollDataAndUpdateState(guild_id, message_id) {
        // should fetch if never fetched before OR if it is an edit
        const should_fetch = Boolean(!this.state.poll_data_cache.cache.has(guild_id)) || Boolean(message_id);
        if (!should_fetch) //console.log(guild_id, `Poll Data Cache`);
        return;
        if (this.state.poll_data_cache.currently_being_fetched) //console.log(guild_id, "Poll Data Cache Duplicate Fetch (Aborting)");
        return;
        // update it instantly because setState is not guaranteed to be instant
        this.state.poll_data_cache.currently_being_fetched = true;
        this.setState({
            poll_data_cache: {
                currently_being_fetched: true,
                cache: this.state.poll_data_cache.cache
            }
        });
        //console.log(guild_id, `Fetching Poll Data`);
        (0, _pollCreation.fetchPollData)(this.state.discord_auth_token, guild_id, message_id).then((val)=>{
            if (!val) this.props.history.replace((0, _commonUtils.common_utils).getGuildOptionsURL(guild_id));
            else this.state.poll_data_cache.cache.set(guild_id, val);
            this.setState({
                poll_data_cache: {
                    currently_being_fetched: false,
                    cache: this.state.poll_data_cache.cache
                }
            });
        });
    }
    fetchEventDataAndUpdateState(guild_id, message_id) {
        // should fetch if never fetched before OR if it is an edit
        const should_fetch = Boolean(!this.state.event_data_cache.cache.has(guild_id)) || Boolean(message_id);
        if (!should_fetch) //console.log(guild_id, `Event Data Cache`);
        return;
        if (this.state.event_data_cache.currently_being_fetched) // console.log(
        // 	guild_id,
        // 	"Event Data Cache Duplicate Fetch (Aborting)"
        // );
        return;
        // update it instantly because setState is not guaranteed to be instant
        this.state.event_data_cache.currently_being_fetched = true;
        this.setState({
            event_data_cache: {
                currently_being_fetched: true,
                cache: this.state.event_data_cache.cache
            }
        });
        //console.log(guild_id, `Fetching Event Data`);
        (0, _eventCreation.fetchEventData)(this.state.discord_auth_token, guild_id, message_id).then((val)=>{
            if (!val) this.props.history.replace((0, _commonUtils.common_utils).getGuildOptionsURL(guild_id));
            else this.state.event_data_cache.cache.set(guild_id, val);
            this.setState({
                event_data_cache: {
                    currently_being_fetched: false,
                    cache: this.state.event_data_cache.cache
                }
            });
        });
    }
    fetchGuildSettingsAndUpdateState(guild_id) {
        //console.log("Fetching Guild Settings");
        (0, _guildSettings.fetchGuildSettings)(this.state.discord_auth_token, guild_id).then((val)=>this.setState({
                guild_settings_data: val
            }));
    }
    fetchGuildChannelSettingsAndUpdateState(guild_id) {
        //console.log("Fetching Guild Channel Settings");
        (0, _guildSettings.fetchGuildChannelSettings)(this.state.discord_auth_token, guild_id).then((val)=>this.setState({
                guild_channel_settings_overrides: val
            }));
    }
    handleRoutes() {
        let on_save_func = (settings, individual_channel_settings_overrides, channel_id, guild_id, refetch_channels)=>{
            if (settings) {
                let new_cache_data = {
                    ...this.state.guild_settings_data,
                    original_guild_settings: settings,
                    initial_event_channel_id: settings.event_channel?.id,
                    initial_poll_channel_id: settings.poll_channel?.id
                };
                this.setState({
                    guild_settings_data: new_cache_data
                });
            }
            if (individual_channel_settings_overrides) {
                if (refetch_channels && guild_id) this.fetchGuildRolesAndChannelsAndUpdateState(guild_id, true);
                let new_cache_data = (0, _lodash.cloneDeep)(this.state.guild_channel_settings_overrides);
                new_cache_data.overrides[channel_id] = individual_channel_settings_overrides;
                this.setState({
                    guild_channel_settings_overrides: new_cache_data
                });
            }
        };
        if (!this.state.user_data || !this.state.list_of_guilds_data?.list) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage()
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildListContext.Provider, {
                value: this.state.list_of_guilds_data?.list ?? [],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserContext.Provider, {
                    value: {
                        ...this.state.user_data,
                        ...this.state.discord_auth_token
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: true,
                                path: "/dashboard/admin",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminPage.AdminPage), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: this.PathData.premium.path,
                                exact: this.PathData.premium.exact,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumPage.PremiumPage), {
                                    back_link: this.props.location.state?.prev_path
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: this.PathData.stripe_redirect.path,
                                exact: this.PathData.stripe_redirect.exact,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stripeRedirectPage.StripeRedirectPage), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.google_redirect.exact,
                                path: this.PathData.google_redirect.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleRedirectPageDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_options.exact,
                                path: this.PathData.guild_options.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitGuildOptions, {
                                    list_of_guilds: this.state.list_of_guilds_data.list,
                                    auth_token: this.state.discord_auth_token
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_settings.exact,
                                path: this.PathData.guild_settings.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitGuildSettings, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    settings_data: this.state.guild_settings_data,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    clear_settings_data_func: ()=>this.setState({
                                            guild_settings_data: null
                                        }),
                                    on_save_func: on_save_func,
                                    on_premium_modified_func: (props)=>{
                                        const guild_in_guild_data_list = this.state.list_of_guilds_data.list.find((val)=>val.id === props.guild_data.id);
                                        guild_in_guild_data_list.is_premium = props.is_premium;
                                        const event_data_cache = this.state.event_data_cache?.cache?.get(props.guild_data.id);
                                        if (event_data_cache) event_data_cache.is_premium = props.is_premium;
                                        const poll_data_cache = this.state.poll_data_cache?.cache?.get(props.guild_data.id);
                                        if (poll_data_cache) poll_data_cache.is_premium = props.is_premium;
                                        this.setState({
                                            guild_settings_data: props,
                                            list_of_guilds_data: this.state.list_of_guilds_data,
                                            event_data_cache: this.state.event_data_cache,
                                            poll_data_cache: this.state.poll_data_cache
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_calendar_settings.exact,
                                path: this.PathData.guild_calendar_settings.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarSettingsPage.CalendarSettingsPage), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_channel_settings_picker.exact,
                                path: this.PathData.guild_channel_settings_picker.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitGuildChannelPicker, {
                                    list_of_guilds: this.state.list_of_guilds_data.list,
                                    discord_auth_token: this.state.discord_auth_token,
                                    channel_settings_data: this.state.guild_channel_settings_overrides,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    clear_settings_data_func: ()=>this.setState({
                                            guild_channel_settings_overrides: null
                                        }),
                                    on_save_func: (deleted_override_channel_id)=>{
                                        let new_cache_data = (0, _lodash.cloneDeep)(this.state.guild_channel_settings_overrides);
                                        delete new_cache_data.overrides[deleted_override_channel_id];
                                        this.setState({
                                            guild_channel_settings_overrides: new_cache_data
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_channel_settings.exact,
                                path: this.PathData.guild_channel_settings.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitGuildChannelSettings, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    channel_settings_overrides: this.state.guild_channel_settings_overrides,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    clear_settings_data_func: ()=>this.setState({
                                            guild_channel_settings_overrides: null
                                        }),
                                    guild_settings_data: this.state.guild_settings_data,
                                    on_save_func: on_save_func
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // create event
                            ), {
                                exact: this.PathData.event_creation.exact,
                                path: this.PathData.event_creation.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitEventCreation, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    event_data_cache: this.state.event_data_cache.cache,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    is_edit: false
                                }, "create_event")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // edit event
                            ), {
                                exact: this.PathData.event_editing.exact,
                                path: this.PathData.event_editing.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitEventCreation, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    event_data_cache: this.state.event_data_cache.cache,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    is_edit: true,
                                    on_unmount: (server_id)=>{
                                        this.state.event_data_cache.cache.delete(server_id);
                                        this.setState({
                                            event_data_cache: {
                                                cache: this.state.event_data_cache.cache,
                                                currently_being_fetched: this.state.event_data_cache.currently_being_fetched
                                            }
                                        });
                                    }
                                }, "edit_event")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // event listings
                            ), {
                                exact: this.PathData.event_listings.exact,
                                path: this.PathData.event_listings.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventListBase.EventListBase), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.time_finder.exact,
                                path: this.PathData.time_finder.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderDashboard.TimeFinderDashboard), {
                                    type: "base"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.time_finder_create.exact,
                                path: this.PathData.time_finder_create.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderDashboard.TimeFinderDashboard), {
                                    type: "create"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.time_finder_view.exact,
                                path: this.PathData.time_finder_view.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderDashboard.TimeFinderDashboard), {
                                    type: "view"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.time_finder_list.exact,
                                path: this.PathData.time_finder_list.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderDashboard.TimeFinderDashboard), {
                                    type: "view"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.time_finder_edit.exact,
                                path: this.PathData.time_finder_edit.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderDashboard.TimeFinderDashboard), {
                                    type: "edit"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.dst_fix.exact,
                                path: this.PathData.dst_fix.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dstFixPageImprovedDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // event attendees
                            ), {
                                exact: this.PathData.event_attendees.exact,
                                path: this.PathData.event_attendees.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpDisplayFormPage.RSVPDisplayFormPage), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // create poll
                            ), {
                                exact: this.PathData.poll_creation.exact,
                                path: this.PathData.poll_creation.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitPollCreation, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    poll_data_cache: this.state.poll_data_cache.cache,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    is_edit: false,
                                    on_poll_edited_func: this.onPollCreatedOrEdited
                                }, "create_poll")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // edit poll
                            ), {
                                exact: this.PathData.poll_editing.exact,
                                path: this.PathData.poll_editing.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitPollCreation, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    poll_data_cache: this.state.poll_data_cache.cache,
                                    roles_and_channels_cache: this.state.guild_roles_and_channels_cache.cache,
                                    is_edit: true,
                                    on_poll_edited_func: this.onPollCreatedOrEdited,
                                    on_unmount: (server_id)=>{
                                        this.state.poll_data_cache.cache.delete(server_id);
                                        this.setState({
                                            poll_data_cache: {
                                                cache: this.state.poll_data_cache.cache,
                                                currently_being_fetched: this.state.poll_data_cache.currently_being_fetched
                                            }
                                        });
                                    }
                                }, "edit_poll")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route // poll listings
                            ), {
                                exact: this.PathData.poll_listings.exact,
                                path: this.PathData.poll_listings.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitPollListings, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.poll_results.exact,
                                path: this.PathData.poll_results.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitPollResults, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: this.PathData.guild_select.exact,
                                path: this.PathData.guild_select.path,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitGuildSelect, {
                                    discord_auth_token: this.state.discord_auth_token,
                                    list_of_guilds: this.state.list_of_guilds_data.list,
                                    sesh_client_id: this.props.sesh_client_id
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: false,
                                path: "/dashboard/",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderDashboardErrorPage, {
                                    text: "Page not found",
                                    title: "404"
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    render() {
        // store guild data on sesh router, only fetch if we're on a page that needs it (same with guild members)
        // if cache is empty, fetch regardless
        if (!this.state) {
            (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
            return;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _useUserPreferencesModal.UserPreferencesModalContext).Provider, {
            value: {
                is_open: this.state.is_user_preferences_open,
                setIsOpen: (is_open)=>this.setState({
                        is_user_preferences_open: is_open
                    })
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshToaster.SeshToaster), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbar.Navbar), {
                            type: "dashboard",
                            user_data: this.state.user_data,
                            sesh_client_id: this.props.sesh_client_id,
                            discord_auth_token: this.state.discord_auth_token
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusBanner.StatusBanner), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildRolesAndChannelContext.Provider, {
                            value: this.state.guild_roles_and_channels_cache.cache,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _useGuildMembers.GuildMemberContext).Provider, {
                                value: {
                                    members: this.state.members,
                                    getMembers: (guild_id)=>{
                                        return this.state.members.get(guild_id) ?? [];
                                    },
                                    addMembers: (guild_id, members)=>{
                                        this.setState((state)=>{
                                            const existing_members = state.members.get(guild_id) ?? [];
                                            const existing_members_map = {};
                                            const all_members = existing_members.concat(members);
                                            for (const member of all_members)existing_members_map[member.id] = member;
                                            state.members.set(guild_id, Object.values(existing_members_map));
                                            const map_clone = new Map(state.members);
                                            return {
                                                ...state,
                                                members: map_clone
                                            };
                                        });
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blurbWrapper.BlurbWrapper), {
                                        children: this.handleRoutes()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "section"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userPreferencesModal.UserPreferencesModal), {})
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(SeshRouter);

},{"react/jsx-runtime":"dpQXr","lodash":"fIO2m","react":"IMRgT","react-router-dom":[["matchPath","3XSn5"],["Route","djWTS"],["Switch","djWTS"],["useHistory","djWTS"],["useLocation","djWTS"],["useParams","djWTS"],["useRouteMatch","djWTS"],["withRouter","djWTS"]],"../../../common/common_utils":"gACUC","../../../common/sesh_types":"aUAOg","./dashboard_utils":"jvA8A","./event_creation":"a8uX3","./forms/channel_settings_picker":"kC6wM","./forms/improved_components/admin/admin_page":"aT6UX","./forms/improved_components/dst_fix_page/dst_fix_page_improved":"emCby","./forms/improved_components/hooks/use_guild_members":"iK4oL","./forms/improved_components/hooks/use_template_id":"geI3T","./forms/improved_components/hooks/use_user_preferences_modal":"7PgND","./forms/improved_components/listings_form/event/calendar/components/calendar_settings_page":"eq7hL","./forms/improved_components/listings_form/event/event_list_base":"5jRGe","./forms/improved_components/listings_form/poll_listing_form/poll_listing_form":"eeO3i","./forms/improved_components/navbar":"hW22W","./forms/improved_components/premium_page/premium_page":"c9Srw","./forms/improved_components/premium_page/stripe_redirect_page":"klRLV","./forms/improved_components/rsvp_display_form/rsvp_display_form_page":"6VxYK","./forms/improved_components/status_banner":"8cw2q","./forms/improved_components/user_preferences/user_preferences_modal":"GVrDV","./guild_options":"gXAWx","./guild_select":"jlwhz","./guild_settings/google_redirect_page":"jkI4d","./guild_settings/guild_settings":"gNnfh","./poll_creation":"1rPaz","./poll_results":"9uXeh","./utils/trpc":"dyYvM","./forms/improved_components/blurb/blurb_wrapper":"6sYWe","./forms/improved_components/time-finder/time_finder_dashboard":"3d3dA","./forms/improved_components/sesh_toaster":"ja211","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"a8uX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumFeatures", ()=>PremiumFeatures);
parcelHelpers.export(exports, "PlaceholderNames", ()=>PlaceholderNames);
parcelHelpers.export(exports, "PlaceholderDescriptions", ()=>PlaceholderDescriptions);
parcelHelpers.export(exports, "EventCreationContext", ()=>EventCreationContext);
parcelHelpers.export(exports, "PlaceholderTimes", ()=>PlaceholderTimes);
parcelHelpers.export(exports, "IDsToMentionables", ()=>IDsToMentionables);
parcelHelpers.export(exports, "fetchEventData", ()=>fetchEventData);
parcelHelpers.export(exports, "EventCreation", ()=>EventCreation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textInput = require("./forms/text_input");
var _webUi = require("./web_ui");
// pick a date util library
var _luxon = require("luxon");
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _rrule = require("rrule");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouterDom = require("react-router-dom");
var _commonFormatUtils = require("../../../common/common_format_utils");
var _commonUtils = require("../../../common/common_utils");
var _constants = require("../../../common/constants");
var _timeFormatUtils = require("../../../common/time_format_utils");
var _typeUtils = require("../../../common/type_utils");
var _dashboardUtils = require("./dashboard_utils");
var _eventColorPicker = require("./forms/event_color_picker");
var _eventColorPickerDefault = parcelHelpers.interopDefault(_eventColorPicker);
var _imageUploader = require("./forms/image_uploader");
var _addRoleToAttendeesEventForm = require("./forms/improved_components/add_role_to_attendees_event_form");
var _advancedEventCreationSelector = require("./forms/improved_components/advanced_event_creation_selector");
var _channelDropdownWithTags = require("./forms/improved_components/channel_dropdown_with_tags");
var _dateFieldWithDuration = require("./forms/improved_components/date_field_with_duration");
var _eventTemplatePage = require("./forms/improved_components/event_templates/event_template_page");
var _eventThreadForm = require("./forms/improved_components/event_thread_form");
var _eventListBase = require("./forms/improved_components/listings_form/event/event_list_base");
var _note = require("./forms/improved_components/note");
var _repeatFormComponent = require("./forms/improved_components/repeat_form_component");
var _serverRemindersBlurb = require("./forms/improved_components/server_reminders/server_reminders_blurb");
var _seshAccordianComponent = require("./forms/improved_components/sesh_accordian_component");
var _signupOptionBlurb = require("./forms/improved_components/signup_options/signup_option_blurb");
var _nativeEventForm = require("./forms/native_event_form");
var _nativeEventFormDefault = parcelHelpers.interopDefault(_nativeEventForm);
var _roleRestrictions = require("./forms/role_restrictions");
var _textArea = require("./forms/text_area");
var _eventCreationUtils = require("./utils/event_creation_utils");
var _lockRsvpsBefore = require("./forms/improved_components/lock_rsvps_before/lock_rsvps_before");
const PremiumFeatures = [
    "rrule",
    "eligible_role_ids",
    "attendee_role_data",
    "is_ai_enabled"
];
// Janky way to require all types in an ordered object
const FIELD_ORDER = {
    event_name: undefined,
    start_time: undefined,
    description: undefined,
    selected_channel: undefined
};
const PlaceholderNames = [
    "Apex Legends",
    "Minecraft",
    "Valorant 5 Stack"
];
const PlaceholderDescriptions = [
    "Let's have fun :D",
    "First five to RSVP get dibs!",
    "Invite your friends!"
];
const EventCreationContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
const PlaceholderTimes = [
    {
        start_time: "in 5 hours",
        duration: "1 hr 20 min"
    },
    {
        start_time: "Tomorrow at 5pm",
        duration: "1 hr 30 min"
    },
    {
        start_time: "8/21 at 2 pm",
        duration: "1 hr 40 min"
    }
];
function IDsToMentionables(user_ids, mentionables) {
    if (!mentionables) return [];
    return mentionables.filter((val)=>user_ids.includes(val.id));
}
async function fetchEventData(auth_token, guild_id, message_id) {
    let request_body = {
        access_token: auth_token.access_token,
        token_type: auth_token.token_type,
        guild_id: guild_id,
        message_id: message_id
    };
    return fetch(`/api/get_event_data`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
class EventCreation extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props), this.fields = {}, this.modified_settings = {}, this.pending_revert_state_updates = {};
        if (this.props.template_data) for(const key in this.props.template_data.json)this.modified_settings[(0, _eventCreationUtils.EventSettingToGuildSetting)[key]] = true;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getGuildOrChannelSetting = this.getGuildOrChannelSetting.bind(this);
        this.getSelectedChannel.bind(this);
        this.state = this.createInitialState();
        this.populate_field_list("event_name", this.createTitleField);
        this.populate_field_list("start_time", this.createTimeField);
        this.populate_field_list("selected_channel", this.createChannelField);
        this.populate_field_list("rsvp_options", this.createRSVPOptionsField);
        this.populate_field_list("description", this.createDescriptionField);
        this.populate_field_list("thread_settings", this.createThreadField);
        this.populate_field_list("color", this.createColorField);
        this.populate_field_list("image_url", this.createImageField);
        this.populate_field_list("hide_attendees", this.createHideEventAttendeesField);
        this.populate_field_list("native_event_data", this.createDiscordNativeEventMirrorField);
        this.populate_field_list("eligible_role_ids", this.createRoleRestrictionsField);
        this.populate_field_list("attendee_role_data", this.createAddRoleToAttendeesField);
        this.populate_field_list("rrule", this.createRepeatField);
        this.populate_field_list("rsvp_lock_before_ms", this.createLockRSVPsBeforeField);
        this.populate_field_list("server_reminders", this.createServerRemindersField);
    }
    createInitialState(force_new = false) {
        let placeholder_name = PlaceholderNames[Math.floor(Math.random() * PlaceholderNames.length)];
        let placeholder_description = PlaceholderDescriptions[Math.floor(Math.random() * PlaceholderDescriptions.length)];
        let placeholder_time_fields = PlaceholderTimes[Math.floor(Math.random() * PlaceholderTimes.length)];
        let placeholder_fields = {
            event_name: placeholder_name,
            description: placeholder_description,
            start_time: placeholder_time_fields.start_time,
            duration: placeholder_time_fields.duration
        };
        for(let key in placeholder_fields)placeholder_fields[key] = "ex: " + placeholder_fields[key];
        let user_timezone = _luxon.DateTime.local().zone.name;
        (0, _webUi.setDocTitle)(this.props.is_edit ? "Editing event" : "Creating event", this.props.guild_name);
        if (!force_new && this.props.is_edit) {
            if (!this.props.edit_data) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("No edit data found.");
                return;
            }
        }
        const editable_state = (0, _eventCreationUtils.createInitialEventState)(this, {
            user_timezone
        });
        const base_state = {
            can_make_recurring: this.props.can_make_recurring,
            guild_data_for_this_guild: this.props.all_guild_data.find((val)=>val.id === this.props.guild_id),
            guild_timezone: this.props.guild_timezone,
            header_text: this.props.is_edit ? this.getEditHeaderText(this.props.edit_data.event_name) : this.getCreateHeaderText(),
            inform_users_of_edit: true,
            is_confirming: false,
            is_edit: this.props.is_edit,
            loading_roles_and_channels: !Boolean(this.props.roles),
            use_24h_clock: this.props.use_24h_clock,
            confirmation_data: null,
            custom_emojis: this.props.custom_emojis,
            user_presets: this.props.user_presets,
            placeholder_fields: placeholder_fields,
            original_start_time: editable_state.start_time,
            user_timezone: user_timezone,
            current_page: "main"
        };
        const state = {
            ...editable_state,
            ...base_state
        };
        return state;
    }
    getUpdatedChannelData() {
        const roles = this.props.roles;
        if (!roles) return {
            selected_channel: null
        };
        const all_channels = this.props.is_edit ? this.props.all_text_channels : this.props.all_text_channels.filter((val)=>val.has_write);
        const query = new URLSearchParams(this.props.location.search);
        const channel_id_from_param = query.get("channel_id");
        let selected_channel_id;
        if (this.props.is_edit) selected_channel_id = this.props.edit_data.sent_channel_data.id;
        else if (this.props.template_data) // If there's a channel id in param, prioritize that
        selected_channel_id = channel_id_from_param ? channel_id_from_param : this.props.template_data.json.sent_channel_data.id;
        else if (this.props.can_select_channel) selected_channel_id = Boolean(channel_id_from_param) ? channel_id_from_param : this.props.event_channel_id;
        else selected_channel_id = this.props.event_channel_id;
        let selected_channel = all_channels.find((val)=>val.id === selected_channel_id);
        if (this.props.is_edit) {
            if (!selected_channel || !selected_channel.has_write) {
                let error_text;
                if (!selected_channel) error_text = `Original event channel (id: ${this.props.edit_data.sent_channel_data.id}) not found. Please ensure both you and sesh have read/write/embed links permissions in the original channel of this event.`;
                else error_text = `Invalid permissions for channel #${selected_channel.name}.  Please ensure both you and sesh have read/write/embed links permissions in the channel.`;
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(error_text);
                this.props.history.push((0, _commonUtils.common_utils).getGuildOptionsURL(this.props.guild_id));
                return;
            }
        }
        if (!selected_channel) selected_channel = all_channels[0];
        if (!selected_channel) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("No valid channels found. Please ensure both you and sesh have read/write/embed links permissions in atleast one channel in the server.");
            this.props.history.push((0, _commonUtils.common_utils).getGuildOptionsURL(this.props.guild_id));
            return;
        }
        if (!this.props.is_edit) {
            query.set("channel_id", selected_channel.id);
            this.props.history.replace(`create?${query}`);
        }
        return {
            selected_channel
        };
    }
    componentDidMount() {
        if (this.props.is_edit) {
            if (this.state.start_time < _luxon.DateTime.utc()) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("This event has already started! Unable to edit.");
                this.props.history.replace((0, _commonUtils.common_utils).getEventCreateURL(this.props.guild_id));
                return;
            }
        }
    }
    componentWillUnmount() {
        if (this.props.on_unmount) this.props.on_unmount();
    }
    getSelectedChannel() {
        return this.props.all_text_channels?.find((val)=>val.id === this.state.selected_channel?.id);
    }
    getModifiedSettingsKey(key) {
        return this.modified_settings[key];
    }
    updateModifiedSettingsKey(key, val) {
        if (!val) {
            delete this.modified_settings[key];
            return;
        }
        if ((0, _eventCreationUtils.ServerRemindersGroupedKeys).includes(key)) {
            (0, _eventCreationUtils.ServerRemindersGroupedKeys).forEach((val)=>this.modified_settings[val] = true);
            return;
        }
        this.modified_settings[key] = true;
    }
    componentDidUpdate(prevProps, prevState) {
        const roles_and_channels_updated = prevProps.roles == null && this.props.roles != null;
        if (prevState.selected_channel?.id == this.state.selected_channel?.id) // Only update this if the state change was *not* caused by channel switching
        for (const key of Object.keys((0, _eventCreationUtils.EventSettingToGuildSetting))){
            if (this.pending_revert_state_updates[key]) {
                delete this.pending_revert_state_updates[key];
                continue;
            }
            if ((0, _commonUtils.common_utils).areObjectsEqual(prevState[key], this.state[key])) continue;
            // Used to keep track of what settings were modified.
            // If a setting was *not* modified, then we want to update it to the default on channel switch
            this.updateModifiedSettingsKey((0, _eventCreationUtils.EventSettingToGuildSetting)[key], true);
        }
        if (roles_and_channels_updated) {
            const roles_and_channels_data = this.getUpdatedChannelData();
            this.setState({
                selected_channel: roles_and_channels_data?.selected_channel ? {
                    id: roles_and_channels_data.selected_channel.id,
                    forum_tag_ids: []
                } : undefined,
                loading_roles_and_channels: false
            });
        }
        if (!this.props.is_edit) {
            const channel_changed = prevState.selected_channel?.id != this.state.selected_channel?.id;
            if (channel_changed) {
                if (this.state.selected_channel) {
                    const query = new URLSearchParams(this.props.location.search);
                    query.set("channel_id", this.state.selected_channel.id);
                    this.props.history.replace(`create?${query}`);
                }
            }
        }
    }
    populate_field_list(key, value) {
        value = value.bind(this);
        this.fields[key.toString()] = value;
    }
    getCalculatedEndTimeIfSet() {
        if (!this.state.duration_ms || !this.state.start_time) return;
        return this.state.start_time.plus({
            millisecond: this.state.duration_ms
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        if (this.state.event_name.length === 0) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Event name is required!", undefined, ()=>this.scrollToElement("event_name"));
            return;
        }
        if (!this.state.start_time) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("A valid start time is required!", undefined, ()=>this.scrollToElement("start_time"));
            return;
        }
        if (this.state.start_time < _luxon.DateTime.utc()) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Can't make an event with a start time in the past!", undefined, ()=>this.scrollToElement("start_time"));
            return;
        }
        const calculated_end_time = this.getCalculatedEndTimeIfSet();
        if (this.getCalculatedEndTimeIfSet() && this.state.start_time > calculated_end_time) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Start time must be earlier than end time!", undefined, ()=>this.scrollToElement("start_time"));
            return;
        }
        if (this.state.rsvp_options) {
            let dupe = (0, _commonFormatUtils.common_format_utils).get_duplicate_emojis_in_preset(this.state.rsvp_options);
            if (dupe) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(`Duplicate custom emojis [${dupe}]! Can not use the same emoji for multiple options.`, undefined, ()=>this.scrollToElement("rsvp_options"));
                return;
            }
        }
        const selected_channel = this.getSelectedChannel();
        if (selected_channel.type === "Forum" && selected_channel.tag_settings.required && this.state.selected_channel.forum_tag_ids.length === 0) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Must have at least one tag selected for this channel", undefined, ()=>this.scrollToElement("selected_channel"));
            return;
        }
        let rrule_str;
        if (this.state.rrule) {
            let first_two_repeat_times = this.state.rrule.all((d, l)=>{
                return l < 2;
            });
            if (first_two_repeat_times.length >= 2) {
                let first_repeat_time = _luxon.DateTime.fromJSDate(first_two_repeat_times[0]);
                let second_repeat_time = _luxon.DateTime.fromJSDate(first_two_repeat_times[1]);
                let repeat_delay = second_repeat_time.diff(first_repeat_time);
                let event_duration;
                if (this.state.duration_ms) event_duration = (0, _luxon.Duration).fromMillis(this.state.duration_ms);
                else event_duration = _luxon.Duration.fromObject((0, _constants.Constants).DEFAULT_EVENT_DURATION);
                if (repeat_delay.as("minutes") < event_duration.as("minutes")) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Can not make an event repeat faster than the event's duration.\nSet the end time earlier to fix this.", undefined, ()=>this.scrollToElement("rrule"));
                    return;
                }
            }
            rrule_str = (0, _rrule.RRule).optionsToString((0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone(this.state.rrule.origOptions, this.state.user_timezone, this.state.start_time));
        }
        const local_timezone = _luxon.DateTime.local().zone.name;
        if (!this.state.is_edit) {
            this.setState({
                is_confirming: true
            });
            const props = this.props;
            const is_attendee_role_data_overriding_server_default = !(0, _commonUtils.common_utils).areAttendeeRoleDatasEqual(this.getGuildOrChannelSetting("attendee_role_data"), this.state.attendee_role_data);
            const is_native_event_data_overriding_server_default = !(0, _commonUtils.common_utils).areObjectsEqual(this.getGuildOrChannelSetting("default_native_event_data"), this.state.native_event_data);
            const is_thread_settings_overriding_server_default = !(0, _commonUtils.common_utils).areObjectsEqual(this.getGuildOrChannelSetting("default_event_thread_settings"), this.state.thread_settings);
            sendEventData({
                user_id: this.props.user_id,
                guild_id: this.props.guild_id,
                event_name: this.state.event_name,
                start_time_str: this.state.start_time.toISO(),
                end_time_str: this.getCalculatedEndTimeIfSet()?.toISO(),
                rrule_string: rrule_str,
                allow_maintain_repeat_rsvp: this.state.allow_maintain_repeat_rsvp,
                channel_id: this.state.selected_channel.id,
                event_description: this.state.description,
                rsvp_options: this.state.rsvp_options,
                color: this.state.color,
                mention_data: {
                    create_role_mentions: this.state.role_mentions_on_create,
                    create_user_mentions: this.state.user_mentions_on_create
                },
                eligible_role_ids: this.state.eligible_role_ids,
                hide_attendees: this.state.hide_attendees,
                image_url: this.state.image_url,
                attendee_role_override_data: {
                    is_overriding_server_default: is_attendee_role_data_overriding_server_default,
                    value: this.state.attendee_role_data
                },
                server_reminders: this.state.server_reminders,
                access_token: this.props.auth_token.access_token,
                forum_tag_ids: this.state.selected_channel.forum_tag_ids,
                native_event_override_data: {
                    is_overriding_server_default: is_native_event_data_overriding_server_default,
                    value: is_native_event_data_overriding_server_default ? this.state.native_event_data : undefined
                },
                thread_settings: this.getSelectedChannel().type !== "Thread" ? {
                    value: this.state.thread_settings,
                    is_overriding_server_default: is_thread_settings_overriding_server_default
                } : undefined,
                event_timezone: this.state.event_timezone,
                token_type: this.props.auth_token.token_type,
                date_input_description: {
                    input: this.state.date_input,
                    timezone: local_timezone
                },
                exdates: this.state.exdates?.map((val)=>val.toISOString()),
                rdates: this.state.rdates?.map((val)=>({
                        orig_date: new Date(val.orig_date).toISOString(),
                        rdate: new Date(val.rdate).toISOString()
                    })),
                rsvp_lock_before_ms: this.state.rsvp_lock_before_ms
            }).then((response)=>{
                response.json().then((val)=>{
                    if (val.error) {
                        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert((0, _commonUtils.common_utils).markdownToHtml(val.error));
                        this.setState({
                            is_confirming: false
                        });
                    } else (0, _eventListBase.redirectToEventListFromCreatePage)(this.props, val.message_id, this.state.start_time.toJSDate(), val.link);
                }).catch((err)=>{
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.statusText);
                    this.setState({
                        is_confirming: false
                    });
                });
            });
        } else {
            let already_started = this.state.original_start_time.diffNow("milliseconds").milliseconds < 0;
            if (already_started) {
                // TODO web refactor: fix this redirect
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("This event has already started. Unable to edit.");
                this.setState(this.createInitialState(true));
                return;
            }
            this.setState({
                is_confirming: true
            });
            const props = this.props;
            sendEditData({
                user_id: this.props.user_id,
                guild_id: this.props.guild_id,
                event_name: this.state.event_name,
                start_time_str: this.state.start_time.toISO(),
                end_time_str: this.getCalculatedEndTimeIfSet()?.toISO(),
                rrule_string: rrule_str,
                allow_maintain_repeat_rsvp: this.state.allow_maintain_repeat_rsvp,
                message_id: this.props.edit_data.event_message_id,
                event_description: this.state.description,
                rsvp_options: this.state.rsvp_options,
                color: this.state.color,
                mention_data: {
                    create_role_mentions: this.state.role_mentions_on_create,
                    create_user_mentions: this.state.user_mentions_on_create
                },
                eligible_role_ids: this.state.eligible_role_ids,
                channel_id: this.state.selected_channel?.id,
                server_reminders: this.state.server_reminders,
                forum_tag_ids: this.state.selected_channel?.forum_tag_ids,
                hide_attendees: this.state.hide_attendees,
                image_url: this.state.image_url,
                inform_users_of_edit: this.state.inform_users_of_edit,
                attendee_role_data: this.state.attendee_role_data,
                event_timezone: this.state.event_timezone,
                native_event_data: this.state.native_event_data,
                thread_settings: this.state.thread_settings,
                access_token: this.props.auth_token.access_token,
                token_type: this.props.auth_token.token_type,
                date_input_description: this.state.date_input ? {
                    input: this.state.date_input,
                    timezone: local_timezone
                } : undefined,
                exdates: this.state.exdates?.map((val)=>val.toISOString()),
                rdates: this.state.rdates?.map((val)=>({
                        orig_date: new Date(val.orig_date).toISOString(),
                        rdate: new Date(val.rdate).toISOString()
                    })),
                rsvp_lock_before_ms: this.state.rsvp_lock_before_ms
            }).then((response)=>{
                response.json().then((val)=>{
                    if (val.error) {
                        (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert((0, _commonUtils.common_utils).markdownToHtml(val.error));
                        this.setState({
                            is_confirming: false
                        });
                    } else (0, _eventListBase.redirectToEventListFromCreatePage)(this.props, this.props.edit_data.event_message_id, this.state.start_time.toJSDate());
                }).catch((err)=>{
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.statusText);
                    this.setState({
                        is_confirming: false
                    });
                });
            });
        }
    }
    updateState(state_key, value) {
        let key = state_key;
        const new_state = {};
        new_state[key] = value;
        //this.state[key] = value;
        this.setState(new_state);
    }
    getEditHeaderText(event_name) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                (0, _dashboardUtils.DashboardUtils).GetEventIcon(),
                "Editing ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    children: event_name
                })
            ]
        });
    }
    getCreateHeaderText() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                (0, _dashboardUtils.DashboardUtils).GetEventIcon(),
                "Creating Event"
            ]
        });
    }
    scrollToElement(id) {
        document.getElementById(id).scrollIntoView({
            behavior: "smooth"
        });
    }
    getCurrentGuildTimezone() {
        return this.getGuildOrChannelSetting("timezone");
    }
    createTitleField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInputForm), {
            id: "event_name",
            name: "Event Title",
            placeholder: this.state.placeholder_fields.event_name,
            initial_value: this.state.event_name,
            updateFunc: (val)=>this.updateState("event_name", val),
            char_limit: (0, _constants.Constants).EVENT_CHAR_LIMIT,
            info: "The title for the event",
            disabled: force_disable
        }, "event_name");
    }
    createTimeField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateFieldWithDuration.DateFormWithDuration), {
            id: "start_time",
            name: "Start Time",
            placeholder: this.state.placeholder_fields.start_time,
            guild_zone: this.getCurrentGuildTimezone(),
            personal_zone: this.state.user_timezone,
            initial_value: this.state.start_time,
            use_24h_clock: this.state.use_24h_clock,
            duration_ms: this.state.duration_ms,
            display_text: "Event Time",
            updateFunc: (val)=>this.updateState("start_time", val),
            onInputChange: (val)=>this.setState({
                    date_input: val
                }),
            info: "The start time for the event",
            disabled: force_disable
        }, "start_time");
    }
    createServerRemindersField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverRemindersBlurb.ServerRemindersForm), {
            is_disabled: force_disable,
            reminders: this.state.server_reminders,
            event_channel_id: this.state.selected_channel?.id,
            event_start_time: this.state.start_time?.toJSDate(),
            setReminders: (reminders)=>this.setState({
                    server_reminders: reminders
                }),
            initial_mentions: {
                create_role_mentions: this.state.role_mentions_on_create,
                create_user_mentions: this.state.user_mentions_on_create
            },
            setInitialMentions: (mentions)=>{
                this.updateState("role_mentions_on_create", mentions.create_role_mentions);
                this.updateState("user_mentions_on_create", mentions.create_user_mentions);
            },
            revert_descriptor: [
                this.getRevertDescriptor("default_event_server_reminders"),
                this.getRevertDescriptor("default_role_mentions_on_event_create"),
                this.getRevertDescriptor("default_user_mentions_on_event_create")
            ]
        }, `server_reminders_${this.state.selected_channel?.id}`);
    }
    createChannelField(force_disable = false) {
        const channel_select_disabled = !this.props.can_select_channel || this.state.is_confirming;
        let channel_info_addenum;
        if (!this.props.can_select_channel) channel_info_addenum = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            children: ". Disabled due to sesh server settings."
        });
        const channel_select_info = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            children: [
                "The channel where the event will get sent to",
                channel_info_addenum
            ]
        });
        const name = "Channel";
        if (this.state.loading_roles_and_channels) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(name, channel_select_info),
                (0, _dashboardUtils.DashboardUtils).RenderLoadingSelect()
            ]
        }, "selected_channel_load");
        let below_element;
        if (this.props.is_edit && this.state.selected_channel.id !== this.props.edit_data.sent_channel_data.id) {
            const original_channel_name = this.props.all_text_channels.find((val)=>val.id === this.props.edit_data.sent_channel_data.id)?.name ?? "unknown";
            below_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "note mt-4 w-full truncate whitespace-break-spaces",
                children: [
                    "Event will be moved from",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            "#",
                            original_channel_name
                        ]
                    }),
                    " ",
                    "to",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            "#",
                            this.getSelectedChannel().name
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdownWithTags.ChannelSelectFormWithTags), {
            id: "selected_channel",
            sesh_channel_id: this.props.event_channel_id,
            name: "Channel",
            desired_channel_id: this.props.is_edit ? undefined : this.props.event_channel_id,
            below_element: below_element,
            initial_value: this.getSelectedChannel(),
            channel_data: this.props.all_text_channels,
            info: channel_select_info,
            disabled: force_disable || channel_select_disabled,
            is_event: true,
            updateFunc: (val)=>{
                for (const key of Object.keys((0, _eventCreationUtils.GuildSettingToEventSetting))){
                    const guild_setting_key = key;
                    if (this.getModifiedSettingsKey(guild_setting_key)) continue;
                    const state_key = (0, _eventCreationUtils.GuildSettingToEventSetting)[guild_setting_key];
                    const new_state = {
                        [state_key]: this.getGuildOrChannelSettingWithChannelParam(guild_setting_key, val)
                    };
                    this.setState(new_state);
                }
                this.setState({
                    selected_channel: {
                        id: val.id,
                        forum_tag_ids: []
                    }
                });
            },
            include_threads: true,
            selected_forum_tag_ids: this.state.selected_channel.forum_tag_ids,
            setSelectedTagIds: (val)=>this.setState({
                    selected_channel: {
                        ...this.state.selected_channel,
                        forum_tag_ids: val
                    }
                })
        }, "selected_channel");
    }
    createDescriptionField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Description", "The description of the event", false, false, false, undefined, force_disable),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textArea.TextAreaForm), {
                    initial_value: this.state.description,
                    rows: 10,
                    placeholder: this.state.placeholder_fields.description,
                    updateFunc: (val)=>this.updateState("description", val),
                    char_limit: (0, _constants.Constants).DESCRIPTION_CHAR_LIMIT,
                    do_not_clear_on_unmount: true
                })
            ]
        }, "description");
    }
    createImageField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "field active",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageUploader.ImageUploaderForm), {
                initial_value: this.state.image_url,
                updateFunc: (val)=>this.updateState("image_url", val),
                disabled: force_disable,
                name: "Image"
            }, "image_url")
        }, "image_url_parent");
    }
    createThreadField(force_disable = false) {
        let error;
        const selected_channel = this.getSelectedChannel();
        if (!this.state.loading_roles_and_channels) {
            if (selected_channel?.type === "Thread" || selected_channel?.type === "Forum") error = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "Can not use this feature when selected channel is a thread or forum channel"
            });
            else if (!selected_channel?.can_make_public_threads) error = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "sesh requires the",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "has-text-weight-bold",
                        children: "Create Public Threads"
                    }),
                    " ",
                    "permission in channel",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            "#",
                            (0, _dashboardUtils.DashboardUtils).LimitName(selected_channel?.name, 20)
                        ]
                    }),
                    " ",
                    "to use this feature"
                ]
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventThreadForm.EventThreadAccordian), {
            type: "EventCreation",
            event_name: this.state.event_name,
            start_time: this.state.start_time?.toJSDate(),
            guild_timezone: this.props.guild_timezone,
            value: this.state.thread_settings,
            revert_descriptor: this.getRevertDescriptor("default_event_thread_settings"),
            onUpdate: (val)=>this.setState({
                    thread_settings: val
                }),
            disabled: force_disable,
            is_loading: this.state.loading_roles_and_channels,
            error: error,
            show_on_closed: true
        }, `event_thread_accordian_${selected_channel?.id}`);
    }
    createColorField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventColorPickerDefault.default), {
            label: "Color",
            field_key: "color",
            info: "The color of all embeds for this event, including notifications",
            color: this.state.color,
            disabled: force_disable,
            updateFunc: (val)=>this.updateState("color", val),
            revert_descriptor: this.getRevertDescriptor("default_event_embed_color")
        }, "color");
    }
    createDiscordNativeEventMirrorField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nativeEventFormDefault.default), {
            is_disabled: force_disable,
            voice_channels: this.props.all_voice_channels,
            initial_event_data: this.state.native_event_data,
            updateFunc: (val)=>this.updateState("native_event_data", val),
            is_loading: this.state.loading_roles_and_channels,
            sesh_has_manage_events: this.props.sesh_has_manage_events,
            user_has_manage_events: this.props.user_has_manage_events,
            label: "Mirror to Discord Native Event",
            revert_descriptor: this.getRevertDescriptor("default_native_event_data"),
            show_on_closed: true,
            rsvp_options: this.state.rsvp_options.custom_options
        }, `native_event_data_${this.state.selected_channel?.id}`);
    }
    createHideEventAttendeesField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
            label: "Hide Attendee Names on Embed",
            is_opened: this.state.hide_attendees,
            info: "Whether to show individual names of those attending in the event embed (Note: Names will still be visible via the web interface)",
            disabled: force_disable,
            revert_descriptor: this.getRevertDescriptor("default_hide_attendees"),
            onChange: (value)=>this.updateState("hide_attendees", value)
        }, "hide_attendees");
    }
    getGuildOrChannelSetting(key) {
        if (!this.props.is_premium) return this.props.guild_defaults[key];
        return (0, _typeUtils.guildSettingsStyle_getIndividualChannelSettingOverride)(this.props.guild_defaults, this.getSelectedChannel()?.overrides, key, {
            all_text_channels: this.props.all_text_channels,
            guild_data: {
                id: this.props.guild_id
            },
            roles: this.props.roles
        }) ?? (0, _eventCreationUtils.DefaultGuildSettingValues)[key];
    }
    getRevertDescriptor(key) {
        if (this.props.is_edit) return undefined;
        const event_key = (0, _eventCreationUtils.GuildSettingToEventSetting)[key];
        const guild_value = this.props.guild_defaults[key] ?? (0, _eventCreationUtils.DefaultGuildSettingValues)[key];
        const channel_value = this.getGuildOrChannelSettingWithChannelParam(key, this.getSelectedChannel());
        const has_active_channel_override = (0, _typeUtils.guildSettingsStyle_hasActiveChannelOverrideForSetting)(this.getSelectedChannel()?.overrides, key);
        const default_value = has_active_channel_override ? channel_value : guild_value;
        return {
            value: this.state[event_key],
            default: {
                value: default_value,
                from: has_active_channel_override ? "Channel" : "Guild"
            },
            onRevertPressed: ()=>{
                this.updateModifiedSettingsKey(key, false);
                this.pending_revert_state_updates[event_key] = true;
                this.updateState(event_key, default_value);
            }
        };
    }
    getGuildOrChannelSettingWithChannelParam(key, channel) {
        const default_value = (0, _eventCreationUtils.DefaultGuildSettingValues)[key];
        if (!this.props.is_premium) return this.props.guild_defaults[key] ?? default_value;
        return (0, _typeUtils.guildSettingsStyle_getIndividualChannelSettingOverride)(this.props.guild_defaults, channel?.overrides, key, {
            all_text_channels: this.props.all_text_channels,
            guild_data: {
                id: this.props.guild_id
            },
            roles: this.props.roles
        }) ?? default_value;
    }
    createAddRoleToAttendeesField(force_disable = false) {
        const disabled_due_to_no_roles_to_add = this.props.roles?.filter((val)=>val.can_user_add_role).length === 0;
        const disabled = force_disable;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addRoleToAttendeesEventForm.AddRoleToAttendeesEventForm), {
            sesh_has_manage_roles: this.props.sesh_has_manage_roles,
            sesh_role_name: this.props.sesh_role_name,
            setValue: (val)=>this.setState({
                    attendee_role_data: val
                }),
            is_server_premium: this.props.is_premium,
            value: this.state.attendee_role_data,
            disabled: disabled,
            has_no_roles_to_add: disabled_due_to_no_roles_to_add,
            event_duration_ms: this.state.duration_ms,
            revert_descriptor: this.getRevertDescriptor("attendee_role_data")
        }, "attendee_role_data");
    }
    createRSVPOptionsField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signupOptionBlurb.SignupOptionsBlurb), {
            current_signup_preset: this.state.rsvp_options,
            setPreset: (val)=>this.setState({
                    rsvp_options: val
                }),
            user_presets: this.state.user_presets,
            custom_emojis: this.state.custom_emojis,
            is_disabled: force_disable,
            is_edit: this.props.is_edit,
            revert_descriptor: this.getRevertDescriptor("signup_options")
        }, "rsvp_options");
    }
    createRoleRestrictionsField(force_disable = false) {
        const disabled = force_disable || !this.props.is_premium;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("field", {
                active: this.props.is_premium
            }),
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Role Restrictions", "Limit event signup to only certain roles", !this.props.is_premium, false, false, undefined, disabled),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleRestrictions.RoleRestrictionsForm), {
                    role_ids: this.state.eligible_role_ids,
                    updateFunc: (val)=>{
                        this.updateState("eligible_role_ids", val);
                    },
                    disabled: disabled
                })
            ]
        }, "elgible_role_ids");
    }
    createLockRSVPsBeforeField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lockRsvpsBefore.LockRSVPsBefore), {
            disabled: force_disable
        }, "lock_rsvps_before");
    }
    createRepeatField(force_disable = false) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repeatFormComponent.RepeatFormComponent), {
            end_time: this.getCalculatedEndTimeIfSet(),
            disabled: force_disable
        }, "rrule");
    }
    renderFields() {
        let primary_fields = [];
        const should_force_disable = this.state.is_confirming;
        for(let field_key in FIELD_ORDER)primary_fields.push(this.fields[field_key.toString()](should_force_disable));
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "creation-primary-fields",
                    children: [
                        this.props.edit_data?.rrule_str && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "field !-mb-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _note.Note), {
                                children: "You are currently editing a repeat event. Any edits made here will affect all current and future events."
                            })
                        }),
                        !this.props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "field !p-0 !pr-2 !pt-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.EventTemplateDropdown), {})
                        }),
                        primary_fields
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advancedEventCreationSelector.EventCreationAdvancedSelector), {
                    field_key_to_element: this.fields,
                    is_disabled: should_force_disable
                })
            ]
        });
    }
    renderAccordians() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "creation-form",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "title is-3 has-text-centered mt-6",
                    children: this.state.header_text
                }),
                this.props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "rsvp-data-link-edit-link",
                    onClick: ()=>{
                        this.props.history.push((0, _commonUtils.common_utils).getAttendeesDisplayURL(this.props.guild_id, this.props.edit_data?.event_message_id, true));
                    },
                    children: "View RSVPs"
                }),
                this.renderFields(),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field submit-button flex flex-col gap-4",
                    children: [
                        this.props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    name: "has_reminders",
                                    checked: this.state.inform_users_of_edit,
                                    onChange: (e)=>this.setState({
                                            inform_users_of_edit: e.target.checked
                                        })
                                }),
                                " ",
                                "Inform RSVPed users of changes via DM"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.SaveCurrentSettingsButton), {
                            is_premium: this.props.is_premium
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateFormConfirmButton, {
                            blocked_by_load: this.state.loading_roles_and_channels,
                            channel_name: this.getSelectedChannel()?.name,
                            is_confirming: this.state.is_confirming,
                            onClick: this.handleSubmit,
                            is_edit: this.props.is_edit,
                            is_event: true
                        })
                    ]
                })
            ]
        });
    }
    renderLinkChains() {
        const link_chain_data = [];
        link_chain_data.push((0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData());
        link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.state.guild_data_for_this_guild));
        link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderEventSelectionLinkChain(this.state.guild_data_for_this_guild));
        link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderEventCreateLinkChain(this.props.guild_id, this.props.is_edit));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
            link_chain_data: link_chain_data
        });
    }
    render() {
        const providerValue = {
            state: this.state,
            setState: (val)=>this.setState(val),
            props: this.props
        };
        if (this.state.current_page === "templates") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventCreationContext.Provider, {
            value: providerValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.EventTemplatePage), {
                is_guild_premium: this.props.is_premium,
                onBack: ()=>{
                    this.setState({
                        current_page: "main"
                    });
                }
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventCreationContext.Provider, {
            value: providerValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
                transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile is-centered !m-0",
                    style: {
                        transition: "opacity 0.5s",
                        opacity: "1"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container",
                        children: [
                            this.renderLinkChains(),
                            this.renderAccordians()
                        ]
                    })
                })
            })
        });
    }
}
function sendEditData(request_body) {
    return fetch(`/api/edit_event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    });
}
async function sendEventData(request_body) {
    let result = fetch(`/api/create_event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    });
    return result;
}
exports.default = (0, _reactRouterDom.withRouter)(EventCreation);

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./forms/text_input":"4jMf1","./web_ui":"7f1Tj","luxon":"fLWpi","../../../src/vendored/FadeIn":"aMGHU","rrule":"ilLpP","classnames":"7uztA","react-router-dom":"djWTS","../../../common/common_format_utils":"ggT25","../../../common/common_utils":"gACUC","../../../common/constants":"lLiun","../../../common/time_format_utils":"g0uQN","../../../common/type_utils":"kvX2A","./dashboard_utils":"jvA8A","./forms/event_color_picker":"6vyZF","./forms/image_uploader":"kfglS","./forms/improved_components/add_role_to_attendees_event_form":"aAYfI","./forms/improved_components/advanced_event_creation_selector":"8oSSD","./forms/improved_components/channel_dropdown_with_tags":"jQ5tM","./forms/improved_components/date_field_with_duration":"7aRSv","./forms/improved_components/event_templates/event_template_page":"5CZM0","./forms/improved_components/event_thread_form":"5ldxh","./forms/improved_components/listings_form/event/event_list_base":"5jRGe","./forms/improved_components/note":"kkvHK","./forms/improved_components/repeat_form_component":"kMi2L","./forms/improved_components/server_reminders/server_reminders_blurb":"dEV54","./forms/improved_components/sesh_accordian_component":"9ti9e","./forms/improved_components/signup_options/signup_option_blurb":"aSFQP","./forms/native_event_form":"gPqC1","./forms/role_restrictions":"2CCGw","./forms/text_area":"dPYPF","./utils/event_creation_utils":"2BuW9","./forms/improved_components/lock_rsvps_before/lock_rsvps_before":"bnjcr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4jMf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextInputForm", ()=>TextInputForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dashboardUtils = require("../dashboard_utils");
class TextInputForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let value = props.initial_value ? props.initial_value : "";
        this.state = {
            value: value
        };
        this.handleChange = this.handleChange.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleChange(event) {
        this.setState({
            value: event.target.value
        });
        this.props.updateFunc(event.target.value);
    }
    render() {
        let classNames = "control";
        if (this.props.disabled) classNames += " input-disabled";
        let divClassNames = "field";
        if (this.props.additional_classnames) divClassNames += ` ${this.props.additional_classnames.join(" ")}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: divClassNames,
            id: this.props.id,
            children: [
                this.props.name && (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(this.props.name, this.props.info, undefined, undefined, this.props.unsaved_changes, undefined, this.props.disabled),
                this.props.note_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "note",
                    children: this.props.note_text
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classNames,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "input",
                        placeholder: this.props.placeholder,
                        disabled: Boolean(this.props.disabled),
                        type: "text",
                        value: this.state.value,
                        onChange: this.handleChange,
                        maxLength: this.props.char_limit
                    })
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kvX2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
does not handle the following
	- command_permissions
	- events_channel_id
	- polls_channel_id
	- attendee_role_data
	- native_event_data
*/ parcelHelpers.export(exports, "getSettingForChannel", ()=>getSettingForChannel);
parcelHelpers.export(exports, "guildSettingsStyle_hasActiveChannelOverrideForSetting", ()=>guildSettingsStyle_hasActiveChannelOverrideForSetting);
parcelHelpers.export(exports, "hasActiveChannelOverrideForSetting", ()=>hasActiveChannelOverrideForSetting);
parcelHelpers.export(exports, "convertGuildSettingsKeyToGuildEntityStyle", ()=>convertGuildSettingsKeyToGuildEntityStyle);
parcelHelpers.export(exports, "guildSettingsStyle_setIndividualChannelSettingOverride", ()=>guildSettingsStyle_setIndividualChannelSettingOverride);
parcelHelpers.export(exports, "guildSettingsStyle_convertAttendeeRoles", ()=>guildSettingsStyle_convertAttendeeRoles);
/**
should only be used for the following, just use get_setting_for_channel() (with GuildEntity style key instead) otherwise
	- command_permissions
	- events_channel_id
	- polls_channel_id
	- attendee_role_data
*/ parcelHelpers.export(exports, "guildSettingsStyle_getIndividualChannelSettingOverride", ()=>guildSettingsStyle_getIndividualChannelSettingOverride);
var _commonUtils = require("./common_utils");
var _constants = require("./constants");
const safe_mappings_guild_entity_to_guild_settings = {
    custom_timezone: "timezone",
    secondary_timezones: "secondary_timezones",
    default_signup_options: "signup_options",
    event_channel_override_only_admins: "event_channel_override_only_admins",
    event_channel_require_send_messages: "event_channel_require_send_messages",
    poll_channel_override_only_admins: "poll_channel_override_only_admins",
    poll_channel_require_send_messages: "poll_channel_require_send_messages",
    auto_remove_event_messages: "clean_event_messages",
    auto_remove_user_commands: "clean_user_commands",
    can_add_poll_options: "poll_add",
    is_default_poll_type_single_vote: "is_default_poll_type_single_vote",
    use_24h_clock: "use_24h_clock",
    custom_prefix: "prefix",
    use_channel_calendars_mode: "use_channel_calendars_mode",
    use_discord_timestamps: "use_discord_timestamps",
    is_ai_enabled: "is_ai_enabled",
    display_attendees_as_plain_text: "display_attendees_as_plain_text",
    default_hide_attendees: "default_hide_attendees",
    use_reactions_for_polls: "use_reactions_for_polls",
    default_event_thread_settings: "default_event_thread_settings",
    event_channel_forum_tag_ids: "event_channel_forum_tag_ids",
    poll_channel_forum_tag_ids: "poll_channel_forum_tag_ids",
    default_event_embed_color: "default_event_embed_color",
    default_poll_embed_color: "default_poll_embed_color",
    default_event_server_reminders: "default_event_server_reminders",
    default_role_mentions_on_event_create: "default_role_mentions_on_event_create",
    default_user_mentions_on_event_create: "default_user_mentions_on_event_create"
};
const safe_mappings_guild_settings_to_guild_entity = {
    timezone: "custom_timezone",
    secondary_timezones: "secondary_timezones",
    signup_options: "default_signup_options",
    event_channel_override_only_admins: "event_channel_override_only_admins",
    event_channel_require_send_messages: "event_channel_require_send_messages",
    poll_channel_override_only_admins: "poll_channel_override_only_admins",
    poll_channel_require_send_messages: "poll_channel_require_send_messages",
    clean_event_messages: "auto_remove_event_messages",
    clean_user_commands: "auto_remove_user_commands",
    poll_add: "can_add_poll_options",
    is_default_poll_type_single_vote: "is_default_poll_type_single_vote",
    use_24h_clock: "use_24h_clock",
    is_ai_enabled: "is_ai_enabled",
    prefix: "custom_prefix",
    use_channel_calendars_mode: "use_channel_calendars_mode",
    use_discord_timestamps: "use_discord_timestamps",
    display_attendees_as_plain_text: "display_attendees_as_plain_text",
    default_hide_attendees: "default_hide_attendees",
    use_reactions_for_polls: "use_reactions_for_polls",
    default_event_thread_settings: "default_event_thread_settings",
    event_channel_forum_tag_ids: "event_channel_forum_tag_ids",
    poll_channel_forum_tag_ids: "poll_channel_forum_tag_ids",
    default_event_embed_color: "default_event_embed_color",
    default_poll_embed_color: "default_poll_embed_color",
    default_event_server_reminders: "default_event_server_reminders",
    default_role_mentions_on_event_create: "default_role_mentions_on_event_create",
    default_user_mentions_on_event_create: "default_user_mentions_on_event_create"
};
const unsafe_mappings_guild_settings_to_guild_entity = {
    attendee_role_data: [
        "default_attendee_role_ids",
        "remove_roles_on_event_end",
        "role_on_rsvp_add_time"
    ],
    default_native_event_data: [
        "default_native_event_location_type",
        "default_native_event_location_value"
    ],
    event_channel: [
        "events_channel_id"
    ],
    poll_channel: [
        "polls_channel_id"
    ],
    permissions: [
        "command_permissions"
    ]
};
function getSettingForChannel(guild_settings, individual_channel_settings_overrides, key) {
    const has_override = individual_channel_settings_overrides && individual_channel_settings_overrides.hasOwnProperty(key);
    if (has_override) return individual_channel_settings_overrides[key];
    return guild_settings[safe_mappings_guild_entity_to_guild_settings[key]];
}
function guildSettingsStyle_hasActiveChannelOverrideForSetting(individual_channel_settings_overrides, key) {
    const safe_guild_entity_style_key = convertGuildSettingsKeyToGuildEntityStyle(key);
    if (safe_guild_entity_style_key) return hasActiveChannelOverrideForSetting(individual_channel_settings_overrides, safe_guild_entity_style_key);
    const unsafe_guild_entity_style_keys = unsafe_mappings_guild_settings_to_guild_entity[key];
    if (unsafe_guild_entity_style_keys) for (const key of unsafe_guild_entity_style_keys){
        const has_override = hasActiveChannelOverrideForSetting(individual_channel_settings_overrides, key);
        if (has_override) return true;
    }
    return false;
}
function hasActiveChannelOverrideForSetting(individual_channel_settings_overrides, key) {
    const has_override = Boolean(individual_channel_settings_overrides && individual_channel_settings_overrides.hasOwnProperty(key));
    return has_override;
}
function convertGuildSettingsKeyToGuildEntityStyle(key) {
    return safe_mappings_guild_settings_to_guild_entity[key];
}
function guildSettingsStyle_setIndividualChannelSettingOverride(individual_channel_settings_overrides, key, value, settings_props) {
    const guild_entity_style_key = convertGuildSettingsKeyToGuildEntityStyle(key);
    if (guild_entity_style_key) individual_channel_settings_overrides[guild_entity_style_key] = value;
    else if (key === "event_channel") {
        const value_channel = value;
        individual_channel_settings_overrides.events_channel_id = value_channel?.id;
    } else if (key === "poll_channel") {
        const value_channel = value;
        individual_channel_settings_overrides.polls_channel_id = value_channel?.id;
    } else if (key === "permissions") individual_channel_settings_overrides.command_permissions = (0, _commonUtils.common_utils).formatCommandPermissionsForDB(value, settings_props.guild_data.id);
    else if (key === "attendee_role_data") {
        const attendee_role_data_from_guild_settings = value;
        individual_channel_settings_overrides.remove_roles_on_event_end = attendee_role_data_from_guild_settings?.remove_on_end ?? null;
        individual_channel_settings_overrides.role_on_rsvp_add_time = attendee_role_data_from_guild_settings?.role_add_time ?? null;
        individual_channel_settings_overrides.default_attendee_role_ids = attendee_role_data_from_guild_settings?.role_ids ?? null;
    } else if (key === "default_native_event_data") {
        const default_native_event_data_from_guild_settings = value;
        individual_channel_settings_overrides.default_native_event_location_type = default_native_event_data_from_guild_settings?.location?.type ?? null;
        individual_channel_settings_overrides.default_native_event_location_value = default_native_event_data_from_guild_settings?.location?.value ?? null;
        individual_channel_settings_overrides.default_native_event_custom_description = default_native_event_data_from_guild_settings?.custom_description ?? null;
        individual_channel_settings_overrides.default_native_event_image_url = default_native_event_data_from_guild_settings?.image_url ?? null;
    }
}
function guildSettingsStyle_convertAttendeeRoles(individual_channel_settings_overrides) {
    const default_attendee_role_ids = individual_channel_settings_overrides.default_attendee_role_ids ?? [];
    const role_on_rsvp_add_time = individual_channel_settings_overrides.role_on_rsvp_add_time ?? (0, _constants.Constants).DEFAULT_ADD_ROLE_ON_RSVP_ADD_TIME;
    const remove_roles_on_event_end = individual_channel_settings_overrides.remove_roles_on_event_end ?? (0, _constants.Constants).DEFAULT_REMOVE_ROLE_ON_EVENT_END;
    return {
        remove_on_end: remove_roles_on_event_end,
        role_add_time: role_on_rsvp_add_time,
        role_ids: default_attendee_role_ids
    };
}
function guildSettingsStyle_getIndividualChannelSettingOverride(guild_settings, individual_channel_settings_overrides, key, settings_props) {
    if (!guildSettingsStyle_hasActiveChannelOverrideForSetting(individual_channel_settings_overrides, key)) return guild_settings[key];
    const guild_entity_style_key = convertGuildSettingsKeyToGuildEntityStyle(key);
    if (guild_entity_style_key) return getSettingForChannel(guild_settings, individual_channel_settings_overrides, guild_entity_style_key);
    else if (key === "event_channel") {
        const events_channel_id = individual_channel_settings_overrides.events_channel_id;
        return settings_props.all_text_channels.find((mentionable)=>events_channel_id === mentionable.id);
    } else if (key === "poll_channel") {
        const polls_channel_id = individual_channel_settings_overrides.polls_channel_id;
        return settings_props.all_text_channels.find((mentionable)=>polls_channel_id === mentionable.id);
    } else if (key === "permissions") return (0, _commonUtils.common_utils).formatCommandPermissionsForWeb(individual_channel_settings_overrides.command_permissions, settings_props.guild_data.id);
    else if (key === "attendee_role_data") return guildSettingsStyle_convertAttendeeRoles(individual_channel_settings_overrides);
    else if (key === "default_native_event_data") {
        if (!individual_channel_settings_overrides.default_native_event_location_type) return null;
        const result = {
            location: {
                type: individual_channel_settings_overrides.default_native_event_location_type,
                value: individual_channel_settings_overrides.default_native_event_location_value ?? undefined
            },
            custom_description: individual_channel_settings_overrides.default_native_event_custom_description ?? undefined,
            image_url: individual_channel_settings_overrides.default_native_event_image_url ?? undefined
        };
        return result;
    }
    throw new Error("Invalid key");
}

},{"./common_utils":"gACUC","./constants":"lLiun","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6vyZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventColorPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../dashboard_utils");
var _colorPicker = require("./color_picker");
function EventColorPicker(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field active",
        children: [
            (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(props.label, props.info, false, false, undefined, undefined, props.disabled, props.is_new, props.revert_descriptor),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorPicker.ColorPickerForm), {
                updateFunc: (val)=>props.updateFunc(val),
                value: props.color,
                disabled: props.disabled
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../dashboard_utils":"jvA8A","./color_picker":"2bL1a","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2bL1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorPickerForm", ()=>ColorPickerForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactColor = require("react-color");
var _constants = require("../../../../common/constants");
var _fontColorContrast = require("font-color-contrast");
var _fontColorContrastDefault = parcelHelpers.interopDefault(_fontColorContrast);
var _modifySettingsButton = require("./improved_components/base_components/modify_settings_button");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const PRESET_COLORS = [
    {
        color: (0, _constants.Constants).EMBED_COLOR,
        title: "sesh"
    },
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#BD10E0",
    "#9013FE",
    "#4A90E2",
    "#50E3C2",
    "#B8E986",
    "#000000",
    "#4A4A4A",
    "#9B9B9B",
    "#FFFFFF"
];
class ColorPickerForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            intermediate_color: this.props.value,
            picker_showing: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDrag = this.handleChangeDrag.bind(this);
        this.onColorSwatchClicked = this.onColorSwatchClicked.bind(this);
        this.onDivClicked = this.onDivClicked.bind(this);
    }
    handleChange(event) {
        this.setState({
            intermediate_color: event.hex
        });
        this.props.updateFunc(event.hex);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // value was updated
        if (prevProps.value !== this.props.value) {
            if (prevState.intermediate_color !== this.props.value) this.setState({
                intermediate_color: this.props.value
            });
        }
    }
    handleChangeDrag(event) {
        this.setState({
            intermediate_color: event.hex
        });
    }
    onClick(event) {
        event.preventDefault();
        event.preventDefault();
        event.stopPropagation();
    }
    onColorSwatchClicked(event) {
        event.preventDefault();
        event.stopPropagation();
        let new_state = !this.state.picker_showing;
        this.setState({
            picker_showing: new_state
        });
    }
    onDivClicked(event) {
        this.setState({
            picker_showing: false
        });
    }
    render() {
        const color_contrast = (0, _fontColorContrastDefault.default)(this.props.value);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "",
                    onClick: this.onClick,
                    children: [
                        this.props.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            className: "label is-size-5",
                            children: this.props.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex",
                            onClick: this.onDivClicked,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex w-fit",
                                onClick: this.onColorSwatchClicked,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                    disabled: this.props.disabled,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "relative h-10 w-28 cursor-pointer rounded-md border",
                                                style: {
                                                    backgroundColor: this.props.value,
                                                    borderColor: color_contrast === "#000000" ? "transparent" : "#00f4ff"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "absolute inset-0 flex items-center justify-center font-mono opacity-50",
                                                    style: {
                                                        color: color_contrast
                                                    },
                                                    children: this.props.value
                                                })
                                            }),
                                            "Modify"
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _classnamesDefault.default)("modal", {
                        "is-active": this.state.picker_showing
                    }),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-background",
                            onClick: ()=>this.setState({
                                    picker_showing: false
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "sketch-picker-parent mt-4 flex flex-col items-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactColor.SketchPicker), {
                                    color: this.state.intermediate_color,
                                    onChange: this.handleChangeDrag,
                                    onChangeComplete: this.handleChange,
                                    disableAlpha: true,
                                    presetColors: PRESET_COLORS
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "modal-close is-large",
                            "aria-label": "close",
                            onClick: (e)=>{
                                e.preventDefault();
                                this.setState({
                                    picker_showing: false
                                });
                            }
                        })
                    ]
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-color":"jPGOE","../../../../common/constants":"lLiun","font-color-contrast":"bP5fh","./improved_components/base_components/modify_settings_button":"kbhTg","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jPGOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "BlockPicker", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "CirclePicker", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ChromePicker", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "CompactPicker", ()=>(0, _compactDefault.default));
parcelHelpers.export(exports, "GithubPicker", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "HuePicker", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "MaterialPicker", ()=>(0, _materialDefault.default));
parcelHelpers.export(exports, "PhotoshopPicker", ()=>(0, _photoshopDefault.default));
parcelHelpers.export(exports, "SketchPicker", ()=>(0, _sketchDefault.default));
parcelHelpers.export(exports, "SliderPicker", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SwatchesPicker", ()=>(0, _swatchesDefault.default));
parcelHelpers.export(exports, "TwitterPicker", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "GooglePicker", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "CustomPicker", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _chromeDefault.default));
var _alpha = require("./components/alpha/Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _block = require("./components/block/Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _circle = require("./components/circle/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _chrome = require("./components/chrome/Chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _compact = require("./components/compact/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _github = require("./components/github/Github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _hue = require("./components/hue/Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _material = require("./components/material/Material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _photoshop = require("./components/photoshop/Photoshop");
var _photoshopDefault = parcelHelpers.interopDefault(_photoshop);
var _sketch = require("./components/sketch/Sketch");
var _sketchDefault = parcelHelpers.interopDefault(_sketch);
var _slider = require("./components/slider/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _swatches = require("./components/swatches/Swatches");
var _swatchesDefault = parcelHelpers.interopDefault(_swatches);
var _twitter = require("./components/twitter/Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _google = require("./components/google/Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _colorWrap = require("./components/common/ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);

},{"./components/alpha/Alpha":"9EQXG","./components/block/Block":"6eM2E","./components/circle/Circle":"hL3jq","./components/chrome/Chrome":"g5EzX","./components/compact/Compact":"91Fcl","./components/github/Github":"bmbqc","./components/hue/Hue":"fXhnw","./components/material/Material":"fjCs4","./components/photoshop/Photoshop":"0svIL","./components/sketch/Sketch":"apktL","./components/slider/Slider":"kpDJC","./components/swatches/Swatches":"kgX20","./components/twitter/Twitter":"a9pBI","./components/google/Google":"gZdu6","./components/common/ColorWrap":"6TXcU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9EQXG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>AlphaPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _alphaPointer = require("./AlphaPointer");
var _alphaPointerDefault = parcelHelpers.interopDefault(_alphaPointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), _extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
AlphaPicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _alphaPointerDefault.default)
};
exports.default = (0, _common.ColorWrap)(AlphaPicker);

},{"react":"IMRgT","reactcss":"k3r4z","../common":"b7fAS","./AlphaPointer":"7d3E8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k3r4z":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
var _flattenNames = require("d21bbaf20f135ed7");
var _flattenNames2 = _interopRequireDefault(_flattenNames);
var _mergeClasses = require("7ab5259b27ba03f4");
var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
var _autoprefix = require("f7ab0b82c66de9f6");
var _autoprefix2 = _interopRequireDefault(_autoprefix);
var _hover2 = require("610a3f6b931726da");
var _hover3 = _interopRequireDefault(_hover2);
var _active = require("8d8d6281227b8365");
var _active2 = _interopRequireDefault(_active);
var _loop2 = require("c3bae8551a541b09");
var _loop3 = _interopRequireDefault(_loop2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes, activeNames);
    return (0, _autoprefix2.default)(merged);
};
exports.default = ReactCSS;

},{"d21bbaf20f135ed7":"3DjXR","7ab5259b27ba03f4":"kZc2y","f7ab0b82c66de9f6":"jIeqA","610a3f6b931726da":"FTW7f","8d8d6281227b8365":"louE4","c3bae8551a541b09":"5rK9z"}],"3DjXR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenNames = undefined;
var _isString2 = require("cc07907b88eac890");
var _isString3 = _interopRequireDefault(_isString2);
var _forOwn2 = require("2db844d13e15e498");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _isPlainObject2 = require("8ea197129e7ee890");
var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
var _map2 = require("8f65518dcbd71fa0");
var _map3 = _interopRequireDefault(_map2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var flattenNames = exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, _isPlainObject3.default)(thing)) (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, _isString3.default)(thing)) names.push(thing);
    });
    return names;
};
exports.default = flattenNames;

},{"cc07907b88eac890":"hU5VA","2db844d13e15e498":"iQzOr","8ea197129e7ee890":"8CW4A","8f65518dcbd71fa0":"fxfry"}],"hU5VA":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"62bdZ","46fdd4d2c5d7b4ab":"e2Lkw","36ebbb6a9d8b3fe4":"9hdx6"}],"62bdZ":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"9gDWc","9b2aaf31b7bdd837":"k6lmG","46d5beb3375f8a28":"aBhfw"}],"9gDWc":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"hfQqg"}],"hfQqg":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"7WkVj"}],"7WkVj":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"k6lmG":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"9gDWc"}],"aBhfw":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"e2Lkw":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"9hdx6":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"iQzOr":[function(require,module,exports,__globalThis) {
var baseForOwn = require("29fecbf008d96984"), castFunction = require("e9d5e9d48b9f93d3");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
    return object && baseForOwn(object, castFunction(iteratee));
}
module.exports = forOwn;

},{"29fecbf008d96984":"4btes","e9d5e9d48b9f93d3":"cjF0r"}],"4btes":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"k7Zum","1fb77c53defe5720":"UsTmH"}],"k7Zum":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"7tWhq"}],"7tWhq":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"UsTmH":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"a94jA","e8453365fdacc8da":"kg3Zz","7760b47b02971dfa":"6c6bm"}],"a94jA":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"viOQt","9cdb51ffa56f149b":"5WfzS","38cd49f1e493b3d7":"e2Lkw","b379831fe1873fed":"a1qsC","f362a34cd8321bb7":"fYQfR","c019db5297494469":"1hJWf"}],"viOQt":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"5WfzS":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"9nBNB","bead821d6af018b5":"9hdx6"}],"9nBNB":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"62bdZ","b6cdbe52dcf709f8":"9hdx6"}],"a1qsC":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"hfQqg","a1e87b138cf75d1d":"7XA2M"}],"7XA2M":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"fYQfR":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"1hJWf":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"7E02h","903f50eb1c16d257":"hZnDi","fa49853a82034c30":"jwac5"}],"7E02h":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"62bdZ","f661b3a120d7a4cb":"gXehZ","cdd86c83797c0618":"9hdx6"}],"gXehZ":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"hZnDi":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"jwac5":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"7WkVj"}],"kg3Zz":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"l6L9q","3ec652610d8dd5d3":"jRzOI"}],"l6L9q":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"jRzOI":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"ZvpVd"}],"ZvpVd":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"6c6bm":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"15hEY","f3db08d4d1110aaf":"gXehZ"}],"15hEY":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"62bdZ","3cba3c966459d528":"gOdBF"}],"gOdBF":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"cjF0r":[function(require,module,exports,__globalThis) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"6buVu"}],"6buVu":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"8CW4A":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"62bdZ","2ca5b85a120835de":"gdA6Q","963b65e043435612":"9hdx6"}],"gdA6Q":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"ZvpVd"}],"fxfry":[function(require,module,exports,__globalThis) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"13Fzl","8bad46685c8864d":"i4avN","51c76ab24fdb66f9":"81TY3","7cb4cacc4dea406c":"e2Lkw"}],"13Fzl":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"i4avN":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"dBxei","4f010869f7b63154":"1N3wh","28f06147d1eb9502":"6buVu","3c56f88c4debf449":"e2Lkw","aee920e0ef5bf111":"6yECE"}],"dBxei":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"c06kb","89e9034a8071e297":"6Gwer","782598b150762386":"iKkev"}],"c06kb":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"1xWJr","9003c0cc8ac007b6":"amr5i"}],"1xWJr":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"kGHaY","ceda2a63c77c915":"8PAIi","91ee1b348d9d7172":"lnqIH","3fe28318f65b9332":"4xH1L","724ca4def8b84e06":"lJRRX","e9ceacb40d9582bd":"gALmY"}],"kGHaY":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"jUKvj","b700cb849df2c166":"4gX1f","d76dd90eead6cced":"967Pn","3d210628ba60ec8":"jgayP","76026bf2d4cfff93":"h2LMF"}],"jUKvj":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"4gX1f":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"6b2si"}],"6b2si":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"lrP9e"}],"lrP9e":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"967Pn":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"6b2si"}],"jgayP":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"6b2si"}],"h2LMF":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"6b2si"}],"8PAIi":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"kGHaY"}],"lnqIH":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"4xH1L":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"lJRRX":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"gALmY":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"kGHaY","1494efbafafa9552":"cSGeW","6049e8027fe9407f":"fhcoo"}],"cSGeW":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"4oEHP","29224713b8d411e6":"hfQqg"}],"4oEHP":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"7hHy7","16db51a0e009bd8c":"b55Aj"}],"7hHy7":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"15hEY","cabbc2adfaeb27d9":"11gKU","cbb5703fe1562e7f":"gOdBF","388b819f47a43aa5":"gf9ST"}],"11gKU":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"2EB1c"}],"2EB1c":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"hfQqg"}],"gf9ST":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"b55Aj":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"fhcoo":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"lo2Kz","d2967b0e32ccfa56":"jpsQv","ca21409ea89624c0":"hn5mm","f88fd07f8dd1f67d":"e8Vrs","dbf3eae765642a3b":"jeolH"}],"lo2Kz":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"4nCUJ","a07dcf3fd3097a0c":"kGHaY","92c01c953ef00ded":"cSGeW"}],"4nCUJ":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"gxE9O","bc25d439ccd1fb47":"eIeKK","f096b37295a92ab0":"go1ns","d88173cbc6a133c8":"fHa2d","afb9b3bae0461cbf":"h17CI"}],"gxE9O":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"7LlTK"}],"7LlTK":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"4oEHP"}],"eIeKK":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"go1ns":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"7LlTK"}],"fHa2d":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"7LlTK"}],"h17CI":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"7LlTK"}],"jpsQv":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"2XgoS"}],"2XgoS":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"36Uu3"}],"36Uu3":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"hn5mm":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"2XgoS"}],"e8Vrs":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"2XgoS"}],"jeolH":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"2XgoS"}],"amr5i":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"k4id7","809bbb0c20650dbc":"9hdx6"}],"k4id7":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"1xWJr","96bc8a1825db53a5":"bCYWb","8bdece495e87fb69":"e0aab","bb94920432a68eca":"aGYyv","45495edff98e5837":"7CISe","18256411ae9e2858":"e2Lkw","e5ba7abf54247fc5":"a1qsC","50d786bb5c7366af":"1hJWf"}],"bCYWb":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"fsEwB","1ee20de911db0cb0":"b0JZE","defff3d81be91b23":"idHUR"}],"fsEwB":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"fhcoo","9a831e81e9a1f98c":"gPD6U","1a2b6c8a7399c39f":"gKLd2"}],"gPD6U":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"gKLd2":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"b0JZE":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"idHUR":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"e0aab":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"9gDWc","dbf6aa5033a0f48":"cnjb7","539966708f906e61":"lrP9e","8142d4017f0a425f":"bCYWb","48cddf732eff33ba":"azFH4","9dc78b26c5daba20":"je2d8"}],"cnjb7":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"hfQqg"}],"azFH4":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"je2d8":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"aGYyv":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"avXGJ"}],"avXGJ":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"cFurh","aa79b69a13f924db":"eISjp","e3ad83e53433bc8a":"UsTmH"}],"cFurh":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"9OhQW","148b85918856c33a":"e2Lkw"}],"9OhQW":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"eISjp":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"3xZxm","6b1c62cea92cdb9":"iZvZg"}],"3xZxm":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"iZvZg":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"7CISe":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"chTqg","28e3344aae951f13":"cSGeW","b286298be5b1d9a4":"84pbE","3ae50c158f89813":"dsgJQ","9f458755f627d456":"5BppE","8e9160b373d7fe66":"62bdZ","b210627dd951641f":"gf9ST"}],"chTqg":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"4oEHP","f83c375075418382":"hfQqg"}],"84pbE":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"4oEHP","a5c6637bac681a0":"hfQqg"}],"dsgJQ":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"4oEHP","ca486d41cdf819d4":"hfQqg"}],"5BppE":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"4oEHP","7a9a6581834a8452":"hfQqg"}],"6Gwer":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"4aRca","94ffded3a85af2f6":"UsTmH"}],"4aRca":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"gOdBF"}],"iKkev":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"1N3wh":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"amr5i","d5ca180f7d6f956a":"4oeUX","3462bb3f546fa1f7":"kaFYn","f5fef07966a1c4ee":"13eQb","2a1cd212d48516":"4aRca","885e72ee7fc6d296":"iKkev","cd65eaf4a3af29f6":"2sFv2"}],"4oeUX":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"av1jC"}],"av1jC":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"9LYh0","c3296f04fad32769":"2sFv2"}],"9LYh0":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"e2Lkw","e823e604d75f975b":"13eQb","f5fff1c342107fbd":"wU9Bq","b04e8cc634273c23":"9OOfh"}],"13eQb":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"e2Lkw","4cdff6c9e9ff5d38":"8oAnl"}],"8oAnl":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"62bdZ","74644060ad1a1d3c":"9hdx6"}],"wU9Bq":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"5GALr"}],"5GALr":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"eeEjM"}],"eeEjM":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"fhcoo"}],"9OOfh":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"j9H7X"}],"j9H7X":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"9gDWc","8439a3a1551d0706":"13Fzl","4b12c9f502d3288a":"e2Lkw","a0ebd327d618908a":"8oAnl"}],"2sFv2":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"8oAnl"}],"kaFYn":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"6ZxpA","b0aefd36de99e579":"2dunC"}],"6ZxpA":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"2dunC":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"9LYh0","47ffafdab3ba0d6f":"5WfzS","93ebd263ff0131c1":"e2Lkw","252ef74480e01958":"fYQfR","23c2f64e75e90a2":"gXehZ","af5ade297cb685ee":"2sFv2"}],"6yECE":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"ee4J3","abf31da39349df22":"lrcN8","a387ef4a4373de2c":"13eQb","9315973458389ae7":"2sFv2"}],"ee4J3":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"lrcN8":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"av1jC"}],"81TY3":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"hyHW8","2924e2db4bb5430d":"6c6bm"}],"hyHW8":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"4btes","f1e3fc84161ef3ec":"e6yvu"}],"e6yvu":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"6c6bm"}],"kZc2y":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeClasses = undefined;
var _forOwn2 = require("42f7fd880fbb6b28");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _cloneDeep2 = require("fe0598645aa3c32b");
var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = _extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
exports.default = mergeClasses;

},{"42f7fd880fbb6b28":"iQzOr","fe0598645aa3c32b":"dxwM2"}],"dxwM2":[function(require,module,exports,__globalThis) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"548QM"}],"548QM":[function(require,module,exports,__globalThis) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"1xWJr","3a79976eb46af94a":"9lmIe","bc83a05a4f99d69b":"6SR8c","e6b4c3e6c85df6bb":"bGWTq","f340cc553ba5643c":"luTRe","e72e99883a50402d":"iOzDj","dc840ead07f1054":"coCz8","309288e8ee190af0":"bEqLk","687fa30fede0b048":"7D9vg","bb0ba724f98b094d":"avXGJ","12bae1dca0e83064":"6qWYX","4c3204eaea28d680":"7CISe","fd7741200b462cdf":"6S5VF","f93a1d24ac08e076":"2ZgJ7","630039e80f692f17":"buicI","f37949484ab52dae":"e2Lkw","ac876cc65d29c86e":"a1qsC","1056c031d98783c0":"jhQFZ","1800fb3122907fc2":"gOdBF","31f022f648037bd3":"jbmav","5f3267fbd9848a7d":"UsTmH","7d3f3bdc4f2e7bb8":"e5qsM"}],"9lmIe":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"6SR8c":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"7uW75","b62ef95b3cf1cde1":"lrP9e"}],"7uW75":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"60tXb"}],"60tXb":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"4oEHP"}],"bGWTq":[function(require,module,exports,__globalThis) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"2mydr","fcf23a0242ef0da9":"UsTmH"}],"2mydr":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"6SR8c","9cddf6ac1a092765":"7uW75"}],"luTRe":[function(require,module,exports,__globalThis) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"2mydr","7697a1565646c93":"e5qsM"}],"e5qsM":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"a94jA","194eb1a802636842":"dBz3X","ac15afdc3ddd76cd":"6c6bm"}],"dBz3X":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"gOdBF","f7d53cd92b2b977b":"l6L9q","c039208a16eb68bd":"ju7YB"}],"ju7YB":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"iOzDj":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"hfQqg"}],"coCz8":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"bEqLk":[function(require,module,exports,__globalThis) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"2mydr","39cbde2205d9399c":"eISjp"}],"7D9vg":[function(require,module,exports,__globalThis) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"2mydr","9b660e6b0c20d303":"i03XC"}],"i03XC":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"9OhQW","6ccae2aa7cfa3c66":"gdA6Q","bdb501682ee9305d":"eISjp","7641fe4ae6d2cc96":"iZvZg"}],"6qWYX":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"cFurh","feede5d0a2d06427":"i03XC","287f70f798405911":"e5qsM"}],"6S5VF":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"2ZgJ7":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"5pj0u","dbf04edaab2ae376":"jI4qj","763300f2dd9bdaf3":"iUc2Y","c30e64d90e4b92d1":"381QM","d1edd8349e9ad54d":"gtkTo"}],"5pj0u":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"cnjb7"}],"jI4qj":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"5pj0u"}],"iUc2Y":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"381QM":[function(require,module,exports,__globalThis) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"9gDWc"}],"gtkTo":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"5pj0u"}],"buicI":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"QNO04","8c92276927b7c3e0":"gdA6Q","e939f15d7a0f64a5":"l6L9q"}],"QNO04":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"gOdBF"}],"jhQFZ":[function(require,module,exports,__globalThis) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"iI764","6a7e6b1a2d9fb1d5":"hZnDi","7d4f449dd306450f":"jwac5"}],"iI764":[function(require,module,exports,__globalThis) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"7CISe","88260e33e0003386":"9hdx6"}],"jbmav":[function(require,module,exports,__globalThis) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"fnGvv","3cb35dba719c68b1":"hZnDi","7a3e899a332ff7be":"jwac5"}],"fnGvv":[function(require,module,exports,__globalThis) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"7CISe","b6fc875bc5f351c9":"9hdx6"}],"jIeqA":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoprefix = undefined;
var _forOwn2 = require("6b2ab06ed0e74650");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var autoprefix = exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
            var transform = transforms[key];
            if (transform) expanded = _extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
exports.default = autoprefix;

},{"6b2ab06ed0e74650":"iQzOr"}],"FTW7f":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("a618bb79e13970dd");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }(_react2.default.Component);
};
exports.default = hover;

},{"a618bb79e13970dd":"IMRgT"}],"louE4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.active = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("91e1b91cd0b21ba2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }(_react2.default.Component);
};
exports.default = active;

},{"91e1b91cd0b21ba2":"IMRgT"}],"5rK9z":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
exports.default = loopable;

},{}],"b7fAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "Checkboard", ()=>(0, _checkboardDefault.default));
parcelHelpers.export(exports, "EditableInput", ()=>(0, _editableInputDefault.default));
parcelHelpers.export(exports, "Hue", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "Raised", ()=>(0, _raisedDefault.default));
parcelHelpers.export(exports, "Saturation", ()=>(0, _saturationDefault.default));
parcelHelpers.export(exports, "ColorWrap", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "Swatch", ()=>(0, _swatchDefault.default));
var _alpha = require("./Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _editableInput = require("./EditableInput");
var _editableInputDefault = parcelHelpers.interopDefault(_editableInput);
var _hue = require("./Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _raised = require("./Raised");
var _raisedDefault = parcelHelpers.interopDefault(_raised);
var _saturation = require("./Saturation");
var _saturationDefault = parcelHelpers.interopDefault(_saturation);
var _colorWrap = require("./ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);
var _swatch = require("./Swatch");
var _swatchDefault = parcelHelpers.interopDefault(_swatch);

},{"./Alpha":"eualg","./Checkboard":"6PsWA","./EditableInput":"k2ept","./Hue":"fqXC6","./Raised":"5UrlJ","./Saturation":"5YhdD","./ColorWrap":"6TXcU","./Swatch":"fZcZT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eualg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _alpha = require("../../helpers/alpha");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
    _inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': _extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.checkboard
                }, (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
                    renderers: this.props.renderers
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.gradient
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Alpha;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/alpha":"aVU7w","./Checkboard":"6PsWA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aVU7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6PsWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboard", ()=>Checkboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _checkboard = require("../../helpers/checkboard");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + _checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, _react.isValidElement)(children) ? (0, _reactDefault.default).cloneElement(children, _extends({}, children.props, {
        style: _extends({}, children.props.style, styles.grid)
    })) : (0, _reactDefault.default).createElement('div', {
        style: styles.grid
    });
};
Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
exports.default = Checkboard;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/checkboard":"5pjOW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5pjOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "get", ()=>get);
var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if (checkboardCache[key]) return checkboardCache[key];
    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k2ept":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInput", ()=>EditableInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [
    UP_KEY_CODE,
    DOWN_KEY_CODE
];
var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var idCounter = 1;
var EditableInput = function(_ref) {
    _inherits(EditableInput, _ref);
    function EditableInput(props) {
        _classCallCheck(this, EditableInput);
        var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = getNumberValue(e.target.value);
            if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + idCounter++;
        return _this;
    }
    _createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return _defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap
                }, (0, _reactDefault.default).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, _reactDefault.default).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = EditableInput;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fqXC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hue", ()=>Hue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _hue = require("../../helpers/hue");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
    _inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Hue;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/hue":"8ouzM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8ouzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5UrlJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Raised", ()=>Raised);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.bg
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.content
    }, children));
};
Raised.propTypes = {
    background: (0, _propTypesDefault.default).string,
    zDepth: (0, _propTypesDefault.default).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
exports.default = Raised;

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jBFEd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"3r1B5","./_createAssigner.js":"dIwBm","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3r1B5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"ic7Np","./_assignMergeValue.js":"dxDjX","./_baseFor.js":"k5X33","./_baseMergeDeep.js":"aXeHa","./isObject.js":"1XhCI","./keysIn.js":"lsYoQ","./_safeGet.js":"8Bi0Z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ic7Np":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype['delete'] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"g2vXf","./_stackClear.js":"kwDsJ","./_stackDelete.js":"2abWI","./_stackGet.js":"54AXU","./_stackHas.js":"bEeeY","./_stackSet.js":"ibLOI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"g2vXf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype['delete'] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"4yPpx","./_listCacheDelete.js":"htbZZ","./_listCacheGet.js":"3DrNK","./_listCacheHas.js":"aCatM","./_listCacheSet.js":"idRhO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4yPpx":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"htbZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"hmHOB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hmHOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"aLCOW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aLCOW":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3DrNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"hmHOB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aCatM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"hmHOB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"idRhO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"hmHOB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kwDsJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"g2vXf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2abWI":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"54AXU":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bEeeY":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ibLOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"g2vXf","./_Map.js":"cND7G","./_MapCache.js":"fe9S3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cND7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Map');
exports.default = Map;

},{"./_getNative.js":"iuJGh","./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iuJGh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"5zVjf","./_getValue.js":"4e06A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5zVjf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"6KL9g","./_isMasked.js":"e2pQM","./isObject.js":"1XhCI","./_toSource.js":"dAjyu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6KL9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"heZ7g","./isObject.js":"1XhCI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"heZ7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"6UyyI","./_getRawTag.js":"4UP8q","./_objectToString.js":"1YXLA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6UyyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"E7Za9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function('return this')();
exports.default = root;

},{"./_freeGlobal.js":"fiQLR","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fiQLR":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4UP8q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"6UyyI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1YXLA":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1XhCI":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e2pQM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"9VKOk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9VKOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)['__core-js_shared__'];
exports.default = coreJsData;

},{"./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dAjyu":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4e06A":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fe9S3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype['delete'] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"lqhct","./_mapCacheDelete.js":"dY0ix","./_mapCacheGet.js":"3vkSj","./_mapCacheHas.js":"5tm0g","./_mapCacheSet.js":"fVOUv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lqhct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, _hashJsDefault.default),
        'map': new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        'string': new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"77phJ","./_ListCache.js":"g2vXf","./_Map.js":"cND7G","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"77phJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype['delete'] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"5LOKu","./_hashDelete.js":"jezFu","./_hashGet.js":"dF3gV","./_hashHas.js":"bHrPq","./_hashSet.js":"ifEIC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5LOKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"6hdFC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6hdFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, 'create');
exports.default = nativeCreate;

},{"./_getNative.js":"iuJGh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jezFu":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dF3gV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"6hdFC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bHrPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"6hdFC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ifEIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"6hdFC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dY0ix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"dhl4c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dhl4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"8ioy2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8ioy2":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3vkSj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"dhl4c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5tm0g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"dhl4c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fVOUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"dhl4c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dxDjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"9cF0z","./eq.js":"aLCOW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9cF0z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"aLgRc","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aLgRc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"iuJGh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k5X33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"9pv0N","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9pv0N":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aXeHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"dxDjX","./_cloneBuffer.js":"hQrbk","./_cloneTypedArray.js":"jW69o","./_copyArray.js":"dw7d7","./_initCloneObject.js":"6hEca","./isArguments.js":"05eGH","./isArray.js":"k3vmz","./isArrayLikeObject.js":"33OP3","./isBuffer.js":"adE78","./isFunction.js":"6KL9g","./isObject.js":"1XhCI","./isPlainObject.js":"59by1","./isTypedArray.js":"iu237","./_safeGet.js":"8Bi0Z","./toPlainObject.js":"bu5Ln","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hQrbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jW69o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"9ohSn","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9ohSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"5nxX6","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5nxX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dw7d7":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6hEca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"aUSCf","./_getPrototype.js":"5NQhv","./_isPrototype.js":"ktyt4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aUSCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"1XhCI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5NQhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"6KM7B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6KM7B":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ktyt4":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"05eGH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"kU2OB","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kU2OB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"heZ7g","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gd171":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k3vmz":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"33OP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"91QEo","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"91QEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"6KL9g","./isLength.js":"gF8aA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gF8aA":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"adE78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"E7Za9","./stubFalse.js":"hBa6N","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hBa6N":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"59by1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"heZ7g","./_getPrototype.js":"5NQhv","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iu237":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"4YZeC","./_baseUnary.js":"2xxM0","./_nodeUtil.js":"5KwwV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4YZeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"heZ7g","./isLength.js":"gF8aA","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2xxM0":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5KwwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"fiQLR","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8Bi0Z":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bu5Ln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"fOKKz","./keysIn.js":"lsYoQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fOKKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"9tnFd","./_baseAssignValue.js":"9cF0z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9tnFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"9cF0z","./eq.js":"aLCOW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lsYoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"4V8Hp","./_baseKeysIn.js":"3esSW","./isArrayLike.js":"91QEo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4V8Hp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"82DmG","./isArguments.js":"05eGH","./isArray.js":"k3vmz","./isBuffer.js":"adE78","./_isIndex.js":"fSdkU","./isTypedArray.js":"iu237","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"82DmG":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fSdkU":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3esSW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"1XhCI","./_isPrototype.js":"ktyt4","./_nativeKeysIn.js":"7NLLu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7NLLu":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dIwBm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"cT9Ey","./_isIterateeCall.js":"5K7k3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cT9Ey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + '');
}
exports.default = baseRest;

},{"./identity.js":"iZLdt","./_overRest.js":"ffALR","./_setToString.js":"cExdV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iZLdt":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ffALR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"fszuU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fszuU":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cExdV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"5JtKU","./_shortOut.js":"4v29D","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5JtKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, _constantJsDefault.default)(string),
        'writable': true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"knYvM","./_defineProperty.js":"aLgRc","./identity.js":"iZLdt","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"knYvM":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4v29D":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5K7k3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == 'string' && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"aLCOW","./isArrayLike.js":"91QEo","./_isIndex.js":"fSdkU","./isObject.js":"1XhCI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5YhdD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saturation", ()=>Saturation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _saturation = require("../../helpers/saturation");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
    _inherits(Saturation, _ref);
    function Saturation(props) {
        _classCallCheck(this, Saturation);
        var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, _saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, _throttleDefault.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    _createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, _reactDefault.default).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Saturation;

},{"react":"IMRgT","reactcss":"k3r4z","lodash-es/throttle":"hgPoq","../../helpers/saturation":"8W2Cj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hgPoq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"aRikk","./isObject.js":"1XhCI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aRikk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"1XhCI","./now.js":"8HZxA","./toNumber.js":"dPwIT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8HZxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dPwIT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"er77m","./isObject.js":"1XhCI","./isSymbol.js":"6mJJk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"er77m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, '') : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"cNCOr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cNCOr":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6mJJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"heZ7g","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8W2Cj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6TXcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWrap", ()=>ColorWrap);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash-es/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _color = require("../../helpers/color");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        _inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            _classCallCheck(this, ColorPicker);
            var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = _extends({}, _color.toState(props.color, 0));
            _this.debounce = (0, _debounceDefault.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        _createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, _reactDefault.default).createElement(Picker, _extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return _extends({}, _color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, _react.PureComponent) || (0, _react.Component));
    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
exports.default = ColorWrap;

},{"react":"IMRgT","lodash-es/debounce":"aRikk","../../helpers/color":"416MJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"416MJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "simpleCheckForValidColor", ()=>simpleCheckForValidColor);
parcelHelpers.export(exports, "toState", ()=>toState);
parcelHelpers.export(exports, "isValidHex", ()=>isValidHex);
parcelHelpers.export(exports, "getContrastingColor", ()=>getContrastingColor);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "isvalidColorString", ()=>isvalidColorString);
var _each = require("lodash-es/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, _eachDefault.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2Default.default)(data.hex) : (0, _tinycolor2Default.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2Default.default)(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, _tinycolor2Default.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

},{"lodash-es/each":"9L6iT","tinycolor2":"jPWgM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9L6iT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayEachJsDefault.default) : (0, _baseEachJsDefault.default);
    return func(collection, (0, _castFunctionJsDefault.default)(iteratee));
}
exports.default = forEach;

},{"./_arrayEach.js":"gx6wy","./_baseEach.js":"9gBLs","./_castFunction.js":"8d1WV","./isArray.js":"k3vmz","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gx6wy":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9gBLs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForOwnJs = require("./_baseForOwn.js");
var _baseForOwnJsDefault = parcelHelpers.interopDefault(_baseForOwnJs);
var _createBaseEachJs = require("./_createBaseEach.js");
var _createBaseEachJsDefault = parcelHelpers.interopDefault(_createBaseEachJs);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = (0, _createBaseEachJsDefault.default)((0, _baseForOwnJsDefault.default));
exports.default = baseEach;

},{"./_baseForOwn.js":"l5kEc","./_createBaseEach.js":"wOeFJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l5kEc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && (0, _baseForJsDefault.default)(object, iteratee, (0, _keysJsDefault.default));
}
exports.default = baseForOwn;

},{"./_baseFor.js":"k5X33","./keys.js":"c1rqx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c1rqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"4V8Hp","./_baseKeys.js":"9F7P9","./isArrayLike.js":"91QEo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9F7P9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"ktyt4","./_nativeKeys.js":"2lfsv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2lfsv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"6KM7B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"wOeFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, _isArrayLikeJsDefault.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
exports.default = createBaseEach;

},{"./isArrayLike.js":"91QEo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8d1WV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : (0, _identityJsDefault.default);
}
exports.default = castFunction;

},{"./identity.js":"iZLdt","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fZcZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatch", ()=>Swatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _interaction = require("../../helpers/interaction");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var ENTER = 13;
var Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, _reactcssDefault.default)({
        default: {
            swatch: _extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, _reactDefault.default).createElement('div', _extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
exports.default = (0, _interaction.handleFocus)(Swatch);

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/interaction":"lbpq8","./Checkboard":"6PsWA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lbpq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFocus", ()=>handleFocus);
/* eslint-disable no-invalid-this */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, _reactDefault.default).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, _reactDefault.default).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, _reactDefault.default).Component);
};

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7d3E8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPointer", ()=>AlphaPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = AlphaPointer;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6eM2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Block", ()=>Block);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _blockSwatches = require("./BlockSwatches");
var _blockSwatchesDefault = parcelHelpers.interopDefault(_blockSwatches);
var Block = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        _color.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: _color.getContrastingColor(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, transparent && (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        borderRadius: '6px 6px 0 0'
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, hex)), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement((0, _blockSwatchesDefault.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
Block.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Block.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Block);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../../helpers/color":"416MJ","../common":"b7fAS","./BlockSwatches":"h152s","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h152s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockSwatches", ()=>BlockSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _common = require("../common");
var BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = BlockSwatches;

},{"react":"IMRgT","reactcss":"k3r4z","lodash-es/map":"6D4U6","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6D4U6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _baseIterateeJs = require("./_baseIteratee.js");
var _baseIterateeJsDefault = parcelHelpers.interopDefault(_baseIterateeJs);
var _baseMapJs = require("./_baseMap.js");
var _baseMapJsDefault = parcelHelpers.interopDefault(_baseMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayMapJsDefault.default) : (0, _baseMapJsDefault.default);
    return func(collection, (0, _baseIterateeJsDefault.default)(iteratee, 3));
}
exports.default = map;

},{"./_arrayMap.js":"f8FWN","./_baseIteratee.js":"7ikxD","./_baseMap.js":"Pwxhf","./isArray.js":"k3vmz","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f8FWN":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7ikxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMatchesJs = require("./_baseMatches.js");
var _baseMatchesJsDefault = parcelHelpers.interopDefault(_baseMatchesJs);
var _baseMatchesPropertyJs = require("./_baseMatchesProperty.js");
var _baseMatchesPropertyJsDefault = parcelHelpers.interopDefault(_baseMatchesPropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, _identityJsDefault.default;
    if (typeof value == 'object') return (0, _isArrayJsDefault.default)(value) ? (0, _baseMatchesPropertyJsDefault.default)(value[0], value[1]) : (0, _baseMatchesJsDefault.default)(value);
    return (0, _propertyJsDefault.default)(value);
}
exports.default = baseIteratee;

},{"./_baseMatches.js":"Mxq0y","./_baseMatchesProperty.js":"4bilC","./identity.js":"iZLdt","./isArray.js":"k3vmz","./property.js":"5ykwT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"Mxq0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMatchJs = require("./_baseIsMatch.js");
var _baseIsMatchJsDefault = parcelHelpers.interopDefault(_baseIsMatchJs);
var _getMatchDataJs = require("./_getMatchData.js");
var _getMatchDataJsDefault = parcelHelpers.interopDefault(_getMatchDataJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = (0, _getMatchDataJsDefault.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, _matchesStrictComparableJsDefault.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, _baseIsMatchJsDefault.default)(object, source, matchData);
    };
}
exports.default = baseMatches;

},{"./_baseIsMatch.js":"gprKE","./_getMatchData.js":"aiQhM","./_matchesStrictComparable.js":"f3HIa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gprKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, _stackJsDefault.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
exports.default = baseIsMatch;

},{"./_Stack.js":"ic7Np","./_baseIsEqual.js":"ix1pA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ix1pA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualDeepJs = require("./_baseIsEqualDeep.js");
var _baseIsEqualDeepJsDefault = parcelHelpers.interopDefault(_baseIsEqualDeepJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, _isObjectLikeJsDefault.default)(value) && !(0, _isObjectLikeJsDefault.default)(other)) return value !== value && other !== other;
    return (0, _baseIsEqualDeepJsDefault.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}
exports.default = baseIsEqual;

},{"./_baseIsEqualDeep.js":"cw38l","./isObjectLike.js":"gd171","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cw38l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _equalByTagJs = require("./_equalByTag.js");
var _equalByTagJsDefault = parcelHelpers.interopDefault(_equalByTagJs);
var _equalObjectsJs = require("./_equalObjects.js");
var _equalObjectsJsDefault = parcelHelpers.interopDefault(_equalObjectsJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, _isArrayJsDefault.default)(object), othIsArr = (0, _isArrayJsDefault.default)(other), objTag = objIsArr ? arrayTag : (0, _getTagJsDefault.default)(object), othTag = othIsArr ? arrayTag : (0, _getTagJsDefault.default)(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, _isBufferJsDefault.default)(object)) {
        if (!(0, _isBufferJsDefault.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, _stackJsDefault.default));
        return objIsArr || (0, _isTypedArrayJsDefault.default)(object) ? (0, _equalArraysJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTagJsDefault.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, _stackJsDefault.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, _stackJsDefault.default));
    return (0, _equalObjectsJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack);
}
exports.default = baseIsEqualDeep;

},{"./_Stack.js":"ic7Np","./_equalArrays.js":"fvJDl","./_equalByTag.js":"6gvVG","./_equalObjects.js":"hOUpE","./_getTag.js":"cE4Ce","./isArray.js":"k3vmz","./isBuffer.js":"adE78","./isTypedArray.js":"iu237","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fvJDl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setCacheJs = require("./_SetCache.js");
var _setCacheJsDefault = parcelHelpers.interopDefault(_setCacheJs);
var _arraySomeJs = require("./_arraySome.js");
var _arraySomeJsDefault = parcelHelpers.interopDefault(_arraySomeJs);
var _cacheHasJs = require("./_cacheHas.js");
var _cacheHasJsDefault = parcelHelpers.interopDefault(_cacheHasJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new (0, _setCacheJsDefault.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, _arraySomeJsDefault.default)(other, function(othValue, othIndex) {
                if (!(0, _cacheHasJsDefault.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
exports.default = equalArrays;

},{"./_SetCache.js":"3Wrxb","./_arraySome.js":"2Rpsg","./_cacheHas.js":"6yRel","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3Wrxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
var _setCacheAddJs = require("./_setCacheAdd.js");
var _setCacheAddJsDefault = parcelHelpers.interopDefault(_setCacheAddJs);
var _setCacheHasJs = require("./_setCacheHas.js");
var _setCacheHasJsDefault = parcelHelpers.interopDefault(_setCacheHasJs);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, _mapCacheJsDefault.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = (0, _setCacheAddJsDefault.default);
SetCache.prototype.has = (0, _setCacheHasJsDefault.default);
exports.default = SetCache;

},{"./_MapCache.js":"fe9S3","./_setCacheAdd.js":"4NeI9","./_setCacheHas.js":"4mTZ4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4NeI9":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
exports.default = setCacheAdd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4mTZ4":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setCacheHas(value) {
    return this.__data__.has(value);
}
exports.default = setCacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2Rpsg":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
exports.default = arraySome;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6yRel":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function cacheHas(cache, key) {
    return cache.has(key);
}
exports.default = cacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6gvVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _mapToArrayJs = require("./_mapToArray.js");
var _mapToArrayJsDefault = parcelHelpers.interopDefault(_mapToArrayJs);
var _setToArrayJs = require("./_setToArray.js");
var _setToArrayJsDefault = parcelHelpers.interopDefault(_setToArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, _uint8ArrayJsDefault.default)(object), new (0, _uint8ArrayJsDefault.default)(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, _eqJsDefault.default)(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = (0, _mapToArrayJsDefault.default);
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, _setToArrayJsDefault.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, _equalArraysJsDefault.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
exports.default = equalByTag;

},{"./_Symbol.js":"6UyyI","./_Uint8Array.js":"5nxX6","./eq.js":"aLCOW","./_equalArrays.js":"fvJDl","./_mapToArray.js":"8YVMV","./_setToArray.js":"5JYU7","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8YVMV":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
exports.default = mapToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5JYU7":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
exports.default = setToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hOUpE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = (0, _getAllKeysJsDefault.default)(object), objLength = objProps.length, othProps = (0, _getAllKeysJsDefault.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
exports.default = equalObjects;

},{"./_getAllKeys.js":"bEHnG","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bEHnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"4uRKe","./_getSymbols.js":"3XawV","./keys.js":"c1rqx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4uRKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"bw9YI","./isArray.js":"k3vmz","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bw9YI":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3XawV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"lkwM5","./stubArray.js":"7BR6S","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lkwM5":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7BR6S":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cE4Ce":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"1BGeB","./_Map.js":"cND7G","./_Promise.js":"cUwfG","./_Set.js":"dkxxc","./_WeakMap.js":"42imJ","./_baseGetTag.js":"heZ7g","./_toSource.js":"dAjyu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1BGeB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'DataView');
exports.default = DataView;

},{"./_getNative.js":"iuJGh","./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cUwfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Promise');
exports.default = Promise;

},{"./_getNative.js":"iuJGh","./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dkxxc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Set');
exports.default = Set;

},{"./_getNative.js":"iuJGh","./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"42imJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'WeakMap');
exports.default = WeakMap;

},{"./_getNative.js":"iuJGh","./_root.js":"E7Za9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aiQhM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = (0, _keysJsDefault.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, _isStrictComparableJsDefault.default)(value)
        ];
    }
    return result;
}
exports.default = getMatchData;

},{"./_isStrictComparable.js":"5mj5t","./keys.js":"c1rqx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5mj5t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !(0, _isObjectJsDefault.default)(value);
}
exports.default = isStrictComparable;

},{"./isObject.js":"1XhCI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f3HIa":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
exports.default = matchesStrictComparable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4bilC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
var _getJs = require("./get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if ((0, _isKeyJsDefault.default)(path) && (0, _isStrictComparableJsDefault.default)(srcValue)) return (0, _matchesStrictComparableJsDefault.default)((0, _toKeyJsDefault.default)(path), srcValue);
    return function(object) {
        var objValue = (0, _getJsDefault.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, _hasInJsDefault.default)(object, path) : (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
exports.default = baseMatchesProperty;

},{"./_baseIsEqual.js":"ix1pA","./get.js":"eU7yg","./hasIn.js":"fvJNc","./_isKey.js":"iNV9w","./_isStrictComparable.js":"5mj5t","./_matchesStrictComparable.js":"f3HIa","./_toKey.js":"hBfpv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eU7yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, _baseGetJsDefault.default)(object, path);
    return result === undefined ? defaultValue : result;
}
exports.default = get;

},{"./_baseGet.js":"faBAv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"faBAv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, _toKeyJsDefault.default)(path[index++])];
    return index && index == length ? object : undefined;
}
exports.default = baseGet;

},{"./_castPath.js":"gbS1W","./_toKey.js":"hBfpv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gbS1W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return value;
    return (0, _isKeyJsDefault.default)(value, object) ? [
        value
    ] : (0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value));
}
exports.default = castPath;

},{"./isArray.js":"k3vmz","./_isKey.js":"iNV9w","./_stringToPath.js":"ay6tv","./toString.js":"eykXT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iNV9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, _isSymbolJsDefault.default)(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
exports.default = isKey;

},{"./isArray.js":"k3vmz","./isSymbol.js":"6mJJk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ay6tv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"8K7GL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8K7GL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"31Ncq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"31Ncq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"fe9S3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eykXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"kzqv5","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kzqv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + '';
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"6UyyI","./_arrayMap.js":"f8FWN","./isArray.js":"k3vmz","./isSymbol.js":"6mJJk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hBfpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = toKey;

},{"./isSymbol.js":"6mJJk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fvJNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseHasInJs = require("./_baseHasIn.js");
var _baseHasInJsDefault = parcelHelpers.interopDefault(_baseHasInJs);
var _hasPathJs = require("./_hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && (0, _hasPathJsDefault.default)(object, path, (0, _baseHasInJsDefault.default));
}
exports.default = hasIn;

},{"./_baseHasIn.js":"2BDvG","./_hasPath.js":"d6NBE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2BDvG":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
exports.default = baseHasIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"d6NBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, _toKeyJsDefault.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, _isLengthJsDefault.default)(length) && (0, _isIndexJsDefault.default)(key, length) && ((0, _isArrayJsDefault.default)(object) || (0, _isArgumentsJsDefault.default)(object));
}
exports.default = hasPath;

},{"./_castPath.js":"gbS1W","./isArguments.js":"05eGH","./isArray.js":"k3vmz","./_isIndex.js":"fSdkU","./isLength.js":"gF8aA","./_toKey.js":"hBfpv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5ykwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basePropertyJs = require("./_baseProperty.js");
var _basePropertyJsDefault = parcelHelpers.interopDefault(_basePropertyJs);
var _basePropertyDeepJs = require("./_basePropertyDeep.js");
var _basePropertyDeepJsDefault = parcelHelpers.interopDefault(_basePropertyDeepJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return (0, _isKeyJsDefault.default)(path) ? (0, _basePropertyJsDefault.default)((0, _toKeyJsDefault.default)(path)) : (0, _basePropertyDeepJsDefault.default)(path);
}
exports.default = property;

},{"./_baseProperty.js":"8aD8y","./_basePropertyDeep.js":"81G0C","./_isKey.js":"iNV9w","./_toKey.js":"hBfpv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8aD8y":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
exports.default = baseProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"81G0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return (0, _baseGetJsDefault.default)(object, path);
    };
}
exports.default = basePropertyDeep;

},{"./_baseGet.js":"faBAv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"Pwxhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = (0, _isArrayLikeJsDefault.default)(collection) ? Array(collection.length) : [];
    (0, _baseEachJsDefault.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
exports.default = baseMap;

},{"./_baseEach.js":"9gBLs","./isArrayLike.js":"91QEo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hL3jq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _circleSwatch = require("./CircleSwatch");
var _circleSwatchDefault = parcelHelpers.interopDefault(_circleSwatch);
var Circle = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _circleSwatchDefault.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
Circle.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    circleSize: (0, _propTypesDefault.default).number,
    circleSpacing: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        _materialColors.red['500'],
        _materialColors.pink['500'],
        _materialColors.purple['500'],
        _materialColors.deepPurple['500'],
        _materialColors.indigo['500'],
        _materialColors.blue['500'],
        _materialColors.lightBlue['500'],
        _materialColors.cyan['500'],
        _materialColors.teal['500'],
        _materialColors.green['500'],
        _materialColors.lightGreen['500'],
        _materialColors.lime['500'],
        _materialColors.yellow['500'],
        _materialColors.amber['500'],
        _materialColors.orange['500'],
        _materialColors.deepOrange['500'],
        _materialColors.brown['500'],
        _materialColors.blueGrey['500']
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Circle);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/map":"6D4U6","lodash-es/merge":"jBFEd","material-colors":"2igAq","../common":"b7fAS","./CircleSwatch":"01P33","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2igAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "pink", ()=>pink);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "deepPurple", ()=>deepPurple);
parcelHelpers.export(exports, "indigo", ()=>indigo);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "lightBlue", ()=>lightBlue);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "lightGreen", ()=>lightGreen);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "amber", ()=>amber);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "deepOrange", ()=>deepOrange);
parcelHelpers.export(exports, "brown", ()=>brown);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "blueGrey", ()=>blueGrey);
parcelHelpers.export(exports, "darkText", ()=>darkText);
parcelHelpers.export(exports, "lightText", ()=>lightText);
parcelHelpers.export(exports, "darkIcons", ()=>darkIcons);
parcelHelpers.export(exports, "lightIcons", ()=>lightIcons);
parcelHelpers.export(exports, "white", ()=>white);
parcelHelpers.export(exports, "black", ()=>black);
var red = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var pink = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var purple = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var deepPurple = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var indigo = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var blue = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var lightBlue = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var cyan = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var teal = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var green = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var lightGreen = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var lime = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var yellow = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var amber = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var orange = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var deepOrange = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var brown = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var grey = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var blueGrey = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var darkText = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
exports.default = {
    red: red,
    pink: pink,
    purple: purple,
    deepPurple: deepPurple,
    indigo: indigo,
    blue: blue,
    lightBlue: lightBlue,
    cyan: cyan,
    teal: teal,
    green: green,
    lightGreen: lightGreen,
    lime: lime,
    yellow: yellow,
    amber: amber,
    orange: orange,
    deepOrange: deepOrange,
    brown: brown,
    grey: grey,
    blueGrey: blueGrey,
    darkText: darkText,
    lightText: lightText,
    darkIcons: darkIcons,
    lightIcons: lightIcons,
    white: white,
    black: black
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"01P33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleSwatch", ()=>CircleSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
exports.default = (0, _reactcss.handleHover)(CircleSwatch);

},{"react":"IMRgT","reactcss":"k3r4z","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"g5EzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chrome", ()=>Chrome);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _chromeFields = require("./ChromeFields");
var _chromeFieldsDefault = parcelHelpers.interopDefault(_chromeFields);
var _chromePointer = require("./ChromePointer");
var _chromePointerDefault = parcelHelpers.interopDefault(_chromePointer);
var _chromePointerCircle = require("./ChromePointerCircle");
var _chromePointerCircleDefault = parcelHelpers.interopDefault(_chromePointerCircle);
var Chrome = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _chromePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        renderers: renderers
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.toggles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, _reactDefault.default).createElement((0, _chromeFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
Chrome.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    disableAlpha: (0, _propTypesDefault.default).bool,
    styles: (0, _propTypesDefault.default).object,
    defaultView: (0, _propTypesDefault.default).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Chrome);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./ChromeFields":"fiSKu","./ChromePointer":"4YI7a","./ChromePointerCircle":"8hfvB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fiSKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromeFields", ()=>ChromeFields);
/* eslint-disable react/no-did-mount-set-state, no-param-reassign */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _isUndefined = require("lodash-es/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _common = require("../common");
var _unfoldMoreHorizontalIcon = require("@icons/material/UnfoldMoreHorizontalIcon");
var _unfoldMoreHorizontalIconDefault = parcelHelpers.interopDefault(_unfoldMoreHorizontalIcon);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
    _inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        _classCallCheck(this, ChromeFields);
        var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) _color.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, _isUndefinedDefault.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, _isUndefinedDefault.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    _createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, _reactDefault.default).createElement('div', {
                    style: styles.toggle
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, _reactDefault.default).createElement((0, _unfoldMoreHorizontalIconDefault.default), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, _reactDefault.default).Component);
ChromeFields.defaultProps = {
    view: "hex"
};
exports.default = ChromeFields;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","lodash-es/isUndefined":"UmuIk","../common":"b7fAS","@icons/material/UnfoldMoreHorizontalIcon":"ebkwf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"UmuIk":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isUndefined(value) {
    return value === undefined;
}
exports.default = isUndefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ebkwf":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cab3160a8154bde");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};

},{"cab3160a8154bde":"IMRgT"}],"4YI7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointer", ()=>ChromePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointer = function ChromePointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointer;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8hfvB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointerCircle", ()=>ChromePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointerCircle;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"91Fcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compact", ()=>Compact);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _compactColor = require("./CompactColor");
var _compactColorDefault = parcelHelpers.interopDefault(_compactColor);
var _compactFields = require("./CompactFields");
var _compactFieldsDefault = parcelHelpers.interopDefault(_compactFields);
var Compact = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, _reactDefault.default).createElement('div', null, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _compactColorDefault.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })), (0, _reactDefault.default).createElement((0, _compactFieldsDefault.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
Compact.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Compact.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Compact);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/map":"6D4U6","lodash-es/merge":"jBFEd","../../helpers/color":"416MJ","../common":"b7fAS","./CompactColor":"4Dgts","./CompactFields":"7UKXW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4Dgts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactColor", ()=>CompactColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var CompactColor = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: _color.getContrastingColor(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.dot
    }));
};
exports.default = CompactColor;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7UKXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactFields", ()=>CompactFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
exports.default = CompactFields;

},{"react":"IMRgT","reactcss":"k3r4z","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bmbqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _githubSwatch = require("./GithubSwatch");
var _githubSwatchDefault = parcelHelpers.interopDefault(_githubSwatch);
var Github = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _githubSwatchDefault.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
Github.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Github.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Github);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/map":"6D4U6","lodash-es/merge":"jBFEd","../common":"b7fAS","./GithubSwatch":"2Zo2A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2Zo2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubSwatch", ()=>GithubSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
exports.default = (0, _reactcss.handleHover)(GithubSwatch);

},{"react":"IMRgT","reactcss":"k3r4z","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fXhnw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HuePicker", ()=>HuePicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _huePointer = require("./HuePointer");
var _huePointerDefault = parcelHelpers.interopDefault(_huePointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var HuePicker = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Hue), _extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
HuePicker.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
HuePicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _huePointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(HuePicker);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./HuePointer":"2PYBV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2PYBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fjCs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Material", ()=>Material);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Material = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
exports.default = (0, _common.ColorWrap)(Material);

},{"react":"IMRgT","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"0svIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photoshop", ()=>Photoshop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _photoshopFields = require("./PhotoshopFields");
var _photoshopFieldsDefault = parcelHelpers.interopDefault(_photoshopFields);
var _photoshopPointerCircle = require("./PhotoshopPointerCircle");
var _photoshopPointerCircleDefault = parcelHelpers.interopDefault(_photoshopPointerCircle);
var _photoshopPointer = require("./PhotoshopPointer");
var _photoshopPointerDefault = parcelHelpers.interopDefault(_photoshopPointer);
var _photoshopButton = require("./PhotoshopButton");
var _photoshopButtonDefault = parcelHelpers.interopDefault(_photoshopButton);
var _photoshopPreviews = require("./PhotoshopPreviews");
var _photoshopPreviewsDefault = parcelHelpers.interopDefault(_photoshopPreviews);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
    _inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        _classCallCheck(this, Photoshop);
        var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    _createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, _reactDefault.default).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.saturation
                }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, _photoshopPointerCircleDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement((0, _common.Hue), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, _photoshopPointerDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.controls
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.previews
                }, (0, _reactDefault.default).createElement((0, _photoshopPreviewsDefault.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.actions
                }, (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, _reactDefault.default).createElement((0, _photoshopFieldsDefault.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, _reactDefault.default).Component);
Photoshop.propTypes = {
    header: (0, _propTypesDefault.default).string,
    styles: (0, _propTypesDefault.default).object
};
Photoshop.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Photoshop);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./PhotoshopFields":"aq0Bh","./PhotoshopPointerCircle":"bmY04","./PhotoshopPointer":"eGasC","./PhotoshopButton":"ew72A","./PhotoshopPreviews":"gFPuk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aq0Bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPicker", ()=>PhotoshopPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) _color.isValidHex(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.fieldSymbols
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%')));
};
exports.default = PhotoshopPicker;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bmY04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = PhotoshopPointerCircle;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eGasC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.pointer
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.left
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.leftInside
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.right
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.rightInside
    })));
};
exports.default = PhotoshopPointerCircle;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ew72A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopButton", ()=>PhotoshopButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
exports.default = PhotoshopButton;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gFPuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPreviews", ()=>PhotoshopPreviews);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', null, (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'new'), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.new
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.current
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'current'));
};
exports.default = PhotoshopPreviews;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"apktL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sketch", ()=>Sketch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sketchFields = require("./SketchFields");
var _sketchFieldsDefault = parcelHelpers.interopDefault(_sketchFields);
var _sketchPresetColors = require("./SketchPresetColors");
var _sketchPresetColorsDefault = parcelHelpers.interopDefault(_sketchPresetColors);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Sketch = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': _extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.sliders
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement((0, _common.Checkboard), null), (0, _reactDefault.default).createElement('div', {
        style: styles.activeColor
    }))), (0, _reactDefault.default).createElement((0, _sketchFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, _reactDefault.default).createElement((0, _sketchPresetColorsDefault.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
Sketch.propTypes = {
    disableAlpha: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object
};
Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
exports.default = (0, _common.ColorWrap)(Sketch);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./SketchFields":"kYUiu","./SketchPresetColors":"8fzFs","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kYUiu":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchFields", ()=>SketchFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
exports.default = SketchFields;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8fzFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchPresetColors", ()=>SketchPresetColors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, _reactDefault.default).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, _reactDefault.default).createElement((0, _common.Swatch), _extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
SketchPresetColors.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            color: (0, _propTypesDefault.default).string,
            title: (0, _propTypesDefault.default).string
        })
    ])).isRequired
};
exports.default = SketchPresetColors;

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kpDJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sliderSwatches = require("./SliderSwatches");
var _sliderSwatchesDefault = parcelHelpers.interopDefault(_sliderSwatches);
var _sliderPointer = require("./SliderPointer");
var _sliderPointerDefault = parcelHelpers.interopDefault(_sliderPointer);
var Slider = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchesDefault.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
Slider.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
Slider.defaultProps = {
    pointer: (0, _sliderPointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Slider);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./SliderSwatches":"kYb2w","./SliderPointer":"ipvOK","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kYb2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatches", ()=>SliderSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _sliderSwatch = require("./SliderSwatch");
var _sliderSwatchDefault = parcelHelpers.interopDefault(_sliderSwatch);
var SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = SliderSwatches;

},{"react":"IMRgT","reactcss":"k3r4z","./SliderSwatch":"egpys","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"egpys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatch", ()=>SliderSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
exports.default = SliderSwatch;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ipvOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"IMRgT","reactcss":"k3r4z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kgX20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatches", ()=>Swatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _swatchesGroup = require("./SwatchesGroup");
var _swatchesGroupDefault = parcelHelpers.interopDefault(_swatchesGroup);
var Swatches = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Raised), null, (0, _reactDefault.default).createElement('div', {
        style: styles.overflow
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(group) {
        return (0, _reactDefault.default).createElement((0, _swatchesGroupDefault.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })))));
};
Swatches.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    height: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    styles: (0, _propTypesDefault.default).object
};
Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            _materialColors.red['900'],
            _materialColors.red['700'],
            _materialColors.red['500'],
            _materialColors.red['300'],
            _materialColors.red['100']
        ],
        [
            _materialColors.pink['900'],
            _materialColors.pink['700'],
            _materialColors.pink['500'],
            _materialColors.pink['300'],
            _materialColors.pink['100']
        ],
        [
            _materialColors.purple['900'],
            _materialColors.purple['700'],
            _materialColors.purple['500'],
            _materialColors.purple['300'],
            _materialColors.purple['100']
        ],
        [
            _materialColors.deepPurple['900'],
            _materialColors.deepPurple['700'],
            _materialColors.deepPurple['500'],
            _materialColors.deepPurple['300'],
            _materialColors.deepPurple['100']
        ],
        [
            _materialColors.indigo['900'],
            _materialColors.indigo['700'],
            _materialColors.indigo['500'],
            _materialColors.indigo['300'],
            _materialColors.indigo['100']
        ],
        [
            _materialColors.blue['900'],
            _materialColors.blue['700'],
            _materialColors.blue['500'],
            _materialColors.blue['300'],
            _materialColors.blue['100']
        ],
        [
            _materialColors.lightBlue['900'],
            _materialColors.lightBlue['700'],
            _materialColors.lightBlue['500'],
            _materialColors.lightBlue['300'],
            _materialColors.lightBlue['100']
        ],
        [
            _materialColors.cyan['900'],
            _materialColors.cyan['700'],
            _materialColors.cyan['500'],
            _materialColors.cyan['300'],
            _materialColors.cyan['100']
        ],
        [
            _materialColors.teal['900'],
            _materialColors.teal['700'],
            _materialColors.teal['500'],
            _materialColors.teal['300'],
            _materialColors.teal['100']
        ],
        [
            '#194D33',
            _materialColors.green['700'],
            _materialColors.green['500'],
            _materialColors.green['300'],
            _materialColors.green['100']
        ],
        [
            _materialColors.lightGreen['900'],
            _materialColors.lightGreen['700'],
            _materialColors.lightGreen['500'],
            _materialColors.lightGreen['300'],
            _materialColors.lightGreen['100']
        ],
        [
            _materialColors.lime['900'],
            _materialColors.lime['700'],
            _materialColors.lime['500'],
            _materialColors.lime['300'],
            _materialColors.lime['100']
        ],
        [
            _materialColors.yellow['900'],
            _materialColors.yellow['700'],
            _materialColors.yellow['500'],
            _materialColors.yellow['300'],
            _materialColors.yellow['100']
        ],
        [
            _materialColors.amber['900'],
            _materialColors.amber['700'],
            _materialColors.amber['500'],
            _materialColors.amber['300'],
            _materialColors.amber['100']
        ],
        [
            _materialColors.orange['900'],
            _materialColors.orange['700'],
            _materialColors.orange['500'],
            _materialColors.orange['300'],
            _materialColors.orange['100']
        ],
        [
            _materialColors.deepOrange['900'],
            _materialColors.deepOrange['700'],
            _materialColors.deepOrange['500'],
            _materialColors.deepOrange['300'],
            _materialColors.deepOrange['100']
        ],
        [
            _materialColors.brown['900'],
            _materialColors.brown['700'],
            _materialColors.brown['500'],
            _materialColors.brown['300'],
            _materialColors.brown['100']
        ],
        [
            _materialColors.blueGrey['900'],
            _materialColors.blueGrey['700'],
            _materialColors.blueGrey['500'],
            _materialColors.blueGrey['300'],
            _materialColors.blueGrey['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Swatches);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/map":"6D4U6","lodash-es/merge":"jBFEd","material-colors":"2igAq","../common":"b7fAS","./SwatchesGroup":"kZLLW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kZLLW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesGroup", ()=>SwatchesGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _swatchesColor = require("./SwatchesColor");
var _swatchesColorDefault = parcelHelpers.interopDefault(_swatchesColor);
var SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.group
    }, (0, _mapDefault.default)(group, function(color, i) {
        return (0, _reactDefault.default).createElement((0, _swatchesColorDefault.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
exports.default = SwatchesGroup;

},{"react":"IMRgT","reactcss":"k3r4z","lodash-es/map":"6D4U6","./SwatchesColor":"9t9wR","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9t9wR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesColor", ()=>SwatchesColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var _checkIcon = require("@icons/material/CheckIcon");
var _checkIconDefault = parcelHelpers.interopDefault(_checkIcon);
var SwatchesColor = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: _color.getContrastingColor(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.check
    }, (0, _reactDefault.default).createElement((0, _checkIconDefault.default), null)));
};
exports.default = SwatchesColor;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","../common":"b7fAS","@icons/material/CheckIcon":"h7xf1","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h7xf1":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b7292f2d749daff7");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};

},{"b7292f2d749daff7":"IMRgT"}],"a9pBI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        _color.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(c, i) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.hash
    }, '#'), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })));
};
Twitter.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Twitter.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Twitter);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/map":"6D4U6","lodash-es/merge":"jBFEd","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gZdu6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Google", ()=>Google);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _googlePointerCircle = require("./GooglePointerCircle");
var _googlePointerCircleDefault = parcelHelpers.interopDefault(_googlePointerCircle);
var _googlePointer = require("./GooglePointer");
var _googlePointerDefault = parcelHelpers.interopDefault(_googlePointer);
var _googleFields = require("./GoogleFields");
var _googleFieldsDefault = parcelHelpers.interopDefault(_googleFields);
var Google = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, header), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _googlePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, _googlePointerDefault.default),
        onChange: onChange
    }))), (0, _reactDefault.default).createElement((0, _googleFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
Google.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object,
    header: (0, _propTypesDefault.default).string
};
Google.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
exports.default = (0, _common.ColorWrap)(Google);

},{"react":"IMRgT","prop-types":"iRwZ2","reactcss":"k3r4z","lodash-es/merge":"jBFEd","../common":"b7fAS","./GooglePointerCircle":"jrpA2","./GooglePointer":"1LPXx","./GoogleFields":"cPjxo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jrpA2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointerCircle", ()=>GooglePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointerCircle = function GooglePointerCircle(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointerCircle.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointerCircle.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointerCircle;

},{"react":"IMRgT","reactcss":"k3r4z","prop-types":"iRwZ2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1LPXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointer", ()=>GooglePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointer = function GooglePointer(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointer.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointer.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointer;

},{"react":"IMRgT","reactcss":"k3r4z","prop-types":"iRwZ2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cPjxo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleFields", ()=>GoogleFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var GoogleFields = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            _color.isvalidColorString(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if (_color.isvalidColorString(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if (_color.isvalidColorString(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.column
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
exports.default = GoogleFields;

},{"react":"IMRgT","reactcss":"k3r4z","../../helpers/color":"416MJ","../common":"b7fAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bP5fh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const FontColorContrast_1 = require("dbc04855a494a834");
function fontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold) {
    const fcc = new FontColorContrast_1.FontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold);
    return fcc.getColor();
}
exports.default = fontColorContrast;

},{"dbc04855a494a834":"fBYcL"}],"fBYcL":[function(require,module,exports,__globalThis) {
"use strict";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FontColorContrast_hexColorOrRedOrArray, _FontColorContrast_greenOrThreshold, _FontColorContrast_blue, _FontColorContrast_threshold;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FontColorContrast = exports.NumberType = void 0;
const cssNamedColors_1 = require("72d907e4502289cd");
var NumberType;
(function(NumberType) {
    NumberType[NumberType["COLOR"] = 255] = "COLOR";
    NumberType[NumberType["RGB"] = 16777215] = "RGB";
    NumberType[NumberType["THRESHOLD"] = 1] = "THRESHOLD";
})(NumberType = exports.NumberType || (exports.NumberType = {}));
class FontColorContrast {
    /**
     * Sets the #params in the instance
     * @param hexColorOrRedOrArray One of the options: hex color number, hex color string, named CSS color, array with red, green and blue or string or the red portion of the color
     * @param greenOrThreshold The green portion of the color or the contrast threshold to control the resulting font color
     * @param blue The blue portion of the color
     * @param threshold Contrast threshold to control the resulting font color
     */ constructor(hexColorOrRedOrArray, greenOrThreshold, blue, threshold){
        this.red = 0;
        this.green = 0;
        this.blue = 0;
        _FontColorContrast_hexColorOrRedOrArray.set(this, void 0);
        _FontColorContrast_greenOrThreshold.set(this, void 0);
        _FontColorContrast_blue.set(this, void 0);
        _FontColorContrast_threshold.set(this, void 0);
        /**
         * Contrast threshold to control the resulting font color, float values from 0 to 1. Default is 0.5
         */ this.threshold = 0.5;
        __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, hexColorOrRedOrArray, "f");
        __classPrivateFieldSet(this, _FontColorContrast_greenOrThreshold, greenOrThreshold, "f");
        __classPrivateFieldSet(this, _FontColorContrast_blue, blue, "f");
        __classPrivateFieldSet(this, _FontColorContrast_threshold, threshold, "f");
    }
    /**
     * Analyses the color (normally used in the background) and retrieves what color (black or white) has a better contrast.
     * @returns The best contrast between black and white
     */ getColor() {
        if (this.isRgb()) this.setColorsFromRgbNumbers();
        else if (this.isHexString()) this.setColorsFromHexString();
        else if (this.isNumber()) this.setColorsFromNumber();
        else if (this.isArray()) this.setColorsFromArray();
        else return '#ffffff';
        return this.contrastFromHSP();
    }
    /**
     * Checks if the color is set as RGB on each param
     * @returns True if color is set as RGB on each param
     */ isRgb() {
        return FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_blue, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"), NumberType.THRESHOLD);
    }
    /**
     * Checks if color is set on the first param as a hex string and removes the hash of it
     * @returns True if color is a hex string
     */ isHexString() {
        const [cleanString, hexNum] = this.getCleanStringAndHexNum();
        if (FontColorContrast.isValidNumber(hexNum, NumberType.RGB) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"))) {
            __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, cleanString, "f");
            return true;
        }
        return false;
    }
    /**
     * Checks if color is set on the first param as a number
     * @returns True if color is a valid RGB nunbernumber
     */ isNumber() {
        return FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"), NumberType.RGB) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Checks if color is set as an RGB array
     * @returns True if color is set as an RGB array
     */ isArray() {
        return Array.isArray(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")) && __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").length === 3 && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Converts a color array or separated in RGB to the respective RGB values
     * @example All these examples produces the same value
     * arrayOrRgbToRGB(0, 0xcc, 153)
     * arrayOrRgbToRGB(0x0, 0xcc, 153)
     * arrayOrRgbToRGB(0, 204, 0x99)
     */ setColorsFromRgbNumbers() {
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f");
        this.green = __classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f");
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_blue, "f");
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Converts a color array or separated in RGB to the respective RGB values
     * @param this.#hexColorOrRedOrArray The RGB array
     * @param threshold The threshold
     * @example All these examples produces the same value
     * arrayOrRgbToRGB([0, 0xcc, 153])
     * arrayOrRgbToRGB([0x0, 0xcc, 153])
     * arrayOrRgbToRGB([0, 204, 0x99])
     */ setColorsFromArray() {
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0];
        this.green = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1];
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2];
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Converts a ColorIntensity string or number, with all possibilities (e.g. '#009', '009', '#000099', '000099', 153, 0x00099) to the respective RGB values
     * @param hexColor The color string or number
     * @param threshold The threshold
     * @example All these examples produces the same value
     * hexColorToRGB('#0C9')
     * hexColorToRGB('0C9')
     * hexColorToRGB('#00CC99')
     * hexColorToRGB('00cc99')
     * hexColorToRGB(52377)
     * hexColorToRGB(0x00Cc99)
     */ setColorsFromHexString() {
        switch(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").length){
            // Color has one char for each color, so they must be repeated
            case 3:
                this.red = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0].repeat(2), 16);
                this.green = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1].repeat(2), 16);
                this.blue = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2].repeat(2), 16);
                break;
            // All chars are filled, so no transformation is needed
            default:
                this.red = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(0, 2), 16);
                this.green = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(2, 4), 16);
                this.blue = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(4, 6), 16);
                break;
        }
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Converts the RGB number and sets the respective RGB values.
     */ setColorsFromNumber() {
        /*
         * The RGB color has 24 bits (8 bits per color).
         * This function uses binary operations for better performance, but can be tricky to understand. A 24 bits color could be represented as RRRRRRRR GGGGGGGG BBBBBBBB (the first 8 bits are red, the middle 8 bits are green and the last 8 bits are blue).
         * To get each color we perform some RIGHT SHIFT and AND operations.
         * Gets the first 8 bits of the color by shifting it 16 bits
         * RIGHT SHIFT operation (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Right_shift)
         * AND operation (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_AND)
         */ // To get red, we shift the 24 bits number 16 bits to the right, leaving the number only with the leftmost 8 bits (RRRRRRRR)
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") >> 16;
        // To get green, the middle 8 bits, we shift it by 8 bits (removing all blue bits - RRRRRRRR GGGGGGGG) and use an AND operation with "0b0000000011111111 = 0xff" to get only the rightmost bits (GGGGGGGG)
        this.green = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") >> 8 & 0xff;
        // To get blue we use an AND operation with "0b000000000000000011111111 = 0xff" to get only the rightmost bits (BBBBBBBB)
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") & 0xff;
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Sets the threshold to the passed value (if valid - less than or equal 1) or the dafault (0.5)
     * @param threshold The passed threshold or undefined if not passed
     */ setThreshold(threshold) {
        this.threshold = threshold || this.threshold;
    }
    /**
     * Verifies if a number is a valid color number (numberType = NumberType.COLOR = 0xff) or a valid RGB (numberType = NumberType.RGB = 0xffffff) or a valid threshold (numberType = NumberType.THRESHOLD = 1)
     * @param num The number to be checked
     * @param numberType The type of number to be chacked that defines maximum value of the number (default = NumberType.COLOR = 0xff)
     * @returns True if the number is valid
     */ static isValidNumber(num, numberType) {
        if (numberType === NumberType.THRESHOLD && (num === undefined || num === null)) return true;
        return typeof num === 'number' && (numberType !== NumberType.THRESHOLD && Number.isInteger(num) || numberType === NumberType.THRESHOLD) && num !== undefined && num !== null && num >= 0 && num <= numberType;
    }
    /**
     * Verifies if a string is a valig string to be used as a color and if true, returns the correspondent hex number
     * @returns Array with an empty string and false if the string is invalid or an array with the clean string and the converted string number]
     */ getCleanStringAndHexNum() {
        if (typeof __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") !== 'string') return [
            '',
            false
        ];
        const cleanRegEx = /(#|\s)/ig;
        const namedColor = cssNamedColors_1.cssNamedColors.find((color)=>color.name === __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"));
        if (namedColor) __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, namedColor.hex.replace(cleanRegEx, ''), "f");
        const cleanString = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").replace(cleanRegEx, '');
        if (cleanString.length !== 3 && cleanString.length !== 6) return [
            '',
            false
        ];
        const hexNum = Number('0x' + cleanString);
        return [
            cleanString,
            hexNum
        ];
    }
    /**
     * Verifies if a value is not set
     * @param value The value that should be undefined or null
     * @returns True if the value is not set
     */ static isNotSet(value) {
        return value === undefined || value === null;
    }
    /**
     * Calculates the best color (black or white) to contrast with the passed RGB color using the algorithm from https://alienryderflex.com/hsp.html
     * @returns Black or White depending on the best possible contrast
     */ contrastFromHSP() {
        const pRed = 0.299;
        const pGreen = 0.587;
        const pBlue = 0.114;
        const contrast = Math.sqrt(pRed * Math.pow(this.red / 255, 2) + pGreen * Math.pow(this.green / 255, 2) + pBlue * Math.pow(this.blue / 255, 2));
        return contrast > this.threshold ? '#000000' : '#ffffff';
    }
}
exports.FontColorContrast = FontColorContrast;
_FontColorContrast_hexColorOrRedOrArray = new WeakMap(), _FontColorContrast_greenOrThreshold = new WeakMap(), _FontColorContrast_blue = new WeakMap(), _FontColorContrast_threshold = new WeakMap();

},{"72d907e4502289cd":"cJtmY"}],"cJtmY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cssNamedColors = void 0;
exports.cssNamedColors = [
    {
        name: 'aliceblue',
        hex: '#f0f8ff'
    },
    {
        name: 'antiquewhite',
        hex: '#faebd7'
    },
    {
        name: 'aqua',
        hex: '#00ffff'
    },
    {
        name: 'aquamarine',
        hex: '#7fffd4'
    },
    {
        name: 'azure',
        hex: '#f0ffff'
    },
    {
        name: 'beige',
        hex: '#f5f5dc'
    },
    {
        name: 'bisque',
        hex: '#ffe4c4'
    },
    {
        name: 'black',
        hex: '#000000'
    },
    {
        name: 'blanchedalmond',
        hex: '#ffebcd'
    },
    {
        name: 'blue',
        hex: '#0000ff'
    },
    {
        name: 'blueviolet',
        hex: '#8a2be2'
    },
    {
        name: 'brown',
        hex: '#a52a2a'
    },
    {
        name: 'burlywood',
        hex: '#deb887'
    },
    {
        name: 'cadetblue',
        hex: '#5f9ea0'
    },
    {
        name: 'chartreuse',
        hex: '#7fff00'
    },
    {
        name: 'chocolate',
        hex: '#d2691e'
    },
    {
        name: 'coral',
        hex: '#ff7f50'
    },
    {
        name: 'cornflowerblue',
        hex: '#6495ed'
    },
    {
        name: 'cornsilk',
        hex: '#fff8dc'
    },
    {
        name: 'crimson',
        hex: '#dc143c'
    },
    {
        name: 'cyan',
        hex: '#00ffff'
    },
    {
        name: 'darkblue',
        hex: '#00008b'
    },
    {
        name: 'darkcyan',
        hex: '#008b8b'
    },
    {
        name: 'darkgoldenrod',
        hex: '#b8860b'
    },
    {
        name: 'darkgray',
        hex: '#a9a9a9'
    },
    {
        name: 'darkgreen',
        hex: '#006400'
    },
    {
        name: 'darkgrey',
        hex: '#a9a9a9'
    },
    {
        name: 'darkkhaki',
        hex: '#bdb76b'
    },
    {
        name: 'darkmagenta',
        hex: '#8b008b'
    },
    {
        name: 'darkolivegreen',
        hex: '#556b2f'
    },
    {
        name: 'darkorange',
        hex: '#ff8c00'
    },
    {
        name: 'darkorchid',
        hex: '#9932cc'
    },
    {
        name: 'darkred',
        hex: '#8b0000'
    },
    {
        name: 'darksalmon',
        hex: '#e9967a'
    },
    {
        name: 'darkseagreen',
        hex: '#8fbc8f'
    },
    {
        name: 'darkslateblue',
        hex: '#483d8b'
    },
    {
        name: 'darkslategray',
        hex: '#2f4f4f'
    },
    {
        name: 'darkslategrey',
        hex: '#2f4f4f'
    },
    {
        name: 'darkturquoise',
        hex: '#00ced1'
    },
    {
        name: 'darkviolet',
        hex: '#9400d3'
    },
    {
        name: 'deeppink',
        hex: '#ff1493'
    },
    {
        name: 'deepskyblue',
        hex: '#00bfff'
    },
    {
        name: 'dimgray',
        hex: '#696969'
    },
    {
        name: 'dimgrey',
        hex: '#696969'
    },
    {
        name: 'dodgerblue',
        hex: '#1e90ff'
    },
    {
        name: 'firebrick',
        hex: '#b22222'
    },
    {
        name: 'floralwhite',
        hex: '#fffaf0'
    },
    {
        name: 'forestgreen',
        hex: '#228b22'
    },
    {
        name: 'fuchsia',
        hex: '#ff00ff'
    },
    {
        name: 'gainsboro',
        hex: '#dcdcdc'
    },
    {
        name: 'ghostwhite',
        hex: '#f8f8ff'
    },
    {
        name: 'gold',
        hex: '#ffd700'
    },
    {
        name: 'goldenrod',
        hex: '#daa520'
    },
    {
        name: 'gray',
        hex: '#808080'
    },
    {
        name: 'green',
        hex: '#008000'
    },
    {
        name: 'greenyellow',
        hex: '#adff2f'
    },
    {
        name: 'grey',
        hex: '#808080'
    },
    {
        name: 'honeydew',
        hex: '#f0fff0'
    },
    {
        name: 'hotpink',
        hex: '#ff69b4'
    },
    {
        name: 'indianred',
        hex: '#cd5c5c'
    },
    {
        name: 'indigo',
        hex: '#4b0082'
    },
    {
        name: 'ivory',
        hex: '#fffff0'
    },
    {
        name: 'khaki',
        hex: '#f0e68c'
    },
    {
        name: 'lavender',
        hex: '#e6e6fa'
    },
    {
        name: 'lavenderblush',
        hex: '#fff0f5'
    },
    {
        name: 'lawngreen',
        hex: '#7cfc00'
    },
    {
        name: 'lemonchiffon',
        hex: '#fffacd'
    },
    {
        name: 'lightblue',
        hex: '#add8e6'
    },
    {
        name: 'lightcoral',
        hex: '#f08080'
    },
    {
        name: 'lightcyan',
        hex: '#e0ffff'
    },
    {
        name: 'lightgoldenrodyellow',
        hex: '#fafad2'
    },
    {
        name: 'lightgray',
        hex: '#d3d3d3'
    },
    {
        name: 'lightgreen',
        hex: '#90ee90'
    },
    {
        name: 'lightgrey',
        hex: '#d3d3d3'
    },
    {
        name: 'lightpink',
        hex: '#ffb6c1'
    },
    {
        name: 'lightsalmon',
        hex: '#ffa07a'
    },
    {
        name: 'lightseagreen',
        hex: '#20b2aa'
    },
    {
        name: 'lightskyblue',
        hex: '#87cefa'
    },
    {
        name: 'lightslategray',
        hex: '#778899'
    },
    {
        name: 'lightslategrey',
        hex: '#778899'
    },
    {
        name: 'lightsteelblue',
        hex: '#b0c4de'
    },
    {
        name: 'lightyellow',
        hex: '#ffffe0'
    },
    {
        name: 'lime',
        hex: '#00ff00'
    },
    {
        name: 'limegreen',
        hex: '#32cd32'
    },
    {
        name: 'linen',
        hex: '#faf0e6'
    },
    {
        name: 'magenta',
        hex: '#ff00ff'
    },
    {
        name: 'maroon',
        hex: '#800000'
    },
    {
        name: 'mediumaquamarine',
        hex: '#66cdaa'
    },
    {
        name: 'mediumblue',
        hex: '#0000cd'
    },
    {
        name: 'mediumorchid',
        hex: '#ba55d3'
    },
    {
        name: 'mediumpurple',
        hex: '#9370db'
    },
    {
        name: 'mediumseagreen',
        hex: '#3cb371'
    },
    {
        name: 'mediumslateblue',
        hex: '#7b68ee'
    },
    {
        name: 'mediumspringgreen',
        hex: '#00fa9a'
    },
    {
        name: 'mediumturquoise',
        hex: '#48d1cc'
    },
    {
        name: 'mediumvioletred',
        hex: '#c71585'
    },
    {
        name: 'midnightblue',
        hex: '#191970'
    },
    {
        name: 'mintcream',
        hex: '#f5fffa'
    },
    {
        name: 'mistyrose',
        hex: '#ffe4e1'
    },
    {
        name: 'moccasin',
        hex: '#ffe4b5'
    },
    {
        name: 'navajowhite',
        hex: '#ffdead'
    },
    {
        name: 'navy',
        hex: '#000080'
    },
    {
        name: 'oldlace',
        hex: '#fdf5e6'
    },
    {
        name: 'olive',
        hex: '#808000'
    },
    {
        name: 'olivedrab',
        hex: '#6b8e23'
    },
    {
        name: 'orange',
        hex: '#ffa500'
    },
    {
        name: 'orangered',
        hex: '#ff4500'
    },
    {
        name: 'orchid',
        hex: '#da70d6'
    },
    {
        name: 'palegoldenrod',
        hex: '#eee8aa'
    },
    {
        name: 'palegreen',
        hex: '#98fb98'
    },
    {
        name: 'paleturquoise',
        hex: '#afeeee'
    },
    {
        name: 'palevioletred',
        hex: '#db7093'
    },
    {
        name: 'papayawhip',
        hex: '#ffefd5'
    },
    {
        name: 'peachpuff',
        hex: '#ffdab9'
    },
    {
        name: 'peru',
        hex: '#cd853f'
    },
    {
        name: 'pink',
        hex: '#ffc0cb'
    },
    {
        name: 'plum',
        hex: '#dda0dd'
    },
    {
        name: 'powderblue',
        hex: '#b0e0e6'
    },
    {
        name: 'purple',
        hex: '#800080'
    },
    {
        name: 'red',
        hex: '#ff0000'
    },
    {
        name: 'rosybrown',
        hex: '#bc8f8f'
    },
    {
        name: 'royalblue',
        hex: '#4169e1'
    },
    {
        name: 'saddlebrown',
        hex: '#8b4513'
    },
    {
        name: 'salmon',
        hex: '#fa8072'
    },
    {
        name: 'sandybrown',
        hex: '#f4a460'
    },
    {
        name: 'seagreen',
        hex: '#2e8b57'
    },
    {
        name: 'seashell',
        hex: '#fff5ee'
    },
    {
        name: 'sienna',
        hex: '#a0522d'
    },
    {
        name: 'silver',
        hex: '#c0c0c0'
    },
    {
        name: 'skyblue',
        hex: '#87ceeb'
    },
    {
        name: 'slateblue',
        hex: '#6a5acd'
    },
    {
        name: 'slategray',
        hex: '#708090'
    },
    {
        name: 'slategrey',
        hex: '#708090'
    },
    {
        name: 'snow',
        hex: '#fffafa'
    },
    {
        name: 'springgreen',
        hex: '#00ff7f'
    },
    {
        name: 'steelblue',
        hex: '#4682b4'
    },
    {
        name: 'tan',
        hex: '#d2b48c'
    },
    {
        name: 'teal',
        hex: '#008080'
    },
    {
        name: 'thistle',
        hex: '#d8bfd8'
    },
    {
        name: 'tomato',
        hex: '#ff6347'
    },
    {
        name: 'turquoise',
        hex: '#40e0d0'
    },
    {
        name: 'violet',
        hex: '#ee82ee'
    },
    {
        name: 'wheat',
        hex: '#f5deb3'
    },
    {
        name: 'white',
        hex: '#ffffff'
    },
    {
        name: 'whitesmoke',
        hex: '#f5f5f5'
    },
    {
        name: 'yellow',
        hex: '#ffff00'
    },
    {
        name: 'yellowgreen',
        hex: '#9acd32'
    },
    {
        name: 'rebeccapurple',
        hex: '#663399'
    }
];

},{}],"kbhTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModifySettingsButton", ()=>ModifySettingsButton);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function ModifySettingsButton(props) {
    const { hide_arrow, ...html_props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...html_props,
        className: (0, _classnamesDefault.default)("font-bold text-sesh-primary hover:text-sesh-dark hover:underline", props.className, {
            "input-disabled": props.disabled
        }),
        type: "button",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: props.children
                }),
                props.disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-lock"
                    }, "lock-button-icon")
                }),
                !props.disabled && !props.hide_arrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-arrow-right"
                    }, "button-icon")
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kfglS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageUploaderForm", ()=>ImageUploaderForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("../../../../common/constants");
var _rcNumberInputScss = require("../../../css/rc_number_input.scss");
var _validUrl = require("valid-url");
var _validUrlDefault = parcelHelpers.interopDefault(_validUrl);
var _dashboardUtils = require("../dashboard_utils");
class ImageUploaderForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            value: this.props.initial_value ? this.props.initial_value : "",
            url: this.props.initial_value,
            error: false
        };
        this.handleChange = this.handleChange.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleChange(event) {
        const value = event.target.value;
        if ((0, _validUrlDefault.default).isUri(value) && value.match(/https?/)) {
            this.setState({
                value,
                url: value,
                error: false
            });
            this.props.updateFunc(value);
        } else {
            this.setState({
                value,
                url: null,
                error: value.length > 0
            });
            this.props.updateFunc(null);
        }
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                this.props.name && !this.props.hide_header && (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Image", "The image that will display on the embed for this event. Image URLs must start with http:// or https://.", false, false, false, undefined, this.props.disabled),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "control",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "input",
                            placeholder: "Image URL",
                            type: "text",
                            value: this.state.value,
                            onChange: this.handleChange,
                            maxLength: (0, _constants.Constants).IMAGE_URL_LIMIT,
                            disabled: this.props.disabled
                        }),
                        this.state.url && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "uploaded-image",
                            src: this.state.url,
                            onError: ()=>{
                                this.setState({
                                    error: true,
                                    url: null
                                });
                            // Don't call updateFunc(null) on load errors - preserve original value
                            }
                        }),
                        this.state.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-note mt-4",
                            children: "Invalid Image URL"
                        })
                    ]
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../common/constants":"lLiun","../../../css/rc_number_input.scss":"3fSWU","valid-url":"04qHt","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3fSWU":[function() {},{}],"04qHt":[function(require,module,exports,__globalThis) {
(function(module1) {
    'use strict';
    module1.exports.is_uri = is_iri;
    module1.exports.is_http_uri = is_http_iri;
    module1.exports.is_https_uri = is_https_iri;
    module1.exports.is_web_uri = is_web_iri;
    // Create aliases
    module1.exports.isUri = is_iri;
    module1.exports.isHttpUri = is_http_iri;
    module1.exports.isHttpsUri = is_https_iri;
    module1.exports.isWebUri = is_web_iri;
    // private function
    // internal URI spitter method - direct from RFC 3986
    var splitUri = function(uri) {
        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return splitted;
    };
    function is_iri(value) {
        if (!value) return;
        // check for illegal characters
        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;
        // check for hex escapes that aren't complete
        if (/%[^0-9a-f]/i.test(value)) return;
        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var query = '';
        var fragment = '';
        var out = '';
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        // scheme and path are required, though the path can be empty
        if (!(scheme && scheme.length && path.length >= 0)) return;
        // if authority is present, the path must be empty or begin with a /
        if (authority && authority.length) {
            if (!(path.length === 0 || /^\//.test(path))) return;
        } else {
            // if authority is not present, the path must not start with //
            if (/^\/\//.test(path)) return;
        }
        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return;
        // re-assemble the URL per section 5.3 in RFC 3986
        out += scheme + ':';
        if (authority && authority.length) out += '//' + authority;
        out += path;
        if (query && query.length) out += '?' + query;
        if (fragment && fragment.length) out += '#' + fragment;
        return out;
    }
    function is_http_iri(value, allowHttps) {
        if (!is_iri(value)) return;
        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var port = '';
        var query = '';
        var fragment = '';
        var out = '';
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        if (!scheme) return;
        if (allowHttps) {
            if (scheme.toLowerCase() != 'https') return;
        } else {
            if (scheme.toLowerCase() != 'http') return;
        }
        // fully-qualified URIs must have an authority section that is
        // a valid host
        if (!authority) return;
        // enable port component
        if (/:(\d+)$/.test(authority)) {
            port = authority.match(/:(\d+)$/)[0];
            authority = authority.replace(/:\d+$/, '');
        }
        out += scheme + ':';
        out += '//' + authority;
        if (port) out += port;
        out += path;
        if (query && query.length) out += '?' + query;
        if (fragment && fragment.length) out += '#' + fragment;
        return out;
    }
    function is_https_iri(value) {
        return is_http_iri(value, true);
    }
    function is_web_iri(value) {
        return is_http_iri(value) || is_https_iri(value);
    }
})(module);

},{}],"aAYfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddRoleToAttendeesEventForm", ()=>AddRoleToAttendeesEventForm);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constants = require("../../../../../common/constants");
var _dashboardUtils = require("../../dashboard_utils");
var _addRoleToAttendeesComponent = require("./add_role_to_attendees_component");
const default_attendee_role_data = {
    role_ids: [],
    remove_on_end: (0, _constants.Constants).DEFAULT_REMOVE_ROLE_ON_EVENT_END,
    role_add_time: (0, _constants.Constants).DEFAULT_ADD_ROLE_ON_RSVP_ADD_TIME
};
function AddRoleToAttendeesEventForm(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("field", {
            active: props.is_server_premium
        }),
        children: [
            (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Add Role to Attendees", "Discord roles users will be granted upon RSVP or Event Start", !props.is_server_premium, false, false, undefined, props.disabled, false, props.is_server_premium ? props.revert_descriptor : undefined),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addRoleToAttendeesComponent.AddRoleToAttendeesComponent), {
                value: props.value,
                setValue: (val)=>{
                    props.setValue(val);
                },
                sesh_has_manage_roles: props.sesh_has_manage_roles,
                sesh_role_name: props.sesh_role_name,
                event_duration_ms: props.event_duration_ms,
                disabled: props.disabled || !props.is_server_premium,
                has_no_roles_to_add: props.has_no_roles_to_add
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../../../../common/constants":"lLiun","../../dashboard_utils":"jvA8A","./add_role_to_attendees_component":"cKhKw","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cKhKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddRoleToAttendeesComponent", ()=>AddRoleToAttendeesComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constants = require("../../../../../common/constants");
var _seshTypes = require("../../../../../common/sesh_types");
var _dashboardUtils = require("../../dashboard_utils");
var _searchableDropdown = require("../searchable_dropdown");
var _useRoles = require("./hooks/use_roles");
var _infoTooltip = require("./tooltips/info_tooltip");
function AddRoleToAttendeesComponent(props) {
    const disabled_due_to_manage_roles = !props.sesh_has_manage_roles;
    let placeholder_text = props.placeholder;
    if (!placeholder_text) {
        if (disabled_due_to_manage_roles || props.disabled) placeholder_text = "Disabled";
        else placeholder_text = "None";
    }
    let disabled = disabled_due_to_manage_roles || props.disabled || props.has_no_roles_to_add;
    let duration_text = "Remove role on event end";
    const duration_label = /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        className: "attendee-remove-on-end-label",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "checkbox",
                    checked: props.value.remove_on_end,
                    onChange: (e)=>props.setValue({
                            ...props.value,
                            remove_on_end: e.target.checked
                        }),
                    disabled: disabled
                }),
                " ",
                duration_text,
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                    info: "Set event duration to determine when roles are removed. If no duration is set, roles will be removed one hour after the event starts."
                })
            ]
        })
    });
    let label_element;
    if (!props.disabled) {
        if (disabled_due_to_manage_roles) label_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "error-note",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "",
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                children: props.sesh_role_name ?? "sesh"
                            }),
                            " role requires the ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: "Manage Roles"
                            }),
                            " permission to use this feature.",
                            " 	"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "manual-link",
                        href: (0, _constants.Constants).ATTENDEE_ROLES_HELP_LINK + "#invalid_permissions",
                        target: "_blank",
                        children: "Click here for more info"
                    })
                ]
            })
        });
        else if (props.has_no_roles_to_add) label_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "error-note",
                children: [
                    "No valid roles found. Ensure you have",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "Manage Roles"
                    }),
                    " permissions."
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            label_element,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `flex w-full flex-col gap-2`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RoleSelect, {
                            value: props.value,
                            setValue: props.setValue,
                            placeholder_text: placeholder_text,
                            disabled: disabled
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _classnamesDefault.default)({
                            "input-disabled": (props.value?.role_ids.length ?? -1) === 0
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _classnamesDefault.default)("flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-8", {
                                "pointer-events-none": (props.value?.role_ids.length ?? -1) === 0
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex w-fit gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "",
                                            children: "Add role on"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                className: "inline-dropdown",
                                                onChange: (val)=>props.setValue({
                                                        ...props.value,
                                                        role_add_time: parseInt(val.target.value)
                                                    }),
                                                value: props.value.role_add_time,
                                                disabled: disabled,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        value: (0, _seshTypes.RoleOnRSVPAddTime).OnEventStart,
                                                        children: "Event Start"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        value: (0, _seshTypes.RoleOnRSVPAddTime).OnRSVP,
                                                        children: "User RSVP"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "",
                                    children: duration_label
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function RoleSelect(props) {
    const roles = (0, _useRoles.useRoles)();
    if (!roles) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLoadingSelect, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.SearchableDropdown), {
        handleChange: (val)=>props.setValue({
                ...props.value,
                role_ids: val.map((v)=>v.id)
            }),
        options: roles.filter((val)=>!val.is_everyone_or_here && !val.is_managed_role),
        initial_mentions: roles.filter((val)=>props.value.role_ids.includes(val.id)),
        ignore_invalid_permissions: true,
        check_can_sesh_and_user_add_role: true,
        disabled: props.disabled,
        placeholder: props.placeholder_text,
        is_single_select: true
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../../../../common/constants":"lLiun","../../../../../common/sesh_types":"aUAOg","../../dashboard_utils":"jvA8A","../searchable_dropdown":"8iEAS","./hooks/use_roles":"b2XTr","./tooltips/info_tooltip":"93rAL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8iEAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SingleValue", ()=>SingleValue);
parcelHelpers.export(exports, "dropdownColourStyles", ()=>dropdownColourStyles);
parcelHelpers.export(exports, "DropdownMemberSelectedLabel", ()=>DropdownMemberSelectedLabel);
parcelHelpers.export(exports, "DropdownMemberLabel", ()=>DropdownMemberLabel);
parcelHelpers.export(exports, "SearchableDropdown", ()=>SearchableDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _reactSelect = require("react-select");
var _seshTypes = require("../../../../common/sesh_types");
var _constants = require("../../../../common/constants");
var _chromaJs = require("chroma-js");
var _chromaJsDefault = parcelHelpers.interopDefault(_chromaJs);
const ellipsis_option = {
    value: null,
    isDisabled: true,
    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "has-text-weight-bold",
        style: {
            color: (0, _constants.Constants).EMBED_COLOR,
            textAlign: "center",
            fontSize: "0.75rem"
        },
        children: "More results than can be displayed. Type to filter."
    })
};
const SingleValue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).SingleValue, {
        ...props,
        children: props.data.selectedLabel ?? props.data.label
    });
const dropdownColourStyles = {
    multiValue: (styles, { data })=>{
        let color = (0, _chromaJsDefault.default)(data.color ? data.color : "#000000");
        color = (0, _chromaJsDefault.default).contrast(color, "black") > 2 ? color : color.darken(-1.5);
        return {
            ...styles,
            backgroundColor: color.alpha(0.1).css()
        };
    },
    multiValueLabel: (styles, { data })=>{
        let color = (0, _chromaJsDefault.default)(data.color ? data.color : "#000000");
        color = (0, _chromaJsDefault.default).contrast(color, "black") > 2 ? color : color.darken(-1.5);
        return {
            ...styles,
            color: color.css()
        };
    },
    multiValueRemove: (styles, { data })=>{
        let color = (0, _chromaJsDefault.default)(data.color ? data.color : "#000000");
        color = (0, _chromaJsDefault.default).contrast(color, "black") > 2 ? color : color.darken(-1.5);
        let css_color = color.css();
        return {
            ...styles,
            color: css_color,
            ":hover": {
                backgroundColor: css_color,
                color: "black"
            }
        };
    }
};
function DropdownMemberSelectedLabel(props) {
    const { val } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "columns is-variable is-1 is-mobile",
        title: val.name,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-vcentered is-variable is-1 is-mobile",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow",
                        children: val.avatar_url && /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                            className: "image is-16x16",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "is-rounded",
                                src: "https://cdn.discordapp.com/" + val.avatar_url,
                                width: 16,
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "dropdown-name",
                            children: val.name
                        })
                    })
                ]
            })
        })
    });
}
function DropdownMemberLabel(props) {
    const { val, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "columns is-variable is-1 is-mobile",
        title: val.name,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-vcentered is-variable is-1 is-mobile",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow",
                        children: val.avatar_url && /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                            className: "image is-16x16",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "is-rounded",
                                src: "https://cdn.discordapp.com/" + val.avatar_url,
                                width: 16,
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "dropdown-name",
                            children: val.name
                        })
                    }),
                    disabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `column is-pulled-right ${disabled.class}`,
                                children: disabled.text_element
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-narrow"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
class SearchableDropdown extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let initial_dropdown_data = [];
        for (let mention of this.props.initial_mentions)initial_dropdown_data.push(this.createDropdownElement(mention));
        this.state = {
            mentions: initial_dropdown_data ?? [],
            cached_search_results: new Map(),
            useless_string_prefix_cache: new Map()
        };
        this.handleChange = this.handleChange.bind(this);
        this.createDropdownElement = this.createDropdownElement.bind(this);
    }
    componentDidUpdate(prevProps) {
        let is_equal = Boolean(prevProps);
        if (is_equal) {
            is_equal = prevProps.initial_mentions.length === this.props.initial_mentions.length;
            if (is_equal) {
                for(let i = 0; i < this.props.initial_mentions.length; i++)if (prevProps.initial_mentions[i].id !== this.props.initial_mentions[i].id) {
                    is_equal = false;
                    break;
                }
            }
        }
        if (!is_equal) this.setState({
            mentions: this.props.initial_mentions.map((val)=>this.createDropdownElement(val))
        });
    }
    createDropdownElement(val) {
        let color = "#ffffff";
        if (val.type === (0, _seshTypes.MentionTypes).Role || val.is_everyone_or_here) {
            color = val.color;
            if (color === "#000000") color = "#ffffff";
        }
        let disabled = false;
        let disabled_text_element;
        let disabled_class = "dropdown-disabled-text";
        if (val.disabled && !this.props.ignore_invalid_permissions) {
            disabled = true;
            disabled_text_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "Invalid Permissions"
            });
        } else if (this.props.ids_to_ignore && this.props.ids_to_ignore.includes(val.id)) {
            disabled = true;
            disabled_text_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: this.props.ids_to_ignore_text
            });
        }
        if (!this.props.disabled && this.props.check_can_sesh_and_user_add_role) {
            if (!val.can_sesh_add_role || !val.can_user_add_role) {
                disabled_class += " dropdown-disabled-add-role";
                disabled = true;
                let disabled_reasons = [];
                if (!val.can_sesh_add_role) disabled_reasons.push("sesh");
                if (!val.can_user_add_role) disabled_reasons.push("User");
                disabled_text_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    className: "manual-link",
                    href: (0, _constants.Constants).ATTENDEE_ROLES_HELP_LINK + "#invalid_permissions",
                    target: "_blank",
                    children: [
                        "Invalid ",
                        disabled_reasons.join(" & "),
                        " permissions",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-external-link-alt ml-[0.4em]"
                        })
                    ]
                });
            }
        }
        return {
            value: val.id,
            isDisabled: disabled,
            mentionable: val,
            color,
            selectedLabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DropdownMemberSelectedLabel, {
                val: val
            }),
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DropdownMemberLabel, {
                val: val,
                disabled: disabled ? {
                    class: disabled_class,
                    text_element: disabled_text_element
                } : undefined
            })
        };
    }
    loadOptions(options, input_value, callback) {
        if (this.props.loading) return;
        if (this.props.longest_name_length && input_value.length > this.props.longest_name_length) {
            callback([]);
            return;
        }
        if (this.state.cached_search_results.has(input_value)) {
            let value = this.state.cached_search_results.get(input_value);
            this.state.cached_search_results.delete(input_value);
            this.state.cached_search_results.set(input_value, value);
            callback(value);
            return;
        }
        const input_value_lowercase = input_value.toLowerCase();
        let useless_cache_key;
        this.state.useless_string_prefix_cache.forEach((_, key)=>{
            if (input_value_lowercase.startsWith(key)) {
                useless_cache_key = key;
                return;
            }
        });
        if (useless_cache_key) {
            this.state.useless_string_prefix_cache.delete(useless_cache_key);
            this.state.useless_string_prefix_cache.set(useless_cache_key, true);
            callback([]);
            return;
        }
        let result = [];
        let count = 0;
        for (let option of options){
            let name = option.name.toLowerCase();
            if (name.includes(input_value_lowercase)) {
                let option_element = this.createDropdownElement(option);
                result.push(option_element);
                count++;
                if (count > (0, _constants.Constants).WEB_UI_DROPDOWN_LIMIT) break;
            }
        }
        if (count === 0) {
            this.state.useless_string_prefix_cache.set(input_value_lowercase, true);
            if (this.state.useless_string_prefix_cache.size > (0, _constants.Constants).WEB_UI_DROPDOWN_FORM_CACHE_SIZE) {
                const keyToDelete = this.state.useless_string_prefix_cache.keys().next().value;
                this.state.useless_string_prefix_cache.delete(keyToDelete);
            }
        } else {
            this.state.cached_search_results.set(input_value_lowercase, result);
            if (this.state.cached_search_results.size > (0, _constants.Constants).WEB_UI_DROPDOWN_FORM_CACHE_SIZE) {
                const keyToDelete = this.state.cached_search_results.keys().next().value;
                this.state.cached_search_results.delete(keyToDelete);
            }
            if (count > (0, _constants.Constants).WEB_UI_DROPDOWN_LIMIT) result.push(ellipsis_option);
        }
        callback(result);
    }
    handleChange(event) {
        if (this.props.disabled) return;
        if (!event) event = [];
        if (!Array.isArray(event)) event = [
            event
        ];
        if (this.props.limit && event.length > this.props.limit) return;
        event = event.filter((val)=>Boolean(val.mentionable));
        this.setState({
            mentions: event
        });
        let mentionables = event.map((val)=>val.mentionable);
        this.props.handleChange(mentionables);
    }
    render() {
        const limit_reached = this.props.limit && this.state.mentions.length >= this.props.limit;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                limit_reached && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-text",
                    children: [
                        "Selection limit reached (",
                        this.props.limit,
                        " /",
                        " ",
                        this.props.limit,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                    isClearable: true,
                    classNamePrefix: "sesh-dropdown",
                    value: this.state.mentions,
                    styles: dropdownColourStyles,
                    onChange: this.handleChange,
                    isMulti: !Boolean(this.props.is_single_select),
                    defaultOptions: true,
                    loadOptions: (input_value, callback)=>this.loadOptions(this.props.options, input_value, callback),
                    isDisabled: this.props.disabled || this.props.loading,
                    placeholder: !this.props.loading ? this.props.placeholder : "Loading...",
                    isLoading: this.props.loading,
                    components: {
                        SingleValue
                    }
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select/async":"8lz6t","react-select":[["components","j5lp9","c"]],"../../../../common/sesh_types":"aUAOg","../../../../common/constants":"lLiun","chroma-js":"4nIac","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4nIac":[function(require,module,exports,__globalThis) {
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var limit$2 = function(x, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;
        return x < min ? min : x > max ? max : x;
    };
    var limit$1 = limit$2;
    var clip_rgb$3 = function(rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(var i = 0; i <= 3; i++){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                rgb[i] = limit$1(rgb[i], 0, 255);
            } else if (i === 3) rgb[i] = limit$1(rgb[i], 0, 1);
        }
        return rgb;
    };
    // ported from jQuery's $.type
    var classToType = {};
    for(var i$1 = 0, list$1 = [
        'Boolean',
        'Number',
        'String',
        'Function',
        'Array',
        'Date',
        'RegExp',
        'Undefined',
        'Null'
    ]; i$1 < list$1.length; i$1 += 1){
        var name = list$1[i$1];
        classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type$p = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var type$o = type$p;
    var unpack$B = function(args, keyOrder) {
        if (keyOrder === void 0) keyOrder = null;
        // if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) return Array.prototype.slice.call(args);
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
        if (type$o(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter(function(k) {
            return args[0][k] !== undefined;
        }).map(function(k) {
            return args[0][k];
        });
        // otherwise we just return the first argument
        // (which we suppose is an array of args)
        return args[0];
    };
    var type$n = type$p;
    var last$4 = function(args) {
        if (args.length < 2) return null;
        var l = args.length - 1;
        if (type$n(args[l]) == 'string') return args[l].toLowerCase();
        return null;
    };
    var PI$2 = Math.PI;
    var utils = {
        clip_rgb: clip_rgb$3,
        limit: limit$2,
        type: type$p,
        unpack: unpack$B,
        last: last$4,
        PI: PI$2,
        TWOPI: PI$2 * 2,
        PITHIRD: PI$2 / 3,
        DEG2RAD: PI$2 / 180,
        RAD2DEG: 180 / PI$2
    };
    var input$h = {
        format: {},
        autodetect: []
    };
    var last$3 = utils.last;
    var clip_rgb$2 = utils.clip_rgb;
    var type$m = utils.type;
    var _input = input$h;
    var Color$D = function Color() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var me = this;
        if (type$m(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        var mode = last$3(args);
        var autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!_input.sorted) {
                _input.autodetect = _input.autodetect.sort(function(a, b) {
                    return b.p - a.p;
                });
                _input.sorted = true;
            }
            // auto-detect format
            for(var i = 0, list = _input.autodetect; i < list.length; i += 1){
                var chk = list[i];
                mode = chk.test.apply(chk, args);
                if (mode) break;
            }
        }
        if (_input.format[mode]) {
            var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = clip_rgb$2(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    };
    Color$D.prototype.toString = function toString() {
        if (type$m(this.hex) == 'function') return this.hex();
        return "[" + this._rgb.join(',') + "]";
    };
    var Color_1 = Color$D;
    var chroma$k = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(chroma$k.Color, [
            null
        ].concat(args)));
    };
    chroma$k.Color = Color_1;
    chroma$k.version = '2.4.2';
    var chroma_1 = chroma$k;
    var unpack$A = utils.unpack;
    var max$2 = Math.max;
    var rgb2cmyk$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$A(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max$2(r, max$2(g, b));
        var f = k < 1 ? 1 / (1 - k) : 0;
        var c = (1 - r - k) * f;
        var m = (1 - g - k) * f;
        var y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    var rgb2cmyk_1 = rgb2cmyk$1;
    var unpack$z = utils.unpack;
    var cmyk2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$z(args, 'cmyk');
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        return [
            c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
            m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
            y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
            alpha
        ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var chroma$j = chroma_1;
    var Color$C = Color_1;
    var input$g = input$h;
    var unpack$y = utils.unpack;
    var type$l = utils.type;
    var rgb2cmyk = rgb2cmyk_1;
    Color$C.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    chroma$j.cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$C, [
            null
        ].concat(args, [
            'cmyk'
        ])));
    };
    input$g.format.cmyk = cmyk2rgb_1;
    input$g.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$y(args, 'cmyk');
            if (type$l(args) === 'array' && args.length === 4) return 'cmyk';
        }
    });
    var unpack$x = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a) {
        return Math.round(a * 100) / 100;
    };
    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */ var hsl2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hsla = unpack$x(args, 'hsla');
        var mode = last$2(args) || 'lsa';
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1] * 100) + '%';
        hsla[2] = rnd(hsla[2] * 100) + '%';
        if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = 'hsla';
        } else hsla.length = 3;
        return mode + "(" + hsla.join(',') + ")";
    };
    var hsl2css_1 = hsl2css$1;
    var unpack$w = utils.unpack;
    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */ var rgb2hsl$3 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$w(args, 'rgba');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var l = (max + min) / 2;
        var s, h;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r == max) h = (g - b) / (max - min);
        else if (g == max) h = 2 + (b - r) / (max - min);
        else if (b == max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        if (args.length > 3 && args[3] !== undefined) return [
            h,
            s,
            l,
            args[3]
        ];
        return [
            h,
            s,
            l
        ];
    };
    var rgb2hsl_1 = rgb2hsl$3;
    var unpack$v = utils.unpack;
    var last$1 = utils.last;
    var hsl2css = hsl2css_1;
    var rgb2hsl$2 = rgb2hsl_1;
    var round$6 = Math.round;
    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */ var rgb2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$v(args, 'rgba');
        var mode = last$1(args) || 'rgb';
        if (mode.substr(0, 3) == 'hsl') return hsl2css(rgb2hsl$2(rgba), mode);
        rgba[0] = round$6(rgba[0]);
        rgba[1] = round$6(rgba[1]);
        rgba[2] = round$6(rgba[2]);
        if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = 'rgba';
        }
        return mode + "(" + rgba.slice(0, mode === 'rgb' ? 3 : 4).join(',') + ")";
    };
    var rgb2css_1 = rgb2css$1;
    var unpack$u = utils.unpack;
    var round$5 = Math.round;
    var hsl2rgb$1 = function() {
        var assign;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$u(args, 'hsl');
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r, g, b;
        if (s === 0) r = g = b = l * 255;
        else {
            var t3 = [
                0,
                0,
                0
            ];
            var c = [
                0,
                0,
                0
            ];
            var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1 / 3;
            t3[1] = h_;
            t3[2] = h_ - 1 / 3;
            for(var i = 0; i < 3; i++){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            assign = [
                round$5(c[0] * 255),
                round$5(c[1] * 255),
                round$5(c[2] * 255)
            ], r = assign[0], g = assign[1], b = assign[2];
        }
        if (args.length > 3) // keep alpha channel
        return [
            r,
            g,
            b,
            args[3]
        ];
        return [
            r,
            g,
            b,
            1
        ];
    };
    var hsl2rgb_1 = hsl2rgb$1;
    var hsl2rgb = hsl2rgb_1;
    var input$f = input$h;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$4 = Math.round;
    var css2rgb$1 = function(css) {
        css = css.toLowerCase().trim();
        var m;
        if (input$f.format.named) try {
            return input$f.format.named(css);
        } catch (e) {
        // eslint-disable-next-line
        }
        // rgb(250,20,0)
        if (m = css.match(RE_RGB)) {
            var rgb = m.slice(1, 4);
            for(var i = 0; i < 3; i++)rgb[i] = +rgb[i];
            rgb[3] = 1; // default alpha
            return rgb;
        }
        // rgba(250,20,0,0.4)
        if (m = css.match(RE_RGBA)) {
            var rgb$1 = m.slice(1, 5);
            for(var i$1 = 0; i$1 < 4; i$1++)rgb$1[i$1] = +rgb$1[i$1];
            return rgb$1;
        }
        // rgb(100%,0%,0%)
        if (m = css.match(RE_RGB_PCT)) {
            var rgb$2 = m.slice(1, 4);
            for(var i$2 = 0; i$2 < 3; i$2++)rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
            rgb$2[3] = 1; // default alpha
            return rgb$2;
        }
        // rgba(100%,0%,0%,0.4)
        if (m = css.match(RE_RGBA_PCT)) {
            var rgb$3 = m.slice(1, 5);
            for(var i$3 = 0; i$3 < 3; i$3++)rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }
        // hsl(0,100%,50%)
        if (m = css.match(RE_HSL)) {
            var hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }
        // hsla(0,100%,50%,0.5)
        if (m = css.match(RE_HSLA)) {
            var hsl$1 = m.slice(1, 4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb(hsl$1);
            rgb$5[3] = +m[4]; // default alpha = 1
            return rgb$5;
        }
    };
    css2rgb$1.test = function(s) {
        return RE_RGB.test(s) || RE_RGBA.test(s) || RE_RGB_PCT.test(s) || RE_RGBA_PCT.test(s) || RE_HSL.test(s) || RE_HSLA.test(s);
    };
    var css2rgb_1 = css2rgb$1;
    var chroma$i = chroma_1;
    var Color$B = Color_1;
    var input$e = input$h;
    var type$k = utils.type;
    var rgb2css = rgb2css_1;
    var css2rgb = css2rgb_1;
    Color$B.prototype.css = function(mode) {
        return rgb2css(this._rgb, mode);
    };
    chroma$i.css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$B, [
            null
        ].concat(args, [
            'css'
        ])));
    };
    input$e.format.css = css2rgb;
    input$e.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$k(h) === 'string' && css2rgb.test(h)) return 'css';
        }
    });
    var Color$A = Color_1;
    var chroma$h = chroma_1;
    var input$d = input$h;
    var unpack$t = utils.unpack;
    input$d.format.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$t(args, 'rgba');
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };
    chroma$h.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$A, [
            null
        ].concat(args, [
            'gl'
        ])));
    };
    Color$A.prototype.gl = function() {
        var rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    var unpack$s = utils.unpack;
    var rgb2hcg$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$s(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    var rgb2hcg_1 = rgb2hcg$1;
    var unpack$r = utils.unpack;
    var floor$3 = Math.floor;
    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */ var hcg2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$r(args, 'hcg');
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r, g, b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$3(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$q = utils.unpack;
    var type$j = utils.type;
    var chroma$g = chroma_1;
    var Color$z = Color_1;
    var input$c = input$h;
    var rgb2hcg = rgb2hcg_1;
    Color$z.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    chroma$g.hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$z, [
            null
        ].concat(args, [
            'hcg'
        ])));
    };
    input$c.format.hcg = hcg2rgb_1;
    input$c.autodetect.push({
        p: 1,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$q(args, 'hcg');
            if (type$j(args) === 'array' && args.length === 3) return 'hcg';
        }
    });
    var unpack$p = utils.unpack;
    var last = utils.last;
    var round$3 = Math.round;
    var rgb2hex$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$p(args, 'rgba');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last(args) || 'auto';
        if (a === undefined) a = 1;
        if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = '0' + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch(mode.toLowerCase()){
            case 'rgba':
                return "#" + str + hxa;
            case 'argb':
                return "#" + hxa + str;
            default:
                return "#" + str;
        }
    };
    var rgb2hex_1 = rgb2hex$2;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb$1 = function(hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split('');
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) // remove optional leading #
            hex = hex.substr(1);
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split('');
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [
                r$1,
                g$1,
                b$1,
                a
            ];
        }
        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb
        throw new Error("unknown hex color: " + hex);
    };
    var hex2rgb_1 = hex2rgb$1;
    var chroma$f = chroma_1;
    var Color$y = Color_1;
    var type$i = utils.type;
    var input$b = input$h;
    var rgb2hex$1 = rgb2hex_1;
    Color$y.prototype.hex = function(mode) {
        return rgb2hex$1(this._rgb, mode);
    };
    chroma$f.hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$y, [
            null
        ].concat(args, [
            'hex'
        ])));
    };
    input$b.format.hex = hex2rgb_1;
    input$b.autodetect.push({
        p: 4,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$i(h) === 'string' && [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ].indexOf(h.length) >= 0) return 'hex';
        }
    });
    var unpack$o = utils.unpack;
    var TWOPI$2 = utils.TWOPI;
    var min$2 = Math.min;
    var sqrt$4 = Math.sqrt;
    var acos = Math.acos;
    var rgb2hsi$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */ var ref = unpack$o(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min$2(r, g, b);
        var i = (r + g + b) / 3;
        var s = i > 0 ? 1 - min_ / i : 0;
        if (s === 0) h = NaN;
        else {
            h = (r - g + (r - b)) / 2;
            h /= sqrt$4((r - g) * (r - g) + (r - b) * (g - b));
            h = acos(h);
            if (b > g) h = TWOPI$2 - h;
            h /= TWOPI$2;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    var rgb2hsi_1 = rgb2hsi$1;
    var unpack$n = utils.unpack;
    var limit = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos$4 = Math.cos;
    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */ var hsi2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */ args = unpack$n(args, 'hsi');
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r, g, b;
        if (isNaN(h)) h = 0;
        if (isNaN(s)) s = 0;
        // normalize hue
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$m = utils.unpack;
    var type$h = utils.type;
    var chroma$e = chroma_1;
    var Color$x = Color_1;
    var input$a = input$h;
    var rgb2hsi = rgb2hsi_1;
    Color$x.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    chroma$e.hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$x, [
            null
        ].concat(args, [
            'hsi'
        ])));
    };
    input$a.format.hsi = hsi2rgb_1;
    input$a.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$m(args, 'hsi');
            if (type$h(args) === 'array' && args.length === 3) return 'hsi';
        }
    });
    var unpack$l = utils.unpack;
    var type$g = utils.type;
    var chroma$d = chroma_1;
    var Color$w = Color_1;
    var input$9 = input$h;
    var rgb2hsl$1 = rgb2hsl_1;
    Color$w.prototype.hsl = function() {
        return rgb2hsl$1(this._rgb);
    };
    chroma$d.hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$w, [
            null
        ].concat(args, [
            'hsl'
        ])));
    };
    input$9.format.hsl = hsl2rgb_1;
    input$9.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$l(args, 'hsl');
            if (type$g(args) === 'array' && args.length === 3) return 'hsl';
        }
    });
    var unpack$k = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;
    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */ var rgb2hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$k(args, 'rgb');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h, s, v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) h = (g - b) / delta;
            if (g === max_) h = 2 + (b - r) / delta;
            if (b === max_) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    var rgb2hsv$1 = rgb2hsl;
    var unpack$j = utils.unpack;
    var floor$2 = Math.floor;
    var hsv2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$j(args, 'hsv');
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r, g, b;
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$2(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$i = utils.unpack;
    var type$f = utils.type;
    var chroma$c = chroma_1;
    var Color$v = Color_1;
    var input$8 = input$h;
    var rgb2hsv = rgb2hsv$1;
    Color$v.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    chroma$c.hsv = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$v, [
            null
        ].concat(args, [
            'hsv'
        ])));
    };
    input$8.format.hsv = hsv2rgb_1;
    input$8.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$i(args, 'hsv');
            if (type$f(args) === 'array' && args.length === 3) return 'hsv';
        }
    });
    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,
        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    var LAB_CONSTANTS$3 = labConstants;
    var unpack$h = utils.unpack;
    var pow$a = Math.pow;
    var rgb2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$h(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r, g, b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [
            l < 0 ? 0 : l,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    var rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        return pow$a((r + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t) {
        if (t > LAB_CONSTANTS$3.t3) return pow$a(t, 1 / 3);
        return t / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
    };
    var rgb2xyz = function(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS$3.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
        return [
            x,
            y,
            z
        ];
    };
    var rgb2lab_1 = rgb2lab$2;
    var LAB_CONSTANTS$2 = labConstants;
    var unpack$g = utils.unpack;
    var pow$9 = Math.pow;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var lab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$g(args, 'lab');
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x, y, z, r, g, b_;
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS$2.Yn * lab_xyz(y);
        x = LAB_CONSTANTS$2.Xn * lab_xyz(x);
        z = LAB_CONSTANTS$2.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b_,
            args.length > 3 ? args[3] : 1
        ];
    };
    var xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$9(r, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t) {
        return t > LAB_CONSTANTS$2.t1 ? t * t * t : LAB_CONSTANTS$2.t2 * (t - LAB_CONSTANTS$2.t0);
    };
    var lab2rgb_1 = lab2rgb$1;
    var unpack$f = utils.unpack;
    var type$e = utils.type;
    var chroma$b = chroma_1;
    var Color$u = Color_1;
    var input$7 = input$h;
    var rgb2lab$1 = rgb2lab_1;
    Color$u.prototype.lab = function() {
        return rgb2lab$1(this._rgb);
    };
    chroma$b.lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$u, [
            null
        ].concat(args, [
            'lab'
        ])));
    };
    input$7.format.lab = lab2rgb_1;
    input$7.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$f(args, 'lab');
            if (type$e(args) === 'array' && args.length === 3) return 'lab';
        }
    });
    var unpack$e = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$3 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var round$2 = Math.round;
    var lab2lch$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$e(args, 'lab');
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$3(a * a + b * b);
        var h = (atan2$2(b, a) * RAD2DEG + 360) % 360;
        if (round$2(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    var lab2lch_1 = lab2lch$2;
    var unpack$d = utils.unpack;
    var rgb2lab = rgb2lab_1;
    var lab2lch$1 = lab2lch_1;
    var rgb2lch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$d(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch$1(l, a, b_);
    };
    var rgb2lch_1 = rgb2lch$1;
    var unpack$c = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin$3 = Math.sin;
    var cos$3 = Math.cos;
    var lch2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */ var ref = unpack$c(args, 'lch');
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) h = 0;
        h = h * DEG2RAD;
        return [
            l,
            cos$3(h) * c,
            sin$3(h) * c
        ];
    };
    var lch2lab_1 = lch2lab$2;
    var unpack$b = utils.unpack;
    var lch2lab$1 = lch2lab_1;
    var lab2rgb = lab2rgb_1;
    var lch2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$b(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab$1(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var lch2rgb_1 = lch2rgb$1;
    var unpack$a = utils.unpack;
    var lch2rgb = lch2rgb_1;
    var hcl2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hcl = unpack$a(args, 'hcl').reverse();
        return lch2rgb.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$9 = utils.unpack;
    var type$d = utils.type;
    var chroma$a = chroma_1;
    var Color$t = Color_1;
    var input$6 = input$h;
    var rgb2lch = rgb2lch_1;
    Color$t.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color$t.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    chroma$a.lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            'lch'
        ])));
    };
    chroma$a.hcl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            'hcl'
        ])));
    };
    input$6.format.lch = lch2rgb_1;
    input$6.format.hcl = hcl2rgb_1;
    [
        'lch',
        'hcl'
    ].forEach(function(m) {
        return input$6.autodetect.push({
            p: 2,
            test: function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                args = unpack$9(args, m);
                if (type$d(args) === 'array' && args.length === 3) return m;
            }
        });
    });
    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */ var w3cx11$1 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };
    var w3cx11_1 = w3cx11$1;
    var Color$s = Color_1;
    var input$5 = input$h;
    var type$c = utils.type;
    var w3cx11 = w3cx11_1;
    var hex2rgb = hex2rgb_1;
    var rgb2hex = rgb2hex_1;
    Color$s.prototype.name = function() {
        var hex = rgb2hex(this._rgb, 'rgb');
        for(var i = 0, list = Object.keys(w3cx11); i < list.length; i += 1){
            var n = list[i];
            if (w3cx11[n] === hex) return n.toLowerCase();
        }
        return hex;
    };
    input$5.format.named = function(name) {
        name = name.toLowerCase();
        if (w3cx11[name]) return hex2rgb(w3cx11[name]);
        throw new Error('unknown color name: ' + name);
    };
    input$5.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$c(h) === 'string' && w3cx11[h.toLowerCase()]) return 'named';
        }
    });
    var unpack$8 = utils.unpack;
    var rgb2num$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$8(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num$1;
    var type$b = utils.type;
    var num2rgb = function(num) {
        if (type$b(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = num >> 8 & 0xFF;
            var b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        throw new Error("unknown num color: " + num);
    };
    var num2rgb_1 = num2rgb;
    var chroma$9 = chroma_1;
    var Color$r = Color_1;
    var input$4 = input$h;
    var type$a = utils.type;
    var rgb2num = rgb2num_1;
    Color$r.prototype.num = function() {
        return rgb2num(this._rgb);
    };
    chroma$9.num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$r, [
            null
        ].concat(args, [
            'num'
        ])));
    };
    input$4.format.num = num2rgb_1;
    input$4.autodetect.push({
        p: 5,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            if (args.length === 1 && type$a(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) return 'num';
        }
    });
    var chroma$8 = chroma_1;
    var Color$q = Color_1;
    var input$3 = input$h;
    var unpack$7 = utils.unpack;
    var type$9 = utils.type;
    var round$1 = Math.round;
    Color$q.prototype.rgb = function(rnd) {
        if (rnd === void 0) rnd = true;
        if (rnd === false) return this._rgb.slice(0, 3);
        return this._rgb.slice(0, 3).map(round$1);
    };
    Color$q.prototype.rgba = function(rnd) {
        if (rnd === void 0) rnd = true;
        return this._rgb.slice(0, 4).map(function(v, i) {
            return i < 3 ? rnd === false ? v : round$1(v) : v;
        });
    };
    chroma$8.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$q, [
            null
        ].concat(args, [
            'rgb'
        ])));
    };
    input$3.format.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$7(args, 'rgba');
        if (rgba[3] === undefined) rgba[3] = 1;
        return rgba;
    };
    input$3.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$7(args, 'rgba');
            if (type$9(args) === 'array' && (args.length === 3 || args.length === 4 && type$9(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
        }
    });
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */ var log$1 = Math.log;
    var temperature2rgb$1 = function(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log$1(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log$1(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log$1(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log$1(g);
            b = 255;
        }
        return [
            r,
            g,
            b,
            1
        ];
    };
    var temperature2rgb_1 = temperature2rgb$1;
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/ var temperature2rgb = temperature2rgb_1;
    var unpack$6 = utils.unpack;
    var round = Math.round;
    var rgb2temperature$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$6(args, 'rgb');
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb(temp);
            if (rgb$1[2] / rgb$1[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    var rgb2temperature_1 = rgb2temperature$1;
    var chroma$7 = chroma_1;
    var Color$p = Color_1;
    var input$2 = input$h;
    var rgb2temperature = rgb2temperature_1;
    Color$p.prototype.temp = Color$p.prototype.kelvin = Color$p.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    chroma$7.temp = chroma$7.kelvin = chroma$7.temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$p, [
            null
        ].concat(args, [
            'temp'
        ])));
    };
    input$2.format.temp = input$2.format.kelvin = input$2.format.temperature = temperature2rgb_1;
    var unpack$5 = utils.unpack;
    var cbrt = Math.cbrt;
    var pow$8 = Math.pow;
    var sign$1 = Math.sign;
    var rgb2oklab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // OKLab color space implementation taken from
        // https://bottosson.github.io/posts/oklab/
        var ref = unpack$5(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = [
            rgb2lrgb(r / 255),
            rgb2lrgb(g / 255),
            rgb2lrgb(b / 255)
        ];
        var lr = ref$1[0];
        var lg = ref$1[1];
        var lb = ref$1[2];
        var l = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
        var m = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
        var s = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
        return [
            0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
            1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
            0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
        ];
    };
    var rgb2oklab_1 = rgb2oklab$2;
    function rgb2lrgb(c) {
        var abs = Math.abs(c);
        if (abs < 0.04045) return c / 12.92;
        return (sign$1(c) || 1) * pow$8((abs + 0.055) / 1.055, 2.4);
    }
    var unpack$4 = utils.unpack;
    var pow$7 = Math.pow;
    var sign = Math.sign;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var oklab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$4(args, 'lab');
        var L = args[0];
        var a = args[1];
        var b = args[2];
        var l = pow$7(L + 0.3963377774 * a + 0.2158037573 * b, 3);
        var m = pow$7(L - 0.1055613458 * a - 0.0638541728 * b, 3);
        var s = pow$7(L - 0.0894841775 * a - 1.291485548 * b, 3);
        return [
            255 * lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
            255 * lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
            255 * lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklab2rgb_1 = oklab2rgb$1;
    function lrgb2rgb(c) {
        var abs = Math.abs(c);
        if (abs > 0.0031308) return (sign(c) || 1) * (1.055 * pow$7(abs, 1 / 2.4) - 0.055);
        return c * 12.92;
    }
    var unpack$3 = utils.unpack;
    var type$8 = utils.type;
    var chroma$6 = chroma_1;
    var Color$o = Color_1;
    var input$1 = input$h;
    var rgb2oklab$1 = rgb2oklab_1;
    Color$o.prototype.oklab = function() {
        return rgb2oklab$1(this._rgb);
    };
    chroma$6.oklab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$o, [
            null
        ].concat(args, [
            'oklab'
        ])));
    };
    input$1.format.oklab = oklab2rgb_1;
    input$1.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$3(args, 'oklab');
            if (type$8(args) === 'array' && args.length === 3) return 'oklab';
        }
    });
    var unpack$2 = utils.unpack;
    var rgb2oklab = rgb2oklab_1;
    var lab2lch = lab2lch_1;
    var rgb2oklch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$2(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2oklab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch(l, a, b_);
    };
    var rgb2oklch_1 = rgb2oklch$1;
    var unpack$1 = utils.unpack;
    var lch2lab = lch2lab_1;
    var oklab2rgb = oklab2rgb_1;
    var oklch2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$1(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = oklab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklch2rgb_1 = oklch2rgb;
    var unpack = utils.unpack;
    var type$7 = utils.type;
    var chroma$5 = chroma_1;
    var Color$n = Color_1;
    var input = input$h;
    var rgb2oklch = rgb2oklch_1;
    Color$n.prototype.oklch = function() {
        return rgb2oklch(this._rgb);
    };
    chroma$5.oklch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$n, [
            null
        ].concat(args, [
            'oklch'
        ])));
    };
    input.format.oklch = oklch2rgb_1;
    input.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack(args, 'oklch');
            if (type$7(args) === 'array' && args.length === 3) return 'oklch';
        }
    });
    var Color$m = Color_1;
    var type$6 = utils.type;
    Color$m.prototype.alpha = function(a, mutate) {
        if (mutate === void 0) mutate = false;
        if (a !== undefined && type$6(a) === 'number') {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color$m([
                this._rgb[0],
                this._rgb[1],
                this._rgb[2],
                a
            ], 'rgb');
        }
        return this._rgb[3];
    };
    var Color$l = Color_1;
    Color$l.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    var Color$k = Color_1;
    var LAB_CONSTANTS$1 = labConstants;
    Color$k.prototype.darken = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lab = me.lab();
        lab[0] -= LAB_CONSTANTS$1.Kn * amount;
        return new Color$k(lab, 'lab').alpha(me.alpha(), true);
    };
    Color$k.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 1;
        return this.darken(-amount);
    };
    Color$k.prototype.darker = Color$k.prototype.darken;
    Color$k.prototype.brighter = Color$k.prototype.brighten;
    var Color$j = Color_1;
    Color$j.prototype.get = function(mc) {
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
            if (i > -1) return src[i];
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$i = Color_1;
    var type$5 = utils.type;
    var pow$6 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color$i.prototype.luminance = function(lum) {
        if (lum !== undefined && type$5(lum) === 'number') {
            if (lum === 0) // return pure black
            return new Color$i([
                0,
                0,
                0,
                this._rgb[3]
            ], 'rgb');
            if (lum === 1) // return pure white
            return new Color$i([
                255,
                255,
                255,
                this._rgb[3]
            ], 'rgb');
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = 'rgb';
            var max_iter = MAX_ITER;
            var test = function(low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) // close enough
                return mid;
                return lm > lum ? test(low, mid) : test(mid, high);
            };
            var rgb = (cur_lum > lum ? test(new Color$i([
                0,
                0,
                0
            ]), this) : test(this, new Color$i([
                255,
                255,
                255
            ]))).rgb();
            return new Color$i(rgb.concat([
                this._rgb[3]
            ]));
        }
        return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r, g, b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x) {
        x /= 255;
        return x <= 0.03928 ? x / 12.92 : pow$6((x + 0.055) / 1.055, 2.4);
    };
    var interpolator$1 = {};
    var Color$h = Color_1;
    var type$4 = utils.type;
    var interpolator = interpolator$1;
    var mix$1 = function(col1, col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 3;
        while(len-- > 0)rest[len] = arguments[len + 3];
        var mode = rest[0] || 'lrgb';
        if (!interpolator[mode] && !rest.length) // fall back to the first supported mode
        mode = Object.keys(interpolator)[0];
        if (!interpolator[mode]) throw new Error("interpolation mode " + mode + " is not defined");
        if (type$4(col1) !== 'object') col1 = new Color$h(col1);
        if (type$4(col2) !== 'object') col2 = new Color$h(col2);
        return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    var Color$g = Color_1;
    var mix = mix$1;
    Color$g.prototype.mix = Color$g.prototype.interpolate = function(col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 2;
        while(len-- > 0)rest[len] = arguments[len + 2];
        return mix.apply(void 0, [
            this,
            col2,
            f
        ].concat(rest));
    };
    var Color$f = Color_1;
    Color$f.prototype.premultiply = function(mutate) {
        if (mutate === void 0) mutate = false;
        var rgb = this._rgb;
        var a = rgb[3];
        if (mutate) {
            this._rgb = [
                rgb[0] * a,
                rgb[1] * a,
                rgb[2] * a,
                a
            ];
            return this;
        } else return new Color$f([
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ], 'rgb');
    };
    var Color$e = Color_1;
    var LAB_CONSTANTS = labConstants;
    Color$e.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lch = me.lch();
        lch[1] += LAB_CONSTANTS.Kn * amount;
        if (lch[1] < 0) lch[1] = 0;
        return new Color$e(lch, 'lch').alpha(me.alpha(), true);
    };
    Color$e.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 1;
        return this.saturate(-amount);
    };
    var Color$d = Color_1;
    var type$3 = utils.type;
    Color$d.prototype.set = function(mc, value, mutate) {
        if (mutate === void 0) mutate = false;
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
            if (i > -1) {
                if (type$3(value) == 'string') switch(value.charAt(0)){
                    case '+':
                        src[i] += +value;
                        break;
                    case '-':
                        src[i] += +value;
                        break;
                    case '*':
                        src[i] *= +value.substr(1);
                        break;
                    case '/':
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else if (type$3(value) === 'number') src[i] = value;
                else throw new Error("unsupported value for Color.set");
                var out = new Color$d(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$c = Color_1;
    var rgb = function(col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color$c(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
    };
    // register interpolator
    interpolator$1.rgb = rgb;
    var Color$b = Color_1;
    var sqrt$2 = Math.sqrt;
    var pow$5 = Math.pow;
    var lrgb = function(col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color$b(sqrt$2(pow$5(x1, 2) * (1 - f) + pow$5(x2, 2) * f), sqrt$2(pow$5(y1, 2) * (1 - f) + pow$5(y2, 2) * f), sqrt$2(pow$5(z1, 2) * (1 - f) + pow$5(z2, 2) * f), 'rgb');
    };
    // register interpolator
    interpolator$1.lrgb = lrgb;
    var Color$a = Color_1;
    var lab = function(col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color$a(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
    };
    // register interpolator
    interpolator$1.lab = lab;
    var Color$9 = Color_1;
    var _hsx = function(col1, col2, f, m) {
        var assign, assign$1;
        var xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        } else if (m === 'oklch') {
            xyz0 = col1.oklch().reverse();
            xyz1 = col2.oklch().reverse();
        }
        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === 'h' || m === 'oklch') {
            assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2];
            assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2];
        }
        var sat, hue, lbv, dh;
        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
        } else hue = Number.NaN;
        if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return m === 'oklch' ? new Color$9([
            lbv,
            sat,
            hue
        ], m) : new Color$9([
            hue,
            sat,
            lbv
        ], m);
    };
    var interpolate_hsx$5 = _hsx;
    var lch = function(col1, col2, f) {
        return interpolate_hsx$5(col1, col2, f, 'lch');
    };
    // register interpolator
    interpolator$1.lch = lch;
    interpolator$1.hcl = lch;
    var Color$8 = Color_1;
    var num = function(col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color$8(c1 + f * (c2 - c1), 'num');
    };
    // register interpolator
    interpolator$1.num = num;
    var interpolate_hsx$4 = _hsx;
    var hcg = function(col1, col2, f) {
        return interpolate_hsx$4(col1, col2, f, 'hcg');
    };
    // register interpolator
    interpolator$1.hcg = hcg;
    var interpolate_hsx$3 = _hsx;
    var hsi = function(col1, col2, f) {
        return interpolate_hsx$3(col1, col2, f, 'hsi');
    };
    // register interpolator
    interpolator$1.hsi = hsi;
    var interpolate_hsx$2 = _hsx;
    var hsl = function(col1, col2, f) {
        return interpolate_hsx$2(col1, col2, f, 'hsl');
    };
    // register interpolator
    interpolator$1.hsl = hsl;
    var interpolate_hsx$1 = _hsx;
    var hsv = function(col1, col2, f) {
        return interpolate_hsx$1(col1, col2, f, 'hsv');
    };
    // register interpolator
    interpolator$1.hsv = hsv;
    var Color$7 = Color_1;
    var oklab = function(col1, col2, f) {
        var xyz0 = col1.oklab();
        var xyz1 = col2.oklab();
        return new Color$7(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
    };
    // register interpolator
    interpolator$1.oklab = oklab;
    var interpolate_hsx = _hsx;
    var oklch = function(col1, col2, f) {
        return interpolate_hsx(col1, col2, f, 'oklch');
    };
    // register interpolator
    interpolator$1.oklch = oklch;
    var Color$6 = Color_1;
    var clip_rgb$1 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$1 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors, mode, weights) {
        if (mode === void 0) mode = 'lrgb';
        if (weights === void 0) weights = null;
        var l = colors.length;
        if (!weights) weights = Array.from(new Array(l)).map(function() {
            return 1;
        });
        // normalize weights
        var k = l / weights.reduce(function(a, b) {
            return a + b;
        });
        weights.forEach(function(w, i) {
            weights[i] *= k;
        });
        // convert colors to Color objects
        colors = colors.map(function(c) {
            return new Color$6(c);
        });
        if (mode === 'lrgb') return _average_lrgb(colors, weights);
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for(var i = 0; i < xyz.length; i++){
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$2(A) * weights[0];
            }
        }
        var alpha = first.alpha() * weights[0];
        colors.forEach(function(c, ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci + 1];
            for(var i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
                cnt[i] += weights[ci + 1];
                if (mode.charAt(i) === 'h') {
                    var A = xyz2[i] / 180 * PI$1;
                    dx += cos$2(A) * weights[ci + 1];
                    dy += sin$2(A) * weights[ci + 1];
                } else xyz[i] += xyz2[i] * weights[ci + 1];
            }
        });
        for(var i$1 = 0; i$1 < xyz.length; i$1++)if (mode.charAt(i$1) === 'h') {
            var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
            while(A$1 < 0)A$1 += 360;
            while(A$1 >= 360)A$1 -= 360;
            xyz[i$1] = A$1;
        } else xyz[i$1] = xyz[i$1] / cnt[i$1];
        alpha /= l;
        return new Color$6(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors, weights) {
        var l = colors.length;
        var xyz = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < colors.length; i++){
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0], 2) * f;
            xyz[1] += pow$4(rgb[1], 2) * f;
            xyz[2] += pow$4(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$1(xyz[0]);
        xyz[1] = sqrt$1(xyz[1]);
        xyz[2] = sqrt$1(xyz[2]);
        if (xyz[3] > 0.9999999) xyz[3] = 1;
        return new Color$6(clip_rgb$1(xyz));
    };
    // minimal multi-purpose interface
    // @requires utils color analyze
    var chroma$4 = chroma_1;
    var type$2 = utils.type;
    var pow$3 = Math.pow;
    var scale$2 = function(colors) {
        // constructor
        var _mode = 'rgb';
        var _nacol = chroma$4('#ccc');
        var _spread = 0;
        // const _fixed = false;
        var _domain = [
            0,
            1
        ];
        var _pos = [];
        var _padding = [
            0,
            0
        ];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;
        // private methods
        var setColors = function(colors) {
            colors = colors || [
                '#fff',
                '#000'
            ];
            if (colors && type$2(colors) === 'string' && chroma$4.brewer && chroma$4.brewer[colors.toLowerCase()]) colors = chroma$4.brewer[colors.toLowerCase()];
            if (type$2(colors) === 'array') {
                // handle single color
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for(var c = 0; c < colors.length; c++)colors[c] = chroma$4(colors[c]);
                // auto-fill color position
                _pos.length = 0;
                for(var c$1 = 0; c$1 < colors.length; c$1++)_pos.push(c$1 / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length - 1;
                var i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        var tMapLightness = function(t) {
            return t;
        };
        var tMapDomain = function(t) {
            return t;
        };
        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };
        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) // just interpolate between min/max
                t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            // domain map
            t = tMapDomain(t);
            if (!bypassMap) t = tMapLightness(t); // lightness correction
            if (_gamma !== 1) t = pow$3(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            var k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type$2(_colors) === 'array') //for i in [0.._pos.length-1]
                for(var i = 0; i < _pos.length; i++){
                    var p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma$4.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type$2(_colors) === 'function') col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        var resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        // public interface
        var f = function(v) {
            var c = chroma$4(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            if (classes != null) {
                if (type$2(classes) === 'array') {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    var d = chroma$4.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma$4.limits(d, 'e', classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            var k = _colors.length;
            if (domain.length === k && _min !== _max) // update positions
            for(var i = 0, list = Array.from(domain); i < list.length; i += 1){
                var d = list[i];
                _pos.push((d - _min) / (_max - _min));
            }
            else {
                for(var c = 0; c < k; c++)_pos.push(c / (k - 1));
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function(d, i) {
                        return i / (domain.length - 1);
                    });
                    var tBreaks = domain.map(function(d) {
                        return (d - _min) / (_max - _min);
                    });
                    if (!tBreaks.every(function(val, i) {
                        return tOut[i] === val;
                    })) tMapDomain = function(t) {
                        if (t <= 0 || t >= 1) return t;
                        var i = 0;
                        while(t >= tBreaks[i + 1])i++;
                        var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                        var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                        return out;
                    };
                }
            }
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tMapLightness = function(t) {
                var L0 = getColor(0, true).lab()[0];
                var L1 = getColor(1, true).lab()[0];
                var pol = L0 > L1;
                var L_actual = getColor(t, true).lab()[0];
                var L_ideal = L0 + (L1 - L0) * t;
                var L_diff = L_actual - L_ideal;
                var t0 = 0;
                var t1 = 1;
                var max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tMapLightness = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type$2(p) === 'number') p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) out = 'hex';
            var result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                var samples = [];
                if (_classes && _classes.length > 2) for(var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma$4[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma$4(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
        return range;
    }
    //
    // interpolates between a set of colors uzing a bezier spline
    //
    // @requires utils lab
    var Color$5 = Color_1;
    var scale$1 = scale$2;
    // nth row of the pascal triangle
    var binom_row = function(n) {
        var row = [
            1,
            1
        ];
        for(var i = 1; i < n; i++){
            var newrow = [
                1
            ];
            for(var j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
            row = newrow;
        }
        return row;
    };
    var bezier = function(colors) {
        var assign, assign$1, assign$2;
        var I, lab0, lab1, lab2;
        colors = colors.map(function(c) {
            return new Color$5(c);
        });
        if (colors.length === 2) {
            // linear interpolation
            assign = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign[0], lab1 = assign[1];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return lab0[i] + t * (lab1[i] - lab0[i]);
                });
                return new Color$5(lab, 'lab');
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            assign$1 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
                });
                return new Color$5(lab, 'lab');
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            assign$2 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
                });
                return new Color$5(lab, 'lab');
            };
        } else if (colors.length >= 5) {
            // general case (degree n bezier)
            var labs, row, n;
            labs = colors.map(function(c) {
                return c.lab();
            });
            n = colors.length - 1;
            row = binom_row(n);
            I = function(t) {
                var u = 1 - t;
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return labs.reduce(function(sum, el, j) {
                        return sum + row[j] * Math.pow(u, n - j) * Math.pow(t, j) * el[i];
                    }, 0);
                });
                return new Color$5(lab, 'lab');
            };
        } else throw new RangeError("No point in running bezier with only one color.");
        return I;
    };
    var bezier_1 = function(colors) {
        var f = bezier(colors);
        f.scale = function() {
            return scale$1(f);
        };
        return f;
    };
    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */ var chroma$3 = chroma_1;
    var blend = function(bottom, top, mode) {
        if (!blend[mode]) throw new Error('unknown blend mode ' + mode);
        return blend[mode](bottom, top);
    };
    var blend_f = function(f) {
        return function(bottom, top) {
            var c0 = chroma$3(top).rgb();
            var c1 = chroma$3(bottom).rgb();
            return chroma$3.rgb(f(c0, c1));
        };
    };
    var each = function(f) {
        return function(c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        };
    };
    var normal = function(a) {
        return a;
    };
    var multiply = function(a, b) {
        return a * b / 255;
    };
    var darken = function(a, b) {
        return a > b ? b : a;
    };
    var lighten = function(a, b) {
        return a > b ? a : b;
    };
    var screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    var overlay = function(a, b) {
        return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    var burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    var dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a;
    };
    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));
    var blend_1 = blend;
    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf
    var type$1 = utils.type;
    var clip_rgb = utils.clip_rgb;
    var TWOPI = utils.TWOPI;
    var pow$2 = Math.pow;
    var sin$1 = Math.sin;
    var cos$1 = Math.cos;
    var chroma$2 = chroma_1;
    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if (start === void 0) start = 300;
        if (rotations === void 0) rotations = -1.5;
        if (hue === void 0) hue = 1;
        if (gamma === void 0) gamma = 1;
        if (lightness === void 0) lightness = [
            0,
            1
        ];
        var dh = 0, dl;
        if (type$1(lightness) === 'array') dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        var f = function(fract) {
            var a = TWOPI * ((start + 120) / 360 + rotations * fract);
            var l = pow$2(lightness[0] + dl * fract, gamma);
            var h = dh !== 0 ? hue[0] + fract * dh : hue;
            var amp = h * l * (1 - l) / 2;
            var cos_a = cos$1(a);
            var sin_a = sin$1(a);
            var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            var b = l + amp * (1.97294 * cos_a);
            return chroma$2(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type$1(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type$1(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma$2.scale(f);
        };
        f.hue(hue);
        return f;
    };
    var Color$4 = Color_1;
    var digits = '0123456789abcdef';
    var floor$1 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
        var code = '#';
        for(var i = 0; i < 6; i++)code += digits.charAt(floor$1(random() * 16));
        return new Color$4(code, 'hex');
    };
    var type = type$p;
    var log = Math.log;
    var pow$1 = Math.pow;
    var floor = Math.floor;
    var abs$1 = Math.abs;
    var analyze = function(data, key) {
        if (key === void 0) key = null;
        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === 'object') data = Object.values(data);
        data.forEach(function(val) {
            if (key && type(val) === 'object') val = val[key];
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        });
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return limits(r, mode, num);
        };
        return r;
    };
    var limits = function(data, mode, num) {
        if (mode === void 0) mode = 'equal';
        if (num === void 0) num = 7;
        if (type(data) == 'array') data = analyze(data);
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        var limits = [];
        if (mode.substr(0, 1) === 'c') {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === 'e') {
            limits.push(min);
            for(var i = 1; i < num; i++)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'l') {
            if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
            var min_log = Math.LOG10E * log(min);
            var max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(var i$1 = 1; i$1 < num; i$1++)limits.push(pow$1(10, min_log + i$1 / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'q') {
            limits.push(min);
            for(var i$2 = 1; i$2 < num; i$2++){
                var p = (values.length - 1) * i$2 / num;
                var pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    var pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === 'k') {
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */ var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;
            // get seed values
            centroids = [];
            centroids.push(min);
            for(var i$3 = 1; i$3 < num; i$3++)centroids.push(min + i$3 / num * (max - min));
            centroids.push(max);
            while(repeat){
                // assignment step
                for(var j = 0; j < num; j++)clusterSizes[j] = 0;
                for(var i$4 = 0; i$4 < n; i$4++){
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = void 0;
                    for(var j$1 = 0; j$1 < num; j$1++){
                        var dist = abs$1(centroids[j$1] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }
                // update centroids step
                var newCentroids = new Array(num);
                for(var j$2 = 0; j$2 < num; j$2++)newCentroids[j$2] = null;
                for(var i$5 = 0; i$5 < n; i$5++){
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i$5];
                    else newCentroids[cluster] += values[i$5];
                }
                for(var j$3 = 0; j$3 < num; j$3++)newCentroids[j$3] *= 1 / clusterSizes[j$3];
                // check convergence
                repeat = false;
                for(var j$4 = 0; j$4 < num; j$4++)if (newCentroids[j$4] !== centroids[j$4]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for(var j$5 = 0; j$5 < num; j$5++)kClusters[j$5] = [];
            for(var i$6 = 0; i$6 < n; i$6++){
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for(var j$6 = 0; j$6 < num; j$6++){
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2){
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    var analyze_1 = {
        analyze: analyze,
        limits: limits
    };
    var Color$3 = Color_1;
    var contrast = function(a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color$3(a);
        b = new Color$3(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var Color$2 = Color_1;
    var sqrt = Math.sqrt;
    var pow = Math.pow;
    var min = Math.min;
    var max = Math.max;
    var atan2 = Math.atan2;
    var abs = Math.abs;
    var cos = Math.cos;
    var sin = Math.sin;
    var exp = Math.exp;
    var PI = Math.PI;
    var deltaE = function(a, b, Kl, Kc, Kh) {
        if (Kl === void 0) Kl = 1;
        if (Kc === void 0) Kc = 1;
        if (Kh === void 0) Kh = 1;
        // Delta E (CIE 2000)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
        var rad2deg = function(rad) {
            return 360 * rad / (2 * PI);
        };
        var deg2rad = function(deg) {
            return 2 * PI * deg / 360;
        };
        a = new Color$2(a);
        b = new Color$2(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var avgL = (L1 + L2) / 2;
        var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
        var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
        var avgC = (C1 + C2) / 2;
        var G = 0.5 * (1 - sqrt(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
        var a1p = a1 * (1 + G);
        var a2p = a2 * (1 + G);
        var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
        var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
        var avgCp = (C1p + C2p) / 2;
        var arctan1 = rad2deg(atan2(b1, a1p));
        var arctan2 = rad2deg(atan2(b2, a2p));
        var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
        var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
        var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
        var T = 1 - 0.17 * cos(deg2rad(avgHp - 30)) + 0.24 * cos(deg2rad(2 * avgHp)) + 0.32 * cos(deg2rad(3 * avgHp + 6)) - 0.2 * cos(deg2rad(4 * avgHp - 63));
        var deltaHp = h2p - h1p;
        deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
        deltaHp = 2 * sqrt(C1p * C2p) * sin(deg2rad(deltaHp) / 2);
        var deltaL = L2 - L1;
        var deltaCp = C2p - C1p;
        var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt(20 + pow(avgL - 50, 2));
        var sc = 1 + 0.045 * avgCp;
        var sh = 1 + 0.015 * avgCp * T;
        var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
        var Rc = 2 * sqrt(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
        var Rt = -Rc * sin(2 * deg2rad(deltaTheta));
        var result = sqrt(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
        return max(0, min(100, result));
    };
    var Color$1 = Color_1;
    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if (mode === void 0) mode = 'lab';
        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color$1(a);
        b = new Color$1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for(var i in l1){
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    var Color = Color_1;
    var valid = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        try {
            new (Function.prototype.bind.apply(Color, [
                null
            ].concat(args)));
            return true;
        } catch (e) {
            return false;
        }
    };
    // some pre-defined color scales:
    var chroma$1 = chroma_1;
    var scale = scale$2;
    var scales = {
        cool: function cool() {
            return scale([
                chroma$1.hsl(180, 1, .9),
                chroma$1.hsl(250, .7, .4)
            ]);
        },
        hot: function hot() {
            return scale([
                '#000',
                '#f00',
                '#ff0',
                '#fff'
            ]).mode('rgb');
        }
    };
    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */ var colorbrewer = {
        // sequential
        OrRd: [
            '#fff7ec',
            '#fee8c8',
            '#fdd49e',
            '#fdbb84',
            '#fc8d59',
            '#ef6548',
            '#d7301f',
            '#b30000',
            '#7f0000'
        ],
        PuBu: [
            '#fff7fb',
            '#ece7f2',
            '#d0d1e6',
            '#a6bddb',
            '#74a9cf',
            '#3690c0',
            '#0570b0',
            '#045a8d',
            '#023858'
        ],
        BuPu: [
            '#f7fcfd',
            '#e0ecf4',
            '#bfd3e6',
            '#9ebcda',
            '#8c96c6',
            '#8c6bb1',
            '#88419d',
            '#810f7c',
            '#4d004b'
        ],
        Oranges: [
            '#fff5eb',
            '#fee6ce',
            '#fdd0a2',
            '#fdae6b',
            '#fd8d3c',
            '#f16913',
            '#d94801',
            '#a63603',
            '#7f2704'
        ],
        BuGn: [
            '#f7fcfd',
            '#e5f5f9',
            '#ccece6',
            '#99d8c9',
            '#66c2a4',
            '#41ae76',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlOrBr: [
            '#ffffe5',
            '#fff7bc',
            '#fee391',
            '#fec44f',
            '#fe9929',
            '#ec7014',
            '#cc4c02',
            '#993404',
            '#662506'
        ],
        YlGn: [
            '#ffffe5',
            '#f7fcb9',
            '#d9f0a3',
            '#addd8e',
            '#78c679',
            '#41ab5d',
            '#238443',
            '#006837',
            '#004529'
        ],
        Reds: [
            '#fff5f0',
            '#fee0d2',
            '#fcbba1',
            '#fc9272',
            '#fb6a4a',
            '#ef3b2c',
            '#cb181d',
            '#a50f15',
            '#67000d'
        ],
        RdPu: [
            '#fff7f3',
            '#fde0dd',
            '#fcc5c0',
            '#fa9fb5',
            '#f768a1',
            '#dd3497',
            '#ae017e',
            '#7a0177',
            '#49006a'
        ],
        Greens: [
            '#f7fcf5',
            '#e5f5e0',
            '#c7e9c0',
            '#a1d99b',
            '#74c476',
            '#41ab5d',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlGnBu: [
            '#ffffd9',
            '#edf8b1',
            '#c7e9b4',
            '#7fcdbb',
            '#41b6c4',
            '#1d91c0',
            '#225ea8',
            '#253494',
            '#081d58'
        ],
        Purples: [
            '#fcfbfd',
            '#efedf5',
            '#dadaeb',
            '#bcbddc',
            '#9e9ac8',
            '#807dba',
            '#6a51a3',
            '#54278f',
            '#3f007d'
        ],
        GnBu: [
            '#f7fcf0',
            '#e0f3db',
            '#ccebc5',
            '#a8ddb5',
            '#7bccc4',
            '#4eb3d3',
            '#2b8cbe',
            '#0868ac',
            '#084081'
        ],
        Greys: [
            '#ffffff',
            '#f0f0f0',
            '#d9d9d9',
            '#bdbdbd',
            '#969696',
            '#737373',
            '#525252',
            '#252525',
            '#000000'
        ],
        YlOrRd: [
            '#ffffcc',
            '#ffeda0',
            '#fed976',
            '#feb24c',
            '#fd8d3c',
            '#fc4e2a',
            '#e31a1c',
            '#bd0026',
            '#800026'
        ],
        PuRd: [
            '#f7f4f9',
            '#e7e1ef',
            '#d4b9da',
            '#c994c7',
            '#df65b0',
            '#e7298a',
            '#ce1256',
            '#980043',
            '#67001f'
        ],
        Blues: [
            '#f7fbff',
            '#deebf7',
            '#c6dbef',
            '#9ecae1',
            '#6baed6',
            '#4292c6',
            '#2171b5',
            '#08519c',
            '#08306b'
        ],
        PuBuGn: [
            '#fff7fb',
            '#ece2f0',
            '#d0d1e6',
            '#a6bddb',
            '#67a9cf',
            '#3690c0',
            '#02818a',
            '#016c59',
            '#014636'
        ],
        Viridis: [
            '#440154',
            '#482777',
            '#3f4a8a',
            '#31678e',
            '#26838f',
            '#1f9d8a',
            '#6cce5a',
            '#b6de2b',
            '#fee825'
        ],
        // diverging
        Spectral: [
            '#9e0142',
            '#d53e4f',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#e6f598',
            '#abdda4',
            '#66c2a5',
            '#3288bd',
            '#5e4fa2'
        ],
        RdYlGn: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#d9ef8b',
            '#a6d96a',
            '#66bd63',
            '#1a9850',
            '#006837'
        ],
        RdBu: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#f7f7f7',
            '#d1e5f0',
            '#92c5de',
            '#4393c3',
            '#2166ac',
            '#053061'
        ],
        PiYG: [
            '#8e0152',
            '#c51b7d',
            '#de77ae',
            '#f1b6da',
            '#fde0ef',
            '#f7f7f7',
            '#e6f5d0',
            '#b8e186',
            '#7fbc41',
            '#4d9221',
            '#276419'
        ],
        PRGn: [
            '#40004b',
            '#762a83',
            '#9970ab',
            '#c2a5cf',
            '#e7d4e8',
            '#f7f7f7',
            '#d9f0d3',
            '#a6dba0',
            '#5aae61',
            '#1b7837',
            '#00441b'
        ],
        RdYlBu: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee090',
            '#ffffbf',
            '#e0f3f8',
            '#abd9e9',
            '#74add1',
            '#4575b4',
            '#313695'
        ],
        BrBG: [
            '#543005',
            '#8c510a',
            '#bf812d',
            '#dfc27d',
            '#f6e8c3',
            '#f5f5f5',
            '#c7eae5',
            '#80cdc1',
            '#35978f',
            '#01665e',
            '#003c30'
        ],
        RdGy: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#ffffff',
            '#e0e0e0',
            '#bababa',
            '#878787',
            '#4d4d4d',
            '#1a1a1a'
        ],
        PuOr: [
            '#7f3b08',
            '#b35806',
            '#e08214',
            '#fdb863',
            '#fee0b6',
            '#f7f7f7',
            '#d8daeb',
            '#b2abd2',
            '#8073ac',
            '#542788',
            '#2d004b'
        ],
        // qualitative
        Set2: [
            '#66c2a5',
            '#fc8d62',
            '#8da0cb',
            '#e78ac3',
            '#a6d854',
            '#ffd92f',
            '#e5c494',
            '#b3b3b3'
        ],
        Accent: [
            '#7fc97f',
            '#beaed4',
            '#fdc086',
            '#ffff99',
            '#386cb0',
            '#f0027f',
            '#bf5b17',
            '#666666'
        ],
        Set1: [
            '#e41a1c',
            '#377eb8',
            '#4daf4a',
            '#984ea3',
            '#ff7f00',
            '#ffff33',
            '#a65628',
            '#f781bf',
            '#999999'
        ],
        Set3: [
            '#8dd3c7',
            '#ffffb3',
            '#bebada',
            '#fb8072',
            '#80b1d3',
            '#fdb462',
            '#b3de69',
            '#fccde5',
            '#d9d9d9',
            '#bc80bd',
            '#ccebc5',
            '#ffed6f'
        ],
        Dark2: [
            '#1b9e77',
            '#d95f02',
            '#7570b3',
            '#e7298a',
            '#66a61e',
            '#e6ab02',
            '#a6761d',
            '#666666'
        ],
        Paired: [
            '#a6cee3',
            '#1f78b4',
            '#b2df8a',
            '#33a02c',
            '#fb9a99',
            '#e31a1c',
            '#fdbf6f',
            '#ff7f00',
            '#cab2d6',
            '#6a3d9a',
            '#ffff99',
            '#b15928'
        ],
        Pastel2: [
            '#b3e2cd',
            '#fdcdac',
            '#cbd5e8',
            '#f4cae4',
            '#e6f5c9',
            '#fff2ae',
            '#f1e2cc',
            '#cccccc'
        ],
        Pastel1: [
            '#fbb4ae',
            '#b3cde3',
            '#ccebc5',
            '#decbe4',
            '#fed9a6',
            '#ffffcc',
            '#e5d8bd',
            '#fddaec',
            '#f2f2f2'
        ]
    };
    // add lowercase aliases for case-insensitive matches
    for(var i = 0, list = Object.keys(colorbrewer); i < list.length; i += 1){
        var key = list[i];
        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    var chroma = chroma_1;
    // feel free to comment out anything to rollup
    // a smaller chroma.js built
    // io --> convert colors
    // operators --> modify existing Colors
    // interpolators
    // generators -- > create new colors
    chroma.average = average;
    chroma.bezier = bezier_1;
    chroma.blend = blend_1;
    chroma.cubehelix = cubehelix;
    chroma.mix = chroma.interpolate = mix$1;
    chroma.random = random_1;
    chroma.scale = scale$2;
    // other utility methods
    chroma.analyze = analyze_1.analyze;
    chroma.contrast = contrast;
    chroma.deltaE = deltaE;
    chroma.distance = distance;
    chroma.limits = analyze_1.limits;
    chroma.valid = valid;
    // scale
    chroma.scales = scales;
    // colors
    chroma.colors = w3cx11_1;
    chroma.brewer = colorbrewer_1;
    var chroma_js = chroma;
    return chroma_js;
});

},{}],"b2XTr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRoles", ()=>useRoles);
var _react = require("react");
var _reactRouter = require("react-router");
var _seshRouter = require("../../../sesh_router");
function useRoles() {
    let { server_id } = (0, _reactRouter.useParams)();
    const context = (0, _react.useContext)((0, _seshRouter.GuildRolesAndChannelContext));
    return context.get(server_id)?.roles;
}

},{"react":"IMRgT","react-router":"djWTS","../../../sesh_router":"hfnpE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8oSSD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventCreationAdvancedSelector", ()=>EventCreationAdvancedSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _tag = require("./base_components/tag");
const Sections = {
    RSVPs: [
        "rsvp_options"
    ],
    Notifications: [
        "server_reminders"
    ],
    Appearance: [
        "color",
        "image_url",
        "hide_attendees"
    ],
    Attendees: [
        "eligible_role_ids",
        "attendee_role_data",
        "rsvp_lock_before_ms"
    ],
    Integrations: [
        "thread_settings",
        "native_event_data"
    ],
    Repeat: [
        "rrule"
    ]
};
const SectionIcons = {
    RSVPs: "fas fa-check-square",
    Appearance: "fas fa-palette",
    Attendees: "fas fa-users",
    Integrations: "fab fa-discord",
    Notifications: "fas fa-bell",
    Repeat: "fas fa-redo"
};
const NewSections = [
    "Notifications"
];
function EventCreationAdvancedSelector(props) {
    const [active_section, setActiveSection] = (0, _react.useState)(Object.keys(Sections)[0]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-fit self-center rounded-t-md bg-base-dark px-4 text-lg",
                    children: "Advanced"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex justify-between overflow-auto rounded-t-md bg-base-dark",
                    children: Object.keys(Sections).map((section_name, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionIcon, {
                            section_name: section_name,
                            is_active: section_name === active_section,
                            onClick: ()=>setActiveSection(section_name),
                            is_first: index === 0,
                            is_last: index === Object.keys(Sections).length - 1
                        }, section_name))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "improved-event-creation-form flex flex-col gap-4 bg-base-semidark px-0 py-2",
                    children: Sections[active_section].map((field_key)=>props.field_key_to_element[field_key](props.is_disabled))
                })
            ]
        })
    });
}
function SectionIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        onClick: props.onClick,
        className: (0, _classnamesDefault.default)("relative w-full cursor-pointer p-2 py-4", {
            "opacity-50": !props.is_active,
            "bg-base-semidark": props.is_active,
            "rounded-tl-md": props.is_first,
            "rounded-tr-md": props.is_last
        }),
        children: [
            NewSections.includes(props.section_name) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absolute right-0 top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                    type: "Light",
                    children: "New"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-2xl",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: SectionIcons[props.section_name]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "hidden sm:flex",
                        children: props.section_name
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","./base_components/tag":"l4wGc","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jQ5tM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelSelectFormWithTags", ()=>ChannelSelectFormWithTags);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _channelDropdown = require("../channel_dropdown");
const name = null;
function ChannelSelectFormWithTags(props) {
    const selected_channel = props.channel_data.find((val)=>val.id === props.initial_value?.id);
    const tags = selected_channel?.type === "Forum" ? selected_channel?.tag_settings.tags : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdown.ChannelSelectForm), {
                ...props,
                should_check_forum_tag_permissions: true
            }),
            selected_channel?.type === "Forum" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ForumTags, {
                required: selected_channel.tag_settings.required,
                tags: tags,
                selected_forum_tag_ids: props.selected_forum_tag_ids,
                setSelectedTagIds: props.setSelectedTagIds
            })
        ]
    });
}
function ForumTags(props) {
    if (props.tags.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("flex gap-2 max-w-full overflow-auto pb-1", {
            "input-disabled": props.disabled
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-shrink-0",
                children: `Tags${props.required ? " (required)" : ""} (${props.selected_forum_tag_ids.length}/5):`
            }),
            props.tags.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ForumTag, {
                    tag: val,
                    is_active: props.selected_forum_tag_ids.includes(val.id),
                    onClick: (id)=>{
                        if (props.selected_forum_tag_ids.includes(id)) props.setSelectedTagIds(props.selected_forum_tag_ids.filter((val)=>val !== id));
                        else if (props.selected_forum_tag_ids.length < 5) props.setSelectedTagIds(props.selected_forum_tag_ids.concat(id));
                    }
                }, index))
        ]
    });
}
function ForumTag(props) {
    const { tag } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("tag forum-tag flex gap-1", {
            active: props.is_active
        }),
        onClick: ()=>props.onClick(tag.id),
        children: [
            tag.emoji && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordEmoji, {
                emoji: tag.emoji
            }),
            tag.moderated,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "select-none",
                children: tag.name
            })
        ]
    });
}
function DiscordEmoji(props) {
    const emoji_element = props.emoji.id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: "h-[1em]",
        src: `https://cdn.discordapp.com/emojis/${props.emoji.id}.png`
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.emoji.name
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "self-center",
        children: emoji_element
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../channel_dropdown":"eUzk8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eUzk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelSelectForm", ()=>ChannelSelectForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _dashboardUtils = require("../dashboard_utils");
const disabledStyle = {
    control: (base, state)=>({
            ...base,
            background: "#BBBBBB",
            // Overwrittes the different states of border
            borderColor: "#BBBBBB",
            cursor: "not-allowed"
        })
};
function createCategoryDropdown(data, disabled) {
    return {
        value: data.category_id,
        label: data.category_name,
        options: data.children,
        channel_data: undefined
    };
}
function createDropdownData(data, disabled, should_check_forum_tag_permissions) {
    let className = "";
    let icon;
    switch(data.type){
        case "Text":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-hashtag"
            });
            break;
        case "Forum":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-comments"
            });
            break;
        case "Thread":
            className = "ml-2 mr-1";
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-level-up-alt fa-rotate-90 small-indent"
            }, "thread-icon");
            break;
    }
    let is_disabled = disabled;
    let error_message;
    if (!data.has_write) {
        is_disabled = true;
        error_message = "Invalid Write Permissions";
    } else if (should_check_forum_tag_permissions) {
        if (data.type === "Forum" && data.tag_settings.required && data.tag_settings.tags.length === 0) {
            error_message = "Invalid Tag Permissions";
            is_disabled = true;
        }
    }
    return {
        value: data.id,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-vcentered",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: className,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    color: "gray"
                                },
                                className: "mr-1",
                                children: icon
                            }, "spany span"),
                            data.name
                        ]
                    })
                }),
                error_message && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `column is-pulled-right dropdown-disabled-text`,
                            children: error_message
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow"
                        })
                    ]
                })
            ]
        }, data.id),
        channel_data: data,
        isDisabled: is_disabled
    };
}
function hasPermsForChannel(channel_data) {
    if (!channel_data?.has_write) return false;
    if (channel_data.type === "Forum") {
        if (channel_data.tag_settings.required && channel_data.tag_settings.tags.length === 0) return false;
    }
    return true;
}
function ChannelSelectForm(props) {
    const channel_list = props.include_threads ? props.channel_data : props.channel_data.filter((val)=>val.type !== "Thread");
    let parent_to_threads_map = new Map();
    const threads = channel_list.filter((val)=>val.type === "Thread");
    const channel_list_no_threads = channel_list.filter((val)=>val.type !== "Thread");
    for (const thread of threads){
        let children_threads;
        if (parent_to_threads_map.has(thread.category_id)) children_threads = parent_to_threads_map.get(thread.category_id);
        else {
            children_threads = [];
            parent_to_threads_map.set(thread.category_id, children_threads);
        }
        children_threads.push(createDropdownData(thread, props.disabled, props.should_check_forum_tag_permissions));
    }
    let category_mapped_channels = [];
    for (let option of channel_list_no_threads){
        if (props.sesh_channel_id && option.id === props.sesh_channel_id && props.is_event != null) {
            category_mapped_channels = [
                {
                    category_id: "SESH_CHANNEL",
                    category_name: `Sesh ${props.is_event ? "Event" : "Poll"} Channel`,
                    children: [
                        createDropdownData(option, props.disabled, props.should_check_forum_tag_permissions)
                    ].concat(parent_to_threads_map.get(option.id) ?? [])
                }
            ].concat(category_mapped_channels);
            continue;
        }
        if (!option.category_id) {
            category_mapped_channels.push({
                category_id: null,
                category_name: null,
                children: [
                    createDropdownData(option, props.disabled, props.should_check_forum_tag_permissions)
                ].concat(parent_to_threads_map.get(option.id) ?? [])
            });
            continue;
        }
        let category_data = category_mapped_channels.find((val)=>val.category_id === option.category_id);
        if (!category_data) {
            category_data = {
                category_id: option.category_id,
                category_name: option.category_name,
                children: []
            };
            category_mapped_channels.push(category_data);
        }
        category_data.children.push(createDropdownData(option, props.disabled, props.should_check_forum_tag_permissions));
        category_data.children = category_data.children.concat(parent_to_threads_map.get(option.id) ?? []);
    }
    let options = [];
    for (let category_data of category_mapped_channels)if (!category_data.category_id) options = options.concat(category_data.children);
    else options.push(createCategoryDropdown(category_data, props.disabled));
    const options_flat = [];
    for (let root_option of options){
        if (root_option.options && root_option.options.length > 0) for (let option of root_option.options)options_flat.push(option);
        else options_flat.push(root_option);
    }
    let initial_value_dropdown;
    if (props.initial_value) initial_value_dropdown = options_flat.find((val)=>val.value === props.initial_value.id);
    if (!initial_value_dropdown || !hasPermsForChannel(initial_value_dropdown.channel_data)) {
        let first_channel;
        for (let option of options_flat){
            if (!hasPermsForChannel(option.channel_data)) continue;
            first_channel = option;
            break;
        }
        if (first_channel) initial_value_dropdown = first_channel;
        else (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("No valid channels found. Please ensure sesh and you have proper permissions in atleast one channel in the server.");
    }
    const [state, setState] = (0, _react.useState)({
        value: initial_value_dropdown,
        options: options,
        options_flat
    });
    (0, _react.useEffect)(()=>{
        if (props.update_initially) props.updateFunc(state.value.channel_data);
    }, []);
    function renderHeader() {
        if (!props.name) return null;
        return (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(props.name, props.info, undefined, undefined, props.has_unsaved_changes, undefined, props.disabled);
    }
    function renderOverrideText() {
        if (props.desired_channel_id && props.desired_channel_id !== state.value.channel_data.id) {
            const desired_channel_data = state.options_flat.find((val)=>val?.channel_data?.id == props.desired_channel_id);
            if (!desired_channel_data) return;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "mt-4 warning-note",
                children: [
                    "Selected channel differs from server default: (#",
                    desired_channel_data.channel_data.name,
                    ")",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "link-chain-clickable-text",
                        onClick: ()=>{
                            handleChange(desired_channel_data);
                        },
                        children: "Revert"
                    })
                ]
            });
        }
        return null;
    }
    function renderChannelDropdown() {
        const style = props.disabled ? disabledStyle : undefined;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            id: props.id,
            children: [
                renderHeader(),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        //menuIsOpen={true}
                        classNamePrefix: "sesh-dropdown",
                        filterOption: filterOptions,
                        //styles={style}
                        value: state.value,
                        options: state.options,
                        onChange: handleChange,
                        isDisabled: props.disabled
                    })
                }),
                renderOverrideText(),
                props.below_element
            ]
        });
    }
    function handleChange(event) {
        setState({
            ...state,
            value: event
        });
        props.updateFunc(event.channel_data);
    }
    return renderChannelDropdown();
}
function filterOptions(option, input) {
    let lowercase_input = input.toLowerCase();
    let lowercase_channel = "#" + option.data.channel_data.name.toLowerCase();
    return lowercase_channel.includes(lowercase_input);
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select":"8FQ4W","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8FQ4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _select6Efcc53AEsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _select6Efcc53AEsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _select6Efcc53AEsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _index9F7Dc477EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select6Efcc53AEsmJs = require("./Select-6efcc53a.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _index9F7Dc477EsmJs = require("./index-9f7dc477.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _typeof = require("@babel/runtime/helpers/typeof");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _select6Efcc53AEsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};
exports.default = StateManagedSelect;

},{"./useStateManager-7e1e8489.esm.js":"96guW","@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","./Select-6efcc53a.esm.js":"5hglB","@emotion/react":[["CacheProvider","gvB8D","C"]],"@emotion/cache":"aPh1k","./index-9f7dc477.esm.js":"j5lp9","@babel/runtime/helpers/objectSpread2":"bRaaz","@babel/runtime/helpers/slicedToArray":"645an","@babel/runtime/helpers/objectWithoutProperties":"9oMCs","@babel/runtime/helpers/classCallCheck":"fcShU","@babel/runtime/helpers/createClass":"vMnDx","@babel/runtime/helpers/inherits":"6dnmI","@babel/runtime/helpers/createSuper":"5kRad","@babel/runtime/helpers/toConsumableArray":"iebyH","memoize-one":"5mMU6","@babel/runtime/helpers/taggedTemplateLiteral":"46qqA","@babel/runtime/helpers/typeof":"5h97i","@babel/runtime/helpers/defineProperty":"a1zHA","react-dom":"fODdr","@floating-ui/dom":"2hhpa","use-isomorphic-layout-effect":"6icBW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lIuHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7aRSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerButton", ()=>DatePickerButton);
parcelHelpers.export(exports, "DateFormWithDuration", ()=>DateFormWithDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _chronoNode = require("chrono-node");
var _chronoNodeDefault = parcelHelpers.interopDefault(_chronoNode);
var _luxon = require("luxon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _timeFormatUtils = require("../../../../../common/time_format_utils");
var _dashboardUtils = require("../../dashboard_utils");
var _eventCreation = require("../../event_creation");
var _dateTimePicker = require("../date_time_picker");
var _modifySettingsButton = require("./base_components/modify_settings_button");
var _seshTextInput = require("./base_components/sesh_text_input");
var _seshTextRawInput = require("./base_components/sesh_text_raw_input");
var _durationComponent = require("./duration_component");
function DatePickerButton(props) {
    const [isActive, setIsActive] = (0, _react.useState)(false);
    const [date, setDate] = (0, _react.useState)(props.initial_date);
    const modal_body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile is-multiline is-centered",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-two-thirds-tablet is-full-mobile is-centered",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePicker.DateTimePicker), {
                    updateFunc: (date)=>setDate(date),
                    initial_value: date,
                    disable_past_days: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "is-pulled-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `button dashboard-primary-button--tiny is-size-6 has-text-right`,
                        type: "submit",
                        onClick: (e)=>{
                            e.preventDefault();
                            props.onSubmit(date);
                            setIsActive(false);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "has-text-weight-bold",
                            children: "Confirm"
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex h-full w-full items-center p-2 text-2xl",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    onClick: ()=>{
                        setIsActive(true);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "far fa-calendar-alt text-sesh-primary hover:cursor-pointer hover:text-sesh-dark"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: isActive,
                onClose: (e)=>{
                    e.preventDefault();
                    setIsActive(false);
                },
                title: "Date Picker",
                allow_overflow: true,
                subtitle: props.modal_subtitle,
                content: modal_body
            })
        ]
    });
}
class DateFormWithDuration extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let initial_date = props.initial_value;
        let initial_value = initial_date ? (0, _timeFormatUtils.time_format_utils).format_time_verbose_without_until(initial_date.setZone(props.personal_zone), null, this.props.use_24h_clock) : "";
        this.state = {
            value: initial_value,
            utc_date: props.initial_value,
            is_duration_active: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleInputChange(event) {
        this.props.onInputChange?.(event.target.value);
        this.updateDate(event.target.value);
    }
    updateDateFromPicker(date) {
        const luxon_date = _luxon.DateTime.fromJSDate(date);
        const value = (0, _timeFormatUtils.time_format_utils).format_time_from_date_picker(luxon_date);
        this.props.onInputChange?.(value);
        const utc_date = luxon_date.toUTC();
        this.setState({
            value,
            utc_date
        });
        this.props.updateFunc(utc_date);
    }
    updateDate(str) {
        const message_timestamp_luxon = _luxon.DateTime.fromJSDate(new Date()).toLocal();
        const local_timezone = _luxon.DateTime.local().zone;
        const user_timezone = _luxon.IANAZone.create(this.props.personal_zone);
        const user_timezone_offset = -local_timezone.offset(message_timestamp_luxon.toMillis());
        const guild_timezone_offset = -user_timezone.offset(message_timestamp_luxon.toMillis());
        let chrono_results = (0, _chronoNodeDefault.default).parse(str, message_timestamp_luxon.plus({
            minutes: user_timezone_offset - guild_timezone_offset
        }).toJSDate(), {
            forwardDate: true
        });
        let chrono_result = chrono_results[0];
        if (this.props.use_24h_clock) (0, _timeFormatUtils.time_format_utils).refine_to_24_hour_clock(chrono_result);
        const start_time_parse_success = chrono_results !== undefined && chrono_result !== undefined && chrono_result.start !== undefined;
        let luxon_date = null;
        if (start_time_parse_success) {
            if (chrono_result.start.isCertain("timezoneOffset")) luxon_date = _luxon.DateTime.fromJSDate(chrono_result.start.date()).toUTC(chrono_result.start.get("timezoneOffset"));
            else luxon_date = _luxon.DateTime.fromJSDate(chrono_result.start.date()).minus(_luxon.Duration.fromObject({
                minutes: user_timezone_offset - guild_timezone_offset
            })).toUTC();
            if (!luxon_date.isValid) luxon_date = null;
        }
        this.setState({
            value: str,
            utc_date: luxon_date
        });
        this.props.updateFunc(luxon_date);
    }
    render() {
        let start_time_personal;
        let start_time_guild;
        if (this.state.utc_date) {
            start_time_personal = this.state.utc_date.setZone(this.props.personal_zone);
            start_time_guild = this.state.utc_date.setZone(this.props.guild_zone);
        } else {
            start_time_personal = _luxon.DateTime.local();
            start_time_guild = _luxon.DateTime.local();
        }
        const timezone_abbr_personal = (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time_personal, this.props.personal_zone);
        const timezone_abbr_guild = (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time_guild, this.props.guild_zone);
        let does_personal_timezone_match_guild = (0, _timeFormatUtils.time_format_utils).areTimezonesEquivalent(this.props.personal_zone, this.props.guild_zone, this.state.utc_date);
        let timezone_delta_message = null;
        does_personal_timezone_match_guild;
        let output_message = null;
        const is_field_empty = !this.state.value || this.state.value.length === 0;
        const is_time_valid = Boolean(this.state.utc_date);
        if (!is_field_empty) {
            if (is_time_valid) {
                let guild_time_text;
                if (this.props.display_text) guild_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_guild, null, null, this.props.use_24h_clock, this.props.duration_ms);
                else guild_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_guild, this.props.personal_zone, null, this.props.use_24h_clock, this.props.duration_ms);
                let success_message;
                if (does_personal_timezone_match_guild) success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        this.props.display_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                children: [
                                    this.props.display_text,
                                    " (",
                                    timezone_abbr_guild,
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: ` ${guild_time_text}`
                        })
                    ]
                });
                else {
                    const is_same_day = start_time_personal.hasSame(start_time_guild, "day");
                    if (is_same_day) {
                        const dual_timezone_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose_dual_timezone(start_time_personal, this.props.personal_zone, this.props.guild_zone, this.props.use_24h_clock, this.props.duration_ms);
                        success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: this.props.display_text
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: ` ${dual_timezone_text}`
                                })
                            ]
                        });
                    } else {
                        const local_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_personal, null, null, this.props.use_24h_clock, this.props.duration_ms);
                        success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-2 sm:flex-row sm:gap-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "output-time",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Local time (",
                                                    timezone_abbr_personal,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: ` ${local_time_text}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "output-time",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Server time (",
                                                    timezone_abbr_guild,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: ` ${guild_time_text}`
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }
                const in_future = this.state.utc_date.toMillis() > new Date().getTime();
                if (in_future) output_message = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "success-note mt-4",
                    children: success_message
                });
                else output_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-note mt-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-text has-text-weight-bold",
                            children: "Invalid Input: Time in past"
                        }),
                        success_message
                    ]
                });
            } else output_message = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "error-note mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Could not parse time"
                })
            });
        }
        let inputClassName = "input";
        if (this.props.disabled) inputClassName += " input-disabled";
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            id: this.props.id,
            className: "field",
            children: [
                this.props.name && (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(this.props.name, this.props.info, undefined, undefined, undefined, undefined, this.props.disabled),
                timezone_delta_message,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                                    input_element_override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextRawInput.SeshTextRawInput), {
                                        placeholder: this.props.placeholder,
                                        type: "text",
                                        value: this.state.value,
                                        onChange: this.handleInputChange,
                                        disabled: this.props.disabled,
                                        right_children: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "h-full w-full",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerButton, {
                                                    initial_date: this.state.utc_date?.toJSDate() ?? new Date(),
                                                    onSubmit: (date)=>{
                                                        this.updateDateFromPicker(date);
                                                    },
                                                    modal_subtitle: "Select the event time using your local timezone"
                                                }, this.state.utc_date?.toISO())
                                            })
                                    }),
                                    input_props: {}
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddDurationComponent, {
                                guild_zone: this.props.guild_zone,
                                personal_zone: this.props.personal_zone,
                                use_24h_clock: this.props.use_24h_clock
                            })
                        ]
                    })
                }),
                output_message
            ]
        });
    }
}
function AddDurationComponent(props) {
    const creation_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    if (creation_context.state.duration_ms == null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "ml-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
            hide_arrow: true,
            onClick: ()=>creation_context.setState({
                    duration_ms: 3600000
                }),
            children: "Add Duration"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full items-center gap-1 sm:w-3/4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationComponent.EventDurationComponent), {})
    });
}

},{"react/jsx-runtime":"dpQXr","chrono-node":"jT2kU","luxon":"fLWpi","react":"IMRgT","../../../../../common/time_format_utils":"g0uQN","../../dashboard_utils":"jvA8A","../../event_creation":"a8uX3","../date_time_picker":"c4mcO","./base_components/modify_settings_button":"kbhTg","./base_components/sesh_text_input":"befXR","./base_components/sesh_text_raw_input":"7BBPX","./duration_component":"l9cPz","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l9cPz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventDurationComponent", ()=>EventDurationComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _eventCreation = require("../../event_creation");
var _durationPicker = require("../duration_picker");
var _durationPickerDefault = parcelHelpers.interopDefault(_durationPicker);
function EventDurationComponent() {
    const creation_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    // const [input, setInput] = useState(creation_context.state.end);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationPickerDefault.default), {
        duration_ms: creation_context.state.duration_ms,
        updateFunc: (val)=>{
            creation_context.setState({
                duration_ms: val
            });
        }
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../event_creation":"a8uX3","../duration_picker":"leXKg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"leXKg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DurationComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
function formatPluralDuration(num, label) {
    return num === 1 ? `${num} ${label}` : `${num} ${label}s`;
}
function DurationComponent(props) {
    const minutes_in_ms = 60000;
    const hours_in_ms = minutes_in_ms * 60;
    const hours = Math.floor(props.duration_ms / hours_in_ms);
    const minutes = props.duration_ms % hours_in_ms / minutes_in_ms;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center gap-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-bold",
                    children: "Duration"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex w-full items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-1/2 sm:w-1/3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationDropdown, {
                            setValue: (val)=>props.updateFunc(val * hours_in_ms + minutes_in_ms * minutes),
                            value: hours,
                            type: "hour"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-1/2 sm:w-1/3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationDropdown, {
                            setValue: (val)=>props.updateFunc(hours * hours_in_ms + val * minutes_in_ms),
                            value: minutes,
                            type: "minute"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-fit cursor-pointer text-xl opacity-50 hover:text-warning hover:opacity-100",
                        onClick: ()=>props.updateFunc(undefined),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "fas fa-times"
                        })
                    })
                ]
            })
        ]
    });
}
function createInitialHourOptions(val) {
    const hour_options = [];
    for(let i = 0; i < 24; i++)hour_options.push({
        label: formatPluralDuration(i, "hour"),
        value: i
    });
    if (val >= 24) hour_options.push({
        label: formatPluralDuration(val, "hour"),
        value: val
    });
    return hour_options;
}
function createInitialMinuteOptions(val) {
    const minute_options = [];
    for(let i = 0; i < 60; i += 5){
        if (val > i && val < i + 5) minute_options.push({
            label: formatPluralDuration(val, "minute"),
            value: val
        });
        minute_options.push({
            label: formatPluralDuration(i, "minute"),
            value: i
        });
    }
    return minute_options;
}
function DurationDropdown(props) {
    const [options, setOptions] = (0, _react.useState)(props.type === "hour" ? createInitialHourOptions(props.value) : createInitialMinuteOptions(props.value));
    const selected_option = options.find((val)=>val.value === props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "field w-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "control w-full",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                classNamePrefix: "sesh-dropdown",
                value: selected_option,
                options: options,
                onChange: (selected)=>props.setValue(selected.value),
                isValidNewOption: (inputValue)=>Boolean(tryParseCreatedSelection(inputValue, props.type)),
                formatCreateLabel: (inputValue)=>{
                    const new_option_value = tryParseCreatedSelection(inputValue, props.type);
                    if (new_option_value == null) return;
                    return formatPluralDuration(new_option_value, props.type);
                },
                onCreateOption: (inputValue)=>{
                    const new_option_value = tryParseCreatedSelection(inputValue, props.type);
                    if (new_option_value == null) return;
                    const new_option_dropdown = {
                        label: formatPluralDuration(new_option_value, props.type),
                        value: new_option_value
                    };
                    setOptions((options)=>{
                        return [
                            ...options,
                            new_option_dropdown
                        ].sort((a, b)=>a.value - b.value);
                    });
                    props.type;
                    props.setValue(new_option_value);
                },
                isDisabled: false
            })
        })
    });
}
function tryParseCreatedSelection(input, type) {
    const new_option_value = input.split(" ").map((val)=>parseInt(val)).find((val)=>!isNaN(val));
    if (new_option_value === undefined) return;
    if (new_option_value < 0) return;
    if (type === "minute" && new_option_value >= 60) return;
    return new_option_value;
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select/creatable":"iiR0X","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5CZM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateDropdown", ()=>EventTemplateDropdown);
parcelHelpers.export(exports, "EventTemplatesHeader", ()=>EventTemplatesHeader);
parcelHelpers.export(exports, "EventTemplatePage", ()=>EventTemplatePage);
parcelHelpers.export(exports, "EventTemplateContents", ()=>EventTemplateContents);
parcelHelpers.export(exports, "SaveCurrentSettingsButton", ()=>SaveCurrentSettingsButton);
parcelHelpers.export(exports, "ColoredColor", ()=>ColoredColor);
var _jsxRuntime = require("react/jsx-runtime");
var _fontColorContrast = require("font-color-contrast");
var _fontColorContrastDefault = parcelHelpers.interopDefault(_fontColorContrast);
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _backButton = require("../base_components/back_button");
var _dashboardContainer = require("../base_components/dashboard_container");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _seshSearchForm = require("../base_components/sesh_search_form");
var _useEventCreationContext = require("../hooks/use_event_creation_context");
var _useIsAdmin = require("../hooks/use_is_admin");
var _useServerId = require("../hooks/use_server_id");
var _infoTooltip = require("../tooltips/info_tooltip");
var _withTooltipPortaled = require("../tooltips/with_tooltip_portaled");
var _eventTemplateBookmarkList = require("./event_template_bookmark_list");
var _eventTemplateList = require("./event_template_list");
var _eventTemplateModalInfoPage = require("./event_template_modal_info_page");
var _eventTemplatePrevEventList = require("./event_template_prev_event_list");
function EventTemplateDropdown(props) {
    const event_context = (0, _useEventCreationContext.useEventCreationContext)();
    const template_name = event_context.props.template_data?.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex w-full",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto flex items-center gap-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "flex items-center gap-2 font-bold text-sesh-primary hover:text-sesh-dark",
                    onClick: ()=>event_context.setState({
                            current_page: "templates"
                        }),
                    children: [
                        template_name ?? "Template",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-pencil-alt"
                        })
                    ]
                })
            })
        })
    });
}
function EventTemplatesHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Event Templates"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "flex items-end text-2xl",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "Event templates allow server members to quickly create new events using the settings from previous events. Admins are also able to manage template favorites for quick selection for anyone in the server. For more info, see",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                className: "manual-link",
                                href: "/manual/#event_templates",
                                children: "here"
                            }),
                            "."
                        ]
                    })
                })
            })
        ]
    });
}
function EventTemplatePage(props) {
    const isAdmin = (0, _useIsAdmin.useIsAdmin)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTemplatesHeader, {}),
        bread_crumbs: props.onBack && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButton.BackButton), {
            label: "Back",
            onClick: props.onBack
        }),
        is_loading: !isAdmin.isSuccess,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTemplateContents, {
            is_guild_premium: props.is_guild_premium
        })
    });
}
function EventTemplateContents(props) {
    const server_id = (0, _useServerId.useServerId)();
    const [selected_info_template, setSelectedInfoId] = (0, _react.useState)(null);
    const [selected_template, setSelectedId] = (0, _react.useState)(null);
    const event_list_query = (0, _trpc.trpc).event_template.getBookmarkedList.useQuery({
        guild_id: server_id
    });
    const [search, setSearch] = (0, _react.useState)("");
    const history = (0, _reactRouter.useHistory)();
    const is_viewing_current_settings = selected_info_template?.message_id === "CURRENT";
    let bookmark_count = event_list_query.data?.length;
    const are_server_bookmarks_full = bookmark_count >= (0, _constants.Constants).MAXIMUM_EVENT_TEMPLATES[props.is_guild_premium ? "premium" : "free"];
    const [is_favorites_collapsed, setFavoritesCollapsed] = (0, _react.useState)(false);
    const [is_previous_events_collapsed, setPreviousEventsCollapsed] = (0, _react.useState)(false);
    const onUseClick = (0, _react.useCallback)((template)=>{
        const type = template.template_id ? "template" : "event";
        const selected_template_id = type === "template" ? template.template_id : template.message_id;
        history.push((0, _commonUtils.common_utils).getEventCreateURL(server_id, undefined, {
            type,
            id: selected_template_id
        }), {
            uuid: Math.random()
        });
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mx-auto flex w-11/12 flex-col sm:w-3/4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto w-64",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshSearchForm), {
                                onSubmit: setSearch,
                                placeholder: "Search by name"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "h-[512px] overflow-auto",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListHeader, {
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "Favorited Templates"
                                        }),
                                        !props.is_guild_premium && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "(",
                                                        bookmark_count,
                                                        "/",
                                                        (0, _constants.Constants).MAXIMUM_EVENT_TEMPLATES["free"],
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                                                    style: "Info",
                                                    tooltip: "Server favorites are limited to 3 per server. Upgrade this server to premium to have unlimited favorites.",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fa fa-info-circle fa-sm"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                is_collapsed: is_favorites_collapsed,
                                setCollapsed: setFavoritesCollapsed
                            }),
                            !is_favorites_collapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateBookmarkList.EventTemplateBookmarkedList), {
                                event_list_query: event_list_query,
                                setSelectedTemplate: setSelectedId,
                                setSelectedInfoTemplate: setSelectedInfoId,
                                onUseClick: onUseClick,
                                selected_template: selected_template,
                                search: search
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListHeader, {
                                label: "Previous Events",
                                is_collapsed: is_previous_events_collapsed,
                                setCollapsed: setPreviousEventsCollapsed
                            }),
                            !is_previous_events_collapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePrevEventList.EventTemplatePrevEventList), {
                                setSelectedTemplate: setSelectedId,
                                setSelectedInfoTemplate: setSelectedInfoId,
                                onUseClick: onUseClick,
                                selected_template: selected_template,
                                are_bookmarks_full: are_server_bookmarks_full,
                                search: search
                            })
                        ]
                    })
                ]
            }),
            selected_info_template && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                title: selected_info_template.name + " Template",
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mt-2",
                    children: is_viewing_current_settings ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalInfoPage.StateTemplateViewer), {
                        onClose: ()=>setSelectedInfoId(null)
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalInfoPage.ExistingTemplateViewer), {
                        selected_template: selected_info_template
                    })
                }),
                is_active: true,
                onClose: ()=>setSelectedInfoId(null)
            })
        ]
    });
}
function SaveCurrentSettingsButton(props) {
    const [is_modal_opened, setIsModalOpened] = (0, _react.useState)(false);
    const isAdmin = (0, _useIsAdmin.useIsAdmin)();
    const server_id = (0, _useServerId.useServerId)();
    const event_list_query = (0, _trpc.trpc).event_template.getBookmarkedList.useQuery({
        guild_id: server_id
    });
    if (isAdmin.isLoading || event_list_query.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const are_server_bookmarks_full = event_list_query.data.length >= (0, _constants.Constants).MAXIMUM_EVENT_TEMPLATES[props.is_premium ? "premium" : "free"];
    let tooltip = "";
    if (are_server_bookmarks_full) tooltip = "Favorites full";
    else if (!isAdmin.data) tooltip = "Requires Manage sesh permissions";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-fit",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                    style: "Info",
                    tooltip: tooltip,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modifySettingsButton.ModifySettingsButton), {
                        className: "whitespace-nowrap",
                        hide_arrow: true,
                        disabled: !isAdmin.data || are_server_bookmarks_full,
                        onClick: ()=>setIsModalOpened(true),
                        children: [
                            "Save Current Settings as Template",
                            are_server_bookmarks_full ? " (Favorites Full)" : ""
                        ]
                    })
                })
            }),
            is_modal_opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                title: "Current Settings Template",
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalInfoPage.StateTemplateViewer), {
                        onClose: ()=>setIsModalOpened(false)
                    })
                }),
                is_active: true,
                onClose: ()=>setIsModalOpened(false)
            })
        ]
    });
}
function ListHeader(props) {
    const { setCollapsed, is_collapsed } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "sticky top-0 z-[1]",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: "group w-full",
            onClick: ()=>setCollapsed(!is_collapsed),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateList.PlaceholderRow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full flex-col items-center px-4 transition-all group-hover:text-sesh-primary",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute right-4",
                            children: is_collapsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-down"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-up"
                            })
                        }, is_collapsed ? "collapsed" : "not_collapsed")
                    ]
                })
            })
        })
    });
}
function ColoredColor(props) {
    const color_contrast = (0, _fontColorContrastDefault.default)(props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "w-fit rounded-lg border px-2 text-sm",
        style: {
            backgroundColor: props.value,
            borderColor: color_contrast === "#000000" ? "transparent" : "#00f4ff",
            color: color_contrast
        },
        children: props.value
    });
}

},{"react/jsx-runtime":"dpQXr","font-color-contrast":"bP5fh","react":"IMRgT","react-router":"djWTS","../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/back_button":"hMqc2","../base_components/dashboard_container":"9WDu5","../base_components/modify_settings_button":"kbhTg","../base_components/sesh_search_form":"lufGy","../hooks/use_event_creation_context":"flKqC","../hooks/use_is_admin":"dsdqX","../hooks/use_server_id":"d0sLH","../tooltips/info_tooltip":"93rAL","../tooltips/with_tooltip_portaled":"6LBvw","./event_template_bookmark_list":"22irs","./event_template_list":"dGzHv","./event_template_modal_info_page":"5aBGB","./event_template_prev_event_list":"4NZkJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hMqc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackButton", ()=>BackButton);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../../dashboard_utils");
function BackButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-min items-center gap-2 whitespace-nowrap font-bold text-sesh-primary hover:cursor-pointer hover:text-sesh-dark",
        onClick: props.onClick,
        children: [
            (0, _dashboardUtils.DashboardUtils).GetBackIcon(),
            props.label
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lufGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshSearchForm", ()=>SeshSearchForm);
parcelHelpers.export(exports, "SeshTextSearchInput", ()=>SeshTextSearchInput);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _seshTextRawInput = require("./sesh_text_raw_input");
var _seshTextInput = require("./sesh_text_input");
var _removingThrobber = require("../../removing_throbber");
function SeshSearchForm(props) {
    const [value, setValue] = (0, _react.useState)("");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SeshTextSearchInput, {
        onSubmit: ()=>props.onSubmit(value),
        handleChange: (str)=>setValue(str),
        handleClear: ()=>{
            setValue("");
            props.onSubmit("");
        },
        input_props: {
            value: value,
            placeholder: props.placeholder
        }
    });
}
function SeshTextSearchInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            props?.onSubmit();
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
            ...props,
            input_element_override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextRawInput.SeshTextRawInput), {
                ...props.input_props,
                onChange: (e)=>props.handleChange(e.currentTarget.value),
                right_children: (is_hovered, is_focused)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex h-full items-center",
                        children: [
                            props.handleClear && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                "aria-label": "Clear Search",
                                title: "Clear Search",
                                className: (0, _classnamesDefault.default)("mx-2 cursor-pointer opacity-20 hover:opacity-100"),
                                onClick: ()=>props.handleClear(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-times"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SeshTextSearchButton, {
                                is_hovered: is_hovered,
                                is_focused: is_focused,
                                is_loading: props.is_loading
                            })
                        ]
                    })
            })
        })
    });
}
function SeshTextSearchButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "submit",
        className: (0, _classnamesDefault.default)("flex h-full items-center border-l-2 px-2 hover:bg-base-light", {
            "border-sesh-primary": props.is_focused,
            "border-sesh-dark": props.is_hovered && !props.is_focused,
            "border-content-secondary": !props.is_focused && !props.is_hovered,
            "is-loading": props.is_loading
        }),
        children: [
            props.is_loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
            !props.is_loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-search"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","./sesh_text_raw_input":"7BBPX","./sesh_text_input":"befXR","../../removing_throbber":"TmURk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"TmURk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemovingThrobber", ()=>RemovingThrobber);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSpinners = require("react-spinners");
var _constants = require("../../../../common/constants");
function RemovingThrobber(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
            size: "1rem",
            loading: true,
            color: props.color ?? (0, _constants.Constants).EMBED_COLOR
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../common/constants":"lLiun","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9a5oM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unitConverter = require("./helpers/unitConverter");
var _animation = require("./helpers/animation");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var clip = (0, _animation.createAnimation)("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");
function ClipLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 35 : _f, additionalprops = __rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size"
    ]);
    var style = __assign({
        background: "transparent !important",
        width: (0, _unitConverter.cssValue)(size),
        height: (0, _unitConverter.cssValue)(size),
        borderRadius: "100%",
        border: "2px solid",
        borderTopColor: color,
        borderBottomColor: "transparent",
        borderLeftColor: color,
        borderRightColor: color,
        display: "inline-block",
        animation: "".concat(clip, " ").concat(0.75 / speedMultiplier, "s 0s infinite linear"),
        animationFillMode: "both"
    }, cssOverride);
    if (!loading) return null;
    return _react.createElement("span", __assign({
        style: style
    }, additionalprops));
}
exports.default = ClipLoader;

},{"react":"IMRgT","./helpers/unitConverter":"6dzcC","./helpers/animation":"6f7wb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6dzcC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */ parcelHelpers.export(exports, "parseLengthAndUnit", ()=>parseLengthAndUnit);
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */ parcelHelpers.export(exports, "cssValue", ()=>cssValue);
var cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
function parseLengthAndUnit(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if (cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
function cssValue(value) {
    var lengthWithunit = parseLengthAndUnit(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6f7wb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAnimation", ()=>createAnimation);
var createAnimation = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"flKqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventCreationContext", ()=>useEventCreationContext);
var _react = require("react");
var _eventCreation = require("../../../event_creation");
function useEventCreationContext() {
    return (0, _react.useContext)((0, _eventCreation.EventCreationContext));
}

},{"react":"IMRgT","../../../event_creation":"a8uX3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dsdqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsAdmin", ()=>useIsAdmin);
var _reactRouter = require("react-router");
var _trpc = require("../../../utils/trpc");
function useIsAdmin(opts = {}) {
    const { server_id } = (0, _reactRouter.useParams)();
    return (0, _trpc.trpc).members.isAdmin.useQuery({
        guild_id: server_id
    }, {
        enabled: !opts.disabled,
        staleTime: 600000,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
}

},{"react-router":"djWTS","../../../utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"d0sLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useServerId", ()=>useServerId);
var _reactRouter = require("react-router");
function useServerId() {
    let { server_id } = (0, _reactRouter.useParams)();
    return server_id;
}

},{"react-router":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6LBvw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowSize", ()=>useWindowSize);
parcelHelpers.export(exports, "WithTooltipPortaled", ()=>WithTooltipPortaled);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDom = require("react-dom");
var _useOutsideAlerter = require("../hooks/use_outside_alerter");
var _useOutsideAlerterDefault = parcelHelpers.interopDefault(_useOutsideAlerter);
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = (0, _react.useState)({
        width: undefined,
        height: undefined
    });
    (0, _react.useEffect)(()=>{
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return ()=>window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
const clamp = (num, min, max)=>Math.min(Math.max(num, min), max);
function WithTooltipPortaled(props) {
    const [is_active_click, setIsActiveClick] = (0, _react.useState)(false);
    const [is_active_hover, setIsActiveHover] = (0, _react.useState)(false);
    const windowSize = useWindowSize();
    const tooltip_ref = (0, _react.useRef)(null);
    const parent_ref = (0, _react.useRef)(null);
    const arrow_ref = (0, _react.useRef)(null);
    (0, _useOutsideAlerterDefault.default)(parent_ref, ()=>setIsActiveClick(false));
    (0, _react.useEffect)(()=>{
        if (!is_active_click && !is_active_hover) return;
        if (!tooltip_ref?.current || !parent_ref || !windowSize || !arrow_ref) return;
        const { width: t_width, height: t_height } = tooltip_ref.current.getBoundingClientRect();
        const { left: p_left, width: p_width, top: p_top } = parent_ref.current.getBoundingClientRect();
        // Hack to determine border length, since can't set child relative to border
        const border_offset = getComputedStyle(tooltip_ref.current).borderLeftWidth;
        const border_thickness = Number.parseInt(border_offset.substring(0, border_offset.length - 2));
        const { width: a_width } = arrow_ref.current.getBoundingClientRect();
        const desired_absolute_tooltip_x = p_left + p_width / 2 - t_width / 2;
        const absolute_tooltip_x = clamp(desired_absolute_tooltip_x, 0, windowSize.width - t_width);
        tooltip_ref.current.style.left = `${absolute_tooltip_x}px`;
        tooltip_ref.current.style.top = `${p_top - t_height}px`;
        const desired_absolute_arrow_x = p_left + p_width / 2 - a_width / 2;
        arrow_ref.current.style.left = `${(t_width - a_width) / 2}px`;
    // it is one pixel off for some reason
    }, [
        tooltip_ref,
        parent_ref,
        arrow_ref,
        windowSize,
        is_active_click,
        is_active_hover
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dropdown inline-flex w-fit max-w-full items-center",
        ref: parent_ref,
        onMouseLeave: ()=>setIsActiveHover(false),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-trigger max-w-full flex-grow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "max-w-full flex-grow cursor-pointer",
                    "aria-haspopup": "true",
                    "aria-controls": "dropdown-menu4",
                    onClick: props.disable_click ? undefined : (e)=>{
                        e.preventDefault();
                        setIsActiveClick(true);
                    },
                    onMouseEnter: ()=>setIsActiveHover(true),
                    children: props.children
                })
            }),
            props.tooltip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _classnamesDefault.default)("has-text-centered absolute z-[1003] mb-2 flex h-max w-max max-w-[15rem] overflow-auto rounded-sm p-2 text-xs font-semibold drop-shadow-xl transition-opacity sm:max-h-[24rem] sm:max-w-[24rem] sm:!p-3 sm:text-sm", {
                        "pointer-events-none": !is_active_click,
                        "tooltip-v2": props.style === "Info",
                        "tooltip-v2--error": props.style === "Error",
                        "delay-500": is_active_hover && !is_active_click && !props.no_delay,
                        "delay-0": is_active_hover && !is_active_click && props.no_delay,
                        "transition-none": is_active_click,
                        "invisible opacity-0": !is_active_click && !is_active_hover,
                        "visible opacity-[97%]": is_active_click || is_active_hover
                    }),
                    id: "dropdown-menu4",
                    role: "menu",
                    ref: tooltip_ref,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "overflow-auto",
                            children: props.tooltip
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "tooltip-arrow",
                            ref: arrow_ref
                        })
                    ]
                }), document.body)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-dom":"fODdr","../hooks/use_outside_alerter":"d0yYg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"22irs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateBookmarkedList", ()=>EventTemplateBookmarkedList);
var _jsxRuntime = require("react/jsx-runtime");
var _trpc = require("../../../utils/trpc");
var _useServerId = require("../hooks/use_server_id");
var _eventTemplateList = require("./event_template_list");
var _eventTemplateModalRow = require("./event_template_modal_row");
var _luxon = require("luxon");
var _removingThrobber = require("../../removing_throbber");
function EventTemplateBookmarkedList(props) {
    const server_id = (0, _useServerId.useServerId)();
    const event_list_query = props.event_list_query;
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).event_template.deleteBookmark.useMutation({
        onSuccess: (data)=>{
            context.event_template.getBookmarkedList.invalidate({
                guild_id: server_id
            });
        }
    });
    if (!event_list_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateList.PlaceholderRow), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex  items-center gap-2",
            children: [
                "Loading ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
            ]
        })
    });
    const filtered_templates = props.search ? event_list_query.data.filter((item)=>item.name.toLowerCase().includes(props.search.toLowerCase())) : event_list_query.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-1",
        children: filtered_templates.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-1",
            children: filtered_templates.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalRow.EventTemplateModalRow), {
                    item_id: item.id,
                    bookmark_id: item.id,
                    item_name: item.name,
                    author_id: item.author_id,
                    created_at: (0, _luxon.DateTime).fromJSDate(new Date(item.created_at)),
                    selected_template: props.selected_template,
                    onUseClick: ()=>props.onUseClick({
                            template_id: item.id,
                            name: item.name
                        }),
                    onRowClick: ()=>{
                        props.setSelectedTemplate({
                            template_id: item.id,
                            name: item.name
                        });
                    },
                    onFavoriteClicked: ()=>{
                        mutation.mutate({
                            template_id: item.id
                        });
                    },
                    onInfoClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        props.setSelectedInfoTemplate({
                            template_id: item.id,
                            name: item.json.event_name
                        });
                    },
                    is_event_list: false
                }, item.id))
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateList.PlaceholderRow), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full px-4 text-left text-content-secondary",
                children: "No favorited templates"
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../../utils/trpc":"dyYvM","../hooks/use_server_id":"d0sLH","./event_template_list":"dGzHv","./event_template_modal_row":"6YsUq","luxon":"fLWpi","../../removing_throbber":"TmURk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dGzHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateList", ()=>EventTemplateList);
parcelHelpers.export(exports, "PlaceholderRow", ()=>PlaceholderRow);
var _jsxRuntime = require("react/jsx-runtime");
var _reactVirtual = require("@tanstack/react-virtual");
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var _removingThrobber = require("../../removing_throbber");
function EventTemplateList(props) {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const { isFetchingNextPage, hasNextPage, fetchNextPage, isFetching, isLoading, isRefetching } = props.list_query;
    const items = props.list_query.data?.pages.flatMap((val)=>val.items) ?? [];
    const parentRef = (0, _react.useRef)();
    const virtualizer = (0, _reactVirtual.useVirtualizer)({
        count: hasNextPage ? items.length + 1 : items.length,
        getScrollElement: ()=>parentRef.current,
        estimateSize: ()=>64,
        overscan: 3
    });
    (0, _react.useEffect)(()=>{
        if (inView) fetchNextPage();
    }, [
        inView
    ]);
    // const is_initial_fetch = !(!isRefetching || isFetchingNextPage);
    const is_initial_fetch = isLoading || isRefetching && !isFetchingNextPage;
    if (is_initial_fetch) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex  items-center gap-2",
                children: [
                    "Loading ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                ]
            })
        })
    });
    if (!isFetching && items.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-full px-4 text-left text-content-secondary",
            children: "No events found"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: parentRef,
        className: "w-full overflow-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                height: `${virtualizer.getTotalSize()}px`,
                width: "100%",
                position: "relative"
            },
            children: [
                virtualizer.getVirtualItems().map((virtualRow)=>{
                    const isLoaderRow = virtualRow.index > items.length - 1;
                    const post = items[virtualRow.index];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            transform: `translateY(${virtualRow.start}px)`
                        },
                        children: isLoaderRow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: ref,
                                className: "flex h-full items-center gap-2",
                                children: [
                                    "Loading ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                                ]
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            "data-index": virtualRow.index,
                            ref: virtualizer.measureElement,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "pb-1",
                                    children: props.itemCreator(post)
                                }),
                                !hasNextPage && virtualRow.index === items.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                                    children: "End of Events"
                                })
                            ]
                        })
                    }, virtualRow.index);
                }),
                !isFetching && items.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                    children: "End of Events"
                })
            ]
        })
    });
}
function PlaceholderRow(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col items-center justify-center gap-0 border border-base-light bg-base-dark py-3 text-sesh-dark",
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@tanstack/react-virtual":"aXI26","react":"IMRgT","react-intersection-observer":"c8WqK","../../removing_throbber":"TmURk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aXI26":[function(require,module,exports,__globalThis) {
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVirtualizer", ()=>useVirtualizer);
parcelHelpers.export(exports, "useWindowVirtualizer", ()=>useWindowVirtualizer);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _react = require("react");
var _virtualCore = require("@tanstack/virtual-core");
parcelHelpers.exportAll(_virtualCore, exports);
//
var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
function useVirtualizerBase(options) {
    var rerender = _react.useReducer(function() {
        return {};
    }, {})[1];
    var resolvedOptions = (0, _rollupPluginBabelHelpersEsmJs.extends)({}, options, {
        onChange: function onChange(instance) {
            rerender();
            options.onChange == null || options.onChange(instance);
        }
    });
    var _React$useState = _react.useState(function() {
        return new (0, _virtualCore.Virtualizer)(resolvedOptions);
    }), instance = _React$useState[0];
    instance.setOptions(resolvedOptions);
    _react.useEffect(function() {
        return instance._didMount();
    }, []);
    useIsomorphicLayoutEffect(function() {
        return instance._willUpdate();
    });
    return instance;
}
function useVirtualizer(options) {
    return useVirtualizerBase((0, _rollupPluginBabelHelpersEsmJs.extends)({
        observeElementRect: (0, _virtualCore.observeElementRect),
        observeElementOffset: (0, _virtualCore.observeElementOffset),
        scrollToFn: (0, _virtualCore.elementScroll)
    }, options));
}
function useWindowVirtualizer(options) {
    return useVirtualizerBase((0, _rollupPluginBabelHelpersEsmJs.extends)({
        getScrollElement: function getScrollElement() {
            return typeof document !== 'undefined' ? window : null;
        },
        observeElementRect: (0, _virtualCore.observeWindowRect),
        observeElementOffset: (0, _virtualCore.observeWindowOffset),
        scrollToFn: (0, _virtualCore.windowScroll)
    }, options));
}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"fsVvj","react":"IMRgT","@tanstack/virtual-core":"essQc","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fsVvj":[function(require,module,exports,__globalThis) {
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extends", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"essQc":[function(require,module,exports,__globalThis) {
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "approxEqual", ()=>(0, _utilsEsmJs.approxEqual));
parcelHelpers.export(exports, "memo", ()=>(0, _utilsEsmJs.memo));
parcelHelpers.export(exports, "notUndefined", ()=>(0, _utilsEsmJs.notUndefined));
parcelHelpers.export(exports, "Virtualizer", ()=>Virtualizer);
parcelHelpers.export(exports, "defaultKeyExtractor", ()=>defaultKeyExtractor);
parcelHelpers.export(exports, "defaultRangeExtractor", ()=>defaultRangeExtractor);
parcelHelpers.export(exports, "elementScroll", ()=>elementScroll);
parcelHelpers.export(exports, "measureElement", ()=>measureElement);
parcelHelpers.export(exports, "observeElementOffset", ()=>observeElementOffset);
parcelHelpers.export(exports, "observeElementRect", ()=>observeElementRect);
parcelHelpers.export(exports, "observeWindowOffset", ()=>observeWindowOffset);
parcelHelpers.export(exports, "observeWindowRect", ()=>observeWindowRect);
parcelHelpers.export(exports, "windowScroll", ()=>windowScroll);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
//
//
var defaultKeyExtractor = function defaultKeyExtractor(index) {
    return index;
};
var defaultRangeExtractor = function defaultRangeExtractor(range) {
    var start = Math.max(range.startIndex - range.overscan, 0);
    var end = Math.min(range.endIndex + range.overscan, range.count - 1);
    var arr = [];
    for(var _i = start; _i <= end; _i++)arr.push(_i);
    return arr;
};
var observeElementRect = function observeElementRect(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler(rect) {
        var width = rect.width, height = rect.height;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    var observer = new ResizeObserver(function(entries) {
        var entry = entries[0];
        if (entry != null && entry.borderBoxSize) {
            var box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: 'border-box'
    });
    return function() {
        observer.unobserve(element);
    };
};
var observeWindowRect = function observeWindowRect(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener('resize', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('resize', handler);
    };
};
var observeElementOffset = function observeElementOffset(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb(element[instance.options.horizontal ? 'scrollLeft' : 'scrollTop']);
    };
    handler();
    element.addEventListener('scroll', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('scroll', handler);
    };
};
var observeWindowOffset = function observeWindowOffset(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb(element[instance.options.horizontal ? 'scrollX' : 'scrollY']);
    };
    handler();
    element.addEventListener('scroll', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('scroll', handler);
    };
};
var measureElement = function measureElement(element, entry, instance) {
    if (entry != null && entry.borderBoxSize) {
        var box = entry.borderBoxSize[0];
        if (box) {
            var size = Math.round(box[instance.options.horizontal ? 'inlineSize' : 'blockSize']);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? 'width' : 'height']);
};
var windowScroll = function windowScroll(offset, _ref, instance) {
    var _instance$scrollEleme, _instance$scrollEleme2;
    var _ref$adjustments = _ref.adjustments, adjustments = _ref$adjustments === void 0 ? 0 : _ref$adjustments, behavior = _ref.behavior;
    var toOffset = offset + adjustments;
    (_instance$scrollEleme = instance.scrollElement) == null || _instance$scrollEleme.scrollTo == null || _instance$scrollEleme.scrollTo((_instance$scrollEleme2 = {}, _instance$scrollEleme2[instance.options.horizontal ? 'left' : 'top'] = toOffset, _instance$scrollEleme2.behavior = behavior, _instance$scrollEleme2));
};
var elementScroll = function elementScroll(offset, _ref2, instance) {
    var _instance$scrollEleme3, _instance$scrollEleme4;
    var _ref2$adjustments = _ref2.adjustments, adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments, behavior = _ref2.behavior;
    var toOffset = offset + adjustments;
    (_instance$scrollEleme3 = instance.scrollElement) == null || _instance$scrollEleme3.scrollTo == null || _instance$scrollEleme3.scrollTo((_instance$scrollEleme4 = {}, _instance$scrollEleme4[instance.options.horizontal ? 'left' : 'top'] = toOffset, _instance$scrollEleme4.behavior = behavior, _instance$scrollEleme4));
};
var Virtualizer = function Virtualizer(_opts) {
    var _this = this;
    this.unsubs = [];
    this.scrollElement = null;
    this.isScrolling = false;
    this.isScrollingTimeoutId = null;
    this.scrollToIndexTimeoutId = null;
    this.measurementsCache = [];
    this.itemSizeCache = new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.measureElementCache = new Map();
    this.observer = function() {
        var _ro = null;
        var get = function get() {
            if (_ro) return _ro;
            else if (typeof ResizeObserver !== 'undefined') return _ro = new ResizeObserver(function(entries) {
                entries.forEach(function(entry) {
                    _this._measureElement(entry.target, entry);
                });
            });
            else return null;
        };
        return {
            disconnect: function disconnect() {
                var _get;
                return (_get = get()) == null ? void 0 : _get.disconnect();
            },
            observe: function observe(target) {
                var _get2;
                return (_get2 = get()) == null ? void 0 : _get2.observe(target, {
                    box: 'border-box'
                });
            },
            unobserve: function unobserve(target) {
                var _get3;
                return (_get3 = get()) == null ? void 0 : _get3.unobserve(target);
            }
        };
    }();
    this.range = {
        startIndex: 0,
        endIndex: 0
    };
    this.setOptions = function(opts) {
        Object.entries(opts).forEach(function(_ref3) {
            var key = _ref3[0], value = _ref3[1];
            if (typeof value === 'undefined') delete opts[key];
        });
        _this.options = (0, _rollupPluginBabelHelpersEsmJs.extends)({
            debug: false,
            initialOffset: 0,
            overscan: 1,
            paddingStart: 0,
            paddingEnd: 0,
            scrollPaddingStart: 0,
            scrollPaddingEnd: 0,
            horizontal: false,
            getItemKey: defaultKeyExtractor,
            rangeExtractor: defaultRangeExtractor,
            onChange: function onChange() {},
            measureElement: measureElement,
            initialRect: {
                width: 0,
                height: 0
            },
            scrollMargin: 0,
            scrollingDelay: 150,
            indexAttribute: 'data-index',
            initialMeasurementsCache: [],
            lanes: 1
        }, opts);
    };
    this.notify = function() {
        _this.options.onChange == null || _this.options.onChange(_this);
    };
    this.cleanup = function() {
        _this.unsubs.filter(Boolean).forEach(function(d) {
            return d();
        });
        _this.unsubs = [];
        _this.scrollElement = null;
    };
    this._didMount = function() {
        _this.measureElementCache.forEach(_this.observer.observe);
        return function() {
            _this.observer.disconnect();
            _this.cleanup();
        };
    };
    this._willUpdate = function() {
        var scrollElement = _this.options.getScrollElement();
        if (_this.scrollElement !== scrollElement) {
            _this.cleanup();
            _this.scrollElement = scrollElement;
            _this._scrollToOffset(_this.scrollOffset, {
                adjustments: undefined,
                behavior: undefined
            });
            _this.unsubs.push(_this.options.observeElementRect(_this, function(rect) {
                var prev = _this.scrollRect;
                _this.scrollRect = rect;
                if (_this.options.horizontal ? rect.width !== prev.width : rect.height !== prev.height) _this.maybeNotify();
            }));
            _this.unsubs.push(_this.options.observeElementOffset(_this, function(offset) {
                _this.scrollAdjustments = 0;
                if (_this.scrollOffset === offset) return;
                if (_this.isScrollingTimeoutId !== null) {
                    clearTimeout(_this.isScrollingTimeoutId);
                    _this.isScrollingTimeoutId = null;
                }
                _this.isScrolling = true;
                _this.scrollDirection = _this.scrollOffset < offset ? 'forward' : 'backward';
                _this.scrollOffset = offset;
                _this.maybeNotify();
                _this.isScrollingTimeoutId = setTimeout(function() {
                    _this.isScrollingTimeoutId = null;
                    _this.isScrolling = false;
                    _this.scrollDirection = null;
                    _this.maybeNotify();
                }, _this.options.scrollingDelay);
            }));
        }
    };
    this.getSize = function() {
        return _this.scrollRect[_this.options.horizontal ? 'width' : 'height'];
    };
    this.memoOptions = (0, _utilsEsmJs.memo)(function() {
        return [
            _this.options.count,
            _this.options.paddingStart,
            _this.options.scrollMargin,
            _this.options.getItemKey
        ];
    }, function(count, paddingStart, scrollMargin, getItemKey) {
        _this.pendingMeasuredCacheIndexes = [];
        return {
            count: count,
            paddingStart: paddingStart,
            scrollMargin: scrollMargin,
            getItemKey: getItemKey
        };
    }, {
        key: false
    });
    this.getFurthestMeasurement = function(measurements, index) {
        var furthestMeasurementsFound = new Map();
        var furthestMeasurements = new Map();
        for(var m = index - 1; m >= 0; m--){
            var measurement = measurements[m];
            if (furthestMeasurementsFound.has(measurement.lane)) continue;
            var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
            if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
            else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
            if (furthestMeasurementsFound.size === _this.options.lanes) break;
        }
        return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function(a, b) {
            return a.end - b.end;
        })[0] : undefined;
    };
    this.getMeasurements = (0, _utilsEsmJs.memo)(function() {
        return [
            _this.memoOptions(),
            _this.itemSizeCache
        ];
    }, function(_ref4, itemSizeCache) {
        var count = _ref4.count, paddingStart = _ref4.paddingStart, scrollMargin = _ref4.scrollMargin, getItemKey = _ref4.getItemKey;
        var min = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _this.pendingMeasuredCacheIndexes) : 0;
        _this.pendingMeasuredCacheIndexes = [];
        var measurements = _this.measurementsCache.slice(0, min);
        for(var _i2 = min; _i2 < count; _i2++){
            var key = getItemKey(_i2);
            var furthestMeasurement = _this.options.lanes === 1 ? measurements[_i2 - 1] : _this.getFurthestMeasurement(measurements, _i2);
            var start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
            var measuredSize = itemSizeCache.get(key);
            var size = typeof measuredSize === 'number' ? measuredSize : _this.options.estimateSize(_i2);
            var end = start + size;
            var lane = furthestMeasurement ? furthestMeasurement.lane : _i2 % _this.options.lanes;
            measurements[_i2] = {
                index: _i2,
                start: start,
                size: size,
                end: end,
                key: key,
                lane: lane
            };
        }
        _this.measurementsCache = measurements;
        return measurements;
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.calculateRange = (0, _utilsEsmJs.memo)(function() {
        return [
            _this.getMeasurements(),
            _this.getSize(),
            _this.scrollOffset
        ];
    }, function(measurements, outerSize, scrollOffset) {
        return _this.range = calculateRange({
            measurements: measurements,
            outerSize: outerSize,
            scrollOffset: scrollOffset
        });
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.maybeNotify = (0, _utilsEsmJs.memo)(function() {
        var range = _this.calculateRange();
        return [
            range.startIndex,
            range.endIndex,
            _this.isScrolling
        ];
    }, function() {
        _this.notify();
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        },
        initialDeps: [
            this.range.startIndex,
            this.range.endIndex,
            this.isScrolling
        ]
    });
    this.getIndexes = (0, _utilsEsmJs.memo)(function() {
        return [
            _this.options.rangeExtractor,
            _this.calculateRange(),
            _this.options.overscan,
            _this.options.count
        ];
    }, function(rangeExtractor, range, overscan, count) {
        return rangeExtractor((0, _rollupPluginBabelHelpersEsmJs.extends)({}, range, {
            overscan: overscan,
            count: count
        }));
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.indexFromElement = function(node) {
        var attributeName = _this.options.indexAttribute;
        var indexStr = node.getAttribute(attributeName);
        if (!indexStr) {
            console.warn("Missing attribute name '" + attributeName + "={index}' on measured element.");
            return -1;
        }
        return parseInt(indexStr, 10);
    };
    this._measureElement = function(node, entry) {
        var _this$itemSizeCache$g;
        var index = _this.indexFromElement(node);
        var item = _this.measurementsCache[index];
        if (!item) return;
        var prevNode = _this.measureElementCache.get(item.key);
        if (!node.isConnected) {
            _this.observer.unobserve(node);
            if (node === prevNode) _this.measureElementCache["delete"](item.key);
            return;
        }
        if (prevNode !== node) {
            if (prevNode) _this.observer.unobserve(prevNode);
            _this.observer.observe(node);
            _this.measureElementCache.set(item.key, node);
        }
        var measuredItemSize = _this.options.measureElement(node, entry, _this);
        var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) != null ? _this$itemSizeCache$g : item.size;
        var delta = measuredItemSize - itemSize;
        if (delta !== 0) {
            if (item.start < _this.scrollOffset) _this._scrollToOffset(_this.scrollOffset, {
                adjustments: _this.scrollAdjustments += delta,
                behavior: undefined
            });
            _this.pendingMeasuredCacheIndexes.push(index);
            _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, measuredItemSize));
            _this.notify();
        }
    };
    this.measureElement = function(node) {
        if (!node) return;
        _this._measureElement(node, undefined);
    };
    this.getVirtualItems = (0, _utilsEsmJs.memo)(function() {
        return [
            _this.getIndexes(),
            _this.getMeasurements()
        ];
    }, function(indexes, measurements) {
        var virtualItems = [];
        for(var k = 0, len = indexes.length; k < len; k++){
            var _i3 = indexes[k];
            var measurement = measurements[_i3];
            virtualItems.push(measurement);
        }
        return virtualItems;
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.getVirtualItemForOffset = function(offset) {
        var measurements = _this.getMeasurements();
        return (0, _utilsEsmJs.notUndefined)(measurements[findNearestBinarySearch(0, measurements.length - 1, function(index) {
            return (0, _utilsEsmJs.notUndefined)(measurements[index]).start;
        }, offset)]);
    };
    this.getOffsetForAlignment = function(toOffset, align) {
        var size = _this.getSize();
        if (align === 'auto') {
            if (toOffset <= _this.scrollOffset) align = 'start';
            else if (toOffset >= _this.scrollOffset + size) align = 'end';
            else align = 'start';
        }
        if (align === 'start') toOffset;
        else if (align === 'end') toOffset = toOffset - size;
        else if (align === 'center') toOffset = toOffset - size / 2;
        var scrollSizeProp = _this.options.horizontal ? 'scrollWidth' : 'scrollHeight';
        var scrollSize = _this.scrollElement ? 'document' in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
        var maxOffset = scrollSize - _this.getSize();
        return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = function(index, align) {
        if (align === void 0) align = 'auto';
        index = Math.max(0, Math.min(index, _this.options.count - 1));
        var measurement = (0, _utilsEsmJs.notUndefined)(_this.getMeasurements()[index]);
        if (align === 'auto') {
            if (measurement.end >= _this.scrollOffset + _this.getSize() - _this.options.scrollPaddingEnd) align = 'end';
            else if (measurement.start <= _this.scrollOffset + _this.options.scrollPaddingStart) align = 'start';
            else return [
                _this.scrollOffset,
                align
            ];
        }
        var toOffset = align === 'end' ? measurement.end + _this.options.scrollPaddingEnd : measurement.start - _this.options.scrollPaddingStart;
        return [
            _this.getOffsetForAlignment(toOffset, align),
            align
        ];
    };
    this.isDynamicMode = function() {
        return _this.measureElementCache.size > 0;
    };
    this.cancelScrollToIndex = function() {
        if (_this.scrollToIndexTimeoutId !== null) {
            clearTimeout(_this.scrollToIndexTimeoutId);
            _this.scrollToIndexTimeoutId = null;
        }
    };
    this.scrollToOffset = function(toOffset, _temp) {
        var _ref5 = _temp === void 0 ? {} : _temp, _ref5$align = _ref5.align, align = _ref5$align === void 0 ? 'start' : _ref5$align, behavior = _ref5.behavior;
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
            adjustments: undefined,
            behavior: behavior
        });
    };
    this.scrollToIndex = function(index, _temp2) {
        var _ref6 = _temp2 === void 0 ? {} : _temp2, _ref6$align = _ref6.align, initialAlign = _ref6$align === void 0 ? 'auto' : _ref6$align, behavior = _ref6.behavior;
        index = Math.max(0, Math.min(index, _this.options.count - 1));
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        var _this$getOffsetForInd = _this.getOffsetForIndex(index, initialAlign), toOffset = _this$getOffsetForInd[0], align = _this$getOffsetForInd[1];
        _this._scrollToOffset(toOffset, {
            adjustments: undefined,
            behavior: behavior
        });
        if (behavior !== 'smooth' && _this.isDynamicMode()) _this.scrollToIndexTimeoutId = setTimeout(function() {
            _this.scrollToIndexTimeoutId = null;
            var elementInDOM = _this.measureElementCache.has(_this.options.getItemKey(index));
            if (elementInDOM) {
                var _this$getOffsetForInd2 = _this.getOffsetForIndex(index, align), _toOffset = _this$getOffsetForInd2[0];
                if (!(0, _utilsEsmJs.approxEqual)(_toOffset, _this.scrollOffset)) _this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            } else _this.scrollToIndex(index, {
                align: align,
                behavior: behavior
            });
        });
    };
    this.scrollBy = function(delta, _temp3) {
        var _ref7 = _temp3 === void 0 ? {} : _temp3, behavior = _ref7.behavior;
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        _this._scrollToOffset(_this.scrollOffset + delta, {
            adjustments: undefined,
            behavior: behavior
        });
    };
    this.getTotalSize = function() {
        var _this$getMeasurements;
        return (((_this$getMeasurements = _this.getMeasurements()[_this.options.count - 1]) == null ? void 0 : _this$getMeasurements.end) || _this.options.paddingStart) - _this.options.scrollMargin + _this.options.paddingEnd;
    };
    this._scrollToOffset = function(offset, _ref8) {
        var adjustments = _ref8.adjustments, behavior = _ref8.behavior;
        _this.options.scrollToFn(offset, {
            behavior: behavior,
            adjustments: adjustments
        }, _this);
    };
    this.measure = function() {
        _this.itemSizeCache = new Map();
        _this.notify();
    };
    this.setOptions(_opts);
    this.scrollRect = this.options.initialRect;
    this.scrollOffset = this.options.initialOffset;
    this.measurementsCache = this.options.initialMeasurementsCache;
    this.measurementsCache.forEach(function(item) {
        _this.itemSizeCache.set(item.key, item.size);
    });
    this.maybeNotify();
};
var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
    while(low <= high){
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function calculateRange(_ref9) {
    var measurements = _ref9.measurements, outerSize = _ref9.outerSize, scrollOffset = _ref9.scrollOffset;
    var count = measurements.length - 1;
    var getOffset = function getOffset(index) {
        return measurements[index].start;
    };
    var startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
    var endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"5qh6v","./utils.esm.js":"HRXVQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5qh6v":[function(require,module,exports,__globalThis) {
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extends", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"HRXVQ":[function(require,module,exports,__globalThis) {
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "approxEqual", ()=>approxEqual);
parcelHelpers.export(exports, "memo", ()=>memo);
parcelHelpers.export(exports, "notUndefined", ()=>notUndefined);
function memo(getDeps, fn, opts) {
    var _opts$initialDeps;
    var deps = (_opts$initialDeps = opts.initialDeps) != null ? _opts$initialDeps : [];
    var result;
    return function() {
        var depTime;
        if (opts.key && opts.debug != null && opts.debug()) depTime = Date.now();
        var newDeps = getDeps();
        var depsChanged = newDeps.length !== deps.length || newDeps.some(function(dep, index) {
            return deps[index] !== dep;
        });
        if (!depsChanged) return result;
        deps = newDeps;
        var resultTime;
        if (opts.key && opts.debug != null && opts.debug()) resultTime = Date.now();
        result = fn.apply(void 0, newDeps);
        if (opts.key && opts.debug != null && opts.debug()) {
            var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            var resultFpsPercentage = resultEndTime / 16;
            var pad = function pad(str, num) {
                str = String(str);
                while(str.length < num)str = ' ' + str;
                return str;
            };
            console.info("%c\u23F1 " + pad(resultEndTime, 5) + " /" + pad(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
        }
        opts == null || opts.onChange == null || opts.onChange(result);
        return result;
    };
}
function notUndefined(value, msg) {
    if (value === undefined) throw new Error("Unexpected undefined" + (msg ? ": " + msg : ''));
    else return value;
}
var approxEqual = function approxEqual(a, b) {
    return Math.abs(a - b) < 1;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c8WqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InView", ()=>InView);
parcelHelpers.export(exports, "defaultFallbackInView", ()=>defaultFallbackInView);
parcelHelpers.export(exports, "observe", ()=>observe);
parcelHelpers.export(exports, "useInView", ()=>useInView);
var _react = require("react");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function defaultFallbackInView(inView) {
    unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function getRootId(root) {
    if (!root) return '0';
    if (RootIds.has(root)) return RootIds.get(root);
    rootId += 1;
    RootIds.set(root, rootId.toString());
    return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
    }).toString();
}
function createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = optionsToId(options);
    var instance = observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                });
                // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options);
        // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function observe(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {
        // Nothing to cleanup
        };
    }
    // An observer with the same options can be reused, so lets use this fact
    var _createObserver = createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements;
    // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            observerMap["delete"](id);
        }
    };
}
var _excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var InView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = observe(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = _objectWithoutPropertiesLoose(_this$props2, _excluded);
        return _react.createElement(as || 'div', _extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}(_react.Component);
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function useInView(_temp) {
    var _state$entry;
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView, onChange = _ref.onChange;
    var _React$useState = _react.useState(null), ref = _React$useState[0], setRef = _React$useState[1];
    var callback = _react.useRef();
    var _React$useState2 = _react.useState({
        inView: !!initialInView,
        entry: undefined
    }), state = _React$useState2[0], setState = _React$useState2[1];
    // Store the onChange callback in a `ref`, so we can access the latest instance
    // inside the `useEffect`, but without triggering a rerender.
    callback.current = onChange;
    _react.useEffect(function() {
        // Ensure we have node ref, and that we shouldn't skip observing
        if (skip || !ref) return;
        var unobserve;
        unobserve = observe(ref, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve();
                unobserve = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
        return function() {
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    var entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
    var previousEntryTarget = _react.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: undefined
        });
    }
    var result = [
        setRef,
        state.inView,
        state.entry
    ];
    // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6YsUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateModalRow", ()=>EventTemplateModalRow);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _trpc = require("../../../utils/trpc");
var _removingThrobber = require("../../removing_throbber");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _boxItem = require("../box_item");
var _disabler = require("../disabler");
var _useIsAdmin = require("../hooks/use_is_admin");
var _useServerId = require("../hooks/use_server_id");
var _simpleMemberDisplayName = require("../member_display_name/simple_member_display_name");
var _simpleMemberDisplayNameDefault = parcelHelpers.interopDefault(_simpleMemberDisplayName);
var _withTooltipPortaled = require("../tooltips/with_tooltip_portaled");
function EventTemplateModalRow(props) {
    const is_bookmarked = !!props.bookmark_id;
    const author_verb = props.is_event_list ? "Created" : "Favorited";
    const server_id = (0, _useServerId.useServerId)();
    const context = (0, _trpc.trpc).useContext();
    const delete_bookmark_mutation = (0, _trpc.trpc).event_template.deleteBookmark.useMutation({
        onSuccess: (data)=>{
            context.event_template.getBookmarkedList.setData((old_data)=>{
                return old_data.filter((val)=>val.id !== props.bookmark_id);
            }, {
                guild_id: server_id
            });
        }
    });
    const isAdmin = (0, _useIsAdmin.useIsAdmin)();
    const is_selected = props.selected_template?.message_id === props.item_id || props.selected_template?.template_id === props.item_id;
    const should_force_show_buttons = is_selected || delete_bookmark_mutation.isLoading;
    const mobile_responsive_class_names = (0, _classnamesDefault.default)({
        block: is_selected,
        "hidden group-hover:block sm:block": !is_selected
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
        disabled: delete_bookmark_mutation.isLoading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
            bgColor: "dark",
            className: "group cursor-pointer",
            onClick: props.onRowClick,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-11/12 flex-col text-content-primary-darker",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex w-full flex-col items-center gap-2 sm:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "overflow-hidden overflow-ellipsis whitespace-nowrap text-lg font-bold text-content-primary",
                                        title: props.item_name,
                                        children: props.item_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-xs sm:ml-auto",
                                        children: props.info_text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col gap-2 text-xs sm:flex-row sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _withTooltipPortaled.WithTooltipPortaled), {
                                            tooltip: props.created_at.toLocaleString({
                                                dateStyle: "full",
                                                timeStyle: "medium"
                                            }),
                                            style: "Info",
                                            children: [
                                                author_verb,
                                                " by",
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleMemberDisplayNameDefault.default), {
                                                    user_id: props.author_id
                                                }),
                                                " ",
                                                props.created_at.toRelative()
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)(mobile_responsive_class_names, "ml-auto"),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: (0, _classnamesDefault.default)("ml-auto flex items-center gap-4 text-sm transition-all group-hover:opacity-100", {
                                                "opacity-100": should_force_show_buttons,
                                                "opacity-0": !should_force_show_buttons
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                                        className: (0, _classnamesDefault.default)("ml-auto w-fit", {
                                                            "text-warning hover:text-warning-hover": !!props.bookmark_id
                                                        }),
                                                        disabled: !isAdmin?.data || !is_bookmarked && props.are_bookmarks_full,
                                                        onClick: ()=>{
                                                            props.bookmark_id ? delete_bookmark_mutation.mutate({
                                                                template_id: props.bookmark_id
                                                            }) : props.onFavoriteClicked();
                                                        },
                                                        hide_arrow: true,
                                                        title: props.are_bookmarks_full ? "Favorites full" : undefined,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: delete_bookmark_mutation.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}) : props.bookmark_id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                            className: "fas fa-trash"
                                                                        })
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                            className: "fas fa-star"
                                                                        })
                                                                    })
                                                                }, delete_bookmark_mutation.isLoading ? "removing" : "not_removing"),
                                                                props.bookmark_id ? props.is_event_list ? "Unfavorite" : "Delete" : "Favorite"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modifySettingsButton.ModifySettingsButton), {
                                                        className: "ml-auto w-fit",
                                                        onClick: props.onUseClick,
                                                        hide_arrow: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-check"
                                                            }),
                                                            " Use"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _classnamesDefault.default)(mobile_responsive_class_names, "ml-auto"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _classnamesDefault.default)("self-center text-content-primary transition-all hover:!opacity-100 group-hover:opacity-50", {
                                "opacity-100": should_force_show_buttons,
                                "opacity-0": !should_force_show_buttons
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: props.onInfoClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-info-circle"
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}
function HoverableStarEmpty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
        disable_click: !props.disable_hover,
        tooltip: `Add to server favorites${props.disable_hover ? " (requires Manage Sesh permissions)" : ""}`,
        style: "Info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("fa-stack w-8", {
                "group/star": !props.disable_hover
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "far fa-star fa-stack-1x opacity-100 transition-all group-hover/star:opacity-0"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-star fa-stack-1x opacity-0 transition-opacity group-hover/star:opacity-100"
                })
            ]
        })
    });
}
function HoverableStarFull(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
        disable_click: !props.disable_hover,
        tooltip: `Unfavorite from server${props.disable_hover ? " (requires Manage Sesh permissions)" : ""}`,
        style: "Info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("fa-stack w-8", {
                "group/star": !props.disable_hover
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-star fa-stack-1x opacity-100 transition-all group-hover/star:opacity-0"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "far fa-star fa-stack-1x opacity-0 transition-opacity group-hover/star:opacity-100"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../../utils/trpc":"dyYvM","../../removing_throbber":"TmURk","../base_components/modify_settings_button":"kbhTg","../box_item":"gTVlB","../disabler":"hF5sC","../hooks/use_is_admin":"dsdqX","../hooks/use_server_id":"d0sLH","../member_display_name/simple_member_display_name":"hXYPB","../tooltips/with_tooltip_portaled":"6LBvw","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gTVlB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoxItem", ()=>BoxItem);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function BoxItem(props) {
    let { bgColor, padding, customRef, no_border, ...rest } = props;
    padding = props.padding ?? "p-4";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...rest,
        ref: props.customRef,
        className: (0, _classnamesDefault.default)("flex", {
            border: !no_border,
            "border-base-dark bg-base-semidark": props.bgColor === "semidark",
            "border-base-light bg-base-dark": props.bgColor === "dark",
            "p-0": padding === "p-0",
            "p-1": padding === "p-1",
            "p-2": padding === "p-2",
            "p-3": padding === "p-3",
            "p-4": padding === "p-4"
        }, props.className),
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hF5sC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Be careful with this component. It *does not* disable keyboard events (i.e. tabbing and typing)
parcelHelpers.export(exports, "Disabler", ()=>Disabler);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Disabler(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)({
            "disable-children-pointer-events cursor-not-allowed opacity-70": props.disabled
        }),
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hXYPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SimpleMemberDisplayName);
parcelHelpers.export(exports, "SimpleMemberDisplayNameWithoutCache", ()=>SimpleMemberDisplayNameWithoutCache);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _useGuildMembers = require("../hooks/use_guild_members");
function SimpleMemberDisplayName(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const members_query = (0, _useGuildMembers.useGuildMemberQuery)(server_id, [
        props.user_id
    ]);
    const member = members_query?.members?.find((val)=>val.id === props.user_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleMemberDisplayNameWithoutCache, {
        member: member,
        ...props
    });
}
function SimpleMemberDisplayNameWithoutCache(props) {
    const { member } = props;
    const has_valid_discriminator = member?.discriminator && member.discriminator !== "0";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            props.include_avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "mr-1 inline-block align-text-bottom",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                    className: (0, _classnamesDefault.default)("image flex-shrink-0", {
                        "is-16x16": props.width === 16,
                        "is-24x24": !props.width || props.width === 24,
                        "is-32x32": props.width === 32
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "is-rounded",
                        src: member?.avatar_url ? `https://cdn.discordapp.com/${member.avatar_url}` : (0, _dashboardUtils.DashboardUtils).GetPlaceholderAvatarURL(props.user_id, 32),
                        width: props.width ?? 24,
                        height: props.width ?? 24
                    })
                })
            }),
            member ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    member.name,
                    has_valid_discriminator && // Add slight right padding so italic isnt cut off
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "pr-[2px] italic",
                        children: [
                            "#",
                            member.discriminator
                        ]
                    })
                ]
            }) : props.user_id
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../hooks/use_guild_members":"iK4oL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iK4oL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildMemberContext", ()=>GuildMemberContext);
parcelHelpers.export(exports, "useGuildMemberQuery", ()=>useGuildMemberQuery);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _trpc = require("../../../utils/trpc");
var _useGuildMemberCache = require("./use_guild_member_cache");
const GuildMemberContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useGuildMemberQuery(guild_id, ids) {
    const members_cache = (0, _useGuildMemberCache.useGuildMemberCache)();
    const members_for_guild = members_cache.getMembers(guild_id);
    const recordified_members = members_for_guild.reduce((acc, val)=>{
        acc[val.id] = val;
        return acc;
    }, {});
    const members_to_fetch = ids.filter((val)=>!recordified_members[val]);
    const members_query = (0, _trpc.trpc).members.get.useQuery({
        guild_id,
        ids: members_to_fetch
    }, {
        staleTime: Infinity,
        enabled: members_to_fetch.length > 0,
        onSuccess: (data)=>{
            members_cache.addMembers(guild_id, data);
        }
    });
    return {
        is_loading: members_query.fetchStatus === "fetching",
        members: ids.map((val)=>recordified_members[val]).filter((val)=>val)
    };
}

},{"react":"IMRgT","../../../utils/trpc":"dyYvM","./use_guild_member_cache":"fDOuW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fDOuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGuildMemberCache", ()=>useGuildMemberCache);
var _react = require("react");
var _useGuildMembers = require("./use_guild_members");
function useGuildMemberCache() {
    return (0, _react.useContext)((0, _useGuildMembers.GuildMemberContext));
}

},{"react":"IMRgT","./use_guild_members":"iK4oL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5aBGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExistingTemplateViewer", ()=>ExistingTemplateViewer);
parcelHelpers.export(exports, "StateTemplateViewer", ()=>StateTemplateViewer);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _constants = require("../../../../../../common/constants");
var _eventSerializationUtils = require("../../../../../../common/event_serialization_utils");
var _seshTypes = require("../../../../../../common/sesh_types");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _channelName = require("../channel_name");
var _useEventCreationContext = require("../hooks/use_event_creation_context");
var _useServerId = require("../hooks/use_server_id");
var _inlineEmoji = require("../inline_emoji");
var _eventRow = require("../listings_form/event/event_listing_form/event_row");
var _mentionsList = require("../server_reminders/mentions_list");
var _eventTemplateModalSelectedStateRow = require("./event_template_modal_selected_state_row");
var _eventTemplatePage = require("./event_template_page");
var _eventTemplateSaveFavoriteInput = require("./event_template_save_favorite_input");
function ExistingTemplateViewer(props) {
    const server_id = (0, _useServerId.useServerId)();
    const event_query = (0, _trpc.trpc).event_template.get.useQuery({
        guild_id: server_id,
        message_id: props.selected_template.message_id,
        template_id: props.selected_template.template_id
    }, {
        staleTime: Infinity
    });
    if (!event_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TemplateViewer, {
        json: event_query.data.json
    });
}
function StateTemplateViewer(props) {
    const event_context = (0, _useEventCreationContext.useEventCreationContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TemplateViewer, {
                json: (0, _eventSerializationUtils.eventCreationStateToTemplateData)(event_context.state)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 flex flex-col gap-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateSaveFavoriteInput.EventTemplateSaveFavoriteInput), {
                    initial_name: event_context.state.event_name,
                    onSaveSuccess: props.onClose,
                    is_full: props.is_full,
                    save_props: {
                        data: JSON.stringify((0, _eventSerializationUtils.eventCreationStateToTemplateData)(event_context.state))
                    },
                    label: "Save"
                })
            })
        ]
    });
}
function TemplateViewer(props) {
    const d = props.json;
    const start_time = d.start_time ? (0, _luxon.DateTime).fromJSDate(new Date(d.start_time)) : undefined;
    const end_time = d.duration_ms ? (0, _luxon.DateTime).fromJSDate(new Date(d.duration_ms)) : undefined;
    const emojis = d.rsvp_options.custom_options.map((val, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
            option: val
        }, idx));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-[384px] flex-col gap-1 overflow-auto border border-base-dark bg-base-semidark p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Name",
                value: d.event_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Start Time",
                value: start_time ? (0, _timeFormatUtils.time_format_utils).format_time_verbose_date_first(start_time) : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Duration",
                value: d.duration_ms ? (0, _timeFormatUtils.time_format_utils).formatDurationVerbose((0, _luxon.Duration).fromMillis(d.duration_ms)) : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Description",
                value: d.description ? d.description : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Channel",
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelName.ChannelName), {
                    channel_id: d.sent_channel_data.id
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Repeat",
                childs: d.rrule_str ? [
                    {
                        label: "Interval",
                        value: d.rrule_str ? (0, _eventRow.rruleToRepeatString)(d.rrule_str, start_time ?? (0, _luxon.DateTime).now()) : "None"
                    },
                    {
                        label: "Allow Maintain RSVP",
                        value: d.allow_maintain_repeat_rsvp.toString()
                    },
                    {
                        label: "Repeat Timezone",
                        value: d.event_timezone
                    }
                ] : [
                    {
                        label: "Enabled",
                        value: "false"
                    }
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "RSVP Options",
                value: emojis.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex gap-1",
                    children: emojis
                }) : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Color",
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.ColoredColor), {
                    value: d.color ?? (0, _constants.Constants).EMBED_COLOR
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Mentions on Create",
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex gap-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                        role_mention_ids: d.role_mentions_on_create,
                        user_mention_ids: d.user_mentions_on_create
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Role Restrictions",
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex gap-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                        role_mention_ids: d.eligible_role_ids,
                        user_mention_ids: []
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Hide Attendees",
                value: d.hide_attendees.toString()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Image URL",
                value: d.image_url
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Attendee Roles",
                childs: [
                    {
                        label: "Roles",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex gap-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                                role_mention_ids: d.attendee_role_data.role_ids,
                                user_mention_ids: []
                            })
                        })
                    },
                    {
                        label: "Role Add Time",
                        value: d.attendee_role_data.role_add_time === (0, _seshTypes.RoleOnRSVPAddTime).OnRSVP ? "RSVP" : "Event Start"
                    },
                    {
                        label: "Remove on End",
                        value: d.attendee_role_data.remove_on_end.toString()
                    }
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Thread Settings",
                childs: [
                    {
                        label: "Enabled",
                        value: Boolean(d.thread_settings).toString()
                    },
                    d.thread_settings ? {
                        label: "Thread Title",
                        value: d.thread_settings.name
                    } : undefined,
                    d.thread_settings ? {
                        label: "Auto Archive Duration",
                        value: (0, _seshTypes.SeshThreadAutoArchiveDuration)[d.thread_settings.auto_archive_duration]
                    } : undefined,
                    d.thread_settings ? {
                        label: "Join on RSVP",
                        value: d.thread_settings.should_auto_join_attendees_on_rsvp.toString()
                    } : undefined,
                    d.thread_settings ? {
                        label: "Start Message",
                        value: d.thread_settings.should_send_start_message_to_thread ? "Thread" : "Channel"
                    } : undefined
                ].filter((val)=>val !== undefined)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "Notifications",
                childs: d.server_reminders.map((val)=>({
                        label: (0, _timeFormatUtils.time_format_utils).formatDurationVerbose((0, _luxon.Duration).fromMillis(val.fire_before_ms)) + " before",
                        childs: [
                            {
                                label: "Channel",
                                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelName.ChannelName), {
                                    channel_id: val.desired_channel_id ?? d.sent_channel_data.id
                                })
                            },
                            {
                                label: "Mentions",
                                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex gap-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                                        role_mention_ids: val.role_mention_ids,
                                        user_mention_ids: val.user_mention_ids
                                    })
                                })
                            },
                            {
                                label: "Title",
                                value: val.message_title
                            }
                        ]
                    }))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalSelectedStateRow.EventTemplateModalSelectedStateRow), {
                label: "RSVP Lock Before Time",
                value: d.rsvp_lock_before_ms ? (0, _luxon.Duration).fromMillis(d.rsvp_lock_before_ms).toFormat("d 'days,' h 'hours,' m 'minutes'") : undefined
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","../../../../../../common/constants":"lLiun","../../../../../../common/event_serialization_utils":"65mah","../../../../../../common/sesh_types":"aUAOg","../../../../../../common/time_format_utils":"g0uQN","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../channel_name":"csu1S","../hooks/use_event_creation_context":"flKqC","../hooks/use_server_id":"d0sLH","../inline_emoji":"39PEk","../listings_form/event/event_listing_form/event_row":"4oVnC","../server_reminders/mentions_list":"9HygK","./event_template_modal_selected_state_row":"8Vzvj","./event_template_page":"5CZM0","./event_template_save_favorite_input":"bSD2G","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"65mah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCreationStateToTemplateData", ()=>eventCreationStateToTemplateData);
var _luxon = require("luxon");
var _rrule = require("rrule");
var _timeFormatUtils = require("./time_format_utils");
function eventCreationStateToTemplateData(state) {
    // TODO: would be very nice to just use { ...state } here, but state has some bad things we don't want
    return {
        allow_maintain_repeat_rsvp: state.allow_maintain_repeat_rsvp ?? false,
        event_timezone: state.event_timezone,
        attendee_role_data: state.attendee_role_data,
        color: state.color,
        description: state.description,
        duration_ms: state.duration_ms,
        event_name: state.event_name,
        eligible_role_ids: state.eligible_role_ids,
        exdates: state.exdates,
        hide_attendees: state.hide_attendees,
        image_url: state.image_url,
        native_event_data: state.native_event_data,
        rdates: state.rdates,
        role_mentions_on_create: state.role_mentions_on_create,
        rsvp_options: state.rsvp_options,
        server_reminders: state.server_reminders,
        thread_settings: state.thread_settings,
        user_mentions_on_create: state.user_mentions_on_create,
        start_time: state.start_time ? new Date(state.start_time) : undefined,
        sent_channel_data: state.selected_channel,
        rrule_str: state.rrule ? (0, _rrule.RRule).optionsToString((0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone(state.rrule.origOptions, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        state.user_timezone, state.start_time ?? (0, _luxon.DateTime).now())) : undefined,
        rsvp_lock_before_ms: state.rsvp_lock_before_ms
    };
}

},{"luxon":"fLWpi","rrule":"ilLpP","./time_format_utils":"g0uQN","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1I8d2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingThrobber", ()=>LoadingThrobber);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../../dashboard_utils");
function LoadingThrobber(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(props.loading_text, props.vertical_spaces)
    });
}

},{"react/jsx-runtime":"dpQXr","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"csu1S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelName", ()=>ChannelName);
parcelHelpers.export(exports, "ChannelNameWithoutCache", ()=>ChannelNameWithoutCache);
var _jsxRuntime = require("react/jsx-runtime");
var _useChannelName = require("./hooks/use_channel_name");
function ChannelName(props) {
    const channel_name = (0, _useChannelName.useChannelName)(props.channel_id, props.include_hashtag);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelNameWithoutCache, {
        channel_name: channel_name
    });
}
function ChannelNameWithoutCache(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "inline-flex min-w-0 max-w-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "overflow-hidden overflow-ellipsis",
            children: props.channel_name
        })
    });
}

},{"react/jsx-runtime":"dpQXr","./hooks/use_channel_name":"hA9Qq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hA9Qq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useChannelName", ()=>useChannelName);
var _react = require("react");
var _reactRouter = require("react-router");
var _seshRouter = require("../../../sesh_router");
function useChannelName(channel_id, include_hashtag = true) {
    let { server_id } = (0, _reactRouter.useParams)();
    const context = (0, _react.useContext)((0, _seshRouter.GuildRolesAndChannelContext));
    const channel_name = context?.get(server_id)?.channels?.find((val)=>val.id === channel_id)?.name;
    return channel_name ? `${include_hashtag ? "#" : ""}${channel_name}` : channel_id;
}

},{"react":"IMRgT","react-router":"djWTS","../../../sesh_router":"hfnpE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"39PEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEmoji", ()=>InlineEmoji);
var _jsxRuntime = require("react/jsx-runtime");
function InlineEmoji(props) {
    const option = props.option;
    let emoji_element;
    let custom_emoji_data = option.custom_emoji_data;
    if (custom_emoji_data) {
        let image_url = `https://cdn.discordapp.com/emojis/${custom_emoji_data.id}.` + (custom_emoji_data.animated ? "gif" : "png");
        emoji_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "emoji-img inline-block",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: "",
                src: image_url
            })
        });
    } else emoji_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "inline",
        children: option.emoji
    });
    return emoji_element;
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4oVnC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventActionIcons", ()=>EventActionIcons);
parcelHelpers.export(exports, "getRepeatData", ()=>getRepeatData);
parcelHelpers.export(exports, "rruleToRepeatString", ()=>rruleToRepeatString);
parcelHelpers.export(exports, "default", ()=>EventRow);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../../common/common_utils");
var _timeFormatUtils = require("../../../../../../../../common/time_format_utils");
var _trpc = require("../../../../../utils/trpc");
var _removingThrobber = require("../../../../removing_throbber");
var _linkWithPrevPage = require("../../../base_components/link_with_prev_page");
var _withDropdownImproved = require("../../../base_components/with_dropdown_improved");
var _useChannelName = require("../../../hooks/use_channel_name");
var _useGenerateEventActions = require("../../../hooks/use_generate_event_actions");
var _memberDisplayNameWithTooltip = require("../../../member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
var _listingsFormTableData = require("../../listings_form_table_data");
var _conciseRsvpList = require("./concise_rsvp_list");
var _dateTableData = require("./date_table_data");
const EventActionIcons = {
    edit: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-pencil-alt"
    }),
    clone: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-clone"
    }),
    delete: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "far fa-trash-alt"
    }),
    open: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-external-link-alt"
    })
};
function getRepeatData(event) {
    const output_timezone = (0, _luxon.DateTime).local().zone.name;
    if (!event.rrule) return undefined;
    return {
        repeat_id: event.original_repeat_message_id,
        repeat_text: rruleToRepeatString(event.rrule, (0, _luxon.DateTime).fromJSDate(new Date(event.start_time_str)))
    };
}
function rruleToRepeatString(rrule, start_time) {
    const output_timezone = (0, _luxon.DateTime).local().zone.name;
    return (0, _timeFormatUtils.time_format_utils).formatRRule(rrule, output_timezone, start_time, false);
}
function EventRow(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    const event_query = (0, _trpc.trpc).event.getListItem.useQuery({
        guild_id: server_id,
        message_id: props.message_id
    }, {
        staleTime: Infinity
    });
    const channel_name = (0, _useChannelName.useChannelName)(event_query.data?.channel_id);
    if (!event_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const event = event_query.data;
    const now_date = new Date();
    const start_time = new Date(event.start_time_str);
    const end_time = new Date(event.end_time_str);
    const is_in_past = end_time < now_date;
    let emoji_data;
    if (event.rsvp_options) emoji_data = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conciseRsvpList.ConciseRSVPList), {
        preset: event.rsvp_options
    });
    const repeat_data = getRepeatData(event);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        className: (0, _classnamesDefault.default)({
            "opacity-75": is_removing
        }),
        "in-past": is_in_past.toString(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTableData.DateTableData), {
                start_time_js_date: start_time,
                end_time_js_date: end_time,
                repeat_data: repeat_data
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: event.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: channel_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                    user_id: event.author_id,
                    tooltip_type: "SeshTooltip"
                })
            }),
            emoji_data && /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                className: (0, _classnamesDefault.default)({
                    "opacity-50": is_in_past
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkWithPrevPage.LinkWithPreviousPage), {
                    className: "w-full font-bold text-sesh-primary hover:text-sesh-dark",
                    title: "Manage RSVPs",
                    to: {
                        pathname: (0, _commonUtils.common_utils).getAttendeesDisplayURL(server_id, props.message_id)
                    },
                    prev_page: {
                        url: location.pathname,
                        label: "Event List"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "w-full",
                        children: emoji_data
                    })
                })
            }),
            !emoji_data && /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RowActions, {
                    guild_id: server_id,
                    event: event,
                    is_in_past: is_in_past,
                    is_removing: is_removing,
                    setIsRemoving: setIsRemoving
                })
            })
        ]
    });
}
function RowActions(props) {
    const actions = (0, _useGenerateEventActions.useGenerateEventActions)(props.event, props.is_removing, props.setIsRemoving, undefined, true);
    if (actions.isLoading === true || props.is_removing) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full flex-col sm:items-center",
        title: "Settings",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownImproved.WithDropdownImproved), {
            alignment: "left",
            items: [
                actions.edit,
                actions.clone,
                actions.open,
                {
                    type: "divider"
                },
                actions.delete
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _classnamesDefault.default)("text-sesh-primary hover:text-sesh-dark", {
                    "opacity-50": props.is_in_past
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-cog"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","react-router":"djWTS","../../../../../../../../common/common_utils":"gACUC","../../../../../../../../common/time_format_utils":"g0uQN","../../../../../utils/trpc":"dyYvM","../../../../removing_throbber":"TmURk","../../../base_components/link_with_prev_page":"81Et4","../../../base_components/with_dropdown_improved":"iYgdS","../../../hooks/use_channel_name":"hA9Qq","../../../hooks/use_generate_event_actions":"6ffvT","../../../member_display_name/member_display_name_with_tooltip":"7N9T1","../../listings_form_table_data":"9UCxt","./concise_rsvp_list":"lCma5","./date_table_data":"bdUOh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"81Et4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkWithPreviousPage", ()=>LinkWithPreviousPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
function LinkWithPreviousPage(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        ...props,
        to: {
            ...props.to,
            state: {
                ...props.to?.state,
                prev_page: props.prev_page
            }
        }
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"3XSn5","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iYgdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownItemToElementGenerator", ()=>DropdownItemToElementGenerator);
parcelHelpers.export(exports, "DropdownItemToElementWithoutLabel", ()=>DropdownItemToElementWithoutLabel);
parcelHelpers.export(exports, "DropdownItemToElementWithLabel", ()=>DropdownItemToElementWithLabel);
parcelHelpers.export(exports, "WithDropdownImproved", ()=>WithDropdownImproved);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _disabler = require("../disabler");
var _withTooltipPortaled = require("../tooltips/with_tooltip_portaled");
var _withDropdownBase = require("./with_dropdown_base");
const DropdownItemToElementGenerator = (Element)=>{
    return {
        a: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                ...item.props,
                herf: item.disabled_state?.is_disabled ? "#" : item.props.href,
                className: (0, _classnamesDefault.default)({
                    "text-gray-400 hover:text-gray-400": item.disabled_state?.is_disabled,
                    "hover:text-sesh-primary": !item.disabled_state?.is_disabled
                }),
                disabled: item.disabled_state?.is_disabled,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
                    ...item
                })
            }),
        button: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                ...item.props,
                disabled: item.disabled_state?.is_disabled,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
                    ...item
                })
            }),
        link: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                ...item.props,
                to: item.disabled_state?.is_disabled ? "#" : item.props.to,
                className: (0, _classnamesDefault.default)("hello", {
                    "text-gray-400 hover:text-gray-400": item.disabled_state?.is_disabled,
                    "hover:text-sesh-primary": !item.disabled_state?.is_disabled
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
                    ...item
                })
            }),
        dropdown: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
                ...item.props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
                    ...item
                })
            })
    };
};
const DropdownItemToElementWithoutLabel = (color)=>DropdownItemToElementGenerator((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
            disable_click: true,
            tooltip: props.disabled_state?.is_disabled ? props.disabled_state?.tooltip ?? props.label : props.label,
            style: "Info",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    color: color
                },
                className: (0, _classnamesDefault.default)("p-2", {
                    "cursor-not-allowed opacity-40": props.disabled_state?.is_disabled,
                    "opacity-100 hover:opacity-60": !props.disabled_state?.is_disabled
                }),
                children: props.icon
            })
        }));
const DropdownItemToElementWithLabel = DropdownItemToElementGenerator(DropdownItemLabel);
function DropdownItemLabel(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: (0, _classnamesDefault.default)("flex gap-2 px-4 py-2 sm:py-1", {
            "text-warning": props.is_warning
        }),
        children: [
            props.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "flex w-5 items-center justify-center",
                children: props.icon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: props.label
            })
        ]
    });
}
function WithDropdownImproved(props) {
    const dropdownRef = (0, _react.useRef)(null);
    const handleItemClick = (item)=>{
        if (item.close_on_click) dropdownRef.current?.close();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
        ref: dropdownRef,
        x_alignment: props.alignment,
        y_alignment: "bottom",
        dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-fit rounded-sm border border-sesh-dark bg-base-dark !p-1 text-sm text-sesh-primary shadow-md",
            children: props.items.map((val, index)=>{
                if (val.type === "divider") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                    className: "my-1 h-[1px] border-none bg-sesh-primary/25"
                }, index);
                const result = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                    disabled: val.disabled_state?.is_disabled,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "sesh-dropdown-item w-full whitespace-nowrap font-semibold hover:bg-base-light",
                        onClick: ()=>handleItemClick(val),
                        children: DropdownItemToElementWithLabel[val.type](val)
                    })
                }, index);
                if (val.disabled_state?.is_disabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                    disable_click: true,
                    style: "Info",
                    tooltip: val.disabled_state.tooltip,
                    children: result
                }, index);
                return result;
            })
        }),
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router-dom":"3XSn5","../disabler":"hF5sC","../tooltips/with_tooltip_portaled":"6LBvw","./with_dropdown_base":"1AlyU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1AlyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithDropdownBase", ()=>WithDropdownBase);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _useOutsideAlerter = require("../hooks/use_outside_alerter");
var _useOutsideAlerterDefault = parcelHelpers.interopDefault(_useOutsideAlerter);
const WithDropdownBase = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const [is_active, setIsActive] = (0, _react.useState)(false);
    const trigger_ref = (0, _react.useRef)(null);
    const dropdown_ref = (0, _react.useRef)(null);
    (0, _useOutsideAlerterDefault.default)(dropdown_ref, ()=>setIsActive(false));
    const close = ()=>{
        setIsActive(false);
        props.onClose?.();
    };
    (0, _react.useImperativeHandle)(ref, ()=>({
            close
        }));
    (0, _react.useEffect)(()=>{
        const setPosition = ()=>{
            if (!is_active || !trigger_ref.current || !dropdown_ref.current) return;
            const container = props.parent_id ? document.getElementById(props.parent_id) : document.body;
            // Position dropdown_ref relative to trigger_ref
            const trigger_rect = trigger_ref.current.getBoundingClientRect();
            const dropdown_rect = dropdown_ref.current.getBoundingClientRect();
            const container_rect = container.getBoundingClientRect();
            const dropdown_width = dropdown_rect.width;
            const dropdown_height = dropdown_rect.height;
            let x_alignment = props.x_alignment || "auto";
            const y_alignment = props.y_alignment || "auto";
            let dropdown_center_abs_x = trigger_rect.left + trigger_rect.width / 2;
            if (x_alignment === "auto") {
                // For auto alignment, check which side has more space
                if (dropdown_center_abs_x > window.innerWidth / 2) x_alignment = "right";
                else x_alignment = "left";
            }
            let dropdown_abs_left;
            if (x_alignment === "left") // Left align - dropdown's left edge aligns with trigger's left edge
            dropdown_abs_left = trigger_rect.left;
            else if (x_alignment === "right") // Right align - dropdown's right edge aligns with trigger's right edge
            dropdown_abs_left = trigger_rect.right - dropdown_rect.width;
            else if (x_alignment === "middle") // Middle align - dropdown is centered with the trigger
            dropdown_abs_left = dropdown_center_abs_x - dropdown_rect.width / 2;
            else // Default to centered
            dropdown_abs_left = dropdown_center_abs_x - dropdown_rect.width / 2;
            let dropdown_top;
            if (y_alignment === "top") dropdown_top = trigger_rect.top - dropdown_height;
            else if (y_alignment === "bottom") dropdown_top = trigger_rect.bottom;
            else dropdown_top = trigger_rect.top + (trigger_rect.height - dropdown_height) / 2;
            // Ensure dropdown stays within viewport horizontally
            dropdown_abs_left = Math.max(dropdown_abs_left, 0);
            dropdown_abs_left = Math.min(dropdown_abs_left, window.innerWidth - dropdown_width);
            const left = dropdown_abs_left - container_rect.left;
            let top = Math.max(dropdown_top - container_rect.top, window.scrollY);
            if (top + dropdown_rect.height > window.innerHeight) top = window.innerHeight - dropdown_rect.height;
            dropdown_ref.current.style.left = `${left}px`;
            dropdown_ref.current.style.top = `${top}px`;
            dropdown_ref.current.style.opacity = "1";
        };
        setPosition();
    }, [
        is_active,
        props.x_alignment,
        props.y_alignment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: trigger_ref,
        className: (0, _classnamesDefault.default)("w-full", {
            "is-active": is_active,
            "is-right": props.x_alignment === "right"
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-trigger w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "flex w-full items-center gap-2",
                    "aria-haspopup": "true",
                    onClick: ()=>!props.disabled ? setIsActive(true) : undefined,
                    children: typeof props.children === "function" ? props.children(is_active) : props.children
                })
            }),
            is_active && /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: props.id,
                ref: dropdown_ref,
                className: "absolute z-[1002] w-fit p-2 opacity-0 transition-all",
                role: "menu",
                children: props.dropdown_element
            }), props.parent_id ? document.getElementById(props.parent_id) : document.body)
        ]
    });
});

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-dom":"fODdr","../hooks/use_outside_alerter":"d0yYg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6ffvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGenerateEventActions", ()=>useGenerateEventActions);
parcelHelpers.export(exports, "onDeleteClicked", ()=>onDeleteClicked);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _boxItem = require("../box_item");
var _useHistoryPusher = require("../listings_form/event/calendar/hooks/use_history_pusher");
var _usePublicCalendarContext = require("../listings_form/event/calendar/hooks/use_public_calendar_context");
var _eventRow = require("../listings_form/event/event_listing_form/event_row");
var _editEventTimeContent = require("./edit_event_time_content");
var _useIsAdmin = require("./use_is_admin");
var _useServerId = require("./use_server_id");
var _useUserContext = require("./use_user_context");
function LinkOrAnchorDropdownItemProps(opts, props) {
    if (opts.is_public_calendar) return {
        ...props,
        type: "a",
        props: {
            href: props.url
        }
    };
    return {
        ...props,
        type: "link",
        props: {
            to: props.url
        }
    };
}
function useGenerateEventActions(event, is_removing, setIsRemoving, dropdown_parent_id, disable_rrule_check = false) {
    const server_id = (0, _useServerId.useServerId)();
    const { is_public: is_public_calendar } = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    const user = (0, _useUserContext.useUserContext)();
    const is_admin_query = (0, _useIsAdmin.useIsAdmin)({
        disabled: is_public_calendar
    });
    const history = (0, _reactRouter.useHistory)();
    const context = (0, _trpc.trpc).useContext();
    const is_event_creator = user?.id === event.author_id;
    const has_edit_event_perms = is_public_calendar || is_admin_query.data || is_event_creator;
    const has_event_started = new Date(event.start_time_str) < new Date();
    const cannot_edit_event_tooltip_text = "Must be event creator or have Manage Sesh permissions to modify events";
    const exdate_mutation = (0, _trpc.trpc).event.deleteRepeatOccurrence.useMutation();
    if (!is_public_calendar && (is_removing || !is_admin_query.isSuccess)) return {
        isLoading: true
    };
    return {
        isLoading: false,
        edit: !disable_rrule_check && event.rrule ? {
            type: "dropdown",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-pencil-alt"
            }),
            label: "Edit event",
            props: {
                parent_id: dropdown_parent_id,
                dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RepeatEditDropdown, {
                    event: event
                })
            },
            disabled_state: {
                is_disabled: has_event_started || !has_edit_event_perms,
                tooltip: !has_edit_event_perms ? cannot_edit_event_tooltip_text : "Can not edit completed or ongoing events"
            }
        } : LinkOrAnchorDropdownItemProps({
            is_public_calendar
        }, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-pencil-alt"
            }),
            label: "Edit event",
            disabled_state: {
                is_disabled: has_event_started || !has_edit_event_perms,
                tooltip: !has_edit_event_perms ? cannot_edit_event_tooltip_text : "Can not edit completed or ongoing events"
            },
            url: (0, _commonUtils.common_utils).getEventEditURL(server_id, event.message_id)
        }),
        clone: LinkOrAnchorDropdownItemProps({
            is_public_calendar
        }, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-clone"
            }),
            label: "Use as template",
            url: (0, _commonUtils.common_utils).getEventCreateURL(server_id, undefined, {
                id: event.message_id,
                type: "event"
            })
        }),
        open: {
            type: "a",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-external-link-alt"
            }),
            label: "Open in Discord",
            props: {
                href: `${(0, _constants.Constants).DISCORD_LINK_PREFIX}${server_id}/${event.channel_id}/${event.message_id}`.replace("https", "discord")
            },
            disabled_state: {
                is_disabled: event.is_repeat_occurrence,
                tooltip: "Event has not been posted yet"
            }
        },
        delete: !is_public_calendar ? {
            type: "button",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "far fa-trash-alt"
            }),
            label: "Delete event",
            is_warning: true,
            props: {
                onClick: ()=>{
                    if (!has_edit_event_perms) return;
                    onDeleteClicked(context, event, (delete_type)=>{
                        if (event.is_repeat_occurrence) return exdate_mutation.mutateAsync({
                            date: event.start_time_str,
                            repeat_message_id: event.original_repeat_message_id,
                            type: delete_type
                        });
                        return deleteEvent(user, server_id, event.message_id, delete_type);
                    }, setIsRemoving);
                }
            },
            disabled_state: {
                is_disabled: !has_edit_event_perms,
                tooltip: cannot_edit_event_tooltip_text
            }
        } : undefined
    };
}
function RepeatEditDropdown(props) {
    const server_id = (0, _useServerId.useServerId)();
    const pushHistory = (0, _useHistoryPusher.useHistoryPusher)();
    const [is_modal_open, setIsModalOpen] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                className: "border border-sesh-primary shadow-lg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-64 flex-col gap-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            custom_size: "small",
                            onClick: ()=>setIsModalOpen(true),
                            children: "Edit This Instance"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            custom_size: "small",
                            onClick: ()=>pushHistory((0, _commonUtils.common_utils).getEventEditURL(server_id, props.event.message_id)),
                            children: "Edit All Instances"
                        })
                    ]
                })
            }),
            is_modal_open && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: true,
                allow_overflow: true,
                title: props.event.name,
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditTimeModalContent, {
                    event: props.event,
                    close: ()=>setIsModalOpen(false)
                }),
                onClose: ()=>setIsModalOpen(false)
            })
        ]
    });
}
function EditTimeModalContent(props) {
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).event.addRepeatRDate.useMutation({
        onSuccess: ()=>{
            context.event.list.invalidate();
            props.close();
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editEventTimeContent.EditEventTimeContent), {
        repeat_start_time: new Date(props.event.repeat_instance_original_start_time_str),
        original_instance_start_time: new Date(props.event.initial_event_start_time_str),
        start_time: new Date(props.event.start_time_str),
        end_time: new Date(props.event.end_time_str),
        rrule: props.event.rrule,
        repeat_tz: props.event.repeat_tz,
        exdates: props.event.exdates,
        rdates: props.event.rdates,
        onSubmit: (date)=>mutation.mutate({
                orig_date: props.event.start_time_str,
                new_date: date.toISOString(),
                repeat_message_id: props.event.original_repeat_message_id
            }),
        is_loading: mutation.isLoading
    });
}
async function deleteEvent(auth_token, guild_id, message_id, delete_type = "Single") {
    const request_body = {
        access_token: auth_token.access_token,
        token_type: auth_token.token_type,
        guild_id,
        message_id,
        delete_type
    };
    return fetch("/api/delete_event", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
            return value;
        }));
}
async function onDeleteClicked(context, event, deleteFunc, setEventPendingDelete) {
    const end_time = new Date(event.end_time_str);
    const repeat_data = (0, _eventRow.getRepeatData)(event);
    let confirmation_result;
    if (repeat_data && end_time > new Date()) // Only display this if its the most current repeat occurrence
    confirmation_result = await (0, _dashboardUtils.DashboardUtils).ShowDeleteRepeatConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "Would you like to delete only this event or this event and all future occurrences of",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: event.name
            }),
            "?",
            !event.is_repeat_occurrence && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    " ",
                    "If you delete only this event, the next event will be posted immediately."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: "Repeats:"
            }),
            " ",
            repeat_data.repeat_text
        ]
    }));
    else confirmation_result = await (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "Are you sure you want to permanently delete event",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: event.name
            }),
            "?",
            " ",
            repeat_data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "Delete the latest event to stop future repeats."
            })
        ]
    }));
    // Confirm = Single Delete - Deny = Full Delete
    if (!confirmation_result.isConfirmed && !confirmation_result.isDenied) return;
    const delete_type = confirmation_result.isConfirmed ? "Single" : "Single_And_Future";
    setEventPendingDelete?.(true);
    deleteFunc(delete_type).then((val)=>{
        setEventPendingDelete?.(false);
        if (val.db_success) context.event.list.invalidate();
        if (val.repeat_delete_result?.err) (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert((0, _commonUtils.common_utils).markdownToHtml(val.repeat_delete_result.err));
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/sesh_primary_button":"3QyI2","../box_item":"gTVlB","../listings_form/event/calendar/hooks/use_history_pusher":"fnplP","../listings_form/event/calendar/hooks/use_public_calendar_context":"948cp","../listings_form/event/event_listing_form/event_row":"4oVnC","./edit_event_time_content":"8xN9r","./use_is_admin":"dsdqX","./use_server_id":"d0sLH","./use_user_context":"eU1k4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fnplP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHistoryPusher", ()=>useHistoryPusher);
var _reactRouter = require("react-router");
var _usePublicCalendarContext = require("./use_public_calendar_context");
function useHistoryPusher() {
    const history = (0, _reactRouter.useHistory)();
    const { is_public } = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    return (url)=>is_public ? window.location.href = url : history.push(url);
}

},{"react-router":"djWTS","./use_public_calendar_context":"948cp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"948cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PublicCalendarContext", ()=>PublicCalendarContext);
parcelHelpers.export(exports, "usePublicCalendarContext", ()=>usePublicCalendarContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PublicCalendarContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    is_public: false
});
function usePublicCalendarContext() {
    return (0, _react.useContext)(PublicCalendarContext) ?? {
        is_public: false
    };
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8xN9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditEventTimeContent", ()=>EditEventTimeContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _dateTimePicker = require("../../date_time_picker");
var _repeatUtils = require("../../../../../../common/repeat_utils");
var _modifySettingsButton = require("../base_components/modify_settings_button");
function EditEventTimeContent(props) {
    const [time, setTime] = (0, _react.useState)(new Date(props.start_time));
    // const rrule_set = createRRuleSet({
    // 	rrule_str: props.event.rrule,
    // 	start_time_js: new Date(
    // 		props.event.repeat_instance_original_start_time_str
    // 	),
    // 	repeat_tz: props.event.repeat_tz,
    // 	exdates: props.event.exdates,
    // 	rdates: props.event.rdates,
    // });
    const rrule_set = (0, _repeatUtils.createRRuleSet)({
        rrule_str: props.rrule,
        start_time_js: props.repeat_start_time,
        repeat_tz: props.repeat_tz,
        exdates: props.exdates,
        rdates: props.rdates
    });
    const duration_ms = props.end_time.getTime() - props.start_time.getTime();
    const is_valid_time = (0, _repeatUtils.isTimeBetweenRepeats)(rrule_set, new Date(props.original_instance_start_time), props.start_time, time, duration_ms);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-4 flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePicker.DateTimePicker), {
                disable_past_days: true,
                initial_value: time,
                updateFunc: (val)=>setTime(new Date(val)),
                disabled: false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex w-fit items-center gap-2",
                children: [
                    !is_valid_time && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-sm text-warning",
                        children: "Start time must be between subsequent and previous repeats"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ml-auto flex w-fit gap-4",
                        children: [
                            props.onBack && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                hide_arrow: true,
                                onClick: props.onBack,
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                disabled: !is_valid_time,
                                onClick: ()=>props.onSubmit(time),
                                is_loading: props.is_loading,
                                children: "Edit"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../base_components/sesh_primary_button":"3QyI2","../../date_time_picker":"c4mcO","../../../../../../common/repeat_utils":"gG7ok","../base_components/modify_settings_button":"kbhTg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gG7ok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextNOccurrences", ()=>getNextNOccurrences);
parcelHelpers.export(exports, "getPrevious", ()=>getPrevious);
parcelHelpers.export(exports, "isTimeBetweenRepeats", ()=>isTimeBetweenRepeats);
parcelHelpers.export(exports, "getPreviousNOccurrences", ()=>getPreviousNOccurrences);
parcelHelpers.export(exports, "timeToRRuleTime", ()=>timeToRRuleTime);
parcelHelpers.export(exports, "rruleTimeToLocalTime", ()=>rruleTimeToLocalTime);
parcelHelpers.export(exports, "rruleAfter", ()=>rruleAfter);
parcelHelpers.export(exports, "createRRuleSet", ()=>createRRuleSet);
var _luxon = require("luxon");
var _rrule = require("rrule");
var _timeFormatUtils = require("./time_format_utils");
function getNextNOccurrences(rrule, start_time, repeat_tz, n, include = true) {
    const current_start_time = timeToRRuleTime(start_time, repeat_tz);
    return rrule.between(current_start_time, new Date(2050, 1, 1), include, (date, len)=>{
        return len < n;
    });
}
function getPrevious(rrule, repeat_start, current_time) {
    let i = 0;
    let next_start_time = (0, _luxon.DateTime).fromJSDate(repeat_start);
    let previous_start_time = null;
    while(next_start_time && next_start_time.toMillis() < current_time.getTime()){
        const candidate = rruleAfter(rrule, next_start_time.toJSDate());
        if (!candidate) break;
        previous_start_time = next_start_time;
        next_start_time = candidate;
        if (i > 1000) break;
        i++;
    }
    return previous_start_time?.toUTC();
}
function isTimeBetweenRepeats(rrule, repeat_start, current_time, desired_time, duration_ms) {
    const previous_time = getPrevious(rrule, repeat_start, current_time);
    const subsequent_time = rruleAfter(rrule, (0, _luxon.DateTime).fromJSDate(current_time).toUTC(undefined, {
        keepLocalTime: true
    }).toJSDate());
    const is_after_previous = desired_time.getTime() > Date.now() && (!previous_time || previous_time.toMillis() + duration_ms < desired_time.getTime());
    const is_before_subsequent = !subsequent_time || subsequent_time.toMillis() > desired_time.getTime() + duration_ms;
    // console.log();
    // console.log("previous", previous_time?.toISO());
    // console.log("current_time", current_time.toISOString());
    // console.log("subsequent", subsequent_time?.toISO());
    // console.log("desired_time", desired_time.toISOString());
    return is_after_previous && is_before_subsequent;
}
function getPreviousNOccurrences(rrule, raw_event_start_time, raw_current_start_time, repeat_tz, n) {
    const event_start_time = timeToRRuleTime(raw_event_start_time, repeat_tz);
    const dates = [];
    let current_date = raw_current_start_time;
    for(let i = 0; i < n; i++){
        current_date = rrule.before(timeToRRuleTime(current_date, repeat_tz), false);
        if (!current_date || current_date.getTime() < event_start_time.getTime()) break;
        dates.push(current_date);
    }
    return dates.reverse();
}
function timeToRRuleTime(start_time, repeat_tz) {
    return (0, _luxon.DateTime).fromJSDate(start_time).setZone(repeat_tz).toUTC(undefined, {
        keepLocalTime: true
    }).toJSDate();
}
function rruleTimeToLocalTime(rrule_date) {
    return (0, _luxon.DateTime).fromJSDate(rrule_date).toUTC().setZone("local", {
        keepLocalTime: true
    });
}
function rruleAfter(rrule_set, start) {
    const start_datetime = (0, _luxon.DateTime).fromJSDate(start);
    // TODO repeat: test calendar page with different system timezone
    const next_date_result = rrule_set.after(start_datetime.toJSDate(), false);
    if (!next_date_result) return null;
    return rruleTimeToLocalTime(next_date_result).toUTC();
}
function createRRuleSet({ rrule_str, start_time_js, repeat_tz, exdates, rdates }) {
    const start_time = (0, _luxon.DateTime).fromJSDate(start_time_js).toUTC();
    const rrule_set = new (0, _rrule.RRuleSet)();
    const rrule = new (0, _rrule.RRule)({
        ...(0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone((0, _rrule.RRule).parseString(rrule_str), repeat_tz, start_time, true),
        dtstart: timeToRRuleTime(start_time.toJSDate(), repeat_tz),
        tzid: repeat_tz === "UTC" ? "GMT" : repeat_tz
    });
    if (rrule.options.until) // rrule.options.until = DateTime.fromJSDate(rrule.options.until)
    // 	.setZone(local_timezone)
    // 	.toUTC(undefined, { keepLocalTime: true })
    // 	.toJSDate();
    rrule.options.until = timeToRRuleTime(rrule.options.until, repeat_tz);
    rrule_set.rrule(rrule);
    exdates?.forEach((exdate)=>rrule_set.exdate(timeToRRuleTime(new Date(exdate), repeat_tz)));
    rdates?.forEach((rdate)=>{
        rrule_set.exdate(timeToRRuleTime(new Date(rdate.orig_date), repeat_tz));
        rrule_set.rdate(timeToRRuleTime(new Date(rdate.rdate), repeat_tz));
    });
    return rrule_set;
}

},{"luxon":"fLWpi","rrule":"ilLpP","./time_format_utils":"g0uQN","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eU1k4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUserContext", ()=>useUserContext);
var _react = require("react");
var _seshRouter = require("../../../sesh_router");
function useUserContext() {
    return (0, _react.useContext)((0, _seshRouter.UserContext));
}

},{"react":"IMRgT","../../../sesh_router":"hfnpE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7N9T1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MemberDisplayNameWithTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _useGuildMembers = require("../hooks/use_guild_members");
var _withTooltip = require("../tooltips/with_tooltip");
function MemberDisplayNameWithTooltip(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const members_query = (0, _useGuildMembers.useGuildMemberQuery)(server_id, [
        props.user_id
    ]);
    const tooltip_type = props.tooltip_type ?? "Title";
    const member = members_query?.members?.find((val)=>val.id === props.user_id);
    const has_valid_discriminator = member?.discriminator && member.discriminator !== "0";
    const tooltip_text = `${member ? member.name : props.user_id}${has_valid_discriminator ? `#${member.discriminator}` : ""} (${props.user_id})`;
    const element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-2 overflow-hidden whitespace-nowrap",
        title: tooltip_type === "Title" ? tooltip_text : undefined,
        children: [
            props.include_avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                className: "image is-24x24 flex-shrink-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "is-rounded",
                    src: member?.avatar_url ? `https://cdn.discordapp.com/${member.avatar_url}` : (0, _dashboardUtils.DashboardUtils).GetPlaceholderAvatarURL(props.user_id, 32),
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "min-w-0 max-w-full overflow-hidden overflow-ellipsis",
                children: member ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        member.name,
                        has_valid_discriminator && // Add slight right padding so italic isnt cut off
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "pr-[2px] italic",
                            children: [
                                "#",
                                member.discriminator
                            ]
                        })
                    ]
                }) : props.user_id
            })
        ]
    });
    if (tooltip_type === "SeshTooltip") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
        style: "Info",
        tooltip: tooltip_text,
        children: element
    });
    else return element;
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../hooks/use_guild_members":"iK4oL","../tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9UCxt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListingsFormTableData", ()=>ListingsFormTableData);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _withTooltip = require("../tooltips/with_tooltip");
function ListingsFormTableData(props) {
    const { content, bolded } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
            tooltip: content,
            style: "Info",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: (0, _classnamesDefault.default)("ellipsis-overflow w-full overflow-hidden whitespace-nowrap", {
                        "font-bold": bolded
                    }),
                    children: content
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lCma5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConciseRSVPList", ()=>ConciseRSVPList);
var _jsxRuntime = require("react/jsx-runtime");
var _inlineEmoji = require("../../../inline_emoji");
function ConciseRSVPList(props) {
    const { preset } = props;
    const columns = [];
    let index = 0;
    for (let option of preset){
        const emoji = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
            option: option
        });
        columns.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "column is-one-third-tablet is-one-third-mobile column-in-table-cell has-text-centered-tablet",
            children: [
                emoji,
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: option.rsvp_count
                })
            ]
        }, index));
        index++;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "columns is-multiline is-mobile",
        children: columns
    });
}

},{"react/jsx-runtime":"dpQXr","../../../inline_emoji":"39PEk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bdUOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTableData", ()=>DateTableData);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _withTooltip = require("../../../tooltips/with_tooltip");
function DateTableData(props) {
    const { start_time_js_date, end_time_js_date, repeat_data } = props;
    const start_time = _luxon.DateTime.fromJSDate(start_time_js_date);
    const end_time = _luxon.DateTime.fromJSDate(end_time_js_date);
    const date = start_time.toLocaleString({
        month: "short",
        day: "2-digit"
    });
    const full_date = start_time.toLocaleString({
        dateStyle: "full",
        timeStyle: "short"
    });
    const time = start_time.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    const end_time_string = end_time.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    let repeat_element;
    let datatip_strings = [
        full_date
    ];
    if (repeat_data) {
        repeat_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-redo"
        });
        datatip_strings.push(repeat_data.repeat_text);
    }
    const datatip = datatip_strings.join("<br />");
    const date_string = `${date} ${time} - ${end_time_string}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        className: "w-full",
        "data-tip": datatip,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
            style: "Info",
            tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: full_date
                    }),
                    repeat_data?.repeat_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: repeat_data.repeat_text
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full min-w-0 items-center gap-2 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "ellipsis-overflow max-w-full flex-shrink-0 overflow-hidden whitespace-nowrap",
                        children: date_string
                    }),
                    repeat_element
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","../../../tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9HygK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MentionsList", ()=>MentionsList);
var _jsxRuntime = require("react/jsx-runtime");
var _initialMentionsBlurb = require("./initial_mentions_blurb");
function MentionsList(props) {
    const { role_mention_ids, user_mention_ids } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            role_mention_ids.length === 0 && user_mention_ids.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "None"
            }),
            role_mention_ids.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.RoleMention), {
                    id: val
                }, val)),
            user_mention_ids.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.UserMention), {
                    id: val
                }, val))
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","./initial_mentions_blurb":"f2kPT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f2kPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoleMention", ()=>RoleMention);
parcelHelpers.export(exports, "UserMention", ()=>UserMention);
parcelHelpers.export(exports, "ActiveMentionsModal", ()=>ActiveMentionsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _useGuildMembers = require("../hooks/use_guild_members");
var _useRoles = require("../hooks/use_roles");
var _serverRemindersMentions = require("./server_reminders_mentions");
function RoleMention(props) {
    const roles = (0, _useRoles.useRoles)();
    const role = roles.find((role)=>role.id === props.id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex-nowrap whitespace-nowrap rounded-md bg-discord-blurple bg-opacity-25 px-1",
        children: role?.name ? `${role.is_everyone_or_here ? "" : "@"}${role.name}` : "unknown"
    });
}
function UserMention(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const members_query = (0, _useGuildMembers.useGuildMemberQuery)(server_id, [
        props.id
    ]);
    const name = members_query.members?.[0]?.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex-nowrap whitespace-nowrap rounded-md bg-discord-blurple bg-opacity-25 px-1",
        children: name ? `@${name}` : "unknown"
    });
}
function ActiveMentionsModal(props) {
    const [ephemeral_user_mention_ids, setEphemeralUserMentionIds] = (0, _react.useState)(props.user_mention_ids);
    const [ephemeral_role_mention_ids, setEphemeralRoleMentionIds] = (0, _react.useState)(props.role_mention_ids);
    const [ephemeral_is_mirroring, setEphemeralIsMirroring] = (0, _react.useState)(props.is_mirroring_mentions);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        allow_overflow: true,
        title: props.header,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mt-2 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverRemindersMentions.MentionsSection), {
                    member_ids: ephemeral_user_mention_ids,
                    role_ids: ephemeral_role_mention_ids,
                    onMembersChange: setEphemeralUserMentionIds,
                    onRolesChange: setEphemeralRoleMentionIds,
                    is_editing: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ml-auto flex cursor-pointer items-center gap-2",
                    onClick: ()=>{
                        setEphemeralIsMirroring(!ephemeral_is_mirroring);
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            checked: ephemeral_is_mirroring,
                            readOnly: true
                        }),
                        " ",
                        "Copy mentions to all notifications"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ml-auto mt-2 flex w-fit",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        onClick: ()=>{
                            props.onSubmit(ephemeral_user_mention_ids, ephemeral_role_mention_ids, ephemeral_is_mirroring);
                        },
                        children: "Set"
                    })
                })
            ]
        }),
        onClose: props.onClose
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../base_components/sesh_primary_button":"3QyI2","../hooks/use_guild_members":"iK4oL","../hooks/use_roles":"b2XTr","./server_reminders_mentions":"ehKOb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ehKOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MentionsSection", ()=>MentionsSection);
var _jsxRuntime = require("react/jsx-runtime");
var _membersSearchDropdownWithServerId = require("../../members_search_dropdown_with_server_id");
var _rolesSearchDropdown = require("../roles_search_dropdown");
var _mentionsList = require("./mentions_list");
function MentionsSection(props) {
    const { is_editing } = props;
    if (!is_editing) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap gap-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
            role_mention_ids: props.role_ids,
            user_mention_ids: props.member_ids
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _membersSearchDropdownWithServerId.MembersSearchDropdownWithServerId), {
                selected_ids: props.member_ids,
                onUpdate: props.onMembersChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesSearchDropdown.RolesSearchDropdown), {
                selected_ids: props.role_ids,
                handleChange: props.onRolesChange
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../members_search_dropdown_with_server_id":"3hG2N","../roles_search_dropdown":"e09Fz","./mentions_list":"9HygK","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3hG2N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MembersSearchDropdownWithServerId", ()=>MembersSearchDropdownWithServerId);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _membersSearchDropdown = require("./improved_components/members_search_dropdown");
function MembersSearchDropdownWithServerId(props) {
    let { server_id } = (0, _reactRouter.useParams)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _membersSearchDropdown.MembersSearchDropdown), {
        ...props,
        guild_id: server_id,
        onUpdate: (ids)=>props.onUpdate(ids)
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","./improved_components/members_search_dropdown":"j5v22","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j5v22":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MembersSearchDropdown", ()=>MembersSearchDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactSelect = require("react-select");
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _constants = require("../../../../../common/constants");
var _trpc = require("../../utils/trpc");
var _searchableDropdown = require("../searchable_dropdown");
var _useGuildMembers = require("./hooks/use_guild_members");
function MemberToDropdownItem(members_map, id) {
    const member = members_map[id];
    return {
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
            val: member
        }),
        selectedLabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
            val: member
        }),
        value: id,
        color: "#ffffff"
    };
}
const MenuList = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSelect.components).MenuList, {
        ...props,
        children: [
            props.children,
            props.options.length > (0, _constants.Constants).GUILD_MEMBERS_SEARCH_LIMIT && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "py-2 text-center text-xs font-bold text-sesh-primary",
                children: "More results than can be displayed. Type to filter."
            })
        ]
    });
};
const Input = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Input, {
        ...props,
        maxLength: 64
    });
function MembersSearchDropdown(props) {
    const context = (0, _trpc.trpc).useContext();
    const search_cache = (0, _react.useRef)({});
    const members = (0, _useGuildMembers.useGuildMemberQuery)(props.guild_id, props.selected_ids);
    const members_cache = (0, _react.useContext)((0, _useGuildMembers.GuildMemberContext));
    const members_for_guild = members_cache.getMembers(props.guild_id);
    const members_map = {};
    for (const member of members_for_guild)members_map[member.id] = member;
    const fetchMembers = (0, _react.useCallback)((0, _lodash.debounce)((new_input, callback)=>{
        if (search_cache.current[new_input]) {
            callback(search_cache.current[new_input]);
            return;
        }
        const previous_searches = Object.keys(search_cache.current);
        for (const search of previous_searches){
            if (search.length === 0) continue;
            // This can be improved by checking for length < Constants.GUILD_MEMBERS_SEARCH_LIMIT, but it gets tricky to deal with since search deals with usernames and displaynames
            if (new_input.startsWith(search) && search_cache.current[search].length === 0) {
                callback([]);
                return;
            }
        }
        return context.members.search.fetch({
            guild_id: props.guild_id,
            query: new_input
        }).then((val)=>{
            members_cache.addMembers(props.guild_id, val);
            const member_items = val.map((member)=>({
                    label: member.name,
                    value: member.id
                }));
            search_cache.current[new_input] = member_items;
            callback(member_items);
        });
    }, 500), [
        props.guild_id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            props.limit && props.selected_ids.length >= props.limit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "error-text",
                children: [
                    "Selection limit reached (",
                    props.limit,
                    " / ",
                    props.limit,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                placeholder: "Select members...",
                classNamePrefix: "sesh-dropdown",
                isMulti: true,
                styles: (0, _searchableDropdown.dropdownColourStyles),
                components: {
                    Input,
                    SingleValue: (0, _searchableDropdown.SingleValue),
                    MenuList
                },
                value: props.selected_ids.map((val)=>MemberToDropdownItem(members_map, val)),
                onChange: (data)=>{
                    if (props.is_disabled) return;
                    props.onUpdate(data.slice(0, props.limit ?? 100).map((val)=>val.value));
                },
                loadOptions: (input, callback)=>{
                    if (props.is_disabled) {
                        callback([]);
                        return;
                    }
                    fetchMembers(input, callback);
                },
                isDisabled: props.is_disabled,
                defaultOptions: true,
                isOptionDisabled: (data)=>props.disabled_ids?.includes(data.value),
                formatOptionLabel: (data)=>{
                    const member = members_map[data.value];
                    return member ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
                        val: member,
                        disabled: props.disabled_ids?.includes(data.value) ? {
                            text_element: "Already RSVPed",
                            class: "dropdown-disabled-text"
                        } : undefined
                    }) : data.value;
                }
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","lodash":"fIO2m","react":"IMRgT","react-select":[["components","j5lp9","c"]],"react-select/async":"8lz6t","../../../../../common/constants":"lLiun","../../utils/trpc":"dyYvM","../searchable_dropdown":"8iEAS","./hooks/use_guild_members":"iK4oL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e09Fz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RolesSearchDropdown", ()=>RolesSearchDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../dashboard_utils");
var _searchableDropdown = require("../searchable_dropdown");
var _useRoles = require("./hooks/use_roles");
function RolesSearchDropdown(props) {
    const roles = (0, _useRoles.useRoles)();
    const loading = !Boolean(roles);
    if (loading) return (0, _dashboardUtils.DashboardUtils).RenderLoadingSelect();
    let filtered_roles = props.should_disable_managed_roles ? roles.filter((val)=>!val.is_managed_role) : roles;
    if (props.should_disable_here) filtered_roles = filtered_roles.filter((val)=>val.id !== "@here");
    if (props.should_disable_everyone) filtered_roles = filtered_roles.filter((val)=>val.id !== "@everyone");
    const selected_mentions = props.selected_ids.map((id)=>filtered_roles.find((val)=>val.id === id)).filter((val)=>val);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.SearchableDropdown), {
        handleChange: (roles)=>props.handleChange(roles.map((val)=>val.id)),
        options: filtered_roles,
        initial_mentions: selected_mentions,
        ignore_invalid_permissions: false,
        disabled: props.disabled,
        loading: !Boolean(roles),
        placeholder: "Select roles..."
    });
}

},{"react/jsx-runtime":"dpQXr","../../dashboard_utils":"jvA8A","../searchable_dropdown":"8iEAS","./hooks/use_roles":"b2XTr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8Vzvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateModalSelectedStateRow", ()=>EventTemplateModalSelectedStateRow);
var _jsxRuntime = require("react/jsx-runtime");
function EventTemplateModalSelectedStateRow(props) {
    if ("childs" in props) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "opacity-75",
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mx-1 w-full border-l border-white/25",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "-mx-1 w-full px-4",
                        children: props.childs.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTemplateModalSelectedStateRow, {
                                ...val
                            }, index))
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grid w-full grid-cols-12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-span-6 opacity-75 sm:col-span-5",
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-span-6 whitespace-nowrap sm:col-span-7",
                children: props.value ? props.value : "None"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bSD2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateSaveFavoriteInput", ()=>EventTemplateSaveFavoriteInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _constants = require("../../../../../../common/constants");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshTextInput = require("../base_components/sesh_text_input");
var _useServerId = require("../hooks/use_server_id");
var _useSetbookmarkMutation = require("../hooks/use_setbookmark_mutation");
function EventTemplateSaveFavoriteInput(props) {
    const [name, setName] = (0, _react.useState)(props.initial_name);
    const server_id = (0, _useServerId.useServerId)();
    const mutation = (0, _useSetbookmarkMutation.useSetBookmarkMutation)(props.onSaveSuccess);
    const is_name_empty = name.length <= 0;
    const is_name_too_long = name.length > (0, _constants.Constants).EVENT_TEMPLATE_NAME_LIMITS.max;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "flex flex-col gap-2",
        onSubmit: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            mutation.mutate({
                ...props.save_props,
                guild_id: server_id,
                name: name
            });
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                input_props: {
                    placeholder: "Template name",
                    value: name,
                    onChange: (e)=>{
                        setName(e.currentTarget.value);
                    },
                    type: "submit",
                    autoFocus: true
                },
                error_text: is_name_empty ? "can not be empty" : is_name_too_long ? "character limit reached" : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto w-fit",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    className: "flex items-center gap-2",
                    disabled: is_name_empty || is_name_too_long || props.is_full,
                    is_loading: mutation.isLoading,
                    type: "submit",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-star"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: props.is_full ? "Favorites Full" : props.label
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../common/constants":"lLiun","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_text_input":"befXR","../hooks/use_server_id":"d0sLH","../hooks/use_setbookmark_mutation":"h82m1","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h82m1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSetBookmarkMutation", ()=>useSetBookmarkMutation);
var _trpc = require("../../../utils/trpc");
var _useServerId = require("./use_server_id");
function useSetBookmarkMutation(onSuccess) {
    const context = (0, _trpc.trpc).useContext();
    const server_id = (0, _useServerId.useServerId)();
    return (0, _trpc.trpc).event_template.setBookmark.useMutation({
        onSuccess: (data)=>{
            context.event_template.getBookmarkedList.setData((old_data)=>{
                const new_data = [
                    ...old_data
                ];
                new_data.push(data);
                new_data.sort((a, b)=>new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                return new_data;
            }, {
                guild_id: server_id
            });
            context.event_template.getBookmarkedList.invalidate({
                guild_id: server_id
            });
            onSuccess?.();
        }
    });
}

},{"../../../utils/trpc":"dyYvM","./use_server_id":"d0sLH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4NZkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplatePrevEventList", ()=>EventTemplatePrevEventList);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _useServerId = require("../hooks/use_server_id");
var _eventTemplateList = require("./event_template_list");
var _eventTemplateModalRow = require("./event_template_modal_row");
var _eventTemplateSaveFavoriteInput = require("./event_template_save_favorite_input");
function EventTemplatePrevEventList(props) {
    const server_id = (0, _useServerId.useServerId)();
    const context = (0, _trpc.trpc).useContext();
    const [favoriting_event, setFavoritingEvent] = (0, _react.useState)(null);
    const [favoriting_event_name, setFavoritingEventName] = (0, _react.useState)("");
    // Have to cast this to any because useInfiniteQuery only appears if we have strict mode enabled
    const event_list_query = (0, _trpc.trpc).event.list.useInfiniteQuery({
        guild_id: server_id,
        include_completed: true,
        search: props.search,
        cursor: 0,
        sort: {
            type: "Created",
            direction: "DESC"
        }
    }, {
        getNextPageParam: (lastPage)=>lastPage.next_page,
        refetchOnWindowFocus: false,
        cacheTime: Infinity
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateList.EventTemplateList), {
                list_query: event_list_query,
                itemCreator: (item)=>{
                    const existing_bookmark = context.event_template.getBookmarkedList.getData({
                        guild_id: server_id
                    })?.find((val)=>val.json.event_message_id === item.message_id && val.event_edit_version === item.edit_version);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateModalRow.EventTemplateModalRow), {
                        are_bookmarks_full: props.are_bookmarks_full,
                        item_id: item.message_id,
                        bookmark_id: existing_bookmark?.id,
                        item_name: item.name,
                        author_id: item.author_id,
                        created_at: (0, _luxon.DateTime).fromJSDate(new Date(item.created_at_str)),
                        selected_template: props.selected_template,
                        onFavoriteClicked: ()=>{
                            setFavoritingEvent(item);
                            setFavoritingEventName(item.name);
                        // mutation.mutate({
                        // 	message_id: item.message_id,
                        // });
                        },
                        onUseClick: ()=>props.onUseClick({
                                message_id: item.message_id,
                                name: item.name
                            }),
                        onRowClick: ()=>props.setSelectedTemplate({
                                message_id: item.message_id,
                                name: item.name
                            }),
                        onInfoClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            props.setSelectedInfoTemplate({
                                message_id: item.message_id,
                                name: item.name
                            });
                        },
                        info_text: existing_bookmark ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "flex gap-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-star"
                                    }, "star"),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "",
                                        children: [
                                            "Favorited as",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-semibold",
                                                children: existing_bookmark.name
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : undefined,
                        is_event_list: true
                    });
                }
            }),
            favoriting_event && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                title: "Favoriting Template",
                subtitle: "Template will be accessible to everyone in the server",
                is_active: true,
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col gap-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateSaveFavoriteInput.EventTemplateSaveFavoriteInput), {
                        is_full: props.are_bookmarks_full,
                        initial_name: favoriting_event.name,
                        save_props: {
                            message_id: favoriting_event.message_id
                        },
                        onSaveSuccess: ()=>setFavoritingEvent(null),
                        label: "Favorite"
                    })
                }),
                onClose: ()=>setFavoritingEvent(null)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../hooks/use_server_id":"d0sLH","./event_template_list":"dGzHv","./event_template_modal_row":"6YsUq","./event_template_save_favorite_input":"bSD2G","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5ldxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventThreadAccordian", ()=>EventThreadAccordian);
parcelHelpers.export(exports, "EventThreadDisplay", ()=>EventThreadDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonUtils = require("../../../../../common/common_utils");
var _constants = require("../../../../../common/constants");
var _seshTypes = require("../../../../../common/sesh_types");
var _dashboardUtils = require("../../dashboard_utils");
var _autocompleteInput = require("./autocomplete_input/autocomplete_input");
var _modifySettingsButton = require("./base_components/modify_settings_button");
var _seshAddonInput = require("./base_components/sesh_addon_input");
var _seshSelectInput = require("./base_components/sesh_select_input");
var _seshTextInput = require("./base_components/sesh_text_input");
var _errorNote = require("./error_note");
var _seshAccordianComponent = require("./sesh_accordian_component/sesh_accordian_component");
var _infoTooltip = require("./tooltips/info_tooltip");
function getEphemeralValue(value, default_value) {
    return value ?? default_value ?? {
        name: (0, _constants.Constants).EVENT_NAME_PLACEHOLDER,
        auto_archive_duration: (0, _seshTypes.SeshThreadAutoArchiveDuration).OneDay,
        should_auto_join_attendees_on_rsvp: true,
        should_send_start_message_to_thread: true
    };
}
function EventThreadAccordian(props) {
    const [is_open, setIsOpen] = (0, _react.useState)(!!props.value);
    const [ephemeral_value, setEphemeralValue] = (0, _react.useState)(getEphemeralValue(props.value, props.revert_descriptor?.default?.value));
    if (!props.error && !props.value && is_open) setIsOpen(false);
    const label = props.type === "EventCreation" ? "Create Thread for Event" : "Create Thread for Events";
    const info = props.type === "EventCreation" ? "Create a thread for this event as soon as it is created" : "Create a thread for every event";
    const error_note = props.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
        error: props.error
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
        is_opened: is_open,
        label: label,
        info: info,
        is_beta: true,
        is_unsaved: props.is_unsaved,
        is_loading: props.is_loading,
        is_channel_override_active: props.is_channel_override_active,
        is_new: true,
        revert_descriptor: props.revert_descriptor ? {
            ...props.revert_descriptor,
            onRevertPressed: ()=>{
                props.revert_descriptor.onRevertPressed();
                setEphemeralValue(getEphemeralValue(undefined, props.revert_descriptor?.default?.value));
                setIsOpen(!!props.revert_descriptor.default.value);
            }
        } : undefined,
        onChange: (isOpen)=>{
            setIsOpen(isOpen);
            if (props.error) {
                props.onUpdate(undefined);
                return;
            }
            if (!isOpen) props.onUpdate(undefined);
            else props.onUpdate(ephemeral_value);
        },
        disabled: props.disabled,
        closed_element: props.show_on_closed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "cursor-not-allowed opacity-25",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "disable-pointer-events",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventThreadDisplay, {
                    event_name: props.event_name,
                    start_time: props.start_time,
                    guild_timezone: props.guild_timezone,
                    value: ephemeral_value,
                    onUpdate: (val)=>{},
                    disabled: true
                })
            })
        }) : undefined,
        children: props.error ? error_note : /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventThreadDisplay, {
            event_name: props.event_name,
            start_time: props.start_time,
            guild_timezone: props.guild_timezone,
            value: props.value,
            onUpdate: (val)=>{
                if (!is_open) return;
                setEphemeralValue(val);
                props.onUpdate(val);
            },
            disabled: props.disabled
        })
    });
}
function EventThreadDisplay(props) {
    const [is_modal_open, setIsModalOpen] = (0, _react.useState)(false);
    const start_time = props.start_time ? (0, _luxon.DateTime).fromJSDate(props.start_time) : undefined;
    const parsed_event_name = (0, _commonUtils.common_utils).replacePlaceholders("ThreadTitle", props.value?.name ?? "", {
        event_name: props.event_name,
        event_link: undefined,
        start_time: start_time,
        timezone: props.guild_timezone,
        duration_ms: start_time?.diffNow().milliseconds,
        rsvp_options: undefined
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sesh-dark",
                                children: "Thread Title"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                title: parsed_event_name,
                                children: (0, _dashboardUtils.DashboardUtils).LimitName(parsed_event_name, 16)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sesh-dark",
                                children: "Add on RSVP"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: props.value.should_auto_join_attendees_on_rsvp ? "Enabled" : "Disabled"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sesh-dark",
                                children: "Event Start Message"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: props.value.should_send_start_message_to_thread ? "Thread" : "Channel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sesh-dark",
                                children: "Archive Time"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: AutoArchiveDurationToLabel[props.value.auto_archive_duration]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                className: "mt-4",
                disabled: props.disabled,
                onClick: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    if (props.disabled) return;
                    setIsModalOpen(true);
                },
                children: "Modify"
            }),
            is_modal_open && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventThreadModal, {
                ...props,
                closeModal: ()=>setIsModalOpen(false)
            })
        ]
    });
}
function EventThreadModal(props) {
    const [state, setState] = (0, _react.useState)(props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            props.closeModal();
        },
        title: "Event Thread",
        //subtitle={subtitle}
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "event-thread-modal",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventThreadTitleInput, {
                        value: state.name,
                        onUpdate: (name)=>setState({
                                ...state,
                                name: name
                            })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutoJoinAttendeesInput, {
                        value: state.should_auto_join_attendees_on_rsvp,
                        onUpdate: (val)=>setState({
                                ...state,
                                should_auto_join_attendees_on_rsvp: val
                            })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SendEventStartMessageToThreadInput, {
                        value: state.should_send_start_message_to_thread,
                        onUpdate: (val)=>setState({
                                ...state,
                                should_send_start_message_to_thread: val
                            })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventThreadDurationInput, {
                        value: state.auto_archive_duration,
                        onUpdate: (val)=>setState({
                                ...state,
                                auto_archive_duration: val
                            })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "is-pulled-right mt-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `button dashboard-primary-button--tiny is-size-6 has-text-right`,
                        type: "button",
                        disabled: state.name.length === 0,
                        onClick: ()=>{
                            props.onUpdate(state);
                            props.closeModal();
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "has-text-weight-bold",
                            children: "Save Thread Settings"
                        })
                    })
                })
            ]
        })
    });
}
const AutoArchiveDurationToLabel = {
    [(0, _seshTypes.SeshThreadAutoArchiveDuration).OneDay]: "One Day",
    [(0, _seshTypes.SeshThreadAutoArchiveDuration).OneHour]: "One Hour",
    [(0, _seshTypes.SeshThreadAutoArchiveDuration).OneWeek]: "One Week",
    [(0, _seshTypes.SeshThreadAutoArchiveDuration).ThreeDays]: "Three Days"
};
function EventThreadDurationInput(props) {
    const options = [];
    // Remove numbers from keys
    const keys = Object.keys((0, _seshTypes.SeshThreadAutoArchiveDuration)).filter((val)=>Number.isNaN(Number(val)));
    for (const archive_duration of keys){
        const casted_key = archive_duration;
        options.push({
            label: AutoArchiveDurationToLabel[(0, _seshTypes.SeshThreadAutoArchiveDuration)[casted_key]],
            value: (0, _seshTypes.SeshThreadAutoArchiveDuration)[casted_key]
        });
    }
    const value = options.find((val)=>val.value === props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSelectInput.SeshSelect), {
        label: "Auto Archive Duration",
        options: options,
        value: value,
        onChange: (val)=>props.onUpdate(val.value)
    });
}
function AutoJoinAttendeesInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                "Add Attendees on RSVP",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                    info: "If enabled, users who RSVP to an 'Is Attendee' role will be automatically invited to the thread. To modify what RSVP option is considered an attendee or not, go to the 'RSVP Options' section."
                })
            ]
        }),
        value: props.value,
        setValue: props.onUpdate,
        buttons: [
            {
                label: "Enabled",
                value: true
            },
            {
                label: "Disabled",
                value: false
            }
        ]
    });
}
function SendEventStartMessageToThreadInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
        label: "Event Notification Destination",
        value: props.value,
        setValue: props.onUpdate,
        buttons: [
            {
                label: "Thread",
                value: true
            },
            {
                label: "Channel",
                value: false
            }
        ]
    });
}
function EventThreadTitleInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
        label: "Thread Title",
        input_element_override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteInput.AutocompleteInput), {
            placeholder: "Title",
            value: props.value,
            onChange: (val)=>{
                props.onUpdate(val);
            },
            type: "title",
            char_limit: (0, _constants.Constants).THREAD_TITLE_LIMIT
        }),
        input_props: {},
        help_text: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "",
                children: [
                    "Type ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "command-example--inline",
                        children: "$"
                    }),
                    " ",
                    "for a full list of",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "manual-link",
                        href: (0, _dashboardUtils.DashboardUtils).GetManualLink() + `/placeholders`,
                        target: "_blank",
                        children: "placeholders"
                    }),
                    "."
                ]
            })
        }),
        error_text: props.value.length === 0 ? "Must not be empty" : undefined
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","../../../../../common/common_utils":"gACUC","../../../../../common/constants":"lLiun","../../../../../common/sesh_types":"aUAOg","../../dashboard_utils":"jvA8A","./autocomplete_input/autocomplete_input":"cjDV5","./base_components/modify_settings_button":"kbhTg","./base_components/sesh_addon_input":"pd6di","./base_components/sesh_select_input":"8Vo8B","./base_components/sesh_text_input":"befXR","./error_note":"kzA14","./sesh_accordian_component/sesh_accordian_component":"GAskf","./tooltips/info_tooltip":"93rAL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cjDV5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutocompleteInput", ()=>AutocompleteInput);
var _jsxRuntime = require("react/jsx-runtime");
var _reactTextareaAutocomplete = require("@webscopeio/react-textarea-autocomplete");
var _reactTextareaAutocompleteDefault = parcelHelpers.interopDefault(_reactTextareaAutocomplete);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _commonUtils = require("../../../../../../common/common_utils");
function AutocompleteInput(props) {
    const data = Object.keys((0, _commonUtils.common_utils).PlaceholderTokens).filter((val)=>props.type === "title" ? !(0, _commonUtils.common_utils).PlaceholderTokens[val].not_allowed_in_title : true).map((val)=>val.substring(1));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextareaAutocompleteDefault.default), {
        placeholder: props.placeholder,
        maxLength: props.char_limit,
        value: props.value,
        onChange: (e)=>{
            props.onChange(e.target.value);
        },
        onKeyPress: (e)=>{
            if (props.type === "description") return;
            if (e.key === "Enter") e.preventDefault();
        },
        rows: props.type === "description" ? 5 : 1,
        listClassName: "relative",
        dropdownClassName: "absolute bg-base-light z-[1002] text-white mt-6 shadow-lg rounded-sm border-sesh-hover border max-h-52 overflow-auto",
        containerClassName: "relative",
        loadingComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Loading"
            }),
        // wrap={props.type === "text" ? "off" : undefined}
        className: (0, _classnamesDefault.default)("input relative", {
            "resize-none overflow-y-hidden": props.type === "title",
            textarea: props.type === "description"
        }),
        renderToBody: true,
        minChar: 0,
        trigger: {
            $: {
                component: ({ selected, entity })=>{
                    const description = (0, _commonUtils.common_utils).PlaceholderTokens["$" + entity]?.description;
                    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("flex flex-col px-2 py-1 text-sm", {
                            "bg-sesh-primary text-black": selected
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: typeof entity === 'string' ? entity : JSON.stringify(entity)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-xs opacity-70",
                                children: description
                            })
                        ]
                    });
                    // @ts-ignore - React 18 type strictness workaround
                    return content;
                },
                dataProvider: (token)=>{
                    return data.filter((item)=>item.toLowerCase().startsWith(token.toLowerCase()));
                },
                output: (item, trigger)=>`$${item}`
            }
        }
    });
}

},{"react/jsx-runtime":"dpQXr","@webscopeio/react-textarea-autocomplete":"4rJ0N","classnames":"7uztA","../../../../../../common/common_utils":"gACUC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4rJ0N":[function(require,module,exports,__globalThis) {
/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2017 Jakub Beneš <benes@webscope.io>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _textareaCaret = require("textarea-caret");
var _textareaCaretDefault = parcelHelpers.interopDefault(_textareaCaret);
var _customEvent = require("custom-event");
var _customEventDefault = parcelHelpers.interopDefault(_customEvent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof2(obj) {
        return typeof obj;
    };
    else _typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof2(obj);
}
function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") _typeof = function _typeof(obj) {
        return _typeof2(obj);
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
    return _typeof(obj);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var KEY_CODES = {
    ESC: 27,
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    ENTER: 13,
    TAB: 9
}; // This is self-made key shortcuts manager, used for caching key strokes
var Listener = function Listener() {
    var _this = this;
    _classCallCheck(this, Listener);
    this.startListen = function(ref) {
        if (!ref) return;
        ref.addEventListener("keydown", _this.f);
    };
    this.stopListen = function(ref) {
        if (!ref) return;
        ref.removeEventListener("keydown", _this.f);
    };
    this.add = function(keyCodes, fn) {
        var keyCode = keyCodes;
        if (typeof keyCode !== "object") keyCode = [
            keyCode
        ];
        _this.listeners[_this.index] = {
            keyCode: keyCode,
            fn: fn
        };
        return _this.index++;
    };
    this.remove = function(id) {
        delete _this.listeners[id];
    };
    this.removeAll = function() {
        _this.listeners = {};
        _this.index = 1;
    };
    this.index = 1;
    this.listeners = {};
    this.f = function(e) {
        if (!e) return;
        var code = e.keyCode || e.which;
        Object.values(_this.listeners).forEach(function(_ref) {
            var keyCode = _ref.keyCode, fn = _ref.fn;
            if (keyCode.includes(code)) {
                e.stopPropagation();
                e.preventDefault();
                fn(e);
            }
        });
    };
};
var Listeners = new Listener();
var Item = /*#__PURE__*/ function(_React$Component) {
    _inherits(Item, _React$Component);
    function Item() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Item);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Item)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.selectItem = function() {
            var _this$props = _this.props, item = _this$props.item, onSelectHandler = _this$props.onSelectHandler;
            onSelectHandler(item);
        };
        return _this;
    }
    _createClass(Item, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.item !== nextProps.item || this.props.selected !== nextProps.selected || this.props.style !== nextProps.style || this.props.className !== nextProps.className) return true;
                return false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, Component = _this$props2.component, style = _this$props2.style, onClickHandler = _this$props2.onClickHandler, item = _this$props2.item, selected = _this$props2.selected, className = _this$props2.className, innerRef = _this$props2.innerRef;
                return (0, _reactDefault.default).createElement("li", {
                    className: "rta__item  ".concat(selected === true ? "rta__item--selected" : "", " ").concat(className || ""),
                    style: style
                }, (0, _reactDefault.default).createElement("div", {
                    className: "rta__entity ".concat(selected === true ? "rta__entity--selected" : ""),
                    role: "button",
                    tabIndex: 0,
                    onClick: onClickHandler,
                    onFocus: this.selectItem,
                    onMouseEnter: this.selectItem,
                    onTouchStart: function onTouchStart() {
                        _this2.clicked = true;
                        _this2.selectItem();
                    },
                    onTouchEnd: function onTouchEnd(e) {
                        e.preventDefault();
                        if (_this2.clicked) onClickHandler(e);
                    },
                    onTouchMove: function onTouchMove() {
                        _this2.clicked = false;
                    },
                    onTouchCancel: function onTouchCancel() {
                        _this2.clicked = false;
                    },
                    ref: innerRef
                }, (0, _reactDefault.default).createElement(Component, {
                    selected: selected,
                    entity: item
                })));
            }
        }
    ]);
    return Item;
}((0, _reactDefault.default).Component);
var List = /*#__PURE__*/ function(_React$Component) {
    _inherits(List, _React$Component);
    function List() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            selectedItem: null
        };
        _this.cachedIdOfItems = new Map();
        _this.onPressEnter = function(e) {
            if (typeof e !== "undefined") e.preventDefault();
            var values = _this.props.values;
            _this.modifyText(values[_this.getPositionInList()]);
        };
        _this.getPositionInList = function() {
            var values = _this.props.values;
            var selectedItem = _this.state.selectedItem;
            if (!selectedItem) return 0;
            return values.findIndex(function(a) {
                return _this.getId(a) === _this.getId(selectedItem);
            });
        };
        _this.getId = function(item) {
            if (_this.cachedIdOfItems.has(item)) // $FlowFixMe
            return _this.cachedIdOfItems.get(item);
            var textToReplace = _this.props.getTextToReplace(item);
            var computeId = function computeId() {
                if (textToReplace) {
                    if (textToReplace.key) return textToReplace.key;
                    if (typeof item === "string" || !item.key) return textToReplace.text;
                }
                if (!item.key) throw new Error("Item ".concat(JSON.stringify(item), " has to have defined \"key\" property"));
                 // $FlowFixMe
                return item.key;
            };
            var id = computeId();
            _this.cachedIdOfItems.set(item, id);
            return id;
        };
        _this.listeners = [];
        _this.itemsRef = {};
        _this.modifyText = function(value) {
            if (!value) return;
            var onSelect = _this.props.onSelect;
            onSelect(value);
        };
        _this.selectItem = function(item) {
            var keyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var onItemHighlighted = _this.props.onItemHighlighted;
            if (_this.state.selectedItem === item) return;
            _this.setState({
                selectedItem: item
            }, function() {
                onItemHighlighted(item);
                if (keyboard) _this.props.dropdownScroll(_this.itemsRef[_this.getId(item)]);
            });
        };
        _this.scroll = function(e) {
            e.preventDefault();
            var values = _this.props.values;
            var code = e.keyCode || e.which;
            var oldPosition = _this.getPositionInList();
            var newPosition;
            switch(code){
                case KEY_CODES.DOWN:
                    newPosition = oldPosition + 1;
                    break;
                case KEY_CODES.UP:
                    newPosition = oldPosition - 1;
                    break;
                default:
                    newPosition = oldPosition;
                    break;
            }
            newPosition = (newPosition % values.length + values.length) % values.length; // eslint-disable-line
            _this.selectItem(values[newPosition], [
                KEY_CODES.DOWN,
                KEY_CODES.UP
            ].includes(code));
        };
        _this.isSelected = function(item) {
            var selectedItem = _this.state.selectedItem;
            if (!selectedItem) return false;
            return _this.getId(selectedItem) === _this.getId(item);
        };
        return _this;
    }
    _createClass(List, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.listeners.push(Listeners.add([
                    KEY_CODES.DOWN,
                    KEY_CODES.UP
                ], this.scroll), Listeners.add([
                    KEY_CODES.ENTER,
                    KEY_CODES.TAB
                ], this.onPressEnter));
                var values = this.props.values;
                if (values && values[0]) this.selectItem(values[0]);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(_ref) {
                var _this2 = this;
                var oldValues = _ref.values;
                var values = this.props.values;
                var oldValuesSerialized = oldValues.map(function(val) {
                    return _this2.getId(val);
                }).join("");
                var newValuesSerialized = values.map(function(val) {
                    return _this2.getId(val);
                }).join("");
                if (oldValuesSerialized !== newValuesSerialized && values && values[0]) this.selectItem(values[0]);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var listener;
                while(this.listeners.length){
                    listener = this.listeners.pop();
                    Listeners.remove(listener);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props = this.props, values = _this$props.values, component = _this$props.component, style = _this$props.style, itemClassName = _this$props.itemClassName, className = _this$props.className, itemStyle = _this$props.itemStyle;
                return (0, _reactDefault.default).createElement("ul", {
                    className: "rta__list ".concat(className || ""),
                    style: style
                }, values.map(function(item) {
                    return (0, _reactDefault.default).createElement(Item, {
                        key: _this3.getId(item),
                        innerRef: function innerRef(ref) {
                            _this3.itemsRef[_this3.getId(item)] = ref;
                        },
                        selected: _this3.isSelected(item),
                        item: item,
                        className: itemClassName,
                        style: itemStyle,
                        onClickHandler: _this3.onPressEnter,
                        onSelectHandler: _this3.selectItem,
                        component: component
                    });
                }));
            }
        }
    ]);
    return List;
}((0, _reactDefault.default).Component);
function defaultScrollToItem(container, item) {
    var itemHeight = parseInt(getComputedStyle(item).getPropertyValue("height"), 10);
    var containerHight = parseInt(getComputedStyle(container).getPropertyValue("height"), 10) - itemHeight;
    var itemOffsetTop = item.offsetTop;
    var actualScrollTop = container.scrollTop;
    if (itemOffsetTop < actualScrollTop + containerHight && actualScrollTop < itemOffsetTop) return;
     // eslint-disable-next-line
    container.scrollTop = itemOffsetTop;
}
var DEFAULT_CARET_POSITION = "next";
var POSITION_CONFIGURATION = {
    X: {
        LEFT: "rta__autocomplete--left",
        RIGHT: "rta__autocomplete--right"
    },
    Y: {
        TOP: "rta__autocomplete--top",
        BOTTOM: "rta__autocomplete--bottom"
    }
};
var errorMessage = function errorMessage(message) {
    return console.error("RTA: dataProvider fails: ".concat(message, "\n    \nCheck the documentation or create issue if you think it's bug. https://github.com/webscopeio/react-textarea-autocomplete/issues"));
};
var reservedRegexChars = [
    ".",
    "^",
    "$",
    "*",
    "+",
    "-",
    "?",
    "(",
    ")",
    "[",
    "]",
    "{",
    "}",
    "\\",
    "|"
];
var escapeRegex = function escapeRegex(text) {
    return _toConsumableArray(text).map(function(character) {
        return reservedRegexChars.includes(character) ? "\\".concat(character) : character;
    }).join("");
}; // The main purpose of this component is to figure out to which side the autocomplete should be opened
var Autocomplete = /*#__PURE__*/ function(_React$Component) {
    _inherits(Autocomplete, _React$Component);
    function Autocomplete() {
        _classCallCheck(this, Autocomplete);
        return _possibleConstructorReturn(this, _getPrototypeOf(Autocomplete).apply(this, arguments));
    }
    _createClass(Autocomplete, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var boundariesElement = this.props.boundariesElement;
                if (typeof boundariesElement === "string") {
                    var elem = document.querySelector(boundariesElement);
                    if (!elem) throw new Error("RTA: Invalid prop boundariesElement: it has to be string or HTMLElement.");
                    this.containerElem = elem;
                } else if (boundariesElement instanceof HTMLElement) this.containerElem = boundariesElement;
                else throw new Error("RTA: Invalid prop boundariesElement: it has to be string or HTMLElement.");
                if (!this.containerElem || !this.containerElem.contains(this.ref)) throw new Error("RTA: Invalid prop boundariesElement: it has to be one of the parents of the RTA.");
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$ref$classList, _this$ref$classList2;
                var top = this.props.top || 0;
                var left = this.props.left || 0;
                var usedClasses = [];
                var unusedClasses = [];
                var topPosition = 0;
                var leftPosition = 0;
                var containerBounds = this.containerElem.getBoundingClientRect();
                var dropdownBounds = this.ref.getBoundingClientRect();
                var textareaBounds = this.props.textareaRef.getBoundingClientRect();
                var computedStyle = window.getComputedStyle(this.ref);
                var marginTop = parseInt(computedStyle.getPropertyValue("margin-top"), 10);
                var marginBottom = parseInt(computedStyle.getPropertyValue("margin-bottom"), 10);
                var marginLeft = parseInt(computedStyle.getPropertyValue("margin-left"), 10);
                var marginRight = parseInt(computedStyle.getPropertyValue("margin-right"), 10);
                var dropdownBottom = marginTop + marginBottom + textareaBounds.top + top + dropdownBounds.height;
                var dropdownRight = marginLeft + marginRight + textareaBounds.left + left + dropdownBounds.width;
                if (dropdownRight > containerBounds.right && textareaBounds.left + left > dropdownBounds.width) {
                    leftPosition = left - dropdownBounds.width;
                    usedClasses.push(POSITION_CONFIGURATION.X.LEFT);
                    unusedClasses.push(POSITION_CONFIGURATION.X.RIGHT);
                } else {
                    leftPosition = left;
                    usedClasses.push(POSITION_CONFIGURATION.X.RIGHT);
                    unusedClasses.push(POSITION_CONFIGURATION.X.LEFT);
                }
                if (dropdownBottom > containerBounds.bottom && textareaBounds.top + top > dropdownBounds.height) {
                    topPosition = top - dropdownBounds.height;
                    usedClasses.push(POSITION_CONFIGURATION.Y.TOP);
                    unusedClasses.push(POSITION_CONFIGURATION.Y.BOTTOM);
                } else {
                    topPosition = top;
                    usedClasses.push(POSITION_CONFIGURATION.Y.BOTTOM);
                    unusedClasses.push(POSITION_CONFIGURATION.Y.TOP);
                }
                if (this.props.renderToBody) {
                    topPosition += textareaBounds.top;
                    leftPosition += textareaBounds.left;
                }
                this.ref.style.top = "".concat(topPosition, "px");
                this.ref.style.left = "".concat(leftPosition, "px");
                (_this$ref$classList = this.ref.classList).remove.apply(_this$ref$classList, unusedClasses);
                (_this$ref$classList2 = this.ref.classList).add.apply(_this$ref$classList2, usedClasses);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, innerRef = _this$props.innerRef, children = _this$props.children, renderToBody = _this$props.renderToBody;
                var body = document.body;
                var autocompleteContainer = (0, _reactDefault.default).createElement("div", {
                    ref: function ref(_ref) {
                        // $FlowFixMe
                        _this.ref = _ref; // $FlowFixMe
                        innerRef(_ref);
                    },
                    className: "rta__autocomplete ".concat(className || ""),
                    style: style
                }, children);
                return renderToBody && body !== null ? (0, _reactDomDefault.default).createPortal(autocompleteContainer, body) : autocompleteContainer;
            }
        }
    ]);
    return Autocomplete;
}((0, _reactDefault.default).Component);
var ReactTextareaAutocomplete = /*#__PURE__*/ function(_React$Component2) {
    _inherits(ReactTextareaAutocomplete, _React$Component2);
    function ReactTextareaAutocomplete(_props) {
        var _this2;
        _classCallCheck(this, ReactTextareaAutocomplete);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReactTextareaAutocomplete).call(this, _props));
        _this2.state = {
            top: null,
            left: null,
            currentTrigger: null,
            actualToken: "",
            data: null,
            value: "",
            dataLoading: false,
            selectionEnd: 0,
            component: null,
            textToReplace: null
        };
        _this2.escListenerInit = function() {
            if (!_this2.escListener) _this2.escListener = Listeners.add(KEY_CODES.ESC, _this2._closeAutocomplete);
        };
        _this2.escListenerDestroy = function() {
            if (_this2.escListener) {
                Listeners.remove(_this2.escListener);
                _this2.escListener = null;
            }
        };
        _this2.getSelectionPosition = function() {
            if (!_this2.textareaRef) return null;
            return {
                selectionStart: _this2.textareaRef.selectionStart,
                selectionEnd: _this2.textareaRef.selectionEnd
            };
        };
        _this2.getSelectedText = function() {
            if (!_this2.textareaRef) return null;
            var _this2$textareaRef = _this2.textareaRef, selectionStart = _this2$textareaRef.selectionStart, selectionEnd = _this2$textareaRef.selectionEnd;
            if (selectionStart === selectionEnd) return null;
            return _this2.state.value.substr(selectionStart, selectionEnd - selectionStart);
        };
        _this2.setCaretPosition = function() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            if (!_this2.textareaRef) return;
            _this2.textareaRef.focus();
            _this2.textareaRef.setSelectionRange(position, position);
        };
        _this2.getCaretPosition = function() {
            if (!_this2.textareaRef) return 0;
            var position = _this2.textareaRef.selectionEnd;
            return position;
        };
        _this2._handleCaretChange = function(e) {
            var cleanLastTrigger = function cleanLastTrigger() {
                var beforeHandle = _this2.getCaretPosition() - 1;
                _this2.lastTrigger = _this2.lastTrigger ? beforeHandle : 0;
            };
            if (e.type === "keydown") {
                // $FlowFixMe
                var code = e.keyCode || e.which;
                switch(code){
                    case KEY_CODES.UP:
                    case KEY_CODES.DOWN:
                        if (!_this2._isAutocompleteOpen()) cleanLastTrigger();
                        break;
                    case KEY_CODES.LEFT:
                    case KEY_CODES.RIGHT:
                        cleanLastTrigger();
                        break;
                    default:
                }
                return;
            }
            cleanLastTrigger();
        };
        _this2._onSelect = function(item) {
            var _this2$state = _this2.state, selectionEnd = _this2$state.selectionEnd, currentTrigger = _this2$state.currentTrigger, textareaValue = _this2$state.value;
            var onItemSelected = _this2.props.onItemSelected;
            if (!currentTrigger) return;
            var getTextToReplaceForCurrentTrigger = _this2._getTextToReplace(currentTrigger);
            if (!getTextToReplaceForCurrentTrigger) {
                _this2._closeAutocomplete();
                return;
            }
            var newToken = getTextToReplaceForCurrentTrigger(item);
            if (!newToken) {
                _this2._closeAutocomplete();
                return;
            }
            if (onItemSelected) onItemSelected({
                currentTrigger: currentTrigger,
                item: item
            });
            var computeCaretPosition = function computeCaretPosition(position, token, startToken) {
                switch(position){
                    case "start":
                        return startToken;
                    case "next":
                    case "end":
                        return startToken + token.length;
                    default:
                        if (!Number.isInteger(position)) throw new Error('RTA: caretPosition should be "start", "next", "end" or number.');
                        return position;
                }
            };
            var textToModify = textareaValue.slice(0, selectionEnd);
            /**
       * It's important to escape the currentTrigger char for chars like [, (,...
       * This is a ridiculous dark magic, basically we found position of the last current token (from current trigger) and then we replace the text from that position (calculating the offset)
       */ var escapedCurrentTrigger = escapeRegex(currentTrigger);
            var triggerOffset = textToModify.length - textToModify.lastIndexOf(currentTrigger);
            var startOfTokenPosition = textToModify.search(new RegExp("(?!".concat(escapedCurrentTrigger, ")$"))) - triggerOffset; // we add space after emoji is selected if a caret position is next
            var newTokenString = newToken.caretPosition === "next" ? "".concat(newToken.text, " ") : newToken.text;
            var newCaretPosition = computeCaretPosition(newToken.caretPosition, newTokenString, startOfTokenPosition);
            var modifiedText = textToModify.substring(0, startOfTokenPosition) + newTokenString;
            var newValue = textareaValue.replace(textToModify, modifiedText); // set the new textarea value and after that set the caret back to its position
            _this2.setState({
                value: newValue,
                dataLoading: false
            }, function() {
                var insertedTrigger = _this2.tokenRegExpEnding.exec(newTokenString);
                var insertedTriggerModifier = insertedTrigger ? insertedTrigger[0].length : 1;
                _this2.lastTrigger = newCaretPosition ? newCaretPosition - insertedTriggerModifier : newCaretPosition;
                _this2.textareaRef.value = newValue;
                _this2.textareaRef.selectionEnd = newCaretPosition;
                _this2._changeHandler();
                var scrollTop = _this2.textareaRef.scrollTop;
                _this2.setCaretPosition(newCaretPosition);
                /*
          Chrome does not maintain scroll position
          Relevant discussion https://github.com/webscopeio/react-textarea-autocomplete/pull/97
        */ if (window.chrome) _this2.textareaRef.scrollTop = scrollTop;
            });
        };
        _this2._getTextToReplace = function(currentTrigger) {
            var triggerSettings = _this2.props.trigger[currentTrigger];
            if (!currentTrigger || !triggerSettings) return null;
            var output = triggerSettings.output;
            return function(item) {
                if (typeof item === "object" && (!output || typeof output !== "function")) throw new Error('Output functor is not defined! If you are using items as object you have to define "output" function. https://github.com/webscopeio/react-textarea-autocomplete#trigger-type');
                if (output) {
                    var textToReplace = output(item, currentTrigger);
                    if (textToReplace === undefined || typeof textToReplace === "number") throw new Error("Output functor should return string or object in shape {text: string, caretPosition: string | number}.\nGot \"".concat(String(textToReplace), "\". Check the implementation for trigger \"").concat(currentTrigger, "\"\n\nSee https://github.com/webscopeio/react-textarea-autocomplete#trigger-type for more information.\n"));
                    if (textToReplace === null) return null;
                    if (typeof textToReplace === "string") return {
                        text: textToReplace,
                        caretPosition: DEFAULT_CARET_POSITION
                    };
                    if (!textToReplace.text && typeof textToReplace.text !== 'string') throw new Error("Output \"text\" is not defined! Object should has shape {text: string, caretPosition: string | number}. Check the implementation for trigger \"".concat(currentTrigger, "\"\n"));
                    if (!textToReplace.caretPosition) throw new Error("Output \"caretPosition\" is not defined! Object should has shape {text: string, caretPosition: string | number}. Check the implementation for trigger \"".concat(currentTrigger, "\"\n"));
                    return textToReplace;
                }
                if (typeof item !== "string") throw new Error("Output item should be string\n");
                return {
                    text: "".concat(currentTrigger).concat(item).concat(currentTrigger),
                    caretPosition: DEFAULT_CARET_POSITION
                };
            };
        };
        _this2._getCurrentTriggerSettings = function() {
            var currentTrigger = _this2.state.currentTrigger;
            if (!currentTrigger) return null;
            return _this2.props.trigger[currentTrigger];
        };
        _this2._getValuesFromProvider = function() {
            var _this2$state2 = _this2.state, currentTrigger = _this2$state2.currentTrigger, actualToken = _this2$state2.actualToken;
            var triggerSettings = _this2._getCurrentTriggerSettings();
            if (!currentTrigger || !triggerSettings) return;
            var dataProvider = triggerSettings.dataProvider, component = triggerSettings.component;
            if (typeof dataProvider !== "function") throw new Error("Trigger provider has to be a function!");
            _this2.setState({
                dataLoading: true
            });
            var providedData = dataProvider(actualToken);
            if (!(providedData instanceof Promise)) providedData = Promise.resolve(providedData);
            providedData.then(function(data) {
                if (!Array.isArray(data)) throw new Error("Trigger provider has to provide an array!");
                if (typeof component !== "function") throw new Error("Component should be defined!");
                 // throw away if we resolved old trigger
                if (currentTrigger !== _this2.state.currentTrigger) return; // if we haven't resolved any data let's close the autocomplete
                if (!data.length) {
                    _this2._closeAutocomplete();
                    return;
                }
                _this2.setState({
                    dataLoading: false,
                    data: data,
                    component: component
                });
            }).catch(function(e) {
                return errorMessage(e.message);
            });
        };
        _this2._getSuggestions = function() {
            var _this2$state3 = _this2.state, currentTrigger = _this2$state3.currentTrigger, data = _this2$state3.data;
            if (!currentTrigger || !data || data && !data.length) return null;
            return data;
        };
        _this2._createRegExp = function() {
            var trigger = _this2.props.trigger; // negative lookahead to match only the trigger + the actual token = "bladhwd:adawd:word test" => ":word"
            // https://stackoverflow.com/a/8057827/2719917
            _this2.tokenRegExp = new RegExp("(".concat(Object.keys(trigger) // the sort is important for multi-char combos as "/kick", "/"
            .sort(function(a, b) {
                if (a < b) return 1;
                if (a > b) return -1;
                return 0;
            }).map(function(a) {
                return escapeRegex(a);
            }).join("|"), ")((?:(?!\\1)[^\\s])*$)"));
            _this2.tokenRegExpEnding = new RegExp("(".concat(Object.keys(trigger) // the sort is important for multi-char combos as "/kick", "/"
            .sort(function(a, b) {
                if (a < b) return 1;
                if (a > b) return -1;
                return 0;
            }).map(function(a) {
                return escapeRegex(a);
            }).join("|"), ")$"));
        };
        _this2._closeAutocomplete = function() {
            var currentTrigger = _this2.state.currentTrigger;
            _this2.escListenerDestroy();
            _this2.setState({
                data: null,
                dataLoading: false,
                currentTrigger: null
            }, function() {
                if (currentTrigger) _this2._onItemHighlightedHandler(null);
            });
        };
        _this2._cleanUpProps = function() {
            var props = _objectSpread({}, _this2.props);
            var notSafe = [
                "loadingComponent",
                "boundariesElement",
                "containerStyle",
                "minChar",
                "scrollToItem",
                "ref",
                "innerRef",
                "onChange",
                "onCaretPositionChange",
                "className",
                "value",
                "trigger",
                "listStyle",
                "itemStyle",
                "containerStyle",
                "loaderStyle",
                "className",
                "containerClassName",
                "listClassName",
                "itemClassName",
                "loaderClassName",
                "dropdownStyle",
                "dropdownClassName",
                "movePopupAsYouType",
                "textAreaComponent",
                "renderToBody",
                "onItemSelected",
                "onItemHighlighted"
            ]; // eslint-disable-next-line
            for(var prop in props)if (notSafe.includes(prop)) delete props[prop];
            return props;
        };
        _this2._changeHandler = function(e) {
            var _this2$props = _this2.props, trigger = _this2$props.trigger, onChange = _this2$props.onChange, minChar = _this2$props.minChar, onCaretPositionChange = _this2$props.onCaretPositionChange, movePopupAsYouType = _this2$props.movePopupAsYouType;
            var _this2$state4 = _this2.state, top = _this2$state4.top, left = _this2$state4.left;
            var event = e;
            if (!event) {
                // fire onChange event after successful selection
                event = new (0, _customEventDefault.default)("change", {
                    bubbles: true
                });
                _this2.textareaRef.dispatchEvent(event);
            }
            var textarea = event.target || _this2.textareaRef; // fallback to support Shadow DOM
            var selectionEnd = textarea.selectionEnd;
            var value = textarea.value;
            _this2.lastValueBubbledEvent = value;
            if (onChange && event) {
                event.persist && event.persist();
                onChange(new Proxy(event, {
                    get: function get(original, prop, receiver) {
                        if (prop === "target") return textarea;
                        return Reflect.get(original, prop, receiver);
                    }
                }));
            }
            if (onCaretPositionChange) {
                var caretPosition = _this2.getCaretPosition();
                onCaretPositionChange(caretPosition);
            }
            _this2.setState({
                value: value
            });
            var setTopLeft = function setTopLeft() {
                var _getCaretCoordinates = (0, _textareaCaretDefault.default)(textarea, selectionEnd), newTop = _getCaretCoordinates.top, newLeft = _getCaretCoordinates.left;
                _this2.setState({
                    // make position relative to textarea
                    top: newTop - _this2.textareaRef.scrollTop || 0,
                    left: newLeft
                });
            };
            var cleanLastTrigger = function cleanLastTrigger(triggerLength) {
                _this2.lastTrigger = selectionEnd - triggerLength;
                _this2._closeAutocomplete();
                setTopLeft();
            };
            if (selectionEnd <= _this2.lastTrigger) {
                var _affectedTextareaValue = value.slice(0, selectionEnd);
                var _newTrigger = _this2.tokenRegExp.exec(_affectedTextareaValue);
                cleanLastTrigger(_newTrigger ? _newTrigger[0].length : 0);
            }
            var affectedTextareaValue = value.slice(_this2.lastTrigger, selectionEnd);
            var tokenMatch = _this2.tokenRegExp.exec(affectedTextareaValue);
            var lastToken = tokenMatch && tokenMatch[0];
            var currentTrigger = tokenMatch && tokenMatch[1] || null;
            var currentTriggerLength = currentTrigger ? currentTrigger.length - 1 : 0; // with this approach we want to know if the user just inserted a new trigger sequence
            var newTrigger = _this2.tokenRegExpEnding.exec(affectedTextareaValue);
            if (newTrigger) cleanLastTrigger(newTrigger[0].length);
            else if (!_this2._isAutocompleteOpen()) _this2._closeAutocomplete();
            /*
       if we lost the trigger token or there is no following character we want to close
       the autocomplete
      */ if ((!lastToken || lastToken.length <= minChar + currentTriggerLength) && (_this2.state.currentTrigger && !trigger[_this2.state.currentTrigger].allowWhitespace || !_this2.state.currentTrigger)) {
                _this2._closeAutocomplete();
                return;
            }
            /**
       * This code has to be sync that is the reason why we obtain the currentTrigger
       * from currentTrigger not this.state.currentTrigger
       *
       * Check if the currently typed token has to be afterWhitespace, or not.
       *
       * This setting means that there has to be whitespace before the token (on it has to be the the first character typed into textarea)
       */ if (currentTrigger && trigger[currentTrigger].afterWhitespace && !/\s/.test(value[selectionEnd - lastToken.length - 1]) && value[selectionEnd - lastToken.length - 1] !== undefined) {
                _this2._closeAutocomplete();
                return;
            }
            /**
        If our current trigger allows whitespace
        get the correct token for DataProvider, so we need to construct new RegExp
       */ if (_this2.state.currentTrigger && trigger[_this2.state.currentTrigger].allowWhitespace) {
                tokenMatch = new RegExp("".concat(escapeRegex(_this2.state.currentTrigger), ".*$")).exec(value.slice(0, selectionEnd));
                lastToken = tokenMatch && tokenMatch[0];
                if (!lastToken) {
                    _this2._closeAutocomplete();
                    return;
                }
                currentTrigger = Object.keys(trigger).find(function(a) {
                    return a.slice(0, currentTriggerLength + 1) === lastToken.slice(0, currentTriggerLength + 1);
                }) || null;
            }
            var actualToken = lastToken.slice(1); // if trigger is not configured step out from the function, otherwise proceed
            if (!currentTrigger) return;
            if (movePopupAsYouType || top === null && left === null || // if the trigger got changed, let's reposition the autocomplete
            _this2.state.currentTrigger !== currentTrigger) setTopLeft();
            _this2.escListenerInit();
            var textToReplace = _this2._getTextToReplace(currentTrigger);
            _this2.setState({
                selectionEnd: selectionEnd,
                currentTrigger: currentTrigger,
                textToReplace: textToReplace,
                actualToken: actualToken
            }, function() {
                try {
                    _this2._getValuesFromProvider();
                } catch (err) {
                    errorMessage(err.message);
                }
            });
        };
        _this2._selectHandler = function(e) {
            var _this2$props2 = _this2.props, onCaretPositionChange = _this2$props2.onCaretPositionChange, onSelect = _this2$props2.onSelect;
            if (onCaretPositionChange) {
                var caretPosition = _this2.getCaretPosition();
                onCaretPositionChange(caretPosition);
            }
            if (onSelect) {
                e.persist();
                onSelect(e);
            }
        };
        _this2._shouldStayOpen = function(e) {
            var el = e.relatedTarget; // IE11 doesn't know about `relatedTarget` // https://stackoverflow.com/a/49325196/2719917
            if (el === null) el = document.activeElement;
            if (_this2.dropdownRef && el instanceof Node && _this2.dropdownRef.contains(el)) return true;
            return false;
        };
        _this2._onClick = function(e) {
            var onClick = _this2.props.onClick;
            if (onClick) {
                e.persist();
                onClick(e);
            }
            if (_this2._shouldStayOpen(e)) return;
            _this2._closeAutocomplete();
        };
        _this2._onBlur = function(e) {
            var onBlur = _this2.props.onBlur;
            if (onBlur) {
                e.persist();
                onBlur(e);
            }
            if (_this2._shouldStayOpen(e)) return;
            _this2._closeAutocomplete();
        };
        _this2._onScrollHandler = function() {
            _this2._closeAutocomplete();
        };
        _this2._onItemHighlightedHandler = function(item) {
            var onItemHighlighted = _this2.props.onItemHighlighted;
            var currentTrigger = _this2.state.currentTrigger;
            if (onItemHighlighted) {
                if (typeof onItemHighlighted === "function") onItemHighlighted({
                    currentTrigger: currentTrigger,
                    item: item
                });
                else throw new Error("`onItemHighlighted` has to be a function");
            }
        };
        _this2._dropdownScroll = function(item) {
            var scrollToItem = _this2.props.scrollToItem;
            if (!scrollToItem) return;
            if (scrollToItem === true) {
                defaultScrollToItem(_this2.dropdownRef, item);
                return;
            }
            if (typeof scrollToItem !== "function" || scrollToItem.length !== 2) throw new Error("`scrollToItem` has to be boolean (true for default implementation) or function with two parameters: container, item.");
            scrollToItem(_this2.dropdownRef, item);
        };
        _this2._isAutocompleteOpen = function() {
            var _this2$state5 = _this2.state, dataLoading = _this2$state5.dataLoading, currentTrigger = _this2$state5.currentTrigger;
            var suggestionData = _this2._getSuggestions();
            return !!((dataLoading || suggestionData) && currentTrigger);
        };
        _this2._textareaRef = function(ref) {
            // $FlowFixMe - ref is actually a `?HTMLTextAreaElement`
            _this2.props.innerRef && _this2.props.innerRef(ref);
            _this2.textareaRef = ref;
        };
        _this2.lastTrigger = 0;
        _this2.escListener = null;
        var _this2$props3 = _this2.props, loadingComponent = _this2$props3.loadingComponent, _trigger = _this2$props3.trigger, _value = _this2$props3.value;
        if (_value) _this2.state.value = _value;
        _this2._createRegExp();
        if (!loadingComponent) throw new Error("RTA: loadingComponent is not defined");
        if (!_trigger) throw new Error("RTA: trigger is not defined");
        return _this2;
    }
    _createClass(ReactTextareaAutocomplete, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                Listeners.startListen(this.textareaRef); // handle caret change
                this.textareaRef && this.textareaRef.addEventListener("focus", this._handleCaretChange);
                this.textareaRef && this.textareaRef.addEventListener("click", this._handleCaretChange);
                this.textareaRef && this.textareaRef.addEventListener("keydown", this._handleCaretChange);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(_ref2) {
                var oldTrigger = _ref2.trigger, oldValue = _ref2.value;
                var _this$props2 = this.props, trigger = _this$props2.trigger, value = _this$props2.value;
                if (Object.keys(trigger).join("") !== Object.keys(oldTrigger).join("")) this._createRegExp();
                if (oldValue !== value && this.lastValueBubbledEvent !== value) {
                    this.lastTrigger = 0;
                    this._changeHandler();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.escListenerDestroy();
                Listeners.stopListen(this.textareaRef); // handle caret change
                this.textareaRef && this.textareaRef.removeEventListener("focus", this._handleCaretChange);
                this.textareaRef && this.textareaRef.removeEventListener("click", this._handleCaretChange);
                this.textareaRef && this.textareaRef.removeEventListener("keydown", this._handleCaretChange);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, Loader = _this$props3.loadingComponent, style = _this$props3.style, className = _this$props3.className, listStyle = _this$props3.listStyle, itemStyle = _this$props3.itemStyle, boundariesElement = _this$props3.boundariesElement, movePopupAsYouType = _this$props3.movePopupAsYouType, listClassName = _this$props3.listClassName, itemClassName = _this$props3.itemClassName, dropdownClassName = _this$props3.dropdownClassName, dropdownStyle = _this$props3.dropdownStyle, containerStyle = _this$props3.containerStyle, containerClassName = _this$props3.containerClassName, loaderStyle = _this$props3.loaderStyle, loaderClassName = _this$props3.loaderClassName, textAreaComponent = _this$props3.textAreaComponent, renderToBody = _this$props3.renderToBody;
                var _this$state = this.state, left = _this$state.left, top = _this$state.top, dataLoading = _this$state.dataLoading, component = _this$state.component, value = _this$state.value, textToReplace = _this$state.textToReplace;
                var isAutocompleteOpen = this._isAutocompleteOpen();
                var suggestionData = this._getSuggestions();
                var extraAttrs = {};
                var TextAreaComponent;
                if (textAreaComponent.component) {
                    TextAreaComponent = textAreaComponent.component;
                    extraAttrs[textAreaComponent.ref] = this._textareaRef;
                } else {
                    TextAreaComponent = textAreaComponent;
                    extraAttrs.ref = this._textareaRef;
                }
                return (0, _reactDefault.default).createElement("div", {
                    className: "rta ".concat(dataLoading === true ? "rta--loading" : "", " ").concat(containerClassName || ""),
                    style: containerStyle
                }, (0, _reactDefault.default).createElement(TextAreaComponent, Object.assign({}, this._cleanUpProps(), {
                    className: "rta__textarea ".concat(className || ""),
                    onChange: this._changeHandler,
                    onSelect: this._selectHandler,
                    onScroll: this._onScrollHandler,
                    onClick: this._onClick,
                    onBlur: this._onBlur,
                    value: value,
                    style: style
                }, extraAttrs)), isAutocompleteOpen && (0, _reactDefault.default).createElement(Autocomplete, {
                    innerRef: function innerRef(ref) {
                        // $FlowFixMe
                        _this3.dropdownRef = ref;
                    },
                    top: top,
                    left: left,
                    style: dropdownStyle,
                    className: dropdownClassName,
                    movePopupAsYouType: movePopupAsYouType,
                    boundariesElement: boundariesElement,
                    textareaRef: this.textareaRef,
                    renderToBody: renderToBody
                }, suggestionData && component && textToReplace && (0, _reactDefault.default).createElement(List, {
                    values: suggestionData,
                    component: component,
                    style: listStyle,
                    className: listClassName,
                    itemClassName: itemClassName,
                    itemStyle: itemStyle,
                    getTextToReplace: textToReplace,
                    onItemHighlighted: this._onItemHighlightedHandler,
                    onSelect: this._onSelect,
                    dropdownScroll: this._dropdownScroll
                }), dataLoading && (0, _reactDefault.default).createElement("div", {
                    className: "rta__loader ".concat(suggestionData !== null ? "rta__loader--suggestion-data" : "rta__loader--empty-suggestion-data", " ").concat(loaderClassName || ""),
                    style: loaderStyle
                }, (0, _reactDefault.default).createElement(Loader, {
                    data: suggestionData
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref3) {
                var value = _ref3.value;
                if (value === null || value === undefined) return null;
                return {
                    value: value
                };
            }
        }
    ]);
    return ReactTextareaAutocomplete;
}((0, _reactDefault.default).Component);
ReactTextareaAutocomplete.defaultProps = {
    movePopupAsYouType: false,
    value: null,
    minChar: 1,
    boundariesElement: "body",
    scrollToItem: true,
    textAreaComponent: "textarea",
    renderToBody: false
};
exports.default = ReactTextareaAutocomplete;

},{"react-dom":"fODdr","textarea-caret":"e4Gh1","custom-event":"7OKU8","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e4Gh1":[function(require,module,exports,__globalThis) {
/* jshint browser: true */ (function() {
    // The properties that we copy into a mirrored div.
    // Note that some browsers, such as Firefox,
    // do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
    // so we have to do every single property specifically.
    var properties = [
        'direction',
        'boxSizing',
        'width',
        'height',
        'overflowX',
        'overflowY',
        'borderTopWidth',
        'borderRightWidth',
        'borderBottomWidth',
        'borderLeftWidth',
        'borderStyle',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft',
        // https://developer.mozilla.org/en-US/docs/Web/CSS/font
        'fontStyle',
        'fontVariant',
        'fontWeight',
        'fontStretch',
        'fontSize',
        'fontSizeAdjust',
        'lineHeight',
        'fontFamily',
        'textAlign',
        'textTransform',
        'textIndent',
        'textDecoration',
        'letterSpacing',
        'wordSpacing',
        'tabSize',
        'MozTabSize'
    ];
    var isBrowser = typeof window !== 'undefined';
    var isFirefox = isBrowser && window.mozInnerScreenX != null;
    function getCaretCoordinates(element, position, options) {
        if (!isBrowser) throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
        var debug = options && options.debug || false;
        if (debug) {
            var el = document.querySelector('#input-textarea-caret-position-mirror-div');
            if (el) el.parentNode.removeChild(el);
        }
        // mirrored div
        var div = document.createElement('div');
        div.id = 'input-textarea-caret-position-mirror-div';
        document.body.appendChild(div);
        var style = div.style;
        var computed = window.getComputedStyle ? getComputedStyle(element) : element.currentStyle; // currentStyle for IE < 9
        // default textarea styles
        style.whiteSpace = 'pre-wrap';
        if (element.nodeName !== 'INPUT') style.wordWrap = 'break-word'; // only for textarea-s
        // position off-screen
        style.position = 'absolute'; // required to return coordinates properly
        if (!debug) style.visibility = 'hidden'; // not 'display: none' because we want rendering
        // transfer the element's properties to the div
        properties.forEach(function(prop) {
            style[prop] = computed[prop];
        });
        if (isFirefox) // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
        {
            if (element.scrollHeight > parseInt(computed.height)) style.overflowY = 'scroll';
        } else style.overflow = 'hidden'; // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
        div.textContent = element.value.substring(0, position);
        // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
        if (element.nodeName === 'INPUT') div.textContent = div.textContent.replace(/\s/g, '\u00a0');
        var span = document.createElement('span');
        // Wrapping must be replicated *exactly*, including when a long word gets
        // onto the next line, with whitespace at the end of the line before (#7).
        // The  *only* reliable way to do that is to copy the *entire* rest of the
        // textarea's content into the <span> created at the caret position.
        // for inputs, just '.' would be enough, but why bother?
        span.textContent = element.value.substring(position) || '.'; // || because a completely empty faux span doesn't render at all
        div.appendChild(span);
        var coordinates = {
            top: span.offsetTop + parseInt(computed['borderTopWidth']),
            left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
        };
        if (debug) span.style.backgroundColor = '#aaa';
        else document.body.removeChild(div);
        return coordinates;
    }
    if (typeof module.exports != 'undefined') module.exports = getCaretCoordinates;
    else if (isBrowser) window.getCaretCoordinates = getCaretCoordinates;
})();

},{}],"7OKU8":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var NativeCustomEvent = global.CustomEvent;
function useNative() {
    try {
        var p = new NativeCustomEvent('cat', {
            detail: {
                foo: 'bar'
            }
        });
        return 'cat' === p.type && 'bar' === p.detail.foo;
    } catch (e) {}
    return false;
}
/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */ module.exports = useNative() ? NativeCustomEvent : // IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent(type, params) {
    var e = document.createEvent('CustomEvent');
    if (params) e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    else e.initCustomEvent(type, false, false, void 0);
    return e;
} : // IE <= 8
function CustomEvent(type, params) {
    var e = document.createEventObject();
    e.type = type;
    if (params) {
        e.bubbles = Boolean(params.bubbles);
        e.cancelable = Boolean(params.cancelable);
        e.detail = params.detail;
    } else {
        e.bubbles = false;
        e.cancelable = false;
        e.detail = void 0;
    }
    return e;
};

},{}],"8Vo8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshSelect", ()=>SeshSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
function SeshSelect(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: props.className,
        children: [
            props.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                classNamePrefix: "sesh-dropdown",
                onInputChange: props.onInputChange,
                value: props.value,
                options: props.options,
                onChange: (selected)=>props.onChange(selected),
                isDisabled: props.is_disabled,
                isLoading: props.is_loading
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react-select":"8FQ4W","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kzA14":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorNote", ()=>ErrorNote);
var _jsxRuntime = require("react/jsx-runtime");
function ErrorNote(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "error-note",
            children: props.error
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"GAskf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshAccordianComponent", ()=>SeshAccordianComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _prettyCheckboxReact = require("pretty-checkbox-react");
var _dashboardUtils = require("../../../dashboard_utils");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SeshAccordianComponent(props) {
    const { is_opened, setIsOpened } = props;
    const checkbox = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        // className={`checkbox-wrapper${
        // 	props.should_hide_checkbox ? ` is-invisible` : ""
        // }`}
        className: (0, _classnamesDefault.default)("checkbox-wrapper"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyCheckboxReact.Checkbox), {
            className: "title-checkbox",
            checked: is_opened,
            onChange: (e)=>{
                setIsOpened?.(e.target.checked);
                props.onChange?.(e.target.checked);
            },
            disabled: props.disabled
        })
    });
    const child_element = props.is_loading ? (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber() : props.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)("field", {
            "expanded-collapsible": is_opened,
            "overridden-field": props.is_channel_override_active
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(props.label, props.info, props.does_require_premium && !props.does_server_have_premium, props.is_beta, props.is_unsaved, checkbox, props.disabled, props.is_new, props.revert_descriptor),
                is_opened ? child_element : props.closed_element
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","pretty-checkbox-react":"fcrko","../../../dashboard_utils":"jvA8A","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fcrko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
parcelHelpers.export(exports, "Radio", ()=>Radio);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "useCheckboxState", ()=>useCheckboxState);
parcelHelpers.export(exports, "useRadioState", ()=>useRadioState);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactMergeRefs = require("react-merge-refs");
var _reactMergeRefsDefault = parcelHelpers.interopDefault(_reactMergeRefs);
var _nonSecure = require("nanoid/non-secure");
const INDETERMINATE_STATE = 'indeterminate';
const dispatch = (value)=>(state)=>{
        if (Array.isArray(state)) {
            const index = state.indexOf(value);
            if (index === -1) state.push(value);
            else state.splice(index, 1);
            return [
                ...state
            ];
        } else if (value !== '') return [
            value
        ];
        return !state;
    };
const useCheckboxState = ({ state: initialState = false, onChange } = {})=>{
    const [state, setState] = (0, _react.useState)(()=>{
        if (typeof initialState === 'string' && initialState !== INDETERMINATE_STATE) return [
            initialState
        ];
        return initialState;
    });
    return {
        state,
        setState,
        onChange: (0, _react.useCallback)((e)=>{
            const { value } = e.currentTarget;
            setState(dispatch(value));
            if (typeof onChange === 'function') onChange(e);
        }, [
            onChange
        ])
    };
};
const lockedStyles = {
    pointerEvents: 'none'
};
/**
 * A simplier way to prevent checking when PCR is in locked mode.
 * This is way simplier than controlling the checkbox using
 * event handlers. Supports IE 11+
 */ const useLocked = ({ locked, style })=>{
    if (locked) return {
        ...lockedStyles,
        ...style
    };
    return style;
};
const useIcon = (icon)=>{
    return (0, _react.useMemo)(()=>{
        if (icon) {
            let type = 'icon';
            if (icon.type === 'img') type = 'image';
            else if (icon.type === 'svg') type = 'svg';
            // icons that contain `type` substring
            // won't fail with a word boundary search
            const re = new RegExp(`\\b${type}\\b`);
            return {
                iconType: icon.props['data-type'] || type,
                icon: icon.props.className && !re.test(icon.props.className) ? (0, _react.cloneElement)(icon, {
                    ...icon.props,
                    className: (0, _clsxDefault.default)(icon.props.className, type)
                }) : icon
            };
        }
        return {};
    }, [
        icon
    ]);
};
const isDefault = (animation, type)=>{
    if (type) return false;
    return !animation || animation === 'smooth' || animation === 'pulse';
};
/**
 * Responsible for returning an object used by classnames
 * to properly add the className values to the .pretty element.
 */ const useClassNames = (props, isSwitch)=>{
    const { animation, bigger, locked, plain, shape, variant, iconType, hasFocus } = props;
    return {
        'p-default': !isSwitch && isDefault(animation, iconType),
        'p-bigger': bigger,
        'p-locked': locked,
        'p-plain': plain,
        'p-has-focus': hasFocus,
        [`p-${animation}`]: animation,
        [`p-${shape}`]: shape,
        [`p-${variant}`]: variant,
        [`p-${iconType}`]: iconType
    };
};
const isBoolean = (e)=>typeof e === 'boolean';
const isNullish = (e)=>e === null || e === undefined;
const isIndeterminate = (e)=>e === 'indeterminate';
/**
 * A generic way to setup controlled components by
 * removing  state hook return results, setting `checked`,
 * and `value` props too.
 */ const useControlled = (props)=>{
    // remove state and state dispatch from the props
    // eslint-disable-next-line prefer-const
    let { checked, state, setState, value, defaultValue, ...rest } = props;
    // if a dispatcher is used, then we're good to run the rest
    // of the logic
    if (setState) {
        // if state is defined and checked is NOT defined
        // then use state to set the value of checked.
        if ((isBoolean(state) || isIndeterminate(state)) && !isBoolean(checked) && isNullish(checked)) checked = !!state;
        else if (Array.isArray(state)) // otherwise set checked true if the value is contained
        // within the state.
        checked = state.includes(value);
        else if (isNullish(checked)) // The type is not a boolean and is probably a string.
        // If you're attempting to use this hook in a different
        // way, then you should considering controlling the component
        // yourself. Object.is used here just in case ;)
        checked = Object.is(state, value);
        // preset the value prop in controlled mode to an empty
        // string to prevent 'on' values. Use the defaultValue
        // if provided
        if (isNullish(value)) value = defaultValue || '';
    }
    return {
        checked,
        value,
        state,
        ...rest
    };
};
const PREFIX = 'pcr_';
const useUUID = ()=>(0, _react.useRef)(PREFIX + (0, _nonSecure.nanoid)(8)).current;
/**
 * Filters out the noise of prop mayhem with PCR. This separates
 * all props from the native HTML props that will eventually get passed
 * to the input element. Generated PCR UUIDs are created here, unless
 * user has specified one of their own.
 */ const useCommonProps = (props)=>{
    const defaultId = useUUID();
    const { locked, color, variant, animation, children, style, id = defaultId, className, bigger, hasFocus, ...rest } = props;
    return {
        locked,
        color,
        variant,
        animation,
        children,
        id,
        className,
        bigger,
        style,
        hasFocus,
        htmlProps: rest
    };
};
/**
 * Responsible for extracting common props for radio and checkbox
 * controls.
 */ const useCheckboxRadioProps = (props)=>{
    const { shape, plain, icon, indeterminate, hasFocus, ...rest } = props;
    return {
        shape,
        plain,
        icon,
        indeterminate,
        ...useCommonProps(rest)
    };
};
/**
 * A tiny component to abstract away pretty-checkbox "state" div.
 * Shared by all components.
 */ const State = ({ color, icon, id, children, ...rest })=>{
    return (0, _react.createElement)("div", {
        className: (0, _clsxDefault.default)('state', color && `p-${color}`),
        ...rest
    }, icon, (0, _react.createElement)("label", {
        htmlFor: id
    }, children));
};
State.displayName = 'State';
const useIndeterminate = ({ checked, state, indeterminate: indeterminateFromProps })=>{
    const [indeterminate, setStatus] = (0, _react.useState)(false);
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (state !== undefined && ref.current) setStatus(state === 'indeterminate');
    }, [
        state
    ]);
    // if a prop is passed mark the indeterminate state
    // we should check to ensure state isn't set to indeterminate
    // since we don't want ot clobber the state value if
    // it is defined.
    (0, _react.useEffect)(()=>{
        if (state !== 'indeterminate' && ref.current && typeof indeterminateFromProps !== 'undefined') {
            ref.current.checked = indeterminateFromProps;
            // fix needs to come from pretty-checkbox
            // ref.current.indeterminate = indeterminateFromProps;
            setStatus(indeterminateFromProps);
        }
    }, [
        indeterminateFromProps,
        state
    ]);
    return {
        ref,
        'aria-checked': indeterminate ? 'mixed' : checked
    };
};
const Checkbox = (0, _react.forwardRef)((props, ref)=>{
    const { checked, value, state, ...rest } = useControlled(props);
    const { children, locked, color, id, className, style, indeterminate, icon: propsIcon, htmlProps } = useCheckboxRadioProps(rest);
    const { ref: intRef, ...aria } = useIndeterminate({
        state,
        checked,
        indeterminate
    });
    const styles = useLocked({
        locked,
        style
    });
    const { icon, iconType } = useIcon(propsIcon);
    return (0, _react.createElement)("div", {
        style: styles,
        className: (0, _clsxDefault.default)('pretty', useClassNames({
            ...props,
            iconType
        }), className)
    }, (0, _react.createElement)("input", {
        ref: (0, _reactMergeRefsDefault.default)([
            ref,
            intRef
        ]),
        value: value,
        type: "checkbox",
        id: id,
        checked: checked,
        ...aria,
        ...htmlProps
    }), (0, _react.createElement)(State, {
        id: id,
        icon: icon,
        color: color
    }, children));
});
Checkbox.displayName = 'Checkbox';
const useRadioState = ({ state: initialState = false, onChange } = {})=>{
    const [state, setState] = (0, _react.useState)(initialState);
    return {
        state,
        setState,
        onChange: (0, _react.useCallback)((e)=>{
            const { value } = e.currentTarget;
            setState((current)=>{
                if (value !== '') return value;
                return !current;
            });
            if (typeof onChange === 'function') onChange(e);
        }, [
            onChange
        ])
    };
};
const Radio = (0, _react.forwardRef)((props, ref)=>{
    const { checked, value, state, ...rest } = useControlled(props);
    const { shape = 'round', children, locked, color, id, className, style, icon: propsIcon, htmlProps } = useCheckboxRadioProps(rest);
    const styles = useLocked({
        locked,
        style
    });
    const { icon, iconType } = useIcon(propsIcon);
    return (0, _react.createElement)("div", {
        style: styles,
        className: (0, _clsxDefault.default)('pretty', useClassNames({
            ...props,
            shape,
            iconType
        }), className)
    }, (0, _react.createElement)("input", {
        ref: ref,
        value: value,
        type: "radio",
        id: id,
        checked: checked,
        ...htmlProps
    }), (0, _react.createElement)(State, {
        id: id,
        icon: icon,
        color: color
    }, children));
});
Radio.displayName = 'Radio';
const handler = (e)=>{
    e.currentTarget.setAttribute('aria-checked', e.currentTarget.checked + '');
};
/**
 * A small hook to help manage correct aria-checked state when switch
 * is used as an uncontrolled component. We need this to run
 * for a11y purposes. FOr the `switch` role, `aria-checked` is required.
 */ const useAriaChecked = ({ setState, checked })=>{
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const elem = ref.current;
        let bound = false;
        if (!setState && !checked && elem) {
            elem.setAttribute('aria-checked', elem.checked + '');
            elem.addEventListener('change', handler);
            bound = true;
        }
        return ()=>{
            if (bound && elem) elem.removeEventListener('change', handler);
        };
    }, [
        setState,
        checked
    ]);
    return ref;
};
const Switch = (0, _react.forwardRef)((props, ref)=>{
    const { checked, value, state, ...rest } = useControlled(props);
    const { children, locked, color, id, className, style, htmlProps } = useCommonProps(rest);
    const styles = useLocked({
        locked,
        style
    });
    const htmlRef = useAriaChecked({
        setState: props.setState,
        checked
    });
    return (0, _react.createElement)("div", {
        style: styles,
        className: (0, _clsxDefault.default)('pretty', 'p-switch', useClassNames(props, true), className)
    }, (0, _react.createElement)("input", {
        ref: (0, _reactMergeRefsDefault.default)([
            ref,
            htmlRef
        ]),
        type: "checkbox",
        role: "switch",
        value: value,
        id: id,
        "aria-checked": checked,
        checked: checked,
        ...htmlProps
    }), (0, _react.createElement)(State, {
        id: id,
        color: color
    }, children));
});
Switch.displayName = 'Switch';

},{"react":"IMRgT","clsx":"fE0Pb","react-merge-refs":"6Gpdo","nanoid/non-secure":"ilid2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fE0Pb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6Gpdo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
exports.default = mergeRefs;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ilid2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "customAlphabet", ()=>customAlphabet);
let urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let nanoid = (size = 21)=>{
    let id = '';
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5jRGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "redirectToEventListFromCreatePage", ()=>redirectToEventListFromCreatePage);
parcelHelpers.export(exports, "EventListBase", ()=>EventListBase);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../common/common_utils");
var _confirmationPage = require("../../../../confirmation_page");
var _dashboardUtils = require("../../../../dashboard_utils");
var _dashboardContainer = require("../../base_components/dashboard_container");
var _seshAddonInput = require("../../base_components/sesh_addon_input");
var _useDocTitle = require("../../hooks/use_doc_title");
var _useGuildData = require("../../hooks/use_guild_data");
var _calendarPage = require("./calendar/components/calendar_page");
var _eventListingForm = require("./event_listing_form/event_listing_form");
var _eventListingFormDefault = parcelHelpers.interopDefault(_eventListingForm);
var _useCalendarSearchParams = require("./hooks/use_calendar_search_params");
function redirectToEventListFromCreatePage(props, message_id, start_time, link) {
    const state = {
        type: props.is_edit ? "Edit" : "Create",
        message_id,
        link
    };
    const url = `${(0, _commonUtils.common_utils).getEventListURL(props.guild_id)}?view=calendar&date=${start_time.getFullYear()}-${start_time.getMonth() + 1}`;
    props.history.push(url, state);
}
function getRedirectState(history) {
    const state = history.location.state;
    if (!state) return null;
    return state;
}
function EventListBase() {
    (0, _useDocTitle.useDocTitle)("Events");
    const search_params = (0, _useCalendarSearchParams.useCalendarSearchParams)();
    const history = (0, _reactRouter.useHistory)();
    const [redirect_state, setRedirectState] = (0, _react.useState)(getRedirectState(history));
    const guild_data = (0, _useGuildData.useCurrentGuildData)();
    const value = search_params.get("view");
    (0, _react.useEffect)(()=>{
        if (!(0, _useCalendarSearchParams.ViewValues).includes(value)) {
            search_params.set("view", "calendar");
            history.replace(search_params.toURL());
        }
    }, [
        value,
        search_params,
        history
    ]);
    if (!(0, _useCalendarSearchParams.ViewValues).includes(value)) return null;
    const ViewToggler = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
        value: value,
        setValue: (new_value)=>{
            search_params.set("view", new_value);
            history.replace(search_params.toURL());
        },
        buttons: [
            {
                label: "Calendar",
                value: "calendar"
            },
            {
                label: "List",
                value: "list"
            }
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardContainer.DashboardContainer), {
        size: "xl",
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
            link_chain_data: [
                (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(guild_data),
                (0, _dashboardUtils.DashboardUtils).RenderEventSelectionLinkChain(guild_data)
            ]
        }),
        children: [
            value === "list" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventListingFormDefault.default), {
                viewToggler: ViewToggler
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPage.DashboardCalendar), {
                viewToggler: ViewToggler
            }),
            redirect_state && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmationPage.EventCreationConfirmation), {
                is_edit: redirect_state?.type === "Edit",
                link: redirect_state?.link,
                onClose: ()=>setRedirectState(null)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../../../../../common/common_utils":"gACUC","../../../../confirmation_page":"np3gy","../../../../dashboard_utils":"jvA8A","../../base_components/dashboard_container":"9WDu5","../../base_components/sesh_addon_input":"pd6di","../../hooks/use_doc_title":"bmu5s","../../hooks/use_guild_data":"ljx0Q","./calendar/components/calendar_page":"9W447","./event_listing_form/event_listing_form":"VSiAF","./hooks/use_calendar_search_params":"iOdjS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"np3gy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventCreationConfirmation", ()=>EventCreationConfirmation);
parcelHelpers.export(exports, "PollCreationConfirmation", ()=>PollCreationConfirmation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _dashboardUtils = require("./dashboard_utils");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../common/common_utils");
var _useServerId = require("./forms/improved_components/hooks/use_server_id");
function EventCreationConfirmation(props) {
    const history = (0, _reactRouter.useHistory)();
    const server_id = (0, _useServerId.useServerId)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: props.onClose,
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center justify-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "Event successfully",
                        " ",
                        props.is_edit ? "edited" : "created",
                        "!"
                    ]
                }),
                props.link && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: props.link.replace("https", "discord"),
                    className: "manual-link",
                    style: {
                        background: "none",
                        border: "none",
                        padding: 0
                    },
                    title: "View Event in Discord",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-external-link-alt"
                    })
                })
            ]
        }),
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "columns is-mobile is-multiline is-centered pt-4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                    on_click: ()=>history.push((0, _commonUtils.common_utils).getEventCreateURL(server_id)),
                    button_name: "Create New Event",
                    icon: (0, _dashboardUtils.DashboardUtils).GetEventIcon()
                })
            })
        })
    });
}
function PollCreationConfirmation(props) {
    const containerClassName = "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container is-centered";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
        transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "columns is-centered is-mobile",
            style: {
                transition: "opacity 0.5s",
                opacity: "1"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: containerClassName,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
                        link_chain_data: [
                            (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                            (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(props.guild_data),
                            (0, _dashboardUtils.DashboardUtils).RenderPollSelectionLinkChain(props.guild_data),
                            (0, _dashboardUtils.DashboardUtils).RenderPollCreateLinkChain(props.poll_props.guild_id, props.poll_props.is_edit)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        className: "title is-3 has-text-centered !mb-8",
                        children: [
                            "Poll successfully",
                            " ",
                            props.poll_props.is_edit ? "edited" : "created",
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "columns is-mobile is-multiline is-centered",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                                button_name: "Create New Poll",
                                icon: (0, _dashboardUtils.DashboardUtils).GetPollIcon(),
                                on_click: props.reset_state_func
                            })
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../src/vendored/FadeIn":"aMGHU","./dashboard_utils":"jvA8A","react-router":"djWTS","../../../common/common_utils":"gACUC","./forms/improved_components/hooks/use_server_id":"d0sLH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bmu5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocTitle", ()=>useDocTitle);
var _react = require("react");
var _webUi = require("../../../web_ui");
var _useGuildData = require("./use_guild_data");
function useDocTitle(status) {
    const guild_data = (0, _useGuildData.useCurrentGuildData)();
    (0, _react.useEffect)(()=>{
        const strings = [
            status
        ];
        if (guild_data) strings.push(guild_data.name);
        (0, _webUi.setDocTitle)(strings.join(" - "));
    }, []);
}

},{"react":"IMRgT","../../../web_ui":"7f1Tj","./use_guild_data":"ljx0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ljx0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCurrentGuildData", ()=>useCurrentGuildData);
var _react = require("react");
var _reactRouter = require("react-router");
var _seshRouter = require("../../../sesh_router");
function useCurrentGuildData() {
    let { server_id } = (0, _reactRouter.useParams)();
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    return guild_list?.find((val)=>val.id === server_id);
}

},{"react":"IMRgT","react-router":"djWTS","../../../sesh_router":"hfnpE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9W447":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
parcelHelpers.export(exports, "DashboardCalendar", ()=>DashboardCalendar);
parcelHelpers.export(exports, "PublicCalendar", ()=>PublicCalendar);
parcelHelpers.export(exports, "CalendarPage", ()=>CalendarPage);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../../../common/common_utils");
var _repeatUtils = require("../../../../../../../../../common/repeat_utils");
var _webUi = require("../../../../../../web_ui");
var _removingThrobber = require("../../../../../removing_throbber");
var _loadingThrobber = require("../../../../base_components/loading_throbber");
var _modifySettingsButton = require("../../../../base_components/modify_settings_button");
var _seshPrimaryButton = require("../../../../base_components/sesh_primary_button");
var _disabler = require("../../../../disabler");
var _guildIcon = require("../../../../guild_icon");
var _useEventListQuery = require("../../../../hooks/use_event_list_query");
var _usePublicCalendarQuery = require("../../../../hooks/use_public_calendar_query");
var _useServerId = require("../../../../hooks/use_server_id");
var _useCalendarSearchParams = require("../../hooks/use_calendar_search_params");
var _usePublicCalendarContext = require("../hooks/use_public_calendar_context");
var _calendarCell = require("./calendar_cell");
var _mobileCalendarCell = require("./mobile_calendar_cell");
var _mobileCalendarEventList = require("./mobile_calendar_event_list");
const days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
function eventSorter(a, b) {
    const a_start_time = new Date(a.start_time_str).getTime();
    const b_start_time = new Date(b.start_time_str).getTime();
    if (a_start_time === b_start_time) return new Date(a.created_at_str).getTime() - new Date(b.created_at_str).getTime();
    return a_start_time - b_start_time;
}
function getRepeatedEventsThisMonth(repeat_items, start_of_month, start_of_month_index) {
    if (!repeat_items) return [];
    const local_timezone = (0, _luxon.DateTime).local().zoneName;
    return repeat_items.flatMap((val)=>{
        const rrule_set = (0, _repeatUtils.createRRuleSet)({
            rrule_str: val.rrule,
            start_time_js: new Date(val.repeat_instance_original_start_time_str),
            repeat_tz: val.repeat_tz,
            exdates: val.exdates,
            rdates: val.rdates
        });
        const dates = rrule_set.between((0, _repeatUtils.timeToRRuleTime)(new Date(val.start_time_str), val.repeat_tz), start_of_month.plus({
            days: 42 - start_of_month_index
        }).toUTC(undefined, {
            keepLocalTime: true
        }).toJSDate(), false);
        return dates.map((date)=>{
            const duration = new Date(val.end_time_str).getTime() - new Date(val.start_time_str).getTime();
            const start_time = (0, _luxon.DateTime).fromJSDate(date).toUTC().setZone(local_timezone, {
                keepLocalTime: true
            }).toUTC();
            // Ensure start time is excluded. Duplicates will occur if user viewing the event is in a different timezone than the event itself
            if (start_time.toMillis() === new Date(val.start_time_str).getTime()) return undefined;
            return {
                ...val,
                start_time_str: start_time.toISO(),
                end_time_str: start_time.plus({
                    milliseconds: duration
                }).toISO(),
                is_repeat_occurrence: true,
                initial_event_start_time_str: val.start_time_str
            };
        }).filter((val)=>val);
    });
}
function DashboardCalendar(props) {
    const server_id = (0, _useServerId.useServerId)();
    const initial_props = useInitialCalendarProps();
    const event_query = (0, _useEventListQuery.useEventListQuery)({
        guild_id: server_id,
        sort: {
            type: "Date",
            direction: "ASC"
        },
        range: {
            begin: initial_props.start_of_month.minus({
                days: initial_props.start_of_month_index
            }).toISO(),
            end: initial_props.start_of_month.plus({
                days: 42 - initial_props.start_of_month_index
            }).toISO()
        },
        search: "",
        include_completed: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarPage, {
        ...initial_props,
        headerElement: props.viewToggler,
        events_query: event_query
    });
}
function PublicCalendar() {
    const server_id = (0, _useServerId.useServerId)();
    const initial_props = useInitialCalendarProps();
    const events_query = (0, _usePublicCalendarQuery.usePublicCalendarQuery)({
        guild_id: server_id,
        range: {
            begin: initial_props.start_of_month.minus({
                days: initial_props.start_of_month_index
            }).toISO(),
            end: initial_props.start_of_month.plus({
                days: 42 - initial_props.start_of_month_index
            }).toISO()
        }
    });
    (0, _react.useEffect)(()=>{
        if (events_query.data?.guild_descriptor.name) (0, _webUi.setDocTitle)("Calendar - " + events_query.data?.guild_descriptor.name);
    }, [
        events_query.data?.guild_descriptor.name
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usePublicCalendarContext.PublicCalendarContext).Provider, {
        value: {
            is_public: true,
            authors: events_query.data?.authors ?? [],
            channels: events_query.data?.channels ?? []
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarPage, {
            ...initial_props,
            events_query: events_query,
            headerElement: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-xl font-bold",
                children: [
                    events_query.data?.guild_descriptor.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildIcon.GuildIcon), {
                        server_id: server_id,
                        hash: events_query.data?.guild_descriptor.icon,
                        width: 32
                    }),
                    events_query.data?.guild_descriptor.name
                ]
            })
        })
    });
}
function getLastSunday(date) {
    return date.minus({
        days: date.weekday % 7
    });
}
function getNextSaturday(date) {
    const desired_weekday = 6;
    const current_weekday = date.weekday;
    const day_difference = (desired_weekday - current_weekday + 7) % 7;
    return date.plus({
        days: day_difference
    }).startOf("day");
}
function CalendarPage(props) {
    const { events_query, month_offset, current_month, start_of_month, start_of_month_index } = props;
    const search_params = (0, _useCalendarSearchParams.useCalendarSearchParams)();
    const history = (0, _reactRouter.useHistory)();
    const server_id = (0, _useServerId.useServerId)();
    const { is_public } = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    const repeated_events_this_month = (0, _react.useMemo)(()=>getRepeatedEventsThisMonth(events_query.data?.repeat_items, start_of_month, start_of_month_index), [
        events_query.data?.repeat_items,
        start_of_month,
        start_of_month_index
    ]);
    const [mobile_status, setIsMobile] = (0, _react.useState)(window.innerWidth < 640 ? {
        selected_index: null
    } : null);
    function setMonthOffset(month_offset) {
        if (month_offset === 0) {
            search_params.delete("date");
            history.replace(search_params.toURL());
            return;
        }
        const new_date = (0, _luxon.DateTime).now().startOf("month").plus({
            month: month_offset
        });
        search_params.set("date", `${new_date.year}-${new_date.month}`);
        history.replace(search_params.toURL());
    }
    (0, _react.useEffect)(()=>{
        function handleResize() {
            setIsMobile((prev)=>{
                const is_mobile = !!prev;
                const changed_to_mobile = !is_mobile && window.innerWidth < 640;
                const changed_to_desktop = is_mobile && window.innerWidth >= 640;
                if (changed_to_mobile) return {
                    selected_index: null
                };
                else if (changed_to_desktop) return null;
                return prev;
            });
        }
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (!events_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    // Create a map of event day to an array of all events on that day
    const events_by_day = new Map();
    const events = [
        ...events_query.data.items,
        ...repeated_events_this_month,
        ...events_query.data.native_events
    ];
    for (const event of events){
        const event_date = (0, _luxon.DateTime).fromJSDate(new Date(event.start_time_str)).startOf("day");
        // Round for DST fuckery
        const day = Math.round(event_date.diff(start_of_month).as("days"));
        if (!events_by_day.has(day)) events_by_day.set(day, []);
        events_by_day.get(day).push(event);
    }
    const start_of_cal = getLastSunday(start_of_month);
    const end_of_cal = getNextSaturday(start_of_month.endOf("month"));
    const rows_required = (Math.round(end_of_cal.diff(start_of_cal, "days").days) + 1) / 7;
    let elements = [];
    for(let i = 0; i < 7 * rows_required; i++){
        const day_offset = i - start_of_month_index;
        elements.push(mobile_status ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileCalendarCell.MobileCalendarCell), {
            index: i,
            events: events_by_day.get(day_offset)?.sort(eventSorter) ?? [],
            day_offset: day_offset,
            start_of_month: start_of_month,
            is_selected: mobile_status.selected_index === day_offset,
            setIsSelected: (selected_index)=>setIsMobile({
                    selected_index
                })
        }, `${day_offset}_mobile`) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarCell.CalendarCell), {
            index: i,
            events: events_by_day.get(day_offset)?.sort(eventSorter) ?? [],
            day_offset: day_offset,
            start_of_month: start_of_month
        }, `${day_offset}_tablet`));
    }
    const is_loading = events_query.isPreviousData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
        disabled: is_loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col sm:flex-row",
                    children: [
                        props.headerElement,
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto flex items-center gap-2 text-xl font-bold",
                            children: [
                                is_loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "px-4 font-bold text-sesh-primary hover:text-sesh-dark",
                                            onClick: ()=>{
                                                if (is_loading) return;
                                                setMonthOffset(month_offset - 1);
                                            },
                                            disabled: is_loading,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-chevron-left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "font-mono",
                                            children: [
                                                current_month.monthShort,
                                                " ",
                                                current_month.year
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "px-4 font-bold text-sesh-primary hover:text-sesh-dark",
                                            onClick: ()=>{
                                                if (is_loading) return;
                                                setMonthOffset(month_offset + 1);
                                            },
                                            disabled: is_loading,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-chevron-right"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    custom_size: "small",
                                    onClick: ()=>{
                                        if (is_loading) return;
                                        setMonthOffset(0);
                                    },
                                    children: "Today"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ml-4",
                                    children: is_public ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "manual-link",
                                        href: (0, _commonUtils.common_utils).getEventListURL(server_id),
                                        children: "Dashboard"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                        hide_arrow: true,
                                        onClick: ()=>// TODO: should make this back link business more reusable
                                            history.push((0, _commonUtils.common_utils).getGuildCalendarSettingsURL(server_id), {
                                                back_link: history.location.pathname
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-cog"
                                                }),
                                                "Settings"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)("grid w-full grid-cols-7", {
                        "grid-rows-5 sm:h-[43rem]": rows_required === 5,
                        "grid-rows-6 sm:h-[51.6rem]": rows_required === 6
                    }),
                    children: elements
                }),
                mobile_status?.selected_index != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileCalendarEventList.MobileCalendarEventList), {
                    date: start_of_month.plus({
                        days: mobile_status.selected_index
                    }).startOf("day"),
                    events: events_by_day.get(mobile_status?.selected_index)?.sort(eventSorter) ?? []
                })
            ]
        })
    });
}
function useInitialCalendarProps() {
    const search_params = (0, _useCalendarSearchParams.useCalendarSearchParams)();
    const date_from_url = search_params.get("date");
    let desired_date = undefined;
    if (date_from_url) {
        const [year, month] = date_from_url.split("-").map((val)=>parseInt(val));
        desired_date = (0, _luxon.DateTime).fromObject({
            year,
            month
        });
    } else desired_date = (0, _luxon.DateTime).now().startOf("month");
    const now_start_of_month = (0, _luxon.DateTime).local().startOf("month");
    // Use luxon to get the difference in months between now and desired date
    const month_offset = Math.round(desired_date.diff(now_start_of_month, "months").as("months"));
    const current_month = (0, _luxon.DateTime).now().plus({
        month: month_offset
    });
    const start_of_month = current_month.startOf("month");
    const start_of_month_index = start_of_month.weekday % 7;
    return {
        current_month,
        start_of_month,
        start_of_month_index,
        month_offset
    };
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","react-router":"djWTS","../../../../../../../../../common/common_utils":"gACUC","../../../../../../../../../common/repeat_utils":"gG7ok","../../../../../../web_ui":"7f1Tj","../../../../../removing_throbber":"TmURk","../../../../base_components/loading_throbber":"1I8d2","../../../../base_components/modify_settings_button":"kbhTg","../../../../base_components/sesh_primary_button":"3QyI2","../../../../disabler":"hF5sC","../../../../guild_icon":"lVuRf","../../../../hooks/use_event_list_query":"bB4iO","../../../../hooks/use_public_calendar_query":"dYfcA","../../../../hooks/use_server_id":"d0sLH","../../hooks/use_calendar_search_params":"iOdjS","../hooks/use_public_calendar_context":"948cp","./calendar_cell":"kECD1","./mobile_calendar_cell":"7QMlf","./mobile_calendar_event_list":"fgyvk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lVuRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildIcon", ()=>GuildIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function GuildIcon(props) {
    const width = props.width ?? 24;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
        className: (0, _classnamesDefault.default)("image flex-shrink-0", `is-${width}x${width}`),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            className: "is-rounded",
            src: `https://cdn.discordapp.com/icons/${props.server_id}/${props.hash}.webp`,
            width: width,
            height: width
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bB4iO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventListQuery", ()=>useEventListQuery);
var _trpc = require("../../../utils/trpc");
function useEventListQuery(params) {
    const context = (0, _trpc.trpc).useContext();
    return (0, _trpc.trpc).event.list.useQuery(params, {
        staleTime: 5000,
        keepPreviousData: true,
        onSuccess: (data)=>{
            data.items.forEach((val)=>context.event.getListItem.setData(()=>val, {
                    guild_id: params.guild_id,
                    message_id: val.message_id
                }));
        }
    });
}

},{"../../../utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dYfcA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePublicCalendarQuery", ()=>usePublicCalendarQuery);
var _jsxRuntime = require("react/jsx-runtime");
var _commonUtils = require("../../../../../../common/common_utils");
var _useError = require("../../../../calendar/hooks/useError");
var _trpc = require("../../../utils/trpc");
var _useServerId = require("./use_server_id");
function usePublicCalendarQuery(params) {
    const error_context = (0, _useError.useError)();
    const server_id = (0, _useServerId.useServerId)();
    return (0, _trpc.trpc).calendar.view.useQuery(params, {
        staleTime: 5000,
        keepPreviousData: true,
        onError: (err)=>{
            console.log(err.data.code);
            let text = err.message;
            if (err.data.code === "FORBIDDEN") text = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    err.message,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "If you are a member of this server, you can view the calendar",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                className: "manual-link",
                                href: (0, _commonUtils.common_utils).getEventListURL(server_id),
                                children: "here"
                            }),
                            "."
                        ]
                    })
                ]
            });
            error_context.setError({
                title: err.data.code,
                text
            });
        }
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../../../common/common_utils":"gACUC","../../../../calendar/hooks/useError":"bAp9Q","../../../utils/trpc":"dyYvM","./use_server_id":"d0sLH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bAp9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorContext", ()=>ErrorContext);
parcelHelpers.export(exports, "useError", ()=>useError);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ErrorContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    error: null,
    setError: (error)=>{}
});
function useError() {
    return (0, _react.useContext)(ErrorContext);
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iOdjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewValues", ()=>ViewValues);
parcelHelpers.export(exports, "useCalendarSearchParams", ()=>useCalendarSearchParams);
var _useSearchParams = require("../../../hooks/use_search_params");
const ViewValues = [
    "list",
    "calendar"
];
function useCalendarSearchParams() {
    return (0, _useSearchParams.useSearchParams)();
}

},{"../../../hooks/use_search_params":"8kOtW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8kOtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
var _reactRouter = require("react-router");
function useSearchParams() {
    const location = (0, _reactRouter.useLocation)();
    const params = new URLSearchParams(location.search);
    return {
        ...params,
        delete: (key)=>{
            params.delete(key);
        },
        has: (key)=>{
            return params.has(key);
        },
        get: (key)=>{
            return params.get(key);
        },
        set: (key, value)=>{
            params.set(key, value);
        },
        toURL: ()=>location.pathname + "?" + params.toString()
    };
}

},{"react-router":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kECD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarCell", ()=>CalendarCell);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _reactRouter = require("react-router");
var _calendarPage = require("./calendar_page");
var _calendarEventItem = require("./calendar_event_item");
var _useServerId = require("../../../../hooks/use_server_id");
var _commonUtils = require("../../../../../../../../../common/common_utils");
var _withDropdownBase = require("../../../../base_components/with_dropdown_base");
var _boxItem = require("../../../../box_item");
var _useHistoryPusher = require("../hooks/use_history_pusher");
var _getEventId = require("../utils/get_event_id");
function CalendarCell(props) {
    const date = props.start_of_month.plus({
        days: props.day_offset
    }).startOf("day");
    const has_weekday_shown = props.index < 7;
    const max_events_to_display = has_weekday_shown ? 4 : 5;
    const events_to_display = props.events.slice(0, has_weekday_shown ? 4 : 5);
    const dropdown_id = `calendar-cell-${props.day_offset}`;
    const now = (0, _luxon.DateTime).now().startOf("day");
    const is_today = now.toMillis() === date.toMillis();
    const is_in_past = date.toMillis() < now.toMillis();
    const is_first_of_month = date.day === 1;
    const history = (0, _reactRouter.useHistory)();
    const server_id = (0, _useServerId.useServerId)();
    let day_element;
    if (is_today) day_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "flex w-[20px] flex-col items-center rounded-[100%] bg-sesh-primary font-bold text-black",
        children: date.day
    });
    else if (is_first_of_month) day_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "font-bold",
        children: [
            date.monthShort,
            " ",
            date.day
        ]
    });
    else day_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-bold",
        children: date.day
    });
    const pushHistory = (0, _useHistoryPusher.useHistoryPusher)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)("group/cell h-full border-b border-r border-sesh-dark bg-base-dark", {
            "border-l": props.index % 7 === 0,
            "border-t": props.index < 7
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("flex h-full flex-col items-center text-sm", {
                "opacity-50": is_in_past || props.start_of_month.month !== date.month
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _classnamesDefault.default)("group/day relative flex w-full py-[2px] transition-all", {
                        "cursor-pointer hover:bg-base-light": !is_in_past
                    }),
                    onClick: ()=>{
                        if (is_in_past) return;
                        pushHistory((0, _commonUtils.common_utils).getEventCreateURL(server_id, undefined, undefined, {
                            date: encodeURIComponent(date.set({
                                hour: 12
                            }).toISO().replaceAll("+", "%2b"))
                        }));
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex w-full flex-col items-center",
                            children: [
                                has_weekday_shown && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: (0, _calendarPage.days)[props.index]
                                }),
                                day_element
                            ]
                        }),
                        !is_in_past && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute flex w-full px-1 opacity-0 transition-all group-hover/cell:opacity-25 group-hover/day:!opacity-100",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "ml-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-plus"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex h-full w-full flex-col gap-0 overflow-y-auto px-1",
                    children: [
                        events_to_display.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItem.CalendarEventItem), {
                                is_today_or_future: !is_in_past,
                                event: val
                            }, `${(0, _getEventId.getEventId)(val)}_${val.start_time_str}`)),
                        props.events.length > max_events_to_display && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
                            id: dropdown_id,
                            dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                                bgColor: "semidark",
                                className: "border border-sesh-primary",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex w-48 flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex w-full flex-col items-center gap-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-xs text-content-secondary",
                                                    children: date.weekdayLong
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-lg font-bold",
                                                    children: date.day
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex max-h-32 flex-col gap-1 overflow-auto",
                                            children: props.events.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItem.CalendarEventItem), {
                                                    is_today_or_future: !is_in_past,
                                                    event: val,
                                                    dropdown_parent_id: dropdown_id
                                                }, `${(0, _getEventId.getEventId)(val)}_${val.start_time_str}`))
                                        })
                                    ]
                                })
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex w-full flex-shrink-0 cursor-pointer gap-2 overflow-hidden overflow-ellipsis whitespace-nowrap px-1 text-xs hover:bg-base-light",
                                children: [
                                    props.events.length - max_events_to_display,
                                    " ",
                                    "more"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }, props.day_offset);
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react-router":"djWTS","./calendar_page":"9W447","./calendar_event_item":"aLfRO","../../../../hooks/use_server_id":"d0sLH","../../../../../../../../../common/common_utils":"gACUC","../../../../base_components/with_dropdown_base":"1AlyU","../../../../box_item":"gTVlB","../hooks/use_history_pusher":"fnplP","../utils/get_event_id":"23wqy","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aLfRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarEventItem", ()=>CalendarEventItem);
parcelHelpers.export(exports, "CalendarSeshEventItem", ()=>CalendarSeshEventItem);
parcelHelpers.export(exports, "CalendarDiscordEventItem", ()=>CalendarDiscordEventItem);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _constants = require("../../../../../../../../../common/constants");
var _removingThrobber = require("../../../../../removing_throbber");
var _withDropdownBase = require("../../../../base_components/with_dropdown_base");
var _isSeshEvent = require("../utils/is_sesh_event");
var _calendarEventItemDropdown = require("./calendar_event_item_dropdown");
function CalendarEventItem(props) {
    if ((0, _isSeshEvent.isSeshEvent)(props.event)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarSeshEventItem, {
        ...props,
        event: props.event
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarDiscordEventItem, {
        ...props,
        event: props.event
    });
}
function CalendarSeshEventItem(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
        id: `${props.event.message_id}_${props.event.start_time_str}`,
        x_alignment: "auto",
        y_alignment: "middle",
        dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItemDropdown.SeshEventItemDropdown), {
            event: props.event,
            is_removing: is_removing,
            setIsRemoving: setIsRemoving
        }),
        parent_id: props.dropdown_parent_id,
        disabled: is_removing,
        children: (is_active)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EventCellItem, {
                name: props.event.name,
                is_active: is_active,
                color: props.event.color,
                start_time_str: props.event.start_time_str,
                end_time_str: props.event.end_time_str,
                is_removing: is_removing,
                is_today_or_future: props.is_today_or_future
            })
    });
}
function CalendarDiscordEventItem(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
        id: `${props.event.id}_${props.event.start_time_str}`,
        x_alignment: "auto",
        y_alignment: "middle",
        dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItemDropdown.DiscordEventItemDropdown), {
            event: props.event,
            is_removing: is_removing,
            setIsRemoving: setIsRemoving
        }),
        parent_id: props.dropdown_parent_id,
        disabled: is_removing,
        children: (is_active)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EventCellItem, {
                name: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-[0.6rem]",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fab fa-discord"
                            })
                        }),
                        props.event.name
                    ]
                }),
                is_active: is_active,
                color: (0, _constants.Constants).DISCORD_BLURPLE,
                start_time_str: props.event.start_time_str,
                end_time_str: props.event.end_time_str,
                is_removing: is_removing,
                is_today_or_future: props.is_today_or_future
            })
    });
}
function EventCellItem(props) {
    const event_start_time = (0, _luxon.DateTime).fromJSDate(new Date(props.start_time_str));
    const event_end_time = props.end_time_str ? (0, _luxon.DateTime).fromJSDate(new Date(props.end_time_str)) : event_start_time;
    const time = event_start_time.toLocaleString({
        timeStyle: "short"
    }).toLowerCase().replace(" ", "");
    let time_string = time.includes(":00") ? time.replace(":00", "") : time;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            borderLeftColor: props.color
        },
        className: (0, _classnamesDefault.default)("relative mb-[1px] flex w-full gap-2 whitespace-nowrap rounded-sm border-l-[3px] px-1 py-[1px] text-left text-xs transition-all hover:bg-base-light", {
            "bg-base-light": props.is_active,
            "bg-base-semidark": !props.is_active,
            "opacity-50": props.is_today_or_future && event_end_time < (0, _luxon.DateTime).local()
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "overflow-hidden overflow-ellipsis font-semibold",
                children: props.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto flex-shrink-0 text-content-secondary",
                children: time_string
            }),
            props.is_removing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
            props.is_removing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absolute left-0 top-0 h-full w-full bg-warning/10"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","../../../../../../../../../common/constants":"lLiun","../../../../../removing_throbber":"TmURk","../../../../base_components/with_dropdown_base":"1AlyU","../utils/is_sesh_event":"4wbFP","./calendar_event_item_dropdown":"eOtRa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4wbFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: use query item
parcelHelpers.export(exports, "isSeshEvent", ()=>isSeshEvent);
function isSeshEvent(event) {
    return event.message_id !== undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eOtRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshEventItemDropdown", ()=>SeshEventItemDropdown);
parcelHelpers.export(exports, "DiscordEventItemDropdown", ()=>DiscordEventItemDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _fontColorContrast = require("font-color-contrast");
var _fontColorContrastDefault = parcelHelpers.interopDefault(_fontColorContrast);
var _luxon = require("luxon");
var _react = require("react");
var _commonUtils = require("../../../../../../../../../common/common_utils");
var _constants = require("../../../../../../../../../common/constants");
var _timeFormatUtils = require("../../../../../../../../../common/time_format_utils");
var _removingThrobber = require("../../../../../removing_throbber");
var _rsvpListImproved = require("../../../../base_components/rsvp_list_improved");
var _withDropdownImproved = require("../../../../base_components/with_dropdown_improved");
var _boxItem = require("../../../../box_item");
var _channelName = require("../../../../channel_name");
var _useGenerateEventActions = require("../../../../hooks/use_generate_event_actions");
var _useServerId = require("../../../../hooks/use_server_id");
var _simpleMemberDisplayName = require("../../../../member_display_name/simple_member_display_name");
var _simpleMemberDisplayNameDefault = parcelHelpers.interopDefault(_simpleMemberDisplayName);
var _withTooltipPortaled = require("../../../../tooltips/with_tooltip_portaled");
var _usePublicCalendarContext = require("../hooks/use_public_calendar_context");
var _dashboardOrPublicLink = require("./dashboard_or_public_link");
function BaseEventItemDropdown(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
        bgColor: "semidark",
        style: {
            borderColor: props.color
        },
        className: "overflow-hidden rounded-lg !p-0 pt-0 shadow-lg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-[90vw] flex-col sm:w-[28rem]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full items-center px-2",
                    style: {
                        backgroundColor: props.color
                    },
                    children: [
                        props.is_discord_event && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-xl",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fab fa-discord text-white"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto flex items-center gap-1",
                            children: props.actions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col px-4 py-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-xl font-bold sm:max-h-16 sm:overflow-auto sm:text-2xl",
                            children: props.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-2 flex flex-col gap-0 text-xs sm:gap-2 sm:text-sm",
                            children: props.children
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto mt-0 text-xs sm:mt-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemMemberDisplayName, {
                                author_id: props.author_id
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function SeshEventItemDropdown(props) {
    const server_id = (0, _useServerId.useServerId)();
    const start_time = (0, _luxon.DateTime).fromJSDate(new Date(props.event.start_time_str));
    const end_time = (0, _luxon.DateTime).fromJSDate(new Date(props.event.end_time_str));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BaseEventItemDropdown, {
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownActions, {
            event: props.event,
            is_removing: props.is_removing,
            setIsRemoving: props.setIsRemoving
        }),
        name: props.event.name,
        author_id: props.event.author_id,
        color: props.event.color,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-clock",
                title: "Start Time",
                text: `${(0, _timeFormatUtils.time_format_utils).displayDateTime(start_time, {
                    date: true,
                    time: true,
                    weekday: true
                })} \u{2013} ${(0, _timeFormatUtils.time_format_utils).displayDateTime(end_time, {
                    time: true,
                    date: start_time.day !== end_time.day,
                    weekday: start_time.day !== end_time.day
                })}`
            }),
            props.event.rrule && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-redo-alt",
                title: "Repeats",
                text: (0, _timeFormatUtils.time_format_utils).formatRRule(props.event.rrule, (0, _luxon.DateTime).local().zoneName, (0, _luxon.DateTime).fromJSDate(new Date(props.event.start_time_str)))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemChannelAttribute, {
                channel_id: props.event.channel_id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-user",
                title: "RSVPs",
                text: props.event.is_repeat_occurrence ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                    style: "Info",
                    tooltip: "Event not posted yet",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpListImproved.RSVPListImproved), {
                        preset: props.event.rsvp_options
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardOrPublicLink.DashboardOrPublicLink), {
                    to: (0, _commonUtils.common_utils).getAttendeesDisplayURL(server_id, props.event.message_id, false),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpListImproved.RSVPListImproved), {
                        preset: props.event.rsvp_options
                    })
                })
            }),
            props.event.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-align-left",
                title: "Description",
                text: props.event.description ? props.event.description : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "italic",
                    children: "None"
                })
            })
        ]
    });
}
function DiscordEventItemDropdown(props) {
    const server_id = (0, _useServerId.useServerId)();
    const start_time = (0, _luxon.DateTime).fromJSDate(new Date(props.event.start_time_str));
    const start_time_text = [
        (0, _timeFormatUtils.time_format_utils).displayDateTime(start_time, {
            date: true,
            time: true,
            weekday: true
        })
    ];
    if (props.event.end_time_str) start_time_text.push((0, _timeFormatUtils.time_format_utils).displayDateTime((0, _luxon.DateTime).fromJSDate(new Date(props.event.end_time_str)), {
        time: true
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BaseEventItemDropdown, {
        is_discord_event: true,
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
            style: "Info",
            tooltip: "Open in Discord",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    className: "p-2 text-white opacity-100 transition-all hover:opacity-60",
                    href: `https://discord.com/events/${server_id}/${props.event.id}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-external-link-alt"
                    })
                })
            })
        }),
        name: props.event.name,
        author_id: props.event.author_id,
        color: (0, _constants.Constants).DISCORD_BLURPLE,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-clock",
                title: "Start Time",
                text: start_time_text.join(" \u2013 ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-user",
                title: "RSVPs",
                text: props.event.attendees.toString()
            }),
            props.event.type === "External" && props.event.location && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-map-marker-alt",
                title: "Location",
                text: props.event.location
            }),
            props.event.type === "Voice" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-volume-up",
                title: "Location",
                text: props.event.channel_name
            }),
            props.event.type === "Stage" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fa fa-podcast",
                title: "Location",
                text: props.event.channel_name
            }),
            props.event.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
                icon: "fas fa-align-left",
                title: "Description",
                text: props.event.description ? props.event.description : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "italic",
                    children: "None"
                })
            })
        ]
    });
}
function EventItemChannelAttribute({ channel_id }) {
    const calendar_context = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    let attribute_text = undefined;
    if (calendar_context.is_public) {
        // If we're on public calendar, we need to use different API routes. This component facilitates that
        const channel = calendar_context.channels.find((val)=>val.id === channel_id);
        attribute_text = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelName.ChannelNameWithoutCache), {
            channel_name: channel?.name ?? channel_id
        });
    } else attribute_text = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelName.ChannelName), {
        channel_id: channel_id,
        include_hashtag: false
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventItemDropdownAttribute, {
        icon: "fas fa-hashtag",
        title: "Channel",
        text: attribute_text
    });
}
function EventItemMemberDisplayName({ author_id }) {
    const calendar_context = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    if (calendar_context.is_public) {
        // If we're on public calendar, we need to use different API routes. This component facilitates that
        const member = calendar_context.authors.find((val)=>val.id === author_id);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleMemberDisplayName.SimpleMemberDisplayNameWithoutCache), {
            member: member,
            user_id: author_id,
            include_avatar: true,
            width: 16
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleMemberDisplayNameDefault.default), {
        user_id: author_id,
        include_avatar: true,
        width: 16
    });
}
function EventItemDropdownAttribute(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-6 w-4",
                title: props.title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: (0, _classnamesDefault.default)("text-content-secondary", props.icon)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "max-h-48 overflow-auto whitespace-pre-wrap",
                children: props.text
            })
        ]
    });
}
function EventItemDropdownActions(props) {
    const actions = (0, _useGenerateEventActions.useGenerateEventActions)(props.event, props.is_removing, props.setIsRemoving, `${props.event.message_id}_${props.event.start_time_str}`);
    const color_contrast = (0, _fontColorContrastDefault.default)(props.event.color);
    if (actions.isLoading === true) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "px-4 py-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {
            color: color_contrast
        })
    });
    const DropdownItemsWithColor = (0, _withDropdownImproved.DropdownItemToElementWithoutLabel)(color_contrast);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex gap-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex items-center gap-1",
            style: {
                color: color_contrast
            },
            children: Object.keys(actions).filter((val)=>actions[val]).map((val)=>{
                if (val === "isLoading") return;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                    children: DropdownItemsWithColor[actions[val].type](actions[val])
                }, val);
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","font-color-contrast":"bP5fh","luxon":"fLWpi","react":"IMRgT","../../../../../../../../../common/common_utils":"gACUC","../../../../../../../../../common/constants":"lLiun","../../../../../../../../../common/time_format_utils":"g0uQN","../../../../../removing_throbber":"TmURk","../../../../base_components/rsvp_list_improved":"kbn35","../../../../base_components/with_dropdown_improved":"iYgdS","../../../../box_item":"gTVlB","../../../../channel_name":"csu1S","../../../../hooks/use_generate_event_actions":"6ffvT","../../../../hooks/use_server_id":"d0sLH","../../../../member_display_name/simple_member_display_name":"hXYPB","../../../../tooltips/with_tooltip_portaled":"6LBvw","../hooks/use_public_calendar_context":"948cp","./dashboard_or_public_link":"tq629","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kbn35":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RSVPListImproved", ()=>RSVPListImproved);
var _jsxRuntime = require("react/jsx-runtime");
var _inlineEmoji = require("../inline_emoji");
function RSVPListImproved(props) {
    const { preset } = props;
    const columns = [];
    let index = 0;
    for (let option of preset){
        const emoji = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
            option: option
        });
        columns.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "column is-one-third-tablet is-one-third-mobile column-in-table-cell has-text-centered-tablet",
            children: [
                emoji,
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: option.rsvp_count
                })
            ]
        }, index));
        index++;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex gap-2",
        children: preset.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
                        option: val
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: val.rsvp_count
                    })
                ]
            }, val.id))
    });
}

},{"react/jsx-runtime":"dpQXr","../inline_emoji":"39PEk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"tq629":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardOrPublicLink", ()=>DashboardOrPublicLink);
var _jsxRuntime = require("react/jsx-runtime");
var _disableableLink = require("../../../../base_components/disableable_link");
var _usePublicCalendarContext = require("../hooks/use_public_calendar_context");
function DashboardOrPublicLink(props) {
    const { is_public } = (0, _usePublicCalendarContext.usePublicCalendarContext)();
    if (is_public) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        className: "manual-link",
        href: props.to,
        children: props.children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disableableLink.DisableableLink), {
        to: props.to,
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../base_components/disableable_link":"6Sjx5","../hooks/use_public_calendar_context":"948cp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6Sjx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisableableLink", ()=>DisableableLink);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouterDom = require("react-router-dom");
var _withTooltip = require("../tooltips/with_tooltip");
function DisableableLink(props) {
    const { is_disabled, tooltip, ...pure_props } = props;
    const link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        ...pure_props,
        className: (0, _classnamesDefault.default)(props.className, {
            "input-disabled pointer-events-none text-gray-400": is_disabled,
            "manual-link": !is_disabled
        })
    });
    if (props.tooltip) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
        style: "Info",
        tooltip: tooltip,
        disable_click: true,
        children: link
    });
    return link;
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react-router-dom":"3XSn5","../tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"23wqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEventId", ()=>getEventId);
function getEventId(event) {
    return "message_id" in event ? event.message_id : event.id;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7QMlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileCalendarCell", ()=>MobileCalendarCell);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _calendarPage = require("./calendar_page");
function MobileCalendarCell(props) {
    const date = props.start_of_month.plus({
        days: props.day_offset
    }).startOf("day");
    const has_weekday_shown = props.index < 7;
    const now = (0, _luxon.DateTime).now().startOf("day");
    const is_today = now.toMillis() === date.toMillis();
    const is_in_past = date.toMillis() < now.toMillis();
    let day_element;
    day_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _classnamesDefault.default)("flex h-[20px] w-[20px] flex-col items-center justify-center rounded-[100%] font-bold", {
            "bg-sesh-primary text-black": is_today
        }),
        children: date.day
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)("group/cell h-16 w-full border-b border-r border-sesh-dark hover:bg-base-light", {
            "border-l": props.index % 7 === 0,
            "border-t": props.index < 7,
            "bg-base-light": props.is_selected,
            "bg-base-dark": !props.is_selected
        }),
        onClick: ()=>props.setIsSelected(props.day_offset),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("flex h-full flex-col items-center text-xs", {
                "opacity-50": is_in_past || props.start_of_month.month !== date.month
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)("group/day relative flex w-full py-[2px] transition-all"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full flex-col items-center",
                        children: [
                            has_weekday_shown && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: (0, _calendarPage.days)[props.index]
                            }),
                            day_element
                        ]
                    })
                }),
                props.events.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex h-full pb-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "my-auto h-[6px] w-[6px] rounded-[100%] bg-sesh-primary"
                    })
                })
            ]
        })
    }, props.day_offset);
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","./calendar_page":"9W447","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fgyvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileCalendarEventList", ()=>MobileCalendarEventList);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _commonUtils = require("../../../../../../../../../common/common_utils");
var _constants = require("../../../../../../../../../common/constants");
var _removingThrobber = require("../../../../../removing_throbber");
var _seshPrimaryButton = require("../../../../base_components/sesh_primary_button");
var _withDropdownBase = require("../../../../base_components/with_dropdown_base");
var _boxItem = require("../../../../box_item");
var _useServerId = require("../../../../hooks/use_server_id");
var _useHistoryPusher = require("../hooks/use_history_pusher");
var _isSeshEvent = require("../utils/is_sesh_event");
var _calendarEventItemDropdown = require("./calendar_event_item_dropdown");
function MobileCalendarEventList(props) {
    const guild_id = (0, _useServerId.useServerId)();
    const pushHistory = (0, _useHistoryPusher.useHistoryPusher)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            props.events.length > 0 ? props.events.map((val, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileEventItem, {
                    event: val
                }, idx.toString())) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                className: "border-l-4 border-l-inherit text-sm",
                padding: "p-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex w-full",
                    children: "No events"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                custom_size: "small",
                className: "mt-1",
                onClick: ()=>pushHistory((0, _commonUtils.common_utils).getEventCreateURL(guild_id, undefined, undefined, {
                        date: props.date.set({
                            hour: 12
                        }).toISO()
                    })),
                children: "New Event"
            })
        ]
    });
}
function MobileEventItem(props) {
    if ((0, _isSeshEvent.isSeshEvent)(props.event)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileSeshEventItem, {
        event: props.event
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileDiscordEventItem, {
        event: props.event
    });
}
function MobileDiscordEventItem(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
        id: `${props.event.id}_${props.event.start_time_str}`,
        x_alignment: "middle",
        y_alignment: "top",
        dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItemDropdown.DiscordEventItemDropdown), {
            event: props.event,
            is_removing: is_removing,
            setIsRemoving: setIsRemoving
        }),
        disabled: is_removing,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: (0, _classnamesDefault.default)("w-full", {
                "border-warning": is_removing
            }),
            style: {
                borderLeftColor: (0, _constants.Constants).DISCORD_BLURPLE
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                className: (0, _classnamesDefault.default)("w-full border-l-4 text-sm", {
                    "border-warning": is_removing,
                    "border-l-inherit": !is_removing
                }),
                padding: "p-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 overflow-hidden overflow-ellipsis whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fab fa-discord"
                                    })
                                }),
                                props.event.name
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto flex flex-shrink-0 items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-content-secondary",
                                    children: (0, _luxon.DateTime).fromJSDate(new Date(props.event.start_time_str)).toLocaleString({
                                        timeStyle: "short"
                                    })
                                }),
                                is_removing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }, props.event.id + props.event.start_time_str);
}
function MobileSeshEventItem(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownBase.WithDropdownBase), {
        id: `${props.event.message_id}_${props.event.start_time_str}`,
        x_alignment: "middle",
        y_alignment: "top",
        dropdown_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarEventItemDropdown.SeshEventItemDropdown), {
            event: props.event,
            is_removing: is_removing,
            setIsRemoving: setIsRemoving
        }),
        disabled: is_removing,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: (0, _classnamesDefault.default)("w-full", {
                "border-warning": is_removing
            }),
            style: {
                borderLeftColor: props.event.color
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                className: (0, _classnamesDefault.default)("w-full border-l-4 text-sm", {
                    "border-warning": is_removing,
                    "border-l-inherit": !is_removing
                }),
                padding: "p-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overflow-hidden overflow-ellipsis whitespace-nowrap",
                            children: props.event.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto flex flex-shrink-0 items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-content-secondary",
                                    children: (0, _luxon.DateTime).fromJSDate(new Date(props.event.start_time_str)).toLocaleString({
                                        timeStyle: "short"
                                    })
                                }),
                                is_removing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }, props.event.message_id + props.event.start_time_str);
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","../../../../../../../../../common/common_utils":"gACUC","../../../../../../../../../common/constants":"lLiun","../../../../../removing_throbber":"TmURk","../../../../base_components/sesh_primary_button":"3QyI2","../../../../base_components/with_dropdown_base":"1AlyU","../../../../box_item":"gTVlB","../../../../hooks/use_server_id":"d0sLH","../hooks/use_history_pusher":"fnplP","../utils/is_sesh_event":"4wbFP","./calendar_event_item_dropdown":"eOtRa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"VSiAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventListingForm);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lib = require("csv-stringify/lib");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../../common/common_utils");
var _constants = require("../../../../../../../../common/constants");
var _dashboardUtils = require("../../../../../dashboard_utils");
var _seshRouter = require("../../../../../sesh_router");
var _removingThrobber = require("../../../../removing_throbber");
var _loadingThrobber = require("../../../base_components/loading_throbber");
var _seshPrimaryButton = require("../../../base_components/sesh_primary_button");
var _seshSearchForm = require("../../../base_components/sesh_search_form");
var _csvDownload = require("../../../csv_download");
var _useEventListQuery = require("../../../hooks/use_event_list_query");
var _useUserContext = require("../../../hooks/use_user_context");
var _pageButtons = require("../../page_buttons");
var _eventRow = require("./event_row");
var _eventRowDefault = parcelHelpers.interopDefault(_eventRow);
async function downloadEventListingsCSV(auth_token, guild_id) {
    let request_body = {
        access_token: auth_token.access_token,
        token_type: auth_token.token_type,
        guild_id: guild_id
    };
    return fetch(`/api/get_event_listings_csv`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            (0, _lib.stringify)(value.result, (err, output)=>{
                if (err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(err.toString());
                    return;
                }
                const element = document.createElement("a");
                const file = new Blob([
                    output
                ], {
                    type: "text/plain"
                });
                element.href = URL.createObjectURL(file);
                element.download = `events_${guild_id}.csv`;
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            });
            return value.result;
        }));
}
function EventListingForm(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const history = (0, _reactRouter.useHistory)();
    const user_context = (0, _useUserContext.useUserContext)();
    const [page, setPage] = (0, _react.useState)(0);
    const [sort, setSort] = (0, _react.useState)({
        type: "Date",
        direction: "ASC"
    });
    const [include_completed, setIncludeCompleted] = (0, _react.useState)(false);
    const [search, setSearch] = (0, _react.useState)("");
    const [is_csv_loading, setIsCSVLoading] = (0, _react.useState)(false);
    const list_query = (0, _useEventListQuery.useEventListQuery)({
        guild_id: server_id,
        include_completed,
        cursor: page,
        sort,
        search
    });
    if (!list_query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    const query_items = list_query.data?.items;
    const disabled = list_query.isPreviousData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("flex flex-col gap-2", {
            "input-disabled": disabled
        }),
        children: [
            props.viewToggler,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-8 flex flex-col items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sm:w-3/4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col items-center gap-4 sm:flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshSearchForm), {
                                    onSubmit: setSearch,
                                    placeholder: "Search by name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "cursor-pointer",
                                    onClick: disabled ? undefined : ()=>setIncludeCompleted(!include_completed),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            className: "cursor-pointer",
                                            checked: include_completed,
                                            onChange: ()=>{}
                                        }),
                                        " ",
                                        "Include completed events"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _csvDownload.CSVDownload), {
                                    is_loading: is_csv_loading,
                                    onClick: ()=>{
                                        setIsCSVLoading(true);
                                        downloadEventListingsCSV(user_context, server_id).finally(()=>setIsCSVLoading(false));
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                            className: (0, _classnamesDefault.default)("sesh-table listing-table responsive-table event-listings"),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[27%]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                                    type: "Date",
                                                    current_sort: sort,
                                                    setSort: setSort,
                                                    is_loading: list_query.isPreviousData
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[23%]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                                    type: "Name",
                                                    current_sort: sort,
                                                    setSort: setSort,
                                                    is_loading: list_query.isPreviousData
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[12%]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                                    type: "Channel",
                                                    current_sort: sort,
                                                    setSort: setSort,
                                                    is_loading: list_query.isPreviousData
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[12%]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                                    type: "Author",
                                                    current_sort: sort,
                                                    setSort: setSort,
                                                    is_loading: list_query.isPreviousData
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[15%]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                                    type: "RSVPs",
                                                    current_sort: sort,
                                                    setSort: setSort,
                                                    is_loading: list_query.isPreviousData
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "w-[11%] overflow-hidden overflow-ellipsis",
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                    children: query_items && query_items.length > 0 ? query_items.map((val)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventRowDefault.default), {
                                            message_id: val.message_id
                                        }, val.message_id);
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                        className: "",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            colSpan: 6,
                                            className: "text-center",
                                            children: "No results found"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex w-full flex-wrap-reverse gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-fit",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                        onClick: ()=>history.push((0, _commonUtils.common_utils).getEventCreateURL(server_id)),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 px-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-plus-circle"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "New Event"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ml-auto",
                                    children: list_query.data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageButtons.PageButtons), {
                                        page: page,
                                        total_items: list_query.data?.total_item_count ?? 0,
                                        setPage: setPage,
                                        is_loading: list_query.isPreviousData,
                                        items_per_page: (0, _constants.Constants).LISTING_PAGINATION_LIMIT
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const OppositeSortMap = {
    ASC: "DESC",
    DESC: "ASC"
};
function SortableTableHeader(props) {
    const is_current_sort = props.current_sort.type === props.type;
    const is_pending_results = props.is_loading && is_current_sort;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("group flex flex-wrap items-center gap-1", {
            "cursor-pointer": !props.is_loading
        }),
        onClick: ()=>{
            if (props.is_loading) return;
            props.setSort({
                type: props.type,
                direction: is_current_sort ? OppositeSortMap[props.current_sort.direction] : "ASC"
            });
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-full overflow-hidden overflow-ellipsis",
                children: props.type
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: (0, _classnamesDefault.default)("group-hover:text-sesh-primary", {
                            hidden: is_pending_results,
                            "fas fa-sort text-base-light": !is_current_sort,
                            "fas fa-sort-down": is_current_sort && props.current_sort.direction === "DESC",
                            "fas fa-sort-up": is_current_sort && props.current_sort.direction === "ASC"
                        })
                    }),
                    is_pending_results && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                ]
            }, `${props.type}_${props.current_sort.direction}_${is_current_sort}_${is_pending_results}`)
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","csv-stringify/lib":"i03fZ","react":"IMRgT","react-router":"djWTS","../../../../../../../../common/common_utils":"gACUC","../../../../../../../../common/constants":"lLiun","../../../../../dashboard_utils":"jvA8A","../../../../../sesh_router":"hfnpE","../../../../removing_throbber":"TmURk","../../../base_components/loading_throbber":"1I8d2","../../../base_components/sesh_primary_button":"3QyI2","../../../base_components/sesh_search_form":"lufGy","../../../csv_download":"6sVFK","../../../hooks/use_event_list_query":"bB4iO","../../../hooks/use_user_context":"eU1k4","../../page_buttons":"5paOM","./event_row":"4oVnC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i03fZ":[function(require,module,exports,__globalThis) {
/*
CSV Stringify

Please look at the [project documentation](https://csv.js.org/stringify/) for
additional information.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// export default stringify
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "CsvError", ()=>(0, _csvErrorJs.CsvError));
parcelHelpers.export(exports, "Stringifier", ()=>Stringifier);
var _stream = require("stream");
var _csvErrorJs = require("./api/CsvError.js");
var _isObjectJs = require("./utils/is_object.js");
var _indexJs = require("./api/index.js");
var _normalizeOptionsJs = require("./api/normalize_options.js");
class Stringifier extends (0, _stream.Transform) {
    constructor(opts = {}){
        super({
            writableObjectMode: true,
            ...opts
        });
        const [err, options] = (0, _normalizeOptionsJs.normalize_options)(opts);
        if (err !== undefined) throw err;
        // Expose options
        this.options = options;
        // Internal state
        this.state = {
            stop: false
        };
        // Information
        this.info = {
            records: 0
        };
        this.api = (0, _indexJs.stringifier)(this.options, this.state, this.info);
        this.api.options.on_record = (...args)=>{
            this.emit('record', ...args);
        };
    }
    _transform(chunk, encoding, callback) {
        if (this.state.stop === true) return;
        const err = this.api.__transform(chunk, this.push.bind(this));
        if (err !== undefined) this.state.stop = true;
        callback(err);
    }
    _flush(callback) {
        if (this.state.stop === true) // Note, Node.js 12 call flush even after an error, we must prevent
        // `callback` from being called in flush without any error.
        return;
        if (this.info.records === 0) {
            this.api.bom(this.push.bind(this));
            const err = this.api.headers(this.push.bind(this));
            if (err) callback(err);
        }
        callback();
    }
}
const stringify = function() {
    let data, options, callback;
    for(const i in arguments){
        const argument = arguments[i];
        const type = typeof argument;
        if (data === undefined && Array.isArray(argument)) data = argument;
        else if (options === undefined && (0, _isObjectJs.is_object)(argument)) options = argument;
        else if (callback === undefined && type === 'function') callback = argument;
        else throw new (0, _csvErrorJs.CsvError)('CSV_INVALID_ARGUMENT', [
            'Invalid argument:',
            `got ${JSON.stringify(argument)} at index ${i}`
        ]);
    }
    const stringifier = new Stringifier(options);
    if (callback) {
        const chunks = [];
        stringifier.on('readable', function() {
            let chunk;
            while((chunk = this.read()) !== null)chunks.push(chunk);
        });
        stringifier.on('error', function(err) {
            callback(err);
        });
        stringifier.on('end', function() {
            callback(undefined, chunks.join(''));
        });
    }
    if (data !== undefined) {
        const writer = function() {
            for (const record of data)stringifier.write(record);
            stringifier.end();
        };
        // Support Deno, Rollup doesnt provide a shim for setImmediate
        if (typeof setImmediate === 'function') setImmediate(writer);
        else setTimeout(writer, 0);
    }
    return stringifier;
};

},{"stream":"eTKI1","./api/CsvError.js":"c2m7W","./utils/is_object.js":"kXJ7k","./api/index.js":"k7ME0","./api/normalize_options.js":"iGNyd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eTKI1":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"jZ1FP","4a6ee9586f51c38d":"9Dxpg","e6206e1f4d20abc7":"bxF0I","a3f1405f37e1dfb1":"iNXwd","6691a72c5fc222fd":"jquri","43a905ce7ec6ac9e":"4CQCI","dd715550d7783885":"8XDZw","d90a3520974ec96e":"2H17Y","eb2779cfd287c5c9":"dl4b4"}],"jZ1FP":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"9Dxpg":[function(require,module,exports,__globalThis) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"bxF0I":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("5cd4b65a2667f30e");
'use strict';
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("c152f2119aca4689").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("ee1c46a25703890d");
/*</replacement>*/ var Buffer = require("efffad1605c95e76").Buffer;
var OurUint8Array = global.Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("f6690d8cb5f89003");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("f8c4515e8234bd59");
var destroyImpl = require("2b842a435cfab72e");
var _require = require("6f90938893f80e4b"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("daceb54799edbc39").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("6b2730f2f68f00ce")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("d53c82af0b49f760");
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("d53c82af0b49f760");
    if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
    } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug('onend');
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug('cleanup'); // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        debug('ondata');
        var ret = dest.write(chunk);
        debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit('pipe', src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug('pipe resume');
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug('on readable', state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount('data') > 0) self.resume();
}
function nReadingNextTick(self) {
    debug('readable nexttick read 0');
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug('resume'); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === 'function') Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("746c700ae68bf97c");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === 'function') Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7770a768738aeba9");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"5cd4b65a2667f30e":"elRZ0","c152f2119aca4689":"jZ1FP","ee1c46a25703890d":"dLNEM","efffad1605c95e76":"aegCb","f6690d8cb5f89003":"bu3mH","f8c4515e8234bd59":"ib4VR","2b842a435cfab72e":"l9N9m","6f90938893f80e4b":"gRTZ9","daceb54799edbc39":"jnlBZ","6b2730f2f68f00ce":"9Dxpg","d53c82af0b49f760":"jquri","e7e497563ff3b269":"dFEGL","746c700ae68bf97c":"kcRYu","7770a768738aeba9":"fYzTQ"}],"elRZ0":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"dLNEM":[function(require,module,exports,__globalThis) {
module.exports = require("256d09989820a7e9").EventEmitter;

},{"256d09989820a7e9":"jZ1FP"}],"bu3mH":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"ib4VR":[function(require,module,exports,__globalThis) {
'use strict';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var _require = require("56f983784a0fab6f"), Buffer = _require.Buffer;
var _require2 = require("95cdcc9e77389728"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"56f983784a0fab6f":"aegCb","95cdcc9e77389728":"bu3mH"}],"l9N9m":[function(require,module,exports,__globalThis) {
var process = require("688ab6a28ddb436d");
'use strict'; // undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit('error', err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"688ab6a28ddb436d":"elRZ0"}],"gRTZ9":[function(require,module,exports,__globalThis) {
'use strict';
var ERR_INVALID_OPT_VALUE = require("4543c6055fd8382c").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4543c6055fd8382c":"jnlBZ"}],"jnlBZ":[function(require,module,exports,__globalThis) {
'use strict';
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if (endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    else {
        var type = includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],"jquri":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("34d2aeaf352b4512");
'use strict';
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("7b75ce1e482a8dfb");
var Writable = require("fd2e3b6f36c506e9");
require("7dcb079aaf2f7ac6")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"34d2aeaf352b4512":"elRZ0","7b75ce1e482a8dfb":"bxF0I","fd2e3b6f36c506e9":"iNXwd","7dcb079aaf2f7ac6":"9Dxpg"}],"iNXwd":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("960325341c691095");
'use strict';
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("7d0952b2aab2880f")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("d4a8b8f0181be806");
/*</replacement>*/ var Buffer = require("329aa7fef0ab6df1").Buffer;
var OurUint8Array = global.Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("6a39a8b28b6e8ab4");
var _require = require("4b9079029d7ad85f"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("4d4d95a33057eaa").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("df23fd9c6d29b882")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("a02e72411207d1a6");
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("a02e72411207d1a6"); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
} // if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"960325341c691095":"elRZ0","7d0952b2aab2880f":"3B5lH","d4a8b8f0181be806":"dLNEM","329aa7fef0ab6df1":"aegCb","6a39a8b28b6e8ab4":"l9N9m","4b9079029d7ad85f":"gRTZ9","4d4d95a33057eaa":"jnlBZ","df23fd9c6d29b882":"9Dxpg","a02e72411207d1a6":"jquri"}],"3B5lH":[function(require,module,exports,__globalThis) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config('throwDeprecation')) throw new Error(msg);
            else if (config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

},{}],"dFEGL":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

},{"2a29807c689a070a":"jToBu"}],"jToBu":[function(require,module,exports,__globalThis) {
/* eslint-disable node/no-deprecated-api */ var buffer = require("e514375b8bd1a829");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return buffer.SlowBuffer(size);
};

},{"e514375b8bd1a829":"aegCb"}],"kcRYu":[function(require,module,exports,__globalThis) {
var process = require("cc8bd4d851c0d480");
'use strict';
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var finished = require("c70af6a403549764");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on('readable', onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"cc8bd4d851c0d480":"elRZ0","c70af6a403549764":"2H17Y"}],"2H17Y":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var ERR_STREAM_PREMATURE_CLOSE = require("260b8c2ccb6493b7").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
    if (typeof opts === 'function') return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if (isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = eos;

},{"260b8c2ccb6493b7":"jnlBZ"}],"fYzTQ":[function(require,module,exports,__globalThis) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

},{}],"4CQCI":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = Transform;
var _require$codes = require("181e3ac8da6bd561").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("74feb8f76dae610a");
require("7382ff9fb3538488")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"181e3ac8da6bd561":"jnlBZ","74feb8f76dae610a":"jquri","7382ff9fb3538488":"9Dxpg"}],"8XDZw":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = PassThrough;
var Transform = require("ef151ac5a8afeb5c");
require("ad2dd1617f55ad62")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"ef151ac5a8afeb5c":"4CQCI","ad2dd1617f55ad62":"9Dxpg"}],"dl4b4":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("e9d469d31ac56495").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if (eos === undefined) eos = require("96a756f22061fd7");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED('pipe'));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== 'function') return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"e9d469d31ac56495":"jnlBZ","96a756f22061fd7":"2H17Y"}],"c2m7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CsvError", ()=>CsvError);
var Buffer = require("1d17eb630e27486e").Buffer;
class CsvError extends Error {
    constructor(code, message, ...contexts){
        if (Array.isArray(message)) message = message.join(' ');
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, CsvError);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = Buffer.isBuffer(value) ? value.toString() : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}

},{"1d17eb630e27486e":"aegCb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kXJ7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "is_object", ()=>is_object);
const is_object = function(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k7ME0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringifier", ()=>stringifier);
var _getJs = require("../utils/get.js");
var _isObjectJs = require("../utils/is_object.js");
var _normalizeColumnsJs = require("./normalize_columns.js");
var _normalizeOptionsJs = require("./normalize_options.js");
var Buffer = require("18480bbb98e04e08").Buffer;
const bom_utf8 = Buffer.from([
    239,
    187,
    191
]);
const stringifier = function(options, state, info) {
    return {
        options: options,
        state: state,
        info: info,
        __transform: function(chunk, push) {
            // Chunk validation
            if (!Array.isArray(chunk) && typeof chunk !== 'object') return Error(`Invalid Record: expect an array or an object, got ${JSON.stringify(chunk)}`);
            // Detect columns from the first record
            if (this.info.records === 0) {
                if (Array.isArray(chunk)) {
                    if (this.options.header === true && this.options.columns === undefined) return Error('Undiscoverable Columns: header option requires column option or object records');
                } else if (this.options.columns === undefined) {
                    const [err, columns] = (0, _normalizeColumnsJs.normalize_columns)(Object.keys(chunk));
                    if (err) return;
                    this.options.columns = columns;
                }
            }
            // Emit the header
            if (this.info.records === 0) {
                this.bom(push);
                const err = this.headers(push);
                if (err) return err;
            }
            // Emit and stringify the record if an object or an array
            try {
                // this.emit('record', chunk, this.info.records);
                if (this.options.on_record) this.options.on_record(chunk, this.info.records);
            } catch (err) {
                return err;
            }
            // Convert the record into a string
            let err, chunk_string;
            if (this.options.eof) {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else chunk_string = chunk_string + this.options.record_delimiter;
            } else {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else if (this.options.header || this.info.records) chunk_string = this.options.record_delimiter + chunk_string;
            }
            // Emit the csv
            this.info.records++;
            push(chunk_string);
        },
        stringify: function(chunk, chunkIsHeader = false) {
            if (typeof chunk !== 'object') return [
                undefined,
                chunk
            ];
            const { columns } = this.options;
            const record = [];
            // Record is an array
            if (Array.isArray(chunk)) {
                // We are getting an array but the user has specified output columns. In
                // this case, we respect the columns indexes
                if (columns) chunk.splice(columns.length);
                // Cast record elements
                for(let i = 0; i < chunk.length; i++){
                    const field = chunk[i];
                    const [err, value] = this.__cast(field, {
                        index: i,
                        column: i,
                        records: this.info.records,
                        header: chunkIsHeader
                    });
                    if (err) return [
                        err
                    ];
                    record[i] = [
                        value,
                        field
                    ];
                }
            // Record is a literal object
            // `columns` is always defined: it is either provided or discovered.
            } else for(let i = 0; i < columns.length; i++){
                const field = (0, _getJs.get)(chunk, columns[i].key);
                const [err, value] = this.__cast(field, {
                    index: i,
                    column: columns[i].key,
                    records: this.info.records,
                    header: chunkIsHeader
                });
                if (err) return [
                    err
                ];
                record[i] = [
                    value,
                    field
                ];
            }
            let csvrecord = '';
            for(let i = 0; i < record.length; i++){
                let options, err;
                // eslint-disable-next-line
                let [value, field] = record[i];
                if (typeof value === "string") options = this.options;
                else if ((0, _isObjectJs.is_object)(value)) {
                    options = value;
                    value = options.value;
                    delete options.value;
                    if (typeof value !== "string" && value !== undefined && value !== null) {
                        if (err) return [
                            Error(`Invalid Casting Value: returned value must return a string, null or undefined, got ${JSON.stringify(value)}`)
                        ];
                    }
                    options = {
                        ...this.options,
                        ...options
                    };
                    [err, options] = (0, _normalizeOptionsJs.normalize_options)(options);
                    if (err !== undefined) return [
                        err
                    ];
                } else if (value === undefined || value === null) options = this.options;
                else return [
                    Error(`Invalid Casting Value: returned value must return a string, an object, null or undefined, got ${JSON.stringify(value)}`)
                ];
                const { delimiter, escape, quote, quoted, quoted_empty, quoted_string, quoted_match, record_delimiter } = options;
                if ('' === value && '' === field) {
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === 'string') return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    const shouldQuote = quotedMatch || true === quoted_empty || true === quoted_string && false !== quoted_empty;
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (value) {
                    if (typeof value !== 'string') return [
                        Error(`Formatter must return a string, null or undefined, got ${JSON.stringify(value)}`)
                    ];
                    const containsdelimiter = delimiter.length && value.indexOf(delimiter) >= 0;
                    const containsQuote = quote !== '' && value.indexOf(quote) >= 0;
                    const containsEscape = value.indexOf(escape) >= 0 && escape !== quote;
                    const containsRecordDelimiter = value.indexOf(record_delimiter) >= 0;
                    const quotedString = quoted_string && typeof field === 'string';
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === 'string') return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    const shouldQuote = containsQuote === true || containsdelimiter || containsRecordDelimiter || quoted || quotedString || quotedMatch;
                    if (shouldQuote === true && containsEscape === true) {
                        const regexp = escape === '\\' ? new RegExp(escape + escape, 'g') : new RegExp(escape, 'g');
                        value = value.replace(regexp, escape + escape);
                    }
                    if (containsQuote === true) {
                        const regexp = new RegExp(quote, 'g');
                        value = value.replace(regexp, escape + quote);
                    }
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (quoted_empty === true || field === '' && quoted_string === true && quoted_empty !== false) csvrecord += quote + quote;
                if (i !== record.length - 1) csvrecord += delimiter;
            }
            return [
                undefined,
                csvrecord
            ];
        },
        bom: function(push) {
            if (this.options.bom !== true) return;
            push(bom_utf8);
        },
        headers: function(push) {
            if (this.options.header === false) return;
            if (this.options.columns === undefined) return;
            let err;
            let headers = this.options.columns.map((column)=>column.header);
            if (this.options.eof) {
                [err, headers] = this.stringify(headers, true);
                headers += this.options.record_delimiter;
            } else [err, headers] = this.stringify(headers);
            if (err) return err;
            push(headers);
        },
        __cast: function(value, context) {
            const type = typeof value;
            try {
                if (type === 'string') return [
                    undefined,
                    this.options.cast.string(value, context)
                ];
                else if (type === 'bigint') return [
                    undefined,
                    this.options.cast.bigint(value, context)
                ];
                else if (type === 'number') return [
                    undefined,
                    this.options.cast.number(value, context)
                ];
                else if (type === 'boolean') return [
                    undefined,
                    this.options.cast.boolean(value, context)
                ];
                else if (value instanceof Date) return [
                    undefined,
                    this.options.cast.date(value, context)
                ];
                else if (type === 'object' && value !== null) return [
                    undefined,
                    this.options.cast.object(value, context)
                ];
                else return [
                    undefined,
                    value,
                    value
                ];
            } catch (err) {
                return [
                    err
                ];
            }
        }
    };
};

},{"18480bbb98e04e08":"aegCb","../utils/get.js":"bS0gS","../utils/is_object.js":"kXJ7k","./normalize_columns.js":"cLrGb","./normalize_options.js":"iGNyd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bS0gS":[function(require,module,exports,__globalThis) {
// Lodash implementation of `get`
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
const charCodeOfDot = '.'.charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", 'g');
const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const reIsPlainProp = /^\w*$/;
const getTag = function(value) {
    value;
    return Object.prototype.toString.call(value);
};
const isSymbol = function(value) {
    const type = typeof value;
    return type === 'symbol' || type === 'object' && value && getTag(value) === '[object Symbol]';
};
const isKey = function(value, object) {
    if (Array.isArray(value)) return false;
    const type = typeof value;
    if (type === 'number' || type === 'symbol' || type === 'boolean' || !value || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
};
const stringToPath = function(string) {
    const result = [];
    if (string.charCodeAt(0) === charCodeOfDot) result.push('');
    string.replace(rePropName, function(match, expression, quote, subString) {
        let key = match;
        if (quote) key = subString.replace(reEscapeChar, '$1');
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
const castPath = function(value, object) {
    if (Array.isArray(value)) return value;
    else return isKey(value, object) ? [
        value
    ] : stringToPath(value);
};
const toKey = function(value) {
    if (typeof value === 'string' || isSymbol(value)) return value;
    const result = `${value}`;
    // eslint-disable-next-line
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
};
const get = function(object, path) {
    path = castPath(path, object);
    let index = 0;
    const length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index === length ? object : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cLrGb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize_columns", ()=>normalize_columns);
const normalize_columns = function(columns) {
    if (columns === undefined || columns === null) return [
        undefined,
        undefined
    ];
    if (typeof columns !== 'object') return [
        Error('Invalid option "columns": expect an array or an object')
    ];
    if (!Array.isArray(columns)) {
        const newcolumns = [];
        for(const k in columns)newcolumns.push({
            key: k,
            header: columns[k]
        });
        columns = newcolumns;
    } else {
        const newcolumns = [];
        for (const column of columns){
            if (typeof column === 'string') newcolumns.push({
                key: column,
                header: column
            });
            else if (typeof column === 'object' && column !== null && !Array.isArray(column)) {
                if (!column.key) return [
                    Error('Invalid column definition: property "key" is required')
                ];
                if (column.header === undefined) column.header = column.key;
                newcolumns.push(column);
            } else return [
                Error('Invalid column definition: expect a string or an object')
            ];
        }
        columns = newcolumns;
    }
    return [
        undefined,
        columns
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iGNyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize_options", ()=>normalize_options);
var _csvErrorJs = require("./CsvError.js");
var _normalizeColumnsJs = require("./normalize_columns.js");
var _underscoreJs = require("../utils/underscore.js");
var Buffer = require("3abb7d02c5a98b70").Buffer;
const normalize_options = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[(0, _underscoreJs.underscore)(opt)] = opts[opt];
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) return [
        new (0, _csvErrorJs.CsvError)('CSV_OPTION_BOOLEAN_INVALID_TYPE', [
            'option `bom` is optional and must be a boolean value,',
            `got ${JSON.stringify(options.bom)}`
        ])
    ];
    // Normalize option `delimiter`
    if (options.delimiter === undefined || options.delimiter === null) options.delimiter = ',';
    else if (Buffer.isBuffer(options.delimiter)) options.delimiter = options.delimiter.toString();
    else if (typeof options.delimiter !== 'string') return [
        new (0, _csvErrorJs.CsvError)('CSV_OPTION_DELIMITER_INVALID_TYPE', [
            'option `delimiter` must be a buffer or a string,',
            `got ${JSON.stringify(options.delimiter)}`
        ])
    ];
    // Normalize option `quote`
    if (options.quote === undefined || options.quote === null) options.quote = '"';
    else if (options.quote === true) options.quote = '"';
    else if (options.quote === false) options.quote = '';
    else if (Buffer.isBuffer(options.quote)) options.quote = options.quote.toString();
    else if (typeof options.quote !== 'string') return [
        new (0, _csvErrorJs.CsvError)('CSV_OPTION_QUOTE_INVALID_TYPE', [
            'option `quote` must be a boolean, a buffer or a string,',
            `got ${JSON.stringify(options.quote)}`
        ])
    ];
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `quoted_empty`
    if (options.quoted_empty === undefined || options.quoted_empty === null) options.quoted_empty = undefined;
    // Normalize option `quoted_match`
    if (options.quoted_match === undefined || options.quoted_match === null || options.quoted_match === false) options.quoted_match = null;
    else if (!Array.isArray(options.quoted_match)) options.quoted_match = [
        options.quoted_match
    ];
    if (options.quoted_match) for (const quoted_match of options.quoted_match){
        const isString = typeof quoted_match === 'string';
        const isRegExp = quoted_match instanceof RegExp;
        if (!isString && !isRegExp) return [
            Error(`Invalid Option: quoted_match must be a string or a regex, got ${JSON.stringify(quoted_match)}`)
        ];
    }
    // Normalize option `quoted_string`
    if (options.quoted_string === undefined || options.quoted_string === null) options.quoted_string = false;
    // Normalize option `eof`
    if (options.eof === undefined || options.eof === null) options.eof = true;
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === null) options.escape = '"';
    else if (Buffer.isBuffer(options.escape)) options.escape = options.escape.toString();
    else if (typeof options.escape !== 'string') return [
        Error(`Invalid Option: escape must be a buffer or a string, got ${JSON.stringify(options.escape)}`)
    ];
    if (options.escape.length > 1) return [
        Error(`Invalid Option: escape must be one character, got ${options.escape.length} characters`)
    ];
    // Normalize option `header`
    if (options.header === undefined || options.header === null) options.header = false;
    // Normalize option `columns`
    const [errColumns, columns] = (0, _normalizeColumnsJs.normalize_columns)(options.columns);
    if (errColumns !== undefined) return [
        errColumns
    ];
    options.columns = columns;
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `cast`
    if (options.cast === undefined || options.cast === null) options.cast = {};
    // Normalize option cast.bigint
    if (options.cast.bigint === undefined || options.cast.bigint === null) // Cast boolean to string by default
    options.cast.bigint = (value)=>'' + value;
    // Normalize option cast.boolean
    if (options.cast.boolean === undefined || options.cast.boolean === null) // Cast boolean to string by default
    options.cast.boolean = (value)=>value ? '1' : '';
    // Normalize option cast.date
    if (options.cast.date === undefined || options.cast.date === null) // Cast date to timestamp string by default
    options.cast.date = (value)=>'' + value.getTime();
    // Normalize option cast.number
    if (options.cast.number === undefined || options.cast.number === null) // Cast number to string using native casting by default
    options.cast.number = (value)=>'' + value;
    // Normalize option cast.object
    if (options.cast.object === undefined || options.cast.object === null) // Stringify object as JSON by default
    options.cast.object = (value)=>JSON.stringify(value);
    // Normalize option cast.string
    if (options.cast.string === undefined || options.cast.string === null) // Leave string untouched
    options.cast.string = function(value) {
        return value;
    };
    // Normalize option `on_record`
    if (options.on_record !== undefined && typeof options.on_record !== 'function') return [
        Error(`Invalid Option: "on_record" must be a function.`)
    ];
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined || options.record_delimiter === null) options.record_delimiter = '\n';
    else if (Buffer.isBuffer(options.record_delimiter)) options.record_delimiter = options.record_delimiter.toString();
    else if (typeof options.record_delimiter !== 'string') return [
        Error(`Invalid Option: record_delimiter must be a buffer or a string, got ${JSON.stringify(options.record_delimiter)}`)
    ];
    switch(options.record_delimiter){
        case 'auto':
            options.record_delimiter = null;
            break;
        case 'unix':
            options.record_delimiter = "\n";
            break;
        case 'mac':
            options.record_delimiter = "\r";
            break;
        case 'windows':
            options.record_delimiter = "\r\n";
            break;
        case 'ascii':
            options.record_delimiter = "\u001e";
            break;
        case 'unicode':
            options.record_delimiter = "\u2028";
            break;
    }
    return [
        undefined,
        options
    ];
};

},{"3abb7d02c5a98b70":"aegCb","./CsvError.js":"c2m7W","./normalize_columns.js":"cLrGb","../utils/underscore.js":"dcNsB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dcNsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "underscore", ()=>underscore);
const underscore = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return '_' + match.toLowerCase();
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6sVFK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSVDownload", ()=>CSVDownload);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function CSVDownload(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: (0, _classnamesDefault.default)("manual-link ml-auto flex items-center gap-2", {
            "input-disabled": props.is_loading
        }),
        onClick: ()=>{
            if (props.is_loading) return;
            props.onClick();
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-file-download"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Download CSV"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5paOM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageButtons", ()=>PageButtons);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _removingThrobber = require("../../removing_throbber");
var _seshAddonInput = require("../base_components/sesh_addon_input");
function PageButtons(props) {
    const buttons = [];
    const total_pages = Math.ceil(props.total_items / props.items_per_page);
    const numbered_buttons = 2;
    const page_index = props.page;
    if (props.page > total_pages) props.setPage(total_pages - 1);
    for(let i = page_index - numbered_buttons; i < page_index + numbered_buttons + 1; i++){
        let current_page_num = i;
        if (current_page_num < 0) current_page_num = page_index + numbered_buttons + Math.abs(i);
        if (current_page_num >= total_pages) {
            const diff = current_page_num - (total_pages - 1);
            current_page_num = page_index - numbered_buttons - diff;
        }
        if (current_page_num >= total_pages || current_page_num < 0) continue;
        buttons.push({
            label: (current_page_num + 1).toString(),
            value: current_page_num
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _classnamesDefault.default)({
                            invisible: !props.is_loading
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                        is_disabled: props.is_loading,
                        value: props.page,
                        setValue: props.setPage,
                        buttons: [
                            {
                                label: "<",
                                value: Math.max(props.page - 1, 0),
                                disable_selected_state: true
                            },
                            ...buttons.sort((a, b)=>a.value - b.value),
                            {
                                label: ">",
                                value: Math.min(props.page + 1, total_pages - 1),
                                disable_selected_state: true
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    "Showing ",
                    props.page * props.items_per_page,
                    "-",
                    Math.min((props.page + 1) * props.items_per_page, props.total_items),
                    " ",
                    "of ",
                    props.total_items
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../removing_throbber":"TmURk","../base_components/sesh_addon_input":"pd6di","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kkvHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Note", ()=>Note);
var _jsxRuntime = require("react/jsx-runtime");
function Note(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "note",
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kMi2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RepeatFormComponent", ()=>RepeatFormComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _rrule = require("rrule");
var _eventCreation = require("../../event_creation");
var _repeatForm = require("./repeat_form/repeat_form");
var _repeatFormDefault = parcelHelpers.interopDefault(_repeatForm);
var _seshAccordianComponent = require("./sesh_accordian_component");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function RepeatFormComponent(props) {
    const event_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    const { state: event_state, setState, props: event_props } = event_context;
    const [ephemeral_rrule, setEphemeralRRule] = (0, _react.useState)(event_state.rrule ?? new (0, _rrule.RRule)({
        freq: (0, _rrule.RRule).WEEKLY,
        interval: 1
    }));
    const is_enabled = !!event_state.rrule;
    const repeat_form = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repeatFormDefault.default), {
        event_timezone: event_state.event_timezone,
        guild_timezone: event_state.guild_timezone,
        user_timezone: event_state.user_timezone,
        use_24h_clock: event_state.use_24h_clock,
        previous_event_timezone: event_props.edit_data?.event_timezone,
        initial_value: ephemeral_rrule,
        start_time: event_state.start_time,
        end_time: props.end_time,
        allow_maintaining_rsvp: event_state.allow_maintain_repeat_rsvp,
        rruleUpdateFunc: (val)=>{
            if (!is_enabled || props.disabled) return;
            setState({
                rrule: val
            });
            setEphemeralRRule(val);
        },
        eventTimezoneUpdateFunc: (val)=>{
            if (!is_enabled || props.disabled) return;
            setState({
                event_timezone: val
            });
        },
        maintainRSVPUpdateFunc: (val)=>{
            if (!is_enabled || props.disabled) return;
            setState({
                allow_maintain_repeat_rsvp: val
            });
        },
        should_hide_time_listing: !is_enabled
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
        is_opened: is_enabled,
        does_require_premium: true,
        does_server_have_premium: event_props.is_premium,
        label: "Repeat",
        info: "Repeat options for this event",
        onChange: (val)=>{
            if (props.disabled) return;
            setState({
                rrule: val ? ephemeral_rrule : null
            });
        },
        disabled: props.disabled,
        closed_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "cursor-not-allowed opacity-25",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "disable-pointer-events",
                children: repeat_form
            })
        }),
        children: repeat_form
    });
}

},{"react/jsx-runtime":"dpQXr","rrule":"ilLpP","../../event_creation":"a8uX3","./repeat_form/repeat_form":"4oBoW","./sesh_accordian_component":"9ti9e","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4oBoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RepeatForm);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _rrule = require("rrule");
var _repeatUtils = require("../../../../../../common/repeat_utils");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _reactRruleGenerator = require("../../../react-rrule-generator");
var _reactRruleGeneratorDefault = parcelHelpers.interopDefault(_reactRruleGenerator);
var _useEventCreationContext = require("../hooks/use_event_creation_context");
var _infoTooltip = require("../tooltips/info_tooltip");
var _editRepeatOccurrencesSection = require("./edit_repeat_occurrences_section");
function getRRuleString(rrule) {
    if (!rrule) return "";
    return rrule.toString();
}
function getNextDSTSwitchDate(local_now) {
    const starting_month = local_now.month;
    const starting_offset = local_now.offset;
    for(let i = 0; i < 12; i++){
        const current_month_index = starting_month + i + 1;
        const new_date_by_month = local_now.set({
            month: current_month_index,
            day: 1,
            hour: 0,
            minute: 0,
            second: 0
        });
        // we found a differing offset at the start of a month, must've changed in previous month
        if (new_date_by_month.offset != starting_offset) {
            const previous_month = new_date_by_month.minus({
                months: 1
            });
            for(let day = 0; day < previous_month.daysInMonth; day++){
                const day_index = day + 1;
                const new_date_by_day = previous_month.set({
                    day: day_index
                });
                if (new_date_by_day.offset != starting_offset) {
                    const previous_day = previous_month.set({
                        day: day_index - 1
                    });
                    for(let hour = 0; hour < 24; hour++){
                        const new_date_by_hour = previous_day.set({
                            hour
                        });
                        if (new_date_by_hour.offset != starting_offset) return new_date_by_hour;
                    }
                }
            }
        }
    }
    return null;
}
function RepeatTZSelect(props) {
    const date_to_use = props.start_time ? props.start_time : (0, _luxon.DateTime).utc();
    const date = date_to_use.setZone(props.current_event_timezone);
    let DST_date;
    if (!date.isOffsetFixed) DST_date = getNextDSTSwitchDate(date);
    let info_note;
    if (date.isOffsetFixed || !DST_date || !DST_date.isValid) info_note = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        children: [
            "This event will be created using the",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "emphasis",
                children: props.current_event_timezone
            }),
            " ",
            "region which does not observe Daylight Savings Time."
        ]
    });
    else {
        const start_or_end_text = DST_date.isInDST ? "start" : "end";
        const date_text = DST_date.toLocaleString({
            dateStyle: "long"
        });
        info_note = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            children: [
                "This event will be created using the",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "emphasis",
                    children: props.current_event_timezone
                }),
                " ",
                "region which observes Daylight Savings Time. DST will",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "emphasis",
                    children: start_or_end_text
                }),
                " on",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "emphasis",
                    children: date_text
                }),
                ". After this date, the event time will be automatically adjusted to maintain the same time of day in the",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "emphasis",
                    children: props.current_event_timezone
                }),
                " ",
                "timezone."
            ]
        });
    }
    const is_previous_timezone_different = props.previous_event_timezone && props.previous_event_timezone !== props.guild_timezone && props.previous_event_timezone !== props.user_timezone;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-wrap gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                info: info_note
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Timezone:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.user_timezone === props.guild_timezone && props.user_timezone === props.previous_event_timezone ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: props.guild_timezone
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                    className: "inline-dropdown",
                    onChange: (e)=>props.eventTimezoneUpdateFunc(e.target.value),
                    value: props.current_event_timezone,
                    children: [
                        is_previous_timezone_different && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                            value: props.previous_event_timezone,
                            children: [
                                props.previous_event_timezone,
                                " (previous)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                            value: props.user_timezone,
                            children: [
                                props.user_timezone,
                                " (local)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                            value: props.guild_timezone,
                            children: [
                                props.guild_timezone,
                                " (server)"
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function RecurringTimesDisplay(props) {
    const { state } = (0, _useEventCreationContext.useEventCreationContext)();
    if (!props.rrule) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    let repeating_guild_times = undefined;
    let start_time = (0, _luxon.DateTime).local();
    const guild_timezone = props.guild_timezone;
    if (props.start_time) {
        start_time = props.start_time;
        if (guild_timezone) {
            let local_time_list_elements = [];
            let guild_time_list_elements = [];
            const rrule_utc_string = (0, _rrule.RRule).optionsToString((0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone(state.rrule.origOptions, state.user_timezone, state.start_time));
            const local_rrule_set = (0, _repeatUtils.createRRuleSet)({
                repeat_tz: state.event_timezone,
                rrule_str: rrule_utc_string,
                start_time_js: props.start_time.toJSDate(),
                exdates: state.exdates,
                rdates: state.rdates
            });
            (0, _repeatUtils.getNextNOccurrences)(local_rrule_set, props.start_time.toJSDate(), state.event_timezone, 4).forEach((date, index)=>{
                const local_luxon = (0, _repeatUtils.rruleTimeToLocalTime)(date);
                const local_string = (0, _timeFormatUtils.time_format_utils).formatTimeConciseV2(local_luxon, true);
                // let local_string = time_format_utils.format_time_concise(
                // 	DateTime.fromJSDate(date),
                // 	null,
                // 	props.use_24h_clock,
                // 	true
                // );
                local_time_list_elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: local_string
                }, index));
                let guild_string = (0, _timeFormatUtils.time_format_utils).formatTimeConciseV2(local_luxon.setZone(guild_timezone), false);
                guild_time_list_elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: guild_string
                }, index));
            });
            let subsequent_event_display_string;
            if (props.end_time) subsequent_event_display_string = "Subsequent events will be posted when the previous one ends.";
            else subsequent_event_display_string = `Subsequent events will be posted 1 hour after the previous event begins.`;
            if (props.user_timezone === guild_timezone) repeating_guild_times = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "column is-half",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Event Repeat Times (",
                                                    (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time.setZone(props.user_timezone), props.user_timezone),
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                        children: [
                                            local_time_list_elements,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: "..."
                                            }, "ellipsis")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: subsequent_event_display_string
                    })
                ]
            });
            else repeating_guild_times = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "column is-half",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Local Repeat Times (",
                                                    (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time.setZone(props.user_timezone), props.user_timezone),
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                        children: [
                                            local_time_list_elements,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: "..."
                                            }, "ellipsis")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "column is-half",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Server Repeat Times (",
                                                    (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time.setZone(guild_timezone), guild_timezone),
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                        children: [
                                            guild_time_list_elements,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: "..."
                                            }, "ellipsis")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: subsequent_event_display_string
                    })
                ]
            });
        }
    }
    if (props.start_time && repeating_guild_times) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "note",
        children: repeating_guild_times
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}
function RepeatForm(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RepeatTZSelect, {
                start_time: props.start_time,
                user_timezone: props.user_timezone,
                guild_timezone: props.guild_timezone,
                current_event_timezone: props.event_timezone,
                previous_event_timezone: props.previous_event_timezone,
                eventTimezoneUpdateFunc: props.eventTimezoneUpdateFunc
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRruleGeneratorDefault.default), {
                onChange: (val)=>props.rruleUpdateFunc(val ? (0, _rrule.RRule).fromString(val) : null),
                value: getRRuleString(props.initial_value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editRepeatOccurrencesSection.EditRepeatOccurrencesSection), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "py-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        name: "has_reminders",
                        checked: props.allow_maintaining_rsvp,
                        onChange: (e)=>props.maintainRSVPUpdateFunc(e.target.checked)
                    }),
                    " ",
                    "Allow users to maintain RSVP for future events"
                ]
            }),
            !props.should_hide_time_listing && /*#__PURE__*/ (0, _jsxRuntime.jsx)(RecurringTimesDisplay, {
                start_time: props.start_time,
                end_time: props.end_time,
                guild_timezone: props.guild_timezone,
                rrule: props.initial_value,
                use_24h_clock: props.use_24h_clock,
                user_timezone: props.user_timezone
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","rrule":"ilLpP","../../../../../../common/repeat_utils":"gG7ok","../../../../../../common/time_format_utils":"g0uQN","../../../react-rrule-generator":"j7d2B","../hooks/use_event_creation_context":"flKqC","../tooltips/info_tooltip":"93rAL","./edit_repeat_occurrences_section":"aJ55g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j7d2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "translations", ()=>(0, _translationsDefault.default));
var _reactRRuleGenerator = require("./components/ReactRRuleGenerator");
var _reactRRuleGeneratorDefault = parcelHelpers.interopDefault(_reactRRuleGenerator);
var _translations = require("./translations");
var _translationsDefault = parcelHelpers.interopDefault(_translations);
exports.default = (0, _reactRRuleGeneratorDefault.default);

},{"./components/ReactRRuleGenerator":"7UBk3","./translations":"4I85A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7UBk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _lodash = require("lodash");
var _index = require("./Start/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("./Repeat/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _index2 = require("./End/index");
var _indexDefault2 = parcelHelpers.interopDefault(_index2);
var _computeRRule = require("../utils/computeRRule/toString/computeRRule");
var _computeRRuleDefault = parcelHelpers.interopDefault(_computeRRule);
var _computeRRule1 = require("../utils/computeRRule/fromString/computeRRule");
var _computeRRuleDefault1 = parcelHelpers.interopDefault(_computeRRule1);
var _configureInitialState = require("../utils/configureInitialState");
var _configureInitialStateDefault = parcelHelpers.interopDefault(_configureInitialState);
var _translateLabel = require("../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
var _translations = require("../translations");
var _translationsDefault = parcelHelpers.interopDefault(_translations);
var _indexCss = require("../styles/index.css");
var _rrule = require("rrule");
class ReactRRuleGenerator extends (0, _react.PureComponent) {
    // compute default view based on user's config
    state = (0, _configureInitialStateDefault.default)(this.props.config, this.props.calendarComponent, this.props.id);
    UNSAFE_componentWillMount() {
        if (this.props.onChange === ReactRRuleGenerator.defaultProps.onChange) // no onChange() was provided
        throw new Error("No onChange() function has been passed to RRuleGenerator. \nPlease provide one, it's needed to handle generated value.");
        if (this.props.value) {
            // if value is provided to RRuleGenerator, it's used to compute state of component's forms
            const data = (0, _computeRRuleDefault1.default)(this.state.data, this.props.value);
            this.setState({
                data
            });
        } else {
            // Set Default RRULE
            let default_rrule = new (0, _rrule.RRule)({
                freq: (0, _rrule.RRule).WEEKLY,
                interval: 1
            }).toString();
            let data = (0, _computeRRuleDefault1.default)(this.state.data, default_rrule);
            this.setState({
                data
            });
            this.props.onChange(default_rrule);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value && !this.props.value) this.setState((0, _configureInitialStateDefault.default)(this.props.config, this.props.calendarComponent, this.props.id));
    }
    handleChange = ({ target })=>{
        const newData = (0, _lodash.cloneDeep)(this.state.data);
        (0, _lodash.set)(newData, target.name, target.value);
        const rrule = (0, _computeRRuleDefault.default)(newData);
        this.setState({
            data: newData
        });
        this.props.onChange(rrule);
    };
    render() {
        const { id, data: { start, repeat, end, options, error } } = this.state;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field sesh-rrule",
            children: [
                !options.hideError && error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "alert alert-danger",
                    children: (0, _translateLabelDefault.default)(this.props.translations, "invalid_rrule", {
                        value: error.value
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded px-0 pt-3",
                    children: [
                        !options.hideStart && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault.default), {
                                    id: `${id}-start`,
                                    start: start,
                                    handleChange: this.handleChange,
                                    translations: this.props.translations
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault1.default), {
                                id: `${id}-repeat`,
                                repeat: repeat,
                                handleChange: this.handleChange,
                                translations: this.props.translations
                            })
                        }),
                        !options.hideEnd && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault2.default), {
                                id: `${id}-end`,
                                end: end,
                                handleChange: this.handleChange,
                                translations: this.props.translations
                            })
                        })
                    ]
                })
            ]
        });
    }
}
ReactRRuleGenerator.propTypes = {
    id: (0, _propTypesDefault.default).string,
    config: (0, _propTypesDefault.default).shape({
        frequency: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
            "Yearly",
            "Monthly",
            "Weekly",
            "Daily",
            "Hourly"
        ])),
        yearly: (0, _propTypesDefault.default).oneOf([
            "on",
            "on the"
        ]),
        monthly: (0, _propTypesDefault.default).oneOf([
            "on",
            "on the"
        ]),
        end: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
            "Never",
            "After",
            "On date"
        ])),
        hideStart: (0, _propTypesDefault.default).bool,
        hideEnd: (0, _propTypesDefault.default).bool,
        hideError: (0, _propTypesDefault.default).bool,
        weekStartsOnSunday: (0, _propTypesDefault.default).bool
    }),
    value: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func,
    calendarComponent: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).element,
        (0, _propTypesDefault.default).func
    ]),
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ])
};
ReactRRuleGenerator.defaultProps = {
    id: null,
    value: "",
    config: {},
    onChange () {},
    calendarComponent: null,
    translations: (0, _translationsDefault.default).english
};
exports.default = ReactRRuleGenerator;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","lodash":"fIO2m","./Start/index":"cDJp6","./Repeat/index":"55UVt","./End/index":"lbBEO","../utils/computeRRule/toString/computeRRule":"1j9RE","../utils/computeRRule/fromString/computeRRule":"cNM48","../utils/configureInitialState":"8gVKm","../utils/translateLabel":"aLp4B","../translations":"4I85A","../styles/index.css":"3SEJl","rrule":"ilLpP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cDJp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _onDate = require("./OnDate");
var _onDateDefault = parcelHelpers.interopDefault(_onDate);
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const Start = ({ id, start: { onDate }, handleChange, translations })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "px-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "form-group row",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "col-sm-2 text-sm-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: id,
                        className: "col-form-label",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: (0, _translateLabelDefault.default)(translations, "start.label")
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onDateDefault.default), {
                    id: id,
                    onDate: onDate,
                    handleChange: handleChange,
                    translations: translations
                })
            ]
        })
    });
Start.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    start: (0, _propTypesDefault.default).shape({
        onDate: (0, _propTypesDefault.default).object.isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = Start;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","./OnDate":"jZ4Zg","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jZ4Zg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactDatetime = require("react-datetime");
var _reactDatetimeDefault = parcelHelpers.interopDefault(_reactDatetime);
var _locales = require("moment/min/locales");
var _index = require("../../constants/index");
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const StartOnDate = ({ id, onDate: { date, options }, handleChange, translations })=>{
    const CustomCalendar = options.calendarComponent;
    const locale = options.weekStartsOnSunday ? 'en-ca' : 'en-gb';
    const calendarAttributes = {
        'aria-label': (0, _translateLabelDefault.default)(translations, 'start.tooltip'),
        value: date,
        dateFormat: (0, _index.DATE_TIME_FORMAT),
        locale,
        readOnly: true
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "col-6 col-sm-3",
        children: CustomCalendar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomCalendar, {
            ...calendarAttributes,
            onChange: (event)=>{
                const editedEvent = {
                    target: {
                        value: event.target.value,
                        name: 'start.onDate.date'
                    }
                };
                handleChange(editedEvent);
            }
        }, `${id}-calendar`) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatetimeDefault.default), {
            ...calendarAttributes,
            inputProps: {
                id: `${id}-datetime`,
                name: 'start.onDate.date',
                readOnly: true
            },
            locale: (0, _translateLabelDefault.default)(translations, 'locale'),
            timeFormat: false,
            viewMode: "days",
            closeOnSelect: true,
            closeOnTab: true,
            required: true,
            onChange: (inputDate)=>{
                const editedEvent = {
                    target: {
                        value: (0, _momentDefault.default)(inputDate).format((0, _index.DATE_TIME_FORMAT)),
                        name: 'start.onDate.date'
                    }
                };
                handleChange(editedEvent);
            }
        })
    });
};
StartOnDate.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    onDate: (0, _propTypesDefault.default).shape({
        date: (0, _propTypesDefault.default).string.isRequired,
        options: (0, _propTypesDefault.default).shape({
            weekStartsOnSunday: (0, _propTypesDefault.default).bool,
            calendarComponent: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).element,
                (0, _propTypesDefault.default).func
            ])
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = StartOnDate;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","moment":"fAGp8","react-datetime":"9rHsb","moment/min/locales":"5rDUU","../../constants/index":"2hd2R","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9rHsb":[function(require,module,exports,__globalThis) {
module.exports = function(e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 4);
}([
    function(e, t) {
        e.exports = require("c6a860992a89d6d4");
    },
    function(e, t) {
        e.exports = require("e5cdb80906268f6f");
    },
    function(e, t) {
        e.exports = require("ec7c649cedac611b");
    },
    function(e, t, n) {
        e.exports = n(5)();
    },
    function(e, t, n) {
        e.exports = n(7);
    },
    function(e, t, n) {
        "use strict";
        var r = n(6);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function() {
            function e(e, t, n, o, i, a) {
                if (a !== r) {
                    var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw s.name = "Invariant Violation", s;
                }
            }
            function t() {
                return e;
            }
            e.isRequired = e;
            var n = {
                array: e,
                bigint: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: i,
                resetWarningCache: o
            };
            return n.PropTypes = n, n;
        };
    },
    function(e, t, n) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(e, t, n) {
        "use strict";
        n.r(t);
        var r = n(3), o = n.n(r), i = n(1), a = n.n(i), s = n(0), c = n.n(s);
        function u() {
            return (u = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function l(e) {
            var t = e.onClickPrev, n = e.onClickSwitch, r = e.onClickNext, o = e.switchContent, i = e.switchColSpan, a = e.switchProps;
            return c.a.createElement("tr", null, c.a.createElement("th", {
                className: "rdtPrev",
                onClick: t
            }, c.a.createElement("span", null, "\u2039")), c.a.createElement("th", u({
                className: "rdtSwitch",
                colSpan: i,
                onClick: n
            }, a), o), c.a.createElement("th", {
                className: "rdtNext",
                onClick: r
            }, c.a.createElement("span", null, "\u203A")));
        }
        function p(e) {
            return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function f(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function d(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function h(e, t) {
            return (h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function y(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = b(e);
                if (t) {
                    var o = b(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return m(this, n);
            };
        }
        function m(e, t) {
            if (t && ("object" === p(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return v(e);
        }
        function v(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function b(e) {
            return (b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function O(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        var g = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && h(e, t);
            }(i, e);
            var t, n, r, o = y(i);
            function i() {
                var e;
                f(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return O(v(e = o.call.apply(o, [
                    this
                ].concat(n))), "_setDate", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtDays"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation(), this.renderDayHeaders()), c.a.createElement("tbody", null, this.renderDays()), this.renderFooter()));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.props.viewDate, n = t.localeData();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-1, "months");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("months");
                            },
                            onClickNext: function() {
                                return e.props.navigate(1, "months");
                            },
                            switchContent: n.months(t) + " " + t.year(),
                            switchColSpan: 5,
                            switchProps: {
                                "data-value": this.props.viewDate.month()
                            }
                        });
                    }
                },
                {
                    key: "renderDayHeaders",
                    value: function() {
                        var e = (function(e) {
                            var t = e.firstDayOfWeek(), n = [], r = 0;
                            return e._weekdaysMin.forEach(function(e) {
                                n[(7 + r++ - t) % 7] = e;
                            }), n;
                        })(this.props.viewDate.localeData()).map(function(e, t) {
                            return c.a.createElement("th", {
                                key: e + t,
                                className: "dow"
                            }, e);
                        });
                        return c.a.createElement("tr", null, e);
                    }
                },
                {
                    key: "renderDays",
                    value: function() {
                        var e = this.props.viewDate, t = e.clone().startOf("month"), n = e.clone().endOf("month"), r = [
                            [],
                            [],
                            [],
                            [],
                            [],
                            []
                        ], o = e.clone().subtract(1, "months");
                        o.date(o.daysInMonth()).startOf("week");
                        for(var i = o.clone().add(42, "d"), a = 0; o.isBefore(i);)w(r, a++).push(this.renderDay(o, t, n)), o.add(1, "d");
                        return r.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: "".concat(i.month(), "_").concat(t)
                            }, e);
                        });
                    }
                },
                {
                    key: "renderDay",
                    value: function(e, t, n) {
                        var r = this.props.selectedDate, o = {
                            key: e.format("M_D"),
                            "data-value": e.date(),
                            "data-month": e.month(),
                            "data-year": e.year()
                        }, i = "rdtDay";
                        return e.isBefore(t) ? i += " rdtOld" : e.isAfter(n) && (i += " rdtNew"), r && e.isSame(r, "day") && (i += " rdtActive"), e.isSame(this.props.moment(), "day") && (i += " rdtToday"), this.props.isValidDate(e) ? o.onClick = this._setDate : i += " rdtDisabled", o.className = i, this.props.renderDay(o, e.clone(), r && r.clone());
                    }
                },
                {
                    key: "renderFooter",
                    value: function() {
                        var e = this;
                        if (this.props.timeFormat) {
                            var t = this.props.viewDate;
                            return c.a.createElement("tfoot", null, c.a.createElement("tr", null, c.a.createElement("td", {
                                onClick: function() {
                                    return e.props.showView("time");
                                },
                                colSpan: 7,
                                className: "rdtTimeToggle"
                            }, t.format(this.props.timeFormat))));
                        }
                    }
                }
            ], d(t.prototype, n), r && d(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function w(e, t) {
            return e[Math.floor(t / 7)];
        }
        function D(e) {
            return (D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function k(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function C(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function P(e, t) {
            return (P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function _(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = S(e);
                if (t) {
                    var o = S(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return E(this, n);
            };
        }
        function E(e, t) {
            if (t && ("object" === D(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return j(e);
        }
        function j(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function S(e) {
            return (S = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function V(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        O(g, "defaultProps", {
            isValidDate: function() {
                return !0;
            },
            renderDay: function(e, t) {
                return c.a.createElement("td", e, t.date());
            }
        });
        var T = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && P(e, t);
            }(i, e);
            var t, n, r, o = _(i);
            function i() {
                var e;
                k(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return V(j(e = o.call.apply(o, [
                    this
                ].concat(n))), "_updateSelectedMonth", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtMonths"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation())), c.a.createElement("table", null, c.a.createElement("tbody", null, this.renderMonths())));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.props.viewDate.year();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-1, "years");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("years");
                            },
                            onClickNext: function() {
                                return e.props.navigate(1, "years");
                            },
                            switchContent: t,
                            switchColSpan: "2"
                        });
                    }
                },
                {
                    key: "renderMonths",
                    value: function() {
                        for(var e = [
                            [],
                            [],
                            []
                        ], t = 0; t < 12; t++)N(e, t).push(this.renderMonth(t));
                        return e.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: t
                            }, e);
                        });
                    }
                },
                {
                    key: "renderMonth",
                    value: function(e) {
                        var t, n = this.props.selectedDate, r = "rdtMonth";
                        this.isDisabledMonth(e) ? r += " rdtDisabled" : t = this._updateSelectedMonth, n && n.year() === this.props.viewDate.year() && n.month() === e && (r += " rdtActive");
                        var o = {
                            key: e,
                            className: r,
                            "data-value": e,
                            onClick: t
                        };
                        return this.props.renderMonth ? this.props.renderMonth(o, e, this.props.viewDate.year(), this.props.selectedDate && this.props.selectedDate.clone()) : c.a.createElement("td", o, this.getMonthText(e));
                    }
                },
                {
                    key: "isDisabledMonth",
                    value: function(e) {
                        var t = this.props.isValidDate;
                        if (!t) return !1;
                        for(var n = this.props.viewDate.clone().set({
                            month: e
                        }), r = n.endOf("month").date() + 1; r-- > 1;)if (t(n.date(r))) return !1;
                        return !0;
                    }
                },
                {
                    key: "getMonthText",
                    value: function(e) {
                        var t, n = this.props.viewDate, r = n.localeData().monthsShort(n.month(e));
                        return (t = r.substring(0, 3)).charAt(0).toUpperCase() + t.slice(1);
                    }
                }
            ], C(t.prototype, n), r && C(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function N(e, t) {
            return t < 4 ? e[0] : t < 8 ? e[1] : e[2];
        }
        function x(e) {
            return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function F(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function I(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function R(e, t) {
            return (R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function M(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = B(e);
                if (t) {
                    var o = B(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return Y(this, n);
            };
        }
        function Y(e, t) {
            if (t && ("object" === x(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return L(e);
        }
        function L(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function B(e) {
            return (B = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function A(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        var H = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && R(e, t);
            }(i, e);
            var t, n, r, o = M(i);
            function i() {
                var e;
                F(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return A(L(e = o.call.apply(o, [
                    this
                ].concat(n))), "disabledYearsCache", {}), A(L(e), "_updateSelectedYear", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtYears"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation())), c.a.createElement("table", null, c.a.createElement("tbody", null, this.renderYears())));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.getViewYear();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-10, "years");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("years");
                            },
                            onClickNext: function() {
                                return e.props.navigate(10, "years");
                            },
                            switchContent: "".concat(t, "-").concat(t + 9)
                        });
                    }
                },
                {
                    key: "renderYears",
                    value: function() {
                        for(var e = this.getViewYear(), t = [
                            [],
                            [],
                            []
                        ], n = e - 1; n < e + 11; n++)U(t, n - e).push(this.renderYear(n));
                        return t.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: t
                            }, e);
                        });
                    }
                },
                {
                    key: "renderYear",
                    value: function(e) {
                        var t, n = this.getSelectedYear(), r = "rdtYear";
                        this.isDisabledYear(e) ? r += " rdtDisabled" : t = this._updateSelectedYear, n === e && (r += " rdtActive");
                        var o = {
                            key: e,
                            className: r,
                            "data-value": e,
                            onClick: t
                        };
                        return this.props.renderYear(o, e, this.props.selectedDate && this.props.selectedDate.clone());
                    }
                },
                {
                    key: "getViewYear",
                    value: function() {
                        return 10 * parseInt(this.props.viewDate.year() / 10, 10);
                    }
                },
                {
                    key: "getSelectedYear",
                    value: function() {
                        return this.props.selectedDate && this.props.selectedDate.year();
                    }
                },
                {
                    key: "isDisabledYear",
                    value: function(e) {
                        var t = this.disabledYearsCache;
                        if (void 0 !== t[e]) return t[e];
                        var n = this.props.isValidDate;
                        if (!n) return !1;
                        for(var r = this.props.viewDate.clone().set({
                            year: e
                        }), o = r.endOf("year").dayOfYear() + 1; o-- > 1;)if (n(r.dayOfYear(o))) return t[e] = !1, !1;
                        return t[e] = !0, !0;
                    }
                }
            ], I(t.prototype, n), r && I(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function U(e, t) {
            return t < 3 ? e[0] : t < 7 ? e[1] : e[2];
        }
        function Z(e) {
            return (Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function W(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function z(e, t) {
            return (z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function q(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = X(e);
                if (t) {
                    var o = X(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return K(this, n);
            };
        }
        function K(e, t) {
            if (t && ("object" === Z(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }
        function X(e) {
            return (X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function G(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function J(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? G(Object(n), !0).forEach(function(t) {
                    Q(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : G(Object(n)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
            }
            return e;
        }
        function Q(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        A(H, "defaultProps", {
            renderYear: function(e, t) {
                return c.a.createElement("td", e, t);
            }
        });
        var $ = {
            hours: {
                min: 0,
                max: 23,
                step: 1
            },
            minutes: {
                min: 0,
                max: 59,
                step: 1
            },
            seconds: {
                min: 0,
                max: 59,
                step: 1
            },
            milliseconds: {
                min: 0,
                max: 999,
                step: 1
            }
        };
        var ee = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && z(e, t);
            }(i, e);
            var t, n, r, o = q(i);
            function i(e) {
                var t, n, r;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, i), (t = o.call(this, e)).constraints = (n = e.timeConstraints, r = {}, Object.keys($).forEach(function(e) {
                    r[e] = J(J({}, $[e]), n[e] || {});
                }), r), t.state = t.getTimeParts(e.selectedDate || e.viewDate), t;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        var e = this, t = [], n = this.state;
                        return this.getCounters().forEach(function(r, o) {
                            o && "ampm" !== r && t.push(c.a.createElement("div", {
                                key: "sep".concat(o),
                                className: "rdtCounterSeparator"
                            }, ":")), t.push(e.renderCounter(r, n[r]));
                        }), c.a.createElement("div", {
                            className: "rdtTime"
                        }, c.a.createElement("table", null, this.renderHeader(), c.a.createElement("tbody", null, c.a.createElement("tr", null, c.a.createElement("td", null, c.a.createElement("div", {
                            className: "rdtCounters"
                        }, t))))));
                    }
                },
                {
                    key: "renderCounter",
                    value: function(e, t) {
                        var n = this;
                        return "hours" === e && this.isAMPM() && 0 == (t = (t - 1) % 12 + 1) && (t = 12), "ampm" === e && (t = -1 !== this.props.timeFormat.indexOf(" A") ? this.props.viewDate.format("A") : this.props.viewDate.format("a")), c.a.createElement("div", {
                            key: e,
                            className: "rdtCounter"
                        }, c.a.createElement("span", {
                            className: "rdtBtn",
                            onMouseDown: function(t) {
                                return n.onStartClicking(t, "increase", e);
                            }
                        }, "\u25B2"), c.a.createElement("div", {
                            className: "rdtCount"
                        }, t), c.a.createElement("span", {
                            className: "rdtBtn",
                            onMouseDown: function(t) {
                                return n.onStartClicking(t, "decrease", e);
                            }
                        }, "\u25BC"));
                    }
                },
                {
                    key: "renderHeader",
                    value: function() {
                        var e = this;
                        if (this.props.dateFormat) {
                            var t = this.props.selectedDate || this.props.viewDate;
                            return c.a.createElement("thead", null, c.a.createElement("tr", null, c.a.createElement("td", {
                                className: "rdtSwitch",
                                colSpan: "4",
                                onClick: function() {
                                    return e.props.showView("days");
                                }
                            }, t.format(this.props.dateFormat))));
                        }
                    }
                },
                {
                    key: "onStartClicking",
                    value: function(e, t, n) {
                        var r = this;
                        if (!e || !e.button || 0 === e.button) {
                            if ("ampm" === n) return this.toggleDayPart();
                            var o = {}, i = document.body;
                            o[n] = this[t](n), this.setState(o), this.timer = setTimeout(function() {
                                r.increaseTimer = setInterval(function() {
                                    o[n] = r[t](n), r.setState(o);
                                }, 70);
                            }, 500), this.mouseUpListener = function() {
                                clearTimeout(r.timer), clearInterval(r.increaseTimer), r.props.setTime(n, parseInt(r.state[n], 10)), i.removeEventListener("mouseup", r.mouseUpListener), i.removeEventListener("touchend", r.mouseUpListener);
                            }, i.addEventListener("mouseup", this.mouseUpListener), i.addEventListener("touchend", this.mouseUpListener);
                        }
                    }
                },
                {
                    key: "toggleDayPart",
                    value: function() {
                        var e = parseInt(this.state.hours, 10);
                        e >= 12 ? e -= 12 : e += 12, this.props.setTime("hours", e);
                    }
                },
                {
                    key: "increase",
                    value: function(e) {
                        var t = this.constraints[e], n = parseInt(this.state[e], 10) + t.step;
                        return n > t.max && (n = t.min + (n - (t.max + 1))), te(e, n);
                    }
                },
                {
                    key: "decrease",
                    value: function(e) {
                        var t = this.constraints[e], n = parseInt(this.state[e], 10) - t.step;
                        return n < t.min && (n = t.max + 1 - (t.min - n)), te(e, n);
                    }
                },
                {
                    key: "getCounters",
                    value: function() {
                        var e = [], t = this.props.timeFormat;
                        return -1 !== t.toLowerCase().indexOf("h") && (e.push("hours"), -1 !== t.indexOf("m") && (e.push("minutes"), -1 !== t.indexOf("s") && (e.push("seconds"), -1 !== t.indexOf("S") && e.push("milliseconds")))), this.isAMPM() && e.push("ampm"), e;
                    }
                },
                {
                    key: "isAMPM",
                    value: function() {
                        return -1 !== this.props.timeFormat.toLowerCase().indexOf(" a");
                    }
                },
                {
                    key: "getTimeParts",
                    value: function(e) {
                        var t = e.hours();
                        return {
                            hours: te("hours", t),
                            minutes: te("minutes", e.minutes()),
                            seconds: te("seconds", e.seconds()),
                            milliseconds: te("milliseconds", e.milliseconds()),
                            ampm: t < 12 ? "am" : "pm"
                        };
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e) {
                        this.props.selectedDate ? this.props.selectedDate !== e.selectedDate && this.setState(this.getTimeParts(this.props.selectedDate)) : e.viewDate !== this.props.viewDate && this.setState(this.getTimeParts(this.props.viewDate));
                    }
                }
            ], W(t.prototype, n), r && W(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function te(e, t) {
            for(var n = {
                hours: 1,
                minutes: 2,
                seconds: 2,
                milliseconds: 3
            }, r = t + ""; r.length < n[e];)r = "0" + r;
            return r;
        }
        var ne = n(2);
        function re(e, t) {
            return (re = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function oe(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function ie(e, t, n) {
            return e === t || (e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n));
        }
        var ae, se, ce = (void 0 === ae && (ae = 0), function() {
            return ++ae;
        }), ue = {}, le = {}, pe = [
            "touchstart",
            "touchmove"
        ];
        function fe(e, t) {
            var n = null;
            return -1 !== pe.indexOf(t) && se && (n = {
                passive: !e.props.preventDefault
            }), n;
        }
        var de = function(e, t) {
            var n, r, o = e.displayName || e.name || "Component";
            return r = n = function(n) {
                var r, i;
                function a(e) {
                    var r;
                    return (r = n.call(this, e) || this).__outsideClickHandler = function(e) {
                        if ("function" != typeof r.__clickOutsideHandlerProp) {
                            var t = r.getInstance();
                            if ("function" != typeof t.props.handleClickOutside) {
                                if ("function" != typeof t.handleClickOutside) throw new Error("WrappedComponent: " + o + " lacks a handleClickOutside(event) function for processing outside click events.");
                                t.handleClickOutside(e);
                            } else t.props.handleClickOutside(e);
                        } else r.__clickOutsideHandlerProp(e);
                    }, r.__getComponentNode = function() {
                        var e = r.getInstance();
                        return t && "function" == typeof t.setClickOutsideRef ? t.setClickOutsideRef()(e) : "function" == typeof e.setClickOutsideRef ? e.setClickOutsideRef() : Object(ne.findDOMNode)(e);
                    }, r.enableOnClickOutside = function() {
                        if ("undefined" != typeof document && !le[r._uid]) {
                            void 0 === se && (se = function() {
                                if ("undefined" != typeof window && "function" == typeof window.addEventListener) {
                                    var e = !1, t = Object.defineProperty({}, "passive", {
                                        get: function() {
                                            e = !0;
                                        }
                                    }), n = function() {};
                                    return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
                                }
                            }()), le[r._uid] = !0;
                            var e = r.props.eventTypes;
                            e.forEach || (e = [
                                e
                            ]), ue[r._uid] = function(e) {
                                var t;
                                null !== r.componentNode && (r.props.preventDefault && e.preventDefault(), r.props.stopPropagation && e.stopPropagation(), r.props.excludeScrollbar && (t = e, document.documentElement.clientWidth <= t.clientX || document.documentElement.clientHeight <= t.clientY) || function(e, t, n) {
                                    if (e === t) return !0;
                                    for(; e.parentNode || e.host;){
                                        if (e.parentNode && ie(e, t, n)) return !0;
                                        e = e.parentNode || e.host;
                                    }
                                    return e;
                                }(e.composed && e.composedPath && e.composedPath().shift() || e.target, r.componentNode, r.props.outsideClickIgnoreClass) === document && r.__outsideClickHandler(e));
                            }, e.forEach(function(e) {
                                document.addEventListener(e, ue[r._uid], fe(oe(r), e));
                            });
                        }
                    }, r.disableOnClickOutside = function() {
                        delete le[r._uid];
                        var e = ue[r._uid];
                        if (e && "undefined" != typeof document) {
                            var t = r.props.eventTypes;
                            t.forEach || (t = [
                                t
                            ]), t.forEach(function(t) {
                                return document.removeEventListener(t, e, fe(oe(r), t));
                            }), delete ue[r._uid];
                        }
                    }, r.getRef = function(e) {
                        return r.instanceRef = e;
                    }, r._uid = ce(), r;
                }
                i = n, (r = a).prototype = Object.create(i.prototype), r.prototype.constructor = r, re(r, i);
                var c = a.prototype;
                return c.getInstance = function() {
                    if (e.prototype && !e.prototype.isReactComponent) return this;
                    var t = this.instanceRef;
                    return t.getInstance ? t.getInstance() : t;
                }, c.componentDidMount = function() {
                    if ("undefined" != typeof document && document.createElement) {
                        var e = this.getInstance();
                        if (t && "function" == typeof t.handleClickOutside && (this.__clickOutsideHandlerProp = t.handleClickOutside(e), "function" != typeof this.__clickOutsideHandlerProp)) throw new Error("WrappedComponent: " + o + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
                        this.componentNode = this.__getComponentNode(), this.props.disableOnClickOutside || this.enableOnClickOutside();
                    }
                }, c.componentDidUpdate = function() {
                    this.componentNode = this.__getComponentNode();
                }, c.componentWillUnmount = function() {
                    this.disableOnClickOutside();
                }, c.render = function() {
                    var t = this.props;
                    t.excludeScrollbar;
                    var n = function(e, t) {
                        if (null == e) return {};
                        var n, r, o = {}, i = Object.keys(e);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                        return o;
                    }(t, [
                        "excludeScrollbar"
                    ]);
                    return e.prototype && e.prototype.isReactComponent ? n.ref = this.getRef : n.wrappedRef = this.getRef, n.disableOnClickOutside = this.disableOnClickOutside, n.enableOnClickOutside = this.enableOnClickOutside, Object(s.createElement)(e, n);
                }, a;
            }(s.Component), n.displayName = "OnClickOutside(" + o + ")", n.defaultProps = {
                eventTypes: [
                    "mousedown",
                    "touchstart"
                ],
                excludeScrollbar: t && t.excludeScrollbar || !1,
                outsideClickIgnoreClass: "ignore-react-onclickoutside",
                preventDefault: !1,
                stopPropagation: !1
            }, n.getClass = function() {
                return e.getClass ? e.getClass() : e;
            }, r;
        };
        function he(e) {
            return (he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function ye(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function me(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ye(Object(n), !0).forEach(function(t) {
                    _e(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
            }
            return e;
        }
        function ve(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function be(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Oe(e, t, n) {
            return t && be(e.prototype, t), n && be(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }
        function ge(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(e, "prototype", {
                writable: !1
            }), t && we(e, t);
        }
        function we(e, t) {
            return (we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function De(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = Pe(e);
                if (t) {
                    var o = Pe(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return ke(this, n);
            };
        }
        function ke(e, t) {
            if (t && ("object" === he(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return Ce(e);
        }
        function Ce(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Pe(e) {
            return (Pe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function _e(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        n.d(t, "default", function() {
            return Fe;
        });
        var Ee = "years", je = "months", Se = "days", Ve = "time", Te = o.a, Ne = function() {}, xe = Te.oneOfType([
            Te.instanceOf(a.a),
            Te.instanceOf(Date),
            Te.string
        ]), Fe = function(e) {
            ge(n, e);
            var t = De(n);
            function n(e) {
                var r;
                return ve(this, n), _e(Ce(r = t.call(this, e)), "_renderCalendar", function() {
                    var e = r.props, t = r.state, n = {
                        viewDate: t.viewDate.clone(),
                        selectedDate: r.getSelectedDate(),
                        isValidDate: e.isValidDate,
                        updateDate: r._updateDate,
                        navigate: r._viewNavigate,
                        moment: a.a,
                        showView: r._showView
                    };
                    switch(t.currentView){
                        case Ee:
                            return n.renderYear = e.renderYear, c.a.createElement(H, n);
                        case je:
                            return n.renderMonth = e.renderMonth, c.a.createElement(T, n);
                        case Se:
                            return n.renderDay = e.renderDay, n.timeFormat = r.getFormat("time"), c.a.createElement(g, n);
                        default:
                            return n.dateFormat = r.getFormat("date"), n.timeFormat = r.getFormat("time"), n.timeConstraints = e.timeConstraints, n.setTime = r._setTime, c.a.createElement(ee, n);
                    }
                }), _e(Ce(r), "_showView", function(e, t) {
                    var n = (t || r.state.viewDate).clone(), o = r.props.onBeforeNavigate(e, r.state.currentView, n);
                    o && r.state.currentView !== o && (r.props.onNavigate(o), r.setState({
                        currentView: o
                    }));
                }), _e(Ce(r), "viewToMethod", {
                    days: "date",
                    months: "month",
                    years: "year"
                }), _e(Ce(r), "nextView", {
                    days: "time",
                    months: "days",
                    years: "months"
                }), _e(Ce(r), "_updateDate", function(e) {
                    var t = r.state.currentView, n = r.getUpdateOn(r.getFormat("date")), o = r.state.viewDate.clone();
                    o[r.viewToMethod[t]](parseInt(e.target.getAttribute("data-value"), 10)), "days" === t && (o.month(parseInt(e.target.getAttribute("data-month"), 10)), o.year(parseInt(e.target.getAttribute("data-year"), 10)));
                    var i = {
                        viewDate: o
                    };
                    t === n ? (i.selectedDate = o.clone(), i.inputValue = o.format(r.getFormat("datetime")), void 0 === r.props.open && r.props.input && r.props.closeOnSelect && r._closeCalendar(), r.props.onChange(o.clone())) : r._showView(r.nextView[t], o), r.setState(i);
                }), _e(Ce(r), "_viewNavigate", function(e, t) {
                    var n = r.state.viewDate.clone();
                    n.add(e, t), e > 0 ? r.props.onNavigateForward(e, t) : r.props.onNavigateBack(-e, t), r.setState({
                        viewDate: n
                    });
                }), _e(Ce(r), "_setTime", function(e, t) {
                    var n = (r.getSelectedDate() || r.state.viewDate).clone();
                    n[e](t), r.props.value || r.setState({
                        selectedDate: n,
                        viewDate: n.clone(),
                        inputValue: n.format(r.getFormat("datetime"))
                    }), r.props.onChange(n);
                }), _e(Ce(r), "_openCalendar", function() {
                    r.isOpen() || r.setState({
                        open: !0
                    }, r.props.onOpen);
                }), _e(Ce(r), "_closeCalendar", function() {
                    r.isOpen() && r.setState({
                        open: !1
                    }, function() {
                        r.props.onClose(r.state.selectedDate || r.state.inputValue);
                    });
                }), _e(Ce(r), "_handleClickOutside", function() {
                    var e = r.props;
                    e.input && r.state.open && void 0 === e.open && e.closeOnClickOutside && r._closeCalendar();
                }), _e(Ce(r), "_onInputFocus", function(e) {
                    r.callHandler(r.props.inputProps.onFocus, e) && r._openCalendar();
                }), _e(Ce(r), "_onInputChange", function(e) {
                    if (r.callHandler(r.props.inputProps.onChange, e)) {
                        var t = e.target ? e.target.value : e, n = r.localMoment(t, r.getFormat("datetime")), o = {
                            inputValue: t
                        };
                        n.isValid() ? (o.selectedDate = n, o.viewDate = n.clone().startOf("month")) : o.selectedDate = null, r.setState(o, function() {
                            r.props.onChange(n.isValid() ? n : r.state.inputValue);
                        });
                    }
                }), _e(Ce(r), "_onInputKeyDown", function(e) {
                    r.callHandler(r.props.inputProps.onKeyDown, e) && 9 === e.which && r.props.closeOnTab && r._closeCalendar();
                }), _e(Ce(r), "_onInputClick", function(e) {
                    r.callHandler(r.props.inputProps.onClick, e) && r._openCalendar();
                }), r.state = r.getInitialState(), r;
            }
            return Oe(n, [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement(Re, {
                            className: this.getClassName(),
                            onClickOut: this._handleClickOutside
                        }, this.renderInput(), c.a.createElement("div", {
                            className: "rdtPicker"
                        }, this.renderView()));
                    }
                },
                {
                    key: "renderInput",
                    value: function() {
                        if (this.props.input) {
                            var e = me(me({
                                type: "text",
                                className: "form-control",
                                value: this.getInputValue()
                            }, this.props.inputProps), {}, {
                                onFocus: this._onInputFocus,
                                onChange: this._onInputChange,
                                onKeyDown: this._onInputKeyDown,
                                onClick: this._onInputClick
                            });
                            return this.props.renderInput ? c.a.createElement("div", null, this.props.renderInput(e, this._openCalendar, this._closeCalendar)) : c.a.createElement("input", e);
                        }
                    }
                },
                {
                    key: "renderView",
                    value: function() {
                        return this.props.renderView(this.state.currentView, this._renderCalendar);
                    }
                },
                {
                    key: "getInitialState",
                    value: function() {
                        var e = this.props, t = this.getFormat("datetime"), n = this.parseDate(e.value || e.initialValue, t);
                        return this.checkTZ(), {
                            open: !e.input,
                            currentView: e.initialViewMode || this.getInitialView(),
                            viewDate: this.getInitialViewDate(n),
                            selectedDate: n && n.isValid() ? n : void 0,
                            inputValue: this.getInitialInputValue(n)
                        };
                    }
                },
                {
                    key: "getInitialViewDate",
                    value: function(e) {
                        var t, n = this.props.initialViewDate;
                        if (n) {
                            if ((t = this.parseDate(n, this.getFormat("datetime"))) && t.isValid()) return t;
                            Ie('The initialViewDated given "' + n + '" is not valid. Using current date instead.');
                        } else if (e && e.isValid()) return e.clone();
                        return this.getInitialDate();
                    }
                },
                {
                    key: "getInitialDate",
                    value: function() {
                        var e = this.localMoment();
                        return e.hour(0).minute(0).second(0).millisecond(0), e;
                    }
                },
                {
                    key: "getInitialView",
                    value: function() {
                        var e = this.getFormat("date");
                        return e ? this.getUpdateOn(e) : Ve;
                    }
                },
                {
                    key: "parseDate",
                    value: function(e, t) {
                        var n;
                        return e && "string" == typeof e ? n = this.localMoment(e, t) : e && (n = this.localMoment(e)), n && !n.isValid() && (n = null), n;
                    }
                },
                {
                    key: "getClassName",
                    value: function() {
                        var e = "rdt", t = this.props, n = t.className;
                        return Array.isArray(n) ? e += " " + n.join(" ") : n && (e += " " + n), t.input || (e += " rdtStatic"), this.isOpen() && (e += " rdtOpen"), e;
                    }
                },
                {
                    key: "isOpen",
                    value: function() {
                        return !this.props.input || (void 0 === this.props.open ? this.state.open : this.props.open);
                    }
                },
                {
                    key: "getUpdateOn",
                    value: function(e) {
                        return this.props.updateOnView ? this.props.updateOnView : e.match(/[lLD]/) ? Se : -1 !== e.indexOf("M") ? je : -1 !== e.indexOf("Y") ? Ee : Se;
                    }
                },
                {
                    key: "getLocaleData",
                    value: function() {
                        var e = this.props;
                        return this.localMoment(e.value || e.defaultValue || new Date).localeData();
                    }
                },
                {
                    key: "getDateFormat",
                    value: function() {
                        var e = this.getLocaleData(), t = this.props.dateFormat;
                        return !0 === t ? e.longDateFormat("L") : t || "";
                    }
                },
                {
                    key: "getTimeFormat",
                    value: function() {
                        var e = this.getLocaleData(), t = this.props.timeFormat;
                        return !0 === t ? e.longDateFormat("LT") : t || "";
                    }
                },
                {
                    key: "getFormat",
                    value: function(e) {
                        if ("date" === e) return this.getDateFormat();
                        if ("time" === e) return this.getTimeFormat();
                        var t = this.getDateFormat(), n = this.getTimeFormat();
                        return t && n ? t + " " + n : t || n;
                    }
                },
                {
                    key: "updateTime",
                    value: function(e, t, n, r) {
                        var o = {}, i = r ? "selectedDate" : "viewDate";
                        o[i] = this.state[i].clone()[e](t, n), this.setState(o);
                    }
                },
                {
                    key: "localMoment",
                    value: function(e, t, n) {
                        var r = null;
                        return r = (n = n || this.props).utc ? a.a.utc(e, t, n.strictParsing) : n.displayTimeZone ? a.a.tz(e, t, n.displayTimeZone) : a()(e, t, n.strictParsing), n.locale && r.locale(n.locale), r;
                    }
                },
                {
                    key: "checkTZ",
                    value: function() {
                        var e = this.props.displayTimeZone;
                        !e || this.tzWarning || a.a.tz || (this.tzWarning = !0, Ie('displayTimeZone prop with value "' + e + '" is used but moment.js timezone is not loaded.', "error"));
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e) {
                        if (e !== this.props) {
                            var t = !1, n = this.props;
                            [
                                "locale",
                                "utc",
                                "displayZone",
                                "dateFormat",
                                "timeFormat"
                            ].forEach(function(r) {
                                e[r] !== n[r] && (t = !0);
                            }), t && this.regenerateDates(), n.value && n.value !== e.value && this.setViewDate(n.value), this.checkTZ();
                        }
                    }
                },
                {
                    key: "regenerateDates",
                    value: function() {
                        var e = this.props, t = this.state.viewDate.clone(), n = this.state.selectedDate && this.state.selectedDate.clone();
                        e.locale && (t.locale(e.locale), n && n.locale(e.locale)), e.utc ? (t.utc(), n && n.utc()) : e.displayTimeZone ? (t.tz(e.displayTimeZone), n && n.tz(e.displayTimeZone)) : (t.locale(), n && n.locale());
                        var r = {
                            viewDate: t,
                            selectedDate: n
                        };
                        n && n.isValid() && (r.inputValue = n.format(this.getFormat("datetime"))), this.setState(r);
                    }
                },
                {
                    key: "getSelectedDate",
                    value: function() {
                        if (void 0 === this.props.value) return this.state.selectedDate;
                        var e = this.parseDate(this.props.value, this.getFormat("datetime"));
                        return !(!e || !e.isValid()) && e;
                    }
                },
                {
                    key: "getInitialInputValue",
                    value: function(e) {
                        var t = this.props;
                        return t.inputProps.value ? t.inputProps.value : e && e.isValid() ? e.format(this.getFormat("datetime")) : t.value && "string" == typeof t.value ? t.value : t.initialValue && "string" == typeof t.initialValue ? t.initialValue : "";
                    }
                },
                {
                    key: "getInputValue",
                    value: function() {
                        var e = this.getSelectedDate();
                        return e ? e.format(this.getFormat("datetime")) : this.state.inputValue;
                    }
                },
                {
                    key: "setViewDate",
                    value: function(e) {
                        var t, n = function() {
                            return Ie("Invalid date passed to the `setViewDate` method: " + e);
                        };
                        return e && (t = "string" == typeof e ? this.localMoment(e, this.getFormat("datetime")) : this.localMoment(e)) && t.isValid() ? void this.setState({
                            viewDate: t
                        }) : n();
                    }
                },
                {
                    key: "navigate",
                    value: function(e) {
                        this._showView(e);
                    }
                },
                {
                    key: "callHandler",
                    value: function(e, t) {
                        return !e || !1 !== e(t);
                    }
                }
            ]), n;
        }(c.a.Component);
        function Ie(e, t) {
            var n = "undefined" != typeof window && window.console;
            n && (t || (t = "warn"), n[t]("***react-datetime:" + e));
        }
        _e(Fe, "propTypes", {
            value: xe,
            initialValue: xe,
            initialViewDate: xe,
            initialViewMode: Te.oneOf([
                Ee,
                je,
                Se,
                Ve
            ]),
            onOpen: Te.func,
            onClose: Te.func,
            onChange: Te.func,
            onNavigate: Te.func,
            onBeforeNavigate: Te.func,
            onNavigateBack: Te.func,
            onNavigateForward: Te.func,
            updateOnView: Te.string,
            locale: Te.string,
            utc: Te.bool,
            displayTimeZone: Te.string,
            input: Te.bool,
            dateFormat: Te.oneOfType([
                Te.string,
                Te.bool
            ]),
            timeFormat: Te.oneOfType([
                Te.string,
                Te.bool
            ]),
            inputProps: Te.object,
            timeConstraints: Te.object,
            isValidDate: Te.func,
            open: Te.bool,
            strictParsing: Te.bool,
            closeOnSelect: Te.bool,
            closeOnTab: Te.bool,
            renderView: Te.func,
            renderInput: Te.func,
            renderDay: Te.func,
            renderMonth: Te.func,
            renderYear: Te.func
        }), _e(Fe, "defaultProps", {
            onOpen: Ne,
            onClose: Ne,
            onCalendarOpen: Ne,
            onCalendarClose: Ne,
            onChange: Ne,
            onNavigate: Ne,
            onBeforeNavigate: function(e) {
                return e;
            },
            onNavigateBack: Ne,
            onNavigateForward: Ne,
            dateFormat: !0,
            timeFormat: !0,
            utc: !1,
            className: "",
            input: !0,
            inputProps: {},
            timeConstraints: {},
            isValidDate: function() {
                return !0;
            },
            strictParsing: !0,
            closeOnSelect: !1,
            closeOnTab: !0,
            closeOnClickOutside: !0,
            renderView: function(e, t) {
                return t();
            }
        }), _e(Fe, "moment", a.a);
        var Re = de(function(e) {
            ge(n, e);
            var t = De(n);
            function n() {
                var e;
                ve(this, n);
                for(var r = arguments.length, o = new Array(r), i = 0; i < r; i++)o[i] = arguments[i];
                return _e(Ce(e = t.call.apply(t, [
                    this
                ].concat(o))), "container", c.a.createRef()), e;
            }
            return Oe(n, [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: this.props.className,
                            ref: this.container
                        }, this.props.children);
                    }
                },
                {
                    key: "handleClickOutside",
                    value: function(e) {
                        this.props.onClickOut(e);
                    }
                },
                {
                    key: "setClickOutsideRef",
                    value: function() {
                        return this.container.current;
                    }
                }
            ]), n;
        }(c.a.Component));
    }
]);

},{"c6a860992a89d6d4":"IMRgT","e5cdb80906268f6f":"fAGp8","ec7c649cedac611b":"fODdr"}],"5rDUU":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(require("b26f676d67bbe12f"));
})(this, function(moment) {
    'use strict';
    //! moment.js locale configuration
    moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function(input) {
            return /^nm$/i.test(input);
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? 'vm' : 'VM';
            else return isLower ? 'nm' : 'NM';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: "[M\xf4re om] LT",
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var pluralForm = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number), str = plurals[u][pluralForm(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months = [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 0,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ar-kw', {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split('_'),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split('_'),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062A\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0627\u062D\u062F_\u0627\u062A\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 0,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var symbolMap = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        0: '0'
    }, pluralForm$1 = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals$1 = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize$1 = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm$1(number), str = plurals$1[u][pluralForm$1(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months$1 = [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale('ar-ly', {
        months: months$1,
        monthsShort: months$1,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize$1('s'),
            ss: pluralize$1('s'),
            m: pluralize$1('m'),
            mm: pluralize$1('m'),
            h: pluralize$1('h'),
            hh: pluralize$1('h'),
            d: pluralize$1('d'),
            dd: pluralize$1('d'),
            M: pluralize$1('M'),
            MM: pluralize$1('M'),
            y: pluralize$1('y'),
            yy: pluralize$1('y')
        },
        preparse: function(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ar-ma', {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split('_'),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split('_'),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0627\u062D\u062F_\u0627\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$1 = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap = {
        "\u0661": '1',
        "\u0662": '2',
        "\u0663": '3',
        "\u0664": '4',
        "\u0665": '5',
        "\u0666": '6',
        "\u0667": '7',
        "\u0668": '8',
        "\u0669": '9',
        "\u0660": '0'
    };
    moment.defineLocale('ar-sa', {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split('_'),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split('_'),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$1[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ar-tn', {
        months: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split('_'),
        monthsShort: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split('_'),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$2 = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap$1 = {
        "\u0661": '1',
        "\u0662": '2',
        "\u0663": '3',
        "\u0664": '4',
        "\u0665": '5',
        "\u0666": '6',
        "\u0667": '7',
        "\u0668": '8',
        "\u0669": '9',
        "\u0660": '0'
    }, pluralForm$2 = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals$2 = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize$2 = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm$2(number), str = plurals$2[u][pluralForm$2(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months$2 = [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale('ar', {
        months: months$2,
        monthsShort: months$2,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split('_'),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split('_'),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize$2('s'),
            ss: pluralize$2('s'),
            m: pluralize$2('m'),
            mm: pluralize$2('m'),
            h: pluralize$2('h'),
            hh: pluralize$2('h'),
            d: pluralize$2('d'),
            dd: pluralize$2('d'),
            M: pluralize$2('M'),
            MM: pluralize$2('M'),
            y: pluralize$2('y'),
            yy: pluralize$2('y')
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap$1[match];
            }).replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$2[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: "-\xfcnc\xfc",
        4: "-\xfcnc\xfc",
        100: "-\xfcnc\xfc",
        6: "-nc\u0131",
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: "-\u0131nc\u0131",
        90: "-\u0131nc\u0131"
    };
    moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: "Bazar_Bazar ert\u0259si_\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131_\xc7\u0259r\u015F\u0259nb\u0259_C\xfcm\u0259 ax\u015Fam\u0131_C\xfcm\u0259_\u015E\u0259nb\u0259".split('_'),
        weekdaysShort: "Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015E\u0259n".split('_'),
        weekdaysMin: "Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015E\u0259".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: '[sabah saat] LT',
            nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
            lastDay: "[d\xfcn\u0259n] LT",
            lastWeek: "[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: "%s \u0259vv\u0259l",
            s: "bir ne\xe7\u0259 saniy\u0259",
            ss: "%d saniy\u0259",
            m: "bir d\u0259qiq\u0259",
            mm: "%d d\u0259qiq\u0259",
            h: 'bir saat',
            hh: '%d saat',
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function(input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "gec\u0259";
            else if (hour < 12) return "s\u0259h\u0259r";
            else if (hour < 17) return "g\xfcnd\xfcz";
            else return "ax\u015Fam";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function(number) {
            if (number === 0) // special case for zero
            return number + "-\u0131nc\u0131";
            var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D",
            hh: withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D",
            dd: "\u0434\u0437\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u0437\u0451\u043D",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u044B_\u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            yy: "\u0433\u043E\u0434_\u0433\u0430\u0434\u044B_\u0433\u0430\u0434\u043E\u045E"
        };
        if (key === 'm') return withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443";
        else if (key === 'h') return withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443";
        else return number + ' ' + plural(format[key], +number);
    }
    moment.defineLocale('be', {
        months: {
            format: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F_\u043B\u044E\u0442\u0430\u0433\u0430_\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430_\u0442\u0440\u0430\u045E\u043D\u044F_\u0447\u044D\u0440\u0432\u0435\u043D\u044F_\u043B\u0456\u043F\u0435\u043D\u044F_\u0436\u043D\u0456\u045E\u043D\u044F_\u0432\u0435\u0440\u0430\u0441\u043D\u044F_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430_\u0441\u043D\u0435\u0436\u043D\u044F".split('_'),
            standalone: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C_\u043B\u044E\u0442\u044B_\u0441\u0430\u043A\u0430\u0432\u0456\u043A_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u044D\u0440\u0432\u0435\u043D\u044C_\u043B\u0456\u043F\u0435\u043D\u044C_\u0436\u043D\u0456\u0432\u0435\u043D\u044C_\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434_\u0441\u043D\u0435\u0436\u0430\u043D\u044C".split('_')
        },
        monthsShort: "\u0441\u0442\u0443\u0434_\u043B\u044E\u0442_\u0441\u0430\u043A_\u043A\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044D\u0440\u0432_\u043B\u0456\u043F_\u0436\u043D\u0456\u0432_\u0432\u0435\u0440_\u043A\u0430\u0441\u0442_\u043B\u0456\u0441\u0442_\u0441\u043D\u0435\u0436".split('_'),
        weekdays: {
            format: "\u043D\u044F\u0434\u0437\u0435\u043B\u044E_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0443_\u0441\u0443\u0431\u043E\u0442\u0443".split('_'),
            standalone: "\u043D\u044F\u0434\u0437\u0435\u043B\u044F_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0430_\u0441\u0443\u0431\u043E\u0442\u0430".split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split('_'),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., HH:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0451\u043D\u043D\u044F \u045E] LT",
            nextDay: "[\u0417\u0430\u045E\u0442\u0440\u0430 \u045E] LT",
            lastDay: "[\u0423\u0447\u043E\u0440\u0430 \u045E] LT",
            nextWeek: function() {
                return "[\u0423] dddd [\u045E] LT";
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u0443\u044E] dddd [\u045E] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u044B] dddd [\u045E] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u043F\u0440\u0430\u0437 %s",
            past: "%s \u0442\u0430\u043C\u0443",
            s: "\u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0441\u0435\u043A\u0443\u043D\u0434",
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: "\u0434\u0437\u0435\u043D\u044C",
            dd: relativeTimeWithPlural,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: relativeTimeWithPlural,
            y: "\u0433\u043E\u0434",
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function(input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u044B";
            else if (hour < 12) return "\u0440\u0430\u043D\u0456\u0446\u044B";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u0430\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function(number, period) {
            switch(period){
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + "-\u0456" : number + "-\u044B";
                case 'D':
                    return number + "-\u0433\u0430";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('bg', {
        months: "\u044F\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split('_'),
        monthsShort: "\u044F\u043D\u0443_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split('_'),
        weekdays: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u044F\u0434\u0430_\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A_\u043F\u0435\u0442\u044A\u043A_\u0441\u044A\u0431\u043E\u0442\u0430".split('_'),
        weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u044F_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u044A\u0431".split('_'),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: "[\u0414\u043D\u0435\u0441 \u0432] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
            nextWeek: "dddd [\u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u041C\u0438\u043D\u0430\u043B\u0430\u0442\u0430] dddd [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u041C\u0438\u043D\u0430\u043B\u0438\u044F] dddd [\u0432] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0441\u043B\u0435\u0434 %s",
            past: "\u043F\u0440\u0435\u0434\u0438 %s",
            s: "\u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            m: "\u043C\u0438\u043D\u0443\u0442\u0430",
            mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
            h: "\u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0434\u0435\u043D",
            dd: "%d \u0434\u0435\u043D\u0430",
            w: "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
            ww: "%d \u0441\u0435\u0434\u043C\u0438\u0446\u0438",
            M: "\u043C\u0435\u0441\u0435\u0446",
            MM: "%d \u043C\u0435\u0441\u0435\u0446\u0430",
            y: "\u0433\u043E\u0434\u0438\u043D\u0430",
            yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function(number) {
            var lastDigit = number % 10, last2Digits = number % 100;
            if (number === 0) return number + "-\u0435\u0432";
            else if (last2Digits === 0) return number + "-\u0435\u043D";
            else if (last2Digits > 10 && last2Digits < 20) return number + "-\u0442\u0438";
            else if (lastDigit === 1) return number + "-\u0432\u0438";
            else if (lastDigit === 2) return number + "-\u0440\u0438";
            else if (lastDigit === 7 || lastDigit === 8) return number + "-\u043C\u0438";
            else return number + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('bm', {
        months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025Bkalo_Zuw\u025Bnkalo_Zuluyekalo_Utikalo_S\u025Btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split('_'),
        monthsShort: "Zan_Few_Mar_Awi_M\u025B_Zuw_Zul_Uti_S\u025Bt_\u0254ku_Now_Des".split('_'),
        weekdays: "Kari_Nt\u025Bn\u025Bn_Tarata_Araba_Alamisa_Juma_Sibiri".split('_'),
        weekdaysShort: "Kar_Nt\u025B_Tar_Ara_Ala_Jum_Sib".split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: "MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm",
            LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm"
        },
        calendar: {
            sameDay: "[Bi l\u025Br\u025B] LT",
            nextDay: "[Sini l\u025Br\u025B] LT",
            nextWeek: "dddd [don l\u025Br\u025B] LT",
            lastDay: "[Kunu l\u025Br\u025B] LT",
            lastWeek: "dddd [t\u025Bm\u025Bnen l\u025Br\u025B] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s k\u0254n\u0254",
            past: "a b\u025B %s b\u0254",
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: "l\u025Br\u025B kelen",
            hh: "l\u025Br\u025B %d",
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d'
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$3 = {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    }, numberMap$2 = {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    };
    moment.defineLocale('bn-bd', {
        months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split('_'),
        monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split('_'),
        weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split('_'),
        weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split('_'),
        weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split('_'),
        longDateFormat: {
            LT: "A h:mm \u09B8\u09AE\u09DF",
            LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
        },
        calendar: {
            sameDay: "[\u0986\u099C] LT",
            nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
            lastWeek: "[\u0997\u09A4] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u09AA\u09B0\u09C7",
            past: "%s \u0986\u0997\u09C7",
            s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
            mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
            h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
            hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
            d: "\u098F\u0995 \u09A6\u09BF\u09A8",
            dd: "%d \u09A6\u09BF\u09A8",
            M: "\u098F\u0995 \u09AE\u09BE\u09B8",
            MM: "%d \u09AE\u09BE\u09B8",
            y: "\u098F\u0995 \u09AC\u099B\u09B0",
            yy: "%d \u09AC\u099B\u09B0"
        },
        preparse: function(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
                return numberMap$2[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$3[match];
            });
        },
        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u09B0\u09BE\u09A4") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u09AD\u09CB\u09B0") return hour;
            else if (meridiem === "\u09B8\u0995\u09BE\u09B2") return hour;
            else if (meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0") return hour >= 3 ? hour : hour + 12;
            else if (meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") return hour + 12;
            else if (meridiem === "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u09B0\u09BE\u09A4";
            else if (hour < 6) return "\u09AD\u09CB\u09B0";
            else if (hour < 12) return "\u09B8\u0995\u09BE\u09B2";
            else if (hour < 15) return "\u09A6\u09C1\u09AA\u09C1\u09B0";
            else if (hour < 18) return "\u09AC\u09BF\u0995\u09BE\u09B2";
            else if (hour < 20) return "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE";
            else return "\u09B0\u09BE\u09A4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var symbolMap$4 = {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    }, numberMap$3 = {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    };
    moment.defineLocale('bn', {
        months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split('_'),
        monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split('_'),
        weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split('_'),
        weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split('_'),
        weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split('_'),
        longDateFormat: {
            LT: "A h:mm \u09B8\u09AE\u09DF",
            LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
        },
        calendar: {
            sameDay: "[\u0986\u099C] LT",
            nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
            lastWeek: "[\u0997\u09A4] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u09AA\u09B0\u09C7",
            past: "%s \u0986\u0997\u09C7",
            s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
            mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
            h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
            hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
            d: "\u098F\u0995 \u09A6\u09BF\u09A8",
            dd: "%d \u09A6\u09BF\u09A8",
            M: "\u098F\u0995 \u09AE\u09BE\u09B8",
            MM: "%d \u09AE\u09BE\u09B8",
            y: "\u098F\u0995 \u09AC\u099B\u09B0",
            yy: "%d \u09AC\u099B\u09B0"
        },
        preparse: function(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
                return numberMap$3[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$4[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u09B0\u09BE\u09A4" && hour >= 4 || meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0" && hour < 5 || meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u09B0\u09BE\u09A4";
            else if (hour < 10) return "\u09B8\u0995\u09BE\u09B2";
            else if (hour < 17) return "\u09A6\u09C1\u09AA\u09C1\u09B0";
            else if (hour < 20) return "\u09AC\u09BF\u0995\u09BE\u09B2";
            else return "\u09B0\u09BE\u09A4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var symbolMap$5 = {
        1: "\u0F21",
        2: "\u0F22",
        3: "\u0F23",
        4: "\u0F24",
        5: "\u0F25",
        6: "\u0F26",
        7: "\u0F27",
        8: "\u0F28",
        9: "\u0F29",
        0: "\u0F20"
    }, numberMap$4 = {
        "\u0F21": '1',
        "\u0F22": '2',
        "\u0F23": '3',
        "\u0F24": '4',
        "\u0F25": '5',
        "\u0F26": '6',
        "\u0F27": '7',
        "\u0F28": '8',
        "\u0F29": '9',
        "\u0F20": '0'
    };
    moment.defineLocale('bo', {
        months: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F44\u0F0B\u0F54\u0F7C_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F66\u0F74\u0F58\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F5E\u0F72\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F63\u0F94\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0FB2\u0F74\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F62\u0F92\u0FB1\u0F51\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F42\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F45\u0F72\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54".split('_'),
        monthsShort: "\u0F5F\u0FB3\u0F0B1_\u0F5F\u0FB3\u0F0B2_\u0F5F\u0FB3\u0F0B3_\u0F5F\u0FB3\u0F0B4_\u0F5F\u0FB3\u0F0B5_\u0F5F\u0FB3\u0F0B6_\u0F5F\u0FB3\u0F0B7_\u0F5F\u0FB3\u0F0B8_\u0F5F\u0FB3\u0F0B9_\u0F5F\u0FB3\u0F0B10_\u0F5F\u0FB3\u0F0B11_\u0F5F\u0FB3\u0F0B12".split('_'),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: "\u0F42\u0F5F\u0F60\u0F0B\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F42\u0F5F\u0F60\u0F0B\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split('_'),
        weekdaysShort: "\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split('_'),
        weekdaysMin: "\u0F49\u0F72_\u0F5F\u0FB3_\u0F58\u0F72\u0F42_\u0F63\u0FB7\u0F42_\u0F55\u0F74\u0F62_\u0F66\u0F44\u0F66_\u0F66\u0FA4\u0F7A\u0F53".split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: "[\u0F51\u0F72\u0F0B\u0F62\u0F72\u0F44] LT",
            nextDay: "[\u0F66\u0F44\u0F0B\u0F49\u0F72\u0F53] LT",
            nextWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F62\u0F97\u0F7A\u0F66\u0F0B\u0F58], LT",
            lastDay: "[\u0F41\u0F0B\u0F66\u0F44] LT",
            lastWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F58\u0F50\u0F60\u0F0B\u0F58] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0F63\u0F0B",
            past: "%s \u0F66\u0F94\u0F53\u0F0B\u0F63",
            s: "\u0F63\u0F58\u0F0B\u0F66\u0F44",
            ss: "%d \u0F66\u0F90\u0F62\u0F0B\u0F46\u0F0D",
            m: "\u0F66\u0F90\u0F62\u0F0B\u0F58\u0F0B\u0F42\u0F45\u0F72\u0F42",
            mm: "%d \u0F66\u0F90\u0F62\u0F0B\u0F58",
            h: "\u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51\u0F0B\u0F42\u0F45\u0F72\u0F42",
            hh: "%d \u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51",
            d: "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F45\u0F72\u0F42",
            dd: "%d \u0F49\u0F72\u0F53\u0F0B",
            M: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F45\u0F72\u0F42",
            MM: "%d \u0F5F\u0FB3\u0F0B\u0F56",
            y: "\u0F63\u0F7C\u0F0B\u0F42\u0F45\u0F72\u0F42",
            yy: "%d \u0F63\u0F7C"
        },
        preparse: function(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function(match) {
                return numberMap$4[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$5[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C" && hour >= 4 || meridiem === "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44" && hour < 5 || meridiem === "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
            else if (hour < 10) return "\u0F5E\u0F7C\u0F42\u0F66\u0F0B\u0F40\u0F66";
            else if (hour < 17) return "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44";
            else if (hour < 20) return "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42";
            else return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch(lastNumber(number)){
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) return lastNumber(number % 10);
        return number;
    }
    function mutation(text, number) {
        if (number === 2) return softMutation(text);
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) return text;
        return mutationTable[text.charAt(0)] + text.substring(1);
    }
    var monthsParse = [
        /^gen/i,
        /^c[ʼ\']hwe/i,
        /^meu/i,
        /^ebr/i,
        /^mae/i,
        /^(mez|eve)/i,
        /^gou/i,
        /^eos/i,
        /^gwe/i,
        /^her/i,
        /^du/i,
        /^ker/i
    ], monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i, monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, fullWeekdaysParse = [
        /^sul/i,
        /^lun/i,
        /^meurzh/i,
        /^merc[ʼ\']her/i,
        /^yaou/i,
        /^gwener/i,
        /^sadorn/i
    ], shortWeekdaysParse = [
        /^Sul/i,
        /^Lun/i,
        /^Meu/i,
        /^Mer/i,
        /^Yao/i,
        /^Gwe/i,
        /^Sad/i
    ], minWeekdaysParse = [
        /^Su/i,
        /^Lu/i,
        /^Me([^r]|$)/i,
        /^Mer/i,
        /^Ya/i,
        /^Gw/i,
        /^Sa/i
    ];
    moment.defineLocale('br', {
        months: "Genver_C\u02BChwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split('_'),
        monthsShort: "Gen_C\u02BChwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split('_'),
        weekdays: "Sul_Lun_Meurzh_Merc\u02BCher_Yaou_Gwener_Sadorn".split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: "[Warc\u02BChoazh da] LT",
            nextWeek: 'dddd [da] LT',
            lastDay: "[Dec\u02BCh da] LT",
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'a-benn %s',
            past: "%s \u02BCzo",
            s: "un nebeud segondenno\xf9",
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function(number) {
            var output = number === 1 ? "a\xf1" : 'vet';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        },
        meridiemParse: /a.m.|g.m./,
        isPM: function(token) {
            return token === 'g.m.';
        },
        meridiem: function(hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        }
    });
    //! moment.js locale configuration
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch(key){
            case 'ss':
                if (number === 1) result += 'sekunda';
                else if (number === 2 || number === 3 || number === 4) result += 'sekunde';
                else result += 'sekundi';
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) result += 'minuta';
                else if (number === 2 || number === 3 || number === 4) result += 'minute';
                else result += 'minuta';
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) result += 'sat';
                else if (number === 2 || number === 3 || number === 4) result += 'sata';
                else result += 'sati';
                return result;
            case 'dd':
                if (number === 1) result += 'dan';
                else result += 'dana';
                return result;
            case 'MM':
                if (number === 1) result += 'mjesec';
                else if (number === 2 || number === 3 || number === 4) result += 'mjeseca';
                else result += 'mjeseci';
                return result;
            case 'yy':
                if (number === 1) result += 'godina';
                else if (number === 2 || number === 3 || number === 4) result += 'godine';
                else result += 'godina';
                return result;
        }
    }
    moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split('_'),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split('_'),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: "[ju\u010Der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                        return "[pro\u0161lu] dddd [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ca', {
        months: {
            standalone: "gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split('_'),
            format: "de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split('_'),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: function() {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function() {
                return "[dem\xe0 a " + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function() {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : "\xe8";
            if (period === 'w' || period === 'W') output = 'a';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$3 = {
        format: "leden_\xfanor_b\u0159ezen_duben_kv\u011Bten_\u010Derven_\u010Dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split('_'),
        standalone: "ledna_\xfanora_b\u0159ezna_dubna_kv\u011Btna_\u010Dervna_\u010Dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split('_')
    }, monthsShort = "led_\xfano_b\u0159e_dub_kv\u011B_\u010Dvn_\u010Dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split('_'), monthsParse$1 = [
        /^led/i,
        /^úno/i,
        /^bře/i,
        /^dub/i,
        /^kvě/i,
        /^(čvn|červen$|června)/i,
        /^(čvc|červenec|července)/i,
        /^srp/i,
        /^zář/i,
        /^říj/i,
        /^lis/i,
        /^pro/i
    ], // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    monthsRegex$1 = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
    function plural$1(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch(key){
            case 's':
                return withoutSuffix || isFuture ? "p\xe1r sekund" : "p\xe1r sekundami";
            case 'ss':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? 'sekundy' : 'sekund');
                else return result + 'sekundami';
            case 'm':
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? 'minuty' : 'minut');
                else return result + 'minutami';
            case 'h':
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? 'hodiny' : 'hodin');
                else return result + 'hodinami';
            case 'd':
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? 'dny' : "dn\xed");
                else return result + 'dny';
            case 'M':
                return withoutSuffix || isFuture ? "m\u011Bs\xedc" : "m\u011Bs\xedcem";
            case 'MM':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "m\u011Bs\xedce" : "m\u011Bs\xedc\u016F");
                else return result + "m\u011Bs\xedci";
            case 'y':
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy':
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? 'roky' : 'let');
                else return result + 'lety';
        }
    }
    moment.defineLocale('cs', {
        months: months$3,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex$1,
        monthsShortRegex: monthsRegex$1,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse$1,
        longMonthsParse: monthsParse$1,
        shortMonthsParse: monthsParse$1,
        weekdays: "ned\u011Ble_pond\u011Bl\xed_\xfater\xfd_st\u0159eda_\u010Dtvrtek_p\xe1tek_sobota".split('_'),
        weekdaysShort: "ne_po_\xfat_st_\u010Dt_p\xe1_so".split('_'),
        weekdaysMin: "ne_po_\xfat_st_\u010Dt_p\xe1_so".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: "[z\xedtra v] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v ned\u011Bli v] LT";
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return "[ve st\u0159edu v] LT";
                    case 4:
                        return "[ve \u010Dtvrtek v] LT";
                    case 5:
                        return "[v p\xe1tek v] LT";
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: "[v\u010Dera v] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minulou ned\u011Bli v] LT";
                    case 1:
                    case 2:
                        return "[minul\xe9] dddd [v] LT";
                    case 3:
                        return "[minulou st\u0159edu v] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [v] LT";
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: "p\u0159ed %s",
            s: translate$1,
            ss: translate$1,
            m: translate$1,
            mm: translate$1,
            h: translate$1,
            hh: translate$1,
            d: translate$1,
            dd: translate$1,
            M: translate$1,
            MM: translate$1,
            y: translate$1,
            yy: translate$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('cv', {
        months: "\u043A\u04D1\u0440\u043B\u0430\u0447_\u043D\u0430\u0440\u04D1\u0441_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440\u0442\u043C\u0435_\u0443\u0442\u04D1_\u04AB\u0443\u0440\u043B\u0430_\u0430\u0432\u04D1\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448\u0442\u0430\u0432".split('_'),
        monthsShort: "\u043A\u04D1\u0440_\u043D\u0430\u0440_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440_\u0443\u0442\u04D1_\u04AB\u0443\u0440_\u0430\u0432\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448".split('_'),
        weekdays: "\u0432\u044B\u0440\u0441\u0430\u0440\u043D\u0438\u043A\u0443\u043D_\u0442\u0443\u043D\u0442\u0438\u043A\u0443\u043D_\u044B\u0442\u043B\u0430\u0440\u0438\u043A\u0443\u043D_\u044E\u043D\u043A\u0443\u043D_\u043A\u04D7\u04AB\u043D\u0435\u0440\u043D\u0438\u043A\u0443\u043D_\u044D\u0440\u043D\u0435\u043A\u0443\u043D_\u0448\u04D1\u043C\u0430\u0442\u043A\u0443\u043D".split('_'),
        weekdaysShort: "\u0432\u044B\u0440_\u0442\u0443\u043D_\u044B\u0442\u043B_\u044E\u043D_\u043A\u04D7\u04AB_\u044D\u0440\u043D_\u0448\u04D1\u043C".split('_'),
        weekdaysMin: "\u0432\u0440_\u0442\u043D_\u044B\u0442_\u044E\u043D_\u043A\u04AB_\u044D\u0440_\u0448\u043C".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7]",
            LLL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm",
            LLLL: "dddd, YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm"
        },
        calendar: {
            sameDay: "[\u041F\u0430\u044F\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextDay: "[\u042B\u0440\u0430\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastDay: "[\u04D6\u043D\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextWeek: "[\u04AA\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastWeek: "[\u0418\u0440\u0442\u043D\u04D7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            sameElse: 'L'
        },
        relativeTime: {
            future: function(output) {
                var affix = /сехет$/i.exec(output) ? "\u0440\u0435\u043D" : /ҫул$/i.exec(output) ? "\u0442\u0430\u043D" : "\u0440\u0430\u043D";
                return output + affix;
            },
            past: "%s \u043A\u0430\u044F\u043B\u043B\u0430",
            s: "\u043F\u04D7\u0440-\u0438\u043A \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
            ss: "%d \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
            m: "\u043F\u04D7\u0440 \u043C\u0438\u043D\u0443\u0442",
            mm: "%d \u043C\u0438\u043D\u0443\u0442",
            h: "\u043F\u04D7\u0440 \u0441\u0435\u0445\u0435\u0442",
            hh: "%d \u0441\u0435\u0445\u0435\u0442",
            d: "\u043F\u04D7\u0440 \u043A\u0443\u043D",
            dd: "%d \u043A\u0443\u043D",
            M: "\u043F\u04D7\u0440 \u0443\u0439\u04D1\u0445",
            MM: "%d \u0443\u0439\u04D1\u0445",
            y: "\u043F\u04D7\u0440 \u04AB\u0443\u043B",
            yy: "%d \u04AB\u0443\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: "%d-\u043C\u04D7\u0448",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: "%s yn \xf4l",
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function(number) {
            var b = number, output = '', lookup = [
                '',
                'af',
                'il',
                'ydd',
                'ydd',
                'ed',
                'ed',
                'ed',
                'fed',
                'fed',
                'fed',
                'eg',
                'fed',
                'eg',
                'eg',
                'fed',
                'eg',
                'eg',
                'fed',
                'eg',
                'fed'
            ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) output = 'fed'; // not 30ain, 70ain or 90ain
                else output = 'ain';
            } else if (b > 0) output = lookup[b];
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split('_'),
        weekdaysShort: "s\xf8n_man_tir_ons_tor_fre_l\xf8r".split('_'),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: "p\xe5 dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: "f\xe5 sekunder",
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "et \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                'eine Minute',
                'einer Minute'
            ],
            h: [
                'eine Stunde',
                'einer Stunde'
            ],
            d: [
                'ein Tag',
                'einem Tag'
            ],
            dd: [
                number + ' Tage',
                number + ' Tagen'
            ],
            w: [
                'eine Woche',
                'einer Woche'
            ],
            M: [
                'ein Monat',
                'einem Monat'
            ],
            MM: [
                number + ' Monate',
                number + ' Monaten'
            ],
            y: [
                'ein Jahr',
                'einem Jahr'
            ],
            yy: [
                number + ' Jahre',
                number + ' Jahren'
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale('de-at', {
        months: "J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split('_'),
        monthsShort: "J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                'eine Minute',
                'einer Minute'
            ],
            h: [
                'eine Stunde',
                'einer Stunde'
            ],
            d: [
                'ein Tag',
                'einem Tag'
            ],
            dd: [
                number + ' Tage',
                number + ' Tagen'
            ],
            w: [
                'eine Woche',
                'einer Woche'
            ],
            M: [
                'ein Monat',
                'einem Monat'
            ],
            MM: [
                number + ' Monate',
                number + ' Monaten'
            ],
            y: [
                'ein Jahr',
                'einem Jahr'
            ],
            yy: [
                number + ' Jahre',
                number + ' Jahren'
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale('de-ch', {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split('_'),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$1,
            mm: '%d Minuten',
            h: processRelativeTime$1,
            hh: '%d Stunden',
            d: processRelativeTime$1,
            dd: processRelativeTime$1,
            w: processRelativeTime$1,
            ww: '%d Wochen',
            M: processRelativeTime$1,
            MM: processRelativeTime$1,
            y: processRelativeTime$1,
            yy: processRelativeTime$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                'eine Minute',
                'einer Minute'
            ],
            h: [
                'eine Stunde',
                'einer Stunde'
            ],
            d: [
                'ein Tag',
                'einem Tag'
            ],
            dd: [
                number + ' Tage',
                number + ' Tagen'
            ],
            w: [
                'eine Woche',
                'einer Woche'
            ],
            M: [
                'ein Monat',
                'einem Monat'
            ],
            MM: [
                number + ' Monate',
                number + ' Monaten'
            ],
            y: [
                'ein Jahr',
                'einem Jahr'
            ],
            yy: [
                number + ' Jahre',
                number + ' Jahren'
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale('de', {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split('_'),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$2,
            mm: '%d Minuten',
            h: processRelativeTime$2,
            hh: '%d Stunden',
            d: processRelativeTime$2,
            dd: processRelativeTime$2,
            w: processRelativeTime$2,
            ww: '%d Wochen',
            M: processRelativeTime$2,
            MM: processRelativeTime$2,
            y: processRelativeTime$2,
            yy: processRelativeTime$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$4 = [
        "\u0796\u07AC\u0782\u07AA\u0787\u07A6\u0783\u07A9",
        "\u078A\u07AC\u0784\u07B0\u0783\u07AA\u0787\u07A6\u0783\u07A9",
        "\u0789\u07A7\u0783\u07A8\u0797\u07AA",
        "\u0787\u07AD\u0795\u07B0\u0783\u07A9\u078D\u07AA",
        "\u0789\u07AD",
        "\u0796\u07AB\u0782\u07B0",
        "\u0796\u07AA\u078D\u07A6\u0787\u07A8",
        "\u0787\u07AF\u078E\u07A6\u0790\u07B0\u0793\u07AA",
        "\u0790\u07AC\u0795\u07B0\u0793\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
        "\u0787\u07AE\u0786\u07B0\u0793\u07AF\u0784\u07A6\u0783\u07AA",
        "\u0782\u07AE\u0788\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
        "\u0791\u07A8\u0790\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA"
    ], weekdays = [
        "\u0787\u07A7\u078B\u07A8\u0787\u07B0\u078C\u07A6",
        "\u0780\u07AF\u0789\u07A6",
        "\u0787\u07A6\u0782\u07B0\u078E\u07A7\u0783\u07A6",
        "\u0784\u07AA\u078B\u07A6",
        "\u0784\u07AA\u0783\u07A7\u0790\u07B0\u078A\u07A6\u078C\u07A8",
        "\u0780\u07AA\u0786\u07AA\u0783\u07AA",
        "\u0780\u07AE\u0782\u07A8\u0780\u07A8\u0783\u07AA"
    ];
    moment.defineLocale('dv', {
        months: months$4,
        monthsShort: months$4,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: "\u0787\u07A7\u078B\u07A8_\u0780\u07AF\u0789\u07A6_\u0787\u07A6\u0782\u07B0_\u0784\u07AA\u078B\u07A6_\u0784\u07AA\u0783\u07A7_\u0780\u07AA\u0786\u07AA_\u0780\u07AE\u0782\u07A8".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM: function(input) {
            return "\u0789\u078A" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0789\u0786";
            else return "\u0789\u078A";
        },
        calendar: {
            sameDay: "[\u0789\u07A8\u0787\u07A6\u078B\u07AA] LT",
            nextDay: "[\u0789\u07A7\u078B\u07A6\u0789\u07A7] LT",
            nextWeek: 'dddd LT',
            lastDay: "[\u0787\u07A8\u0787\u07B0\u0794\u07AC] LT",
            lastWeek: "[\u078A\u07A7\u0787\u07A8\u078C\u07AA\u0788\u07A8] dddd LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u078C\u07AC\u0783\u07AD\u078E\u07A6\u0787\u07A8 %s",
            past: "\u0786\u07AA\u0783\u07A8\u0782\u07B0 %s",
            s: "\u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA\u0786\u07AE\u0785\u07AC\u0787\u07B0",
            ss: "d% \u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA",
            m: "\u0789\u07A8\u0782\u07A8\u0793\u07AC\u0787\u07B0",
            mm: "\u0789\u07A8\u0782\u07A8\u0793\u07AA %d",
            h: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AC\u0787\u07B0",
            hh: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AA %d",
            d: "\u078B\u07AA\u0788\u07A6\u0780\u07AC\u0787\u07B0",
            dd: "\u078B\u07AA\u0788\u07A6\u0790\u07B0 %d",
            M: "\u0789\u07A6\u0780\u07AC\u0787\u07B0",
            MM: "\u0789\u07A6\u0790\u07B0 %d",
            y: "\u0787\u07A6\u0780\u07A6\u0783\u07AC\u0787\u07B0",
            yy: "\u0787\u07A6\u0780\u07A6\u0783\u07AA %d"
        },
        preparse: function(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 7,
            doy: 12
        }
    });
    //! moment.js locale configuration
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    moment.defineLocale('el', {
        monthsNominativeEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2_\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2_\u039C\u03AC\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2_\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2_\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2_\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2".split('_'),
        monthsGenitiveEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5_\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5_\u039C\u03B1\u0390\u03BF\u03C5_\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5_\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5_\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5_\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5_\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5".split('_'),
        months: function(momentToFormat, format) {
            if (!momentToFormat) return this._monthsNominativeEl;
            else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
            else return this._monthsNominativeEl[momentToFormat.month()];
        },
        monthsShort: "\u0399\u03B1\u03BD_\u03A6\u03B5\u03B2_\u039C\u03B1\u03C1_\u0391\u03C0\u03C1_\u039C\u03B1\u03CA_\u0399\u03BF\u03C5\u03BD_\u0399\u03BF\u03C5\u03BB_\u0391\u03C5\u03B3_\u03A3\u03B5\u03C0_\u039F\u03BA\u03C4_\u039D\u03BF\u03B5_\u0394\u03B5\u03BA".split('_'),
        weekdays: "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE_\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1_\u03A4\u03C1\u03AF\u03C4\u03B7_\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7_\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7_\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE_\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF".split('_'),
        weekdaysShort: "\u039A\u03C5\u03C1_\u0394\u03B5\u03C5_\u03A4\u03C1\u03B9_\u03A4\u03B5\u03C4_\u03A0\u03B5\u03BC_\u03A0\u03B1\u03C1_\u03A3\u03B1\u03B2".split('_'),
        weekdaysMin: "\u039A\u03C5_\u0394\u03B5_\u03A4\u03C1_\u03A4\u03B5_\u03A0\u03B5_\u03A0\u03B1_\u03A3\u03B1".split('_'),
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "\u03BC\u03BC" : "\u039C\u039C";
            else return isLower ? "\u03C0\u03BC" : "\u03A0\u039C";
        },
        isPM: function(input) {
            return (input + '').toLowerCase()[0] === "\u03BC";
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl: {
            sameDay: "[\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1 {}] LT",
            nextDay: "[\u0391\u03CD\u03C1\u03B9\u03BF {}] LT",
            nextWeek: 'dddd [{}] LT',
            lastDay: "[\u03A7\u03B8\u03B5\u03C2 {}] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 6:
                        return "[\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF] dddd [{}] LT";
                    default:
                        return "[\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7] dddd [{}] LT";
                }
            },
            sameElse: 'L'
        },
        calendar: function(key, mom) {
            var output = this._calendarEl[key], hours = mom && mom.hours();
            if (isFunction(output)) output = output.apply(mom);
            return output.replace('{}', hours % 12 === 1 ? "\u03C3\u03C4\u03B7" : "\u03C3\u03C4\u03B9\u03C2");
        },
        relativeTime: {
            future: "\u03C3\u03B5 %s",
            past: "%s \u03C0\u03C1\u03B9\u03BD",
            s: "\u03BB\u03AF\u03B3\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            ss: "%d \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            m: "\u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
            mm: "%d \u03BB\u03B5\u03C0\u03C4\u03AC",
            h: "\u03BC\u03AF\u03B1 \u03CE\u03C1\u03B1",
            hh: "%d \u03CE\u03C1\u03B5\u03C2",
            d: "\u03BC\u03AF\u03B1 \u03BC\u03AD\u03C1\u03B1",
            dd: "%d \u03BC\u03AD\u03C1\u03B5\u03C2",
            M: "\u03AD\u03BD\u03B1\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
            MM: "%d \u03BC\u03AE\u03BD\u03B5\u03C2",
            y: "\u03AD\u03BD\u03B1\u03C2 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
            yy: "%d \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: "%d\u03B7",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('eo', {
        months: "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016Dgusto_septembro_oktobro_novembro_decembro".split('_'),
        monthsShort: "jan_feb_mart_apr_maj_jun_jul_a\u016Dg_sept_okt_nov_dec".split('_'),
        weekdays: "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016Ddo_vendredo_sabato".split('_'),
        weekdaysShort: "dim_lun_mard_merk_\u0135a\u016D_ven_sab".split('_'),
        weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function(input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? 'p.t.m.' : 'P.T.M.';
            else return isLower ? 'a.t.m.' : 'A.T.M.';
        },
        calendar: {
            sameDay: "[Hodia\u016D je] LT",
            nextDay: "[Morga\u016D je] LT",
            nextWeek: 'dddd[n je] LT',
            lastDay: "[Hiera\u016D je] LT",
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'post %s',
            past: "anta\u016D %s",
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago',
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), monthsParse$2 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$2 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot;
            else if (/-MMM-/.test(format)) return monthsShort$1[m.month()];
            else return monthsShortDot[m.month()];
        },
        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$2,
        longMonthsParse: monthsParse$2,
        shortMonthsParse: monthsParse$2,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortDot$1 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), monthsParse$3 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$3 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$1;
            else if (/-MMM-/.test(format)) return monthsShort$2[m.month()];
            else return monthsShortDot$1[m.month()];
        },
        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$3,
        longMonthsParse: monthsParse$3,
        shortMonthsParse: monthsParse$3,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    });
    //! moment.js locale configuration
    var monthsShortDot$2 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), monthsParse$4 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$4 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$2;
            else if (/-MMM-/.test(format)) return monthsShort$3[m.month()];
            else return monthsShortDot$2[m.month()];
        },
        monthsRegex: monthsRegex$4,
        monthsShortRegex: monthsRegex$4,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$4,
        longMonthsParse: monthsParse$4,
        shortMonthsParse: monthsParse$4,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsShortDot$3 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort$4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), monthsParse$5 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$5 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$3;
            else if (/-MMM-/.test(format)) return monthsShort$4[m.month()];
            else return monthsShortDot$3[m.month()];
        },
        monthsRegex: monthsRegex$5,
        monthsShortRegex: monthsRegex$5,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$5,
        longMonthsParse: monthsParse$5,
        shortMonthsParse: monthsParse$5,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    });
    //! moment.js locale configuration
    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "m\xf5ne sekundi",
                "m\xf5ni sekund",
                'paar sekundit'
            ],
            ss: [
                number + 'sekundi',
                number + 'sekundit'
            ],
            m: [
                "\xfche minuti",
                "\xfcks minut"
            ],
            mm: [
                number + ' minuti',
                number + ' minutit'
            ],
            h: [
                "\xfche tunni",
                'tund aega',
                "\xfcks tund"
            ],
            hh: [
                number + ' tunni',
                number + ' tundi'
            ],
            d: [
                "\xfche p\xe4eva",
                "\xfcks p\xe4ev"
            ],
            M: [
                'kuu aja',
                'kuu aega',
                "\xfcks kuu"
            ],
            MM: [
                number + ' kuu',
                number + ' kuud'
            ],
            y: [
                "\xfche aasta",
                'aasta',
                "\xfcks aasta"
            ],
            yy: [
                number + ' aasta',
                number + ' aastat'
            ]
        };
        if (withoutSuffix) return format[key][2] ? format[key][2] : format[key][1];
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale('et', {
        months: "jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split('_'),
        monthsShort: "jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split('_'),
        weekdays: "p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split('_'),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: "[T\xe4na,] LT",
            nextDay: '[Homme,] LT',
            nextWeek: "[J\xe4rgmine] dddd LT",
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s p\xe4rast",
            past: '%s tagasi',
            s: processRelativeTime$3,
            ss: processRelativeTime$3,
            m: processRelativeTime$3,
            mm: processRelativeTime$3,
            h: processRelativeTime$3,
            hh: processRelativeTime$3,
            d: processRelativeTime$3,
            dd: "%d p\xe4eva",
            M: processRelativeTime$3,
            MM: processRelativeTime$3,
            y: processRelativeTime$3,
            yy: processRelativeTime$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$6 = {
        1: "\u06F1",
        2: "\u06F2",
        3: "\u06F3",
        4: "\u06F4",
        5: "\u06F5",
        6: "\u06F6",
        7: "\u06F7",
        8: "\u06F8",
        9: "\u06F9",
        0: "\u06F0"
    }, numberMap$5 = {
        "\u06F1": '1',
        "\u06F2": '2',
        "\u06F3": '3',
        "\u06F4": '4',
        "\u06F5": '5',
        "\u06F6": '6',
        "\u06F7": '7',
        "\u06F8": '8',
        "\u06F9": '9',
        "\u06F0": '0'
    };
    moment.defineLocale('fa', {
        months: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split('_'),
        monthsShort: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split('_'),
        weekdays: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
        weekdaysShort: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
        weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u062C_\u0634".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function(input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631";
            else return "\u0628\u0639\u062F \u0627\u0632 \u0638\u0647\u0631";
        },
        calendar: {
            sameDay: "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
            nextDay: "[\u0641\u0631\u062F\u0627 \u0633\u0627\u0639\u062A] LT",
            nextWeek: "dddd [\u0633\u0627\u0639\u062A] LT",
            lastDay: "[\u062F\u06CC\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
            lastWeek: "dddd [\u067E\u06CC\u0634] [\u0633\u0627\u0639\u062A] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u062F\u0631 %s",
            past: "%s \u067E\u06CC\u0634",
            s: "\u0686\u0646\u062F \u062B\u0627\u0646\u06CC\u0647",
            ss: "%d \u062B\u0627\u0646\u06CC\u0647",
            m: "\u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
            mm: "%d \u062F\u0642\u06CC\u0642\u0647",
            h: "\u06CC\u06A9 \u0633\u0627\u0639\u062A",
            hh: "%d \u0633\u0627\u0639\u062A",
            d: "\u06CC\u06A9 \u0631\u0648\u0632",
            dd: "%d \u0631\u0648\u0632",
            M: "\u06CC\u06A9 \u0645\u0627\u0647",
            MM: "%d \u0645\u0627\u0647",
            y: "\u06CC\u06A9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/[۰-۹]/g, function(match) {
                return numberMap$5[match];
            }).replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$6[match];
            }).replace(/,/g, "\u060C");
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: "%d\u0645",
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var numbersPast = "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(' '), numbersFuture = [
        'nolla',
        'yhden',
        'kahden',
        'kolmen',
        "nelj\xe4n",
        'viiden',
        'kuuden',
        numbersPast[7],
        numbersPast[8],
        numbersPast[9]
    ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch(key){
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case 'dd':
                result = isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }
    moment.defineLocale('fi', {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split('_'),
        monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: '%s sitten',
            s: translate$2,
            ss: translate$2,
            m: translate$2,
            mm: translate$2,
            h: translate$2,
            hh: translate$2,
            d: translate$2,
            dd: translate$2,
            M: translate$2,
            MM: translate$2,
            y: translate$2,
            yy: translate$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('fo', {
        months: "januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: "sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split('_'),
        weekdaysShort: "sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split('_'),
        weekdaysMin: "su_m\xe1_t\xfd_mi_h\xf3_fr_le".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\xcd dag kl.] LT",
            nextDay: "[\xcd morgin kl.] LT",
            nextWeek: 'dddd [kl.] LT',
            lastDay: "[\xcd gj\xe1r kl.] LT",
            lastWeek: "[s\xed\xf0stu] dddd [kl] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'um %s',
            past: "%s s\xed\xf0ani",
            s: "f\xe1 sekund",
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: "ein t\xedmi",
            hh: "%d t\xedmar",
            d: 'ein dagur',
            dd: '%d dagar',
            M: "ein m\xe1na\xf0ur",
            MM: "%d m\xe1na\xf0ir",
            y: "eitt \xe1r",
            yy: "%d \xe1r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('fr-ca', {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split('_'),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(number, period) {
            switch(period){
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('fr-ch', {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split('_'),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(number, period) {
            switch(period){
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsStrictRegex$1 = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsShortStrictRegex$1 = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i, monthsRegex$6 = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsParse$6 = [
        /^janv/i,
        /^févr/i,
        /^mars/i,
        /^avr/i,
        /^mai/i,
        /^juin/i,
        /^juil/i,
        /^août/i,
        /^sept/i,
        /^oct/i,
        /^nov/i,
        /^déc/i
    ];
    moment.defineLocale('fr', {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split('_'),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split('_'),
        monthsRegex: monthsRegex$6,
        monthsShortRegex: monthsRegex$6,
        monthsStrictRegex: monthsStrictRegex$1,
        monthsShortStrictRegex: monthsShortStrictRegex$1,
        monthsParse: monthsParse$6,
        longMonthsParse: monthsParse$6,
        shortMonthsParse: monthsParse$6,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function(number, period) {
            switch(period){
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');
                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'), monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
    moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots[m.month()];
            else return monthsShortWithDots[m.month()];
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: "[\xf4fr\xfbne] dddd [om] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: "ien min\xfat",
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$5 = [
        "Ean\xe1ir",
        'Feabhra',
        "M\xe1rta",
        "Aibre\xe1n",
        'Bealtaine',
        'Meitheamh',
        "I\xfail",
        "L\xfanasa",
        "Me\xe1n F\xf3mhair",
        "Deireadh F\xf3mhair",
        'Samhain',
        'Nollaig'
    ], monthsShort$5 = [
        'Ean',
        'Feabh',
        "M\xe1rt",
        'Aib',
        'Beal',
        'Meith',
        "I\xfail",
        "L\xfan",
        'M.F.',
        'D.F.',
        'Samh',
        'Noll'
    ], weekdays$1 = [
        "D\xe9 Domhnaigh",
        "D\xe9 Luain",
        "D\xe9 M\xe1irt",
        "D\xe9 C\xe9adaoin",
        "D\xe9ardaoin",
        "D\xe9 hAoine",
        "D\xe9 Sathairn"
    ], weekdaysShort = [
        'Domh',
        'Luan',
        "M\xe1irt",
        "C\xe9ad",
        "D\xe9ar",
        'Aoine',
        'Sath'
    ], weekdaysMin = [
        'Do',
        'Lu',
        "M\xe1",
        "C\xe9",
        "D\xe9",
        'A',
        'Sa'
    ];
    moment.defineLocale('ga', {
        months: months$5,
        monthsShort: monthsShort$5,
        monthsParseExact: true,
        weekdays: weekdays$1,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: "[Am\xe1rach ag] LT",
            nextWeek: 'dddd [ag] LT',
            lastDay: "[Inn\xe9 ag] LT",
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: "%s \xf3 shin",
            s: "c\xfapla soicind",
            ss: '%d soicind',
            m: "n\xf3im\xe9ad",
            mm: "%d n\xf3im\xe9ad",
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: "l\xe1",
            dd: "%d l\xe1",
            M: "m\xed",
            MM: "%d m\xedonna",
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$6 = [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ], monthsShort$6 = [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ], weekdays$2 = [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ], weekdaysShort$1 = [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ], weekdaysMin$1 = [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ];
    moment.defineLocale('gd', {
        months: months$6,
        monthsShort: monthsShort$6,
        monthsParseExact: true,
        weekdays: weekdays$2,
        weekdaysShort: weekdaysShort$1,
        weekdaysMin: weekdaysMin$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: "[A-m\xe0ireach aig] LT",
            nextWeek: 'dddd [aig] LT',
            lastDay: "[An-d\xe8 aig] LT",
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: "m\xecos",
            MM: "%d m\xecosan",
            y: 'bliadhna',
            yy: '%d bliadhna'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('gl', {
        months: "xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split('_'),
        monthsShort: "xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split('_'),
        monthsParseExact: true,
        weekdays: "domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_m\xe9_xo_ve_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function() {
                return '[hoxe ' + (this.hours() !== 1 ? "\xe1s" : "\xe1") + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1\xe1 " + (this.hours() !== 1 ? "\xe1s" : "\xe1") + '] LT';
            },
            nextWeek: function() {
                return 'dddd [' + (this.hours() !== 1 ? "\xe1s" : 'a') + '] LT';
            },
            lastDay: function() {
                return '[onte ' + (this.hours() !== 1 ? "\xe1" : 'a') + '] LT';
            },
            lastWeek: function() {
                return '[o] dddd [pasado ' + (this.hours() !== 1 ? "\xe1s" : 'a') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function(str) {
                if (str.indexOf('un') === 0) return 'n' + str;
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "\u0925\u094B\u0921\u092F\u093E \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940",
                "\u0925\u094B\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"
            ],
            ss: [
                number + " \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940",
                number + " \u0938\u0945\u0915\u0902\u0921"
            ],
            m: [
                "\u090F\u0915\u093E \u092E\u093F\u0923\u091F\u093E\u0928",
                "\u090F\u0915 \u092E\u093F\u0928\u0942\u091F"
            ],
            mm: [
                number + " \u092E\u093F\u0923\u091F\u093E\u0902\u0928\u0940",
                number + " \u092E\u093F\u0923\u091F\u093E\u0902"
            ],
            h: [
                "\u090F\u0915\u093E \u0935\u0930\u093E\u0928",
                "\u090F\u0915 \u0935\u0930"
            ],
            hh: [
                number + " \u0935\u0930\u093E\u0902\u0928\u0940",
                number + " \u0935\u0930\u093E\u0902"
            ],
            d: [
                "\u090F\u0915\u093E \u0926\u093F\u0938\u093E\u0928",
                "\u090F\u0915 \u0926\u0940\u0938"
            ],
            dd: [
                number + " \u0926\u093F\u0938\u093E\u0902\u0928\u0940",
                number + " \u0926\u0940\u0938"
            ],
            M: [
                "\u090F\u0915\u093E \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928",
                "\u090F\u0915 \u092E\u094D\u0939\u092F\u0928\u094B"
            ],
            MM: [
                number + " \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928\u0940",
                number + " \u092E\u094D\u0939\u092F\u0928\u0947"
            ],
            y: [
                "\u090F\u0915\u093E \u0935\u0930\u094D\u0938\u093E\u0928",
                "\u090F\u0915 \u0935\u0930\u094D\u0938"
            ],
            yy: [
                number + " \u0935\u0930\u094D\u0938\u093E\u0902\u0928\u0940",
                number + " \u0935\u0930\u094D\u0938\u093E\u0902"
            ]
        };
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale('gom-deva', {
        months: {
            standalone: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u092F_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split('_'),
            format: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092E\u093E\u0930\u094D\u091A\u093E\u091A\u094D\u092F\u093E_\u090F\u092A\u094D\u0930\u0940\u0932\u093E\u091A\u094D\u092F\u093E_\u092E\u0947\u092F\u093E\u091A\u094D\u092F\u093E_\u091C\u0942\u0928\u093E\u091A\u094D\u092F\u093E_\u091C\u0941\u0932\u092F\u093E\u091A\u094D\u092F\u093E_\u0911\u0917\u0938\u094D\u091F\u093E\u091A\u094D\u092F\u093E_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0911\u0915\u094D\u091F\u094B\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0921\u093F\u0938\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E".split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940._\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0906\u092F\u0924\u093E\u0930_\u0938\u094B\u092E\u093E\u0930_\u092E\u0902\u0917\u0933\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u092C\u093F\u0930\u0947\u0938\u094D\u0924\u093E\u0930_\u0938\u0941\u0915\u094D\u0930\u093E\u0930_\u0936\u0947\u0928\u0935\u093E\u0930".split('_'),
        weekdaysShort: "\u0906\u092F\u0924._\u0938\u094B\u092E._\u092E\u0902\u0917\u0933._\u092C\u0941\u0927._\u092C\u094D\u0930\u0947\u0938\u094D\u0924._\u0938\u0941\u0915\u094D\u0930._\u0936\u0947\u0928.".split('_'),
        weekdaysMin: "\u0906_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u092C\u094D\u0930\u0947_\u0938\u0941_\u0936\u0947".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            LTS: "A h:mm:ss [\u0935\u093E\u091C\u0924\u093E\u0902]",
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]"
        },
        calendar: {
            sameDay: "[\u0906\u092F\u091C] LT",
            nextDay: "[\u092B\u093E\u0932\u094D\u092F\u093E\u0902] LT",
            nextWeek: "[\u092B\u0941\u0921\u0932\u094B] dddd[,] LT",
            lastDay: "[\u0915\u093E\u0932] LT",
            lastWeek: "[\u092B\u093E\u091F\u0932\u094B] dddd[,] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: "%s \u0906\u0926\u0940\u0902",
            s: processRelativeTime$4,
            ss: processRelativeTime$4,
            m: processRelativeTime$4,
            mm: processRelativeTime$4,
            h: processRelativeTime$4,
            hh: processRelativeTime$4,
            d: processRelativeTime$4,
            dd: processRelativeTime$4,
            M: processRelativeTime$4,
            MM: processRelativeTime$4,
            y: processRelativeTime$4,
            yy: processRelativeTime$4
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function(number, period) {
            switch(period){
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + "\u0935\u0947\u0930";
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924\u0940") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0938\u0915\u093E\u0933\u0940\u0902") return hour;
            else if (meridiem === "\u0926\u0928\u092A\u093E\u0930\u093E\u0902") return hour > 12 ? hour : hour + 12;
            else if (meridiem === "\u0938\u093E\u0902\u091C\u0947") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0930\u093E\u0924\u0940";
            else if (hour < 12) return "\u0938\u0915\u093E\u0933\u0940\u0902";
            else if (hour < 16) return "\u0926\u0928\u092A\u093E\u0930\u093E\u0902";
            else if (hour < 20) return "\u0938\u093E\u0902\u091C\u0947";
            else return "\u0930\u093E\u0924\u0940";
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                'thoddea sekondamni',
                'thodde sekond'
            ],
            ss: [
                number + ' sekondamni',
                number + ' sekond'
            ],
            m: [
                'eka mintan',
                'ek minut'
            ],
            mm: [
                number + ' mintamni',
                number + ' mintam'
            ],
            h: [
                'eka voran',
                'ek vor'
            ],
            hh: [
                number + ' voramni',
                number + ' voram'
            ],
            d: [
                'eka disan',
                'ek dis'
            ],
            dd: [
                number + ' disamni',
                number + ' dis'
            ],
            M: [
                'eka mhoinean',
                'ek mhoino'
            ],
            MM: [
                number + ' mhoineamni',
                number + ' mhoine'
            ],
            y: [
                'eka vorsan',
                'ek voros'
            ],
            yy: [
                number + ' vorsamni',
                number + ' vorsam'
            ]
        };
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime$5,
            ss: processRelativeTime$5,
            m: processRelativeTime$5,
            mm: processRelativeTime$5,
            h: processRelativeTime$5,
            hh: processRelativeTime$5,
            d: processRelativeTime$5,
            dd: processRelativeTime$5,
            M: processRelativeTime$5,
            MM: processRelativeTime$5,
            y: processRelativeTime$5,
            yy: processRelativeTime$5
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function(number, period) {
            switch(period){
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'rati') return hour < 4 ? hour : hour + 12;
            else if (meridiem === 'sokallim') return hour;
            else if (meridiem === 'donparam') return hour > 12 ? hour : hour + 12;
            else if (meridiem === 'sanje') return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return 'rati';
            else if (hour < 12) return 'sokallim';
            else if (hour < 16) return 'donparam';
            else if (hour < 20) return 'sanje';
            else return 'rati';
        }
    });
    //! moment.js locale configuration
    var symbolMap$7 = {
        1: "\u0AE7",
        2: "\u0AE8",
        3: "\u0AE9",
        4: "\u0AEA",
        5: "\u0AEB",
        6: "\u0AEC",
        7: "\u0AED",
        8: "\u0AEE",
        9: "\u0AEF",
        0: "\u0AE6"
    }, numberMap$6 = {
        "\u0AE7": '1',
        "\u0AE8": '2',
        "\u0AE9": '3',
        "\u0AEA": '4',
        "\u0AEB": '5',
        "\u0AEC": '6',
        "\u0AED": '7',
        "\u0AEE": '8',
        "\u0AEF": '9',
        "\u0AE6": '0'
    };
    moment.defineLocale('gu', {
        months: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0_\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0_\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2_\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE\u0A88_\u0A91\u0A97\u0AB8\u0ACD\u0A9F_\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0A91\u0A95\u0ACD\u0A9F\u0ACD\u0AAC\u0AB0_\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0".split('_'),
        monthsShort: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1._\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1._\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF._\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE._\u0A91\u0A97._\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7._\u0A91\u0A95\u0ACD\u0A9F\u0ACD._\u0AA8\u0AB5\u0AC7._\u0AA1\u0ABF\u0AB8\u0AC7.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0_\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0_\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0_\u0AAC\u0AC1\u0AA7\u0ACD\u0AB5\u0ABE\u0AB0_\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0_\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0".split('_'),
        weekdaysShort: "\u0AB0\u0AB5\u0ABF_\u0AB8\u0ACB\u0AAE_\u0AAE\u0A82\u0A97\u0AB3_\u0AAC\u0AC1\u0AA7\u0ACD_\u0A97\u0AC1\u0AB0\u0AC1_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0_\u0AB6\u0AA8\u0ABF".split('_'),
        weekdaysMin: "\u0AB0_\u0AB8\u0ACB_\u0AAE\u0A82_\u0AAC\u0AC1_\u0A97\u0AC1_\u0AB6\u0AC1_\u0AB6".split('_'),
        longDateFormat: {
            LT: "A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            LTS: "A h:mm:ss \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7"
        },
        calendar: {
            sameDay: "[\u0A86\u0A9C] LT",
            nextDay: "[\u0A95\u0ABE\u0AB2\u0AC7] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0A97\u0A87\u0A95\u0ABE\u0AB2\u0AC7] LT",
            lastWeek: "[\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0AAE\u0ABE",
            past: "%s \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE",
            s: "\u0A85\u0AAE\u0AC1\u0A95 \u0AAA\u0AB3\u0ACB",
            ss: "%d \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
            m: "\u0A8F\u0A95 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
            mm: "%d \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
            h: "\u0A8F\u0A95 \u0A95\u0AB2\u0ABE\u0A95",
            hh: "%d \u0A95\u0AB2\u0ABE\u0A95",
            d: "\u0A8F\u0A95 \u0AA6\u0ABF\u0AB5\u0AB8",
            dd: "%d \u0AA6\u0ABF\u0AB5\u0AB8",
            M: "\u0A8F\u0A95 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
            MM: "%d \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
            y: "\u0A8F\u0A95 \u0AB5\u0AB0\u0ACD\u0AB7",
            yy: "%d \u0AB5\u0AB0\u0ACD\u0AB7"
        },
        preparse: function(string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function(match) {
                return numberMap$6[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$7[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0AB0\u0ABE\u0AA4") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0AB8\u0AB5\u0ABE\u0AB0") return hour;
            else if (meridiem === "\u0AAC\u0AAA\u0ACB\u0AB0") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0AB8\u0ABE\u0A82\u0A9C") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0AB0\u0ABE\u0AA4";
            else if (hour < 10) return "\u0AB8\u0AB5\u0ABE\u0AB0";
            else if (hour < 17) return "\u0AAC\u0AAA\u0ACB\u0AB0";
            else if (hour < 20) return "\u0AB8\u0ABE\u0A82\u0A9C";
            else return "\u0AB0\u0ABE\u0AA4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('he', {
        months: "\u05D9\u05E0\u05D5\u05D0\u05E8_\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05D9\u05DC_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8_\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8_\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8_\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8_\u05D3\u05E6\u05DE\u05D1\u05E8".split('_'),
        monthsShort: "\u05D9\u05E0\u05D5\u05F3_\u05E4\u05D1\u05E8\u05F3_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05F3_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05F3_\u05E1\u05E4\u05D8\u05F3_\u05D0\u05D5\u05E7\u05F3_\u05E0\u05D5\u05D1\u05F3_\u05D3\u05E6\u05DE\u05F3".split('_'),
        weekdays: "\u05E8\u05D0\u05E9\u05D5\u05DF_\u05E9\u05E0\u05D9_\u05E9\u05DC\u05D9\u05E9\u05D9_\u05E8\u05D1\u05D9\u05E2\u05D9_\u05D7\u05DE\u05D9\u05E9\u05D9_\u05E9\u05D9\u05E9\u05D9_\u05E9\u05D1\u05EA".split('_'),
        weekdaysShort: "\u05D0\u05F3_\u05D1\u05F3_\u05D2\u05F3_\u05D3\u05F3_\u05D4\u05F3_\u05D5\u05F3_\u05E9\u05F3".split('_'),
        weekdaysMin: "\u05D0_\u05D1_\u05D2_\u05D3_\u05D4_\u05D5_\u05E9".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: "D [\u05D1]MMMM YYYY",
            LLL: "D [\u05D1]MMMM YYYY HH:mm",
            LLLL: "dddd, D [\u05D1]MMMM YYYY HH:mm",
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u05D4\u05D9\u05D5\u05DD \u05D1\u05BE]LT",
            nextDay: "[\u05DE\u05D7\u05E8 \u05D1\u05BE]LT",
            nextWeek: "dddd [\u05D1\u05E9\u05E2\u05D4] LT",
            lastDay: "[\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05BE]LT",
            lastWeek: "[\u05D1\u05D9\u05D5\u05DD] dddd [\u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05D1\u05E9\u05E2\u05D4] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u05D1\u05E2\u05D5\u05D3 %s",
            past: "\u05DC\u05E4\u05E0\u05D9 %s",
            s: "\u05DE\u05E1\u05E4\u05E8 \u05E9\u05E0\u05D9\u05D5\u05EA",
            ss: "%d \u05E9\u05E0\u05D9\u05D5\u05EA",
            m: "\u05D3\u05E7\u05D4",
            mm: "%d \u05D3\u05E7\u05D5\u05EA",
            h: "\u05E9\u05E2\u05D4",
            hh: function(number) {
                if (number === 2) return "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD";
                return number + " \u05E9\u05E2\u05D5\u05EA";
            },
            d: "\u05D9\u05D5\u05DD",
            dd: function(number) {
                if (number === 2) return "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD";
                return number + " \u05D9\u05DE\u05D9\u05DD";
            },
            M: "\u05D7\u05D5\u05D3\u05E9",
            MM: function(number) {
                if (number === 2) return "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD";
                return number + " \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD";
            },
            y: "\u05E9\u05E0\u05D4",
            yy: function(number) {
                if (number === 2) return "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD";
                else if (number % 10 === 0 && number !== 10) return number + " \u05E9\u05E0\u05D4";
                return number + " \u05E9\u05E0\u05D9\u05DD";
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function(input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 5) return "\u05DC\u05E4\u05E0\u05D5\u05EA \u05D1\u05D5\u05E7\u05E8";
            else if (hour < 10) return "\u05D1\u05D1\u05D5\u05E7\u05E8";
            else if (hour < 12) return isLower ? '\u05DC\u05E4\u05E0\u05D4"\u05E6' : "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
            else if (hour < 18) return isLower ? '\u05D0\u05D7\u05D4"\u05E6' : "\u05D0\u05D7\u05E8\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
            else return "\u05D1\u05E2\u05E8\u05D1";
        }
    });
    //! moment.js locale configuration
    var symbolMap$8 = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$7 = {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }, monthsParse$7 = [
        /^जन/i,
        /^फ़र|फर/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सितं|सित/i,
        /^अक्टू/i,
        /^नव|नवं/i,
        /^दिसं|दिस/i
    ], shortMonthsParse = [
        /^जन/i,
        /^फ़र/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सित/i,
        /^अक्टू/i,
        /^नव/i,
        /^दिस/i
    ];
    moment.defineLocale('hi', {
        months: {
            format: "\u091C\u0928\u0935\u0930\u0940_\u092B\u093C\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u092E\u094D\u092C\u0930_\u0926\u093F\u0938\u092E\u094D\u092C\u0930".split('_'),
            standalone: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u0902\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u0902\u092C\u0930_\u0926\u093F\u0938\u0902\u092C\u0930".split('_')
        },
        monthsShort: "\u091C\u0928._\u092B\u093C\u0930._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948._\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0905\u0917._\u0938\u093F\u0924._\u0905\u0915\u094D\u091F\u0942._\u0928\u0935._\u0926\u093F\u0938.".split('_'),
        weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0932\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split('_'),
        weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0932_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split('_'),
        weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split('_'),
        longDateFormat: {
            LT: "A h:mm \u092C\u091C\u0947",
            LTS: "A h:mm:ss \u092C\u091C\u0947",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u092C\u091C\u0947",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u092C\u091C\u0947"
        },
        monthsParse: monthsParse$7,
        longMonthsParse: monthsParse$7,
        shortMonthsParse: shortMonthsParse,
        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u0915\u0932] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0915\u0932] LT",
            lastWeek: "[\u092A\u093F\u091B\u0932\u0947] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u092E\u0947\u0902",
            past: "%s \u092A\u0939\u0932\u0947",
            s: "\u0915\u0941\u091B \u0939\u0940 \u0915\u094D\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0902\u0921",
            m: "\u090F\u0915 \u092E\u093F\u0928\u091F",
            mm: "%d \u092E\u093F\u0928\u091F",
            h: "\u090F\u0915 \u0918\u0902\u091F\u093E",
            hh: "%d \u0918\u0902\u091F\u0947",
            d: "\u090F\u0915 \u0926\u093F\u0928",
            dd: "%d \u0926\u093F\u0928",
            M: "\u090F\u0915 \u092E\u0939\u0940\u0928\u0947",
            MM: "%d \u092E\u0939\u0940\u0928\u0947",
            y: "\u090F\u0915 \u0935\u0930\u094D\u0937",
            yy: "%d \u0935\u0930\u094D\u0937"
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$7[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$8[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0938\u0941\u092C\u0939") return hour;
            else if (meridiem === "\u0926\u094B\u092A\u0939\u0930") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0936\u093E\u092E") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0930\u093E\u0924";
            else if (hour < 10) return "\u0938\u0941\u092C\u0939";
            else if (hour < 17) return "\u0926\u094B\u092A\u0939\u0930";
            else if (hour < 20) return "\u0936\u093E\u092E";
            else return "\u0930\u093E\u0924";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function translate$3(number, withoutSuffix, key) {
        var result = number + ' ';
        switch(key){
            case 'ss':
                if (number === 1) result += 'sekunda';
                else if (number === 2 || number === 3 || number === 4) result += 'sekunde';
                else result += 'sekundi';
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) result += 'minuta';
                else if (number === 2 || number === 3 || number === 4) result += 'minute';
                else result += 'minuta';
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) result += 'sat';
                else if (number === 2 || number === 3 || number === 4) result += 'sata';
                else result += 'sati';
                return result;
            case 'dd':
                if (number === 1) result += 'dan';
                else result += 'dana';
                return result;
            case 'MM':
                if (number === 1) result += 'mjesec';
                else if (number === 2 || number === 3 || number === 4) result += 'mjeseca';
                else result += 'mjeseci';
                return result;
            case 'yy':
                if (number === 1) result += 'godina';
                else if (number === 2 || number === 3 || number === 4) result += 'godine';
                else result += 'godina';
                return result;
        }
    }
    moment.defineLocale('hr', {
        months: {
            format: "sije\u010Dnja_velja\u010De_o\u017Eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split('_'),
            standalone: "sije\u010Danj_velja\u010Da_o\u017Eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split('_')
        },
        monthsShort: "sij._velj._o\u017Eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split('_'),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split('_'),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split('_'),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: "[ju\u010Der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[pro\u0161lu] [nedjelju] [u] LT";
                    case 3:
                        return "[pro\u0161lu] [srijedu] [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate$3,
            m: translate$3,
            mm: translate$3,
            h: translate$3,
            hh: translate$3,
            d: 'dan',
            dd: translate$3,
            M: 'mjesec',
            MM: translate$3,
            y: 'godinu',
            yy: translate$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var weekEndings = "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(' ');
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch(key){
            case 's':
                return isFuture || withoutSuffix ? "n\xe9h\xe1ny m\xe1sodperc" : "n\xe9h\xe1ny m\xe1sodperce";
            case 'ss':
                return num + (isFuture || withoutSuffix) ? " m\xe1sodperc" : " m\xe1sodperce";
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case 'hh':
                return num + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case 'MM':
                return num + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
            case 'yy':
                return num + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : "[m\xfalt] ") + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }
    moment.defineLocale('hu', {
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split('_'),
        monthsShort: "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split('_'),
        monthsParseExact: true,
        weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split('_'),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower === true ? 'de' : 'DE';
            else return isLower === true ? 'du' : 'DU';
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s m\xfalva",
            past: '%s',
            s: translate$4,
            ss: translate$4,
            m: translate$4,
            mm: translate$4,
            h: translate$4,
            hh: translate$4,
            d: translate$4,
            dd: translate$4,
            M: translate$4,
            MM: translate$4,
            y: translate$4,
            yy: translate$4
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('hy-am', {
        months: {
            format: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580\u056B_\u0583\u0565\u057F\u0580\u057E\u0561\u0580\u056B_\u0574\u0561\u0580\u057F\u056B_\u0561\u057A\u0580\u056B\u056C\u056B_\u0574\u0561\u0575\u056B\u057D\u056B_\u0570\u0578\u0582\u0576\u056B\u057D\u056B_\u0570\u0578\u0582\u056C\u056B\u057D\u056B_\u0585\u0563\u0578\u057D\u057F\u0578\u057D\u056B_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056B_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B".split('_'),
            standalone: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580_\u0583\u0565\u057F\u0580\u057E\u0561\u0580_\u0574\u0561\u0580\u057F_\u0561\u057A\u0580\u056B\u056C_\u0574\u0561\u0575\u056B\u057D_\u0570\u0578\u0582\u0576\u056B\u057D_\u0570\u0578\u0582\u056C\u056B\u057D_\u0585\u0563\u0578\u057D\u057F\u0578\u057D_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580".split('_')
        },
        monthsShort: "\u0570\u0576\u057E_\u0583\u057F\u0580_\u0574\u0580\u057F_\u0561\u057A\u0580_\u0574\u0575\u057D_\u0570\u0576\u057D_\u0570\u056C\u057D_\u0585\u0563\u057D_\u057D\u057A\u057F_\u0570\u056F\u057F_\u0576\u0574\u0562_\u0564\u056F\u057F".split('_'),
        weekdays: "\u056F\u056B\u0580\u0561\u056F\u056B_\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split('_'),
        weekdaysShort: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split('_'),
        weekdaysMin: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: "D MMMM YYYY \u0569.",
            LLL: "D MMMM YYYY \u0569., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0569., HH:mm"
        },
        calendar: {
            sameDay: "[\u0561\u0575\u057D\u0585\u0580] LT",
            nextDay: "[\u057E\u0561\u0572\u0568] LT",
            lastDay: "[\u0565\u0580\u0565\u056F] LT",
            nextWeek: function() {
                return "dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
            },
            lastWeek: function() {
                return "[\u0561\u0576\u0581\u0561\u056E] dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0570\u0565\u057F\u0578",
            past: "%s \u0561\u057C\u0561\u057B",
            s: "\u0574\u056B \u0584\u0561\u0576\u056B \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
            ss: "%d \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
            m: "\u0580\u0578\u057A\u0565",
            mm: "%d \u0580\u0578\u057A\u0565",
            h: "\u056A\u0561\u0574",
            hh: "%d \u056A\u0561\u0574",
            d: "\u0585\u0580",
            dd: "%d \u0585\u0580",
            M: "\u0561\u0574\u056B\u057D",
            MM: "%d \u0561\u0574\u056B\u057D",
            y: "\u057F\u0561\u0580\u056B",
            yy: "%d \u057F\u0561\u0580\u056B"
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function(input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function(hour) {
            if (hour < 4) return "\u0563\u056B\u0577\u0565\u0580\u057E\u0561";
            else if (hour < 12) return "\u0561\u057C\u0561\u057E\u0578\u057F\u057E\u0561";
            else if (hour < 17) return "\u0581\u0565\u0580\u0565\u056F\u057E\u0561";
            else return "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576";
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function(number, period) {
            switch(period){
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) return number + "-\u056B\u0576";
                    return number + "-\u0580\u0564";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'pagi') return hour;
            else if (meridiem === 'siang') return hour >= 11 ? hour : hour + 12;
            else if (meridiem === 'sore' || meridiem === 'malam') return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return 'pagi';
            else if (hours < 15) return 'siang';
            else if (hours < 19) return 'sore';
            else return 'malam';
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function plural$2(n) {
        if (n % 100 === 11) return true;
        else if (n % 10 === 1) return false;
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch(key){
            case 's':
                return withoutSuffix || isFuture ? "nokkrar sek\xfandur" : "nokkrum sek\xfandum";
            case 'ss':
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "sek\xfandur" : "sek\xfandum");
                return result + "sek\xfanda";
            case 'm':
                return withoutSuffix ? "m\xedn\xfata" : "m\xedn\xfatu";
            case 'mm':
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "m\xedn\xfatur" : "m\xedn\xfatum");
                else if (withoutSuffix) return result + "m\xedn\xfata";
                return result + "m\xedn\xfatu";
            case 'hh':
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) return 'dagur';
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural$2(number)) {
                    if (withoutSuffix) return result + 'dagar';
                    return result + (isFuture ? 'daga' : "d\xf6gum");
                } else if (withoutSuffix) return result + 'dagur';
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) return "m\xe1nu\xf0ur";
                return isFuture ? "m\xe1nu\xf0" : "m\xe1nu\xf0i";
            case 'MM':
                if (plural$2(number)) {
                    if (withoutSuffix) return result + "m\xe1nu\xf0ir";
                    return result + (isFuture ? "m\xe1nu\xf0i" : "m\xe1nu\xf0um");
                } else if (withoutSuffix) return result + "m\xe1nu\xf0ur";
                return result + (isFuture ? "m\xe1nu\xf0" : "m\xe1nu\xf0i");
            case 'y':
                return withoutSuffix || isFuture ? "\xe1r" : "\xe1ri";
            case 'yy':
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "\xe1r" : "\xe1rum");
                return result + (withoutSuffix || isFuture ? "\xe1r" : "\xe1ri");
        }
    }
    moment.defineLocale('is', {
        months: "jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split('_'),
        monthsShort: "jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split('_'),
        weekdays: "sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split('_'),
        weekdaysShort: "sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split('_'),
        weekdaysMin: "Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar: {
            sameDay: "[\xed dag kl.] LT",
            nextDay: "[\xe1 morgun kl.] LT",
            nextWeek: 'dddd [kl.] LT',
            lastDay: "[\xed g\xe6r kl.] LT",
            lastWeek: "[s\xed\xf0asta] dddd [kl.] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'eftir %s',
            past: "fyrir %s s\xed\xf0an",
            s: translate$5,
            ss: translate$5,
            m: translate$5,
            mm: translate$5,
            h: 'klukkustund',
            hh: translate$5,
            d: translate$5,
            dd: translate$5,
            M: translate$5,
            MM: translate$5,
            y: translate$5,
            yy: translate$5
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function(s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: function() {
                return '[Oggi a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextDay: function() {
                return '[Domani a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextWeek: function() {
                return 'dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastDay: function() {
                return '[Ieri a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[La scorsa] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                    default:
                        return '[Lo scorso] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: "\u4EE4\u548C",
                narrow: "\u32FF",
                abbr: 'R'
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: "\u5E73\u6210",
                narrow: "\u337B",
                abbr: 'H'
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: "\u662D\u548C",
                narrow: "\u337C",
                abbr: 'S'
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: "\u5927\u6B63",
                narrow: "\u337D",
                abbr: 'T'
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: "\u660E\u6CBB",
                narrow: "\u337E",
                abbr: 'M'
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: "\u897F\u66A6",
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: "\u7D00\u5143\u524D",
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function(input, match) {
            return match[1] === "\u5143" ? 1 : parseInt(match[1] || input, 10);
        },
        months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u65E5\u66DC\u65E5_\u6708\u66DC\u65E5_\u706B\u66DC\u65E5_\u6C34\u66DC\u65E5_\u6728\u66DC\u65E5_\u91D1\u66DC\u65E5_\u571F\u66DC\u65E5".split('_'),
        weekdaysShort: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split('_'),
        weekdaysMin: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5 dddd HH:mm",
            l: 'YYYY/MM/DD',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5(ddd) HH:mm"
        },
        meridiemParse: /午前|午後/i,
        isPM: function(input) {
            return input === "\u5348\u5F8C";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u5348\u524D";
            else return "\u5348\u5F8C";
        },
        calendar: {
            sameDay: "[\u4ECA\u65E5] LT",
            nextDay: "[\u660E\u65E5] LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) return "[\u6765\u9031]dddd LT";
                else return 'dddd LT';
            },
            lastDay: "[\u6628\u65E5] LT",
            lastWeek: function(now) {
                if (this.week() !== now.week()) return "[\u5148\u9031]dddd LT";
                else return 'dddd LT';
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function(number, period) {
            switch(period){
                case 'y':
                    return number === 1 ? "\u5143\u5E74" : number + "\u5E74";
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u6570\u79D2",
            ss: "%d\u79D2",
            m: "1\u5206",
            mm: "%d\u5206",
            h: "1\u6642\u9593",
            hh: "%d\u6642\u9593",
            d: "1\u65E5",
            dd: "%d\u65E5",
            M: "1\u30F6\u6708",
            MM: "%d\u30F6\u6708",
            y: "1\u5E74",
            yy: "%d\u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'enjing') return hour;
            else if (meridiem === 'siyang') return hour >= 11 ? hour : hour + 12;
            else if (meridiem === 'sonten' || meridiem === 'ndalu') return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return 'enjing';
            else if (hours < 15) return 'siyang';
            else if (hours < 19) return 'sonten';
            else return 'ndalu';
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ka', {
        months: "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8_\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8_\u10DB\u10D0\u10E0\u10E2\u10D8_\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8_\u10DB\u10D0\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8_\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD_\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8".split('_'),
        monthsShort: "\u10D8\u10D0\u10DC_\u10D7\u10D4\u10D1_\u10DB\u10D0\u10E0_\u10D0\u10DE\u10E0_\u10DB\u10D0\u10D8_\u10D8\u10D5\u10DC_\u10D8\u10D5\u10DA_\u10D0\u10D2\u10D5_\u10E1\u10D4\u10E5_\u10DD\u10E5\u10E2_\u10DC\u10DD\u10D4_\u10D3\u10D4\u10D9".split('_'),
        weekdays: {
            standalone: "\u10D9\u10D5\u10D8\u10E0\u10D0_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8_\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8".split('_'),
            format: "\u10D9\u10D5\u10D8\u10E0\u10D0\u10E1_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10E1_\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1".split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: "\u10D9\u10D5\u10D8_\u10DD\u10E0\u10E8_\u10E1\u10D0\u10DB_\u10DD\u10D7\u10EE_\u10EE\u10E3\u10D7_\u10DE\u10D0\u10E0_\u10E8\u10D0\u10D1".split('_'),
        weekdaysMin: "\u10D9\u10D5_\u10DD\u10E0_\u10E1\u10D0_\u10DD\u10D7_\u10EE\u10E3_\u10DE\u10D0_\u10E8\u10D0".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u10D3\u10E6\u10D4\u10E1] LT[-\u10D6\u10D4]",
            nextDay: "[\u10EE\u10D5\u10D0\u10DA] LT[-\u10D6\u10D4]",
            lastDay: "[\u10D2\u10E3\u10E8\u10D8\u10DC] LT[-\u10D6\u10D4]",
            nextWeek: "[\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2] dddd LT[-\u10D6\u10D4]",
            lastWeek: "[\u10EC\u10D8\u10DC\u10D0] dddd LT-\u10D6\u10D4",
            sameElse: 'L'
        },
        relativeTime: {
            future: function(s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function($0, $1, $2) {
                    return $2 === "\u10D8" ? $1 + "\u10E8\u10D8" : $1 + $2 + "\u10E8\u10D8";
                });
            },
            past: function(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) return s.replace(/(ი|ე)$/, "\u10D8\u10E1 \u10EC\u10D8\u10DC");
                if (/წელი/.test(s)) return s.replace(/წელი$/, "\u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC");
                return s;
            },
            s: "\u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10EC\u10D0\u10DB\u10D8",
            ss: "%d \u10EC\u10D0\u10DB\u10D8",
            m: "\u10EC\u10E3\u10D7\u10D8",
            mm: "%d \u10EC\u10E3\u10D7\u10D8",
            h: "\u10E1\u10D0\u10D0\u10D7\u10D8",
            hh: "%d \u10E1\u10D0\u10D0\u10D7\u10D8",
            d: "\u10D3\u10E6\u10D4",
            dd: "%d \u10D3\u10E6\u10D4",
            M: "\u10D7\u10D5\u10D4",
            MM: "%d \u10D7\u10D5\u10D4",
            y: "\u10EC\u10D4\u10DA\u10D8",
            yy: "%d \u10EC\u10D4\u10DA\u10D8"
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function(number) {
            if (number === 0) return number;
            if (number === 1) return number + "-\u10DA\u10D8";
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) return "\u10DB\u10D4-" + number;
            return number + "-\u10D4";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var suffixes$1 = {
        0: "-\u0448\u0456",
        1: "-\u0448\u0456",
        2: "-\u0448\u0456",
        3: "-\u0448\u0456",
        4: "-\u0448\u0456",
        5: "-\u0448\u0456",
        6: "-\u0448\u044B",
        7: "-\u0448\u0456",
        8: "-\u0448\u0456",
        9: "-\u0448\u044B",
        10: "-\u0448\u044B",
        20: "-\u0448\u044B",
        30: "-\u0448\u044B",
        40: "-\u0448\u044B",
        50: "-\u0448\u0456",
        60: "-\u0448\u044B",
        70: "-\u0448\u0456",
        80: "-\u0448\u0456",
        90: "-\u0448\u044B",
        100: "-\u0448\u0456"
    };
    moment.defineLocale('kk', {
        months: "\u049B\u0430\u04A3\u0442\u0430\u0440_\u0430\u049B\u043F\u0430\u043D_\u043D\u0430\u0443\u0440\u044B\u0437_\u0441\u04D9\u0443\u0456\u0440_\u043C\u0430\u043C\u044B\u0440_\u043C\u0430\u0443\u0441\u044B\u043C_\u0448\u0456\u043B\u0434\u0435_\u0442\u0430\u043C\u044B\u0437_\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A_\u049B\u0430\u0437\u0430\u043D_\u049B\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D".split('_'),
        monthsShort: "\u049B\u0430\u04A3_\u0430\u049B\u043F_\u043D\u0430\u0443_\u0441\u04D9\u0443_\u043C\u0430\u043C_\u043C\u0430\u0443_\u0448\u0456\u043B_\u0442\u0430\u043C_\u049B\u044B\u0440_\u049B\u0430\u0437_\u049B\u0430\u0440_\u0436\u0435\u043B".split('_'),
        weekdays: "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456_\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0436\u04B1\u043C\u0430_\u0441\u0435\u043D\u0431\u0456".split('_'),
        weekdaysShort: "\u0436\u0435\u043A_\u0434\u04AF\u0439_\u0441\u0435\u0439_\u0441\u04D9\u0440_\u0431\u0435\u0439_\u0436\u04B1\u043C_\u0441\u0435\u043D".split('_'),
        weekdaysMin: "\u0436\u043A_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043C_\u0441\u043D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0411\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442] LT",
            nextDay: "[\u0415\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            lastDay: "[\u041A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
            lastWeek: "[\u04E8\u0442\u043A\u0435\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u04A3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0456\u0448\u0456\u043D\u0434\u0435",
            past: "%s \u0431\u04B1\u0440\u044B\u043D",
            s: "\u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
            m: "\u0431\u0456\u0440 \u043C\u0438\u043D\u0443\u0442",
            mm: "%d \u043C\u0438\u043D\u0443\u0442",
            h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
            hh: "%d \u0441\u0430\u0493\u0430\u0442",
            d: "\u0431\u0456\u0440 \u043A\u04AF\u043D",
            dd: "%d \u043A\u04AF\u043D",
            M: "\u0431\u0456\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0456\u0440 \u0436\u044B\u043B",
            yy: "%d \u0436\u044B\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$9 = {
        1: "\u17E1",
        2: "\u17E2",
        3: "\u17E3",
        4: "\u17E4",
        5: "\u17E5",
        6: "\u17E6",
        7: "\u17E7",
        8: "\u17E8",
        9: "\u17E9",
        0: "\u17E0"
    }, numberMap$8 = {
        "\u17E1": '1',
        "\u17E2": '2',
        "\u17E3": '3',
        "\u17E4": '4',
        "\u17E5": '5',
        "\u17E6": '6',
        "\u17E7": '7',
        "\u17E8": '8',
        "\u17E9": '9',
        "\u17E0": '0'
    };
    moment.defineLocale('km', {
        months: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split('_'),
        monthsShort: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split('_'),
        weekdays: "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799_\u1785\u17D0\u1793\u17D2\u1791_\u17A2\u1784\u17D2\u1782\u17B6\u179A_\u1796\u17BB\u1792_\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD_\u179F\u17BB\u1780\u17D2\u179A_\u179F\u17C5\u179A\u17CD".split('_'),
        weekdaysShort: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split('_'),
        weekdaysMin: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function(input) {
            return input === "\u179B\u17D2\u1784\u17B6\u1785";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u1796\u17D2\u179A\u17B9\u1780";
            else return "\u179B\u17D2\u1784\u17B6\u1785";
        },
        calendar: {
            sameDay: "[\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7 \u1798\u17C9\u17C4\u1784] LT",
            nextDay: "[\u179F\u17D2\u17A2\u17C2\u1780 \u1798\u17C9\u17C4\u1784] LT",
            nextWeek: "dddd [\u1798\u17C9\u17C4\u1784] LT",
            lastDay: "[\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789 \u1798\u17C9\u17C4\u1784] LT",
            lastWeek: "dddd [\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD\u1798\u17BB\u1793] [\u1798\u17C9\u17C4\u1784] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s\u1791\u17C0\u178F",
            past: "%s\u1798\u17BB\u1793",
            s: "\u1794\u17C9\u17BB\u1793\u17D2\u1798\u17B6\u1793\u179C\u17B7\u1793\u17B6\u1791\u17B8",
            ss: "%d \u179C\u17B7\u1793\u17B6\u1791\u17B8",
            m: "\u1798\u17BD\u1799\u1793\u17B6\u1791\u17B8",
            mm: "%d \u1793\u17B6\u1791\u17B8",
            h: "\u1798\u17BD\u1799\u1798\u17C9\u17C4\u1784",
            hh: "%d \u1798\u17C9\u17C4\u1784",
            d: "\u1798\u17BD\u1799\u1790\u17D2\u1784\u17C3",
            dd: "%d \u1790\u17D2\u1784\u17C3",
            M: "\u1798\u17BD\u1799\u1781\u17C2",
            MM: "%d \u1781\u17C2",
            y: "\u1798\u17BD\u1799\u1786\u17D2\u1793\u17B6\u17C6",
            yy: "%d \u1786\u17D2\u1793\u17B6\u17C6"
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: "\u1791\u17B8%d",
        preparse: function(string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function(match) {
                return numberMap$8[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$9[match];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$a = {
        1: "\u0CE7",
        2: "\u0CE8",
        3: "\u0CE9",
        4: "\u0CEA",
        5: "\u0CEB",
        6: "\u0CEC",
        7: "\u0CED",
        8: "\u0CEE",
        9: "\u0CEF",
        0: "\u0CE6"
    }, numberMap$9 = {
        "\u0CE7": '1',
        "\u0CE8": '2',
        "\u0CE9": '3',
        "\u0CEA": '4',
        "\u0CEB": '5',
        "\u0CEC": '6',
        "\u0CED": '7',
        "\u0CEE": '8',
        "\u0CEF": '9',
        "\u0CE6": '0'
    };
    moment.defineLocale('kn', {
        months: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5\u0CAC\u0CB0\u0CCD_\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD".split('_'),
        monthsShort: "\u0C9C\u0CA8_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5_\u0CA8\u0CB5\u0CC6\u0C82_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82".split('_'),
        monthsParseExact: true,
        weekdays: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE\u0CB5\u0CBE\u0CB0_\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0_\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0_\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0_\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0".split('_'),
        weekdaysShort: "\u0CAD\u0CBE\u0CA8\u0CC1_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE_\u0CAE\u0C82\u0C97\u0CB3_\u0CAC\u0CC1\u0CA7_\u0C97\u0CC1\u0CB0\u0CC1_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0_\u0CB6\u0CA8\u0CBF".split('_'),
        weekdaysMin: "\u0CAD\u0CBE_\u0CB8\u0CC6\u0CC2\u0CD5_\u0CAE\u0C82_\u0CAC\u0CC1_\u0C97\u0CC1_\u0CB6\u0CC1_\u0CB6".split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: "[\u0C87\u0C82\u0CA6\u0CC1] LT",
            nextDay: "[\u0CA8\u0CBE\u0CB3\u0CC6] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6] LT",
            lastWeek: "[\u0C95\u0CC6\u0CC2\u0CA8\u0CC6\u0CAF] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0CA8\u0C82\u0CA4\u0CB0",
            past: "%s \u0CB9\u0CBF\u0C82\u0CA6\u0CC6",
            s: "\u0C95\u0CC6\u0CB2\u0CB5\u0CC1 \u0C95\u0CCD\u0CB7\u0CA3\u0C97\u0CB3\u0CC1",
            ss: "%d \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            m: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            mm: "%d \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            h: "\u0C92\u0C82\u0CA6\u0CC1 \u0C97\u0C82\u0C9F\u0CC6",
            hh: "%d \u0C97\u0C82\u0C9F\u0CC6",
            d: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA6\u0CBF\u0CA8",
            dd: "%d \u0CA6\u0CBF\u0CA8",
            M: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            MM: "%d \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            y: "\u0C92\u0C82\u0CA6\u0CC1 \u0CB5\u0CB0\u0CCD\u0CB7",
            yy: "%d \u0CB5\u0CB0\u0CCD\u0CB7"
        },
        preparse: function(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function(match) {
                return numberMap$9[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$a[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6") return hour;
            else if (meridiem === "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0CB8\u0C82\u0C9C\u0CC6") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
            else if (hour < 10) return "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6";
            else if (hour < 17) return "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8";
            else if (hour < 20) return "\u0CB8\u0C82\u0C9C\u0CC6";
            else return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function(number) {
            return number + "\u0CA8\u0CC6\u0CD5";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ko', {
        months: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split('_'),
        monthsShort: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split('_'),
        weekdays: "\uC77C\uC694\uC77C_\uC6D4\uC694\uC77C_\uD654\uC694\uC77C_\uC218\uC694\uC77C_\uBAA9\uC694\uC77C_\uAE08\uC694\uC77C_\uD1A0\uC694\uC77C".split('_'),
        weekdaysShort: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split('_'),
        weekdaysMin: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: "YYYY\uB144 MMMM D\uC77C",
            LLL: "YYYY\uB144 MMMM D\uC77C A h:mm",
            LLLL: "YYYY\uB144 MMMM D\uC77C dddd A h:mm",
            l: 'YYYY.MM.DD.',
            ll: "YYYY\uB144 MMMM D\uC77C",
            lll: "YYYY\uB144 MMMM D\uC77C A h:mm",
            llll: "YYYY\uB144 MMMM D\uC77C dddd A h:mm"
        },
        calendar: {
            sameDay: "\uC624\uB298 LT",
            nextDay: "\uB0B4\uC77C LT",
            nextWeek: 'dddd LT',
            lastDay: "\uC5B4\uC81C LT",
            lastWeek: "\uC9C0\uB09C\uC8FC dddd LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \uD6C4",
            past: "%s \uC804",
            s: "\uBA87 \uCD08",
            ss: "%d\uCD08",
            m: "1\uBD84",
            mm: "%d\uBD84",
            h: "\uD55C \uC2DC\uAC04",
            hh: "%d\uC2DC\uAC04",
            d: "\uD558\uB8E8",
            dd: "%d\uC77C",
            M: "\uD55C \uB2EC",
            MM: "%d\uB2EC",
            y: "\uC77C \uB144",
            yy: "%d\uB144"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\uC77C";
                case 'M':
                    return number + "\uC6D4";
                case 'w':
                case 'W':
                    return number + "\uC8FC";
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function(token) {
            return token === "\uC624\uD6C4";
        },
        meridiem: function(hour, minute, isUpper) {
            return hour < 12 ? "\uC624\uC804" : "\uC624\uD6C4";
        }
    });
    //! moment.js locale configuration
    var symbolMap$b = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap$a = {
        "\u0661": '1',
        "\u0662": '2',
        "\u0663": '3',
        "\u0664": '4',
        "\u0665": '5',
        "\u0666": '6',
        "\u0667": '7',
        "\u0668": '8',
        "\u0669": '9',
        "\u0660": '0'
    }, months$7 = [
        "\u06A9\u0627\u0646\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0634\u0648\u0628\u0627\u062A",
        "\u0626\u0627\u0632\u0627\u0631",
        "\u0646\u06CC\u0633\u0627\u0646",
        "\u0626\u0627\u06CC\u0627\u0631",
        "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
        "\u062A\u06D5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u06CC\u0644\u0648\u0648\u0644",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u0643\u06D5\u0645",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0643\u0627\u0646\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
    ];
    moment.defineLocale('ku', {
        months: months$7,
        monthsShort: months$7,
        weekdays: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u062F\u0648\u0648\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0633\u06CE\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split('_'),
        weekdaysShort: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645_\u062F\u0648\u0648\u0634\u0647\u200C\u0645_\u0633\u06CE\u0634\u0647\u200C\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split('_'),
        weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u0647_\u0634".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function(input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC";
            else return "\u0626\u06CE\u0648\u0627\u0631\u0647\u200C";
        },
        calendar: {
            sameDay: "[\u0626\u0647\u200C\u0645\u0631\u06C6 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            nextDay: "[\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            nextWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            lastDay: "[\u062F\u0648\u06CE\u0646\u06CE \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            lastWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0644\u0647\u200C %s",
            past: '%s',
            s: "\u0686\u0647\u200C\u0646\u062F \u0686\u0631\u0643\u0647\u200C\u06CC\u0647\u200C\u0643",
            ss: "\u0686\u0631\u0643\u0647\u200C %d",
            m: "\u06CC\u0647\u200C\u0643 \u062E\u0648\u0644\u0647\u200C\u0643",
            mm: "%d \u062E\u0648\u0644\u0647\u200C\u0643",
            h: "\u06CC\u0647\u200C\u0643 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
            hh: "%d \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
            d: "\u06CC\u0647\u200C\u0643 \u0695\u06C6\u0698",
            dd: "%d \u0695\u06C6\u0698",
            M: "\u06CC\u0647\u200C\u0643 \u0645\u0627\u0646\u06AF",
            MM: "%d \u0645\u0627\u0646\u06AF",
            y: "\u06CC\u0647\u200C\u0643 \u0633\u0627\u06B5",
            yy: "%d \u0633\u0627\u06B5"
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap$a[match];
            }).replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$b[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var suffixes$2 = {
        0: "-\u0447\u04AF",
        1: "-\u0447\u0438",
        2: "-\u0447\u0438",
        3: "-\u0447\u04AF",
        4: "-\u0447\u04AF",
        5: "-\u0447\u0438",
        6: "-\u0447\u044B",
        7: "-\u0447\u0438",
        8: "-\u0447\u0438",
        9: "-\u0447\u0443",
        10: "-\u0447\u0443",
        20: "-\u0447\u044B",
        30: "-\u0447\u0443",
        40: "-\u0447\u044B",
        50: "-\u0447\u04AF",
        60: "-\u0447\u044B",
        70: "-\u0447\u0438",
        80: "-\u0447\u0438",
        90: "-\u0447\u0443",
        100: "-\u0447\u04AF"
    };
    moment.defineLocale('ky', {
        months: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split('_'),
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split('_'),
        weekdays: "\u0416\u0435\u043A\u0448\u0435\u043C\u0431\u0438_\u0414\u04AF\u0439\u0448\u04E9\u043C\u0431\u04AF_\u0428\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043C\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0416\u0443\u043C\u0430_\u0418\u0448\u0435\u043C\u0431\u0438".split('_'),
        weekdaysShort: "\u0416\u0435\u043A_\u0414\u04AF\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043C_\u0418\u0448\u0435".split('_'),
        weekdaysMin: "\u0416\u043A_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043C_\u0418\u0448".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0411\u04AF\u0433\u04AF\u043D \u0441\u0430\u0430\u0442] LT",
            nextDay: "[\u042D\u0440\u0442\u0435\u04A3 \u0441\u0430\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
            lastDay: "[\u041A\u0435\u0447\u044D\u044D \u0441\u0430\u0430\u0442] LT",
            lastWeek: "[\u04E8\u0442\u043A\u04E9\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u043D] dddd [\u043A\u04AF\u043D\u04AF] [\u0441\u0430\u0430\u0442] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0438\u0447\u0438\u043D\u0434\u0435",
            past: "%s \u043C\u0443\u0440\u0443\u043D",
            s: "\u0431\u0438\u0440\u043D\u0435\u0447\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
            m: "\u0431\u0438\u0440 \u043C\u04AF\u043D\u04E9\u0442",
            mm: "%d \u043C\u04AF\u043D\u04E9\u0442",
            h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
            hh: "%d \u0441\u0430\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043A\u04AF\u043D",
            dd: "%d \u043A\u04AF\u043D",
            M: "\u0431\u0438\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0438\u0440 \u0436\u044B\u043B",
            yy: "%d \u0436\u044B\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                'eng Minutt',
                'enger Minutt'
            ],
            h: [
                'eng Stonn',
                'enger Stonn'
            ],
            d: [
                'een Dag',
                'engem Dag'
            ],
            M: [
                'ee Mount',
                'engem Mount'
            ],
            y: [
                'ee Joer',
                'engem Joer'
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) return 'a ' + string;
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) return 'viru ' + string;
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */ function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) return false;
        if (number < 0) // Negative Number --> always true
        return true;
        else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) return true;
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) return eifelerRegelAppliesToNumber(firstDigit);
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while(number >= 10)number = number / 10;
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }
    moment.defineLocale('lb', {
        months: "Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split('_'),
        weekdaysShort: "So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split('_'),
        weekdaysMin: "So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: "[G\xebschter um] LT",
            lastWeek: function() {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch(this.day()){
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime$6,
            mm: '%d Minutten',
            h: processRelativeTime$6,
            hh: '%d Stonnen',
            d: processRelativeTime$6,
            dd: '%d Deeg',
            M: processRelativeTime$6,
            MM: "%d M\xe9int",
            y: processRelativeTime$6,
            yy: '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('lo', {
        months: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split('_'),
        monthsShort: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split('_'),
        weekdays: "\u0EAD\u0EB2\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split('_'),
        weekdaysShort: "\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split('_'),
        weekdaysMin: "\u0E97_\u0E88_\u0EAD\u0E84_\u0E9E_\u0E9E\u0EAB_\u0EAA\u0E81_\u0EAA".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: "\u0EA7\u0EB1\u0E99dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function(input) {
            return input === "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0E95\u0EAD\u0E99\u0EC0\u0E8A\u0EBB\u0EC9\u0EB2";
            else return "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
        },
        calendar: {
            sameDay: "[\u0EA1\u0EB7\u0EC9\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            nextDay: "[\u0EA1\u0EB7\u0EC9\u0EAD\u0EB7\u0EC8\u0E99\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            nextWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EDC\u0EC9\u0EB2\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            lastDay: "[\u0EA1\u0EB7\u0EC9\u0EA7\u0EB2\u0E99\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            lastWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EC1\u0EA5\u0EC9\u0EA7\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0EAD\u0EB5\u0E81 %s",
            past: "%s\u0E9C\u0EC8\u0EB2\u0E99\u0EA1\u0EB2",
            s: "\u0E9A\u0ECD\u0EC8\u0EC0\u0E97\u0EBB\u0EC8\u0EB2\u0EC3\u0E94\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
            ss: "%d \u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
            m: "1 \u0E99\u0EB2\u0E97\u0EB5",
            mm: "%d \u0E99\u0EB2\u0E97\u0EB5",
            h: "1 \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
            hh: "%d \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
            d: "1 \u0EA1\u0EB7\u0EC9",
            dd: "%d \u0EA1\u0EB7\u0EC9",
            M: "1 \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
            MM: "%d \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
            y: "1 \u0E9B\u0EB5",
            yy: "%d \u0E9B\u0EB5"
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function(number) {
            return "\u0E97\u0EB5\u0EC8" + number;
        }
    });
    //! moment.js locale configuration
    var units = {
        ss: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
        m: "minut\u0117_minut\u0117s_minut\u0119",
        mm: "minut\u0117s_minu\u010Di\u0173_minutes",
        h: "valanda_valandos_valand\u0105",
        hh: "valandos_valand\u0173_valandas",
        d: "diena_dienos_dien\u0105",
        dd: "dienos_dien\u0173_dienas",
        M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
        MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
        y: "metai_met\u0173_metus",
        yy: "metai_met\u0173_metus"
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) return "kelios sekund\u0117s";
        else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        else if (withoutSuffix) return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        else {
            if (isFuture) return result + forms(key)[1];
            else return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
    moment.defineLocale('lt', {
        months: {
            format: "sausio_vasario_kovo_baland\u017Eio_gegu\u017E\u0117s_bir\u017Eelio_liepos_rugpj\u016B\u010Dio_rugs\u0117jo_spalio_lapkri\u010Dio_gruod\u017Eio".split('_'),
            standalone: "sausis_vasaris_kovas_balandis_gegu\u017E\u0117_bir\u017Eelis_liepa_rugpj\u016Btis_rugs\u0117jis_spalis_lapkritis_gruodis".split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: "sekmadien\u012F_pirmadien\u012F_antradien\u012F_tre\u010Diadien\u012F_ketvirtadien\u012F_penktadien\u012F_\u0161e\u0161tadien\u012F".split('_'),
            standalone: "sekmadienis_pirmadienis_antradienis_tre\u010Diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split('_'),
        weekdaysMin: "S_P_A_T_K_Pn_\u0160".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar: {
            sameDay: "[\u0160iandien] LT",
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: "[Pra\u0117jus\u012F] dddd LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'po %s',
            past: "prie\u0161 %s",
            s: translateSeconds,
            ss: translate$6,
            m: translateSingular,
            mm: translate$6,
            h: translateSingular,
            hh: translate$6,
            d: translateSingular,
            dd: translate$6,
            M: translateSingular,
            MM: translate$6,
            y: translateSingular,
            yy: translate$6
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function(number) {
            return number + '-oji';
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var units$1 = {
        ss: "sekundes_sekund\u0113m_sekunde_sekundes".split('_'),
        m: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split('_'),
        mm: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split('_'),
        h: "stundas_stund\u0101m_stunda_stundas".split('_'),
        hh: "stundas_stund\u0101m_stunda_stundas".split('_'),
        d: "dienas_dien\u0101m_diena_dienas".split('_'),
        dd: "dienas_dien\u0101m_diena_dienas".split('_'),
        M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split('_'),
        MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */ function format(forms, number, withoutSuffix) {
        if (withoutSuffix) // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        else // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + ' ' + format(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? "da\u017Eas sekundes" : "da\u017E\u0101m sekund\u0113m";
    }
    moment.defineLocale('lv', {
        months: "janv\u0101ris_febru\u0101ris_marts_apr\u012Blis_maijs_j\u016Bnijs_j\u016Blijs_augusts_septembris_oktobris_novembris_decembris".split('_'),
        monthsShort: "jan_feb_mar_apr_mai_j\u016Bn_j\u016Bl_aug_sep_okt_nov_dec".split('_'),
        weekdays: "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split('_'),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar: {
            sameDay: "[\u0160odien pulksten] LT",
            nextDay: "[R\u012Bt pulksten] LT",
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "p\u0113c %s",
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural$1,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural$1,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural$1,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural$1,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural$1,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var translator = {
        words: {
            //Different grammatical cases
            ss: [
                'sekund',
                'sekunda',
                'sekundi'
            ],
            m: [
                'jedan minut',
                'jednog minuta'
            ],
            mm: [
                'minut',
                'minuta',
                'minuta'
            ],
            h: [
                'jedan sat',
                'jednog sata'
            ],
            hh: [
                'sat',
                'sata',
                'sati'
            ],
            dd: [
                'dan',
                'dana',
                'dana'
            ],
            MM: [
                'mjesec',
                'mjeseca',
                'mjeseci'
            ],
            yy: [
                'godina',
                'godine',
                'godina'
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) return withoutSuffix ? wordKey[0] : wordKey[1];
            else return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    };
    moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split('_'),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split('_'),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: "[ju\u010De u] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[pro\u0161le] [nedjelje] [u] LT",
                    "[pro\u0161log] [ponedjeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srijede] [u] LT",
                    "[pro\u0161log] [\u010Detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('mi', {
        months: "Kohi-t\u0101te_Hui-tanguru_Pout\u016B-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014Dngoingoi_Here-turi-k\u014Dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split('_'),
        monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014Dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: "R\u0101tapu_Mane_T\u016Brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split('_'),
        weekdaysShort: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split('_'),
        weekdaysMin: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: "te h\u0113kona ruarua",
            ss: "%d h\u0113kona",
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('mk', {
        months: "\u0458\u0430\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D\u0438_\u0458\u0443\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split('_'),
        monthsShort: "\u0458\u0430\u043D_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split('_'),
        weekdays: "\u043D\u0435\u0434\u0435\u043B\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A_\u043F\u0435\u0442\u043E\u043A_\u0441\u0430\u0431\u043E\u0442\u0430".split('_'),
        weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u0430\u0431".split('_'),
        weekdaysMin: "\u043De_\u043Fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441a".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: "[\u0414\u0435\u043D\u0435\u0441 \u0432\u043E] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043E] LT",
            nextWeek: "[\u0412\u043E] dddd [\u0432\u043E] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043E] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043E] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442] dddd [\u0432\u043E] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043F\u0440\u0435\u0434 %s",
            s: "\u043D\u0435\u043A\u043E\u043B\u043A\u0443 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            m: "\u0435\u0434\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
            mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
            h: "\u0435\u0434\u0435\u043D \u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0435\u0434\u0435\u043D \u0434\u0435\u043D",
            dd: "%d \u0434\u0435\u043D\u0430",
            M: "\u0435\u0434\u0435\u043D \u043C\u0435\u0441\u0435\u0446",
            MM: "%d \u043C\u0435\u0441\u0435\u0446\u0438",
            y: "\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
            yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function(number) {
            var lastDigit = number % 10, last2Digits = number % 100;
            if (number === 0) return number + "-\u0435\u0432";
            else if (last2Digits === 0) return number + "-\u0435\u043D";
            else if (last2Digits > 10 && last2Digits < 20) return number + "-\u0442\u0438";
            else if (lastDigit === 1) return number + "-\u0432\u0438";
            else if (lastDigit === 2) return number + "-\u0440\u0438";
            else if (lastDigit === 7 || lastDigit === 8) return number + "-\u043C\u0438";
            else return number + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ml', {
        months: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F_\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F_\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D_\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D_\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48_\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D_\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C_\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C_\u0D28\u0D35\u0D02\u0D2C\u0D7C_\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C".split('_'),
        monthsShort: "\u0D1C\u0D28\u0D41._\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41._\u0D2E\u0D3E\u0D7C._\u0D0F\u0D2A\u0D4D\u0D30\u0D3F._\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48._\u0D13\u0D17._\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31._\u0D12\u0D15\u0D4D\u0D1F\u0D4B._\u0D28\u0D35\u0D02._\u0D21\u0D3F\u0D38\u0D02.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A_\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A_\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A_\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A".split('_'),
        weekdaysShort: "\u0D1E\u0D3E\u0D2F\u0D7C_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D7E_\u0D1A\u0D4A\u0D35\u0D4D\u0D35_\u0D2C\u0D41\u0D27\u0D7B_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D02_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F_\u0D36\u0D28\u0D3F".split('_'),
        weekdaysMin: "\u0D1E\u0D3E_\u0D24\u0D3F_\u0D1A\u0D4A_\u0D2C\u0D41_\u0D35\u0D4D\u0D2F\u0D3E_\u0D35\u0D46_\u0D36".split('_'),
        longDateFormat: {
            LT: "A h:mm -\u0D28\u0D41",
            LTS: "A h:mm:ss -\u0D28\u0D41",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm -\u0D28\u0D41",
            LLLL: "dddd, D MMMM YYYY, A h:mm -\u0D28\u0D41"
        },
        calendar: {
            sameDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D4D] LT",
            nextDay: "[\u0D28\u0D3E\u0D33\u0D46] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D32\u0D46] LT",
            lastWeek: "[\u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D",
            past: "%s \u0D2E\u0D41\u0D7B\u0D2A\u0D4D",
            s: "\u0D05\u0D7D\u0D2A \u0D28\u0D3F\u0D2E\u0D3F\u0D37\u0D19\u0D4D\u0D19\u0D7E",
            ss: "%d \u0D38\u0D46\u0D15\u0D4D\u0D15\u0D7B\u0D21\u0D4D",
            m: "\u0D12\u0D30\u0D41 \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
            mm: "%d \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
            h: "\u0D12\u0D30\u0D41 \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
            hh: "%d \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
            d: "\u0D12\u0D30\u0D41 \u0D26\u0D3F\u0D35\u0D38\u0D02",
            dd: "%d \u0D26\u0D3F\u0D35\u0D38\u0D02",
            M: "\u0D12\u0D30\u0D41 \u0D2E\u0D3E\u0D38\u0D02",
            MM: "%d \u0D2E\u0D3E\u0D38\u0D02",
            y: "\u0D12\u0D30\u0D41 \u0D35\u0D7C\u0D37\u0D02",
            yy: "%d \u0D35\u0D7C\u0D37\u0D02"
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F" && hour >= 4 || meridiem === "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D" || meridiem === "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
            else if (hour < 12) return "\u0D30\u0D3E\u0D35\u0D3F\u0D32\u0D46";
            else if (hour < 17) return "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D";
            else if (hour < 20) return "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02";
            else return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
        }
    });
    //! moment.js locale configuration
    function translate$7(number, withoutSuffix, key, isFuture) {
        switch(key){
            case 's':
                return withoutSuffix ? "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434" : "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D";
            case 'ss':
                return number + (withoutSuffix ? " \u0441\u0435\u043A\u0443\u043D\u0434" : " \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D");
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? " \u043C\u0438\u043D\u0443\u0442" : " \u043C\u0438\u043D\u0443\u0442\u044B\u043D");
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? " \u0446\u0430\u0433" : " \u0446\u0430\u0433\u0438\u0439\u043D");
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? " \u04E9\u0434\u04E9\u0440" : " \u04E9\u0434\u0440\u0438\u0439\u043D");
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? " \u0441\u0430\u0440" : " \u0441\u0430\u0440\u044B\u043D");
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? " \u0436\u0438\u043B" : " \u0436\u0438\u043B\u0438\u0439\u043D");
            default:
                return number;
        }
    }
    moment.defineLocale('mn', {
        months: "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043E\u043B\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split('_'),
        monthsShort: "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split('_'),
        monthsParseExact: true,
        weekdays: "\u041D\u044F\u043C_\u0414\u0430\u0432\u0430\u0430_\u041C\u044F\u0433\u043C\u0430\u0440_\u041B\u0445\u0430\u0433\u0432\u0430_\u041F\u04AF\u0440\u044D\u0432_\u0411\u0430\u0430\u0441\u0430\u043D_\u0411\u044F\u043C\u0431\u0430".split('_'),
        weekdaysShort: "\u041D\u044F\u043C_\u0414\u0430\u0432_\u041C\u044F\u0433_\u041B\u0445\u0430_\u041F\u04AF\u0440_\u0411\u0430\u0430_\u0411\u044F\u043C".split('_'),
        weekdaysMin: "\u041D\u044F_\u0414\u0430_\u041C\u044F_\u041B\u0445_\u041F\u04AF_\u0411\u0430_\u0411\u044F".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D",
            LLL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm",
            LLLL: "dddd, YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm"
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function(input) {
            return input === "\u04AE\u0425";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u04AE\u04E8";
            else return "\u04AE\u0425";
        },
        calendar: {
            sameDay: "[\u04E8\u043D\u04E9\u04E9\u0434\u04E9\u0440] LT",
            nextDay: "[\u041C\u0430\u0440\u0433\u0430\u0430\u0448] LT",
            nextWeek: "[\u0418\u0440\u044D\u0445] dddd LT",
            lastDay: "[\u04E8\u0447\u0438\u0433\u0434\u04E9\u0440] LT",
            lastWeek: "[\u04E8\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D] dddd LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0434\u0430\u0440\u0430\u0430",
            past: "%s \u04E9\u043C\u043D\u04E9",
            s: translate$7,
            ss: translate$7,
            m: translate$7,
            mm: translate$7,
            h: translate$7,
            hh: translate$7,
            d: translate$7,
            dd: translate$7,
            M: translate$7,
            MM: translate$7,
            y: translate$7,
            yy: translate$7
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + " \u04E9\u0434\u04E9\u0440";
                default:
                    return number;
            }
        }
    });
    //! moment.js locale configuration
    var symbolMap$c = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$b = {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    };
    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) switch(string){
            case 's':
                output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
                break;
            case 'ss':
                output = "%d \u0938\u0947\u0915\u0902\u0926";
                break;
            case 'm':
                output = "\u090F\u0915 \u092E\u093F\u0928\u093F\u091F";
                break;
            case 'mm':
                output = "%d \u092E\u093F\u0928\u093F\u091F\u0947";
                break;
            case 'h':
                output = "\u090F\u0915 \u0924\u093E\u0938";
                break;
            case 'hh':
                output = "%d \u0924\u093E\u0938";
                break;
            case 'd':
                output = "\u090F\u0915 \u0926\u093F\u0935\u0938";
                break;
            case 'dd':
                output = "%d \u0926\u093F\u0935\u0938";
                break;
            case 'M':
                output = "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E";
                break;
            case 'MM':
                output = "%d \u092E\u0939\u093F\u0928\u0947";
                break;
            case 'y':
                output = "\u090F\u0915 \u0935\u0930\u094D\u0937";
                break;
            case 'yy':
                output = "%d \u0935\u0930\u094D\u0937\u0947";
                break;
        }
        else switch(string){
            case 's':
                output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
                break;
            case 'ss':
                output = "%d \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
                break;
            case 'm':
                output = "\u090F\u0915\u093E \u092E\u093F\u0928\u093F\u091F\u093E";
                break;
            case 'mm':
                output = "%d \u092E\u093F\u0928\u093F\u091F\u093E\u0902";
                break;
            case 'h':
                output = "\u090F\u0915\u093E \u0924\u093E\u0938\u093E";
                break;
            case 'hh':
                output = "%d \u0924\u093E\u0938\u093E\u0902";
                break;
            case 'd':
                output = "\u090F\u0915\u093E \u0926\u093F\u0935\u0938\u093E";
                break;
            case 'dd':
                output = "%d \u0926\u093F\u0935\u0938\u093E\u0902";
                break;
            case 'M':
                output = "\u090F\u0915\u093E \u092E\u0939\u093F\u0928\u094D\u092F\u093E";
                break;
            case 'MM':
                output = "%d \u092E\u0939\u093F\u0928\u094D\u092F\u093E\u0902";
                break;
            case 'y':
                output = "\u090F\u0915\u093E \u0935\u0930\u094D\u0937\u093E";
                break;
            case 'yy':
                output = "%d \u0935\u0930\u094D\u0937\u093E\u0902";
                break;
        }
        return output.replace(/%d/i, number);
    }
    moment.defineLocale('mr', {
        months: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u093F\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u0948_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split('_'),
        monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A._\u090F\u092A\u094D\u0930\u093F._\u092E\u0947._\u091C\u0942\u0928._\u091C\u0941\u0932\u0948._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0933\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split('_'),
        weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0933_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split('_'),
        weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split('_'),
        longDateFormat: {
            LT: "A h:mm \u0935\u093E\u091C\u0924\u093E",
            LTS: "A h:mm:ss \u0935\u093E\u091C\u0924\u093E",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E"
        },
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u0909\u0926\u094D\u092F\u093E] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0915\u093E\u0932] LT",
            lastWeek: "[\u092E\u093E\u0917\u0940\u0932] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s\u092E\u0927\u094D\u092F\u0947",
            past: "%s\u092A\u0942\u0930\u094D\u0935\u0940",
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$b[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$c[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u092A\u0939\u093E\u091F\u0947" || meridiem === "\u0938\u0915\u093E\u0933\u0940") return hour;
            else if (meridiem === "\u0926\u0941\u092A\u093E\u0930\u0940" || meridiem === "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940" || meridiem === "\u0930\u093E\u0924\u094D\u0930\u0940") return hour >= 12 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour >= 0 && hour < 6) return "\u092A\u0939\u093E\u091F\u0947";
            else if (hour < 12) return "\u0938\u0915\u093E\u0933\u0940";
            else if (hour < 17) return "\u0926\u0941\u092A\u093E\u0930\u0940";
            else if (hour < 20) return "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940";
            else return "\u0930\u093E\u0924\u094D\u0930\u0940";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'pagi') return hour;
            else if (meridiem === 'tengahari') return hour >= 11 ? hour : hour + 12;
            else if (meridiem === 'petang' || meridiem === 'malam') return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return 'pagi';
            else if (hours < 15) return 'tengahari';
            else if (hours < 19) return 'petang';
            else return 'malam';
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'pagi') return hour;
            else if (meridiem === 'tengahari') return hour >= 11 ? hour : hour + 12;
            else if (meridiem === 'petang' || meridiem === 'malam') return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return 'pagi';
            else if (hours < 15) return 'tengahari';
            else if (hours < 19) return 'petang';
            else return 'malam';
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('mt', {
        months: "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010Bembru".split('_'),
        monthsShort: "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010B".split('_'),
        weekdays: "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split('_'),
        weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split('_'),
        weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: "[G\u0127ada fil-]LT",
            nextWeek: 'dddd [fil-]LT',
            lastDay: "[Il-biera\u0127 fil-]LT",
            lastWeek: "dddd [li g\u0127adda] [fil-]LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "f\u2019 %s",
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: "sieg\u0127a",
            hh: "%d sieg\u0127at",
            d: "\u0121urnata",
            dd: "%d \u0121ranet",
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$d = {
        1: "\u1041",
        2: "\u1042",
        3: "\u1043",
        4: "\u1044",
        5: "\u1045",
        6: "\u1046",
        7: "\u1047",
        8: "\u1048",
        9: "\u1049",
        0: "\u1040"
    }, numberMap$c = {
        "\u1041": '1',
        "\u1042": '2',
        "\u1043": '3',
        "\u1044": '4',
        "\u1045": '5',
        "\u1046": '6',
        "\u1047": '7',
        "\u1048": '8',
        "\u1049": '9',
        "\u1040": '0'
    };
    moment.defineLocale('my', {
        months: "\u1007\u1014\u103A\u1014\u101D\u102B\u101B\u102E_\u1016\u1031\u1016\u1031\u102C\u103A\u101D\u102B\u101B\u102E_\u1019\u1010\u103A_\u1027\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u1007\u1030\u101C\u102D\u102F\u1004\u103A_\u101E\u103C\u1002\u102F\u1010\u103A_\u1005\u1000\u103A\u1010\u1004\u103A\u1018\u102C_\u1021\u1031\u102C\u1000\u103A\u1010\u102D\u102F\u1018\u102C_\u1014\u102D\u102F\u101D\u1004\u103A\u1018\u102C_\u1012\u102E\u1007\u1004\u103A\u1018\u102C".split('_'),
        monthsShort: "\u1007\u1014\u103A_\u1016\u1031_\u1019\u1010\u103A_\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u101C\u102D\u102F\u1004\u103A_\u101E\u103C_\u1005\u1000\u103A_\u1021\u1031\u102C\u1000\u103A_\u1014\u102D\u102F_\u1012\u102E".split('_'),
        weekdays: "\u1010\u1014\u1004\u103A\u1039\u1002\u1014\u103D\u1031_\u1010\u1014\u1004\u103A\u1039\u101C\u102C_\u1021\u1004\u103A\u1039\u1002\u102B_\u1017\u102F\u1012\u1039\u1013\u101F\u1030\u1038_\u1000\u103C\u102C\u101E\u1015\u1010\u1031\u1038_\u101E\u1031\u102C\u1000\u103C\u102C_\u1005\u1014\u1031".split('_'),
        weekdaysShort: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split('_'),
        weekdaysMin: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u101A\u1014\u1031.] LT [\u1019\u103E\u102C]",
            nextDay: "[\u1019\u1014\u1000\u103A\u1016\u103C\u1014\u103A] LT [\u1019\u103E\u102C]",
            nextWeek: "dddd LT [\u1019\u103E\u102C]",
            lastDay: "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103E\u102C]",
            lastWeek: "[\u1015\u103C\u102E\u1038\u1001\u1032\u1037\u101E\u1031\u102C] dddd LT [\u1019\u103E\u102C]",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u101C\u102C\u1019\u100A\u103A\u1037 %s \u1019\u103E\u102C",
            past: "\u101C\u103D\u1014\u103A\u1001\u1032\u1037\u101E\u1031\u102C %s \u1000",
            s: "\u1005\u1000\u1039\u1000\u1014\u103A.\u1021\u1014\u100A\u103A\u1038\u1004\u101A\u103A",
            ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103A",
            m: "\u1010\u1005\u103A\u1019\u102D\u1014\u1005\u103A",
            mm: "%d \u1019\u102D\u1014\u1005\u103A",
            h: "\u1010\u1005\u103A\u1014\u102C\u101B\u102E",
            hh: "%d \u1014\u102C\u101B\u102E",
            d: "\u1010\u1005\u103A\u101B\u1000\u103A",
            dd: "%d \u101B\u1000\u103A",
            M: "\u1010\u1005\u103A\u101C",
            MM: "%d \u101C",
            y: "\u1010\u1005\u103A\u1014\u103E\u1005\u103A",
            yy: "%d \u1014\u103E\u1005\u103A"
        },
        preparse: function(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function(match) {
                return numberMap$c[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$d[match];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split('_'),
        weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split('_'),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$e = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$d = {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    };
    moment.defineLocale('ne', {
        months: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F\u0932_\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0937\u094D\u091F_\u0938\u0947\u092A\u094D\u091F\u0947\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u092D\u0947\u092E\u094D\u092C\u0930_\u0921\u093F\u0938\u0947\u092E\u094D\u092C\u0930".split('_'),
        monthsShort: "\u091C\u0928._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F._\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908._\u0905\u0917._\u0938\u0947\u092A\u094D\u091F._\u0905\u0915\u094D\u091F\u094B._\u0928\u094B\u092D\u0947._\u0921\u093F\u0938\u0947.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0906\u0907\u0924\u092C\u093E\u0930_\u0938\u094B\u092E\u092C\u093E\u0930_\u092E\u0919\u094D\u0917\u0932\u092C\u093E\u0930_\u092C\u0941\u0927\u092C\u093E\u0930_\u092C\u093F\u0939\u093F\u092C\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u092C\u093E\u0930_\u0936\u0928\u093F\u092C\u093E\u0930".split('_'),
        weekdaysShort: "\u0906\u0907\u0924._\u0938\u094B\u092E._\u092E\u0919\u094D\u0917\u0932._\u092C\u0941\u0927._\u092C\u093F\u0939\u093F._\u0936\u0941\u0915\u094D\u0930._\u0936\u0928\u093F.".split('_'),
        weekdaysMin: "\u0906._\u0938\u094B._\u092E\u0902._\u092C\u0941._\u092C\u093F._\u0936\u0941._\u0936.".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "A\u0915\u094B h:mm \u092C\u091C\u0947",
            LTS: "A\u0915\u094B h:mm:ss \u092C\u091C\u0947",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947",
            LLLL: "dddd, D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947"
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$d[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$e[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924\u093F") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u092C\u093F\u0939\u093E\u0928") return hour;
            else if (meridiem === "\u0926\u093F\u0909\u0901\u0938\u094B") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0938\u093E\u0901\u091D") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 3) return "\u0930\u093E\u0924\u093F";
            else if (hour < 12) return "\u092C\u093F\u0939\u093E\u0928";
            else if (hour < 16) return "\u0926\u093F\u0909\u0901\u0938\u094B";
            else if (hour < 20) return "\u0938\u093E\u0901\u091D";
            else return "\u0930\u093E\u0924\u093F";
        },
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u092D\u094B\u0932\u093F] LT",
            nextWeek: "[\u0906\u0909\u0901\u0926\u094B] dddd[,] LT",
            lastDay: "[\u0939\u093F\u091C\u094B] LT",
            lastWeek: "[\u0917\u090F\u0915\u094B] dddd[,] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s\u092E\u093E",
            past: "%s \u0905\u0917\u093E\u0921\u093F",
            s: "\u0915\u0947\u0939\u0940 \u0915\u094D\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0947\u0923\u094D\u0921",
            m: "\u090F\u0915 \u092E\u093F\u0928\u0947\u091F",
            mm: "%d \u092E\u093F\u0928\u0947\u091F",
            h: "\u090F\u0915 \u0918\u0923\u094D\u091F\u093E",
            hh: "%d \u0918\u0923\u094D\u091F\u093E",
            d: "\u090F\u0915 \u0926\u093F\u0928",
            dd: "%d \u0926\u093F\u0928",
            M: "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E",
            MM: "%d \u092E\u0939\u093F\u0928\u093E",
            y: "\u090F\u0915 \u092C\u0930\u094D\u0937",
            yy: "%d \u092C\u0930\u094D\u0937"
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots$1 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'), monthsShortWithoutDots$1 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'), monthsParse$8 = [
        /^jan/i,
        /^feb/i,
        /^maart|mrt.?$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], monthsRegex$7 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots$1;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots$1[m.month()];
            else return monthsShortWithDots$1[m.month()];
        },
        monthsRegex: monthsRegex$7,
        monthsShortRegex: monthsRegex$7,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: monthsParse$8,
        longMonthsParse: monthsParse$8,
        shortMonthsParse: monthsParse$8,
        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: "\xe9\xe9n minuut",
            mm: '%d minuten',
            h: "\xe9\xe9n uur",
            hh: '%d uur',
            d: "\xe9\xe9n dag",
            dd: '%d dagen',
            M: "\xe9\xe9n maand",
            MM: '%d maanden',
            y: "\xe9\xe9n jaar",
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots$2 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'), monthsShortWithoutDots$2 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'), monthsParse$9 = [
        /^jan/i,
        /^feb/i,
        /^maart|mrt.?$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], monthsRegex$8 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots$2;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots$2[m.month()];
            else return monthsShortWithDots$2[m.month()];
        },
        monthsRegex: monthsRegex$8,
        monthsShortRegex: monthsRegex$8,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: monthsParse$9,
        longMonthsParse: monthsParse$9,
        shortMonthsParse: monthsParse$9,
        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: "\xe9\xe9n minuut",
            mm: '%d minuten',
            h: "\xe9\xe9n uur",
            hh: '%d uur',
            d: "\xe9\xe9n dag",
            dd: '%d dagen',
            w: "\xe9\xe9n week",
            ww: '%d weken',
            M: "\xe9\xe9n maand",
            MM: '%d maanden',
            y: "\xe9\xe9n jaar",
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: "sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split('_'),
        weekdaysShort: "su._m\xe5._ty._on._to._fr._lau.".split('_'),
        weekdaysMin: "su_m\xe5_ty_on_to_fr_la".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: "[I g\xe5r klokka] LT",
            lastWeek: "[F\xf8reg\xe5ande] dddd [klokka] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: "ein m\xe5nad",
            MM: "%d m\xe5nader",
            y: "eit \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('oc-lnc', {
        months: {
            standalone: "geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split('_'),
            format: "de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split('_'),
        monthsParseExact: true,
        weekdays: "dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split('_'),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: "[u\xe8i a] LT",
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: "[i\xe8r a] LT",
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : "\xe8";
            if (period === 'w' || period === 'W') output = 'a';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$f = {
        1: "\u0A67",
        2: "\u0A68",
        3: "\u0A69",
        4: "\u0A6A",
        5: "\u0A6B",
        6: "\u0A6C",
        7: "\u0A6D",
        8: "\u0A6E",
        9: "\u0A6F",
        0: "\u0A66"
    }, numberMap$e = {
        "\u0A67": '1',
        "\u0A68": '2',
        "\u0A69": '3',
        "\u0A6A": '4',
        "\u0A6B": '5',
        "\u0A6C": '6',
        "\u0A6D": '7',
        "\u0A6E": '8',
        "\u0A6F": '9',
        "\u0A66": '0'
    };
    moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split('_'),
        monthsShort: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split('_'),
        weekdays: "\u0A10\u0A24\u0A35\u0A3E\u0A30_\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30_\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30_\u0A2C\u0A41\u0A27\u0A35\u0A3E\u0A30_\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A28\u0A40\u0A1A\u0A30\u0A35\u0A3E\u0A30".split('_'),
        weekdaysShort: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split('_'),
        weekdaysMin: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split('_'),
        longDateFormat: {
            LT: "A h:mm \u0A35\u0A1C\u0A47",
            LTS: "A h:mm:ss \u0A35\u0A1C\u0A47",
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47"
        },
        calendar: {
            sameDay: "[\u0A05\u0A1C] LT",
            nextDay: "[\u0A15\u0A32] LT",
            nextWeek: "[\u0A05\u0A17\u0A32\u0A3E] dddd, LT",
            lastDay: "[\u0A15\u0A32] LT",
            lastWeek: "[\u0A2A\u0A3F\u0A1B\u0A32\u0A47] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0A35\u0A3F\u0A71\u0A1A",
            past: "%s \u0A2A\u0A3F\u0A1B\u0A32\u0A47",
            s: "\u0A15\u0A41\u0A1D \u0A38\u0A15\u0A3F\u0A70\u0A1F",
            ss: "%d \u0A38\u0A15\u0A3F\u0A70\u0A1F",
            m: "\u0A07\u0A15 \u0A2E\u0A3F\u0A70\u0A1F",
            mm: "%d \u0A2E\u0A3F\u0A70\u0A1F",
            h: "\u0A07\u0A71\u0A15 \u0A18\u0A70\u0A1F\u0A3E",
            hh: "%d \u0A18\u0A70\u0A1F\u0A47",
            d: "\u0A07\u0A71\u0A15 \u0A26\u0A3F\u0A28",
            dd: "%d \u0A26\u0A3F\u0A28",
            M: "\u0A07\u0A71\u0A15 \u0A2E\u0A39\u0A40\u0A28\u0A3E",
            MM: "%d \u0A2E\u0A39\u0A40\u0A28\u0A47",
            y: "\u0A07\u0A71\u0A15 \u0A38\u0A3E\u0A32",
            yy: "%d \u0A38\u0A3E\u0A32"
        },
        preparse: function(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function(match) {
                return numberMap$e[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$f[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0A30\u0A3E\u0A24") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0A38\u0A35\u0A47\u0A30") return hour;
            else if (meridiem === "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0A38\u0A3C\u0A3E\u0A2E") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0A30\u0A3E\u0A24";
            else if (hour < 10) return "\u0A38\u0A35\u0A47\u0A30";
            else if (hour < 17) return "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30";
            else if (hour < 20) return "\u0A38\u0A3C\u0A3E\u0A2E";
            else return "\u0A30\u0A3E\u0A24";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split('_'), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split('_'), monthsParse$a = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i
    ];
    function plural$3(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + ' ';
        switch(key){
            case 'ss':
                return result + (plural$3(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : "minut\u0119";
            case 'mm':
                return result + (plural$3(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : "godzin\u0119";
            case 'hh':
                return result + (plural$3(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural$3(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural$3(number) ? "miesi\u0105ce" : "miesi\u0119cy");
            case 'yy':
                return result + (plural$3(number) ? 'lata' : 'lat');
        }
    }
    moment.defineLocale('pl', {
        months: function(momentToFormat, format) {
            if (!momentToFormat) return monthsNominative;
            else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
            else return monthsNominative[momentToFormat.month()];
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split('_'),
        monthsParse: monthsParse$a,
        longMonthsParse: monthsParse$a,
        shortMonthsParse: monthsParse$a,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split('_'),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split('_'),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Dzi\u015B o] LT",
            nextDay: '[Jutro o] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return '[We wtorek o] LT';
                    case 3:
                        return "[W \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate$8,
            m: translate$8,
            mm: translate$8,
            h: translate$8,
            hh: translate$8,
            d: "1 dzie\u0144",
            dd: '%d dni',
            w: "tydzie\u0144",
            ww: translate$8,
            M: "miesi\u0105c",
            MM: translate$8,
            y: 'rok',
            yy: translate$8
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('pt-br', {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split('_'),
        weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split('_'),
        weekdaysMin: "do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return this.day() === 0 || this.day() === 6 ? "[\xdaltimo] dddd [\xe0s] LT" // Saturday + Sunday
                 : "[\xdaltima] dddd [\xe0s] LT"; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: "h\xe1 %s",
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: "um m\xeas",
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        invalidDate: "Data inv\xe1lida"
    });
    //! moment.js locale configuration
    moment.defineLocale('pt', {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split('_'),
        weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split('_'),
        weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return this.day() === 0 || this.day() === 6 ? "[\xdaltimo] dddd [\xe0s] LT" // Saturday + Sunday
                 : "[\xdaltima] dddd [\xe0s] LT"; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: "h\xe1 %s",
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: "um m\xeas",
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
            ss: 'secunde',
            mm: 'minute',
            hh: 'ore',
            dd: 'zile',
            ww: "s\u0103pt\u0103m\xe2ni",
            MM: 'luni',
            yy: 'ani'
        }, separator = ' ';
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) separator = ' de ';
        return number + separator + format[key];
    }
    moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: "duminic\u0103_luni_mar\u021Bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split('_'),
        weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split('_'),
        weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: "[m\xe2ine la] LT",
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'peste %s',
            past: "%s \xeen urm\u0103",
            s: "c\xe2teva secunde",
            ss: relativeTimeWithPlural$2,
            m: 'un minut',
            mm: relativeTimeWithPlural$2,
            h: "o or\u0103",
            hh: relativeTimeWithPlural$2,
            d: 'o zi',
            dd: relativeTimeWithPlural$2,
            w: "o s\u0103pt\u0103m\xe2n\u0103",
            ww: relativeTimeWithPlural$2,
            M: "o lun\u0103",
            MM: relativeTimeWithPlural$2,
            y: 'un an',
            yy: relativeTimeWithPlural$2
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural$4(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
            ww: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043D\u0435\u0434\u0435\u043B\u0438_\u043D\u0435\u0434\u0435\u043B\u044C",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
        };
        if (key === 'm') return withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443";
        else return number + ' ' + plural$4(format[key], +number);
    }
    var monthsParse$b = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i
    ];
    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    moment.defineLocale('ru', {
        months: {
            format: "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split('_'),
            standalone: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split('_')
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split('_'),
            standalone: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split('_')
        },
        weekdays: {
            standalone: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split('_'),
            format: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043E\u0442\u0443".split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split('_'),
        weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split('_'),
        monthsParse: monthsParse$b,
        longMonthsParse: monthsParse$b,
        shortMonthsParse: monthsParse$b,
        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432] LT",
            nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            lastWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043D\u0430\u0437\u0430\u0434",
            s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: relativeTimeWithPlural$3,
            m: relativeTimeWithPlural$3,
            mm: relativeTimeWithPlural$3,
            h: "\u0447\u0430\u0441",
            hh: relativeTimeWithPlural$3,
            d: "\u0434\u0435\u043D\u044C",
            dd: relativeTimeWithPlural$3,
            w: "\u043D\u0435\u0434\u0435\u043B\u044F",
            ww: relativeTimeWithPlural$3,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: relativeTimeWithPlural$3,
            y: "\u0433\u043E\u0434",
            yy: relativeTimeWithPlural$3
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function(input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u0438";
            else if (hour < 12) return "\u0443\u0442\u0440\u0430";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u0435\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function(number, period) {
            switch(period){
                case 'M':
                case 'd':
                case 'DDD':
                    return number + "-\u0439";
                case 'D':
                    return number + "-\u0433\u043E";
                case 'w':
                case 'W':
                    return number + "-\u044F";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$8 = [
        "\u062C\u0646\u0648\u0631\u064A",
        "\u0641\u064A\u0628\u0631\u0648\u0631\u064A",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067E\u0631\u064A\u0644",
        "\u0645\u0626\u064A",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u0621\u0650",
        "\u0622\u06AF\u0633\u067D",
        "\u0633\u064A\u067E\u067D\u0645\u0628\u0631",
        "\u0622\u06AA\u067D\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u068A\u0633\u0645\u0628\u0631"
    ], days = [
        "\u0622\u0686\u0631",
        "\u0633\u0648\u0645\u0631",
        "\u0627\u06B1\u0627\u0631\u0648",
        "\u0627\u0631\u0628\u0639",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639",
        "\u0687\u0646\u0687\u0631"
    ];
    moment.defineLocale('sd', {
        months: months$8,
        monthsShort: months$8,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: "dddd\u060C D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function(input) {
            return "\u0634\u0627\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635\u0628\u062D";
            return "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0684] LT",
            nextDay: "[\u0633\u0680\u0627\u06BB\u064A] LT",
            nextWeek: "dddd [\u0627\u06B3\u064A\u0646 \u0647\u0641\u062A\u064A \u062A\u064A] LT",
            lastDay: "[\u06AA\u0627\u0644\u0647\u0647] LT",
            lastWeek: "[\u06AF\u0632\u0631\u064A\u0644 \u0647\u0641\u062A\u064A] dddd [\u062A\u064A] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u067E\u0648\u0621",
            past: "%s \u0627\u06B3",
            s: "\u0686\u0646\u062F \u0633\u064A\u06AA\u0646\u068A",
            ss: "%d \u0633\u064A\u06AA\u0646\u068A",
            m: "\u0647\u06AA \u0645\u0646\u067D",
            mm: "%d \u0645\u0646\u067D",
            h: "\u0647\u06AA \u06AA\u0644\u0627\u06AA",
            hh: "%d \u06AA\u0644\u0627\u06AA",
            d: "\u0647\u06AA \u068F\u064A\u0646\u0647\u0646",
            dd: "%d \u068F\u064A\u0646\u0647\u0646",
            M: "\u0647\u06AA \u0645\u0647\u064A\u0646\u0648",
            MM: "%d \u0645\u0647\u064A\u0646\u0627",
            y: "\u0647\u06AA \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('se', {
        months: "o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010Dam\xe1nnu_cuo\u014Bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010Dak\u010Dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split('_'),
        monthsShort: "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010Dak\u010D_golg_sk\xe1b_juov".split('_'),
        weekdays: "sotnabeaivi_vuoss\xe1rga_ma\u014B\u014Beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split('_'),
        weekdaysShort: "sotn_vuos_ma\u014B_gask_duor_bear_l\xe1v".split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s gea\u017Ees",
            past: "ma\u014Bit %s",
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: "okta m\xe1nnu",
            MM: "%d m\xe1nut",
            y: 'okta jahki',
            yy: '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    /*jshint -W100*/ moment.defineLocale('si', {
        months: "\u0DA2\u0DB1\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB4\u0DD9\u0DB6\u0DBB\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB8\u0DCF\u0DBB\u0DCA\u0DAD\u0DD4_\u0D85\u0DB4\u0DCA\u200D\u0DBB\u0DDA\u0DBD\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD\u0DC3\u0DCA\u0DAD\u0DD4_\u0DC3\u0DD0\u0DB4\u0DCA\u0DAD\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0D94\u0D9A\u0DCA\u0DAD\u0DDD\u0DB6\u0DBB\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0DAF\u0DD9\u0DC3\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA".split('_'),
        monthsShort: "\u0DA2\u0DB1_\u0DB4\u0DD9\u0DB6_\u0DB8\u0DCF\u0DBB\u0DCA_\u0D85\u0DB4\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD_\u0DC3\u0DD0\u0DB4\u0DCA_\u0D94\u0D9A\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0_\u0DAF\u0DD9\u0DC3\u0DD0".split('_'),
        weekdays: "\u0D89\u0DBB\u0DD2\u0DAF\u0DCF_\u0DC3\u0DB3\u0DD4\u0DAF\u0DCF_\u0D85\u0D9F\u0DC4\u0DBB\u0DD4\u0DC0\u0DCF\u0DAF\u0DCF_\u0DB6\u0DAF\u0DCF\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4\u0DC3\u0DCA\u0DB4\u0DAD\u0DD2\u0DB1\u0DCA\u0DAF\u0DCF_\u0DC3\u0DD2\u0D9A\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF_\u0DC3\u0DD9\u0DB1\u0DC3\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF".split('_'),
        weekdaysShort: "\u0D89\u0DBB\u0DD2_\u0DC3\u0DB3\u0DD4_\u0D85\u0D9F_\u0DB6\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4_\u0DC3\u0DD2\u0D9A\u0DD4_\u0DC3\u0DD9\u0DB1".split('_'),
        weekdaysMin: "\u0D89_\u0DC3_\u0D85_\u0DB6_\u0DB6\u0DCA\u200D\u0DBB_\u0DC3\u0DD2_\u0DC3\u0DD9".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: "YYYY MMMM D [\u0DC0\u0DD0\u0DB1\u0DD2] dddd, a h:mm:ss"
        },
        calendar: {
            sameDay: "[\u0D85\u0DAF] LT[\u0DA7]",
            nextDay: "[\u0DC4\u0DD9\u0DA7] LT[\u0DA7]",
            nextWeek: "dddd LT[\u0DA7]",
            lastDay: "[\u0D8A\u0DBA\u0DDA] LT[\u0DA7]",
            lastWeek: "[\u0DB4\u0DC3\u0DD4\u0D9C\u0DD2\u0DBA] dddd LT[\u0DA7]",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s\u0D9A\u0DD2\u0DB1\u0DCA",
            past: "%s\u0D9A\u0DA7 \u0DB4\u0DD9\u0DBB",
            s: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB \u0D9A\u0DD2\u0DC4\u0DD2\u0DB4\u0DBA",
            ss: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB %d",
            m: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4\u0DC0",
            mm: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4 %d",
            h: "\u0DB4\u0DD0\u0DBA",
            hh: "\u0DB4\u0DD0\u0DBA %d",
            d: "\u0DAF\u0DD2\u0DB1\u0DBA",
            dd: "\u0DAF\u0DD2\u0DB1 %d",
            M: "\u0DB8\u0DCF\u0DC3\u0DBA",
            MM: "\u0DB8\u0DCF\u0DC3 %d",
            y: "\u0DC0\u0DC3\u0DBB",
            yy: "\u0DC0\u0DC3\u0DBB %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function(number) {
            return number + " \u0DC0\u0DD0\u0DB1\u0DD2";
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function(input) {
            return input === "\u0DB4.\u0DC0." || input === "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "\u0DB4.\u0DC0." : "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
            else return isLower ? "\u0DB4\u0DD9.\u0DC0." : "\u0DB4\u0DD9\u0DBB \u0DC0\u0DBB\u0DD4";
        }
    });
    //! moment.js locale configuration
    var months$9 = "janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split('_'), monthsShort$7 = "jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split('_');
    function plural$5(n) {
        return n > 1 && n < 5;
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch(key){
            case 's':
                return withoutSuffix || isFuture ? "p\xe1r sek\xfand" : "p\xe1r sekundami";
            case 'ss':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? 'sekundy' : "sek\xfand");
                else return result + 'sekundami';
            case 'm':
                return withoutSuffix ? "min\xfata" : isFuture ? "min\xfatu" : "min\xfatou";
            case 'mm':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "min\xfaty" : "min\xfat");
                else return result + "min\xfatami";
            case 'h':
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? 'hodiny' : "hod\xedn");
                else return result + 'hodinami';
            case 'd':
                return withoutSuffix || isFuture ? "de\u0148" : "d\u0148om";
            case 'dd':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? 'dni' : "dn\xed");
                else return result + "d\u0148ami";
            case 'M':
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
                else return result + 'mesiacmi';
            case 'y':
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy':
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? 'roky' : 'rokov');
                else return result + 'rokmi';
        }
    }
    moment.defineLocale('sk', {
        months: months$9,
        monthsShort: monthsShort$7,
        weekdays: "nede\u013Ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split('_'),
        weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split('_'),
        weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v nede\u013Eu o] LT";
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return "[vo \u0161tvrtok o] LT";
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: "[v\u010Dera o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minul\xfa nede\u013Eu o] LT";
                    case 1:
                    case 2:
                        return "[minul\xfd] dddd [o] LT";
                    case 3:
                        return "[minul\xfa stredu o] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [o] LT";
                    case 6:
                        return "[minul\xfa sobotu o] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate$9,
            ss: translate$9,
            m: translate$9,
            mm: translate$9,
            h: translate$9,
            hh: translate$9,
            d: translate$9,
            dd: translate$9,
            M: translate$9,
            MM: translate$9,
            y: translate$9,
            yy: translate$9
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch(key){
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) result += withoutSuffix ? 'sekundo' : 'sekundi';
                else if (number === 2) result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                else if (number < 5) result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                else result += 'sekund';
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) result += withoutSuffix ? 'minuta' : 'minuto';
                else if (number === 2) result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                else if (number < 5) result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                else result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) result += withoutSuffix ? 'ura' : 'uro';
                else if (number === 2) result += withoutSuffix || isFuture ? 'uri' : 'urama';
                else if (number < 5) result += withoutSuffix || isFuture ? 'ure' : 'urami';
                else result += withoutSuffix || isFuture ? 'ur' : 'urami';
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                else if (number === 2) result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                else result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                else if (number === 2) result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                else if (number < 5) result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                else result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) result += withoutSuffix || isFuture ? 'leto' : 'letom';
                else if (number === 2) result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                else if (number < 5) result += withoutSuffix || isFuture ? 'leta' : 'leti';
                else result += withoutSuffix || isFuture ? 'let' : 'leti';
                return result;
        }
    }
    moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: "nedelja_ponedeljek_torek_sreda_\u010Detrtek_petek_sobota".split('_'),
        weekdaysShort: "ned._pon._tor._sre._\u010Det._pet._sob.".split('_'),
        weekdaysMin: "ne_po_to_sr_\u010De_pe_so".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: "[v\u010Deraj ob] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[prej\u0161njo] [nedeljo] [ob] LT";
                    case 3:
                        return "[prej\u0161njo] [sredo] [ob] LT";
                    case 6:
                        return "[prej\u0161njo] [soboto] [ob] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[prej\u0161nji] dddd [ob] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u010Dez %s",
            past: 'pred %s',
            s: processRelativeTime$7,
            ss: processRelativeTime$7,
            m: processRelativeTime$7,
            mm: processRelativeTime$7,
            h: processRelativeTime$7,
            hh: processRelativeTime$7,
            d: processRelativeTime$7,
            dd: processRelativeTime$7,
            M: processRelativeTime$7,
            MM: processRelativeTime$7,
            y: processRelativeTime$7,
            yy: processRelativeTime$7
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('sq', {
        months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split('_'),
        monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split('_'),
        weekdays: "E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split('_'),
        weekdaysShort: "Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split('_'),
        weekdaysMin: "D_H_Ma_M\xeb_E_P_Sh".split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function(input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Sot n\xeb] LT",
            nextDay: "[Nes\xebr n\xeb] LT",
            nextWeek: "dddd [n\xeb] LT",
            lastDay: "[Dje n\xeb] LT",
            lastWeek: "dddd [e kaluar n\xeb] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "n\xeb %s",
            past: "%s m\xeb par\xeb",
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: "nj\xeb minut\xeb",
            mm: '%d minuta',
            h: "nj\xeb or\xeb",
            hh: "%d or\xeb",
            d: "nj\xeb dit\xeb",
            dd: "%d dit\xeb",
            M: "nj\xeb muaj",
            MM: '%d muaj',
            y: "nj\xeb vit",
            yy: '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var translator$1 = {
        words: {
            //Different grammatical cases
            ss: [
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0435",
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
            ],
            m: [
                "\u0458\u0435\u0434\u0430\u043D \u043C\u0438\u043D\u0443\u0442",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0438\u043D\u0443\u0442\u0430"
            ],
            mm: [
                "\u043C\u0438\u043D\u0443\u0442",
                "\u043C\u0438\u043D\u0443\u0442\u0430",
                "\u043C\u0438\u043D\u0443\u0442\u0430"
            ],
            h: [
                "\u0458\u0435\u0434\u0430\u043D \u0441\u0430\u0442",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u0441\u0430\u0442\u0430"
            ],
            hh: [
                "\u0441\u0430\u0442",
                "\u0441\u0430\u0442\u0430",
                "\u0441\u0430\u0442\u0438"
            ],
            d: [
                "\u0458\u0435\u0434\u0430\u043D \u0434\u0430\u043D",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u0434\u0430\u043D\u0430"
            ],
            dd: [
                "\u0434\u0430\u043D",
                "\u0434\u0430\u043D\u0430",
                "\u0434\u0430\u043D\u0430"
            ],
            M: [
                "\u0458\u0435\u0434\u0430\u043D \u043C\u0435\u0441\u0435\u0446",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0435\u0441\u0435\u0446\u0430"
            ],
            MM: [
                "\u043C\u0435\u0441\u0435\u0446",
                "\u043C\u0435\u0441\u0435\u0446\u0430",
                "\u043C\u0435\u0441\u0435\u0446\u0438"
            ],
            y: [
                "\u0458\u0435\u0434\u043D\u0443 \u0433\u043E\u0434\u0438\u043D\u0443",
                "\u0458\u0435\u0434\u043D\u0435 \u0433\u043E\u0434\u0438\u043D\u0435"
            ],
            yy: [
                "\u0433\u043E\u0434\u0438\u043D\u0443",
                "\u0433\u043E\u0434\u0438\u043D\u0435",
                "\u0433\u043E\u0434\u0438\u043D\u0430"
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) return number % 10 === 1 ? wordKey[0] : wordKey[1];
            return wordKey[2];
        },
        translate: function(number, withoutSuffix, key, isFuture) {
            var wordKey = translator$1.words[key], word;
            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return "\u0458\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430";
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }
            word = translator$1.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === "\u0433\u043E\u0434\u0438\u043D\u0443") return number + " \u0433\u043E\u0434\u0438\u043D\u0430";
            return number + ' ' + word;
        }
    };
    moment.defineLocale('sr-cyrl', {
        months: "\u0458\u0430\u043D\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440_\u043E\u043A\u0442\u043E\u0431\u0430\u0440_\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440".split('_'),
        monthsShort: "\u0458\u0430\u043D._\u0444\u0435\u0431._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433._\u0441\u0435\u043F._\u043E\u043A\u0442._\u043D\u043E\u0432._\u0434\u0435\u0446.".split('_'),
        monthsParseExact: true,
        weekdays: "\u043D\u0435\u0434\u0435\u0459\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A_\u0443\u0442\u043E\u0440\u0430\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A_\u043F\u0435\u0442\u0430\u043A_\u0441\u0443\u0431\u043E\u0442\u0430".split('_'),
        weekdaysShort: "\u043D\u0435\u0434._\u043F\u043E\u043D._\u0443\u0442\u043E._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043F\u0435\u0442._\u0441\u0443\u0431.".split('_'),
        weekdaysMin: "\u043D\u0435_\u043F\u043E_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441\u0443".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: "[\u0434\u0430\u043D\u0430\u0441 \u0443] LT",
            nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[\u0443] [\u043D\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
                    case 3:
                        return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
                    case 6:
                        return "[\u0443] [\u0441\u0443\u0431\u043E\u0442\u0443] [\u0443] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0443] dddd [\u0443] LT";
                }
            },
            lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u043D\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0443\u0442\u043E\u0440\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u0435\u0442\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0443\u0431\u043E\u0442\u0435] [\u0443] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043F\u0440\u0435 %s",
            s: "\u043D\u0435\u043A\u043E\u043B\u0438\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: translator$1.translate,
            m: translator$1.translate,
            mm: translator$1.translate,
            h: translator$1.translate,
            hh: translator$1.translate,
            d: translator$1.translate,
            dd: translator$1.translate,
            M: translator$1.translate,
            MM: translator$1.translate,
            y: translator$1.translate,
            yy: translator$1.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var translator$2 = {
        words: {
            //Different grammatical cases
            ss: [
                'sekunda',
                'sekunde',
                'sekundi'
            ],
            m: [
                'jedan minut',
                'jednog minuta'
            ],
            mm: [
                'minut',
                'minuta',
                'minuta'
            ],
            h: [
                'jedan sat',
                'jednog sata'
            ],
            hh: [
                'sat',
                'sata',
                'sati'
            ],
            d: [
                'jedan dan',
                'jednog dana'
            ],
            dd: [
                'dan',
                'dana',
                'dana'
            ],
            M: [
                'jedan mesec',
                'jednog meseca'
            ],
            MM: [
                'mesec',
                'meseca',
                'meseci'
            ],
            y: [
                'jednu godinu',
                'jedne godine'
            ],
            yy: [
                'godinu',
                'godine',
                'godina'
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) return number % 10 === 1 ? wordKey[0] : wordKey[1];
            return wordKey[2];
        },
        translate: function(number, withoutSuffix, key, isFuture) {
            var wordKey = translator$2.words[key], word;
            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }
            word = translator$2.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') return number + ' godina';
            return number + ' ' + word;
        }
    };
    moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: "nedelja_ponedeljak_utorak_sreda_\u010Detvrtak_petak_subota".split('_'),
        weekdaysShort: "ned._pon._uto._sre._\u010Det._pet._sub.".split('_'),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: "[ju\u010De u] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[pro\u0161le] [nedelje] [u] LT",
                    "[pro\u0161log] [ponedeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srede] [u] LT",
                    "[pro\u0161log] [\u010Detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator$2.translate,
            m: translator$2.translate,
            mm: translator$2.translate,
            h: translator$2.translate,
            hh: translator$2.translate,
            d: translator$2.translate,
            dd: translator$2.translate,
            M: translator$2.translate,
            MM: translator$2.translate,
            y: translator$2.translate,
            yy: translator$2.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return 'ekuseni';
            else if (hours < 15) return 'emini';
            else if (hours < 19) return 'entsambama';
            else return 'ebusuku';
        },
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === 'ekuseni') return hour;
            else if (meridiem === 'emini') return hour >= 11 ? hour : hour + 12;
            else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) return 0;
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$g = {
        1: "\u0BE7",
        2: "\u0BE8",
        3: "\u0BE9",
        4: "\u0BEA",
        5: "\u0BEB",
        6: "\u0BEC",
        7: "\u0BED",
        8: "\u0BEE",
        9: "\u0BEF",
        0: "\u0BE6"
    }, numberMap$f = {
        "\u0BE7": '1',
        "\u0BE8": '2',
        "\u0BE9": '3',
        "\u0BEA": '4',
        "\u0BEB": '5',
        "\u0BEC": '6',
        "\u0BED": '7',
        "\u0BEE": '8',
        "\u0BEF": '9',
        "\u0BE6": '0'
    };
    moment.defineLocale('ta', {
        months: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split('_'),
        monthsShort: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split('_'),
        weekdays: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0B9F\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8".split('_'),
        weekdaysShort: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF_\u0B9A\u0BA9\u0BBF".split('_'),
        weekdaysMin: "\u0B9E\u0BBE_\u0BA4\u0BBF_\u0B9A\u0BC6_\u0BAA\u0BC1_\u0BB5\u0BBF_\u0BB5\u0BC6_\u0B9A".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar: {
            sameDay: "[\u0B87\u0BA9\u0BCD\u0BB1\u0BC1] LT",
            nextDay: "[\u0BA8\u0BBE\u0BB3\u0BC8] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1] LT",
            lastWeek: "[\u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0B87\u0BB2\u0BCD",
            past: "%s \u0BAE\u0BC1\u0BA9\u0BCD",
            s: "\u0B92\u0BB0\u0BC1 \u0B9A\u0BBF\u0BB2 \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            ss: "%d \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            m: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            mm: "%d \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            h: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            hh: "%d \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            d: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBE\u0BB3\u0BCD",
            dd: "%d \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            M: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            MM: "%d \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            y: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            yy: "%d \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD"
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function(number) {
            return number + "\u0BB5\u0BA4\u0BC1";
        },
        preparse: function(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function(match) {
                return numberMap$f[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$g[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function(hour, minute, isLower) {
            if (hour < 2) return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
            else if (hour < 6) return " \u0BB5\u0BC8\u0B95\u0BB1\u0BC8"; // வைகறை
            else if (hour < 10) return " \u0B95\u0BBE\u0BB2\u0BC8"; // காலை
            else if (hour < 14) return " \u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD"; // நண்பகல்
            else if (hour < 18) return " \u0B8E\u0BB1\u0BCD\u0BAA\u0BBE\u0B9F\u0BC1"; // எற்பாடு
            else if (hour < 22) return " \u0BAE\u0BBE\u0BB2\u0BC8"; // மாலை
            else return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
        },
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0BAF\u0BBE\u0BAE\u0BAE\u0BCD") return hour < 2 ? hour : hour + 12;
            else if (meridiem === "\u0BB5\u0BC8\u0B95\u0BB1\u0BC8" || meridiem === "\u0B95\u0BBE\u0BB2\u0BC8") return hour;
            else if (meridiem === "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD") return hour >= 10 ? hour : hour + 12;
            else return hour + 12;
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('te', {
        months: "\u0C1C\u0C28\u0C35\u0C30\u0C3F_\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F_\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D_\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41_\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D_\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D_\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D_\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D".split('_'),
        monthsShort: "\u0C1C\u0C28._\u0C2B\u0C3F\u0C2C\u0C4D\u0C30._\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F._\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17._\u0C38\u0C46\u0C2A\u0C4D._\u0C05\u0C15\u0C4D\u0C1F\u0C4B._\u0C28\u0C35._\u0C21\u0C3F\u0C38\u0C46.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02_\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02_\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02_\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02_\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02".split('_'),
        weekdaysShort: "\u0C06\u0C26\u0C3F_\u0C38\u0C4B\u0C2E_\u0C2E\u0C02\u0C17\u0C33_\u0C2C\u0C41\u0C27_\u0C17\u0C41\u0C30\u0C41_\u0C36\u0C41\u0C15\u0C4D\u0C30_\u0C36\u0C28\u0C3F".split('_'),
        weekdaysMin: "\u0C06_\u0C38\u0C4B_\u0C2E\u0C02_\u0C2C\u0C41_\u0C17\u0C41_\u0C36\u0C41_\u0C36".split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: "[\u0C28\u0C47\u0C21\u0C41] LT",
            nextDay: "[\u0C30\u0C47\u0C2A\u0C41] LT",
            nextWeek: 'dddd, LT',
            lastDay: "[\u0C28\u0C3F\u0C28\u0C4D\u0C28] LT",
            lastWeek: "[\u0C17\u0C24] dddd, LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0C32\u0C4B",
            past: "%s \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02",
            s: "\u0C15\u0C4A\u0C28\u0C4D\u0C28\u0C3F \u0C15\u0C4D\u0C37\u0C23\u0C3E\u0C32\u0C41",
            ss: "%d \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32\u0C41",
            m: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            mm: "%d \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41",
            h: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            hh: "%d \u0C17\u0C02\u0C1F\u0C32\u0C41",
            d: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            dd: "%d \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41",
            M: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            MM: "%d \u0C28\u0C46\u0C32\u0C32\u0C41",
            y: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            yy: "%d \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: "%d\u0C35",
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0C09\u0C26\u0C2F\u0C02") return hour;
            else if (meridiem === "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
            else if (hour < 10) return "\u0C09\u0C26\u0C2F\u0C02";
            else if (hour < 17) return "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02";
            else if (hour < 20) return "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02";
            else return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('tet', {
        months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var suffixes$3 = {
        0: "-\u0443\u043C",
        1: "-\u0443\u043C",
        2: "-\u044E\u043C",
        3: "-\u044E\u043C",
        4: "-\u0443\u043C",
        5: "-\u0443\u043C",
        6: "-\u0443\u043C",
        7: "-\u0443\u043C",
        8: "-\u0443\u043C",
        9: "-\u0443\u043C",
        10: "-\u0443\u043C",
        12: "-\u0443\u043C",
        13: "-\u0443\u043C",
        20: "-\u0443\u043C",
        30: "-\u044E\u043C",
        40: "-\u0443\u043C",
        50: "-\u0443\u043C",
        60: "-\u0443\u043C",
        70: "-\u0443\u043C",
        80: "-\u0443\u043C",
        90: "-\u0443\u043C",
        100: "-\u0443\u043C"
    };
    moment.defineLocale('tg', {
        months: {
            format: "\u044F\u043D\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043B\u0438_\u043C\u0430\u0440\u0442\u0438_\u0430\u043F\u0440\u0435\u043B\u0438_\u043C\u0430\u0439\u0438_\u0438\u044E\u043D\u0438_\u0438\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u0438_\u043E\u043A\u0442\u044F\u0431\u0440\u0438_\u043D\u043E\u044F\u0431\u0440\u0438_\u0434\u0435\u043A\u0430\u0431\u0440\u0438".split('_'),
            standalone: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split('_')
        },
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split('_'),
        weekdays: "\u044F\u043A\u0448\u0430\u043D\u0431\u0435_\u0434\u0443\u0448\u0430\u043D\u0431\u0435_\u0441\u0435\u0448\u0430\u043D\u0431\u0435_\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0435_\u043F\u0430\u043D\u04B7\u0448\u0430\u043D\u0431\u0435_\u04B7\u0443\u043C\u044A\u0430_\u0448\u0430\u043D\u0431\u0435".split('_'),
        weekdaysShort: "\u044F\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043F\u0448\u0431_\u04B7\u0443\u043C_\u0448\u043D\u0431".split('_'),
        weekdaysMin: "\u044F\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043F\u0448_\u04B7\u043C_\u0448\u0431".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u0418\u043C\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
            nextDay: "[\u0424\u0430\u0440\u0434\u043E \u0441\u043E\u0430\u0442\u0438] LT",
            lastDay: "[\u0414\u0438\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
            nextWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u043E\u044F\u043D\u0434\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
            lastWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0431\u0430\u044A\u0434\u0438 %s",
            past: "%s \u043F\u0435\u0448",
            s: "\u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u043E\u043D\u0438\u044F",
            m: "\u044F\u043A \u0434\u0430\u049B\u0438\u049B\u0430",
            mm: "%d \u0434\u0430\u049B\u0438\u049B\u0430",
            h: "\u044F\u043A \u0441\u043E\u0430\u0442",
            hh: "%d \u0441\u043E\u0430\u0442",
            d: "\u044F\u043A \u0440\u04EF\u0437",
            dd: "%d \u0440\u04EF\u0437",
            M: "\u044F\u043A \u043C\u043E\u04B3",
            MM: "%d \u043C\u043E\u04B3",
            y: "\u044F\u043A \u0441\u043E\u043B",
            yy: "%d \u0441\u043E\u043B"
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0448\u0430\u0431") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0441\u0443\u0431\u04B3") return hour;
            else if (meridiem === "\u0440\u04EF\u0437") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u0431\u0435\u0433\u043E\u04B3") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0448\u0430\u0431";
            else if (hour < 11) return "\u0441\u0443\u0431\u04B3";
            else if (hour < 16) return "\u0440\u04EF\u0437";
            else if (hour < 19) return "\u0431\u0435\u0433\u043E\u04B3";
            else return "\u0448\u0430\u0431";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('th', {
        months: "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21_\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C_\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21_\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19_\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21_\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19_\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21_\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21_\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19_\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21_\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19_\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21".split('_'),
        monthsShort: "\u0E21.\u0E04._\u0E01.\u0E1E._\u0E21\u0E35.\u0E04._\u0E40\u0E21.\u0E22._\u0E1E.\u0E04._\u0E21\u0E34.\u0E22._\u0E01.\u0E04._\u0E2A.\u0E04._\u0E01.\u0E22._\u0E15.\u0E04._\u0E1E.\u0E22._\u0E18.\u0E04.".split('_'),
        monthsParseExact: true,
        weekdays: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split('_'),
        weekdaysShort: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split('_'),
        weekdaysMin: "\u0E2D\u0E32._\u0E08._\u0E2D._\u0E1E._\u0E1E\u0E24._\u0E28._\u0E2A.".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: "D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm",
            LLLL: "\u0E27\u0E31\u0E19dddd\u0E17\u0E35\u0E48 D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm"
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function(input) {
            return input === "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
            else return "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
        },
        calendar: {
            sameDay: "[\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            nextDay: "[\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            nextWeek: "dddd[\u0E2B\u0E19\u0E49\u0E32 \u0E40\u0E27\u0E25\u0E32] LT",
            lastDay: "[\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            lastWeek: "[\u0E27\u0E31\u0E19]dddd[\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E27\u0E25\u0E32] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0E2D\u0E35\u0E01 %s",
            past: "%s\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27",
            s: "\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
            ss: "%d \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
            m: "1 \u0E19\u0E32\u0E17\u0E35",
            mm: "%d \u0E19\u0E32\u0E17\u0E35",
            h: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
            hh: "%d \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
            d: "1 \u0E27\u0E31\u0E19",
            dd: "%d \u0E27\u0E31\u0E19",
            w: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
            ww: "%d \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
            M: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
            MM: "%d \u0E40\u0E14\u0E37\u0E2D\u0E19",
            y: "1 \u0E1B\u0E35",
            yy: "%d \u0E1B\u0E35"
        }
    });
    //! moment.js locale configuration
    var suffixes$4 = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'\xfcnji",
        4: "'\xfcnji",
        100: "'\xfcnji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy"
    };
    moment.defineLocale('tk', {
        months: "\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split('_'),
        monthsShort: "\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split('_'),
        weekdays: "\xddek\u015Fenbe_Du\u015Fenbe_Si\u015Fenbe_\xc7ar\u015Fenbe_Pen\u015Fenbe_Anna_\u015Eenbe".split('_'),
        weekdaysShort: "\xddek_Du\u015F_Si\u015F_\xc7ar_Pen_Ann_\u015Een".split('_'),
        weekdaysMin: "\xddk_D\u015F_S\u015F_\xc7r_Pn_An_\u015En".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[bug\xfcn sagat] LT",
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: "[d\xfc\xfdn] LT",
            lastWeek: "[ge\xe7en] dddd [sagat] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s so\u0148",
            past: "%s \xf6\u0148",
            s: "birn\xe4\xe7e sekunt",
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir a\xfd",
            MM: "%d a\xfd",
            y: "bir \xfdyl",
            yy: "%d \xfdyl"
        },
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) // special case for zero
                    return number + "'unjy";
                    var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var numbersNouns = "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split('_');
    function translateFuture(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
        return time;
    }
    function translatePast(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + "Hu\u2019" : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
        return time;
    }
    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch(string){
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }
    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100), ten = Math.floor(number % 100 / 10), one = number % 10, word = '';
        if (hundred > 0) word += numbersNouns[hundred] + 'vatlh';
        if (ten > 0) word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        if (one > 0) word += (word !== '' ? ' ' : '') + numbersNouns[one];
        return word === '' ? 'pagh' : word;
    }
    moment.defineLocale('tlh', {
        months: "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split('_'),
        monthsShort: "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split('_'),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: "[wa\u2019leS] LT",
            nextWeek: 'LLL',
            lastDay: "[wa\u2019Hu\u2019] LT",
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate$a,
            m: "wa\u2019 tup",
            mm: translate$a,
            h: "wa\u2019 rep",
            hh: translate$a,
            d: "wa\u2019 jaj",
            dd: translate$a,
            M: "wa\u2019 jar",
            MM: translate$a,
            y: "wa\u2019 DIS",
            yy: translate$a
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var suffixes$5 = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'\xfcnc\xfc",
        4: "'\xfcnc\xfc",
        100: "'\xfcnc\xfc",
        6: "'nc\u0131",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'\u0131nc\u0131",
        90: "'\u0131nc\u0131"
    };
    moment.defineLocale('tr', {
        months: "Ocak_\u015Eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011Fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split('_'),
        monthsShort: "Oca_\u015Eub_Mar_Nis_May_Haz_Tem_A\u011Fu_Eyl_Eki_Kas_Ara".split('_'),
        weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015Famba_Per\u015Fembe_Cuma_Cumartesi".split('_'),
        weekdaysShort: "Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split('_'),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split('_'),
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? "\xf6\xf6" : "\xd6\xd6";
            else return isLower ? "\xf6s" : "\xd6S";
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function(input) {
            return input === "\xf6s" || input === "\xd6S";
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[yar\u0131n saat] LT",
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: "[d\xfcn] LT",
            lastWeek: "[ge\xe7en] dddd [saat] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: "bir y\u0131l",
            yy: "%d y\u0131l"
        },
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) // special case for zero
                    return number + "'\u0131nc\u0131";
                    var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
                    return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    moment.defineLocale('tzl', {
        months: "Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split('_'),
        monthsShort: "Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split('_'),
        weekdays: "S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split('_'),
        weekdaysShort: "S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split('_'),
        weekdaysMin: "S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function(input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "d'o" : "D'O";
            else return isLower ? "d'a" : "D'A";
        },
        calendar: {
            sameDay: "[oxhi \xe0] LT",
            nextDay: "[dem\xe0 \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[ieiri \xe0] LT",
            lastWeek: "[s\xfcr el] dddd [lasteu \xe0] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime$8,
            ss: processRelativeTime$8,
            m: processRelativeTime$8,
            mm: processRelativeTime$8,
            h: processRelativeTime$8,
            hh: processRelativeTime$8,
            d: processRelativeTime$8,
            dd: processRelativeTime$8,
            M: processRelativeTime$8,
            MM: processRelativeTime$8,
            y: processRelativeTime$8,
            yy: processRelativeTime$8
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                'viensas secunds',
                "'iensas secunds"
            ],
            ss: [
                number + ' secunds',
                '' + number + ' secunds'
            ],
            m: [
                "'n m\xedut",
                "'iens m\xedut"
            ],
            mm: [
                number + " m\xeduts",
                '' + number + " m\xeduts"
            ],
            h: [
                "'n \xfeora",
                "'iensa \xfeora"
            ],
            hh: [
                number + " \xfeoras",
                '' + number + " \xfeoras"
            ],
            d: [
                "'n ziua",
                "'iensa ziua"
            ],
            dd: [
                number + ' ziuas',
                '' + number + ' ziuas'
            ],
            M: [
                "'n mes",
                "'iens mes"
            ],
            MM: [
                number + ' mesen',
                '' + number + ' mesen'
            ],
            y: [
                "'n ar",
                "'iens ar"
            ],
            yy: [
                number + ' ars',
                '' + number + ' ars'
            ]
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }
    //! moment.js locale configuration
    moment.defineLocale('tzm-latn', {
        months: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split('_'),
        monthsShort: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split('_'),
        weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split('_'),
        weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split('_'),
        weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: "minu\u1E0D",
            mm: "%d minu\u1E0D",
            h: "sa\u025Ba",
            hh: "%d tassa\u025Bin",
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('tzm', {
        months: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split('_'),
        monthsShort: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split('_'),
        weekdays: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split('_'),
        weekdaysShort: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split('_'),
        weekdaysMin: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[\u2D30\u2D59\u2D37\u2D45 \u2D34] LT",
            nextDay: "[\u2D30\u2D59\u2D3D\u2D30 \u2D34] LT",
            nextWeek: "dddd [\u2D34] LT",
            lastDay: "[\u2D30\u2D5A\u2D30\u2D4F\u2D5C \u2D34] LT",
            lastWeek: "dddd [\u2D34] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u2D37\u2D30\u2D37\u2D45 \u2D59 \u2D62\u2D30\u2D4F %s",
            past: "\u2D62\u2D30\u2D4F %s",
            s: "\u2D49\u2D4E\u2D49\u2D3D",
            ss: "%d \u2D49\u2D4E\u2D49\u2D3D",
            m: "\u2D4E\u2D49\u2D4F\u2D53\u2D3A",
            mm: "%d \u2D4E\u2D49\u2D4F\u2D53\u2D3A",
            h: "\u2D59\u2D30\u2D44\u2D30",
            hh: "%d \u2D5C\u2D30\u2D59\u2D59\u2D30\u2D44\u2D49\u2D4F",
            d: "\u2D30\u2D59\u2D59",
            dd: "%d o\u2D59\u2D59\u2D30\u2D4F",
            M: "\u2D30\u2D62o\u2D53\u2D54",
            MM: "%d \u2D49\u2D62\u2D62\u2D49\u2D54\u2D4F",
            y: "\u2D30\u2D59\u2D33\u2D30\u2D59",
            yy: "%d \u2D49\u2D59\u2D33\u2D30\u2D59\u2D4F"
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('ug-cn', {
        months: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split('_'),
        monthsShort: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split('_'),
        weekdays: "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5_\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5_\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5_\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u062C\u06C8\u0645\u06D5_\u0634\u06D5\u0646\u0628\u06D5".split('_'),
        weekdaysShort: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split('_'),
        weekdaysMin: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649",
            LLL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm",
            LLLL: "dddd\u060C YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm"
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5" || meridiem === "\u0633\u06D5\u06BE\u06D5\u0631" || meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646") return hour;
            else if (meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646" || meridiem === "\u0643\u06D5\u0686") return hour + 12;
            else return hour >= 11 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5";
            else if (hm < 900) return "\u0633\u06D5\u06BE\u06D5\u0631";
            else if (hm < 1130) return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646";
            else if (hm < 1230) return "\u0686\u06C8\u0634";
            else if (hm < 1800) return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646";
            else return "\u0643\u06D5\u0686";
        },
        calendar: {
            sameDay: "[\u0628\u06C8\u06AF\u06C8\u0646 \u0633\u0627\u0626\u06D5\u062A] LT",
            nextDay: "[\u0626\u06D5\u062A\u06D5 \u0633\u0627\u0626\u06D5\u062A] LT",
            nextWeek: "[\u0643\u06D0\u0644\u06D5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
            lastDay: "[\u062A\u06C6\u0646\u06C8\u06AF\u06C8\u0646] LT",
            lastWeek: "[\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0643\u06D0\u064A\u0649\u0646",
            past: "%s \u0628\u06C7\u0631\u06C7\u0646",
            s: "\u0646\u06D5\u0686\u0686\u06D5 \u0633\u06D0\u0643\u0648\u0646\u062A",
            ss: "%d \u0633\u06D0\u0643\u0648\u0646\u062A",
            m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
            mm: "%d \u0645\u0649\u0646\u06C7\u062A",
            h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
            hh: "%d \u0633\u0627\u0626\u06D5\u062A",
            d: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
            dd: "%d \u0643\u06C8\u0646",
            M: "\u0628\u0649\u0631 \u0626\u0627\u064A",
            MM: "%d \u0626\u0627\u064A",
            y: "\u0628\u0649\u0631 \u064A\u0649\u0644",
            yy: "%d \u064A\u0649\u0644"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "-\u0643\u06C8\u0646\u0649";
                case 'w':
                case 'W':
                    return number + "-\u06BE\u06D5\u067E\u062A\u06D5";
                default:
                    return number;
            }
        },
        preparse: function(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural$6(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D",
            hh: withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D" : "\u0433\u043E\u0434\u0438\u043D\u0443_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u043D\u0456\u0432",
            MM: "\u043C\u0456\u0441\u044F\u0446\u044C_\u043C\u0456\u0441\u044F\u0446\u0456_\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            yy: "\u0440\u0456\u043A_\u0440\u043E\u043A\u0438_\u0440\u043E\u043A\u0456\u0432"
        };
        if (key === 'm') return withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443";
        else if (key === 'h') return withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430" : "\u0433\u043E\u0434\u0438\u043D\u0443";
        else return number + ' ' + plural$6(format[key], +number);
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            nominative: "\u043D\u0435\u0434\u0456\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F_\u0441\u0443\u0431\u043E\u0442\u0430".split('_'),
            accusative: "\u043D\u0435\u0434\u0456\u043B\u044E_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E_\u0441\u0443\u0431\u043E\u0442\u0443".split('_'),
            genitive: "\u043D\u0435\u0434\u0456\u043B\u0456_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430_\u0432\u0456\u0432\u0442\u043E\u0440\u043A\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u0456_\u0441\u0443\u0431\u043E\u0442\u0438".split('_')
        }, nounCase;
        if (m === true) return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        if (!m) return weekdays['nominative'];
        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function() {
            return str + "\u043E" + (this.hours() === 11 ? "\u0431" : '') + '] LT';
        };
    }
    moment.defineLocale('uk', {
        months: {
            format: "\u0441\u0456\u0447\u043D\u044F_\u043B\u044E\u0442\u043E\u0433\u043E_\u0431\u0435\u0440\u0435\u0437\u043D\u044F_\u043A\u0432\u0456\u0442\u043D\u044F_\u0442\u0440\u0430\u0432\u043D\u044F_\u0447\u0435\u0440\u0432\u043D\u044F_\u043B\u0438\u043F\u043D\u044F_\u0441\u0435\u0440\u043F\u043D\u044F_\u0432\u0435\u0440\u0435\u0441\u043D\u044F_\u0436\u043E\u0432\u0442\u043D\u044F_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043D\u044F".split('_'),
            standalone: "\u0441\u0456\u0447\u0435\u043D\u044C_\u043B\u044E\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C_\u043A\u0432\u0456\u0442\u0435\u043D\u044C_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u0435\u0440\u0432\u0435\u043D\u044C_\u043B\u0438\u043F\u0435\u043D\u044C_\u0441\u0435\u0440\u043F\u0435\u043D\u044C_\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C_\u0436\u043E\u0432\u0442\u0435\u043D\u044C_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043D\u044C".split('_')
        },
        monthsShort: "\u0441\u0456\u0447_\u043B\u044E\u0442_\u0431\u0435\u0440_\u043A\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043B\u0438\u043F_\u0441\u0435\u0440\u043F_\u0432\u0435\u0440_\u0436\u043E\u0432\u0442_\u043B\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split('_'),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split('_'),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: "D MMMM YYYY \u0440.",
            LLL: "D MMMM YYYY \u0440., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0440., HH:mm"
        },
        calendar: {
            sameDay: processHoursFunction("[\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 "),
            nextDay: processHoursFunction("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
            lastDay: processHoursFunction("[\u0412\u0447\u043E\u0440\u0430 "),
            nextWeek: processHoursFunction("[\u0423] dddd ["),
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0457] dddd [").call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0433\u043E] dddd [").call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "%s \u0442\u043E\u043C\u0443",
            s: "\u0434\u0435\u043A\u0456\u043B\u044C\u043A\u0430 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: relativeTimeWithPlural$4,
            m: relativeTimeWithPlural$4,
            mm: relativeTimeWithPlural$4,
            h: "\u0433\u043E\u0434\u0438\u043D\u0443",
            hh: relativeTimeWithPlural$4,
            d: "\u0434\u0435\u043D\u044C",
            dd: relativeTimeWithPlural$4,
            M: "\u043C\u0456\u0441\u044F\u0446\u044C",
            MM: relativeTimeWithPlural$4,
            y: "\u0440\u0456\u043A",
            yy: relativeTimeWithPlural$4
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function(input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u0456";
            else if (hour < 12) return "\u0440\u0430\u043D\u043A\u0443";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u043E\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function(number, period) {
            switch(period){
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + "-\u0439";
                case 'D':
                    return number + "-\u0433\u043E";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var months$a = [
        "\u062C\u0646\u0648\u0631\u06CC",
        "\u0641\u0631\u0648\u0631\u06CC",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067E\u0631\u06CC\u0644",
        "\u0645\u0626\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u0626\u06CC",
        "\u0627\u06AF\u0633\u062A",
        "\u0633\u062A\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u062F\u0633\u0645\u0628\u0631"
    ], days$1 = [
        "\u0627\u062A\u0648\u0627\u0631",
        "\u067E\u06CC\u0631",
        "\u0645\u0646\u06AF\u0644",
        "\u0628\u062F\u06BE",
        "\u062C\u0645\u0639\u0631\u0627\u062A",
        "\u062C\u0645\u0639\u06C1",
        "\u06C1\u0641\u062A\u06C1"
    ];
    moment.defineLocale('ur', {
        months: months$a,
        monthsShort: months$a,
        weekdays: days$1,
        weekdaysShort: days$1,
        weekdaysMin: days$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: "dddd\u060C D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function(input) {
            return "\u0634\u0627\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635\u0628\u062D";
            return "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0622\u062C \u0628\u0648\u0642\u062A] LT",
            nextDay: "[\u06A9\u0644 \u0628\u0648\u0642\u062A] LT",
            nextWeek: "dddd [\u0628\u0648\u0642\u062A] LT",
            lastDay: "[\u06AF\u0630\u0634\u062A\u06C1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062A] LT",
            lastWeek: "[\u06AF\u0630\u0634\u062A\u06C1] dddd [\u0628\u0648\u0642\u062A] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s \u0628\u0639\u062F",
            past: "%s \u0642\u0628\u0644",
            s: "\u0686\u0646\u062F \u0633\u06CC\u06A9\u0646\u0688",
            ss: "%d \u0633\u06CC\u06A9\u0646\u0688",
            m: "\u0627\u06CC\u06A9 \u0645\u0646\u0679",
            mm: "%d \u0645\u0646\u0679",
            h: "\u0627\u06CC\u06A9 \u06AF\u06BE\u0646\u0679\u06C1",
            hh: "%d \u06AF\u06BE\u0646\u0679\u06D2",
            d: "\u0627\u06CC\u06A9 \u062F\u0646",
            dd: "%d \u062F\u0646",
            M: "\u0627\u06CC\u06A9 \u0645\u0627\u06C1",
            MM: "%d \u0645\u0627\u06C1",
            y: "\u0627\u06CC\u06A9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('uz', {
        months: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split('_'),
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split('_'),
        weekdays: "\u042F\u043A\u0448\u0430\u043D\u0431\u0430_\u0414\u0443\u0448\u0430\u043D\u0431\u0430_\u0421\u0435\u0448\u0430\u043D\u0431\u0430_\u0427\u043E\u0440\u0448\u0430\u043D\u0431\u0430_\u041F\u0430\u0439\u0448\u0430\u043D\u0431\u0430_\u0416\u0443\u043C\u0430_\u0428\u0430\u043D\u0431\u0430".split('_'),
        weekdaysShort: "\u042F\u043A\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043E\u0440_\u041F\u0430\u0439_\u0416\u0443\u043C_\u0428\u0430\u043D".split('_'),
        weekdaysMin: "\u042F\u043A_\u0414\u0443_\u0421\u0435_\u0427\u043E_\u041F\u0430_\u0416\u0443_\u0428\u0430".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: "[\u0411\u0443\u0433\u0443\u043D \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            nextDay: "[\u042D\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
            nextWeek: "dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            lastDay: "[\u041A\u0435\u0447\u0430 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            lastWeek: "[\u0423\u0442\u0433\u0430\u043D] dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\u042F\u043A\u0438\u043D %s \u0438\u0447\u0438\u0434\u0430",
            past: "\u0411\u0438\u0440 \u043D\u0435\u0447\u0430 %s \u043E\u043B\u0434\u0438\u043D",
            s: "\u0444\u0443\u0440\u0441\u0430\u0442",
            ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
            m: "\u0431\u0438\u0440 \u0434\u0430\u043A\u0438\u043A\u0430",
            mm: "%d \u0434\u0430\u043A\u0438\u043A\u0430",
            h: "\u0431\u0438\u0440 \u0441\u043E\u0430\u0442",
            hh: "%d \u0441\u043E\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043A\u0443\u043D",
            dd: "%d \u043A\u0443\u043D",
            M: "\u0431\u0438\u0440 \u043E\u0439",
            MM: "%d \u043E\u0439",
            y: "\u0431\u0438\u0440 \u0439\u0438\u043B",
            yy: "%d \u0439\u0438\u043B"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('vi', {
        months: "th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split('_'),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
        monthsParseExact: true,
        weekdays: "ch\u1EE7 nh\u1EADt_th\u1EE9 hai_th\u1EE9 ba_th\u1EE9 t\u01B0_th\u1EE9 n\u0103m_th\u1EE9 s\xe1u_th\u1EE9 b\u1EA3y".split('_'),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function(input) {
            return /^ch$/i.test(input);
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? 'sa' : 'SA';
            else return isLower ? 'ch' : 'CH';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: "D MMMM [n\u0103m] YYYY",
            LLL: "D MMMM [n\u0103m] YYYY HH:mm",
            LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[H\xf4m nay l\xfac] LT",
            nextDay: "[Ng\xe0y mai l\xfac] LT",
            nextWeek: "dddd [tu\u1EA7n t\u1EDBi l\xfac] LT",
            lastDay: "[H\xf4m qua l\xfac] LT",
            lastWeek: "dddd [tu\u1EA7n tr\u01B0\u1EDBc l\xfac] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s t\u1EDBi",
            past: "%s tr\u01B0\u1EDBc",
            s: "v\xe0i gi\xe2y",
            ss: "%d gi\xe2y",
            m: "m\u1ED9t ph\xfat",
            mm: "%d ph\xfat",
            h: "m\u1ED9t gi\u1EDD",
            hh: "%d gi\u1EDD",
            d: "m\u1ED9t ng\xe0y",
            dd: "%d ng\xe0y",
            w: "m\u1ED9t tu\u1EA7n",
            ww: "%d tu\u1EA7n",
            M: "m\u1ED9t th\xe1ng",
            MM: "%d th\xe1ng",
            y: "m\u1ED9t n\u0103m",
            yy: "%d n\u0103m"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('x-pseudo', {
        months: "J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split('_'),
        monthsShort: "J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split('_'),
        monthsParseExact: true,
        weekdays: "S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split('_'),
        weekdaysShort: "S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split('_'),
        weekdaysMin: "S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[T~\xf3d\xe1~\xfd \xe1t] LT",
            nextDay: "[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",
            nextWeek: "dddd [\xe1t] LT",
            lastDay: "[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",
            lastWeek: "[L~\xe1st] dddd [\xe1t] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "\xed~\xf1 %s",
            past: "%s \xe1~g\xf3",
            s: "\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",
            ss: "%d s~\xe9c\xf3\xf1~ds",
            m: "\xe1 ~m\xed\xf1~\xfat\xe9",
            mm: "%d m~\xed\xf1\xfa~t\xe9s",
            h: "\xe1~\xf1 h\xf3~\xfar",
            hh: "%d h~\xf3\xfars",
            d: "\xe1 ~d\xe1\xfd",
            dd: "%d d~\xe1\xfds",
            M: "\xe1 ~m\xf3\xf1~th",
            MM: "%d m~\xf3\xf1t~hs",
            y: "\xe1 ~\xfd\xe9\xe1r",
            yy: "%d \xfd~\xe9\xe1rs"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('yo', {
        months: "S\u1EB9\u0301r\u1EB9\u0301_E\u0300re\u0300le\u0300_\u1EB8r\u1EB9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1EB9mo_O\u0300gu\u0301n_Owewe_\u1ECC\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ECC\u0300p\u1EB9\u0300\u0300".split('_'),
        monthsShort: "S\u1EB9\u0301r_E\u0300rl_\u1EB8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1EB9_O\u0300gu\u0301_Owe_\u1ECC\u0300wa\u0300_Be\u0301l_\u1ECC\u0300p\u1EB9\u0300\u0300".split('_'),
        weekdays: "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1EB9\u0301gun_\u1ECCj\u1ECD\u0301ru\u0301_\u1ECCj\u1ECD\u0301b\u1ECD_\u1EB8ti\u0300_A\u0300ba\u0301m\u1EB9\u0301ta".split('_'),
        weekdaysShort: "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1EB9\u0301_\u1ECCjr_\u1ECCjb_\u1EB8ti\u0300_A\u0300ba\u0301".split('_'),
        weekdaysMin: "A\u0300i\u0300_Aj_I\u0300s_\u1ECCr_\u1ECCb_\u1EB8t_A\u0300b".split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: "[O\u0300ni\u0300 ni] LT",
            nextDay: "[\u1ECC\u0300la ni] LT",
            nextWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301n'b\u1ECD] [ni] LT",
            lastDay: "[A\u0300na ni] LT",
            lastWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301l\u1ECD\u0301] [ni] LT",
            sameElse: 'L'
        },
        relativeTime: {
            future: "ni\u0301 %s",
            past: "%s k\u1ECDja\u0301",
            s: "i\u0300s\u1EB9ju\u0301 aaya\u0301 die",
            ss: "aaya\u0301 %d",
            m: "i\u0300s\u1EB9ju\u0301 kan",
            mm: "i\u0300s\u1EB9ju\u0301 %d",
            h: "wa\u0301kati kan",
            hh: "wa\u0301kati %d",
            d: "\u1ECDj\u1ECD\u0301 kan",
            dd: "\u1ECDj\u1ECD\u0301 %d",
            M: "osu\u0300 kan",
            MM: "osu\u0300 %d",
            y: "\u1ECDdu\u0301n kan",
            yy: "\u1ECDdu\u0301n %d"
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: "\u1ECDj\u1ECD\u0301 %d",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('zh-cn', {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split('_'),
        weekdaysShort: "\u5468\u65E5_\u5468\u4E00_\u5468\u4E8C_\u5468\u4E09_\u5468\u56DB_\u5468\u4E94_\u5468\u516D".split('_'),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5Ah\u70B9mm\u5206",
            LLLL: "YYYY\u5E74M\u6708D\u65E5ddddAh\u70B9mm\u5206",
            l: 'YYYY/M/D',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
            else // '中午'
            return hour >= 11 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929]LT",
            nextDay: "[\u660E\u5929]LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) return "[\u4E0B]dddLT";
                else return "[\u672C]dddLT";
            },
            lastDay: "[\u6628\u5929]LT",
            lastWeek: function(now) {
                if (this.week() !== now.week()) return "[\u4E0A]dddLT";
                else return "[\u672C]dddLT";
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                case 'M':
                    return number + "\u6708";
                case 'w':
                case 'W':
                    return number + "\u5468";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u540E",
            past: "%s\u524D",
            s: "\u51E0\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u949F",
            mm: "%d \u5206\u949F",
            h: "1 \u5C0F\u65F6",
            hh: "%d \u5C0F\u65F6",
            d: "1 \u5929",
            dd: "%d \u5929",
            w: "1 \u5468",
            ww: "%d \u5468",
            M: "1 \u4E2A\u6708",
            MM: "%d \u4E2A\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('zh-hk', {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split('_'),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split('_'),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: 'YYYY/M/D',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1200) return "\u4E0A\u5348";
            else if (hm === 1200) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929]LT",
            nextDay: "[\u660E\u5929]LT",
            nextWeek: "[\u4E0B]ddddLT",
            lastDay: "[\u6628\u5929]LT",
            lastWeek: "[\u4E0A]ddddLT",
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                case 'M':
                    return number + "\u6708";
                case 'w':
                case 'W':
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('zh-mo', {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split('_'),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split('_'),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: 'D/M/YYYY',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929] LT",
            nextDay: "[\u660E\u5929] LT",
            nextWeek: "[\u4E0B]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4E0A]dddd LT",
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                case 'M':
                    return number + "\u6708";
                case 'w':
                case 'W':
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5167",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale('zh-tw', {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split('_'),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split('_'),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split('_'),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split('_'),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: 'YYYY/M/D',
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929] LT",
            nextDay: "[\u660E\u5929] LT",
            nextWeek: "[\u4E0B]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4E0A]dddd LT",
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case 'd':
                case 'D':
                case 'DDD':
                    return number + "\u65E5";
                case 'M':
                    return number + "\u6708";
                case 'w':
                case 'W':
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    moment.locale('en');
    return moment;
});

},{"b26f676d67bbe12f":"fAGp8"}],"2hd2R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_TIME_FORMAT", ()=>DATE_TIME_FORMAT);
parcelHelpers.export(exports, "MONTHS", ()=>MONTHS);
parcelHelpers.export(exports, "DAYS", ()=>DAYS);
const DATE_TIME_FORMAT = 'YYYY-MM-DD';
const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const DAYS = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
    'Day',
    'Weekday',
    'Weekend day'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aLp4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lodash = require("lodash");
const replacePlaceholder = (text, replacements = {})=>{
    (0, _lodash.each)(replacements, (value, key)=>{
        text = text.replace(`%{${key}}`, value);
    });
    return text;
};
const translateLabel = (translations, key, replacements = {})=>{
    if ((0, _lodash.isFunction)(translations)) return translations(key, replacements);
    else if ((0, _lodash.isPlainObject)(translations)) return replacePlaceholder((0, _lodash.get)(translations, key, `[translation missing '${key}']`), replacements);
    return null;
};
exports.default = translateLabel;

},{"lodash":"fIO2m","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"55UVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _index = require("./Yearly/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("./Monthly/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _index2 = require("./Weekly/index");
var _indexDefault2 = parcelHelpers.interopDefault(_index2);
var _index3 = require("./Daily/index");
var _indexDefault3 = parcelHelpers.interopDefault(_index3);
var _index4 = require("./Hourly/index");
var _indexDefault4 = parcelHelpers.interopDefault(_index4);
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const Repeat = ({ id, repeat: { frequency, yearly, monthly, weekly, daily, hourly, options }, handleChange, translations })=>{
    const isOptionAvailable = (option)=>!options.frequency || options.frequency.indexOf(option) !== -1;
    const isOptionSelected = (option)=>frequency === option;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "field",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "select",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            name: "repeat.frequency",
                            id: `${id}-frequency`,
                            value: frequency,
                            onChange: handleChange,
                            children: [
                                isOptionAvailable("Yearly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Yearly",
                                    children: (0, _translateLabelDefault.default)(translations, "repeat.yearly.label")
                                }),
                                isOptionAvailable("Monthly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Monthly",
                                    children: (0, _translateLabelDefault.default)(translations, "repeat.monthly.label")
                                }),
                                isOptionAvailable("Weekly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Weekly",
                                    children: (0, _translateLabelDefault.default)(translations, "repeat.weekly.label")
                                }),
                                isOptionAvailable("Daily") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Daily",
                                    children: (0, _translateLabelDefault.default)(translations, "repeat.daily.label")
                                }),
                                isOptionAvailable("Hourly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Hourly",
                                    children: (0, _translateLabelDefault.default)(translations, "repeat.hourly.label")
                                })
                            ]
                        })
                    })
                })
            }),
            isOptionSelected("Yearly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault.default), {
                id: `${id}-yearly`,
                yearly: yearly,
                handleChange: handleChange,
                translations: translations
            }),
            isOptionSelected("Monthly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault1.default), {
                id: `${id}-monthly`,
                monthly: monthly,
                handleChange: handleChange,
                translations: translations
            }),
            isOptionSelected("Weekly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault2.default), {
                id: `${id}-weekly`,
                weekly: weekly,
                handleChange: handleChange,
                translations: translations
            }),
            isOptionSelected("Daily") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault3.default), {
                id: `${id}-daily`,
                daily: daily,
                handleChange: handleChange,
                translations: translations
            }),
            isOptionSelected("Hourly") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault4.default), {
                id: `${id}-hourly`,
                hourly: hourly,
                handleChange: handleChange,
                translations: translations
            })
        ]
    });
};
Repeat.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    repeat: (0, _propTypesDefault.default).shape({
        frequency: (0, _propTypesDefault.default).oneOf([
            "Yearly",
            "Monthly",
            "Weekly",
            "Daily",
            "Hourly"
        ]).isRequired,
        yearly: (0, _propTypesDefault.default).object.isRequired,
        monthly: (0, _propTypesDefault.default).object.isRequired,
        weekly: (0, _propTypesDefault.default).object.isRequired,
        daily: (0, _propTypesDefault.default).object.isRequired,
        hourly: (0, _propTypesDefault.default).object.isRequired,
        options: (0, _propTypesDefault.default).shape({
            frequency: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
                "Yearly",
                "Monthly",
                "Weekly",
                "Daily",
                "Hourly"
            ])),
            yearly: (0, _propTypesDefault.default).oneOf([
                "on",
                "on the"
            ]),
            monthly: (0, _propTypesDefault.default).oneOf([
                "on",
                "on the"
            ])
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = Repeat;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","./Yearly/index":"9XUeh","./Monthly/index":"dVklG","./Weekly/index":"kkSIX","./Daily/index":"gAjjD","./Hourly/index":"6K1X5","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9XUeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _on = require("./On");
var _onDefault = parcelHelpers.interopDefault(_on);
var _onThe = require("./OnThe");
var _onTheDefault = parcelHelpers.interopDefault(_onThe);
const RepeatYearly = ({ id, yearly: { mode, on, onThe, options }, handleChange, translations })=>{
    const isTheOnlyOneMode = (option)=>options.modes === option;
    const isOptionAvailable = (option)=>!options.modes || isTheOnlyOneMode(option);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            isOptionAvailable("on") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onDefault.default), {
                id: `${id}-on`,
                mode: mode,
                on: on,
                hasMoreModes: !isTheOnlyOneMode("on"),
                handleChange: handleChange,
                translations: translations
            }),
            isOptionAvailable("on the") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onTheDefault.default), {
                id: `${id}-onThe`,
                mode: mode,
                onThe: onThe,
                hasMoreModes: !isTheOnlyOneMode("on the"),
                handleChange: handleChange,
                translations: translations
            })
        ]
    });
};
RepeatYearly.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    yearly: (0, _propTypesDefault.default).shape({
        mode: (0, _propTypesDefault.default).oneOf([
            "on",
            "on the"
        ]).isRequired,
        on: (0, _propTypesDefault.default).object.isRequired,
        onThe: (0, _propTypesDefault.default).object.isRequired,
        options: (0, _propTypesDefault.default).shape({
            modes: (0, _propTypesDefault.default).oneOf([
                "on",
                "on the"
            ])
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatYearly;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","./On":"fLPly","./OnThe":"fPY4q","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fLPly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _index = require("../../../constants/index");
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatYearlyOn = ({ id, mode, on, hasMoreModes, handleChange, translations })=>{
    const daysInMonth = (0, _momentDefault.default)(on.month, "MMM").daysInMonth();
    const isActive = mode === "on";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `field is-grouped ${!isActive && "opacity-50"} columns is-multiline is-mobile is-vcentered`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: hasMoreModes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: id,
                    type: "radio",
                    name: "repeat.yearly.mode",
                    "aria-label": "Repeat yearly on",
                    value: "on",
                    checked: isActive,
                    onChange: handleChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.yearly.on")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-month`,
                        name: "repeat.yearly.on.month",
                        "aria-label": "Repeat yearly on month",
                        value: on.month,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: (0, _index.MONTHS).map((month)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: month,
                                children: (0, _translateLabelDefault.default)(translations, `months.${month.toLowerCase()}`)
                            }, month))
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-day`,
                        name: "repeat.yearly.on.day",
                        "aria-label": "Repeat yearly on a day",
                        value: on.day,
                        disabled: !isActive,
                        onChange: (0, _numericalFieldHandlerDefault.default)(handleChange),
                        children: (0, _lodash.range)(0, daysInMonth).map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: i + 1,
                                children: i + 1
                            }, i))
                    })
                })
            })
        ]
    });
};
RepeatYearlyOn.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    mode: (0, _propTypesDefault.default).oneOf([
        "on",
        "on the"
    ]).isRequired,
    on: (0, _propTypesDefault.default).shape({
        month: (0, _propTypesDefault.default).oneOf((0, _index.MONTHS)).isRequired,
        day: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    hasMoreModes: (0, _propTypesDefault.default).bool.isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatYearlyOn;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","moment":"fAGp8","lodash":"fIO2m","../../../utils/numericalFieldHandler":"hmoFr","../../../constants/index":"2hd2R","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hmoFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lodash = require("lodash");
const numericalFieldHandler = (callback)=>(event)=>{
        // Convert input from a string to a number
        const inputNumber = +event.target.value;
        // Check if is a number and is less than 1000
        if ((0, _lodash.isNaN)(inputNumber) || inputNumber >= 1000) return;
        const editedEvent = {
            target: {
                value: inputNumber,
                name: event.target.name
            }
        };
        callback(editedEvent);
    };
exports.default = numericalFieldHandler;

},{"lodash":"fIO2m","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fPY4q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _index = require("../../../constants/index");
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatYearlyOnThe = ({ id, mode, onThe, hasMoreModes, handleChange, translations })=>{
    const isActive = mode === "on the";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `field is-grouped ${!isActive && "opacity-50"} columns is-multiline is-mobile is-vcentered`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: hasMoreModes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: id,
                    type: "radio",
                    "aria-label": "Repeat yearly on the",
                    name: "repeat.yearly.mode",
                    checked: isActive,
                    value: "on the",
                    onChange: handleChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.yearly.on_the")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        id: `${id}-which`,
                        name: "repeat.yearly.onThe.which",
                        "aria-label": "Repeat yearly on the which",
                        value: onThe.which,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "First",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.first")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Second",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.second")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Third",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.third")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Fourth",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.fourth")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Last",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.last")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-day`,
                        name: "repeat.yearly.onThe.day",
                        "aria-label": "Repeat yearly on the day",
                        value: onThe.day,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: (0, _index.DAYS).map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: day,
                                children: (0, _translateLabelDefault.default)(translations, `days.${day.toLowerCase()}`)
                            }, day))
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.yearly.of")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-month`,
                        name: "repeat.yearly.onThe.month",
                        "aria-label": "Repeat yearly on the month",
                        value: onThe.month,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: (0, _index.MONTHS).map((month)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: month,
                                children: (0, _translateLabelDefault.default)(translations, `months.${month.toLowerCase()}`)
                            }, month))
                    })
                })
            })
        ]
    });
};
RepeatYearlyOnThe.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    mode: (0, _propTypesDefault.default).oneOf([
        "on",
        "on the"
    ]).isRequired,
    onThe: (0, _propTypesDefault.default).shape({
        which: (0, _propTypesDefault.default).oneOf([
            "First",
            "Second",
            "Third",
            "Fourth",
            "Last"
        ]).isRequired,
        month: (0, _propTypesDefault.default).oneOf((0, _index.MONTHS)).isRequired,
        day: (0, _propTypesDefault.default).oneOf((0, _index.DAYS)).isRequired
    }).isRequired,
    hasMoreModes: (0, _propTypesDefault.default).bool.isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatYearlyOnThe;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../../constants/index":"2hd2R","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dVklG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _on = require("./On");
var _onDefault = parcelHelpers.interopDefault(_on);
var _onThe = require("./OnThe");
var _onTheDefault = parcelHelpers.interopDefault(_onThe);
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatMonthly = ({ id, monthly: { mode, interval, on, onThe, options }, handleChange, translations })=>{
    const isTheOnlyOneMode = (option)=>options.modes === option;
    const isOptionAvailable = (option)=>!options.modes || isTheOnlyOneMode(option);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "field is-grouped columns is-multiline is-mobile is-vcentered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: (0, _translateLabelDefault.default)(translations, "repeat.monthly.every")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            id: `${id}-interval`,
                            name: "repeat.monthly.interval",
                            "aria-label": "Repeat monthly interval",
                            className: "input",
                            value: interval,
                            onChange: (0, _numericalFieldHandlerDefault.default)(handleChange)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: (0, _translateLabelDefault.default)(translations, "repeat.monthly.months")
                    })
                ]
            }),
            isOptionAvailable("on") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onDefault.default), {
                id: `${id}-on`,
                mode: mode,
                on: on,
                hasMoreModes: !isTheOnlyOneMode("on"),
                handleChange: handleChange,
                translations: translations
            }),
            isOptionAvailable("on the") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onTheDefault.default), {
                id: `${id}-onThe`,
                mode: mode,
                onThe: onThe,
                hasMoreModes: !isTheOnlyOneMode("on the"),
                handleChange: handleChange,
                translations: translations
            })
        ]
    });
};
RepeatMonthly.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    monthly: (0, _propTypesDefault.default).shape({
        mode: (0, _propTypesDefault.default).oneOf([
            "on",
            "on the"
        ]).isRequired,
        interval: (0, _propTypesDefault.default).number.isRequired,
        on: (0, _propTypesDefault.default).object.isRequired,
        onThe: (0, _propTypesDefault.default).object.isRequired,
        options: (0, _propTypesDefault.default).shape({
            modes: (0, _propTypesDefault.default).oneOf([
                "on",
                "on the"
            ])
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatMonthly;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","./On":"drkDA","./OnThe":"6PSXO","../../../utils/numericalFieldHandler":"hmoFr","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"drkDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatMonthlyOn = ({ id, mode, on, hasMoreModes, handleChange, translations })=>{
    const isActive = mode === "on";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `field is-grouped ${!isActive && "opacity-50"} columns is-multiline is-mobile is-vcentered`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: hasMoreModes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: id,
                    type: "radio",
                    name: "repeat.monthly.mode",
                    "aria-label": "Repeat monthly on",
                    value: "on",
                    checked: isActive,
                    onChange: handleChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.monthly.on_day")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-day`,
                        name: "repeat.monthly.on.day",
                        "aria-label": "Repeat monthly on a day",
                        value: on.day,
                        disabled: !isActive,
                        onChange: (0, _numericalFieldHandlerDefault.default)(handleChange),
                        children: [
                            ...new Array(31)
                        ].map((day, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: i + 1,
                                children: i + 1
                            }, i))
                    })
                })
            })
        ]
    });
};
RepeatMonthlyOn.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    mode: (0, _propTypesDefault.default).oneOf([
        "on",
        "on the"
    ]).isRequired,
    on: (0, _propTypesDefault.default).shape({
        day: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    hasMoreModes: (0, _propTypesDefault.default).bool.isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatMonthlyOn;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../../utils/numericalFieldHandler":"hmoFr","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6PSXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _index = require("../../../constants/index");
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatMonthlyOnThe = ({ id, mode, onThe, hasMoreModes, handleChange, translations })=>{
    const isActive = mode === "on the";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `field is-grouped ${!isActive && "opacity-50"} columns is-multiline is-mobile is-vcentered`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: hasMoreModes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: id,
                    type: "radio",
                    name: "repeat.monthly.mode",
                    "aria-label": "Repeat monthly on the",
                    value: "on the",
                    checked: isActive,
                    onChange: handleChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.monthly.on_the")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        id: `${id}-which`,
                        name: "repeat.monthly.onThe.which",
                        "aria-label": "Repeat monthly on the which",
                        value: onThe.which,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "First",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.first")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Second",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.second")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Third",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.third")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Fourth",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.fourth")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "Last",
                                children: (0, _translateLabelDefault.default)(translations, "numerals.last")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "select",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        id: `${id}-day`,
                        name: "repeat.monthly.onThe.day",
                        "aria-label": "Repeat monthly on the day",
                        value: onThe.day,
                        disabled: !isActive,
                        onChange: handleChange,
                        children: (0, _index.DAYS).map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: day,
                                children: (0, _translateLabelDefault.default)(translations, `days.${day.toLowerCase()}`)
                            }, day))
                    })
                })
            })
        ]
    });
};
RepeatMonthlyOnThe.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    mode: (0, _propTypesDefault.default).oneOf([
        "on",
        "on the"
    ]).isRequired,
    onThe: (0, _propTypesDefault.default).shape({
        which: (0, _propTypesDefault.default).oneOf([
            "First",
            "Second",
            "Third",
            "Fourth",
            "Last"
        ]).isRequired,
        day: (0, _propTypesDefault.default).oneOf((0, _index.DAYS)).isRequired
    }).isRequired,
    hasMoreModes: (0, _propTypesDefault.default).bool.isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatMonthlyOnThe;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../../constants/index":"2hd2R","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kkSIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _lodash = require("lodash");
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatWeekly = ({ id, weekly: { interval, days, options }, handleChange, translations })=>{
    let daysArray = (0, _lodash.toPairs)(days);
    if (options.weekStartsOnSunday) daysArray = daysArray.slice(-1).concat(daysArray.slice(0, -1));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "field is-grouped columns is-multiline is-mobile is-vcentered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: (0, _translateLabelDefault.default)(translations, "repeat.weekly.every")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            id: `${id}-interval`,
                            name: "repeat.weekly.interval",
                            "aria-label": "Repeat weekly interval",
                            className: "input",
                            value: interval,
                            onChange: (0, _numericalFieldHandlerDefault.default)(handleChange)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control column is-narrow",
                        children: (0, _translateLabelDefault.default)(translations, "repeat.weekly.weeks")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "field has-addons column is-narrow",
                children: daysArray.map(([dayName, isDayActive])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "control",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            htmlFor: `${id}-${dayName}`,
                            className: `button ${isDayActive ? "is-primary" : ""}`,
                            name: `repeat.weekly.days[${dayName}]`,
                            onClick: (event)=>{
                                const editedEvent = {
                                    ...event,
                                    target: {
                                        ...event.currentTarget,
                                        value: !isDayActive,
                                        name: event.currentTarget.name
                                    }
                                };
                                handleChange(editedEvent);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: (0, _translateLabelDefault.default)(translations, `days_short.${dayName.toLowerCase()}`)
                            })
                        })
                    }, dayName))
            })
        ]
    });
};
RepeatWeekly.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    weekly: (0, _propTypesDefault.default).shape({
        interval: (0, _propTypesDefault.default).number.isRequired,
        days: (0, _propTypesDefault.default).shape({
            mon: (0, _propTypesDefault.default).bool.isRequired,
            tue: (0, _propTypesDefault.default).bool.isRequired,
            wed: (0, _propTypesDefault.default).bool.isRequired,
            thu: (0, _propTypesDefault.default).bool.isRequired,
            fri: (0, _propTypesDefault.default).bool.isRequired,
            sat: (0, _propTypesDefault.default).bool.isRequired,
            sun: (0, _propTypesDefault.default).bool.isRequired
        }).isRequired,
        options: (0, _propTypesDefault.default).shape({
            weekStartsOnSunday: (0, _propTypesDefault.default).bool
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatWeekly;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","lodash":"fIO2m","../../../utils/numericalFieldHandler":"hmoFr","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gAjjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatDaily = ({ id, daily: { interval }, handleChange, translations })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field is-grouped columns is-multiline is-mobile is-vcentered",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.daily.every")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: `${id}-interval`,
                    name: "repeat.daily.interval",
                    "aria-label": "Repeat daily interval",
                    className: "input",
                    value: interval,
                    onChange: (0, _numericalFieldHandlerDefault.default)(handleChange)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.daily.days")
            })
        ]
    });
RepeatDaily.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    daily: (0, _propTypesDefault.default).shape({
        interval: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatDaily;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../../utils/numericalFieldHandler":"hmoFr","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6K1X5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _numericalFieldHandler = require("../../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const RepeatHourly = ({ id, hourly: { interval }, handleChange, translations })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field is-grouped columns is-multiline is-mobile is-vcentered",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.hourly.every")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: `${id}-interval`,
                    name: "repeat.hourly.interval",
                    "aria-label": "Repeat hourly interval",
                    className: "input",
                    value: interval,
                    onChange: (0, _numericalFieldHandlerDefault.default)(handleChange)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control column is-narrow",
                children: (0, _translateLabelDefault.default)(translations, "repeat.hourly.hours")
            })
        ]
    });
RepeatHourly.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    hourly: (0, _propTypesDefault.default).shape({
        interval: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = RepeatHourly;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../../utils/numericalFieldHandler":"hmoFr","../../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lbBEO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _after = require("./After");
var _afterDefault = parcelHelpers.interopDefault(_after);
var _onDate = require("./OnDate");
var _onDateDefault = parcelHelpers.interopDefault(_onDate);
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const End = ({ id, end: { mode, after, onDate, options }, handleChange, translations })=>{
    const isOptionAvailable = (option)=>!options.modes || options.modes.indexOf(option) !== -1;
    const isOptionSelected = (option)=>mode === option;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: id,
                        className: "my-2 label is-size-5",
                        children: (0, _translateLabelDefault.default)(translations, "end.label")
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "select",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            name: "end.mode",
                            id: id,
                            value: mode,
                            onChange: handleChange,
                            children: [
                                isOptionAvailable("Never") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "Never",
                                    children: (0, _translateLabelDefault.default)(translations, "end.never")
                                }),
                                isOptionAvailable("After") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "After",
                                    children: (0, _translateLabelDefault.default)(translations, "end.after")
                                }),
                                isOptionAvailable("On date") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "On date",
                                    children: (0, _translateLabelDefault.default)(translations, "end.on_date")
                                })
                            ]
                        })
                    })
                }),
                isOptionSelected("After") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _afterDefault.default), {
                    id: `${id}-after`,
                    after: after,
                    handleChange: handleChange,
                    translations: translations
                }),
                isOptionSelected("On date") && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onDateDefault.default), {
                    id: `${id}-onDate`,
                    onDate: onDate,
                    handleChange: handleChange,
                    translations: translations
                })
            ]
        })
    });
};
End.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    end: (0, _propTypesDefault.default).shape({
        mode: (0, _propTypesDefault.default).string.isRequired,
        after: (0, _propTypesDefault.default).number.isRequired,
        onDate: (0, _propTypesDefault.default).object.isRequired,
        options: (0, _propTypesDefault.default).shape({
            modes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
                "Never",
                "After",
                "On date"
            ])),
            weekStartsOnSunday: (0, _propTypesDefault.default).bool
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = End;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","./After":"lCOJd","./OnDate":"54CCK","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lCOJd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _numericalFieldHandler = require("../../utils/numericalFieldHandler");
var _numericalFieldHandlerDefault = parcelHelpers.interopDefault(_numericalFieldHandler);
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const EndAfter = ({ id, after, handleChange, translations })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field is-grouped items-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: id,
                    name: "end.after",
                    "aria-label": "End after",
                    className: "input",
                    value: after,
                    onChange: (0, _numericalFieldHandlerDefault.default)(handleChange)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control",
                children: (0, _translateLabelDefault.default)(translations, "end.executions")
            })
        ]
    });
EndAfter.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    after: (0, _propTypesDefault.default).number.isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = EndAfter;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","../../utils/numericalFieldHandler":"hmoFr","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"54CCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactDatetime = require("react-datetime");
var _reactDatetimeDefault = parcelHelpers.interopDefault(_reactDatetime);
var _locales = require("moment/min/locales");
var _index = require("../../constants/index");
var _translateLabel = require("../../utils/translateLabel");
var _translateLabelDefault = parcelHelpers.interopDefault(_translateLabel);
const EndOnDate = ({ id, onDate: { date, options }, handleChange, translations })=>{
    const CustomCalendar = options.calendarComponent;
    const locale = options.weekStartsOnSunday ? "en-ca" : "en-gb";
    const calendarAttributes = {
        "aria-label": (0, _translateLabelDefault.default)(translations, "end.tooltip"),
        value: date,
        dateFormat: (0, _index.DATE_TIME_FORMAT),
        locale,
        readOnly: true
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "field",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "control",
            children: CustomCalendar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomCalendar, {
                ...calendarAttributes,
                onChange: (event)=>{
                    const editedEvent = {
                        target: {
                            value: event.target.value,
                            name: "end.onDate.date"
                        }
                    };
                    handleChange(editedEvent);
                }
            }, `${id}-calendar`) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatetimeDefault.default), {
                ...calendarAttributes,
                inputProps: {
                    id: `${id}-datetime`,
                    name: "end.onDate.date",
                    readOnly: true,
                    className: "input w-fit"
                },
                locale: (0, _translateLabelDefault.default)(translations, "locale"),
                timeFormat: false,
                viewMode: "days",
                closeOnTab: true,
                required: true,
                onChange: (inputDate)=>{
                    const editedEvent = {
                        target: {
                            value: (0, _momentDefault.default)(inputDate).format((0, _index.DATE_TIME_FORMAT)),
                            name: "end.onDate.date"
                        }
                    };
                    handleChange(editedEvent);
                }
            })
        })
    });
};
EndOnDate.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    onDate: (0, _propTypesDefault.default).shape({
        date: (0, _propTypesDefault.default).string.isRequired,
        options: (0, _propTypesDefault.default).shape({
            weekStartsOnSunday: (0, _propTypesDefault.default).bool,
            calendarComponent: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).element,
                (0, _propTypesDefault.default).func
            ])
        }).isRequired
    }).isRequired,
    handleChange: (0, _propTypesDefault.default).func.isRequired,
    translations: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
exports.default = EndOnDate;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","moment":"fAGp8","react-datetime":"9rHsb","moment/min/locales":"5rDUU","../../constants/index":"2hd2R","../../utils/translateLabel":"aLp4B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1j9RE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
var _computeStart = require("./computeStart");
var _computeStartDefault = parcelHelpers.interopDefault(_computeStart);
var _computeRepeat = require("./computeRepeat");
var _computeRepeatDefault = parcelHelpers.interopDefault(_computeRepeat);
var _computeEnd = require("./computeEnd");
var _computeEndDefault = parcelHelpers.interopDefault(_computeEnd);
var _computeOptions = require("./computeOptions");
var _computeOptionsDefault = parcelHelpers.interopDefault(_computeOptions);
const computeRRule = ({ start, repeat, end, options })=>{
    const rruleObject = {
        ...(0, _computeStartDefault.default)(start),
        ...(0, _computeRepeatDefault.default)(repeat),
        ...(0, _computeEndDefault.default)(end),
        ...(0, _computeOptionsDefault.default)(options)
    };
    const rrule = new (0, _rrule.RRule)(rruleObject);
    return rrule.toString();
};
exports.default = computeRRule;

},{"rrule":"ilLpP","./computeStart":"vrIc5","./computeRepeat":"4FpVD","./computeEnd":"fcH6F","./computeOptions":"1yG3U","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"vrIc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const computeStart = ({ onDate: { date } })=>{
    // verify that incoming date is valid
    // by seeing if it can be converted into a moment object.
    // if not, then create a new date
    if (!(0, _momentDefault.default).isMoment((0, _momentDefault.default)(date))) date = new Date().setMilliseconds(0);
    return {
        dtstart: (0, _momentDefault.default)(date).toDate()
    };
};
exports.default = computeStart;

},{"moment":"fAGp8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4FpVD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeYearly = require("./computeYearly");
var _computeYearlyDefault = parcelHelpers.interopDefault(_computeYearly);
var _computeMonthly = require("./computeMonthly");
var _computeMonthlyDefault = parcelHelpers.interopDefault(_computeMonthly);
var _computeWeekly = require("./computeWeekly");
var _computeWeeklyDefault = parcelHelpers.interopDefault(_computeWeekly);
var _computeDaily = require("./computeDaily");
var _computeDailyDefault = parcelHelpers.interopDefault(_computeDaily);
var _computeHourly = require("./computeHourly");
var _computeHourlyDefault = parcelHelpers.interopDefault(_computeHourly);
const computeRepeat = ({ frequency, yearly, monthly, weekly, daily, hourly })=>{
    switch(frequency){
        case 'Yearly':
            return (0, _computeYearlyDefault.default)(yearly);
        case 'Monthly':
            return (0, _computeMonthlyDefault.default)(monthly);
        case 'Weekly':
            return (0, _computeWeeklyDefault.default)(weekly);
        case 'Daily':
            return (0, _computeDailyDefault.default)(daily);
        case 'Hourly':
            return (0, _computeHourlyDefault.default)(hourly);
        default:
            return {};
    }
};
exports.default = computeRepeat;

},{"./computeYearly":"aq5kT","./computeMonthly":"8jPYu","./computeWeekly":"xeVPs","./computeDaily":"aJJCf","./computeHourly":"g2S6b","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aq5kT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
var _computeYearlyOn = require("./computeYearlyOn");
var _computeYearlyOnDefault = parcelHelpers.interopDefault(_computeYearlyOn);
var _computeYearlyOnThe = require("./computeYearlyOnThe");
var _computeYearlyOnTheDefault = parcelHelpers.interopDefault(_computeYearlyOnThe);
const computeYearly = ({ mode, on, onThe })=>({
        freq: (0, _rrule.RRule).YEARLY,
        ...mode === "on" ? (0, _computeYearlyOnDefault.default)(on) : (0, _computeYearlyOnTheDefault.default)(onThe)
    });
exports.default = computeYearly;

},{"rrule":"ilLpP","./computeYearlyOn":"kSs3U","./computeYearlyOnThe":"eXOO4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kSs3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../../constants/index");
const computeYearlyOn = (on)=>({
        bymonth: (0, _index.MONTHS).indexOf(on.month) + 1,
        bymonthday: on.day
    });
exports.default = computeYearlyOn;

},{"../../../constants/index":"2hd2R","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eXOO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../../constants/index");
const computeYearlyOnThe = (onThe)=>{
    const repeat = {};
    switch(onThe.which){
        case 'First':
            repeat.bysetpos = 1;
            break;
        case 'Second':
            repeat.bysetpos = 2;
            break;
        case 'Third':
            repeat.bysetpos = 3;
            break;
        case 'Fourth':
            repeat.bysetpos = 4;
            break;
        case 'Last':
            repeat.bysetpos = -1;
            break;
        default:
            break;
    }
    switch(onThe.day){
        case 'Monday':
            repeat.byweekday = [
                0
            ];
            break;
        case 'Tuesday':
            repeat.byweekday = [
                1
            ];
            break;
        case 'Wednesday':
            repeat.byweekday = [
                2
            ];
            break;
        case 'Thursday':
            repeat.byweekday = [
                3
            ];
            break;
        case 'Friday':
            repeat.byweekday = [
                4
            ];
            break;
        case 'Saturday':
            repeat.byweekday = [
                5
            ];
            break;
        case 'Sunday':
            repeat.byweekday = [
                6
            ];
            break;
        case 'Day':
            repeat.byweekday = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            break;
        case 'Weekday':
            repeat.byweekday = [
                0,
                1,
                2,
                3,
                4
            ];
            break;
        case 'Weekend day':
            repeat.byweekday = [
                5,
                6
            ];
            break;
        default:
            break;
    }
    repeat.bymonth = (0, _index.MONTHS).indexOf(onThe.month) + 1;
    return repeat;
};
exports.default = computeYearlyOnThe;

},{"../../../constants/index":"2hd2R","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8jPYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
var _computeMonthlyOn = require("./computeMonthlyOn");
var _computeMonthlyOnDefault = parcelHelpers.interopDefault(_computeMonthlyOn);
var _computeMonthlyOnThe = require("./computeMonthlyOnThe");
var _computeMonthlyOnTheDefault = parcelHelpers.interopDefault(_computeMonthlyOnThe);
const computeMonthly = ({ mode, interval, on, onThe })=>({
        freq: (0, _rrule.RRule).MONTHLY,
        interval,
        ...mode === "on" ? (0, _computeMonthlyOnDefault.default)(on) : (0, _computeMonthlyOnTheDefault.default)(onThe)
    });
exports.default = computeMonthly;

},{"rrule":"ilLpP","./computeMonthlyOn":"kmAoe","./computeMonthlyOnThe":"lYjPR","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kmAoe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyOn = (on)=>({
        bymonthday: on.day
    });
exports.default = computeMonthlyOn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lYjPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyOnThe = (onThe)=>{
    const repeat = {};
    switch(onThe.which){
        case 'First':
            repeat.bysetpos = 1;
            break;
        case 'Second':
            repeat.bysetpos = 2;
            break;
        case 'Third':
            repeat.bysetpos = 3;
            break;
        case 'Fourth':
            repeat.bysetpos = 4;
            break;
        case 'Last':
            repeat.bysetpos = -1;
            break;
        default:
            break;
    }
    switch(onThe.day){
        case 'Monday':
            repeat.byweekday = [
                0
            ];
            break;
        case 'Tuesday':
            repeat.byweekday = [
                1
            ];
            break;
        case 'Wednesday':
            repeat.byweekday = [
                2
            ];
            break;
        case 'Thursday':
            repeat.byweekday = [
                3
            ];
            break;
        case 'Friday':
            repeat.byweekday = [
                4
            ];
            break;
        case 'Saturday':
            repeat.byweekday = [
                5
            ];
            break;
        case 'Sunday':
            repeat.byweekday = [
                6
            ];
            break;
        case 'Day':
            repeat.byweekday = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            break;
        case 'Weekday':
            repeat.byweekday = [
                0,
                1,
                2,
                3,
                4
            ];
            break;
        case 'Weekend day':
            repeat.byweekday = [
                5,
                6
            ];
            break;
        default:
            break;
    }
    return repeat;
};
exports.default = computeMonthlyOnThe;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"xeVPs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
var _lodash = require("lodash");
const computeWeekly = ({ interval, days })=>({
        freq: (0, _rrule.RRule).WEEKLY,
        interval,
        byweekday: (0, _lodash.values)(days).reduce((activeDays, isDayActive, dayIndex)=>isDayActive ? [
                ...activeDays,
                dayIndex
            ] : activeDays, [])
    });
exports.default = computeWeekly;

},{"rrule":"ilLpP","lodash":"fIO2m","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aJJCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
const computeDaily = ({ interval })=>({
        freq: (0, _rrule.RRule).DAILY,
        interval
    });
exports.default = computeDaily;

},{"rrule":"ilLpP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"g2S6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
const computeHourly = ({ interval })=>({
        freq: (0, _rrule.RRule).HOURLY,
        interval
    });
exports.default = computeHourly;

},{"rrule":"ilLpP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fcH6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const computeEnd = ({ mode, after, onDate: { date } })=>{
    const end = {};
    if (mode === 'After') end.count = after;
    if (mode === 'On date') end.until = (0, _momentDefault.default)(date).format();
    return end;
};
exports.default = computeEnd;

},{"moment":"fAGp8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1yG3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
const computeOptions = ({ hideStart, weekStartsOnSunday })=>{
    const options = {};
    if (hideStart) options.dtstart = null;
    if (weekStartsOnSunday) options.wkst = (0, _rrule.RRule).SU;
    return options;
};
exports.default = computeOptions;

},{"rrule":"ilLpP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cNM48":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rrule = require("rrule");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _index = require("../../../constants/index");
var _computeStartOnDate = require("./computeStartOnDate");
var _computeStartOnDateDefault = parcelHelpers.interopDefault(_computeStartOnDate);
var _computeFrequency = require("./computeFrequency");
var _computeFrequencyDefault = parcelHelpers.interopDefault(_computeFrequency);
var _computeYearlyMode = require("./computeYearlyMode");
var _computeYearlyModeDefault = parcelHelpers.interopDefault(_computeYearlyMode);
var _computeYearlyOnMonth = require("./computeYearlyOnMonth");
var _computeYearlyOnMonthDefault = parcelHelpers.interopDefault(_computeYearlyOnMonth);
var _computeYearlyOnMonthday = require("./computeYearlyOnMonthday");
var _computeYearlyOnMonthdayDefault = parcelHelpers.interopDefault(_computeYearlyOnMonthday);
var _computeYearlyOnTheMonth = require("./computeYearlyOnTheMonth");
var _computeYearlyOnTheMonthDefault = parcelHelpers.interopDefault(_computeYearlyOnTheMonth);
var _computeYearlyOnTheMonthday = require("./computeYearlyOnTheMonthday");
var _computeYearlyOnTheMonthdayDefault = parcelHelpers.interopDefault(_computeYearlyOnTheMonthday);
var _computeYearlyOnTheWhich = require("./computeYearlyOnTheWhich");
var _computeYearlyOnTheWhichDefault = parcelHelpers.interopDefault(_computeYearlyOnTheWhich);
var _computeMonthlyMode = require("./computeMonthlyMode");
var _computeMonthlyModeDefault = parcelHelpers.interopDefault(_computeMonthlyMode);
var _computeMonthlyInterval = require("./computeMonthlyInterval");
var _computeMonthlyIntervalDefault = parcelHelpers.interopDefault(_computeMonthlyInterval);
var _computeMonthlyOnDay = require("./computeMonthlyOnDay");
var _computeMonthlyOnDayDefault = parcelHelpers.interopDefault(_computeMonthlyOnDay);
var _computeMonthlyOnTheDay = require("./computeMonthlyOnTheDay");
var _computeMonthlyOnTheDayDefault = parcelHelpers.interopDefault(_computeMonthlyOnTheDay);
var _computeMonthlyOnTheWhich = require("./computeMonthlyOnTheWhich");
var _computeMonthlyOnTheWhichDefault = parcelHelpers.interopDefault(_computeMonthlyOnTheWhich);
var _computeWeeklyInterval = require("./computeWeeklyInterval");
var _computeWeeklyIntervalDefault = parcelHelpers.interopDefault(_computeWeeklyInterval);
var _computeWeeklyDays = require("./computeWeeklyDays");
var _computeWeeklyDaysDefault = parcelHelpers.interopDefault(_computeWeeklyDays);
var _computeWeekStartDay = require("./computeWeekStartDay");
var _computeWeekStartDayDefault = parcelHelpers.interopDefault(_computeWeekStartDay);
var _computeDailyInterval = require("./computeDailyInterval");
var _computeDailyIntervalDefault = parcelHelpers.interopDefault(_computeDailyInterval);
var _computeHourlyInterval = require("./computeHourlyInterval");
var _computeHourlyIntervalDefault = parcelHelpers.interopDefault(_computeHourlyInterval);
var _computeEndMode = require("./computeEndMode");
var _computeEndModeDefault = parcelHelpers.interopDefault(_computeEndMode);
var _computeEndAfter = require("./computeEndAfter");
var _computeEndAfterDefault = parcelHelpers.interopDefault(_computeEndAfter);
var _computeEndOnDate = require("./computeEndOnDate");
var _computeEndOnDateDefault = parcelHelpers.interopDefault(_computeEndOnDate);
const computeRRule = (data, rrule)=>{
    if (!rrule) return data;
    let newDataObj;
    try {
        const rruleObj = (0, _rrule.rrulestr)(rrule).origOptions;
        newDataObj = {
            ...data,
            start: {
                ...data.start,
                onDate: {
                    date: (0, _momentDefault.default)((0, _computeStartOnDateDefault.default)(data, rruleObj)).format((0, _index.DATE_TIME_FORMAT)),
                    options: {
                        ...data.start.onDate.options,
                        weekStartsOnSunday: (0, _computeWeekStartDayDefault.default)(data, rruleObj)
                    }
                }
            },
            repeat: {
                ...data.repeat,
                frequency: (0, _computeFrequencyDefault.default)(data, rruleObj),
                yearly: {
                    ...data.repeat.yearly,
                    mode: (0, _computeYearlyModeDefault.default)(data, rruleObj),
                    on: {
                        month: (0, _computeYearlyOnMonthDefault.default)(data, rruleObj),
                        day: (0, _computeYearlyOnMonthdayDefault.default)(data, rruleObj)
                    },
                    onThe: {
                        month: (0, _computeYearlyOnTheMonthDefault.default)(data, rruleObj),
                        day: (0, _computeYearlyOnTheMonthdayDefault.default)(data, rruleObj),
                        which: (0, _computeYearlyOnTheWhichDefault.default)(data, rruleObj)
                    }
                },
                monthly: {
                    ...data.repeat.monthly,
                    mode: (0, _computeMonthlyModeDefault.default)(data, rruleObj),
                    interval: (0, _computeMonthlyIntervalDefault.default)(data, rruleObj),
                    on: {
                        day: (0, _computeMonthlyOnDayDefault.default)(data, rruleObj)
                    },
                    onThe: {
                        day: (0, _computeMonthlyOnTheDayDefault.default)(data, rruleObj),
                        which: (0, _computeMonthlyOnTheWhichDefault.default)(data, rruleObj)
                    }
                },
                weekly: {
                    interval: (0, _computeWeeklyIntervalDefault.default)(data, rruleObj),
                    days: (0, _computeWeeklyDaysDefault.default)(data, rruleObj),
                    options: {
                        weekStartsOnSunday: (0, _computeWeekStartDayDefault.default)(data, rruleObj)
                    }
                },
                daily: {
                    interval: (0, _computeDailyIntervalDefault.default)(data, rruleObj)
                },
                hourly: {
                    interval: (0, _computeHourlyIntervalDefault.default)(data, rruleObj)
                }
            },
            end: {
                ...data.end,
                mode: (0, _computeEndModeDefault.default)(data, rruleObj),
                after: (0, _computeEndAfterDefault.default)(data, rruleObj),
                onDate: {
                    date: (0, _momentDefault.default)((0, _computeEndOnDateDefault.default)(data, rruleObj)).format((0, _index.DATE_TIME_FORMAT)),
                    options: {
                        ...data.end.onDate.options,
                        weekStartsOnSunday: (0, _computeWeekStartDayDefault.default)(data, rruleObj)
                    }
                }
            },
            options: {
                ...data.options,
                weekStartsOnSunday: (0, _computeWeekStartDayDefault.default)(data, rruleObj)
            },
            error: null
        };
    } catch (e) {
        return {
            ...data,
            error: {
                value: rrule,
                message: e
            }
        };
    }
    return newDataObj;
};
exports.default = computeRRule;

},{"rrule":"ilLpP","moment":"fAGp8","../../../constants/index":"2hd2R","./computeStartOnDate":"56Czv","./computeFrequency":"WN0Ec","./computeYearlyMode":"3kqTZ","./computeYearlyOnMonth":"lEzHH","./computeYearlyOnMonthday":"9xZwI","./computeYearlyOnTheMonth":"f9q3A","./computeYearlyOnTheMonthday":"42dT0","./computeYearlyOnTheWhich":"kvRlw","./computeMonthlyMode":"gcP6A","./computeMonthlyInterval":"aHjkK","./computeMonthlyOnDay":"3BEpv","./computeMonthlyOnTheDay":"bt0s2","./computeMonthlyOnTheWhich":"dmGGL","./computeWeeklyInterval":"e37ji","./computeWeeklyDays":"5gTfO","./computeWeekStartDay":"3nNpm","./computeDailyInterval":"8iB6H","./computeHourlyInterval":"im0nR","./computeEndMode":"iPHTQ","./computeEndAfter":"h33qE","./computeEndOnDate":"4kXNa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"56Czv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeStartOnDate = (data, rruleObj)=>{
    if (!rruleObj.dtstart) return data.start.onDate.date;
    return rruleObj.dtstart;
};
exports.default = computeStartOnDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"WN0Ec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeFrequency = (data, rruleObj)=>{
    switch(rruleObj.freq){
        case 0:
            return 'Yearly';
        case 1:
            return 'Monthly';
        case 2:
            return 'Weekly';
        case 3:
            return 'Daily';
        case 4:
            return 'Hourly';
        default:
            return data.repeat.frequency;
    }
};
exports.default = computeFrequency;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3kqTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeYearlyMode = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.bymonth) return data.repeat.yearly.mode;
    if (rruleObj.bymonthday) return 'on';
    return 'on the';
};
exports.default = computeYearlyMode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lEzHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../../constants/index");
const computeYearlyOnMonth = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.bymonthday) return data.repeat.yearly.on.month;
    if (typeof rruleObj.bymonth === 'number') return (0, _index.MONTHS)[rruleObj.bymonth - 1];
    return (0, _index.MONTHS)[rruleObj.bymonth[0] - 1];
};
exports.default = computeYearlyOnMonth;

},{"../../../constants/index":"2hd2R","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9xZwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeYearlyOnMonthday = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.bymonthday) return data.repeat.yearly.on.day;
    if (typeof rruleObj.bymonthday === 'number') return rruleObj.bymonthday;
    return rruleObj.bymonthday[0];
};
exports.default = computeYearlyOnMonthday;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f9q3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../../constants/index");
const computeYearlyOnTheMonth = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.byweekday) return data.repeat.yearly.onThe.month;
    if (typeof rruleObj.bymonth === 'number') return (0, _index.MONTHS)[rruleObj.bymonth - 1];
    return (0, _index.MONTHS)[rruleObj.bymonth[0] - 1];
};
exports.default = computeYearlyOnTheMonth;

},{"../../../constants/index":"2hd2R","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"42dT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeYearlyOnTheMonthday = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.byweekday) return data.repeat.yearly.onThe.day;
    const weekdays = rruleObj.byweekday.map((weekday)=>weekday.weekday).join(',');
    switch(weekdays){
        case '0':
            return 'Monday';
        case '1':
            return 'Tuesday';
        case '2':
            return 'Wednesday';
        case '3':
            return 'Thursday';
        case '4':
            return 'Friday';
        case '5':
            return 'Saturday';
        case '6':
            return 'Sunday';
        case '0,1,2,3,4,5,6':
            return 'Day';
        case '0,1,2,3,4':
            return 'Weekday';
        case '5,6':
            return 'Weekend day';
        default:
            return data.repeat.yearly.onThe.day;
    }
};
exports.default = computeYearlyOnTheMonthday;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kvRlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeYearlyOnTheWhich = (data, rruleObj)=>{
    if (rruleObj.freq !== 0 || !rruleObj.byweekday) return data.repeat.yearly.onThe.which;
    const bysetpos = typeof rruleObj.bysetpos === 'number' ? rruleObj.bysetpos : rruleObj.bysetpos[0];
    switch(bysetpos){
        case 1:
            return 'First';
        case 2:
            return 'Second';
        case 3:
            return 'Third';
        case 4:
            return 'Fourth';
        case -1:
            return 'Last';
        default:
            return data.repeat.yearly.onThe.which;
    }
};
exports.default = computeYearlyOnTheWhich;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gcP6A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyMode = (data, rruleObj)=>{
    if (rruleObj.freq !== 1) return data.repeat.monthly.mode;
    if (rruleObj.bymonthday) return 'on';
    return 'on the';
};
exports.default = computeMonthlyMode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aHjkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyInterval = (data, rruleObj)=>{
    if (rruleObj.freq !== 1) return data.repeat.monthly.interval;
    return rruleObj.interval;
};
exports.default = computeMonthlyInterval;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3BEpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyOnDay = (data, rruleObj)=>{
    if (rruleObj.freq !== 1 || !rruleObj.bymonthday) return data.repeat.monthly.on.day;
    if (typeof rruleObj.bymonthday === 'number') return rruleObj.bymonthday;
    return rruleObj.bymonthday[0];
};
exports.default = computeMonthlyOnDay;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bt0s2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyOnTheDay = (data, rruleObj)=>{
    if (rruleObj.freq !== 1 || !rruleObj.byweekday) return data.repeat.monthly.onThe.day;
    const weekdays = rruleObj.byweekday.map((weekday)=>weekday.weekday).join(',');
    switch(weekdays){
        case '0':
            return 'Monday';
        case '1':
            return 'Tuesday';
        case '2':
            return 'Wednesday';
        case '3':
            return 'Thursday';
        case '4':
            return 'Friday';
        case '5':
            return 'Saturday';
        case '6':
            return 'Sunday';
        case '0,1,2,3,4,5,6':
            return 'Day';
        case '0,1,2,3,4':
            return 'Weekday';
        case '5,6':
            return 'Weekend day';
        default:
            return data.repeat.monthly.onThe.day;
    }
};
exports.default = computeMonthlyOnTheDay;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dmGGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeMonthlyOnTheWhich = (data, rruleObj)=>{
    if (rruleObj.freq !== 1 || !rruleObj.bysetpos) return data.repeat.monthly.onThe.which;
    const bysetpos = typeof rruleObj.bysetpos === 'number' ? rruleObj.bysetpos : rruleObj.bysetpos[0];
    switch(bysetpos){
        case 1:
            return 'First';
        case 2:
            return 'Second';
        case 3:
            return 'Third';
        case 4:
            return 'Fourth';
        case -1:
            return 'Last';
        default:
            return data.repeat.monthly.onThe.which;
    }
};
exports.default = computeMonthlyOnTheWhich;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e37ji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeWeeklyInterval = (data, rruleObj)=>{
    if (rruleObj.freq !== 2) return data.repeat.weekly.interval;
    return rruleObj.interval;
};
exports.default = computeWeeklyInterval;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5gTfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeWeeklyDays = (data, rruleObj)=>{
    let weekdays = [];
    if (rruleObj.freq !== 2) return data.repeat.weekly.days;
    if (rruleObj.byweekday) weekdays = rruleObj.byweekday.map((weekday)=>weekday.weekday);
    return {
        mon: weekdays.includes(0),
        tue: weekdays.includes(1),
        wed: weekdays.includes(2),
        thu: weekdays.includes(3),
        fri: weekdays.includes(4),
        sat: weekdays.includes(5),
        sun: weekdays.includes(6)
    };
};
exports.default = computeWeeklyDays;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3nNpm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeWeekStartDay = (data, rruleObj)=>{
    if (!rruleObj.wkst) return data.options.weekStartsOnSunday;
    return rruleObj.wkst === 6;
};
exports.default = computeWeekStartDay;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8iB6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeDailyInterval = (data, rruleObj)=>{
    if (rruleObj.freq !== 3) return data.repeat.daily.interval;
    return rruleObj.interval;
};
exports.default = computeDailyInterval;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"im0nR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeHourlyInterval = (data, rruleObj)=>{
    if (rruleObj.freq !== 4) return data.repeat.daily.interval;
    return rruleObj.interval;
};
exports.default = computeHourlyInterval;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iPHTQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeEndMode = (data, rruleObj)=>{
    if (rruleObj.count || rruleObj.count === 0) return 'After';
    if (rruleObj.until) return 'On date';
    return 'Never';
};
exports.default = computeEndMode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h33qE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeEndAfter = (data, rruleObj)=>{
    if (!rruleObj.count && rruleObj.count !== 0) return data.end.after;
    return rruleObj.count;
};
exports.default = computeEndAfter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4kXNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const computeEndOnDate = (data, rruleObj)=>{
    if (!rruleObj.until) return data.end.onDate.date;
    return rruleObj.until;
};
exports.default = computeEndOnDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8gVKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _computeRRule = require("./computeRRule/toString/computeRRule");
var _computeRRuleDefault = parcelHelpers.interopDefault(_computeRRule);
var _index = require("../constants/index");
const configureState = (config = {}, calendarComponent, id)=>{
    const configureFrequency = ()=>config.repeat ? config.repeat[0] : 'Yearly';
    const configureYearly = ()=>config.yearly || 'on';
    const configureMonthly = ()=>config.monthly || 'on';
    const configureEnd = ()=>config.end ? config.end[0] : 'Never';
    const configureHideStart = ()=>typeof config.hideStart === 'undefined' ? true : config.hideStart;
    const uniqueRruleId = (0, _lodash.isEmpty)(id) ? (0, _lodash.uniqueId)('rrule-') : id;
    const data = {
        start: {
            onDate: {
                date: (0, _momentDefault.default)().format((0, _index.DATE_TIME_FORMAT)),
                options: {
                    weekStartsOnSunday: config.weekStartsOnSunday,
                    calendarComponent
                }
            }
        },
        repeat: {
            frequency: configureFrequency(),
            yearly: {
                mode: configureYearly(),
                on: {
                    month: 'Jan',
                    day: 1
                },
                onThe: {
                    month: 'Jan',
                    day: 'Monday',
                    which: 'First'
                },
                options: {
                    modes: config.yearly
                }
            },
            monthly: {
                mode: configureMonthly(),
                interval: 1,
                on: {
                    day: 1
                },
                onThe: {
                    day: 'Monday',
                    which: 'First'
                },
                options: {
                    modes: config.monthly
                }
            },
            weekly: {
                interval: 1,
                days: {
                    mon: false,
                    tue: false,
                    wed: false,
                    thu: false,
                    fri: false,
                    sat: false,
                    sun: false
                },
                options: {
                    weekStartsOnSunday: config.weekStartsOnSunday
                }
            },
            daily: {
                interval: 1
            },
            hourly: {
                interval: 1
            },
            options: {
                frequency: config.repeat
            }
        },
        end: {
            mode: configureEnd(),
            after: 1,
            onDate: {
                date: (0, _momentDefault.default)().format((0, _index.DATE_TIME_FORMAT)),
                options: {
                    weekStartsOnSunday: config.weekStartsOnSunday,
                    calendarComponent
                }
            },
            options: {
                modes: config.end
            }
        },
        options: {
            hideStart: configureHideStart(),
            hideEnd: config.hideEnd,
            hideError: config.hideError,
            weekStartsOnSunday: config.weekStartsOnSunday
        },
        error: null
    };
    return {
        id: uniqueRruleId,
        data,
        rrule: (0, _computeRRuleDefault.default)(data)
    };
};
exports.default = configureState;

},{"moment":"fAGp8","lodash":"fIO2m","./computeRRule/toString/computeRRule":"1j9RE","../constants/index":"2hd2R","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4I85A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _english = require("./english");
var _englishDefault = parcelHelpers.interopDefault(_english);
var _german = require("./german");
var _germanDefault = parcelHelpers.interopDefault(_german);
exports.default = {
    english: (0, _englishDefault.default),
    german: (0, _germanDefault.default)
};

},{"./english":"5MRHj","./german":"4Fjhw","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5MRHj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    locale: 'en-gb',
    invalid_rrule: "You provided an invalid RRule value to component. '%{value}' is not a correct RRule string.",
    months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
    },
    days_short: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
    },
    days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        day: 'Day',
        weekday: 'Weekday',
        'weekend day': 'Weekend day'
    },
    numerals: {
        first: 'First',
        second: 'Second',
        third: 'Third',
        fourth: 'Fourth',
        last: 'Last'
    },
    start: {
        label: 'Start',
        tooltip: 'Datetime picker for start on date'
    },
    repeat: {
        label: 'Repeat',
        yearly: {
            label: 'Yearly',
            on: 'on',
            on_the: 'on the',
            of: 'of'
        },
        monthly: {
            label: 'Monthly',
            every: 'every',
            months: 'month(s)',
            on_day: 'on day',
            on_the: 'on the'
        },
        weekly: {
            label: 'Weekly',
            every: 'every',
            weeks: 'week(s)'
        },
        daily: {
            label: 'Daily',
            every: 'every',
            days: 'day(s)'
        },
        hourly: {
            label: 'Hourly',
            every: 'every',
            hours: 'hour(s)'
        }
    },
    end: {
        label: 'End',
        tooltip: 'Datetime picker for end on date',
        never: 'Never',
        after: 'After',
        on_date: 'On date',
        executions: 'executions.'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4Fjhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    locale: 'de',
    invalid_rrule: "Sie haben eine ung\xfcltige RRule an die Komponente \xfcbergeben. '%{value}' ist keine g\xfcltige RRule.",
    months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: "M\xe4r",
        apr: 'Apr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dez'
    },
    days_short: {
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'So'
    },
    days: {
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        day: 'Tag',
        weekday: 'Wochentag',
        'weekend day': 'Wochenende'
    },
    numerals: {
        first: 'Ersten',
        second: 'Zweiten',
        third: 'Dritten',
        fourth: 'Vierten',
        last: 'Letzten'
    },
    start: {
        label: 'Start',
        tooltip: 'Startdatum des Zeitplans'
    },
    repeat: {
        label: 'Wiederholen',
        yearly: {
            label: "J\xe4hrlich",
            on: 'am',
            on_the: 'an dem',
            of: 'von'
        },
        monthly: {
            label: 'Monatlich',
            every: 'Jeden',
            months: 'Monat(e)',
            on_day: 'am Tag',
            on_the: 'am'
        },
        weekly: {
            label: "W\xf6chentlich",
            every: 'Jede',
            weeks: 'Woche(n)'
        },
        daily: {
            label: "T\xe4glich",
            every: 'Jeden',
            days: 'Tag(e)'
        },
        hourly: {
            label: "St\xfcndlich",
            every: 'Jede',
            hours: 'Stunde(n)'
        }
    },
    end: {
        label: 'Ende',
        tooltip: 'Ende des Zeitplans',
        never: 'Niemals',
        after: 'Nach',
        on_date: 'Am',
        executions: "Ausf\xfchrungen."
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3SEJl":[function() {},{}],"aJ55g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditRepeatOccurrencesSection", ()=>EditRepeatOccurrencesSection);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _rrule = require("rrule");
var _repeatUtils = require("../../../../../../common/repeat_utils");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _dashboardUtils = require("../../../dashboard_utils");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _withDropdownImproved = require("../base_components/with_dropdown_improved");
var _boxItem = require("../box_item");
var _editEventTimeContent = require("../hooks/edit_event_time_content");
var _useEventCreationContext = require("../hooks/use_event_creation_context");
function createRDatesState(rdates, time_being_edited, date) {
    const result_rdates = [
        ...rdates ?? []
    ].filter((val)=>new Date(val.rdate).getTime() !== time_being_edited.getTime());
    if (time_being_edited.getTime() !== date.getTime()) {
        const orig_date = rdates?.find((val)=>new Date(val.rdate).getTime() === time_being_edited.getTime())?.orig_date ?? time_being_edited;
        result_rdates.push({
            orig_date,
            rdate: date
        });
    }
    return result_rdates;
}
function getOriginalOccurrenceDate(rdates, time_to_find) {
    return rdates?.find((val)=>new Date(val.rdate).getTime() === time_to_find.getTime())?.orig_date ?? time_to_find;
}
function EditRepeatOccurrencesSection(props) {
    const [is_open, setIsOpen] = (0, _react.useState)(false);
    const { state } = (0, _useEventCreationContext.useEventCreationContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                    hide_arrow: true,
                    onClick: ()=>setIsOpen(true),
                    disabled: !state.start_time,
                    children: "Edit Repeat Occurrences"
                })
            }),
            is_open && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditRepeatOccurrencesModal, {
                onClose: ()=>setIsOpen(false)
            })
        ]
    });
}
function EditRepeatOccurrencesModal({ onClose }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        title: "Repeat Occurrences",
        is_active: true,
        onClose: onClose,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mt-2",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditRepeatOccurrencesModalContent, {
                onClose: onClose
            })
        }),
        allow_overflow: true
    });
}
function EditRepeatOccurrencesModalContent({ onClose }) {
    const { state, setState } = (0, _useEventCreationContext.useEventCreationContext)();
    const [time_currently_being_edited, setTimeCurrentlyBeingEdited] = (0, _react.useState)(null);
    // TODO: input different thing for state time if part of an rdate
    if (time_currently_being_edited) {
        const original_date = getOriginalOccurrenceDate(state.rdates, state.start_time.toJSDate());
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editEventTimeContent.EditEventTimeContent), {
                rrule: (0, _rrule.RRule).optionsToString(state.rrule.origOptions),
                repeat_start_time: state.start_time.toJSDate(),
                original_instance_start_time: new Date(original_date),
                start_time: time_currently_being_edited,
                end_time: (0, _luxon.DateTime).fromJSDate(time_currently_being_edited).plus({
                    milliseconds: state.duration_ms ?? 3600000
                }).toJSDate(),
                repeat_tz: state.event_timezone,
                exdates: state.exdates?.map((val)=>val.toISOString()) ?? [],
                rdates: state.rdates,
                onSubmit: (date)=>{
                    setState((state)=>{
                        return {
                            ...state,
                            rdates: createRDatesState(state.rdates, time_currently_being_edited, date)
                        };
                    });
                    setTimeCurrentlyBeingEdited(null);
                },
                onBack: ()=>setTimeCurrentlyBeingEdited(null)
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RepeatOccurrencesList, {
        onSubmit: onClose,
        onEditTimeSelected: (time)=>setTimeCurrentlyBeingEdited(time)
    });
}
function RepeatOccurrencesList({ onSubmit, onEditTimeSelected }) {
    const { state, setState } = (0, _useEventCreationContext.useEventCreationContext)();
    const rrule_str = (0, _rrule.RRule).optionsToString((0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone(state.rrule.origOptions, state.user_timezone, state.start_time));
    const rrule_set = (0, _repeatUtils.createRRuleSet)({
        rrule_str,
        start_time_js: state.start_time.toJSDate(),
        repeat_tz: state.event_timezone,
        rdates: []
    });
    const [dates_to_list, setDatesToList] = (0, _react.useState)((0, _repeatUtils.getNextNOccurrences)(rrule_set, state.start_time.toJSDate(), state.event_timezone, 10, true));
    const exdates_set = new Set(state.exdates?.map((val)=>val.getTime()) ?? []);
    const dates = dates_to_list.map((val)=>{
        const existing_rdate = state.rdates?.find((rdate)=>new Date(rdate.orig_date).getTime() === (0, _repeatUtils.rruleTimeToLocalTime)(val).toMillis());
        return existing_rdate ? (0, _luxon.DateTime).fromJSDate(new Date(existing_rdate.rdate)) : (0, _repeatUtils.rruleTimeToLocalTime)(val);
    });
    const can_go_back = (0, _repeatUtils.getPreviousNOccurrences)(rrule_set, state.start_time.toJSDate(), dates[0].toJSDate(), state.event_timezone, 10).length > 0;
    const can_go_forward = (0, _repeatUtils.getNextNOccurrences)(rrule_set, dates[dates.length - 1].toJSDate(), state.event_timezone, 1, false).length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex w-fit",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        disabled: !can_go_back,
                        className: "px-4 font-bold text-sesh-primary hover:text-sesh-dark",
                        custom_size: "small",
                        onClick: (e)=>{
                            e.preventDefault();
                            if (!can_go_back) return;
                            setDatesToList((0, _repeatUtils.getPreviousNOccurrences)(rrule_set, state.start_time.toJSDate(), dates[0].toJSDate(), state.event_timezone, 10));
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-chevron-left"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        custom_size: "small",
                        disabled: !can_go_forward,
                        className: "px-4 font-bold text-sesh-primary hover:text-sesh-dark",
                        onClick: (e)=>{
                            e.preventDefault();
                            if (!can_go_forward) return;
                            setDatesToList((0, _repeatUtils.getNextNOccurrences)(rrule_set, dates[dates.length - 1].toJSDate(), state.event_timezone, 10, false));
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-chevron-right"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-1",
                children: dates.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RepeatOccurrenceItem, {
                        is_already_excluded: exdates_set.has(val.toMillis()),
                        date: val,
                        onEditTimeSelected: ()=>// TODO: put in original time probably (not rdate time)
                            onEditTimeSelected(val.toJSDate())
                    }, val.toISO()))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-2 flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ml-auto flex gap-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-fit",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: ()=>{
                                onSubmit();
                            },
                            children: "Close"
                        })
                    })
                })
            })
        ]
    });
}
function RepeatOccurrenceItem({ date, onEditTimeSelected, is_already_excluded }) {
    const { setState } = (0, _useEventCreationContext.useEventCreationContext)();
    const delete_or_restore_item = is_already_excluded ? {
        label: "Restore",
        type: "button",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-redo-alt"
        }, "restore"),
        props: {
            onClick: (e)=>{
                e.preventDefault();
                setState((state)=>{
                    const exdates = state.exdates ?? [];
                    exdates.splice(exdates.findIndex((val)=>val.getTime() === date.toMillis()), 1);
                    return {
                        ...state,
                        exdates: exdates
                    };
                });
            }
        }
    } : {
        label: "Delete",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-trash"
        }, "delete"),
        type: "button",
        is_warning: true,
        props: {
            onClick: (e)=>{
                e.preventDefault();
                setState((state)=>{
                    const exdates = state.exdates ?? [];
                    exdates.push(date.toJSDate());
                    const unique_exdates = [
                        ...new Set(exdates.map((val)=>val.getTime()))
                    ].map((ms)=>new Date(ms)).sort((a, b)=>a.getTime() - b.getTime());
                    return {
                        ...state,
                        exdates: unique_exdates
                    };
                });
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxItem.BoxItem), {
        bgColor: "semidark",
        className: (0, _classnamesDefault.default)("group relative flex items-center gap-2 !p-2", {
            "opacity-50": is_already_excluded
        }),
        disabled: is_already_excluded,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("text-sesh-primary", {
                    "text-sesh-primary": !is_already_excluded,
                    "text-warning": is_already_excluded
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-calendar-day"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-mono",
                children: `${date.toLocaleString({
                    weekday: "short",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    year: date.year !== (0, _luxon.DateTime).now().year ? "numeric" : undefined
                })} ${(0, _luxon.DateTime).local().zone.offsetName(new Date().getTime(), {
                    format: "short"
                })}`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex w-fit items-center gap-2",
                children: [
                    is_already_excluded && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-xs font-semibold text-warning",
                        children: "Canceled"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownImproved.WithDropdownImproved), {
                        alignment: "right",
                        items: [
                            {
                                label: "Edit time",
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-clock"
                                }),
                                type: "button",
                                props: {
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        onEditTimeSelected();
                                    }
                                }
                            },
                            delete_or_restore_item
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-ellipsis-h opacity-50 group-hover:opacity-100"
                        })
                    })
                ]
            })
        ]
    }, is_already_excluded.toString());
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","rrule":"ilLpP","../../../../../../common/repeat_utils":"gG7ok","../../../../../../common/time_format_utils":"g0uQN","../../../dashboard_utils":"jvA8A","../base_components/modify_settings_button":"kbhTg","../base_components/sesh_primary_button":"3QyI2","../base_components/with_dropdown_improved":"iYgdS","../box_item":"gTVlB","../hooks/edit_event_time_content":"8xN9r","../hooks/use_event_creation_context":"flKqC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9ti9e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshAccordianComponent", ()=>(0, _seshAccordianComponent.SeshAccordianComponent));
var _seshAccordianComponent = require("./sesh_accordian_component");

},{"./sesh_accordian_component":"GAskf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dEV54":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReminderTimeUnitDescriptors", ()=>ReminderTimeUnitDescriptors);
parcelHelpers.export(exports, "CreateNewDefaultReminder", ()=>CreateNewDefaultReminder);
parcelHelpers.export(exports, "ServerRemindersForm", ()=>ServerRemindersForm);
parcelHelpers.export(exports, "reminderDiscretizedTimeToMs", ()=>reminderDiscretizedTimeToMs);
parcelHelpers.export(exports, "getReminderDiscretizedTime", ()=>getReminderDiscretizedTime);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _disabler = require("../disabler");
var _useChannelName = require("../hooks/use_channel_name");
var _errorTooltip = require("../tooltips/error_tooltip");
var _withTooltip = require("../tooltips/with_tooltip");
var _initialMentionsBlurb = require("./initial_mentions_blurb");
var _serverRemindersModal = require("./server_reminders_modal");
var _lodash = require("lodash");
var _eventCreation = require("../../../event_creation");
var _simpleSelectableBoxItem = require("../simple_selectable_box_item");
var _mentionsList = require("./mentions_list");
const ReminderTimeUnitDescriptors = {
    weeks: 604800000,
    days: 86400000,
    hours: 3600000,
    minutes: 60000
};
function CreateNewDefaultReminder(is_first, mentions) {
    return {
        ...(0, _lodash.cloneDeep)((0, _constants.Constants).DEFAULT_EVENT_SERVER_REMINDERS[0]),
        fire_before_ms: is_first ? 0 : 600000,
        role_mention_ids: mentions?.role_ids ?? [],
        user_mention_ids: mentions?.user_ids ?? []
    };
}
function getCreatedAt(last_reminder_edited, index) {
    if (last_reminder_edited.index === "all") return last_reminder_edited.created_at_ms;
    return last_reminder_edited.index === index ? last_reminder_edited.created_at_ms : undefined;
}
function ServerRemindersForm(props) {
    const [state, setState] = (0, _react.useState)("Root");
    const [mentions_to_mirror, setMentionsToMirror] = (0, _react.useState)(undefined);
    const [modal_state, setModalState] = (0, _react.useState)(undefined);
    function updateMentionsOnAllReminders(mentions) {
        props.setReminders(props.reminders.map((val)=>({
                ...val,
                role_mention_ids: mentions.role_ids,
                user_mention_ids: mentions.user_ids
            })));
    }
    const [reminder_edited_info, setLastReminderEditedInfo] = (0, _react.useState)({
        index: -1,
        created_at_ms: 0
    });
    const event_start_reminders = props.reminders.filter((val)=>val.fire_before_ms === 0);
    // Event start reminder to modify priority:
    // 1. Reminder in event's channel
    // 2. Reminder in event's channel but not explicitly set to event's channel
    // 3. First reminder with fire time of 0
    const event_start_reminder = event_start_reminders.find((val)=>!val.desired_channel_id) ?? event_start_reminders.find((val)=>val.desired_channel_id === props.event_channel_id) ?? event_start_reminders[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _classnamesDefault.default)("field", {
                    "overridden-field": props.is_channel_override_active,
                    "active blurb": !props.is_channel_override_active
                }),
                children: [
                    (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Notifications & Mentions", "Customizable notifications that will be sent to specific channels in the server", false, false, props.has_unsaved_changes, undefined, props.is_disabled, false, props.revert_descriptor),
                    state === "Root" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerRemindersStateButtons, {
                        create_mentions: {
                            role_ids: props.initial_mentions.create_role_mentions,
                            user_ids: props.initial_mentions.create_user_mentions
                        },
                        start_reminder: event_start_reminder,
                        onCustomizeNotificationsClicked: ()=>setState("CustomizingNotifications"),
                        onCreateMentionsClicked: ()=>{
                            setModalState("CreateMentions");
                        },
                        onStartMentionsClicked: ()=>{
                            setModalState("StartMentions");
                        }
                    }),
                    state === "CustomizingNotifications" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomizeNotificationsForm, {
                        ...props,
                        onBackClick: ()=>setState("Root"),
                        mentions_to_mirror: mentions_to_mirror,
                        reminder_edited_info: reminder_edited_info,
                        setLastReminderEditedInfo: setLastReminderEditedInfo,
                        is_mentions_modal_active: modal_state === "CreateMentions",
                        setMentionsModalActive: (val)=>setModalState(val ? "CreateMentions" : undefined)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(MentionsModal, {
                header: "Mentions on Event Create",
                initial_role_mentions: props.initial_mentions.create_role_mentions,
                initial_user_mentions: props.initial_mentions.create_user_mentions,
                is_active: modal_state === "CreateMentions",
                onClose: ()=>setModalState(undefined),
                onSubmit: (mentions)=>{
                    props.setInitialMentions({
                        create_role_mentions: mentions.role_ids,
                        create_user_mentions: mentions.user_ids
                    });
                },
                setMentionsToMirror: (val)=>{
                    setMentionsToMirror(val);
                    if (val) {
                        updateMentionsOnAllReminders(val);
                        setLastReminderEditedInfo({
                            created_at_ms: Date.now(),
                            index: "all"
                        });
                    }
                },
                is_disabled: props.is_disabled,
                is_mirroring: mentions_to_mirror !== undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(MentionsModal, {
                header: "Mentions on Event Start",
                initial_role_mentions: event_start_reminder?.role_mention_ids,
                initial_user_mentions: event_start_reminder?.user_mention_ids,
                is_active: modal_state === "StartMentions",
                onClose: ()=>setModalState(undefined),
                onSubmit: (mentions)=>{
                    const reminders_copy = [
                        ...props.reminders
                    ];
                    reminders_copy[props.reminders.indexOf(event_start_reminder)] = {
                        ...event_start_reminder,
                        role_mention_ids: mentions.role_ids,
                        user_mention_ids: mentions.user_ids
                    };
                    props.setReminders(reminders_copy);
                },
                setMentionsToMirror: (val)=>{
                    setMentionsToMirror(val);
                    if (val) {
                        updateMentionsOnAllReminders(val);
                        props.setInitialMentions({
                            create_role_mentions: val.role_ids,
                            create_user_mentions: val.user_ids
                        });
                        setLastReminderEditedInfo({
                            created_at_ms: Date.now(),
                            index: "all"
                        });
                    }
                },
                is_disabled: props.is_disabled,
                is_mirroring: mentions_to_mirror !== undefined
            })
        ]
    });
}
function MentionsModal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.is_active && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.ActiveMentionsModal), {
            header: props.header,
            role_mention_ids: props.initial_role_mentions,
            user_mention_ids: props.initial_user_mentions,
            onClose: props.onClose,
            onSubmit: (user_ids, role_ids, is_mirroring)=>{
                props.onClose();
                if (props.is_disabled) return;
                const mentions = {
                    role_ids,
                    user_ids
                };
                props.onSubmit(mentions);
                // props.setInitialMentions(mentions);
                props.setMentionsToMirror(is_mirroring ? mentions : undefined);
            },
            is_mirroring_mentions: props.is_mirroring
        })
    });
}
function ServerRemindersStateButtons(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSelectableBoxItem.SimpleSelectableBoxItem), {
                header: `Mentions on Event Create`,
                description: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex w-full gap-2 overflow-hidden",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                        role_mention_ids: props.create_mentions.role_ids,
                        user_mention_ids: props.create_mentions.user_ids
                    })
                }),
                onClick: props.onCreateMentionsClicked,
                bgColor: "dark"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSelectableBoxItem.SimpleSelectableBoxItem), {
                header: "Mentions on Event Start",
                disabled: !props.start_reminder,
                description: !props.start_reminder ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "No event start notification set"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex w-full gap-2 overflow-hidden",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsList.MentionsList), {
                        role_mention_ids: props.start_reminder?.role_mention_ids ?? [],
                        user_mention_ids: props.start_reminder?.user_mention_ids ?? []
                    })
                }),
                onClick: props.onStartMentionsClicked,
                bgColor: "dark"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSelectableBoxItem.SimpleSelectableBoxItem), {
                header: "Customize Notifications",
                description: "",
                onClick: props.onCustomizeNotificationsClicked,
                bgColor: "dark"
            })
        ]
    });
}
function CustomizeNotificationsForm(props) {
    const { mentions_to_mirror, reminder_edited_info, is_mentions_modal_active, setLastReminderEditedInfo, setMentionsModalActive } = props;
    const [edited_reminder, setEditedReminder] = (0, _react.useState)(undefined);
    const [edited_reminder_index, setEditedReminderIndex] = (0, _react.useState)(undefined);
    const sorted_index_to_true_index_map = {};
    const sorted_reminders = [
        ...props.reminders
    ].sort((a, b)=>b.fire_before_ms - a.fire_before_ms);
    sorted_reminders.forEach((val, index)=>{
        sorted_index_to_true_index_map[index] = props.reminders.findIndex((v)=>v === val);
    });
    const { reminders, setReminders } = props;
    const max_server_reminders_reached = props.reminders.length >= (0, _constants.Constants).MAX_SERVER_REMINDERS_COUNT;
    let error_messages = Array(props.reminders.length).fill(undefined);
    const reminders_copy = [
        ...props.reminders
    ];
    for(let i = reminders_copy.length - 1; i >= 0; i--){
        let { is_valid, error_message } = (0, _commonUtils.common_utils).ValidateReminderWithIndex(reminders_copy, i, props.event_channel_id);
        if (is_valid && props.event_start_time) {
            if (props.event_start_time.getTime() - reminders_copy[i].fire_before_ms < Date.now() - 60000) {
                is_valid = false;
                error_message = "Can not create a reminder in the past";
            }
        }
        if (!is_valid) {
            error_messages[i] = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: error_message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: "This reminder will not be sent"
                    })
                ]
            });
            reminders_copy.splice(i, 1);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                disabled: props.is_disabled,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-col gap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-col gap-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventStartItem, {
                                            event_channel_id: props.event_channel_id,
                                            created_at_ms: getCreatedAt(reminder_edited_info, "create_mentions"),
                                            mentions: props.initial_mentions,
                                            onEditClicked: ()=>{
                                                setMentionsModalActive(true);
                                            }
                                        }),
                                        sorted_reminders.map((reminder, index)=>{
                                            const true_index = sorted_index_to_true_index_map[index];
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReminderItem, {
                                                event_channel_id: props.event_channel_id,
                                                reminder: reminder,
                                                error_message: error_messages[true_index],
                                                created_at_ms: getCreatedAt(reminder_edited_info, true_index),
                                                onDeleteClicked: ()=>{
                                                    if (props.is_disabled) return;
                                                    setReminders(reminders.filter((val, filter_index)=>filter_index !== true_index));
                                                },
                                                onEditClicked: ()=>{
                                                    if (props.is_disabled) return;
                                                    setEditedReminder((0, _lodash.cloneDeep)(reminder));
                                                    setEditedReminderIndex(true_index);
                                                },
                                                onDuplicateClicked: max_server_reminders_reached ? undefined : ()=>{
                                                    if (props.is_disabled) return;
                                                    setEditedReminder((0, _lodash.cloneDeep)(reminder));
                                                }
                                            }, true_index);
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: `flex flex-col items-center gap-4 rounded-sm bg-base-light p-3 shadow-sm`,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                                disabled: max_server_reminders_reached || props.is_disabled,
                                                hide_arrow: true,
                                                onClick: ()=>{
                                                    setEditedReminder({
                                                        ...CreateNewDefaultReminder(props.reminders.length === 0, mentions_to_mirror ? props.mentions_to_mirror : undefined),
                                                        fire_before_ms: undefined
                                                    });
                                                },
                                                children: max_server_reminders_reached ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Maximum Notifications"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Add Notification"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                            hide_arrow: true,
                            onClick: props.onBackClick,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-arrow-left"
                                    }, "button-icon"),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Back"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            !is_mentions_modal_active && edited_reminder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverRemindersModal.ServerRemindersModal), {
                value: edited_reminder,
                other_reminders: reminders.filter((val, index)=>index !== edited_reminder_index),
                event_channel_id: props.event_channel_id,
                is_edit: edited_reminder_index !== undefined,
                onClose: ()=>{
                    setEditedReminder(undefined);
                    setEditedReminderIndex(undefined);
                },
                addReminder: (reminder)=>{
                    const reminders_clone = [
                        ...reminders
                    ];
                    if (edited_reminder_index !== undefined) reminders_clone[edited_reminder_index] = {
                        ...reminder,
                        has_fired: false
                    };
                    else reminders_clone.push(reminder);
                    setLastReminderEditedInfo({
                        index: edited_reminder_index ?? reminders_clone.length - 1,
                        created_at_ms: Date.now()
                    });
                    setReminders(reminders_clone);
                    setEditedReminder(undefined);
                    setEditedReminderIndex(undefined);
                }
            })
        ]
    });
}
function EventStartItem(props) {
    const is_newly_created = Date.now() - (props.created_at_ms ?? 0) < 500;
    const [should_glow, setShouldGlow] = (0, _react.useState)(is_newly_created);
    const event_creation_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    if (is_newly_created && !should_glow) setShouldGlow(true);
    (0, _react.useEffect)(()=>{
        if (should_glow) {
            const timeout = setTimeout(()=>{
                setShouldGlow(false);
            }, 1000);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        should_glow
    ]);
    const channel_name = props.event_channel_id ? (0, _useChannelName.useChannelName)(props.event_channel_id, false) : "event's channel";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("relative box-border flex w-full min-w-0 gap-3 rounded-sm border-2 bg-base-light p-3 shadow-sm ease-out", {
            "border-sesh-primary": should_glow,
            "border-transparent transition duration-500": !should_glow
        }),
        children: [
            event_creation_context?.props.is_edit && !event_creation_context.state.rrule && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                style: "Info",
                tooltip: "Message already sent",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-check-circle success-text"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex w-[20%] min-w-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: "Fire time",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-bell opacity-50"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 whitespace-nowrap",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-bold",
                                    children: "Event create"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden w-[20%] min-w-0 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: channel_name,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-hashtag opacity-50"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: channel_name
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden w-[30%] min-w-0 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: "The signup for the message for this event",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-comment-alt opacity-50"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mr-4 min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap italic",
                                children: "Signup message"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden  w-1/12 min-w-0 items-center gap-1 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            props.mentions.create_role_mentions.length === 0 && props.mentions.create_user_mentions.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: "None"
                            }),
                            props.mentions.create_role_mentions.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.RoleMention), {
                                    id: val
                                }, val)),
                            props.mentions.create_user_mentions.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.UserMention), {
                                    id: val
                                }, val))
                        ]
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-at opacity-50"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: props.mentions.create_role_mentions.length + props.mentions.create_user_mentions.length
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionButtons, {
                    onEditClicked: props.onEditClicked
                })
            })
        ]
    });
}
function ReminderItem(props) {
    const { count, unit } = getReminderDiscretizedTime(props.reminder);
    const is_newly_created = Date.now() - (props.created_at_ms ?? 0) < 500;
    const [should_glow, setShouldGlow] = (0, _react.useState)(is_newly_created);
    const event_creation_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    if (is_newly_created && !should_glow) setShouldGlow(true);
    const should_send_to_thread = event_creation_context?.state.thread_settings?.should_send_start_message_to_thread;
    (0, _react.useEffect)(()=>{
        if (should_glow) {
            const timeout = setTimeout(()=>{
                setShouldGlow(false);
            }, 1000);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        should_glow
    ]);
    let channel_name;
    if (props.reminder.desired_channel_id) channel_name = (0, _useChannelName.useChannelName)(props.reminder.desired_channel_id, false);
    else if (props.event_channel_id) channel_name = should_send_to_thread ? "event thread" : (0, _useChannelName.useChannelName)(props.event_channel_id, false);
    else channel_name = "event's channel";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("relative box-border flex w-full min-w-0 gap-3 rounded-sm border-2 bg-base-light p-3 shadow-sm ease-out", {
            "border-sesh-primary": should_glow,
            "border-transparent transition duration-500": !should_glow
        }),
        children: [
            props.error_message && !props.reminder.has_fired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorTooltip.ErrorTooltip), {
                info: props.error_message
            }),
            props.error_message && !props.reminder.has_fired && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pointer-events-none absolute left-0 top-0 flex h-full w-full bg-warning px-4 py-3 opacity-20"
            }),
            props.reminder.has_fired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                style: "Info",
                tooltip: "Reminder already sent",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-check-circle success-text"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex w-[20%] min-w-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: "Fire time",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-bell opacity-50"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 whitespace-nowrap",
                                children: count === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-bold",
                                    children: "Event start"
                                }) : `${count} ${count === 1 ? unit.toLowerCase().substring(0, unit.length - 1) : unit}`
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden w-[20%] min-w-0 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: channel_name,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-hashtag opacity-50"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: channel_name
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden w-[30%] min-w-0 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Title: ",
                                    props.reminder.message_title ?? "none"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Description:",
                                    " ",
                                    props.reminder.message_description ?? "none"
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-comment-alt opacity-50"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: props.reminder.message_title ? props.reminder.message_title : props.reminder.message_description
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hidden  w-1/12 min-w-0 items-center gap-1 sm:flex",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            props.reminder.role_mention_ids.length === 0 && props.reminder.user_mention_ids.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: "None"
                            }),
                            props.reminder.role_mention_ids.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.RoleMention), {
                                    id: val
                                }, val)),
                            props.reminder.user_mention_ids.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initialMentionsBlurb.UserMention), {
                                    id: val
                                }, val))
                        ]
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-at opacity-50"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: props.reminder.role_mention_ids.length + props.reminder.user_mention_ids.length
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionButtons, {
                    onDeleteClicked: props.onDeleteClicked,
                    onEditClicked: props.onEditClicked,
                    onDuplicateClicked: props.onDuplicateClicked
                })
            })
        ]
    });
}
function ActionButtons(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex gap-4",
        children: [
            props.onEditClicked && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                style: "Info",
                tooltip: "Edit notification",
                disable_click: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: (0, _classnamesDefault.default)("manual-link"),
                    onClick: (e)=>{
                        e.preventDefault();
                        props.onEditClicked();
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-pencil-alt"
                    })
                })
            }),
            props.onDuplicateClicked && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                style: "Info",
                tooltip: "Duplicate notification",
                disable_click: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: (0, _classnamesDefault.default)("manual-link", {
                        "input-disabled": !props.onDuplicateClicked
                    }),
                    onClick: (e)=>{
                        e.preventDefault();
                        props.onDuplicateClicked?.();
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "far fa-clone"
                    })
                })
            }),
            props.onDeleteClicked && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                style: "Info",
                tooltip: "Delete notification",
                disable_click: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: (0, _classnamesDefault.default)("text-warning hover:text-warning-hover"),
                    onClick: (e)=>{
                        e.preventDefault();
                        props.onDeleteClicked();
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "far fa-trash-alt"
                    })
                })
            })
        ]
    });
}
function reminderDiscretizedTimeToMs(val) {
    return val.count * ReminderTimeUnitDescriptors[val.unit];
}
function getReminderDiscretizedTime(reminder) {
    // Loop through object keys backwards
    if (reminder.fire_before_ms === 0) return {
        count: 0,
        unit: "minutes"
    };
    for(const key in ReminderTimeUnitDescriptors){
        const current_value_ms = ReminderTimeUnitDescriptors[key];
        if (reminder.fire_before_ms % current_value_ms === 0) return {
            count: Math.floor(reminder.fire_before_ms / current_value_ms),
            unit: key
        };
    }
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../base_components/modify_settings_button":"kbhTg","../disabler":"hF5sC","../hooks/use_channel_name":"hA9Qq","../tooltips/error_tooltip":"j9Mgc","../tooltips/with_tooltip":"bOdAf","./initial_mentions_blurb":"f2kPT","./server_reminders_modal":"kyr5j","lodash":"fIO2m","../../../event_creation":"a8uX3","../simple_selectable_box_item":"fd7YP","./mentions_list":"9HygK","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j9Mgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorTooltip", ()=>ErrorTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _withTooltip = require("./with_tooltip");
function ErrorTooltip(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
        tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: props.info
        }),
        style: "Error",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-exclamation-circle error-text"
        })
    });
}

},{"react/jsx-runtime":"dpQXr","./with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kyr5j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerRemindersModal", ()=>ServerRemindersModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _eventCreation = require("../../../event_creation");
var _numberInput = require("../../number_input");
var _autocompleteInput = require("../autocomplete_input/autocomplete_input");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _seshAddonInput = require("../base_components/sesh_addon_input");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshSelectInput = require("../base_components/sesh_select_input");
var _channelPicker = require("../channel_picker");
var _channelPickerDefault = parcelHelpers.interopDefault(_channelPicker);
var _discordEmbed = require("../discord_embed/discord_embed");
var _errorNote = require("../error_note");
var _useChannels = require("../hooks/use_channels");
var _settingsItem = require("../settings_item");
var _simpleSelectableBoxItem = require("../simple_selectable_box_item");
var _serverRemindersBlurb = require("./server_reminders_blurb");
var _serverRemindersMentions = require("./server_reminders_mentions");
function ServerRemindersModal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: props.onClose,
        title: "\uD83D\uDD14 Server Notification",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ModalContent, {
            ...props
        })
    });
}
function ContentChoice(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "font-bold",
                children: "Select notification time"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSelectableBoxItem.SimpleSelectableBoxItem), {
                header: "Before Event Start",
                description: "Create a notification that will be sent before the event starts",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-hourglass-start"
                }),
                onClick: ()=>props.setChoice("Pre"),
                bgColor: "semidark"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSelectableBoxItem.SimpleSelectableBoxItem), {
                header: "At Event Start",
                description: "Create a notification that will be sent when the event starts",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-hourglass-end"
                }),
                onClick: ()=>props.setChoice("Start"),
                bgColor: "semidark"
            })
        ]
    });
}
function ModalContent(props) {
    const [reminder, setReminder] = (0, _react.useState)({
        ...props.value,
        time: props.value.fire_before_ms !== undefined ? (0, _serverRemindersBlurb.getReminderDiscretizedTime)(props.value) : undefined
    });
    const [is_editing_mentions, setIsEditingMentions] = (0, _react.useState)(false);
    // It is a new reminder and choice has not been set yet
    if (reminder.time === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentChoice, {
        setChoice: (choice)=>{
            setReminder({
                ...reminder,
                time: {
                    count: choice === "Pre" ? 10 : 0,
                    unit: "minutes"
                }
            });
        }
    });
    const { is_valid, error_message } = (0, _commonUtils.common_utils).ValidateReminder({
        ...reminder,
        fire_before_ms: (0, _serverRemindersBlurb.reminderDiscretizedTimeToMs)(reminder.time)
    }, props.other_reminders, props.event_channel_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsItem.SettingsItem), {
                active: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeSection, {
                    onChange: (val)=>setReminder({
                            ...reminder,
                            time: val
                        }),
                    value: reminder.time
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsItem.SettingsItem), {
                active: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelSelect, {
                    channel_id: reminder.desired_channel_id,
                    setChannelId: (val)=>setReminder({
                            ...reminder,
                            desired_channel_id: val
                        })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsItem.SettingsItem), {
                active: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MessageSection, {
                    value: {
                        message_description: reminder.message_description,
                        message_title: reminder.message_title
                    },
                    onChange: (val)=>{
                        setReminder({
                            ...reminder,
                            ...val
                        });
                    },
                    fire_time_ms: (0, _serverRemindersBlurb.reminderDiscretizedTimeToMs)(reminder.time)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsItem.SettingsItem), {
                active: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "font-bold",
                                    children: "Mentions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                    hide_arrow: true,
                                    className: "ml-auto",
                                    onClick: ()=>setIsEditingMentions(!is_editing_mentions),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: is_editing_mentions ? "preview" : "edit"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverRemindersMentions.MentionsSection), {
                            member_ids: reminder.user_mention_ids,
                            role_ids: reminder.role_mention_ids,
                            is_editing: is_editing_mentions,
                            onMembersChange: (val)=>setReminder({
                                    ...reminder,
                                    user_mention_ids: val
                                }),
                            onRolesChange: (val)=>setReminder({
                                    ...reminder,
                                    role_mention_ids: val
                                })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    error_message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-grow text-sm",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
                            error: error_message
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ml-auto flex w-fit",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            disabled: !is_valid,
                            className: "ml-auto",
                            onClick: ()=>props.addReminder({
                                    ...reminder,
                                    fire_before_ms: (0, _serverRemindersBlurb.reminderDiscretizedTimeToMs)(reminder.time)
                                }),
                            children: props.is_edit ? "Edit" : "Add"
                        })
                    })
                ]
            })
        ]
    });
}
function TimeSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Fire Time"
            }),
            props.value.count === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex cursor-pointer items-center gap-2 text-sesh-primary hover:text-sesh-dark",
                onClick: ()=>props.onChange(undefined),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "font-bold text-sesh-primary",
                        children: "Event Start"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-pencil-alt"
                    })
                ]
            }),
            props.value.count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "limit-form flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _numberInput.NumberInputForm), {
                                name: "limit",
                                allow_zero: true,
                                initial_value: props.value.count,
                                do_not_update_initially: true,
                                updateFunc: (val)=>{
                                    props.onChange({
                                        ...props.value,
                                        count: val
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSelectInput.SeshSelect), {
                                    value: {
                                        label: props.value.unit,
                                        value: props.value.unit
                                    },
                                    options: [
                                        {
                                            label: "minutes",
                                            value: "minutes"
                                        },
                                        {
                                            label: "hours",
                                            value: "hours"
                                        },
                                        {
                                            label: "days",
                                            value: "days"
                                        },
                                        {
                                            label: "weeks",
                                            value: "weeks"
                                        }
                                    ],
                                    onChange: (val)=>props.onChange({
                                            ...props.value,
                                            unit: val.value
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: "before event start"
                    })
                ]
            })
        ]
    });
}
function ChannelSelect(props) {
    const [channel_type, setChannelType] = (0, _react.useState)(props.channel_id ? "custom" : "event");
    const channels = (0, _useChannels.useChannels)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Channel"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                value: channel_type,
                setValue: (val)=>{
                    setChannelType(val);
                    if (val === "custom") props.setChannelId(channels[0].id);
                    else props.setChannelId(undefined);
                },
                buttons: [
                    {
                        label: "Event's Channel",
                        value: "event"
                    },
                    {
                        label: "Custom Channel",
                        value: "custom"
                    }
                ]
            }),
            channel_type === "custom" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelPickerDefault.default), {
                channel_id: props.channel_id,
                setChannel: (val)=>props.setChannelId(val)
            })
        ]
    });
}
function MessageSection(props) {
    const [is_editing, setIsEditing] = (0, _react.useState)(false);
    const event_creation_context = (0, _react.useContext)((0, _eventCreation.EventCreationContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-2 font-bold",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: "Message"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                            className: "ml-auto",
                            hide_arrow: true,
                            onClick: ()=>setIsEditing(!is_editing),
                            children: is_editing ? "preview" : "edit"
                        })
                    ]
                }),
                is_editing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                is_editing && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-xs",
                                    children: [
                                        "Type",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "command-example--inline",
                                            children: "$"
                                        }),
                                        " ",
                                        "for a full list of",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            className: "manual-link",
                                            href: (0, _dashboardUtils.DashboardUtils).GetManualLink() + `/placeholders`,
                                            target: "_blank",
                                            children: "placeholders"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleText, {
                                    fire_time_ms: props.fire_time_ms,
                                    value: props.value.message_title,
                                    setValue: (str)=>props.onChange({
                                            ...props.value,
                                            message_title: str
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DescriptionText, {
                            fire_time_ms: props.fire_time_ms,
                            value: props.value.message_description,
                            setValue: (str)=>{
                                props.onChange({
                                    ...props.value,
                                    message_description: str
                                });
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _discordEmbed.DiscordEmbedComponent), {
                    title: replacePlaceholders("EmbedTitle", event_creation_context, props.fire_time_ms, props.value.message_title),
                    description: replacePlaceholders("EmbedDescription", event_creation_context, props.fire_time_ms, props.value.message_description),
                    color: event_creation_context?.state.color
                })
            ]
        })
    });
}
function replacePlaceholders(type, context, fire_time_ms, value) {
    return (0, _commonUtils.common_utils).replacePlaceholders(type, value, {
        event_link: undefined,
        event_name: context?.state.event_name,
        start_time: context?.state.start_time,
        timezone: context?.props.guild_timezone,
        duration_ms: fire_time_ms,
        description: context?.state.description,
        rsvp_options: context?.state.rsvp_options.custom_options
    });
}
function DescriptionText(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteInput.AutocompleteInput), {
        placeholder: "Description",
        value: props.value,
        onChange: (str)=>props.setValue(str),
        char_limit: (0, _constants.Constants).DESCRIPTION_CHAR_LIMIT - 400,
        type: "description"
    });
}
function TitleText(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteInput.AutocompleteInput), {
        placeholder: "Title",
        onChange: (str)=>props.setValue(str),
        type: "title",
        value: props.value,
        char_limit: (0, _constants.Constants).EMBED_TITLE_LIMIT
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../../../event_creation":"a8uX3","../../number_input":"9IxdI","../autocomplete_input/autocomplete_input":"cjDV5","../base_components/modify_settings_button":"kbhTg","../base_components/sesh_addon_input":"pd6di","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_select_input":"8Vo8B","../channel_picker":"c7Ywk","../discord_embed/discord_embed":"27esV","../error_note":"kzA14","../hooks/use_channels":"5uhZ7","../settings_item":"a0mBr","../simple_selectable_box_item":"fd7YP","./server_reminders_blurb":"dEV54","./server_reminders_mentions":"ehKOb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9IxdI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberInputForm", ()=>NumberInputForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rcInputNumber = require("rc-input-number");
var _rcInputNumberDefault = parcelHelpers.interopDefault(_rcInputNumber);
var _rcNumberInputScss = require("../../../css/rc_number_input.scss");
class NumberInputForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let value = props.initial_value;
        this.state = {
            value: value
        };
        this.handleChange = this.handleChange.bind(this);
        if (!this.props.do_not_update_initially) this.props.updateFunc(value);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleChange(event) {
        let value = event ?? 0;
        if (!this.props.allow_zero && event < 1) value = null;
        this.setState({
            value: value
        });
        this.props.updateFunc(value);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rcInputNumberDefault.default), {
                disabled: Boolean(this.props.disabled),
                placeholder: "NONE",
                type: "number",
                inputMode: "numeric",
                min: 0,
                max: 10000,
                step: 1,
                value: this.state.value,
                onChange: this.handleChange,
                parser: (str)=>{
                    return str.replace(/\D/, "");
                }
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","rc-input-number":"hgRPX","../../../css/rc_number_input.scss":"3fSWU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hgRPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inputNumber = require("./InputNumber");
var _inputNumberDefault = parcelHelpers.interopDefault(_inputNumber);
exports.default = (0, _inputNumberDefault.default);

},{"./InputNumber":"aEWjJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aEWjJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _miniDecimal = require("@rc-component/mini-decimal");
var _miniDecimalDefault = parcelHelpers.interopDefault(_miniDecimal);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _rcInput = require("rc-input");
var _useLayoutEffect = require("rc-util/es/hooks/useLayoutEffect");
var _ref = require("rc-util/es/ref");
var _react = require("react");
var _useCursor = require("./hooks/useCursor");
var _useCursorDefault = parcelHelpers.interopDefault(_useCursor);
var _stepHandler = require("./StepHandler");
var _stepHandlerDefault = parcelHelpers.interopDefault(_stepHandler);
var _numberUtil = require("./utils/numberUtil");
var _commonUtils = require("rc-input/es/utils/commonUtils");
var _useFrame = require("./hooks/useFrame");
var _useFrameDefault = parcelHelpers.interopDefault(_useFrame);
var _excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "controls",
    "classNames",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep"
], _excluded2 = [
    "disabled",
    "style",
    "prefixCls",
    "value",
    "prefix",
    "suffix",
    "addonBefore",
    "addonAfter",
    "classes",
    "className",
    "classNames"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, _miniDecimalDefault.default)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var InternalInputNumber = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _clsx;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input-number' : _props$prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, classNames = props.classNames, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, inputProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = _react.useRef(null);
    var _React$useState = _react.useState(false), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = _react.useRef(false);
    var compositionRef = _react.useRef(false);
    var shiftKeyRef = _react.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = _react.useState(function() {
        return (0, _miniDecimalDefault.default)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, _slicedToArrayDefault.default)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = _react.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, _miniDecimal.getNumberPrecision)(numStr), (0, _miniDecimal.getNumberPrecision)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = _react.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, '.');
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, '');
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = _react.useRef('');
    var mergedFormatter = _react.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === 'number' ? (0, _miniDecimal.num2str)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, _miniDecimal.validateNumber)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || '.';
                str = (0, _miniDecimal.toFixed)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = _react.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            'string',
            'number'
        ].includes((0, _typeofDefault.default)(initValue))) return Number.isNaN(initValue) ? '' : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, _slicedToArrayDefault.default)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = _react.useMemo(function() {
        return getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = _react.useMemo(function() {
        return getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = _react.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = _react.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, _useCursorDefault.default)(inputRef.current, focus), _useCursor2 = (0, _slicedToArrayDefault.default)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, _miniDecimalDefault.default)((0, _miniDecimal.toFixed)(numStr, '.', mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, _miniDecimalDefault.default)((0, _miniDecimal.toFixed)(numStr, '.', mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, _useFrameDefault.default)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue in case input can not parse as number
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, _miniDecimalDefault.default)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, '.');
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, _miniDecimalDefault.default)(shiftKeyRef.current ? (0, _numberUtil.getDecupleSteps)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, _miniDecimalDefault.default)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep(getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, _numberUtil.getDecupleSteps)(step) : step,
            type: up ? 'up' : 'down'
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, _miniDecimalDefault.default)(mergedParser(inputValue));
        var formatValue = parsedValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = decimalValue;
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var key = event.key, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === 'Enter') {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            'Up',
            'ArrowUp',
            'Down',
            'ArrowDown'
        ].includes(key)) {
            onInternalStep(key === 'Up' || key === 'ArrowUp');
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision
    ]);
    // Input by value
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        var newValue = (0, _miniDecimalDefault.default)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, _miniDecimalDefault.default)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _classnamesDefault.default)(prefixCls, classNames === null || classNames === void 0 ? void 0 : classNames.input, className, (_clsx = {}, (0, _definePropertyDefault.default)(_clsx, "".concat(prefixCls, "-focused"), focus), (0, _definePropertyDefault.default)(_clsx, "".concat(prefixCls, "-disabled"), disabled), (0, _definePropertyDefault.default)(_clsx, "".concat(prefixCls, "-readonly"), readOnly), (0, _definePropertyDefault.default)(_clsx, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), (0, _definePropertyDefault.default)(_clsx, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue)), _clsx)),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ _react.createElement((0, _stepHandlerDefault.default), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ _react.createElement("input", (0, _extendsDefault.default)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, _ref.composeRef)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
var InputNumber = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, style = props.style, prefixCls = props.prefixCls, value = props.value, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, classes = props.classes, className = props.className, classNames = props.classNames, rest = (0, _objectWithoutPropertiesDefault.default)(props, _excluded2);
    var inputFocusRef = _react.useRef(null);
    var focus = function focus(option) {
        if (inputFocusRef.current) (0, _commonUtils.triggerFocus)(inputFocusRef.current, option);
    };
    return /*#__PURE__*/ _react.createElement((0, _rcInput.BaseInput), {
        inputElement: /*#__PURE__*/ _react.createElement(InternalInputNumber, (0, _extendsDefault.default)({
            prefixCls: prefixCls,
            disabled: disabled,
            classNames: classNames,
            ref: (0, _ref.composeRef)(inputFocusRef, ref)
        }, rest)),
        className: className,
        triggerFocus: focus,
        prefixCls: prefixCls,
        value: value,
        disabled: disabled,
        style: style,
        prefix: prefix,
        suffix: suffix,
        addonAfter: addonAfter,
        addonBefore: addonBefore,
        classes: classes,
        classNames: classNames,
        components: {
            affixWrapper: 'div',
            groupWrapper: 'div',
            wrapper: 'div',
            groupAddon: 'div'
        }
    });
});
InputNumber.displayName = 'InputNumber';
exports.default = InputNumber;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/defineProperty":"eybOX","@babel/runtime/helpers/esm/typeof":"jc2jX","@babel/runtime/helpers/esm/slicedToArray":"gdW7l","@babel/runtime/helpers/esm/objectWithoutProperties":"fBqaP","@rc-component/mini-decimal":"956Mv","classnames":"7uztA","rc-input":"gKK7f","rc-util/es/hooks/useLayoutEffect":"9ctb4","rc-util/es/ref":"faJUT","react":"IMRgT","./hooks/useCursor":"c036Z","./StepHandler":"uecjs","./utils/numberUtil":"jNC9O","rc-input/es/utils/commonUtils":"fFF2c","./hooks/useFrame":"dCxLo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"956Mv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trimNumber", ()=>(0, _numberUtil.trimNumber));
parcelHelpers.export(exports, "getNumberPrecision", ()=>(0, _numberUtil.getNumberPrecision));
parcelHelpers.export(exports, "num2str", ()=>(0, _numberUtil.num2str));
parcelHelpers.export(exports, "validateNumber", ()=>(0, _numberUtil.validateNumber));
var _miniDecimal = require("./MiniDecimal");
var _miniDecimalDefault = parcelHelpers.interopDefault(_miniDecimal);
parcelHelpers.exportAll(_miniDecimal, exports);
var _numberUtil = require("./numberUtil");
exports.default = (0, _miniDecimalDefault.default);

},{"./MiniDecimal":"bbRgV","./numberUtil":"bKEwx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bbRgV":[function(require,module,exports,__globalThis) {
/* eslint-disable max-classes-per-file */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Still support origin export
parcelHelpers.export(exports, "NumberDecimal", ()=>(0, _numberDecimalDefault.default));
parcelHelpers.export(exports, "BigIntDecimal", ()=>(0, _bigIntDecimalDefault.default));
parcelHelpers.export(exports, "default", ()=>getMiniDecimal);
/**
 * Align the logic of toFixed to around like 1.5 => 2.
 * If set `cutOnly`, will just remove the over decimal part.
 */ parcelHelpers.export(exports, "toFixed", ()=>toFixed);
var _bigIntDecimal = require("./BigIntDecimal");
var _bigIntDecimalDefault = parcelHelpers.interopDefault(_bigIntDecimal);
var _numberDecimal = require("./NumberDecimal");
var _numberDecimalDefault = parcelHelpers.interopDefault(_numberDecimal);
var _numberUtil = require("./numberUtil");
var _supportUtil = require("./supportUtil");
function getMiniDecimal(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, _supportUtil.supportBigInt)()) return new (0, _bigIntDecimalDefault.default)(value);
    return new (0, _numberDecimalDefault.default)(value);
}
function toFixed(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === '') return '';
    var _trimNumber = (0, _numberUtil.trimNumber)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = getMiniDecimal(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
            return toFixed(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
    }
    if (precisionDecimalStr === '.0') return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}

},{"./BigIntDecimal":"jvX5U","./NumberDecimal":"alQGv","./numberUtil":"bKEwx","./supportUtil":"lNSqO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jvX5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BigIntDecimal);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _numberUtil = require("./numberUtil");
var BigIntDecimal = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, _classCallCheckDefault.default)(this, BigIntDecimal);
        (0, _definePropertyDefault.default)(this, "origin", '');
        (0, _definePropertyDefault.default)(this, "negative", void 0);
        (0, _definePropertyDefault.default)(this, "integer", void 0);
        (0, _definePropertyDefault.default)(this, "decimal", void 0);
        (0, _definePropertyDefault.default)(this, "decimalLen", void 0);
        (0, _definePropertyDefault.default)(this, "empty", void 0);
        (0, _definePropertyDefault.default)(this, "nan", void 0);
        if ((0, _numberUtil.isEmpty)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === '-' || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, _numberUtil.isE)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === 'string' ? mergedValue : (0, _numberUtil.num2str)(mergedValue);
        if ((0, _numberUtil.validateNumber)(mergedValue)) {
            var trimRet = (0, _numberUtil.trimNumber)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split('.');
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || '0';
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, _createClassDefault.default)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? '-' : '';
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, '0');
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, _numberUtil.trimNumber)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, '0'));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, _numberUtil.trimNumber)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"g5UsO","@babel/runtime/helpers/esm/createClass":"14O1C","@babel/runtime/helpers/esm/defineProperty":"eybOX","./numberUtil":"bKEwx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bKEwx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
/**
 * Format string number to readable number
 */ parcelHelpers.export(exports, "trimNumber", ()=>trimNumber);
parcelHelpers.export(exports, "isE", ()=>isE);
/**
 * [Legacy] Convert 1e-9 to 0.000000001.
 * This may lose some precision if user really want 1e-9.
 */ parcelHelpers.export(exports, "getNumberPrecision", ()=>getNumberPrecision);
/**
 * Convert number (includes scientific notation) to -xxx.yyy format
 */ parcelHelpers.export(exports, "num2str", ()=>num2str);
parcelHelpers.export(exports, "validateNumber", ()=>validateNumber);
var _supportUtil = require("./supportUtil");
function isEmpty(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function trimNumber(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith('-');
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, '$1')// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, '')// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, '');
    if (str.startsWith('.')) str = "0".concat(str);
    var trimStr = str || '0';
    var splitNumber = trimStr.split('.');
    var integerStr = splitNumber[0] || '0';
    var decimalStr = splitNumber[1] || '0';
    if (integerStr === '0' && decimalStr === '0') negative = false;
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function isE(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes('e');
}
function getNumberPrecision(number) {
    var numStr = String(number);
    if (isE(number)) {
        var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes('.') && validateNumber(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
function num2str(number) {
    var numStr = String(number);
    if (isE(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, _supportUtil.supportBigInt)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, _supportUtil.supportBigInt)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed(getNumberPrecision(numStr));
    }
    return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
    if (typeof num === 'number') return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}

},{"./supportUtil":"lNSqO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lNSqO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportBigInt", ()=>supportBigInt);
function supportBigInt() {
    return typeof BigInt === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"alQGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NumberDecimal);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _numberUtil = require("./numberUtil");
/**
 * We can remove this when IE not support anymore
 */ var NumberDecimal = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, _classCallCheckDefault.default)(this, NumberDecimal);
        (0, _definePropertyDefault.default)(this, "origin", '');
        (0, _definePropertyDefault.default)(this, "number", void 0);
        (0, _definePropertyDefault.default)(this, "empty", void 0);
        if ((0, _numberUtil.isEmpty)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, _createClassDefault.default)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, _numberUtil.getNumberPrecision)(this.number), (0, _numberUtil.getNumberPrecision)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, _numberUtil.getNumberPrecision)(this.number), (0, _numberUtil.getNumberPrecision)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, _numberUtil.num2str)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"g5UsO","@babel/runtime/helpers/esm/createClass":"14O1C","@babel/runtime/helpers/esm/defineProperty":"eybOX","./numberUtil":"bKEwx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gKK7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseInput", ()=>(0, _baseInputDefault.default));
var _baseInput = require("./BaseInput");
var _baseInputDefault = parcelHelpers.interopDefault(_baseInput);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
exports.default = (0, _inputDefault.default);

},{"./BaseInput":"gJsLJ","./Input":"8e4wO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gJsLJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonUtils = require("./utils/commonUtils");
var BaseInput = function BaseInput(props) {
    var _inputElement$props, _inputElement$props2;
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || 'span';
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || 'span';
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || 'span';
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || 'span';
    var containerRef = (0, _react.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _clsx;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, _typeofDefault.default)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            onClick: handleReset,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, _classnamesDefault.default)(clearIconCls, (_clsx = {}, (0, _definePropertyDefault.default)(_clsx, "".concat(clearIconCls, "-hidden"), !needClear), (0, _definePropertyDefault.default)(_clsx, "".concat(clearIconCls, "-has-suffix"), !!suffix), _clsx)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, _react.cloneElement)(inputElement, {
        value: value,
        hidden: hidden,
        className: (0, _classnamesDefault.default)((_inputElement$props = inputElement.props) === null || _inputElement$props === void 0 ? void 0 : _inputElement$props.className, !(0, _commonUtils.hasPrefixSuffix)(props) && !(0, _commonUtils.hasAddon)(props) && className) || null,
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, (_inputElement$props2 = inputElement.props) === null || _inputElement$props2 === void 0 ? void 0 : _inputElement$props2.style), !(0, _commonUtils.hasPrefixSuffix)(props) && !(0, _commonUtils.hasAddon)(props) ? style : {})
    });
    // ================== Prefix & Suffix ================== //
    if ((0, _commonUtils.hasPrefixSuffix)(props)) {
        var _clsx2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, _classnamesDefault.default)(affixWrapperPrefixCls, (_clsx2 = {}, (0, _definePropertyDefault.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, _definePropertyDefault.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, _definePropertyDefault.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, _definePropertyDefault.default)(_clsx2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _clsx2), !(0, _commonUtils.hasAddon)(props) && className, classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _classnamesDefault.default)("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, _reactDefault.default).createElement(AffixWrapperComponent, (0, _extendsDefault.default)({
            className: affixWrapperCls,
            style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, !(0, _commonUtils.hasAddon)(props) ? style : undefined), styles === null || styles === void 0 ? void 0 : styles.affixWrapper),
            hidden: !(0, _commonUtils.hasAddon)(props) && hidden,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _classnamesDefault.default)("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), /*#__PURE__*/ (0, _react.cloneElement)(inputElement, {
            value: value,
            hidden: null
        }), suffixNode);
    }
    // ================== Addon ================== //
    if ((0, _commonUtils.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, _classnamesDefault.default)("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper);
        var mergedGroupClassName = (0, _classnamesDefault.default)("".concat(prefixCls, "-group-wrapper"), className, classes === null || classes === void 0 ? void 0 : classes.group);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, _react.cloneElement)(element, {
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
exports.default = BaseInput;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectSpread2":"dItc3","@babel/runtime/helpers/esm/defineProperty":"eybOX","@babel/runtime/helpers/esm/typeof":"jc2jX","classnames":"7uztA","react":"IMRgT","./utils/commonUtils":"fFF2c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fFF2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasAddon", ()=>hasAddon);
parcelHelpers.export(exports, "hasPrefixSuffix", ()=>hasPrefixSuffix);
parcelHelpers.export(exports, "resolveOnChange", ()=>resolveOnChange);
parcelHelpers.export(exports, "triggerFocus", ()=>triggerFocus);
parcelHelpers.export(exports, "fixControlledValue", ()=>fixControlledValue);
function hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function resolveOnChange(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function triggerFocus(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8e4wO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useMergedState = require("rc-util/es/hooks/useMergedState");
var _useMergedStateDefault = parcelHelpers.interopDefault(_useMergedState);
var _omit = require("rc-util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _baseInput = require("./BaseInput");
var _baseInputDefault = parcelHelpers.interopDefault(_baseInput);
var _commonUtils = require("./utils/commonUtils");
var _excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "type",
    "classes",
    "classNames",
    "styles"
];
var Input = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, rest = (0, _objectWithoutPropertiesDefault.default)(props, _excluded);
    var _useMergedState = (0, _useMergedStateDefault.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, _slicedToArrayDefault.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var _useState = (0, _react.useState)(false), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var inputRef = (0, _react.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, _commonUtils.triggerFocus)(inputRef.current, option);
    };
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, _react.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var handleChange = function handleChange(e) {
        if (props.value === undefined) setValue(e.target.value);
        if (inputRef.current) (0, _commonUtils.resolveOnChange)(inputRef.current, e, onChange);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter') onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, _commonUtils.resolveOnChange)(inputRef.current, e, onChange);
    };
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, _omitDefault.default)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'classes',
            'htmlSize',
            'styles',
            'classNames'
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", (0, _extendsDefault.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, _classnamesDefault.default)(prefixCls, (0, _definePropertyDefault.default)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(maxLength) > 0;
        if (suffix || showCount) {
            var val = (0, _commonUtils.fixControlledValue)(value);
            var valueLength = (0, _toConsumableArrayDefault.default)(val).length;
            var dataCount = (0, _typeofDefault.default)(showCount) === 'object' ? showCount.formatter({
                value: val,
                count: valueLength,
                maxLength: maxLength
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !!showCount && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _classnamesDefault.default)("".concat(prefixCls, "-show-count-suffix"), (0, _definePropertyDefault.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, _objectSpread2Default.default)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _baseInputDefault.default), (0, _extendsDefault.default)({}, rest, {
        prefixCls: prefixCls,
        className: className,
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: (0, _commonUtils.fixControlledValue)(value),
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles
    }));
});
exports.default = Input;

},{"@babel/runtime/helpers/esm/objectSpread2":"dItc3","@babel/runtime/helpers/esm/typeof":"jc2jX","@babel/runtime/helpers/esm/toConsumableArray":"f1HoU","@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/defineProperty":"eybOX","@babel/runtime/helpers/esm/slicedToArray":"gdW7l","@babel/runtime/helpers/esm/objectWithoutProperties":"fBqaP","classnames":"7uztA","rc-util/es/hooks/useMergedState":"effgq","rc-util/es/omit":"izQws","react":"IMRgT","./BaseInput":"gJsLJ","./utils/commonUtils":"fFF2c","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"effgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergedState);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("./useLayoutEffect");
var _useState = require("./useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
/** We only think `undefined` is empty */ function hasValue(value) {
    return value !== undefined;
}
function useMergedState(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, _useStateDefault.default)(function() {
        if (hasValue(value)) return value;
        else if (hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, _useEventDefault.default)(onChange);
    var _useState3 = (0, _useStateDefault.default)([
        mergedValue
    ]), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        if (!hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, _useEventDefault.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

},{"@babel/runtime/helpers/esm/slicedToArray":"gdW7l","./useEvent":"jIGpd","./useLayoutEffect":"9ctb4","./useState":"biPfK","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jIGpd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEvent);
var _react = require("react");
function useEvent(callback) {
    var fnRef = _react.useRef();
    fnRef.current = callback;
    var memoFn = _react.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9ctb4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutUpdateEffect", ()=>useLayoutUpdateEffect);
var _react = require("react");
var _canUseDom = require("../Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var useInternalLayoutEffect = (0, _canUseDomDefault.default)() ? _react.useLayoutEffect : _react.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = _react.useRef(true);
    useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
    useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
exports.default = useLayoutEffect;

},{"react":"IMRgT","../Dom/canUseDom":"hkSZ9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hkSZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>canUseDom);
function canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"biPfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSafeState);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _react = require("react");
function useSafeState(defaultValue) {
    var destroyRef = _react.useRef(false);
    var _React$useState = _react.useState(defaultValue), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    _react.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

},{"@babel/runtime/helpers/esm/slicedToArray":"gdW7l","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"izQws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>omit);
function omit(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"faJUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillRef", ()=>fillRef);
parcelHelpers.export(exports, "composeRef", ()=>composeRef);
parcelHelpers.export(exports, "useComposeRef", ()=>useComposeRef);
parcelHelpers.export(exports, "supportRef", ()=>supportRef);
parcelHelpers.export(exports, "supportNodeRef", ()=>supportNodeRef);
parcelHelpers.export(exports, "getNodeRef", ()=>getNodeRef);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _react = require("react");
var _reactIs = require("react-is");
var _useMemo = require("./hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isFragment = require("./React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
var ReactMajorVersion = Number((0, _react.version).split('.')[0]);
var fillRef = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, _typeofDefault.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            fillRef(ref, node);
        });
    };
};
var useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, _useMemoDefault.default)(function() {
        return composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) return true;
    var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    return true;
};
function isReactElement(node) {
    return /*#__PURE__*/ (0, _react.isValidElement)(node) && !(0, _isFragmentDefault.default)(node);
}
var supportNodeRef = function supportNodeRef(node) {
    return isReactElement(node) && supportRef(node);
};
var getNodeRef = function getNodeRef(node) {
    if (node && isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

},{"@babel/runtime/helpers/esm/typeof":"jc2jX","react":"IMRgT","react-is":"01F3b","./hooks/useMemo":"9ACWp","./React/isFragment":"hk8Wg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"01F3b":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("7998368c99c862ed");

},{"7998368c99c862ed":"lSUF6"}],"lSUF6":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"9ACWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMemo);
var _react = require("react");
function useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = _react.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hk8Wg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFragment);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function isFragment(object) {
    return(// Base object type
    object && (0, _typeofDefault.default)(object) === 'object' && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE);
}

},{"@babel/runtime/helpers/esm/typeof":"jc2jX","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c036Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCursor);
var _react = require("react");
var _warning = require("rc-util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function useCursor(input, focused) {
    var selectionRef = (0, _react.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, _warningDefault.default)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}

},{"react":"IMRgT","rc-util/es/warning":"dAF0h","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dAF0h":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preMessage", ()=>preMessage);
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ parcelHelpers.export(exports, "warning", ()=>warning);
/** @see Similar to {@link warning} */ parcelHelpers.export(exports, "note", ()=>note);
parcelHelpers.export(exports, "resetWarned", ()=>resetWarned);
parcelHelpers.export(exports, "call", ()=>call);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "warningOnce", ()=>warningOnce);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "noteOnce", ()=>noteOnce);
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage(fn) {
    preWarningFns.push(fn);
};
function warning(valid, message) {
    var finalMessage;
}
function note(valid, message) {
    var finalMessage;
}
function resetWarned() {
    warned = {};
}
function call(method, valid, message) {
    if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
    }
}
function warningOnce(valid, message) {
    call(warning, valid, message);
}
function noteOnce(valid, message) {
    call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
exports.default = warningOnce;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"uecjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StepHandler);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
/* eslint-disable react/no-unknown-property */ var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useMobile = require("rc-util/es/hooks/useMobile");
var _useMobileDefault = parcelHelpers.interopDefault(_useMobile);
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var STEP_DELAY = 600;
function StepHandler(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = _react.useRef();
    var onStepRef = _react.useRef();
    onStepRef.current = onStep;
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
    };
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    _react.useEffect(function() {
        return onStopStep;
    }, []);
    // ======================= Render =======================
    var isMobile = (0, _useMobileDefault.default)();
    if (isMobile) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, _classnamesDefault.default)(handlerClassName, "".concat(handlerClassName, "-up"), (0, _definePropertyDefault.default)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, _classnamesDefault.default)(handlerClassName, "".concat(handlerClassName, "-down"), (0, _definePropertyDefault.default)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    var sharedHandlerProps = {
        unselectable: 'on',
        role: 'button',
        onMouseUp: onStopStep,
        onMouseLeave: onStopStep
    };
    return /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ _react.createElement("span", (0, _extendsDefault.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ _react.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ _react.createElement("span", (0, _extendsDefault.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ _react.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/defineProperty":"eybOX","react":"IMRgT","classnames":"7uztA","rc-util/es/hooks/useMobile":"3k6de","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3k6de":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _react = require("react");
var _isMobile = require("../isMobile");
var _isMobileDefault = parcelHelpers.interopDefault(_isMobile);
var _useLayoutEffect = require("./useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
/**
 * Hook to detect if the user is on a mobile device
 * Notice that this hook will only detect the device type in effect, so it will always be false in server side
 */ var useMobile = function useMobile() {
    var _useState = (0, _react.useState)(false), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, _useLayoutEffectDefault.default)(function() {
        setMobile((0, _isMobileDefault.default)());
    }, []);
    return mobile;
};
exports.default = useMobile;

},{"@babel/runtime/helpers/esm/slicedToArray":"gdW7l","react":"IMRgT","../isMobile":"c7v0D","./useLayoutEffect":"9ctb4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c7v0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jNC9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDecupleSteps", ()=>getDecupleSteps);
var _miniDecimal = require("@rc-component/mini-decimal");
function getDecupleSteps(step) {
    var stepStr = typeof step === 'number' ? (0, _miniDecimal.num2str)(step) : (0, _miniDecimal.trimNumber)(step).fullStr;
    var hasPoint = stepStr.includes('.');
    if (!hasPoint) return step + '0';
    return (0, _miniDecimal.trimNumber)(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}

},{"@rc-component/mini-decimal":"956Mv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dCxLo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _raf = require("rc-util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
/**
 * Always trigger latest once when call multiple time
 */ exports.default = function() {
    var idRef = (0, _react.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, _rafDefault.default).cancel(idRef.current);
    };
    (0, _react.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, _rafDefault.default)(function() {
            callback();
        });
    };
};

},{"react":"IMRgT","rc-util/es/raf":"a2nre","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"a2nre":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
    rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    rafUUID += 1;
    var id = rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
wrapperRaf.cancel = function(id) {
    var realId = rafIds.get(id);
    cleanup(id);
    return caf(realId);
};
exports.default = wrapperRaf;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3fSWU":[function() {},{}],"c7Ywk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequiredPermission", ()=>RequiredPermission);
parcelHelpers.export(exports, "default", ()=>ChannelPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _channelDropdown = require("../channel_dropdown");
var _useChannels = require("./hooks/use_channels");
var RequiredPermission = /*#__PURE__*/ function(RequiredPermission) {
    RequiredPermission[RequiredPermission["Read"] = 0] = "Read";
    RequiredPermission[RequiredPermission["Write"] = 1] = "Write";
    return RequiredPermission;
}({});
function ChannelPicker(props) {
    const channels = (0, _useChannels.useChannels)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdown.ChannelSelectForm), {
        name: props.name,
        info: props.description,
        initial_value: channels.find((val)=>val.id === props.channel_id) ?? channels[0],
        update_initially: true,
        channel_data: channels,
        disabled: false,
        updateFunc: (val)=>{
            props.setChannel(val.id);
        },
        include_threads: true,
        has_unsaved_changes: props.hasUnsavedChanges
    });
}

},{"react/jsx-runtime":"dpQXr","../channel_dropdown":"eUzk8","./hooks/use_channels":"5uhZ7","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5uhZ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useChannels", ()=>useChannels);
var _react = require("react");
var _reactRouter = require("react-router");
var _seshRouter = require("../../../sesh_router");
function useChannels() {
    let { server_id } = (0, _reactRouter.useParams)();
    const context = (0, _react.useContext)((0, _seshRouter.GuildRolesAndChannelContext));
    return context?.get(server_id)?.channels;
}

},{"react":"IMRgT","react-router":"djWTS","../../../sesh_router":"hfnpE","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"27esV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiscordEmbedComponent", ()=>DiscordEmbedComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _markdown = require("../../../markdown_parser/markdown");
var _discordEmbedScss = require("./discord_embed.scss");
function DiscordEmbedComponent(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-fit max-w-full flex-col gap-2 rounded-[3px] border-l-4 border-sesh-primary bg-base-dark p-3",
        style: {
            borderColor: props.color
        },
        children: [
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full font-semibold",
                children: (0, _markdown.parseEmbedTitle)(props.title)
            }),
            props.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "description w-full break-words text-sm",
                children: (0, _markdown.parseAllowLinks)(props.description.replaceAll("\n", "  \n"))
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../../markdown_parser/markdown":"gk0Ee","./discord_embed.scss":"FVRbj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"FVRbj":[function() {},{}],"a0mBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SettingsItem", ()=>SettingsItem);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SettingsItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("w-[0.33rem] min-w-0 flex-shrink-0 border-y border-base-dark", {
                    "bg-sesh-dark": props.active,
                    "bg-base-dark": !props.active
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("h-full w-full border-y border-l-0 border-r  border-y-base-dark border-r-base-dark bg-base-semidark p-4"),
                children: props.children
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fd7YP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleSelectableBoxItem", ()=>SimpleSelectableBoxItem);
var _jsxRuntime = require("react/jsx-runtime");
var _disabler = require("./disabler");
var _selectableBox = require("./selectable_box");
function SimpleSelectableBoxItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
        disabled: props.disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableBox.SelectableBox), {
            onClick: ()=>{
                if (props.disabled) return;
                props.onClick();
            },
            bgColor: props.bgColor,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full items-center gap-4",
                children: [
                    props.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-3xl",
                        children: props.icon
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-11/12 flex-col text-content-primary-darker",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-bold text-content-primary",
                                children: props.header
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: props.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ml-auto self-center text-content-primary",
                        children: !props.disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-chevron-right "
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-lock"
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","./disabler":"hF5sC","./selectable_box":"aVlDe","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aVlDe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectableBox", ()=>SelectableBox);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _boxItem = require("./box_item");
var _disabler = require("./disabler");
function SelectableBox(props) {
    const { children, disabled, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
        disabled: props.disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
            bgColor: props.bgColor,
            className: (0, _classnamesDefault.default)("cursor-pointer hover:border-sesh-primary", {
                "border-sesh-primary": props.force_hover
            }, props.className),
            onClick: ()=>{
                if (disabled) return;
                onClick?.();
            },
            children: children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","./box_item":"gTVlB","./disabler":"hF5sC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aSFQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignupOptionsBlurb", ()=>SignupOptionsBlurb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshRouter = require("../../../sesh_router");
var _rsvpOptions = require("../../rsvp_options");
var _rsvpOptionsDefault = parcelHelpers.interopDefault(_rsvpOptions);
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _useGuildData = require("../hooks/use_guild_data");
var _useUserContext = require("../hooks/use_user_context");
var _rsvpOptionsTable = require("../rsvp_options_table");
function SignupOptionsBlurb(props) {
    const [is_modal_open, setIsModalOpen] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "field blurb active",
                children: [
                    (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("RSVP Options", "RSVP options, reminders, and waitlist options for this event.", undefined, undefined, false, undefined, props.is_disabled, false, props.revert_descriptor),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpOptionsTable.RSVPOptionsTable), {
                                options: props.current_signup_preset
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                    disabled: props.is_disabled,
                                    onClick: ()=>setIsModalOpen(true),
                                    children: "Modify"
                                })
                            })
                        ]
                    })
                ]
            }),
            is_modal_open && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SignupOptionsModal, {
                onClose: ()=>setIsModalOpen(false),
                current_signup_preset: props.current_signup_preset,
                is_edit: props.is_edit,
                user_presets: props.user_presets,
                custom_emojis: props.custom_emojis,
                setPreset: props.setPreset
            })
        ]
    });
}
function SignupOptionsModal(props) {
    const [preset, setPreset] = (0, _react.useState)(props.current_signup_preset);
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const guild = (0, _useGuildData.useCurrentGuildData)();
    const user_context = (0, _useUserContext.useUserContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: props.onClose,
        title: "RSVP Options",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex h-full min-h-0 flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "h-full w-full",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpOptionsDefault.default), {
                        current_preset: preset,
                        updateFunc: (val)=>{
                            setPreset(val);
                        },
                        is_premium: guild.is_premium,
                        is_edit: props.is_edit,
                        user_presets: props.user_presets,
                        user_id: user_context.id,
                        custom_emojis: props.custom_emojis,
                        all_guild_data: guild_list,
                        token_type: user_context.token_type,
                        access_token: user_context.access_token,
                        from_event_creation: true,
                        ignore_unmount: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    className: "ml-auto w-fit",
                    onClick: ()=>{
                        props.setPreset(preset);
                        props.onClose();
                    },
                    children: "Set"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../dashboard_utils":"jvA8A","../../../sesh_router":"hfnpE","../../rsvp_options":"6SLLX","../base_components/modify_settings_button":"kbhTg","../base_components/sesh_primary_button":"3QyI2","../hooks/use_guild_data":"ljx0Q","../hooks/use_user_context":"eU1k4","../rsvp_options_table":"9UTc1","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6SLLX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("../../../../common/constants");
var _commonFormatUtils = require("../../../../common/common_format_utils");
var _dashboardUtils = require("../dashboard_utils");
var _numberInput = require("./number_input");
var _textInput = require("./text_input");
var _reactSpinners = require("react-spinners");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _infoTooltip = require("./improved_components/tooltips/info_tooltip");
var _modifySettingsButton = require("./improved_components/base_components/modify_settings_button");
var _settingsBooleanItem = require("./improved_components/settings_items/settings_boolean_item");
var _boxItem = require("./improved_components/box_item");
const EmojiPickerForm = /*#__PURE__*/ (0, _react.lazy)(()=>require("d2dfad2f65700b60"));
function clonePreset(preset) {
    let cloned = {
        name: preset.name,
        author_id: preset.author_id,
        unsaved_changes: preset.unsaved_changes,
        custom_options: [],
        allow_multiple_rsvps: preset.allow_multiple_rsvps ?? false
    };
    for (let custom_option of preset.custom_options){
        let cloned_options = {};
        for(let key in custom_option)cloned_options[key] = custom_option[key];
        cloned.custom_options.push(cloned_options);
    }
    return cloned;
}
function createPresetDropdownSeparator(text) {
    return {
        value: null,
        label: text,
        isDisabled: true
    };
}
function createPresetDropdownValue(value, index) {
    return {
        value: index,
        label: value.name
    };
}
class RSVPOptionsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let current_preset;
        let all_presets = [];
        if (this.props.current_preset) {
            current_preset = clonePreset(this.props.current_preset);
            if (current_preset.author_id !== this.props.user_id) all_presets = [
                current_preset
            ];
        } else current_preset = clonePreset((0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS[0]);
        all_presets = (0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS.slice(0).concat(all_presets);
        if (this.props.user_presets) all_presets = all_presets.concat(this.props.user_presets);
        all_presets = all_presets.filter(function(elem, index, self) {
            return index === self.findIndex((val)=>elem.name === val.name);
        });
        this.state = {
            current_preset: current_preset,
            original_current_preset: clonePreset(current_preset),
            presets: all_presets,
            saving_state: null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlePresetChange = this.handlePresetChange.bind(this);
        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onSavePresetPressed = this.onSavePresetPressed.bind(this);
        this.onDeletePresetPressed = this.onDeletePresetPressed.bind(this);
        this.onAddPresetPressed = this.onAddPresetPressed.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleChange(index, event1, extra_events) {
        const value = event1.target.type === "checkbox" ? event1.target.checked : event1.target.value;
        this.state.current_preset.custom_options[index][event1.target.name] = value;
        if (extra_events) for (let event1 of extra_events)this.state.current_preset.custom_options[index][event1.target.name] = event1.target.value;
        this.state.current_preset.unsaved_changes = true;
        this.updateOptions(this.state.current_preset);
    }
    componentDidMount() {
        this.props.updateFunc(this.state.current_preset);
    }
    handlePresetChange(event1) {
        this.updateOptions(this.state.presets[event1.value], true);
    }
    componentWillUnmount() {
        if (this.props.ignore_unmount) return;
        this.props.updateFunc(null);
    }
    onDelete(index) {
        let new_options = this.state.current_preset.custom_options.filter((val, i)=>{
            return index !== i;
        });
        this.state.current_preset.custom_options = new_options;
        this.state.current_preset.unsaved_changes = true;
        this.updateOptions(this.state.current_preset, true);
    }
    updateOptions(new_preset, switched_presets = false) {
        let new_state;
        if (switched_presets) new_state = {
            current_preset: clonePreset(new_preset),
            original_current_preset: clonePreset(new_preset)
        };
        else new_state = {
            current_preset: clonePreset(new_preset)
        };
        this.setState({
            ...new_state
        });
        this.props.updateFunc(new_preset);
    }
    renderPresetDropdown() {
        let defaults = [];
        let available = [];
        let unavailable = [];
        this.state.presets.forEach((value, index)=>{
            let dropdownElement = createPresetDropdownValue(value, index);
            if (index < (0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS.length) {
                defaults.push(dropdownElement);
                return;
            }
            available.push(dropdownElement);
        });
        let result = [
            createPresetDropdownSeparator("\u2500 Defaults \u2500")
        ];
        result = result.concat(defaults);
        if (available.length > 0) {
            result = result.concat(createPresetDropdownSeparator("\u2500 Presets \u2500"));
            result = result.concat(available);
        }
        if (unavailable.length > 0) {
            result = result.concat(createPresetDropdownSeparator("\u2500 Unavailable \u2500"));
            result = result.concat(unavailable);
        }
        const dropdown_options = [
            {
                label: "\u2500 Defaults \u2500",
                value: undefined,
                options: defaults
            },
            {
                label: "\u2500 Presets \u2500",
                value: undefined,
                options: available
            },
            {
                label: "\u2500 Unavailable \u2500",
                value: undefined,
                options: unavailable
            }
        ];
        return dropdown_options;
    }
    OnEditEmojiTooltip(emoji) {
        if (!this.props.is_edit || emoji.just_added) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "tooltipright",
            children: "Can not change emoji of already made event"
        });
    }
    ButtonDeleteTooltip(is_default_option) {
        if (!(this.props.is_premium && is_default_option)) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "tooltiptop",
            children: "Cannot delete default preset"
        });
    }
    PresetButtonTooltip(content) {
        if (!this.props.is_premium) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "tooltiptop",
            children: content
        });
    }
    onAddPresetPressed(event1) {
        event1.preventDefault();
        event1.stopPropagation();
        if (!this.props.user_id) return;
        (0, _dashboardUtils.DashboardUtils).ShowPrompt("New Preset", "Enter a name for this preset.").then((val)=>{
            if (!val.isConfirmed) return;
            const preset_name = val.value;
            if (preset_name.length === 0) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Preset name must not be empty.");
                return;
            }
            if (this.state.presets.find((value)=>value.name === preset_name)) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Can not overwrite existing preset. Switch to that preset and save it instead.");
                return;
            }
            if (preset_name.length > (0, _constants.Constants).CUSTOM_OPTION_PRESET_NAME_MAX_LENGTH) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(`Preset name can not be more than ${(0, _constants.Constants).CUSTOM_OPTION_PRESET_NAME_MAX_LENGTH} characters.`);
                return;
            }
            let new_preset = {
                name: preset_name,
                unsaved_changes: true,
                custom_options: [],
                allow_multiple_rsvps: false
            };
            let new_preset_list = this.state.presets;
            let index = new_preset_list.findIndex((value)=>value.name === new_preset.name);
            // duplicate found
            if (index > -1) new_preset_list.splice(index, 1);
            new_preset_list.push(new_preset);
            this.setState({
                current_preset: new_preset,
                original_current_preset: clonePreset(new_preset),
                presets: new_preset_list
            });
            this.props.updateFunc(new_preset);
        });
    }
    onSavePresetPressed(event1) {
        event1.preventDefault();
        event1.stopPropagation();
        if (!this.props.user_id) return;
        (0, _dashboardUtils.DashboardUtils).ShowPrompt("Saving Preset", "Enter a name for this preset.\nPut in the same name to overwrite existing preset.", this.state.current_preset.name).then((val)=>{
            if (!val.isConfirmed) return;
            const preset_name = val.value;
            if ((0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS.find((value)=>value.name === preset_name)) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Can not overwrite default presets.\nTry a different name.");
                return;
            }
            if (preset_name.length > (0, _constants.Constants).CUSTOM_OPTION_PRESET_NAME_MAX_LENGTH) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(`Preset name can not be more than ${(0, _constants.Constants).CUSTOM_OPTION_PRESET_NAME_MAX_LENGTH} characters.`);
                return;
            }
            const dupe = (0, _commonFormatUtils.common_format_utils).get_duplicate_emojis_in_preset(this.state.current_preset);
            if (dupe) {
                let error = `Duplicate custom emojis [${dupe}]! Can not use the same emoji for multiple options.`;
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(error);
                return;
            }
            let current_preset = clonePreset(this.state.current_preset);
            current_preset.name = preset_name;
            let body = JSON.stringify({
                user_id: this.props.user_id,
                preset: JSON.stringify(current_preset),
                dm_data: JSON.stringify(this.props.dm_data),
                access_token: this.props.access_token,
                token_type: this.props.token_type
            });
            this.setState({
                saving_state: "Saving"
            });
            fetch(`/api/save_preset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: body
            }).then((response)=>response.json().then((preset)=>{
                    let new_preset_list = this.state.presets;
                    let index = new_preset_list.findIndex((value)=>value.name === preset.name);
                    // duplicate found
                    if (index > -1) new_preset_list.splice(index, 1);
                    else {
                        let old_preset_index = new_preset_list.findIndex((val)=>this.state.current_preset.name === val.name);
                        this.state.original_current_preset.unsaved_changes = false;
                        new_preset_list[old_preset_index] = this.state.original_current_preset;
                    }
                    new_preset_list.push(preset);
                    this.setState({
                        current_preset: preset,
                        original_current_preset: clonePreset(preset),
                        presets: new_preset_list,
                        saving_state: null
                    });
                    this.props.updateFunc(preset);
                }));
        });
    }
    onDeletePresetPressed() {
        event.preventDefault();
        event.stopPropagation();
        (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "Are you sure you want to delete preset",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "has-text-weight-bold",
                    children: this.state.current_preset.name
                }),
                "?"
            ]
        })).then((val)=>{
            if (!val.isConfirmed) return;
            let req = new XMLHttpRequest(); // new HttpRequest instance
            req.open("POST", "/api/delete_preset");
            req.setRequestHeader("Content-Type", "application/json");
            this.setState({
                saving_state: "Deleting"
            });
            fetch(`/api/delete_preset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user_id: this.props.user_id,
                    preset_name: this.state.current_preset.name,
                    dm_data: JSON.stringify(this.props.dm_data)
                })
            }).then((val)=>this.setState({
                    saving_state: null
                }));
            let index = this.state.presets.findIndex((value)=>{
                return value.name === this.state.current_preset.name;
            });
            if (index > -1) {
                let new_preset_list = this.state.presets;
                new_preset_list.splice(index, 1);
                let current_preset_index = Math.min(index, new_preset_list.length - 1);
                let current_preset = new_preset_list[current_preset_index];
                let new_state = {
                    current_preset: current_preset,
                    original_current_preset: clonePreset(current_preset),
                    presets: new_preset_list,
                    saving_state: this.state.saving_state
                };
                this.setState(new_state);
                this.props.updateFunc(new_state.current_preset);
            }
        });
    }
    RenderDropdown() {
        if (this.props.is_edit) return;
        let is_default_option = Boolean((0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS.find((value)=>value.name === this.state.current_preset.name));
        let current_index = this.state.presets.findIndex((value)=>{
            return this.state.current_preset.name === value.name;
        });
        let add_preset_tooltip = "Add new preset";
        let save_preset_tooltip = "Save as new preset";
        let delete_preset_tooltip = "Delete preset";
        if (!this.props.is_premium) {
            add_preset_tooltip = "Premium required to edit RSVP options.";
            save_preset_tooltip = "Premium required to edit RSVP options.";
        }
        if (this.props.is_premium && is_default_option) delete_preset_tooltip = "Cannot delete default preset";
        const button_class_names = [
            "button dashboard-primary-button--tiny mx-1"
        ];
        if (this.state.saving_state) button_class_names.push("input-disabled");
        const save_preset_button_class_names = button_class_names.slice();
        const delete_preset_button_class_names = button_class_names.slice();
        if (this.state.saving_state) switch(this.state.saving_state){
            case "Deleting":
                delete_preset_button_class_names.push("is-loading");
                break;
            case "Saving":
                save_preset_button_class_names.push("is-loading");
                break;
        }
        const options = this.renderPresetDropdown();
        const flat_options = options.flatMap((val)=>val.options ? val.options : val);
        const selected_option = flat_options.find((val)=>val.value === current_index);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: "Preset"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "control flex flex-col gap-2 sm:flex-row sm:items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                classNamePrefix: "sesh-dropdown",
                                value: selected_option,
                                options: this.renderPresetDropdown(),
                                onChange: this.handlePresetChange
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex gap-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    disabled: !this.props.is_premium || Boolean(this.state.saving_state),
                                    onClick: this.onAddPresetPressed,
                                    className: button_class_names.join(" "),
                                    title: add_preset_tooltip,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "icon is-medium",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fa fa-plus"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    disabled: !this.props.is_premium || Boolean(this.state.saving_state),
                                    onClick: this.onSavePresetPressed,
                                    className: save_preset_button_class_names.join(" "),
                                    title: save_preset_tooltip,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "icon is-medium",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fa fa-save"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    disabled: !this.props.is_premium || Boolean(this.state.saving_state) || is_default_option,
                                    onClick: this.onDeletePresetPressed,
                                    className: delete_preset_button_class_names.join(" "),
                                    style: {
                                        display: "inline-block"
                                    },
                                    title: delete_preset_tooltip,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "icon is-medium",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fa fa-trash"
                                        })
                                    })
                                })
                            ]
                        }),
                        this.state.current_preset.unsaved_changes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                color: "white"
                            },
                            children: "Unsaved Preset Changes"
                        })
                    ]
                })
            ]
        });
    }
    RSVPOption(index) {
        let custom_option = this.state.current_preset.custom_options[index];
        let emoji_enabled = false;
        if (this.props.is_edit) emoji_enabled = custom_option.just_added;
        else emoji_enabled = this.props.is_premium;
        let key = index + custom_option.emoji;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxItem.BoxItem), {
            bgColor: "semidark",
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-2 sm:flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "tooltip w-1/5",
                                    children: [
                                        this.OnEditEmojiTooltip(custom_option),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                            fallback: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "control",
                                                children: [
                                                    "Emoji",
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
                                                            size: "1rem",
                                                            loading: true,
                                                            color: (0, _constants.Constants).EMBED_COLOR
                                                        })
                                                    })
                                                ]
                                            }),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmojiPickerForm, {
                                                updateFunc: (val)=>{
                                                    let event1 = {
                                                        target: {
                                                            name: "emoji",
                                                            value: val.emoji
                                                        }
                                                    };
                                                    let second_event = {
                                                        target: {
                                                            name: "custom_emoji_data",
                                                            value: val.custom_emoji_data
                                                        }
                                                    };
                                                    let third_event = {
                                                        target: {
                                                            name: "guild_id",
                                                            value: val.guild_id
                                                        }
                                                    };
                                                    this.handleChange(index, event1, [
                                                        second_event,
                                                        third_event
                                                    ]);
                                                },
                                                emoji: custom_option.emoji,
                                                disabled: !emoji_enabled,
                                                custom_emojis: this.props.custom_emojis,
                                                all_guild_data: this.props.all_guild_data
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        "Name",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInputForm), {
                                            initial_value: custom_option.name,
                                            disabled: !this.props.is_premium,
                                            char_limit: (0, _constants.Constants).EVENT_REACTION_OPTION_NAME_LIMIT,
                                            updateFunc: (val)=>{
                                                let event1 = {
                                                    target: {
                                                        name: "name",
                                                        value: val
                                                    }
                                                };
                                                this.handleChange(index, event1);
                                            },
                                            placeholder: "Ex: RSVP"
                                        }, key)
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "limit-form",
                                    children: [
                                        "Limit",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _numberInput.NumberInputForm), {
                                            name: "limit",
                                            initial_value: custom_option.limit,
                                            do_not_update_initially: true,
                                            disabled: !this.props.is_premium,
                                            updateFunc: (val)=>{
                                                let event1 = {
                                                    target: {
                                                        name: "limit",
                                                        value: val
                                                    }
                                                };
                                                this.handleChange(index, event1);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).DeleteButton, {
                                className: "is-pulled-right",
                                onClick: ()=>this.onDelete(index)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-fit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-wrap gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-fit",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    name: "has_reminders",
                                                    type: "checkbox",
                                                    checked: custom_option.has_reminders,
                                                    disabled: !this.props.is_premium,
                                                    onChange: (event1)=>{
                                                        this.handleChange(index, event1);
                                                    }
                                                }),
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-fit",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Allow Reminders"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-fit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `flex flex-wrap gap-2`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "w-fit",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                name: "do_not_apply_attendee_role",
                                                type: "checkbox",
                                                disabled: !this.props.is_premium,
                                                checked: !Boolean(custom_option.do_not_apply_attendee_role),
                                                onChange: (event1)=>{
                                                    event1.target.checked = !event1.target.checked;
                                                    this.handleChange(index, event1);
                                                }
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Is Attendee"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                                info: "Indicates if users selecting this option are considered attendees. Users RSVPing to this option will be given Attendee Roles (if enabled) and will auto join Event Threads (if enabled)."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }, key);
    }
    AddOptionButton(index) {
        let list_type = index % 2 === 0 ? "list-odd" : "list-odd";
        let class_names = `${list_type}`;
        let disabled = !this.props.is_premium || this.state.current_preset.custom_options.length >= (0, _constants.Constants).EVENT_REACTION_LIMIT;
        let button_text;
        if (this.state.current_preset.custom_options.length >= (0, _constants.Constants).EVENT_REACTION_LIMIT) button_text = "Max Signup Option Reached";
        else button_text = "Add Signup Option";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
            bgColor: "semidark",
            className: "flex flex-col items-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                hide_arrow: true,
                disabled: disabled,
                onClick: this.onButtonPressed,
                children: button_text
            })
        }, "add");
    }
    onButtonPressed(event1) {
        event1.preventDefault();
        event1.stopPropagation();
        this.state.current_preset.custom_options.push({
            emoji: "\uD83D\uDE03",
            has_reminders: true,
            name: "",
            limit: null,
            just_added: true,
            user_ids: undefined
        });
        this.state.current_preset.unsaved_changes = true;
        this.updateOptions(this.state.current_preset);
    }
    RSVPOptionList() {
        let result = [];
        this.state.current_preset.custom_options.forEach((value, index)=>{
            result.push(this.RSVPOption(index));
        });
        result.push(this.AddOptionButton(result.length));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            className: "!mx-0 flex max-h-[500px] flex-col gap-2 overflow-y-auto overflow-x-hidden",
            children: result
        });
    }
    SubscribeToPremium() {
        if (this.props.is_premium) return;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    children: [
                        "\uD83D\uDD12 Subscribe to",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "locked-link",
                            href: (0, _constants.Constants).PREMIUM_LINK,
                            target: "_blank",
                            children: "Premium"
                        }),
                        " ",
                        "to edit RSVP options"
                    ]
                })
            ]
        });
    }
    render() {
        let button_element;
        if (this.props.save_for_guild_settings_data) {
            const disabled = this.state.current_preset.unsaved_changes;
            button_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field submit-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-mobile is-vcentered is-multiline",
                            children: [
                                disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "error-text",
                                        children: "Must save preset before you can set it as default"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        disabled: disabled,
                                        className: "button dashboard-primary-button is-size-4-tablet is-size-5-mobile",
                                        onClick: ()=>{
                                            this.props.save_for_guild_settings_data.on_click_func(this.state.current_preset);
                                        },
                                        children: this.props.save_for_guild_settings_data.text
                                    })
                                })
                            ]
                        })
                    })
                })
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mt-2 flex flex-col gap-2",
                    children: [
                        this.RenderDropdown(),
                        this.SubscribeToPremium(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBooleanItem.SettingsBooleanItem), {
                            disabled: !this.props.is_premium,
                            label: "Allow Multiple RSVPs",
                            is_beta: true,
                            description: "Allow users to RSVP to multiple options",
                            value: this.state.current_preset.allow_multiple_rsvps ?? false,
                            is_loading: false,
                            onChange: (checked)=>{
                                this.state.current_preset.allow_multiple_rsvps = checked;
                                this.state.current_preset.unsaved_changes = true;
                                this.updateOptions(this.state.current_preset);
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-col gap-4",
                            children: this.RSVPOptionList()
                        }, this.state.current_preset.name)
                    ]
                }),
                button_element
            ]
        });
    }
}
exports.default = RSVPOptionsForm;

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../common/constants":"lLiun","../../../../common/common_format_utils":"ggT25","../dashboard_utils":"jvA8A","d2dfad2f65700b60":"532ac","./number_input":"9IxdI","./text_input":"4jMf1","react-spinners":[["ClipLoader","9a5oM","default"]],"react-select":"8FQ4W","./improved_components/tooltips/info_tooltip":"93rAL","./improved_components/base_components/modify_settings_button":"kbhTg","./improved_components/settings_items/settings_boolean_item":"eGiOr","./improved_components/box_item":"gTVlB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"532ac":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("46b613c84e044a77")(import.meta.resolve("jnPd0")),
    import("h1QWH")
]).then(()=>module.bundle.root('1KFOX'));

},{"46b613c84e044a77":"hVPwM"}],"hVPwM":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"21JHI"}],"21JHI":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"eGiOr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SettingsBooleanItem", ()=>SettingsBooleanItem);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _removingThrobber = require("../../removing_throbber");
var _settingsBaseItem = require("./settings_base_item");
function SettingsBooleanItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-fit items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    "aria-hidden": !props.is_loading,
                    className: (0, _classnamesDefault.default)("flex", {
                        invisible: !props.is_loading,
                        visible: props.is_loading
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                    // height={24}
                    disabled: props.disabled || props.is_loading,
                    checked: props.value,
                    onChange: props.onChange,
                    onColor: "#00c3cc",
                    onHandleColor: "#00f4ff",
                    checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-check"
                        })
                    }),
                    uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-times"
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react-switch":"l5ttz","../../removing_throbber":"TmURk","./settings_base_item":"byg9r","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l5ttz":[function(require,module,exports,__globalThis) {
module.exports = require("5bdf5d330b1c5b98");

},{"5bdf5d330b1c5b98":"1a8kh"}],"1a8kh":[function(require,module,exports,__globalThis) {
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var t = require("ac6b16128f94da1b");
function i() {
    return i = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var s = arguments[i];
            for(var n in s)Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
        }
        return t;
    }, i.apply(this, arguments);
}
var s = t.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
        position: "absolute",
        top: 0
    }
}, t.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
})), n = t.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
        position: "absolute",
        top: 0
    }
}, t.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
}));
function o(t) {
    if (7 === t.length) return t;
    for(var i = "#", s = 1; s < 4; s += 1)i += t[s] + t[s];
    return i;
}
function h(t, i, s, n, h) {
    return function(t, i, s, n, o) {
        var h = (t - s) / (i - s);
        if (0 === h) return n;
        if (1 === h) return o;
        for(var e = "#", a = 1; a < 6; a += 2){
            var r = parseInt(n.substr(a, 2), 16), l = parseInt(o.substr(a, 2), 16), u = Math.round((1 - h) * r + h * l).toString(16);
            1 === u.length && (u = "0" + u), e += u;
        }
        return e;
    }(t, i, s, o(n), o(h));
}
var e = function(s) {
    function n(t) {
        s.call(this, t);
        var i = t.height, n = t.width, o = t.checked;
        this.t = t.handleDiameter || i - 2, this.i = Math.max(n - i, n - (i + this.t) / 2), this.o = Math.max(0, (i - this.t) / 2), this.state = {
            h: o ? this.i : this.o
        }, this.l = 0, this.u = 0, this.p = this.p.bind(this), this.v = this.v.bind(this), this.g = this.g.bind(this), this.k = this.k.bind(this), this.M = this.M.bind(this), this.m = this.m.bind(this), this.T = this.T.bind(this), this.$ = this.$.bind(this), this.C = this.C.bind(this), this.O = this.O.bind(this), this.D = this.D.bind(this), this.S = this.S.bind(this);
    }
    return s && (n.__proto__ = s), (n.prototype = Object.create(s && s.prototype)).constructor = n, n.prototype.componentDidMount = function() {
        this.W = !0;
    }, n.prototype.componentDidUpdate = function(t) {
        t.checked !== this.props.checked && this.setState({
            h: this.props.checked ? this.i : this.o
        });
    }, n.prototype.componentWillUnmount = function() {
        this.W = !1;
    }, n.prototype.I = function(t) {
        this.H.focus(), this.setState({
            j: t,
            R: !0,
            B: Date.now()
        });
    }, n.prototype.L = function(t) {
        var i = this.state, s = i.j, n = i.h, o = (this.props.checked ? this.i : this.o) + t - s;
        i.N || t === s || this.setState({
            N: !0
        });
        var h = Math.min(this.i, Math.max(this.o, o));
        h !== n && this.setState({
            h: h
        });
    }, n.prototype.U = function(t) {
        var i = this.state, s = i.h, n = i.N, o = i.B, h = this.props.checked, e = (this.i + this.o) / 2;
        this.setState({
            h: this.props.checked ? this.i : this.o
        });
        var a = Date.now() - o;
        (!n || a < 250 || h && s <= e || !h && s >= e) && this.A(t), this.W && this.setState({
            N: !1,
            R: !1
        }), this.l = Date.now();
    }, n.prototype.p = function(t) {
        t.preventDefault(), "number" == typeof t.button && 0 !== t.button || (this.I(t.clientX), window.addEventListener("mousemove", this.v), window.addEventListener("mouseup", this.g));
    }, n.prototype.v = function(t) {
        t.preventDefault(), this.L(t.clientX);
    }, n.prototype.g = function(t) {
        this.U(t), window.removeEventListener("mousemove", this.v), window.removeEventListener("mouseup", this.g);
    }, n.prototype.k = function(t) {
        this.X = null, this.I(t.touches[0].clientX);
    }, n.prototype.M = function(t) {
        this.L(t.touches[0].clientX);
    }, n.prototype.m = function(t) {
        t.preventDefault(), this.U(t);
    }, n.prototype.$ = function(t) {
        Date.now() - this.l > 50 && (this.A(t), Date.now() - this.u > 50 && this.W && this.setState({
            R: !1
        }));
    }, n.prototype.C = function() {
        this.u = Date.now();
    }, n.prototype.O = function() {
        this.setState({
            R: !0
        });
    }, n.prototype.D = function() {
        this.setState({
            R: !1
        });
    }, n.prototype.S = function(t) {
        this.H = t;
    }, n.prototype.T = function(t) {
        t.preventDefault(), this.H.focus(), this.A(t), this.W && this.setState({
            R: !1
        });
    }, n.prototype.A = function(t) {
        var i = this.props;
        (0, i.onChange)(!i.checked, t, i.id);
    }, n.prototype.render = function() {
        var s = this.props, n = s.checked, o = s.disabled, e = s.className, a = s.offColor, r = s.onColor, l = s.offHandleColor, u = s.onHandleColor, c = s.checkedIcon, d = s.uncheckedIcon, f = s.checkedHandleIcon, p = s.uncheckedHandleIcon, b = s.boxShadow, v = s.activeBoxShadow, g = s.height, y = s.width, w = s.borderRadius, k = function(t, i) {
            var s = {};
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && -1 === i.indexOf(n) && (s[n] = t[n]);
            return s;
        }(s, [
            "checked",
            "disabled",
            "className",
            "offColor",
            "onColor",
            "offHandleColor",
            "onHandleColor",
            "checkedIcon",
            "uncheckedIcon",
            "checkedHandleIcon",
            "uncheckedHandleIcon",
            "boxShadow",
            "activeBoxShadow",
            "height",
            "width",
            "borderRadius",
            "handleDiameter"
        ]), M = this.state, m = M.h, T = M.N, x = M.R, $ = {
            position: "relative",
            display: "inline-block",
            textAlign: "left",
            opacity: o ? .5 : 1,
            direction: "ltr",
            borderRadius: g / 2,
            WebkitTransition: "opacity 0.25s",
            MozTransition: "opacity 0.25s",
            transition: "opacity 0.25s",
            touchAction: "none",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none"
        }, C = {
            height: g,
            width: y,
            margin: Math.max(0, (this.t - g) / 2),
            position: "relative",
            background: h(m, this.i, this.o, a, r),
            borderRadius: "number" == typeof w ? w : g / 2,
            cursor: o ? "default" : "pointer",
            WebkitTransition: T ? null : "background 0.25s",
            MozTransition: T ? null : "background 0.25s",
            transition: T ? null : "background 0.25s"
        }, O = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "relative",
            opacity: (m - this.o) / (this.i - this.o),
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, D = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "absolute",
            opacity: 1 - (m - this.o) / (this.i - this.o),
            right: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, S = {
            height: this.t,
            width: this.t,
            background: h(m, this.i, this.o, l, u),
            display: "inline-block",
            cursor: o ? "default" : "pointer",
            borderRadius: "number" == typeof w ? w - 1 : "50%",
            position: "absolute",
            transform: "translateX(" + m + "px)",
            top: Math.max(0, (g - this.t) / 2),
            outline: 0,
            boxShadow: x ? v : b,
            border: 0,
            WebkitTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            MozTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            transition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        }, W = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * (1 - (m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, z = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * ((m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        };
        return t.createElement("div", {
            className: e,
            style: $
        }, t.createElement("div", {
            className: "react-switch-bg",
            style: C,
            onClick: o ? null : this.T,
            onMouseDown: function(t) {
                return t.preventDefault();
            }
        }, c && t.createElement("div", {
            style: O
        }, c), d && t.createElement("div", {
            style: D
        }, d)), t.createElement("div", {
            className: "react-switch-handle",
            style: S,
            onClick: function(t) {
                return t.preventDefault();
            },
            onMouseDown: o ? null : this.p,
            onTouchStart: o ? null : this.k,
            onTouchMove: o ? null : this.M,
            onTouchEnd: o ? null : this.m,
            onTouchCancel: o ? null : this.D
        }, p && t.createElement("div", {
            style: W
        }, p), f && t.createElement("div", {
            style: z
        }, f)), t.createElement("input", i({}, {
            type: "checkbox",
            role: "switch",
            "aria-checked": n,
            checked: n,
            disabled: o,
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: 1,
                margin: -1,
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: 1
            }
        }, k, {
            ref: this.S,
            onFocus: this.O,
            onBlur: this.D,
            onKeyUp: this.C,
            onChange: this.$
        })));
    }, n;
}(t.Component);
e.defaultProps = {
    disabled: !1,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: s,
    checkedIcon: n,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
}, exports.default = e;

},{"ac6b16128f94da1b":"IMRgT"}],"byg9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SettingsBaseItem", ()=>SettingsBaseItem);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _boxItem = require("../box_item");
function SettingsBaseItem(props) {
    const ref = (0, _react.useRef)(null);
    const [size, setSize] = (0, _react.useState)("md");
    (0, _react.useEffect)(()=>{
        if (!ref.current) return;
        ref.current.getBoundingClientRect();
        const resizeObserver = new ResizeObserver(()=>{
            if (!ref.current) return;
            const { width } = ref.current.getBoundingClientRect();
            setSize(width < 640 ? "md" : "lg");
        });
        resizeObserver.observe(ref.current);
        return ()=>resizeObserver.disconnect(); // clean up
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
        bgColor: props.bgColor ?? "semidark",
        customRef: ref,
        no_border: props.no_border,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-full flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full flex-col gap-4 md:flex-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    title: props.label,
                                    className: (0, _classnamesDefault.default)("flex items-center gap-2 overflow-hidden overflow-ellipsis font-bold", {
                                        "text-lg": size === "lg"
                                    }),
                                    children: [
                                        props.label,
                                        props.is_premium && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "rounded-md bg-sesh-primary px-1.5 py-0.5 text-xs font-medium text-black",
                                            children: "Premium"
                                        }),
                                        props.is_beta && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "rounded-md bg-sesh-primary px-1.5 py-0.5 text-xs font-medium text-black",
                                            children: "Beta"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _classnamesDefault.default)("text-content-secondary", {
                                        "text-sm": size === "md"
                                    }),
                                    children: props.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-2 w-full md:ml-auto md:mt-0 md:w-auto md:flex-shrink-0 md:flex-grow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full md:ml-auto md:w-fit",
                                children: props.children
                            })
                        })
                    ]
                }),
                props.below_element && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mt-4",
                    children: props.below_element
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../box_item":"gTVlB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9UTc1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RSVPOptionsTable", ()=>RSVPOptionsTable);
var _jsxRuntime = require("react/jsx-runtime");
function RSVPOptionsTable(props) {
    const rows = [];
    let index = 0;
    for (let option of props.options.custom_options){
        let emoji_element;
        if (option.custom_emoji_data) {
            const emoji_url = `https://cdn.discordapp.com/emojis/${option.custom_emoji_data.id}.` + (option.custom_emoji_data.animated ? "gif" : "png");
            emoji_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    style: {
                        maxWidth: "1rem",
                        maxHeight: "1rem"
                    },
                    src: emoji_url
                }, index)
            });
        } else emoji_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: option.emoji
        }, index);
        rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: emoji_element
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: option.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: option.limit ? option.limit : "\u221E"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: option.has_reminders ? "Enabled" : "Disabled"
                })
            ]
        }, index));
        index++;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: "sesh-table mobilized-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Emoji"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Limit"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Reminders"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: rows
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gPqC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DiscordNativeEventForm);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _prettyCheckboxReact = require("pretty-checkbox-react");
var _react = require("react");
var _commonUtils = require("../../../../common/common_utils");
var _constants = require("../../../../common/constants");
var _dashboardUtils = require("../dashboard_utils");
var _autocompleteInput = require("./improved_components/autocomplete_input/autocomplete_input");
var _modifySettingsButton = require("./improved_components/base_components/modify_settings_button");
var _seshTextInput = require("./improved_components/base_components/sesh_text_input");
var _discordNativeEvent = require("./improved_components/discord_embed/discord_native_event");
var _errorNote = require("./improved_components/error_note");
var _seshAccordianComponent = require("./improved_components/sesh_accordian_component");
var _infoTooltip = require("./improved_components/tooltips/info_tooltip");
var _imageUploader = require("./image_uploader");
var _voiceChannelDropdownForm = require("./voice_channel_dropdown_form");
var _voiceChannelDropdownFormDefault = parcelHelpers.interopDefault(_voiceChannelDropdownForm);
function DiscordNativeEventForm(props) {
    const [is_open, setIsOpen] = (0, _react.useState)(!!props.initial_event_data);
    const [ephemeral_value, setEphemeralValue] = (0, _react.useState)(props.initial_event_data ?? {
        location: {
            type: "EVENT_LINK"
        }
    });
    if (props.is_loading) return (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(undefined, 2);
    const is_default_setting = props.revert_descriptor && (0, _commonUtils.common_utils).areObjectsEqual(props.revert_descriptor.default.value, props.revert_descriptor.value);
    const has_invalid_permissions = !props.sesh_has_manage_events || !is_default_setting && !props.user_has_manage_events;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
        is_opened: is_open,
        disabled: props.is_disabled,
        label: props.label,
        info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "Create a corresponding Discord native event for this sesh event. For more info, see",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    className: "manual-link",
                    href: `${(0, _dashboardUtils.DashboardUtils).GetManualLink()}#native_events`,
                    target: "_blank",
                    children: "here"
                }),
                "."
            ]
        }),
        onChange: (is_open)=>{
            setIsOpen(is_open);
            const opened_value = has_invalid_permissions ? undefined : ephemeral_value;
            props.updateFunc(is_open ? opened_value : undefined);
        },
        is_channel_override_active: props.is_overridden,
        is_unsaved: props.unsaved_changes,
        revert_descriptor: props.revert_descriptor ? {
            ...props.revert_descriptor,
            onRevertPressed: ()=>{
                setEphemeralValue(props.revert_descriptor.default.value ?? {
                    location: {
                        type: "EVENT_LINK"
                    }
                });
                setIsOpen(!!props.revert_descriptor.default.value);
                props.revert_descriptor.onRevertPressed();
            }
        } : undefined,
        closed_element: props.show_on_closed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "discord-native-event-form cursor-not-allowed opacity-25",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "disable-pointer-events",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeEventFormBlurb, {
                    disabled: true,
                    is_guild_setting: props.is_guild_setting,
                    value: props.initial_event_data,
                    voice_channels: props.voice_channels,
                    rsvp_options: props.rsvp_options,
                    updateFunc: ()=>{}
                })
            })
        }) : undefined,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "discord-native-event-form",
            children: [
                has_invalid_permissions && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvalidPermissionsBlurb, {
                    sesh_has_manage_events: props.sesh_has_manage_events,
                    user_has_manage_events: props.user_has_manage_events,
                    is_default_setting: is_default_setting
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeEventFormBlurb, {
                    disabled: props.is_disabled || has_invalid_permissions,
                    is_guild_setting: props.is_guild_setting,
                    value: ephemeral_value,
                    voice_channels: props.voice_channels,
                    updateFunc: (native_event_data)=>{
                        setEphemeralValue(native_event_data);
                        props.updateFunc(native_event_data);
                    },
                    rsvp_options: props.rsvp_options
                })
            ]
        })
    });
}
function NativeEventFormBlurb(props) {
    const defaultCustomDescription = "$EventRSVPCounts\n\n\uD83D\uDD17 **[Event Details and Signup Link]($EventLink)**";
    const [custom_description, setCustomDescription] = (0, _react.useState)(props.value?.custom_description ?? defaultCustomDescription);
    const [is_editing_description, setIsEditingDescription] = (0, _react.useState)(false);
    const [image_url, setImageUrl] = (0, _react.useState)(props.value?.image_url ?? "");
    const getPreviewDescription = (description, rsvp_options)=>{
        try {
            // Create mock placeholder context for preview
            const mockPlaceholderContext = {
                event_link: "https://discord.com/channels/123456789/987654321/555666777",
                event_name: "Sample Event Name",
                start_time: _luxon.DateTime.now().plus({
                    days: 1
                }),
                timezone: "America/New_York",
                description: "This is a sample event description for preview purposes.",
                duration_ms: 7200000,
                rsvp_options: rsvp_options
            };
            return (0, _commonUtils.common_utils).replacePlaceholders("EmbedDescription", description, mockPlaceholderContext);
        } catch (error) {
            console.log(error);
            // If placeholder replacement fails, return original description with error note
            return `${description}\n\n[Preview Error: Some placeholders may not render correctly]`;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: props.disabled ? "input-disabled" : "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.is_guild_setting ? "Enable this setting to create a matching Discord native event in addition to the sesh event for all sesh events made in this server. Any edits made to either will update them both. Users must still RSVP via the sesh event." : "Enable this setting to create a matching Discord event in addition to the sesh event. Any edits made to either will update them both. Users must still RSVP via the sesh event."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPicker, {
                initial_location: props.value?.location,
                voice_channels: props.voice_channels,
                is_disabled: props.disabled,
                updateFunc: (location)=>{
                    props.updateFunc({
                        location,
                        custom_description: custom_description,
                        image_url: image_url
                    });
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "flex items-center font-semibold",
                                children: "Native Event Description"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        "Customize the description that appears in the Discord native event.",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://sesh.fyi/manual/placeholders",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "manual-link",
                                            children: "Supports placeholders"
                                        }),
                                        "."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                className: "ml-auto",
                                hide_arrow: true,
                                onClick: ()=>{
                                    const newEditingState = !is_editing_description;
                                    setIsEditingDescription(newEditingState);
                                    // If we're starting to edit and there's no custom description, set the default
                                    if (newEditingState && !props.value?.custom_description) props.updateFunc({
                                        location: props.value?.location ?? {
                                            type: "EVENT_LINK"
                                        },
                                        custom_description: defaultCustomDescription,
                                        image_url: image_url
                                    });
                                },
                                disabled: props.disabled,
                                children: is_editing_description ? "preview" : "edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control",
                        children: is_editing_description ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-2 text-sm text-content-secondary",
                                    children: [
                                        "Type",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "command-example--inline",
                                            children: "$"
                                        }),
                                        " ",
                                        "for a",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://sesh.fyi/manual/placeholders",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "manual-link",
                                            children: "full list of placeholders"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteInput.AutocompleteInput), {
                                    value: custom_description,
                                    onChange: (value)=>{
                                        setCustomDescription(value);
                                        props.updateFunc({
                                            location: props.value?.location ?? {
                                                type: "EVENT_LINK"
                                            },
                                            custom_description: value,
                                            image_url: image_url
                                        });
                                    },
                                    type: "description",
                                    placeholder: "Enter description for Discord event...",
                                    char_limit: (0, _constants.Constants).NATIVE_EVENT_DESCRIPTION_CHAR_LIMIT
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: custom_description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _discordNativeEvent.DiscordNativeEventComponent), {
                                description: getPreviewDescription(custom_description, props.rsvp_options)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "has-text-grey",
                                children: 'No description set. Click "edit" to add one.'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "flex items-center font-semibold",
                                children: "Native Event Image"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                info: "Add a banner image that appears at the top of the Discord native event. Images at least 800px wide and 320px tall are recommended."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "control",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-2 text-sm text-content-secondary",
                                children: "An image at least 800px wide and 320px tall is recommended"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageUploader.ImageUploaderForm), {
                                initial_value: image_url,
                                updateFunc: (value)=>{
                                    setImageUrl(value);
                                    props.updateFunc({
                                        location: props.value?.location ?? {
                                            type: "EVENT_LINK"
                                        },
                                        custom_description: custom_description,
                                        image_url: value
                                    });
                                },
                                disabled: props.disabled,
                                hide_header: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function InvalidPermissionsBlurb(props) {
    let prefix_text;
    if (props.is_default_setting) {
        if (!props.sesh_has_manage_events) prefix_text = "sesh";
        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    } else if (!props.sesh_has_manage_events && !props.user_has_manage_events) prefix_text = "Both you and sesh";
    else prefix_text = !props.sesh_has_manage_events ? "sesh" : "You";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mb-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
            error: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    prefix_text,
                    " must have the",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "has-text-weight-bold",
                        children: "Manage Events and Create Events"
                    }),
                    " ",
                    "permission in Discord to use this feature"
                ]
            })
        })
    });
}
function getLocationManualLink() {
    return `${(0, _dashboardUtils.DashboardUtils).GetManualLink()}#${(0, _constants.Constants).NATIVE_EVENT_LOCATION_HELP_ID}`;
}
function DiscordLocationPicker(props) {
    const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
    const voice_channels = props.voice_channels?.filter((val)=>!val.is_stage);
    const stage_channels = props.voice_channels?.filter((val)=>val.is_stage);
    let location_display_text;
    switch(props.initial_location?.type){
        case "EVENT_LINK":
            location_display_text = "Display a link to sesh event";
            break;
        case "VOICE_CHANNEL":
            location_display_text = voice_channels?.find((val)=>val.id === props.initial_location?.value)?.name ?? "loading...";
            break;
        case "STAGE_CHANNEL":
            location_display_text = stage_channels?.find((val)=>val.id === props.initial_location?.value)?.name ?? "loading...";
            break;
        case "ELSEWHERE":
            location_display_text = props.initial_location?.value;
            break;
        default:
            location_display_text = "none";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "flex items-center font-semibold",
                                children: "Event Location Field"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                info: "Set where the Discord native event will be located. Options include event signup link, voice channels, stage channels, or custom text."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                className: "ml-auto",
                                hide_arrow: true,
                                onClick: ()=>{
                                    setIsModalOpen(true);
                                },
                                disabled: props.is_disabled,
                                children: "edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocationIcon, {
                                    location_type: props.initial_location?.type,
                                    size: "MEDIUM"
                                }, props.initial_location?.type),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: location_display_text
                                })
                            ]
                        })
                    })
                ]
            }),
            isModalOpen && !props.is_disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPickerModal, {
                initial_location: props.initial_location,
                voice_channels: props.voice_channels,
                closeModal: ()=>setIsModalOpen(false),
                updateFunc: props.updateFunc
            })
        ]
    });
}
function DiscordLocationPickerModal(props) {
    const [selectedLocationType, setSelectedLocationType] = (0, _react.useState)(props.initial_location?.type);
    const [location_value, setLocationValue] = (0, _react.useState)(props.initial_location?.value);
    const voice_channels = props.voice_channels.filter((val)=>!val.is_stage);
    const stage_channels = props.voice_channels.filter((val)=>val.is_stage);
    let location_input_field;
    switch(selectedLocationType){
        case "EVENT_LINK":
            location_input_field = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    className: "label",
                    children: "Location will be set to a Discord link directly to the sesh event signup message"
                })
            });
            break;
        case "VOICE_CHANNEL":
            location_input_field = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _voiceChannelDropdownFormDefault.default), {
                voice_channels: voice_channels,
                selected_channel_id: location_value,
                updateFunc: (channel_id)=>setLocationValue(channel_id),
                is_stage: false
            });
            break;
        case "STAGE_CHANNEL":
            location_input_field = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _voiceChannelDropdownFormDefault.default), {
                voice_channels: stage_channels,
                selected_channel_id: location_value,
                updateFunc: (channel_id)=>setLocationValue(channel_id),
                is_stage: true
            });
            break;
        case "ELSEWHERE":
            location_input_field = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                label: "Input a location",
                input_props: {
                    placeholder: "An URL, a place, anything you want",
                    value: location_value,
                    maxLength: (0, _constants.Constants).LOCATION_CHARACTER_LIMIT,
                    onChange: (event)=>{
                        setLocationValue(event.currentTarget.value);
                    }
                }
            });
            break;
    }
    function onLocationTypeClicked(location) {
        setLocationValue(null);
        setSelectedLocationType(location);
    }
    const modal_content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-mobile is-multiline is-vcentered location-picker",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPickerLocationElement, {
                        onClick: (location)=>onLocationTypeClicked(location),
                        location_type: "EVENT_LINK",
                        selected_location: selectedLocationType,
                        label: "Event Signup Link (default)",
                        sublabel: "Location will be a link to the sesh signup message"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPickerLocationElement, {
                        onClick: (location)=>onLocationTypeClicked(location),
                        location_type: "VOICE_CHANNEL",
                        selected_location: selectedLocationType,
                        label: "Voice Channel",
                        sublabel: "Set location to a voice channel"
                    }),
                    stage_channels.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPickerLocationElement, {
                        onClick: (location)=>onLocationTypeClicked(location),
                        location_type: "STAGE_CHANNEL",
                        selected_location: selectedLocationType,
                        label: "Stage Channel",
                        sublabel: "Set location to a stage channel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordLocationPickerLocationElement, {
                        onClick: (location)=>onLocationTypeClicked(location),
                        location_type: "ELSEWHERE",
                        selected_location: selectedLocationType,
                        label: "Custom Text",
                        sublabel: "Input anything you want, such as a URL"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full",
                        children: location_input_field
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "is-pulled-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `button dashboard-primary-button--tiny is-size-6 has-text-right`,
                        type: "button",
                        disabled: !validateLocation(selectedLocationType, location_value, props.voice_channels),
                        onClick: (event)=>{
                            event.preventDefault();
                            props.updateFunc({
                                type: selectedLocationType,
                                value: location_value
                            });
                            props.closeModal();
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "has-text-weight-bold",
                            children: "Set Location"
                        })
                    })
                })
            })
        ]
    });
    const manual_link = getLocationManualLink();
    const subtitle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "Location will be displayed on the native event",
            "  ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: manual_link,
                target: "_blank",
                style: {
                    color: "inherit"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fa fa-info-circle font-awesome-hoverable"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: props.closeModal,
        title: "Discord Event Location",
        subtitle: subtitle,
        content: modal_content
    });
}
function validateLocation(location_type, selected_location, voice_channels) {
    switch(location_type){
        case "EVENT_LINK":
            return true;
        case "VOICE_CHANNEL":
            {
                const voice_channel = voice_channels.find((val)=>val.id === selected_location);
                return !voice_channel?.is_stage && (0, _dashboardUtils.DashboardUtils).IsValidSeshVoiceChannel(voice_channel, false);
            }
        case "STAGE_CHANNEL":
            {
                const stage_channel = voice_channels.find((val)=>val.id === selected_location);
                return stage_channel?.is_stage && (0, _dashboardUtils.DashboardUtils).IsValidSeshVoiceChannel(stage_channel, true);
            }
        case "ELSEWHERE":
            const elsewhere_input = selected_location;
            return elsewhere_input && elsewhere_input.length > 0;
        default:
            return false;
    }
}
function DiscordLocationPickerLocationElement(props) {
    const selected = props.location_type === props.selected_location;
    const classNames = [
        "column is-full location-picker-child"
    ];
    if (selected) classNames.push("is-active");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classNames.join(" "),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-multiline is-vcentered is-variable is-1",
            onClick: ()=>props.onClick(props.location_type),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow location-checkbox is-vcentered has-text-centered checkbox-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyCheckboxReact.Checkbox), {
                        className: "p-round title-checkbox",
                        name: "location",
                        checked: selected,
                        readOnly: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow is-vcentered has-text-centered is-hidden-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocationIcon, {
                        location_type: props.location_type,
                        size: "LARGE"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-mobile is-multiline !m-0 !p-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full has-text-weight-bold !m-0 !p-0",
                                children: props.label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full !m-0 !p-0",
                                children: props.sublabel
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function LocationIcon(props) {
    const font_awesome_classes = [
        "fas"
    ];
    switch(props.location_type){
        case "EVENT_LINK":
            font_awesome_classes.push("fa-calendar-check");
            break;
        case "VOICE_CHANNEL":
            font_awesome_classes.push("fa-volume-up");
            break;
        case "STAGE_CHANNEL":
            font_awesome_classes.push("fa-podcast");
            break;
        case "ELSEWHERE":
            font_awesome_classes.push("fa-map-marker-alt");
            break;
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    }
    const icon_classes = [
        "icon"
    ];
    switch(props.size){
        case "MEDIUM":
            icon_classes.push("is-medium");
            font_awesome_classes.push("fa-lg");
            break;
        case "LARGE":
            icon_classes.push("is-large");
            font_awesome_classes.push("fa-lg");
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: icon_classes.join(" "),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: font_awesome_classes.join(" ")
        })
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","pretty-checkbox-react":"fcrko","react":"IMRgT","../../../../common/common_utils":"gACUC","../../../../common/constants":"lLiun","../dashboard_utils":"jvA8A","./improved_components/autocomplete_input/autocomplete_input":"cjDV5","./improved_components/base_components/modify_settings_button":"kbhTg","./improved_components/base_components/sesh_text_input":"befXR","./improved_components/discord_embed/discord_native_event":"dXb0S","./improved_components/error_note":"kzA14","./improved_components/sesh_accordian_component":"9ti9e","./improved_components/tooltips/info_tooltip":"93rAL","./image_uploader":"kfglS","./voice_channel_dropdown_form":"3hTwV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dXb0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiscordNativeEventComponent", ()=>DiscordNativeEventComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _markdown = require("../../../markdown_parser/markdown");
var _discordEmbedScss = require("./discord_embed.scss");
function DiscordNativeEventComponent(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full max-w-full flex-col gap-2 rounded-xl border border-[#3B3B40] bg-base-dark p-6",
        children: props.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "description w-full break-words text-sm",
            children: (0, _markdown.parseAllowLinks)(props.description.replaceAll("\n", "  \n"))
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../../markdown_parser/markdown":"gk0Ee","./discord_embed.scss":"FVRbj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"FVRbj":[function() {},{}],"3hTwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VoiceChannelDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _dashboardUtils = require("../dashboard_utils");
function VoiceChannelDropdown(props) {
    const initial_channel_id = props.selected_channel_id ?? (props.voice_channels ? props.voice_channels[0]?.id : undefined);
    if (!props.voice_channels) return (0, _dashboardUtils.DashboardUtils).RenderLoadingSelect();
    (0, _react.useEffect)(()=>{
        props.updateFunc(initial_channel_id);
    });
    // TODO: sort on server
    const category_dropdown_map = new Map();
    const channel_dropdown_map = new Map();
    const channel_dropdown_descriptors = [];
    for (const channel of props.voice_channels){
        const channel_dropdown = createChannelDropdownDescriptor(channel);
        channel_dropdown_map.set(channel.id, channel_dropdown);
        if (channel.category_id) {
            // this channel is in a category
            const existing_category_dropdown = category_dropdown_map.get(channel.category_id);
            if (existing_category_dropdown) {
                // category already made
                existing_category_dropdown.options.push(channel_dropdown);
                continue;
            }
            // category has not been made yet
            const category_dropdown_descriptor = createCategoryDropdownDesciptor(channel);
            category_dropdown_descriptor.options.push(channel_dropdown);
            channel_dropdown_descriptors.push(category_dropdown_descriptor);
            category_dropdown_map.set(category_dropdown_descriptor.value, category_dropdown_descriptor);
            continue;
        }
        // not in a category
        channel_dropdown_descriptors.push(channel_dropdown);
    }
    let initial_value = channel_dropdown_map.get(initial_channel_id);
    if (!initial_value) {
        initial_value = [
            ...channel_dropdown_map.values()
        ][0];
        if (!initial_value) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "field",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                className: "label",
                children: [
                    "No valid ",
                    props.is_stage ? "stage" : "voice",
                    " channels."
                ]
            })
        });
    }
    const is_valid_voice_channel = (0, _dashboardUtils.DashboardUtils).IsValidSeshVoiceChannel(initial_value.channel_data, props.is_stage);
    const label = props.is_stage ? "Choose a stage channel" : "Choose a voice channel";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "field",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "control",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                    //menuIsOpen={true}
                    classNamePrefix: "sesh-dropdown",
                    filterOption: filterOptions,
                    //styles={style}
                    value: initial_value,
                    options: channel_dropdown_descriptors,
                    onChange: (channel_dropdown)=>props.updateFunc(channel_dropdown.channel_data.id),
                    isDisabled: false
                })
            }),
            !is_valid_voice_channel && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvalidVoiceChannelDescription, {
                voice_channel: initial_value.channel_data
            })
        ]
    });
}
function InvalidVoiceChannelDescription(props) {
    const sesh_missing_permissions_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            "sesh is missing",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: props.voice_channel.sesh_missing_perms.join(", ")
            }),
            " ",
            "permissions"
        ]
    });
    const user_missing_permissions_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            "You are missing",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: props.voice_channel.user_missing_perms.join(", ")
            }),
            " ",
            "permissions"
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "error-note mt-4",
        children: [
            props.voice_channel.user_missing_perms.length > 0 && user_missing_permissions_element,
            props.voice_channel.sesh_missing_perms.length > 0 && sesh_missing_permissions_element
        ]
    });
}
function createChannelDropdownDescriptor(channel) {
    let icon;
    let disabled_text_element;
    const is_valid_channel = (0, _dashboardUtils.DashboardUtils).IsValidSeshVoiceChannel(channel, channel.is_stage);
    const classNames = [
        "columns is-mobile is-vcentered is-variable is-1"
    ];
    if (is_valid_channel) icon = channel.is_stage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fa fa-podcast"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-volume-up"
    });
    else {
        icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-ban"
        });
        disabled_text_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `column is-pulled-right dropdown-disabled-text`,
            children: "Invalid Permissions"
        });
        classNames.push("invalid-permissions-dropdown-element");
    }
    return {
        channel_data: channel,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: classNames.join(" "),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "icon",
                        children: icon
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: channel.name
                }),
                disabled_text_element
            ]
        }),
        value: channel.id,
        is_disabled: false
    };
}
function createCategoryDropdownDesciptor(channel) {
    return {
        value: channel.category_id,
        label: channel.category_name,
        options: []
    };
}
function filterOptions(option, input) {
    let lowercase_input = input.toLowerCase();
    let lowercase_channel = option.data.channel_data.name.toLowerCase();
    return lowercase_channel.includes(lowercase_input);
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select":"8FQ4W","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2CCGw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoleRestrictionsForm", ()=>RoleRestrictionsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _useRoles = require("./improved_components/hooks/use_roles");
var _searchableDropdown = require("./searchable_dropdown");
function RoleRestrictionsForm(props) {
    const roles = (0, _useRoles.useRoles)();
    const mentionables = roles?.filter((val)=>props.role_ids.includes(val.id)) ?? [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.SearchableDropdown), {
        options: roles.filter((val)=>!val.is_everyone_or_here) ?? [],
        placeholder: props.disabled ? "Disabled" : "None",
        handleChange: (mentionables)=>props.updateFunc(mentionables.map((val)=>val.id)),
        initial_mentions: mentionables.filter((val)=>!val.is_everyone_or_here),
        ignore_invalid_permissions: true,
        loading: !roles,
        disabled: props.disabled
    });
}

},{"react/jsx-runtime":"dpQXr","./improved_components/hooks/use_roles":"b2XTr","./searchable_dropdown":"8iEAS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dPYPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaForm", ()=>TextAreaForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textareaAutosize = require("../TextareaAutosize");
class TextAreaForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let value = props.initial_value ? props.initial_value : "";
        this.state = {
            value: value
        };
        this.handleChange = this.handleChange.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleChange(event) {
        this.setState({
            value: event.target.value
        });
        this.props.updateFunc(event.target.value);
    }
    componentWillUnmount() {
        if (this.props.do_not_clear_on_unmount) return;
        this.props.updateFunc("");
    }
    render() {
        const show_char_count = this.props.char_limit && this.state.value.length > this.props.char_limit * 0.85;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                this.props.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    className: "label is-size-5",
                    children: this.props.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosize.TextareaAutosize), {
                        className: "textarea input",
                        placeholder: this.props.placeholder,
                        value: this.state.value,
                        onChange: this.handleChange,
                        maxLength: this.props.char_limit,
                        rows: 2
                    })
                }),
                show_char_count && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "has-text-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: this.state.value.length === this.props.char_limit ? "error-text" : "",
                        children: [
                            this.state.value.length,
                            "/",
                            this.props.char_limit
                        ]
                    })
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../TextareaAutosize":"ltpXu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ltpXu":[function(require,module,exports,__globalThis) {
// from https://github.com/buildo/react-autosize-textarea/blob/master/src/TextareaAutosize.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextareaAutosize", ()=>TextareaAutosize);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _lineHeight = require("line-height");
var _autosize = require("autosize");
const getLineHeight = _lineHeight;
const RESIZED = "autosize:resized";
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */ class TextareaAutosizeClass extends _react.Component {
    static{
        this.defaultProps = {
            rows: 1,
            async: false
        };
    }
    static{
        this.propTypes = {
            rows: _propTypes.number,
            maxRows: _propTypes.number,
            onResize: _propTypes.func,
            innerRef: _propTypes.any,
            async: _propTypes.bool
        };
    }
    componentDidMount() {
        const { maxRows, async } = this.props;
        if (typeof maxRows === "number") this.updateLineHeight();
        if (typeof maxRows === "number" || async) /*
        the defer is needed to:
          - force "autosize" to activate the scrollbar when this.props.maxRows is passed
          - support StyledComponents (see #71)
      */ setTimeout(()=>this.textarea && _autosize.default(this.textarea));
        else this.textarea && _autosize.default(this.textarea);
        if (this.textarea) this.textarea.addEventListener(RESIZED, this.onResize);
    }
    componentWillUnmount() {
        if (this.textarea) {
            this.textarea.removeEventListener(RESIZED, this.onResize);
            _autosize.default.destroy(this.textarea);
        }
    }
    render() {
        const { props: { onResize, maxRows, onChange, style, innerRef, children, ...props }, state: { lineHeight } } = this;
        const maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
            ...props,
            onChange: this.onChange,
            style: maxHeight ? {
                ...style,
                maxHeight
            } : style,
            ref: (element)=>{
                this.textarea = element;
                if (typeof this.props.innerRef === "function") this.props.innerRef(element);
                else if (this.props.innerRef) this.props.innerRef.current = element;
            },
            children: children
        });
    }
    componentDidUpdate() {
        this.textarea && _autosize.default.update(this.textarea);
    }
    constructor(...args){
        super(...args), this.state = {
            lineHeight: null
        }, this.textarea = null, this.onResize = (e)=>{
            if (this.props.onResize) this.props.onResize(e);
        }, this.updateLineHeight = ()=>{
            if (this.textarea) this.setState({
                lineHeight: getLineHeight(this.textarea)
            });
        }, this.onChange = (e)=>{
            const { onChange } = this.props;
            this.currentValue = e.currentTarget.value;
            onChange && onChange(e);
        };
    }
}
const TextareaAutosize = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextareaAutosizeClass, {
        ...props,
        innerRef: ref
    });
});

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","prop-types":"iRwZ2","line-height":"69Ltu","autosize":"2hDFW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"69Ltu":[function(require,module,exports,__globalThis) {
// Load in dependencies
var computedStyle = require("e713fcfdddfe2b91");
/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */ function lineHeight(node) {
    // Grab the line-height via style
    var lnHeightStr = computedStyle(node, 'line-height');
    var lnHeight = parseFloat(lnHeightStr, 10);
    // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
    if (lnHeightStr === lnHeight + '') {
        // Save the old lineHeight style and update the em unit to the element
        var _lnHeightStyle = node.style.lineHeight;
        node.style.lineHeight = lnHeightStr + 'em';
        // Calculate the em based height
        lnHeightStr = computedStyle(node, 'line-height');
        lnHeight = parseFloat(lnHeightStr, 10);
        // Revert the lineHeight style
        if (_lnHeightStyle) node.style.lineHeight = _lnHeightStyle;
        else delete node.style.lineHeight;
    }
    // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
    // DEV: `em` units are converted to `pt` in IE6
    // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
    if (lnHeightStr.indexOf('pt') !== -1) {
        lnHeight *= 4;
        lnHeight /= 3;
    // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
    } else if (lnHeightStr.indexOf('mm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 25.4;
    // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
    } else if (lnHeightStr.indexOf('cm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 2.54;
    // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
    } else if (lnHeightStr.indexOf('in') !== -1) lnHeight *= 96;
    else if (lnHeightStr.indexOf('pc') !== -1) lnHeight *= 16;
    // Continue our computation
    lnHeight = Math.round(lnHeight);
    // If the line-height is "normal", calculate by font-size
    if (lnHeightStr === 'normal') {
        // Create a temporary node
        var nodeName = node.nodeName;
        var _node = document.createElement(nodeName);
        _node.innerHTML = '&nbsp;';
        // If we have a text area, reset it to only 1 row
        // https://github.com/twolfson/line-height/issues/4
        if (nodeName.toUpperCase() === 'TEXTAREA') _node.setAttribute('rows', '1');
        // Set the font-size of the element
        var fontSizeStr = computedStyle(node, 'font-size');
        _node.style.fontSize = fontSizeStr;
        // Remove default padding/border which can affect offset height
        // https://github.com/twolfson/line-height/issues/4
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
        _node.style.padding = '0px';
        _node.style.border = '0px';
        // Append it to the body
        var body = document.body;
        body.appendChild(_node);
        // Assume the line height of the element is the height
        var height = _node.offsetHeight;
        lnHeight = height;
        // Remove our child from the DOM
        body.removeChild(_node);
    }
    // Return the calculated height
    return lnHeight;
}
// Export lineHeight
module.exports = lineHeight;

},{"e713fcfdddfe2b91":"5cYnc"}],"5cYnc":[function(require,module,exports,__globalThis) {
// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var computedStyle = function(el, prop, getComputedStyle) {
    getComputedStyle = window.getComputedStyle;
    // In one fell swoop
    return(// If we have getComputedStyle
    (getComputedStyle ? // Query it
    // TODO: From CSS-Query notes, we might need (node, null) for FF
    getComputedStyle(el) : // Otherwise, we are in IE and use currentStyle
    el.currentStyle)[// Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function(word, letter) {
        return letter.toUpperCase();
    })]);
};
module.exports = computedStyle;

},{}],"2hDFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var e, t, n = "function" == typeof Map ? new Map : (e = [], t = [], {
    has: function(t) {
        return e.indexOf(t) > -1;
    },
    get: function(n) {
        return t[e.indexOf(n)];
    },
    set: function(n, o) {
        -1 === e.indexOf(n) && (e.push(n), t.push(o));
    },
    delete: function(n) {
        var o = e.indexOf(n);
        o > -1 && (e.splice(o, 1), t.splice(o, 1));
    }
}), o = function(e) {
    return new Event(e, {
        bubbles: !0
    });
};
try {
    new Event("test");
} catch (e) {
    o = function(e) {
        var t = document.createEvent("Event");
        return t.initEvent(e, !0, !1), t;
    };
}
function r(e) {
    var t = n.get(e);
    t && t.destroy();
}
function i(e) {
    var t = n.get(e);
    t && t.update();
}
var l = null;
"undefined" == typeof window || "function" != typeof window.getComputedStyle ? ((l = function(e) {
    return e;
}).destroy = function(e) {
    return e;
}, l.update = function(e) {
    return e;
}) : ((l = function(e, t) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], function(e) {
        return function(e) {
            if (e && e.nodeName && "TEXTAREA" === e.nodeName && !n.has(e)) {
                var t, r = null, i = null, l = null, d = function() {
                    e.clientWidth !== i && c();
                }, a = (function(t) {
                    window.removeEventListener("resize", d, !1), e.removeEventListener("input", c, !1), e.removeEventListener("keyup", c, !1), e.removeEventListener("autosize:destroy", a, !1), e.removeEventListener("autosize:update", c, !1), Object.keys(t).forEach(function(n) {
                        e.style[n] = t[n];
                    }), n.delete(e);
                }).bind(e, {
                    height: e.style.height,
                    resize: e.style.resize,
                    overflowY: e.style.overflowY,
                    overflowX: e.style.overflowX,
                    wordWrap: e.style.wordWrap
                });
                e.addEventListener("autosize:destroy", a, !1), "onpropertychange" in e && "oninput" in e && e.addEventListener("keyup", c, !1), window.addEventListener("resize", d, !1), e.addEventListener("input", c, !1), e.addEventListener("autosize:update", c, !1), e.style.overflowX = "hidden", e.style.wordWrap = "break-word", n.set(e, {
                    destroy: a,
                    update: c
                }), "vertical" === (t = window.getComputedStyle(e, null)).resize ? e.style.resize = "none" : "both" === t.resize && (e.style.resize = "horizontal"), r = "content-box" === t.boxSizing ? -(parseFloat(t.paddingTop) + parseFloat(t.paddingBottom)) : parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), isNaN(r) && (r = 0), c();
            }
            function u(t) {
                var n = e.style.width;
                e.style.width = "0px", e.style.width = n, e.style.overflowY = t;
            }
            function s() {
                if (0 !== e.scrollHeight) {
                    var t = function(e) {
                        for(var t = []; e && e.parentNode && e.parentNode instanceof Element;)e.parentNode.scrollTop && t.push({
                            node: e.parentNode,
                            scrollTop: e.parentNode.scrollTop
                        }), e = e.parentNode;
                        return t;
                    }(e), n = document.documentElement && document.documentElement.scrollTop;
                    e.style.height = "", e.style.height = e.scrollHeight + r + "px", i = e.clientWidth, t.forEach(function(e) {
                        e.node.scrollTop = e.scrollTop;
                    }), n && (document.documentElement.scrollTop = n);
                }
            }
            function c() {
                s();
                var t = Math.round(parseFloat(e.style.height)), n = window.getComputedStyle(e, null), r = "content-box" === n.boxSizing ? Math.round(parseFloat(n.height)) : e.offsetHeight;
                if (r < t ? "hidden" === n.overflowY && (u("scroll"), s(), r = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight) : "hidden" !== n.overflowY && (u("hidden"), s(), r = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight), l !== r) {
                    l = r;
                    var i = o("autosize:resized");
                    try {
                        e.dispatchEvent(i);
                    } catch (e) {}
                }
            }
        }(e);
    }), e;
}).destroy = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], r), e;
}, l.update = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], i), e;
});
var d = l;
exports.default = d;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2BuW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildSettingToEventSetting", ()=>GuildSettingToEventSetting);
parcelHelpers.export(exports, "EventSettingToGuildSetting", ()=>EventSettingToGuildSetting);
parcelHelpers.export(exports, "ServerRemindersGroupedKeys", ()=>ServerRemindersGroupedKeys);
parcelHelpers.export(exports, "DefaultGuildSettingValues", ()=>DefaultGuildSettingValues);
parcelHelpers.export(exports, "EventEditDataToStateData", ()=>EventEditDataToStateData);
parcelHelpers.export(exports, "createInitialEventState", ()=>createInitialEventState);
var _luxon = require("luxon");
var _rrule = require("rrule");
var _constants = require("../../../../common/constants");
var _timeFormatUtils = require("../../../../common/time_format_utils");
const GuildSettingToEventSetting = {
    attendee_role_data: "attendee_role_data",
    default_event_embed_color: "color",
    default_event_server_reminders: "server_reminders",
    default_event_thread_settings: "thread_settings",
    default_hide_attendees: "hide_attendees",
    default_native_event_data: "native_event_data",
    signup_options: "rsvp_options",
    default_role_mentions_on_event_create: "role_mentions_on_create",
    default_user_mentions_on_event_create: "user_mentions_on_create"
};
const EventSettingToGuildSetting = Object.fromEntries(Object.entries(GuildSettingToEventSetting).map(([key, value])=>[
        value,
        key
    ]));
const ServerRemindersGroupedKeys = [
    "server_reminders",
    "role_mentions_on_create",
    "user_mentions_on_create"
];
const DefaultGuildSettingValues = {
    signup_options: (0, _constants.Constants).WEB_UI_DEFAULT_REACTION_PRESETS[0],
    default_hide_attendees: false,
    default_event_embed_color: (0, _constants.Constants).EMBED_COLOR
};
/**
 * Map of EventEditableStateKeys (sent from backend) to EventCreationState keys (used on frontend)
 */ const EventEditableDataKeyToStateKey = {
    start_time: "start_time",
    hide_attendees: "hide_attendees",
    allow_maintain_repeat_rsvp: "allow_maintain_repeat_rsvp",
    attendee_role_data: "attendee_role_data",
    thread_settings: "thread_settings",
    color: "color",
    description: "description",
    eligible_role_ids: "eligible_role_ids",
    duration_ms: "duration_ms",
    event_name: "event_name",
    event_timezone: "event_timezone",
    role_mentions_on_create: "role_mentions_on_create",
    user_mentions_on_create: "user_mentions_on_create",
    image_url: "image_url",
    native_event_data: "native_event_data",
    rrule_str: "rrule",
    rsvp_options: "rsvp_options",
    sent_channel_data: "selected_channel",
    server_reminders: "server_reminders",
    exdates: "exdates",
    rdates: "rdates",
    rsvp_lock_before_ms: "rsvp_lock_before_ms"
};
const EventEditDataToStateData = {
    start_time: (ctx, raw_date)=>(0, _luxon.DateTime).fromJSDate(new Date(raw_date)).toUTC(),
    rrule_str: (ctx, rrule_str)=>{
        if (!rrule_str) return;
        return new (0, _rrule.RRule)((0, _timeFormatUtils.time_format_utils).transformRRuleToTimezone((0, _rrule.RRule).parseString(rrule_str), ctx.user_timezone, ctx.start_time, true));
    },
    exdates: (ctx, exdates)=>{
        if (!exdates) return;
        return exdates.map((val)=>new Date(val));
    },
    duration_ms: undefined,
    sent_channel_data: undefined,
    eligible_role_ids: undefined,
    allow_maintain_repeat_rsvp: undefined,
    attendee_role_data: undefined,
    color: (ctx, color)=>color ?? (0, _constants.Constants).EMBED_COLOR,
    description: undefined,
    event_name: undefined,
    event_timezone: undefined,
    hide_attendees: undefined,
    image_url: undefined,
    native_event_data: undefined,
    role_mentions_on_create: undefined,
    rsvp_options: undefined,
    thread_settings: undefined,
    user_mentions_on_create: undefined,
    server_reminders: undefined,
    rdates: undefined,
    rsvp_lock_before_ms: undefined
};
function createInitialEventState(event, ctx) {
    // EDIT
    const result = {};
    const event_data = event.props.is_edit ? event.props.edit_data : event.props.template_data?.json;
    if (event_data) {
        const start_time = EventEditDataToStateData.start_time({
            ...ctx,
            start_time: undefined
        }, event_data.start_time);
        for(const key in event_data){
            const edit_key = key;
            const state_key = EventEditableDataKeyToStateKey[edit_key];
            result[state_key] = EventEditDataToStateData[edit_key]?.({
                ...ctx,
                start_time
            }, event_data[edit_key]) ?? event_data[edit_key];
        }
        const channel_data = event.getUpdatedChannelData();
        if (event.props.template_data) result.selected_channel = channel_data?.selected_channel ? {
            id: channel_data?.selected_channel?.id,
            forum_tag_ids: []
        } : undefined;
        return result;
    }
    // END EDIT
    const channel_data = event.getUpdatedChannelData();
    const guild_default_values = {};
    for(const guild_key in GuildSettingToEventSetting){
        const casted_guild_key = guild_key;
        const event_key = GuildSettingToEventSetting[casted_guild_key];
        guild_default_values[event_key] = event.getGuildOrChannelSettingWithChannelParam(casted_guild_key, channel_data?.selected_channel);
    }
    const complete_guild_default_values = guild_default_values;
    const params = new URLSearchParams(event.props.location.search);
    const start_time_from_state = params.get("date") ?? undefined;
    const event_title_from_state = params.get("title") ?? undefined;
    const event_description_from_state = params.get("description") ?? undefined;
    // TODO: should ideally remove date from URL but no big deal
    const other = {
        event_name: event_title_from_state ?? "",
        description: event_description_from_state ?? "",
        // from calendar page
        start_time: start_time_from_state ? (0, _luxon.DateTime).fromJSDate(new Date(decodeURIComponent(start_time_from_state))) : undefined,
        exdates: undefined,
        eligible_role_ids: [],
        duration_ms: undefined,
        rsvp_lock_before_ms: null,
        event_timezone: ctx.user_timezone,
        image_url: undefined,
        rrule: undefined,
        selected_channel: channel_data?.selected_channel ? {
            id: channel_data?.selected_channel?.id,
            forum_tag_ids: []
        } : undefined,
        allow_maintain_repeat_rsvp: true,
        rdates: undefined
    };
    return {
        ...complete_guild_default_values,
        ...other
    };
}

},{"luxon":"fLWpi","rrule":"ilLpP","../../../../common/constants":"lLiun","../../../../common/time_format_utils":"g0uQN","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bnjcr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LockRSVPsBefore", ()=>LockRSVPsBefore);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _dayHourMinutePicker = require("../day_hour_minute_picker");
var _disabler = require("../disabler");
var _useEventCreationContext = require("../hooks/use_event_creation_context");
var _seshAccordianComponent = require("../sesh_accordian_component");
function LockRSVPsBefore(props) {
    const event_state = (0, _useEventCreationContext.useEventCreationContext)();
    const start_time = event_state.state.start_time;
    const duration = (0, _luxon.Duration).fromMillis(event_state.state.rsvp_lock_before_ms ?? 0);
    let description;
    if (start_time) description = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "RSVPs will be locked on",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-semibold",
                children: start_time.toLocal().minus(duration).toLocaleString({
                    dateStyle: "full",
                    timeStyle: "short"
                })
            })
        ]
    });
    else description = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "RSVPs will be locked",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-semibold",
                children: duration.toFormat("d 'days,' h 'hours,' m 'minutes'")
            }),
            " ",
            "before event start"
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
        disabled: props.disabled,
        does_require_premium: true,
        does_server_have_premium: event_state.props.is_premium,
        info: "Prevent users from RSVPing a certain amount of time before the event starts.",
        is_opened: event_state.state.rsvp_lock_before_ms !== null,
        label: "Close RSVPs Early",
        onChange: (isOpen)=>{
            event_state.setState({
                rsvp_lock_before_ms: !isOpen ? null : 3600000
            });
        },
        is_new: true,
        closed_element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
            disabled: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "RSVPs will not be locked before event start."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayHourMinutePicker.DayHourMinutePicker), {
                        duration_ms: 3600000,
                        updateFunc: ()=>{}
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
            disabled: props.disabled,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: description
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayHourMinutePicker.DayHourMinutePicker), {
                        duration_ms: event_state.state.rsvp_lock_before_ms ?? 0,
                        updateFunc: (val)=>event_state.setState({
                                rsvp_lock_before_ms: val
                            })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","../day_hour_minute_picker":"7A7NP","../disabler":"hF5sC","../hooks/use_event_creation_context":"flKqC","../sesh_accordian_component":"9ti9e","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7A7NP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayHourMinutePicker", ()=>DayHourMinutePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
function formatPluralDuration(num, label) {
    return num === 1 ? `${num} ${label}` : `${num} ${label}s`;
}
function DayHourMinutePicker(props) {
    const minutes_in_ms = 60000;
    const hours_in_ms = minutes_in_ms * 60;
    const days_in_ms = hours_in_ms * 24;
    const days = Math.floor(props.duration_ms / days_in_ms);
    const hours = Math.floor(props.duration_ms % days_in_ms / hours_in_ms);
    const minutes = props.duration_ms % hours_in_ms / minutes_in_ms;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ml-auto flex w-full items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationDropdown, {
                    setValue: (val)=>{
                        props.updateFunc(val * days_in_ms + hours * hours_in_ms + minutes_in_ms * minutes);
                    },
                    value: days,
                    type: "day"
                }, "day")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationDropdown, {
                    setValue: (val)=>props.updateFunc(days_in_ms * days + val * hours_in_ms + minutes_in_ms * minutes),
                    value: hours,
                    type: "hour"
                }, "hour")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationDropdown, {
                    setValue: (val)=>props.updateFunc(days_in_ms * days + hours * hours_in_ms + val * minutes_in_ms),
                    value: minutes,
                    type: "minute"
                }, "minute")
            })
        ]
    });
}
function createInitialDayOptions(val) {
    const day_options = [];
    for(let i = 0; i < 100; i++)day_options.push({
        label: formatPluralDuration(i, "day"),
        value: i
    });
    if (val >= 100) day_options.push({
        label: formatPluralDuration(val, "day"),
        value: val
    });
    return day_options;
}
function createInitialHourOptions(val) {
    const hour_options = [];
    for(let i = 0; i < 24; i++)hour_options.push({
        label: formatPluralDuration(i, "hour"),
        value: i
    });
    if (val >= 24) hour_options.push({
        label: formatPluralDuration(val, "hour"),
        value: val
    });
    return hour_options;
}
function createInitialMinuteOptions(val) {
    const minute_options = [];
    for(let i = 0; i < 60; i += 5){
        if (val > i && val < i + 5) minute_options.push({
            label: formatPluralDuration(val, "minute"),
            value: val
        });
        minute_options.push({
            label: formatPluralDuration(i, "minute"),
            value: i
        });
    }
    return minute_options;
}
const TypeToInitialOptions = {
    hour: createInitialHourOptions,
    minute: createInitialMinuteOptions,
    day: createInitialDayOptions
};
function DurationDropdown(props) {
    const [options, setOptions] = (0, _react.useState)(TypeToInitialOptions[props.type](props.value));
    const selected_option = options.find((val)=>val.value === props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "field w-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "control w-full",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                classNamePrefix: "sesh-dropdown",
                value: selected_option,
                options: options,
                onChange: (selected)=>props.setValue(selected.value),
                isValidNewOption: (inputValue)=>Boolean(tryParseCreatedSelection(inputValue, props.type)),
                formatCreateLabel: (inputValue)=>{
                    const new_option_value = tryParseCreatedSelection(inputValue, props.type);
                    if (new_option_value == null) return;
                    return formatPluralDuration(new_option_value, props.type);
                },
                onCreateOption: (inputValue)=>{
                    const new_option_value = tryParseCreatedSelection(inputValue, props.type);
                    if (new_option_value == null) return;
                    const new_option_dropdown = {
                        label: formatPluralDuration(new_option_value, props.type),
                        value: new_option_value
                    };
                    setOptions((options)=>{
                        return [
                            ...options,
                            new_option_dropdown
                        ].sort((a, b)=>a.value - b.value);
                    });
                    props.type;
                    props.setValue(new_option_value);
                },
                isDisabled: false
            })
        })
    });
}
function tryParseCreatedSelection(input, type) {
    const new_option_value = input.split(" ").map((val)=>parseInt(val)).find((val)=>!isNaN(val));
    if (new_option_value === undefined) return;
    if (new_option_value < 0) return;
    if (type === "minute" && new_option_value >= 60) return;
    return new_option_value;
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select/creatable":"iiR0X","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kC6wM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelSettingsPickerForm", ()=>ChannelSettingsPickerForm);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fadeIn = require("../../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _reactRouter = require("react-router");
var _reactSpinners = require("react-spinners");
var _commonUtils = require("../../../../common/common_utils");
var _constants = require("../../../../common/constants");
var _dashboardUtils = require("../dashboard_utils");
function ChannelOverrideElement(props) {
    const history = (0, _reactRouter.useHistory)();
    let className = "channel-element";
    if (props.should_add_bottom_border) className += "  channel-element-bottom-border";
    if (props.is_overridden) className += " channel-element-overridden";
    const icon = props.channel_data.type === "Text" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-hashtag"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-comments fa-sm"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-vcentered is-mobile ml-2",
            onClick: ()=>{
                history.push((0, _commonUtils.common_utils).getGuildChannelSettingsURL(props.guild_id, props.channel_data.id));
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-one-third-tablet is-two-thirds-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full min-w-0 truncate",
                                children: props.channel_data.name
                            })
                        ]
                    })
                }),
                props.is_overridden && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-one-third is-hidden-mobile is-centered has-text-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "italic-note has-text-centered",
                        children: "Overrides Active"
                    })
                }),
                props.is_overridden && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-one-third is-pulled-right has-text-right",
                    children: props.is_deleting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
                        size: "1rem",
                        loading: true,
                        color: (0, _constants.Constants).EMBED_COLOR
                    }) || /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "tooltip delete-channel-override-icon",
                        onClick: (e)=>{
                            e.stopPropagation();
                            props.on_delete_channel_overrides(props.channel_data.id);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-trash-alt"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "tooltiptop",
                                children: "Delete overrides for this channel"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function CategoryElement(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "category-element",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: props.category_data.name.toUpperCase()
        })
    });
}
class ChannelSettingsPickerForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            delete_being_processed_channel_ids: []
        };
    }
    renderChannelOverridesList() {
        // category_id -> CategoryData
        const categories_map = new Map();
        const channels_and_categories_flat_list = [];
        // populate channels_and_categories_flat_list and categories_map
        for (let channel of this.props.roles_and_channels.channels){
            if (channel.type === "Thread" || !channel.has_write) continue;
            if (channel.category_id) {
                if (!categories_map.has(channel.category_id)) {
                    const new_category = {
                        is_category: true,
                        id: channel.category_id,
                        name: channel.category_name,
                        position: channel.category_position,
                        channels: []
                    };
                    categories_map.set(channel.category_id, new_category);
                }
                let category_data = categories_map.get(channel.category_id);
                category_data.channels.push(channel);
            } else channels_and_categories_flat_list.push(channel);
        }
        // sort
        let categories_list = Array.from(categories_map.values());
        categories_list.sort((a, b)=>{
            return a.position - b.position;
        });
        for (let category of categories_list){
            channels_and_categories_flat_list.push(category);
            category.channels.sort((a, b)=>{
                return a.position - b.position;
            });
            for (let channel of category.channels)channels_and_categories_flat_list.push(channel);
        }
        const channel_elements = [];
        let channel_index_counter = 0;
        let last_category = null;
        for (let channel_or_category of channels_and_categories_flat_list)if (channel_or_category.hasOwnProperty("is_category")) {
            channel_elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(CategoryElement, {
                category_data: channel_or_category,
                guild_id: this.props.guild_data.id
            }, channel_or_category.id));
            channel_index_counter = 0;
            last_category = channel_or_category;
        } else {
            let channel = channel_or_category;
            let should_add_bottom_border = false;
            if (last_category && last_category.channels.includes(channel)) {
                const last_channel_in_category = last_category.channels[last_category.channels.length - 1];
                if (last_channel_in_category !== channel) should_add_bottom_border = true;
            }
            let is_overridden = this.props.channel_settings_overrides.overrides[channel.id] && !(0, _lodash.isEmpty)(this.props.channel_settings_overrides.overrides[channel.id]);
            channel_elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelOverrideElement, {
                channel_data: channel_or_category,
                guild_id: this.props.guild_data.id,
                is_overridden: is_overridden,
                should_add_bottom_border: should_add_bottom_border,
                is_deleting: this.state.delete_being_processed_channel_ids.includes(channel.id),
                on_delete_channel_overrides: (channel_id)=>{
                    let new_deletes_being_processed = (0, _lodash.cloneDeep)(this.state.delete_being_processed_channel_ids);
                    new_deletes_being_processed.push(channel_id);
                    this.setState({
                        delete_being_processed_channel_ids: new_deletes_being_processed
                    });
                    const request_body = {
                        access_token: this.props.auth_token.access_token,
                        token_type: this.props.auth_token.token_type,
                        guild_id: this.props.guild_data.id,
                        channel_id: channel_id
                    };
                    fetch(`/api/delete_channel_override_settings`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(request_body)
                    }).then(async (response)=>{
                        let new_deletes_being_processed = (0, _lodash.cloneDeep)(this.state.delete_being_processed_channel_ids).filter((val)=>val !== channel_id);
                        this.setState({
                            delete_being_processed_channel_ids: new_deletes_being_processed
                        });
                        if (response.status === 200) this.props.on_save_func(channel_id);
                        else {
                            let response_json = await response.json();
                            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response_json.err);
                        }
                    });
                }
            }, channel_or_category.id));
            channel_index_counter++;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mt-4",
            children: channel_elements
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-mobile is-centered",
                style: {
                    transition: "opacity 0.5s",
                    opacity: "1"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "settings-link-chain-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
                                link_chain_data: [
                                    (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                                    (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.props.guild_data),
                                    (0, _dashboardUtils.DashboardUtils).RenderGuildSettingsLinkChain(this.props.guild_data.id),
                                    (0, _dashboardUtils.DashboardUtils).RenderGuildChannelPickerLinkChain(this.props.guild_data.id)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "title is-3 has-text-centered mt-6",
                            children: "Channel Overrides"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "note",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "",
                                    children: "Channel overrides let you change settings on a per-channel basis."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mt-2",
                                    children: "This is great for customizing the default timezone, sign up options, or nearly anything other setting per channel!"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mt-2",
                                    children: "Select a channel below to get started."
                                })
                            ]
                        }),
                        this.renderChannelOverridesList()
                    ]
                })
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","lodash":"fIO2m","react":"IMRgT","../../../../src/vendored/FadeIn":"aMGHU","react-router":"djWTS","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../common/common_utils":"gACUC","../../../../common/constants":"lLiun","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aT6UX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminPage", ()=>AdminPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _dashboardContainer = require("../base_components/dashboard_container");
var _seshAddonInput = require("../base_components/sesh_addon_input");
var _useQueryParams = require("../hooks/use_query_params");
var _adminEntityViewer = require("./admin_entity_viewer");
var _adminLogsViewer = require("./admin_logs_viewer");
var _adminSeshStatsViewer = require("./admin_sesh_stats_viewer");
var _adminStatusPage = require("./admin_status_page");
var _adminStripeManager = require("./admin_stripe_manager");
var _adminWaitlistManager = require("./admin_waitlist_manager");
var _adminShardsViewer = require("./admin_shards_viewer");
var _adminBlurbManager = require("./admin_blurb_manager");
const tabs = {
    Entities: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminEntityViewer.AdminEntityViewer), {}),
    Stripe: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminStripeManager.AdminStripeManager), {}),
    Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminStatusPage.AdminStatusPage), {}),
    Waitlist: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminWaitlistManager.AdminWaitlistManager), {}),
    Logs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminLogsViewer.AdminLogsViewer), {}),
    Stats: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminSeshStatsViewer.AdminSeshStats), {}),
    Shards: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminShardsViewer.AdminShardsViewer), {}),
    Blurbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminBlurbManager.AdminBlurbManager), {})
};
function AdminPage() {
    const is_admin_query = (0, _trpc.trpc).admin.isSeshAdmin.useQuery();
    let { tab: tab_from_url } = (0, _useQueryParams.useQueryParams)();
    const [tab, setTab] = (0, _react.useState)(tab_from_url ?? "Entities");
    if (is_admin_query.isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderDashboardErrorPage, {
        text: "Must be admin to view this page",
        title: "UNAUTHORIZED"
    });
    if (!is_admin_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
        title: "Admin",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mb-12 ml-auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                        buttons: Object.keys(tabs).map((val)=>({
                                label: val,
                                value: val
                            })),
                        setValue: (tab)=>{
                            setTab(tab);
                            const search_params = new URLSearchParams();
                            search_params.append("tab", tab);
                            window.history.pushState({}, null, `/dashboard/admin?${search_params}`);
                        },
                        value: tab
                    })
                }),
                tabs[tab]
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/dashboard_container":"9WDu5","../base_components/sesh_addon_input":"pd6di","../hooks/use_query_params":"85qk7","./admin_entity_viewer":"lG2XY","./admin_logs_viewer":"2d8Or","./admin_sesh_stats_viewer":"hrdJ3","./admin_status_page":"4G61z","./admin_stripe_manager":"gJW9Q","./admin_waitlist_manager":"c3x83","./admin_shards_viewer":"9ezZC","./admin_blurb_manager":"6wDr9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"85qk7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryParams", ()=>useQueryParams);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
function useQueryParams() {
    const { search } = (0, _reactRouterDom.useLocation)();
    return (0, _reactDefault.default).useMemo(()=>Object.fromEntries(new URLSearchParams(search)), [
        search
    ]);
}

},{"react":"IMRgT","react-router-dom":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lG2XY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminEntityViewer", ()=>AdminEntityViewer);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _jsonViewer = require("@textea/json-viewer");
var _premiumTiers = require("../../../../../../common/premium_tiers");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshTextInput = require("../base_components/sesh_text_input");
var _withDropdown = require("../base_components/with_dropdown");
var _discordEntitlement = require("../premium_page/entitlements/discord_entitlement");
var _stripeEntitlement = require("../premium_page/entitlements/stripe_entitlement");
var _infoTooltip = require("../tooltips/info_tooltip");
const AdminViews = {
    Guild: {
        query: (0, _trpc.trpc).admin.getGuild.useQuery,
        element: undefined
    },
    User: {
        query: (0, _trpc.trpc).admin.getUser.useQuery,
        element: (id)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(UserView, {
                id: id
            })
    },
    Event: {
        query: (0, _trpc.trpc).admin.getEvent.useQuery,
        element: undefined
    },
    Poll: {
        query: (0, _trpc.trpc).admin.getPoll.useQuery,
        element: undefined
    },
    Sync: {
        query: (0, _trpc.trpc).admin.getSync.useQuery,
        element: undefined
    }
};
function AdminEntityViewer() {
    const [id_input, setIdInput] = (0, _react.useState)({
        Event: "",
        Guild: "",
        Poll: "",
        User: "",
        Sync: ""
    });
    const [id, setId] = (0, _react.useState)({
        Event: "",
        Guild: "",
        Poll: "",
        User: "",
        Sync: ""
    });
    const [tab, setTab] = (0, _react.useState)("Guild");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tabs, {
                tab: tab,
                setTab: (tab)=>{
                    setTab(tab);
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: "w-full",
                onSubmit: (e)=>{
                    e.preventDefault();
                    setId({
                        ...id,
                        [tab]: id_input[tab]
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        className: "label",
                        children: [
                            tab,
                            " ID"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                                input_props: {
                                    value: id_input[tab],
                                    onChange: (e)=>setIdInput({
                                            ...id_input,
                                            [tab]: e.currentTarget.value
                                        })
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                className: "w-fit rounded-md",
                                type: "submit",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-search"
                                })
                            })
                        ]
                    })
                ]
            }),
            AdminViews[tab].element && AdminViews[tab].element(id[tab]),
            id[tab] && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EntityViewer, {
                type: tab,
                id: id[tab]
            })
        ]
    });
}
function Tabs(props) {
    const tabs = [];
    for(const key in AdminViews)tabs.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        className: (0, _classnamesDefault.default)({
            "is-active bg-base-dark": props.tab === key
        }),
        onClick: ()=>props.setTab(key),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            className: "manual-link !bg-inherit",
            children: key
        })
    }, key));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "tabs is-boxed",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            children: tabs
        })
    });
}
function EntityViewer(props) {
    const query = AdminViews[props.type].query({
        id: props.id
    });
    if (!query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    if (!query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "Not found"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonViewer.JsonViewer), {
        value: query.data,
        theme: "light"
    });
}
function UserView(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserEntitlementsTable, {
        id: props.id
    });
}
function UserEntitlementsTable(props) {
    const user_query = (0, _trpc.trpc).admin.getUser.useQuery({
        id: props.id
    });
    if (!props.id) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!user_query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-24 flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-xl font-bold",
                children: "Stripe Entitlements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-2",
                children: user_query.data.stripe_entitlements.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StripeAdminEntitlement, {
                        entity: val,
                        user_id: props.id,
                        customer_id: user_query.data.stripe_customer_id
                    }, val.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-fit",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddDropdownButton, {
                    user_id: props.id
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-xl font-bold",
                children: "Discord Entitlements"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-2",
                children: user_query.data.discord_entitlements.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DiscordAdminEntitlement, {
                        entity: val,
                        user_id: props.id
                    }, val.id))
            })
        ]
    });
}
function AddDropdownButton(props) {
    const tiers = (0, _premiumTiers.getTiersWithoutPrices)();
    const mutation = (0, _trpc.trpc).admin.addStripeEntitlement.useMutation({
        onSuccess: ()=>context.admin.getUser.invalidate({
                id: props.user_id
            })
    });
    const context = (0, _trpc.trpc).useContext();
    const items = [];
    if (!mutation.isLoading) for(const product_id in tiers){
        const product = (0, _premiumTiers.getRawProductWithoutPrices)(product_id);
        items.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex cursor-pointer gap-2 p-1 hover:bg-base-dark",
            onClick: ()=>{
                mutation.mutate({
                    product_id: product_id,
                    user_id: props.user_id
                });
            },
            children: [
                product.title,
                " (",
                product.activations,
                ")"
            ]
        }));
    }
    else items.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "Loading..."
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdown.WithDropdown), {
        items: items,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-fit self-center font-bold",
            children: "Add Entitlement"
        })
    });
}
function StripeAdminEntitlement(props) {
    const context = (0, _trpc.trpc).useContext();
    const { entity, customer_id } = props;
    const delete_entitlement_mutation = (0, _trpc.trpc).admin.removeStripeEntitlement.useMutation({
        onSuccess: ()=>{
            context.admin.getUser.invalidate({
                id: props.user_id
            });
        }
    });
    const [is_deleting_entitlement, setDeletingEntitlement] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stripeEntitlement.StripeEntitlementNoModifyButton), {
                    activations: (0, _premiumTiers.getRawProductWithoutPrices)(entity.product_id).activations,
                    ...entity
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                className: "flex w-fit items-center gap-2",
                is_loading: is_deleting_entitlement,
                onClick: ()=>{
                    setDeletingEntitlement(true);
                    delete_entitlement_mutation.mutate({
                        entitlement_id: entity.id
                    });
                },
                children: [
                    "Delete",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                info: "Will only delete from sesh DB, not from Stripe's end"
            })
        ]
    });
}
function DiscordAdminEntitlement(props) {
    const context = (0, _trpc.trpc).useContext();
    const { entity } = props;
    const delete_entitlement_mutation = (0, _trpc.trpc).admin.removeDiscordEntitlement.useMutation({
        onSuccess: ()=>{
            context.admin.getUser.invalidate({
                id: props.user_id
            });
        }
    });
    const [is_deleting_entitlement, setDeletingEntitlement] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _discordEntitlement.DiscordEntitlement), {
                    ...entity
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                className: "flex w-fit items-center gap-2",
                is_loading: is_deleting_entitlement,
                onClick: ()=>{
                    setDeletingEntitlement(true);
                    delete_entitlement_mutation.mutate({
                        entitlement_id: entity.id
                    });
                },
                children: [
                    "Delete",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                info: "Will only delete from sesh DB, not from Stripe's end"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","@textea/json-viewer":"cB69Z","../../../../../../common/premium_tiers":"NLcok","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_text_input":"befXR","../base_components/with_dropdown":"4XaXU","../premium_page/entitlements/discord_entitlement":"cyL4j","../premium_page/entitlements/stripe_entitlement":"9cNtY","../tooltips/info_tooltip":"93rAL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cB69Z":[function(require,module,exports,__globalThis) {
/// <reference types="./index.d.ts" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonViewer", ()=>JsonViewer);
parcelHelpers.export(exports, "applyValue", ()=>applyValue);
parcelHelpers.export(exports, "bigIntType", ()=>bigIntType);
parcelHelpers.export(exports, "booleanType", ()=>booleanType);
parcelHelpers.export(exports, "createDataType", ()=>createDataType);
parcelHelpers.export(exports, "darkColorspace", ()=>darkColorspace);
parcelHelpers.export(exports, "dateType", ()=>dateType);
parcelHelpers.export(exports, "defineDataType", ()=>defineDataType);
parcelHelpers.export(exports, "defineEasyType", ()=>defineEasyType);
parcelHelpers.export(exports, "deleteValue", ()=>deleteValue);
parcelHelpers.export(exports, "floatType", ()=>floatType);
parcelHelpers.export(exports, "functionType", ()=>functionType);
parcelHelpers.export(exports, "getPathValue", ()=>getPathValue);
parcelHelpers.export(exports, "intType", ()=>intType);
parcelHelpers.export(exports, "isCycleReference", ()=>isCycleReference);
parcelHelpers.export(exports, "lightColorspace", ()=>lightColorspace);
parcelHelpers.export(exports, "nanType", ()=>nanType);
parcelHelpers.export(exports, "nullType", ()=>nullType);
parcelHelpers.export(exports, "objectType", ()=>objectType);
parcelHelpers.export(exports, "pathValueDefaultGetter", ()=>pathValueDefaultGetter);
parcelHelpers.export(exports, "safeStringify", ()=>safeStringify);
parcelHelpers.export(exports, "stringType", ()=>stringType);
parcelHelpers.export(exports, "undefinedType", ()=>undefinedType);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("@mui/material");
var _react = require("react");
var _zustand = require("zustand");
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
const lightColorspace = {
    scheme: 'Light Theme',
    author: 'mac gainor (https://github.com/mac-s-g)',
    base00: 'rgba(0, 0, 0, 0)',
    base01: 'rgb(245, 245, 245)',
    base02: 'rgb(235, 235, 235)',
    base03: '#93a1a1',
    base04: 'rgba(0, 0, 0, 0.3)',
    base05: '#586e75',
    base06: '#073642',
    base07: '#002b36',
    base08: '#d33682',
    base09: '#cb4b16',
    base0A: '#ffd500',
    base0B: '#859900',
    base0C: '#6c71c4',
    base0D: '#586e75',
    base0E: '#2aa198',
    base0F: '#268bd2'
};
const darkColorspace = {
    scheme: 'Dark Theme',
    author: 'Chris Kempson (http://chriskempson.com)',
    base00: '#181818',
    base01: '#282828',
    base02: '#383838',
    base03: '#585858',
    base04: '#b8b8b8',
    base05: '#d8d8d8',
    base06: '#e8e8e8',
    base07: '#f8f8f8',
    base08: '#ab4642',
    base09: '#dc9656',
    base0A: '#f7ca88',
    base0B: '#a1b56c',
    base0C: '#86c1b9',
    base0D: '#7cafc2',
    base0E: '#ba8baf',
    base0F: '#a16946'
};
const DefaultKeyRenderer = ()=>null;
DefaultKeyRenderer.when = ()=>false;
const createJsonViewerStore = (props)=>{
    return (0, _zustand.create)()((set, get)=>{
        var _props_rootName, _props_indentWidth, _props_keyRenderer, _props_enableAdd, _props_enableDelete, _props_enableClipboard, _props_editable, _props_onChange, _props_onCopy, _props_onSelect, _props_onAdd, _props_onDelete, _props_defaultInspectDepth, _props_defaultInspectControl, _props_maxDisplayLength, _props_groupArraysAfterLength, _props_collapseStringsAfterLength, _props_objectSortKeys, _props_quotesOnKeys, _props_displayDataTypes, _props_displaySize, _props_displayComma, _props_highlightUpdates;
        return {
            // provided by user
            rootName: (_props_rootName = props.rootName) !== null && _props_rootName !== void 0 ? _props_rootName : 'root',
            indentWidth: (_props_indentWidth = props.indentWidth) !== null && _props_indentWidth !== void 0 ? _props_indentWidth : 3,
            keyRenderer: (_props_keyRenderer = props.keyRenderer) !== null && _props_keyRenderer !== void 0 ? _props_keyRenderer : DefaultKeyRenderer,
            enableAdd: (_props_enableAdd = props.enableAdd) !== null && _props_enableAdd !== void 0 ? _props_enableAdd : false,
            enableDelete: (_props_enableDelete = props.enableDelete) !== null && _props_enableDelete !== void 0 ? _props_enableDelete : false,
            enableClipboard: (_props_enableClipboard = props.enableClipboard) !== null && _props_enableClipboard !== void 0 ? _props_enableClipboard : true,
            editable: (_props_editable = props.editable) !== null && _props_editable !== void 0 ? _props_editable : false,
            onChange: (_props_onChange = props.onChange) !== null && _props_onChange !== void 0 ? _props_onChange : ()=>{},
            onCopy: (_props_onCopy = props.onCopy) !== null && _props_onCopy !== void 0 ? _props_onCopy : undefined,
            onSelect: (_props_onSelect = props.onSelect) !== null && _props_onSelect !== void 0 ? _props_onSelect : undefined,
            onAdd: (_props_onAdd = props.onAdd) !== null && _props_onAdd !== void 0 ? _props_onAdd : undefined,
            onDelete: (_props_onDelete = props.onDelete) !== null && _props_onDelete !== void 0 ? _props_onDelete : undefined,
            defaultInspectDepth: (_props_defaultInspectDepth = props.defaultInspectDepth) !== null && _props_defaultInspectDepth !== void 0 ? _props_defaultInspectDepth : 5,
            defaultInspectControl: (_props_defaultInspectControl = props.defaultInspectControl) !== null && _props_defaultInspectControl !== void 0 ? _props_defaultInspectControl : undefined,
            maxDisplayLength: (_props_maxDisplayLength = props.maxDisplayLength) !== null && _props_maxDisplayLength !== void 0 ? _props_maxDisplayLength : 30,
            groupArraysAfterLength: (_props_groupArraysAfterLength = props.groupArraysAfterLength) !== null && _props_groupArraysAfterLength !== void 0 ? _props_groupArraysAfterLength : 100,
            collapseStringsAfterLength: props.collapseStringsAfterLength === false ? Number.MAX_VALUE : (_props_collapseStringsAfterLength = props.collapseStringsAfterLength) !== null && _props_collapseStringsAfterLength !== void 0 ? _props_collapseStringsAfterLength : 50,
            objectSortKeys: (_props_objectSortKeys = props.objectSortKeys) !== null && _props_objectSortKeys !== void 0 ? _props_objectSortKeys : false,
            quotesOnKeys: (_props_quotesOnKeys = props.quotesOnKeys) !== null && _props_quotesOnKeys !== void 0 ? _props_quotesOnKeys : true,
            displayDataTypes: (_props_displayDataTypes = props.displayDataTypes) !== null && _props_displayDataTypes !== void 0 ? _props_displayDataTypes : true,
            displaySize: (_props_displaySize = props.displaySize) !== null && _props_displaySize !== void 0 ? _props_displaySize : true,
            displayComma: (_props_displayComma = props.displayComma) !== null && _props_displayComma !== void 0 ? _props_displayComma : false,
            highlightUpdates: (_props_highlightUpdates = props.highlightUpdates) !== null && _props_highlightUpdates !== void 0 ? _props_highlightUpdates : false,
            // internal state
            inspectCache: {},
            hoverPath: null,
            colorspace: lightColorspace,
            value: props.value,
            prevValue: undefined,
            getInspectCache: (path, nestedIndex)=>{
                const target = nestedIndex !== undefined ? path.join('.') + "[".concat(nestedIndex, "]nt") : path.join('.');
                return get().inspectCache[target];
            },
            setInspectCache: (path, action, nestedIndex)=>{
                const target = nestedIndex !== undefined ? path.join('.') + "[".concat(nestedIndex, "]nt") : path.join('.');
                set((state)=>({
                        inspectCache: {
                            ...state.inspectCache,
                            [target]: typeof action === 'function' ? action(state.inspectCache[target]) : action
                        }
                    }));
            },
            setHover: (path, nestedIndex)=>{
                set({
                    hoverPath: path ? {
                        path,
                        nestedIndex
                    } : null
                });
            }
        };
    });
};
// @ts-expect-error we intentionally want to pass undefined to the context
// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
const JsonViewerStoreContext = (0, _react.createContext)(undefined);
JsonViewerStoreContext.Provider;
const useJsonViewerStore = (selector, equalityFn)=>{
    const store = (0, _react.useContext)(JsonViewerStoreContext);
    return (0, _zustand.useStore)(store, selector, equalityFn);
};
const useTextColor = ()=>{
    return useJsonViewerStore((store)=>store.colorspace.base07);
};
// reference: https://github.com/immerjs/immer/blob/main/src/utils/common.ts
const objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== 'object') return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor === 'function' && Function.toString.call(Ctor) === objectCtorString;
}
function shouldShallowCopy(value) {
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || value instanceof Map || value instanceof Set;
}
function shallowCopy(value) {
    if (Array.isArray(value)) return Array.prototype.slice.call(value);
    if (value instanceof Set) return new Set(value);
    if (value instanceof Map) return new Map(value);
    if (typeof value === 'object' && value !== null) return Object.assign({}, value);
    return value;
}
function _applyValue(input, path, value) {
    let visitedMapping = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new Map();
    if (typeof input !== 'object' || input === null) {
        if (path.length !== 0) throw new Error('path is incorrect');
        return value;
    }
    const shouldCopy = shouldShallowCopy(input);
    if (shouldCopy) {
        let copiedInput = visitedMapping.get(input);
        if (!copiedInput) {
            copiedInput = shallowCopy(input);
            visitedMapping.set(input, copiedInput);
        }
        input = copiedInput;
    }
    const [key, ...restPath] = path;
    if (key !== undefined) {
        if (key === '__proto__') throw new TypeError('Modification of prototype is not allowed');
        if (restPath.length > 0) input[key] = _applyValue(input[key], restPath, value, visitedMapping);
        else input[key] = value;
    }
    return input;
}
/**
 * Apply a value to a given path of an object.
 */ function applyValue(input, path, value) {
    return _applyValue(input, path, value);
}
/**
 * Delete a value from a given path of an object.
 */ function deleteValue(input, path, value) {
    if (typeof input !== 'object' || input === null) {
        if (path.length !== 0) throw new Error('path is incorrect');
        return value;
    }
    const shouldCopy = shouldShallowCopy(input);
    if (shouldCopy) input = shallowCopy(input);
    const [key, ...restPath] = path;
    if (key !== undefined) {
        if (key === '__proto__') throw new TypeError('Modification of prototype is not allowed');
        if (restPath.length > 0) input[key] = deleteValue(input[key], restPath, value);
        else if (Array.isArray(input)) input.splice(Number(key), 1);
        else delete input[key];
    }
    return input;
}
/**
 * @deprecated use `defineDataType` instead
 */ function createDataType(is, Component, Editor, PreComponent, PostComponent) {
    return {
        is,
        Component,
        Editor,
        PreComponent,
        PostComponent
    };
}
/**
 * Define custom data types for any data structure
 */ function defineDataType(param) {
    let { is, serialize, deserialize, Component, Editor, PreComponent, PostComponent } = param;
    return {
        is,
        serialize,
        deserialize,
        Component,
        Editor,
        PreComponent,
        PostComponent
    };
}
const isCycleReference = (root, path, value)=>{
    if (root === null || value === null) return false;
    if (typeof root !== 'object') return false;
    if (typeof value !== 'object') return false;
    if (Object.is(root, value) && path.length !== 0) return '';
    const currentPath = [];
    const arr = [
        ...path
    ];
    let currentRoot = root;
    while(currentRoot !== value || arr.length !== 0){
        if (typeof currentRoot !== 'object' || currentRoot === null) return false;
        if (Object.is(currentRoot, value)) return currentPath.reduce((path, value, currentIndex)=>{
            if (typeof value === 'number') return path + "[".concat(value, "]");
            return path + "".concat(currentIndex === 0 ? '' : '.').concat(value);
        }, '');
        const target = arr.shift();
        currentPath.push(target);
        currentRoot = currentRoot[target];
    }
    return false;
};
function getValueSize(value) {
    if (value === null || undefined) return 0;
    else if (Array.isArray(value)) return value.length;
    else if (value instanceof Map || value instanceof Set) return value.size;
    else if (value instanceof Date) return 1;
    else if (typeof value === 'object') return Object.keys(value).length;
    else if (typeof value === 'string') return value.length;
    return 1;
}
function segmentArray(arr, size) {
    const result = [];
    let index = 0;
    while(index < arr.length){
        result.push(arr.slice(index, index + size));
        index += size;
    }
    return result;
}
/**
 * A safe version of `JSON.stringify` that handles circular references and BigInts.
 *
 * *This function might be changed in the future to support more types. Use it with caution.*
 *
 * @param obj A JavaScript value, usually an object or array, to be converted.
 * @param space Adds indentation, white space, and line break characters to the return-value JSON text to make it easier to read.
 * @returns
 */ function safeStringify(obj, space) {
    const seenValues = [];
    function replacer(key, value) {
        // https://github.com/GoogleChromeLabs/jsbi/issues/30
        if (typeof value === 'bigint') return value.toString();
        // Map and Set are not supported by JSON.stringify
        if (value instanceof Map) {
            if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
            if (value.size === 0) return {};
            if (seenValues.includes(value)) return '[Circular]';
            seenValues.push(value);
            const entries = Array.from(value.entries());
            if (entries.every((param)=>{
                let [key] = param;
                return typeof key === 'string' || typeof key === 'number';
            })) return Object.fromEntries(entries);
            // if keys are not string or number, we can't convert to object
            // fallback to default behavior
            return {};
        }
        if (value instanceof Set) {
            if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
            if (seenValues.includes(value)) return '[Circular]';
            seenValues.push(value);
            return Array.from(value.values());
        }
        // https://stackoverflow.com/a/72457899
        if (typeof value === 'object' && value !== null && Object.keys(value).length) {
            const stackSize = seenValues.length;
            if (stackSize) {
                // clean up expired references
                for(let n = stackSize - 1; n >= 0 && seenValues[n][key] !== value; --n)seenValues.pop();
                if (seenValues.includes(value)) return '[Circular]';
            }
            seenValues.push(value);
        }
        return value;
    }
    return JSON.stringify(obj, replacer, space);
}
async function copyString(value) {
    if ('clipboard' in navigator) try {
        await navigator.clipboard.writeText(value);
    } catch  {
    // When navigator.clipboard throws an error, fallback to copy-to-clipboard package
    }
    // fallback to copy-to-clipboard when navigator.clipboard is not available
    (0, _copyToClipboardDefault.default)(value);
}
function pathValueDefaultGetter(value, key) {
    if (value === null || value === undefined) return null;
    if (value instanceof Map || value instanceof WeakMap) return value.get(key);
    if (value instanceof Set) return Array.from(value)[key];
    if (value instanceof WeakSet) throw new Error('WeakSet is not supported');
    if (Array.isArray(value)) return value[Number(key)];
    if (typeof value === 'object') return value[key];
    return null;
}
/**
 * Get the value at a given path in an object.
 * Passing custom getters allows you to handle custom data structures.
 * @experimental This function is not yet stable and may change in the future.
 */ function getPathValue(obj, path) {
    let customGetters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    try {
        // @ts-ignore
        return path.reduce((acc, key, index)=>{
            if (acc === null || acc === undefined) {
                console.error('Invalid path or value encountered at path', path.slice(0, index));
                throw new Error('Invalid path or value encountered');
            }
            for (const handler of customGetters){
                const currentPath = path.slice(0, index + 1);
                if (handler.is(acc, currentPath)) return handler.handler(acc, key);
            }
            return pathValueDefaultGetter(acc, key);
        }, obj);
    } catch (error) {
        console.error(error);
        return null // or throw error?
        ;
    }
}
/**
 * useClipboard hook accepts one argument options in which copied status timeout duration is defined (defaults to 2000). Hook returns object with properties:
 * - copy – function to copy value to clipboard
 * - copied – value that indicates that copy handler was called less than options.timeout ms ago
 * - reset – function to clear timeout and reset copied to false
 */ function useClipboard() {
    let { timeout = 2000 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [copied, setCopied] = (0, _react.useState)(false);
    const copyTimeout = (0, _react.useRef)(null);
    const handleCopyResult = (0, _react.useCallback)((value)=>{
        const current = copyTimeout.current;
        if (current) window.clearTimeout(current);
        copyTimeout.current = window.setTimeout(()=>setCopied(false), timeout);
        setCopied(value);
    }, [
        timeout
    ]);
    const onCopy = useJsonViewerStore((store)=>store.onCopy);
    const copy = (0, _react.useCallback)(async (path, value)=>{
        if (typeof onCopy === 'function') try {
            await onCopy(path, value, copyString);
            handleCopyResult(true);
        } catch (error) {
            console.error("error when copy ".concat(path.length === 0 ? 'src' : "src[".concat(path.join('.')), "]"), error);
        }
        else try {
            const valueToCopy = safeStringify(typeof value === 'function' ? value.toString() : value, '  ');
            await copyString(valueToCopy);
            handleCopyResult(true);
        } catch (error) {
            console.error("error when copy ".concat(path.length === 0 ? 'src' : "src[".concat(path.join('.')), "]"), error);
        }
    }, [
        handleCopyResult,
        onCopy
    ]);
    const reset = (0, _react.useCallback)(()=>{
        setCopied(false);
        if (copyTimeout.current) clearTimeout(copyTimeout.current);
    }, []);
    return {
        copy,
        reset,
        copied
    };
}
function useIsCycleReference(path, value) {
    const rootValue = useJsonViewerStore((store)=>store.value);
    return (0, _react.useMemo)(()=>isCycleReference(rootValue, path, value), [
        path,
        value,
        rootValue
    ]);
}
function useInspect(path, value, nestedIndex) {
    const depth = path.length;
    const isTrap = useIsCycleReference(path, value);
    const getInspectCache = useJsonViewerStore((store)=>store.getInspectCache);
    const setInspectCache = useJsonViewerStore((store)=>store.setInspectCache);
    const defaultInspectDepth = useJsonViewerStore((store)=>store.defaultInspectDepth);
    const defaultInspectControl = useJsonViewerStore((store)=>store.defaultInspectControl);
    (0, _react.useEffect)(()=>{
        const inspect = getInspectCache(path, nestedIndex);
        if (inspect !== undefined) return;
        // item with nestedIndex should not be inspected
        if (nestedIndex !== undefined) {
            setInspectCache(path, false, nestedIndex);
            return;
        }
        // do not inspect when it is a cycle reference, otherwise there will have a loop
        const shouldInspect = isTrap ? false : typeof defaultInspectControl === 'function' ? defaultInspectControl(path, value) : depth < defaultInspectDepth;
        setInspectCache(path, shouldInspect);
    }, [
        defaultInspectDepth,
        defaultInspectControl,
        depth,
        getInspectCache,
        isTrap,
        nestedIndex,
        path,
        value,
        setInspectCache
    ]);
    const [inspect, set] = (0, _react.useState)(()=>{
        const shouldInspect = getInspectCache(path, nestedIndex);
        if (shouldInspect !== undefined) return shouldInspect;
        if (nestedIndex !== undefined) return false;
        return isTrap ? false : typeof defaultInspectControl === 'function' ? defaultInspectControl(path, value) : depth < defaultInspectDepth;
    });
    const setInspect = (0, _react.useCallback)((apply)=>{
        set((oldState)=>{
            const newState = typeof apply === 'boolean' ? apply : apply(oldState);
            setInspectCache(path, newState, nestedIndex);
            return newState;
        });
    }, [
        nestedIndex,
        path,
        setInspectCache
    ]);
    return [
        inspect,
        setInspect
    ];
}
const DataBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        component: "div",
        ...props,
        sx: {
            display: 'inline-block',
            ...props.sx
        }
    });
const DataTypeLabel = (param)=>{
    let { dataType, enable = true } = param;
    if (!enable) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
        className: "data-type-label",
        sx: {
            mx: 0.5,
            fontSize: '0.7rem',
            opacity: 0.8,
            userSelect: 'none'
        },
        children: dataType
    });
};
/**
 * Enhanced version of `defineDataType` that creates a `DataType` with editor and a optional type label.
 * It will take care of the color and all the necessary props.
 *
 * *All of the built-in data types are defined with this function.*
 *
 * @param config.type The type name.
 * @param config.colorKey The color key in the colorspace. ('base00' - 'base0F')
 * @param config.displayTypeLabel Whether to display the type label.
 * @param config.Renderer The component to render the value.
 */ function defineEasyType(param) {
    let { is, serialize, deserialize, type, colorKey, displayTypeLabel = true, Renderer } = param;
    const Render = /*#__PURE__*/ (0, _react.memo)(Renderer);
    const EasyType = (props)=>{
        const storeDisplayDataTypes = useJsonViewerStore((store)=>store.displayDataTypes);
        const color = useJsonViewerStore((store)=>store.colorspace[colorKey]);
        const onSelect = useJsonViewerStore((store)=>store.onSelect);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DataBox, {
            onClick: ()=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(props.path, props.value),
            sx: {
                color
            },
            children: [
                displayTypeLabel && storeDisplayDataTypes && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataTypeLabel, {
                    dataType: type
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
                    className: "".concat(type, "-value"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Render, {
                        path: props.path,
                        inspect: props.inspect,
                        setInspect: props.setInspect,
                        value: props.value,
                        prevValue: props.prevValue
                    })
                })
            ]
        });
    };
    EasyType.displayName = "easy-".concat(type, "-type");
    if (!serialize || !deserialize) return {
        is,
        Component: EasyType
    };
    const EasyTypeEditor = (param)=>{
        let { value, setValue, abortEditing, commitEditing } = param;
        const color = useJsonViewerStore((store)=>store.colorspace[colorKey]);
        const handleKeyDown = (0, _react.useCallback)((event)=>{
            if (event.key === 'Enter') {
                event.preventDefault();
                commitEditing(value);
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                abortEditing();
            }
        }, [
            abortEditing,
            commitEditing,
            value
        ]);
        const handleChange = (0, _react.useCallback)((event)=>{
            setValue(event.target.value);
        }, [
            setValue
        ]);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.InputBase), {
            autoFocus: true,
            value: value,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            size: "small",
            multiline: true,
            sx: {
                color,
                padding: 0.5,
                borderStyle: 'solid',
                borderColor: 'black',
                borderWidth: 1,
                fontSize: '0.8rem',
                fontFamily: 'monospace',
                display: 'inline-flex'
            }
        });
    };
    EasyTypeEditor.displayName = "easy-".concat(type, "-type-editor");
    return {
        is,
        serialize,
        deserialize,
        Component: EasyType,
        Editor: EasyTypeEditor
    };
}
const booleanType = defineEasyType({
    is: (value)=>typeof value === 'boolean',
    type: 'bool',
    colorKey: 'base0E',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        throw new Error('Invalid boolean value');
    },
    Renderer: (param)=>{
        let { value } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: value ? 'true' : 'false'
        });
    }
});
const displayOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
};
const dateType = defineEasyType({
    is: (value)=>value instanceof Date,
    type: 'date',
    colorKey: 'base0D',
    Renderer: (param)=>{
        let { value } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: value.toLocaleTimeString('en-us', displayOptions)
        });
    }
});
const functionBody = (func)=>{
    const funcString = func.toString();
    let isUsualFunction = true;
    const parenthesisPos = funcString.indexOf(')');
    const arrowPos = funcString.indexOf('=>');
    if (arrowPos !== -1 && arrowPos > parenthesisPos) isUsualFunction = false;
    if (isUsualFunction) return funcString.substring(funcString.indexOf('{', parenthesisPos) + 1, funcString.lastIndexOf('}'));
    return funcString.substring(funcString.indexOf('=>') + 2);
};
const functionName = (func)=>{
    const funcString = func.toString();
    const isUsualFunction = funcString.indexOf('function') !== -1;
    if (isUsualFunction) return funcString.substring(8, funcString.indexOf('{')).trim();
    return funcString.substring(0, funcString.indexOf('=>') + 2).trim();
};
const lb = '{';
const rb = '}';
const PreFunctionType = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.NoSsr), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataTypeLabel, {
                dataType: "function"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                component: "span",
                className: "data-function-start",
                sx: {
                    letterSpacing: 0.5
                },
                children: [
                    functionName(props.value),
                    ' ',
                    lb
                ]
            })
        ]
    });
};
const PostFunctionType = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.NoSsr), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            component: "span",
            className: "data-function-end",
            children: rb
        })
    });
};
const FunctionType = (props)=>{
    const functionColor = useJsonViewerStore((store)=>store.colorspace.base05);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.NoSsr), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            className: "data-function",
            sx: {
                display: props.inspect ? 'block' : 'inline-block',
                pl: props.inspect ? 2 : 0,
                color: functionColor
            },
            children: props.inspect ? functionBody(props.value) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                component: "span",
                className: "data-function-body",
                onClick: ()=>props.setInspect(true),
                sx: {
                    '&:hover': {
                        cursor: 'pointer'
                    },
                    padding: 0.5
                },
                children: "\u2026"
            })
        })
    });
};
const functionType = {
    is: (value)=>typeof value === 'function',
    Component: FunctionType,
    PreComponent: PreFunctionType,
    PostComponent: PostFunctionType
};
const nullType = defineEasyType({
    is: (value)=>value === null,
    type: 'null',
    colorKey: 'base08',
    displayTypeLabel: false,
    Renderer: ()=>{
        const backgroundColor = useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                fontSize: '0.8rem',
                backgroundColor,
                fontWeight: 'bold',
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "NULL"
        });
    }
});
const isInt = (n)=>n % 1 === 0;
const nanType = defineEasyType({
    is: (value)=>typeof value === 'number' && isNaN(value),
    type: 'NaN',
    colorKey: 'base08',
    displayTypeLabel: false,
    serialize: ()=>'NaN',
    // allow deserialize the value back to number
    deserialize: (value)=>parseFloat(value),
    Renderer: ()=>{
        const backgroundColor = useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                backgroundColor,
                fontSize: '0.8rem',
                fontWeight: 'bold',
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "NaN"
        });
    }
});
const floatType = defineEasyType({
    is: (value)=>typeof value === 'number' && !isInt(value) && !isNaN(value),
    type: 'float',
    colorKey: 'base0B',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>parseFloat(value),
    Renderer: (param)=>{
        let { value } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: value
        });
    }
});
const intType = defineEasyType({
    is: (value)=>typeof value === 'number' && isInt(value),
    type: 'int',
    colorKey: 'base0F',
    serialize: (value)=>value.toString(),
    // allow deserialize the value to float
    deserialize: (value)=>parseFloat(value),
    Renderer: (param)=>{
        let { value } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: value
        });
    }
});
const bigIntType = defineEasyType({
    is: (value)=>typeof value === 'bigint',
    type: 'bigint',
    colorKey: 'base0F',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>BigInt(value.replace(/\D/g, '')),
    Renderer: (param)=>{
        let { value } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "".concat(value, "n")
        });
    }
});
const BaseIcon = (param)=>{
    let { d, ...props } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.SvgIcon), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: d
        })
    });
};
const AddBox = 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z';
const Check = 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';
const ChevronRight = 'M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z';
const CircularArrows = 'M 12 2 C 10.615 1.998 9.214625 2.2867656 7.890625 2.8847656 L 8.9003906 4.6328125 C 9.9043906 4.2098125 10.957 3.998 12 4 C 15.080783 4 17.738521 5.7633175 19.074219 8.3222656 L 17.125 9 L 21.25 11 L 22.875 7 L 20.998047 7.6523438 C 19.377701 4.3110398 15.95585 2 12 2 z M 6.5097656 4.4882812 L 2.2324219 5.0820312 L 3.734375 6.3808594 C 1.6515335 9.4550558 1.3615962 13.574578 3.3398438 17 C 4.0308437 18.201 4.9801562 19.268234 6.1601562 20.115234 L 7.1699219 18.367188 C 6.3019219 17.710187 5.5922656 16.904 5.0722656 16 C 3.5320014 13.332354 3.729203 10.148679 5.2773438 7.7128906 L 6.8398438 9.0625 L 6.5097656 4.4882812 z M 19.929688 13 C 19.794687 14.08 19.450734 15.098 18.927734 16 C 17.386985 18.668487 14.531361 20.090637 11.646484 19.966797 L 12.035156 17.9375 L 8.2402344 20.511719 L 10.892578 23.917969 L 11.265625 21.966797 C 14.968963 22.233766 18.681899 20.426323 20.660156 17 C 21.355156 15.801 21.805219 14.445 21.949219 13 L 19.929688 13 z';
const Close = 'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z';
const ContentCopy = 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z';
const Edit = 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z';
const ExpandMore = 'M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z';
const Delete = 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5l-1-1h-5l-1 1H5v2h14V4z';
const AddBoxIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: AddBox,
        ...props
    });
};
const CheckIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: Check,
        ...props
    });
};
const ChevronRightIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: ChevronRight,
        ...props
    });
};
const CircularArrowsIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: CircularArrows,
        ...props
    });
};
const CloseIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: Close,
        ...props
    });
};
const ContentCopyIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: ContentCopy,
        ...props
    });
};
const EditIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: Edit,
        ...props
    });
};
const ExpandMoreIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: ExpandMore,
        ...props
    });
};
const DeleteIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseIcon, {
        d: Delete,
        ...props
    });
};
const objectLb = '{';
const arrayLb = '[';
const objectRb = '}';
const arrayRb = ']';
function inspectMetadata(value) {
    const length = getValueSize(value);
    let name = '';
    if (value instanceof Map || value instanceof Set) name = value[Symbol.toStringTag];
    if (Object.prototype.hasOwnProperty.call(value, Symbol.toStringTag)) name = value[Symbol.toStringTag];
    return "".concat(length, " Items").concat(name ? " (".concat(name, ")") : '');
}
const PreObjectType = (props)=>{
    const metadataColor = useJsonViewerStore((store)=>store.colorspace.base04);
    const textColor = useTextColor();
    const isArrayLike = (0, _react.useMemo)(()=>Array.isArray(props.value) || props.value instanceof Set, [
        props.value
    ]);
    const isEmptyValue = (0, _react.useMemo)(()=>getValueSize(props.value) === 0, [
        props.value
    ]);
    const sizeOfValue = (0, _react.useMemo)(()=>inspectMetadata(props.value), [
        props.value
    ]);
    const displaySize = useJsonViewerStore((store)=>store.displaySize);
    const shouldDisplaySize = (0, _react.useMemo)(()=>typeof displaySize === 'function' ? displaySize(props.path, props.value) : displaySize, [
        displaySize,
        props.path,
        props.value
    ]);
    const isTrap = useIsCycleReference(props.path, props.value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        component: "span",
        className: "data-object-start",
        sx: {
            letterSpacing: 0.5
        },
        children: [
            isArrayLike ? arrayLb : objectLb,
            shouldDisplaySize && props.inspect && !isEmptyValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                component: "span",
                sx: {
                    pl: 0.5,
                    fontStyle: 'italic',
                    color: metadataColor,
                    userSelect: 'none'
                },
                children: sizeOfValue
            }),
            isTrap && !props.inspect && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularArrowsIcon, {
                        sx: {
                            fontSize: 12,
                            color: textColor,
                            mx: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
                        sx: {
                            cursor: 'pointer',
                            userSelect: 'none'
                        },
                        children: isTrap
                    })
                ]
            })
        ]
    });
};
const PostObjectType = (props)=>{
    const metadataColor = useJsonViewerStore((store)=>store.colorspace.base04);
    const textColor = useTextColor();
    const isArrayLike = (0, _react.useMemo)(()=>Array.isArray(props.value) || props.value instanceof Set, [
        props.value
    ]);
    const isEmptyValue = (0, _react.useMemo)(()=>getValueSize(props.value) === 0, [
        props.value
    ]);
    const sizeOfValue = (0, _react.useMemo)(()=>inspectMetadata(props.value), [
        props.value
    ]);
    const displaySize = useJsonViewerStore((store)=>store.displaySize);
    const shouldDisplaySize = (0, _react.useMemo)(()=>typeof displaySize === 'function' ? displaySize(props.path, props.value) : displaySize, [
        displaySize,
        props.path,
        props.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        component: "span",
        className: "data-object-end",
        sx: {
            lineHeight: 1.5,
            color: textColor,
            letterSpacing: 0.5,
            opacity: 0.8
        },
        children: [
            isArrayLike ? arrayRb : objectRb,
            shouldDisplaySize && (isEmptyValue || !props.inspect) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                component: "span",
                sx: {
                    pl: 0.5,
                    fontStyle: 'italic',
                    color: metadataColor,
                    userSelect: 'none'
                },
                children: sizeOfValue
            }) : null
        ]
    });
};
function getIterator(value) {
    return typeof (value === null || value === void 0 ? void 0 : value[Symbol.iterator]) === 'function';
}
const ObjectType = (props)=>{
    const keyColor = useTextColor();
    const borderColor = useJsonViewerStore((store)=>store.colorspace.base02);
    const groupArraysAfterLength = useJsonViewerStore((store)=>store.groupArraysAfterLength);
    const isTrap = useIsCycleReference(props.path, props.value);
    const [displayLength, setDisplayLength] = (0, _react.useState)(useJsonViewerStore((store)=>store.maxDisplayLength));
    const objectSortKeys = useJsonViewerStore((store)=>store.objectSortKeys);
    const elements = (0, _react.useMemo)(()=>{
        if (!props.inspect) return null;
        const value = props.value;
        const iterator = getIterator(value);
        // Array also has iterator, we skip it and treat it as an array as normal.
        if (iterator && !Array.isArray(value)) {
            const elements = [];
            if (value instanceof Map) {
                const lastIndex = value.size - 1;
                let index = 0;
                value.forEach((value, k)=>{
                    // fixme: key might be a object, array, or any value for the `Map<any, any>`
                    const key = k.toString();
                    const path = [
                        ...props.path,
                        key
                    ];
                    elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
                        path: path,
                        value: value,
                        prevValue: props.prevValue instanceof Map ? props.prevValue.get(k) : undefined,
                        editable: false,
                        last: index === lastIndex
                    }, key));
                    index++;
                });
            } else {
                // iterate with iterator func
                const iterator = value[Symbol.iterator]();
                let result = iterator.next();
                let count = 0;
                while(true){
                    const nextResult = iterator.next();
                    var _nextResult_done;
                    elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
                        path: [
                            ...props.path,
                            "iterator:".concat(count)
                        ],
                        value: result.value,
                        nestedIndex: count,
                        editable: false,
                        last: (_nextResult_done = nextResult.done) !== null && _nextResult_done !== void 0 ? _nextResult_done : false
                    }, count));
                    if (nextResult.done) break;
                    count++;
                    result = nextResult;
                }
            }
            return elements;
        }
        if (Array.isArray(value)) {
            const lastIndex = value.length - 1;
            // unknown[]
            if (value.length <= groupArraysAfterLength) {
                const elements = value.slice(0, displayLength).map((value, _index)=>{
                    const index = props.nestedIndex ? props.nestedIndex * groupArraysAfterLength + _index : _index;
                    const path = [
                        ...props.path,
                        index
                    ];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
                        path: path,
                        value: value,
                        prevValue: Array.isArray(props.prevValue) ? props.prevValue[index] : undefined,
                        last: _index === lastIndex
                    }, index);
                });
                if (value.length > displayLength) {
                    const rest = value.length - displayLength;
                    elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(DataBox, {
                        sx: {
                            cursor: 'pointer',
                            lineHeight: 1.5,
                            color: keyColor,
                            letterSpacing: 0.5,
                            opacity: 0.8,
                            userSelect: 'none'
                        },
                        onClick: ()=>setDisplayLength((length)=>length * 2),
                        children: [
                            "hidden ",
                            rest,
                            " items\u2026"
                        ]
                    }, "last"));
                }
                return elements;
            }
            const elements = segmentArray(value, groupArraysAfterLength);
            const prevElements = Array.isArray(props.prevValue) ? segmentArray(props.prevValue, groupArraysAfterLength) : undefined;
            const elementsLastIndex = elements.length - 1;
            return elements.map((list, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
                    path: props.path,
                    value: list,
                    nestedIndex: index,
                    prevValue: prevElements === null || prevElements === void 0 ? void 0 : prevElements[index],
                    last: index === elementsLastIndex
                }, index);
            });
        }
        // object
        let entries = Object.entries(value);
        if (objectSortKeys) entries = objectSortKeys === true ? entries.sort((param, param1)=>{
            let [a] = param, [b] = param1;
            return a.localeCompare(b);
        }) : entries.sort((param, param1)=>{
            let [a] = param, [b] = param1;
            return objectSortKeys(a, b);
        });
        const lastIndex = entries.length - 1;
        const elements = entries.slice(0, displayLength).map((param, index)=>{
            let [key, value] = param;
            var _props_prevValue;
            const path = [
                ...props.path,
                key
            ];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
                path: path,
                value: value,
                prevValue: (_props_prevValue = props.prevValue) === null || _props_prevValue === void 0 ? void 0 : _props_prevValue[key],
                last: index === lastIndex
            }, key);
        });
        if (entries.length > displayLength) {
            const rest = entries.length - displayLength;
            elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(DataBox, {
                sx: {
                    cursor: 'pointer',
                    lineHeight: 1.5,
                    color: keyColor,
                    letterSpacing: 0.5,
                    opacity: 0.8,
                    userSelect: 'none'
                },
                onClick: ()=>setDisplayLength((length)=>length * 2),
                children: [
                    "hidden ",
                    rest,
                    " items\u2026"
                ]
            }, "last"));
        }
        return elements;
    }, [
        props.inspect,
        props.value,
        props.prevValue,
        props.path,
        props.nestedIndex,
        groupArraysAfterLength,
        displayLength,
        keyColor,
        objectSortKeys
    ]);
    const marginLeft = props.inspect ? 0.6 : 0;
    const width = useJsonViewerStore((store)=>store.indentWidth);
    const indentWidth = props.inspect ? width - marginLeft : width;
    const isEmptyValue = (0, _react.useMemo)(()=>getValueSize(props.value) === 0, [
        props.value
    ]);
    if (isEmptyValue) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        className: "data-object",
        sx: {
            display: props.inspect ? 'block' : 'inline-block',
            pl: props.inspect ? indentWidth - 0.6 : 0,
            marginLeft,
            color: keyColor,
            borderLeft: props.inspect ? "1px solid ".concat(borderColor) : 'none'
        },
        children: props.inspect ? elements : !isTrap && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            component: "span",
            className: "data-object-body",
            onClick: ()=>props.setInspect(true),
            sx: {
                '&:hover': {
                    cursor: 'pointer'
                },
                padding: 0.5,
                userSelect: 'none'
            },
            children: "\u2026"
        })
    });
};
const objectType = {
    is: (value)=>typeof value === 'object',
    Component: ObjectType,
    PreComponent: PreObjectType,
    PostComponent: PostObjectType
};
const stringType = defineEasyType({
    is: (value)=>typeof value === 'string',
    type: 'string',
    colorKey: 'base09',
    serialize: (value)=>value,
    deserialize: (value)=>value,
    Renderer: (props)=>{
        const [showRest, setShowRest] = (0, _react.useState)(false);
        const collapseStringsAfterLength = useJsonViewerStore((store)=>store.collapseStringsAfterLength);
        const value = showRest ? props.value : props.value.slice(0, collapseStringsAfterLength);
        const hasRest = props.value.length > collapseStringsAfterLength;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            component: "span",
            sx: {
                overflowWrap: 'anywhere',
                cursor: hasRest ? 'pointer' : 'inherit'
            },
            onClick: ()=>{
                var _window_getSelection;
                if (((_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.type) === 'Range') return;
                if (hasRest) setShowRest((value)=>!value);
            },
            children: [
                '"',
                value,
                hasRest && !showRest && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    component: "span",
                    sx: {
                        padding: 0.5
                    },
                    children: "\u2026"
                }),
                '"'
            ]
        });
    }
});
const undefinedType = defineEasyType({
    is: (value)=>value === undefined,
    type: 'undefined',
    colorKey: 'base05',
    displayTypeLabel: false,
    Renderer: ()=>{
        const backgroundColor = useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                fontSize: '0.7rem',
                backgroundColor,
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "undefined"
        });
    }
});
function memorizeDataType(dataType) {
    function compare(prevProps, nextProps) {
        var _prevProps_path, _nextProps_path;
        return Object.is(prevProps.value, nextProps.value) && prevProps.inspect && nextProps.inspect && ((_prevProps_path = prevProps.path) === null || _prevProps_path === void 0 ? void 0 : _prevProps_path.join('.')) === ((_nextProps_path = nextProps.path) === null || _nextProps_path === void 0 ? void 0 : _nextProps_path.join('.'));
    }
    dataType.Component = /*#__PURE__*/ (0, _react.memo)(dataType.Component, compare);
    if (dataType.Editor) dataType.Editor = /*#__PURE__*/ (0, _react.memo)(dataType.Editor, function compare(prevProps, nextProps) {
        return Object.is(prevProps.value, nextProps.value);
    });
    if (dataType.PreComponent) dataType.PreComponent = /*#__PURE__*/ (0, _react.memo)(dataType.PreComponent, compare);
    if (dataType.PostComponent) dataType.PostComponent = /*#__PURE__*/ (0, _react.memo)(dataType.PostComponent, compare);
    return dataType;
}
const predefinedTypes = [
    memorizeDataType(booleanType),
    memorizeDataType(dateType),
    memorizeDataType(nullType),
    memorizeDataType(undefinedType),
    memorizeDataType(stringType),
    memorizeDataType(functionType),
    memorizeDataType(nanType),
    memorizeDataType(intType),
    memorizeDataType(floatType),
    memorizeDataType(bigIntType)
];
const createTypeRegistryStore = ()=>{
    return (0, _zustand.createStore)()((set)=>({
            registry: predefinedTypes,
            registerTypes: (setState)=>{
                set((state)=>({
                        registry: typeof setState === 'function' ? setState(state.registry) : setState
                    }));
            }
        }));
};
// @ts-expect-error we intentionally want to pass undefined to the context
// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
const TypeRegistryStoreContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
TypeRegistryStoreContext.Provider;
const useTypeRegistryStore = (selector, equalityFn)=>{
    const store = (0, _react.useContext)(TypeRegistryStoreContext);
    return (0, _zustand.useStore)(store, selector, equalityFn);
};
function matchTypeComponents(value, path, registry) {
    let potential;
    for (const T of registry)if (T.is(value, path)) potential = T;
    if (potential === undefined) {
        if (typeof value === 'object') return objectType;
        throw new Error("No type matched for value: ".concat(value));
    }
    return potential;
}
function useTypeComponents(value, path) {
    const registry = useTypeRegistryStore((store)=>store.registry);
    return (0, _react.useMemo)(()=>matchTypeComponents(value, path, registry), [
        value,
        path,
        registry
    ]);
}
const IconBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        component: "span",
        ...props,
        sx: {
            cursor: 'pointer',
            paddingLeft: '0.7rem',
            ...props.sx
        }
    });
const DataKeyPair = (props)=>{
    const { value, prevValue, path, nestedIndex, last } = props;
    const { Component, PreComponent, PostComponent, Editor, serialize, deserialize } = useTypeComponents(value, path);
    var _props_editable;
    const propsEditable = (_props_editable = props.editable) !== null && _props_editable !== void 0 ? _props_editable : undefined;
    const storeEditable = useJsonViewerStore((store)=>store.editable);
    const editable = (0, _react.useMemo)(()=>{
        if (storeEditable === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEditable === 'function') return !!storeEditable(path, value);
        return storeEditable;
    }, [
        path,
        propsEditable,
        storeEditable,
        value
    ]);
    const [tempValue, setTempValue] = (0, _react.useState)('');
    const depth = path.length;
    const key = path[depth - 1];
    const hoverPath = useJsonViewerStore((store)=>store.hoverPath);
    const isHover = (0, _react.useMemo)(()=>{
        return hoverPath && path.every((value, index)=>value === hoverPath.path[index] && nestedIndex === hoverPath.nestedIndex);
    }, [
        hoverPath,
        path,
        nestedIndex
    ]);
    const setHover = useJsonViewerStore((store)=>store.setHover);
    const root = useJsonViewerStore((store)=>store.value);
    const [inspect, setInspect] = useInspect(path, value, nestedIndex);
    const [editing, setEditing] = (0, _react.useState)(false);
    const onChange = useJsonViewerStore((store)=>store.onChange);
    const keyColor = useTextColor();
    const numberKeyColor = useJsonViewerStore((store)=>store.colorspace.base0C);
    const highlightColor = useJsonViewerStore((store)=>store.colorspace.base0A);
    const displayComma = useJsonViewerStore((store)=>store.displayComma);
    const quotesOnKeys = useJsonViewerStore((store)=>store.quotesOnKeys);
    const rootName = useJsonViewerStore((store)=>store.rootName);
    const isRoot = root === value;
    const isNumberKey = Number.isInteger(Number(key));
    const storeEnableAdd = useJsonViewerStore((store)=>store.enableAdd);
    const onAdd = useJsonViewerStore((store)=>store.onAdd);
    const enableAdd = (0, _react.useMemo)(()=>{
        if (!onAdd || nestedIndex !== undefined) return false;
        if (storeEnableAdd === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEnableAdd === 'function') return !!storeEnableAdd(path, value);
        if (Array.isArray(value) || isPlainObject(value)) return true;
        return false;
    }, [
        onAdd,
        nestedIndex,
        path,
        storeEnableAdd,
        propsEditable,
        value
    ]);
    const storeEnableDelete = useJsonViewerStore((store)=>store.enableDelete);
    const onDelete = useJsonViewerStore((store)=>store.onDelete);
    const enableDelete = (0, _react.useMemo)(()=>{
        if (!onDelete || nestedIndex !== undefined) return false;
        if (isRoot) // don't allow delete root
        return false;
        if (storeEnableDelete === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEnableDelete === 'function') return !!storeEnableDelete(path, value);
        return storeEnableDelete;
    }, [
        onDelete,
        nestedIndex,
        isRoot,
        path,
        storeEnableDelete,
        propsEditable,
        value
    ]);
    const enableClipboard = useJsonViewerStore((store)=>store.enableClipboard);
    const { copy, copied } = useClipboard();
    const highlightUpdates = useJsonViewerStore((store)=>store.highlightUpdates);
    const isHighlight = (0, _react.useMemo)(()=>{
        if (!highlightUpdates || prevValue === undefined) return false;
        // highlight if value type changed
        if (typeof value !== typeof prevValue) return true;
        if (typeof value === 'number') {
            // notice: NaN !== NaN
            if (isNaN(value) && isNaN(prevValue)) return false;
            return value !== prevValue;
        }
        // highlight if isArray changed
        if (Array.isArray(value) !== Array.isArray(prevValue)) return true;
        // not highlight object/function
        // deep compare they will be slow
        if (typeof value === 'object' || typeof value === 'function') return false;
        // highlight if not equal
        if (value !== prevValue) return true;
        return false;
    }, [
        highlightUpdates,
        prevValue,
        value
    ]);
    const highlightContainer = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        if (highlightContainer.current && isHighlight && 'animate' in highlightContainer.current) highlightContainer.current.animate([
            {
                backgroundColor: highlightColor
            },
            {
                backgroundColor: ''
            }
        ], {
            duration: 1000,
            easing: 'ease-in'
        });
    }, [
        highlightColor,
        isHighlight,
        prevValue,
        value
    ]);
    const startEditing = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        if (serialize) setTempValue(serialize(value));
        setEditing(true);
    }, [
        serialize,
        value
    ]);
    const abortEditing = (0, _react.useCallback)(()=>{
        setEditing(false);
        setTempValue('');
    }, [
        setEditing,
        setTempValue
    ]);
    const commitEditing = (0, _react.useCallback)((newValue)=>{
        setEditing(false);
        if (!deserialize) return;
        try {
            onChange(path, value, deserialize(newValue));
        } catch (e) {
        // do nothing when deserialize failed
        }
    }, [
        setEditing,
        deserialize,
        onChange,
        path,
        value
    ]);
    const actionIcons = (0, _react.useMemo)(()=>{
        if (editing) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseIcon, {
                        sx: {
                            fontSize: '.8rem'
                        },
                        onClick: abortEditing
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckIcon, {
                        sx: {
                            fontSize: '.8rem'
                        },
                        onClick: ()=>commitEditing(tempValue)
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                enableClipboard && /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        try {
                            copy(path, value, copyString);
                        } catch (e) {
                            // in some case, this will throw error
                            // fixme: `useAlert` hook
                            console.error(e);
                        }
                    },
                    children: copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentCopyIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                Editor && editable && serialize && deserialize && /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    onClick: startEditing,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                enableAdd && /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        onAdd === null || onAdd === void 0 || onAdd(path);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddBoxIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                enableDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        onDelete === null || onDelete === void 0 || onDelete(path, value);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeleteIcon, {
                        sx: {
                            fontSize: '.9rem'
                        }
                    })
                })
            ]
        });
    }, [
        Editor,
        serialize,
        deserialize,
        copied,
        copy,
        editable,
        editing,
        enableClipboard,
        enableAdd,
        enableDelete,
        tempValue,
        path,
        value,
        onAdd,
        onDelete,
        startEditing,
        abortEditing,
        commitEditing
    ]);
    const isEmptyValue = (0, _react.useMemo)(()=>getValueSize(value) === 0, [
        value
    ]);
    const expandable = !isEmptyValue && !!(PreComponent && PostComponent);
    const KeyRenderer = useJsonViewerStore((store)=>store.keyRenderer);
    const downstreamProps = (0, _react.useMemo)(()=>({
            path,
            inspect,
            setInspect,
            value,
            prevValue,
            nestedIndex
        }), [
        inspect,
        path,
        setInspect,
        value,
        prevValue,
        nestedIndex
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        className: "data-key-pair",
        "data-testid": 'data-key-pair' + path.join('.'),
        sx: {
            userSelect: 'text'
        },
        onMouseEnter: (0, _react.useCallback)(()=>setHover(path, nestedIndex), [
            setHover,
            path,
            nestedIndex
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DataBox, {
                component: "span",
                className: "data-key",
                sx: {
                    lineHeight: 1.5,
                    color: keyColor,
                    letterSpacing: 0.5,
                    opacity: 0.8
                },
                onClick: (0, _react.useCallback)((event)=>{
                    if (event.isDefaultPrevented()) return;
                    if (!isEmptyValue) setInspect((state)=>!state);
                }, [
                    isEmptyValue,
                    setInspect
                ]),
                children: [
                    expandable ? inspect ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandMoreIcon, {
                        className: "data-key-toggle-expanded",
                        sx: {
                            fontSize: '.8rem',
                            '&:hover': {
                                cursor: 'pointer'
                            }
                        }
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChevronRightIcon, {
                        className: "data-key-toggle-collapsed",
                        sx: {
                            fontSize: '.8rem',
                            '&:hover': {
                                cursor: 'pointer'
                            }
                        }
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        ref: highlightContainer,
                        className: "data-key-key",
                        component: "span",
                        children: isRoot && depth === 0 ? rootName !== false ? quotesOnKeys ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                '"',
                                rootName,
                                '"'
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: rootName
                        }) : null : KeyRenderer.when(downstreamProps) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(KeyRenderer, {
                            ...downstreamProps
                        }) : nestedIndex === undefined && (isNumberKey ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            component: "span",
                            style: {
                                color: numberKeyColor,
                                userSelect: isNumberKey ? 'none' : 'auto'
                            },
                            children: key
                        }) : quotesOnKeys ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                '"',
                                key,
                                '"'
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: key
                        }))
                    }),
                    isRoot ? rootName !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
                        className: "data-key-colon",
                        sx: {
                            mr: 0.5
                        },
                        children: ":"
                    }) : nestedIndex === undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
                        className: "data-key-colon",
                        sx: {
                            mr: 0.5,
                            '.data-key-key:empty + &': {
                                display: 'none'
                            },
                            userSelect: isNumberKey ? 'none' : 'auto'
                        },
                        children: ":"
                    }),
                    PreComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreComponent, {
                        ...downstreamProps
                    }),
                    isHover && expandable && inspect && actionIcons
                ]
            }),
            editing && editable ? Editor && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Editor, {
                path: path,
                value: tempValue,
                setValue: setTempValue,
                abortEditing: abortEditing,
                commitEditing: commitEditing
            }) : Component ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...downstreamProps
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                component: "span",
                className: "data-value-fallback",
                children: "fallback: ".concat(value)
            }),
            PostComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PostComponent, {
                ...downstreamProps
            }),
            !last && displayComma && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataBox, {
                children: ","
            }),
            isHover && expandable && !inspect && actionIcons,
            isHover && !expandable && actionIcons,
            !isHover && editing && actionIcons
        ]
    });
};
const query = '(prefers-color-scheme: dark)';
function useThemeDetector() {
    const [isDark, setIsDark] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const listener = (e)=>setIsDark(e.matches);
        setIsDark(window.matchMedia(query).matches);
        const queryMedia = window.matchMedia(query);
        queryMedia.addEventListener('change', listener);
        return ()=>queryMedia.removeEventListener('change', listener);
    }, []);
    return isDark;
}
/**
 * @internal
 */ function useSetIfNotUndefinedEffect(key, value) {
    const { setState } = (0, _react.useContext)(JsonViewerStoreContext);
    (0, _react.useEffect)(()=>{
        if (value !== undefined) setState({
            [key]: value
        });
    }, [
        key,
        value,
        setState
    ]);
}
/**
 * @internal
 */ const JsonViewerInner = (props)=>{
    const { setState } = (0, _react.useContext)(JsonViewerStoreContext);
    (0, _react.useEffect)(()=>{
        setState((state)=>({
                prevValue: state.value,
                value: props.value
            }));
    }, [
        props.value,
        setState
    ]);
    useSetIfNotUndefinedEffect('rootName', props.rootName);
    useSetIfNotUndefinedEffect('indentWidth', props.indentWidth);
    useSetIfNotUndefinedEffect('keyRenderer', props.keyRenderer);
    useSetIfNotUndefinedEffect('enableAdd', props.enableAdd);
    useSetIfNotUndefinedEffect('enableDelete', props.enableDelete);
    useSetIfNotUndefinedEffect('enableClipboard', props.enableClipboard);
    useSetIfNotUndefinedEffect('editable', props.editable);
    useSetIfNotUndefinedEffect('onChange', props.onChange);
    useSetIfNotUndefinedEffect('onCopy', props.onCopy);
    useSetIfNotUndefinedEffect('onSelect', props.onSelect);
    useSetIfNotUndefinedEffect('onAdd', props.onAdd);
    useSetIfNotUndefinedEffect('onDelete', props.onDelete);
    useSetIfNotUndefinedEffect('maxDisplayLength', props.maxDisplayLength);
    useSetIfNotUndefinedEffect('groupArraysAfterLength', props.groupArraysAfterLength);
    useSetIfNotUndefinedEffect('quotesOnKeys', props.quotesOnKeys);
    useSetIfNotUndefinedEffect('displayDataTypes', props.displayDataTypes);
    useSetIfNotUndefinedEffect('displaySize', props.displaySize);
    useSetIfNotUndefinedEffect('displayComma', props.displayComma);
    useSetIfNotUndefinedEffect('highlightUpdates', props.highlightUpdates);
    (0, _react.useEffect)(()=>{
        if (props.theme === 'light') setState({
            colorspace: lightColorspace
        });
        else if (props.theme === 'dark') setState({
            colorspace: darkColorspace
        });
        else if (typeof props.theme === 'object') setState({
            colorspace: props.theme
        });
    }, [
        setState,
        props.theme
    ]);
    const themeCls = (0, _react.useMemo)(()=>{
        if (typeof props.theme === 'object') return 'json-viewer-theme-custom';
        return props.theme === 'dark' ? 'json-viewer-theme-dark' : 'json-viewer-theme-light';
    }, [
        props.theme
    ]);
    const onceRef = (0, _react.useRef)(true);
    const registerTypes = useTypeRegistryStore((store)=>store.registerTypes);
    if (onceRef.current) {
        const allTypes = props.valueTypes ? [
            ...predefinedTypes,
            ...props.valueTypes
        ] : [
            ...predefinedTypes
        ];
        registerTypes(allTypes);
        onceRef.current = false;
    }
    (0, _react.useEffect)(()=>{
        const allTypes = props.valueTypes ? [
            ...predefinedTypes,
            ...props.valueTypes
        ] : [
            ...predefinedTypes
        ];
        registerTypes(allTypes);
    }, [
        props.valueTypes,
        registerTypes
    ]);
    const value = useJsonViewerStore((store)=>store.value);
    const prevValue = useJsonViewerStore((store)=>store.prevValue);
    const emptyPath = (0, _react.useMemo)(()=>[], []);
    const setHover = useJsonViewerStore((store)=>store.setHover);
    const onMouseLeave = (0, _react.useCallback)(()=>setHover(null), [
        setHover
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Paper), {
        elevation: 0,
        className: clsx(themeCls, props.className),
        style: props.style,
        sx: {
            fontFamily: 'monospace',
            userSelect: 'none',
            contentVisibility: 'auto',
            ...props.sx
        },
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataKeyPair, {
            value: value,
            prevValue: prevValue,
            path: emptyPath,
            last: true
        })
    });
};
const JsonViewer = function JsonViewer(props) {
    const isAutoDarkTheme = useThemeDetector();
    const themeType = (0, _react.useMemo)(()=>{
        var _props_theme;
        return props.theme === 'auto' ? isAutoDarkTheme ? 'dark' : 'light' : (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : 'light';
    }, [
        isAutoDarkTheme,
        props.theme
    ]);
    const theme = (0, _react.useMemo)(()=>{
        const backgroundColor = typeof themeType === 'object' ? themeType.base00 : themeType === 'dark' ? darkColorspace.base00 : lightColorspace.base00;
        const foregroundColor = typeof themeType === 'object' ? themeType.base07 : themeType === 'dark' ? darkColorspace.base07 : lightColorspace.base07;
        return (0, _material.createTheme)({
            components: {
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundColor,
                            color: foregroundColor
                        }
                    }
                }
            },
            palette: {
                mode: themeType === 'dark' ? 'dark' : 'light',
                background: {
                    default: backgroundColor
                }
            }
        });
    }, [
        themeType
    ]);
    const mixedProps = {
        ...props,
        theme: themeType
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const jsonViewerStore = (0, _react.useMemo)(()=>createJsonViewerStore(props), []);
    const typeRegistryStore = (0, _react.useMemo)(()=>createTypeRegistryStore(), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ThemeProvider), {
        theme: theme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypeRegistryStoreContext.Provider, {
            value: typeRegistryStore,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(JsonViewerStoreContext.Provider, {
                value: jsonViewerStore,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(JsonViewerInner, {
                    ...mixedProps
                })
            })
        })
    });
};

},{"react/jsx-runtime":"dpQXr","@mui/material":[["Box","lTMZJ","default"],["createTheme","XJRGA","default"],["InputBase","8bonu","default"],["NoSsr","hInB9","default"],["Paper","dYSDg","default"],["SvgIcon","kegAl","default"],["ThemeProvider","6Yb3a","default"]],"react":"IMRgT","zustand":"2yVQ8","copy-to-clipboard":"9lZ8E","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lTMZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _system = require("@mui/system");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _className = require("../className");
var _styles = require("../styles");
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
'use client';
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: (0, _identifierDefault.default),
    defaultTheme,
    defaultClassName: (0, _boxClassesDefault.default).root,
    generateClassName: (0, _className.unstable_ClassNameGenerator).generate
});
exports.default = Box;

},{"@mui/system":[["createBox","6Kl2S","default"]],"prop-types":"iRwZ2","../className":[["unstable_ClassNameGenerator","ekeuS","default"]],"../styles":[["createTheme","XJRGA","default"]],"../styles/identifier":"dL24M","./boxClasses":"jRfnM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6Kl2S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBox);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component"
];
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = 'MuiBox-root', generateClassName } = options;
    const BoxRoot = (0, _styledEngineDefault.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, _styleFunctionSxDefault.default));
    const Box = /*#__PURE__*/ _react.forwardRef(function Box(inProps, ref) {
        const theme = (0, _useThemeDefault.default)(defaultTheme);
        const _extendSxProp = (0, _styleFunctionSx.extendSxProp)(inProps), { className, component = 'div' } = _extendSxProp, other = (0, _objectWithoutPropertiesLooseDefault.default)(_extendSxProp, _excluded);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, (0, _extendsDefault.default)({
            as: component,
            ref: ref,
            className: (0, _clsxDefault.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","react":"IMRgT","clsx":"dVFZM","@mui/styled-engine":"hcPbL","./styleFunctionSx":[["default","kOMd4"],["extendSxProp","cia9A","default"]],"./useTheme":"gVe4Z","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dVFZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hcPbL":[function(require,module,exports,__globalThis) {
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _react.ThemeContext));
parcelHelpers.export(exports, "keyframes", ()=>(0, _react.keyframes));
parcelHelpers.export(exports, "css", ()=>(0, _react.css));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngineProviderDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "default", ()=>styled);
parcelHelpers.export(exports, "internal_processStyles", ()=>internal_processStyles);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "internal_serializeStyles", ()=>internal_serializeStyles);
/* eslint-disable no-underscore-dangle */ var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _serialize = require("@emotion/serialize");
var _react = require("@emotion/react");
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
'use client';
function styled(tag, options) {
    const stylesFactory = (0, _styledDefault.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const internal_processStyles = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const wrapper = [];
function internal_serializeStyles(styles) {
    wrapper[0] = styles;
    return (0, _serialize.serializeStyles)(wrapper);
}

},{"@emotion/styled":"ctYDN","@emotion/serialize":"1OQbo","@emotion/react":"lH1pG","./StyledEngineProvider":"96yIp","./GlobalStyles":"1yVaZ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ctYDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styled);
var _emotionStyledBaseEsmJs = require("../base/dist/emotion-styled-base.esm.js");
var _emotionStyledBaseEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var styled = (0, _emotionStyledBaseEsmJsDefault.default).bind(null);
tags.forEach(function(tagName) {
    styled[tagName] = styled(tagName);
});

},{"../base/dist/emotion-styled-base.esm.js":"1LxPE","@babel/runtime/helpers/extends":"iyGus","@emotion/react":"lH1pG","@emotion/serialize":"1OQbo","@emotion/use-insertion-effect-with-fallbacks":"f9sgL","@emotion/utils":"cHzPX","react":"IMRgT","@emotion/is-prop-valid":"fe6TC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1LxPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var isBrowser = typeof document !== 'undefined';
var isDevelopment = false;
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, _react.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react1.useContext((0, _react.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ _react1.createElement(_react1.Fragment, null, /*#__PURE__*/ _react1.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ _react1.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@emotion/react":"lH1pG","@emotion/serialize":"1OQbo","@emotion/use-insertion-effect-with-fallbacks":"f9sgL","@emotion/utils":"cHzPX","react":"IMRgT","@emotion/is-prop-valid":"fe6TC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fe6TC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"e4Rfa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"96yIp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StyledEngineProvider);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, _cacheDefault.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const cacheMap = new Map();
function StyledEngineProvider(props) {
    const { injectFirst, enableCssLayer, children } = props;
    const cache = _react.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && cacheMap.has(cacheKey)) return cacheMap.get(cacheKey);
        const fresh = getCache(injectFirst, enableCssLayer);
        cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.CacheProvider), {
        value: cache,
        children: children
    });
    return children;
}

},{"react":"IMRgT","prop-types":"iRwZ2","@emotion/react":[["CacheProvider","gvB8D","C"]],"@emotion/cache":"aPh1k","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1yVaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalStyles);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Global), {
        styles: globalStyles
    });
}

},{"react":"IMRgT","prop-types":"iRwZ2","@emotion/react":"lH1pG","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kOMd4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>unstable_createStyleFunctionSx);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _merge = require("../merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _style = require("../style");
var _breakpoints = require("../breakpoints");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx, theme = {}, nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, _defaultSxConfigDefault.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme,
                                nested: true
                            });
                            else css = (0, _mergeDefault.default)(css, breakpointsValues);
                        }
                    } else css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    'sx'
];
exports.default = styleFunctionSx;

},{"@mui/utils/capitalize":"1qSep","../merge":"d5sXZ","../style":"bGhJU","../breakpoints":"l6d36","./defaultSxConfig":"9YSCV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1qSep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>capitalize);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, _formatMuiErrorMessageDefault.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"@mui/utils/formatMuiErrorMessage":"2wzsQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2wzsQ":[function(require,module,exports,__globalThis) {
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatMuiErrorMessage);
function formatMuiErrorMessage(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"d5sXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmergeDefault.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
exports.default = merge;

},{"@mui/utils/deepmerge":"lBRGq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lBRGq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "default", ()=>deepmerge);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
function isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (/*#__PURE__*/ _react.isValidElement(source) || !isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, _extendsDefault.default)({}, target) : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ _react.isValidElement(source[key])) output[key] = source[key];
        else if (isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bGhJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "getStyleValue", ()=>getStyleValue);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
exports.default = style;

},{"@mui/utils/capitalize":"1qSep","./responsivePropType":"btvvp","./breakpoints":"l6d36","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"btvvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const responsivePropType = {};
exports.default = responsivePropType;

},{"prop-types":"iRwZ2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l6d36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "handleBreakpoints", ()=>handleBreakpoints);
parcelHelpers.export(exports, "createEmptyBreakpointObject", ()=>createEmptyBreakpointObject);
parcelHelpers.export(exports, "removeUnusedBreakpoints", ()=>removeUnusedBreakpoints);
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>mergeBreakpointsInOrder);
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
parcelHelpers.export(exports, "computeBreakpointsBase", ()=>computeBreakpointsBase);
parcelHelpers.export(exports, "resolveBreakpointValues", ()=>resolveBreakpointValues);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, _extendsDefault.default)({
                    theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, _mergeDefault.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmergeDefault.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
exports.default = breakpoints;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","prop-types":"iRwZ2","@mui/utils/deepmerge":"lBRGq","./merge":"d5sXZ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9YSCV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacing = require("../spacing");
var _borders = require("../borders");
var _cssGrid = require("../cssGrid");
var _palette = require("../palette");
var _sizing = require("../sizing");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, _borders.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, _palette.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, _palette.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, _palette.paletteTransform)
    },
    // spacing
    p: {
        style: (0, _spacing.padding)
    },
    pt: {
        style: (0, _spacing.padding)
    },
    pr: {
        style: (0, _spacing.padding)
    },
    pb: {
        style: (0, _spacing.padding)
    },
    pl: {
        style: (0, _spacing.padding)
    },
    px: {
        style: (0, _spacing.padding)
    },
    py: {
        style: (0, _spacing.padding)
    },
    padding: {
        style: (0, _spacing.padding)
    },
    paddingTop: {
        style: (0, _spacing.padding)
    },
    paddingRight: {
        style: (0, _spacing.padding)
    },
    paddingBottom: {
        style: (0, _spacing.padding)
    },
    paddingLeft: {
        style: (0, _spacing.padding)
    },
    paddingX: {
        style: (0, _spacing.padding)
    },
    paddingY: {
        style: (0, _spacing.padding)
    },
    paddingInline: {
        style: (0, _spacing.padding)
    },
    paddingInlineStart: {
        style: (0, _spacing.padding)
    },
    paddingInlineEnd: {
        style: (0, _spacing.padding)
    },
    paddingBlock: {
        style: (0, _spacing.padding)
    },
    paddingBlockStart: {
        style: (0, _spacing.padding)
    },
    paddingBlockEnd: {
        style: (0, _spacing.padding)
    },
    m: {
        style: (0, _spacing.margin)
    },
    mt: {
        style: (0, _spacing.margin)
    },
    mr: {
        style: (0, _spacing.margin)
    },
    mb: {
        style: (0, _spacing.margin)
    },
    ml: {
        style: (0, _spacing.margin)
    },
    mx: {
        style: (0, _spacing.margin)
    },
    my: {
        style: (0, _spacing.margin)
    },
    margin: {
        style: (0, _spacing.margin)
    },
    marginTop: {
        style: (0, _spacing.margin)
    },
    marginRight: {
        style: (0, _spacing.margin)
    },
    marginBottom: {
        style: (0, _spacing.margin)
    },
    marginLeft: {
        style: (0, _spacing.margin)
    },
    marginX: {
        style: (0, _spacing.margin)
    },
    marginY: {
        style: (0, _spacing.margin)
    },
    marginInline: {
        style: (0, _spacing.margin)
    },
    marginInlineStart: {
        style: (0, _spacing.margin)
    },
    marginInlineEnd: {
        style: (0, _spacing.margin)
    },
    marginBlock: {
        style: (0, _spacing.margin)
    },
    marginBlockStart: {
        style: (0, _spacing.margin)
    },
    marginBlockEnd: {
        style: (0, _spacing.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, _cssGrid.gap)
    },
    rowGap: {
        style: (0, _cssGrid.rowGap)
    },
    columnGap: {
        style: (0, _cssGrid.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, _sizing.sizingTransform)
    },
    maxWidth: {
        style: (0, _sizing.maxWidth)
    },
    minWidth: {
        transform: (0, _sizing.sizingTransform)
    },
    height: {
        transform: (0, _sizing.sizingTransform)
    },
    maxHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    minHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
exports.default = defaultSxConfig;

},{"../spacing":"5CIJZ","../borders":"dXqpP","../cssGrid":"ixjmd","../palette":"fupXI","../sizing":"8adiI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5CIJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marginKeys", ()=>marginKeys);
parcelHelpers.export(exports, "paddingKeys", ()=>paddingKeys);
parcelHelpers.export(exports, "createUnaryUnit", ()=>createUnaryUnit);
parcelHelpers.export(exports, "createUnarySpacing", ()=>createUnarySpacing);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getStyleFromPropValue", ()=>getStyleFromPropValue);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "padding", ()=>padding);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
var _style = require("./style");
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _memoize = require("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
const properties = {
    m: 'margin',
    p: 'padding'
};
const directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoizeDefault.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, _style.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce((0, _mergeDefault.default), {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
exports.default = spacing;

},{"./responsivePropType":"btvvp","./breakpoints":"l6d36","./style":"bGhJU","./merge":"d5sXZ","./memoize":"iHFl8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iHFl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dXqpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderTransform", ()=>borderTransform);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderTop", ()=>borderTop);
parcelHelpers.export(exports, "borderRight", ()=>borderRight);
parcelHelpers.export(exports, "borderBottom", ()=>borderBottom);
parcelHelpers.export(exports, "borderLeft", ()=>borderLeft);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderTopColor", ()=>borderTopColor);
parcelHelpers.export(exports, "borderRightColor", ()=>borderRightColor);
parcelHelpers.export(exports, "borderBottomColor", ()=>borderBottomColor);
parcelHelpers.export(exports, "borderLeftColor", ()=>borderLeftColor);
parcelHelpers.export(exports, "outline", ()=>outline);
parcelHelpers.export(exports, "outlineColor", ()=>outlineColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
function borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _styleDefault.default)({
        prop,
        themeKey: 'borders',
        transform
    });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = [
    'borderRadius'
];
const borders = (0, _composeDefault.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
exports.default = borders;

},{"./responsivePropType":"btvvp","./style":"bGhJU","./compose":"cozj0","./spacing":"5CIJZ","./breakpoints":"l6d36","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cozj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _mergeDefault.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
exports.default = compose;

},{"./merge":"d5sXZ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ixjmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gap", ()=>gap);
parcelHelpers.export(exports, "columnGap", ()=>columnGap);
parcelHelpers.export(exports, "rowGap", ()=>rowGap);
parcelHelpers.export(exports, "gridColumn", ()=>gridColumn);
parcelHelpers.export(exports, "gridRow", ()=>gridRow);
parcelHelpers.export(exports, "gridAutoFlow", ()=>gridAutoFlow);
parcelHelpers.export(exports, "gridAutoColumns", ()=>gridAutoColumns);
parcelHelpers.export(exports, "gridAutoRows", ()=>gridAutoRows);
parcelHelpers.export(exports, "gridTemplateColumns", ()=>gridTemplateColumns);
parcelHelpers.export(exports, "gridTemplateRows", ()=>gridTemplateRows);
parcelHelpers.export(exports, "gridTemplateAreas", ()=>gridTemplateAreas);
parcelHelpers.export(exports, "gridArea", ()=>gridArea);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
gap.propTypes = {};
gap.filterProps = [
    'gap'
];
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
columnGap.propTypes = {};
columnGap.filterProps = [
    'columnGap'
];
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
rowGap.propTypes = {};
rowGap.filterProps = [
    'rowGap'
];
const gridColumn = (0, _styleDefault.default)({
    prop: 'gridColumn'
});
const gridRow = (0, _styleDefault.default)({
    prop: 'gridRow'
});
const gridAutoFlow = (0, _styleDefault.default)({
    prop: 'gridAutoFlow'
});
const gridAutoColumns = (0, _styleDefault.default)({
    prop: 'gridAutoColumns'
});
const gridAutoRows = (0, _styleDefault.default)({
    prop: 'gridAutoRows'
});
const gridTemplateColumns = (0, _styleDefault.default)({
    prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0, _styleDefault.default)({
    prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0, _styleDefault.default)({
    prop: 'gridTemplateAreas'
});
const gridArea = (0, _styleDefault.default)({
    prop: 'gridArea'
});
const grid = (0, _composeDefault.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
exports.default = grid;

},{"./style":"bGhJU","./compose":"cozj0","./spacing":"5CIJZ","./breakpoints":"l6d36","./responsivePropType":"btvvp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fupXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paletteTransform", ()=>paletteTransform);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "bgcolor", ()=>bgcolor);
parcelHelpers.export(exports, "backgroundColor", ()=>backgroundColor);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
function paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const color = (0, _styleDefault.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: paletteTransform
});
const bgcolor = (0, _styleDefault.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const backgroundColor = (0, _styleDefault.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const palette = (0, _composeDefault.default)(color, bgcolor, backgroundColor);
exports.default = palette;

},{"./style":"bGhJU","./compose":"cozj0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8adiI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizingTransform", ()=>sizingTransform);
parcelHelpers.export(exports, "width", ()=>width);
parcelHelpers.export(exports, "maxWidth", ()=>maxWidth);
parcelHelpers.export(exports, "minWidth", ()=>minWidth);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "maxHeight", ()=>maxHeight);
parcelHelpers.export(exports, "minHeight", ()=>minHeight);
parcelHelpers.export(exports, "sizeWidth", ()=>sizeWidth);
parcelHelpers.export(exports, "sizeHeight", ()=>sizeHeight);
parcelHelpers.export(exports, "boxSizing", ()=>boxSizing);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _breakpoints = require("./breakpoints");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0, _styleDefault.default)({
    prop: 'width',
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, _breakpoints.values)[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
maxWidth.filterProps = [
    'maxWidth'
];
const minWidth = (0, _styleDefault.default)({
    prop: 'minWidth',
    transform: sizingTransform
});
const height = (0, _styleDefault.default)({
    prop: 'height',
    transform: sizingTransform
});
const maxHeight = (0, _styleDefault.default)({
    prop: 'maxHeight',
    transform: sizingTransform
});
const minHeight = (0, _styleDefault.default)({
    prop: 'minHeight',
    transform: sizingTransform
});
const sizeWidth = (0, _styleDefault.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: sizingTransform
});
const sizeHeight = (0, _styleDefault.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: sizingTransform
});
const boxSizing = (0, _styleDefault.default)({
    prop: 'boxSizing'
});
const sizing = (0, _composeDefault.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
exports.default = sizing;

},{"./style":"bGhJU","./compose":"cozj0","./breakpoints":"l6d36","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cia9A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extendSxProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
const _excluded = [
    "sx"
];
const splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, _defaultSxConfigDefault.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return (0, _extendsDefault.default)({}, systemProps, result);
    };
    else finalSx = (0, _extendsDefault.default)({}, systemProps, inSx);
    return (0, _extendsDefault.default)({}, otherProps, {
        sx: finalSx
    });
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@mui/utils/deepmerge":"lBRGq","./defaultSxConfig":"9YSCV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gVe4Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
'use client';
const systemDefaultTheme = (0, _createThemeDefault.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefaultDefault.default)(defaultTheme);
}
exports.default = useTheme;

},{"./createTheme":"8X8Lk","./useThemeWithoutDefault":"liJxj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8X8Lk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _shape = require("./shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _createSpacing = require("./createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _styleFunctionSx = require("../styleFunctionSx/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _defaultSxConfig = require("../styleFunctionSx/defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);
const _excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const breakpoints = (0, _createBreakpointsDefault.default)(breakpointsInput);
    const spacing = (0, _createSpacingDefault.default)(spacingInput);
    let muiTheme = (0, _deepmergeDefault.default)({
        breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, _extendsDefault.default)({
            mode: 'light'
        }, paletteInput),
        spacing,
        shape: (0, _extendsDefault.default)({}, (0, _shapeDefault.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, _applyStylesDefault.default);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _defaultSxConfigDefault.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@mui/utils/deepmerge":"lBRGq","./createBreakpoints":"6I4o6","./shape":"6rgm1","./createSpacing":"fPVVd","../styleFunctionSx/styleFunctionSx":"kOMd4","../styleFunctionSx/defaultSxConfig":"9YSCV","./applyStyles":"de4DV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6I4o6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpointKeys", ()=>breakpointKeys);
parcelHelpers.export(exports, "default", ()=>createBreakpoints);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "values",
    "unit",
    "step"
];
const breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, _extendsDefault.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = 'px', step = 5 } = breakpoints, other = (0, _objectWithoutPropertiesLooseDefault.default)(breakpoints, _excluded);
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, _extendsDefault.default)({
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit
    }, other);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6rgm1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shape = {
    borderRadius: 4
};
exports.default = shape;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fPVVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSpacing);
var _spacing = require("../spacing");
function createSpacing(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, _spacing.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

},{"../spacing":"5CIJZ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"de4DV":[function(require,module,exports,__globalThis) {
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyStyles);
function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"liJxj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _styledEngine = require("@mui/styled-engine");
'use client';
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = _react.useContext((0, _styledEngine.ThemeContext));
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
exports.default = useTheme;

},{"react":"IMRgT","@mui/styled-engine":"lH1pG","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ekeuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
exports.default = ClassNameGenerator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"XJRGA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMuiTheme", ()=>createMuiTheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _createTheme = require("@mui/system/createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _createPalette = require("./createPalette");
var _createPaletteDefault = parcelHelpers.interopDefault(_createPalette);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _createTransitions = require("./createTransitions");
var _createTransitionsDefault = parcelHelpers.interopDefault(_createTransitions);
var _zIndex = require("./zIndex");
var _zIndexDefault = parcelHelpers.interopDefault(_zIndex);
const _excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, _formatMuiErrorMessageDefault.default)(18));
    const palette = (0, _createPaletteDefault.default)(paletteInput);
    const systemTheme = (0, _createThemeDefault.default)(options);
    let muiTheme = (0, _deepmergeDefault.default)(systemTheme, {
        mixins: (0, _createMixinsDefault.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, _shadowsDefault.default).slice(),
        typography: (0, _createTypographyDefault.default)(palette, typographyInput),
        transitions: (0, _createTransitionsDefault.default)(transitionsInput),
        zIndex: (0, _extendsDefault.default)({}, (0, _zIndexDefault.default))
    });
    muiTheme = (0, _deepmergeDefault.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _styleFunctionSx.unstable_defaultSxConfig), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
    return createTheme(...args);
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@mui/utils/formatMuiErrorMessage":"2wzsQ","@mui/utils/deepmerge":"lBRGq","@mui/system/styleFunctionSx":[["default","kOMd4"],["unstable_defaultSxConfig","9YSCV","default"]],"@mui/system/createTheme":"8X8Lk","@mui/utils/generateUtilityClass":"iawj8","./createMixins":"ffk1t","./createPalette":"isqRr","./createTypography":"8jr9A","./shadows":"jcZIK","./createTransitions":"l438R","./zIndex":"aDQ0K","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iawj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassDefault.default));
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);

},{"./generateUtilityClass":"BZPn3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"BZPn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalStateClasses", ()=>globalStateClasses);
parcelHelpers.export(exports, "default", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _classNameGenerator = require("../ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
const globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, _classNameGeneratorDefault.default).generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"../ClassNameGenerator":"ekeuS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ffk1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createMixins);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function createMixins(breakpoints, mixins) {
    return (0, _extendsDefault.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"isqRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "light", ()=>light);
parcelHelpers.export(exports, "dark", ()=>dark);
parcelHelpers.export(exports, "default", ()=>createPalette);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _colorManipulator = require("@mui/system/colorManipulator");
var _common = require("../colors/common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _grey = require("../colors/grey");
var _greyDefault = parcelHelpers.interopDefault(_grey);
var _purple = require("../colors/purple");
var _purpleDefault = parcelHelpers.interopDefault(_purple);
var _red = require("../colors/red");
var _redDefault = parcelHelpers.interopDefault(_red);
var _orange = require("../colors/orange");
var _orangeDefault = parcelHelpers.interopDefault(_orange);
var _blue = require("../colors/blue");
var _blueDefault = parcelHelpers.interopDefault(_blue);
var _lightBlue = require("../colors/lightBlue");
var _lightBlueDefault = parcelHelpers.interopDefault(_lightBlue);
var _green = require("../colors/green");
var _greenDefault = parcelHelpers.interopDefault(_green);
const _excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, _commonDefault.default).white,
        default: (0, _commonDefault.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const dark = {
    text: {
        primary: (0, _commonDefault.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, _commonDefault.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _blueDefault.default)[200],
        light: (0, _blueDefault.default)[50],
        dark: (0, _blueDefault.default)[400]
    };
    return {
        main: (0, _blueDefault.default)[700],
        light: (0, _blueDefault.default)[400],
        dark: (0, _blueDefault.default)[800]
    };
}
function getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _purpleDefault.default)[200],
        light: (0, _purpleDefault.default)[50],
        dark: (0, _purpleDefault.default)[400]
    };
    return {
        main: (0, _purpleDefault.default)[500],
        light: (0, _purpleDefault.default)[300],
        dark: (0, _purpleDefault.default)[700]
    };
}
function getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _redDefault.default)[500],
        light: (0, _redDefault.default)[300],
        dark: (0, _redDefault.default)[700]
    };
    return {
        main: (0, _redDefault.default)[700],
        light: (0, _redDefault.default)[400],
        dark: (0, _redDefault.default)[800]
    };
}
function getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _lightBlueDefault.default)[400],
        light: (0, _lightBlueDefault.default)[300],
        dark: (0, _lightBlueDefault.default)[700]
    };
    return {
        main: (0, _lightBlueDefault.default)[700],
        light: (0, _lightBlueDefault.default)[500],
        dark: (0, _lightBlueDefault.default)[900]
    };
}
function getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _greenDefault.default)[400],
        light: (0, _greenDefault.default)[300],
        dark: (0, _greenDefault.default)[700]
    };
    return {
        main: (0, _greenDefault.default)[800],
        light: (0, _greenDefault.default)[500],
        dark: (0, _greenDefault.default)[900]
    };
}
function getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _orangeDefault.default)[400],
        light: (0, _orangeDefault.default)[300],
        dark: (0, _orangeDefault.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, _orangeDefault.default)[500],
        dark: (0, _orangeDefault.default)[900]
    };
}
function createPalette(palette) {
    const { mode = 'light', contrastThreshold = 3, tonalOffset = 0.2 } = palette, other = (0, _objectWithoutPropertiesLooseDefault.default)(palette, _excluded);
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = (0, _extendsDefault.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, _formatMuiErrorMessageDefault.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, _formatMuiErrorMessageDefault.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        addLightOrDark(color, 'light', lightShade, tonalOffset);
        addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark,
        light
    };
    const paletteOutput = (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        // A collection of common colors.
        common: (0, _extendsDefault.default)({}, (0, _commonDefault.default)),
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        (0, _greyDefault.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@mui/utils/formatMuiErrorMessage":"2wzsQ","@mui/utils/deepmerge":"lBRGq","@mui/system/colorManipulator":"exnBf","../colors/common":"36EWO","../colors/grey":"hSE4P","../colors/purple":"9BxyD","../colors/red":"6CoLc","../colors/orange":"do2jB","../colors/blue":"kSuAl","../colors/lightBlue":"1n10h","../colors/green":"4zy4X","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"exnBf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a73561c9993d7239");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alpha = alpha;
exports.blend = blend;
exports.colorChannel = void 0;
exports.darken = darken;
exports.decomposeColor = decomposeColor;
exports.emphasize = emphasize;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.hexToRgb = hexToRgb;
exports.hslToRgb = hslToRgb;
exports.lighten = lighten;
exports.private_safeAlpha = private_safeAlpha;
exports.private_safeColorChannel = void 0;
exports.private_safeDarken = private_safeDarken;
exports.private_safeEmphasize = private_safeEmphasize;
exports.private_safeLighten = private_safeLighten;
exports.recomposeColor = recomposeColor;
exports.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault(require("6cffbcaa55ae3b91"));
var _clamp = _interopRequireDefault(require("e0a90cc904ea55f0"));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
exports.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ exports.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"a73561c9993d7239":"3WFdk","6cffbcaa55ae3b91":"dLH4c","e0a90cc904ea55f0":"i0heV"}],"3WFdk":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"dLH4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formatMuiErrorMessageDefault.default));
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);

},{"./formatMuiErrorMessage":"2wzsQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i0heV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clampDefault.default));
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./clamp":"55BtF","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"55BtF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
exports.default = clamp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"36EWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const common = {
    black: '#000',
    white: '#fff'
};
exports.default = common;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hSE4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
exports.default = grey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9BxyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
exports.default = purple;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6CoLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
exports.default = red;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"do2jB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
exports.default = orange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kSuAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
exports.default = blue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1n10h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
exports.default = lightBlue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4zy4X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
exports.default = green;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8jr9A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createTypography);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
const _excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, _extendsDefault.default)({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === defaultFontFamily ? {
            letterSpacing: `${round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@mui/utils/deepmerge":"lBRGq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jcZIK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    'none',
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
exports.default = shadows;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l438R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easing", ()=>easing);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "default", ()=>createTransitions);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "duration",
    "easing",
    "delay"
];
const easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    const mergedEasing = (0, _extendsDefault.default)({}, easing, inputTransitions.easing);
    const mergedDuration = (0, _extendsDefault.default)({}, duration, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0 } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
    };
    return (0, _extendsDefault.default)({
        getAutoHeightDuration,
        create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aDQ0K":[function(require,module,exports,__globalThis) {
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
exports.default = zIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dL24M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '$$material';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jRfnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const boxClasses = (0, _generateUtilityClassesDefault.default)('MuiBox', [
    'root'
]);
exports.default = boxClasses;

},{"@mui/utils/generateUtilityClasses":"2uTku","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2uTku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClassDefault.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"../generateUtilityClass":"BZPn3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8bonu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootOverridesResolver", ()=>rootOverridesResolver);
parcelHelpers.export(exports, "inputOverridesResolver", ()=>inputOverridesResolver);
parcelHelpers.export(exports, "InputBaseRoot", ()=>InputBaseRoot);
parcelHelpers.export(exports, "InputBaseComponent", ()=>InputBaseComponent);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _isHostComponent = require("@mui/utils/isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
var _textareaAutosize = require("../TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _utils = require("./utils");
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, _capitalizeDefault.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _inputBaseClasses.getInputBaseUtilityClass), classes);
};
const InputBaseRoot = (0, _styledDefault.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const InputBaseComponent = (0, _styledDefault.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, _extendsDefault.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, _extendsDefault.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, _inputBaseClassesDefault.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const inputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ _react.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete, autoFocus, className, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, fullWidth = false, id, inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, slotProps = {}, slots = {}, startAdornment, type = 'text', value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef();
    const handleInputRefWarning = _react.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRefDefault.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = _react.useState(false);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    _react.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = _react.useCallback((obj)=>{
        if ((0, _utils.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessageDefault.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    _react.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, _extendsDefault.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, _extendsDefault.default)({
            type: undefined,
            maxRows,
            minRows
        }, inputProps);
        InputComponent = (0, _textareaAutosizeDefault.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    _react.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    });
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseComponent;
    inputProps = (0, _extendsDefault.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            !disableInjectingGlobalStyles && inputGlobalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _isHostComponentDefault.default)(Root) && {
                ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, _clsxDefault.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _extendsDefault.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, _isHostComponentDefault.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, _extendsDefault.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, _clsxDefault.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, _extendsDefault.default)({}, fcs, {
                        startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
exports.default = InputBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@babel/runtime/helpers/esm/extends":"lIuHI","@mui/utils/formatMuiErrorMessage":"2wzsQ","react":"IMRgT","prop-types":"iRwZ2","clsx":"jaUDM","@mui/utils/elementTypeAcceptingRef":"ak0Q4","@mui/utils/refType":"km7gO","@mui/utils/composeClasses":"56crA","@mui/utils/isHostComponent":"lSBrt","../TextareaAutosize":"8E2Bj","../FormControl/formControlState":"6X0qj","../FormControl/FormControlContext":"eGfS5","../FormControl/useFormControl":"c9Kcx","../styles/styled":"5H9bb","../DefaultPropsProvider":"7JmjS","../utils/capitalize":"9PE2I","../utils/useForkRef":"6YSKA","../utils/useEnhancedEffect":"9QTL4","../GlobalStyles":"21lJa","./utils":"8Axl5","./inputBaseClasses":"b5zKl","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jaUDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ak0Q4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementTypeAcceptingRefDefault.default));
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);

},{"./elementTypeAcceptingRef":"8uHSC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8uHSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
exports.default = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).elementType, elementTypeAcceptingRef);

},{"prop-types":"iRwZ2","../chainPropTypes":"aP4zO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aP4zO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>chainPropTypes);
function chainPropTypes(propType1, propType2) {
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"km7gO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _refTypeDefault.default));
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);

},{"./refType":"7Ieaa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7Ieaa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const refType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).object
]);
exports.default = refType;

},{"prop-types":"iRwZ2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"56crA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeClasses);
function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lSBrt":[function(require,module,exports,__globalThis) {
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isHostComponent(element) {
    return typeof element === 'string';
}
exports.default = isHostComponent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8E2Bj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function isEmpty(obj) {
    return isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const TextareaAutosize = /*#__PURE__*/ _react.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { current: isControlled } = _react.useRef(value != null);
    const textareaRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(forwardedRef, textareaRef);
    const heightRef = _react.useRef(null);
    const hiddenTextareaRef = _react.useRef(null);
    const calculateTextareaStyles = _react.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, _utils.unstable_ownerWindow)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, _utils.unstable_useEventCallback)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = _react.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = _react.useRef(-1);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const debouncedHandleResize = (0, _utils.unstable_debounce)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, _utils.unstable_ownerWindow)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", (0, _extendsDefault.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, _extendsDefault.default)({}, styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
exports.default = TextareaAutosize;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","react":"IMRgT","prop-types":"iRwZ2","@mui/utils":[["unstable_debounce","iJZzL","default"],["unstable_ownerWindow","3aBTf","default"],["unstable_useEnhancedEffect","k2kzg","default"],["unstable_useEventCallback","dAW7w","default"],["unstable_useForkRef","fscxW","default"]],"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iJZzL":[function(require,module,exports,__globalThis) {
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3aBTf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("../ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    const doc = (0, _ownerDocumentDefault.default)(node);
    return doc.defaultView || window;
}

},{"../ownerDocument":"7vROv","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7vROv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k2kzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
exports.default = useEnhancedEffect;

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dAW7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEnhancedEffect = require("../useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = _react.useRef(fn);
    (0, _useEnhancedEffectDefault.default)(()=>{
        ref.current = fn;
    });
    return _react.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
exports.default = useEventCallback;

},{"react":"IMRgT","../useEnhancedEffect":"k2kzg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fscxW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForkRef);
var _react = require("react");
var _setRef = require("../setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
'use client';
function useForkRef(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return _react.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, _setRefDefault.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"react":"IMRgT","../setRef":"1gT2l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1gT2l":[function(require,module,exports,__globalThis) {
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRef);
function setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6X0qj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formControlState);
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eGfS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = FormControlContext;

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c9Kcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormControl);
var _react = require("react");
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
'use client';
function useFormControl() {
    return _react.useContext((0, _formControlContextDefault.default));
}

},{"react":"IMRgT","./FormControlContext":"eGfS5","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5H9bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slotShouldForwardProp", ()=>(0, _slotShouldForwardPropDefault.default));
parcelHelpers.export(exports, "rootShouldForwardProp", ()=>(0, _rootShouldForwardPropDefault.default));
var _createStyled = require("@mui/system/createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _rootShouldForwardProp = require("./rootShouldForwardProp");
var _rootShouldForwardPropDefault = parcelHelpers.interopDefault(_rootShouldForwardProp);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
'use client';
const styled = (0, _createStyledDefault.default)({
    themeId: (0, _identifierDefault.default),
    defaultTheme: (0, _defaultThemeDefault.default),
    rootShouldForwardProp: (0, _rootShouldForwardPropDefault.default)
});
exports.default = styled;

},{"@mui/system/createStyled":"5ssDJ","./defaultTheme":"eVEBG","./identifier":"dL24M","./rootShouldForwardProp":"ipP76","./slotShouldForwardProp":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5ssDJ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("de1391ba5333f89c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyled;
exports.shouldForwardProp = shouldForwardProp;
exports.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault(require("b05e701df06cf2b8"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("1c23f895f04bb1f8"));
var _styledEngine = _interopRequireWildcard(require("474b747b46951daf"));
var _deepmerge = require("e7e859a1b9e6ab40");
var _capitalize = _interopRequireDefault(require("8202cda0a3f0a433"));
var _getDisplayName = _interopRequireDefault(require("ba8df200ce7809c8"));
var _createTheme = _interopRequireDefault(require("e9a196e78b4b1fc3"));
var _styleFunctionSx = _interopRequireDefault(require("60bc7d9f0f1dc713"));
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extends2.default)({
            ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, _extends2.default)({
                ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, _extends2.default)({
                    ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
            theme: resolveTheme((0, _extends2.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) return (props)=>{
                const theme = resolveTheme({
                    theme: props.theme,
                    defaultTheme,
                    themeId
                });
                return processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
                    theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
                        theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extends2.default)({}, props, {
                    theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"de1391ba5333f89c":"3WFdk","b05e701df06cf2b8":"iyGus","1c23f895f04bb1f8":"8IUYP","474b747b46951daf":"hcPbL","e7e859a1b9e6ab40":"4e83N","8202cda0a3f0a433":"jWXsb","ba8df200ce7809c8":"keFiS","e9a196e78b4b1fc3":"6dyOz","60bc7d9f0f1dc713":"e7tj6"}],"4e83N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deepmergeDefault.default));
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
parcelHelpers.exportAll(_deepmerge, exports);

},{"./deepmerge":"lBRGq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jWXsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _capitalizeDefault.default));
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);

},{"./capitalize":"1qSep","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"keFiS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getDisplayNameDefault.default));
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
parcelHelpers.exportAll(_getDisplayName, exports);

},{"./getDisplayName":"3IvDJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3IvDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "default", ()=>getDisplayName);
var _reactIs = require("react-is");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
    const match = `${fn}`.match(fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, _reactIs.Memo:
            return getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

},{"react-is":"1OsUp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1OsUp":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a620b46ed6d86cc0");

},{"a620b46ed6d86cc0":"9rLkX"}],"9rLkX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"6dyOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "private_createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "unstable_applyStyles", ()=>(0, _applyStylesDefault.default));
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);

},{"./createTheme":"8X8Lk","./createBreakpoints":"6I4o6","./applyStyles":"de4DV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e7tj6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "extendSxProp", ()=>(0, _extendSxPropDefault.default));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _defaultSxConfigDefault.default));
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _extendSxProp = require("./extendSxProp");
var _extendSxPropDefault = parcelHelpers.interopDefault(_extendSxProp);
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);

},{"./styleFunctionSx":"kOMd4","./extendSxProp":"cia9A","./defaultSxConfig":"9YSCV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eVEBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
'use client';
const defaultTheme = (0, _createThemeDefault.default)();
exports.default = defaultTheme;

},{"./createTheme":"XJRGA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ipP76":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
const rootShouldForwardProp = (prop)=>(0, _slotShouldForwardPropDefault.default)(prop) && prop !== 'classes';
exports.default = rootShouldForwardProp;

},{"./slotShouldForwardProp":"7WOKJ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7WOKJ":[function(require,module,exports,__globalThis) {
// copied from @mui/system/createStyled
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
exports.default = slotShouldForwardProp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7JmjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _defaultPropsProvider = require("@mui/system/DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultPropsProviderDefault.default), (0, _extendsDefault.default)({}, props));
}
exports.default = DefaultPropsProvider;
function useDefaultProps(params) {
    return (0, _defaultPropsProvider.useDefaultProps)(params);
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","prop-types":"iRwZ2","@mui/system/DefaultPropsProvider":"19s5N","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"19s5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const PropsContext = /*#__PURE__*/ _react.createContext(undefined);
function DefaultPropsProvider({ value, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropsContext.Provider, {
        value: value,
        children: children
    });
}
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, _resolvePropsDefault.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, _resolvePropsDefault.default)(config, props);
    return props;
}
function useDefaultProps({ props, name }) {
    const ctx = _react.useContext(PropsContext);
    return getThemeProps({
        props,
        name,
        theme: {
            components: ctx
        }
    });
}
exports.default = DefaultPropsProvider;

},{"react":"IMRgT","prop-types":"iRwZ2","@mui/utils/resolveProps":"jX46S","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jX46S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function resolveProps(defaultProps, props) {
    const output = (0, _extendsDefault.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, _extendsDefault.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, _extendsDefault.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9PE2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
exports.default = (0, _capitalizeDefault.default);

},{"@mui/utils/capitalize":"1qSep","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6YSKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
'use client';
exports.default = (0, _useForkRefDefault.default);

},{"@mui/utils/useForkRef":"fscxW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9QTL4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
'use client';
exports.default = (0, _useEnhancedEffectDefault.default);

},{"@mui/utils/useEnhancedEffect":"k2kzg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"21lJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _defaultTheme = require("../styles/defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.GlobalStyles), (0, _extendsDefault.default)({}, props, {
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    }));
}
exports.default = GlobalStyles;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","prop-types":"iRwZ2","@mui/system":[["GlobalStyles","jrO0q","default"]],"../styles/defaultTheme":"eVEBG","../styles/identifier":"dL24M","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jrO0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function wrapGlobalLayer(styles) {
    const serialized = (0, _styledEngine.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _useThemeDefault.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return wrapGlobalLayer(styleArg(resolvedTheme));
            return wrapGlobalLayer(styleArg);
        });
        else globalStyles = wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
        styles: globalStyles
    });
}
exports.default = GlobalStyles;

},{"react":"IMRgT","prop-types":"iRwZ2","@mui/styled-engine":[["GlobalStyles","1yVaZ","default"],["internal_serializeStyles","hcPbL"]],"../useTheme":"gVe4Z","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8Axl5":[function(require,module,exports,__globalThis) {
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasValue", ()=>hasValue);
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
parcelHelpers.export(exports, "isFilled", ()=>isFilled);
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
parcelHelpers.export(exports, "isAdornedStart", ()=>isAdornedStart);
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"b5zKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputBaseUtilityClass", ()=>getInputBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiInputBase', slot);
}
const inputBaseClasses = (0, _generateUtilityClassesDefault.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
exports.default = inputBaseClasses;

},{"@mui/utils/generateUtilityClasses":"2uTku","@mui/utils/generateUtilityClass":"BZPn3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hInB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/material-ui/api/no-ssr/)
 */ function NoSsr(props) {
    const { children, defer = false, fallback = null } = props;
    const [mountedState, setMountedState] = _react.useState(false);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    _react.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: mountedState ? children : fallback
    });
}
exports.default = NoSsr;

},{"react":"IMRgT","prop-types":"iRwZ2","@mui/utils":[["unstable_useEnhancedEffect","k2kzg","default"]],"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dYSDg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _getOverlayAlpha = require("../styles/getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _paperClasses = require("./paperClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paperClasses.getPaperUtilityClass), classes);
};
const PaperRoot = (0, _styledDefault.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$vars$overlays;
    return (0, _extendsDefault.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, _extendsDefault.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlphaDefault.default)(ownerState.elevation))}, ${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlphaDefault.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const Paper = /*#__PURE__*/ _react.forwardRef(function Paper(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className, component = 'div', elevation = 1, square = false, variant = 'elevation' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        elevation,
        square,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other));
});
exports.default = Paper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","prop-types":"iRwZ2","clsx":"jaUDM","@mui/utils/integerPropType":"cHfxX","@mui/utils/chainPropTypes":"7t4R3","@mui/utils/composeClasses":"56crA","@mui/system/colorManipulator":"exnBf","../styles/styled":"5H9bb","../styles/getOverlayAlpha":"cVwBi","../DefaultPropsProvider":"7JmjS","../styles/useTheme":"eSM0s","./paperClasses":"aw9H4","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cHfxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _integerPropTypeDefault.default));
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
parcelHelpers.exportAll(_integerPropType, exports);

},{"./integerPropType":"lsK0M","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lsK0M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypeByValue", ()=>getTypeByValue);
function getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !isInteger(propValue)) {
        const propType = getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
    return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
exports.default = validatorNoop;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7t4R3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chainPropTypesDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);

},{"./chainPropTypes":"aP4zO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cVwBi":[function(require,module,exports,__globalThis) {
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
exports.default = getOverlayAlpha;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eSM0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
'use client';
function useTheme() {
    const theme = (0, _system.useTheme)((0, _defaultThemeDefault.default));
    return theme[0, _identifierDefault.default] || theme;
}

},{"react":"IMRgT","@mui/system":[["useTheme","gVe4Z","default"]],"./defaultTheme":"eVEBG","./identifier":"dL24M","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aw9H4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaperUtilityClass", ()=>getPaperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPaper', slot);
}
const paperClasses = (0, _generateUtilityClassesDefault.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
exports.default = paperClasses;

},{"@mui/utils/generateUtilityClasses":"2uTku","@mui/utils/generateUtilityClass":"BZPn3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kegAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _svgIconClasses = require("./svgIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, _capitalizeDefault.default)(color)}`,
            `fontSize${(0, _capitalizeDefault.default)(fontSize)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _svgIconClasses.getSvgIconUtilityClass), classes);
};
const SvgIconRoot = (0, _styledDefault.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalizeDefault.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const SvgIcon = /*#__PURE__*/ _react.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children, className, color = 'inherit', component = 'svg', fontSize = 'medium', htmlColor, inheritViewBox = false, titleAccess, viewBox = '0 0 24 24' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const hasSvgAsChild = /*#__PURE__*/ _react.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
SvgIcon.muiName = 'SvgIcon';
exports.default = SvgIcon;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","react":"IMRgT","prop-types":"iRwZ2","clsx":"jaUDM","@mui/utils/composeClasses":"56crA","../utils/capitalize":"9PE2I","../DefaultPropsProvider":"7JmjS","../styles/styled":"5H9bb","./svgIconClasses":"9VB5X","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9VB5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSvgIconUtilityClass", ()=>getSvgIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiSvgIcon', slot);
}
const svgIconClasses = (0, _generateUtilityClassesDefault.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
exports.default = svgIconClasses;

},{"@mui/utils/generateUtilityClasses":"2uTku","@mui/utils/generateUtilityClass":"BZPn3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6Yb3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ThemeProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "theme"
];
function ThemeProvider(_ref) {
    let { theme: themeInput } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const scopedTheme = themeInput[0, _identifierDefault.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, _extendsDefault.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, _extendsDefault.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.ThemeProvider), (0, _extendsDefault.default)({}, props, {
        themeId: scopedTheme ? (0, _identifierDefault.default) : undefined,
        theme: finalTheme
    }));
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","react":"IMRgT","prop-types":"iRwZ2","@mui/system":[["ThemeProvider","3LrhH","default"]],"./identifier":"dL24M","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3LrhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _privateTheming = require("@mui/private-theming");
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _styledEngine = require("@mui/styled-engine");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _rtlProvider = require("../RtlProvider");
var _rtlProviderDefault = parcelHelpers.interopDefault(_rtlProvider);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);
var _useLayerOrder = require("./useLayerOrder");
var _useLayerOrderDefault = parcelHelpers.interopDefault(_useLayerOrder);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return _react.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, _extendsDefault.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, _extendsDefault.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, _extendsDefault.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefaultDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, _useLayerOrderDefault.default)(engineTheme);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateTheming.ThemeProvider), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.ThemeContext).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtlProviderDefault.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _defaultPropsProviderDefault.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","prop-types":"iRwZ2","@mui/private-theming":[["ThemeProvider","bx21X","default"],["useTheme","icBi5","default"]],"@mui/utils/exactProp":"28X2E","@mui/styled-engine":"lH1pG","../useThemeWithoutDefault":"liJxj","../RtlProvider":"8moSV","../DefaultPropsProvider":"19s5N","./useLayerOrder":"avkha","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bx21X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _themeContext = require("../useTheme/ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);
// To support composition of theme.
var _jsxRuntime = require("react/jsx-runtime");
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _useThemeDefault.default)();
    const theme = _react.useMemo(()=>{
        const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, _nestedDefault.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContextDefault.default).Provider, {
        value: theme,
        children: children
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","prop-types":"iRwZ2","@mui/utils":"8lLSv","../useTheme/ThemeContext":"8mcOB","../useTheme":"icBi5","./nested":"jSjVL","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8lLSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainPropTypes", ()=>(0, _chainPropTypesDefault.default));
parcelHelpers.export(exports, "deepmerge", ()=>(0, _deepmergeDefault.default));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _deepmerge.isPlainObject));
parcelHelpers.export(exports, "elementAcceptingRef", ()=>(0, _elementAcceptingRefDefault.default));
parcelHelpers.export(exports, "elementTypeAcceptingRef", ()=>(0, _elementTypeAcceptingRefDefault.default));
parcelHelpers.export(exports, "exactProp", ()=>(0, _exactPropDefault.default));
parcelHelpers.export(exports, "formatMuiErrorMessage", ()=>(0, _formatMuiErrorMessageDefault.default));
parcelHelpers.export(exports, "getDisplayName", ()=>(0, _getDisplayNameDefault.default));
parcelHelpers.export(exports, "HTMLElementType", ()=>(0, _htmlelementTypeDefault.default));
parcelHelpers.export(exports, "ponyfillGlobal", ()=>(0, _ponyfillGlobalDefault.default));
parcelHelpers.export(exports, "refType", ()=>(0, _refTypeDefault.default));
parcelHelpers.export(exports, "unstable_capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "unstable_createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "unstable_debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "unstable_deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "unstable_isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "unstable_ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "unstable_ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "unstable_requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "unstable_setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unstable_unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "unstable_useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "unstable_useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "unstable_useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "unstable_useLazyRef", ()=>(0, _useLazyRefDefault.default));
parcelHelpers.export(exports, "unstable_useTimeout", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "unstable_Timeout", ()=>(0, _useTimeout.Timeout));
parcelHelpers.export(exports, "unstable_useOnMount", ()=>(0, _useOnMountDefault.default));
parcelHelpers.export(exports, "unstable_useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_getScrollbarSize", ()=>(0, _getScrollbarSizeDefault.default));
parcelHelpers.export(exports, "unstable_detectScrollType", ()=>(0, _scrollLeft.detectScrollType));
parcelHelpers.export(exports, "unstable_getNormalizedScrollLeft", ()=>(0, _scrollLeft.getNormalizedScrollLeft));
parcelHelpers.export(exports, "usePreviousProps", ()=>(0, _usePreviousPropsDefault.default));
parcelHelpers.export(exports, "getValidReactChildren", ()=>(0, _getValidReactChildrenDefault.default));
parcelHelpers.export(exports, "visuallyHidden", ()=>(0, _visuallyHiddenDefault.default));
parcelHelpers.export(exports, "integerPropType", ()=>(0, _integerPropTypeDefault.default));
parcelHelpers.export(exports, "internal_resolveProps", ()=>(0, _resolvePropsDefault.default));
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _composeClassesDefault.default));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClassDefault.default));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
parcelHelpers.export(exports, "unstable_generateUtilityClasses", ()=>(0, _generateUtilityClassesDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _classNameGeneratorDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampDefault.default));
parcelHelpers.export(exports, "unstable_useSlotProps", ()=>(0, _useSlotPropsDefault.default));
parcelHelpers.export(exports, "unstable_resolveComponentProps", ()=>(0, _resolveComponentPropsDefault.default));
parcelHelpers.export(exports, "unstable_extractEventHandlers", ()=>(0, _extractEventHandlersDefault.default));
parcelHelpers.export(exports, "unstable_getReactElementRef", ()=>(0, _getReactElementRefDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _scrollLeft = require("./scrollLeft");
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
var _useSlotProps = require("./useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _resolveComponentProps = require("./resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _extractEventHandlers = require("./extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);
var _getReactElementRef = require("./getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./chainPropTypes":"aP4zO","./deepmerge":"lBRGq","./elementAcceptingRef":"cLFv8","./elementTypeAcceptingRef":"8uHSC","./exactProp":"jir9p","./formatMuiErrorMessage":"2wzsQ","./getDisplayName":"3IvDJ","./HTMLElementType":"l9U6S","./ponyfillGlobal":"ay9D0","./refType":"7Ieaa","./capitalize":"1qSep","./createChainedFunction":"7hwVp","./debounce":"iJZzL","./deprecatedPropType":"aPcbX","./isMuiElement":"jLQMh","./ownerDocument":"7vROv","./ownerWindow":"3aBTf","./requirePropFactory":"gZYu9","./setRef":"1gT2l","./useEnhancedEffect":"k2kzg","./useId":"7bPz1","./unsupportedProp":"aZEzY","./useControlled":"xE2ig","./useEventCallback":"dAW7w","./useForkRef":"fscxW","./useLazyRef":"i0gvx","./useTimeout":"ayG0E","./useOnMount":"f3Z0F","./useIsFocusVisible":"hQpEK","./getScrollbarSize":"5rbLk","./scrollLeft":"764fS","./usePreviousProps":"hqNQY","./getValidReactChildren":"2A4iw","./visuallyHidden":"7SHy4","./integerPropType":"lsK0M","./resolveProps":"jX46S","./composeClasses":"56crA","./generateUtilityClass":"iawj8","./generateUtilityClasses":"2uTku","./ClassNameGenerator":"ekeuS","./clamp":"55BtF","./useSlotProps":"lpkAy","./resolveComponentProps":"4QHOf","./extractEventHandlers":"lQc1s","./getReactElementRef":"duBqN","./types":"5lRec","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cLFv8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const elementAcceptingRef = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element.isRequired, acceptingRef);
exports.default = elementAcceptingRef;

},{"prop-types":"iRwZ2","../chainPropTypes":"aP4zO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jir9p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>exactProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l9U6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HTMLElementType);
function HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ay9D0":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7hwVp":[function(require,module,exports,__globalThis) {
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createChainedFunction);
function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aPcbX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deprecatedPropType);
function deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jLQMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMuiElement);
var _react = require("react");
function isMuiElement(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ _react.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gZYu9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requirePropFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7bPz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useId);
var _react = require("react");
'use client';
let globalId = 0;
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = _react.useState(idOverride);
    const id = idOverride || defaultId;
    _react.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = _react['useId'.toString()];
function useId(idOverride) {
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aZEzY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unsupportedProp);
function unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"xE2ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlled);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _react = require("react");
'use client';
function useControlled({ controlled, default: defaultProp, name, state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = _react.useRef(controlled !== undefined);
    const [valueState, setValue] = _react.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = _react.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i0gvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyRef);
var _react = require("react");
'use client';
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
    const ref = _react.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ayG0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeout", ()=>Timeout);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _useLazyRef = require("../useLazyRef/useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useOnMount = require("../useOnMount/useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
'use client';
class Timeout {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new Timeout();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function useTimeout() {
    const timeout = (0, _useLazyRefDefault.default)(Timeout.create).current;
    (0, _useOnMountDefault.default)(timeout.disposeEffect);
    return timeout;
}

},{"../useLazyRef/useLazyRef":"i0gvx","../useOnMount/useOnMount":"f3Z0F","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f3Z0F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnMount);
var _react = require("react");
'use client';
const EMPTY = [];
function useOnMount(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ _react.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hQpEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teardown", ()=>teardown);
parcelHelpers.export(exports, "default", ()=>useIsFocusVisible);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var _react = require("react");
var _useTimeout = require("../useTimeout/useTimeout");
'use client';
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new (0, _useTimeout.Timeout)();
const inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function focusTriggersKeyboardModality(node) {
    const { type, tagName } = node;
    if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function handlePointerDown() {
    hadKeyboardEvent = false;
}
function handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if (hadFocusVisibleRecently) hadKeyboardEvent = true;
    }
}
function prepare(doc) {
    doc.addEventListener('keydown', handleKeyDown, true);
    doc.addEventListener('mousedown', handlePointerDown, true);
    doc.addEventListener('pointerdown', handlePointerDown, true);
    doc.addEventListener('touchstart', handlePointerDown, true);
    doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
    doc.removeEventListener('keydown', handleKeyDown, true);
    doc.removeEventListener('mousedown', handlePointerDown, true);
    doc.removeEventListener('pointerdown', handlePointerDown, true);
    doc.removeEventListener('touchstart', handlePointerDown, true);
    doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
    const { target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
    const ref = _react.useCallback((node)=>{
        if (node != null) prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = _react.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if (isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref
    };
}

},{"react":"IMRgT","../useTimeout/useTimeout":"ayG0E","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5rbLk":[function(require,module,exports,__globalThis) {
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollbarSize);
function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"764fS":[function(require,module,exports,__globalThis) {
// Source from https://github.com/alitaheri/normalize-scroll-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */ parcelHelpers.export(exports, "detectScrollType", ()=>detectScrollType);
// Based on https://stackoverflow.com/a/24394376
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>getNormalizedScrollLeft);
let cachedType;
function detectScrollType() {
    if (cachedType) return cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return cachedType;
}
function getNormalizedScrollLeft(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = detectScrollType();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hqNQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
const usePreviousProps = (value)=>{
    const ref = _react.useRef({});
    _react.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePreviousProps;

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2A4iw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getValidReactChildren);
var _react = require("react");
function getValidReactChildren(children) {
    return _react.Children.toArray(children).filter((child)=>/*#__PURE__*/ _react.isValidElement(child));
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7SHy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
exports.default = visuallyHidden;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lpkAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useForkRef = require("../useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _appendOwnerState = require("../appendOwnerState");
var _appendOwnerStateDefault = parcelHelpers.interopDefault(_appendOwnerState);
var _mergeSlotProps = require("../mergeSlotProps");
var _mergeSlotPropsDefault = parcelHelpers.interopDefault(_mergeSlotProps);
var _resolveComponentProps = require("../resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
'use client';
const _excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false } = parameters, rest = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentPropsDefault.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotPropsDefault.default)((0, _extendsDefault.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, _useForkRefDefault.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, _appendOwnerStateDefault.default)(elementType, (0, _extendsDefault.default)({}, mergedProps, {
        ref
    }), ownerState);
    return props;
}
exports.default = useSlotProps;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","../useForkRef":"fscxW","../appendOwnerState":"0kXci","../mergeSlotProps":"5AVq0","../resolveComponentProps":"4QHOf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"0kXci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _isHostComponent = require("../isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponentDefault.default)(elementType)) return otherProps;
    return (0, _extendsDefault.default)({}, otherProps, {
        ownerState: (0, _extendsDefault.default)({}, otherProps.ownerState, ownerState)
    });
}
exports.default = appendOwnerState;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","../isHostComponent":"lSBrt","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5AVq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _extractEventHandlers = require("../extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);
var _omitEventHandlers = require("../omitEventHandlers");
var _omitEventHandlersDefault = parcelHelpers.interopDefault(_omitEventHandlers);
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsxDefault.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, _extendsDefault.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, _extendsDefault.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlersDefault.default)((0, _extendsDefault.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlersDefault.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlersDefault.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsxDefault.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, _extendsDefault.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, _extendsDefault.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}
exports.default = mergeSlotProps;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","clsx":"ayjcw","../extractEventHandlers":"lQc1s","../omitEventHandlers":"jNJVY","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ayjcw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lQc1s":[function(require,module,exports,__globalThis) {
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
exports.default = extractEventHandlers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jNJVY":[function(require,module,exports,__globalThis) {
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
exports.default = omitEventHandlers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4QHOf":[function(require,module,exports,__globalThis) {
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
exports.default = resolveComponentProps;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"duBqN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getReactElementRef);
var _react = require("react");
function getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt(_react.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5lRec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8mcOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const ThemeContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ThemeContext;

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"icBi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _themeContext = require("./ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
function useTheme() {
    const theme = _react.useContext((0, _themeContextDefault.default));
    return theme;
}

},{"react":"IMRgT","./ThemeContext":"8mcOB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jSjVL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
exports.default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"28X2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _exactPropDefault.default));
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);

},{"./exactProp":"jir9p","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8moSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRtl", ()=>useRtl);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "value"
];
const RtlContext = /*#__PURE__*/ _react.createContext();
function RtlProvider(_ref) {
    let { value } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, (0, _extendsDefault.default)({
        value: value != null ? value : true
    }, props));
}
const useRtl = ()=>{
    const value = _react.useContext(RtlContext);
    return value != null ? value : false;
};
exports.default = RtlProvider;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","react":"IMRgT","prop-types":"iRwZ2","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"avkha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLayerOrder);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
function useLayerOrder(theme) {
    const upperTheme = (0, _useThemeWithoutDefaultDefault.default)();
    const id = (0, _useIdDefault.default)() || '';
    const { modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, _useEnhancedEffectDefault.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
        styles: layerOrder
    });
}

},{"react":"IMRgT","@mui/utils/useEnhancedEffect":"k2kzg","@mui/utils/useId":"7bPz1","../GlobalStyles":"jrO0q","../useThemeWithoutDefault":"liJxj","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2yVQ8":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var ReactExports = require("e3cb921f47249eac");
var useSyncExternalStoreExports = require("1e8ad8cf8d3b3c90");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var didWarnAboutEqualityFn = false;
var identity = function identity(arg) {
    return arg;
};
function useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? vanilla.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var create = function create(createState) {
    return createState ? createImpl(createState) : createImpl;
};
var react = function(createState) {
    return create(createState);
};
exports.create = create;
exports.default = react;
exports.useStore = useStore;
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
module.exports = react;
module.exports.create = create;
module.exports.useStore = useStore;
module.exports.createStore = vanilla.createStore;
exports.default = module.exports;

},{"a19f4edd89926025":"kD8oa","e3cb921f47249eac":"IMRgT","1e8ad8cf8d3b3c90":"gSjS8"}],"kD8oa":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"gSjS8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"9D83g"}],"9D83g":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"IMRgT","5be634d856d1f9fa":"cl2XL"}],"9lZ8E":[function(require,module,exports,__globalThis) {
"use strict";
var deselectCurrent = require("b270149f26797c52");
var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = deselectCurrent();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = format("message" in options ? options.message : defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = copy;

},{"b270149f26797c52":"chctq"}],"chctq":[function(require,module,exports,__globalThis) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

},{}],"4XaXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithDropdown", ()=>WithDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useOutsideAlerter = require("../hooks/use_outside_alerter");
var _useOutsideAlerterDefault = parcelHelpers.interopDefault(_useOutsideAlerter);
function WithDropdown(props) {
    const [is_active, setIsActive] = (0, _react.useState)(false);
    const trigger_ref = (0, _react.useRef)(null);
    (0, _useOutsideAlerterDefault.default)(trigger_ref, ()=>setIsActive(false));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: trigger_ref,
        className: (0, _classnamesDefault.default)("dropdown", {
            "is-active": is_active
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-trigger",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "flex items-center gap-2",
                    "aria-haspopup": "true",
                    "aria-controls": "dropdown-menu",
                    onClick: ()=>setIsActive(true),
                    children: [
                        props.children,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "icon is-small",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-angle-down",
                                "aria-hidden": "true"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-menu w-min rounded-sm bg-base-light shadow-md",
                id: "dropdown-menu",
                role: "menu",
                children: props.items.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "dropdown-item w-full",
                        children: val
                    }, index))
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../hooks/use_outside_alerter":"d0yYg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cyL4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiscordEntitlement", ()=>DiscordEntitlement);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _constants = require("../../../../../../../common/constants");
var _seshRouter = require("../../../../sesh_router");
var _genericEntitlement = require("./generic_entitlement");
function DiscordEntitlement(props) {
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const activated_guild = guild_list.find((val)=>val.id === props.guildId);
    const is_one_time_purchase = props.sku_id === (0, _constants.Constants).DISCORD_ONE_TIME_PURCHASE_BUNDLE_SKU_ID || props.sku_id === (0, _constants.Constants).DISCORD_ONE_TIME_PURCHASE_SINGLE_SKU_ID;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericEntitlement.GenericEntitlement), {
        title: "Discord Premium",
        type: "Discord",
        payment_interval: is_one_time_purchase ? "one-time" : "monthly",
        modify_link: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
            className: "secondary-link",
            target: "_blank",
            href: (0, _constants.Constants).DISCORD_PREMIUM_MANAGEMENT_FAQ_LINK,
            children: [
                "Modify ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-external-link-alt"
                })
            ]
        }),
        details: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex w-full",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: is_one_time_purchase ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        "Activations Granted:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.sku_id === (0, _constants.Constants).DISCORD_ONE_TIME_PURCHASE_SINGLE_SKU_ID ? 1 : 3
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        "Server:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: activated_guild?.name ? `${activated_guild.name} (${props.guildId})` : props.guildId
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../../common/constants":"lLiun","../../../../sesh_router":"hfnpE","./generic_entitlement":"tOvUS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"tOvUS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenericEntitlement", ()=>GenericEntitlement);
var _jsxRuntime = require("react/jsx-runtime");
var _tag = require("../../base_components/tag");
function GenericEntitlement(props) {
    let icon;
    switch(props.type){
        case "Stripe":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fab fa-stripe fa-2x",
                title: "Stripe"
            });
            break;
        case "Patreon":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fab fa-patreon",
                title: "Patreon"
            });
            break;
        case "Discord":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fab fa-discord fa-lg",
                title: "discord"
            });
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-center gap-2 rounded-sm bg-base-light text-sm shadow-sm sm:flex-row sm:text-base",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center self-stretch bg-base-dark p-2 sm:min-w-[3.5rem] sm:justify-center sm:p-0",
                children: icon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full flex-col p-2 pt-0 pb-4 sm:p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "text-md mb-2 flex flex-wrap items-center gap-2 font-bold sm:text-lg",
                        children: [
                            props.title,
                            props.payment_interval && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                                type: "Dark",
                                children: props.payment_interval
                            }),
                            props.tag && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: props.tag
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ml-auto text-sm",
                                children: props.modify_link
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex w-full flex-col gap-4 sm:flex-row sm:text-base",
                        children: props.details
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../base_components/tag":"l4wGc","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9cNtY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StripeEntitlement", ()=>StripeEntitlement);
parcelHelpers.export(exports, "StripeEntitlementNoModifyButton", ()=>StripeEntitlementNoModifyButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../../../../common/common_utils");
var _premiumTiers = require("../../../../../../../common/premium_tiers");
var _genericEntitlement = require("./generic_entitlement");
function StripeEntitlement(props) {
    const product = (0, _premiumTiers.getRawProductWithoutPrices)(props.product_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericEntitlement.GenericEntitlement), {
        title: product.title,
        type: "Stripe",
        modify_link: props.payment_interval !== (0, _premiumTiers.PaymentInterval).OneTime ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            className: "secondary-link",
            to: (0, _commonUtils.common_utils).getStripeRedirectURL({
                type: "manager"
            }),
            children: "Modify"
        }) : undefined,
        payment_interval: (0, _premiumTiers.PaymentIntervalToActiveName)[props.payment_interval].toLowerCase(),
        details: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Activations Granted:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.activations
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Status:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.active_status
                        })
                    ]
                }),
                props.is_from_admin && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "From admin: ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: "true"
                        })
                    ]
                })
            ]
        })
    });
}
function StripeEntitlementNoModifyButton(props) {
    const product = (0, _premiumTiers.getRawProductWithoutPrices)(props.product_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericEntitlement.GenericEntitlement), {
        title: product.title,
        type: "Stripe",
        payment_interval: (0, _premiumTiers.PaymentIntervalToActiveName)[props.payment_interval].toLowerCase(),
        details: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Activations Granted:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.activations
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Status:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.active_status
                        })
                    ]
                }),
                props.is_from_admin && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "From admin: ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: "true"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"3XSn5","../../../../../../../common/common_utils":"gACUC","../../../../../../../common/premium_tiers":"NLcok","./generic_entitlement":"tOvUS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2d8Or":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminLogsViewer", ()=>AdminLogsViewer);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _logTypes = require("../../../../../../common/log_types");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _trpc = require("../../../utils/trpc");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _seshSearchForm = require("../base_components/sesh_search_form");
var _disabler = require("../disabler");
var _guildLogFilter = require("../guild_logs/guild_log_filter");
var _guildLogIcon = require("../guild_logs/guild_log_icon");
var _guildLogList = require("../guild_logs/guild_log_list");
var _guildLogPage = require("../guild_logs/guild_log_page");
var _guildLogTitle = require("../guild_logs/guild_log_title");
function AdminLogsViewer() {
    const [server_id, setServerId] = (0, _react.useState)(null);
    const [filter, setFilter] = (0, _react.useState)([]);
    const [fetch_date] = (0, _react.useState)(new Date());
    // Have to cast this to any because useInfiniteQuery only appears if we have strict mode enabled
    const logs_query = (0, _trpc.trpc).admin.viewGuildLogs.useInfiniteQuery({
        guild_id: server_id,
        from_before_ms: fetch_date.getTime(),
        filter
    }, {
        getNextPageParam: (lastPage)=>lastPage.next_page,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        enabled: !!server_id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-1/2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshSearchForm), {
                    onSubmit: (server_id)=>setServerId(server_id),
                    placeholder: "Server ID"
                })
            }),
            server_id && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                        disabled: logs_query.isFetching,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogFilter.FilterMenu), {
                            filter: filter,
                            setFilter: setFilter
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogList.GuildLogList), {
                        logs_query: logs_query,
                        logItemCreator: (log)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AdminLogItem, {
                                log: log
                            })
                    }, "LogsList")
                ]
            })
        ]
    });
}
function AdminLogItem(props) {
    const [is_showing_details, setShowDetails] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex cursor-pointer flex-col gap-0 border border-transparent bg-base-light hover:border-sesh-primary",
        onClick: ()=>setShowDetails(!is_showing_details),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full items-center gap-4 p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogIcon.LogIcon), {
                            log_type: props.log.type
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full min-w-0 flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex w-full min-w-0 flex-wrap items-center gap-4 text-xs text-sesh-dark sm:flex-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogTitle.GuildLogTitle), {
                                        log: props.log
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-auto flex-shrink-0",
                                        children: (0, _timeFormatUtils.time_format_utils).format_time_concise_date_first((0, _luxon.DateTime).fromJSDate(new Date(props.log.created_at)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4 text-sm font-bold sm:text-base",
                                children: [
                                    props.log.userId,
                                    " [",
                                    (0, _logTypes.LogType)[props.log.type],
                                    "]"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                        hide_arrow: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: is_showing_details ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-down"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-up"
                            })
                        }, is_showing_details.toString())
                    })
                ]
            }),
            is_showing_details && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogPage.DetailsPane), {
                log: props.log
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","../../../../../../common/log_types":"i2oOb","../../../../../../common/time_format_utils":"g0uQN","../../../utils/trpc":"dyYvM","../base_components/modify_settings_button":"kbhTg","../base_components/sesh_search_form":"lufGy","../disabler":"hF5sC","../guild_logs/guild_log_filter":"Runow","../guild_logs/guild_log_icon":"3j5Es","../guild_logs/guild_log_list":"kDtpU","../guild_logs/guild_log_page":"vqbLQ","../guild_logs/guild_log_title":"jKO5I","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i2oOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogType", ()=>LogType);
parcelHelpers.export(exports, "LogTypeGroups", ()=>LogTypeGroups);
var LogType = /*#__PURE__*/ function(LogType) {
    LogType[LogType["EventCreate"] = 0] = "EventCreate";
    LogType[LogType["EventEdit"] = 1] = "EventEdit";
    LogType[LogType["EventAddRSVP"] = 2] = "EventAddRSVP";
    LogType[LogType["EventRemoveRSVP"] = 3] = "EventRemoveRSVP";
    LogType[LogType["EventDelete"] = 4] = "EventDelete";
    LogType[LogType["PollCreate"] = 5] = "PollCreate";
    LogType[LogType["PollEdit"] = 6] = "PollEdit";
    LogType[LogType["PollAddOption"] = 7] = "PollAddOption";
    LogType[LogType["PollAddVote"] = 8] = "PollAddVote";
    LogType[LogType["PollRemoveVote"] = 9] = "PollRemoveVote";
    LogType[LogType["PollForceEnd"] = 10] = "PollForceEnd";
    LogType[LogType["PollDelete"] = 11] = "PollDelete";
    LogType[LogType["SettingsModify"] = 12] = "SettingsModify";
    LogType[LogType["SettingsPremiumModify"] = 13] = "SettingsPremiumModify";
    LogType[LogType["EventTemplateFavorite"] = 14] = "EventTemplateFavorite";
    LogType[LogType["EventTemplateUnfavorite"] = 15] = "EventTemplateUnfavorite";
    LogType[LogType["TimeFinderCreate"] = 16] = "TimeFinderCreate";
    LogType[LogType["TimeFinderEdit"] = 17] = "TimeFinderEdit";
    LogType[LogType["TimeFinderVote"] = 18] = "TimeFinderVote";
    LogType[LogType["TimeFinderDelete"] = 19] = "TimeFinderDelete";
    return LogType;
}({});
const LogTypeGroups = {
    Event: [
        2,
        0,
        4,
        1,
        3,
        14,
        15
    ],
    Poll: [
        5,
        11,
        6,
        10,
        8,
        9,
        7
    ],
    Settings: [
        12,
        13
    ],
    TimeFinder: [
        16,
        17,
        18,
        19
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"Runow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterMenu", ()=>FilterMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _logTypes = require("../../../../../../common/log_types");
var _disabler = require("../disabler");
const FilterTypes = [
    "All",
    ...Object.keys((0, _logTypes.LogTypeGroups))
];
function FilterMenu(props) {
    const [type, setType] = (0, _react.useState)("All");
    const [action, setAction] = (0, _react.useState)("All");
    const current_actions = (0, _logTypes.LogTypeGroups)[type] ?? [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ml-auto flex w-fit flex-col flex-wrap gap-2 text-sm sm:flex-row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: "Type:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InlineSelect, {
                        selected: type,
                        setSelected: (val)=>{
                            props.setFilter(val === "All" ? [] : [
                                ...(0, _logTypes.LogTypeGroups)[val]
                            ]);
                            setAction("All");
                            setType(val);
                        },
                        options: FilterTypes.map((val)=>({
                                value: val,
                                label: val
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                disabled: type === "All",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ml-auto flex gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: "Action:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(InlineSelect, {
                            selected: action === "All" ? "All" : (0, _logTypes.LogType)[action],
                            setSelected: (val)=>{
                                const is_all = val === "All";
                                props.setFilter(is_all ? [
                                    ...(0, _logTypes.LogTypeGroups)[type]
                                ] : [
                                    (0, _logTypes.LogType)[val]
                                ]);
                                setAction(is_all ? "All" : (0, _logTypes.LogType)[val]);
                            },
                            options: [
                                {
                                    value: "All",
                                    label: "All"
                                }
                            ].concat(current_actions.map((val)=>({
                                    value: (0, _logTypes.LogType)[val],
                                    label: (0, _logTypes.LogType)[val]
                                })))
                        })
                    ]
                })
            })
        ]
    });
}
function InlineSelect(props) {
    const select_ref = (0, _react.useRef)(null);
    const sizer_ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (select_ref.current && sizer_ref.current) {
            const selected_element = sizer_ref.current;
            select_ref.current.style.width = selected_element.getBoundingClientRect().width + "px";
        }
    }, [
        props.selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                ref: select_ref,
                className: "inline-dropdown",
                onChange: (e)=>{
                    props.setSelected(e.target.value);
                },
                value: props.selected,
                children: props.options.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: val.value,
                        children: val.label
                    }, val.value))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                id: "select-sizer",
                className: "inline-dropdown invisible absolute",
                ref: sizer_ref,
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    value: props.selected,
                    children: props.options.find((val)=>val.value === props.selected)?.label
                }, props.selected)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../common/log_types":"i2oOb","../disabler":"hF5sC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3j5Es":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogIcon", ()=>LogIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _logTypes = require("../../../../../../common/log_types");
const CreateIcons = [
    (0, _logTypes.LogType).EventCreate,
    (0, _logTypes.LogType).PollCreate,
    (0, _logTypes.LogType).TimeFinderCreate
];
const EditIcons = [
    (0, _logTypes.LogType).EventEdit,
    (0, _logTypes.LogType).PollEdit,
    (0, _logTypes.LogType).PollAddOption,
    (0, _logTypes.LogType).SettingsModify,
    (0, _logTypes.LogType).TimeFinderEdit
];
const DeleteIcons = [
    (0, _logTypes.LogType).EventDelete,
    (0, _logTypes.LogType).PollDelete,
    (0, _logTypes.LogType).TimeFinderDelete
];
const AddInteractionIcons = [
    (0, _logTypes.LogType).EventAddRSVP,
    (0, _logTypes.LogType).PollAddVote,
    (0, _logTypes.LogType).TimeFinderVote
];
const RemoveInteractionIcons = [
    (0, _logTypes.LogType).EventRemoveRSVP,
    (0, _logTypes.LogType).PollRemoveVote
];
const TemplateCreateIcons = [
    (0, _logTypes.LogType).EventTemplateFavorite
];
const TemplateDeleteIcons = [
    (0, _logTypes.LogType).EventTemplateUnfavorite
];
const EndInteractionIcons = [
    (0, _logTypes.LogType).PollForceEnd
];
const PremiumIcons = [
    (0, _logTypes.LogType).SettingsPremiumModify
];
function matchLogType(type, log_type) {
    return (0, _logTypes.LogTypeGroups)[type].includes(log_type);
}
function LogIcon(props) {
    const { log_type } = props;
    let primary_icon_class;
    let secondary_icon;
    if (matchLogType("Event", log_type)) primary_icon_class = "fas fa-calendar-day";
    else if (matchLogType("Poll", log_type)) primary_icon_class = "fas fa-poll-h";
    else if (matchLogType("Settings", log_type)) primary_icon_class = "fas fa-cog";
    else if (matchLogType("TimeFinder", log_type)) primary_icon_class = "fas fa-clock";
    if (CreateIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-plus-circle fa-sm"
    });
    else if (DeleteIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-ban fa-sm"
    });
    else if (AddInteractionIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-check-circle fa-sm"
    });
    else if (RemoveInteractionIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-times-circle fa-sm"
    });
    else if (EndInteractionIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-stop-circle fa-sm"
    });
    else if (EditIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditIcon, {});
    else if (PremiumIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PremiumIcon, {});
    else if (TemplateCreateIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddTemplateIcon, {});
    else if (TemplateDeleteIcons.includes(log_type)) secondary_icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(RemoveTemplateIcon, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative text-sesh-dark",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `${primary_icon_class} fa-2x text`
            }),
            secondary_icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `absolute left-5  top-5 inline-block rounded-[50%] bg-base-light p-[2px] leading-[0] `,
                children: secondary_icon
            })
        ]
    }, props.log_type);
}
function AddTemplateIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircledIcon, {
        font_awesome_class: "fas fa-star"
    });
}
function RemoveTemplateIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative h-[14px] w-[14px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `far fa-star absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `fas fa-slash absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`
            })
        ]
    }, "CircledIcon");
}
function EditIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircledIcon, {
        font_awesome_class: "fas fa-pen"
    });
}
function EditVoteIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative h-[14px] w-[14px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `fas fa-edit absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`
            })
        ]
    }, "CircledIcon");
}
function PremiumIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircledIcon, {
        font_awesome_class: "fas fa-crown"
    });
}
function CircledIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative h-[14px] w-[14px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `fas fa-circle absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: `${props.font_awesome_class} absolute left-1/2 top-1/2 !h-4/6 !w-4/6 -translate-x-1/2 -translate-y-1/2 text-base-light`
            })
        ]
    }, "CircledIcon");
}

},{"react/jsx-runtime":"dpQXr","../../../../../../common/log_types":"i2oOb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kDtpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogList", ()=>GuildLogList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactVirtual = require("@tanstack/react-virtual");
var _react = require("react");
var _removingThrobber = require("../../removing_throbber");
function GuildLogList(props) {
    const { isFetchingNextPage, hasNextPage, fetchNextPage, isFetching, isLoading, isRefetching } = props.logs_query;
    const logs = props.logs_query.data?.pages.flatMap((val)=>val.logs) ?? [];
    const parentRef = (0, _react.useRef)();
    const virtualizer = (0, _reactVirtual.useVirtualizer)({
        count: hasNextPage ? logs.length + 1 : logs.length,
        getScrollElement: ()=>parentRef.current,
        estimateSize: ()=>90,
        overscan: 3
    });
    (0, _react.useEffect)(()=>{
        const [lastItem] = [
            ...virtualizer.getVirtualItems()
        ].reverse();
        if (!lastItem) return;
        if (lastItem.index >= logs.length - 1 && hasNextPage && !isFetchingNextPage) fetchNextPage();
    }, [
        hasNextPage,
        fetchNextPage,
        logs.length,
        isFetchingNextPage,
        virtualizer.getVirtualItems()
    ]);
    // const is_initial_fetch = !(!isRefetching || isFetchingNextPage);
    const is_initial_fetch = isLoading || isRefetching && !isFetchingNextPage;
    if (is_initial_fetch) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "h-[500px]",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex h-full items-center gap-2",
                children: [
                    "Loading ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: parentRef,
        className: "h-[500px] w-full overflow-auto px-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                height: `${virtualizer.getTotalSize()}px`,
                width: "100%",
                position: "relative"
            },
            children: [
                virtualizer.getVirtualItems().map((virtualRow)=>{
                    const isLoaderRow = virtualRow.index > logs.length - 1;
                    const post = logs[virtualRow.index];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            transform: `translateY(${virtualRow.start}px)`
                        },
                        children: isLoaderRow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex h-full items-center gap-2",
                                children: [
                                    "Loading ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                                ]
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            "data-index": virtualRow.index,
                            ref: virtualizer.measureElement,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "pt-1",
                                    children: props.logItemCreator(post)
                                }),
                                !hasNextPage && virtualRow.index === logs.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                                    children: "End of Logs"
                                })
                            ]
                        })
                    }, virtualRow.index);
                }),
                !isFetching && logs.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlaceholderRow, {
                    children: "End of Logs"
                })
            ]
        })
    });
}
function PlaceholderRow(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pt-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col items-center justify-center gap-0 bg-base-light py-6 text-sesh-dark",
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@tanstack/react-virtual":"aXI26","react":"IMRgT","../../removing_throbber":"TmURk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"vqbLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogsPage", ()=>GuildLogsPage);
parcelHelpers.export(exports, "GuildLogsView", ()=>GuildLogsView);
parcelHelpers.export(exports, "DetailsPane", ()=>DetailsPane);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _commonUtils = require("../../../../../../common/common_utils");
var _dashboardUtils = require("../../../dashboard_utils");
var _newPageBlurb = require("../../../guild_settings/new_page_blurb");
var _trpc = require("../../../utils/trpc");
var _disableableLink = require("../base_components/disableable_link");
var _disabler = require("../disabler");
var _errorNote = require("../error_note");
var _useServerId = require("../hooks/use_server_id");
var _note = require("../note");
var _guildLogChannelSettingsPage = require("./guild_log_channel_settings_page");
var _guildLogFilter = require("./guild_log_filter");
var _guildLogItem = require("./guild_log_item");
var _guildLogList = require("./guild_log_list");
function GuildLogsPage(props) {
    const server_id = (0, _useServerId.useServerId)();
    // Have to cast this to any because useInfiniteQuery only appears if we have strict mode enabled
    const query = (0, _trpc.trpc).guild_logs.canView.useQuery({
        guild_id: server_id
    });
    if (!query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber()
    });
    if (query.data === false) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
        error: "You do not have permission to view this server's logs"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            !props.is_premium && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _note.Note), {
                children: [
                    "Non-premium servers can preview logs up to one day in the past. Get",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disableableLink.DisableableLink), {
                        to: (0, _commonUtils.common_utils).getPremiumPageURL(),
                        children: "Premium"
                    }),
                    " ",
                    "to view unlimited logs."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "server-settings-form",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newPageBlurb.NewPageBlurb), {
                    title: "Send Logs To Channel",
                    description: "Send logs to a channel",
                    onClick: ()=>props.renderOneOffPage(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogChannelSettingsPage.GuildLogChannelSettingsPage), {
                            is_premium: props.is_premium
                        })),
                    is_new: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildLogsView, {})
        ]
    });
}
function GuildLogsView() {
    const [filter, setFilter] = (0, _react.useState)([]);
    const server_id = (0, _useServerId.useServerId)();
    const [fetch_date] = (0, _react.useState)(new Date());
    // Have to cast this to any because useInfiniteQuery only appears if we have strict mode enabled
    const logs_query = (0, _trpc.trpc).guild_logs.get.useInfiniteQuery({
        guild_id: server_id,
        from_before_ms: fetch_date.getTime(),
        filter
    }, {
        getNextPageParam: (lastPage)=>lastPage.next_page,
        refetchOnWindowFocus: false,
        cacheTime: Infinity
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-1",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                    disabled: logs_query.isFetching,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogFilter.FilterMenu), {
                        filter: filter,
                        setFilter: setFilter
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogList.GuildLogList), {
                    logs_query: logs_query,
                    logItemCreator: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogItem.GuildLogItem), {
                            log: data
                        })
                }, "LogsList")
            ]
        })
    });
}
function DetailsPane(props) {
    const data = props.log.data;
    const items = Object.keys(data).map((key)=>{
        const value = data[key];
        const formattedValue = typeof value === "object" && value !== null ? JSON.stringify(value, null, 2) : JSON.stringify(value);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                key,
                ": ",
                formattedValue
            ]
        }, key);
    });
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col border-2 border-t-0 border-base-light bg-base-dark text-sm",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "px-4 py-2",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "date:",
                            " ",
                            props.log.created_at instanceof Date ? props.log.created_at.toString() : props.log.created_at ?? "unknown"
                        ]
                    }, "created_at"),
                    props.log.userId && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "user_id: ",
                            props.log.userId
                        ]
                    }, "user_id"),
                    props.log.channel_id && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "channel_id: ",
                            props.log.channel_id
                        ]
                    }, "channel_id"),
                    items
                ]
            })
        })
    });
    // @ts-ignore - React 18 type strictness workaround
    return content;
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../common/common_utils":"gACUC","../../../dashboard_utils":"jvA8A","../../../guild_settings/new_page_blurb":"aXQ8Q","../../../utils/trpc":"dyYvM","../base_components/disableable_link":"6Sjx5","../disabler":"hF5sC","../error_note":"kzA14","../hooks/use_server_id":"d0sLH","../note":"kkvHK","./guild_log_channel_settings_page":"gb4RE","./guild_log_filter":"Runow","./guild_log_item":"bRdkU","./guild_log_list":"kDtpU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aXQ8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewPageBlurb", ()=>NewPageBlurb);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../dashboard_utils");
function NewPageBlurb(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "field group cursor-pointer transition-all hover:!border-sesh-dark",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(props.title, props.description, false, false, false, undefined, false, props.is_new)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ml-auto text-xl text-sesh-primary transition-all group-hover:text-sesh-dark",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-chevron-right"
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gb4RE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogChannelSettingsPage", ()=>GuildLogChannelSettingsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _logTypes = require("../../../../../../common/log_types");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _boxItem = require("../box_item");
var _channelPicker = require("../channel_picker");
var _channelPickerDefault = parcelHelpers.interopDefault(_channelPicker);
var _disabler = require("../disabler");
var _useServerId = require("../hooks/use_server_id");
var _settingsBaseItem = require("../settings_items/settings_base_item");
var _settingsBooleanItem = require("../settings_items/settings_boolean_item");
function GuildLogChannelSettingsPage(props) {
    const server_id = (0, _useServerId.useServerId)();
    const query = (0, _trpc.trpc).guild_logs.getGuildLogChannelSettings.useQuery({
        guild_id: server_id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "title is-3 has-text-centered",
                children: "Log Channel Settings"
            }),
            !query.isSuccess && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber()
            }),
            query.isSuccess && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadedGuildLogChannelSettingsPage, {
                is_premium: props.is_premium,
                guild_log_channel_settings: query.data
            })
        ]
    });
}
function LoadedGuildLogChannelSettingsPage(props) {
    const server_id = (0, _useServerId.useServerId)();
    const trpcContext = (0, _trpc.trpc).useContext();
    const [enabled, setEnabled] = (0, _react.useState)(props.guild_log_channel_settings.guild_log_channel_id != null && props.is_premium);
    const [data, setData] = (0, _react.useState)(props.guild_log_channel_settings);
    const logTypes = Object.keys((0, _logTypes.LogType)).filter((item)=>{
        return isNaN(Number(item));
    }).map((val)=>(0, _logTypes.LogType)[val]);
    const mutation = (0, _trpc.trpc).guild_logs.setGuildLogChannel.useMutation({
        onSuccess: ()=>{
            trpcContext.guild_logs.getGuildLogChannelSettings.setData((val)=>{
                return {
                    ...val,
                    guild_log_channel_id: data.guild_log_channel_id,
                    guild_log_channel_disabled_messages: data.guild_log_channel_disabled_messages
                };
            }, {
                guild_id: server_id
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                disabled: !props.is_premium,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBooleanItem.SettingsBooleanItem), {
                    label: "Enable Channel Logging",
                    description: `${!props.is_premium ? "[Premium Only] " : ""}Enabling this will send all sesh related logs to a specific Discord channel`,
                    value: enabled,
                    is_loading: false,
                    onChange: ()=>{
                        setEnabled(!enabled);
                        mutation.mutate({
                            guild_id: server_id,
                            channel_id: null,
                            disabled_messages: data.guild_log_channel_disabled_messages
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                disabled: !enabled,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                            label: "Channel",
                            description: "",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex w-full flex-col gap-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelPickerDefault.default), {
                                    channel_id: data.guild_log_channel_id,
                                    setChannel: (val)=>setData((prev)=>({
                                                ...prev,
                                                guild_log_channel_id: val
                                            }))
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxItem.BoxItem), {
                            bgColor: "semidark",
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    title: "Events to Log",
                                    className: (0, _classnamesDefault.default)("overflow-hidden overflow-ellipsis font-bold md:text-lg"),
                                    children: "Events to Log"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-col gap-2",
                                    children: logTypes.map((logType)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    onChange: ()=>{
                                                        setData((prev)=>({
                                                                ...prev,
                                                                guild_log_channel_disabled_messages: {
                                                                    ...prev.guild_log_channel_disabled_messages,
                                                                    [logType]: !prev.guild_log_channel_disabled_messages?.[logType]
                                                                }
                                                            }));
                                                    },
                                                    checked: !data.guild_log_channel_disabled_messages?.[logType]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: (0, _logTypes.LogType)[logType]
                                                })
                                            ]
                                        }, logType))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            className: "w-fit",
                            disabled: !enabled,
                            is_loading: mutation.isLoading,
                            onClick: ()=>{
                                mutation.mutate({
                                    guild_id: server_id,
                                    channel_id: data.guild_log_channel_id,
                                    disabled_messages: data.guild_log_channel_disabled_messages
                                });
                            },
                            children: "Save"
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../../../../common/log_types":"i2oOb","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/sesh_primary_button":"3QyI2","../box_item":"gTVlB","../channel_picker":"c7Ywk","../disabler":"hF5sC","../hooks/use_server_id":"d0sLH","../settings_items/settings_base_item":"byg9r","../settings_items/settings_boolean_item":"eGiOr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bRdkU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogItem", ()=>GuildLogItem);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _guildLogIcon = require("./guild_log_icon");
var _guildLogText = require("./guild_log_text");
var _guildLogTitle = require("./guild_log_title");
var _guildLogPage = require("./guild_log_page");
function GuildLogItem(props) {
    const [is_showing_details, setShowDetails] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex cursor-pointer flex-col gap-0 border border-transparent bg-base-light hover:border-sesh-primary",
        onClick: ()=>setShowDetails(!is_showing_details),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full items-center gap-4 p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogIcon.LogIcon), {
                            log_type: props.log.type
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full min-w-0 flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex w-full min-w-0 flex-wrap items-center gap-4 text-xs text-content-secondary sm:flex-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogTitle.GuildLogTitle), {
                                        log: props.log
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-auto flex-shrink-0",
                                        children: (0, _timeFormatUtils.time_format_utils).format_time_concise_date_first((0, _luxon.DateTime).fromJSDate(new Date(props.log.created_at)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex items-center gap-4 text-sm sm:text-base",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogText.GuildLogText), {
                                    log: props.log,
                                    is_expanded: is_showing_details
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "text-content-primary",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: is_showing_details ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-up"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-down"
                            })
                        }, is_showing_details.toString())
                    })
                ]
            }),
            is_showing_details && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogPage.DetailsPane), {
                log: props.log
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","../../../../../../common/time_format_utils":"g0uQN","./guild_log_icon":"3j5Es","./guild_log_text":"eAvAo","./guild_log_title":"jKO5I","./guild_log_page":"vqbLQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eAvAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogText", ()=>GuildLogText);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _logTypes = require("../../../../../../common/log_types");
var _seshTypes = require("../../../../../../common/sesh_types");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _inlineEmoji = require("../inline_emoji");
var _anonymousNameWithAvatar = require("../member_display_name/anonymous_name_with_avatar");
var _anonymousNameWithAvatarDefault = parcelHelpers.interopDefault(_anonymousNameWithAvatar);
var _simpleMemberDisplayName = require("../member_display_name/simple_member_display_name");
var _simpleMemberDisplayNameDefault = parcelHelpers.interopDefault(_simpleMemberDisplayName);
function EventOrPollName(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-semibold",
        children: props.log.title
    });
}
function SimpleUserName(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-semibold",
        children: props.user_id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleMemberDisplayNameDefault.default), {
            user_id: props.user_id,
            include_avatar: props.hide_avatar ? false : true
        }) : "unknown"
    });
}
function PollOption(props) {
    let option = props.has_username_in_it ? props.log.option_name.replace(/ \[added by .*\]$/, "") : props.log.option_name;
    option = props.log.poll_type === (0, _seshTypes.PollType).Standard ? option : (0, _timeFormatUtils.time_format_utils).format_time_verbose_date_first((0, _luxon.DateTime).fromISO(option));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-mono font-semibold",
        children: option
    });
}
function RSVPOption(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "font-mono font-semibold",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
                option: {
                    emoji: props.log.option_emoji,
                    custom_emoji_data: props.log.option_is_custom ? {
                        animated: false,
                        id: props.log.option_emoji
                    } : undefined
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "ml-1 inline",
                children: props.log.option_name
            })
        ]
    });
}
function BoldedAnonymousName() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-semibold",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anonymousNameWithAvatarDefault.default), {})
    });
}
function TimeFinderAvailability(props) {
    if (props.log.user && props.log.user.availability && props.log.user.availability.length > 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-mono font-semibold",
        children: props.log.user.availability.map((availability, index)=>{
            const dateId = availability.id;
            const dateMs = availability.date_ms;
            if (!dateMs) return null;
            // Convert the milliseconds to a DateTime for formatting
            const dateTime = (0, _luxon.DateTime).fromMillis(dateMs);
            // Format date differently based on are_times_specified flag
            const formattedDate = props.log.are_times_specified ? (0, _timeFormatUtils.time_format_utils).format_time_verbose_date_first(dateTime) : dateTime.toUTC().toFormat("MM/dd/yyyy");
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    index > 0 && ", ",
                    formattedDate,
                    " as",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "uppercase",
                        children: availability.status
                    })
                ]
            }, dateId);
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-mono font-semibold",
        children: "availability updated"
    });
}
const LogText = {
    [(0, _logTypes.LogType).EventCreate]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " created an event"
            ]
        }),
    [(0, _logTypes.LogType).EventEdit]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " edited an event",
                " "
            ]
        }),
    [(0, _logTypes.LogType).EventDelete]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " deleted an event"
            ]
        }),
    [(0, _logTypes.LogType).EventAddRSVP]: (user_id, data)=>{
        if (data.initiator_id && data.initiator_id !== user_id) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " was RSVPed to",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSVPOption, {
                    log: data
                }),
                " by",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: data.initiator_id,
                    hide_avatar: true
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " RSVPed to",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSVPOption, {
                    log: data
                })
            ]
        });
    },
    [(0, _logTypes.LogType).EventRemoveRSVP]: (user_id, data)=>{
        if (data.initiator_id && data.initiator_id !== user_id) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                "'s RSVP for ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSVPOption, {
                    log: data
                }),
                " was removed by",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: data.initiator_id,
                    hide_avatar: true
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " removed their RSVP for",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSVPOption, {
                    log: data
                })
            ]
        });
    },
    [(0, _logTypes.LogType).EventTemplateFavorite]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " created an event template"
            ]
        }),
    [(0, _logTypes.LogType).EventTemplateUnfavorite]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " deleted an event template"
            ]
        }),
    [(0, _logTypes.LogType).PollCreate]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " created a poll"
            ]
        }),
    [(0, _logTypes.LogType).PollEdit]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " edited a poll"
            ]
        }),
    [(0, _logTypes.LogType).PollAddOption]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " added option",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PollOption, {
                    log: data,
                    has_username_in_it: true
                })
            ]
        }),
    [(0, _logTypes.LogType).PollDelete]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " deleted a poll"
            ]
        }),
    [(0, _logTypes.LogType).PollForceEnd]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " ended a poll"
            ]
        }),
    [(0, _logTypes.LogType).PollAddVote]: (user_id, data)=>{
        const name_element = data.is_anonymous === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoldedAnonymousName, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
            user_id: user_id
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                name_element,
                " voted for ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PollOption, {
                    log: data
                })
            ]
        });
    },
    [(0, _logTypes.LogType).PollRemoveVote]: (user_id, data)=>{
        const name_element = data.is_anonymous === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoldedAnonymousName, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
            user_id: user_id
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                name_element,
                " removed their vote for ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PollOption, {
                    log: data
                })
            ]
        });
    },
    [(0, _logTypes.LogType).TimeFinderCreate]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " created a time-finder poll"
            ]
        }),
    [(0, _logTypes.LogType).TimeFinderEdit]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " edited a time-finder poll"
            ]
        }),
    [(0, _logTypes.LogType).TimeFinderVote]: (user_id, data)=>{
        const name_element = data.is_anonymous ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoldedAnonymousName, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
            user_id: user_id
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                name_element,
                " marked availability for",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeFinderAvailability, {
                    log: data
                })
            ]
        });
    },
    [(0, _logTypes.LogType).TimeFinderDelete]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " deleted a time-finder poll"
            ]
        }),
    [(0, _logTypes.LogType).SettingsModify]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " modified the server's settings"
            ]
        }),
    [(0, _logTypes.LogType).SettingsPremiumModify]: (user_id, data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleUserName, {
                    user_id: user_id
                }),
                " ",
                data.is_activate ? "activated" : "deactivated",
                " premium"
            ]
        })
};
function GuildLogText(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)("inline-block w-full overflow-hidden overflow-ellipsis align-middle", {
            "whitespace-nowrap": !props.is_expanded,
            "whitespace-normal": props.is_expanded
        }),
        children: LogText[props.log.type](props.log.userId, props.log.data)
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","../../../../../../common/log_types":"i2oOb","../../../../../../common/sesh_types":"aUAOg","../../../../../../common/time_format_utils":"g0uQN","../inline_emoji":"39PEk","../member_display_name/anonymous_name_with_avatar":"6avhr","../member_display_name/simple_member_display_name":"hXYPB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6avhr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AnonymousNameWithAvatar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
function AnonymousNameWithAvatar() {
    // Create a random integer between 0 and 4
    const random = (0, _react.useRef)(Math.floor(Math.random() * 5));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "mr-1 inline-block align-text-bottom",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                    className: "image is-24x24 flex-shrink-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "is-rounded",
                        src: (0, _dashboardUtils.DashboardUtils).GetPlaceholderAvatarURL(random.current.toString(), 32),
                        width: 24,
                        height: 24
                    })
                })
            }),
            "Anonymous"
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jKO5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildLogTitle", ()=>GuildLogTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _logTypes = require("../../../../../../common/log_types");
const LogTitles = {
    [(0, _logTypes.LogType).SettingsModify]: "Server Settings",
    [(0, _logTypes.LogType).SettingsPremiumModify]: "Premium"
};
function GuildLogTitle(props) {
    let title = "";
    if ("title" in props.log.data) title = props.log.data.title;
    else title = LogTitles[props.log.type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "overflow-hidden overflow-ellipsis whitespace-nowrap text-sm font-bold",
        children: title
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../../../common/log_types":"i2oOb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hrdJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminSeshStats", ()=>AdminSeshStats);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshAddonInput = require("../base_components/sesh_addon_input");
var _simpleTable = require("../simple_table");
var _reactChartjs2 = require("react-chartjs-2");
var _chartJs = require("chart.js");
var _luxon = require("luxon");
var _seshSelectInput = require("../base_components/sesh_select_input");
(0, _chartJs.Chart).register((0, _chartJs.CategoryScale), (0, _chartJs.LinearScale), (0, _chartJs.PointElement), (0, _chartJs.LineElement), (0, _chartJs.Title), (0, _chartJs.Tooltip), (0, _chartJs.Legend));
const SortedHeadersRecord = {
    date: true,
    server_count: true,
    shard_count: true,
    total_user_count: true,
    total_event_count: true,
    future_event_count: true,
    poll_count: true,
    stripe_entitlement_count: true,
    discord_entitlement_count: true,
    patreon_count: true
};
const SortedHeaders = Object.keys(SortedHeadersRecord);
function AdminSeshStats() {
    const stats_query = (0, _trpc.trpc).admin.stats.useQuery();
    const [view, setView] = (0, _react.useState)("Graph");
    if (!stats_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    if (!stats_query.data[0]) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: "No data"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                value: view,
                setValue: setView,
                buttons: [
                    {
                        label: "Graph",
                        value: "Graph"
                    },
                    {
                        label: "Table",
                        value: "Table"
                    }
                ]
            }),
            view === "Table" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableView, {
                data: stats_query.data
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphView, {
                data: stats_query.data
            })
        ]
    });
}
function TableView(props) {
    const headers = SortedHeaders;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleTable.SimpleTable), {
        headers: headers,
        rows: props.data.map((val)=>headers.map((header)=>val.data[header]))
    });
}
function GraphView(props) {
    const headers = SortedHeaders.filter((val)=>val !== "date");
    const [tab, setTab] = (0, _react.useState)(headers[0]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSelectInput.SeshSelect), {
                value: {
                    label: tab,
                    value: tab
                },
                options: headers.map((val)=>({
                        label: val,
                        value: val
                    })),
                onChange: (new_value)=>{
                    setTab(new_value.value);
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Line), {
                options: {
                    scales: {
                        y: {
                            ticks: {
                                precision: 0
                            },
                            beginAtZero: true
                        }
                    }
                },
                data: {
                    labels: props.data.map((val)=>(0, _luxon.DateTime).fromISO(val.created).toLocaleString({
                            month: "short",
                            day: "2-digit",
                            year: "numeric"
                        })),
                    datasets: [
                        {
                            label: tab,
                            data: props.data.map((val)=>val.data[tab]),
                            borderColor: "#00f4ff",
                            backgroundColor: "#00f4ff",
                            pointBackgroundColor: "rgba(255, 0, 0, 0.0)",
                            pointBorderColor: "rgba(255, 0, 0, 0.0)",
                            tension: 0.1,
                            pointHitRadius: 50
                        }
                    ]
                }
            })
        ]
    });
}
function Tabs(props) {
    const tabs = [];
    for (const key of props.tabs)tabs.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        className: (0, _classnamesDefault.default)({
            "is-active bg-base-dark": props.tab === key
        }),
        onClick: ()=>props.setTab(key),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            className: "manual-link !bg-inherit",
            children: key
        })
    }, key));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "tabs is-boxed",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            children: tabs
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_addon_input":"pd6di","../simple_table":"8PgmR","react-chartjs-2":"zTGfZ","chart.js":"9KNHD","luxon":"fLWpi","../base_components/sesh_select_input":"8Vo8B","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8PgmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleTable", ()=>SimpleTable);
var _jsxRuntime = require("react/jsx-runtime");
function SimpleTable(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "h-[36rem] overflow-x-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "sesh-table relative",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                        children: props.headers.map((header, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "sticky top-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex",
                                    style: {
                                        width: props.widths?.[index] ?? undefined
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "",
                                        children: header
                                    })
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: props.rows.map((row, p_index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                            children: row.map((el, c_index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    title: typeof el === "string" ? el : undefined,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-24 overflow-hidden overflow-ellipsis",
                                        children: el
                                    })
                                }, c_index))
                        }, p_index))
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"zTGfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
parcelHelpers.export(exports, "Bubble", ()=>Bubble);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Doughnut", ()=>Doughnut);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Pie", ()=>Pie);
parcelHelpers.export(exports, "PolarArea", ()=>PolarArea);
parcelHelpers.export(exports, "Radar", ()=>Radar);
parcelHelpers.export(exports, "Scatter", ()=>Scatter);
parcelHelpers.export(exports, "getDatasetAtEvent", ()=>getDatasetAtEvent);
parcelHelpers.export(exports, "getElementAtEvent", ()=>getElementAtEvent);
parcelHelpers.export(exports, "getElementsAtEvent", ()=>getElementsAtEvent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _chartJs = require("chart.js");
const defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function ChartComponent(props, ref) {
    const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
    const canvasRef = (0, _react.useRef)(null);
    const chartRef = (0, _react.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, _chartJs.Chart)(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && options) setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current) setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, _react.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const Chart = /*#__PURE__*/ (0, _react.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
    (0, _chartJs.Chart).register(registerables);
    return /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Chart, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const Line = /* #__PURE__ */ createTypedChart("line", (0, _chartJs.LineController));
const Bar = /* #__PURE__ */ createTypedChart("bar", (0, _chartJs.BarController));
const Radar = /* #__PURE__ */ createTypedChart("radar", (0, _chartJs.RadarController));
const Doughnut = /* #__PURE__ */ createTypedChart("doughnut", (0, _chartJs.DoughnutController));
const PolarArea = /* #__PURE__ */ createTypedChart("polarArea", (0, _chartJs.PolarAreaController));
const Bubble = /* #__PURE__ */ createTypedChart("bubble", (0, _chartJs.BubbleController));
const Pie = /* #__PURE__ */ createTypedChart("pie", (0, _chartJs.PieController));
const Scatter = /* #__PURE__ */ createTypedChart("scatter", (0, _chartJs.ScatterController));

},{"react":"IMRgT","chart.js":"9KNHD","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9KNHD":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersSegmentJs.aL));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersSegmentJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _helpersSegmentJs = require("./chunks/helpers.segment.js");
var _color = require("@kurkle/color");
class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersSegmentJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();
const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, _helpersSegmentJs.c)(from || transparent);
        const c1 = c0.valid && (0, _helpersSegmentJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, _helpersSegmentJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, _helpersSegmentJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersSegmentJs.e)[cfg.easing] || (0, _helpersSegmentJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersSegmentJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersSegmentJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, _helpersSegmentJs.i)(config)) return;
        const animationOptions = Object.keys((0, _helpersSegmentJs.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, _helpersSegmentJs.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, _helpersSegmentJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if ((0, _helpersSegmentJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersSegmentJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersSegmentJs.s)(value) === (0, _helpersSegmentJs.s)(otherValue))) value += otherValue;
    }
    return value;
}
function convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min, max, minDefined, maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale, vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, _helpersSegmentJs.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, _helpersSegmentJs.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, _helpersSegmentJs.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, _helpersSegmentJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, _helpersSegmentJs.i)(data)) this._data = convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, _helpersSegmentJs.u)(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersSegmentJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale, _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersSegmentJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersSegmentJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersSegmentJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersSegmentJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, _helpersSegmentJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersSegmentJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip((0, _helpersSegmentJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, _helpersSegmentJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, _helpersSegmentJs.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersSegmentJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersSegmentJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, _helpersSegmentJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersSegmentJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersSegmentJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start, end, reverse, top, bottom } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersSegmentJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersSegmentJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale, vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index, _cachedMeta: { vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, _helpersSegmentJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersSegmentJs.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersSegmentJs.s)(value) !== (0, _helpersSegmentJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, _helpersSegmentJs.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, _helpersSegmentJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, _helpersSegmentJs.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class BubbleController extends DatasetController {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, _helpersSegmentJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, _helpersSegmentJs.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, _helpersSegmentJs.H), startY, endY);
        const minX = calcMin((0, _helpersSegmentJs.P), startX, endX);
        const minY = calcMin((0, _helpersSegmentJs.P) + (0, _helpersSegmentJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, _helpersSegmentJs.i)(data[start])) {
                const { key = 'value' } = this._parsing;
                getter = (i)=>+(0, _helpersSegmentJs.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersSegmentJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersSegmentJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, _helpersSegmentJs.T);
        let max = -(0, _helpersSegmentJs.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, _helpersSegmentJs.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference, rotation } = this._getRotationExtents();
        const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, _helpersSegmentJs.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersSegmentJs.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersSegmentJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersSegmentJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersSegmentJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class LineController extends DatasetController {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class PolarAreaController extends DatasetController {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersSegmentJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersSegmentJs.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersSegmentJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class PieController extends DoughnutController {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class RadarController extends DatasetController {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class ScatterController extends DatasetController {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    const { controller, data, _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, _helpersSegmentJs.A) : (0, _helpersSegmentJs.B);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index, data } = metasets[i];
        const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersSegmentJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle, endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle } = (0, _helpersSegmentJs.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, _helpersSegmentJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack, stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack, pos, stackWeight } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth, hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos, box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, _helpersSegmentJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same, other } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x, y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, _helpersSegmentJs.h)(stack.start)) y = stack.start;
            if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, _helpersSegmentJs.h)(stack.start)) x = stack.start;
            if (box.fullSize) setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, _helpersSegmentJs.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, _helpersSegmentJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersSegmentJs.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersSegmentJs.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, _helpersSegmentJs.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, _helpersSegmentJs.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const eventListenerOptions = (0, _helpersSegmentJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x, y } = (0, _helpersSegmentJs.z)(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, _helpersSegmentJs.I)(canvas);
    if (!container) return;
    const resize = (0, _helpersSegmentJs.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, _helpersSegmentJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, _helpersSegmentJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersSegmentJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, _helpersSegmentJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersSegmentJs.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersSegmentJs.x)(this.x) && (0, _helpersSegmentJs.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, _helpersSegmentJs.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, _helpersSegmentJs.v)(majorStart, 0);
    const end = Math.min((0, _helpersSegmentJs.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersSegmentJs.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, _helpersSegmentJs.a0)(options.font, fallback);
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    const lines = (0, _helpersSegmentJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersSegmentJs.j)(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersSegmentJs.j)(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    let ret = (0, _helpersSegmentJs.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top, left, bottom, right, chart } = scale;
    const { chartArea, scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersSegmentJs.a2)(align, left, right);
        if ((0, _helpersSegmentJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersSegmentJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, _helpersSegmentJs.H) : (0, _helpersSegmentJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
        _userMin = (0, _helpersSegmentJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersSegmentJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersSegmentJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersSegmentJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersSegmentJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersSegmentJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersSegmentJs.g)(_userMin),
            maxDefined: (0, _helpersSegmentJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersSegmentJs.O)(min, (0, _helpersSegmentJs.O)(max, min)),
            max: (0, _helpersSegmentJs.O)(max, (0, _helpersSegmentJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero, grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersSegmentJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersSegmentJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersSegmentJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, _helpersSegmentJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersSegmentJs.U)(Math.min(Math.asin((0, _helpersSegmentJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersSegmentJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersSegmentJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersSegmentJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first, last, widest, highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, _helpersSegmentJs.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align, padding }, position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersSegmentJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis, position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersSegmentJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersSegmentJs.k)(label) && !(0, _helpersSegmentJs.b)(label)) {
                width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersSegmentJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersSegmentJs.k)(nestedLabel) && !(0, _helpersSegmentJs.b)(nestedLabel)) {
                    width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, _helpersSegmentJs.W)(this._alignToPixels ? (0, _helpersSegmentJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min, max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, _helpersSegmentJs.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid, position, border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, _helpersSegmentJs.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, _helpersSegmentJs.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersSegmentJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align, crossAlign, padding, mirror } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersSegmentJs.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position, ticks } = this.options;
        const rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position, ticks: { crossAlign, mirror, padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx, options: { backgroundColor }, left, top, width, height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart, ctx, options: { border, grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersSegmentJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersSegmentJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersSegmentJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersSegmentJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, _helpersSegmentJs.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, _helpersSegmentJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, _helpersSegmentJs.$)(ctx);
    }
    drawTitle() {
        const { ctx, options: { position, title, reverse } } = this;
        if (!title.display) return;
        const font = (0, _helpersSegmentJs.a0)(title.font);
        const padding = (0, _helpersSegmentJs.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, _helpersSegmentJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersSegmentJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
        (0, _helpersSegmentJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, _helpersSegmentJs.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, _helpersSegmentJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersSegmentJs.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersSegmentJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersSegmentJs.d)[scope]) {
            delete (0, _helpersSegmentJs.d)[scope][id];
            if (this.override) delete (0, _helpersSegmentJs.a3)[id];
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, _helpersSegmentJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersSegmentJs.d).get(parentScope) : {},
        (0, _helpersSegmentJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersSegmentJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersSegmentJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, _helpersSegmentJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersSegmentJs.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, _helpersSegmentJs.a5)(method);
        (0, _helpersSegmentJs.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, _helpersSegmentJs.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, _helpersSegmentJs.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersSegmentJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, _helpersSegmentJs.v)(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    const datasetDefaults = (0, _helpersSegmentJs.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = (0, _helpersSegmentJs.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, _helpersSegmentJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersSegmentJs.d).scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersSegmentJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = (0, _helpersSegmentJs.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersSegmentJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, _helpersSegmentJs.ab)(scale, [
            (0, _helpersSegmentJs.d).scales[scale.type],
            (0, _helpersSegmentJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, _helpersSegmentJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = (0, _helpersSegmentJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options, type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options, type } = this;
        return [
            options,
            (0, _helpersSegmentJs.a3)[type] || {},
            (0, _helpersSegmentJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersSegmentJs.d),
            (0, _helpersSegmentJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersSegmentJs.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersSegmentJs.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
        return (0, _helpersSegmentJs.i)(context) ? (0, _helpersSegmentJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, _helpersSegmentJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>(0, _helpersSegmentJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersSegmentJs.a7)(value[key]));
function needContext(proxy, names) {
    const { isScriptable, isIndexable } = (0, _helpersSegmentJs.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, _helpersSegmentJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersSegmentJs.b)(value)) return true;
    }
    return false;
}
var version = "4.4.1";
const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersSegmentJs.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale, yScale } = meta;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, 'left'),
        right: getSizeForArea(xScale, chartArea, 'right'),
        top: getSizeForArea(yScale, chartArea, 'top'),
        bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
class Chart {
    static defaults = (0, _helpersSegmentJs.d);
    static instances = instances;
    static overrides = (0, _helpersSegmentJs.a3);
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, _helpersSegmentJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersSegmentJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
        if (!(0, _helpersSegmentJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, _helpersSegmentJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, _helpersSegmentJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersSegmentJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, _helpersSegmentJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, _helpersSegmentJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, _helpersSegmentJs.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = (0, _helpersSegmentJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersSegmentJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersSegmentJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType, dataElementType } = (0, _helpersSegmentJs.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersSegmentJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersSegmentJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active, _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersSegmentJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, _helpersSegmentJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method, start, count } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, _helpersSegmentJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersSegmentJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, _helpersSegmentJs.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width, height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = getDatasetArea(meta, this.chartArea);
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, _helpersSegmentJs.Y)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, _helpersSegmentJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, _helpersSegmentJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersSegmentJs.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersSegmentJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas, ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersSegmentJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersSegmentJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersSegmentJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersSegmentJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, _helpersSegmentJs.ai)(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersSegmentJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersSegmentJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return (0, _helpersSegmentJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
    const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersSegmentJs.H), startAngle - (0, _helpersSegmentJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersSegmentJs.ak)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersSegmentJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersSegmentJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersSegmentJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x, y, startAngle: start, pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersSegmentJs.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersSegmentJs.H));
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, _helpersSegmentJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersSegmentJs.H));
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, _helpersSegmentJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference, options } = element;
    const { borderWidth, borderJoinStyle, borderDash, borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle, distance } = (0, _helpersSegmentJs.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, _helpersSegmentJs.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.p)(angle, startAngle, endAngle);
        const withinRadius = (0, _helpersSegmentJs.aj)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset, spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options, circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersSegmentJs.T) ? Math.floor(circumference / (0, _helpersSegmentJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, _helpersSegmentJs.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, _helpersSegmentJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersSegmentJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersSegmentJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersSegmentJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersSegmentJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersSegmentJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ar;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersSegmentJs.as;
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    const { points, options } = line;
    const { count, start, loop, ilen } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move = true, reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count, start, ilen } = pathVars(points, segment, params);
    const { move = true, reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ao;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersSegmentJs.ap;
    return 0, _helpersSegmentJs.aq;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments, options } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersSegmentJs.al)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersSegmentJs.am)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, _helpersSegmentJs.an)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start, end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersSegmentJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersSegmentJs.at)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function getBarBounds(bar, useFinalPosition) {
    const { x, y, base, width, height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersSegmentJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, _helpersSegmentJs.av)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, _helpersSegmentJs.aw)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, _helpersSegmentJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersSegmentJs.aj)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersSegmentJs.aj)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount, options: { borderColor, backgroundColor } } = this;
        const { inner, outer } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? (0, _helpersSegmentJs.au) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, base, horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
const BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets }, options: chartOptions } = chart.config;
        const { elements } = chartOptions;
        if (!options.forceOverride && (containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements))) return;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, _helpersSegmentJs.k)(minIndex) && !(0, _helpersSegmentJs.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale } = meta;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data, indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, _helpersSegmentJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersSegmentJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start, end } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, _helpersSegmentJs.an)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, _helpersSegmentJs.ax)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, _helpersSegmentJs.ay)(start);
        end = (0, _helpersSegmentJs.ay)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x = null, y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start, end })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, _helpersSegmentJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersSegmentJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    const fill = parseFillOption(line);
    if ((0, _helpersSegmentJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, _helpersSegmentJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, _helpersSegmentJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersSegmentJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, _helpersSegmentJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    const { scale, index, line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first, last, point } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, _helpersSegmentJs.aj)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x, y, radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersSegmentJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x, y, radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}
function _getTarget(source) {
    const { chart, fill, line } = source;
    if ((0, _helpersSegmentJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale = {}, fill } = source;
    const pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersSegmentJs.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale, fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { line, scale, axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above = color, below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, _helpersSegmentJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis
        });
        (0, _helpersSegmentJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line, target, above, below, area, scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line, target, property, color, scale } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src, target: tgt, start, end } of segments){
        const { style: { backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, bounds) {
    const { top, bottom } = scale.chart.chartArea;
    const { property, start, end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, _helpersSegmentJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options, ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx, maxWidth, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx, maxHeight, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
        const rtlHelper = (0, _helpersSegmentJs.az)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, _helpersSegmentJs.Y)(ctx, this);
            this._draw();
            (0, _helpersSegmentJs.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes, lineWidths, ctx } = this;
        const { align, labels: labelOpts } = opts;
        const defaultColor = (0, _helpersSegmentJs.d).color;
        const rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        const labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        const { padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, _helpersSegmentJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersSegmentJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersSegmentJs.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, _helpersSegmentJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersSegmentJs.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersSegmentJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersSegmentJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, _helpersSegmentJs.aD)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, _helpersSegmentJs.aw)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersSegmentJs.au)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, _helpersSegmentJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersSegmentJs.aA)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersSegmentJs.aB)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersSegmentJs.aC)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersSegmentJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersSegmentJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, _helpersSegmentJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersSegmentJs.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersSegmentJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, _helpersSegmentJs.aj)(x, this.left, this.right) && (0, _helpersSegmentJs.aj)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersSegmentJs.aj)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersSegmentJs.aj)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersSegmentJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersSegmentJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersSegmentJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle, pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, _helpersSegmentJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class Title extends Element {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, _helpersSegmentJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersSegmentJs.E)(opts.padding);
        const textSize = lineCount * (0, _helpersSegmentJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top, left, bottom, right, options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersSegmentJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
                rotation = (0, _helpersSegmentJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersSegmentJs.a2)(align, top, bottom);
                rotation = (0, _helpersSegmentJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, _helpersSegmentJs.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
        (0, _helpersSegmentJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersSegmentJs.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, _helpersSegmentJs.aE)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersSegmentJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    const { element, datasetIndex, index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label, value } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body, footer, title } = tooltip;
    const { boxWidth, boxHeight } = options;
    const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
    const titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
    const footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersSegmentJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersSegmentJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersSegmentJs.F)(body, (bodyItem)=>{
        (0, _helpersSegmentJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersSegmentJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y, height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x, width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    const { x, width } = size;
    const { width: chartWidth, chartArea: { left, right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x, width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y, height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize, caretPadding, cornerRadius } = options;
    const { xAlign, yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersSegmentJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersSegmentJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersSegmentJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: (0, _helpersSegmentJs.aF),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, _helpersSegmentJs.aF),
    beforeBody: (0, _helpersSegmentJs.aF),
    beforeLabel: (0, _helpersSegmentJs.aF),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, _helpersSegmentJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersSegmentJs.aF),
    afterBody: (0, _helpersSegmentJs.aF),
    beforeFooter: (0, _helpersSegmentJs.aF),
    footer: (0, _helpersSegmentJs.aF),
    afterFooter: (0, _helpersSegmentJs.aF)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks } = options;
        const bodyItems = [];
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign, yAlign } = this;
        const { caretSize, cornerRadius } = options;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width, height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight, boxWidth } = options;
        const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersSegmentJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, _helpersSegmentJs.aw)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersSegmentJs.au)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersSegmentJs.au)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body } = this;
        const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
        const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersSegmentJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersSegmentJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersSegmentJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersSegmentJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign, yAlign } = this;
        const { x, y } = pt;
        const { width, height } = tooltipSize;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, _helpersSegmentJs.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersSegmentJs.aA)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersSegmentJs.aC)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersSegmentJs.ah)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, _helpersSegmentJs.ah)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX, caretY, options } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : (0, _helpersSegmentJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index, label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersSegmentJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, _helpersSegmentJs.k)(min);
    const maxDefined = !(0, _helpersSegmentJs.k)(max);
    const countDefined = !(0, _helpersSegmentJs.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, _helpersSegmentJs.aH)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersSegmentJs.aH)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersSegmentJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersSegmentJs.aI)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersSegmentJs.aJ)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, _helpersSegmentJs.aK)(spacing), (0, _helpersSegmentJs.aK)(niceMin));
    factor = Math.pow(10, (0, _helpersSegmentJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersSegmentJs.aJ)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersSegmentJs.aJ)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
    const rad = (0, _helpersSegmentJs.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero } = this.options;
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, _helpersSegmentJs.s)(min);
            const maxSign = (0, _helpersSegmentJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit, stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, _helpersSegmentJs.aG)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class LinearScale extends LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, _helpersSegmentJs.aL).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersSegmentJs.g)(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, _helpersSegmentJs.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const log10Floor = (v)=>Math.floor((0, _helpersSegmentJs.aM)(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
    min = (0, _helpersSegmentJs.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, _helpersSegmentJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, _helpersSegmentJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, _helpersSegmentJs.aL).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersSegmentJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersSegmentJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersSegmentJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersSegmentJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, _helpersSegmentJs.aG)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, _helpersSegmentJs.aM)(start);
        this._valueRange = (0, _helpersSegmentJs.aM)(this.max) - (0, _helpersSegmentJs.aM)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersSegmentJs.aM)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, _helpersSegmentJs.E)(tickOpts.backdropPadding);
        return (0, _helpersSegmentJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersSegmentJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersSegmentJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersSegmentJs.aN)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, _helpersSegmentJs.a0)(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, _helpersSegmentJs.ay)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, _helpersSegmentJs.U)(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra, additionalAngle, padding, size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, _helpersSegmentJs.U)((0, _helpersSegmentJs.ay)(pointLabelPosition.angle + (0, _helpersSegmentJs.H))));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    const { left, top, right, bottom } = item;
    const apexesInArea = (0, _helpersSegmentJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels, display } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left, top, right, bottom } = item;
    const { backdropColor } = opts;
    if (!(0, _helpersSegmentJs.k)(backdropColor)) {
        const borderRadius = (0, _helpersSegmentJs.aw)(opts.borderRadius);
        const padding = (0, _helpersSegmentJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersSegmentJs.au)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx, options: { pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
        const { x, y, textAlign } = item;
        (0, _helpersSegmentJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersSegmentJs.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color, lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersSegmentJs.j)(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, _helpersSegmentJs.aL).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, _helpersSegmentJs.E)(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(false);
        this.min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, _helpersSegmentJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, _helpersSegmentJs.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, _helpersSegmentJs.ay)(index * angleMultiplier + (0, _helpersSegmentJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersSegmentJs.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersSegmentJs.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, _helpersSegmentJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left, top, right, bottom } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        const { backgroundColor, grid: { circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines, grid, border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color, lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersSegmentJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersSegmentJs.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser, round, isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, _helpersSegmentJs.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, _helpersSegmentJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo, hi } = (0, _helpersSegmentJs.aP)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersSegmentJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, _helpersSegmentJs.aO)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersSegmentJs.S)(start, 0, limit);
        end = (0, _helpersSegmentJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, _helpersSegmentJs.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, _helpersSegmentJs.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, _helpersSegmentJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, _helpersSegmentJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersSegmentJs._)(values.sort(sorter));
    }
}
function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo, hi } = (0, _helpersSegmentJs.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo, hi } = (0, _helpersSegmentJs.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
    static defaults = TimeScale.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min, max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
const registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"./chunks/helpers.segment.js":"5l2rC","@kurkle/color":"aVwJy","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5l2rC":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>fontString);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aB", ()=>_textX);
parcelHelpers.export(exports, "aC", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aD", ()=>drawPointLegend);
parcelHelpers.export(exports, "aE", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aF", ()=>noop);
parcelHelpers.export(exports, "aG", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aH", ()=>niceNum);
parcelHelpers.export(exports, "aI", ()=>almostWhole);
parcelHelpers.export(exports, "aJ", ()=>almostEquals);
parcelHelpers.export(exports, "aK", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aL", ()=>Ticks);
parcelHelpers.export(exports, "aM", ()=>log10);
parcelHelpers.export(exports, "aN", ()=>_longestText);
parcelHelpers.export(exports, "aO", ()=>_filterBetween);
parcelHelpers.export(exports, "aP", ()=>_lookup);
parcelHelpers.export(exports, "aQ", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aR", ()=>getHoverColor);
parcelHelpers.export(exports, "aS", ()=>clone);
parcelHelpers.export(exports, "aT", ()=>_merger);
parcelHelpers.export(exports, "aU", ()=>_mergerIf);
parcelHelpers.export(exports, "aV", ()=>_deprecated);
parcelHelpers.export(exports, "aW", ()=>_splitKey);
parcelHelpers.export(exports, "aX", ()=>toFontString);
parcelHelpers.export(exports, "aY", ()=>splineCurve);
parcelHelpers.export(exports, "aZ", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "a_", ()=>getStyle);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>_elementsEqual);
parcelHelpers.export(exports, "ai", ()=>_isClickEvent);
parcelHelpers.export(exports, "aj", ()=>_isBetween);
parcelHelpers.export(exports, "ak", ()=>_readValueToProps);
parcelHelpers.export(exports, "al", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "am", ()=>_computeSegments);
parcelHelpers.export(exports, "an", ()=>_boundSegments);
parcelHelpers.export(exports, "ao", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "ap", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "aq", ()=>_pointInLine);
parcelHelpers.export(exports, "ar", ()=>_steppedLineTo);
parcelHelpers.export(exports, "as", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "at", ()=>drawPoint);
parcelHelpers.export(exports, "au", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "av", ()=>toTRBL);
parcelHelpers.export(exports, "aw", ()=>toTRBLCorners);
parcelHelpers.export(exports, "ax", ()=>_boundSegment);
parcelHelpers.export(exports, "ay", ()=>_normalizeAngle);
parcelHelpers.export(exports, "az", ()=>getRtlAdapter);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>toLineHeight);
parcelHelpers.export(exports, "b1", ()=>PITAU);
parcelHelpers.export(exports, "b2", ()=>INFINITY);
parcelHelpers.export(exports, "b3", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b4", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b5", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b6", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale, _parsed } = meta;
        const axis = iScale.axis;
        const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
        if (minDefined) start = _limitValue(Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = _limitValue(Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale, yScale, _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
const formatters = {
    values (value) {
        return isArray(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ''), scope);
}
class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x, y, w, h, radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min, max } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = _resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy, _context, _subProxy, _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale } = meta;
    const { key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX, offsetY } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) return event;
    const { canvas, currentDevicePixelRatio } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x, y, box } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width, height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width, height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === 'angle') return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start, end, count, loop, style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property, start: startBound, end: endBound } = bounds;
    const { between, normalize } = propertyFn(property);
    const count = points.length;
    let { start, end, loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare, between, normalize } = propertyFn(property);
    const { start, end, loop, style } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

},{"@kurkle/color":"aVwJy","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aVwJy":[function(require,module,exports,__globalThis) {
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
const lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
const map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const hex = [
    ...'0123456789ABCDEF'
];
const h1 = (b)=>hex[b & 0xF];
const h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
const alpha = (a, f)=>a < 255 ? f(a) : '';
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    const rgb = hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    const m = HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    const h = hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    const a = rgb2hsl(v);
    const h = a[0];
    const s = n2p(a[1]);
    const l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function unpack() {
    const unpacked = {};
    const keys = Object.keys(names$1);
    const tkeys = Object.keys(map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    const m = RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    const r = from(b2n(rgb1.r));
    const g = from(b2n(rgb1.g));
    const b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        let tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === 'r') return rgbParse(str);
    return hueParse(str);
}
class Color {
    constructor(input){
        if (input instanceof Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = fromObject(input);
        else if (type === 'string') v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4G61z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminStatusPage", ()=>AdminStatusPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshTextInput = require("../base_components/sesh_text_input");
var _seshWarningButton = require("../base_components/sesh_warning_button");
function AdminStatusPage(props) {
    const status_message_query = (0, _trpc.trpc).misc.getStatusMessage.useQuery(undefined, {
        onSuccess: (data)=>setInput(data)
    });
    const context = (0, _trpc.trpc).useContext();
    const status_message_mutation = (0, _trpc.trpc).admin.setStatusMessage.useMutation({
        onSuccess: ()=>{
            context.misc.getStatusMessage.invalidate();
        }
    });
    const [input, setInput] = (0, _react.useState)(status_message_query?.data ?? "");
    if (!status_message_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                label: "Status Message",
                input_props: {
                    value: input,
                    onChange: (data)=>setInput(data.currentTarget.value),
                    disabled: status_message_mutation.isLoading
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ml-auto flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        className: "w-fit",
                        onClick: ()=>status_message_mutation.mutate({
                                status_message: input
                            }),
                        is_loading: status_message_mutation.isLoading,
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshWarningButton.SeshWarningButton), {
                        className: "w-fit",
                        onClick: ()=>status_message_mutation.mutate({
                                status_message: ""
                            }),
                        is_loading: status_message_mutation.isLoading,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_text_input":"befXR","../base_components/sesh_warning_button":"5HrqM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5HrqM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// background-color: rgba(0, 0, 0, 0) !important;
// 	color: red !important;
// 	border: 2px solid red !important;
parcelHelpers.export(exports, "SeshWarningButton", ()=>SeshWarningButton);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SeshWarningButton(props) {
    const { is_loading, ...base_props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...base_props,
        className: (0, _classnamesDefault.default)(props.className, "h-10 w-full border-2 border-warning bg-transparent px-2 font-bold text-warning hover:bg-warning hover:text-black", {
            "button is-loading": is_loading
        }),
        type: base_props.type ?? "button"
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gJW9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminStripeManager", ()=>AdminStripeManager);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _jsonViewer = require("@textea/json-viewer");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshWarningButton = require("../base_components/sesh_warning_button");
var _seshSelectInput = require("../base_components/sesh_select_input");
var _clipLoader = require("react-spinners/ClipLoader");
var _clipLoaderDefault = parcelHelpers.interopDefault(_clipLoader);
function AdminStripeManager() {
    const context = (0, _trpc.trpc).useContext();
    const active_coupon_query = (0, _trpc.trpc).admin.getActiveCoupon.useQuery();
    const active_coupon_mutation = (0, _trpc.trpc).admin.setActiveCoupon.useMutation({
        onSuccess: ()=>{
            context.admin.getActiveCoupon.invalidate();
        }
    });
    const setActiveCoupon = (coupon_id)=>active_coupon_mutation.mutate({
            coupon_id
        });
    if (!active_coupon_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-10",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutEnabler, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PriceCacheClearer, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-bold",
                                children: "Current Active Coupon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshWarningButton.SeshWarningButton), {
                                className: "ml-auto w-fit",
                                onClick: ()=>setActiveCoupon(null),
                                is_loading: active_coupon_mutation.isLoading,
                                children: "Clear Active Coupon"
                            })
                        ]
                    }),
                    active_coupon_query.data ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonViewer.JsonViewer), {
                        value: active_coupon_query.data,
                        theme: "light"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "None"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CouponSetter, {
                active_coupon_id: active_coupon_query.data?.id,
                setActiveCoupon: setActiveCoupon,
                is_loading: active_coupon_mutation.isLoading
            })
        ]
    });
}
function PriceCacheClearer() {
    const mutation = (0, _trpc.trpc).admin.clearStripePriceCache.useMutation();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Price Cache"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshWarningButton.SeshWarningButton), {
                className: "ml-auto w-fit",
                onClick: ()=>mutation.mutate(),
                is_loading: mutation.isLoading,
                children: "Clear Price Cache"
            })
        ]
    });
}
function CheckoutEnabler(props) {
    const context = (0, _trpc.trpc).useContext();
    const checkout_disabled_query = (0, _trpc.trpc).admin.getCheckoutDisabled.useQuery();
    const mutation = (0, _trpc.trpc).admin.modifyCheckoutDisabled.useMutation({
        onSuccess: ()=>{
            context.admin.getCheckoutDisabled.invalidate();
        }
    });
    if (checkout_disabled_query.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clipLoaderDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Checkout Status"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    "Current Setting:",
                    " ",
                    checkout_disabled_query.data ? "Disabled" : "Enabled",
                    checkout_disabled_query.data ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        className: "ml-auto w-fit",
                        is_loading: mutation.isLoading,
                        onClick: ()=>mutation.mutate({
                                is_disabled: !checkout_disabled_query.data
                            }),
                        children: checkout_disabled_query.data ? "Enable" : "Disable"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshWarningButton.SeshWarningButton), {
                        className: "ml-auto w-fit",
                        is_loading: mutation.isLoading,
                        onClick: ()=>mutation.mutate({
                                is_disabled: !checkout_disabled_query.data
                            }),
                        children: checkout_disabled_query.data ? "Enable" : "Disable"
                    })
                ]
            })
        ]
    });
}
function CouponSetter(props) {
    const all_coupons_query = (0, _trpc.trpc).admin.getCoupons.useQuery(undefined, {
        onSuccess: (data)=>setOption(data[0])
    });
    const all_coupons_query_data = all_coupons_query.data;
    const [option, setOption] = (0, _react.useState)(all_coupons_query_data?.[0]);
    if (!all_coupons_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLoadingSelect, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Set Coupon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSelectInput.SeshSelect), {
                            options: all_coupons_query_data.map((val)=>({
                                    label: val.name + (props.active_coupon_id === val.id ? " (active)" : "") + ` (${val.id})`,
                                    value: val.id
                                })),
                            value: {
                                label: option.name,
                                value: option.id
                            },
                            onChange: (select_val)=>setOption(all_coupons_query_data.find((val)=>val.id === select_val.value))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ml-auto flex gap-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            className: "w-fit",
                            onClick: ()=>props.setActiveCoupon(option.id),
                            is_loading: props.is_loading,
                            children: "Set"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonViewer.JsonViewer), {
                value: option,
                theme: "light"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","@textea/json-viewer":"cB69Z","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_warning_button":"5HrqM","../base_components/sesh_select_input":"8Vo8B","react-spinners/ClipLoader":"6YrEM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6YrEM":[function(require,module,exports,__globalThis) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var React = __importStar(require("582ac4ec4736d09d"));
var unitConverter_1 = require("16f948b3f0485a37");
var animation_1 = require("fda946da9ca9de52");
var clip = (0, animation_1.createAnimation)("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");
function ClipLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 35 : _f, additionalprops = __rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size"
    ]);
    var style = __assign({
        background: "transparent !important",
        width: (0, unitConverter_1.cssValue)(size),
        height: (0, unitConverter_1.cssValue)(size),
        borderRadius: "100%",
        border: "2px solid",
        borderTopColor: color,
        borderBottomColor: "transparent",
        borderLeftColor: color,
        borderRightColor: color,
        display: "inline-block",
        animation: "".concat(clip, " ").concat(0.75 / speedMultiplier, "s 0s infinite linear"),
        animationFillMode: "both"
    }, cssOverride);
    if (!loading) return null;
    return React.createElement("span", __assign({
        style: style
    }, additionalprops));
}
exports.default = ClipLoader;

},{"582ac4ec4736d09d":"IMRgT","16f948b3f0485a37":"2RjLb","fda946da9ca9de52":"yqmEp"}],"c3x83":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminWaitlistManager", ()=>AdminWaitlistManager);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshTextInput = require("../base_components/sesh_text_input");
var _subPageLoader = require("../sub_page_loader");
function AdminWaitlistManager() {
    const metadata_query = (0, _trpc.trpc).admin.getWaitlistedMetadata.useQuery();
    if (!metadata_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageLoader.SubpageLoader), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-2",
                children: Object.keys(metadata_query.data).map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Stat, {
                        label: key,
                        value: metadata_query.data[key]
                    }, key))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraduateUsersFromWaitlistInput, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddServerToGraduatedWaitlistInput, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WaitlistersList, {})
        ]
    });
}
function Stat(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: props.value
            })
        ]
    });
}
function WaitlistersList() {
    const query = (0, _trpc.trpc).admin.getWaitlisters.useQuery();
    if (!query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "Loading"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-2",
        children: query.data.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex gap-2 rounded-md bg-base-dark px-4 py-2",
                children: Object.keys(val).map((val2)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            val2,
                            " ",
                            val[val2].toString()
                        ]
                    }))
            }))
    });
}
function GraduateUsersFromWaitlistInput(props) {
    const [input, setInput] = (0, _react.useState)("");
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).admin.graduateServersFromWaitlist.useMutation({
        onSuccess: ()=>{
            context.admin.getWaitlistedMetadata.invalidate();
            context.admin.getWaitlisters.invalidate();
        }
    });
    let isNumber = false;
    for (const char of input){
        if (isNaN(parseInt(char))) {
            isNumber = false;
            break;
        }
        isNumber = true;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Num of Waitlisted Guilds to Graduate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                            input_props: {
                                onChange: (e)=>setInput(e.currentTarget.value),
                                value: input
                            },
                            error_text: !isNumber ? "Must be a number" : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            is_loading: mutation.isLoading,
                            onClick: ()=>mutation.mutate({
                                    count: parseInt(input)
                                }),
                            disabled: !isNumber,
                            children: "Add"
                        })
                    })
                ]
            })
        ]
    });
}
function isNumber(str) {
    if (str.length === 0) return false;
    for (const char of str){
        if (isNaN(parseInt(char))) return false;
    }
    return true;
}
function AddServerToGraduatedWaitlistInput(props) {
    const [server_input, setServerInput] = (0, _react.useState)("");
    const [user_input, setUserInput] = (0, _react.useState)("");
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).admin.addServerToGraduatedWaitlist.useMutation({
        onSuccess: ()=>{
            context.admin.getWaitlistedMetadata.invalidate();
            context.admin.getWaitlisters.invalidate();
        }
    });
    const is_server_snowflake = isNumber(server_input);
    const is_user_snowflake = isNumber(user_input);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-bold",
                children: "Server to Graduate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                            input_props: {
                                onChange: (e)=>setServerInput(e.currentTarget.value),
                                value: server_input,
                                placeholder: "Server ID"
                            },
                            error_text: !is_server_snowflake ? "Must be a snowflake" : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                            input_props: {
                                onChange: (e)=>setUserInput(e.currentTarget.value),
                                value: user_input,
                                placeholder: "User ID"
                            },
                            error_text: !is_user_snowflake ? "Must be a snowflake" : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            is_loading: mutation.isLoading,
                            onClick: ()=>mutation.mutate({
                                    guild_id: server_input,
                                    user_id: user_input
                                }),
                            disabled: !is_user_snowflake || !is_server_snowflake,
                            children: "Add"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_text_input":"befXR","../sub_page_loader":"dOS2I","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dOS2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubpageLoader", ()=>SubpageLoader);
var _jsxRuntime = require("react/jsx-runtime");
var _reactSpinners = require("react-spinners");
var _constants = require("../../../../../common/constants");
function SubpageLoader() {
    const vertical_spacers = [];
    for(let i = 0; i < 7; i++)vertical_spacers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "py-4"
    }, i));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            vertical_spacers,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "is-centered sweet-loading throbber",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.BeatLoader), {
                        size: "1.5rem",
                        loading: true,
                        color: (0, _constants.Constants).EMBED_COLOR
                    })
                })
            }),
            vertical_spacers
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react-spinners":[["BeatLoader","8yhIq","default"]],"../../../../../common/constants":"lLiun","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8yhIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unitConverter = require("./helpers/unitConverter");
var _animation = require("./helpers/animation");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var beat = (0, _animation.createAnimation)("BeatLoader", "50% {transform: scale(0.75);opacity: 0.2} 100% {transform: scale(1);opacity: 1}", "beat");
function BeatLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 15 : _f, _g = _a.margin, margin = _g === void 0 ? 2 : _g, additionalprops = __rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size",
        "margin"
    ]);
    var wrapper = __assign({
        display: "inherit"
    }, cssOverride);
    var style = function(i) {
        return {
            display: "inline-block",
            backgroundColor: color,
            width: (0, _unitConverter.cssValue)(size),
            height: (0, _unitConverter.cssValue)(size),
            margin: (0, _unitConverter.cssValue)(margin),
            borderRadius: "100%",
            animation: "".concat(beat, " ").concat(0.7 / speedMultiplier, "s ").concat(i % 2 ? "0s" : "".concat(0.35 / speedMultiplier, "s"), " infinite linear"),
            animationFillMode: "both"
        };
    };
    if (!loading) return null;
    return _react.createElement("span", __assign({
        style: wrapper
    }, additionalprops), _react.createElement("span", {
        style: style(1)
    }), _react.createElement("span", {
        style: style(2)
    }), _react.createElement("span", {
        style: style(3)
    }));
}
exports.default = BeatLoader;

},{"react":"IMRgT","./helpers/unitConverter":"6dzcC","./helpers/animation":"6f7wb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9ezZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminShardsViewer", ()=>AdminShardsViewer);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _withTooltipPortaled = require("../tooltips/with_tooltip_portaled");
function AdminShardsViewer() {
    const shards_query = (0, _trpc.trpc).admin.getShardsStatus.useQuery(undefined, {
        refetchInterval: 10000
    });
    if (!shards_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid w-1/2 grid-cols-2 gap-x-4 text-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-content-secondary",
                        children: "Shards"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: shards_query.data.shardDetails.length
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-content-secondary",
                        children: "Ping Mean"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: shards_query.data.averagePing
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-content-secondary",
                        children: "Ping Std. Deviation"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: shards_query.data.standardDeviation
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextFetchTime, {
                dataUpdatedAt: shards_query.dataUpdatedAt,
                isFetching: shards_query.isFetching
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-wrap",
                children: shards_query.data.shardDetails.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ShardCell, {
                        ...val
                    }, val.id))
            })
        ]
    });
}
function NextFetchTime(props) {
    const [fetchTime, setFetchTime] = (0, _react.useState)(10000 - (new Date().getTime() - props.dataUpdatedAt));
    (0, _react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setFetchTime(10000 - (new Date().getTime() - props.dataUpdatedAt));
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        props.dataUpdatedAt
    ]);
    const displayTime = Math.max(Math.round(fetchTime / 1000), 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-right text-sm",
        children: props.isFetching || displayTime === 0 ? "Refetching now..." : `Retching in ${displayTime} seconds...`
    });
}
function ShardCell(props) {
    const restart_shard_mutation = (0, _trpc.trpc).admin.restartShard.useMutation();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
        no_delay: true,
        tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-2 gap-x-4 text-left",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-content-secondary",
                            children: "ID"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: props.id
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-content-secondary",
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: props.status
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-content-secondary",
                            children: "Ping"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: props.ping
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-content-secondary",
                            children: "Guilds"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: props.guild_count
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        is_loading: restart_shard_mutation.isLoading,
                        custom_size: "small",
                        onClick: ()=>restart_shard_mutation.mutate({
                                shard_id: props.id
                            }),
                        children: "Restart"
                    })
                })
            ]
        }),
        style: "Info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)("flex h-14 w-14 flex-col items-center justify-center rounded-md border border-base-light hover:border-sesh-primary", {
                "bg-base-dark": props.status === "Ready",
                "bg-warning": props.status !== "Ready"
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.id
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_primary_button":"3QyI2","../tooltips/with_tooltip_portaled":"6LBvw","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6wDr9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminBlurbManager", ()=>AdminBlurbManager);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshTextarea = require("../base_components/sesh_textarea");
var _boxItem = require("../box_item");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _removingThrobber = require("../../removing_throbber");
function AdminBlurbManager() {
    const [newDashboardMessage, setNewDashboardMessage] = (0, _react.useState)("");
    const [newLandingPageMessage, setNewLandingPageMessage] = (0, _react.useState)("");
    const [editingBlurbId, setEditingBlurbId] = (0, _react.useState)(null);
    const [editingDashboardMessage, setEditingDashboardMessage] = (0, _react.useState)("");
    const [editingLandingPageMessage, setEditingLandingPageMessage] = (0, _react.useState)("");
    const utils = (0, _trpc.trpc).useContext();
    const blurbsQuery = (0, _trpc.trpc).blurb.getAllBlurbs.useQuery();
    const createBlurbMutation = (0, _trpc.trpc).blurb.createBlurb.useMutation({
        onSuccess: ()=>{
            utils.blurb.getAllBlurbs.invalidate();
            utils.blurb.getActiveBlurb.invalidate();
        }
    });
    const editBlurbMutation = (0, _trpc.trpc).blurb.editBlurb.useMutation({
        onSuccess: ()=>{
            utils.blurb.getAllBlurbs.invalidate();
            utils.blurb.getActiveBlurb.invalidate();
            setEditingBlurbId(null);
        }
    });
    const toggleBlurbMutation = (0, _trpc.trpc).blurb.toggleBlurb.useMutation({
        onSuccess: ()=>{
            utils.blurb.getAllBlurbs.invalidate();
            utils.blurb.getActiveBlurb.invalidate();
        }
    });
    const deleteBlurbMutation = (0, _trpc.trpc).blurb.deleteBlurb.useMutation({
        onSuccess: ()=>{
            utils.blurb.getAllBlurbs.invalidate();
            utils.blurb.getActiveBlurb.invalidate();
        }
    });
    if (!blurbsQuery.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    const handleCreateBlurb = async ()=>{
        if (!newDashboardMessage.trim()) return;
        try {
            await createBlurbMutation.mutateAsync({
                dashboard_message: newDashboardMessage,
                landing_page_message: newLandingPageMessage.trim() || null
            });
            setNewDashboardMessage("");
            setNewLandingPageMessage("");
        } catch (error) {
            console.error("Failed to create blurb:", error);
        }
    };
    const handleEditBlurb = async (id)=>{
        try {
            await editBlurbMutation.mutateAsync({
                blurb_id: id,
                dashboard_message: editingDashboardMessage,
                landing_page_message: editingLandingPageMessage.trim() || null
            });
        } catch (error) {
            console.error("Failed to edit blurb:", error);
        }
    };
    const startEditing = (blurb)=>{
        setEditingBlurbId(blurb.id);
        setEditingDashboardMessage(blurb.dashboard_message);
        setEditingLandingPageMessage(blurb.landing_page_message || "");
    };
    const cancelEditing = ()=>{
        setEditingBlurbId(null);
        setEditingDashboardMessage("");
        setEditingLandingPageMessage("");
    };
    const handleToggleBlurb = async (id)=>{
        try {
            await toggleBlurbMutation.mutateAsync({
                blurb_id: id
            });
        } catch (error) {
            console.error("Failed to toggle blurb:", error);
        }
    };
    const handleDeleteBlurb = async (id)=>{
        try {
            await deleteBlurbMutation.mutateAsync({
                blurb_id: id
            });
        } catch (error) {
            console.error("Failed to delete blurb:", error);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "font-bold",
                            children: "Create New Blurb"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-2 font-medium",
                                    children: "Dashboard Message (Required)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextarea.SeshTextarea), {
                                    value: newDashboardMessage,
                                    onChange: (e)=>setNewDashboardMessage(e.target.value),
                                    placeholder: "Enter dashboard message...",
                                    rows: 3
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-2 font-medium",
                                    children: "Landing Page Message (Optional)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextarea.SeshTextarea), {
                                    value: newLandingPageMessage,
                                    onChange: (e)=>setNewLandingPageMessage(e.target.value),
                                    placeholder: "Enter landing page message...",
                                    rows: 3
                                })
                            ]
                        }),
                        (newDashboardMessage || newLandingPageMessage) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                newDashboardMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-sm font-medium text-content-secondary",
                                            children: "Dashboard Preview:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                                            bgColor: "dark",
                                            className: "p-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "whitespace-pre-wrap",
                                                dangerouslySetInnerHTML: {
                                                    __html: newDashboardMessage
                                                }
                                            })
                                        })
                                    ]
                                }),
                                newLandingPageMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-sm font-medium text-content-secondary",
                                            children: "Landing Page Preview:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                                            bgColor: "dark",
                                            className: "p-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "whitespace-pre-wrap",
                                                dangerouslySetInnerHTML: {
                                                    __html: newLandingPageMessage
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                onClick: handleCreateBlurb,
                                disabled: !newDashboardMessage.trim(),
                                children: "Create Blurb"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "font-bold",
                        children: "Existing Blurbs"
                    }),
                    blurbsQuery.data.map((blurb)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                            bgColor: "semidark",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: (0, _classnamesDefault.default)("h-2 w-2 rounded-full", {
                                                            "bg-green-500": blurb.is_active,
                                                            "bg-gray-400": !blurb.is_active
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "text-sm text-content-secondary",
                                                        children: [
                                                            "Created:",
                                                            " ",
                                                            new Date(blurb.created_at).toLocaleDateString()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex items-center gap-4",
                                                children: editingBlurbId === blurb.id ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        editBlurbMutation.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: ()=>handleEditBlurb(blurb.id),
                                                            className: "text-green-500 hover:text-green-600",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-check"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: cancelEditing,
                                                            className: "text-content-secondary hover:text-content-primary",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-times"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: ()=>startEditing(blurb),
                                                            className: "text-content-secondary hover:text-content-primary",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-edit"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: ()=>handleToggleBlurb(blurb.id),
                                                            className: "text-content-secondary hover:text-content-primary",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: (0, _classnamesDefault.default)("fas", {
                                                                    "fa-eye": !blurb.is_active,
                                                                    "fa-eye-slash": blurb.is_active
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: ()=>handleDeleteBlurb(blurb.id),
                                                            className: "text-red-500 hover:text-red-600",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-trash"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    editingBlurbId === blurb.id ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mb-2 font-medium",
                                                        children: "Dashboard Message:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextarea.SeshTextarea), {
                                                        value: editingDashboardMessage,
                                                        onChange: (e)=>setEditingDashboardMessage(e.target.value),
                                                        placeholder: "Enter dashboard message...",
                                                        rows: 3
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mb-2 font-medium",
                                                        children: "Landing Page Message:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextarea.SeshTextarea), {
                                                        value: editingLandingPageMessage,
                                                        onChange: (e)=>setEditingLandingPageMessage(e.target.value),
                                                        placeholder: "Enter landing page message...",
                                                        rows: 3
                                                    })
                                                ]
                                            }),
                                            (editingDashboardMessage || editingLandingPageMessage) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-col gap-4",
                                                children: [
                                                    editingDashboardMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-col gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-sm font-medium text-content-secondary",
                                                                children: "Dashboard Preview:"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                                                                bgColor: "dark",
                                                                className: "p-4",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "whitespace-pre-wrap",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: editingDashboardMessage
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    editingLandingPageMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-col gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-sm font-medium text-content-secondary",
                                                                children: "Landing Page Preview:"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                                                                bgColor: "dark",
                                                                className: "p-4",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "whitespace-pre-wrap",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: editingLandingPageMessage
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mb-2 font-medium",
                                                        children: "Dashboard Message:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "whitespace-pre-wrap",
                                                        children: blurb.dashboard_message
                                                    })
                                                ]
                                            }),
                                            blurb.landing_page_message && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mb-2 font-medium",
                                                        children: "Landing Page Message:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "whitespace-pre-wrap",
                                                        children: blurb.landing_page_message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, blurb.id))
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_textarea":"89s7g","../box_item":"gTVlB","classnames":"7uztA","../../removing_throbber":"TmURk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"89s7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshTextarea", ()=>SeshTextarea);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textareaAutosize = require("../../../../dashboard/TextareaAutosize");
function SeshTextarea(props) {
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)("flex w-full rounded-[4px] border-2 bg-base-dark text-content-primary outline-none", props.className, {
            "input-disabled": props.disabled,
            "border-sesh-primary shadow-input-focus": isFocused,
            "border-content-secondary hover:border-sesh-dark": !isFocused
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosize.TextareaAutosize), {
            className: "w-full border-none bg-transparent px-[11px] py-[7px] outline-none",
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            value: props.value,
            onChange: props.onChange,
            placeholder: props.placeholder,
            rows: props.rows ?? 3,
            maxRows: props.maxRows,
            disabled: props.disabled
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../../dashboard/TextareaAutosize":"ltpXu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"emCby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventListingFormWithDSTFix);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactSpinners = require("react-spinners");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _timeFormatUtils = require("../../../../../../common/time_format_utils");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshRouter = require("../../../sesh_router");
var _trpc = require("../../../utils/trpc");
var _removingThrobber = require("../../removing_throbber");
var _dashboardContainer = require("../base_components/dashboard_container");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _seshSearchForm = require("../base_components/sesh_search_form");
var _useChannelName = require("../hooks/use_channel_name");
var _useDocTitle = require("../hooks/use_doc_title");
var _useIsAdmin = require("../hooks/use_is_admin");
var _useUserContext = require("../hooks/use_user_context");
var _dateTableData = require("../listings_form/event/event_listing_form/date_table_data");
var _listingsFormTableData = require("../listings_form/listings_form_table_data");
var _pageButtons = require("../listings_form/page_buttons");
var _memberDisplayNameWithTooltip = require("../member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
function EditTimeAction(props) {
    let { server_id } = (0, _reactRouter.useParams)();
    const trpc_context = (0, _trpc.trpc).useContext();
    const modify_event_time_mutation = (0, _trpc.trpc).event.modifyEventTime.useMutation({
        onSuccess: (data)=>{
            trpc_context.event.getListItem.setData((val)=>{
                return {
                    ...val,
                    start_time_str: data.start_time.toString(),
                    end_time_str: data.end_time.toString()
                };
            }, {
                guild_id: server_id,
                message_id: props.event_id
            });
        }
    });
    if (modify_event_time_mutation.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
            size: "1rem",
            loading: true,
            color: (0, _constants.Constants).EMBED_COLOR
        })
    });
    const decrement_disabled = props.start_time.getTime() - 3600000 < new Date().getTime();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex gap-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                className: (0, _classnamesDefault.default)({
                    "input-disabled": decrement_disabled
                }),
                onClick: ()=>{
                    if (decrement_disabled) return;
                    modify_event_time_mutation.mutate({
                        type: "Decrement",
                        id: props.event_id,
                        guild_id: server_id,
                        should_dm_users: props.should_dm_users
                    });
                },
                children: "-1 Hour"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                onClick: ()=>modify_event_time_mutation.mutate({
                        type: "Increment",
                        id: props.event_id,
                        guild_id: server_id,
                        should_dm_users: props.should_dm_users
                    }),
                children: "+1 Hour"
            })
        ]
    });
}
function EventListingFormWithDSTFix() {
    (0, _useDocTitle.useDocTitle)("DST fix");
    const { server_id } = (0, _reactRouter.useParams)();
    const context = (0, _trpc.trpc).useContext();
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const history = (0, _reactRouter.useHistory)();
    const guild_data = guild_list?.find((val)=>val.id === server_id);
    const [page, setPage] = (0, _react.useState)(0);
    const [sort, setSort] = (0, _react.useState)({
        type: "Date",
        direction: "ASC"
    });
    const [should_dm_users, setShouldDMUsers] = (0, _react.useState)(false);
    const [search, setSearch] = (0, _react.useState)("");
    const list_query = (0, _trpc.trpc).event.list.useQuery({
        guild_id: server_id,
        include_completed: false,
        cursor: page,
        sort,
        search
    }, {
        staleTime: 5000,
        keepPreviousData: true,
        onSuccess: (data)=>{
            data.items.forEach((val)=>context.event.getListItem.setData(()=>val, {
                    guild_id: server_id,
                    message_id: val.message_id
                }));
        }
    });
    if (!list_query.data || !guild_data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage()
    });
    const query_items = list_query.data?.items;
    const disabled = list_query.isPreviousData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
        title: "DST Fix",
        size: "lg",
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
            link_chain_data: [
                (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(guild_data),
                (0, _dashboardUtils.DashboardUtils).RenderEventSelectionLinkChain(guild_data)
            ]
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("flex flex-col gap-2", {
                "input-disabled": disabled
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 sm:flex-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshSearchForm), {
                            onSubmit: setSearch,
                            placeholder: "Search by name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto cursor-pointer",
                            onClick: disabled ? undefined : ()=>setShouldDMUsers(!should_dm_users),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    className: "cursor-pointer",
                                    checked: should_dm_users,
                                    onChange: ()=>{}
                                }),
                                " ",
                                "DM Users on Start Time Modified"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: (0, _classnamesDefault.default)("sesh-table listing-table responsive-table event-listings"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[27%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Date",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[23%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Name",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[12%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Channel",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[12%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Author",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[26%] overflow-hidden overflow-ellipsis",
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: query_items && query_items.length > 0 ? query_items.map((val)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventRow, {
                                    message_id: val.message_id,
                                    should_dm_users: should_dm_users
                                }, val.message_id);
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                className: "",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    colSpan: 6,
                                    className: "text-center",
                                    children: "No results found"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full flex-wrap-reverse items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            className: "w-fit self-end",
                            onClick: ()=>history.push((0, _commonUtils.common_utils).getEventCreateURL(server_id)),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 px-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-plus-circle"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "New Event"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto",
                            children: list_query.data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageButtons.PageButtons), {
                                page: page,
                                total_items: list_query.data?.total_item_count ?? 0,
                                setPage: setPage,
                                is_loading: list_query.isPreviousData,
                                items_per_page: (0, _constants.Constants).LISTING_PAGINATION_LIMIT
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const OppositeSortMap = {
    ASC: "DESC",
    DESC: "ASC"
};
function SortableTableHeader(props) {
    const is_current_sort = props.current_sort.type === props.type;
    const is_pending_results = props.is_loading && is_current_sort;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("group flex flex-wrap items-center gap-1", {
            "cursor-pointer": !props.is_loading
        }),
        onClick: ()=>{
            if (props.is_loading) return;
            props.setSort({
                type: props.type,
                direction: is_current_sort ? OppositeSortMap[props.current_sort.direction] : "ASC"
            });
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-full overflow-hidden overflow-ellipsis",
                children: props.type
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: (0, _classnamesDefault.default)("group-hover:text-sesh-primary", {
                            hidden: is_pending_results,
                            "fas fa-sort text-base-light": !is_current_sort,
                            "fas fa-sort-down": is_current_sort && props.current_sort.direction === "DESC",
                            "fas fa-sort-up": is_current_sort && props.current_sort.direction === "ASC"
                        })
                    }),
                    is_pending_results && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                ]
            }, `${props.type}_${props.current_sort.direction}_${is_current_sort}_${is_pending_results}`)
        ]
    });
}
function getRepeatData(event) {
    const output_timezone = (0, _luxon.DateTime).local().zone.name;
    return event.rrule ? {
        repeat_id: event.original_repeat_message_id,
        repeat_text: (0, _timeFormatUtils.time_format_utils).formatRRule(event.rrule, output_timezone, (0, _luxon.DateTime).fromJSDate(new Date(event.start_time_str)), false)
    } : undefined;
}
function EventRow(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const event_query = (0, _trpc.trpc).event.getListItem.useQuery({
        guild_id: server_id,
        message_id: props.message_id
    }, {
        staleTime: Infinity
    });
    const channel_name = (0, _useChannelName.useChannelName)(event_query.data?.channel_id);
    if (!event_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const event = event_query.data;
    const now_date = new Date();
    const start_time = new Date(event.start_time_str);
    const end_time = new Date(event.end_time_str);
    const is_in_past = end_time < now_date;
    const classString = is_in_past ? "opacity-75" : "";
    let emoji_data;
    const repeat_data = getRepeatData(event);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        className: classString,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTableData.DateTableData), {
                start_time_js_date: start_time,
                end_time_js_date: end_time,
                repeat_data: repeat_data
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: event.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: channel_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                    user_id: event.author_id,
                    tooltip_type: "SeshTooltip"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RowActions, {
                    guild_id: server_id,
                    event: event,
                    should_dm_users: props.should_dm_users
                })
            })
        ]
    });
}
function RowActions(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    const user = (0, _useUserContext.useUserContext)();
    const is_admin_query = (0, _useIsAdmin.useIsAdmin)();
    if (is_removing || !is_admin_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
    });
    const is_event_creator = user?.id === props.event.author_id;
    const has_edit_event_perms = is_admin_query.data || is_event_creator;
    const has_event_started = new Date(props.event.start_time_str) < new Date();
    if (!has_edit_event_perms) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "Disabled due to invalid perms"
    });
    if (has_event_started) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "Disabled due to already started event"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditTimeAction, {
        event_id: props.event.message_id,
        start_time: new Date(props.event.start_time_str),
        should_dm_users: props.should_dm_users
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","react-router":"djWTS","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../../../../common/time_format_utils":"g0uQN","../../../dashboard_utils":"jvA8A","../../../sesh_router":"hfnpE","../../../utils/trpc":"dyYvM","../../removing_throbber":"TmURk","../base_components/dashboard_container":"9WDu5","../base_components/sesh_primary_button":"3QyI2","../base_components/sesh_search_form":"lufGy","../hooks/use_channel_name":"hA9Qq","../hooks/use_doc_title":"bmu5s","../hooks/use_is_admin":"dsdqX","../hooks/use_user_context":"eU1k4","../listings_form/event/event_listing_form/date_table_data":"bdUOh","../listings_form/listings_form_table_data":"9UCxt","../listings_form/page_buttons":"5paOM","../member_display_name/member_display_name_with_tooltip":"7N9T1","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"geI3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTemplateId", ()=>useTemplateId);
var _useQueryParams = require("./use_query_params");
function useTemplateId() {
    const { template_id } = (0, _useQueryParams.useQueryParams)();
    let type, id;
    if (template_id) {
        [type, id] = template_id.split("_");
        return [
            template_id,
            type,
            id
        ];
    }
    return [
        undefined,
        undefined,
        undefined
    ];
}

},{"./use_query_params":"85qk7","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7PgND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserPreferencesModalContext", ()=>UserPreferencesModalContext);
parcelHelpers.export(exports, "useUserPreferencesModal", ()=>useUserPreferencesModal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const UserPreferencesModalContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    is_open: false,
    setIsOpen: (is_open)=>{}
});
function useUserPreferencesModal() {
    return (0, _react.useContext)(UserPreferencesModalContext);
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eq7hL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarSettingsPage", ()=>CalendarSettingsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../../../common/common_utils");
var _trpc = require("../../../../../../utils/trpc");
var _backButton = require("../../../../base_components/back_button");
var _dashboardContainer = require("../../../../base_components/dashboard_container");
var _copyableText = require("../../../../copyable_text");
var _disabler = require("../../../../disabler");
var _errorNote = require("../../../../error_note");
var _useBackLink = require("../../../../hooks/use_back_link");
var _useServerId = require("../../../../hooks/use_server_id");
var _settingsBooleanItem = require("../../../../settings_items/settings_boolean_item");
function CalendarSettingsPage() {
    const history = (0, _reactRouter.useHistory)();
    const back_link = (0, _useBackLink.useBackLink)();
    const server_id = (0, _useServerId.useServerId)();
    const isAdminQuery = (0, _trpc.trpc).members.isAdmin.useQuery({
        guild_id: server_id
    });
    const calendar_settings_query = (0, _trpc.trpc).calendar.settings.useQuery({
        guild_id: server_id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardContainer.DashboardContainer), {
        is_loading: !isAdminQuery.isSuccess || !calendar_settings_query.isSuccess,
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButton.BackButton), {
            label: "Back",
            onClick: ()=>history.push(back_link ?? (0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "event"))
        }),
        title: "Calendar Settings",
        children: [
            !isAdminQuery.data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
                error: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        "Must have ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Manage Sesh"
                        }),
                        " permissions to change sesh settings"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                disabled: !isAdminQuery.data,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PublicCalendarSetting, {
                            settings: calendar_settings_query.data
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShowNativeEventsSetting, {
                            settings: calendar_settings_query.data
                        })
                    ]
                })
            })
        ]
    });
}
function PublicCalendarSetting(props) {
    const server_id = (0, _useServerId.useServerId)();
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).calendar.updateSettings.useMutation({
        onSuccess: (data)=>{
            context.calendar.settings.setData((prev)=>{
                return {
                    ...prev,
                    ...data
                };
            }, {
                guild_id: server_id
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBooleanItem.SettingsBooleanItem), {
        label: "Publicly Accessible",
        description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Whether to make the calendar for this server publicly accessible. If enabled, users will not be required to log in to view this server's calendar."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "Public URL:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyableText.CopyableText), {
                            text: props.settings.is_public ? `https://sesh.fyi${(0, _commonUtils.common_utils).getGuildPublicCalendarURL(server_id)}` : "Disabled",
                            is_disabled: !props.settings.is_public
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-warning",
                    children: "Enabling this will reveal all events in all channels to everyone with the public URL."
                })
            ]
        }),
        is_loading: mutation.isLoading,
        onChange: (val)=>mutation.mutate({
                is_public: val,
                guild_id: server_id
            }),
        value: props.settings.is_public
    });
}
function ShowNativeEventsSetting(props) {
    const server_id = (0, _useServerId.useServerId)();
    const context = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).calendar.updateSettings.useMutation({
        onSuccess: (data)=>{
            context.calendar.settings.setData((prev)=>{
                return {
                    ...prev,
                    ...data
                };
            }, {
                guild_id: server_id
            });
            context.event.list.invalidate();
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBooleanItem.SettingsBooleanItem), {
        label: "Show Discord Native Events",
        description: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Whether to show Discord native events on this calendar. For more info on Discord events, see",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "manual-link",
                        href: "https://support.discord.com/hc/en-us/articles/4409494125719-Scheduled-Events",
                        children: "here."
                    })
                ]
            })
        }),
        is_loading: mutation.isLoading,
        onChange: (val)=>mutation.mutate({
                show_native_events: val,
                guild_id: server_id
            }),
        value: props.settings.show_native_events
    });
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../../../../../../../../common/common_utils":"gACUC","../../../../../../utils/trpc":"dyYvM","../../../../base_components/back_button":"hMqc2","../../../../base_components/dashboard_container":"9WDu5","../../../../copyable_text":"9BR87","../../../../disabler":"hF5sC","../../../../error_note":"kzA14","../../../../hooks/use_back_link":"jYQLe","../../../../hooks/use_server_id":"d0sLH","../../../../settings_items/settings_boolean_item":"eGiOr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9BR87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableText", ()=>CopyableText);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _inlineCode = require("./inline_code");
function CopyableText(props) {
    const [show_copied, setShowCopied] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: "inline-flex items-center gap-2 hover:text-sesh-primary",
        onClick: ()=>{
            if (props.is_disabled) return;
            setShowCopied(true);
            setTimeout(()=>setShowCopied(false), 1000);
            navigator.clipboard.writeText(props.text);
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineCode.InlineCode), {
                children: props.text
            }),
            !props.is_disabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-copy"
                    }),
                    show_copied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute -left-full -top-full text-sesh-primary opacity-80",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "",
                            children: "copied"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./inline_code":"f57of","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"f57of":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCode", ()=>InlineCode);
var _jsxRuntime = require("react/jsx-runtime");
function InlineCode(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "command-example--inline",
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jYQLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBackLink", ()=>useBackLink);
var _reactRouter = require("react-router");
function useBackLink() {
    const location = (0, _reactRouter.useLocation)();
    return location.state?.back_link;
}

},{"react-router":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eeO3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PollListingForm);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("csv-stringify/lib/index");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../common/common_utils");
var _constants = require("../../../../../../../common/constants");
var _dashboardUtils = require("../../../../dashboard_utils");
var _seshRouter = require("../../../../sesh_router");
var _trpc = require("../../../../utils/trpc");
var _removingThrobber = require("../../../removing_throbber");
var _dashboardContainer = require("../../base_components/dashboard_container");
var _seshPrimaryButton = require("../../base_components/sesh_primary_button");
var _seshSearchForm = require("../../base_components/sesh_search_form");
var _csvDownload = require("../../csv_download");
var _useDocTitle = require("../../hooks/use_doc_title");
var _pageButtons = require("../page_buttons");
var _pollRow = require("./poll_row");
var _pollRowDefault = parcelHelpers.interopDefault(_pollRow);
function PollListingForm() {
    (0, _useDocTitle.useDocTitle)("Polls");
    const { server_id } = (0, _reactRouter.useParams)();
    const context = (0, _trpc.trpc).useContext();
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const history = (0, _reactRouter.useHistory)();
    const guild_data = guild_list?.find((val)=>val.id === server_id);
    const csv_mutation = (0, _trpc.trpc).poll.listCsv.useMutation({
        onSuccess: (data)=>{
            (0, _index.stringify)(data, (err, output)=>{
                if (err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(err.toString());
                    return;
                }
                const element = document.createElement("a");
                const file = new Blob([
                    output
                ], {
                    type: "text/plain"
                });
                element.href = URL.createObjectURL(file);
                element.download = `polls_${server_id}.csv`;
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            });
        }
    });
    const [page, setPage] = (0, _react.useState)(0);
    const [sort, setSort] = (0, _react.useState)({
        type: "Created",
        direction: "ASC"
    });
    const [include_completed, setIncludeCompleted] = (0, _react.useState)(false);
    const [search, setSearch] = (0, _react.useState)("");
    const list_query = (0, _trpc.trpc).poll.list.useQuery({
        guild_id: server_id,
        include_completed,
        page,
        sort,
        search
    }, {
        staleTime: 5000,
        keepPreviousData: true,
        onSuccess: (data)=>{
            data.items.forEach((val)=>context.poll.getListItem.setData(()=>val, {
                    guild_id: server_id,
                    message_id: val.message_id
                }));
        }
    });
    if (!list_query.data || !guild_data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage()
    });
    const query_items = list_query.data?.items;
    const disabled = list_query.isPreviousData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
        title: "Poll Listings",
        size: "lg",
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
            link_chain_data: [
                (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(guild_data),
                (0, _dashboardUtils.DashboardUtils).RenderPollSelectionLinkChain(guild_data)
            ]
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("flex flex-col gap-2", {
                "input-disabled": disabled
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 sm:flex-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshSearchForm), {
                            onSubmit: setSearch,
                            placeholder: "Search by name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "cursor-pointer",
                            onClick: disabled ? undefined : ()=>setIncludeCompleted(!include_completed),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    className: "cursor-pointer",
                                    checked: include_completed,
                                    onChange: ()=>{}
                                }),
                                " ",
                                "Include completed polls"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _csvDownload.CSVDownload), {
                            is_loading: csv_mutation.isLoading,
                            onClick: ()=>csv_mutation.mutate({
                                    guild_id: server_id
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: (0, _classnamesDefault.default)("sesh-table listing-table responsive-table event-listings"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[27%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Created",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[23%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Name",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[12%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Channel",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[12%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Author",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[15%]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableTableHeader, {
                                            type: "Votes",
                                            current_sort: sort,
                                            setSort: setSort,
                                            is_loading: list_query.isPreviousData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "w-[11%] overflow-hidden overflow-ellipsis",
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: query_items && query_items.length > 0 ? query_items.map((val)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollRowDefault.default), {
                                    message_id: val.message_id
                                }, val.message_id);
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                className: "",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    colSpan: 6,
                                    className: "text-center",
                                    children: "No results found"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full flex-wrap-reverse gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-fit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                onClick: ()=>history.push((0, _commonUtils.common_utils).getPollCreateURL(server_id)),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 px-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-plus-circle"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "New Poll"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto",
                            children: list_query.data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageButtons.PageButtons), {
                                page: page,
                                total_items: list_query.data?.total_item_count ?? 0,
                                setPage: setPage,
                                is_loading: list_query.isPreviousData,
                                items_per_page: (0, _constants.Constants).LISTING_PAGINATION_LIMIT
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const OppositeSortMap = {
    ASC: "DESC",
    DESC: "ASC"
};
function SortableTableHeader(props) {
    const is_current_sort = props.current_sort.type === props.type;
    const is_pending_results = props.is_loading && is_current_sort;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("group flex flex-wrap items-center gap-1", {
            "cursor-pointer": !props.is_loading
        }),
        onClick: ()=>{
            if (props.is_loading) return;
            props.setSort({
                type: props.type,
                direction: is_current_sort ? OppositeSortMap[props.current_sort.direction] : "ASC"
            });
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "max-w-full overflow-hidden overflow-ellipsis",
                children: props.type
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: (0, _classnamesDefault.default)("group-hover:text-sesh-primary", {
                            hidden: is_pending_results,
                            "fas fa-sort text-base-light": !is_current_sort,
                            "fas fa-sort-down": is_current_sort && props.current_sort.direction === "DESC",
                            "fas fa-sort-up": is_current_sort && props.current_sort.direction === "ASC"
                        })
                    }),
                    is_pending_results && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
                ]
            }, `${props.type}_${props.current_sort.direction}_${is_current_sort}_${is_pending_results}`)
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","csv-stringify/lib/index":"i03fZ","react":"IMRgT","react-router":"djWTS","../../../../../../../common/common_utils":"gACUC","../../../../../../../common/constants":"lLiun","../../../../dashboard_utils":"jvA8A","../../../../sesh_router":"hfnpE","../../../../utils/trpc":"dyYvM","../../../removing_throbber":"TmURk","../../base_components/dashboard_container":"9WDu5","../../base_components/sesh_primary_button":"3QyI2","../../base_components/sesh_search_form":"lufGy","../../csv_download":"6sVFK","../../hooks/use_doc_title":"bmu5s","../page_buttons":"5paOM","./poll_row":"7aIcD","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7aIcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PollRow);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../common/common_utils");
var _constants = require("../../../../../../../common/constants");
var _dashboardUtils = require("../../../../dashboard_utils");
var _trpc = require("../../../../utils/trpc");
var _removingThrobber = require("../../../removing_throbber");
var _disableableLink = require("../../base_components/disableable_link");
var _useChannelName = require("../../hooks/use_channel_name");
var _useIsAdmin = require("../../hooks/use_is_admin");
var _useUserContext = require("../../hooks/use_user_context");
var _memberDisplayNameWithTooltip = require("../../member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
var _withTooltip = require("../../tooltips/with_tooltip");
var _listingsFormTableData = require("../listings_form_table_data");
var _dateTableData = require("./date_table_data");
function PollRow(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const history = (0, _reactRouter.useHistory)();
    const poll_query = (0, _trpc.trpc).poll.getListItem.useQuery({
        guild_id: server_id,
        message_id: props.message_id
    }, {
        staleTime: Infinity
    });
    const channel_name = (0, _useChannelName.useChannelName)(poll_query.data?.channel_id);
    if (!poll_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const poll = poll_query.data;
    const now_date = new Date();
    const is_in_past = poll.end_time && new Date(poll.end_time) < now_date;
    const classString = is_in_past ? "opacity-75" : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        className: classString,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTableData.DateTableData), {
                start_time_js_date: new Date(poll.created_at),
                end_time_js_date: new Date(poll.created_at),
                repeat_data: undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: poll.poll_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listingsFormTableData.ListingsFormTableData), {
                content: channel_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                    user_id: poll.author_id,
                    tooltip_type: "SeshTooltip"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _disableableLink.DisableableLink), {
                    className: "manual-link",
                    to: (0, _commonUtils.common_utils).getPollResultsURL(server_id, poll.message_id),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-poll"
                        }),
                        " ",
                        poll.vote_count
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditAction, {
                    guild_id: server_id,
                    poll: poll
                })
            })
        ]
    });
}
function EditAction(props) {
    const [is_removing, setIsRemoving] = (0, _react.useState)(false);
    const user = (0, _useUserContext.useUserContext)();
    const is_admin_query = (0, _useIsAdmin.useIsAdmin)();
    const context = (0, _trpc.trpc).useContext();
    if (is_removing || !is_admin_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
    });
    const is_poll_creator = user?.id === props.poll.author_id;
    const has_edit_poll_perms = is_admin_query.data || is_poll_creator;
    const has_poll_ended = props.poll.end_time && new Date(props.poll.end_time) < new Date();
    const cannot_edit_event_tooltip_text = "Must be event creator or have Manage Sesh permissions to modify events";
    const edit_disabled = has_poll_ended || !has_edit_poll_perms;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-full flex-wrap justify-center gap-6 sm:gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disableableLink.DisableableLink), {
                    to: (0, _commonUtils.common_utils).getPollEditURL(props.guild_id, props.poll.message_id),
                    is_disabled: edit_disabled,
                    tooltip: has_poll_ended ? "Can not edit completed or ongoing polls" : has_edit_poll_perms ? "Edit poll" : cannot_edit_event_tooltip_text,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-pencil-alt"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: "View in Discord",
                    disable_click: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "manual-link",
                        href: `${(0, _constants.Constants).DISCORD_LINK_PREFIX}${props.guild_id}/${props.poll.channel_id}/${props.poll.message_id}`,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-external-link-alt"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                    style: "Info",
                    tooltip: has_edit_poll_perms ? "Delete poll" : cannot_edit_event_tooltip_text,
                    disable_click: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: (0, _classnamesDefault.default)({
                            "input-disabled text-gray-400": !has_edit_poll_perms,
                            "text-warning hover:text-warning-hover": has_edit_poll_perms
                        }),
                        onClick: ()=>{
                            if (!has_edit_poll_perms) return;
                            onDeleteClicked(context, props.poll, props.guild_id, user, setIsRemoving);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "far fa-trash-alt"
                        })
                    })
                })
            ]
        })
    });
}
async function onDeleteClicked(context, poll, guild_id, auth_token, setPollPendingDelete) {
    const confirmation_result = await (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "Are you sure you want to permanently delete poll",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: poll.poll_name
            }),
            "?"
        ]
    }));
    if (!confirmation_result.isConfirmed) return;
    setPollPendingDelete(true);
    deletePoll(auth_token, guild_id, poll.message_id).then((val)=>{
        setPollPendingDelete(false);
        if (val.db_success) context.poll.list.invalidate();
    });
}
async function deletePoll(auth_token, guild_id, message_id) {
    const request_body = {
        access_token: auth_token.access_token,
        token_type: auth_token.token_type,
        guild_id,
        message_id
    };
    return fetch("/api/delete_poll", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
            return value;
        }));
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router":"djWTS","../../../../../../../common/common_utils":"gACUC","../../../../../../../common/constants":"lLiun","../../../../dashboard_utils":"jvA8A","../../../../utils/trpc":"dyYvM","../../../removing_throbber":"TmURk","../../base_components/disableable_link":"6Sjx5","../../hooks/use_channel_name":"hA9Qq","../../hooks/use_is_admin":"dsdqX","../../hooks/use_user_context":"eU1k4","../../member_display_name/member_display_name_with_tooltip":"7N9T1","../../tooltips/with_tooltip":"bOdAf","../listings_form_table_data":"9UCxt","./date_table_data":"j3jtd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j3jtd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTableData", ()=>DateTableData);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _withTooltip = require("../../tooltips/with_tooltip");
function DateTableData(props) {
    const { start_time_js_date, end_time_js_date, repeat_data } = props;
    const start_time = _luxon.DateTime.fromJSDate(start_time_js_date);
    const end_time = _luxon.DateTime.fromJSDate(end_time_js_date);
    const date = start_time.toLocaleString({
        month: "short",
        day: "2-digit"
    });
    const full_date = start_time.toLocaleString({
        dateStyle: "full",
        timeStyle: "short"
    });
    const time = start_time.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    const end_time_string = end_time.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    let repeat_element;
    let datatip_strings = [
        full_date
    ];
    if (repeat_data) {
        repeat_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-redo"
        });
        datatip_strings.push(repeat_data.repeat_text);
    }
    const datatip = datatip_strings.join("<br />");
    const date_string = `${date} ${time} - ${end_time_string}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        className: "w-full",
        "data-tip": datatip,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
            style: "Info",
            tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: full_date
                    }),
                    repeat_data?.repeat_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: repeat_data.repeat_text
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full min-w-0 items-center gap-2 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "ellipsis-overflow max-w-full flex-shrink-0 overflow-hidden whitespace-nowrap",
                        children: date_string
                    }),
                    repeat_element
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","../../tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hW22W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navbar", ()=>Navbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _seshRouter = require("../../sesh_router");
var _withDropdownImproved = require("./base_components/with_dropdown_improved");
var _useUserPreferencesModal = require("./hooks/use_user_preferences_modal");
var _manualButton = require("./navbar/manual_button");
var _premiumButton = require("./navbar/premium_button");
var _navbarBase = require("./NavbarBase");
var _staticNavbar = require("./StaticNavbar");
function Navbar(props) {
    if (props.type === "static") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staticNavbar.StaticNavbar), {});
    else if (props.type === "dashboard") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DashboardNavbar, {
        ...props
    });
    else return null;
}
function DashboardNavbar(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarBase.NavbarBase), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column is-narrow topnav-right",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-vcentered is-mobile",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow is-hidden-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _manualButton.ManualButton), {
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow is-hidden-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumButton.PremiumButton), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow is-hidden-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/blog",
                            children: "Blog"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarSection, {
                        user_data: props.user_data,
                        sesh_client_id: props.sesh_client_id,
                        discord_auth_token: props.discord_auth_token
                    })
                ]
            })
        })
    });
}
function AvatarSection(props) {
    const history = (0, _reactRouter.useHistory)();
    const { setIsOpen } = (0, _useUserPreferencesModal.useUserPreferencesModal)();
    if (props.user_data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "ml-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-vcentered",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow avatar-right-padding pointer-events-on",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                        className: "image is-square h-8 w-8 cursor-pointer sm:h-12 sm:w-12",
                        onClick: ()=>history.push("/dashboard/"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "is-rounded",
                            src: props.user_data.avatar_uri
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "pointer-events-on mx-2 hidden items-center gap-2 sm:flex",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownImproved.WithDropdownImproved), {
                        alignment: "middle",
                        items: [
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-credit-card"
                                }),
                                label: "Billing",
                                type: "link",
                                close_on_click: true,
                                props: {
                                    to: "/dashboard/premium"
                                }
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-cog"
                                }),
                                label: "Preferences",
                                type: "button",
                                close_on_click: true,
                                props: {
                                    onClick: ()=>{
                                        setIsOpen(true);
                                    }
                                }
                            },
                            {
                                type: "divider"
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-sign-out-alt"
                                }),
                                label: "Logout",
                                type: "button",
                                props: {
                                    onClick: ()=>{
                                        (0, _seshRouter.redirectToDiscordAuth)(props.sesh_client_id, props.discord_auth_token.access_token);
                                    }
                                },
                                is_warning: true
                            }
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-bold",
                                    children: props.user_data.username
                                }),
                                props.user_data.discriminator !== "0" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        "#",
                                        props.user_data.discriminator
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-down"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "pointer-events-on mx-2 flex items-center gap-2 sm:hidden",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownImproved.WithDropdownImproved), {
                        alignment: "right",
                        items: [
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-book"
                                }),
                                type: "a",
                                label: "Manual",
                                props: {
                                    href: "/manual"
                                }
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-crown"
                                }),
                                type: "link",
                                label: "Premium",
                                props: {
                                    to: {
                                        pathname: "/dashboard/premium",
                                        state: {
                                            prev_path: location.pathname
                                        }
                                    }
                                }
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-newspaper"
                                }),
                                type: "a",
                                label: "Blog",
                                props: {
                                    href: "/blog"
                                }
                            },
                            {
                                type: "divider"
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-cog"
                                }),
                                label: "Preferences",
                                type: "button",
                                props: {
                                    onClick: ()=>{
                                        setIsOpen(true);
                                    }
                                }
                            },
                            {
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-sign-out-alt"
                                }),
                                label: "Logout",
                                type: "button",
                                props: {
                                    onClick: ()=>{
                                        (0, _seshRouter.redirectToDiscordAuth)(props.sesh_client_id, props.discord_auth_token.access_token);
                                    }
                                },
                                is_warning: true
                            }
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-bold",
                                    children: props.user_data.username
                                }),
                                props.user_data.discriminator !== "0" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        "#",
                                        props.user_data.discriminator
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-down"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow pointer-events-on",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "#",
                        onClick: ()=>{
                            (0, _seshRouter.redirectToDiscordAuth)(props.sesh_client_id, props.discord_auth_token.access_token);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "has-text-left",
                            children: "Logout"
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../sesh_router":"hfnpE","./base_components/with_dropdown_improved":"iYgdS","./hooks/use_user_preferences_modal":"7PgND","./navbar/manual_button":"2kgi1","./navbar/premium_button":"bmd7B","./NavbarBase":"cxd2x","./StaticNavbar":"lITN2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bmd7B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumButton", ()=>PremiumButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
function PremiumButton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        className: "flex gap-2",
        to: {
            pathname: "/dashboard/premium",
            state: {
                prev_path: location.pathname
            }
        },
        children: "Premium"
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"3XSn5","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c9Srw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumPage", ()=>PremiumPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _webUi = require("../../../web_ui");
var _backButton = require("../base_components/back_button");
var _dashboardContainer = require("../base_components/dashboard_container");
var _premiumActivePurchaseListings = require("./premium_active_purchase_listings");
var _pricingTable = require("./pricing_table");
var _restoreDiscordPurchasesButton = require("./restore_discord_purchases_button");
var _gifFeatureSections = require("../../../../ssr/premium/components/gif-feature-sections");
var _featureComparisonTable = require("../../../../ssr/premium/components/feature-comparison-table");
var _customBotCard = require("../../../../ssr/premium/components/custom-bot-card");
var _simpleContactModal = require("../../../../ssr/premium/components/simple-contact-modal");
function PremiumPage(props) {
    (0, _react.useEffect)(()=>{
        (0, _webUi.setDocTitle)("Premium");
    }, []);
    const [showContactModal, setShowContactModal] = (0, _react.useState)(false);
    const history = (0, _reactRouter.useHistory)();
    const prices_query = (0, _trpc.trpc).premium.getAllProductsPrices.useQuery();
    const premium_details_query = (0, _trpc.trpc).premium.getUserPremiumDetails.useQuery();
    if (!prices_query.isSuccess || !premium_details_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
                title: "Premium",
                size: "lg",
                bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButton.BackButton), {
                    label: "Back",
                    onClick: ()=>{
                        history.push(props.back_link ?? "/dashboard/");
                    }
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumActivePurchaseListings.PremiumActivePurchaseListings), {
                            premium_details_query: premium_details_query
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricingTable.PricingTable), {
                            link_type: "Link",
                            current_pricing: prices_query.data,
                            has_used_free_trial: premium_details_query.data.has_used_stripe_free_trial
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _restoreDiscordPurchasesButton.RestoreDiscordPurchasesButton), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gifFeatureSections.GifFeatureSections), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureComparisonTable.FeatureComparisonTable), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-16",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customBotCard.CustomBotCard), {
                                onContactClick: ()=>setShowContactModal(true)
                            })
                        })
                    ]
                })
            }),
            showContactModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleContactModal.SimpleContactModal), {
                onClose: ()=>setShowContactModal(false)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../../../web_ui":"7f1Tj","../base_components/back_button":"hMqc2","../base_components/dashboard_container":"9WDu5","./premium_active_purchase_listings":"dPpVM","./pricing_table":"iyQuU","./restore_discord_purchases_button":"3Z9BR","../../../../ssr/premium/components/gif-feature-sections":"1o5nb","../../../../ssr/premium/components/feature-comparison-table":"cs05g","../../../../ssr/premium/components/custom-bot-card":"lWy2J","../../../../ssr/premium/components/simple-contact-modal":"1ki67","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dPpVM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumActivePurchaseListings", ()=>PremiumActivePurchaseListings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useQueryParams = require("../hooks/use_query_params");
var _infoTooltip = require("../tooltips/info_tooltip");
var _discordEntitlement = require("./entitlements/discord_entitlement");
var _patreonEntitlement = require("./entitlements/patreon_entitlement");
var _stripeEntitlement = require("./entitlements/stripe_entitlement");
var _premiumServerListingsModal = require("./premium_server_listings_modal");
function PremiumActivePurchaseListings({ premium_details_query }) {
    const query_params = (0, _useQueryParams.useQueryParams)();
    const [premium_modal_opened, setPremiumModalOpened] = (0, _react.useState)(query_params.success);
    if (!premium_details_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            premium_details_query.data.discord_entitlements.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex items-center gap-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex gap-2 text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: "Discord Purchases"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                        info: "List of sesh premium purchases bought through Discord. Each individual subscription is tied to the server it is purchased for, whereas one-time purchases can be freely transferred between servers. If you wish to modify these subscriptions, you must do so through Discord."
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex w-full flex-col gap-2",
                        children: premium_details_query.data.discord_entitlements.length > 0 && premium_details_query.data.discord_entitlements.map((val)=>/*#__PURE__*/ (0, _react.createElement)((0, _discordEntitlement.DiscordEntitlement), {
                                ...val,
                                key: val.id
                            }))
                    })
                ]
            }),
            premium_details_query.data.max_activated_servers > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-2 text-lg font-bold",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Stripe Purchases"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                            info: "List of sesh premium subscriptions bought through Stripe or Patreon. These subscriptions can be transferred to other servers freely. If you subscribe to more than one tier, your premium server activation count will include all of your purchases and be cumulative."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ml-auto",
                                children: [
                                    "Activated Servers:",
                                    " ",
                                    premium_details_query.data.transferrable_activated_servers_count,
                                    "/",
                                    premium_details_query.data.max_activated_servers,
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "manual-link",
                                        onClick: ()=>setPremiumModalOpened(true),
                                        children: "Manage"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full flex-col gap-2",
                        children: [
                            premium_details_query.data.stripe_entitlements.length > 0 && premium_details_query.data.stripe_entitlements.map((val)=>/*#__PURE__*/ (0, _react.createElement)((0, _stripeEntitlement.StripeEntitlement), {
                                    ...val,
                                    key: val.id
                                })),
                            premium_details_query.data.patreon_activations > 0 && premium_details_query.data.is_patreon_purely_from_override && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _patreonEntitlement.PatreonEntitlement), {
                                ...premium_details_query.data
                            })
                        ]
                    })
                ]
            }),
            premium_modal_opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumServerListingsModal.PremiumServerListingsModal), {
                premium_details: premium_details_query.data,
                onClose: ()=>setPremiumModalOpened(false)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../hooks/use_query_params":"85qk7","../tooltips/info_tooltip":"93rAL","./entitlements/discord_entitlement":"cyL4j","./entitlements/patreon_entitlement":"hG4uI","./entitlements/stripe_entitlement":"9cNtY","./premium_server_listings_modal":"5GZsY","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hG4uI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PatreonEntitlement", ()=>PatreonEntitlement);
var _jsxRuntime = require("react/jsx-runtime");
var _constants = require("../../../../../../../common/constants");
var _genericEntitlement = require("./generic_entitlement");
function PatreonEntitlement(props) {
    const title = props.patreon_activations > 3 ? "Sesh Premium Plus" : "Sesh Premium";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericEntitlement.GenericEntitlement), {
        type: "Patreon",
        title: title,
        modify_link: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            href: (0, _constants.Constants).PATREON_LINK,
            target: "_blank",
            className: "secondary-link",
            children: "Modify"
        }),
        details: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Activations Granted:",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: props.patreon_activations
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Status: ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-bold",
                            children: "active"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../../../../common/constants":"lLiun","./generic_entitlement":"tOvUS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5GZsY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumServerListingsModal", ()=>PremiumServerListingsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../../../common/common_utils");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshRouter = require("../../../sesh_router");
var _trpc = require("../../../utils/trpc");
var _modifySettingsButton = require("../base_components/modify_settings_button");
var _infoTooltip = require("../tooltips/info_tooltip");
function PremiumServerListingsModal(props) {
    const subtitle = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex items-center justify-center justify-items-center gap-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                props.premium_details.transferrable_activated_servers_count,
                "/",
                props.premium_details.max_activated_servers,
                " transferrable activations",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "You can activate servers here or by running the",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "command-example",
                                children: "/premium"
                            }),
                            " ",
                            "command in a server"
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        onClose: props.onClose,
        title: "Manage Premium Servers",
        subtitle: subtitle,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PremiumServersListingContent, {
            activated_guilds: props.premium_details.activated_guilds
        })
    });
}
function PremiumServersListingContent(props) {
    const guild_list = (0, _react.useContext)((0, _seshRouter.GuildListContext));
    const modifiable_server_ids = props.activated_guilds.map((val)=>val.id);
    const filtered_guild_list = guild_list.filter((val)=>!modifiable_server_ids.includes(val.id) && val.has_sesh);
    // TODO: get the icon URL so we can display proper image
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mt-4 flex h-fit max-h-[90%] min-h-0 overflow-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
            className: "flex min-h-0 w-full flex-col gap-2 overflow-auto",
            children: [
                props.activated_guilds.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerListing, {
                        ...val,
                        icon: guild_list.find((data)=>data.id === val.id)?.icon,
                        is_deactivatable: true
                    }, val.id)),
                filtered_guild_list.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerListing, {
                        ...val,
                        is_deactivatable: false,
                        is_discord_entitlement: false
                    }, val.id))
            ]
        })
    });
}
function ServerListing(props) {
    const icon = (0, _dashboardUtils.DashboardUtils).GetGuildIconURI({
        id: props.id,
        icon: props.icon
    }, 64);
    const cta = props.is_deactivatable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SeverListingPremiumButton, {
        ...props
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: (0, _commonUtils.common_utils).getGuildSettingsURL(props.id, "premium"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
            children: "Activate"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
        className: "flex items-center gap-2 rounded-sm bg-base-light shadow-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-full w-[5rem] rounded-l-sm bg-base-dark p-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                    className: "image flex h-full w-full items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "is-rounded h-full w-full",
                        src: icon
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-full flex-col items-center gap-2 p-2 sm:flex-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-center text-base sm:text-left sm:text-lg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-bold",
                                    children: props.name
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-xs",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-mono",
                                    children: props.id
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "sm:ml-auto",
                        children: cta
                    })
                ]
            })
        ]
    });
}
function SeverListingPremiumButton(props) {
    const [is_loading, setIsLoading] = (0, _react.useState)(false);
    const mutation = (0, _trpc.trpc).premium.modifyPremiumStatus.useMutation();
    const context = (0, _trpc.trpc).useContext();
    if (props.is_discord_entitlement) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Discord Subscription"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    className: "manual-link",
                    target: "_blank",
                    href: (0, _constants.Constants).DISCORD_PREMIUM_MANAGEMENT_FAQ_LINK,
                    children: [
                        "Manage ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-external-link-alt"
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: (0, _classnamesDefault.default)("button dashboard-warning-button ml-auto w-fit", {
            "is-loading": is_loading
        }),
        onClick: ()=>{
            setIsLoading(true);
            mutation.mutate({
                guild_id: props.id,
                modification: "Deactivate"
            }, {
                onSuccess: ()=>{
                    setIsLoading(false);
                    context.premium.getUserPremiumDetails.invalidate();
                }
            });
        },
        children: "Deactivate"
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router-dom":"3XSn5","../../../../../../common/common_utils":"gACUC","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../../../sesh_router":"hfnpE","../../../utils/trpc":"dyYvM","../base_components/modify_settings_button":"kbhTg","../tooltips/info_tooltip":"93rAL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3Z9BR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestoreDiscordPurchasesButton", ()=>RestoreDiscordPurchasesButton);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _trpc = require("../../../utils/trpc");
var _removingThrobber = require("../../removing_throbber");
var _reactHotToast = require("react-hot-toast");
function RestoreDiscordPurchasesButton() {
    const utils = (0, _trpc.trpc).useContext();
    const mutation = (0, _trpc.trpc).premium.restoreDiscordPurchases.useMutation({
        onSuccess: ()=>{
            utils.premium.getUserPremiumDetails.invalidate();
            (0, _reactHotToast.toast).success("Purchases restored successfully!");
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-8 flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)({
                    invisible: !mutation.isLoading
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>mutation.mutate(),
                className: (0, _classnamesDefault.default)("manual-link", {
                    "input-disabled": mutation.isLoading
                }),
                children: "Restore Purchases"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../../utils/trpc":"dyYvM","../../removing_throbber":"TmURk","react-hot-toast":"iYXGG","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"klRLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StripeRedirectPage", ()=>StripeRedirectPage);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _useQueryParams = require("../hooks/use_query_params");
function StripeRedirectPage() {
    const params = (0, _useQueryParams.useQueryParams)();
    if (params.type === "checkout") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RedirectToCheckout, {
        product_id: params.product_id,
        subscription_span: Number.parseInt(params.subscription_span),
        should_force_no_coupon: params.should_force_no_coupon === "true"
    });
    else if (params.type === "manager") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RedirectToManagement, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {});
}
function RedirectToCheckout(props) {
    (0, _trpc.trpc).premium.getStripeCheckoutRedirect.useQuery(props, {
        onSuccess: (data)=>{
            window.location.replace(data.url);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {
        text: "Redirecting to Stripe checkout..."
    });
}
function RedirectToManagement() {
    (0, _trpc.trpc).premium.getStripeManagerRedirect.useQuery(undefined, {
        onSuccess: (data)=>{
            window.location.replace(data.url);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {
        text: "Redirecting to Stripe billing..."
    });
}

},{"react/jsx-runtime":"dpQXr","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../hooks/use_query_params":"85qk7","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6VxYK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RSVPDisplayFormPage", ()=>RSVPDisplayFormPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../common/common_utils");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _backButton = require("../base_components/back_button");
var _dashboardContainer = require("../base_components/dashboard_container");
var _csvDownload = require("../csv_download");
var _usePrevPage = require("../hooks/use_prev_page");
var _rsvpList = require("./rsvp_list");
var _index = require("csv-stringify/lib/index");
var _useDocTitle = require("../hooks/use_doc_title");
function RSVPDisplayFormPage() {
    const history = (0, _reactRouter.useHistory)();
    const prev_page = (0, _usePrevPage.usePreviousPage)();
    let { server_id, message_id } = (0, _reactRouter.useParams)();
    const csv_download_mutation = (0, _trpc.trpc).event.rsvpedUsersCsv.useMutation({
        onSuccess: (data)=>{
            (0, _index.stringify)(data, (err, output)=>{
                if (err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(err.toString());
                    return;
                }
                const element = document.createElement("a");
                const file = new Blob([
                    output
                ], {
                    type: "text/plain"
                });
                element.href = URL.createObjectURL(file);
                element.download = `attendee_data_${message_id}.csv`;
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            });
        }
    });
    const event_query = (0, _trpc.trpc).event.getListItem.useQuery({
        guild_id: server_id,
        message_id
    }, {
        staleTime: Infinity
    });
    (0, _useDocTitle.useDocTitle)(event_query.data?.name ? `${event_query.data.name} RSVPers` : `RSVPs`);
    if (event_query.isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderDashboardErrorPage, {
        title: "Error 404",
        text: `Event ${message_id} not found.`
    });
    if (!event_query.isSuccess) return (0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage();
    const has_event_ended = new Date(event_query.data.end_time_str) < new Date();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardContainer.DashboardContainer), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    children: (0, _dashboardUtils.DashboardUtils).LimitName(event_query.data.name, 16)
                }),
                " ",
                "RSVPs"
            ]
        }),
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButton.BackButton), {
            label: prev_page?.label ?? "Back",
            onClick: ()=>{
                history.push(prev_page?.url ?? (0, _commonUtils.common_utils).getEventListURL(server_id));
            }
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ml-auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _csvDownload.CSVDownload), {
                        onClick: ()=>csv_download_mutation.mutate({
                                guild_id: server_id,
                                message_id
                            }),
                        is_loading: csv_download_mutation.isLoading
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col gap-8",
                    children: event_query.data.rsvp_options.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpList.RSVPList), {
                            option: val,
                            has_event_ended: has_event_ended
                        }, val.id))
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../../../../../common/common_utils":"gACUC","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/back_button":"hMqc2","../base_components/dashboard_container":"9WDu5","../csv_download":"6sVFK","../hooks/use_prev_page":"280iA","./rsvp_list":"TBnfW","csv-stringify/lib/index":"i03fZ","../hooks/use_doc_title":"bmu5s","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"280iA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePreviousPage", ()=>usePreviousPage);
var _reactRouter = require("react-router");
function usePreviousPage() {
    const location = (0, _reactRouter.useLocation)();
    return location.state?.prev_page;
}

},{"react-router":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"TBnfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionStringified", ()=>getOptionStringified);
parcelHelpers.export(exports, "RSVPList", ()=>RSVPList);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactRouter = require("react-router");
var _constants = require("../../../../../../common/constants");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _removingThrobber = require("../../removing_throbber");
var _useIsAdmin = require("../hooks/use_is_admin");
var _useRsvpedUsers = require("../hooks/use_rsvped_users");
var _useUserContext = require("../hooks/use_user_context");
var _inlineEmoji = require("../inline_emoji");
var _memberDisplayNameWithTooltip = require("../member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
var _withTooltip = require("../tooltips/with_tooltip");
var _addRsvpModal = require("./add_rsvp_modal");
function getOptionStringified(option, rsvp_count) {
    const emoji_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineEmoji.InlineEmoji), {
        option: option
    });
    const option_name = option.name;
    const count = rsvp_count != null ? `(${rsvp_count}${option.limit ? `/${option.limit}` : ""})` : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            emoji_element,
            " ",
            option_name,
            " ",
            option.limit != null && count != null && count
        ]
    });
}
async function removeRSVPersFromEvent(request_body) {
    return fetch(`/api/remove_rsvpers_from_event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if ("err" in value) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
function RSVPList(props) {
    const user_context = (0, _useUserContext.useUserContext)();
    const context = (0, _trpc.trpc).useContext();
    const [is_modal_active, setModalActive] = (0, _react.useState)(false);
    const [selected_ids_to_remove, setSelectedIdsToRemove] = (0, _react.useState)([]);
    const [is_loading_remove, setIsLoadingRemove] = (0, _react.useState)(false);
    const is_admin_query = (0, _useIsAdmin.useIsAdmin)();
    let { server_id, message_id } = (0, _reactRouter.useParams)();
    const rsvpers_query = (0, _useRsvpedUsers.useRSVPedUsers)(server_id, message_id, props.option.id);
    const is_max_num_of_rsvpers_selected = selected_ids_to_remove.length >= (0, _constants.Constants).MODIFY_RSVPERS_LIMIT;
    const is_admin = Boolean(is_admin_query.data);
    const rsvp_rows = [];
    if (rsvpers_query.isSuccess) {
        let index = 0;
        if (rsvpers_query.data.length > 0) for(let i = 0; i < rsvpers_query.data.length; i++){
            const rsvper = rsvpers_query.data[i];
            let state = undefined;
            if (selected_ids_to_remove.includes(rsvper.id)) {
                if (is_loading_remove) state = "Removing";
                else state = "Selected";
            } else state = "Unselected";
            rsvp_rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RSVPRow, {
                user_id: rsvper.id,
                index: index,
                is_last: i === rsvpers_query.data.length - 1,
                is_disabled: is_loading_remove,
                can_remove: is_admin && !props.has_event_ended,
                remove_state: state,
                onClick: (user_id)=>{
                    setSelectedIdsToRemove((val)=>{
                        const existing = val.indexOf(user_id);
                        const copy = [
                            ...val
                        ];
                        if (existing > -1) {
                            copy.splice(existing, 1);
                            return copy;
                        }
                        if (!is_max_num_of_rsvpers_selected) copy.push(user_id);
                        return copy;
                    });
                }
            }, index));
            if (props.option.limit && i === props.option.limit - 1) {
                index++;
                rsvp_rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RawRSVPRow, {
                    className: "px-4 py-3",
                    index: index,
                    is_last: i === rsvpers_query.data.length - 1,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex w-full flex-col font-bold",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "mx-auto",
                            children: "Waitlist"
                        })
                    })
                }, index));
            }
            index++;
        }
        else rsvp_rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RawRSVPRow, {
            className: "px-4 py-3",
            index: 0,
            is_last: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center gap-2",
                children: "None"
            })
        }, "None"));
    } else rsvp_rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RawRSVPRow, {
        index: 0,
        is_last: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2 px-4 py-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "Loading..."
                })
            ]
        })
    }, "Loading"));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-11/12 flex-col sm:w-3/4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "bg-base-dark px-4 py-3 font-bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    getOptionStringified(props.option, rsvpers_query.data?.length),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-auto flex flex-shrink-0 gap-4 text-lg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                                            tooltip: `Add users${is_admin ? "" : " (requires Manage Sesh permission)"}`,
                                            style: "Info",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: (0, _classnamesDefault.default)({
                                                    "text-link hover:cursor-pointer hover:text-link-hover": is_admin,
                                                    "cursor-not-allowed text-gray-400": !is_admin,
                                                    hidden: props.has_event_ended
                                                }),
                                                onClick: ()=>{
                                                    if (!is_admin_query.data) return;
                                                    setModalActive(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-user-plus"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-base",
                                                        children: "Add"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex max-h-[50vh] w-full flex-col self-start overflow-y-auto",
                            children: rsvp_rows
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _classnamesDefault.default)("ml-auto font-bold text-warning hover:cursor-pointer hover:text-warning-hover", {
                                invisible: selected_ids_to_remove.length === 0 || is_loading_remove || !is_admin || props.has_event_ended
                            }),
                            onClick: ()=>{
                                setIsLoadingRemove(true);
                                removeRSVPersFromEvent({
                                    access_token: user_context.access_token,
                                    token_type: user_context.token_type,
                                    event_id: message_id,
                                    guild_id: server_id,
                                    option_emoji: props.option.emoji,
                                    rsvpers_to_modify: selected_ids_to_remove
                                }).then((val)=>{
                                    setIsLoadingRemove(false);
                                    if ("err" in val) return;
                                    context.event.rsvpedUsers.setData((data)=>data.filter((val)=>!selected_ids_to_remove.includes(val.id)), {
                                        guild_id: server_id,
                                        message_id: message_id,
                                        rsvp_option_id: props.option.id
                                    });
                                    setSelectedIdsToRemove([]);
                                });
                            },
                            title: "Remove users",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-base",
                                children: [
                                    "Remove Selected Users (",
                                    `${selected_ids_to_remove.length ?? 0}${is_max_num_of_rsvpers_selected ? ", MAX" : ""}`,
                                    ")"
                                ]
                            })
                        })
                    ]
                })
            }),
            is_modal_active && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addRsvpModal.RSVPModal), {
                closeModal: ()=>setModalActive(false),
                current_rsvp_ids: rsvpers_query.data.map((val)=>val.id),
                rsvp_option: props.option
            })
        ]
    });
}
function RSVPRow(props) {
    let remove_element;
    switch(props.remove_state){
        case "Unselected":
            remove_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-times opacity-20 group-hover:opacity-100"
            });
            break;
        case "Selected":
            remove_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-times-circle text-warning"
            });
            break;
        case "Removing":
            remove_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {});
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RawRSVPRow, {
        className: (0, _classnamesDefault.default)("group", {
            "cursor-pointer": props.can_remove
        }),
        index: props.index,
        is_last: props.is_last,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "relative w-full",
            onClick: ()=>{
                props.is_disabled ? undefined : props.onClick(props.user_id);
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full px-4 py-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                            user_id: props.user_id,
                            include_discriminator: true,
                            include_avatar: true
                        }),
                        props.can_remove && (!props.is_disabled || props.remove_state !== "Unselected") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ml-auto flex w-8 flex-shrink-0 justify-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: remove_element
                            }, props.remove_state)
                        })
                    ]
                }),
                props.can_remove && props.remove_state !== "Unselected" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "pointer-events-none absolute left-0 top-0 flex h-full w-full bg-warning px-4 py-3 opacity-20"
                })
            ]
        })
    });
}
function RawRSVPRow(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _classnamesDefault.default)(props.className, "group w-full border border-base-dark", {
            "bg-base-primary": props.index % 2 !== 0,
            "bg-base-light": props.index % 2 === 0,
            "border-b": props.is_last,
            "border-b-0": !props.is_last
        }),
        children: props.children
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router":"djWTS","../../../../../../common/constants":"lLiun","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../../removing_throbber":"TmURk","../hooks/use_is_admin":"dsdqX","../hooks/use_rsvped_users":"dF3WI","../hooks/use_user_context":"eU1k4","../inline_emoji":"39PEk","../member_display_name/member_display_name_with_tooltip":"7N9T1","../tooltips/with_tooltip":"bOdAf","./add_rsvp_modal":"jREgi","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dF3WI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRSVPedUsers", ()=>useRSVPedUsers);
var _trpc = require("../../../utils/trpc");
var _useGuildMemberCache = require("./use_guild_member_cache");
function useRSVPedUsers(guild_id, message_id, rsvp_option_id) {
    const members_cache = (0, _useGuildMemberCache.useGuildMemberCache)();
    const rsvpers_query = (0, _trpc.trpc).event.rsvpedUsers.useQuery({
        guild_id,
        message_id,
        rsvp_option_id
    }, {
        onSuccess: (data)=>{
            members_cache.addMembers(guild_id, data);
        }
    });
    return rsvpers_query;
}

},{"../../../utils/trpc":"dyYvM","./use_guild_member_cache":"fDOuW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jREgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RSVPModal", ()=>RSVPModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _useUserContext = require("../hooks/use_user_context");
var _membersSearchDropdown = require("../members_search_dropdown");
var _rsvpList = require("./rsvp_list");
var _constants = require("../../../../../../common/constants");
async function addRSVPersToEvent(request_body) {
    return fetch(`/api/add_rsvpers_to_event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if ("err" in value) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
function RSVPModal(props) {
    const user_context = (0, _useUserContext.useUserContext)();
    let { server_id, message_id } = (0, _reactRouter.useParams)();
    const context = (0, _trpc.trpc).useContext();
    const [pending_user_ids, setPendingUserIds] = (0, _react.useState)([]);
    const [is_loading, setIsLoading] = (0, _react.useState)(false);
    const title = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "title-icon fas fa-user-plus"
            }),
            "Select Users to Add"
        ]
    });
    const ids_to_ignore = props.current_rsvp_ids;
    let member_select = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _membersSearchDropdown.MembersSearchDropdown), {
        selected_ids: pending_user_ids,
        onUpdate: setPendingUserIds,
        disabled_ids: ids_to_ignore,
        guild_id: server_id,
        limit: (0, _constants.Constants).MODIFY_RSVPERS_LIMIT
    });
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile is-multiline",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full !mb-0 pb-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "note",
                    children: "Selected users will be informed of RSVP via direct message."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: member_select
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "is-pulled-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `button dashboard-primary-button--tiny is-size-6 has-text-right ${is_loading ? "is-loading" : ""}`,
                        type: "submit",
                        disabled: pending_user_ids.length === 0,
                        onClick: ()=>{
                            setIsLoading(true);
                            addRSVPersToEvent({
                                access_token: user_context.access_token,
                                token_type: user_context.token_type,
                                event_id: message_id,
                                guild_id: server_id,
                                option_emoji: props.rsvp_option.emoji,
                                rsvpers_to_modify: pending_user_ids
                            }).then((val)=>{
                                setIsLoading(false);
                                context.event.rsvpedUsers.invalidate({
                                    guild_id: server_id,
                                    message_id
                                });
                                props.closeModal();
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "has-text-weight-bold",
                            children: "Add Users"
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: true,
        title: title,
        subtitle: (0, _rsvpList.getOptionStringified)(props.rsvp_option),
        allow_overflow: true,
        content: content,
        onClose: props.closeModal
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../hooks/use_user_context":"eU1k4","../members_search_dropdown":"j5v22","./rsvp_list":"TBnfW","../../../../../../common/constants":"lLiun","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8cw2q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusBanner", ()=>StatusBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _trpc = require("../../utils/trpc");
var _banner = require("./base_components/banner");
function StatusBanner(props) {
    const status_message_query = (0, _trpc.trpc).misc.getStatusMessage.useQuery();
    if (!status_message_query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _banner.Banner), {
        children: status_message_query.data
    });
}

},{"react/jsx-runtime":"dpQXr","../../utils/trpc":"dyYvM","./base_components/banner":"hy2Du","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hy2Du":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Banner", ()=>Banner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function Banner(props) {
    const [open, setOpen] = (0, _react.useState)(true);
    if (!open) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full items-center gap-2 bg-sesh-dark p-2 text-black",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "delete invisible",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full text-center",
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "delete ml-auto",
                onClick: ()=>setOpen(false)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"GVrDV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserPreferencesModal", ()=>UserPreferencesModal);
parcelHelpers.export(exports, "useUserPreferencesMutation", ()=>useUserPreferencesMutation);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _useUserPreferencesModal = require("../hooks/use_user_preferences_modal");
var _userPreferencesTimezoneItem = require("./items/user_preferences_timezone_item");
var _usePreferencesBooleanItem = require("./items/use_preferences_boolean_item");
var _userPreferencesParseItem = require("./items/user_preferences_parse_item");
const ModifiableSettingDescriptors = {
    allow_event_rsvp_confirmation_dms: {
        label: "Event RSVP Confirmation DMs",
        description: "Determines whether to send confirmation DMs when you RSVP to an event. These DMs are necessary for receiving event reminders.",
        Element: (0, _usePreferencesBooleanItem.UserPreferencesBooleanItem)
    },
    allow_event_rsvp_confirmation_replies: {
        label: "Event RSVP Confirmation Replies",
        description: "Determines whether to send ephemeral message replies when you RSVP to an event.",
        Element: (0, _usePreferencesBooleanItem.UserPreferencesBooleanItem)
    },
    allow_poll_vote_confirmation_replies: {
        label: "Poll Vote Confirmation Replies",
        description: "Determines whether to send ephemeral message replies when you vote on a poll.",
        Element: (0, _usePreferencesBooleanItem.UserPreferencesBooleanItem)
    },
    timezone: {
        label: "Personal Timezone",
        description: "The timezone sesh will use to display certain times, along with the timezone sesh will use to parse times created with slash commands if Parsing Timezone is set to Personal.",
        Element: (0, _userPreferencesTimezoneItem.UserPreferencesTimezoneItem)
    },
    should_parse_times_using_local_timezone: {
        label: "Parsing Timezone",
        description: "Determines what timezone sesh will use to parse event times when creating events with /create. The server timezone can be set on your server's settings page.",
        Element: (0, _userPreferencesParseItem.UserPreferencesAddonItem)
    },
    send_rsvp_overlap_warning: {
        label: "Event RSVP Overlap Warning",
        description: "Determines whether to send a DM when you RSVP to an event that overlaps with another event you're attending.",
        Element: (0, _usePreferencesBooleanItem.UserPreferencesBooleanItem)
    }
};
function UserPreferencesModal() {
    const { is_open, setIsOpen } = (0, _useUserPreferencesModal.useUserPreferencesModal)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: is_open && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
            is_active: true,
            onClose: ()=>setIsOpen(false),
            title: "User Preferences",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserPreferencesModalContent, {})
        })
    });
}
function UserPreferencesModalContent() {
    const preferences_query = (0, _trpc.trpc).user.getPreferences.useQuery();
    if (!preferences_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex h-[512px] flex-col gap-4 overflow-auto py-2",
        children: Object.keys(preferences_query.data).map((setting)=>{
            const descriptor = ModifiableSettingDescriptors[setting];
            const value = preferences_query.data[setting];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(descriptor.Element, {
                setting_key: setting,
                description: descriptor.description,
                label: descriptor.label,
                value: value
            }, setting);
        })
    });
}
function useUserPreferencesMutation(settings_key) {
    const context = (0, _trpc.trpc).useContext();
    return (0, _trpc.trpc).user.setPreferences.useMutation({
        onMutate: (t)=>{
            context.user.getPreferences.setData((prev)=>({
                    ...prev,
                    [settings_key]: t[settings_key]
                }));
        }
    });
}

},{"react/jsx-runtime":"dpQXr","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../hooks/use_user_preferences_modal":"7PgND","./items/user_preferences_timezone_item":"kQUzx","./items/use_preferences_boolean_item":"h5V8V","./items/user_preferences_parse_item":"dvtgl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kQUzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserPreferencesTimezoneItem", ()=>UserPreferencesTimezoneItem);
parcelHelpers.export(exports, "UserPreferencesTimezoneSelect", ()=>UserPreferencesTimezoneSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _tzdb = require("@vvo/tzdb");
var _luxon = require("luxon");
var _react = require("react");
var _removingThrobber = require("../../../removing_throbber");
var _seshSelectInput = require("../../base_components/sesh_select_input");
var _disabler = require("../../disabler");
var _settingsBaseItem = require("../../settings_items/settings_base_item");
var _userPreferencesModal = require("./../user_preferences_modal");
function UserPreferencesTimezoneItem(props) {
    const options = (0, _tzdb.getTimeZones)();
    const mutation = (0, _userPreferencesModal.useUserPreferencesMutation)(props.setting_key);
    const [value, setValue] = (0, _react.useState)(options[0]);
    const [is_editing, setIsEditing] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
        ...props,
        children: !is_editing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex gap-2",
            children: [
                mutation.isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabler.Disabler), {
                    disabled: mutation.isLoading,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "manual-link flex w-fit items-center gap-2",
                        onClick: ()=>setIsEditing(true),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: props.value ?? "Not Set"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-pencil-alt"
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserPreferencesTimezoneSelect, {
            initial_value: props.value,
            onSubmit: (val)=>{
                mutation.mutate({
                    [props.setting_key]: val
                });
                setIsEditing(false);
            },
            onCancel: ()=>setIsEditing(false)
        })
    });
}
function UserPreferencesTimezoneSelect(props) {
    const options = (0, _tzdb.getTimeZones)().map((val)=>({
            label: val.name,
            value: val.name
        }));
    const local_zone = (0, _luxon.DateTime).local().zoneName;
    const [value, setValue] = (0, _react.useState)(props.initial_value ? options.find((val)=>val.value === props.initial_value) : options.find((val)=>val.value === local_zone));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-52",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSelectInput.SeshSelect), {
                    value: value,
                    onChange: (new_value)=>setValue(new_value),
                    options: options
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "px-1 text-link hover:text-link-hover",
                        title: "Submit",
                        onClick: ()=>props.onSubmit(value.value),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "px-1 text-warning hover:text-warning-hover",
                        title: "Cancel",
                        onClick: props.onCancel,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-times"
                            })
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@vvo/tzdb":[["getTimeZones","ixPgb","default"]],"luxon":"fLWpi","react":"IMRgT","../../../removing_throbber":"TmURk","../../base_components/sesh_select_input":"8Vo8B","../../disabler":"hF5sC","../../settings_items/settings_base_item":"byg9r","./../user_preferences_modal":"GVrDV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ixPgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimeZones);
var _rawTimeZonesJson = require("../raw-time-zones.json");
var _rawTimeZonesJsonDefault = parcelHelpers.interopDefault(_rawTimeZonesJson);
var _formatTimeZoneJs = require("./formatTimeZone.js");
var _formatTimeZoneJsDefault = parcelHelpers.interopDefault(_formatTimeZoneJs);
var _timeZoneJs = require("./utils/timeZone.js");
function getTimeZones(opts) {
    const includeUtc = !!opts && opts.includeUtc;
    return (0, _rawTimeZonesJsonDefault.default).reduce(function(acc, timeZone) {
        const timeZoneName = timeZone.name;
        const currentOffset = (0, _timeZoneJs.getZoneOffset)(timeZoneName);
        // We build on the latest Node.js version, Node.js embed IANA databases
        // it might happen that the environment that will execute getTimeZones() will not know about some
        // timezones. So we ignore the timezone at runtim
        // See https://github.com/vvo/tzdb/issues/43
        if (currentOffset === false) return acc;
        const timeZoneWithCurrentTimeData = {
            ...timeZone,
            currentTimeOffsetInMinutes: currentOffset
        };
        acc.push({
            ...timeZoneWithCurrentTimeData,
            currentTimeFormat: (0, _formatTimeZoneJsDefault.default)(timeZoneWithCurrentTimeData, {
                useCurrentOffset: true
            })
        });
        return acc;
    }, includeUtc ? [
        utcTimezone
    ] : []).sort((a, b)=>{
        return compareNumbers(a, b) || compareStrings(a.alternativeName, b.alternativeName) || compareStrings(a.mainCities[0], b.mainCities[0]);
    });
}
function compareNumbers(x, y) {
    return x.currentTimeOffsetInMinutes - y.currentTimeOffsetInMinutes;
}
function compareStrings(x, y) {
    if (typeof x === "string" && typeof y === "string") return x.localeCompare(y);
    return 0;
}
const utcTimezone = {
    name: "Etc/UTC",
    alternativeName: "Coordinated Universal Time (UTC)",
    abbreviation: "UTC",
    group: [
        "Etc/UTC",
        "Etc/UCT",
        "UCT",
        "UTC",
        "Universal",
        "Zulu"
    ],
    countryName: "",
    continentCode: "",
    continentName: "",
    mainCities: [
        ""
    ],
    rawOffsetInMinutes: 0,
    rawFormat: "+00:00 Coordinated Universal Time (UTC)",
    currentTimeOffsetInMinutes: 0,
    currentTimeFormat: "+00:00 Coordinated Universal Time (UTC)"
};

},{"../raw-time-zones.json":"31TQb","./formatTimeZone.js":"gwiE1","./utils/timeZone.js":"g1Sde","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"31TQb":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[{"name":"Pacific/Niue","alternativeName":"Niue Time","group":["Pacific/Niue"],"continentCode":"OC","continentName":"Oceania","countryName":"Niue","countryCode":"NU","mainCities":["Alofi"],"rawOffsetInMinutes":-660,"abbreviation":"NUT","rawFormat":"-11:00 Niue Time - Alofi"},{"name":"Pacific/Midway","alternativeName":"Samoa Time","group":["Pacific/Midway"],"continentCode":"OC","continentName":"Oceania","countryName":"United States Minor Outlying Islands","countryCode":"UM","mainCities":["Midway"],"rawOffsetInMinutes":-660,"abbreviation":"SST","rawFormat":"-11:00 Samoa Time - Midway"},{"name":"Pacific/Pago_Pago","alternativeName":"Samoa Time","group":["Pacific/Pago_Pago","US/Samoa","Pacific/Samoa","Pacific/Midway"],"continentCode":"OC","continentName":"Oceania","countryName":"American Samoa","countryCode":"AS","mainCities":["Pago Pago"],"rawOffsetInMinutes":-660,"abbreviation":"SST","rawFormat":"-11:00 Samoa Time - Pago Pago"},{"name":"Pacific/Rarotonga","alternativeName":"Cook Islands Time","group":["Pacific/Rarotonga"],"continentCode":"OC","continentName":"Oceania","countryName":"Cook Islands","countryCode":"CK","mainCities":["Avarua"],"rawOffsetInMinutes":-600,"abbreviation":"CKT","rawFormat":"-10:00 Cook Islands Time - Avarua"},{"name":"America/Adak","alternativeName":"Hawaii-Aleutian Time","group":["America/Adak","US/Aleutian","America/Atka"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Adak"],"rawOffsetInMinutes":-600,"abbreviation":"HAST","rawFormat":"-10:00 Hawaii-Aleutian Time - Adak"},{"name":"Pacific/Honolulu","alternativeName":"Hawaii-Aleutian Time","group":["Pacific/Honolulu","US/Hawaii","Pacific/Johnston"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Honolulu","East Honolulu","Pearl City","Hilo"],"rawOffsetInMinutes":-600,"abbreviation":"HAST","rawFormat":"-10:00 Hawaii-Aleutian Time - Honolulu, East Honolulu, Pearl City, Hilo"},{"name":"Pacific/Tahiti","alternativeName":"Tahiti Time","group":["Pacific/Tahiti"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Faaa","Papeete","Punaauia"],"rawOffsetInMinutes":-600,"abbreviation":"TAHT","rawFormat":"-10:00 Tahiti Time - Faaa, Papeete, Punaauia"},{"name":"Pacific/Marquesas","alternativeName":"Marquesas Time","group":["Pacific/Marquesas"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Marquesas"],"rawOffsetInMinutes":-570,"abbreviation":"MART","rawFormat":"-09:30 Marquesas Time - Marquesas"},{"name":"America/Anchorage","alternativeName":"Alaska Time","group":["America/Anchorage","America/Juneau","America/Metlakatla","America/Nome","America/Sitka","America/Yakutat","US/Alaska"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Anchorage","Juneau","Fairbanks","Eagle River"],"rawOffsetInMinutes":-540,"abbreviation":"AKST","rawFormat":"-09:00 Alaska Time - Anchorage, Juneau, Fairbanks, Eagle River"},{"name":"Pacific/Gambier","alternativeName":"Gambier Time","group":["Pacific/Gambier"],"continentCode":"OC","continentName":"Oceania","countryName":"French Polynesia","countryCode":"PF","mainCities":["Gambier"],"rawOffsetInMinutes":-540,"abbreviation":"GAMT","rawFormat":"-09:00 Gambier Time - Gambier"},{"name":"America/Los_Angeles","alternativeName":"Pacific Time","group":["America/Los_Angeles","US/Pacific"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Los Angeles","San Diego","San Jose","San Francisco"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Los Angeles, San Diego, San Jose, San Francisco"},{"name":"America/Tijuana","alternativeName":"Pacific Time","group":["America/Tijuana","Mexico/BajaNorte","America/Ensenada","America/Santa_Isabel"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Tijuana","Mexicali","Ensenada","Rosarito"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Tijuana, Mexicali, Ensenada, Rosarito"},{"name":"America/Vancouver","alternativeName":"Pacific Time","group":["America/Vancouver","Canada/Pacific"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Vancouver","Surrey","Okanagan","Victoria"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pacific Time - Vancouver, Surrey, Okanagan, Victoria"},{"name":"Pacific/Pitcairn","alternativeName":"Pitcairn Time","group":["Pacific/Pitcairn"],"continentCode":"OC","continentName":"Oceania","countryName":"Pitcairn","countryCode":"PN","mainCities":["Adamstown"],"rawOffsetInMinutes":-480,"abbreviation":"PST","rawFormat":"-08:00 Pitcairn Time - Adamstown"},{"name":"America/Hermosillo","alternativeName":"Mexican Pacific Time","group":["America/Hermosillo","America/Mazatlan","Mexico/BajaSur"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Hermosillo","Culiac\xe1n","Ciudad Obreg\xf3n","Mazatl\xe1n"],"rawOffsetInMinutes":-420,"abbreviation":"GMT-7","rawFormat":"-07:00 Mexican Pacific Time - Hermosillo, Culiac\xe1n, Ciudad Obreg\xf3n, Mazatl\xe1n"},{"name":"America/Edmonton","alternativeName":"Mountain Time","group":["America/Cambridge_Bay","America/Edmonton","America/Inuvik","America/Yellowknife","Canada/Mountain"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Calgary","Edmonton","Red Deer","Sherwood Park"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Calgary, Edmonton, Red Deer, Sherwood Park"},{"name":"America/Ciudad_Juarez","alternativeName":"Mountain Time","group":["America/Ciudad_Juarez"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Ciudad Ju\xe1rez"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Ciudad Ju\xe1rez"},{"name":"America/Denver","alternativeName":"Mountain Time","group":["America/Boise","America/Denver","Navajo","US/Mountain","America/Shiprock"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Denver","El Paso","Albuquerque","Colorado Springs"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Denver, El Paso, Albuquerque, Colorado Springs"},{"name":"America/Phoenix","alternativeName":"Mountain Time","group":["America/Phoenix","US/Arizona","America/Creston"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Phoenix","Tucson","Mesa","Chandler"],"rawOffsetInMinutes":-420,"abbreviation":"MST","rawFormat":"-07:00 Mountain Time - Phoenix, Tucson, Mesa, Chandler"},{"name":"America/Whitehorse","alternativeName":"Yukon Time","group":["America/Creston","America/Dawson","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","Canada/Yukon"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Whitehorse","Fort St. John","Creston","Dawson"],"rawOffsetInMinutes":-420,"abbreviation":"YT","rawFormat":"-07:00 Yukon Time - Whitehorse, Fort St. John, Creston, Dawson"},{"name":"America/Belize","alternativeName":"Central Time","group":["America/Belize"],"continentCode":"NA","continentName":"North America","countryName":"Belize","countryCode":"BZ","mainCities":["Belize City","San Ignacio","San Pedro","Orange Walk"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Belize City, San Ignacio, San Pedro, Orange Walk"},{"name":"America/Chicago","alternativeName":"Central Time","group":["America/Chicago","America/Indiana/Knox","America/Indiana/Tell_City","America/Menominee","America/North_Dakota/Beulah","America/North_Dakota/Center","America/North_Dakota/New_Salem","US/Central","US/Indiana-Starke","America/Knox_IN"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["Chicago","Houston","San Antonio","Dallas"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Chicago, Houston, San Antonio, Dallas"},{"name":"America/Guatemala","alternativeName":"Central Time","group":["America/Guatemala"],"continentCode":"NA","continentName":"North America","countryName":"Guatemala","countryCode":"GT","mainCities":["Guatemala City","Villa Nueva","Mixco","Cob\xe1n"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Guatemala City, Villa Nueva, Mixco, Cob\xe1n"},{"name":"America/Managua","alternativeName":"Central Time","group":["America/Managua"],"continentCode":"NA","continentName":"North America","countryName":"Nicaragua","countryCode":"NI","mainCities":["Managua","Le\xf3n","Masaya","Chinandega"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Managua, Le\xf3n, Masaya, Chinandega"},{"name":"America/Mexico_City","alternativeName":"Central Time","group":["America/Bahia_Banderas","America/Chihuahua","America/Merida","America/Mexico_City","America/Monterrey","Mexico/General"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Mexico City","Iztapalapa","Le\xf3n de los Aldama","Puebla"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Mexico City, Iztapalapa, Le\xf3n de los Aldama, Puebla"},{"name":"America/Matamoros","alternativeName":"Central Time","group":["America/Matamoros","America/Ojinaga"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Reynosa","Heroica Matamoros","Nuevo Laredo","Piedras Negras"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras"},{"name":"America/Costa_Rica","alternativeName":"Central Time","group":["America/Costa_Rica"],"continentCode":"NA","continentName":"North America","countryName":"Costa Rica","countryCode":"CR","mainCities":["San Jos\xe9","Lim\xf3n","San Francisco","Alajuela"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - San Jos\xe9, Lim\xf3n, San Francisco, Alajuela"},{"name":"America/El_Salvador","alternativeName":"Central Time","group":["America/El_Salvador"],"continentCode":"NA","continentName":"North America","countryName":"El Salvador","countryCode":"SV","mainCities":["San Salvador","Soyapango","San Miguel","Santa Ana"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - San Salvador, Soyapango, San Miguel, Santa Ana"},{"name":"America/Regina","alternativeName":"Central Time","group":["America/Regina","America/Swift_Current","Canada/Saskatchewan"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Saskatoon","Regina","Prince Albert","Moose Jaw"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Saskatoon, Regina, Prince Albert, Moose Jaw"},{"name":"America/Tegucigalpa","alternativeName":"Central Time","group":["America/Tegucigalpa"],"continentCode":"NA","continentName":"North America","countryName":"Honduras","countryCode":"HN","mainCities":["Tegucigalpa","San Pedro Sula","La Ceiba","Choloma"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Tegucigalpa, San Pedro Sula, La Ceiba, Choloma"},{"name":"America/Winnipeg","alternativeName":"Central Time","group":["America/Rankin_Inlet","America/Resolute","America/Winnipeg","Canada/Central","America/Rainy_River"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Winnipeg","Brandon","Steinbach","Kenora"],"rawOffsetInMinutes":-360,"abbreviation":"CST","rawFormat":"-06:00 Central Time - Winnipeg, Brandon, Steinbach, Kenora"},{"name":"Pacific/Easter","alternativeName":"Easter Island Time","group":["Pacific/Easter","Chile/EasterIsland"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Easter"],"rawOffsetInMinutes":-360,"abbreviation":"EAST","rawFormat":"-06:00 Easter Island Time - Easter"},{"name":"Pacific/Galapagos","alternativeName":"Galapagos Time","group":["Pacific/Galapagos"],"continentCode":"SA","continentName":"South America","countryName":"Ecuador","countryCode":"EC","mainCities":["Galapagos"],"rawOffsetInMinutes":-360,"abbreviation":"GALT","rawFormat":"-06:00 Galapagos Time - Galapagos"},{"name":"America/Rio_Branco","alternativeName":"Acre Time","group":["America/Eirunepe","America/Rio_Branco","Brazil/Acre","America/Porto_Acre"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Rio Branco","Cruzeiro do Sul","Senador Guiomard","Sena Madureira"],"rawOffsetInMinutes":-300,"abbreviation":"ACT","rawFormat":"-05:00 Acre Time - Rio Branco, Cruzeiro do Sul, Senador Guiomard, Sena Madureira"},{"name":"America/Bogota","alternativeName":"Colombia Time","group":["America/Bogota"],"continentCode":"SA","continentName":"South America","countryName":"Colombia","countryCode":"CO","mainCities":["Bogot\xe1","Cali","Medell\xedn","Barranquilla"],"rawOffsetInMinutes":-300,"abbreviation":"COT","rawFormat":"-05:00 Colombia Time - Bogot\xe1, Cali, Medell\xedn, Barranquilla"},{"name":"America/Havana","alternativeName":"Cuba Time","group":["America/Havana","Cuba"],"continentCode":"NA","continentName":"North America","countryName":"Cuba","countryCode":"CU","mainCities":["Havana","Santiago de Cuba","Camag\xfcey","Holgu\xedn"],"rawOffsetInMinutes":-300,"abbreviation":"CST","rawFormat":"-05:00 Cuba Time - Havana, Santiago de Cuba, Camag\xfcey, Holgu\xedn"},{"name":"America/Atikokan","alternativeName":"Eastern Time","group":["America/Atikokan"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Atikokan"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Atikokan"},{"name":"America/Cancun","alternativeName":"Eastern Time","group":["America/Cancun"],"continentCode":"NA","continentName":"North America","countryName":"Mexico","countryCode":"MX","mainCities":["Canc\xfan","Chetumal","Playa del Carmen","Cozumel"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Canc\xfan, Chetumal, Playa del Carmen, Cozumel"},{"name":"America/Grand_Turk","alternativeName":"Eastern Time","group":["America/Grand_Turk"],"continentCode":"NA","continentName":"North America","countryName":"Turks and Caicos Islands","countryCode":"TC","mainCities":["Cockburn Town"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Cockburn Town"},{"name":"America/Cayman","alternativeName":"Eastern Time","group":["America/Cayman"],"continentCode":"NA","continentName":"North America","countryName":"Cayman Islands","countryCode":"KY","mainCities":["George Town","West Bay"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - George Town, West Bay"},{"name":"America/Jamaica","alternativeName":"Eastern Time","group":["America/Jamaica","Jamaica"],"continentCode":"NA","continentName":"North America","countryName":"Jamaica","countryCode":"JM","mainCities":["Kingston","New Kingston","Spanish Town","Portmore"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Kingston, New Kingston, Spanish Town, Portmore"},{"name":"America/Nassau","alternativeName":"Eastern Time","group":["America/Nassau"],"continentCode":"NA","continentName":"North America","countryName":"Bahamas","countryCode":"BS","mainCities":["Nassau","Lucaya","Freeport"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Nassau, Lucaya, Freeport"},{"name":"America/New_York","alternativeName":"Eastern Time","group":["America/Detroit","America/Indiana/Indianapolis","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Indiana/Vincennes","America/Indiana/Winamac","America/Kentucky/Louisville","America/Kentucky/Monticello","America/New_York","US/Michigan","US/East-Indiana","America/Indianapolis","America/Fort_Wayne","America/Louisville","US/Eastern"],"continentCode":"NA","continentName":"North America","countryName":"United States","countryCode":"US","mainCities":["New York City","Brooklyn","Queens","Philadelphia"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - New York City, Brooklyn, Queens, Philadelphia"},{"name":"America/Panama","alternativeName":"Eastern Time","group":["America/Panama","America/Atikokan","America/Cayman","America/Coral_Harbour"],"continentCode":"NA","continentName":"North America","countryName":"Panama","countryCode":"PA","mainCities":["Panam\xe1","San Miguelito","Juan D\xedaz","David"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Panam\xe1, San Miguelito, Juan D\xedaz, David"},{"name":"America/Port-au-Prince","alternativeName":"Eastern Time","group":["America/Port-au-Prince"],"continentCode":"NA","continentName":"North America","countryName":"Haiti","countryCode":"HT","mainCities":["Port-au-Prince","Carrefour","Delmas 73","Port-de-Paix"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Port-au-Prince, Carrefour, Delmas 73, Port-de-Paix"},{"name":"America/Toronto","alternativeName":"Eastern Time","group":["America/Iqaluit","America/Toronto","America/Pangnirtung","Canada/Eastern","America/Nassau","America/Montreal","America/Nipigon","America/Thunder_Bay"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Toronto","Montr\xe9al","Ottawa","Mississauga"],"rawOffsetInMinutes":-300,"abbreviation":"EST","rawFormat":"-05:00 Eastern Time - Toronto, Montr\xe9al, Ottawa, Mississauga"},{"name":"America/Guayaquil","alternativeName":"Ecuador Time","group":["America/Guayaquil"],"continentCode":"SA","continentName":"South America","countryName":"Ecuador","countryCode":"EC","mainCities":["Quito","Guayaquil","Cuenca","Santo Domingo de los Colorados"],"rawOffsetInMinutes":-300,"abbreviation":"ECT","rawFormat":"-05:00 Ecuador Time - Quito, Guayaquil, Cuenca, Santo Domingo de los Colorados"},{"name":"America/Lima","alternativeName":"Peru Time","group":["America/Lima"],"continentCode":"SA","continentName":"South America","countryName":"Peru","countryCode":"PE","mainCities":["Lima","Callao","Arequipa","Trujillo"],"rawOffsetInMinutes":-300,"abbreviation":"PET","rawFormat":"-05:00 Peru Time - Lima, Callao, Arequipa, Trujillo"},{"name":"America/Manaus","alternativeName":"Amazon Time","group":["America/Boa_Vista","America/Campo_Grande","America/Cuiaba","America/Manaus","America/Porto_Velho","Brazil/West"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Manaus","Campo Grande","Cuiab\xe1","Porto Velho"],"rawOffsetInMinutes":-240,"abbreviation":"AMT","rawFormat":"-04:00 Amazon Time - Manaus, Campo Grande, Cuiab\xe1, Porto Velho"},{"name":"America/St_Kitts","alternativeName":"Atlantic Time","group":["America/St_Kitts"],"continentCode":"NA","continentName":"North America","countryName":"Saint Kitts and Nevis","countryCode":"KN","mainCities":["Basseterre"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Basseterre"},{"name":"America/Blanc-Sablon","alternativeName":"Atlantic Time","group":["America/Blanc-Sablon"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Blanc-Sablon"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Blanc-Sablon"},{"name":"America/Montserrat","alternativeName":"Atlantic Time","group":["America/Montserrat"],"continentCode":"NA","continentName":"North America","countryName":"Montserrat","countryCode":"MS","mainCities":["Brades","Plymouth"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Brades, Plymouth"},{"name":"America/Barbados","alternativeName":"Atlantic Time","group":["America/Barbados"],"continentCode":"NA","continentName":"North America","countryName":"Barbados","countryCode":"BB","mainCities":["Bridgetown"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Bridgetown"},{"name":"America/St_Lucia","alternativeName":"Atlantic Time","group":["America/St_Lucia"],"continentCode":"NA","continentName":"North America","countryName":"Saint Lucia","countryCode":"LC","mainCities":["Castries"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Castries"},{"name":"America/Port_of_Spain","alternativeName":"Atlantic Time","group":["America/Port_of_Spain"],"continentCode":"NA","continentName":"North America","countryName":"Trinidad and Tobago","countryCode":"TT","mainCities":["Chaguanas","Mon Repos","San Fernando","Port of Spain"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Chaguanas, Mon Repos, San Fernando, Port of Spain"},{"name":"America/Martinique","alternativeName":"Atlantic Time","group":["America/Martinique"],"continentCode":"NA","continentName":"North America","countryName":"Martinique","countryCode":"MQ","mainCities":["Fort-de-France","Le Lamentin","Le Robert","Sainte-Marie"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie"},{"name":"America/St_Barthelemy","alternativeName":"Atlantic Time","group":["America/St_Barthelemy"],"continentCode":"NA","continentName":"North America","countryName":"Saint Barthelemy","countryCode":"BL","mainCities":["Gustavia"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Gustavia"},{"name":"America/Halifax","alternativeName":"Atlantic Time","group":["America/Glace_Bay","America/Goose_Bay","America/Halifax","America/Moncton","Canada/Atlantic"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["Halifax","Moncton","Sydney","Dartmouth"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Halifax, Moncton, Sydney, Dartmouth"},{"name":"Atlantic/Bermuda","alternativeName":"Atlantic Time","group":["Atlantic/Bermuda"],"continentCode":"NA","continentName":"North America","countryName":"Bermuda","countryCode":"BM","mainCities":["Hamilton"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Hamilton"},{"name":"America/St_Vincent","alternativeName":"Atlantic Time","group":["America/St_Vincent"],"continentCode":"NA","continentName":"North America","countryName":"Saint Vincent and the Grenadines","countryCode":"VC","mainCities":["Kingstown","Kingstown Park"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Kingstown, Kingstown Park"},{"name":"America/Kralendijk","alternativeName":"Atlantic Time","group":["America/Kralendijk"],"continentCode":"NA","continentName":"North America","countryName":"Bonaire, Saint Eustatius and Saba ","countryCode":"BQ","mainCities":["Kralendijk"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Kralendijk"},{"name":"America/Guadeloupe","alternativeName":"Atlantic Time","group":["America/Guadeloupe"],"continentCode":"NA","continentName":"North America","countryName":"Guadeloupe","countryCode":"GP","mainCities":["Les Abymes","Baie-Mahault","Le Gosier","Petit-Bourg"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg"},{"name":"America/Marigot","alternativeName":"Atlantic Time","group":["America/Marigot"],"continentCode":"NA","continentName":"North America","countryName":"Saint Martin","countryCode":"MF","mainCities":["Marigot"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Marigot"},{"name":"America/Aruba","alternativeName":"Atlantic Time","group":["America/Aruba"],"continentCode":"NA","continentName":"North America","countryName":"Aruba","countryCode":"AW","mainCities":["Oranjestad","Tanki Leendert","San Nicolas"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Oranjestad, Tanki Leendert, San Nicolas"},{"name":"America/Lower_Princes","alternativeName":"Atlantic Time","group":["America/Lower_Princes"],"continentCode":"NA","continentName":"North America","countryName":"Sint Maarten","countryCode":"SX","mainCities":["Philipsburg"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Philipsburg"},{"name":"America/Tortola","alternativeName":"Atlantic Time","group":["America/Tortola"],"continentCode":"NA","continentName":"North America","countryName":"British Virgin Islands","countryCode":"VG","mainCities":["Road Town"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Road Town"},{"name":"America/Dominica","alternativeName":"Atlantic Time","group":["America/Dominica"],"continentCode":"NA","continentName":"North America","countryName":"Dominica","countryCode":"DM","mainCities":["Roseau"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Roseau"},{"name":"America/St_Thomas","alternativeName":"Atlantic Time","group":["America/St_Thomas"],"continentCode":"NA","continentName":"North America","countryName":"U.S. Virgin Islands","countryCode":"VI","mainCities":["Saint Croix","Charlotte Amalie"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint Croix, Charlotte Amalie"},{"name":"America/Grenada","alternativeName":"Atlantic Time","group":["America/Grenada"],"continentCode":"NA","continentName":"North America","countryName":"Grenada","countryCode":"GD","mainCities":["Saint George\'s"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint George\'s"},{"name":"America/Antigua","alternativeName":"Atlantic Time","group":["America/Antigua"],"continentCode":"NA","continentName":"North America","countryName":"Antigua and Barbuda","countryCode":"AG","mainCities":["Saint John\u2019s"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Saint John\u2019s"},{"name":"America/Puerto_Rico","alternativeName":"Atlantic Time","group":["America/Puerto_Rico","America/Virgin","America/Anguilla","America/Antigua","America/Aruba","America/Blanc-Sablon","America/Curacao","America/Dominica","America/Grenada","America/Guadeloupe","America/Kralendijk","America/Lower_Princes","America/Marigot","America/Montserrat","America/Port_of_Spain","America/St_Barthelemy","America/St_Kitts","America/St_Lucia","America/St_Thomas","America/St_Vincent","America/Tortola"],"continentCode":"NA","continentName":"North America","countryName":"Puerto Rico","countryCode":"PR","mainCities":["San Juan","Bayam\xf3n","Carolina","Ponce"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - San Juan, Bayam\xf3n, Carolina, Ponce"},{"name":"America/Santo_Domingo","alternativeName":"Atlantic Time","group":["America/Santo_Domingo"],"continentCode":"NA","continentName":"North America","countryName":"Dominican Republic","countryCode":"DO","mainCities":["Santo Domingo","Santiago de los Caballeros","Santo Domingo Oeste","Santo Domingo Este"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este"},{"name":"America/Anguilla","alternativeName":"Atlantic Time","group":["America/Anguilla"],"continentCode":"NA","continentName":"North America","countryName":"Anguilla","countryCode":"AI","mainCities":["The Valley"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - The Valley"},{"name":"America/Thule","alternativeName":"Atlantic Time","group":["America/Thule"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Thule"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Thule"},{"name":"America/Curacao","alternativeName":"Atlantic Time","group":["America/Curacao"],"continentCode":"NA","continentName":"North America","countryName":"Curacao","countryCode":"CW","mainCities":["Willemstad"],"rawOffsetInMinutes":-240,"abbreviation":"AST","rawFormat":"-04:00 Atlantic Time - Willemstad"},{"name":"America/La_Paz","alternativeName":"Bolivia Time","group":["America/La_Paz"],"continentCode":"SA","continentName":"South America","countryName":"Bolivia","countryCode":"BO","mainCities":["La Paz","Santa Cruz de la Sierra","Cochabamba","Sucre"],"rawOffsetInMinutes":-240,"abbreviation":"BOT","rawFormat":"-04:00 Bolivia Time - La Paz, Santa Cruz de la Sierra, Cochabamba, Sucre"},{"name":"America/Santiago","alternativeName":"Chile Time","group":["America/Santiago","Chile/Continental"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Santiago","Puente Alto","Antofagasta","Vi\xf1a del Mar"],"rawOffsetInMinutes":-240,"abbreviation":"CLT","rawFormat":"-04:00 Chile Time - Santiago, Puente Alto, Antofagasta, Vi\xf1a del Mar"},{"name":"America/Guyana","alternativeName":"Guyana Time","group":["America/Guyana"],"continentCode":"SA","continentName":"South America","countryName":"Guyana","countryCode":"GY","mainCities":["Georgetown","Linden","New Amsterdam"],"rawOffsetInMinutes":-240,"abbreviation":"GYT","rawFormat":"-04:00 Guyana Time - Georgetown, Linden, New Amsterdam"},{"name":"America/Asuncion","alternativeName":"Paraguay Time","group":["America/Asuncion"],"continentCode":"SA","continentName":"South America","countryName":"Paraguay","countryCode":"PY","mainCities":["Asunci\xf3n","Ciudad del Este","San Lorenzo","Capiat\xe1"],"rawOffsetInMinutes":-240,"abbreviation":"PYT","rawFormat":"-04:00 Paraguay Time - Asunci\xf3n, Ciudad del Este, San Lorenzo, Capiat\xe1"},{"name":"America/Caracas","alternativeName":"Venezuela Time","group":["America/Caracas"],"continentCode":"SA","continentName":"South America","countryName":"Venezuela","countryCode":"VE","mainCities":["Caracas","Maracaibo","Maracay","Valencia"],"rawOffsetInMinutes":-240,"abbreviation":"VET","rawFormat":"-04:00 Venezuela Time - Caracas, Maracaibo, Maracay, Valencia"},{"name":"America/St_Johns","alternativeName":"Newfoundland Time","group":["America/St_Johns","Canada/Newfoundland"],"continentCode":"NA","continentName":"North America","countryName":"Canada","countryCode":"CA","mainCities":["St. John\'s","Mount Pearl","Corner Brook","Conception Bay South"],"rawOffsetInMinutes":-210,"abbreviation":"NST","rawFormat":"-03:30 Newfoundland Time - St. John\'s, Mount Pearl, Corner Brook, Conception Bay South"},{"name":"America/Argentina/Buenos_Aires","alternativeName":"Argentina Time","group":["America/Argentina/Buenos_Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La_Rioja","America/Argentina/Mendoza","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Buenos_Aires","America/Catamarca","America/Argentina/ComodRivadavia","America/Cordoba","America/Rosario","America/Jujuy","America/Mendoza"],"continentCode":"SA","continentName":"South America","countryName":"Argentina","countryCode":"AR","mainCities":["Buenos Aires","C\xf3rdoba","Rosario","Mar del Plata"],"rawOffsetInMinutes":-180,"abbreviation":"ART","rawFormat":"-03:00 Argentina Time - Buenos Aires, C\xf3rdoba, Rosario, Mar del Plata"},{"name":"America/Sao_Paulo","alternativeName":"Brasilia Time","group":["America/Araguaina","America/Bahia","America/Belem","America/Fortaleza","America/Maceio","America/Recife","America/Santarem","America/Sao_Paulo","Brazil/East"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["S\xe3o Paulo","Rio de Janeiro","Belo Horizonte","Salvador"],"rawOffsetInMinutes":-180,"abbreviation":"BRT","rawFormat":"-03:00 Brasilia Time - S\xe3o Paulo, Rio de Janeiro, Belo Horizonte, Salvador"},{"name":"Antarctica/Palmer","alternativeName":"Chile Time","group":["Antarctica/Palmer","Antarctica/Rothera"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Palmer","Rothera"],"rawOffsetInMinutes":-180,"abbreviation":"CLT","rawFormat":"-03:00 Chile Time - Palmer, Rothera"},{"name":"America/Punta_Arenas","alternativeName":"Chile Time","group":["America/Punta_Arenas"],"continentCode":"SA","continentName":"South America","countryName":"Chile","countryCode":"CL","mainCities":["Punta Arenas","Puerto Natales"],"rawOffsetInMinutes":-180,"abbreviation":"CLT","rawFormat":"-03:00 Chile Time - Punta Arenas, Puerto Natales"},{"name":"Atlantic/Stanley","alternativeName":"Falkland Islands Time","group":["Atlantic/Stanley"],"continentCode":"SA","continentName":"South America","countryName":"Falkland Islands","countryCode":"FK","mainCities":["Stanley"],"rawOffsetInMinutes":-180,"abbreviation":"FKST","rawFormat":"-03:00 Falkland Islands Time - Stanley"},{"name":"America/Cayenne","alternativeName":"French Guiana Time","group":["America/Cayenne"],"continentCode":"SA","continentName":"South America","countryName":"French Guiana","countryCode":"GF","mainCities":["Cayenne","Matoury","Saint-Laurent-du-Maroni","Kourou"],"rawOffsetInMinutes":-180,"abbreviation":"GFT","rawFormat":"-03:00 French Guiana Time - Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou"},{"name":"America/Miquelon","alternativeName":"St. Pierre & Miquelon Time","group":["America/Miquelon"],"continentCode":"NA","continentName":"North America","countryName":"Saint Pierre and Miquelon","countryCode":"PM","mainCities":["Saint-Pierre"],"rawOffsetInMinutes":-180,"abbreviation":"PM","rawFormat":"-03:00 St. Pierre & Miquelon Time - Saint-Pierre"},{"name":"America/Paramaribo","alternativeName":"Suriname Time","group":["America/Paramaribo"],"continentCode":"SA","continentName":"South America","countryName":"Suriname","countryCode":"SR","mainCities":["Paramaribo","Lelydorp"],"rawOffsetInMinutes":-180,"abbreviation":"SRT","rawFormat":"-03:00 Suriname Time - Paramaribo, Lelydorp"},{"name":"America/Montevideo","alternativeName":"Uruguay Time","group":["America/Montevideo"],"continentCode":"SA","continentName":"South America","countryName":"Uruguay","countryCode":"UY","mainCities":["Montevideo","Salto","Paysand\xfa","Las Piedras"],"rawOffsetInMinutes":-180,"abbreviation":"UYT","rawFormat":"-03:00 Uruguay Time - Montevideo, Salto, Paysand\xfa, Las Piedras"},{"name":"America/Nuuk","alternativeName":"West Greenland Time","group":["America/Nuuk","America/Godthab"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Nuuk"],"rawOffsetInMinutes":-180,"abbreviation":"WGT","rawFormat":"-03:00 West Greenland Time - Nuuk"},{"name":"America/Noronha","alternativeName":"Fernando de Noronha Time","group":["America/Noronha","Brazil/DeNoronha"],"continentCode":"SA","continentName":"South America","countryName":"Brazil","countryCode":"BR","mainCities":["Noronha"],"rawOffsetInMinutes":-120,"abbreviation":"FNT","rawFormat":"-02:00 Fernando de Noronha Time - Noronha"},{"name":"Atlantic/South_Georgia","alternativeName":"South Georgia Time","group":["Atlantic/South_Georgia"],"continentCode":"AN","continentName":"Antarctica","countryName":"South Georgia and the South Sandwich Islands","countryCode":"GS","mainCities":["Grytviken"],"rawOffsetInMinutes":-120,"abbreviation":"GST","rawFormat":"-02:00 South Georgia Time - Grytviken"},{"name":"Atlantic/Azores","alternativeName":"Azores Time","group":["Atlantic/Azores"],"continentCode":"EU","continentName":"Europe","countryName":"Portugal","countryCode":"PT","mainCities":["Ponta Delgada"],"rawOffsetInMinutes":-60,"abbreviation":"AZOT","rawFormat":"-01:00 Azores Time - Ponta Delgada"},{"name":"Atlantic/Cape_Verde","alternativeName":"Cape Verde Time","group":["Atlantic/Cape_Verde"],"continentCode":"AF","continentName":"Africa","countryName":"Cabo Verde","countryCode":"CV","mainCities":["Praia","Mindelo","Santa Maria","Cova Figueira"],"rawOffsetInMinutes":-60,"abbreviation":"CVT","rawFormat":"-01:00 Cape Verde Time - Praia, Mindelo, Santa Maria, Cova Figueira"},{"name":"America/Scoresbysund","alternativeName":"East Greenland Time","group":["America/Scoresbysund"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Scoresbysund"],"rawOffsetInMinutes":-60,"abbreviation":"EGT","rawFormat":"-01:00 East Greenland Time - Scoresbysund"},{"name":"Africa/Abidjan","alternativeName":"Greenwich Mean Time","group":["Africa/Abidjan","Iceland","Africa/Accra","Africa/Bamako","Africa/Banjul","Africa/Conakry","Africa/Dakar","Africa/Freetown","Africa/Lome","Africa/Nouakchott","Africa/Ouagadougou","Atlantic/Reykjavik","Atlantic/St_Helena","Africa/Timbuktu"],"continentCode":"AF","continentName":"Africa","countryName":"Ivory Coast","countryCode":"CI","mainCities":["Abidjan","Abobo","Bouak\xe9","Korhogo"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Abidjan, Abobo, Bouak\xe9, Korhogo"},{"name":"Africa/Accra","alternativeName":"Greenwich Mean Time","group":["Africa/Accra"],"continentCode":"AF","continentName":"Africa","countryName":"Ghana","countryCode":"GH","mainCities":["Accra","Kumasi","Tamale","Takoradi"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Accra, Kumasi, Tamale, Takoradi"},{"name":"Africa/Bamako","alternativeName":"Greenwich Mean Time","group":["Africa/Bamako"],"continentCode":"AF","continentName":"Africa","countryName":"Mali","countryCode":"ML","mainCities":["Bamako","S\xe9gou","Sikasso","Mopti"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Bamako, S\xe9gou, Sikasso, Mopti"},{"name":"Africa/Bissau","alternativeName":"Greenwich Mean Time","group":["Africa/Bissau"],"continentCode":"AF","continentName":"Africa","countryName":"Guinea-Bissau","countryCode":"GW","mainCities":["Bissau","Bafat\xe1"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Bissau, Bafat\xe1"},{"name":"Africa/Conakry","alternativeName":"Greenwich Mean Time","group":["Africa/Conakry"],"continentCode":"AF","continentName":"Africa","countryName":"Guinea","countryCode":"GN","mainCities":["Camayenne","Conakry","Nz\xe9r\xe9kor\xe9","Kindia"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Camayenne, Conakry, Nz\xe9r\xe9kor\xe9, Kindia"},{"name":"Africa/Dakar","alternativeName":"Greenwich Mean Time","group":["Africa/Dakar"],"continentCode":"AF","continentName":"Africa","countryName":"Senegal","countryCode":"SN","mainCities":["Dakar","Pikine","Touba","Thi\xe8s"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Dakar, Pikine, Touba, Thi\xe8s"},{"name":"America/Danmarkshavn","alternativeName":"Greenwich Mean Time","group":["America/Danmarkshavn"],"continentCode":"NA","continentName":"North America","countryName":"Greenland","countryCode":"GL","mainCities":["Danmarkshavn"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Danmarkshavn"},{"name":"Europe/Isle_of_Man","alternativeName":"Greenwich Mean Time","group":["Europe/Isle_of_Man"],"continentCode":"EU","continentName":"Europe","countryName":"Isle of Man","countryCode":"IM","mainCities":["Douglas"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Douglas"},{"name":"Europe/Dublin","alternativeName":"Greenwich Mean Time","group":["Europe/Dublin","Eire"],"continentCode":"EU","continentName":"Europe","countryName":"Ireland","countryCode":"IE","mainCities":["Dublin","South Dublin","Cork","Limerick"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Dublin, South Dublin, Cork, Limerick"},{"name":"Africa/Freetown","alternativeName":"Greenwich Mean Time","group":["Africa/Freetown"],"continentCode":"AF","continentName":"Africa","countryName":"Sierra Leone","countryCode":"SL","mainCities":["Freetown","Bo","Kenema","Koidu"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Freetown, Bo, Kenema, Koidu"},{"name":"Atlantic/St_Helena","alternativeName":"Greenwich Mean Time","group":["Atlantic/St_Helena"],"continentCode":"AF","continentName":"Africa","countryName":"Saint Helena","countryCode":"SH","mainCities":["Jamestown"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Jamestown"},{"name":"Africa/Lome","alternativeName":"Greenwich Mean Time","group":["Africa/Lome"],"continentCode":"AF","continentName":"Africa","countryName":"Togo","countryCode":"TG","mainCities":["Lom\xe9","Sokod\xe9","Kara","Atakpam\xe9"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Lom\xe9, Sokod\xe9, Kara, Atakpam\xe9"},{"name":"Europe/London","alternativeName":"Greenwich Mean Time","group":["Europe/London","GB","GB-Eire","Europe/Guernsey","Europe/Isle_of_Man","Europe/Jersey","Europe/Belfast"],"continentCode":"EU","continentName":"Europe","countryName":"United Kingdom","countryCode":"GB","mainCities":["London","Birmingham","Liverpool","Glasgow"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - London, Birmingham, Liverpool, Glasgow"},{"name":"Africa/Monrovia","alternativeName":"Greenwich Mean Time","group":["Africa/Monrovia"],"continentCode":"AF","continentName":"Africa","countryName":"Liberia","countryCode":"LR","mainCities":["Monrovia","Gbarnga","Kakata","Bensonville"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Monrovia, Gbarnga, Kakata, Bensonville"},{"name":"Africa/Nouakchott","alternativeName":"Greenwich Mean Time","group":["Africa/Nouakchott"],"continentCode":"AF","continentName":"Africa","countryName":"Mauritania","countryCode":"MR","mainCities":["Nouakchott","Nouadhibou","Dar Naim","N\xe9ma"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Nouakchott, Nouadhibou, Dar Naim, N\xe9ma"},{"name":"Africa/Ouagadougou","alternativeName":"Greenwich Mean Time","group":["Africa/Ouagadougou"],"continentCode":"AF","continentName":"Africa","countryName":"Burkina Faso","countryCode":"BF","mainCities":["Ouagadougou","Bobo-Dioulasso","Koudougou","Ouahigouya"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Ouagadougou, Bobo-Dioulasso, Koudougou, Ouahigouya"},{"name":"Atlantic/Reykjavik","alternativeName":"Greenwich Mean Time","group":["Atlantic/Reykjavik","Iceland"],"continentCode":"EU","continentName":"Europe","countryName":"Iceland","countryCode":"IS","mainCities":["Reykjav\xedk","K\xf3pavogur","Hafnarfj\xf6r\xf0ur","Reykjanesb\xe6r"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Reykjav\xedk, K\xf3pavogur, Hafnarfj\xf6r\xf0ur, Reykjanesb\xe6r"},{"name":"Europe/Jersey","alternativeName":"Greenwich Mean Time","group":["Europe/Jersey"],"continentCode":"EU","continentName":"Europe","countryName":"Jersey","countryCode":"JE","mainCities":["Saint Helier"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Saint Helier"},{"name":"Europe/Guernsey","alternativeName":"Greenwich Mean Time","group":["Europe/Guernsey"],"continentCode":"EU","continentName":"Europe","countryName":"Guernsey","countryCode":"GG","mainCities":["Saint Peter Port"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Saint Peter Port"},{"name":"Africa/Banjul","alternativeName":"Greenwich Mean Time","group":["Africa/Banjul"],"continentCode":"AF","continentName":"Africa","countryName":"Gambia","countryCode":"GM","mainCities":["Serekunda","Brikama","Bakau","Banjul"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Serekunda, Brikama, Bakau, Banjul"},{"name":"Africa/Sao_Tome","alternativeName":"Greenwich Mean Time","group":["Africa/Sao_Tome"],"continentCode":"AF","continentName":"Africa","countryName":"Sao Tome and Principe","countryCode":"ST","mainCities":["S\xe3o Tom\xe9"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - S\xe3o Tom\xe9"},{"name":"Antarctica/Troll","alternativeName":"Greenwich Mean Time","group":["Antarctica/Troll"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Troll"],"rawOffsetInMinutes":0,"abbreviation":"GMT","rawFormat":"+00:00 Greenwich Mean Time - Troll"},{"name":"Africa/Casablanca","alternativeName":"Western European Time","group":["Africa/Casablanca"],"continentCode":"AF","continentName":"Africa","countryName":"Morocco","countryCode":"MA","mainCities":["Casablanca","Rabat","F\xe8s","Sale"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Casablanca, Rabat, F\xe8s, Sale"},{"name":"Africa/El_Aaiun","alternativeName":"Western European Time","group":["Africa/El_Aaiun"],"continentCode":"AF","continentName":"Africa","countryName":"Western Sahara","countryCode":"EH","mainCities":["Laayoune","Dakhla","Boujdour"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Laayoune, Dakhla, Boujdour"},{"name":"Atlantic/Canary","alternativeName":"Western European Time","group":["Atlantic/Canary"],"continentCode":"EU","continentName":"Europe","countryName":"Spain","countryCode":"ES","mainCities":["Las Palmas de Gran Canaria","Santa Cruz de Tenerife","La Laguna","Telde"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde"},{"name":"Europe/Lisbon","alternativeName":"Western European Time","group":["Atlantic/Madeira","Europe/Lisbon","Portugal"],"continentCode":"EU","continentName":"Europe","countryName":"Portugal","countryCode":"PT","mainCities":["Lisbon","Porto","Amadora","Braga"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - Lisbon, Porto, Amadora, Braga"},{"name":"Atlantic/Faroe","alternativeName":"Western European Time","group":["Atlantic/Faroe","Atlantic/Faeroe"],"continentCode":"EU","continentName":"Europe","countryName":"Faroe Islands","countryCode":"FO","mainCities":["T\xf3rshavn"],"rawOffsetInMinutes":0,"abbreviation":"WET","rawFormat":"+00:00 Western European Time - T\xf3rshavn"},{"name":"Africa/Windhoek","alternativeName":"Central Africa Time","group":["Africa/Windhoek"],"continentCode":"AF","continentName":"Africa","countryName":"Namibia","countryCode":"NA","mainCities":["Windhoek","Rundu","Walvis Bay","Oshakati"],"rawOffsetInMinutes":60,"abbreviation":"CAT","rawFormat":"+01:00 Central Africa Time - Windhoek, Rundu, Walvis Bay, Oshakati"},{"name":"Africa/Algiers","alternativeName":"Central European Time","group":["Africa/Algiers"],"continentCode":"AF","continentName":"Africa","countryName":"Algeria","countryCode":"DZ","mainCities":["Algiers","Boumerdas","Oran","T\xe9bessa"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Algiers, Boumerdas, Oran, T\xe9bessa"},{"name":"Europe/Amsterdam","alternativeName":"Central European Time","group":["Europe/Amsterdam"],"continentCode":"EU","continentName":"Europe","countryName":"Netherlands","countryCode":"NL","mainCities":["Amsterdam","Rotterdam","The Hague","Utrecht"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Amsterdam, Rotterdam, The Hague, Utrecht"},{"name":"Europe/Andorra","alternativeName":"Central European Time","group":["Europe/Andorra"],"continentCode":"EU","continentName":"Europe","countryName":"Andorra","countryCode":"AD","mainCities":["Andorra la Vella","les Escaldes"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Andorra la Vella, les Escaldes"},{"name":"Europe/Belgrade","alternativeName":"Central European Time","group":["Europe/Belgrade","Europe/Ljubljana","Europe/Podgorica","Europe/Sarajevo","Europe/Skopje","Europe/Zagreb"],"continentCode":"EU","continentName":"Europe","countryName":"Serbia","countryCode":"RS","mainCities":["Belgrade","Ni\u0161","Novi Sad","Zemun"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Belgrade, Ni\u0161, Novi Sad, Zemun"},{"name":"Europe/Berlin","alternativeName":"Central European Time","group":["Europe/Berlin","Europe/Busingen","Arctic/Longyearbyen","Europe/Copenhagen","Europe/Oslo","Europe/Stockholm","Atlantic/Jan_Mayen"],"continentCode":"EU","continentName":"Europe","countryName":"Germany","countryCode":"DE","mainCities":["Berlin","Hamburg","Munich","K\xf6ln"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Berlin, Hamburg, Munich, K\xf6ln"},{"name":"Europe/Bratislava","alternativeName":"Central European Time","group":["Europe/Bratislava"],"continentCode":"EU","continentName":"Europe","countryName":"Slovakia","countryCode":"SK","mainCities":["Bratislava","Ko\u0161ice","Nitra","Pre\u0161ov"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Bratislava, Ko\u0161ice, Nitra, Pre\u0161ov"},{"name":"Europe/Brussels","alternativeName":"Central European Time","group":["Europe/Brussels","Europe/Amsterdam","Europe/Luxembourg"],"continentCode":"EU","continentName":"Europe","countryName":"Belgium","countryCode":"BE","mainCities":["Brussels","Antwerpen","Gent","Charleroi"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Brussels, Antwerpen, Gent, Charleroi"},{"name":"Europe/Budapest","alternativeName":"Central European Time","group":["Europe/Budapest"],"continentCode":"EU","continentName":"Europe","countryName":"Hungary","countryCode":"HU","mainCities":["Budapest","Debrecen","Szeged","Miskolc"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Budapest, Debrecen, Szeged, Miskolc"},{"name":"Europe/Copenhagen","alternativeName":"Central European Time","group":["Europe/Copenhagen"],"continentCode":"EU","continentName":"Europe","countryName":"Denmark","countryCode":"DK","mainCities":["Copenhagen","\xc5rhus","Odense","Aalborg"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Copenhagen, \xc5rhus, Odense, Aalborg"},{"name":"Europe/Gibraltar","alternativeName":"Central European Time","group":["Europe/Gibraltar"],"continentCode":"EU","continentName":"Europe","countryName":"Gibraltar","countryCode":"GI","mainCities":["Gibraltar"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Gibraltar"},{"name":"Europe/Ljubljana","alternativeName":"Central European Time","group":["Europe/Ljubljana"],"continentCode":"EU","continentName":"Europe","countryName":"Slovenia","countryCode":"SI","mainCities":["Ljubljana","Maribor","Kranj","Celje"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Ljubljana, Maribor, Kranj, Celje"},{"name":"Arctic/Longyearbyen","alternativeName":"Central European Time","group":["Arctic/Longyearbyen"],"continentCode":"EU","continentName":"Europe","countryName":"Svalbard and Jan Mayen","countryCode":"SJ","mainCities":["Longyearbyen"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Longyearbyen"},{"name":"Europe/Luxembourg","alternativeName":"Central European Time","group":["Europe/Luxembourg"],"continentCode":"EU","continentName":"Europe","countryName":"Luxembourg","countryCode":"LU","mainCities":["Luxembourg","Esch-sur-Alzette","Dudelange"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Luxembourg, Esch-sur-Alzette, Dudelange"},{"name":"Europe/Madrid","alternativeName":"Central European Time","group":["Africa/Ceuta","Europe/Madrid"],"continentCode":"EU","continentName":"Europe","countryName":"Spain","countryCode":"ES","mainCities":["Madrid","Barcelona","Valencia","Sevilla"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Madrid, Barcelona, Valencia, Sevilla"},{"name":"Europe/Monaco","alternativeName":"Central European Time","group":["Europe/Monaco"],"continentCode":"EU","continentName":"Europe","countryName":"Monaco","countryCode":"MC","mainCities":["Monaco","Monte-Carlo"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Monaco, Monte-Carlo"},{"name":"Europe/Oslo","alternativeName":"Central European Time","group":["Europe/Oslo","Atlantic/Jan_Mayen"],"continentCode":"EU","continentName":"Europe","countryName":"Norway","countryCode":"NO","mainCities":["Oslo","Bergen","Trondheim","Stavanger"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Oslo, Bergen, Trondheim, Stavanger"},{"name":"Europe/Paris","alternativeName":"Central European Time","group":["Europe/Paris","Europe/Monaco"],"continentCode":"EU","continentName":"Europe","countryName":"France","countryCode":"FR","mainCities":["Paris","Marseille","Lyon","Toulouse"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Paris, Marseille, Lyon, Toulouse"},{"name":"Europe/Podgorica","alternativeName":"Central European Time","group":["Europe/Podgorica"],"continentCode":"EU","continentName":"Europe","countryName":"Montenegro","countryCode":"ME","mainCities":["Podgorica","Nik\u0161i\u0107","Herceg Novi","Pljevlja"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Podgorica, Nik\u0161i\u0107, Herceg Novi, Pljevlja"},{"name":"Europe/Prague","alternativeName":"Central European Time","group":["Europe/Prague","Europe/Bratislava"],"continentCode":"EU","continentName":"Europe","countryName":"Czechia","countryCode":"CZ","mainCities":["Prague","Brno","Ostrava","Pilsen"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Prague, Brno, Ostrava, Pilsen"},{"name":"Europe/Rome","alternativeName":"Central European Time","group":["Europe/Rome","Europe/San_Marino","Europe/Vatican"],"continentCode":"EU","continentName":"Europe","countryName":"Italy","countryCode":"IT","mainCities":["Rome","Milan","Naples","Turin"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Rome, Milan, Naples, Turin"},{"name":"Europe/San_Marino","alternativeName":"Central European Time","group":["Europe/San_Marino"],"continentCode":"EU","continentName":"Europe","countryName":"San Marino","countryCode":"SM","mainCities":["San Marino"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - San Marino"},{"name":"Europe/Malta","alternativeName":"Central European Time","group":["Europe/Malta"],"continentCode":"EU","continentName":"Europe","countryName":"Malta","countryCode":"MT","mainCities":["San Pawl il-Ba\u0127ar","Birkirkara","Mosta","Sliema"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - San Pawl il-Ba\u0127ar, Birkirkara, Mosta, Sliema"},{"name":"Europe/Sarajevo","alternativeName":"Central European Time","group":["Europe/Sarajevo"],"continentCode":"EU","continentName":"Europe","countryName":"Bosnia and Herzegovina","countryCode":"BA","mainCities":["Sarajevo","Banja Luka","Zenica","Tuzla"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Sarajevo, Banja Luka, Zenica, Tuzla"},{"name":"Europe/Skopje","alternativeName":"Central European Time","group":["Europe/Skopje"],"continentCode":"EU","continentName":"Europe","countryName":"North Macedonia","countryCode":"MK","mainCities":["Skopje","Kumanovo","Prilep","Bitola"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Skopje, Kumanovo, Prilep, Bitola"},{"name":"Europe/Stockholm","alternativeName":"Central European Time","group":["Europe/Stockholm"],"continentCode":"EU","continentName":"Europe","countryName":"Sweden","countryCode":"SE","mainCities":["Stockholm","G\xf6teborg","Malm\xf6","Uppsala"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Stockholm, G\xf6teborg, Malm\xf6, Uppsala"},{"name":"Europe/Tirane","alternativeName":"Central European Time","group":["Europe/Tirane"],"continentCode":"EU","continentName":"Europe","countryName":"Albania","countryCode":"AL","mainCities":["Tirana","Durr\xebs","Elbasan","Vlor\xeb"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Tirana, Durr\xebs, Elbasan, Vlor\xeb"},{"name":"Africa/Tunis","alternativeName":"Central European Time","group":["Africa/Tunis"],"continentCode":"AF","continentName":"Africa","countryName":"Tunisia","countryCode":"TN","mainCities":["Tunis","Sfax","Sousse","Kairouan"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Tunis, Sfax, Sousse, Kairouan"},{"name":"Europe/Vaduz","alternativeName":"Central European Time","group":["Europe/Vaduz"],"continentCode":"EU","continentName":"Europe","countryName":"Liechtenstein","countryCode":"LI","mainCities":["Vaduz"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vaduz"},{"name":"Europe/Vatican","alternativeName":"Central European Time","group":["Europe/Vatican"],"continentCode":"EU","continentName":"Europe","countryName":"Vatican","countryCode":"VA","mainCities":["Vatican City"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vatican City"},{"name":"Europe/Vienna","alternativeName":"Central European Time","group":["Europe/Vienna"],"continentCode":"EU","continentName":"Europe","countryName":"Austria","countryCode":"AT","mainCities":["Vienna","Graz","Linz","Favoriten"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Vienna, Graz, Linz, Favoriten"},{"name":"Europe/Warsaw","alternativeName":"Central European Time","group":["Europe/Warsaw","Poland"],"continentCode":"EU","continentName":"Europe","countryName":"Poland","countryCode":"PL","mainCities":["Warsaw","\u0141\xf3d\u017A","Krak\xf3w","Wroc\u0142aw"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Warsaw, \u0141\xf3d\u017A, Krak\xf3w, Wroc\u0142aw"},{"name":"Europe/Zagreb","alternativeName":"Central European Time","group":["Europe/Zagreb"],"continentCode":"EU","continentName":"Europe","countryName":"Croatia","countryCode":"HR","mainCities":["Zagreb","Split","Rijeka","Osijek"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Zagreb, Split, Rijeka, Osijek"},{"name":"Europe/Zurich","alternativeName":"Central European Time","group":["Europe/Zurich","Europe/Busingen","Europe/Vaduz"],"continentCode":"EU","continentName":"Europe","countryName":"Switzerland","countryCode":"CH","mainCities":["Z\xfcrich","Gen\xe8ve","Basel","Lausanne"],"rawOffsetInMinutes":60,"abbreviation":"CET","rawFormat":"+01:00 Central European Time - Z\xfcrich, Gen\xe8ve, Basel, Lausanne"},{"name":"Africa/Bangui","alternativeName":"West Africa Time","group":["Africa/Bangui"],"continentCode":"AF","continentName":"Africa","countryName":"Central African Republic","countryCode":"CF","mainCities":["Bangui","Bimbo","Mba\xefki","Berb\xe9rati"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Bangui, Bimbo, Mba\xefki, Berb\xe9rati"},{"name":"Africa/Malabo","alternativeName":"West Africa Time","group":["Africa/Malabo"],"continentCode":"AF","continentName":"Africa","countryName":"Equatorial Guinea","countryCode":"GQ","mainCities":["Bata","Malabo","Ebebiyin"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Bata, Malabo, Ebebiyin"},{"name":"Africa/Brazzaville","alternativeName":"West Africa Time","group":["Africa/Brazzaville"],"continentCode":"AF","continentName":"Africa","countryName":"Republic of the Congo","countryCode":"CG","mainCities":["Brazzaville","Pointe-Noire","Dolisie","Kayes"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Brazzaville, Pointe-Noire, Dolisie, Kayes"},{"name":"Africa/Porto-Novo","alternativeName":"West Africa Time","group":["Africa/Porto-Novo"],"continentCode":"AF","continentName":"Africa","countryName":"Benin","countryCode":"BJ","mainCities":["Cotonou","Abomey-Calavi","Djougou","Porto-Novo"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Cotonou, Abomey-Calavi, Djougou, Porto-Novo"},{"name":"Africa/Douala","alternativeName":"West Africa Time","group":["Africa/Douala"],"continentCode":"AF","continentName":"Africa","countryName":"Cameroon","countryCode":"CM","mainCities":["Douala","Yaound\xe9","Garoua","Kouss\xe9ri"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Douala, Yaound\xe9, Garoua, Kouss\xe9ri"},{"name":"Africa/Kinshasa","alternativeName":"West Africa Time","group":["Africa/Kinshasa"],"continentCode":"AF","continentName":"Africa","countryName":"Democratic Republic of the Congo","countryCode":"CD","mainCities":["Kinshasa","Masina","Kikwit","Mbandaka"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Kinshasa, Masina, Kikwit, Mbandaka"},{"name":"Africa/Lagos","alternativeName":"West Africa Time","group":["Africa/Lagos","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Africa/Kinshasa","Africa/Libreville","Africa/Luanda","Africa/Malabo","Africa/Niamey","Africa/Porto-Novo"],"continentCode":"AF","continentName":"Africa","countryName":"Nigeria","countryCode":"NG","mainCities":["Lagos","Kano","Ibadan","Port Harcourt"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Lagos, Kano, Ibadan, Port Harcourt"},{"name":"Africa/Libreville","alternativeName":"West Africa Time","group":["Africa/Libreville"],"continentCode":"AF","continentName":"Africa","countryName":"Gabon","countryCode":"GA","mainCities":["Libreville","Port-Gentil","Franceville","Oyem"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Libreville, Port-Gentil, Franceville, Oyem"},{"name":"Africa/Luanda","alternativeName":"West Africa Time","group":["Africa/Luanda"],"continentCode":"AF","continentName":"Africa","countryName":"Angola","countryCode":"AO","mainCities":["Luanda","N\u2019dalatando","Huambo","Lobito"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Luanda, N\u2019dalatando, Huambo, Lobito"},{"name":"Africa/Ndjamena","alternativeName":"West Africa Time","group":["Africa/Ndjamena"],"continentCode":"AF","continentName":"Africa","countryName":"Chad","countryCode":"TD","mainCities":["N\'Djamena","Moundou","Sarh","Ab\xe9ch\xe9"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - N\'Djamena, Moundou, Sarh, Ab\xe9ch\xe9"},{"name":"Africa/Niamey","alternativeName":"West Africa Time","group":["Africa/Niamey"],"continentCode":"AF","continentName":"Africa","countryName":"Niger","countryCode":"NE","mainCities":["Niamey","Zinder","Maradi","Agadez"],"rawOffsetInMinutes":60,"abbreviation":"WAT","rawFormat":"+01:00 West Africa Time - Niamey, Zinder, Maradi, Agadez"},{"name":"Africa/Bujumbura","alternativeName":"Central Africa Time","group":["Africa/Bujumbura"],"continentCode":"AF","continentName":"Africa","countryName":"Burundi","countryCode":"BI","mainCities":["Bujumbura","Muyinga","Gitega","Ruyigi"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Bujumbura, Muyinga, Gitega, Ruyigi"},{"name":"Africa/Gaborone","alternativeName":"Central Africa Time","group":["Africa/Gaborone"],"continentCode":"AF","continentName":"Africa","countryName":"Botswana","countryCode":"BW","mainCities":["Gaborone","Francistown","Molepolole","Maun"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Gaborone, Francistown, Molepolole, Maun"},{"name":"Africa/Harare","alternativeName":"Central Africa Time","group":["Africa/Harare"],"continentCode":"AF","continentName":"Africa","countryName":"Zimbabwe","countryCode":"ZW","mainCities":["Harare","Bulawayo","Chitungwiza","Mutare"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Harare, Bulawayo, Chitungwiza, Mutare"},{"name":"Africa/Juba","alternativeName":"Central Africa Time","group":["Africa/Juba"],"continentCode":"AF","continentName":"Africa","countryName":"South Sudan","countryCode":"SS","mainCities":["Juba","Winejok","Yei","Malakal"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Juba, Winejok, Yei, Malakal"},{"name":"Africa/Khartoum","alternativeName":"Central Africa Time","group":["Africa/Khartoum"],"continentCode":"AF","continentName":"Africa","countryName":"Sudan","countryCode":"SD","mainCities":["Khartoum","Omdurman","Nyala","Port Sudan"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Khartoum, Omdurman, Nyala, Port Sudan"},{"name":"Africa/Kigali","alternativeName":"Central Africa Time","group":["Africa/Kigali"],"continentCode":"AF","continentName":"Africa","countryName":"Rwanda","countryCode":"RW","mainCities":["Kigali","Gisenyi","Butare","Gitarama"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Kigali, Gisenyi, Butare, Gitarama"},{"name":"Africa/Blantyre","alternativeName":"Central Africa Time","group":["Africa/Blantyre"],"continentCode":"AF","continentName":"Africa","countryName":"Malawi","countryCode":"MW","mainCities":["Lilongwe","Blantyre","Mzuzu","Zomba"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lilongwe, Blantyre, Mzuzu, Zomba"},{"name":"Africa/Lubumbashi","alternativeName":"Central Africa Time","group":["Africa/Lubumbashi"],"continentCode":"AF","continentName":"Africa","countryName":"Democratic Republic of the Congo","countryCode":"CD","mainCities":["Lubumbashi","Mbuji-Mayi","Kisangani","Kananga"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lubumbashi, Mbuji-Mayi, Kisangani, Kananga"},{"name":"Africa/Lusaka","alternativeName":"Central Africa Time","group":["Africa/Lusaka"],"continentCode":"AF","continentName":"Africa","countryName":"Zambia","countryCode":"ZM","mainCities":["Lusaka","Ndola","Kitwe","Chipata"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Lusaka, Ndola, Kitwe, Chipata"},{"name":"Africa/Maputo","alternativeName":"Central Africa Time","group":["Africa/Maputo","Africa/Blantyre","Africa/Bujumbura","Africa/Gaborone","Africa/Harare","Africa/Kigali","Africa/Lubumbashi","Africa/Lusaka"],"continentCode":"AF","continentName":"Africa","countryName":"Mozambique","countryCode":"MZ","mainCities":["Maputo","Matola","Nampula","Beira"],"rawOffsetInMinutes":120,"abbreviation":"CAT","rawFormat":"+02:00 Central Africa Time - Maputo, Matola, Nampula, Beira"},{"name":"Europe/Athens","alternativeName":"Eastern European Time","group":["Europe/Athens"],"continentCode":"EU","continentName":"Europe","countryName":"Greece","countryCode":"GR","mainCities":["Athens","Thessalon\xedki","P\xe1tra","Piraeus"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Athens, Thessalon\xedki, P\xe1tra, Piraeus"},{"name":"Asia/Beirut","alternativeName":"Eastern European Time","group":["Asia/Beirut"],"continentCode":"AS","continentName":"Asia","countryName":"Lebanon","countryCode":"LB","mainCities":["Beirut","Ra\u2019s Bayr\u016Bt","Tripoli","Sidon"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Beirut, Ra\u2019s Bayr\u016Bt, Tripoli, Sidon"},{"name":"Europe/Bucharest","alternativeName":"Eastern European Time","group":["Europe/Bucharest"],"continentCode":"EU","continentName":"Europe","countryName":"Romania","countryCode":"RO","mainCities":["Bucharest","Sector 3","Ia\u015Fi","Sector 6"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Bucharest, Sector 3, Ia\u015Fi, Sector 6"},{"name":"Africa/Cairo","alternativeName":"Eastern European Time","group":["Africa/Cairo","Egypt"],"continentCode":"AF","continentName":"Africa","countryName":"Egypt","countryCode":"EG","mainCities":["Cairo","Alexandria","Giza","Shubr\u0101 al Khaymah"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Cairo, Alexandria, Giza, Shubr\u0101 al Khaymah"},{"name":"Europe/Chisinau","alternativeName":"Eastern European Time","group":["Europe/Chisinau","Europe/Tiraspol"],"continentCode":"EU","continentName":"Europe","countryName":"Moldova","countryCode":"MD","mainCities":["Chisinau","Tiraspol","B\u0103l\u0163i","Bender"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Chisinau, Tiraspol, B\u0103l\u0163i, Bender"},{"name":"Asia/Hebron","alternativeName":"Eastern European Time","group":["Asia/Gaza","Asia/Hebron"],"continentCode":"AS","continentName":"Asia","countryName":"Palestinian Territory","countryCode":"PS","mainCities":["East Jerusalem","Gaza","Kh\u0101n Y\u016Bnis","Jab\u0101ly\u0101"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - East Jerusalem, Gaza, Kh\u0101n Y\u016Bnis, Jab\u0101ly\u0101"},{"name":"Europe/Helsinki","alternativeName":"Eastern European Time","group":["Europe/Helsinki","Europe/Mariehamn"],"continentCode":"EU","continentName":"Europe","countryName":"Finland","countryCode":"FI","mainCities":["Helsinki","Espoo","Tampere","Oulu"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Helsinki, Espoo, Tampere, Oulu"},{"name":"Europe/Kaliningrad","alternativeName":"Eastern European Time","group":["Europe/Kaliningrad"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Kaliningrad","Chernyakhovsk","Sovetsk","Baltiysk"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk"},{"name":"Europe/Kyiv","alternativeName":"Eastern European Time","group":["Europe/Kyiv","Europe/Uzhgorod","Europe/Zaporozhye","Europe/Kiev"],"continentCode":"EU","continentName":"Europe","countryName":"Ukraine","countryCode":"UA","mainCities":["Kyiv","Kharkiv","Odesa","Dnipro"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Kyiv, Kharkiv, Odesa, Dnipro"},{"name":"Europe/Mariehamn","alternativeName":"Eastern European Time","group":["Europe/Mariehamn"],"continentCode":"EU","continentName":"Europe","countryName":"Aland Islands","countryCode":"AX","mainCities":["Mariehamn"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Mariehamn"},{"name":"Asia/Nicosia","alternativeName":"Eastern European Time","group":["Asia/Famagusta","Asia/Nicosia","Europe/Nicosia"],"continentCode":"EU","continentName":"Europe","countryName":"Cyprus","countryCode":"CY","mainCities":["Nicosia","Limassol","Larnaca","Str\xf3volos"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Nicosia, Limassol, Larnaca, Str\xf3volos"},{"name":"Europe/Riga","alternativeName":"Eastern European Time","group":["Europe/Riga"],"continentCode":"EU","continentName":"Europe","countryName":"Latvia","countryCode":"LV","mainCities":["Riga","Daugavpils","Liep\u0101ja","Jelgava"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Riga, Daugavpils, Liep\u0101ja, Jelgava"},{"name":"Europe/Sofia","alternativeName":"Eastern European Time","group":["Europe/Sofia"],"continentCode":"EU","continentName":"Europe","countryName":"Bulgaria","countryCode":"BG","mainCities":["Sofia","Plovdiv","Varna","Burgas"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Sofia, Plovdiv, Varna, Burgas"},{"name":"Europe/Tallinn","alternativeName":"Eastern European Time","group":["Europe/Tallinn"],"continentCode":"EU","continentName":"Europe","countryName":"Estonia","countryCode":"EE","mainCities":["Tallinn","Tartu","Narva","P\xe4rnu"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Tallinn, Tartu, Narva, P\xe4rnu"},{"name":"Africa/Tripoli","alternativeName":"Eastern European Time","group":["Africa/Tripoli","Libya"],"continentCode":"AF","continentName":"Africa","countryName":"Libya","countryCode":"LY","mainCities":["Tripoli","Benghazi","Ajdabiya","Mi\u015Fr\u0101tah"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Tripoli, Benghazi, Ajdabiya, Mi\u015Fr\u0101tah"},{"name":"Europe/Vilnius","alternativeName":"Eastern European Time","group":["Europe/Vilnius"],"continentCode":"EU","continentName":"Europe","countryName":"Lithuania","countryCode":"LT","mainCities":["Vilnius","Kaunas","Klaip\u0117da","\u0160iauliai"],"rawOffsetInMinutes":120,"abbreviation":"EET","rawFormat":"+02:00 Eastern European Time - Vilnius, Kaunas, Klaip\u0117da, \u0160iauliai"},{"name":"Asia/Jerusalem","alternativeName":"Israel Time","group":["Asia/Jerusalem","Israel","Asia/Tel_Aviv"],"continentCode":"AS","continentName":"Asia","countryName":"Israel","countryCode":"IL","mainCities":["Jerusalem","Tel Aviv","West Jerusalem","Haifa"],"rawOffsetInMinutes":120,"abbreviation":"IST","rawFormat":"+02:00 Israel Time - Jerusalem, Tel Aviv, West Jerusalem, Haifa"},{"name":"Africa/Johannesburg","alternativeName":"South Africa Time","group":["Africa/Johannesburg","Africa/Maseru","Africa/Mbabane"],"continentCode":"AF","continentName":"Africa","countryName":"South Africa","countryCode":"ZA","mainCities":["Johannesburg","Cape Town","Durban","Soweto"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Johannesburg, Cape Town, Durban, Soweto"},{"name":"Africa/Mbabane","alternativeName":"South Africa Time","group":["Africa/Mbabane"],"continentCode":"AF","continentName":"Africa","countryName":"Eswatini","countryCode":"SZ","mainCities":["Manzini","Mbabane","Lobamba"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Manzini, Mbabane, Lobamba"},{"name":"Africa/Maseru","alternativeName":"South Africa Time","group":["Africa/Maseru"],"continentCode":"AF","continentName":"Africa","countryName":"Lesotho","countryCode":"LS","mainCities":["Maseru","Mohale\u2019s Hoek","Mafeteng","Leribe"],"rawOffsetInMinutes":120,"abbreviation":"SAST","rawFormat":"+02:00 South Africa Time - Maseru, Mohale\u2019s Hoek, Mafeteng, Leribe"},{"name":"Asia/Kuwait","alternativeName":"Arabian Time","group":["Asia/Kuwait"],"continentCode":"AS","continentName":"Asia","countryName":"Kuwait","countryCode":"KW","mainCities":["Al A\u1E29mad\u012B","\u1E28awall\u012B","As S\u0101lim\u012Byah","\u015Eab\u0101\u1E29 as S\u0101lim"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Al A\u1E29mad\u012B, \u1E28awall\u012B, As S\u0101lim\u012Byah, \u015Eab\u0101\u1E29 as S\u0101lim"},{"name":"Asia/Bahrain","alternativeName":"Arabian Time","group":["Asia/Bahrain"],"continentCode":"AS","continentName":"Asia","countryName":"Bahrain","countryCode":"BH","mainCities":["Ar Rif\u0101\u2018","Manama","Al Muharraq","D\u0101r Kulayb"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Ar Rif\u0101\u2018, Manama, Al Muharraq, D\u0101r Kulayb"},{"name":"Asia/Baghdad","alternativeName":"Arabian Time","group":["Asia/Baghdad"],"continentCode":"AS","continentName":"Asia","countryName":"Iraq","countryCode":"IQ","mainCities":["Baghdad","Al Maw\u015Fil al Jad\u012Bdah","Al Ba\u015Frah al Qad\u012Bmah","Mosul"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Baghdad, Al Maw\u015Fil al Jad\u012Bdah, Al Ba\u015Frah al Qad\u012Bmah, Mosul"},{"name":"Asia/Qatar","alternativeName":"Arabian Time","group":["Asia/Qatar","Asia/Bahrain"],"continentCode":"AS","continentName":"Asia","countryName":"Qatar","countryCode":"QA","mainCities":["Doha","Ar Rayy\u0101n","Umm \u015Eal\u0101l Mu\u1E29ammad","Al Wakrah"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Doha, Ar Rayy\u0101n, Umm \u015Eal\u0101l Mu\u1E29ammad, Al Wakrah"},{"name":"Asia/Riyadh","alternativeName":"Arabian Time","group":["Asia/Riyadh","Antarctica/Syowa","Asia/Aden","Asia/Kuwait"],"continentCode":"AS","continentName":"Asia","countryName":"Saudi Arabia","countryCode":"SA","mainCities":["Jeddah","Riyadh","Mecca","Medina"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Jeddah, Riyadh, Mecca, Medina"},{"name":"Asia/Aden","alternativeName":"Arabian Time","group":["Asia/Aden"],"continentCode":"AS","continentName":"Asia","countryName":"Yemen","countryCode":"YE","mainCities":["Sanaa","Aden","Al \u1E28udaydah","Taiz"],"rawOffsetInMinutes":180,"abbreviation":"AST","rawFormat":"+03:00 Arabian Time - Sanaa, Aden, Al \u1E28udaydah, Taiz"},{"name":"Asia/Amman","alternativeName":"Asia/Amman","group":["Asia/Amman"],"continentCode":"AS","continentName":"Asia","countryName":"Jordan","countryCode":"JO","mainCities":["Amman","Zarqa","Irbid","Russeifa"],"rawOffsetInMinutes":180,"abbreviation":"GMT+3","rawFormat":"+03:00 Asia/Amman - Amman, Zarqa, Irbid, Russeifa"},{"name":"Asia/Damascus","alternativeName":"Asia/Damascus","group":["Asia/Damascus"],"continentCode":"AS","continentName":"Asia","countryName":"Syria","countryCode":"SY","mainCities":["Aleppo","Damascus","Homs","Latakia"],"rawOffsetInMinutes":180,"abbreviation":"GMT+3","rawFormat":"+03:00 Asia/Damascus - Aleppo, Damascus, Homs, Latakia"},{"name":"Africa/Addis_Ababa","alternativeName":"East Africa Time","group":["Africa/Addis_Ababa"],"continentCode":"AF","continentName":"Africa","countryName":"Ethiopia","countryCode":"ET","mainCities":["Addis Ababa","Jijiga","Gondar","Mek\'ele"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Addis Ababa, Jijiga, Gondar, Mek\'ele"},{"name":"Indian/Antananarivo","alternativeName":"East Africa Time","group":["Indian/Antananarivo"],"continentCode":"AF","continentName":"Africa","countryName":"Madagascar","countryCode":"MG","mainCities":["Antananarivo","Toamasina","Antsirabe","Mahajanga"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Antananarivo, Toamasina, Antsirabe, Mahajanga"},{"name":"Africa/Asmara","alternativeName":"East Africa Time","group":["Africa/Asmara"],"continentCode":"AF","continentName":"Africa","countryName":"Eritrea","countryCode":"ER","mainCities":["Asmara","Keren","Massawa","Assab"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Asmara, Keren, Massawa, Assab"},{"name":"Africa/Dar_es_Salaam","alternativeName":"East Africa Time","group":["Africa/Dar_es_Salaam"],"continentCode":"AF","continentName":"Africa","countryName":"Tanzania","countryCode":"TZ","mainCities":["Dar es Salaam","Mwanza","Zanzibar","Arusha"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Dar es Salaam, Mwanza, Zanzibar, Arusha"},{"name":"Africa/Djibouti","alternativeName":"East Africa Time","group":["Africa/Djibouti"],"continentCode":"AF","continentName":"Africa","countryName":"Djibouti","countryCode":"DJ","mainCities":["Djibouti","\'Ali Sabieh","Tadjourah","Obock"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Djibouti, \'Ali Sabieh, Tadjourah, Obock"},{"name":"Africa/Kampala","alternativeName":"East Africa Time","group":["Africa/Kampala"],"continentCode":"AF","continentName":"Africa","countryName":"Uganda","countryCode":"UG","mainCities":["Kampala","Gulu","Lira","Mbarara"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Kampala, Gulu, Lira, Mbarara"},{"name":"Indian/Mayotte","alternativeName":"East Africa Time","group":["Indian/Mayotte"],"continentCode":"AF","continentName":"Africa","countryName":"Mayotte","countryCode":"YT","mainCities":["Mamoudzou","Koungou","Dzaoudzi"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Mamoudzou, Koungou, Dzaoudzi"},{"name":"Africa/Mogadishu","alternativeName":"East Africa Time","group":["Africa/Mogadishu"],"continentCode":"AF","continentName":"Africa","countryName":"Somalia","countryCode":"SO","mainCities":["Mogadishu","Hargeysa","Berbera","Kismayo"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Mogadishu, Hargeysa, Berbera, Kismayo"},{"name":"Indian/Comoro","alternativeName":"East Africa Time","group":["Indian/Comoro"],"continentCode":"AF","continentName":"Africa","countryName":"Comoros","countryCode":"KM","mainCities":["Moroni","Moutsamoudou"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Moroni, Moutsamoudou"},{"name":"Africa/Nairobi","alternativeName":"East Africa Time","group":["Africa/Nairobi","Africa/Addis_Ababa","Africa/Asmara","Africa/Dar_es_Salaam","Africa/Djibouti","Africa/Kampala","Africa/Mogadishu","Indian/Antananarivo","Indian/Comoro","Indian/Mayotte","Africa/Asmera"],"continentCode":"AF","continentName":"Africa","countryName":"Kenya","countryCode":"KE","mainCities":["Nairobi","Kakamega","Mombasa","Ruiru"],"rawOffsetInMinutes":180,"abbreviation":"EAT","rawFormat":"+03:00 East Africa Time - Nairobi, Kakamega, Mombasa, Ruiru"},{"name":"Europe/Minsk","alternativeName":"Moscow Time","group":["Europe/Minsk"],"continentCode":"EU","continentName":"Europe","countryName":"Belarus","countryCode":"BY","mainCities":["Minsk","Homyel\'","Hrodna","Mahilyow"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Minsk, Homyel\', Hrodna, Mahilyow"},{"name":"Europe/Moscow","alternativeName":"Moscow Time","group":["Europe/Kirov","Europe/Moscow","Europe/Volgograd","W-SU"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Moscow","Saint Petersburg","Nizhniy Novgorod","Kazan"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan"},{"name":"Europe/Simferopol","alternativeName":"Moscow Time","group":["Europe/Simferopol"],"continentCode":"EU","continentName":"Europe","countryName":"Ukraine","countryCode":"UA","mainCities":["Sevastopol","Simferopol","Kerch","Yevpatoriya"],"rawOffsetInMinutes":180,"abbreviation":"MSK","rawFormat":"+03:00 Moscow Time - Sevastopol, Simferopol, Kerch, Yevpatoriya"},{"name":"Antarctica/Syowa","alternativeName":"Syowa Time","group":["Antarctica/Syowa"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Syowa"],"rawOffsetInMinutes":180,"abbreviation":"SYOT","rawFormat":"+03:00 Syowa Time - Syowa"},{"name":"Europe/Istanbul","alternativeName":"Turkey Time","group":["Europe/Istanbul","Turkey","Asia/Istanbul"],"continentCode":"AS","continentName":"Asia","countryName":"Turkey","countryCode":"TR","mainCities":["Istanbul","Ankara","Bursa","\u0130zmir"],"rawOffsetInMinutes":180,"abbreviation":"TRT","rawFormat":"+03:00 Turkey Time - Istanbul, Ankara, Bursa, \u0130zmir"},{"name":"Asia/Tehran","alternativeName":"Iran Time","group":["Asia/Tehran","Iran"],"continentCode":"AS","continentName":"Asia","countryName":"Iran","countryCode":"IR","mainCities":["Tehran","Mashhad","Isfahan","Karaj"],"rawOffsetInMinutes":210,"abbreviation":"IRST","rawFormat":"+03:30 Iran Time - Tehran, Mashhad, Isfahan, Karaj"},{"name":"Asia/Yerevan","alternativeName":"Armenia Time","group":["Asia/Yerevan"],"continentCode":"AS","continentName":"Asia","countryName":"Armenia","countryCode":"AM","mainCities":["Yerevan","Gyumri","Vanadzor","Vagharshapat"],"rawOffsetInMinutes":240,"abbreviation":"AMT","rawFormat":"+04:00 Armenia Time - Yerevan, Gyumri, Vanadzor, Vagharshapat"},{"name":"Asia/Baku","alternativeName":"Azerbaijan Time","group":["Asia/Baku"],"continentCode":"AS","continentName":"Asia","countryName":"Azerbaijan","countryCode":"AZ","mainCities":["Baku","Sumqay\u0131t","Ganja","Lankaran"],"rawOffsetInMinutes":240,"abbreviation":"AZT","rawFormat":"+04:00 Azerbaijan Time - Baku, Sumqay\u0131t, Ganja, Lankaran"},{"name":"Asia/Tbilisi","alternativeName":"Georgia Time","group":["Asia/Tbilisi"],"continentCode":"AS","continentName":"Asia","countryName":"Georgia","countryCode":"GE","mainCities":["Tbilisi","Batumi","Kutaisi","Rustavi"],"rawOffsetInMinutes":240,"abbreviation":"GET","rawFormat":"+04:00 Georgia Time - Tbilisi, Batumi, Kutaisi, Rustavi"},{"name":"Asia/Dubai","alternativeName":"Gulf Time","group":["Asia/Dubai","Asia/Muscat","Indian/Mahe","Indian/Reunion"],"continentCode":"AS","continentName":"Asia","countryName":"United Arab Emirates","countryCode":"AE","mainCities":["Dubai","Abu Dhabi","Sharjah","Al Ain City"],"rawOffsetInMinutes":240,"abbreviation":"GST","rawFormat":"+04:00 Gulf Time - Dubai, Abu Dhabi, Sharjah, Al Ain City"},{"name":"Asia/Muscat","alternativeName":"Gulf Time","group":["Asia/Muscat"],"continentCode":"AS","continentName":"Asia","countryName":"Oman","countryCode":"OM","mainCities":["Muscat","Seeb","Bawshar","\u2018Ibr\u012B"],"rawOffsetInMinutes":240,"abbreviation":"GST","rawFormat":"+04:00 Gulf Time - Muscat, Seeb, Bawshar, \u2018Ibr\u012B"},{"name":"Indian/Mauritius","alternativeName":"Mauritius Time","group":["Indian/Mauritius"],"continentCode":"AF","continentName":"Africa","countryName":"Mauritius","countryCode":"MU","mainCities":["Port Louis","Vacoas","Beau Bassin-Rose Hill","Curepipe"],"rawOffsetInMinutes":240,"abbreviation":"MUT","rawFormat":"+04:00 Mauritius Time - Port Louis, Vacoas, Beau Bassin-Rose Hill, Curepipe"},{"name":"Indian/Reunion","alternativeName":"R\xe9union Time","group":["Indian/Reunion"],"continentCode":"AF","continentName":"Africa","countryName":"Reunion","countryCode":"RE","mainCities":["Saint-Denis","Saint-Paul","Le Tampon","Saint-Pierre"],"rawOffsetInMinutes":240,"abbreviation":"RET","rawFormat":"+04:00 R\xe9union Time - Saint-Denis, Saint-Paul, Le Tampon, Saint-Pierre"},{"name":"Europe/Samara","alternativeName":"Samara Time","group":["Europe/Astrakhan","Europe/Samara","Europe/Saratov","Europe/Ulyanovsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Samara","Saratov","Tolyatti","Izhevsk"],"rawOffsetInMinutes":240,"abbreviation":"SAMT","rawFormat":"+04:00 Samara Time - Samara, Saratov, Tolyatti, Izhevsk"},{"name":"Indian/Mahe","alternativeName":"Seychelles Time","group":["Indian/Mahe"],"continentCode":"AF","continentName":"Africa","countryName":"Seychelles","countryCode":"SC","mainCities":["Victoria"],"rawOffsetInMinutes":240,"abbreviation":"SCT","rawFormat":"+04:00 Seychelles Time - Victoria"},{"name":"Asia/Kabul","alternativeName":"Afghanistan Time","group":["Asia/Kabul"],"continentCode":"AS","continentName":"Asia","countryName":"Afghanistan","countryCode":"AF","mainCities":["Kabul","Her\u0101t","Maz\u0101r-e Shar\u012Bf","Kandah\u0101r"],"rawOffsetInMinutes":270,"abbreviation":"AFT","rawFormat":"+04:30 Afghanistan Time - Kabul, Her\u0101t, Maz\u0101r-e Shar\u012Bf, Kandah\u0101r"},{"name":"Indian/Kerguelen","alternativeName":"French Southern & Antarctic Time","group":["Indian/Kerguelen"],"continentCode":"AN","continentName":"Antarctica","countryName":"French Southern Territories","countryCode":"TF","mainCities":["Port-aux-Fran\xe7ais"],"rawOffsetInMinutes":300,"abbreviation":"FSAT","rawFormat":"+05:00 French Southern & Antarctic Time - Port-aux-Fran\xe7ais"},{"name":"Indian/Maldives","alternativeName":"Maldives Time","group":["Indian/Maldives","Indian/Kerguelen"],"continentCode":"AS","continentName":"Asia","countryName":"Maldives","countryCode":"MV","mainCities":["Male"],"rawOffsetInMinutes":300,"abbreviation":"MVT","rawFormat":"+05:00 Maldives Time - Male"},{"name":"Antarctica/Mawson","alternativeName":"Mawson Time","group":["Antarctica/Mawson"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Mawson"],"rawOffsetInMinutes":300,"abbreviation":"MAWT","rawFormat":"+05:00 Mawson Time - Mawson"},{"name":"Asia/Karachi","alternativeName":"Pakistan Time","group":["Asia/Karachi"],"continentCode":"AS","continentName":"Asia","countryName":"Pakistan","countryCode":"PK","mainCities":["Karachi","Lahore","Faisalabad","Rawalpindi"],"rawOffsetInMinutes":300,"abbreviation":"PKT","rawFormat":"+05:00 Pakistan Time - Karachi, Lahore, Faisalabad, Rawalpindi"},{"name":"Asia/Dushanbe","alternativeName":"Tajikistan Time","group":["Asia/Dushanbe"],"continentCode":"AS","continentName":"Asia","countryName":"Tajikistan","countryCode":"TJ","mainCities":["Dushanbe","Isfara","Istaravshan","K\u016Dlob"],"rawOffsetInMinutes":300,"abbreviation":"TJT","rawFormat":"+05:00 Tajikistan Time - Dushanbe, Isfara, Istaravshan, K\u016Dlob"},{"name":"Asia/Ashgabat","alternativeName":"Turkmenistan Time","group":["Asia/Ashgabat","Asia/Ashkhabad"],"continentCode":"AS","continentName":"Asia","countryName":"Turkmenistan","countryCode":"TM","mainCities":["Ashgabat","T\xfcrkmenabat","Da\u015Foguz","Mary"],"rawOffsetInMinutes":300,"abbreviation":"TMT","rawFormat":"+05:00 Turkmenistan Time - Ashgabat, T\xfcrkmenabat, Da\u015Foguz, Mary"},{"name":"Asia/Tashkent","alternativeName":"Uzbekistan Time","group":["Asia/Samarkand","Asia/Tashkent"],"continentCode":"AS","continentName":"Asia","countryName":"Uzbekistan","countryCode":"UZ","mainCities":["Tashkent","Namangan","Samarkand","Andijon"],"rawOffsetInMinutes":300,"abbreviation":"UZT","rawFormat":"+05:00 Uzbekistan Time - Tashkent, Namangan, Samarkand, Andijon"},{"name":"Asia/Aqtobe","alternativeName":"West Kazakhstan Time","group":["Asia/Aqtau","Asia/Aqtobe","Asia/Atyrau","Asia/Oral","Asia/Qyzylorda"],"continentCode":"AS","continentName":"Asia","countryName":"Kazakhstan","countryCode":"KZ","mainCities":["Aktobe","Kyzylorda","Oral","Atyrau"],"rawOffsetInMinutes":300,"abbreviation":"AQTT","rawFormat":"+05:00 West Kazakhstan Time - Aktobe, Kyzylorda, Oral, Atyrau"},{"name":"Asia/Yekaterinburg","alternativeName":"Yekaterinburg Time","group":["Asia/Yekaterinburg"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Yekaterinburg","Chelyabinsk","Ufa","Perm"],"rawOffsetInMinutes":300,"abbreviation":"YEKT","rawFormat":"+05:00 Yekaterinburg Time - Yekaterinburg, Chelyabinsk, Ufa, Perm"},{"name":"Asia/Colombo","alternativeName":"India Time","group":["Asia/Colombo"],"continentCode":"AS","continentName":"Asia","countryName":"Sri Lanka","countryCode":"LK","mainCities":["Colombo","Dehiwala-Mount Lavinia","Maharagama","Jaffna"],"rawOffsetInMinutes":330,"abbreviation":"IST","rawFormat":"+05:30 India Time - Colombo, Dehiwala-Mount Lavinia, Maharagama, Jaffna"},{"name":"Asia/Kolkata","alternativeName":"India Time","group":["Asia/Kolkata","Asia/Calcutta"],"continentCode":"AS","continentName":"Asia","countryName":"India","countryCode":"IN","mainCities":["Mumbai","Delhi","Bengaluru","Hyder\u0101b\u0101d"],"rawOffsetInMinutes":330,"abbreviation":"IST","rawFormat":"+05:30 India Time - Mumbai, Delhi, Bengaluru, Hyder\u0101b\u0101d"},{"name":"Asia/Kathmandu","alternativeName":"Nepal Time","group":["Asia/Kathmandu","Asia/Katmandu"],"continentCode":"AS","continentName":"Asia","countryName":"Nepal","countryCode":"NP","mainCities":["Kathmandu","Bharatpur","P\u0101tan","Birga\xf1j"],"rawOffsetInMinutes":345,"abbreviation":"NPT","rawFormat":"+05:45 Nepal Time - Kathmandu, Bharatpur, P\u0101tan, Birga\xf1j"},{"name":"Asia/Dhaka","alternativeName":"Bangladesh Time","group":["Asia/Dhaka","Asia/Dacca"],"continentCode":"AS","continentName":"Asia","countryName":"Bangladesh","countryCode":"BD","mainCities":["Dhaka","Chattogram","Khulna","Rangpur"],"rawOffsetInMinutes":360,"abbreviation":"BST","rawFormat":"+06:00 Bangladesh Time - Dhaka, Chattogram, Khulna, Rangpur"},{"name":"Asia/Thimphu","alternativeName":"Bhutan Time","group":["Asia/Thimphu","Asia/Thimbu"],"continentCode":"AS","continentName":"Asia","countryName":"Bhutan","countryCode":"BT","mainCities":["Thimphu","Phuntsholing","Tsirang","Pun\u0101kha"],"rawOffsetInMinutes":360,"abbreviation":"BTT","rawFormat":"+06:00 Bhutan Time - Thimphu, Phuntsholing, Tsirang, Pun\u0101kha"},{"name":"Asia/Urumqi","alternativeName":"China Time","group":["Asia/Urumqi","Antarctica/Vostok","Asia/Kashgar"],"continentCode":"AS","continentName":"Asia","countryName":"China","countryCode":"CN","mainCities":["\xdcr\xfcmqi","Shihezi","Korla","Aksu"],"rawOffsetInMinutes":360,"abbreviation":"CST","rawFormat":"+06:00 China Time - \xdcr\xfcmqi, Shihezi, Korla, Aksu"},{"name":"Asia/Almaty","alternativeName":"East Kazakhstan Time","group":["Asia/Almaty","Asia/Qostanay"],"continentCode":"AS","continentName":"Asia","countryName":"Kazakhstan","countryCode":"KZ","mainCities":["Almaty","Shymkent","Karagandy","Taraz"],"rawOffsetInMinutes":360,"abbreviation":"ALMT","rawFormat":"+06:00 East Kazakhstan Time - Almaty, Shymkent, Karagandy, Taraz"},{"name":"Indian/Chagos","alternativeName":"Indian Ocean Time","group":["Indian/Chagos"],"continentCode":"AS","continentName":"Asia","countryName":"British Indian Ocean Territory","countryCode":"IO","mainCities":["Chagos"],"rawOffsetInMinutes":360,"abbreviation":"IOT","rawFormat":"+06:00 Indian Ocean Time - Chagos"},{"name":"Asia/Bishkek","alternativeName":"Kyrgyzstan Time","group":["Asia/Bishkek"],"continentCode":"AS","continentName":"Asia","countryName":"Kyrgyzstan","countryCode":"KG","mainCities":["Bishkek","Osh","Jalal-Abad","Karakol"],"rawOffsetInMinutes":360,"abbreviation":"KGT","rawFormat":"+06:00 Kyrgyzstan Time - Bishkek, Osh, Jalal-Abad, Karakol"},{"name":"Asia/Omsk","alternativeName":"Omsk Time","group":["Asia/Omsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Omsk","Tara","Kalachinsk"],"rawOffsetInMinutes":360,"abbreviation":"OMST","rawFormat":"+06:00 Omsk Time - Omsk, Tara, Kalachinsk"},{"name":"Antarctica/Vostok","alternativeName":"Vostok Time","group":["Antarctica/Vostok"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Vostok"],"rawOffsetInMinutes":360,"abbreviation":"VOST","rawFormat":"+06:00 Vostok Time - Vostok"},{"name":"Indian/Cocos","alternativeName":"Cocos Islands Time","group":["Indian/Cocos"],"continentCode":"AS","continentName":"Asia","countryName":"Cocos Islands","countryCode":"CC","mainCities":["West Island"],"rawOffsetInMinutes":390,"abbreviation":"CCT","rawFormat":"+06:30 Cocos Islands Time - West Island"},{"name":"Asia/Yangon","alternativeName":"Myanmar Time","group":["Asia/Yangon","Indian/Cocos","Asia/Rangoon"],"continentCode":"AS","continentName":"Asia","countryName":"Myanmar","countryCode":"MM","mainCities":["Yangon","Mandalay","Nay Pyi Taw","Mawlamyine"],"rawOffsetInMinutes":390,"abbreviation":"MMT","rawFormat":"+06:30 Myanmar Time - Yangon, Mandalay, Nay Pyi Taw, Mawlamyine"},{"name":"Indian/Christmas","alternativeName":"Christmas Island Time","group":["Indian/Christmas"],"continentCode":"OC","continentName":"Oceania","countryName":"Christmas Island","countryCode":"CX","mainCities":["Flying Fish Cove"],"rawOffsetInMinutes":420,"abbreviation":"CXT","rawFormat":"+07:00 Christmas Island Time - Flying Fish Cove"},{"name":"Antarctica/Davis","alternativeName":"Davis Time","group":["Antarctica/Davis"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Davis"],"rawOffsetInMinutes":420,"abbreviation":"DAVT","rawFormat":"+07:00 Davis Time - Davis"},{"name":"Asia/Hovd","alternativeName":"Hovd Time","group":["Asia/Hovd"],"continentCode":"AS","continentName":"Asia","countryName":"Mongolia","countryCode":"MN","mainCities":["Ulaangom","Khovd","\xd6lgii","Altai"],"rawOffsetInMinutes":420,"abbreviation":"HOVT","rawFormat":"+07:00 Hovd Time - Ulaangom, Khovd, \xd6lgii, Altai"},{"name":"Asia/Bangkok","alternativeName":"Indochina Time","group":["Asia/Bangkok","Asia/Phnom_Penh","Asia/Vientiane","Indian/Christmas"],"continentCode":"AS","continentName":"Asia","countryName":"Thailand","countryCode":"TH","mainCities":["Bangkok","Samut Prakan","Mueang Nonthaburi","Chon Buri"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Bangkok, Samut Prakan, Mueang Nonthaburi, Chon Buri"},{"name":"Asia/Ho_Chi_Minh","alternativeName":"Indochina Time","group":["Asia/Ho_Chi_Minh","Asia/Saigon"],"continentCode":"AS","continentName":"Asia","countryName":"Vietnam","countryCode":"VN","mainCities":["Ho Chi Minh City","Da Nang","Bi\xean H\xf2a","C\u1EA7n Th\u01A1"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Ho Chi Minh City, Da Nang, Bi\xean H\xf2a, C\u1EA7n Th\u01A1"},{"name":"Asia/Phnom_Penh","alternativeName":"Indochina Time","group":["Asia/Phnom_Penh"],"continentCode":"AS","continentName":"Asia","countryName":"Cambodia","countryCode":"KH","mainCities":["Phnom Penh","Takeo","Siem Reap","Battambang"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Phnom Penh, Takeo, Siem Reap, Battambang"},{"name":"Asia/Vientiane","alternativeName":"Indochina Time","group":["Asia/Vientiane"],"continentCode":"AS","continentName":"Asia","countryName":"Laos","countryCode":"LA","mainCities":["Vientiane","Savannakhet","Pakse","Thakh\xe8k"],"rawOffsetInMinutes":420,"abbreviation":"ICT","rawFormat":"+07:00 Indochina Time - Vientiane, Savannakhet, Pakse, Thakh\xe8k"},{"name":"Asia/Novosibirsk","alternativeName":"Novosibirsk Time","group":["Asia/Barnaul","Asia/Krasnoyarsk","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Tomsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Novosibirsk","Krasnoyarsk","Barnaul","Tomsk"],"rawOffsetInMinutes":420,"abbreviation":"NOVT","rawFormat":"+07:00 Novosibirsk Time - Novosibirsk, Krasnoyarsk, Barnaul, Tomsk"},{"name":"Asia/Jakarta","alternativeName":"Western Indonesia Time","group":["Asia/Jakarta","Asia/Pontianak"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Jakarta","Surabaya","Bekasi","Bandung"],"rawOffsetInMinutes":420,"abbreviation":"WIB","rawFormat":"+07:00 Western Indonesia Time - Jakarta, Surabaya, Bekasi, Bandung"},{"name":"Australia/Perth","alternativeName":"Australian Western Time","group":["Australia/Perth","Australia/West"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Perth","Mandurah","Bunbury","Baldivis"],"rawOffsetInMinutes":480,"abbreviation":"AWST","rawFormat":"+08:00 Australian Western Time - Perth, Mandurah, Bunbury, Baldivis"},{"name":"Asia/Brunei","alternativeName":"Brunei Darussalam Time","group":["Asia/Brunei"],"continentCode":"AS","continentName":"Asia","countryName":"Brunei","countryCode":"BN","mainCities":["Bandar Seri Begawan","Kuala Belait","Seria","Tutong"],"rawOffsetInMinutes":480,"abbreviation":"BNT","rawFormat":"+08:00 Brunei Darussalam Time - Bandar Seri Begawan, Kuala Belait, Seria, Tutong"},{"name":"Asia/Makassar","alternativeName":"Central Indonesia Time","group":["Asia/Makassar","Asia/Ujung_Pandang"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Makassar","Samarinda","Denpasar","Balikpapan"],"rawOffsetInMinutes":480,"abbreviation":"WITA","rawFormat":"+08:00 Central Indonesia Time - Makassar, Samarinda, Denpasar, Balikpapan"},{"name":"Asia/Macau","alternativeName":"China Time","group":["Asia/Macau","Asia/Macao"],"continentCode":"AS","continentName":"Asia","countryName":"Macao","countryCode":"MO","mainCities":["Macau"],"rawOffsetInMinutes":480,"abbreviation":"CST","rawFormat":"+08:00 China Time - Macau"},{"name":"Asia/Shanghai","alternativeName":"China Time","group":["Asia/Shanghai","PRC","Asia/Chongqing","Asia/Harbin","Asia/Chungking"],"continentCode":"AS","continentName":"Asia","countryName":"China","countryCode":"CN","mainCities":["Shanghai","Beijing","Shenzhen","Guangzhou"],"rawOffsetInMinutes":480,"abbreviation":"CST","rawFormat":"+08:00 China Time - Shanghai, Beijing, Shenzhen, Guangzhou"},{"name":"Asia/Hong_Kong","alternativeName":"Hong Kong Time","group":["Asia/Hong_Kong","Hongkong"],"continentCode":"AS","continentName":"Asia","countryName":"Hong Kong","countryCode":"HK","mainCities":["Hong Kong","Kowloon","Victoria","Tuen Mun"],"rawOffsetInMinutes":480,"abbreviation":"HKT","rawFormat":"+08:00 Hong Kong Time - Hong Kong, Kowloon, Victoria, Tuen Mun"},{"name":"Asia/Irkutsk","alternativeName":"Irkutsk Time","group":["Asia/Irkutsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Irkutsk","Ulan-Ude","Bratsk","Angarsk"],"rawOffsetInMinutes":480,"abbreviation":"IRKT","rawFormat":"+08:00 Irkutsk Time - Irkutsk, Ulan-Ude, Bratsk, Angarsk"},{"name":"Asia/Kuala_Lumpur","alternativeName":"Malaysia Time","group":["Asia/Kuala_Lumpur","Asia/Kuching","Asia/Brunei"],"continentCode":"AS","continentName":"Asia","countryName":"Malaysia","countryCode":"MY","mainCities":["Kuala Lumpur","Petaling Jaya","Klang","Johor Bahru"],"rawOffsetInMinutes":480,"abbreviation":"MYT","rawFormat":"+08:00 Malaysia Time - Kuala Lumpur, Petaling Jaya, Klang, Johor Bahru"},{"name":"Asia/Manila","alternativeName":"Philippine Time","group":["Asia/Manila"],"continentCode":"AS","continentName":"Asia","countryName":"Philippines","countryCode":"PH","mainCities":["Quezon City","Davao","Manila","Caloocan City"],"rawOffsetInMinutes":480,"abbreviation":"PHT","rawFormat":"+08:00 Philippine Time - Quezon City, Davao, Manila, Caloocan City"},{"name":"Asia/Singapore","alternativeName":"Singapore Time","group":["Asia/Singapore","Singapore","Asia/Kuala_Lumpur"],"continentCode":"AS","continentName":"Asia","countryName":"Singapore","countryCode":"SG","mainCities":["Singapore","Woodlands","Geylang","Queenstown Estate"],"rawOffsetInMinutes":480,"abbreviation":"SGT","rawFormat":"+08:00 Singapore Time - Singapore, Woodlands, Geylang, Queenstown Estate"},{"name":"Asia/Taipei","alternativeName":"Taipei Time","group":["Asia/Taipei","ROC"],"continentCode":"AS","continentName":"Asia","countryName":"Taiwan","countryCode":"TW","mainCities":["Taipei","Kaohsiung","Taichung","Tainan"],"rawOffsetInMinutes":480,"abbreviation":"TWT","rawFormat":"+08:00 Taipei Time - Taipei, Kaohsiung, Taichung, Tainan"},{"name":"Asia/Ulaanbaatar","alternativeName":"Ulaanbaatar Time","group":["Asia/Choibalsan","Asia/Ulaanbaatar","Asia/Ulan_Bator"],"continentCode":"AS","continentName":"Asia","countryName":"Mongolia","countryCode":"MN","mainCities":["Ulan Bator","Erdenet","Darhan","M\xf6r\xf6n"],"rawOffsetInMinutes":480,"abbreviation":"ULAT","rawFormat":"+08:00 Ulaanbaatar Time - Ulan Bator, Erdenet, Darhan, M\xf6r\xf6n"},{"name":"Australia/Eucla","alternativeName":"Australian Central Western Time","group":["Australia/Eucla"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Eucla"],"rawOffsetInMinutes":525,"abbreviation":"ACWST","rawFormat":"+08:45 Australian Central Western Time - Eucla"},{"name":"Asia/Dili","alternativeName":"East Timor Time","group":["Asia/Dili"],"continentCode":"OC","continentName":"Oceania","countryName":"Timor Leste","countryCode":"TL","mainCities":["Dili","Maliana","Suai","Likis\xe1"],"rawOffsetInMinutes":540,"abbreviation":"TLT","rawFormat":"+09:00 East Timor Time - Dili, Maliana, Suai, Likis\xe1"},{"name":"Asia/Jayapura","alternativeName":"Eastern Indonesia Time","group":["Asia/Jayapura"],"continentCode":"AS","continentName":"Asia","countryName":"Indonesia","countryCode":"ID","mainCities":["Jayapura","Ambon","Sorong","Ternate"],"rawOffsetInMinutes":540,"abbreviation":"WIT","rawFormat":"+09:00 Eastern Indonesia Time - Jayapura, Ambon, Sorong, Ternate"},{"name":"Asia/Tokyo","alternativeName":"Japan Time","group":["Asia/Tokyo","Japan"],"continentCode":"AS","continentName":"Asia","countryName":"Japan","countryCode":"JP","mainCities":["Tokyo","Yokohama","Osaka","Nagoya"],"rawOffsetInMinutes":540,"abbreviation":"JST","rawFormat":"+09:00 Japan Time - Tokyo, Yokohama, Osaka, Nagoya"},{"name":"Asia/Pyongyang","alternativeName":"Korean Time","group":["Asia/Pyongyang"],"continentCode":"AS","continentName":"Asia","countryName":"North Korea","countryCode":"KP","mainCities":["Pyongyang","Hamh\u016Dng","Namp\u2019o","Sunch\u2019\u014Fn"],"rawOffsetInMinutes":540,"abbreviation":"KST","rawFormat":"+09:00 Korean Time - Pyongyang, Hamh\u016Dng, Namp\u2019o, Sunch\u2019\u014Fn"},{"name":"Asia/Seoul","alternativeName":"Korean Time","group":["Asia/Seoul","ROK"],"continentCode":"AS","continentName":"Asia","countryName":"South Korea","countryCode":"KR","mainCities":["Seoul","Busan","Incheon","Daegu"],"rawOffsetInMinutes":540,"abbreviation":"KST","rawFormat":"+09:00 Korean Time - Seoul, Busan, Incheon, Daegu"},{"name":"Pacific/Palau","alternativeName":"Palau Time","group":["Pacific/Palau"],"continentCode":"OC","continentName":"Oceania","countryName":"Palau","countryCode":"PW","mainCities":["Ngerulmud"],"rawOffsetInMinutes":540,"abbreviation":"PWT","rawFormat":"+09:00 Palau Time - Ngerulmud"},{"name":"Asia/Chita","alternativeName":"Yakutsk Time","group":["Asia/Chita","Asia/Khandyga","Asia/Yakutsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Chita","Yakutsk","Blagoveshchensk","Belogorsk"],"rawOffsetInMinutes":540,"abbreviation":"YAKT","rawFormat":"+09:00 Yakutsk Time - Chita, Yakutsk, Blagoveshchensk, Belogorsk"},{"name":"Australia/Adelaide","alternativeName":"Australian Central Time","group":["Australia/Adelaide","Australia/Broken_Hill","Australia/South","Australia/Yancowinna"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Adelaide","Adelaide Hills","Mount Gambier","Morphett Vale"],"rawOffsetInMinutes":570,"abbreviation":"ACST","rawFormat":"+09:30 Australian Central Time - Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale"},{"name":"Australia/Darwin","alternativeName":"Australian Central Time","group":["Australia/Darwin","Australia/North"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Darwin","Alice Springs","Palmerston"],"rawOffsetInMinutes":570,"abbreviation":"ACST","rawFormat":"+09:30 Australian Central Time - Darwin, Alice Springs, Palmerston"},{"name":"Australia/Brisbane","alternativeName":"Australian Eastern Time","group":["Australia/Brisbane","Australia/Lindeman","Australia/Queensland"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Brisbane","Gold Coast","Logan City","Townsville"],"rawOffsetInMinutes":600,"abbreviation":"AEST","rawFormat":"+10:00 Australian Eastern Time - Brisbane, Gold Coast, Logan City, Townsville"},{"name":"Australia/Sydney","alternativeName":"Australian Eastern Time","group":["Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Tasmania","Australia/Currie","Australia/Victoria","Australia/ACT","Australia/NSW","Australia/Canberra"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Sydney","Melbourne","Canberra","Newcastle"],"rawOffsetInMinutes":600,"abbreviation":"AEST","rawFormat":"+10:00 Australian Eastern Time - Sydney, Melbourne, Canberra, Newcastle"},{"name":"Pacific/Guam","alternativeName":"Chamorro Time","group":["Pacific/Guam","Pacific/Saipan"],"continentCode":"OC","continentName":"Oceania","countryName":"Guam","countryCode":"GU","mainCities":["Dededo Village","Yigo Village","Tamuning-Tumon-Harmon Village","Tamuning"],"rawOffsetInMinutes":600,"abbreviation":"ChST","rawFormat":"+10:00 Chamorro Time - Dededo Village, Yigo Village, Tamuning-Tumon-Harmon Village, Tamuning"},{"name":"Pacific/Saipan","alternativeName":"Chamorro Time","group":["Pacific/Saipan"],"continentCode":"OC","continentName":"Oceania","countryName":"Northern Mariana Islands","countryCode":"MP","mainCities":["Saipan"],"rawOffsetInMinutes":600,"abbreviation":"ChST","rawFormat":"+10:00 Chamorro Time - Saipan"},{"name":"Pacific/Chuuk","alternativeName":"Chuuk Time","group":["Pacific/Chuuk","Pacific/Truk","Pacific/Yap"],"continentCode":"OC","continentName":"Oceania","countryName":"Micronesia","countryCode":"FM","mainCities":["Chuuk"],"rawOffsetInMinutes":600,"abbreviation":"CHUT","rawFormat":"+10:00 Chuuk Time - Chuuk"},{"name":"Antarctica/DumontDUrville","alternativeName":"Dumont-d\u2019Urville Time","group":["Antarctica/DumontDUrville"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["DumontDUrville"],"rawOffsetInMinutes":600,"abbreviation":"DDUT","rawFormat":"+10:00 Dumont-d\u2019Urville Time - DumontDUrville"},{"name":"Pacific/Port_Moresby","alternativeName":"Papua New Guinea Time","group":["Pacific/Port_Moresby","Antarctica/DumontDUrville","Pacific/Chuuk","Pacific/Yap","Pacific/Truk"],"continentCode":"OC","continentName":"Oceania","countryName":"Papua New Guinea","countryCode":"PG","mainCities":["Port Moresby","Lae","Mount Hagen","Popondetta"],"rawOffsetInMinutes":600,"abbreviation":"PGT","rawFormat":"+10:00 Papua New Guinea Time - Port Moresby, Lae, Mount Hagen, Popondetta"},{"name":"Asia/Vladivostok","alternativeName":"Vladivostok Time","group":["Asia/Ust-Nera","Asia/Vladivostok"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Khabarovsk","Vladivostok","Khabarovsk Vtoroy","Komsomolsk-on-Amur"],"rawOffsetInMinutes":600,"abbreviation":"VLAT","rawFormat":"+10:00 Vladivostok Time - Khabarovsk, Vladivostok, Khabarovsk Vtoroy, Komsomolsk-on-Amur"},{"name":"Australia/Lord_Howe","alternativeName":"Lord Howe Time","group":["Australia/Lord_Howe","Australia/LHI"],"continentCode":"OC","continentName":"Oceania","countryName":"Australia","countryCode":"AU","mainCities":["Lord Howe"],"rawOffsetInMinutes":630,"abbreviation":"LHST","rawFormat":"+10:30 Lord Howe Time - Lord Howe"},{"name":"Pacific/Bougainville","alternativeName":"Bougainville Time","group":["Pacific/Bougainville"],"continentCode":"OC","continentName":"Oceania","countryName":"Papua New Guinea","countryCode":"PG","mainCities":["Arawa"],"rawOffsetInMinutes":660,"abbreviation":"BST","rawFormat":"+11:00 Bougainville Time - Arawa"},{"name":"Antarctica/Casey","alternativeName":"Casey Time","group":["Antarctica/Casey"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["Casey"],"rawOffsetInMinutes":660,"abbreviation":"CAST","rawFormat":"+11:00 Casey Time - Casey"},{"name":"Pacific/Kosrae","alternativeName":"Kosrae Time","group":["Pacific/Kosrae","Pacific/Pohnpei"],"continentCode":"OC","continentName":"Oceania","countryName":"Micronesia","countryCode":"FM","mainCities":["Kosrae","Palikir - National Government Center"],"rawOffsetInMinutes":660,"abbreviation":"KOST","rawFormat":"+11:00 Kosrae Time - Kosrae, Palikir - National Government Center"},{"name":"Pacific/Noumea","alternativeName":"New Caledonia Time","group":["Pacific/Noumea"],"continentCode":"OC","continentName":"Oceania","countryName":"New Caledonia","countryCode":"NC","mainCities":["Noum\xe9a","Mont-Dore","Dumb\xe9a"],"rawOffsetInMinutes":660,"abbreviation":"NCT","rawFormat":"+11:00 New Caledonia Time - Noum\xe9a, Mont-Dore, Dumb\xe9a"},{"name":"Pacific/Norfolk","alternativeName":"Norfolk Island Time","group":["Pacific/Norfolk"],"continentCode":"OC","continentName":"Oceania","countryName":"Norfolk Island","countryCode":"NF","mainCities":["Kingston"],"rawOffsetInMinutes":660,"abbreviation":"NFT","rawFormat":"+11:00 Norfolk Island Time - Kingston"},{"name":"Asia/Sakhalin","alternativeName":"Sakhalin Time","group":["Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Yuzhno-Sakhalinsk","Magadan","Korsakov","Kholmsk"],"rawOffsetInMinutes":660,"abbreviation":"SAKT","rawFormat":"+11:00 Sakhalin Time - Yuzhno-Sakhalinsk, Magadan, Korsakov, Kholmsk"},{"name":"Pacific/Guadalcanal","alternativeName":"Solomon Islands Time","group":["Pacific/Guadalcanal","Pacific/Pohnpei","Pacific/Ponape"],"continentCode":"OC","continentName":"Oceania","countryName":"Solomon Islands","countryCode":"SB","mainCities":["Honiara"],"rawOffsetInMinutes":660,"abbreviation":"SBT","rawFormat":"+11:00 Solomon Islands Time - Honiara"},{"name":"Pacific/Efate","alternativeName":"Vanuatu Time","group":["Pacific/Efate"],"continentCode":"OC","continentName":"Oceania","countryName":"Vanuatu","countryCode":"VU","mainCities":["Port-Vila"],"rawOffsetInMinutes":660,"abbreviation":"VUT","rawFormat":"+11:00 Vanuatu Time - Port-Vila"},{"name":"Pacific/Fiji","alternativeName":"Fiji Time","group":["Pacific/Fiji"],"continentCode":"OC","continentName":"Oceania","countryName":"Fiji","countryCode":"FJ","mainCities":["Nasinu","Suva","Lautoka","Nadi"],"rawOffsetInMinutes":720,"abbreviation":"FJT","rawFormat":"+12:00 Fiji Time - Nasinu, Suva, Lautoka, Nadi"},{"name":"Pacific/Tarawa","alternativeName":"Gilbert Islands Time","group":["Pacific/Tarawa","Pacific/Funafuti","Pacific/Majuro","Pacific/Wake","Pacific/Wallis"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Tarawa"],"rawOffsetInMinutes":720,"abbreviation":"GILT","rawFormat":"+12:00 Gilbert Islands Time - Tarawa"},{"name":"Pacific/Majuro","alternativeName":"Marshall Islands Time","group":["Pacific/Kwajalein","Pacific/Majuro","Kwajalein"],"continentCode":"OC","continentName":"Oceania","countryName":"Marshall Islands","countryCode":"MH","mainCities":["Majuro","Kwajalein","RMI Capitol"],"rawOffsetInMinutes":720,"abbreviation":"MHT","rawFormat":"+12:00 Marshall Islands Time - Majuro, Kwajalein, RMI Capitol"},{"name":"Pacific/Nauru","alternativeName":"Nauru Time","group":["Pacific/Nauru"],"continentCode":"OC","continentName":"Oceania","countryName":"Nauru","countryCode":"NR","mainCities":["Yaren"],"rawOffsetInMinutes":720,"abbreviation":"NRT","rawFormat":"+12:00 Nauru Time - Yaren"},{"name":"Pacific/Auckland","alternativeName":"New Zealand Time","group":["Pacific/Auckland","NZ","Antarctica/McMurdo","Antarctica/South_Pole"],"continentCode":"OC","continentName":"Oceania","countryName":"New Zealand","countryCode":"NZ","mainCities":["Auckland","Wellington","Christchurch","Manukau City"],"rawOffsetInMinutes":720,"abbreviation":"NZST","rawFormat":"+12:00 New Zealand Time - Auckland, Wellington, Christchurch, Manukau City"},{"name":"Antarctica/McMurdo","alternativeName":"New Zealand Time","group":["Antarctica/McMurdo"],"continentCode":"AN","continentName":"Antarctica","countryName":"Antarctica","countryCode":"AQ","mainCities":["McMurdo"],"rawOffsetInMinutes":720,"abbreviation":"NZST","rawFormat":"+12:00 New Zealand Time - McMurdo"},{"name":"Asia/Kamchatka","alternativeName":"Petropavlovsk-Kamchatski Time","group":["Asia/Anadyr","Asia/Kamchatka"],"continentCode":"EU","continentName":"Europe","countryName":"Russia","countryCode":"RU","mainCities":["Petropavlovsk-Kamchatsky","Yelizovo","Vilyuchinsk","Anadyr"],"rawOffsetInMinutes":720,"abbreviation":"PETT","rawFormat":"+12:00 Petropavlovsk-Kamchatski Time - Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Anadyr"},{"name":"Pacific/Funafuti","alternativeName":"Tuvalu Time","group":["Pacific/Funafuti"],"continentCode":"OC","continentName":"Oceania","countryName":"Tuvalu","countryCode":"TV","mainCities":["Funafuti"],"rawOffsetInMinutes":720,"abbreviation":"TVT","rawFormat":"+12:00 Tuvalu Time - Funafuti"},{"name":"Pacific/Wake","alternativeName":"Wake Island Time","group":["Pacific/Wake"],"continentCode":"OC","continentName":"Oceania","countryName":"United States Minor Outlying Islands","countryCode":"UM","mainCities":["Wake"],"rawOffsetInMinutes":720,"abbreviation":"WAKT","rawFormat":"+12:00 Wake Island Time - Wake"},{"name":"Pacific/Wallis","alternativeName":"Wallis & Futuna Time","group":["Pacific/Wallis"],"continentCode":"OC","continentName":"Oceania","countryName":"Wallis and Futuna","countryCode":"WF","mainCities":["Mata-Utu"],"rawOffsetInMinutes":720,"abbreviation":"WFT","rawFormat":"+12:00 Wallis & Futuna Time - Mata-Utu"},{"name":"Pacific/Chatham","alternativeName":"Chatham Time","group":["Pacific/Chatham","NZ-CHAT"],"continentCode":"OC","continentName":"Oceania","countryName":"New Zealand","countryCode":"NZ","mainCities":["Chatham"],"rawOffsetInMinutes":765,"abbreviation":"CHAST","rawFormat":"+12:45 Chatham Time - Chatham"},{"name":"Pacific/Apia","alternativeName":"Apia Time","group":["Pacific/Apia"],"continentCode":"OC","continentName":"Oceania","countryName":"Samoa","countryCode":"WS","mainCities":["Apia"],"rawOffsetInMinutes":780,"abbreviation":"WST","rawFormat":"+13:00 Apia Time - Apia"},{"name":"Pacific/Kanton","alternativeName":"Phoenix Islands Time","group":["Pacific/Kanton","Pacific/Enderbury"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Kanton"],"rawOffsetInMinutes":780,"abbreviation":"PHOT","rawFormat":"+13:00 Phoenix Islands Time - Kanton"},{"name":"Pacific/Fakaofo","alternativeName":"Tokelau Time","group":["Pacific/Fakaofo"],"continentCode":"OC","continentName":"Oceania","countryName":"Tokelau","countryCode":"TK","mainCities":["Fakaofo"],"rawOffsetInMinutes":780,"abbreviation":"TKT","rawFormat":"+13:00 Tokelau Time - Fakaofo"},{"name":"Pacific/Tongatapu","alternativeName":"Tonga Time","group":["Pacific/Tongatapu"],"continentCode":"OC","continentName":"Oceania","countryName":"Tonga","countryCode":"TO","mainCities":["Nuku\u2018alofa"],"rawOffsetInMinutes":780,"abbreviation":"TOT","rawFormat":"+13:00 Tonga Time - Nuku\u2018alofa"},{"name":"Pacific/Kiritimati","alternativeName":"Line Islands Time","group":["Pacific/Kiritimati"],"continentCode":"OC","continentName":"Oceania","countryName":"Kiribati","countryCode":"KI","mainCities":["Kiritimati"],"rawOffsetInMinutes":840,"abbreviation":"LINT","rawFormat":"+14:00 Line Islands Time - Kiritimati"}]');

},{}],"gwiE1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
function format({ alternativeName, mainCities, rawOffsetInMinutes, currentTimeOffsetInMinutes }, { useCurrentOffset = false } = {}) {
    const offsetInHours = useCurrentOffset ? getOffsetString(currentTimeOffsetInMinutes) : getOffsetString(rawOffsetInMinutes);
    return `${offsetInHours.padStart(6, "+")} ${alternativeName} - ${mainCities.join(", ")}`;
}
function getOffsetString(offsetInMinutes) {
    const absOffsetInMinutes = Math.abs(offsetInMinutes);
    const [hours, minutes] = [
        Math.floor(absOffsetInMinutes / 60),
        absOffsetInMinutes % 60
    ].map((v)=>{
        return v.toString().padStart(2, "0");
    });
    const durationInHoursMinutes = `${hours}:${minutes}`;
    return `${offsetInMinutes >= 0 ? "+" : "-"}${durationInHoursMinutes}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"g1Sde":[function(require,module,exports,__globalThis) {
// Most of the code here is from Luxon
// Copyright 2019 JS Foundation and other contributors
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getZoneOffset", ()=>getZoneOffset);
const ianaRegex = /^[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?$/;
const typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function isValidIanaSpecifier(s) {
    return !!(s && s.match(ianaRegex));
}
function hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, "");
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fHour,
        fMinute,
        fSecond
    ];
}
function partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type, value } = formatted[i];
        const pos = typeToPos[type];
        if (typeof pos !== "undefined") filled[pos] = parseInt(value, 10);
    }
    return filled;
}
function makeDTF(zone) {
    return new Intl.DateTimeFormat("en-US", {
        hourCycle: "h23",
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
}
// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function getZoneOffset(timeZoneName) {
    if (!isValidIanaSpecifier(timeZoneName)) return false;
    const date = new Date(Date.now());
    let dtf;
    try {
        dtf = makeDTF(timeZoneName);
    } catch (_) {
        return false;
    }
    const [year, month, day, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    const asUTC = objToLocalTS({
        year,
        month,
        day,
        hour,
        minute,
        second,
        millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / 60000;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h5V8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserPreferencesBooleanItem", ()=>UserPreferencesBooleanItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _removingThrobber = require("../../../removing_throbber");
var _userPreferencesModal = require("../user_preferences_modal");
var _settingsBaseItem = require("../../settings_items/settings_base_item");
function UserPreferencesBooleanItem(props) {
    const mutation = (0, _userPreferencesModal.useUserPreferencesMutation)(props.setting_key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-fit gap-2",
            children: [
                mutation.isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                    height: 24,
                    disabled: mutation.isLoading,
                    checked: props.value,
                    onChange: (checked)=>mutation.mutate({
                            [props.setting_key]: checked
                        }),
                    onColor: "#00c3cc",
                    onHandleColor: "#00f4ff",
                    checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-check"
                        })
                    }),
                    uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-times"
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react-switch":"l5ttz","../../../removing_throbber":"TmURk","../user_preferences_modal":"GVrDV","../../settings_items/settings_base_item":"byg9r","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dvtgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserPreferencesAddonItem", ()=>UserPreferencesAddonItem);
var _jsxRuntime = require("react/jsx-runtime");
var _removingThrobber = require("../../../removing_throbber");
var _seshAddonInput = require("../../base_components/sesh_addon_input");
var _settingsBaseItem = require("../../settings_items/settings_base_item");
var _userPreferencesModal = require("../user_preferences_modal");
function UserPreferencesAddonItem(props) {
    const mutation = (0, _userPreferencesModal.useUserPreferencesMutation)(props.setting_key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-fit gap-2",
            children: [
                mutation.isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removingThrobber.RemovingThrobber), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                    size: "sm",
                    is_disabled: mutation.isLoading,
                    value: !!props.value,
                    setValue: (t)=>{
                        mutation.mutate({
                            [props.setting_key]: t
                        });
                    },
                    buttons: [
                        {
                            label: "Server",
                            value: false
                        },
                        {
                            label: "Personal",
                            value: true
                        }
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../../removing_throbber":"TmURk","../../base_components/sesh_addon_input":"pd6di","../../settings_items/settings_base_item":"byg9r","../user_preferences_modal":"GVrDV","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gXAWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildOptionsForm", ()=>GuildOptionsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _dashboardUtils = require("./dashboard_utils");
var _commonUtils = require("../../../common/common_utils");
var _reactRouter = require("react-router");
var _webUi = require("./web_ui");
var _tag = require("./forms/improved_components/base_components/tag");
function ListButton(props) {
    const label = props.is_event ? "Events" : "Polls";
    const history = (0, _reactRouter.useHistory)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: props.is_event ? "Event Listings" : "Poll Listings",
        onClick: ()=>history.push(props.is_event ? (0, _commonUtils.common_utils).getEventListURL(props.server_id) : (0, _commonUtils.common_utils).getPollListURL(props.server_id)),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-vcentered is-variable is-1 margin-link",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: props.is_event ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "far fa-calendar-alt"
                    }) : (0, _dashboardUtils.DashboardUtils).GetListIcon()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: props.is_event ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                                type: "Dark",
                                children: "new"
                            })
                        ]
                    }) : label
                })
            ]
        })
    });
}
function BackToServerButton(props) {
    const history = (0, _reactRouter.useHistory)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile is-vcentered is-variable is-1 margin-link",
        onClick: ()=>history.push("/dashboard/"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-narrow",
                children: (0, _dashboardUtils.DashboardUtils).GetBackIcon()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-narrow",
                children: "Servers"
            })
        ]
    });
}
function OptionsTopMarginElement(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile options-margin-items is-size-6-tablet",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-narrow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackToServerButton, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-narrow right-aligned",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "columns is-mobile is-multiline",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListButton, {
                                is_event: true,
                                server_id: props.server_id
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListButton, {
                                is_event: false,
                                server_id: props.server_id
                            })
                        })
                    ]
                })
            })
        ]
    });
}
class GuildOptionsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        if (!this.props.guild_data) (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Invalid Guild Data");
        // const state = common_utils.createWebServerSelectURLState(
        // 	this.props.bot_client_id,
        // 	this.props.guild_data.id
        // );
        //history.replaceState(null, "", `/dashboard/#state=${state}`);
        (0, _webUi.setDocTitle)(this.props.guild_data.name);
    }
    render() {
        const containerClassName = "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container is-centered";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-centered is-mobile !m-0 w-full",
                style: {
                    transition: "opacity 0.5s",
                    opacity: "1"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: containerClassName,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionsTopMarginElement, {
                            server_id: this.props.guild_data.id
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "title is-3 has-text-centered !mb-8",
                                    children: (0, _dashboardUtils.DashboardUtils).LimitGuildName(this.props.guild_data.name, true)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "columns is-mobile is-multiline is-centered",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "column is-10-tablet is-8-desktop is-11-mobile has-text-centered",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "columns is-mobile is-multiline is-centered is-variable is-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "column is-narrow",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                                                            button_name: "Create Event",
                                                            icon: (0, _dashboardUtils.DashboardUtils).GetEventIcon(),
                                                            on_click: (history)=>history.push((0, _commonUtils.common_utils).getEventCreateURL(this.props.guild_data.id)),
                                                            needs_history: true
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                                                            button_name: "Create Poll",
                                                            icon: (0, _dashboardUtils.DashboardUtils).GetPollIcon(),
                                                            on_click: (history)=>history.push((0, _commonUtils.common_utils).getPollCreateURL(this.props.guild_data.id)),
                                                            needs_history: true
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                                                            button_name: "Time Finder",
                                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                className: "fas fa-clock fa-lg title-icon"
                                                            }),
                                                            on_click: (history)=>history.push((0, _commonUtils.common_utils).getTimeFinderURL({
                                                                    server_id: this.props.guild_data.id,
                                                                    type: "base"
                                                                })),
                                                            needs_history: true
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                                                            button_name: "Settings",
                                                            icon: (0, _dashboardUtils.DashboardUtils).GetSettingsIcon(),
                                                            on_click: (history)=>history.push((0, _commonUtils.common_utils).getGuildSettingsURL(this.props.guild_data.id)),
                                                            needs_history: true
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "column is-full"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../src/vendored/FadeIn":"aMGHU","./dashboard_utils":"jvA8A","../../../common/common_utils":"gACUC","react-router":"djWTS","./web_ui":"7f1Tj","./forms/improved_components/base_components/tag":"l4wGc","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jlwhz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildSelectForm", ()=>GuildSelectForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _reactRouterDom = require("react-router-dom");
var _dashboardUtils = require("./dashboard_utils");
var _seshSearchForm = require("./forms/improved_components/base_components/sesh_search_form");
var _useDocTitle = require("./forms/improved_components/hooks/use_doc_title");
function open_invite_screen(guild_data, client_id) {
    let redirect_uri = location.protocol + "//" + location.host + "/dashboard";
    window.open(`https://discord.com/oauth2/authorize?client_id=${client_id}&permissions=17998396517440&guild_id=${guild_data.id}&scope=applications.commands%20bot&response_type=code&redirect_uri=${redirect_uri}`, "_self");
}
function RenderGuildIcon(props) {
    const data = props.guild_data;
    const client_id = props.bot_client_id;
    let uri = (0, _dashboardUtils.DashboardUtils).GetGuildIconURI(data, 128);
    const history = (0, _reactRouterDom.useHistory)();
    const classNames = "column is-narrow is-centered has-text-centered guild-icon-container";
    let img_class = "guild-icon is-rounded has-text-centered";
    let figure_class = "cursor-pointer image is-96x96 is-inline-block guild-icon-figure";
    let guild_name_class = "guild-name-text";
    let on_click_func;
    if (!data.has_sesh) {
        img_class += " uninvited-guild-icon grayed-out-image";
        guild_name_class += " grayed-out-image";
        on_click_func = (data)=>open_invite_screen(data, client_id);
    } else {
        on_click_func = (data)=>history.push(`${data.id}`);
        if (data.is_premium) guild_name_class += " gold-color";
    }
    let guild_name = (0, _dashboardUtils.DashboardUtils).LimitGuildName(data.name);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classNames,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "tooltip",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("figure", {
                className: figure_class,
                onClick: ()=>on_click_func(data),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: img_class,
                        src: uri
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: guild_name_class,
                        children: guild_name
                    }),
                    data.is_premium && data.has_sesh && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "premium-tooltiptop gold-color",
                        children: "\uD83D\uDC51 Premium \uD83D\uDC51"
                    })
                ]
            })
        })
    }, data.id);
}
function GuildSelectForm(props) {
    const [searchString, setSearchString] = (0, _react.useState)("");
    (0, _useDocTitle.useDocTitle)("Server select");
    const guilds = props.list_of_guilds.filter((val)=>val.name.toLowerCase().includes(searchString.toLowerCase()));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
        transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "columns is-mobile is-centered",
            style: {
                transition: "opacity 0s",
                opacity: "1"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "column is-11-mobile is-10-tablet is-half-widescreen is-three-fifths-fullhd create-event-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        className: "title is-3 has-text-centered !mb-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fab fa-discord fa-lg title-icon"
                            }),
                            "Select Server"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshSearchForm.SeshTextSearchInput), {
                                handleChange: (val)=>setSearchString(val),
                                handleClear: ()=>setSearchString(""),
                                input_props: {
                                    className: "w-64 ml-auto",
                                    value: searchString,
                                    placeholder: "Search"
                                },
                                onSubmit: ()=>{}
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "columns is-multiline is-mobile is-centered",
                                children: guilds.map((val)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RenderGuildIcon, {
                                        guild_data: val,
                                        bot_client_id: props.bot_client_id
                                    }, val.id))
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../src/vendored/FadeIn":"aMGHU","react-router-dom":"djWTS","./dashboard_utils":"jvA8A","./forms/improved_components/base_components/sesh_search_form":"lufGy","./forms/improved_components/hooks/use_doc_title":"bmu5s","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jkI4d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GoogleRedirectPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../common/common_utils");
var _dashboardUtils = require("../dashboard_utils");
var _trpc = require("../utils/trpc");
function GoogleRedirectPage() {
    const location = (0, _reactRouter.useLocation)();
    const history = (0, _reactRouter.useHistory)();
    const query = new URLSearchParams(location.search);
    const code = query.get("code");
    const state = query.get("state");
    const setAuthMutation = (0, _trpc.trpc).gcal.setAuth.useMutation();
    (0, _react.useEffect)(()=>{
        if (!code || !state) {
            history.push("/dashboard");
            return;
        }
        let stateObj;
        try {
            // Decode base64 state and parse JSON
            const decodedState = atob(state);
            stateObj = JSON.parse(decodedState);
        } catch (e) {
            console.error("Failed to parse state:", e);
            history.push("/dashboard");
            return;
        }
        if (stateObj.code_source !== "google") {
            console.error("Invalid code source in state");
            history.push("/dashboard");
            return;
        }
        setAuthMutation.mutateAsync({
            code
        }, {
            onSettled () {
                history.push((0, _commonUtils.common_utils).getGuildSettingsURL(stateObj.guild_id) + "?section=sync");
            }
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderFullLoadingThrobberPage, {});
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../../common/common_utils":"gACUC","../dashboard_utils":"jvA8A","../utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gNnfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildSettingsContext", ()=>GuildSettingsContext);
parcelHelpers.export(exports, "fetchGuildSettings", ()=>fetchGuildSettings);
parcelHelpers.export(exports, "fetchGuildChannelSettings", ()=>fetchGuildChannelSettings);
parcelHelpers.export(exports, "GuildSettingsForm", ()=>GuildSettingsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _luxon = require("luxon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactConfetti = require("react-confetti");
var _reactConfettiDefault = parcelHelpers.interopDefault(_reactConfetti);
var _fadeIn = require("../../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _reactRouterDom = require("react-router-dom");
var _beatLoader = require("react-spinners/BeatLoader");
var _beatLoaderDefault = parcelHelpers.interopDefault(_beatLoader);
var _clipLoader = require("react-spinners/ClipLoader");
var _clipLoaderDefault = parcelHelpers.interopDefault(_clipLoader);
var _commonFormatUtils = require("../../../../common/common_format_utils");
var _commonUtils = require("../../../../common/common_utils");
var _constants = require("../../../../common/constants");
var _seshTypes = require("../../../../common/sesh_types");
var _typeUtils = require("../../../../common/type_utils");
var _dashboardUtils = require("../dashboard_utils");
var _colorPickerAccordian = require("../forms/accordians/color_picker_accordian");
var _colorPickerAccordianDefault = parcelHelpers.interopDefault(_colorPickerAccordian);
var _addRoleToAttendeesComponent = require("../forms/improved_components/add_role_to_attendees_component");
var _modifySettingsButton = require("../forms/improved_components/base_components/modify_settings_button");
var _tag = require("../forms/improved_components/base_components/tag");
var _channelDropdownWithTags = require("../forms/improved_components/channel_dropdown_with_tags");
var _errorNote = require("../forms/improved_components/error_note");
var _eventThreadForm = require("../forms/improved_components/event_thread_form");
var _useGuildData = require("../forms/improved_components/hooks/use_guild_data");
var _useIsMobile = require("../forms/improved_components/hooks/use_is_mobile");
var _inlineCode = require("../forms/improved_components/inline_code");
var _rsvpOptionsTable = require("../forms/improved_components/rsvp_options_table");
var _guildLogPage = require("../forms/improved_components/guild_logs/guild_log_page");
var _serverRemindersBlurb = require("../forms/improved_components/server_reminders/server_reminders_blurb");
var _infoTooltip = require("../forms/improved_components/tooltips/info_tooltip");
var _nativeEventForm = require("../forms/native_event_form");
var _nativeEventFormDefault = parcelHelpers.interopDefault(_nativeEventForm);
var _permissionsForm = require("../forms/permissions_form");
var _rsvpOptions = require("../forms/rsvp_options");
var _rsvpOptionsDefault = parcelHelpers.interopDefault(_rsvpOptions);
var _seshAccordian = require("../forms/sesh_accordian");
var _seshAccordianDefault = parcelHelpers.interopDefault(_seshAccordian);
var _timezonePicker = require("../forms/timezone_picker");
var _webUi = require("../web_ui");
var _aiSettingsPage = require("./ai_settings/ai_settings_page");
var _syncSettings = require("./sync_settings/sync_settings");
var _syncSettingsDefault = parcelHelpers.interopDefault(_syncSettings);
var _eventTemplateBlurb = require("./event_template_blurb");
var _eventTemplatePage = require("../forms/improved_components/event_templates/event_template_page");
var _simpleMemberDisplayName = require("../forms/improved_components/member_display_name/simple_member_display_name");
var _simpleMemberDisplayNameDefault = parcelHelpers.interopDefault(_simpleMemberDisplayName);
const GuildSettingsContext = /*#__PURE__*/ (0, _react.createContext)(null);
async function fetchGuildSettings(auth_token, guild_id) {
    let request_body = {
        guild_id,
        access_token: auth_token.access_token,
        token_type: auth_token.token_type
    };
    return fetch(`/api/get_guild_settings_data`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
async function fetchGuildChannelSettings(auth_token, guild_id) {
    let request_body = {
        guild_id,
        access_token: auth_token.access_token,
        token_type: auth_token.token_type
    };
    return fetch(`/api/get_guild_channel_settings_data`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
function render_global_calendars_text() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: "Current Setting:"
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "command-example--inline",
                children: "/list"
            }),
            " and",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "command-example--inline",
                children: "/link"
            }),
            " commands will show all events that are visible to the user running the command in the server."
        ]
    });
}
function render_channel_calendars_text(event_channel_set) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "has-text-weight-bold",
                        children: "Current Setting:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "command-example--inline",
                        children: "/list"
                    }),
                    " and",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "command-example--inline",
                        children: "/link"
                    }),
                    " commands will show only the events in the channel the command was sent in."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "",
                children: [
                    "You can override this using",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "command-example--inline",
                        children: "/list all"
                    }),
                    " or",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "command-example--inline",
                        children: "/link all"
                    }),
                    ". A",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "/manual/#list",
                        className: "manual-link",
                        children: "channel filter"
                    }),
                    " ",
                    "can also be used."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "",
                children: "In all cases, only events visible to the user running the command will be shown."
            }),
            event_channel_set && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "note mt-4",
                children: "NOTE: There is an event channel set above. Events will still be sent there by default. This can be overridden using Channel Overrides."
            })
        ]
    });
}
function render_discord_timestamps_enabled_text() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: "Current Setting:"
            }),
            " Times will be shown using Discord Timestamps. These will automatically convert to each users' local timezone. If the times are not displayed properly, update Discord."
        ]
    });
}
function render_discord_timestamps_disabled_text() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold",
                children: "Current Setting:"
            }),
            " Times will be shown using the",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                className: "manual-link",
                href: "#timezone_settings_blurb",
                children: "Default Timezone."
            })
        ]
    });
}
const LowercaseToUppercaseSectionNamesMap = {};
(0, _seshTypes.GuildSettingsSectionNames).forEach((val)=>LowercaseToUppercaseSectionNamesMap[val.toLowerCase()] = val);
const ChannelOverrideSectionNames = [
    "General",
    "Event",
    "Poll"
];
const SectionNames = {
    General: "General Settings",
    Event: "Event Settings",
    Poll: "Poll Settings",
    Sync: "Sync Settings",
    Logs: "Logs",
    Premium: "Premium"
};
const SectionsToIgnorePerms = {
    Premium: true,
    Sync: true,
    Logs: true
};
const SettingsSectionIcons = {
    General: "fas fa-cog",
    Event: "fas fa-calendar-check",
    Poll: "fas fa-poll",
    Sync: "fas fa-sync",
    Premium: "fas fa-gem",
    Logs: "fas fa-clipboard-list"
};
const BetaSections = {
    Sync: true
};
const AlphaSections = {};
const NewSections = {
    Logs: true
};
function getCurrentSectionFromURL(props) {
    const params = new URLSearchParams(props.location.search);
    return params.get("section");
}
class GuildSettingsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        document.body.style.overflowY = "scroll";
        const section_from_url = getCurrentSectionFromURL(this.props);
        let current_section = LowercaseToUppercaseSectionNamesMap[section_from_url];
        if (!current_section) {
            current_section = "General";
            const params = new URLSearchParams({
                section: current_section.toLowerCase()
            });
            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: params.toString()
            });
        }
        (0, _webUi.setDocTitle)("Settings", this.props.guild_data.name);
        if (this.is_channel_override_page()) this.state = {
            guild_settings: (0, _lodash.cloneDeep)(this.props.original_guild_settings),
            page_to_display: null,
            is_saving: false,
            loading_page: false,
            secondary_timezone_being_removed: [],
            current_section: current_section,
            revision_counter: 0,
            individual_channel_settings_overrides: (0, _lodash.cloneDeep)(this.props.individual_channel_settings_overrides) ?? {}
        };
        else this.state = {
            guild_settings: (0, _lodash.cloneDeep)(this.props.original_guild_settings),
            page_to_display: null,
            is_saving: false,
            loading_page: false,
            secondary_timezone_being_removed: [],
            current_section: current_section,
            revision_counter: 0
        };
        // const state = common_utils.createServerSettingsURLState(
        // 	this.props.auth_token.bot_client_id,
        // 	this.props.guild_data.id
        // );
        // history.replaceState(null, "", `/dashboard/#state=${state}`);
        this.saveGuildSettings = this.saveGuildSettings.bind(this);
        this.AIPage = this.AIPage.bind(this);
        this.savePreset = this.savePreset.bind(this);
        this.renderSignupOptionsPage = this.renderSignupOptionsPage.bind(this);
        this.createOneOffPage = this.createOneOffPage.bind(this);
        this.renderBlurb = this.renderBlurb.bind(this);
        this.createCurrentRSVPOptionsDisplay = this.createCurrentRSVPOptionsDisplay.bind(this);
        this.renderTimezonePickerPage = this.renderTimezonePickerPage.bind(this);
        this.renderPermissionsPage = this.renderPermissionsPage.bind(this);
        this.renderPermissionsBlurb = this.renderPermissionsBlurb.bind(this);
        this.savePrimaryTimezone = this.savePrimaryTimezone.bind(this);
        this.loadOneOffPage = this.loadOneOffPage.bind(this);
        this.createCurrentTimezoneDisplay = this.createCurrentTimezoneDisplay.bind(this);
        this.getPageTitle = this.getPageTitle.bind(this);
        this.saveSecondaryTimezones = this.saveSecondaryTimezones.bind(this);
        this.renderSubmitButton = this.renderSubmitButton.bind(this);
        this.SyncSettings = this.SyncSettings.bind(this);
        this.PremiumSettings = this.PremiumSettings.bind(this);
        this.deactivateServer = this.deactivateServer.bind(this);
        this.activateServer = this.activateServer.bind(this);
    }
    is_channel_override_page() {
        return this.props.is_channel_settings_overrides_page;
    }
    get_channel_override_settings_channel_name() {
        return this.props.all_text_channels.find((val)=>this.props.individual_channel_id == val.id).name;
    }
    getPageTitle() {
        return `${SectionNames[this.state.current_section]}`;
    }
    getSettingForChannel(key) {
        return (0, _typeUtils.getSettingForChannel)(this.state.guild_settings, this.state.individual_channel_settings_overrides, key);
    }
    has_active_channel_override_for_setting_in_props(key) {
        return (0, _typeUtils.hasActiveChannelOverrideForSetting)(this.props.individual_channel_settings_overrides, key);
    }
    hasActiveChannelOverrideForSetting(key) {
        return (0, _typeUtils.hasActiveChannelOverrideForSetting)(this.state.individual_channel_settings_overrides, key);
    }
    guild_settings_style_get_individual_channel_setting_override_from_canonical(key) {
        return (0, _typeUtils.guildSettingsStyle_getIndividualChannelSettingOverride)(this.props.original_guild_settings, this.props.individual_channel_settings_overrides, key, this.props);
    }
    guildSettingsStyle_getIndividualChannelSettingOverrideFromState(key) {
        return (0, _typeUtils.guildSettingsStyle_getIndividualChannelSettingOverride)(this.state.guild_settings, this.state.individual_channel_settings_overrides, key, this.props);
    }
    hasSettingChanged(key) {
        let current_setting = this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState(key);
        let original_setting = (0, _typeUtils.guildSettingsStyle_getIndividualChannelSettingOverride)(this.props.original_guild_settings, this.props.individual_channel_settings_overrides, key, this.props);
        if (key === "prefix") {
            current_setting = current_setting ? current_setting : "!";
            original_setting = original_setting ? original_setting : "!";
        }
        if (current_setting?.id || original_setting?.id) {
            current_setting = current_setting?.id;
            original_setting = original_setting?.id;
        }
        if (key === "attendee_role_data") {
            let current_setting_as_role_data = current_setting;
            let original_setting_as_role_data = original_setting;
            return !(0, _commonUtils.common_utils).areAttendeeRoleDatasEqual(current_setting_as_role_data, original_setting_as_role_data);
        }
        const object_keys = [
            "default_native_event_data",
            "default_event_thread_settings",
            "event_channel_forum_tag_ids",
            "poll_channel_forum_tag_ids",
            "default_event_server_reminders",
            "default_role_mentions_on_event_create",
            "default_user_mentions_on_event_create"
        ];
        if (object_keys.includes(key)) return !(0, _commonUtils.common_utils).areObjectsEqual(current_setting, original_setting);
        if (key === "use_reactions_for_polls") return Boolean(original_setting) !== Boolean(current_setting);
        // Need to explicitly handle objects, if an object makes it here, we implicitly do not handle it, so assume its unchanged
        if (current_setting != null && typeof current_setting === "object" || original_setting != null && typeof original_setting === "object") return false;
        return current_setting !== original_setting;
    // use lodash if we ever use this for non primitives.
    // return !lodash.isEqual(
    // 	this.state.guild_settings[key],
    // 	this.state.original_settings[key]
    // );
    }
    componentWillUnmount() {
        document.body.style.overflowY = "auto";
        this.props.clear_parents_settings_data_func();
    }
    updateState(thing, value) {
        let key = thing.substr(0); //wtf
        if (key in this.state.guild_settings) {
            if (this.is_channel_override_page()) (0, _typeUtils.guildSettingsStyle_setIndividualChannelSettingOverride)(this.state.individual_channel_settings_overrides, key, value, this.props);
            else this.state.guild_settings[key] = value;
        } else if (key in this.state) this.state[key] = value;
        else {
            console.log("Error: Invalid Key");
            return;
        }
        this.setState(this.state);
    }
    handleSubmit(event) {
        event.preventDefault();
    }
    async savePermissions(permissions) {
        if (!this.props.is_admin) return;
        const request_body = {
            permissions,
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            guild_id: this.props.guild_data.id,
            channel_id: this.props.individual_channel_id
        };
        this.setState({
            loading_page: true,
            loading_text: "Setting Server Permissions..."
        });
        fetch(`/api/set_guild_permissions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        }).then((response)=>{
            response.json().then((val)=>{
                this.setState({
                    loading_page: false,
                    loading_text: null,
                    page_to_display: null
                });
                if (response.status === 200) this.updateOriginalSettings("permissions", val.permissions);
                else (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(val.err);
            });
        });
    }
    async savePreset(preset) {
        const dupe = (0, _commonFormatUtils.common_format_utils).get_duplicate_emojis_in_preset(preset);
        if (dupe) {
            let error = `Duplicate custom emojis [${dupe}]! Can not use the same emoji for multiple options.`;
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(error);
            return;
        }
        const request_body = {
            preset,
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            guild_id: this.props.guild_data.id,
            channel_id: this.props.individual_channel_id
        };
        this.setState({
            loading_page: true,
            loading_text: "Setting Preset as Default..."
        });
        fetch(`/api/set_guild_preset`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        }).then((response)=>{
            this.setState({
                loading_page: false,
                loading_text: null,
                page_to_display: null
            });
            if (response.status === 200) this.updateOriginalSettings("signup_options", preset);
            else response.json().then((val)=>{
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(val.err);
            });
        });
    }
    updateOriginalSettings(key, value) {
        if (this.is_channel_override_page()) {
            const original_settings_clone = (0, _lodash.cloneDeep)(this.props.individual_channel_settings_overrides) ?? {};
            (0, _typeUtils.guildSettingsStyle_setIndividualChannelSettingOverride)(original_settings_clone, key, value, this.props);
            this.props.on_save_func(undefined, original_settings_clone, this.props.individual_channel_id, this.props.guild_data.id, true);
        } else {
            const original_settings_clone = (0, _lodash.cloneDeep)(this.props.original_guild_settings);
            original_settings_clone[key] = value;
            this.props.on_save_func(original_settings_clone);
        }
        this.updateState(key, value);
    }
    async saveSecondaryTimezones(timezone, removing) {
        if (!removing && this.guild_settings_style_get_individual_channel_setting_override_from_canonical("secondary_timezones").length >= (0, _constants.Constants).SECONDARY_TIMEZONE_LIMIT) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Secondary timezone limit reached");
            return;
        }
        const request_body = {
            timezone,
            removing,
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            guild_id: this.props.guild_data.id,
            channel_id: this.props.individual_channel_id
        };
        if (removing) {
            const new_secondary_timezones_being_removed = this.state.secondary_timezone_being_removed;
            new_secondary_timezones_being_removed.push(timezone);
            this.setState({
                secondary_timezone_being_removed: new_secondary_timezones_being_removed
            });
        } else this.setState({
            loading_page: true,
            loading_text: "Setting Timezone..."
        });
        fetch(`/api/set_guild_secondary_tz_web`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        }).then(async (response)=>{
            this.setState({
                loading_page: false,
                loading_text: null,
                page_to_display: null,
                is_big: false,
                secondary_timezone_being_removed: this.state.secondary_timezone_being_removed.filter((val)=>val !== timezone)
            });
            if (response.status === 200) {
                const original_settings = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("secondary_timezones");
                if (removing) this.updateOriginalSettings("secondary_timezones", original_settings.filter((val)=>val !== timezone));
                else this.updateOriginalSettings("secondary_timezones", Array.from(new Set(original_settings.concat([
                    timezone
                ]))));
            } else {
                let response_json = await response.json();
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response_json.err);
            }
        });
    }
    async savePrimaryTimezone(timezone) {
        const request_body = {
            timezone,
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            guild_id: this.props.guild_data.id,
            channel_id: this.props.individual_channel_id
        };
        this.setState({
            loading_page: true,
            loading_text: "Setting Timezone..."
        });
        fetch(`/api/set_guild_tz_web`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        }).then((response)=>{
            this.setState({
                loading_page: false,
                loading_text: null,
                page_to_display: null,
                is_big: false
            });
            if (response.status === 200) this.updateOriginalSettings("timezone", timezone);
            else response.json().then((val)=>{
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(val.err);
            });
        });
    }
    async deactivateServer() {
        const body = {
            guild_id: this.props.guild_data.id,
            is_activate: false
        };
        const headers = (0, _commonUtils.common_utils).createSeshHeader(this.props.auth_token);
        this.setState({
            is_saving: true
        });
        return fetch(`/api/modify_premium_status`, {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then((response)=>{
            this.setState({
                is_saving: false
            });
            if (response.status === 200) response.json().then((val)=>{
                if (val.err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert((0, _commonUtils.common_utils).markdownToHtml(val.err));
                    return false;
                }
                this.props.on_premium_modified_func(val.guild_settings_props);
                return true;
            });
            else {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.statusText);
                return false;
            }
        });
    }
    async activateServer() {
        const body = {
            guild_id: this.props.guild_data.id,
            is_activate: true
        };
        const headers = (0, _commonUtils.common_utils).createSeshHeader(this.props.auth_token);
        this.setState({
            is_saving: true
        });
        return fetch(`/api/modify_premium_status`, {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then((response)=>{
            this.setState({
                is_saving: false
            });
            if (response.status === 200) return response.json().then((val)=>{
                if (val.err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert((0, _commonUtils.common_utils).markdownToHtml(val.err));
                    return false;
                }
                this.props.on_premium_modified_func(val.guild_settings_props);
                (0, _dashboardUtils.DashboardUtils).ShowSuccessMessageAlert("Successfully activated server!", `You have used ${val.result.current_activations} out of ${val.result.max_activations} of your activations.`);
                return true;
            });
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.statusText);
            return false;
        });
    }
    saveGuildSettings() {
        if (this.is_channel_override_page()) {
            const settings_to_save = (0, _lodash.cloneDeep)(this.state.individual_channel_settings_overrides);
            let request_body = {
                settings: settings_to_save,
                access_token: this.props.auth_token.access_token,
                token_type: this.props.auth_token.token_type,
                guild_id: this.props.guild_data.id,
                channel_id: this.props.individual_channel_id
            };
            this.setState({
                is_saving: true
            });
            const stringified_body = JSON.stringify(request_body, (k, v)=>v === undefined ? null : v);
            fetch(`/api/set_channel_override_settings`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: stringified_body
            }).then((response)=>{
                if (response.status === 200) {
                    this.setState({
                        is_saving: false,
                        save_err_txt: null
                    });
                    this.props.on_save_func(null, settings_to_save, this.props.individual_channel_id);
                } else response.json().then((val)=>{
                    this.setState({
                        is_saving: false,
                        save_err_txt: val.err
                    });
                });
            });
        } else {
            const settings_to_save = (0, _lodash.cloneDeep)(this.state.guild_settings);
            let request_body = {
                settings: settings_to_save,
                access_token: this.props.auth_token.access_token,
                token_type: this.props.auth_token.token_type,
                guild_id: this.props.guild_data.id
            };
            this.setState({
                is_saving: true
            });
            fetch(`/api/set_guild_settings`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(request_body)
            }).then((response)=>{
                if (response.status === 200) {
                    this.setState({
                        is_saving: false,
                        save_err_txt: null
                    });
                    this.props.on_save_func(settings_to_save);
                } else response.json().then((val)=>{
                    this.setState({
                        is_saving: false,
                        save_err_txt: val.err
                    });
                });
            });
        }
    }
    createTimezoneListing(timezone) {
        let time = _luxon.DateTime.utc().setZone(timezone);
        let offset_text = time.zone.formatOffset(time.toMillis(), "short");
        let result = `[UTC${offset_text}] ${timezone}`;
        if (timezone !== "UTC") result += ` (${time.offsetNameShort})`;
        return result;
    }
    createCurrentTimezoneDisplay() {
        const primary_timezone = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("timezone");
        const primary_header = "Default Timezone";
        const secondary_header = "Additional Display Timezones";
        let button_text = "Add Display Timezone";
        let secondary_timezones = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("secondary_timezones");
        let rows = [];
        const should_disable = !this.props.is_admin;
        let i = 0;
        for (let timezone of secondary_timezones){
            let current_timezones_being_removed = this.state.secondary_timezone_being_removed.includes(timezone);
            rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: this.createTimezoneListing(timezone)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                        children: [
                            !current_timezones_being_removed && !should_disable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).DeleteButton, {
                                onClick: ()=>this.saveSecondaryTimezones(timezone, true)
                            }),
                            current_timezones_being_removed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clipLoaderDefault.default), {
                                    size: "1rem",
                                    loading: true,
                                    color: (0, _constants.Constants).EMBED_COLOR
                                })
                            })
                        ]
                    })
                ]
            }, i));
            i++;
        }
        if (rows.length === 0) rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                colSpan: 2,
                children: "None"
            })
        }, "none_ele"));
        const secondary_timezone_limit_reached = secondary_timezones.length >= (0, _constants.Constants).SECONDARY_TIMEZONE_LIMIT;
        if (secondary_timezone_limit_reached) button_text = "Timezone Limit Reached";
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile is-multiline !pt-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                            className: "sesh-table mobilized-table max-w-full",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    primary_header,
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex w-fit items-center",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                                            info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    "The default timezone when creating events in Discord. Also used in",
                                                                    " ",
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineCode.InlineCode), {
                                                                        children: "/list"
                                                                    }),
                                                                    " ",
                                                                    "output"
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            !should_disable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: this.createTimezoneListing(primary_timezone)
                                            }),
                                            !should_disable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    className: "manual-link",
                                                    onClick: ()=>{
                                                        this.loadOneOffPage(this.renderTimezonePickerPage, true, "timezone");
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-pencil-alt"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "column is-full",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                className: "sesh-table mobilized-table max-w-full",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        secondary_header,
                                                        " ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex w-fit items-center",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                                                info: "Additional timezones to display on event embeds"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                        children: rows
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                                className: "mt-4",
                                onClick: ()=>this.loadOneOffPage(this.renderTimezonePickerPage, true, "secondary_timezones"),
                                disabled: secondary_timezone_limit_reached || should_disable,
                                children: button_text
                            })
                        ]
                    })
                })
            ]
        });
    }
    createCurrentRSVPOptionsDisplay() {
        const signup_options = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("signup_options");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpOptionsTable.RSVPOptionsTable), {
            options: signup_options
        });
    }
    async loadOneOffPage(render_function, is_big, key) {
        this.setState({
            loading_page: true
        });
        let page_to_display = await render_function(key);
        if (this.state.loading_page) {
            this.setState({
                page_to_display: page_to_display,
                loading_page: false,
                is_big: is_big
            });
            is_big; // else: loading was cancelled
        }
    }
    createModifyButton(render_function, is_big, disabled, is_patron_only) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "tooltip",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
                    className: "mt-4",
                    disabled: disabled,
                    onClick: async ()=>{
                        this.loadOneOffPage(render_function, is_big);
                    },
                    children: "Modify"
                }),
                is_patron_only && !this.props.is_premium && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "tooltiptop",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "icon is-small",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-gem"
                            })
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: (0, _constants.Constants).PREMIUM_LINK,
                                    target: "_blank",
                                    children: "Premium"
                                }),
                                " ",
                                "Exclusive"
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderBlurb(id, header, info, blurb_display, render_function, display_options) {
        let disabled = !this.props.is_admin || !this.props.is_premium && display_options.is_patron_only;
        let outerClassName = "field";
        if (display_options.is_overridden) outerClassName += ` overridden-field`;
        else outerClassName += ` blurb`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: outerClassName,
            id: id,
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(header, info),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        blurb_display(),
                        " ",
                        display_options.include_modify_button && this.createModifyButton(render_function, display_options.is_big, disabled, display_options.is_patron_only)
                    ]
                })
            ]
        });
    }
    createOneOffPage(element_func) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "options-margin-items",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-mobile is-vcentered is-variable is-1 margin-link",
                        onClick: ()=>{
                            this.setState({
                                page_to_display: null,
                                loading_page: false,
                                loading_text: null,
                                is_big: false
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-narrow",
                                children: (0, _dashboardUtils.DashboardUtils).GetBackIcon()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "column is-narrow",
                                children: [
                                    this.state.current_section,
                                    " Settings"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "back-arrow"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
                    transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
                    children: element_func
                })
            ]
        });
    }
    async renderSignupOptionsPage() {
        const current_preset = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("signup_options");
        let request_body = {
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            guild_id: this.props.guild_data.id
        };
        const response_raw = await fetch(`/api/get_signup_option_presets`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        });
        const response = await response_raw.json();
        if (response.err) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.err);
            return;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "title is-3 has-text-centered",
                    children: "Edit Default RSVP Options"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpOptionsDefault.default), {
                        is_premium: this.props.is_premium,
                        user_presets: response.user_presets,
                        user_id: response.user_id,
                        custom_emojis: response.custom_emojis,
                        all_guild_data: response.all_guild_data,
                        current_preset: current_preset,
                        updateFunc: ()=>{},
                        token_type: this.props.auth_token.token_type,
                        access_token: this.props.auth_token.access_token,
                        save_for_guild_settings_data: {
                            on_click_func: (preset)=>this.savePreset(preset),
                            text: "Set as Default"
                        }
                    })
                })
            ]
        });
    }
    renderTimezonePickerPage(field_key) {
        let saveFunc;
        let secondary_timezones = [];
        let is_secondary = false;
        if (field_key === "timezone") saveFunc = (val)=>this.savePrimaryTimezone(val);
        else {
            saveFunc = (val)=>this.saveSecondaryTimezones(val, false);
            secondary_timezones = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("secondary_timezones");
            is_secondary = true;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timezonePicker.TimezonePickerForm), {
            token_type: this.props.auth_token.token_type,
            access_token: this.props.auth_token.access_token,
            guild_id: this.props.guild_data.id,
            updateFunc: ()=>{},
            current_timezone: this.guild_settings_style_get_individual_channel_setting_override_from_canonical("timezone"),
            secondary_timezones: secondary_timezones,
            is_secondary: is_secondary,
            saveFunc: (val)=>{
                saveFunc(val);
            },
            use_discord_timestamps: this.state.guild_settings.use_discord_timestamps
        }, "timezone_picker_form");
    }
    renderPermissionsPage() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permissionsForm.PermissionsForm), {
            initial_permissions: this.guild_settings_style_get_individual_channel_setting_override_from_canonical("permissions"),
            role_mentions: this.props.roles,
            save_func: (new_permissions)=>this.savePermissions(new_permissions)
        });
    }
    createAdminElement() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
            label: "admins",
            info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "Users with",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "has-text-weight-bold",
                        children: "Manage Sesh"
                    }),
                    " ",
                    "permissions"
                ]
            })
        });
    }
    renderPermissionsBlurb() {
        const rows = [];
        const admin_name = "admins*";
        const permissions = this.guild_settings_style_get_individual_channel_setting_override_from_canonical("permissions");
        let index = 0;
        for (let option of permissions){
            let role_elements = [];
            let has_everyone = false;
            let mentionables = option.roles_ids.map((val)=>{
                if (val === "@everyone") has_everyone = true;
                return this.props.roles.find((mentionable)=>val === mentionable.id);
            });
            mentionables = mentionables.filter((val)=>Boolean(val));
            if (has_everyone) mentionables = [
                mentionables.find((val)=>val.id === "@everyone")
            ];
            else mentionables.push({
                id: null,
                name: admin_name,
                type: 1,
                color: "#FFFFFF"
            });
            let mention_index = 0;
            for (let role of mentionables){
                let color = "#FFFFFF";
                let name = role.name;
                if (role.name === admin_name) name = this.createAdminElement();
                else if (role.id !== "@everyone") name = "@" + name;
                let comma = mention_index < mentionables.length - 1 ? ", " : "";
                role_elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                color: color
                            },
                            children: name
                        }),
                        comma
                    ]
                }, mention_index));
                mention_index++;
            }
            const name = option.command === "settings" ? "manager" : option.command;
            rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        children: role_elements
                    })
                ]
            }, index));
            index++;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "sesh-table mobilized-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Command"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Roles"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: rows
                    })
                ]
            })
        });
    }
    renderSeshChannelSettings(type, initial_channel, all_channels, is_event) {
        let channel_key;
        let admin_override_key;
        let require_send_messages_key;
        let channel_forum_tags_key;
        switch(type){
            case "Event":
                channel_key = "event_channel";
                admin_override_key = "event_channel_override_only_admins";
                require_send_messages_key = "event_channel_require_send_messages";
                channel_forum_tags_key = "event_channel_forum_tag_ids";
                break;
            case "Poll":
                channel_key = "poll_channel";
                admin_override_key = "poll_channel_override_only_admins";
                require_send_messages_key = "poll_channel_require_send_messages";
                channel_forum_tags_key = "poll_channel_forum_tag_ids";
                break;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-vcentered is-multiline",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-full",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdownWithTags.ChannelSelectFormWithTags), {
                        update_initially: !this.props.is_channel_settings_overrides_page,
                        initial_value: initial_channel,
                        channel_data: all_channels,
                        disabled: !this.props.is_admin,
                        updateFunc: (val)=>this.updateState(channel_key, val),
                        include_threads: false,
                        selected_forum_tag_ids: this.getSettingForChannel(channel_forum_tags_key),
                        setSelectedTagIds: (ids)=>this.updateState(channel_forum_tags_key, ids)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    name: "has_reminders",
                                    checked: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState(admin_override_key),
                                    onChange: (e)=>this.updateState(admin_override_key, e.target.checked),
                                    disabled: !this.props.is_admin
                                }, admin_override_key),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "Only",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "has-text-weight-bold",
                                            children: "Admins"
                                        }),
                                        " ",
                                        "can override",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            "Only allow users with",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "Manage Sesh"
                                            }),
                                            " ",
                                            "perms to send",
                                            " ",
                                            is_event ? "events" : "polls",
                                            " outside the designated channel"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    name: "has_reminders",
                                    checked: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState(require_send_messages_key),
                                    onChange: (e)=>this.updateState(require_send_messages_key, e.target.checked),
                                    disabled: !this.props.is_admin
                                }, require_send_messages_key),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "Require",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "has-text-weight-bold",
                                            children: "Send Messages"
                                        }),
                                        " ",
                                        "permissions",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            "Only allow users with",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "Send Messages"
                                            }),
                                            " ",
                                            "permissions in the selected channel to create ",
                                            is_event ? "events" : "polls",
                                            " ",
                                            "in the channel. If disabled, users will only require",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "View Channel"
                                            }),
                                            " ",
                                            "permissions to create",
                                            " ",
                                            is_event ? "events" : "polls",
                                            " in the channel."
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
    SyncSettings() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildSettingsContext.Provider, {
            value: this.props,
            children: (0, _constants.Constants).GCAL_ENABLED ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncSettingsDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
                error: "Sync settings are currently down for maintenance. Your existing syncs are currently paused. iCal feeds will still work during this downtime. Thanks for your patience."
            })
        });
    }
    PremiumSettings() {
        const [showConfetti, setShowConfetti] = (0, _react.useState)(false);
        const guild_data = (0, _useGuildData.useCurrentGuildData)();
        if (guild_data?.is_discord_premium) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "has-text-centered",
                children: [
                    "This server's premium has been bought through Discord. If you'd like to modify this server's premium status, please follow",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "manual-link",
                        target: "_blank",
                        href: (0, _constants.Constants).DISCORD_PREMIUM_MANAGEMENT_FAQ_LINK,
                        children: "these steps"
                    }),
                    "."
                ]
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                showConfetti && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Party, {
                    duration: 5000
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "has-text-centered",
                    children: [
                        "Activate or deactivate sesh premium for this server. You must be subscribed to",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "manual-link",
                            href: (0, _constants.Constants).PREMIUM_LINK,
                            target: "_blank",
                            children: "Premium"
                        }),
                        " ",
                        "in order to activate servers. Anyone in a server can activate a server, but only the original activator can deactivate it.",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "To view and manage all of your premium servers, go",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            className: "manual-link",
                            to: (0, _commonUtils.common_utils).getPremiumPageURL(),
                            children: "here"
                        }),
                        " ",
                        "or DM sesh",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "command-example--inline",
                            children: "/premium"
                        }),
                        ".",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "To see what premium gets you, visit our",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://sesh.fyi/premium",
                            className: "manual-link",
                            target: "_blank",
                            children: "Premium page"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field submit-button",
                    children: [
                        this.props.is_premium && this.props.premium_activator_id && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-semibold mb-4 text-center text-premium",
                            children: [
                                "\uD83C\uDF89 This server is already activated by",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleMemberDisplayNameDefault.default), {
                                    include_avatar: true,
                                    user_id: this.props.premium_activator_id
                                }),
                                " ",
                                "\uD83C\uDF89"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "control columns is-multiline is-mobile is-vcentered is-centered",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-narrow",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivateButton, {
                                    is_admin: this.props.is_admin,
                                    is_premium: this.props.is_premium,
                                    premium_activator_id: this.props.premium_activator_id,
                                    user_id: this.props.user_id,
                                    is_saving: this.state.is_saving,
                                    guild_name: this.props.guild_data.name,
                                    onClick: (is_activate)=>{
                                        if (is_activate) this.activateServer().then((success)=>{
                                            if (success) setShowConfetti(true);
                                        });
                                        else return this.deactivateServer();
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
    renderPermissionSettings() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: !this.is_channel_override_page() && this.renderBlurb("permissions_blurb", "Permissions", "Modify which roles can run sesh commands", this.renderPermissionsBlurb, this.renderPermissionsPage, {
                is_patron_only: false,
                is_big: false,
                include_modify_button: true,
                is_overridden: this.has_active_channel_override_for_setting_in_props("command_permissions")
            })
        });
    }
    renderGeneralSettings() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.renderBlurb("timezone_settings_blurb", "Timezone Settings", null, this.createCurrentTimezoneDisplay, this.renderTimezonePickerPage, {
                    is_patron_only: false,
                    is_big: true,
                    include_modify_button: false,
                    is_overridden: this.has_active_channel_override_for_setting_in_props("custom_timezone") || this.has_active_channel_override_for_setting_in_props("secondary_timezones")
                }),
                !this.is_channel_override_page() && this.renderBlurb("permissions_blurb", "Permissions", "Modify which roles can run sesh commands", this.renderPermissionsBlurb, this.renderPermissionsPage, {
                    is_patron_only: false,
                    is_big: false,
                    include_modify_button: true,
                    is_overridden: this.has_active_channel_override_for_setting_in_props("command_permissions")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("use_24h_clock"),
                    opened_initially: Boolean(this.getSettingForChannel("use_24h_clock")),
                    label: "Use 24 Hour Clock",
                    field_key: "use_24h_clock",
                    is_server_premium: this.props.is_premium,
                    info: "Use 24 hour clock instead of 12 hour clock. Ex: 23:00 instead 11:00pm",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("use_24h_clock"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("use_24h_clock")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("auto_remove_user_commands"),
                    opened_initially: Boolean(this.getSettingForChannel("auto_remove_user_commands")),
                    label: "Clean User Commands",
                    field_key: "clean_user_commands",
                    is_server_premium: this.props.is_premium,
                    info: "Delete user command messages after they are processed",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("clean_user_commands"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("auto_remove_user_commands")
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.guild_settings.display_attendees_as_plain_text,
                    opened_initially: Boolean(this.state.guild_settings.display_attendees_as_plain_text),
                    label: "Display Usernames as Plain Text",
                    field_key: "display_attendees_as_plain_text",
                    is_server_premium: this.props.is_premium,
                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "Display attendees without mention formatting. Avoids Discord issue of displaying names as",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "command-example--inline",
                                children: "<@12345678910>"
                            }),
                            " ",
                            "instead of",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "command-example--inline",
                                children: "@username"
                            })
                        ]
                    }),
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("display_attendees_as_plain_text")
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: !Boolean(this.state.guild_settings.use_discord_timestamps),
                    opened_initially: !Boolean(this.state.guild_settings.use_discord_timestamps),
                    label: "Use Legacy Time Display",
                    field_key: "use_discord_timestamps",
                    is_server_premium: this.props.is_premium,
                    info: "By default sesh uses Discord Timestamps. Enable this setting to use the old server-timezone-based display.",
                    render_child: render_discord_timestamps_disabled_text,
                    disabled_element_func: render_discord_timestamps_enabled_text,
                    updateFunc: (key, value)=>{
                        this.updateState(key, !value);
                    },
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("use_discord_timestamps")
                })
            ]
        });
    }
    renderPollSettings() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    field_key: "poll_channel",
                    initial_value: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("poll_channel"),
                    opened_initially: Boolean(this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("poll_channel")),
                    label: "Poll Channel",
                    is_server_premium: this.props.is_premium,
                    info: "Channel where polls will get sent to by default",
                    disabled: !this.props.is_admin,
                    onCheckboxUnclicked: ()=>{
                        this.updateState("poll_channel", undefined);
                        this.updateState("poll_channel_forum_tag_ids", []);
                    },
                    unsaved_changes: this.hasSettingChanged("poll_channel") || this.hasSettingChanged("poll_channel_override_only_admins") || this.hasSettingChanged("poll_channel_require_send_messages") || this.hasSettingChanged("poll_channel_forum_tag_ids"),
                    render_child: (field_key, initial_value)=>{
                        return this.renderSeshChannelSettings("Poll", initial_value, this.props.all_text_channels, false);
                    },
                    is_overridden: this.hasActiveChannelOverrideForSetting("polls_channel_id") || this.hasActiveChannelOverrideForSetting("poll_channel_override_only_admins") || this.hasActiveChannelOverrideForSetting("poll_channel_require_send_messages") || this.hasActiveChannelOverrideForSetting("poll_channel_forum_tag_ids")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("can_add_poll_options"),
                    opened_initially: Boolean(this.getSettingForChannel("can_add_poll_options")),
                    label: "Allow Anyone To Add Poll Options",
                    field_key: "poll_add",
                    is_server_premium: this.props.is_premium,
                    info: "Allow any user to add poll options on sesh polls by default",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("poll_add"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("can_add_poll_options")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("is_default_poll_type_single_vote"),
                    opened_initially: Boolean(this.getSettingForChannel("is_default_poll_type_single_vote")),
                    label: "Default Polls to Single Vote Per User",
                    field_key: "is_default_poll_type_single_vote",
                    is_server_premium: this.props.is_premium,
                    info: "By default users can vote for multiple options in polls. Enable this setting to limit users to one option per poll by default. This can be overriden using the poll creation page or the 'single_vote' parameter in /poll.",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("is_default_poll_type_single_vote"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("is_default_poll_type_single_vote")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorPickerAccordianDefault.default), {
                    field_key: "default_poll_embed_color",
                    label: "Poll Color",
                    is_premium: this.props.is_premium,
                    disabled: !this.props.is_admin,
                    is_new: true,
                    color: this.getSettingForChannel("default_poll_embed_color"),
                    unsaved_changes: this.hasSettingChanged("default_poll_embed_color"),
                    info: "The default color for poll embeds",
                    updateFunc: (value)=>this.updateState("default_poll_embed_color", value),
                    is_channel_override_active: this.hasActiveChannelOverrideForSetting("default_poll_embed_color")
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: Boolean(this.state.guild_settings.use_reactions_for_polls),
                    opened_initially: Boolean(this.state.guild_settings.use_reactions_for_polls),
                    label: "Use Reactions for Polls",
                    field_key: "use_reactions_for_polls",
                    is_server_premium: this.props.is_premium,
                    info: "Use reactions for polls instead of buttons.",
                    render_child: null,
                    updateFunc: (key, value)=>{
                        this.updateState(key, value);
                    },
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("use_reactions_for_polls")
                })
            ]
        });
    }
    renderEventSettings() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.renderBlurb("signup_options_blurb", "Default RSVP Options", "Set the default reactions on events made in Discord", this.createCurrentRSVPOptionsDisplay, this.renderSignupOptionsPage, {
                    is_patron_only: false,
                    is_big: false,
                    include_modify_button: true,
                    is_overridden: this.has_active_channel_override_for_setting_in_props("default_signup_options")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverRemindersBlurb.ServerRemindersForm), {
                    is_disabled: !this.props.is_admin,
                    reminders: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("default_event_server_reminders"),
                    setReminders: (val)=>this.updateState("default_event_server_reminders", val),
                    has_unsaved_changes: this.hasSettingChanged("default_event_server_reminders") || this.hasSettingChanged("default_user_mentions_on_event_create") || this.hasSettingChanged("default_role_mentions_on_event_create"),
                    is_channel_override_active: this.hasActiveChannelOverrideForSetting("default_role_mentions_on_event_create") || this.hasActiveChannelOverrideForSetting("default_user_mentions_on_event_create") || this.hasActiveChannelOverrideForSetting("default_event_server_reminders"),
                    initial_mentions: {
                        create_role_mentions: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("default_role_mentions_on_event_create"),
                        create_user_mentions: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("default_user_mentions_on_event_create")
                    },
                    setInitialMentions: (val)=>{
                        this.updateState("default_role_mentions_on_event_create", val.create_role_mentions);
                        this.updateState("default_user_mentions_on_event_create", val.create_user_mentions);
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    field_key: "event_channel",
                    initial_value: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("event_channel"),
                    opened_initially: Boolean(this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("event_channel")),
                    onCheckboxUnclicked: ()=>{
                        this.updateState("event_channel", undefined);
                        this.updateState("event_channel_forum_tag_ids", []);
                    },
                    label: "Event Channel",
                    is_server_premium: this.props.is_premium,
                    info: "Channel where events will get sent to by default",
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("event_channel") || this.hasSettingChanged("event_channel_override_only_admins") || this.hasSettingChanged("event_channel_require_send_messages") || this.hasSettingChanged("event_channel_forum_tag_ids"),
                    render_child: (field_key, initial_value)=>{
                        return this.renderSeshChannelSettings("Event", initial_value, this.props.all_text_channels, true);
                    },
                    is_overridden: this.hasActiveChannelOverrideForSetting("events_channel_id") || this.hasActiveChannelOverrideForSetting("event_channel_override_only_admins") || this.hasActiveChannelOverrideForSetting("event_channel_require_send_messages") || this.hasActiveChannelOverrideForSetting("event_channel_forum_tag_ids")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nativeEventFormDefault.default), {
                    is_guild_setting: true,
                    is_loading: false,
                    voice_channels: this.props.all_voice_channels,
                    initial_event_data: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("default_native_event_data"),
                    updateFunc: (val)=>this.updateState("default_native_event_data", val),
                    sesh_has_manage_events: this.props.sesh_has_manage_events,
                    user_has_manage_events: this.props.user_has_manage_events,
                    label: "Mirror Events to Discord Native Events",
                    is_overridden: this.hasActiveChannelOverrideForSetting("default_native_event_location_type") || this.hasActiveChannelOverrideForSetting("default_native_event_location_value") || this.hasActiveChannelOverrideForSetting("default_native_event_custom_description") || this.hasActiveChannelOverrideForSetting("default_native_event_image_url"),
                    unsaved_changes: this.hasSettingChanged("default_native_event_data"),
                    is_disabled: !this.props.is_admin,
                    rsvp_options: undefined
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventThreadForm.EventThreadAccordian), {
                    type: "GuildSetting",
                    is_unsaved: this.hasSettingChanged("default_event_thread_settings"),
                    value: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("default_event_thread_settings"),
                    is_channel_override_active: this.hasActiveChannelOverrideForSetting("default_event_thread_settings"),
                    onUpdate: (val)=>this.updateState("default_event_thread_settings", val),
                    disabled: !this.props.is_admin
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    field_key: "attendee_role_data",
                    is_server_premium: this.props.is_premium,
                    disabled: !this.props.is_admin,
                    label: "Event Attendee Roles",
                    initial_value: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("attendee_role_data"),
                    opened_initially: this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("attendee_role_data") && this.guildSettingsStyle_getIndividualChannelSettingOverrideFromState("attendee_role_data")?.role_ids?.length > 0,
                    onCheckboxUnclicked: ()=>this.updateState("attendee_role_data", undefined),
                    info: "Discord roles users will be granted upon RSVP or Event Start for all events",
                    unsaved_changes: this.hasSettingChanged("attendee_role_data"),
                    render_child: (field_key, initial_value)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addRoleToAttendeesComponent.AddRoleToAttendeesComponent), {
                            value: initial_value ?? {
                                role_ids: [],
                                remove_on_end: (0, _constants.Constants).DEFAULT_REMOVE_ROLE_ON_EVENT_END,
                                role_add_time: (0, _constants.Constants).DEFAULT_ADD_ROLE_ON_RSVP_ADD_TIME
                            },
                            setValue: (val)=>this.updateState("attendee_role_data", val),
                            sesh_has_manage_roles: this.props.sesh_has_manage_roles,
                            sesh_role_name: this.props.sesh_role_name,
                            disabled: !this.props.is_admin
                        });
                    },
                    is_overridden: this.hasActiveChannelOverrideForSetting("default_attendee_role_ids") || this.hasActiveChannelOverrideForSetting("role_on_rsvp_add_time") || this.hasActiveChannelOverrideForSetting("remove_roles_on_event_end")
                }, "attendee_role_data to be removed"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("auto_remove_event_messages"),
                    opened_initially: Boolean(this.getSettingForChannel("auto_remove_event_messages")),
                    label: "Clean Event Messages",
                    field_key: "clean_event_messages",
                    is_server_premium: this.props.is_premium,
                    info: "Delete event embeds and event start messages when an event ends",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("clean_event_messages"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("auto_remove_event_messages")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.getSettingForChannel("default_hide_attendees"),
                    opened_initially: Boolean(this.getSettingForChannel("default_hide_attendees")),
                    label: "Hide Attendee Names on Embed",
                    field_key: "default_hide_attendees",
                    is_server_premium: this.props.is_premium,
                    info: "Hide event attendees by default for new events. This can be overridden on the Create Event page or by editing an existing event.",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("default_hide_attendees"),
                    is_overridden: this.hasActiveChannelOverrideForSetting("default_hide_attendees")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorPickerAccordianDefault.default), {
                    field_key: "default_event_embed_color",
                    label: "Event Color",
                    is_premium: this.props.is_premium,
                    disabled: !this.props.is_admin,
                    is_new: true,
                    color: this.getSettingForChannel("default_event_embed_color"),
                    unsaved_changes: this.hasSettingChanged("default_event_embed_color"),
                    info: "The default color for event embeds",
                    updateFunc: (value)=>this.updateState("default_event_embed_color", value),
                    is_channel_override_active: this.hasActiveChannelOverrideForSetting("default_event_embed_color")
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: Boolean(this.state.guild_settings.use_channel_calendars_mode),
                    opened_initially: Boolean(this.state.guild_settings.use_channel_calendars_mode),
                    label: "Use Separate Channel Calendars",
                    field_key: "use_channel_calendars_mode",
                    is_server_premium: this.props.is_premium,
                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "This setting determines what is shown by",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineCode.InlineCode), {
                                children: "/list"
                            }),
                            " and",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inlineCode.InlineCode), {
                                children: "/link"
                            }),
                            ". If you want to limit event visibilty to those inside of a channel, you should enable this."
                        ]
                    }),
                    render_child: ()=>render_channel_calendars_text(Boolean(this.state.guild_settings.event_channel)),
                    disabled_element_func: render_global_calendars_text,
                    updateFunc: (key, value)=>{
                        this.updateState(key, value);
                    },
                    disabled: !this.props.is_admin,
                    unsaved_changes: this.hasSettingChanged("use_channel_calendars_mode")
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResetCalendarFeedsBlurb, {
                    is_admin: this.props.is_admin,
                    discord_auth_token: this.props.auth_token,
                    guild_id: this.props.guild_data.id
                }),
                !this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplateBlurb.EventTemplateBlurb), {
                    onClick: ()=>this.setState({
                            page_to_display: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col items-center gap-4 ",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "text-[2rem] font-bold",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.EventTemplatesHeader), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventTemplatePage.EventTemplateContents), {
                                        is_from_guild_settings: true,
                                        is_guild_premium: this.props.is_premium
                                    })
                                ]
                            })
                        })
                })
            ]
        });
    }
    renderSubmitButton() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "field submit-button",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "control columns is-multiline is-mobile is-vcentered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "button dashboard-primary-button is-size-4-tablet is-size-5-mobile",
                            type: "submit",
                            onClick: this.saveGuildSettings,
                            disabled: this.state.is_saving || !this.props.is_admin,
                            children: [
                                this.state.is_saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "beat-loader-offset",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _beatLoaderDefault.default), {
                                        margin: "0.5em",
                                        loading: true,
                                        color: "#FFFFFF"
                                    })
                                }),
                                !this.state.is_saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "has-text-weight-bold",
                                    children: "Save Settings"
                                })
                            ]
                        })
                    }),
                    this.state.is_saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column",
                        children: "Saving..."
                    }),
                    !this.state.is_saving && this.state.save_err_txt && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column error-text",
                        children: this.state.save_err_txt
                    })
                ]
            })
        });
    }
    AIPage(props) {
        const ai_toggle_description = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Grants server-wide access to the GPT-powered",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "command-example",
                            children: "/ai"
                        }),
                        " command."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ml-auto mt-4 text-xs",
                    children: [
                        "By enabling this command you agree to sesh's",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "manual-link",
                            href: "/policies",
                            children: "Terms of Service"
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildSettingsContext.Provider, {
            value: this.props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiSettingsPage.AISettingsPage), {
                onPremiumClicked: ()=>this.setState({
                        current_section: "Premium"
                    }),
                ai_toggler: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "server-settings-form",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                            initial_value: Boolean(this.state.guild_settings.is_ai_enabled),
                            opened_initially: Boolean(this.state.guild_settings.is_ai_enabled),
                            label: "Enable AI Command",
                            field_key: "is_ai_enabled",
                            is_server_premium: this.props.is_premium,
                            info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Grants server-wide access to the GPT-powered",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "command-example",
                                        children: "/ai"
                                    }),
                                    " ",
                                    "command."
                                ]
                            }),
                            render_child: ()=>ai_toggle_description,
                            disabled_element_func: ()=>ai_toggle_description,
                            updateFunc: (key, value)=>{
                                this.updateState(key, value);
                            },
                            disabled: !this.props.is_admin,
                            unsaved_changes: this.hasSettingChanged("is_ai_enabled")
                        }),
                        this.renderSubmitButton()
                    ]
                })
            })
        });
    }
    renderCurrentSection() {
        switch(this.state.current_section){
            case "General":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        this.renderGeneralSettings(),
                        this.renderSubmitButton()
                    ]
                });
            case "Event":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        this.renderEventSettings(),
                        this.renderSubmitButton()
                    ]
                });
            case "Poll":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        this.renderPollSettings(),
                        this.renderSubmitButton()
                    ]
                });
            case "Sync":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(this.SyncSettings, {})
                });
            case "Logs":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildLogPage.GuildLogsPage), {
                    is_premium: this.props.is_premium,
                    renderOneOffPage: (element)=>this.setState({
                            page_to_display: element
                        })
                });
            case "Premium":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(this.PremiumSettings, {})
                });
        }
    }
    render_overview() {
        const should_display_manage_server_text = !this.props.is_admin && !SectionsToIgnorePerms[this.state.current_section];
        const channel_settings_button = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "is-pulled-right",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "button dashboard-primary-button--tiny",
                    type: "submit",
                    onClick: ()=>this.props.history.push((0, _commonUtils.common_utils).getGuildChannelPickerURL(this.props.guild_data.id)),
                    disabled: !this.props.is_premium || !this.props.is_admin,
                    children: !this.props.is_premium && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: (0, _constants.Constants).PREMIUM_LINK,
                        target: "_blank",
                        className: "white-link-text",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-lock button-icon"
                                }),
                                " ",
                                "Channel Overrides"
                            ]
                        })
                    }) || /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            !this.props.is_admin && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-lock button-icon"
                                    }),
                                    " "
                                ]
                            }),
                            "Channel Overrides"
                        ]
                    })
                })
            })
        });
        const link_chain_data = this.is_channel_override_page() ? [
            (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
            (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.props.guild_data),
            (0, _dashboardUtils.DashboardUtils).RenderGuildSettingsLinkChain(this.props.guild_data.id),
            (0, _dashboardUtils.DashboardUtils).RenderGuildChannelPickerLinkChain(this.props.guild_data.id),
            (0, _dashboardUtils.DashboardUtils).RenderGuildChannelSettingsLinkChain(this.props.guild_data.id, this.props.individual_channel_id, this.get_channel_override_settings_channel_name())
        ] : [
            (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
            (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.props.guild_data),
            (0, _dashboardUtils.DashboardUtils).RenderGuildSettingsLinkChain(this.props.guild_data.id)
        ];
        const should_show_channel_overrides_button = !this.is_channel_override_page() && ChannelOverrideSectionNames.includes(this.state.current_section);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex h-full flex-col",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "columns is-mobile is-multiline !mb-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow settings-link-chain-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
                                link_chain_data: link_chain_data
                            })
                        }),
                        should_show_channel_overrides_button && channel_settings_button
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "title is-3 has-text-centered mt-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: `fa-lg title-icon ${SettingsSectionIcons[this.state.current_section]}`
                            }),
                            this.getPageTitle(),
                            BetaSections[this.state.current_section] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "tag beta-tag ml-2 !text-base",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "!text-sesh-primary",
                                    children: "Beta"
                                })
                            }),
                            AlphaSections[this.state.current_section] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "tag alpha-tag ml-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "",
                                    children: "Alpha"
                                })
                            }),
                            this.is_channel_override_page() && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "is-size-6 overridden-text",
                                children: [
                                    "Overriding server settings for",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "has-text-weight-bold",
                                        children: [
                                            "#",
                                            this.get_channel_override_settings_channel_name()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
                    transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
                    childClassName: "h-full",
                    className: "h-full",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        className: "server-settings-form h-full",
                        onSubmit: this.handleSubmit,
                        children: [
                            should_display_manage_server_text && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                        className: "error-note error-text",
                                        children: [
                                            "Must have",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "Manage Sesh"
                                            }),
                                            " ",
                                            "permissions to change sesh settings"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                ]
                            }),
                            this.renderCurrentSection()
                        ]
                    })
                }, this.state.current_section)
            ]
        }, this.state.current_section);
    }
    areUnsavedChangesPresent() {
        for(const key in this.state.guild_settings){
            if (this.hasSettingChanged(key)) return true;
        }
        return false;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.current_section !== this.state.current_section) {
            // Reset settings to original settings on section switch
            this.setState({
                guild_settings: (0, _lodash.cloneDeep)(this.props.original_guild_settings),
                individual_channel_settings_overrides: (0, _lodash.cloneDeep)(this.props.individual_channel_settings_overrides) ?? {}
            });
            const params = new URLSearchParams({
                section: this.state.current_section.toLowerCase()
            });
            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: params.toString()
            });
        }
    }
    render() {
        let current_render;
        let key;
        if (this.state.loading_page) {
            current_render = this.createOneOffPage((0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(this.state.loading_text));
            key = "loading";
        } else {
            current_render = this.state.page_to_display ? this.createOneOffPage(this.state.page_to_display) : this.render_overview();
            key = this.state.page_to_display ? `one_off_${this.state.revision_counter || 0}` : `main_page_${this.state.revision_counter || 0}`;
        }
        const containerClassName = this.state.is_big ? "column is-8 create-event-container" : "column is-full-mobile is-9-tablet is-8-desktop is-7-widescreen is-5-fullhd create-event-container";
        //is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd
        // is-full-desktop
        // is-10-widescreen
        // is-9-full-hd
        const sidebar_disabled = this.state.is_saving || this.state.loading_page;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile",
                    style: {
                        transition: "opacity 0.5s",
                        opacity: "1"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuSidebar, {
                            current_section: this.state.current_section,
                            setSection: (section)=>{
                                if (!this.state.page_to_display && section === this.state.current_section) // Ignore section click if we're not on a one off page or if clicked current section
                                return;
                                if (this.areUnsavedChangesPresent()) (0, _dashboardUtils.DashboardUtils).ShowDefaultWarningAlert("You have unsaved changes on this page. Proceeding will discard any unsaved changes you have made.", "Unsaved Changes").then((val)=>{
                                    if (val.isConfirmed) this.setState({
                                        current_section: section,
                                        page_to_display: null,
                                        loading_page: false,
                                        loading_text: null,
                                        is_big: false
                                    });
                                });
                                else this.setState({
                                    current_section: section,
                                    page_to_display: null,
                                    loading_page: false,
                                    loading_text: null,
                                    is_big: false
                                });
                            },
                            guild_id: this.props.guild_data.id,
                            is_admin: this.props.is_admin,
                            is_premium: this.props.is_premium,
                            is_channel_override: this.is_channel_override_page(),
                            is_disabled: sidebar_disabled,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: containerClassName,
                                children: current_render
                            }, key)
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnsavedChangesBanner, {
                    isVisible: this.areUnsavedChangesPresent(),
                    onSave: ()=>this.saveGuildSettings(),
                    onRevert: ()=>{
                        this.setState({
                            guild_settings: (0, _lodash.cloneDeep)(this.props.original_guild_settings),
                            individual_channel_settings_overrides: (0, _lodash.cloneDeep)(this.props.individual_channel_settings_overrides) ?? {},
                            revision_counter: (this.state.revision_counter || 0) + 1
                        });
                    },
                    isSaving: this.state.is_saving
                })
            ]
        });
    }
}
function SidebarOption(props) {
    const classNames = [
        "column is-full-tablet is-narrow-mobile menu-item has-text-centered"
    ];
    if (props.is_active) classNames.push("is-active");
    else if (props.is_disabled) classNames.push("input-disabled--severe");
    const icon_class_names = [
        `${SettingsSectionIcons[props.section]} section-icon`
    ];
    if (props.section === "Premium") // make this icon smaller because its weirdly bigger
    icon_class_names.push("smaller-icon");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classNames.join(" "),
        onClick: ()=>props.is_disabled ? undefined : props.onClick(props.section),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "icon is-medium is-hidden-tablet",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: `${icon_class_names.join(" ")} fa-sm`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "icon is-large is-hidden-mobile",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: `${icon_class_names.join(" ")} fa-lg`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "is-hidden-tablet-only is-hidden-mobile",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col items-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "",
                                children: props.section
                            }),
                            NewSections[props.section] && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                                type: "Dark",
                                className: "font-bold",
                                children: "New"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function MenuSidebar(props) {
    const is_mobile = (0, _useIsMobile.useIsMobile)();
    const menu_sections = [];
    for (const section_name of (0, _seshTypes.GuildSettingsSectionNames)){
        if (props.is_channel_override && !ChannelOverrideSectionNames.includes(section_name)) continue;
        menu_sections.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarOption, {
            section: section_name,
            is_active: props.current_section === section_name,
            onClick: props.setSection,
            is_disabled: props.is_disabled
        }, section_name));
    }
    if (is_mobile) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-mobile is-centered is-vcentered !m-0 !p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-full !m-0 !p-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "is-pulled-right",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "columns is-mobile is-centered is-vcentered !m-0 !p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-narrow mobile-sidebar-container sesh-sidebar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "columns is-mobile menu-sections is-vcentered",
                                    children: menu_sections
                                })
                            })
                        })
                    })
                })
            }),
            props.children
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile is-centered",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("aside", {
                className: `column is-1-tablet is-fullheight sesh-sidebar`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile is-multiline menu-sections is-vcentered is-centered",
                    children: menu_sections
                })
            }),
            props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-1"
            })
        ]
    });
}
function ResetCalendarFeedsBlurb(props) {
    const [is_resetting, setIsResetting] = (0, _react.useState)(false);
    const button_classes = [
        "button dashboard-warning-button",
        "is-size-6"
    ];
    if (!props.is_admin) button_classes.push("is-disabled");
    if (is_resetting) button_classes.push("is-loading");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "reset_cal_feeds",
        className: "field",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-mobile is-multiline is-vcentered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow",
                        children: (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton("Reset ICS Calendar Feeds", "Reset server calendar feeds that were generated by /link. Click Reset for more info (you will be asked to confirm)", false, false, false, undefined, !props.is_admin)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "is-pulled-right",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: button_classes.join(" "),
                                disabled: !props.is_admin,
                                type: "submit",
                                onClick: ()=>(0, _dashboardUtils.DashboardUtils).ShowResetConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        children: [
                                            "Are you sure you want to reset",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "ALL"
                                            }),
                                            " ",
                                            "non-personal calendar .ics feeds for this server? Current feeds will no longer update, and users will have to resubscribe to a new URL generated by the",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "command-example--inline",
                                                children: "/link"
                                            }),
                                            " ",
                                            "command in order to continue receiving sesh events.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-bold",
                                                children: "This cannot be undone."
                                            })
                                        ]
                                    })).then((val)=>{
                                        if (!val.isConfirmed) return;
                                        setIsResetting(true);
                                        const headers = (0, _commonUtils.common_utils).createSeshHeader(props.discord_auth_token);
                                        const params = {
                                            guild_id: props.guild_id
                                        };
                                        fetch(`/api/reset_cal_feeds`, {
                                            method: "POST",
                                            headers: headers,
                                            body: JSON.stringify(params)
                                        }).then((response)=>{
                                            setIsResetting(false);
                                            if (response.status === 200) (0, _dashboardUtils.DashboardUtils).ShowSuccessMessageAlert("Calendar Feeds Successfully Deleted", "");
                                            else (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Failed to clear server calendar feeds.");
                                            return;
                                        });
                                    }),
                                children: "Reset"
                            })
                        })
                    })
                ]
            })
        })
    });
}
function Party(props) {
    const [isActive, setIsActive] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsActive(false);
        }, props.duration);
        return ()=>{
            clearTimeout(timer);
        };
    });
    const confetti_source_rect = document.getElementById("premium-activate-button").getBoundingClientRect();
    var window_width = window.innerWidth;
    var window_height = window.innerHeight;
    return isActive ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactConfettiDefault.default), {
        className: "confetti",
        width: window_width,
        height: window_height,
        run: isActive,
        confettiSource: {
            x: confetti_source_rect.x + confetti_source_rect.width / 2,
            y: confetti_source_rect.y - 10,
            w: 1,
            h: 1
        },
        initialVelocityX: {
            max: 2.5,
            min: -2.5
        },
        initialVelocityY: {
            max: -2,
            min: -5
        },
        gravity: 0.015,
        recycle: false,
        tweenDuration: 100,
        friction: 1
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}
function ActivateButton(props) {
    const button_class_names = [
        "button is-size-4-tablet is-size-5-mobile"
    ];
    if (props.is_saving) button_class_names.push("is-loading");
    if (props.is_premium) button_class_names.push("dashboard-warning-button");
    else button_class_names.push("dashboard-premium-button");
    let is_disabled = props.is_premium && !props.is_admin && props.premium_activator_id !== props.user_id;
    if (is_disabled) button_class_names.push("input-disabled");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        id: "premium-activate-button",
        className: button_class_names.join(" "),
        type: "submit",
        onClick: ()=>{
            const is_deactivating = props.is_premium;
            if (is_deactivating) (0, _dashboardUtils.DashboardUtils).ShowDefaultWarningAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "Are you sure you want to remove premium features from",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "has-text-weight-bold",
                        children: props.guild_name
                    }),
                    "?",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mx-auto w-fit rounded border border-base-light bg-base-semidark py-8 pl-4 pr-8",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex h-full items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-info-circle fa-lg my-auto text-sesh-primary"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "content w-full text-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mb-2",
                                            children: [
                                                "This will only deactivate premium on this server, it will",
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "has-text-weight-bold has-text-danger",
                                                    children: "not"
                                                }),
                                                " ",
                                                "cancel your subscription."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mb-0",
                                            children: [
                                                "To modify your subscription, go",
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    className: "manual-link has-text-weight-bold",
                                                    href: (0, _commonUtils.common_utils).getPremiumPageURL(),
                                                    target: "_blank",
                                                    children: "here"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })).then((val)=>{
                if (!val.isConfirmed) return;
                props.onClick(false);
            });
            else props.onClick(!props.is_premium);
        },
        disabled: props.is_saving || is_disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "has-text-weight-bold",
            children: props.is_premium ? "Deactivate Premium" : "Activate Premium"
        })
    });
}
function UnsavedChangesBanner(props) {
    const [isAnimatingOut, setIsAnimatingOut] = (0, _react.useState)(false);
    const [isAnimatingIn, setIsAnimatingIn] = (0, _react.useState)(false);
    const [shouldRender, setShouldRender] = (0, _react.useState)(props.isVisible);
    (0, _react.useEffect)(()=>{
        if (props.isVisible) {
            setShouldRender(true);
            setIsAnimatingOut(false);
            setIsAnimatingIn(true);
            // Allow initial render then trigger animation
            const timer = setTimeout(()=>{
                setIsAnimatingIn(false);
            }, 50);
            return ()=>clearTimeout(timer);
        } else if (shouldRender) {
            setIsAnimatingOut(true);
            const timer = setTimeout(()=>{
                setShouldRender(false);
                setIsAnimatingOut(false);
            }, 300); // Match animation duration
            return ()=>clearTimeout(timer);
        }
    }, [
        props.isVisible,
        shouldRender
    ]);
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `fixed bottom-4 left-4 right-4 z-50 transition-all duration-300 ease-out ${isAnimatingOut ? "translate-y-full opacity-0" : isAnimatingIn ? "translate-y-full opacity-0" : "translate-y-0 opacity-100"}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mx-auto max-w-4xl",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-lg border border-sesh-dark/20 bg-base-light px-6 py-4 shadow-2xl backdrop-blur-sm",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "columns is-mobile is-vcentered mb-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex h-8 w-8 items-center justify-center rounded-full bg-sesh-primary/10",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-edit text-sm text-sesh-primary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "has-text-weight-semibold text-content-primary",
                                                children: "You have unsaved changes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "mb-0 text-sm text-content-secondary",
                                                children: "Don't forget to save your settings"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "text-content-secondary hover:text-content-primary transition-colors duration-200 text-sm font-medium",
                                        onClick: props.onRevert,
                                        disabled: props.isSaving,
                                        children: "Revert"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `button dashboard-primary-button--tiny ${props.isSaving ? "is-loading" : ""}`,
                                        onClick: props.onSave,
                                        disabled: props.isSaving,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "has-text-weight-bold",
                                            children: "Save Changes"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","lodash":"fIO2m","luxon":"fLWpi","react":"IMRgT","react-confetti":"9w95n","../../../../src/vendored/FadeIn":"aMGHU","react-router-dom":"3XSn5","react-spinners/BeatLoader":"fwfdz","react-spinners/ClipLoader":"6YrEM","../../../../common/common_format_utils":"ggT25","../../../../common/common_utils":"gACUC","../../../../common/constants":"lLiun","../../../../common/sesh_types":"aUAOg","../../../../common/type_utils":"kvX2A","../dashboard_utils":"jvA8A","../forms/accordians/color_picker_accordian":"fNjuS","../forms/improved_components/add_role_to_attendees_component":"cKhKw","../forms/improved_components/base_components/modify_settings_button":"kbhTg","../forms/improved_components/base_components/tag":"l4wGc","../forms/improved_components/channel_dropdown_with_tags":"jQ5tM","../forms/improved_components/error_note":"kzA14","../forms/improved_components/event_thread_form":"5ldxh","../forms/improved_components/hooks/use_guild_data":"ljx0Q","../forms/improved_components/hooks/use_is_mobile":"3JtKv","../forms/improved_components/inline_code":"f57of","../forms/improved_components/rsvp_options_table":"9UTc1","../forms/improved_components/guild_logs/guild_log_page":"vqbLQ","../forms/improved_components/server_reminders/server_reminders_blurb":"dEV54","../forms/improved_components/tooltips/info_tooltip":"93rAL","../forms/native_event_form":"gPqC1","../forms/permissions_form":"iYQUr","../forms/rsvp_options":"6SLLX","../forms/sesh_accordian":"etZ1w","../forms/timezone_picker":"aJVZh","../web_ui":"7f1Tj","./ai_settings/ai_settings_page":"fhFeU","./sync_settings/sync_settings":"7cgeG","./event_template_blurb":"hK0YC","../forms/improved_components/event_templates/event_template_page":"5CZM0","../forms/improved_components/member_display_name/simple_member_display_name":"hXYPB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9w95n":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e(require("34009e003b690bf5"));
}("undefined" != typeof self ? self : this, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ReactConfetti", function() {
                return Q;
            });
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = "number" == typeof l ? u(-l, l) : u(l.min, l.max), this.vy = "number" == typeof p ? u(-p, 0) : u(p.min, p.max), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? y(Object(n), !0).forEach(function(e) {
                        g(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function b(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function g(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var O = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, w = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), g(this, "canvas", void 0), g(this, "context", void 0), g(this, "_options", void 0), g(this, "generator", void 0), g(this, "rafId", void 0), g(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = d(d(d({}, e), O), t), Object.assign(r, t.confettiSource);
                    }), g(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), g(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), g(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], b(e.prototype, n), r && b(e, r), t;
            }();
            function m(t) {
                return function(t) {
                    if (Array.isArray(t)) return C(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                }(t) || S(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(t) {
                return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function P() {
                return (P = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function j(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function M(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? j(Object(n), !0).forEach(function(e) {
                        T(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function I(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || S(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function S(t, e) {
                if (t) {
                    if ("string" == typeof t) return C(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? C(t, e) : void 0;
                }
            }
            function C(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function D(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function E(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _(t, e) {
                return (_ = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function R(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = F(t);
                    if (e) {
                        var i = F(this).constructor;
                        n = Reflect.construct(r, arguments, i);
                    } else n = r.apply(this, arguments);
                    return k(this, n);
                };
            }
            function k(t, e) {
                return !e || "object" !== x(e) && "function" != typeof e ? A(t) : e;
            }
            function A(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function F(t) {
                return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function T(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var B = a.a.createRef(), N = function(t) {
                !function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _(t, e);
                }(o, t);
                var e, n, r, i = R(o);
                function o(t) {
                    var e;
                    D(this, o);
                    for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)r[c - 1] = arguments[c];
                    return T(A(e = i.call.apply(i, [
                        this,
                        t
                    ].concat(r))), "canvas", a.a.createRef()), T(A(e), "confetti", void 0), e.canvas = t.canvasRef || B, e;
                }
                return e = o, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = q(this.props)[0];
                                this.confetti = new w(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            var t = q(this.props)[0];
                            this.confetti && (this.confetti.options = t);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = I(q(this.props), 2), e = t[0], n = t[1], r = M({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", P({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], E(e.prototype, n), r && E(e, r), o;
            }(o.Component);
            function q(t) {
                var e = {}, n = {}, r = [].concat(m(Object.keys(O)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            T(N, "defaultProps", M({}, O)), T(N, "displayName", "ReactConfetti");
            var Q = a.a.forwardRef(function(t, e) {
                return a.a.createElement(N, P({
                    canvasRef: e
                }, t));
            });
            e.default = Q;
        }
    ]).default;
});

},{"34009e003b690bf5":"IMRgT"}],"fNjuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ColorPickerAccordian);
var _jsxRuntime = require("react/jsx-runtime");
var _constants = require("../../../../../common/constants");
var _colorPicker = require("../color_picker");
var _seshAccordianComponent = require("../improved_components/sesh_accordian_component");
function ColorPickerAccordian(props) {
    const current_default = props.revert_descriptor?.default?.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianComponent.SeshAccordianComponent), {
        label: props.label,
        is_opened: props.color != undefined,
        onChange: (val)=>props.updateFunc(val ? current_default ?? (0, _constants.Constants).EMBED_COLOR : null),
        is_new: props.is_new,
        info: props.info,
        disabled: props.disabled,
        is_unsaved: props.unsaved_changes,
        is_channel_override_active: props.is_channel_override_active,
        revert_descriptor: props.revert_descriptor,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorPicker.ColorPickerForm), {
            updateFunc: (val)=>props.updateFunc(val),
            value: props.color
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../../common/constants":"lLiun","../color_picker":"2bL1a","../improved_components/sesh_accordian_component":"9ti9e","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3JtKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobile", ()=>useIsMobile);
var _react = require("react");
const useIsMobile = ()=>{
    const [isMobile, setIsMobile] = (0, _react.useState)(false);
    const handleResize = ()=>{
        const isMobileSize = window.innerWidth <= 768;
        setIsMobile(isMobileSize);
    };
    (0, _react.useEffect)(()=>{
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return isMobile;
};

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iYQUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PermissionsForm", ()=>PermissionsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchableDropdown = require("./searchable_dropdown");
var _lodash = require("lodash");
var _note = require("./improved_components/note");
var _infoTooltip = require("./improved_components/tooltips/info_tooltip");
const command_to_description = {
    create: "Create events (/create) and create time finder polls",
    poll: "Create polls (/poll)",
    ai: "Use sesh ai (/ai)",
    list: "List events (/list)",
    link: "Generate .ics feeds (/link)",
    delete: "Delete events (/delete)",
    remind: "Set personal reminders (/remind)",
    timestamp: "Generate Discord timestamps (/timestamp)",
    view_logs: "View logs",
    settings: "Manage sesh"
};
const info_descriptions = {
    settings: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "This permission allows users to modify sesh settings and edit/delete sesh events and polls, even if they did not create them.",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-bold",
                children: "This is a dangerous permission to grant."
            })
        ]
    })
};
class PermissionsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            permissions: (0, _lodash.cloneDeep)(this.props.initial_permissions)
        };
        this.handleChange = this.handleChange.bind(this);
    }
    renderCommand(command_permissions) {
        let initial_mentions = command_permissions.roles_ids.map((val)=>this.props.role_mentions.find((mentionable)=>mentionable.id === val));
        // make sure val exists
        let has_everyone = false;
        initial_mentions = initial_mentions.filter((val)=>{
            if (!has_everyone) has_everyone = val?.id === "@everyone";
            return Boolean(val);
        });
        const should_display_warning_note = has_everyone && initial_mentions.length > 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "pb-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex gap-2 pb-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: command_to_description[command_permissions.command]
                        }),
                        info_descriptions[command_permissions.command] && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltip.InfoTooltip), {
                            info: info_descriptions[command_permissions.command]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.SearchableDropdown), {
                        options: this.props.role_mentions.filter((val)=>val.id !== "@here"),
                        initial_mentions: initial_mentions,
                        handleChange: (event)=>this.handleChange(command_permissions.command, event),
                        placeholder: `Manage ${command_permissions.command === "settings" ? "server" : "sesh"} users only`,
                        ignore_invalid_permissions: true
                    })
                }),
                should_display_warning_note && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "error-note mt-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "has-text-weight-bold",
                                children: "@everyone"
                            }),
                            " ",
                            "will take precedence and all other roles will be ignored."
                        ]
                    })
                })
            ]
        }, command_permissions.command);
    }
    handleChange(command, mentionables) {
        let current_command = this.state.permissions.find((val)=>val.command === command);
        current_command.roles_ids = mentionables.map((val)=>val.id);
        this.setState({
            permissions: this.state.permissions
        });
    }
    renderAllCommands() {
        const all_elements = this.state.permissions.map((val)=>this.renderCommand(val));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: all_elements
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "title is-3 has-text-centered",
                    children: "Permissions"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _note.Note), {
                    children: [
                        "These permissions determine which roles can use which sesh features both in Discord and on the web interface. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " Note that you can also limit use of slash commands via",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "manual-link",
                            href: "https://support.discord.com/hc/en-us/articles/10952896421783",
                            children: "Discord integration settings"
                        }),
                        ", though modifiying integration permissions will not affect who can use the web interface."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "py-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: this.renderAllCommands()
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field submit-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "control columns is-mobile is-vcentered",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-narrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "button dashboard-primary-button is-size-4-tablet is-size-5-mobile",
                                onClick: ()=>{
                                    this.props.save_func(this.state.permissions);
                                },
                                children: "Save"
                            })
                        })
                    })
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./searchable_dropdown":"8iEAS","lodash":"fIO2m","./improved_components/note":"kkvHK","./improved_components/tooltips/info_tooltip":"93rAL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"etZ1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _prettyCheckbox = require("@djthoms/pretty-checkbox");
var _prettyCheckboxReact = require("pretty-checkbox-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dashboardUtils = require("../dashboard_utils");
var _eventCreation = require("../event_creation");
class SeshAccordian extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let locked = !this.props.is_server_premium && (0, _eventCreation.PremiumFeatures).includes(this.props.field_key);
        let opened = this.props.opened_initially;
        if (locked) opened = false;
        this.state = {
            opened: opened,
            locked: locked
        };
    }
    handleClick(event) {
        if (this.state.locked) return;
        let opened = event.target.checked;
        this.setState({
            opened: opened
        });
        if (!opened && this.props.onCheckboxUnclicked) this.props.onCheckboxUnclicked();
        if (this.props.updateFunc) this.props.updateFunc(this.props.field_key, opened);
    }
    renderChild() {
        if (this.props.loading) return (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(null, 1);
        if (this.state.opened) return this.props.render_child(this.props.field_key, this.props.initial_value);
    }
    renderUnopenedChild() {
        if (this.props.loading) return (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(null, 1);
        if (!this.state.opened) return this.props.disabled_element_func(this.props.field_key, this.props.initial_value);
    }
    render() {
        let outerClassName = "field";
        const checkbox = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: `checkbox-wrapper${this.props.should_hide_checkbox ? ` is-invisible` : ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyCheckboxReact.Checkbox), {
                className: "title-checkbox",
                name: "has_reminders",
                checked: this.state.opened,
                onChange: (e)=>this.handleClick(e),
                disabled: this.props.disabled
            }, this.props.label + this.state.opened)
        });
        if (this.state.opened) outerClassName += ` expanded-collapsible`;
        if (this.props.is_overridden) outerClassName += ` overridden-field`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: this.props.field_key,
            className: outerClassName,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(this.props.label, this.props.info, this.state.locked, this.props.is_beta, this.props.unsaved_changes, checkbox, this.props.disabled, this.props.is_new, !this.state.locked ? this.props.revert_descriptor : undefined),
                    this.props.note && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "note",
                        children: this.props.note
                    }),
                    this.props.render_child && this.state.opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: this.renderChild()
                    }),
                    this.props.disabled_element_func && !this.state.opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: this.renderUnopenedChild()
                    })
                ]
            })
        });
    }
}
exports.default = SeshAccordian;

},{"react/jsx-runtime":"dpQXr","@djthoms/pretty-checkbox":"wjmHZ","pretty-checkbox-react":"fcrko","react":"IMRgT","../dashboard_utils":"jvA8A","../event_creation":"a8uX3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"wjmHZ":[function() {},{}],"aJVZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimezonePickerForm", ()=>TimezonePickerForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _styleTzMapScss = require("../../../css/style_tz_map.scss");
require("1289a128221005b7");
class TimezonePickerForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            tz_string: this.props.current_timezone
        };
    }
    componentDidMount() {
        const initial_this = this;
        const props = this.props;
        function update_set_timezone_button(timezone, disabled) {
            let button_text;
            if (!disabled) button_text = `Set timezone to ${timezone}`;
            else button_text = `${timezone} already set as timezone`;
            (0, _jqueryDefault.default)(".set-timezone-button").prop("disabled", disabled);
            (0, _jqueryDefault.default)(".set-timezone-button").prop("innerHTML", button_text);
        //button.innerHTML = text;
        }
        this.wrappedEl = (0, _jqueryDefault.default)(this.el);
        let map_tz_string = null;
        const current_timezone = this.props.current_timezone;
        const secondary_timezones = this.props.secondary_timezones;
        let disabled = true;
        if (this.props.is_secondary) disabled = this.props.secondary_timezones.includes(current_timezone);
        update_set_timezone_button(current_timezone, disabled);
        this.wrappedEl.timezonePicker({
            hoverText: function(e, data) {
                return data.timezone + " (" + data.zonename + ")";
            },
            defaultValue: current_timezone,
            quickLink: [
                {
                    UTC: "UTC",
                    PST: "America/Los_Angeles",
                    MST: "America/Denver",
                    CST: "America/Chicago",
                    EST: "America/New_York",
                    UK: "Europe/London",
                    GMT: "Africa/Abidjan"
                }
            ]
        });
        const timezonePickerElement = this.wrappedEl;
        const changing_primary = !this.props.is_secondary;
        this.wrappedEl.on("map:value:changed", function() {
            map_tz_string = timezonePickerElement.data("timezonePicker").getValue()[0].timezone;
            let disabled = false;
            if (changing_primary) disabled = map_tz_string === current_timezone;
            initial_this.setState({
                tz_string: map_tz_string ?? props.current_timezone
            });
            disabled = disabled || secondary_timezones.includes(map_tz_string);
            update_set_timezone_button(map_tz_string, disabled);
        });
    }
    componentWillUnmount() {
    //this.wrappedEl.timezonePicker("destroy");
    }
    handleChange() {
        this.props.saveFunc(this.state.tz_string);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "hero",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "info-area has-text-centered",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "title is-3 result-text",
                            children: this.props.is_secondary ? "Click below to add a display timezone" : "Click below to set your server's timezone"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "is-size-5 secondary-text"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "timezone-picker column is-11 is-9-fullhd",
                        ref: (el)=>this.el = el
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile is-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full-mobile is-three-quarters-tablet is-5-desktop",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "columns is-mobile is-centered",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "set-timezone-button button dashboard-primary-button is-size-4-tablet is-size-5-mobile",
                                    onClick: ()=>this.handleChange(),
                                    children: "Set timezone"
                                })
                            })
                        })
                    })
                })
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","jquery":"jXSh5","1289a128221005b7":"e0bzM","../../../css/style_tz_map.scss":"bXCAK","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e0bzM":[function(require,module,exports,__globalThis) {
module.exports = import("dff0G").then(()=>module.bundle.root('wZJTf'));

},{}],"bXCAK":[function() {},{}],"fhFeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AISettingsPage", ()=>AISettingsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../dashboard_utils");
var _seshPrimaryButton = require("../../forms/improved_components/base_components/sesh_primary_button");
var _trpc = require("../../utils/trpc");
var _guildSettings = require("../guild_settings");
function AISettingsPage(props) {
    let { server_id } = (0, _reactRouter.useParams)();
    const existing_waitlist_query = (0, _trpc.trpc).waitlist.get.useQuery({
        guild_id: server_id
    });
    const { is_premium, is_admin } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    const context = (0, _trpc.trpc).useContext();
    const add_waitlist_mutation = (0, _trpc.trpc).waitlist.set.useMutation({
        onSuccess: (new_data)=>{
            context.waitlist.get.setData((data)=>{
                return new_data;
            }, {
                guild_id: server_id
            });
            (0, _dashboardUtils.DashboardUtils).ShowSuccessMessageAlert("Added to Waitlist", /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "Your server has been successfully added to the waitlist. You will be notified via DM when",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "sesh-text",
                        children: "sesh"
                    }),
                    " AI features are available for this server.",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    "You have also been granted access to the #ai-alpha channel in the sesh.fyi Discord server where you can give feedback and be the first to hear updates."
                ]
            }));
        }
    });
    if (!existing_waitlist_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber()
    });
    let body_element;
    // Server is still waiting on waitlist or not on waitlist yet
    if (!existing_waitlist_query.data?.is_active) {
        const is_on_waitlist = Boolean(existing_waitlist_query.data);
        let button_text;
        if (!is_premium) button_text = "Must have Premium";
        else if (!is_admin) button_text = "Must be Server Admin";
        else button_text = is_on_waitlist ? "Server Already on Waitlist" : "Join the Waitlist";
        body_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "note",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "sesh-text",
                            children: "sesh"
                        }),
                        " AI is currently in alpha. You can join the waitlist now to get a sneak peek for your server. The waitlist is currently only available to servers that have",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "manual-link",
                            onClick: props.onPremiumClicked,
                            children: "Premium"
                        }),
                        " ",
                        "activated.",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We're adding new servers from the waitlist every few days so signup now!"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                        className: "w-fit px-4",
                        disabled: is_on_waitlist || !is_premium || !is_admin,
                        onClick: ()=>add_waitlist_mutation.mutate({
                                guild_id: server_id
                            }),
                        is_loading: add_waitlist_mutation.isLoading,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-lg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-clipboard-list fa-lg"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: button_text
                                })
                            ]
                        })
                    })
                })
            ]
        });
    } else body_element = props.ai_toggler;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "title is-3 has-text-centered mt-6 font-bold",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: `fa-lg title-icon fas fa-robot`
                    }),
                    "AI Settings",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "tag alpha-tag ml-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "",
                            children: "Alpha"
                        })
                    })
                ]
            }),
            body_element
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../dashboard_utils":"jvA8A","../../forms/improved_components/base_components/sesh_primary_button":"3QyI2","../../utils/trpc":"dyYvM","../guild_settings":"gNnfh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7cgeG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../common/common_utils");
var _dashboardUtils = require("../../dashboard_utils");
var _trpc = require("../../utils/trpc");
var _guildSettings = require("../guild_settings");
var _authFooter = require("./auth_footer");
var _authFooterDefault = parcelHelpers.interopDefault(_authFooter);
var _guildSyncsSection = require("./guild_syncs_section");
var _linkAccount = require("./link_account/link_account");
var _linkAccountDefault = parcelHelpers.interopDefault(_linkAccount);
var _guildSyncsButton = require("./sync_overview/guild_syncs_button");
var _syncOverview = require("./sync_overview/sync_overview");
var _syncOverviewDefault = parcelHelpers.interopDefault(_syncOverview);
var _syncSetup = require("./sync_setup/sync_setup");
var _syncSetupDefault = parcelHelpers.interopDefault(_syncSetup);
var Mode = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Overview"] = 0] = "Overview";
    Mode[Mode["AdminOverview"] = 1] = "AdminOverview";
    Mode[Mode["Create"] = 2] = "Create";
    Mode[Mode["Edit"] = 3] = "Edit";
    return Mode;
}(Mode || {});
function SyncSettings() {
    const history = (0, _reactRouter.useHistory)();
    const URLSearchParams1 = useURLSearchParams();
    const { server_id } = (0, _reactRouter.useParams)();
    const getSyncsOrAuthURLQuery = (0, _trpc.trpc).gcal.getSyncsOrAuthURL.useQuery({
        guild_id: server_id
    });
    const { is_admin } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    if (getSyncsOrAuthURLQuery.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber()
    });
    if (!getSyncsOrAuthURLQuery.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "has-text-danger",
        children: "Error communicating with server"
    });
    // get state stored in URL search param, if any
    let modeFromUrl = null;
    let editSyncFromUrl;
    {
        const modeFromURLString = URLSearchParams1.get("action");
        const editSyncIdString = URLSearchParams1.get("editSync");
        const editSyncId = editSyncIdString && editSyncIdString.length > 0 ? Number(editSyncIdString) : null;
        if (modeFromURLString) {
            const typedModeFromUrlString = modeFromURLString;
            const rawModeFromUrl = Mode[typedModeFromUrlString];
            if (rawModeFromUrl === 3 && editSyncId !== null) {
                const rawEditSyncFromUrl = getSyncsOrAuthURLQuery.data.syncs.find((sync)=>sync.id === editSyncId);
                if (rawEditSyncFromUrl) {
                    modeFromUrl = 3;
                    editSyncFromUrl = rawEditSyncFromUrl;
                } else // go to overview if we can't find the sync to edit
                modeFromUrl = 0;
            } else modeFromUrl = rawModeFromUrl;
        }
    }
    const mode = modeFromUrl ?? 0;
    const state = {
        mode,
        editSync: editSyncFromUrl
    };
    const isLoggedIn = getSyncsOrAuthURLQuery.data.isLoggedIn;
    if (is_admin && state.mode === 1) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-full flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSyncsSection.GuildSyncsSection), {
                onBackClicked: ()=>history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync"))
            }),
            isLoggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authFooterDefault.default), {})
        ]
    });
    const noteSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "note",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-bold",
                children: "Heads up!"
            }),
            " This feature is in beta and we're still working out a few bugs. See the manual for a",
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "/manual#known-issues-and-limitations",
                className: "manual-link",
                children: "list of current known issues and limitations"
            }),
            "."
        ]
    });
    if (!isLoggedIn) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            noteSection,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkAccountDefault.default), {
                authUrl: getSyncsOrAuthURLQuery.data.authUrl,
                errorMessage: getSyncsOrAuthURLQuery.data.message,
                missingScopes: getSyncsOrAuthURLQuery.data.missingScopes
            }),
            is_admin && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSyncsButton.GuildSyncsButton), {
                onClick: ()=>history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync", {
                        action: Mode[1]
                    }))
            })
        ]
    });
    const hasAtLeastOneSync = getSyncsOrAuthURLQuery.data.syncs && getSyncsOrAuthURLQuery.data.syncs.length > 0;
    const shouldShowSyncSetup = !hasAtLeastOneSync || state.mode === 2 || state.mode === 3;
    if (shouldShowSyncSetup) {
        const onBackClicked = state.mode === 2 || state.mode === 3 ? ()=>{
            history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync"));
        } : undefined; // no back button on initial setup page
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex h-full flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncSetupDefault.default), {
                    onBackClicked: onBackClicked,
                    editSync: state.mode == 3 ? state.editSync : undefined
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authFooterDefault.default), {})
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-full flex-col gap-2",
        children: [
            noteSection,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncOverviewDefault.default), {
                onSetupNewSyncClicked: ()=>{
                    history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync", {
                        action: Mode[2]
                    }));
                },
                onEditClicked: (sync)=>{
                    history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync", {
                        action: Mode[3],
                        editSync: sync.id.toString()
                    }));
                }
            }),
            is_admin && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSyncsButton.GuildSyncsButton), {
                onClick: ()=>history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync", {
                        action: Mode[1]
                    }))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authFooterDefault.default), {})
        ]
    });
}
function useURLSearchParams() {
    const { search } = (0, _reactRouter.useLocation)();
    return (0, _react.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","../../../../../common/common_utils":"gACUC","../../dashboard_utils":"jvA8A","../../utils/trpc":"dyYvM","../guild_settings":"gNnfh","./auth_footer":"cLin6","./guild_syncs_section":"ecGwf","./link_account/link_account":"6jyRX","./sync_overview/guild_syncs_button":"54N13","./sync_overview/sync_overview":"7h0cu","./sync_setup/sync_setup":"9kQuz","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cLin6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _trpc = require("../../utils/trpc");
function AuthFooter() {
    const utils = (0, _trpc.trpc).useContext();
    const { server_id } = (0, _reactRouter.useParams)();
    const getSyncsOrAuthURLQuery = (0, _trpc.trpc).gcal.getSyncsOrAuthURL.useQuery({
        guild_id: server_id
    });
    const gcalRemoveAuthMutation = (0, _trpc.trpc).gcal.removeAuth.useMutation({
        onSuccess: ()=>{
            utils.gcal.getSyncsOrAuthURL.invalidate();
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-2 mt-auto has-text-right",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "grey-text",
                    children: [
                        "Connected Google Calendar account:",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "whitespace-nowrap",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " grey-text has-text-weight-bold",
                            children: getSyncsOrAuthURLQuery.data.email
                        }),
                        " ",
                        "(",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "secondary-link",
                            onClick: ()=>{
                                gcalRemoveAuthMutation.mutate();
                            },
                            children: "disconnect"
                        }),
                        ")"
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ecGwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildSyncsSection", ()=>GuildSyncsSection);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactSpinners = require("react-spinners");
var _constants = require("../../../../../common/constants");
var _timeFormatUtils = require("../../../../../common/time_format_utils");
var _dashboardUtils = require("../../dashboard_utils");
var _errorTooltip = require("../../forms/improved_components/tooltips/error_tooltip");
var _trpc = require("../../utils/trpc");
var _guildSettings = require("../guild_settings");
function GuildSyncsSection(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const guild_syncs_query = (0, _trpc.trpc).gcal.getGuildSyncs.useQuery({
        guild_id: server_id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "has-text-weight-bold is-size-5 mx-auto pt-4",
                children: "All Inbound Syncs"
            }),
            guild_syncs_query.isSuccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildSyncsList, {
                guild_syncs: guild_syncs_query.data
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
                    size: "2rem",
                    loading: true,
                    color: (0, _constants.Constants).EMBED_COLOR
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "#",
                className: "secondary-link flex items-center gap-2",
                onClick: ()=>props.onBackClicked(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-chevron-left"
                    }),
                    "Back"
                ]
            })
        ]
    });
}
function GuildSyncsList(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: "sesh-table listing-table w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "w-12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Sync Creator"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Channel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            children: "Last Sync"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "w-12"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: props.guild_syncs.length > 0 ? props.guild_syncs.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GuildSyncsListRow, {
                        sync: val
                    }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "has-text-centered",
                    colSpan: 5,
                    children: "None"
                })
            })
        ]
    });
}
function GuildSyncsListRow(props) {
    const { sync } = props;
    const utils = (0, _trpc.trpc).useContext();
    const { all_text_channels } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    const deleteSyncMutation = (0, _trpc.trpc).gcal.deleteSync.useMutation({
        onSuccess: ()=>{
            utils.gcal.getSyncsOrAuthURL.invalidate();
            utils.gcal.getGuildSyncs.invalidate();
        }
    });
    const channel_name = `#${all_text_channels.find((channel)=>sync.output_channel_id === channel.id)?.name ?? "unknown"}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                className: "has-text-centered",
                children: sync.error_code ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorTooltip.ErrorTooltip), {
                    info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full max-w-full rounded-sm text-sm",
                        children: [
                            "Status Code: ",
                            sync.error_code,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            sync.error_message
                        ]
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-check-circle success-text",
                    title: "Active"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                className: "truncate",
                title: sync.user.id,
                children: sync.user.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                className: "truncate",
                children: channel_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: (0, _timeFormatUtils.time_format_utils).format_relative_date_concise(_luxon.DateTime.fromJSDate(new Date(sync.last_synced_at_time)))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: (0, _classnamesDefault.default)("error-link mx-auto select-none border-none !bg-transparent p-1", {
                            "is-loading": deleteSyncMutation.isLoading
                        }),
                        onClick: ()=>{
                            (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Are you sure you want to delete this sync?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-sm font-bold",
                                        children: [
                                            "Author: ",
                                            sync.user.name,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Channel: ",
                                            channel_name
                                        ]
                                    })
                                ]
                            })).then((val)=>{
                                if (!val.isConfirmed) return;
                                deleteSyncMutation.mutate({
                                    sync_id: sync.id
                                });
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "far fa-trash-alt ml-auto"
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","react-router":"djWTS","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../../common/constants":"lLiun","../../../../../common/time_format_utils":"g0uQN","../../dashboard_utils":"jvA8A","../../forms/improved_components/tooltips/error_tooltip":"j9Mgc","../../utils/trpc":"dyYvM","../guild_settings":"gNnfh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6jyRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LinkAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _errorNote = require("../../../forms/improved_components/error_note");
var _signInWithGoogleButton = require("./sign_in_with_google_button");
var _signInWithGoogleButtonDefault = parcelHelpers.interopDefault(_signInWithGoogleButton);
function LinkAccount(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            props.errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
                error: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        props.errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-warning",
                            children: props.errorMessage
                        }),
                        props.missingScopes && props.missingScopes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "list-disc list-inside",
                            children: props.missingScopes.map((scope)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    children: scope.replace("https://www.googleapis.com/auth/", "")
                                }))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "note flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "has-text-centered",
                        children: [
                            "Link your Google account to allow",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "sesh-text",
                                children: "sesh"
                            }),
                            " to sync with Google Calendar"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signInWithGoogleButtonDefault.default), {
                        href: props.authUrl
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../../forms/improved_components/error_note":"kzA14","./sign_in_with_google_button":"lymm7","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lymm7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SignInWithGoogleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const btn_google_signin_dark_normal_web = new URL(require("645619e77dc8abf9"));
const btn_google_signin_dark_pressed_web = new URL(require("aa093ac72fa73401"));
function SignInWithGoogleButton(props) {
    const [isPressed, setIsPressed] = (0, _react.useState)(false);
    const imageUrl = isPressed ? btn_google_signin_dark_pressed_web : btn_google_signin_dark_normal_web;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: props.href,
        className: "mx-auto",
        onMouseDown: ()=>{
            setIsPressed(true);
        },
        onMouseUp: ()=>{
            setIsPressed(false);
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            className: "m-1",
            src: imageUrl
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","645619e77dc8abf9":"8YBVH","aa093ac72fa73401":"gQcqh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8YBVH":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6fIby");

},{}],"gQcqh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eAtAe");

},{}],"54N13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuildSyncsButton", ()=>GuildSyncsButton);
var _jsxRuntime = require("react/jsx-runtime");
var _modifySettingsButton = require("../../../forms/improved_components/base_components/modify_settings_button");
function GuildSyncsButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modifySettingsButton.ModifySettingsButton), {
        className: "mr-auto mt-4",
        onClick: props.onClick,
        children: "(Admin) Manage all server syncs"
    });
}

},{"react/jsx-runtime":"dpQXr","../../../forms/improved_components/base_components/modify_settings_button":"kbhTg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7h0cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncOverview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactSpinners = require("react-spinners");
var _constants = require("../../../../../../common/constants");
var _seshTypes = require("../../../../../../common/sesh_types");
var _trpc = require("../../../utils/trpc");
var _guildSettings = require("../../guild_settings");
var _linkAccount = require("../link_account/link_account");
var _linkAccountDefault = parcelHelpers.interopDefault(_linkAccount);
var _syncBox = require("./sync_box");
function SyncOverview(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const { is_premium } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    const getSyncsOrAuthURLQuery = (0, _trpc.trpc).gcal.getSyncsOrAuthURL.useQuery({
        guild_id: server_id
    });
    if (getSyncsOrAuthURLQuery.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
            size: "2rem",
            loading: true,
            color: (0, _constants.Constants).EMBED_COLOR
        })
    });
    if (!getSyncsOrAuthURLQuery.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "has-text-danger",
        children: "Error communicating with server"
    });
    const isLoggedIn = getSyncsOrAuthURLQuery.data.isLoggedIn;
    if (!isLoggedIn) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkAccountDefault.default), {
        authUrl: getSyncsOrAuthURLQuery.data.authUrl,
        errorMessage: getSyncsOrAuthURLQuery.data.message,
        missingScopes: getSyncsOrAuthURLQuery.data.missingScopes
    });
    const syncs = getSyncsOrAuthURLQuery.data.syncs;
    const inbound_sync_boxes = [];
    const outbound_sync_boxes = [];
    syncs.forEach((sync)=>{
        const sync_box = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncBox.SyncBox), {
            sync: sync,
            onEditClicked: props.onEditClicked,
            guild_id: server_id
        }, sync.id);
        switch(sync.sync_direction){
            case (0, _seshTypes.SyncDirection).Inbound:
                inbound_sync_boxes.push(sync_box);
                break;
            case (0, _seshTypes.SyncDirection).Outbound:
                outbound_sync_boxes.push(sync_box);
                break;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            outbound_sync_boxes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "has-text-weight-bold is-size-5",
                        children: [
                            "Outbound Syncs (",
                            outbound_sync_boxes.length,
                            "/",
                            (0, _constants.Constants).SYNC_LIMITS[(0, _seshTypes.SyncDirection).Outbound][is_premium ? "premium" : "standard"],
                            ")"
                        ]
                    }),
                    outbound_sync_boxes
                ]
            }),
            inbound_sync_boxes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "has-text-weight-bold is-size-5",
                        children: [
                            "Inbound Syncs (",
                            inbound_sync_boxes.length,
                            "/",
                            (0, _constants.Constants).SYNC_LIMITS[(0, _seshTypes.SyncDirection).Inbound][is_premium ? "premium" : "standard"],
                            ")"
                        ]
                    }),
                    inbound_sync_boxes
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-5 p-0 ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "button dashboard-primary-button gap-2",
                    onClick: ()=>{
                        props.onSetupNewSyncClicked();
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Setup a new sync"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "continue-chevron ml-auto self-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-chevron-right "
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../../../common/constants":"lLiun","../../../../../../common/sesh_types":"aUAOg","../../../utils/trpc":"dyYvM","../../guild_settings":"gNnfh","../link_account/link_account":"6jyRX","./sync_box":"eZoSl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eZoSl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncBox", ()=>SyncBox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactSpinners = require("react-spinners");
var _constants = require("../../../../../../common/constants");
var _seshTypes = require("../../../../../../common/sesh_types");
var _dashboardUtils = require("../../../dashboard_utils");
var _errorTooltip = require("../../../forms/improved_components/tooltips/error_tooltip");
var _trpc = require("../../../utils/trpc");
var _actionButton = require("./action_button");
var _actionButtonDefault = parcelHelpers.interopDefault(_actionButton);
var _channelTag = require("./channel_tag");
var _googleCalendarTag = require("./google_calendar_tag");
var _syncDirectionPreposition = require("./sync_direction_preposition");
var _syncInclusionTag = require("./sync_inclusion_tag");
function SyncBox(props) {
    const utils = (0, _trpc.trpc).useContext();
    const deleteSyncMutation = (0, _trpc.trpc).gcal.deleteSync.useMutation({
        onSuccess: ()=>{
            utils.gcal.getSyncsOrAuthURL.setData((data)=>{
                const isLoggedIn = data.isLoggedIn;
                if (!isLoggedIn) return data;
                return {
                    ...data,
                    syncs: data.syncs?.filter((val)=>val.id !== sync.id)
                };
            }, {
                guild_id: props.guild_id
            });
            utils.gcal.getSyncsOrAuthURL.invalidate();
        }
    });
    const { sync } = props;
    const actions = deleteSyncMutation.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {
        size: "1rem",
        loading: true,
        color: (0, _constants.Constants).EMBED_COLOR
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonDefault.default), {
                button_class: "manual-link",
                font_awesome_class: "fas fa-pencil-alt",
                action_verb: "Edit",
                on_click_func: ()=>{
                    props.onEditClicked(sync);
                },
                state: (0, _actionButton.ActionButtonState).Enabled,
                className: "ml-auto"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonDefault.default), {
                button_class: "error-link",
                font_awesome_class: "far fa-trash-alt",
                on_click_func: ()=>{
                    (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert("Are you sure you want to delete this sync?").then((val)=>{
                        if (!val.isConfirmed) return;
                        deleteSyncMutation.mutate({
                            sync_id: sync.id
                        });
                    });
                },
                action_verb: "Delete",
                state: (0, _actionButton.ActionButtonState).Enabled
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "sync-box flex min-w-0 max-w-full gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "white-text flex w-full min-w-0 items-center gap-2",
                children: [
                    sync.error_code && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorTooltip.ErrorTooltip), {
                        info: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex w-full max-w-full rounded-sm text-sm",
                            children: [
                                "Status Code: ",
                                sync.error_code,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                sync.error_message
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full min-w-0 max-w-full flex-col items-center gap-2 sm:flex-row",
                        children: [
                            sync.sync_direction === (0, _seshTypes.SyncDirection).Outbound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncInclusionTag.SyncInclusionTag), {
                                sync: sync
                            }),
                            sync.sync_direction === (0, _seshTypes.SyncDirection).Inbound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarTag.GoogleCalendarTag), {
                                sync: sync
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "self-center justify-self-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncDirectionPreposition.SyncDirectionPreposition), {
                                    sync: sync
                                })
                            }),
                            sync.sync_direction === (0, _seshTypes.SyncDirection).Outbound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarTag.GoogleCalendarTag), {
                                sync: sync
                            }),
                            sync.sync_direction === (0, _seshTypes.SyncDirection).Inbound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelTag.ChannelTag), {
                                id: sync.output_channel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col justify-center gap-4 sm:flex-row",
                children: actions
            })
        ]
    }, sync.id);
}

},{"react/jsx-runtime":"dpQXr","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../../../common/constants":"lLiun","../../../../../../common/sesh_types":"aUAOg","../../../dashboard_utils":"jvA8A","../../../forms/improved_components/tooltips/error_tooltip":"j9Mgc","../../../utils/trpc":"dyYvM","./action_button":"8Cpit","./channel_tag":"6wA3j","./google_calendar_tag":"hBUr4","./sync_direction_preposition":"gX734","./sync_inclusion_tag":"ikX3o","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8Cpit":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionButtonState", ()=>ActionButtonState);
parcelHelpers.export(exports, "default", ()=>ActionButton);
var _jsxRuntime = require("react/jsx-runtime");
var ActionButtonState = /*#__PURE__*/ function(ActionButtonState) {
    ActionButtonState[ActionButtonState["Enabled"] = 0] = "Enabled";
    ActionButtonState[ActionButtonState["DisabledNoPerms"] = 1] = "DisabledNoPerms";
    ActionButtonState[ActionButtonState["DisabledInPast"] = 2] = "DisabledInPast";
    return ActionButtonState;
}({});
function ActionButton(props) {
    let title;
    switch(props.state){
        case 0:
            title = props.action_verb;
            break;
        case 2:
            title = `Can not ${props.action_verb.toLowerCase()} event that has already started`;
            break;
        case 1:
            title = `Invalid permissions to ${props.action_verb.toLowerCase()}`;
            break;
    }
    let className;
    let current_click_func;
    switch(props.state){
        case 0:
            className = props.button_class;
            if (props.on_click_func) current_click_func = ()=>props.on_click_func();
            break;
        case 2:
        case 1:
            className = "action-icon-disabled";
            break;
    }
    if (props.hyperlink) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            className: className,
            "data-tip": title,
            href: props.hyperlink,
            target: "_blank",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: props.font_awesome_class
            })
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: className,
            onClick: current_click_func,
            "data-tip": title,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: props.font_awesome_class
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6wA3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelTag", ()=>ChannelTag);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _guildSettings = require("../../guild_settings");
function ChannelTag(props) {
    const { all_text_channels } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    const name = "name" in props ? props.name : "id" in props ? all_text_channels.find((channel)=>channel.id === props.id)?.name : "Error";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "tag tag-dark-gray gap-2 sm:max-w-[45%] max-w-full min-w-0",
        title: `sesh - #${name}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sesh-text",
                children: "sesh"
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "has-text-weight-bold truncate",
                children: [
                    "#",
                    name
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../guild_settings":"gNnfh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hBUr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleCalendarTag", ()=>GoogleCalendarTag);
var _jsxRuntime = require("react/jsx-runtime");
var _googleCalendarLogo = require("../components/google_calendar_logo");
var _googleCalendarLogoDefault = parcelHelpers.interopDefault(_googleCalendarLogo);
function GoogleCalendarTag(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "tag tag-dark-gray min-w-0 max-w-full gap-2 sm:max-w-[45%]",
        title: `GCal - ${props.sync.gcal_name}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarLogoDefault.default), {
                isDim: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold min-w-0 truncate",
                children: props.sync.gcal_name
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../components/google_calendar_logo":"eiefW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eiefW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GoogleCalendarLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function GoogleCalendarLogo(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("flex items-center gap-1", {
            "grey-text": props.isDim
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fab fa-google"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Cal"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gX734":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncDirectionPreposition", ()=>SyncDirectionPreposition);
var _jsxRuntime = require("react/jsx-runtime");
var _seshTypes = require("../../../../../../common/sesh_types");
function SyncDirectionPreposition(props) {
    switch(props.sync.sync_direction){
        case (0, _seshTypes.SyncDirection).Outbound:
        case (0, _seshTypes.SyncDirection).Inbound:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "to"
            });
    }
}

},{"react/jsx-runtime":"dpQXr","../../../../../../common/sesh_types":"aUAOg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ikX3o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncInclusionTag", ()=>SyncInclusionTag);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _seshTypes = require("../../../../../../common/sesh_types");
var _guildSettings = require("../../guild_settings");
function SyncInclusionTag(props) {
    const { all_text_channels } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    return props.sync.included_sesh_events === (0, _seshTypes.SyncInclusionType).All ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SyncTagLabel, {
        label: "all events"
    }) : props.sync.included_sesh_events === (0, _seshTypes.SyncInclusionType).Channel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SyncTagLabel, {
        label: `#${all_text_channels.find((channel)=>channel.id === props.sync.included_channel)?.name}`
    }) : props.sync.included_sesh_events === (0, _seshTypes.SyncInclusionType).RSVP ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SyncTagLabel, {
        label: "RSVP'd events"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}
function SyncTagLabel(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "tag tag-dark-gray max-w-full flex-shrink flex-grow-0 gap-2 sm:max-w-[45%]",
        title: `sesh - ${props.label}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sesh-text",
                children: "sesh"
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "has-text-weight-bold truncate",
                children: props.label
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../../../common/sesh_types":"aUAOg","../../guild_settings":"gNnfh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9kQuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncSetup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _syncDetails = require("./sync_details/sync_details");
var _syncDetailsDefault = parcelHelpers.interopDefault(_syncDetails);
var _syncDirectionSelection = require("./sync_direction_selection/sync_direction_selection");
var _syncDirectionSelectionDefault = parcelHelpers.interopDefault(_syncDirectionSelection);
function SyncSetup(props) {
    const [selectedSyncDirection, setSelectedSyncDirection] = (0, _react.useState)(props.editSync ? props.editSync.sync_direction : null);
    const hasSelectedSyncDirection = selectedSyncDirection !== null;
    const content = hasSelectedSyncDirection ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncDetailsDefault.default), {
        onBackClicked: ()=>setSelectedSyncDirection(null),
        selectedSyncDirection: selectedSyncDirection,
        editSync: props.editSync
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncDirectionSelectionDefault.default), {
        onSelected: (selectedSyncDirection)=>{
            setSelectedSyncDirection(selectedSyncDirection);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            content,
            props.onBackClicked && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "#",
                className: "secondary-link flex gap-2 items-center",
                onClick: ()=>props.onBackClicked(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-chevron-left"
                    }),
                    "Back"
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./sync_details/sync_details":"d3DTm","./sync_direction_selection/sync_direction_selection":"3QH2G","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"d3DTm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../../common/common_utils");
var _seshTypes = require("../../../../../../../common/sesh_types");
var _dashboardUtils = require("../../../../dashboard_utils");
var _trpc = require("../../../../utils/trpc");
var _guildSettingsChannelPicker = require("./guild_settings_channel_picker");
var _guildSettingsChannelPickerDefault = parcelHelpers.interopDefault(_guildSettingsChannelPicker);
var _googleCalendarPicker = require("./google_calendar_picker");
var _googleCalendarPickerDefault = parcelHelpers.interopDefault(_googleCalendarPicker);
var _includedSeshEventsDropdown = require("./included_sesh_events_dropdown");
var _includedSeshEventsDropdownDefault = parcelHelpers.interopDefault(_includedSeshEventsDropdown);
function SyncDetails(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const utils = (0, _trpc.trpc).useContext();
    const history = (0, _reactRouter.useHistory)();
    const onSuccess = async ()=>{
        await utils.gcal.getSyncsOrAuthURL.invalidate();
        history.push((0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "sync"));
    };
    const createSyncMutation = (0, _trpc.trpc).gcal.createSync.useMutation({
        onSuccess,
        onError: (e)=>{
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(e.message ?? "Error");
        }
    });
    const editSyncMutation = (0, _trpc.trpc).gcal.editSync.useMutation({
        onSuccess,
        onError: (e)=>{
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(e.message ?? "Error");
        }
    });
    const [included_sesh_events, set_included_sesh_events] = (0, _react.useState)(props.editSync?.included_sesh_events ?? (0, _seshTypes.SyncInclusionType).All);
    const [included_channel, set_included_channel] = (0, _react.useState)(props.editSync?.included_channel);
    const [include_existing_events, set_include_existing_events] = (0, _react.useState)(true);
    const [gcal_id, set_gcal_id] = (0, _react.useState)(props.editSync?.gcal_id);
    const [gcal_name, set_gcal_name] = (0, _react.useState)(props.editSync?.gcal_name);
    const [new_gcal_name, set_new_gcal_name] = (0, _react.useState)(null);
    const [output_channel, set_output_channel] = (0, _react.useState)(props.editSync?.output_channel);
    const [use_events_channel_as_output_channel, set_use_events_channel_as_output_channel] = (0, _react.useState)(props.editSync?.use_events_channel_as_output_channel);
    function baseIsConfigurationValid() {
        switch(props.selectedSyncDirection){
            case (0, _seshTypes.SyncDirection).Outbound:
                return (included_sesh_events !== null || included_sesh_events !== undefined) && (included_sesh_events !== (0, _seshTypes.SyncInclusionType).Channel || included_channel !== null && included_channel !== undefined) && gcal_id !== null && gcal_id !== undefined;
            case (0, _seshTypes.SyncDirection).Inbound:
                return gcal_id !== null && gcal_id !== undefined && output_channel !== null && output_channel !== undefined;
            case (0, _seshTypes.SyncDirection).Bidirectional:
                return (included_sesh_events !== null || included_sesh_events !== undefined) && (included_sesh_events !== (0, _seshTypes.SyncInclusionType).Channel || included_channel !== null && included_channel !== undefined) && gcal_id !== null && gcal_id !== undefined && output_channel !== null && output_channel !== undefined;
        }
    }
    function isConfigurationValid() {
        const isBaseValid = baseIsConfigurationValid();
        if (!isBaseValid) return false;
        if (!props.editSync) return isBaseValid;
        switch(props.selectedSyncDirection){
            case (0, _seshTypes.SyncDirection).Outbound:
                return included_sesh_events !== props.editSync.included_sesh_events || included_channel !== props.editSync.included_channel || gcal_id !== props.editSync.gcal_id;
            case (0, _seshTypes.SyncDirection).Inbound:
                return gcal_id !== props.editSync.gcal_id || output_channel !== props.editSync.output_channel;
            case (0, _seshTypes.SyncDirection).Bidirectional:
                return included_sesh_events !== props.editSync.included_sesh_events || included_channel !== props.editSync.included_channel || gcal_id !== props.editSync.gcal_id || output_channel !== props.editSync.output_channel;
        }
    }
    let settings;
    switch(props.selectedSyncDirection){
        case (0, _seshTypes.SyncDirection).Outbound:
            settings = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _includedSeshEventsDropdownDefault.default), {
                        included_sesh_events: included_sesh_events,
                        set_included_sesh_events: set_included_sesh_events,
                        included_channel: included_channel,
                        set_included_channel: set_included_channel,
                        hasUnsavedChanges: props.editSync && (props.editSync.included_sesh_events !== included_sesh_events || props.editSync.included_channel !== included_channel),
                        include_existing_events: !props.editSync ? include_existing_events : undefined,
                        set_include_existing_events: !props.editSync ? set_include_existing_events : undefined
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarPickerDefault.default), {
                        syncType: props.selectedSyncDirection,
                        gcal_id: gcal_id,
                        set_gcal_id: set_gcal_id,
                        set_gcal_name: set_gcal_name,
                        hasUnsavedChanges: props.editSync && props.editSync.gcal_id !== gcal_id
                    })
                ]
            });
            break;
        case (0, _seshTypes.SyncDirection).Inbound:
            settings = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarPickerDefault.default), {
                        syncType: props.selectedSyncDirection,
                        gcal_id: gcal_id,
                        set_gcal_id: set_gcal_id,
                        set_gcal_name: set_gcal_name,
                        hasUnsavedChanges: props.editSync && props.editSync.gcal_id !== gcal_id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSettingsChannelPickerDefault.default), {
                        channel: output_channel,
                        set_channel: set_output_channel,
                        name: "Select output channel",
                        description: "Events created in Google Calendar will be sent to this channel",
                        hasUnsavedChanges: props.editSync && props.editSync.output_channel !== output_channel,
                        requiredPermission: (0, _guildSettingsChannelPicker.RequiredPermission).Write
                    })
                ]
            });
            break;
        case (0, _seshTypes.SyncDirection).Bidirectional:
            settings = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _includedSeshEventsDropdownDefault.default), {
                        included_sesh_events: included_sesh_events,
                        set_included_sesh_events: set_included_sesh_events,
                        included_channel: included_channel,
                        set_included_channel: set_included_channel,
                        hasUnsavedChanges: props.editSync && (props.editSync.included_sesh_events !== included_sesh_events || props.editSync.included_channel !== included_channel),
                        include_existing_events: !props.editSync ? include_existing_events : undefined,
                        set_include_existing_events: !props.editSync ? set_include_existing_events : undefined
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarPickerDefault.default), {
                        syncType: props.selectedSyncDirection,
                        gcal_id: gcal_id,
                        set_gcal_id: set_gcal_id,
                        set_gcal_name: set_gcal_name,
                        hasUnsavedChanges: props.editSync && props.editSync.gcal_id !== gcal_id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSettingsChannelPickerDefault.default), {
                        channel: output_channel,
                        set_channel: set_output_channel,
                        name: "Select output channel",
                        description: "Events created in Google Calendar will be sent to this channel",
                        hasUnsavedChanges: props.editSync && props.editSync.output_channel !== output_channel,
                        requiredPermission: (0, _guildSettingsChannelPicker.RequiredPermission).Write
                    })
                ]
            });
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                className: "is-size-5 has-text-weight-bold has-text-centered",
                children: [
                    (0, _seshTypes.syncDirectionToName)(props.selectedSyncDirection),
                    " sync",
                    " ",
                    props.editSync ? "settings" : "setup"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    settings,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: (0, _classnamesDefault.default)("dashboard-primary-button button", {
                            "is-loading": editSyncMutation.isLoading || createSyncMutation.isLoading
                        }),
                        disabled: !isConfigurationValid(),
                        onClick: ()=>{
                            if (!isConfigurationValid()) return;
                            if (props.editSync) editSyncMutation.mutate({
                                id: props.editSync.id,
                                data: {
                                    included_sesh_events,
                                    included_channel,
                                    gcal_id,
                                    gcal_name,
                                    output_channel,
                                    use_events_channel_as_output_channel
                                }
                            });
                            else createSyncMutation.mutate({
                                guild_id: server_id,
                                syncDirection: props.selectedSyncDirection,
                                included_sesh_events,
                                included_channel,
                                include_existing_events,
                                gcal_id,
                                gcal_name,
                                output_channel,
                                use_events_channel_as_output_channel
                            });
                        },
                        children: props.editSync ? "Save changes" : "Finish sync setup"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router":"djWTS","../../../../../../../common/common_utils":"gACUC","../../../../../../../common/sesh_types":"aUAOg","../../../../dashboard_utils":"jvA8A","../../../../utils/trpc":"dyYvM","./guild_settings_channel_picker":"kXdTe","./google_calendar_picker":"1D27s","./included_sesh_events_dropdown":"1ZqL2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kXdTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequiredPermission", ()=>RequiredPermission);
parcelHelpers.export(exports, "default", ()=>GuildSettingsChannelPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _channelDropdown = require("../../../../forms/channel_dropdown");
var _guildSettings = require("../../../guild_settings");
var RequiredPermission = /*#__PURE__*/ function(RequiredPermission) {
    RequiredPermission[RequiredPermission["Read"] = 0] = "Read";
    RequiredPermission[RequiredPermission["Write"] = 1] = "Write";
    return RequiredPermission;
}({});
function GuildSettingsChannelPicker(props) {
    const { all_text_channels, original_guild_settings, is_admin } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    const { event_channel, event_channel_override_only_admins, event_channel_require_send_messages } = original_guild_settings;
    let filteredChannels;
    switch(props.requiredPermission){
        case 0:
            // all_text_channels is already filtered to channels with read permissions
            filteredChannels = all_text_channels;
            break;
        case 1:
            filteredChannels = all_text_channels.filter((channel)=>{
                if (event_channel && event_channel_override_only_admins && !is_admin) return channel.id === event_channel.id && (!event_channel_require_send_messages || event_channel.has_write);
                return channel.has_write;
            });
            break;
    }
    if (filteredChannels.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "error-text",
        children: "Error: Couldn't find channels. Check that you have Read messages or Send messages permissions."
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdown.ChannelSelectForm), {
        name: props.name,
        info: props.description,
        initial_value: props.channel ? filteredChannels.find((channel)=>{
            return channel.id === props.channel;
        }) : event_channel ? filteredChannels.find((channel)=>{
            return channel.id === event_channel.id;
        }) : null,
        update_initially: true,
        channel_data: filteredChannels,
        disabled: false,
        updateFunc: (val)=>{
            props.set_channel(val.id);
        },
        include_threads: false,
        has_unsaved_changes: props.hasUnsavedChanges
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../../forms/channel_dropdown":"eUzk8","../../../guild_settings":"gNnfh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1D27s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GoogleCalendarPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _seshTypes = require("../../../../../../../common/sesh_types");
var _dashboardUtils = require("../../../../dashboard_utils");
var _trpc = require("../../../../utils/trpc");
function GoogleCalendarPicker(props) {
    const { server_id } = (0, _reactRouter.useParams)();
    const [selectedCalendar, setSelectedCalendar] = (0, _react.useState)(null);
    const [shouldShowEnterNamePrompt, setShouldShowEnterNamePrompt] = (0, _react.useState)(false);
    const selectRef = (0, _react.useRef)(null);
    const calendarListQuery = (0, _trpc.trpc).gcal.calendarList.useQuery({
        guildId: server_id,
        minAccessRole: props.syncType === (0, _seshTypes.SyncDirection).Inbound ? "reader" : "writer"
    }, {
        onSuccess: (data)=>{
            const calendars = data;
            const initialCalendar = props.gcal_id ? calendars.find((calendar)=>{
                return calendar.id === props.gcal_id;
            }) : null;
            if (initialCalendar) setSelectedCalendar({
                value: initialCalendar.id,
                label: initialCalendar.summary
            });
        }
    });
    const createCalendarMutation = (0, _trpc.trpc).gcal.createCalendar.useMutation();
    let directionText;
    let tipText;
    switch(props.syncType){
        case (0, _seshTypes.SyncDirection).Outbound:
            directionText = "Target";
            tipText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "Which Google Calendar to send events to"
            });
            break;
        case (0, _seshTypes.SyncDirection).Inbound:
            directionText = "Source";
            tipText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "Which Google Calendar to sync with"
            });
            break;
        case (0, _seshTypes.SyncDirection).Bidirectional:
            directionText = "Target/source";
            tipText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: "Which Google Calendar to sync with"
            });
            break;
    }
    const header = (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(`${directionText} Google Calendar`, tipText, false, false, props.hasUnsavedChanges);
    if (calendarListQuery.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            header,
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                classNamePrefix: "sesh-dropdown",
                isLoading: true,
                loadingMessage: ()=>"Loading from Google Calendar..."
            })
        ]
    });
    if (!calendarListQuery.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: "has-text-danger",
        children: [
            "Error fetching Google Calendars (",
            calendarListQuery.error.message,
            ")"
        ]
    });
    const hasSuccessfullyCreatedNewCalendar = createCalendarMutation.isSuccess && createCalendarMutation.data.status === 200;
    const shouldAddCalendarFromCreateMutationToList = hasSuccessfullyCreatedNewCalendar && !calendarListQuery.data.find((calendar)=>calendar.id === createCalendarMutation.data.data.id);
    const calendars = shouldAddCalendarFromCreateMutationToList ? [
        ...calendarListQuery.data,
        createCalendarMutation.data.data
    ] : calendarListQuery.data;
    const options = [
        ...calendars.map((calendar)=>{
            return {
                value: calendar.id,
                label: calendar.summary
            };
        }),
        {
            value: "new",
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "italic",
                children: "Create new Google Calendar"
            })
        }
    ];
    const handleCreate = (inputValue)=>{
        props.set_gcal_id(null);
        props.set_gcal_name(null);
        setSelectedCalendar(null);
        createCalendarMutation.mutate({
            gcal_name: inputValue,
            guild_id: server_id
        }, {
            onSuccess: (data)=>{
                if (data.status !== 200) {
                    console.log("Google Calendar API error", data);
                    return; // TODO: handle error
                }
                const calendar = data.data;
                props.set_gcal_id(calendar.id);
                props.set_gcal_name(calendar.summary);
                setSelectedCalendar({
                    value: calendar.id,
                    label: calendar.summary
                });
                setShouldShowEnterNamePrompt(false);
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            header,
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                ref: selectRef,
                classNamePrefix: "sesh-dropdown",
                options: options,
                value: selectedCalendar,
                isDisabled: createCalendarMutation.isLoading,
                isLoading: createCalendarMutation.isLoading,
                onChange: (newValue)=>{
                    if (newValue.value == "new") {
                        // hack to set focus properly
                        // https://github.com/JedWatson/react-select/issues/3871#issuecomment-757648697
                        selectRef.current?.blur();
                        selectRef.current?.focus();
                        props.set_gcal_id(null);
                        props.set_gcal_name(null);
                        setShouldShowEnterNamePrompt(true);
                        setSelectedCalendar(null);
                    } else {
                        props.set_gcal_id(newValue.value);
                        props.set_gcal_name(newValue.label);
                        setSelectedCalendar(newValue);
                        setShouldShowEnterNamePrompt(false);
                    }
                },
                formatCreateLabel: (inputValue)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "!italic",
                        children: [
                            'Create new Google Calendar named "',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "!font-bold",
                                children: inputValue
                            }),
                            '"'
                        ]
                    });
                },
                onBlur: ()=>{
                    if (shouldShowEnterNamePrompt) setShouldShowEnterNamePrompt(false);
                },
                onCreateOption: handleCreate,
                placeholder: createCalendarMutation.isLoading ? "Creating new Google Calendar..." : shouldShowEnterNamePrompt ? "Enter name for new Google Calendar..." : "Select..."
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","react-select/creatable":"iiR0X","../../../../../../../common/sesh_types":"aUAOg","../../../../dashboard_utils":"jvA8A","../../../../utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1ZqL2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IncludedSeshEventsDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _prettyCheckboxReact = require("pretty-checkbox-react");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _seshTypes = require("../../../../../../../common/sesh_types");
var _dashboardUtils = require("../../../../dashboard_utils");
var _trpc = require("../../../../utils/trpc");
var _guildSettingsChannelPicker = require("./guild_settings_channel_picker");
var _guildSettingsChannelPickerDefault = parcelHelpers.interopDefault(_guildSettingsChannelPicker);
function IncludedSeshEventsDropdown(props) {
    let { server_id } = (0, _reactRouter.useParams)();
    const header = (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "Select which ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sesh-text",
                children: "sesh"
            }),
            " events to include"
        ]
    }), "Choose which events will be sent to Google Calendar", false, false, props.hasUnsavedChanges);
    const optionsByType = {
        [(0, _seshTypes.SyncInclusionType).All]: {
            value: (0, _seshTypes.SyncInclusionType).All,
            label: "All"
        },
        [(0, _seshTypes.SyncInclusionType).Channel]: {
            value: (0, _seshTypes.SyncInclusionType).Channel,
            label: "Channel"
        },
        [(0, _seshTypes.SyncInclusionType).RSVP]: {
            value: (0, _seshTypes.SyncInclusionType).RSVP,
            label: "My RSVPed events"
        }
    };
    const options = [
        optionsByType[(0, _seshTypes.SyncInclusionType).All],
        optionsByType[(0, _seshTypes.SyncInclusionType).Channel],
        optionsByType[(0, _seshTypes.SyncInclusionType).RSVP]
    ];
    const [selectedType, setSelectedType] = (0, _react.useState)(props.included_sesh_events !== null && props.included_sesh_events !== undefined ? optionsByType[props.included_sesh_events] : optionsByType[(0, _seshTypes.SyncInclusionType).All]);
    const previewEventCountQuery = (0, _trpc.trpc).gcal.previewEventCount.useQuery({
        guild_id: server_id,
        included_sesh_events: props.included_sesh_events,
        included_channel: props.included_channel
    }, {
        enabled: props.included_sesh_events !== (0, _seshTypes.SyncInclusionType).Channel || Boolean(props.included_channel)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            header,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        isSearchable: false,
                        classNamePrefix: "sesh-dropdown",
                        //filterOption={filterOptions}
                        options: options,
                        value: selectedType,
                        onChange: (newValue)=>{
                            props.set_included_sesh_events(newValue.value);
                            if (newValue.value !== (0, _seshTypes.SyncInclusionType).Channel && props.included_channel) props.set_included_channel(null);
                            setSelectedType(newValue);
                        }
                    }),
                    props.included_sesh_events === (0, _seshTypes.SyncInclusionType).Channel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guildSettingsChannelPickerDefault.default), {
                        channel: props.included_channel,
                        set_channel: props.set_included_channel,
                        requiredPermission: (0, _guildSettingsChannelPicker.RequiredPermission).Read
                    }),
                    props.set_include_existing_events && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "checkbox-wrapper flex cursor-pointer items-center gap-2",
                        onClick: ()=>{
                            props.set_include_existing_events(!props.include_existing_events);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyCheckboxReact.Checkbox), {
                                className: "title-checkbox",
                                name: "include_existing_events",
                                checked: props.include_existing_events,
                                onChange: ()=>{
                                    props.set_include_existing_events(!props.include_existing_events);
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    "Include existing events",
                                    " ",
                                    previewEventCountQuery.isSuccess ? `(${previewEventCountQuery.data})` : ""
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","pretty-checkbox-react":"fcrko","react":"IMRgT","react-router":"djWTS","react-select":"8FQ4W","../../../../../../../common/sesh_types":"aUAOg","../../../../dashboard_utils":"jvA8A","../../../../utils/trpc":"dyYvM","./guild_settings_channel_picker":"kXdTe","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3QH2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncDirectionSelection);
var _jsxRuntime = require("react/jsx-runtime");
var _seshTypes = require("../../../../../../../common/sesh_types");
var _syncTypeBox = require("./sync_type_box");
var _syncTypeBoxDefault = parcelHelpers.interopDefault(_syncTypeBox);
function SyncDirectionSelection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "has-text-weight-bold is-size-5",
                children: "Choose sync direction"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncTypeBoxDefault.default), {
                        syncType: (0, _seshTypes.SyncDirection).Outbound,
                        onSelect: ()=>{
                            props.onSelected((0, _seshTypes.SyncDirection).Outbound);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncTypeBoxDefault.default), {
                        syncType: (0, _seshTypes.SyncDirection).Inbound,
                        onSelect: ()=>{
                            props.onSelected((0, _seshTypes.SyncDirection).Inbound);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncTypeBoxDefault.default), {
                        syncType: (0, _seshTypes.SyncDirection).Bidirectional,
                        onSelect: ()=>{
                            props.onSelected((0, _seshTypes.SyncDirection).Bidirectional);
                        }
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","../../../../../../../common/sesh_types":"aUAOg","./sync_type_box":"85YHw","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"85YHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncTypeBox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactSpinners = require("react-spinners");
var _commonUtils = require("../../../../../../../common/common_utils");
var _seshTypes = require("../../../../../../../common/sesh_types");
var _syncUtils = require("../../../../../../../common/sync_utils");
var _errorNote = require("../../../../forms/improved_components/error_note");
var _selectableBox = require("../../../../forms/improved_components/selectable_box");
var _trpc = require("../../../../utils/trpc");
var _guildSettings = require("../../../guild_settings");
var _syncTypeTag = require("./sync_type_tag");
var _syncTypeTagDefault = parcelHelpers.interopDefault(_syncTypeTag);
function SyncTypeBox(props) {
    const name = (0, _seshTypes.syncDirectionToName)(props.syncType);
    const description = syncTypeToDescription(props.syncType);
    const { server_id } = (0, _reactRouter.useParams)();
    const getSyncsOrAuthURLQuery = (0, _trpc.trpc).gcal.getSyncsOrAuthURL.useQuery({
        guild_id: server_id
    }, {
        staleTime: 86400000
    });
    const { is_premium } = (0, _react.useContext)((0, _guildSettings.GuildSettingsContext));
    let icon;
    let disabled = false;
    if (getSyncsOrAuthURLQuery.isSuccess) {
        if (!getSyncsOrAuthURLQuery.data.isLoggedIn) {
            disabled = true;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorNote.ErrorNote), {
                error: "Not logged in"
            });
        }
        if ((0, _syncUtils.sync_utils).isSyncLimitReached(getSyncsOrAuthURLQuery.data.syncs, props.syncType, is_premium)) {
            disabled = true;
            if (is_premium) icon = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-lock"
                    }),
                    " Limit reached"
                ]
            });
            else icon = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "text-right",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-lock"
                    }),
                    " Free Limit reached",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-right",
                        children: [
                            "Get",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: (0, _commonUtils.common_utils).getGuildSettingsURL(server_id, "premium"),
                                className: "manual-link",
                                children: "Premium"
                            })
                        ]
                    })
                ]
            });
        } else icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-chevron-right "
        });
    } else {
        disabled = true;
        icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSpinners.ClipLoader), {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectableBox.SelectableBox), {
        onClick: props.onSelect,
        disabled: disabled,
        bgColor: "semidark",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col text-content-primary-darker",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "has-text-weight-bold white-text",
                                children: name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _syncTypeTagDefault.default), {
                                syncType: props.syncType
                            })
                        ]
                    }),
                    description
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto self-center text-content-primary",
                children: icon
            })
        ]
    });
}
function syncTypeToDescription(syncType) {
    switch(syncType){
        case (0, _seshTypes.SyncDirection).Outbound:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Export events to Google Calendar in realtime"
            });
        case (0, _seshTypes.SyncDirection).Inbound:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Import events from Google Calendar in realtime"
                })
            });
        case (0, _seshTypes.SyncDirection).Bidirectional:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Sync in both directions in realtime"
                })
            });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router":"djWTS","react-spinners":[["ClipLoader","9a5oM","default"]],"../../../../../../../common/common_utils":"gACUC","../../../../../../../common/sesh_types":"aUAOg","../../../../../../../common/sync_utils":"1q3yj","../../../../forms/improved_components/error_note":"kzA14","../../../../forms/improved_components/selectable_box":"aVlDe","../../../../utils/trpc":"dyYvM","../../../guild_settings":"gNnfh","./sync_type_tag":"lDoca","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1q3yj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sync_utils", ()=>sync_utils);
var _constants = require("./constants");
var _seshTypes = require("./sesh_types");
(function(sync_utils) {
    function isSyncLimitReached(syncs, sync_direction, is_premium) {
        if (sync_direction === (0, _seshTypes.SyncDirection).Bidirectional) return isSyncLimitReached(syncs, (0, _seshTypes.SyncDirection).Inbound, is_premium) || isSyncLimitReached(syncs, (0, _seshTypes.SyncDirection).Outbound, is_premium);
        const amount = syncs.filter((val)=>val.sync_direction === sync_direction).length;
        return amount >= (0, _constants.Constants).SYNC_LIMITS[sync_direction][is_premium ? "premium" : "standard"];
    }
    sync_utils.isSyncLimitReached = isSyncLimitReached;
})(sync_utils || (sync_utils = {}));
var sync_utils;

},{"./constants":"lLiun","./sesh_types":"aUAOg","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lDoca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SyncTypeTag);
var _jsxRuntime = require("react/jsx-runtime");
var _seshTypes = require("../../../../../../../common/sesh_types");
var _googleCalendarLogo = require("../../components/google_calendar_logo");
var _googleCalendarLogoDefault = parcelHelpers.interopDefault(_googleCalendarLogo);
function SyncTypeTag(props) {
    switch(props.syncType){
        case (0, _seshTypes.SyncDirection).Outbound:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "tag tag-dark-gray gap-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "sesh-text",
                        children: "sesh"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-long-arrow-alt-right"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarLogoDefault.default), {})
                ]
            });
        case (0, _seshTypes.SyncDirection).Inbound:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "tag tag-dark-gray gap-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarLogoDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-long-arrow-alt-right"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "sesh-text",
                        children: "sesh"
                    })
                ]
            });
        case (0, _seshTypes.SyncDirection).Bidirectional:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "tag tag-dark-gray gap-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "sesh-text",
                        children: "sesh"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-arrows-alt-h"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleCalendarLogoDefault.default), {})
                ]
            });
    }
}

},{"react/jsx-runtime":"dpQXr","../../../../../../../common/sesh_types":"aUAOg","../../components/google_calendar_logo":"eiefW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hK0YC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTemplateBlurb", ()=>EventTemplateBlurb);
var _jsxRuntime = require("react/jsx-runtime");
var _newPageBlurb = require("./new_page_blurb");
function EventTemplateBlurb(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newPageBlurb.NewPageBlurb), {
        onClick: props.onClick,
        title: "Event Templates",
        description: "View and modify event templates for this server",
        is_new: true
    });
}

},{"react/jsx-runtime":"dpQXr","./new_page_blurb":"aXQ8Q","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1rPaz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchPollData", ()=>fetchPollData);
parcelHelpers.export(exports, "PremiumFeatures", ()=>PremiumFeatures);
parcelHelpers.export(exports, "PlaceholderNames", ()=>PlaceholderNames);
parcelHelpers.export(exports, "PlaceholderDescriptions", ()=>PlaceholderDescriptions);
parcelHelpers.export(exports, "PlaceholderTimes", ()=>PlaceholderTimes);
var _jsxRuntime = require("react/jsx-runtime");
var _webUi = require("./web_ui");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textInput = require("./forms/text_input");
// pick a date util library
var _luxon = require("luxon");
var _dateField = require("./forms/date_field");
var _seshTypes = require("../../../common/sesh_types");
var _constants = require("../../../common/constants");
var _seshAccordian = require("./forms/sesh_accordian");
var _seshAccordianDefault = parcelHelpers.interopDefault(_seshAccordian);
var _textArea = require("./forms/text_area");
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _pollOptions = require("./forms/poll_options");
var _confirmationPage = require("./confirmation_page");
var _roleRestrictions = require("./forms/role_restrictions");
var _eventCreation = require("./event_creation");
var _dashboardUtils = require("./dashboard_utils");
var _commonUtils = require("../../../common/common_utils");
var _reactRouterDom = require("react-router-dom");
var _colorPickerAccordian = require("./forms/accordians/color_picker_accordian");
var _colorPickerAccordianDefault = parcelHelpers.interopDefault(_colorPickerAccordian);
var _imageUploaderAccordian = require("./forms/accordians/image_uploader_accordian");
var _imageUploaderAccordianDefault = parcelHelpers.interopDefault(_imageUploaderAccordian);
var _mentionsFormFunction = require("./forms/mentions_form_function");
var _channelDropdownWithTags = require("./forms/improved_components/channel_dropdown_with_tags");
async function fetchPollData(auth_token, guild_id, message_id) {
    let request_body = {
        access_token: auth_token.access_token,
        token_type: auth_token.token_type,
        guild_id: guild_id,
        message_id: message_id
    };
    return fetch(`/api/get_poll_data`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request_body)
    }).then((response)=>response.json().then((value)=>{
            if (value.err) {
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(value.err);
                return;
            }
            return value;
        }));
}
const PremiumFeatures = [
    "eligible_role_ids"
];
const PlaceholderNames = [
    "Favorite animal?",
    "Favorite food?",
    "Most Sus Among Us Color?"
];
const PlaceholderDescriptions = [
    "Every vote counts!",
    "Feel free to add more poll options.",
    "Vote early!"
];
const PlaceholderTimes = [
    {
        start_time: "in 5 hours",
        duration: "1 hr 20 min"
    },
    {
        start_time: "Tomorrow at 5pm",
        duration: "1 hr 30 min"
    },
    {
        start_time: "8/21 at 2 pm",
        duration: "1 hr 40 min"
    }
];
class PollCreation extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = this.createInitialState();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.sendPollData = this.sendPollData.bind(this);
    }
    createInitialState(force_new = false) {
        let placeholder_name = PlaceholderNames[Math.floor(Math.random() * PlaceholderNames.length)];
        let placeholder_description = PlaceholderDescriptions[Math.floor(Math.random() * PlaceholderDescriptions.length)];
        let placeholder_time_fields = PlaceholderTimes[Math.floor(Math.random() * PlaceholderTimes.length)];
        let placeholder_fields = {
            poll_title: placeholder_name,
            description: placeholder_description,
            end_time: placeholder_time_fields.start_time
        };
        for(let key in placeholder_fields)placeholder_fields[key] = "ex: " + placeholder_fields[key];
        let user_timezone = this.props.user_timezone;
        if (!this.props.user_timezone) user_timezone = _luxon.DateTime.local().zone.name;
        const poll_type = this.props.is_edit ? this.props.edit_data.poll_type : (0, _seshTypes.PollType).Standard;
        let end_time;
        let header_text;
        let description = "";
        let poll_title = "";
        let options = [];
        let image_url = "";
        let allow_anyone_to_add = this.props.guild_default_allow_anyone_to_add;
        let single_vote_per_user = this.props.guild_default_single_vote_per_user;
        let color = this.props.guild_default_poll_embed_color;
        let is_anonymous = false;
        if (!force_new && this.props.is_edit) {
            (0, _webUi.setDocTitle)("Editing poll", this.props.guild_name);
            allow_anyone_to_add = this.props.edit_data.allow_anyone_to_add;
            single_vote_per_user = this.props.edit_data.single_vote_per_user;
            is_anonymous = this.props.edit_data.is_anonymous;
            color = this.props.edit_data.color;
            description = this.props.edit_data.description;
            poll_title = this.props.edit_data.poll_title;
            image_url = this.props.edit_data.image_url;
            header_text = this.getEditHeaderText(this.props.edit_data.poll_title);
            if (this.props.edit_data.end_time) end_time = _luxon.DateTime.fromJSDate(new Date(this.props.edit_data.end_time)).toUTC();
            for (let name of this.props.edit_data.options)options.push({
                name: name,
                is_newly_added: false
            });
        } else {
            (0, _webUi.setDocTitle)("Creating poll", this.props.guild_name);
            header_text = this.getCreateHeaderText();
            options.push((0, _pollOptions.createInitialPollOption)(poll_type));
            options.push((0, _pollOptions.createInitialPollOption)(poll_type));
        }
        // const state = common_utils.createPollURLState(
        // 	this.props.auth_token.bot_client_id,
        // 	this.props.guild_data.id,
        // 	this.props.selected_channel.id,
        // 	this.props.selected_channel.name,
        // 	this.props.poll_message_id
        // );
        // history.replaceState(null, "", `/dashboard/#state=${state}`);
        const roles_and_channels_data = this.getUpdatedRolesAndChannelsData();
        if (!this.props.is_edit && roles_and_channels_data?.selected_channel) this.props.history.replace(`create?channel_id=${roles_and_channels_data?.selected_channel.id}`);
        return {
            poll_title,
            description,
            options,
            end_time,
            header_text,
            selected_channel: roles_and_channels_data?.selected_channel ? {
                id: roles_and_channels_data?.selected_channel.id,
                forum_tag_ids: []
            } : undefined,
            placeholder_fields,
            user_timezone,
            eligible_role_ids: this.props.edit_data?.eligible_role_ids ?? [],
            image_url,
            allow_anyone_to_add,
            single_vote_per_user,
            is_anonymous,
            color,
            poll_type,
            role_mentions: roles_and_channels_data.create_role_mentions,
            user_mentions: this.props.edit_data?.user_mention_ids ?? [],
            loading_roles_and_channels: !Boolean(this.props.roles),
            is_confirming: false,
            is_poll_creation_success: false
        };
    }
    getUpdatedRolesAndChannelsData() {
        const roles = this.props.roles;
        let create_role_mentions = [];
        if (!roles) return {
            selected_channel: null,
            eligible_roles: [],
            create_role_mentions
        };
        const all_channels = this.props.is_edit ? this.props.all_channel_data : this.props.all_channel_data.filter((val)=>val.has_write);
        let eligible_roles = [];
        let selected_channel_id;
        if (this.props.can_select_channel) {
            const query = new URLSearchParams(this.props.location.search);
            const channel_id_from_param = query.get("channel_id");
            selected_channel_id = Boolean(channel_id_from_param) ? channel_id_from_param : this.props.poll_channel_id;
        } else selected_channel_id = this.props.poll_channel_id;
        if (this.props.is_edit) {
            selected_channel_id = this.props.edit_data.selected_channel_id;
            eligible_roles = this.props.is_premium ? (0, _eventCreation.IDsToMentionables)(this.props.edit_data.eligible_role_ids, roles) : [];
            create_role_mentions = (0, _eventCreation.IDsToMentionables)(this.props.edit_data.role_mention_ids, roles);
        }
        let selected_channel = all_channels.find((val)=>val.id === selected_channel_id);
        if (!selected_channel) selected_channel = all_channels[0];
        if (!selected_channel) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("No valid channels found. Please ensure both you and sesh have read/write/embed links permissions in atleast one channel in the server.");
            this.props.history.push((0, _commonUtils.common_utils).getGuildOptionsURL(this.props.guild_id));
            return;
        }
        if (!this.props.is_edit) this.props.history.replace(`create?channel_id=${selected_channel.id}`);
        return {
            selected_channel,
            eligible_roles,
            create_role_mentions
        };
    }
    componentWillUnmount() {
        if (this.props.on_unmount) this.props.on_unmount();
    }
    componentDidMount() {
        if (this.props.is_edit) {
            if (this.props.edit_data.end_time) {
                let end_time = _luxon.DateTime.fromJSDate(new Date(this.props.edit_data.end_time));
                if (end_time < _luxon.DateTime.utc()) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("This poll has already ended. Unable to edit.");
                    this.props.history.replace((0, _commonUtils.common_utils).getPollCreateURL(this.props.guild_id));
                    return;
                }
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const roles_updated = prevProps.roles == null && this.props.roles != null;
        if (roles_updated) {
            const new_state = this.getUpdatedRolesAndChannelsData();
            this.setState({
                selected_channel: {
                    id: new_state?.selected_channel.id,
                    forum_tag_ids: []
                },
                role_mentions: new_state.create_role_mentions,
                loading_roles_and_channels: false
            });
        }
        if (!this.props.is_edit) {
            const channel_changed = prevState.selected_channel?.id != this.state.selected_channel?.id;
            if (channel_changed) {
                if (this.state.selected_channel) this.props.history.replace(`create?channel_id=${this.state.selected_channel.id}`);
            }
        }
    }
    handleSubmit(event) {
        event.preventDefault();
        this.sendPollData();
    }
    bulkUpdateState(data) {
        const new_state = {};
        for (let datum of data)new_state[datum.key] = datum.value;
        this.setState(new_state);
    }
    updateState(key, value) {
        const new_state = {
            [key]: value
        };
        this.setState(new_state);
    }
    getEditHeaderText(poll_title) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                (0, _dashboardUtils.DashboardUtils).GetPollIcon(),
                "Editing ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    children: poll_title
                })
            ]
        });
    }
    getCreateHeaderText() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                (0, _dashboardUtils.DashboardUtils).GetPollIcon(),
                "Creating Poll"
            ]
        });
    }
    getButtonText(channel_name) {
        if (this.props.is_edit) return `Edit Poll in #${channel_name}`;
        else return `Create Poll in #${channel_name}`;
    }
    getSelectedChannel() {
        return this.props.all_channel_data?.find((val)=>val.id === this.state.selected_channel?.id);
    }
    render_channel_select() {
        const channel_select_disabled = !this.props.can_select_channel || this.props.edit_data?.is_reaction_based || this.state.is_confirming;
        let channel_info_addenum;
        if (!this.props.can_select_channel) channel_info_addenum = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            children: ". Disabled due to sesh server settings."
        });
        const channel_select_info = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            children: [
                "The channel where the poll will get sent to",
                channel_info_addenum
            ]
        });
        const name = "Channel";
        if (this.state.loading_roles_and_channels) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(name, channel_select_info),
                (0, _dashboardUtils.DashboardUtils).RenderLoadingSelect()
            ]
        }, "selected_channel_load");
        let below_element;
        if (this.props.is_edit && this.state.selected_channel.id !== this.props.edit_data.selected_channel_id) {
            const original_channel_name = this.props.all_channel_data.find((val)=>val.id === this.props.edit_data.selected_channel_id)?.name ?? "unknown";
            below_element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "note mt-4",
                children: [
                    "Poll will be moved from",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            "#",
                            original_channel_name
                        ]
                    }),
                    " ",
                    "to",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "has-text-weight-bold",
                        children: [
                            "#",
                            this.getSelectedChannel().name
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelDropdownWithTags.ChannelSelectFormWithTags), {
            id: "selected_channel",
            name: "Channel",
            desired_channel_id: this.props.is_edit ? undefined : this.props.poll_channel_id,
            initial_value: this.getSelectedChannel(),
            channel_data: this.props.all_channel_data,
            info: channel_select_info,
            disabled: channel_select_disabled,
            is_event: false,
            below_element: below_element,
            updateFunc: (val)=>this.updateState("selected_channel", {
                    id: val.id,
                    forum_tag_ids: []
                }),
            sesh_channel_id: this.props.poll_channel_id,
            include_threads: true,
            selected_forum_tag_ids: this.state.selected_channel.forum_tag_ids,
            setSelectedTagIds: (val)=>this.updateState("selected_channel", {
                    id: this.state.selected_channel.id,
                    forum_tag_ids: val
                })
        });
    }
    render_accordians() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "creation-form",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "title is-3 has-text-centered mt-6",
                    children: this.state.header_text
                }),
                this.props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "rsvp-data-link-edit-link",
                    onClick: ()=>{
                        this.props.history.push((0, _commonUtils.common_utils).getPollResultsURL(this.props.guild_data.id, this.props.edit_data?.poll_message_id));
                    },
                    children: "View Results"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "creation-primary-fields",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInputForm), {
                            id: "poll_title",
                            name: "Poll Title",
                            placeholder: this.state.placeholder_fields.poll_title,
                            initial_value: this.state.poll_title,
                            updateFunc: (val)=>this.updateState("poll_title", val),
                            char_limit: (0, _constants.Constants).EMBED_TITLE_LIMIT - (0, _constants.Constants).POLL_TITLE_PREFIX.length,
                            info: "The title of the poll",
                            disabled: this.state.is_confirming
                        }),
                        this.render_channel_select(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollOptions.PollOptionsList), {
                            name: `Poll Options (${this.state.options.length} / ${(0, _constants.Constants).MAX_POLL_OPTIONS})`,
                            poll_type: this.state.poll_type,
                            guild_timezone: this.props.guild_timezone,
                            personal_timezone: this.state.user_timezone,
                            use_24h_clock: this.props.use_24h_clock,
                            initial_value: this.state.options,
                            info: "Poll options to vote on",
                            disabled: this.state.is_confirming,
                            is_edit: this.props.is_edit,
                            updateFunc: (options, type)=>{
                                this.bulkUpdateState([
                                    {
                                        key: "options",
                                        value: options
                                    },
                                    {
                                        key: "poll_type",
                                        value: type
                                    }
                                ]);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.description,
                    opened_initially: Boolean(this.state.description),
                    field_key: "description",
                    is_server_premium: this.props.is_premium,
                    label: "Description",
                    info: "The description of the poll",
                    disabled: this.state.is_confirming,
                    render_child: (field_key, initial_value)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textArea.TextAreaForm), {
                            initial_value: initial_value,
                            rows: 10,
                            placeholder: this.state.placeholder_fields.description,
                            updateFunc: (val)=>this.updateState(field_key, val),
                            char_limit: (0, _constants.Constants).DESCRIPTION_CHAR_LIMIT
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.allow_anyone_to_add,
                    opened_initially: Boolean(this.state.allow_anyone_to_add),
                    label: "Allow Anyone To Add Poll Option",
                    field_key: "allow_anyone_to_add",
                    is_server_premium: this.props.is_premium,
                    info: "Allows anyone to add extra poll options from Discord",
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: this.state.is_confirming
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: {
                        user_mentions: this.state.user_mentions,
                        role_mentions: this.state.role_mentions
                    },
                    loading: false,
                    opened_initially: this.props.edit_data?.role_mention_ids && this.props.edit_data.role_mention_ids.length > 0 || this.props.edit_data?.user_mention_ids && this.props.edit_data.user_mention_ids.length > 0,
                    field_key: undefined,
                    is_server_premium: this.props.is_premium,
                    label: "Mentions",
                    info: "Roles/Users to ping when the poll is created",
                    onCheckboxUnclicked: ()=>this.setState({
                            role_mentions: [],
                            user_mentions: []
                        }),
                    disabled: this.state.is_confirming || this.props.is_edit,
                    render_child: (field_key, initial_value)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mentionsFormFunction.MentionsFormFunction), {
                            initial_value: initial_value,
                            roles: this.props.roles,
                            updateFunc: (val)=>{
                                this.setState({
                                    role_mentions: val.role_mentions,
                                    user_mentions: val.user_mentions
                                });
                            },
                            disabled: this.state.is_confirming || this.props.is_edit
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.single_vote_per_user,
                    opened_initially: this.state.single_vote_per_user,
                    label: "Single Vote Per User",
                    field_key: "single_vote_per_user",
                    is_server_premium: this.props.is_premium,
                    info: `Allow only one vote per user. If this is unchecked, then users can vote for multiple options. ${this.props.is_edit ? "\nNOTE: Can not change on edit." : ""}`,
                    render_child: null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: this.props.is_edit || this.state.is_confirming
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.is_anonymous,
                    opened_initially: this.state.is_anonymous,
                    label: "Anonymous",
                    field_key: "is_anonymous",
                    is_server_premium: this.props.is_premium,
                    info: `Prevent the names of poll voters from being seen by everyone, including admins.${this.props.is_edit ? "\nNOTE: Can not modify this setting on an already created poll." : ""}`,
                    render_child: !this.props.is_edit && this.props.are_polls_default_reaction_based ? ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "note",
                            children: "Enabling this setting will create a button based poll, instead of a reaction based one."
                        }) : null,
                    updateFunc: (key, value)=>this.updateState(key, value),
                    disabled: this.state.is_confirming || this.props.is_edit
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.end_time,
                    opened_initially: Boolean(this.state.end_time),
                    disabled: this.state.is_confirming,
                    label: "End Time",
                    field_key: "end_time",
                    is_server_premium: this.props.is_premium,
                    info: "The end time of the poll",
                    render_child: (field_key, initial_value)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateForm), {
                            placeholder: this.state.placeholder_fields.end_time,
                            guild_zone: this.props.guild_timezone,
                            personal_zone: this.state.user_timezone,
                            initial_value: this.state.end_time,
                            use_24h_clock: this.props.use_24h_clock,
                            display_text: "Poll end time",
                            updateFunc: (val)=>this.updateState(field_key, val)
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageUploaderAccordianDefault.default), {
                    field_key: "image_url",
                    image_url: this.state.image_url,
                    is_premium: this.props.is_premium,
                    info: "The image for this poll",
                    updateFunc: (val)=>this.updateState("image_url", val),
                    disabled: this.state.is_confirming
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorPickerAccordianDefault.default), {
                    field_key: "color",
                    label: "Color",
                    is_premium: this.props.is_premium,
                    color: this.state.color,
                    info: "The color of the embed for this event",
                    updateFunc: (val)=>this.updateState("color", val),
                    disabled: this.state.is_confirming
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
                    initial_value: this.state.eligible_role_ids,
                    opened_initially: Boolean(this.props.edit_data?.eligible_role_ids?.length > 0),
                    disabled: this.state.is_confirming,
                    field_key: "eligible_role_ids",
                    is_server_premium: this.props.is_premium,
                    label: "Role Restrictions",
                    loading: this.state.loading_roles_and_channels,
                    info: "Limit poll voting to only certain roles",
                    render_child: (field_key, initial_value)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleRestrictions.RoleRestrictionsForm), {
                            role_ids: initial_value,
                            updateFunc: (val)=>{
                                this.updateState(field_key, val);
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field submit-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateFormConfirmButton, {
                        blocked_by_load: this.state.loading_roles_and_channels,
                        channel_name: this.getSelectedChannel()?.name,
                        is_confirming: this.state.is_confirming,
                        onClick: this.handleSubmit,
                        is_edit: this.props.is_edit,
                        is_event: false
                    })
                })
            ]
        });
    }
    render() {
        if (this.state.is_poll_creation_success) {
            let create_new_event_func;
            if (this.props.is_edit) create_new_event_func = ()=>this.props.history.push((0, _commonUtils.common_utils).getPollCreateURL(this.props.guild_id));
            else create_new_event_func = ()=>this.setState(this.createInitialState(true));
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmationPage.PollCreationConfirmation), {
                poll_props: this.props,
                guild_data: this.props.guild_data,
                reset_state_func: create_new_event_func
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-mobile is-centered !m-0",
                style: {
                    transition: "opacity 0.5s",
                    opacity: "1"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
                            link_chain_data: [
                                (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                                (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.props.guild_data),
                                (0, _dashboardUtils.DashboardUtils).RenderPollSelectionLinkChain(this.props.guild_data),
                                (0, _dashboardUtils.DashboardUtils).RenderPollCreateLinkChain(this.props.guild_id, this.props.is_edit)
                            ]
                        }),
                        this.render_accordians()
                    ]
                })
            })
        });
    }
    scrollToElement(id) {
        document.getElementById(id).scrollIntoView({
            behavior: "smooth"
        });
    }
    sendPollData() {
        if (this.props.edit_data && this.props.edit_data?.end_time && this.props.edit_data?.end_time < new Date()) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("This poll has already ended. Unable to edit.");
            this.props.history.push((0, _commonUtils.common_utils).getGuildOptionsURL(this.props.guild_data.id));
            return;
        }
        if (this.state.end_time && this.state.end_time.toJSDate() < new Date()) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Can not make poll with end time in the past.");
            return;
        }
        const selected_channel = this.getSelectedChannel();
        if (selected_channel.type === "Forum" && selected_channel.tag_settings.required && this.state.selected_channel.forum_tag_ids.length === 0) {
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert("Must have at least one tag selected for this channel", undefined, ()=>this.scrollToElement("selected_channel"));
            return;
        }
        let request_body = {
            user_id: this.props.user_id,
            guild_id: this.props.guild_id,
            channel_id: this.state.selected_channel.id,
            description: this.state.description,
            options: this.state.options,
            title: this.state.poll_title,
            end_time: this.state.end_time?.toISO(),
            color: this.state.color,
            poll_message_id: this.props.edit_data?.poll_message_id,
            allow_anyone_to_add: this.state.allow_anyone_to_add,
            eligible_role_ids: this.state.eligible_role_ids,
            image_url: this.state.image_url,
            single_vote_per_user: this.state.single_vote_per_user,
            is_anonymous: this.state.is_anonymous,
            access_token: this.props.auth_token.access_token,
            token_type: this.props.auth_token.token_type,
            poll_type: this.state.poll_type,
            forum_tag_ids: this.state.selected_channel.forum_tag_ids,
            role_mention_ids: this.state.role_mentions.map((val)=>val.id),
            user_mentions_ids: this.state.user_mentions
        };
        const props = this.props;
        this.setState({
            is_confirming: true
        });
        fetch(`/api/create_poll`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request_body)
        }).then((response)=>response.json().then((val)=>{
                if (val.error) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(val.error.replace(/\*\*([^*]+?)\*\*/g, "<b>$1</b>"));
                    this.setState({
                        is_confirming: false
                    });
                } else this.setState({
                    is_poll_creation_success: true,
                    is_confirming: false
                });
            }).catch((err)=>{
                (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(response.statusText);
                this.setState({
                    is_confirming: false
                });
            }));
    }
}
exports.default = (0, _reactRouterDom.withRouter)(PollCreation);

},{"react/jsx-runtime":"dpQXr","./web_ui":"7f1Tj","react":"IMRgT","./forms/text_input":"4jMf1","luxon":"fLWpi","./forms/date_field":"e6cg9","../../../common/sesh_types":"aUAOg","../../../common/constants":"lLiun","./forms/sesh_accordian":"etZ1w","./forms/text_area":"dPYPF","../../../src/vendored/FadeIn":"aMGHU","./forms/poll_options":"1KdWt","./confirmation_page":"np3gy","./forms/role_restrictions":"2CCGw","./event_creation":"a8uX3","./dashboard_utils":"jvA8A","../../../common/common_utils":"gACUC","react-router-dom":"djWTS","./forms/accordians/color_picker_accordian":"fNjuS","./forms/accordians/image_uploader_accordian":"audXZ","./forms/mentions_form_function":"jG8vR","./forms/improved_components/channel_dropdown_with_tags":"jQ5tM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1KdWt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInitialPollOption", ()=>createInitialPollOption);
parcelHelpers.export(exports, "parseTimePollOption", ()=>parseTimePollOption);
parcelHelpers.export(exports, "PollOptionsList", ()=>PollOptionsList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textInput = require("./text_input");
var _constants = require("../../../../common/constants");
var _fadeIn = require("../../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _seshTypes = require("../../../../common/sesh_types");
var _dashboardUtils = require("../dashboard_utils");
var _dateTimePicker = require("./date_time_picker");
function getListWithoutNulls(list) {
    return list.filter((val)=>val != null);
}
function createInitialPollOption(type) {
    let name;
    switch(type){
        case (0, _seshTypes.PollType).Standard:
            name = "";
            break;
        case (0, _seshTypes.PollType).Time:
            const date = new Date();
            const nearest_15_minute = Math.ceil(date.getMinutes() / 15) * 15;
            date.setMinutes(nearest_15_minute);
            date.setMilliseconds(0);
            date.setSeconds(0);
            name = date.toISOString();
            break;
    }
    return {
        name: name,
        is_newly_added: true
    };
}
function parseTimePollOption(poll_option_string) {
    const option_words = poll_option_string.split(" ");
    const date = new Date(option_words[0]);
    let creator_string;
    if (option_words.length > 1) creator_string = option_words.slice(1).join(" ");
    return {
        date,
        creator_string
    };
}
class PollOptionsList extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let value = this.props.initial_value ? this.props.initial_value : [
            createInitialPollOption(this.props.poll_type)
        ];
        this.state = {
            options: value,
            cleaned_options: value,
            poll_type: this.props.poll_type
        };
        this.handleChange = this.handleChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onAddButtonPressed = this.onAddButtonPressed.bind(this);
        this.updateParent = this.updateParent.bind(this);
    }
    onDelete(index) {
        this.state.options[index] = null;
        this.updateParent(this.state.options, this.state.poll_type);
    }
    createPollOption(index, option) {
        const key = index + "_child";
        switch(this.state.poll_type){
            case (0, _seshTypes.PollType).Standard:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInputForm), {
                        initial_value: option.name,
                        char_limit: (0, _constants.Constants).POLL_OPTION_CHARACTER_LIMIT - 1,
                        updateFunc: (val)=>{
                            let value = {
                                name: val,
                                is_newly_added: true
                            };
                            this.handleChange(index, value);
                        },
                        placeholder: "Poll option",
                        disabled: !option.is_newly_added || this.props.disabled
                    }, key)
                });
            case (0, _seshTypes.PollType).Time:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-8-tablet is-11-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePicker.DateTimePicker), {
                        initial_value: option?.name ? parseTimePollOption(option.name).date : undefined,
                        updateFunc: (val)=>{
                            this.handleChange(index, {
                                name: val.toISOString(),
                                is_newly_added: true
                            });
                        },
                        disabled: !option.is_newly_added || this.props.disabled,
                        disable_past_days: false
                    }, key)
                });
        }
    }
    PollOption(index, deletable) {
        let option = this.state.options[index];
        let key = index;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "columns is-mobile",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column !py-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
                    transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-gapless is-vcentered is-mobile",
                        children: [
                            this.createPollOption(index, option),
                            this.state.cleaned_options.length > 1 && deletable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-1 is-centered has-text-centered is-vcentered",
                                onClick: ()=>this.onDelete(index),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).DeleteButton, {
                                    onClick: ()=>this.onDelete(index)
                                })
                            })
                        ]
                    })
                })
            })
        }, key + "_parent");
    }
    handleChange(index, option_value) {
        //this.props.updateFunc(event);
        this.state.options[index] = option_value;
        this.updateParent(this.state.options, this.state.poll_type);
    }
    updateParent(new_raw_options, poll_type) {
        let cleaned_options = getListWithoutNulls(new_raw_options);
        this.setState({
            options: new_raw_options,
            cleaned_options: cleaned_options
        });
        this.props.updateFunc(cleaned_options, poll_type);
    }
    createPollAddonProps(type) {
        const label = type === (0, _seshTypes.PollType).Standard ? "Generic" : "Time";
        return {
            onClick: (e)=>{
                e.preventDefault();
                const new_poll_options = [
                    createInitialPollOption(type),
                    createInitialPollOption(type)
                ];
                this.setState({
                    poll_type: type,
                    cleaned_options: new_poll_options,
                    options: new_poll_options
                });
                this.updateParent(new_poll_options, type);
            },
            icon: undefined,
            label,
            selected: this.state.poll_type === type,
            disabled: this.props.is_edit || this.props.disabled
        };
    }
    render() {
        let result = [];
        let not_editable_options = this.state.cleaned_options.filter((val)=>!val.is_newly_added);
        let deletable_index = not_editable_options.length - 1;
        this.state.options.forEach((value, index)=>{
            if (value == null) return;
            let deletable = value.is_newly_added || deletable_index === index;
            result.push(this.PollOption(index, deletable));
        });
        result.push(this.AddOptionButton(result.length));
        let name = this.props.name + " " + `(${this.state.cleaned_options.length} / ${(0, _constants.Constants).MAX_POLL_OPTIONS})`;
        const addon_button_data = [];
        addon_button_data.push(this.createPollAddonProps((0, _seshTypes.PollType).Standard));
        addon_button_data.push(this.createPollAddonProps((0, _seshTypes.PollType).Time));
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                this.props.name && (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(this.props.name, this.props.info),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-multiline",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).AddOnButtonGroup, {
                                    addon_button_data: addon_button_data
                                })
                            }),
                            this.state.poll_type === (0, _seshTypes.PollType).Time && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full",
                                children: "Enter poll options using dates and times in your local timezone."
                            }),
                            this.state.poll_type === (0, _seshTypes.PollType).Standard && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full",
                                children: "Enter poll options using simple text."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                    className: "!mx-0",
                                    children: result
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    onAddButtonPressed(event) {
        event.preventDefault();
        let new_option;
        if (this.state.poll_type === (0, _seshTypes.PollType).Standard) new_option = createInitialPollOption(this.state.poll_type);
        else {
            const option_to_clone = this.state.options[this.state.options.length - 1];
            if (option_to_clone) new_option = {
                is_newly_added: true,
                name: option_to_clone.name
            };
            else new_option = createInitialPollOption(this.state.poll_type);
        }
        this.state.options.push(new_option);
        this.updateParent(this.state.options, this.state.poll_type);
    }
    AddOptionButton(index) {
        let className = "";
        let button_text = "Add Option";
        let disabled = this.state.cleaned_options.length >= (0, _constants.Constants).MAX_POLL_OPTIONS || this.props.disabled;
        let button = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: disabled,
                onClick: this.onAddButtonPressed,
                className: "dashboard-primary-button--tiny",
                children: button_text
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "columns is-gapless is-mobile !mx-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-11 !mx-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-mobile is-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow",
                        children: !disabled && button
                    })
                })
            })
        }, "add");
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./text_input":"4jMf1","../../../../common/constants":"lLiun","../../../../src/vendored/FadeIn":"aMGHU","../../../../common/sesh_types":"aUAOg","../dashboard_utils":"jvA8A","./date_time_picker":"c4mcO","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"audXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImageUploaderAccordian);
var _jsxRuntime = require("react/jsx-runtime");
var _seshAccordian = require("../sesh_accordian");
var _seshAccordianDefault = parcelHelpers.interopDefault(_seshAccordian);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _imageUploader = require("../image_uploader");
function ImageUploaderAccordian(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAccordianDefault.default), {
        field_key: props.field_key,
        is_server_premium: props.is_premium,
        label: "Image",
        initial_value: props.image_url,
        opened_initially: Boolean(props.image_url),
        info: props.info,
        disabled: props.disabled,
        onCheckboxUnclicked: ()=>props.updateFunc(null),
        render_child: (field_key, initial_value)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageUploader.ImageUploaderForm), {
                updateFunc: (val)=>props.updateFunc(val),
                initial_value: initial_value
            });
        }
    });
}

},{"react/jsx-runtime":"dpQXr","../sesh_accordian":"etZ1w","react":"IMRgT","../image_uploader":"kfglS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jG8vR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MentionsFormFunction", ()=>MentionsFormFunction);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dashboardUtils = require("../dashboard_utils");
var _searchableDropdown = require("./searchable_dropdown");
var _membersSearchDropdown = require("./improved_components/members_search_dropdown");
var _reactRouter = require("react-router");
function MentionsFormFunction(props) {
    const { disabled } = props;
    let { server_id } = (0, _reactRouter.useParams)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `columns is-multiline !mx-0 !px-0`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-full !mb-0 !pb-0 !px-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-multiline !mx-0 !px-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full !mb-0 !pb-0 !px-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "Users"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column !mt-0 !pt-0 !px-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _membersSearchDropdown.MembersSearchDropdown), {
                                    is_disabled: disabled,
                                    selected_ids: props.initial_value.user_mentions,
                                    guild_id: server_id,
                                    onUpdate: (ids)=>props.updateFunc({
                                            user_mentions: ids,
                                            role_mentions: props.initial_value.role_mentions
                                        })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-full !px-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "columns is-multiline !mx-0 !px-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column is-full !mb-0 !pb-0 !px-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "Roles"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "column !mt-0 !pt-0 !px-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Selector, {
                                    disabled: disabled,
                                    options: props.roles,
                                    selected_ids: props.initial_value.role_mentions,
                                    updateFunc: (mentionables)=>props.updateFunc({
                                            user_mentions: props.initial_value.user_mentions,
                                            role_mentions: mentionables
                                        })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function Selector(props) {
    const { options, disabled, longest_name_length, selected_ids } = props;
    const loading = !Boolean(options);
    if (loading) return (0, _dashboardUtils.DashboardUtils).RenderLoadingSelect();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.SearchableDropdown), {
        handleChange: props.updateFunc,
        longest_name_length: longest_name_length,
        options: options,
        initial_mentions: selected_ids,
        ignore_invalid_permissions: false,
        disabled: disabled,
        loading: !Boolean(options)
    }, loading.toString());
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../dashboard_utils":"jvA8A","./searchable_dropdown":"8iEAS","./improved_components/members_search_dropdown":"j5v22","react-router":"djWTS","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9uXeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PollResultsForm", ()=>PollResultsForm);
parcelHelpers.export(exports, "VoteColorBox", ()=>VoteColorBox);
var _jsxRuntime = require("react/jsx-runtime");
var _index = require("csv-stringify/lib/index");
var _luxon = require("luxon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _reactMinimalPieChart = require("react-minimal-pie-chart");
var _reactRouter = require("react-router");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _seshTypes = require("../../../common/sesh_types");
var _timeFormatUtils = require("../../../common/time_format_utils");
var _dashboardUtils = require("./dashboard_utils");
var _csvDownload = require("./forms/improved_components/csv_download");
var _pollResultsVoterList = require("./forms/improved_components/poll_results_voter_list");
var _pollOptions = require("./forms/poll_options");
var _trpc = require("./utils/trpc");
var _webUi = require("./web_ui");
function limitStringLength(str, characters, suffix = "") {
    if (str.length <= characters) return str;
    return str.substring(0, characters - suffix.length) + suffix;
}
const chart_colors = [
    "#4D4D4D",
    "#5DA5DA",
    "#FAA43A",
    "#60BD68",
    "#F17CB0",
    "#B2912F",
    "#B276B2",
    "#DECF3F",
    "#F15854",
    "#D84797"
];
// export async function fetchPollResults(
// 	auth_token: DiscordAuthToken,
// 	guild_id: string,
// 	message_id: string
// ) {
// 	const request_body: GetPollResultsRequest = {
// 		guild_id,
// 		message_id,
// 		access_token: auth_token.access_token,
// 		token_type: auth_token.token_type,
// 	};
// 	return fetch(`/api/get_poll_results`, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "application/json",
// 		},
// 		body: JSON.stringify(request_body),
// 	}).then((response) =>
// 		response.json().then((value: DashboardResponse<PollResultsProps>) => {
// 			if (value.err) {
// 				DashboardUtils.ShowDefaultErrorAlert(value.err);
// 				return;
// 			}
// 			return value.props;
// 		})
// 	);
// }
const darkened_colors = chart_colors.map((val)=>shadeColor(val, -25));
const PIE_CHART_RADIUS = (0, _reactMinimalPieChart.pieChartDefaultProps).radius - 20;
const INNER_RADIUS = 50;
function shadeColor(color, percent) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);
    R = Math.round(R * (100 + percent) / 100);
    G = Math.round(G * (100 + percent) / 100);
    B = Math.round(B * (100 + percent) / 100);
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    let RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
    let GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
    let BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);
    return "#" + RR + GG + BB;
}
class PollResultsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let sorted_data = this.props.options.map((val, index)=>{
            return {
                title: val.name,
                votes: val.vote_count,
                percentage: val.vote_count / Math.max(this.props.poll.vote_count, Number.EPSILON),
                original_index: index
            };
        }).sort((a, b)=>b.votes - a.votes);
        (0, _webUi.setDocTitle)("Poll results", this.props.guild_data.name);
        this.state = {
            sorted_data: sorted_data,
            chart_selected_index: null,
            chart_hovered_index: null,
            should_display_tooltip: true,
            user_hover_name: null
        };
        this.onChartClicked = this.onChartClicked.bind(this);
        this.onChartMouseOver = this.onChartMouseOver.bind(this);
        this.onChartMouseOut = this.onChartMouseOut.bind(this);
        this.getOptionTitle = this.getOptionTitle.bind(this);
    }
    getOptionTitle(data) {
        const is_time_poll = this.props.poll.type === (0, _seshTypes.PollType).Time;
        if (!is_time_poll) return data.title ? data.title : "unnamed";
        const { date, creator_string } = (0, _pollOptions.parseTimePollOption)(data.title);
        let title = (0, _timeFormatUtils.time_format_utils).format_time_concise_date_first(_luxon.DateTime.fromJSDate(date));
        if (creator_string) title += ` ${creator_string}`;
        return title;
    }
    getTrueIndex(sorted_index) {
        if (sorted_index == null) return null;
        return this.state.sorted_data[sorted_index].original_index;
    }
    onChartClicked(event, index) {
        if (index === this.state.chart_selected_index) index = null;
        this.setState({
            chart_selected_index: index
        });
    }
    onChartMouseOver(event, index, should_display_tooltip, should_ignore = false) {
        if (should_ignore) return;
        this.setState({
            chart_hovered_index: index,
            should_display_tooltip: should_display_tooltip
        });
    }
    onChartMouseOut(event, index) {
        this.setState({
            chart_hovered_index: null
        });
    }
    getChartData(data) {
        return data.map((val, index)=>{
            const normalized_color_index = index % chart_colors.length;
            return {
                key: index,
                title: this.getOptionTitle(val),
                value: val.percentage,
                original_index: val.original_index,
                color: this.state.chart_hovered_index === index ? darkened_colors[normalized_color_index] : chart_colors[normalized_color_index]
            };
        });
    }
    createPieChartBulletPoint(datum, index) {
        const has_votes = datum.value > 0;
        const text_class = this.state.chart_selected_index === index ? "has-text-weight-bold" : "";
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-variable is-1 pie-chart-list is-mobile",
            onMouseOver: has_votes ? (event)=>this.onChartMouseOver(event, index, false) : undefined,
            onMouseOut: (event)=>this.onChartMouseOut(event, index),
            onClick: has_votes ? (event)=>this.onChartClicked(event, index) : undefined,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-narrow pie-chart-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "color-box pie-chart-list",
                        style: {
                            backgroundColor: datum.color
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "column pie-chart-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: `${Math.round((datum.value * 100 + Number.EPSILON) * 100) / 100}%`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: text_class,
                            children: ` ${datum.title}`
                        })
                    ]
                })
            ]
        }, index);
    }
    renderPieChartList(data) {
        let data_list = [];
        let index = 0;
        for (let datum of data){
            data_list.push(this.createPieChartBulletPoint(datum, index));
            index++;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            children: data_list
        });
    }
    makePieChartHoverTooltip(entry) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: this.getOptionTitle(entry)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    "Votes:",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                        children: [
                            entry.votes,
                            " (",
                            Math.round((entry.percentage * 100 + Number.EPSILON) * 100) / 100,
                            "%)"
                        ]
                    })
                ]
            })
        });
    }
    createVoterList(chartData) {
        let current_raw_data = this.state.sorted_data[this.state.chart_selected_index];
        let is_all = !current_raw_data;
        let users_elements = [];
        let index = 0;
        // for (let user of voter_names) {
        // 	let options_user_voted_for = this.state.user_vote_map.get(user);
        // 	let user_name =
        // 		user.length > 13 ? user.substring(0, 13) + "..." : user;
        // 	let element = (
        // 		<div
        // 			key={index}
        // 			onMouseOver={() => this.setState({ user_hover_name: user })}
        // 			onMouseOut={() => this.setState({ user_hover_name: null })}
        // 		>
        // 			<div>
        // 				<p>{user_name}</p>
        // 			</div>
        // 			<div>
        // 				{options_user_voted_for.map((val, index) => {
        // 					return (
        // 						<div
        // 							key={index}
        // 							className="color-box pie-chart-list"
        // 							style={{
        // 								backgroundColor: chartData[val].color,
        // 							}}
        // 						></div>
        // 					);
        // 				})}
        // 			</div>
        // 		</div>
        // 	);
        // 	users_elements.push(element);
        // 	index++;
        // }
        // const first_third_index = Math.ceil(users_elements.length / 3);
        // const second_third_index = Math.ceil((users_elements.length * 2) / 3);
        const tab_element_descriptors = this.state.sorted_data.map((val, index)=>{
            return {
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    className: index === this.state.chart_selected_index ? "is-active" : "",
                    onClick: ()=>this.setState({
                            chart_selected_index: index
                        }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        title: this.getOptionTitle(val),
                        children: limitStringLength(this.getOptionTitle(val), 16, "...")
                    })
                }, index),
                index: val.original_index
            };
        }).sort((a, b)=>a.index - b.index);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "tabs poll-tabs is-boxed !mb-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: is_all ? "is-active" : "",
                                onClick: ()=>{
                                    this.setState({
                                        chart_selected_index: null
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    children: "All"
                                })
                            }),
                            tab_element_descriptors.map((val)=>val.element)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pollResultsVoterList.PollResultsVoterList), {
                        option_index: current_raw_data?.original_index,
                        voteBoxCreator: (indices, include_title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(VoteColorBox, {
                                option_indices: indices,
                                chart_data: this.getChartData(this.state.sorted_data),
                                include_title: include_title
                            })
                    }, current_raw_data?.original_index)
                })
            ]
        });
    }
    // downloadCSVFile() {
    // 	let csv_lines: string[][] = [];
    // 	for (let data of this.state.sorted_data) {
    // 		let current_line_elements: string[] = [];
    // 		current_line_elements.push(data.title);
    // 		current_line_elements.push(data.votes.toString());
    // 		current_line_elements.push(`${data.voter_names.join(",")}`);
    // 		csv_lines.push(current_line_elements);
    // 	}
    // 	stringify(csv_lines, (err, output) => {
    // 		if (err) {
    // 			DashboardUtils.ShowDefaultErrorAlert(err.toString());
    // 			return;
    // 		}
    // 		const element = document.createElement("a");
    // 		const file = new Blob([output], { type: "text/plain" });
    // 		element.href = URL.createObjectURL(file);
    // 		element.download = `poll_results_${this.props.message_id}.csv`;
    // 		document.body.appendChild(element); // Required for this to work in FireFox
    // 		element.click();
    // 	});
    // }
    render() {
        const chartData = this.getChartData(this.state.sorted_data);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-centered is-mobile",
                style: {
                    transition: "opacity 0.5s",
                    opacity: "1"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
                            link_chain_data: [
                                (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
                                (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(this.props.guild_data),
                                (0, _dashboardUtils.DashboardUtils).RenderPollSelectionLinkChain(this.props.guild_data),
                                (0, _dashboardUtils.DashboardUtils).RenderPollResultsLinkChain(this.props.guild_data, this.props.poll.message_id)
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            className: "title is-3 has-text-centered !mb-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-poll fa-lg title-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    children: this.props.poll.poll_name
                                }),
                                " Data"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-multiline is-mobile",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "column is-narrow",
                                    children: [
                                        "Total Votes",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        "Unique Voters",
                                        this.props.poll.is_anonymous && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                "Anonymous Poll"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                        children: [
                                            this.props.poll.vote_count,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            this.props.unique_vote_count
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-vcentered is-centered is-multiline is-mobile",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-one-third",
                                    children: this.renderPieChartList(chartData)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-two-thirds",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "columns is-multiline is-mobile",
                                        children: [
                                            this.renderPieChart(chartData, this.props.poll.vote_count > 0),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "column",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "columns",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "column",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "is-pulled-right",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResultsCSVDownload, {})
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        this.createVoterList(chartData)
                    ]
                })
            })
        });
    }
    renderPieChart(chartData, has_votes_recorded) {
        if (!has_votes_recorded) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column is-full",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-multiline is-centered is-vcentered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full",
                        children: "No votes recorded."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-full"
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "column is-full",
            "data-tip": "",
            "data-for": "chart",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMinimalPieChart.PieChart), {
                    //totalValue={1000}
                    data: chartData.filter((val)=>val.value > 0),
                    // TODO: don't add '...' if char limit isnt reached
                    label: ({ dataEntry })=>{
                        let stringified_name = dataEntry.title.toString();
                        return stringified_name.length > 10 ? stringified_name.substring(0, 10) + "..." : stringified_name;
                    },
                    labelStyle: {
                        fill: "#fff",
                        opacity: 0.75,
                        fontSize: "0.2em"
                    },
                    labelPosition: 112,
                    radius: PIE_CHART_RADIUS,
                    lineWidth: INNER_RADIUS,
                    segmentsStyle: {
                        transition: "stroke .3s",
                        cursor: "pointer"
                    },
                    animate: true,
                    segmentsShift: (index)=>{
                        if (index === this.state.chart_selected_index) return 6;
                        if (index === this.state.chart_hovered_index) return 2;
                        return 0;
                    },
                    onClick: this.onChartClicked,
                    onMouseOver: (event, index)=>this.onChartMouseOver(event, index, true),
                    onMouseOut: this.onChartMouseOut
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                    id: "chart",
                    getContent: ()=>{
                        return typeof this.state.chart_hovered_index === "number" && this.state.should_display_tooltip ? this.makePieChartHoverTooltip(this.state.sorted_data[this.state.chart_hovered_index]) : null;
                    }
                })
            ]
        });
    }
}
function ResultsCSVDownload() {
    let { server_id, message_id } = (0, _reactRouter.useParams)();
    const mutation = (0, _trpc.trpc).poll.resultsCsv.useMutation({
        onSuccess: (data)=>{
            (0, _index.stringify)(data, (err, output)=>{
                if (err) {
                    (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(err.toString());
                    return;
                }
                const element = document.createElement("a");
                const file = new Blob([
                    output
                ], {
                    type: "text/plain"
                });
                element.href = URL.createObjectURL(file);
                element.download = `poll_results_${message_id}.csv`;
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _csvDownload.CSVDownload), {
        is_loading: mutation.isLoading,
        onClick: ()=>mutation.mutate({
                guild_id: server_id,
                message_id
            })
    });
}
function VoteColorBox(props) {
    const sorted_indices = [
        ...props.option_indices
    ].sort((a, b)=>a - b);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: sorted_indices.map((val, index)=>{
            const chart_data = props.chart_data.find((data)=>data.original_index === val);
            if (!chart_data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "color-box pie-chart-list",
                        style: {
                            backgroundColor: chart_data.color
                        }
                    }),
                    props.include_title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: chart_data.title
                    })
                ]
            }, val);
        })
    });
}

},{"react/jsx-runtime":"dpQXr","csv-stringify/lib/index":"i03fZ","luxon":"fLWpi","react":"IMRgT","../../../src/vendored/FadeIn":"aMGHU","react-minimal-pie-chart":"6416O","react-router":"djWTS","react-tooltip":"aF9AC","../../../common/sesh_types":"aUAOg","../../../common/time_format_utils":"g0uQN","./dashboard_utils":"jvA8A","./forms/improved_components/csv_download":"6sVFK","./forms/improved_components/poll_results_voter_list":"lUGLq","./forms/poll_options":"1KdWt","./utils/trpc":"dyYvM","./web_ui":"7f1Tj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6416O":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("32fecae660aadf99"));
})(this, function(exports1, React) {
    'use strict';
    function degreesToRadians(degrees) {
        return degrees * Math.PI / 180;
    }
    function valueBetween(value, min, max) {
        if (value > max) return max;
        if (value < min) return min;
        return value;
    }
    function extractPercentage(value, percentage) {
        return percentage / 100 * value;
    }
    function bisectorAngle(startAngle, lengthAngle) {
        return startAngle + lengthAngle / 2;
    }
    function shiftVectorAlongAngle(angle, distance) {
        var angleRadians = degreesToRadians(angle);
        return {
            dx: distance * Math.cos(angleRadians),
            dy: distance * Math.sin(angleRadians)
        };
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function functionProp(prop, payload) {
        return typeof prop === 'function' ? prop(payload) : prop;
    }
    function makePropsWithDefaults(props, defaultProps) {
        var result = Object.assign({}, defaultProps, props);
        // @NOTE Object.assign doesn't default properties with undefined value (like React defaultProps does)
        for(var key in defaultProps)if (props[key] === undefined) result[key] = defaultProps[key];
        return result;
    }
    function sumValues(data) {
        var sum = 0;
        for(var i = 0; i < data.length; i++)sum += data[i].value;
        return sum;
    }
    // Append "percentage", "degrees" and "startAngle" to each data entry
    function extendData(_ref) {
        var data = _ref.data, totalAngle = _ref.lengthAngle, totalValue = _ref.totalValue, paddingAngle = _ref.paddingAngle, chartStartAngle = _ref.startAngle;
        var total = totalValue || sumValues(data);
        var normalizedTotalAngle = valueBetween(totalAngle, -360, 360);
        var numberOfPaddings = Math.abs(normalizedTotalAngle) === 360 ? data.length : data.length - 1;
        var singlePaddingDegrees = Math.abs(paddingAngle) * Math.sign(totalAngle);
        var degreesTakenByPadding = singlePaddingDegrees * numberOfPaddings;
        var degreesTakenByPaths = normalizedTotalAngle - degreesTakenByPadding;
        var lastSegmentEnd = 0;
        var extendedData = [];
        // @NOTE: Shall we evaluate percentage accordingly to dataEntry.value's sign?
        for(var i = 0; i < data.length; i++){
            var dataEntry = data[i];
            var valueInPercentage = total === 0 ? 0 : dataEntry.value / total * 100;
            var degrees = extractPercentage(degreesTakenByPaths, valueInPercentage);
            var startAngle = lastSegmentEnd + chartStartAngle;
            lastSegmentEnd = lastSegmentEnd + degrees + singlePaddingDegrees;
            extendedData.push(Object.assign({
                percentage: valueInPercentage,
                startAngle: startAngle,
                degrees: degrees
            }, dataEntry));
        }
        return extendedData;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function ReactMinimalPieChartLabel(_ref) {
        var renderLabel = _ref.renderLabel, labelProps = _ref.labelProps;
        var label = renderLabel(labelProps);
        // Default label
        if (typeof label === 'string' || typeof label === 'number') {
            labelProps.dataEntry;
            labelProps.dataIndex;
            var props = _objectWithoutPropertiesLoose(labelProps, [
                "dataEntry",
                "dataIndex"
            ]);
            return /*#__PURE__*/ React.createElement("text", Object.assign({
                dominantBaseline: "central"
            }, props), label);
        }
        if (React.isValidElement(label)) return label;
        return null;
    }
    function round(number) {
        var divisor = 1e14; // 14 decimals
        return Math.round((number + Number.EPSILON) * divisor) / divisor;
    }
    function evaluateTextAnchorPosition(_ref) {
        var labelPosition = _ref.labelPosition, lineWidth = _ref.lineWidth, labelHorizontalShift = _ref.labelHorizontalShift;
        var dx = round(labelHorizontalShift);
        // Label in the vertical center
        if (dx === 0) return 'middle';
        // Outward label
        if (labelPosition > 100) return dx > 0 ? 'start' : 'end';
        // Inward label
        var innerRadius = 100 - lineWidth;
        if (labelPosition < innerRadius) return dx > 0 ? 'end' : 'start';
        // Overlying label
        return 'middle';
    }
    function makeLabelRenderProps(data, props) {
        return data.map(function(dataEntry, index) {
            var _functionProp;
            var segmentsShift = (_functionProp = functionProp(props.segmentsShift, index)) != null ? _functionProp : 0;
            var distanceFromCenter = extractPercentage(props.radius, props.labelPosition) + segmentsShift;
            var _shiftVectorAlongAngl = shiftVectorAlongAngle(bisectorAngle(dataEntry.startAngle, dataEntry.degrees), distanceFromCenter), dx = _shiftVectorAlongAngl.dx, dy = _shiftVectorAlongAngl.dy; // This object is passed as argument to the "label" function prop
            var labelRenderProps = {
                x: props.center[0],
                y: props.center[1],
                dx: dx,
                dy: dy,
                textAnchor: evaluateTextAnchorPosition({
                    labelPosition: props.labelPosition,
                    lineWidth: props.lineWidth,
                    labelHorizontalShift: dx
                }),
                dataEntry: dataEntry,
                dataIndex: index,
                style: functionProp(props.labelStyle, index)
            };
            return labelRenderProps;
        });
    }
    function renderLabels(data, props) {
        var label = props.label;
        if (label) return makeLabelRenderProps(data, props).map(function(labelRenderProps, index) {
            return /*#__PURE__*/ React.createElement(ReactMinimalPieChartLabel, {
                key: "label-" + (labelRenderProps.dataEntry.key || index),
                renderLabel: label,
                labelProps: labelRenderProps
            });
        });
    }
    // from http://stackoverflow.com/a/18473154
    var partialCircle = function partialCircle(cx, cy, r, start, end) {
        var length = end - start;
        if (length === 0) return [];
        var fromX = r * Math.cos(start) + cx;
        var fromY = r * Math.sin(start) + cy;
        var toX = r * Math.cos(end) + cx;
        var toY = r * Math.sin(end) + cy;
        var large = Math.abs(length) <= Math.PI ? '0' : '1';
        var sweep = length < 0 ? '0' : '1';
        return [
            [
                'M',
                fromX,
                fromY
            ],
            [
                'A',
                r,
                r,
                0,
                large,
                sweep,
                toX,
                toY
            ]
        ];
    };
    var svgPartialCircle = partialCircle;
    var partialCircle$1 = svgPartialCircle;
    function makePathCommands(cx, cy, startAngle, lengthAngle, radius) {
        var patchedLengthAngle = valueBetween(lengthAngle, -359.999, 359.999);
        return partialCircle$1(cx, cy, // center X and Y
        radius, degreesToRadians(startAngle), degreesToRadians(startAngle + patchedLengthAngle)).map(function(command) {
            return command.join(' ');
        }).join(' ');
    }
    function ReactMinimalPieChartPath(_ref) {
        var cx = _ref.cx, cy = _ref.cy, lengthAngle = _ref.lengthAngle, lineWidth = _ref.lineWidth, radius = _ref.radius, _ref$shift = _ref.shift, shift = _ref$shift === void 0 ? 0 : _ref$shift, reveal = _ref.reveal, rounded = _ref.rounded, startAngle = _ref.startAngle, title = _ref.title, props = _objectWithoutPropertiesLoose(_ref, [
            "cx",
            "cy",
            "lengthAngle",
            "lineWidth",
            "radius",
            "shift",
            "reveal",
            "rounded",
            "startAngle",
            "title"
        ]);
        var pathRadius = radius - lineWidth / 2;
        //@NOTE This shift might be rendered as a translation in future
        var _shiftVectorAlongAngl = shiftVectorAlongAngle(bisectorAngle(startAngle, lengthAngle), shift), dx = _shiftVectorAlongAngl.dx, dy = _shiftVectorAlongAngl.dy;
        var pathCommands = makePathCommands(cx + dx, cy + dy, startAngle, lengthAngle, pathRadius);
        var strokeDasharray;
        var strokeDashoffset;
        // Animate/hide paths with "stroke-dasharray" + "stroke-dashoffset"
        // https://css-tricks.com/svg-line-animation-works/
        if (isNumber(reveal)) {
            var pathLength = degreesToRadians(pathRadius) * lengthAngle;
            strokeDasharray = Math.abs(pathLength);
            strokeDashoffset = strokeDasharray - extractPercentage(strokeDasharray, reveal);
        }
        return /*#__PURE__*/ React.createElement("path", Object.assign({
            d: pathCommands,
            fill: "none",
            strokeWidth: lineWidth,
            strokeDasharray: strokeDasharray,
            strokeDashoffset: strokeDashoffset,
            strokeLinecap: rounded ? 'round' : undefined
        }, props), title && /*#__PURE__*/ React.createElement("title", null, title));
    }
    function combineSegmentTransitionsStyle(duration, easing, customStyle) {
        // Merge chart's animation CSS transition with "transition" found to customStyle
        var transition = "stroke-dashoffset " + duration + "ms " + easing;
        if (customStyle && customStyle.transition) transition = transition + "," + customStyle.transition;
        return {
            transition: transition
        };
    }
    function getRevealValue(props) {
        //@NOTE When animation is on, chart has to be fully revealed when reveal is not set
        if (props.animate && !isNumber(props.reveal)) return 100;
        return props.reveal;
    }
    function makeEventHandler(eventHandler, payload) {
        return eventHandler && function(e) {
            eventHandler(e, payload);
        };
    }
    function renderSegments(data, props, revealOverride) {
        // @NOTE this should go in Path component. Here for performance reasons
        var reveal = revealOverride != null ? revealOverride : getRevealValue(props);
        var radius = props.radius, _props$center = props.center, cx = _props$center[0], cy = _props$center[1];
        var lineWidth = extractPercentage(radius, props.lineWidth);
        var paths = data.map(function(dataEntry, index) {
            var segmentsStyle = functionProp(props.segmentsStyle, index);
            return /*#__PURE__*/ React.createElement(ReactMinimalPieChartPath, {
                cx: cx,
                cy: cy,
                key: dataEntry.key || index,
                lengthAngle: dataEntry.degrees,
                lineWidth: lineWidth,
                radius: radius,
                rounded: props.rounded,
                reveal: reveal,
                shift: functionProp(props.segmentsShift, index),
                startAngle: dataEntry.startAngle,
                title: dataEntry.title,
                style: Object.assign({}, segmentsStyle, props.animate && combineSegmentTransitionsStyle(props.animationDuration, props.animationEasing, segmentsStyle)),
                stroke: dataEntry.color,
                tabIndex: props.segmentsTabIndex,
                onBlur: makeEventHandler(props.onBlur, index),
                onClick: makeEventHandler(props.onClick, index),
                onFocus: makeEventHandler(props.onFocus, index),
                onKeyDown: makeEventHandler(props.onKeyDown, index),
                onMouseOver: makeEventHandler(props.onMouseOver, index),
                onMouseOut: makeEventHandler(props.onMouseOut, index)
            });
        });
        if (props.background) paths.unshift(/*#__PURE__*/ React.createElement(ReactMinimalPieChartPath, {
            cx: cx,
            cy: cy,
            key: "bg",
            lengthAngle: props.lengthAngle,
            lineWidth: lineWidth,
            radius: radius,
            rounded: props.rounded,
            startAngle: props.startAngle,
            stroke: props.background
        }));
        return paths;
    }
    var defaultProps = {
        animationDuration: 500,
        animationEasing: 'ease-out',
        center: [
            50,
            50
        ],
        data: [],
        labelPosition: 50,
        lengthAngle: 360,
        lineWidth: 100,
        paddingAngle: 0,
        radius: 50,
        startAngle: 0,
        viewBoxSize: [
            100,
            100
        ]
    };
    function ReactMinimalPieChart(originalProps) {
        var props = makePropsWithDefaults(originalProps, // @ts-expect-error: defaultProps.data is typed as BaseDataEntry
        defaultProps);
        var _useState = React.useState(props.animate ? 0 : null), revealOverride = _useState[0], setRevealOverride = _useState[1];
        React.useEffect(function() {
            if (props.animate) // Trigger initial animation
            setRevealOverride(null);
        }, []);
        var extendedData = extendData(props);
        return /*#__PURE__*/ React.createElement("svg", {
            viewBox: "0 0 " + props.viewBoxSize[0] + " " + props.viewBoxSize[1],
            width: "100%",
            height: "100%",
            className: props.className,
            style: props.style
        }, renderSegments(extendedData, props, revealOverride), renderLabels(extendedData, props), props.children);
    }
    exports1.PieChart = ReactMinimalPieChart;
    exports1.pieChartDefaultProps = defaultProps;
});

},{"32fecae660aadf99":"IMRgT"}],"aF9AC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReactTooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _uuid = require("uuid");
var global = arguments[3];
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self1);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();
var objectGetOwnPropertyDescriptor = {};
var fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var fails$8 = fails$9;
// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var fails$7 = fails$9;
var functionBindNative = !fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var NATIVE_BIND$2 = functionBindNative;
var call$4 = Function.prototype.call;
var functionCall = NATIVE_BIND$2 ? call$4.bind(call$4) : function() {
    return call$4.apply(call$4, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var NATIVE_BIND$1 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var call$3 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$1.bind.bind(call$3, call$3);
var functionUncurryThisRaw = function(fn) {
    return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function() {
        return call$3.apply(fn, arguments);
    };
};
var uncurryThisRaw$1 = functionUncurryThisRaw;
var toString$1 = uncurryThisRaw$1({}.toString);
var stringSlice = uncurryThisRaw$1(''.slice);
var classofRaw$2 = function(it) {
    return stringSlice(toString$1(it), 8, -1);
};
var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;
var functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
};
var uncurryThis$9 = functionUncurryThis;
var fails$6 = fails$9;
var classof$3 = classofRaw$2;
var $Object$3 = Object;
var split = uncurryThis$9(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object$3('z').propertyIsEnumerable(0);
}) ? function(it) {
    return classof$3(it) == 'String' ? split(it, '') : $Object$3(it);
} : $Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var isNullOrUndefined$1 = isNullOrUndefined$2;
var $TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function(it) {
    if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;
var toIndexedObject$4 = function(it) {
    return IndexedObject$1(requireObjectCoercible$1(it));
};
var documentAll$2 = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;
var documentAll_1 = {
    all: documentAll$2,
    IS_HTMLDDA: IS_HTMLDDA
};
var $documentAll$1 = documentAll_1;
var documentAll$1 = $documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$c = $documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === documentAll$1;
} : function(argument) {
    return typeof argument == 'function';
};
var isCallable$b = isCallable$c;
var $documentAll = documentAll_1;
var documentAll = $documentAll.all;
var isObject$6 = $documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : isCallable$b(it) || it === documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : isCallable$b(it);
};
var global$9 = global$a;
var isCallable$a = isCallable$c;
var aFunction = function(argument) {
    return isCallable$a(argument) ? argument : undefined;
};
var getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};
var uncurryThis$8 = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);
var getBuiltIn$4 = getBuiltIn$5;
var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';
var global$8 = global$a;
var userAgent = engineUserAgent;
var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
var engineV8Version = version;
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = engineV8Version;
var fails$5 = fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var getBuiltIn$3 = getBuiltIn$5;
var isCallable$9 = isCallable$c;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var $Object$2 = Object;
var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = getBuiltIn$3('Symbol');
    return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};
var $String$1 = String;
var tryToString$1 = function(argument) {
    try {
        return $String$1(argument);
    } catch (error) {
        return 'Object';
    }
};
var isCallable$8 = isCallable$c;
var tryToString = tryToString$1;
var $TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var aCallable$2 = function(argument) {
    if (isCallable$8(argument)) return argument;
    throw $TypeError$4(tryToString(argument) + ' is not a function');
};
var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};
var call$2 = functionCall;
var isCallable$7 = isCallable$c;
var isObject$5 = isObject$6;
var $TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
    if (isCallable$7(fn = input.valueOf) && !isObject$5(val = call$2(fn, input))) return val;
    if (pref !== 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
    throw $TypeError$3("Can't convert object to primitive value");
};
var shared$3 = {
    exports: {}
};
var global$7 = global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;
var defineGlobalProperty$3 = function(key, value) {
    try {
        defineProperty$2(global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global$7[key] = value;
    }
    return value;
};
var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$3.exports = function(key, value) {
    return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.25.5',
    mode: 'global',
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});
var requireObjectCoercible = requireObjectCoercible$2;
var $Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function(argument) {
    return $Object$1(requireObjectCoercible(argument));
};
var uncurryThis$7 = functionUncurryThis;
var toObject$1 = toObject$2;
var hasOwnProperty = uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject$1(it), key);
};
var uncurryThis$6 = functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString = uncurryThis$6(1.0.toString);
var uid$2 = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};
var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;
var wellKnownSymbol$5 = function(name) {
    if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
        var description = 'Symbol.' + name;
        if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
    return WellKnownSymbolsStore[name];
};
var call$1 = functionCall;
var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$4 = wellKnownSymbol$5;
var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$4('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function(input, pref) {
    if (!isObject$4(input) || isSymbol$1(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call$1(exoticToPrim, input, pref);
        if (!isObject$4(result) || isSymbol$1(result)) return result;
        throw $TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return ordinaryToPrimitive(input, pref);
};
var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function(argument) {
    var key = toPrimitive(argument, 'string');
    return isSymbol(key) ? key : key + '';
};
var global$4 = global$a;
var isObject$3 = isObject$6;
var document$1 = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);
var documentCreateElement$1 = function(it) {
    return EXISTS$1 ? document$1.createElement(it) : {};
};
var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var DESCRIPTORS$6 = descriptors;
var call = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject$3(O);
    P = toPropertyKey$1(P);
    if (IE8_DOM_DEFINE$1) try {
        return $getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype != 42;
});
var isObject$2 = isObject$6;
var $String = String;
var $TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var anObject$4 = function(argument) {
    if (isObject$2(argument)) return argument;
    throw $TypeError$1($String(argument) + ' is not an object');
};
var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$3 = anObject$4;
var toPropertyKey = toPropertyKey$2;
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    anObject$3(O);
    P = toPropertyKey(P);
    anObject$3(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject$3(O);
    P = toPropertyKey(P);
    anObject$3(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;
var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function(object, key, value) {
    return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var makeBuiltIn$2 = {
    exports: {}
};
var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable);
var functionName = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};
var uncurryThis$5 = functionUncurryThis;
var isCallable$6 = isCallable$c;
var store$1 = sharedStore;
var functionToString = uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$6(store$1.inspectSource)) store$1.inspectSource = function(it) {
    return functionToString(it);
};
var inspectSource$2 = store$1.inspectSource;
var global$3 = global$a;
var isCallable$5 = isCallable$c;
var WeakMap$1 = global$3.WeakMap;
var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));
var shared$1 = shared$3.exports;
var uid = uid$2;
var keys = shared$1('keys');
var sharedKey$2 = function(key) {
    return keys[key] || (keys[key] = uid(key));
};
var hiddenKeys$4 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$2 = global$a;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject$1(it) || (state = get(it)).type !== TYPE) throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey$1('state');
    hiddenKeys$3[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty$1(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn$3(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn$3(it, STATE);
    };
}
var internalState = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};
var fails$2 = fails$9;
var isCallable$4 = isCallable$c;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule = internalState;
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;
var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function() {
    return defineProperty$1(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn$1 = makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!hasOwn$2(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS$1) defineProperty$1(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) defineProperty$1(value, 'length', {
        value: options.arity
    });
    try {
        if (options && hasOwn$2(options, 'constructor') && options.constructor) {
            if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn$2(state, 'source')) state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
    return isCallable$4(this) && getInternalState(this).source || inspectSource$1(this);
}, 'toString');
var isCallable$3 = isCallable$c;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable$3(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};
var trunc = mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};
var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;
var max = Math.max;
var min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function(index, length) {
    var integer = toIntegerOrInfinity$1(index);
    return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};
var toIntegerOrInfinity = toIntegerOrInfinity$2;
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function(argument) {
    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var toLength = toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function(obj) {
    return toLength(obj.length);
};
var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject$2($this);
        var length = lengthOfArrayLike$1(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod$1(false)
};
var uncurryThis$4 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;
var push$1 = uncurryThis$4([].push);
var objectKeysInternal = function(object, names) {
    var O = toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn$1(O, key = names[i++])) ~indexOf(result, key) || push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var enumBugKeys$3 = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys$1(O, hiddenKeys$1);
};
var objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$2 = getBuiltIn$5;
var uncurryThis$3 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$2 = anObject$4;
var concat = uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject$2(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};
var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule$1.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var fails$1 = fails$9;
var isCallable$2 = isCallable$c;
var replacement = /#|\.prototype\./;
var isForced$1 = function(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : isCallable$2(detection) ? fails$1(detection) : !!detection;
};
var normalize = isForced$1.normalize = function(string) {
    return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';
var isForced_1 = isForced$1;
var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var _export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = global$1;
    else if (STATIC) target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
    else target = (global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$2;
var NATIVE_BIND = functionBindNative;
var bind$1 = uncurryThis$2(uncurryThis$2.bind);
// optional / simple context binding
var functionBindContext = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var classof$2 = classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
    return classof$2(argument) == 'Array';
};
var wellKnownSymbol$3 = wellKnownSymbol$5;
var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');
var test = {};
test[TO_STRING_TAG$1] = 'z';
var toStringTagSupport = String(test) === '[object z]';
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$c;
var classofRaw = classofRaw$2;
var wellKnownSymbol$2 = wellKnownSymbol$5;
var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};
var uncurryThis$1 = functionUncurryThis;
var fails = fails$9;
var isCallable = isCallable$c;
var classof = classof$1;
var getBuiltIn$1 = getBuiltIn$5;
var inspectSource = inspectSource$2;
var noop = function() {};
var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$1(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$6;
var wellKnownSymbol$1 = wellKnownSymbol$5;
var SPECIES = wellKnownSymbol$1('species');
var $Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $Array : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind = functionBindContext;
var uncurryThis = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject = toObject$2;
var lengthOfArrayLike = lengthOfArrayLike$2;
var arraySpeciesCreate = arraySpeciesCreate$1;
var push = uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self1 = IndexedObject(O);
        var boundFunction = bind(callbackfn, that);
        var length = lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$1 = anObject$4;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject$1(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var getBuiltIn = getBuiltIn$5;
var html$1 = getBuiltIn('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */ var anObject = anObject$4;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var JS = 'java' + SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};
var wellKnownSymbol = wellKnownSymbol$5;
var create = objectCreate;
var defineProperty = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
});
// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};
var $ = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$1;
var FIND = 'find';
var SKIPS_HOLES = true;
// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);
var CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
/**
 * Static methods for react-tooltip
 */ var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute('currentItem', 'false');
    else targetArray[i].setAttribute('currentItem', 'true');
};
var customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: _defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function(event) {
            ele.removeEventListener(event, customListeners.get(ele, event));
            var customListener = checkStatus.bind(_this, dataEventOff);
            customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(' ').forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
/**
 * Util method to get effect
 */ var makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === 'function') proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute('data-tip') || null;
        forId = target.getAttribute('data-for') || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = getBody();
        var customEvents = findCustomEvents(targetArray, 'data-event');
        var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside('top'),
        bottom: inside('bottom'),
        left: inside('left'),
        right: inside('right')
    };
    function choose() {
        var allPlaces = desiredPlace.split(',').concat(place, [
            'top',
            'bottom',
            'left',
            'right'
        ]);
        var _iterator = _createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === 'top') extraOffsetY -= parseInt(offset[key], 10);
        else if (key === 'bottom') extraOffsetY += parseInt(offset[key], 10);
        else if (key === 'left') extraOffsetX -= parseInt(offset[key], 10);
        else if (key === 'right') extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function generateUUID() {
    return 't' + (0, _uuid.v4)();
}
var baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
/**
 * Default pop-up style values (text color, background color).
 */ var defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function getDefaultPopupColors(type) {
    return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}
var DEFAULT_PADDING = '8px 21px';
var DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return generateStyle(uuid, getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n\t    border-radius: ").concat(tooltipRadius, "px;\n\t    padding: ").concat(padding, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-top::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: 1;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-bottom::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: 1;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-left::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: 1;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-right::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: 1;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === 'light' ? 'black' : 'white';
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var _class, _class2;
/* Polyfill */ var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_class2 = /*#__PURE__*/ function(_React$Component) {
    _inherits(ReactTooltip, _React$Component);
    var _super = _createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        _classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || generateUUID(),
            place: props.place || 'top',
            // Direction of tooltip
            desiredPlace: props.place || 'top',
            type: props.type || 'dark',
            // Color theme of tooltip
            effect: props.effect || 'float',
            // float or fixed
            show: false,
            border: false,
            borderClass: 'border',
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ _createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case 'Document':
                    case 'HTMLDocument':
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case 'ShadowRoot':
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector('style[data-react-tooltip]')) {
                    var style = document.createElement('style');
                    style.textContent = baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = '[data-tip]:not([data-for])';
                else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
                }
                // Scan document for shadow DOM elements
                nodeListToArray(document.getElementsByTagName('*')).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute('currentItem') === null) target.setAttribute('currentItem', 'false');
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                    target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
                    if (effect === 'float') target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                    target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute('aria-describedby', this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(',')[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(',')[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self1.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self1.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self1.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self1.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute('data-tooltip-radius') || self1.props.tooltipRadius || '3',
                            arrow: target.getAttribute('data-arrow-radius') || self1.props.arrowRadius || '0'
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute('data-padding') || self1.props.padding,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self1.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self1.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self1.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self1.props.border) || false,
                        borderClass: target.getAttribute('data-border-class') || self1.props.borderClass || 'border',
                        extraClass: target.getAttribute('data-class') || self1.props["class"] || self1.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = TipContent(originTooltip, '', _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute('aria-describedby');
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === 'function') callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' ' + this.state.borderClass : '') + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = "".concat(content, "\n<style aria-hidden=\"true\">").concat(style, "</style>");
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, _extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, _extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, _propTypesDefault.default).string,
                    children: (0, _propTypesDefault.default).any,
                    place: (0, _propTypesDefault.default).string,
                    type: (0, _propTypesDefault.default).string,
                    effect: (0, _propTypesDefault.default).string,
                    offset: (0, _propTypesDefault.default).object,
                    padding: (0, _propTypesDefault.default).string,
                    multiline: (0, _propTypesDefault.default).bool,
                    border: (0, _propTypesDefault.default).bool,
                    borderClass: (0, _propTypesDefault.default).string,
                    textColor: (0, _propTypesDefault.default).string,
                    backgroundColor: (0, _propTypesDefault.default).string,
                    borderColor: (0, _propTypesDefault.default).string,
                    arrowColor: (0, _propTypesDefault.default).string,
                    arrowRadius: (0, _propTypesDefault.default).string,
                    tooltipRadius: (0, _propTypesDefault.default).string,
                    insecure: (0, _propTypesDefault.default).bool,
                    "class": (0, _propTypesDefault.default).string,
                    className: (0, _propTypesDefault.default).string,
                    id: (0, _propTypesDefault.default).string,
                    html: (0, _propTypesDefault.default).bool,
                    delayHide: (0, _propTypesDefault.default).number,
                    delayUpdate: (0, _propTypesDefault.default).number,
                    delayShow: (0, _propTypesDefault.default).number,
                    event: (0, _propTypesDefault.default).string,
                    eventOff: (0, _propTypesDefault.default).string,
                    isCapture: (0, _propTypesDefault.default).bool,
                    globalEventOff: (0, _propTypesDefault.default).string,
                    getContent: (0, _propTypesDefault.default).any,
                    afterShow: (0, _propTypesDefault.default).func,
                    afterHide: (0, _propTypesDefault.default).func,
                    overridePosition: (0, _propTypesDefault.default).func,
                    disable: (0, _propTypesDefault.default).bool,
                    scrollHide: (0, _propTypesDefault.default).bool,
                    resizeHide: (0, _propTypesDefault.default).bool,
                    wrapper: (0, _propTypesDefault.default).string,
                    bodyMode: (0, _propTypesDefault.default).bool,
                    possibleCustomEvents: (0, _propTypesDefault.default).string,
                    possibleCustomEventsOff: (0, _propTypesDefault.default).string,
                    clickable: (0, _propTypesDefault.default).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return _objectSpread2(_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, _reactDefault.default).Component), _defineProperty(_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), _defineProperty(_class2, "supportedWrappers", [
    'div',
    'span'
]), _defineProperty(_class2, "displayName", 'ReactTooltip'), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

},{"react":"IMRgT","prop-types":"iRwZ2","uuid":[["v4","41Fg2","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"41Fg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _bytesToUuidJs = require("./bytesToUuid.js");
var _bytesToUuidJsDefault = parcelHelpers.interopDefault(_bytesToUuidJs);
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, _bytesToUuidJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"42GtR","./bytesToUuid.js":"fEtrQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"42GtR":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function rng() {
    if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fEtrQ":[function(require,module,exports,__globalThis) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
exports.default = bytesToUuid;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lUGLq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PollResultsVoterList", ()=>PollResultsVoterList);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactRouter = require("react-router");
var _constants = require("../../../../../common/constants");
var _dashboardUtils = require("../../dashboard_utils");
var _trpc = require("../../utils/trpc");
var _useGuildMemberCache = require("./hooks/use_guild_member_cache");
var _pageButtons = require("./listings_form/page_buttons");
var _memberDisplayNameWithTooltip = require("./member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
var _withTooltip = require("./tooltips/with_tooltip");
function PollResultsVoterList(props) {
    let { server_id, message_id } = (0, _reactRouter.useParams)();
    const [page, setPage] = (0, _react.useState)(0);
    const members_cache = (0, _useGuildMemberCache.useGuildMemberCache)();
    const voters_query = (0, _trpc.trpc).poll.voters.useQuery({
        guild_id: server_id,
        message_id,
        option_index: props.option_index,
        page
    }, {
        keepPreviousData: true,
        onSuccess: (data)=>members_cache.addMembers(server_id, data.items.map((val)=>val))
    });
    if (voters_query.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(undefined, 3)
    });
    const voters = voters_query.data.items;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _classnamesDefault.default)("flex flex-col", {
                    "input-disabled": voters_query.isPreviousData
                }),
                children: [
                    voters.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-base-light py-2 px-4",
                        children: "None"
                    }),
                    voters.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _classnamesDefault.default)("flex w-full py-2 px-4", {
                                "bg-base-primary": index % 2 !== 0,
                                "bg-base-light": index % 2 === 0
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                                // trigger_props={{
                                // 	className: "w-full",
                                // }}
                                style: "Info",
                                tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                                            user_id: val.id,
                                            include_avatar: true
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ml-2 flex flex-col",
                                            children: props.voteBoxCreator(val.votes, true)
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex min-w-full flex-grow cursor-pointer gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
                                            user_id: val.id,
                                            include_avatar: true,
                                            tooltip_type: "None"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ml-auto flex",
                                            children: props.voteBoxCreator(val.votes)
                                        })
                                    ]
                                })
                            })
                        }, val.id))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageButtons.PageButtons), {
                    page: page,
                    total_items: voters_query.data.total_item_count,
                    setPage: setPage,
                    is_loading: voters_query.isPreviousData,
                    items_per_page: (0, _constants.Constants).POLL_VOTERS_PAGINATION_LIMIT
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","react-router":"djWTS","../../../../../common/constants":"lLiun","../../dashboard_utils":"jvA8A","../../utils/trpc":"dyYvM","./hooks/use_guild_member_cache":"fDOuW","./listings_form/page_buttons":"5paOM","./member_display_name/member_display_name_with_tooltip":"7N9T1","./tooltips/with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6sYWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlurbWrapper", ()=>BlurbWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _blurbBanner = require("./blurb_banner");
function BlurbWrapper({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "inline-flex flex-col",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blurbBanner.BlurbBanner), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-screen",
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./blurb_banner":"37rNA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"37rNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlurbBanner", ()=>BlurbBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _fadeIn = require("../../../../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _boxItem = require("../box_item");
function BlurbBanner() {
    const [isDismissed, setIsDismissed] = (0, _react.useState)(false);
    const utils = (0, _trpc.trpc).useContext();
    const activeBlurbQuery = (0, _trpc.trpc).blurb.getActiveBlurb.useQuery();
    const dismissBlurbMutation = (0, _trpc.trpc).blurb.dismissBlurb.useMutation({
        onSuccess: ()=>{
            utils.blurb.getActiveBlurb.invalidate();
        }
    });
    // Don't show anything while loading or if no active blurb
    if (!activeBlurbQuery.isSuccess || !activeBlurbQuery.data) return null;
    const { id, dashboard_message } = activeBlurbQuery.data;
    if (isDismissed) return null;
    const handleDismiss = async ()=>{
        try {
            await dismissBlurbMutation.mutateAsync({
                blurb_id: id
            });
            setIsDismissed(true);
        } catch (error) {
            console.error("Failed to dismiss blurb:", error);
        }
    };
    // is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd
    // w-11/12 md:w-3/4 lg:w-3/4 xl:w-1/2 2xl:w-2/5
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
        transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "z-[11] mb-6 flex w-full items-center justify-center gap-2",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxItem.BoxItem), {
                bgColor: "semidark",
                className: "column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd border border-sesh-dark",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "relative flex w-full min-w-[256px] items-start justify-between p-4 ",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleDismiss,
                            className: (0, _classnamesDefault.default)("absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full", "bg-base-dark/10 hover:bg-base-dark/20", "transition-colors duration-200"),
                            "aria-label": "Dismiss notification",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-times text-sm"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex w-full items-center gap-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mx-auto whitespace-pre-wrap",
                                dangerouslySetInnerHTML: {
                                    __html: dashboard_message
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../../../../src/vendored/FadeIn":"aMGHU","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../box_item":"gTVlB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3d3dA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderDashboard", ()=>TimeFinderDashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _dashboardUtils = require("../../../dashboard_utils");
var _dashboardContainer = require("../base_components/dashboard_container");
var _useGuildData = require("../hooks/use_guild_data");
var _timeFinderBase = require("./time_finder_base");
var _timeFinderCreate = require("./time_finder_create");
var _timeFinderList = require("./time_finder_list");
var _timeFinderView = require("./time_finder_view");
var _timeFinderEdit = require("./time_finder_edit");
var _react = require("react");
var _webUi = require("../../../web_ui");
function TimeFinderDashboard(props) {
    const guild_data = (0, _useGuildData.useCurrentGuildData)();
    const { instance_id } = (0, _reactRouter.useParams)();
    (0, _react.useEffect)(()=>{
        let action = "";
        switch(props.type){
            case "create":
                action = "Time Finder Create";
                break;
            case "view":
                action = instance_id ? "Time Finder View" : "Time Finder List";
                break;
            case "edit":
                action = "Time Finder Edit";
                break;
            default:
                action = "Time Finder";
        }
        (0, _webUi.setDocTitle)(`${action}`, guild_data?.name);
    }, [
        props.type,
        instance_id,
        guild_data
    ]);
    const link_chain_data = [
        (0, _dashboardUtils.DashboardUtils).GetGuildSelectionLinkChainData(),
        (0, _dashboardUtils.DashboardUtils).RenderGuildOptionSelectLinkChain(guild_data),
        (0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "base")
    ];
    switch(props.type){
        case "create":
            link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "create"));
            break;
        case "view":
            link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "view"));
            if (instance_id) link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "view", instance_id));
            break;
        case "edit":
            link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "view"));
            if (instance_id) link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "view", instance_id));
            // We don't break above
            link_chain_data.push((0, _dashboardUtils.DashboardUtils).RenderTimeFinderSelectionLinkChain(guild_data, "edit", instance_id));
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardContainer.DashboardContainer), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "Time Finder"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "rounded bg-sesh-primary px-1.5 py-0.5 text-xs font-medium uppercase tracking-wider text-black",
                    children: "Beta"
                })
            ]
        }),
        bread_crumbs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderLinkChain, {
            link_chain_data: link_chain_data
        }),
        children: [
            props.type === "base" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderBase.TimeFinderBase), {}),
            props.type === "create" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderCreate.TimeFinderCreate), {}),
            props.type === "view" && !instance_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderList.TimeFinderList), {}),
            props.type === "view" && instance_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderView.TimeFinderView), {
                time_finder_id: instance_id
            }),
            props.type === "edit" && instance_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinderEdit.TimeFinderEdit), {
                time_finder_id: instance_id
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../../dashboard_utils":"jvA8A","../base_components/dashboard_container":"9WDu5","../hooks/use_guild_data":"ljx0Q","./time_finder_base":"jhxPj","./time_finder_create":"4kkZd","./time_finder_list":"cmh1o","./time_finder_view":"4s8RH","./time_finder_edit":"154VM","react":"IMRgT","../../../web_ui":"7f1Tj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jhxPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderBase", ()=>TimeFinderBase);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _dashboardUtils = require("../../../dashboard_utils");
function TimeFinderBase() {
    const history = (0, _reactRouterDom.useHistory)();
    const { server_id } = (0, _reactRouterDom.useParams)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mt-4 flex flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                    button_name: "Create New Time Finder",
                    mobile_button_name: "Create New",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-plus-circle fa-lg title-icon"
                    }),
                    on_click: ()=>history.push(`/dashboard/${server_id}/time-finder/create`),
                    needs_history: false
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).CreateOptionsButton, {
                    button_name: "View Previous Time Finders",
                    mobile_button_name: "View Previous",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-history fa-lg title-icon"
                    }),
                    on_click: ()=>history.push(`/dashboard/${server_id}/time-finder/view`),
                    needs_history: false
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"djWTS","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4kkZd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderCreate", ()=>TimeFinderCreate);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../../../common/common_utils");
var _timeFinder = require("../../../../time-finder/components/time_finder");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _useGuildData = require("../hooks/use_guild_data");
var _useRoles = require("../hooks/use_roles");
function TimeFinderCreate() {
    const { server_id } = (0, _reactRouterDom.useParams)();
    const history = (0, _reactRouterDom.useHistory)();
    const mutation = (0, _trpc.trpc).time_finder.create.useMutation({
        onSuccess: (data)=>{
            history.push((0, _commonUtils.common_utils).getTimeFinderURL({
                server_id,
                type: "view",
                instance_id: data.time_finder_instance_id,
                just_created_view: true
            }));
        }
    });
    const guild = (0, _useGuildData.useCurrentGuildData)();
    const roles = (0, _useRoles.useRoles)();
    const does_have_permission_query = (0, _trpc.trpc).members.doesUserHavePermission.useQuery({
        guild_id: server_id,
        permission: "create"
    }, {
        onSuccess: (val)=>{}
    });
    if (does_have_permission_query.isSuccess && !does_have_permission_query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full  flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderErrorContent, {
            text: "You must have 'create' permissions in order to create a time finder.",
            title: "Invalid Permissions"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinder.AppTimeFinder), {
        onSubmit: (opts)=>{
            console.log(server_id);
            mutation.mutate({
                ...opts,
                guild_id: server_id
            });
        },
        is_loading: mutation.isLoading || mutation.isSuccess || !does_have_permission_query.isSuccess,
        is_public: false,
        is_edit: false,
        is_on_dashboard: true,
        does_have_premium: guild?.is_premium,
        roles: roles
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"djWTS","../../../../../../common/common_utils":"gACUC","../../../../time-finder/components/time_finder":"h3qmW","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../hooks/use_guild_data":"ljx0Q","../hooks/use_roles":"b2XTr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h3qmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TIME_FINDER_SETTINGS", ()=>TIME_FINDER_SETTINGS);
parcelHelpers.export(exports, "AppTimeFinder", ()=>AppTimeFinder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _seshPrimaryButton = require("../../dashboard/forms/improved_components/base_components/sesh_primary_button");
var _textArea = require("../../dashboard/forms/text_area");
var _utils = require("../utils");
var _calendarPicker = require("./calendar-picker");
var _inputSection = require("./input-section");
var _constants = require("../../../../common/constants");
var _dashboardUtils = require("../../dashboard/dashboard_utils");
var _settingsBaseItem = require("../../dashboard/forms/improved_components/settings_items/settings_base_item");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _channelPicker = require("../../dashboard/forms/improved_components/channel_picker");
var _channelPickerDefault = parcelHelpers.interopDefault(_channelPicker);
var _eligibleRolesSettingsItem = require("./eligible_roles_settings_item");
var _combinedMentionsDropdown = require("./combined_mentions_dropdown");
const TIME_FINDER_SETTINGS = {
    anonymous_voting: {
        title: "Anonymous Voting",
        description: "Only poll creator and server admins can see the names of voters"
    },
    hide_votes: {
        title: "Hide Results Until Voted",
        description: "Non-admins can not see other people's votes until after they've voted"
    },
    send_to_discord: {
        title: "Send Time Finder to Discord",
        description: "Post this Time Finder poll to a Discord channel, allowing users to select their availability without leaving Discord"
    }
};
function AppTimeFinder(props) {
    const [title, setTitle] = (0, _react.useState)(props.is_edit ? props.initial_data.title : "");
    const [description, setDescription] = (0, _react.useState)(props.is_edit ? props.initial_data.description : "");
    const [selectedDates, setSelectedDates] = (0, _react.useState)(props.is_edit ? props.initial_data.selected_dates : []);
    const [areTimesSpecified, setAreTimesSpecified] = (0, _react.useState)(props.is_edit ? props.initial_data.are_times_specified : false);
    const [isPublic, setIsPublic] = (0, _react.useState)(props.is_public);
    const [anonymousVoting, setAnonymousVoting] = (0, _react.useState)(props.is_edit ? props.initial_data.anonymous_voting : false);
    const [hideVotes, setHideVotes] = (0, _react.useState)(props.is_edit ? props.initial_data.hide_votes : false);
    const [channelId, setChannelId] = (0, _react.useState)(undefined);
    const [sendToDiscord, setSendToDiscord] = (0, _react.useState)(false);
    const [isRestrictRolesEnabled, setIsRestrictRolesEnabled] = (0, _react.useState)(props.is_edit && props.initial_data.eligible_role_ids ? props.initial_data.eligible_role_ids.length > 0 : false);
    const [eligibleRoleIds, setEligibleRoleIds] = (0, _react.useState)(props.is_edit && props.initial_data.eligible_role_ids ? props.initial_data.eligible_role_ids : []);
    const [userMentionsOnCreate, setUserMentionsOnCreate] = (0, _react.useState)(props.is_edit && props.initial_data.user_mentions_on_create ? props.initial_data.user_mentions_on_create : []);
    const [roleMentionsOnCreate, setRoleMentionsOnCreate] = (0, _react.useState)(props.is_edit && props.initial_data.role_mentions_on_create && props.roles ? props.roles.filter((role)=>props.initial_data.role_mentions_on_create.includes(role.id)) : []);
    function validateForm() {
        const errors = [];
        if (title.trim().length === 0) errors.push("Title is required");
        if (title.length > (0, _constants.Constants).EVENT_CHAR_LIMIT) errors.push(`Title must be less than ${(0, _constants.Constants).EVENT_CHAR_LIMIT} characters`);
        if (description.length > (0, _constants.Constants).TIME_FINDER_DESCRIPTION_CHAR_LIMIT) errors.push(`Description must be less than ${(0, _constants.Constants).TIME_FINDER_DESCRIPTION_CHAR_LIMIT} characters`);
        if (selectedDates.length === 0) errors.push("Select at least one date");
        if (sendToDiscord && !channelId) errors.push("Select a channel to send the Time Finder to");
        return errors;
    }
    function handleSubmit() {
        const errors = validateForm();
        if (errors.length > 0) {
            // Show errors in modal with improved styling
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-4 text-lg font-semibold",
                        children: "Please address the following:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border-l-4 border-red-500 bg-red-500/10 p-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "space-y-2",
                            children: errors.map((error, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    className: "flex items-start",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "mr-2 text-red-500",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-exclamation-circle",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: error
                                        })
                                    ]
                                }, index))
                        })
                    })
                ]
            }), "Please Check Your Input");
            return;
        }
        // If no errors, proceed with form submission
        props.onSubmit({
            title,
            description,
            selected_dates: selectedDates.map((val)=>areTimesSpecified ? val : {
                    ...val,
                    timeslots: undefined
                }),
            are_times_specified: areTimesSpecified,
            is_public: isPublic,
            anonymous_voting: anonymousVoting,
            hide_votes: hideVotes,
            channel_id: sendToDiscord ? channelId : undefined,
            eligible_role_ids: isRestrictRolesEnabled ? eligibleRoleIds : [],
            user_mentions_on_create: sendToDiscord ? userMentionsOnCreate : [],
            role_mentions_on_create: sendToDiscord ? roleMentionsOnCreate.map((r)=>r.id) : []
        });
    }
    function onUpdateSelectedDates(newSelectedDates) {
        newSelectedDates.sort((a, b)=>{
            return a.date.year - b.date.year || a.date.month - b.date.month || a.date.day - b.date.day;
        });
        // Remove duplicate dates by comparing day, month, and year
        const uniqueDates = [];
        for (const date of newSelectedDates){
            const isDuplicate = uniqueDates.some((existingDate)=>existingDate.date.day === date.date.day && existingDate.date.month === date.date.month && existingDate.date.year === date.date.year);
            if (!isDuplicate) {
                // If the date has timeslots, ensure they are unique
                if (date.timeslots && date.timeslots.length > 0) {
                    const uniqueTimeslots = [];
                    for (const timeslot of date.timeslots){
                        const isTimeslotDuplicate = uniqueTimeslots.some((existingTimeslot)=>existingTimeslot.start_time === timeslot.start_time && existingTimeslot.end_time === timeslot.end_time);
                        if (!isTimeslotDuplicate) uniqueTimeslots.push(timeslot);
                    }
                    date.timeslots = uniqueTimeslots;
                }
                uniqueDates.push(date);
            }
        }
        setSelectedDates(uniqueDates);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputSection.InputSection), {
                            title: "Event Details",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mb-2 flex items-center gap-2 pt-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "!mb-0 text-lg font-bold",
                                                    children: "Title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "input",
                                                    type: "text",
                                                    placeholder: "Enter event title",
                                                    value: title,
                                                    onChange: (e)=>setTitle(e.target.value),
                                                    maxLength: (0, _constants.Constants).EVENT_CHAR_LIMIT
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mb-2 flex items-center gap-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "!mb-0 text-lg font-bold",
                                                    children: "Description"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "control",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textArea.TextAreaForm), {
                                                    placeholder: "Enter event description (optional)",
                                                    initial_value: description,
                                                    updateFunc: (val)=>setDescription(val),
                                                    rows: 4,
                                                    char_limit: (0, _constants.Constants).TIME_FINDER_DESCRIPTION_CHAR_LIMIT
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputSection.InputSection), {
                            title: "Days & Times",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex w-full flex-col gap-4",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "calendar-container w-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPicker.CalendarPicker), {
                                        selectedDates: selectedDates,
                                        areTimesSpecified: areTimesSpecified,
                                        onUpdate: onUpdateSelectedDates,
                                        onSpecifyTimesChange: (specifyTimes)=>{
                                            if (specifyTimes) setSelectedDates((0, _utils.updateSelectedDatesOnSpecifyTimeToggled));
                                            setAreTimesSpecified(specifyTimes);
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputSection.InputSection), {
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Settings"
                                    }),
                                    !props.is_on_dashboard && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-base-soft text-xs italic",
                                        children: [
                                            "Advanced settings are only available in the",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "/dashboard",
                                                className: "manual-link",
                                                children: "sesh dashboard"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pt-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                                        label: "Visibility",
                                        no_border: true,
                                        children: props.is_public || props.is_edit || !props.is_on_dashboard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                    disabled: true,
                                                    className: "w-full cursor-not-allowed rounded-md border-none bg-base-dark/50 px-3 py-2 text-sm font-medium text-white/70",
                                                    value: props.is_public ? "public" : "members",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                            value: "public",
                                                            children: "Anyone with the Link"
                                                        }),
                                                        !props.is_public && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                            value: "members",
                                                            children: "Server Members"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-base-soft mt-1 text-xs italic",
                                                    children: props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                        children: "Visibility cannot be changed after poll creation"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                            className: "w-full rounded-md border-none bg-base-dark px-3 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-sesh-primary",
                                            value: isPublic ? "public" : "members",
                                            onChange: (e)=>{
                                                const is_public = e.target.value === "public";
                                                setIsPublic(is_public);
                                                if (is_public) setIsRestrictRolesEnabled(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "members",
                                                    children: "Server Members"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "public",
                                                    children: "Anyone with the Link"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "my-6 border-t border-white/10"
                                    }),
                                    (!props.is_edit || props.is_public) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                                        label: TIME_FINDER_SETTINGS.send_to_discord.title,
                                        description: TIME_FINDER_SETTINGS.send_to_discord.description,
                                        no_border: true,
                                        below_element: sendToDiscord ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "space-y-4 border-t border-white/10 pt-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "font-bold",
                                                            children: "Channel"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-2 text-sm text-content-secondary",
                                                            children: "Select which channel to post the Time Finder to"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelPickerDefault.default), {
                                                            channel_id: channelId,
                                                            setChannel: (channel)=>setChannelId(channel)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "font-bold",
                                                            children: "Mentions"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-2 text-sm text-content-secondary",
                                                            children: "Choose users and roles to mention when posting"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _combinedMentionsDropdown.CombinedMentionsDropdown), {
                                                            roles: props.roles,
                                                            initial_value: {
                                                                user_mentions: userMentionsOnCreate,
                                                                role_mentions: roleMentionsOnCreate
                                                            },
                                                            updateFunc: (val)=>{
                                                                setUserMentionsOnCreate(val.user_mentions);
                                                                setRoleMentionsOnCreate(val.role_mentions);
                                                            },
                                                            disabled: !props.is_on_dashboard
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : undefined,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex items-center justify-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                                checked: sendToDiscord,
                                                onChange: (checked)=>{
                                                    setSendToDiscord(checked);
                                                    if (!checked) {
                                                        setChannelId(undefined);
                                                        setUserMentionsOnCreate([]);
                                                        setRoleMentionsOnCreate([]);
                                                    }
                                                },
                                                disabled: !props.is_on_dashboard,
                                                onColor: "#00c3cc",
                                                onHandleColor: "#00f4ff",
                                                checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    })
                                                }),
                                                uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-times"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    props.is_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                                        label: TIME_FINDER_SETTINGS.send_to_discord.title,
                                        description: "Discord settings cannot be changed after creation",
                                        no_border: true,
                                        below_element: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "space-y-4 border-t border-white/10 pt-4 opacity-60",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "font-bold",
                                                            children: "Discord Channel"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-2 text-sm text-content-secondary",
                                                            children: props.is_edit && props.initial_data?.channel_id ? "This Time Finder was sent to the following Discord channel:" : "This Time Finder was not sent to Discord when created"
                                                        }),
                                                        props.is_edit && props.initial_data?.channel_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-full rounded-md border-none bg-base-dark/50 px-3 py-2 text-sm font-medium text-white/70",
                                                            children: props.initial_data.channel_name || props.initial_data.channel_id
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "font-bold",
                                                            children: "Current Mentions"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-2 text-sm text-content-secondary",
                                                            children: props.initial_data?.user_mentions_on_create?.length > 0 || props.initial_data?.role_mentions_on_create?.length > 0 ? `These mentions were set when the Time Finder was created:` : "No mentions were set when this Time Finder was created"
                                                        }),
                                                        (props.initial_data?.user_mentions_on_create?.length > 0 || props.initial_data?.role_mentions_on_create?.length > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "space-y-2",
                                                            children: [
                                                                props.initial_data?.user_mentions_on_create?.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "w-full rounded-md border-none bg-base-dark/50 px-3 py-2 text-sm font-medium text-white/70",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "mb-1 font-semibold",
                                                                            children: [
                                                                                "Users (",
                                                                                props.initial_data.user_mentions_on_create.length,
                                                                                "):"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-xs text-white/60",
                                                                            children: props.initial_data.user_mentions_on_create.map((userId, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    children: [
                                                                                        userId,
                                                                                        index < props.initial_data.user_mentions_on_create.length - 1 ? ", " : ""
                                                                                    ]
                                                                                }, userId))
                                                                        })
                                                                    ]
                                                                }),
                                                                props.initial_data?.role_mentions_on_create?.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "w-full rounded-md border-none bg-base-dark/50 px-3 py-2 text-sm font-medium text-white/70",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "mb-1 font-semibold",
                                                                            children: [
                                                                                "Roles (",
                                                                                props.initial_data.role_mentions_on_create.length,
                                                                                "):"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-xs text-white/60",
                                                                            children: props.initial_data.role_mentions_on_create.map((roleId, index)=>{
                                                                                const role = props.roles?.find((r)=>r.id === roleId);
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "inline-flex items-center gap-1",
                                                                                    children: [
                                                                                        role && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "h-2 w-2 rounded-full",
                                                                                            style: {
                                                                                                backgroundColor: role.color || "#99aab5"
                                                                                            }
                                                                                        }),
                                                                                        role?.name || roleId,
                                                                                        index < props.initial_data.role_mentions_on_create.length - 1 ? ", " : ""
                                                                                    ]
                                                                                }, roleId);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex items-center justify-end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                                checked: props.is_edit && !!props.initial_data?.channel_id || userMentionsOnCreate.length > 0 || roleMentionsOnCreate.length > 0,
                                                onChange: ()=>{
                                                // Do nothing - disabled
                                                },
                                                disabled: true,
                                                onColor: "#00c3cc",
                                                onHandleColor: "#00f4ff",
                                                checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    })
                                                }),
                                                uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-times"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "my-6 border-t border-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                                        label: TIME_FINDER_SETTINGS.anonymous_voting.title,
                                        is_premium: true,
                                        description: TIME_FINDER_SETTINGS.anonymous_voting.description,
                                        no_border: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex items-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                                checked: props.does_have_premium && anonymousVoting,
                                                onChange: (checked)=>{
                                                    if (props.does_have_premium) setAnonymousVoting(checked);
                                                },
                                                disabled: !props.is_on_dashboard || !props.does_have_premium,
                                                onColor: "#00c3cc",
                                                onHandleColor: "#00f4ff",
                                                checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    })
                                                }),
                                                uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-times"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "my-6 border-t border-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
                                        label: TIME_FINDER_SETTINGS.hide_votes.title,
                                        is_premium: true,
                                        description: TIME_FINDER_SETTINGS.hide_votes.description,
                                        no_border: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex items-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                                checked: props.does_have_premium && hideVotes,
                                                onChange: (checked)=>{
                                                    if (props.does_have_premium) setHideVotes(checked);
                                                },
                                                disabled: !props.is_on_dashboard || !props.does_have_premium,
                                                onColor: "#00c3cc",
                                                onHandleColor: "#00f4ff",
                                                checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    })
                                                }),
                                                uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-times"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "my-6 border-t border-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eligibleRolesSettingsItem.EligibleRolesSettingsItem), {
                                        selected_role_ids: eligibleRoleIds,
                                        onRolesChange: setEligibleRoleIds,
                                        disabled: !props.is_on_dashboard,
                                        is_enabled: isRestrictRolesEnabled,
                                        onToggle: setIsRestrictRolesEnabled,
                                        does_have_premium: props.does_have_premium,
                                        is_public: isPublic
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    is_loading: props.is_loading,
                    onClick: handleSubmit,
                    children: props.is_edit ? "Update Time Finder" : "Create Time Finder"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../dashboard/forms/improved_components/base_components/sesh_primary_button":"3QyI2","../../dashboard/forms/text_area":"dPYPF","../utils":"449Z9","./calendar-picker":"4RXPh","./input-section":"aaKad","../../../../common/constants":"lLiun","../../dashboard/dashboard_utils":"jvA8A","../../dashboard/forms/improved_components/settings_items/settings_base_item":"byg9r","react-switch":"l5ttz","../../dashboard/forms/improved_components/channel_picker":"c7Ywk","./eligible_roles_settings_item":"j5iSo","./combined_mentions_dropdown":"b876l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"449Z9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Helper functions for cookie management
parcelHelpers.export(exports, "createDefaultTimeslot", ()=>createDefaultTimeslot);
parcelHelpers.export(exports, "createNewTimeFinderOption", ()=>createNewTimeFinderOption);
parcelHelpers.export(exports, "updateSelectedDatesOnSpecifyTimeToggled", ()=>updateSelectedDatesOnSpecifyTimeToggled);
var _luxon = require("luxon");
function createDefaultTimeslot(date) {
    const start_time_date = date.set({
        hour: 12,
        minute: 0,
        second: 0
    });
    const end_time_date = start_time_date.plus({
        hours: 1
    });
    return {
        start_time: start_time_date.toMillis(),
        end_time: end_time_date.toMillis()
    };
}
function createNewTimeFinderOption(date) {
    const luxonDate = (0, _luxon.DateTime).fromJSDate(date);
    return {
        date: {
            day: luxonDate.day,
            month: luxonDate.month,
            year: luxonDate.year
        },
        timeslots: [
            createDefaultTimeslot(luxonDate)
        ]
    };
}
function updateSelectedDatesOnSpecifyTimeToggled(selectedDates) {
    selectedDates.map((selectedDate)=>{
        if (!selectedDate.timeslots || selectedDate.timeslots.length === 0) {
            const date_obj = (0, _luxon.DateTime).fromObject(selectedDate.date);
            selectedDate.timeslots = [
                createDefaultTimeslot(date_obj)
            ];
        }
    });
    return selectedDates;
}

},{"luxon":"fLWpi","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4RXPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarPicker", ()=>CalendarPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _reactDayPicker = require("react-day-picker");
var _styleCss = require("react-day-picker/src/style.css");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _timePicker = require("../../dashboard/forms/time_picker");
var _withDropdownImproved = require("../../dashboard/forms/improved_components/base_components/with_dropdown_improved");
var _utils = require("../utils");
const formatDate = (date)=>{
    return (0, _luxon.DateTime).fromJSDate(date).toFormat("LLL d, yyyy");
};
const areDatesEqual = (date1, date2)=>{
    return date1.date.day === date2.date.day && date1.date.month === date2.date.month && date1.date.year === date2.date.year;
};
// Grid view component (original view)
const DateGridView = ({ selectedDates, onUpdate })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap gap-2",
        children: selectedDates.map((date)=>{
            const date_obj = (0, _luxon.DateTime).fromObject(date.date);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "group relative flex h-16 w-16 cursor-pointer flex-col overflow-hidden rounded-sm border border-base-dark shadow-sm transition-all hover:border-sesh-primary",
                onClick: ()=>onUpdate(selectedDates.filter((val)=>!areDatesEqual(val, date))),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full bg-base-light py-0.5 text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-xs font-medium text-content-primary",
                            children: date_obj.toFormat("LLL")
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-1 items-center justify-center bg-sesh-dark",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-lg font-bold text-black",
                            children: date_obj.toFormat("d")
                        })
                    })
                ]
            }, date_obj.toISO());
        })
    });
};
function getNextAvailableHour(timeslots) {
    const lastTimeslot = timeslots[timeslots.length - 1];
    const date = (0, _luxon.DateTime).fromMillis(lastTimeslot.start_time).set({
        minute: 0,
        second: 0
    }).plus({
        hour: 1
    });
    return {
        start_time: date.toMillis(),
        end_time: date.plus({
            hour: 1
        }).toMillis()
    };
}
function applyTimesToAllDates(datesWithTimes, dateWithTimes) {
    if (dateWithTimes.timeslots.length === 0) return datesWithTimes;
    const currentTimeslots = dateWithTimes.timeslots;
    return datesWithTimes.map((date)=>{
        const luxon_date = (0, _luxon.DateTime).fromObject(date.date);
        return {
            ...date,
            timeslots: currentTimeslots.map((timeslot)=>{
                const start_hour = (0, _luxon.DateTime).fromMillis(timeslot.start_time).hour;
                const start_minute = (0, _luxon.DateTime).fromMillis(timeslot.start_time).minute;
                const end_hour = (0, _luxon.DateTime).fromMillis(timeslot.end_time).hour;
                const end_minute = (0, _luxon.DateTime).fromMillis(timeslot.end_time).minute;
                const new_start_time = luxon_date.set({
                    hour: start_hour,
                    minute: start_minute
                });
                const new_end_time = luxon_date.set({
                    hour: end_hour,
                    minute: end_minute
                });
                return {
                    start_time: new_start_time.toMillis(),
                    end_time: new_end_time.toMillis()
                };
            })
        };
    });
}
// Vertical list view component with time options
const DateListView = ({ datesWithTimes, onUpdate })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex max-h-[400px] flex-col gap-4 overflow-y-auto pr-2",
        children: datesWithTimes.map((dateWithTimes, dateIndex)=>{
            const date = (0, _luxon.DateTime).fromObject(dateWithTimes.date);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-md border border-base-dark bg-base-dark",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-base-light px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-5 w-5 text-white",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
                                            clipRule: "evenodd"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "font-medium text-white",
                                        children: date.toFormat("EEEE, MMMM d, yyyy")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "text-sm text-white hover:text-red-300",
                                onClick: ()=>onUpdate(datesWithTimes.filter((val)=>val.date !== dateWithTimes.date)),
                                children: "Remove"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-base-light p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "time-options space-y-2",
                                children: dateWithTimes.timeslots.map((timeOption)=>{
                                    const base_id = JSON.stringify(dateWithTimes.date);
                                    const local_start_time = (0, _luxon.DateTime).fromMillis(timeOption.start_time).toLocal();
                                    const local_end_time = (0, _luxon.DateTime).fromMillis(timeOption.end_time).toLocal();
                                    const start_time_hour = local_start_time.hour;
                                    const start_time_minute = local_start_time.minute;
                                    const start_time_ms = start_time_hour * 3600000 + start_time_minute * 60000;
                                    const end_time_hour = local_end_time.hour;
                                    const end_time_minute = local_end_time.minute;
                                    const end_time_ms = end_time_hour * 3600000 + end_time_minute * 60000;
                                    const duration = end_time_ms - start_time_ms;
                                    const start_id = base_id + ":" + timeOption.start_time + "-start";
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sesh-date-picker time-option-row relative flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex-1",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timePicker.TimePicker), {
                                                    initial_value_ms: start_time_ms,
                                                    updateFunc: (ms)=>{
                                                        const minutes = ms / 1000 / 60;
                                                        const hours = Math.floor(minutes / 60);
                                                        const minutes_remainder = minutes % 60;
                                                        const new_start_time = date.set({
                                                            hour: hours,
                                                            minute: minutes_remainder
                                                        });
                                                        timeOption.start_time = new_start_time.toMillis();
                                                        timeOption.end_time = new_start_time.plus({
                                                            millisecond: duration
                                                        }).toMillis();
                                                        onUpdate(datesWithTimes);
                                                    },
                                                    disabled: false,
                                                    portal: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "hidden px-1 py-1 font-medium text-sesh-dark md:block",
                                                children: "to"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex-1",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timePicker.TimePicker), {
                                                    initial_value_ms: end_time_ms,
                                                    updateFunc: (ms)=>{
                                                        const minutes = ms / 1000 / 60;
                                                        const hours = Math.floor(minutes / 60);
                                                        const minutes_remainder = minutes % 60;
                                                        timeOption.end_time = date.set({
                                                            hour: hours,
                                                            minute: minutes_remainder
                                                        }).toMillis();
                                                        onUpdate(datesWithTimes);
                                                    },
                                                    disabled: false,
                                                    portal: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "z-10 flex h-8 w-8 items-center justify-center rounded-full bg-base-dark text-xl text-white hover:bg-red-500",
                                                onClick: ()=>{
                                                    dateWithTimes.timeslots = dateWithTimes.timeslots.filter((val)=>val !== timeOption);
                                                    onUpdate(datesWithTimes);
                                                },
                                                children: "\xd7"
                                            })
                                        ]
                                    }, start_id);
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-3 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex w-fit flex-grow",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "flex items-center whitespace-nowrap rounded-md border-2 border-sesh-dark p-2 px-3 text-sm font-medium",
                                            onClick: ()=>{
                                                dateWithTimes.timeslots.push(getNextAvailableHour(dateWithTimes.timeslots));
                                                onUpdate(datesWithTimes);
                                            },
                                            children: "+ Add Time"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-fit",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withDropdownImproved.WithDropdownImproved), {
                                            alignment: "left",
                                            items: [
                                                {
                                                    type: "button",
                                                    label: "Apply times to all dates",
                                                    close_on_click: true,
                                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"
                                                            })
                                                        ]
                                                    }),
                                                    props: {
                                                        onClick: ()=>{
                                                            onUpdate(applyTimesToAllDates(datesWithTimes, dateWithTimes));
                                                        }
                                                    }
                                                },
                                                {
                                                    type: "button",
                                                    label: "Remove",
                                                    close_on_click: true,
                                                    is_warning: true,
                                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                                                            clipRule: "evenodd"
                                                        })
                                                    }),
                                                    props: {
                                                        onClick: ()=>{
                                                            onUpdate(datesWithTimes.filter((val)=>!areDatesEqual(val, dateWithTimes)));
                                                        }
                                                    }
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex h-8 w-8 cursor-pointer items-center justify-center hover:bg-base-light",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-5 w-5 text-sesh-dark transition-colors hover:text-sesh-primary",
                                                    viewBox: "0 0 20 20",
                                                    fill: "currentColor",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, dateWithTimes.date.year + "/" + dateWithTimes.date.month + "/" + dateWithTimes.date.day);
        })
    });
};
function CalendarPicker({ selectedDates, onSpecifyTimesChange, onUpdate, areTimesSpecified }) {
    const today = (0, _luxon.DateTime).now().startOf("day");
    // State for controlled selected prop
    const [selectedDays, setSelectedDays] = (0, _react.useState)(Array.from(new Set(selectedDates.map((d)=>{
        const date_obj = (0, _luxon.DateTime).fromObject(d.date);
        return date_obj.startOf("day").toJSDate();
    }))));
    // Update selectedDays when selectedDates prop changes
    (0, _react.useEffect)(()=>{
        setSelectedDays(Array.from(new Set(selectedDates.map((d)=>{
            const date_obj = (0, _luxon.DateTime).fromObject(d.date);
            return date_obj.startOf("day").toJSDate();
        }))));
    }, [
        selectedDates
    ]);
    const renderSelectedDates = ()=>{
        if (selectedDates.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex h-20 items-center justify-center rounded-md border border-dashed bg-base-dark",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-sm text-gray-500",
                children: "No dates selected"
            })
        });
        return areTimesSpecified ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateListView, {
            datesWithTimes: selectedDates,
            onUpdate: onUpdate
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateGridView, {
            selectedDates: selectedDates,
            onUpdate: onUpdate
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "calendar-picker flex w-full flex-col items-start justify-items-center gap-6",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex w-full flex-col items-start gap-6 lg:flex-row",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mx-auto flex w-full justify-center lg:w-1/2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDayPicker.DayPicker), {
                        mode: "multiple",
                        selected: selectedDays,
                        onDayClick: (day)=>{
                            if (day < today.toJSDate()) return;
                            // Check if day is already selected
                            const isSelected = selectedDates.some((d)=>{
                                const date_obj = (0, _luxon.DateTime).fromObject(d.date);
                                const dayStart = date_obj.startOf("day").toJSDate();
                                return dayStart.getTime() === day.getTime();
                            });
                            if (isSelected) {
                                // Remove the date
                                const newDates = selectedDates.filter((d)=>{
                                    const date_obj = (0, _luxon.DateTime).fromObject(d.date);
                                    const dayStart = date_obj.startOf("day").toJSDate();
                                    return dayStart.getTime() !== day.getTime();
                                });
                                onUpdate(newDates);
                            } else // Add the date
                            onUpdate([
                                ...selectedDates,
                                (0, _utils.createNewTimeFinderOption)(day)
                            ]);
                        },
                        disabled: {
                            before: today.toJSDate()
                        },
                        modifiersStyles: {
                            selected: {
                                backgroundColor: "var(--sesh-primary)",
                                color: "black"
                            },
                            today: {
                                border: "2px solid var(--sesh-primary)"
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "selected-dates w-full lg:w-1/2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-4 mt-4 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-lg font-medium",
                                    children: "Selected Dates"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "mr-2 text-sm",
                                            children: "Specify Times"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                            checked: areTimesSpecified,
                                            onChange: onSpecifyTimesChange,
                                            onColor: "#00c3cc",
                                            onHandleColor: "#00f4ff",
                                            checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-check"
                                                })
                                            }),
                                            uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-times"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        renderSelectedDates()
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","react-day-picker":"3kO7p","react-day-picker/src/style.css":"iHziy","react-switch":"l5ttz","../../dashboard/forms/time_picker":"bT1Cg","../../dashboard/forms/improved_components/base_components/with_dropdown_improved":"iYgdS","../utils":"449Z9","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iHziy":[function() {},{}],"aaKad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputSection", ()=>InputSection);
var _jsxRuntime = require("react/jsx-runtime");
function InputSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "rounded-t-md  bg-base-dark p-4 text-lg font-bold",
                    children: props.title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-b-md bg-base-semidark px-4 pb-8",
                children: props.children
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j5iSo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELIGIBLE_ROLES_SETTINGS", ()=>ELIGIBLE_ROLES_SETTINGS);
parcelHelpers.export(exports, "EligibleRolesSettingsItem", ()=>EligibleRolesSettingsItem);
var _jsxRuntime = require("react/jsx-runtime");
var _settingsBaseItem = require("../../dashboard/forms/improved_components/settings_items/settings_base_item");
var _rolesSearchDropdown = require("../../dashboard/forms/improved_components/roles_search_dropdown");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _dashboardUtils = require("../../dashboard/dashboard_utils");
const ELIGIBLE_ROLES_SETTINGS = {
    title: "Restrict Voting by Role",
    description: "Restrict which Discord roles can vote on this poll. Also restricts who can view the results on the dashboard."
};
function EligibleRolesSettingsItem(props) {
    const handleToggle = (checked)=>{
        if (props.is_public) {
            // Show warning modal when trying to toggle with public visibility
            (0, _dashboardUtils.DashboardUtils).ShowDefaultErrorAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-2 font-bold text-red-400",
                        children: "This setting cannot be used when visibility is set to public."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: 'Please change the visibility to "Server Members" to enable role restrictions.'
                    })
                ]
            }), "Visibility Restriction");
            return;
        }
        if (props.does_have_premium) {
            props.onToggle(checked);
            // Clear the role IDs if disabling the feature
            if (!checked) props.onRolesChange([]);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsBaseItem.SettingsBaseItem), {
        label: ELIGIBLE_ROLES_SETTINGS.title,
        is_premium: true,
        description: ELIGIBLE_ROLES_SETTINGS.description,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex items-center md:justify-end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                        checked: props.does_have_premium && props.is_enabled,
                        onChange: handleToggle,
                        disabled: props.disabled || !props.does_have_premium,
                        onColor: "#00c3cc",
                        onHandleColor: "#00f4ff",
                        checkedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        }),
                        uncheckedIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "flex h-full flex-col items-center justify-center text-black opacity-50",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-times"
                            })
                        })
                    })
                }),
                props.is_enabled && props.does_have_premium && !props.is_public && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-full max-w-[256px]",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesSearchDropdown.RolesSearchDropdown), {
                        selected_ids: props.selected_role_ids,
                        handleChange: props.onRolesChange,
                        disabled: props.disabled,
                        should_disable_managed_roles: true,
                        should_disable_here: true,
                        should_disable_everyone: true
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../dashboard/forms/improved_components/settings_items/settings_base_item":"byg9r","../../dashboard/forms/improved_components/roles_search_dropdown":"e09Fz","react-switch":"l5ttz","../../dashboard/dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"b876l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CombinedMentionsDropdown", ()=>CombinedMentionsDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactSelect = require("react-select");
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _reactRouter = require("react-router");
var _constants = require("../../../../common/constants");
var _trpc = require("../../dashboard/utils/trpc");
var _searchableDropdown = require("../../dashboard/forms/searchable_dropdown");
var _useGuildMembers = require("../../dashboard/forms/improved_components/hooks/use_guild_members");
var _useRoles = require("../../dashboard/forms/improved_components/hooks/use_roles");
function MemberToDropdownItem(members_map, id) {
    const member = members_map[id];
    const isDisabled = member?.disabled || false;
    return {
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
            val: member,
            disabled: isDisabled ? {
                text_element: "Invalid permissions",
                class: "dropdown-disabled-text"
            } : undefined
        }),
        selectedLabel: isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "opacity-50",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
                val: member
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
            val: member
        }),
        value: id,
        color: "#ffffff",
        type: "user"
    };
}
function RoleToDropdownItem(role) {
    const isDisabled = role.disabled || false;
    const disabledClass = isDisabled ? "opacity-50" : "";
    return {
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `flex items-center gap-2 ${disabledClass}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "h-3 w-3 rounded-full",
                    style: {
                        backgroundColor: role.color || "#99aab5"
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: role.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-white/50",
                    children: "(role)"
                }),
                isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-red-400",
                    children: "- Invalid permissions"
                })
            ]
        }),
        selectedLabel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `flex items-center gap-2 ${disabledClass}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "h-3 w-3 rounded-full",
                    style: {
                        backgroundColor: role.color || "#99aab5"
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: role.name
                }),
                isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-red-400",
                    children: "- Invalid permissions"
                })
            ]
        }),
        value: role.id,
        color: "#ffffff",
        type: "role",
        data: role
    };
}
const MenuList = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSelect.components).MenuList, {
        ...props,
        children: [
            props.children,
            props.options.length > (0, _constants.Constants).GUILD_MEMBERS_SEARCH_LIMIT && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "py-2 text-center text-xs font-bold text-sesh-primary",
                children: "More results than can be displayed. Type to filter."
            })
        ]
    });
};
const Input = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Input, {
        ...props,
        maxLength: 64
    });
function CombinedMentionsDropdown(props) {
    const { server_id: guild_id } = (0, _reactRouter.useParams)();
    const context = (0, _trpc.trpc).useContext();
    const roles = (0, _useRoles.useRoles)();
    const search_cache = (0, _react.useRef)({});
    const members = (0, _useGuildMembers.useGuildMemberQuery)(guild_id, props.initial_value.user_mentions);
    const members_cache = (0, _react.useContext)((0, _useGuildMembers.GuildMemberContext));
    const members_for_guild = members_cache.getMembers(guild_id);
    const members_map = {};
    for (const member of members_for_guild)members_map[member.id] = member;
    // Convert current selection to dropdown items
    const currentValue = [
        ...props.initial_value.user_mentions.map((id)=>MemberToDropdownItem(members_map, id)),
        ...props.initial_value.role_mentions.map((role)=>RoleToDropdownItem(role))
    ];
    const fetchOptions = (0, _react.useCallback)((0, _lodash.debounce)((new_input, callback)=>{
        if (search_cache.current[new_input]) {
            callback(search_cache.current[new_input]);
            return;
        }
        const combined_items = [];
        // Add roles first (they don't need async fetching)
        if (roles) {
            const filtered_roles = roles.filter((role)=>role.name.toLowerCase().includes(new_input.toLowerCase()));
            combined_items.push(...filtered_roles.map(RoleToDropdownItem));
        }
        // Then fetch members
        if (new_input.trim() === "") {
            // For empty search, return roles, currently selected members, and some initial members
            const current_member_items = props.initial_value.user_mentions.map((id)=>MemberToDropdownItem(members_map, id));
            combined_items.push(...current_member_items);
            // Add some initial members from cache that aren't already selected
            const cached_members = members_for_guild.slice(0, 20); // Show first 20 cached members
            const additional_member_items = cached_members.filter((member)=>!props.initial_value.user_mentions.includes(member.id)).map((member)=>{
                const isDisabled = member.disabled || false;
                return {
                    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
                        val: member,
                        disabled: isDisabled ? {
                            text_element: "Invalid permissions",
                            class: "dropdown-disabled-text"
                        } : undefined
                    }),
                    selectedLabel: isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
                            val: member
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
                        val: member
                    }),
                    value: member.id,
                    color: "#ffffff",
                    type: "user"
                };
            });
            combined_items.push(...additional_member_items);
            search_cache.current[new_input] = combined_items;
            callback(combined_items);
            return;
        }
        // Check cache for previous searches
        const previous_searches = Object.keys(search_cache.current);
        for (const search of previous_searches){
            if (search.length === 0) continue;
            if (new_input.startsWith(search) && search_cache.current[search].filter((item)=>item.type === "user").length === 0) {
                // No more users to find, just return roles
                search_cache.current[new_input] = combined_items;
                callback(combined_items);
                return;
            }
        }
        // Fetch members from server
        return context.members.search.fetch({
            guild_id: guild_id,
            query: new_input
        }).then((val)=>{
            members_cache.addMembers(guild_id, val);
            const member_items = val.map((member)=>{
                const isDisabled = member.disabled || false;
                return {
                    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
                        val: member,
                        disabled: isDisabled ? {
                            text_element: "Invalid permissions",
                            class: "dropdown-disabled-text"
                        } : undefined
                    }),
                    selectedLabel: isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "opacity-50",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
                            val: member
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberSelectedLabel), {
                        val: member
                    }),
                    value: member.id,
                    color: "#ffffff",
                    type: "user"
                };
            });
            const final_items = [
                ...combined_items,
                ...member_items
            ];
            search_cache.current[new_input] = final_items;
            callback(final_items);
        });
    }, 500), [
        guild_id,
        roles,
        members_map
    ]);
    const handleChange = (selectedItems)=>{
        if (props.disabled) return;
        const user_mentions = [];
        const role_mentions = [];
        selectedItems.forEach((item)=>{
            if (item.type === "user") user_mentions.push(item.value);
            else if (item.type === "role" && item.data) role_mentions.push(item.data);
        });
        props.updateFunc({
            user_mentions,
            role_mentions
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
            placeholder: "Select users and roles to mention...",
            classNamePrefix: "sesh-dropdown",
            isMulti: true,
            styles: (0, _searchableDropdown.dropdownColourStyles),
            components: {
                Input,
                SingleValue: (0, _searchableDropdown.SingleValue),
                MenuList
            },
            value: currentValue,
            onChange: handleChange,
            loadOptions: (input, callback)=>{
                if (props.disabled) {
                    callback([]);
                    return;
                }
                fetchOptions(input, callback);
            },
            isDisabled: props.disabled,
            defaultOptions: true,
            isOptionDisabled: (data)=>{
                if (data.type === "user") {
                    const member = members_map[data.value];
                    return member?.disabled || false;
                } else if (data.type === "role" && data.data) return data.data.disabled || false;
                return false;
            },
            formatOptionLabel: (data)=>{
                if (data.type === "user") {
                    const member = members_map[data.value];
                    const isDisabled = member?.disabled || false;
                    return member ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchableDropdown.DropdownMemberLabel), {
                        val: member,
                        disabled: isDisabled ? {
                            text_element: "Invalid permissions",
                            class: "dropdown-disabled-text"
                        } : undefined
                    }) : data.value;
                } else return data.label;
            }
        })
    });
}

},{"react/jsx-runtime":"dpQXr","lodash":"fIO2m","react":"IMRgT","react-select":[["components","j5lp9","c"]],"react-select/async":"8lz6t","react-router":"djWTS","../../../../common/constants":"lLiun","../../dashboard/utils/trpc":"dyYvM","../../dashboard/forms/searchable_dropdown":"8iEAS","../../dashboard/forms/improved_components/hooks/use_guild_members":"iK4oL","../../dashboard/forms/improved_components/hooks/use_roles":"b2XTr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cmh1o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderList", ()=>TimeFinderList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _trpc = require("../../../utils/trpc");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _luxon = require("luxon");
var _useGuildData = require("../hooks/use_guild_data");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../../../common/common_utils");
// CSS animation for shimmer effect
const shimmerAnimation = `
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
`;
function TimeFinderList() {
    const guild = (0, _useGuildData.useCurrentGuildData)();
    const guildId = guild?.id;
    const history = (0, _reactRouterDom.useHistory)();
    const [page, setPage] = (0, _react.useState)(0);
    const limit = 9;
    const timeFinderQuery = (0, _trpc.trpc).time_finder.getAllForGuild.useQuery({
        guild_id: guildId,
        page,
        limit
    }, {
        enabled: !!guildId,
        onError: (error)=>{
            console.error("Failed to fetch TimeFinder instances:", error);
        }
    });
    const handleViewTimeFinder = (id)=>{
        if (guildId) history.push((0, _commonUtils.common_utils).getTimeFinderURL({
            server_id: guildId,
            type: "view",
            instance_id: id
        }));
    };
    const handleCreateNew = ()=>{
        if (guildId) history.push((0, _commonUtils.common_utils).getTimeFinderURL({
            server_id: guildId,
            type: "create"
        }));
    };
    const handlePageChange = (newPage)=>{
        setPage(newPage);
    };
    if (timeFinderQuery.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingSkeleton, {});
    const data = timeFinderQuery.data || {
        instances: [],
        pagination: {
            total: 0,
            page: 0,
            limit,
            totalPages: 0
        }
    };
    const instances = data.instances;
    const pagination = data.pagination;
    if (instances.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "py-10 text-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "mb-2 text-xl font-medium",
                children: "No Time Finder Instances"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-4 text-gray-500",
                children: "You haven't created any time finders yet."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                onClick: handleCreateNew,
                children: "Create New TimeFinder"
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "text-xl font-bold sm:text-2xl",
                        children: "Your Time Finder Instances"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-fit",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: handleCreateNew,
                            className: "whitespace-nowrap",
                            children: "Create New"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
                children: instances.map((instance)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeFinderCard, {
                        instance: instance,
                        onClick: ()=>handleViewTimeFinder(instance.id)
                    }, instance.id))
            }),
            pagination.totalPages > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 flex justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center space-x-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: ()=>handlePageChange(Math.max(0, page - 1)),
                            disabled: page === 0,
                            custom_size: "small",
                            className: page === 0 ? "opacity-50" : "",
                            children: "Previous"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "min-w-[100px] text-center text-sm",
                            children: [
                                "Page ",
                                page + 1,
                                " of ",
                                pagination.totalPages
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: ()=>handlePageChange(Math.min(pagination.totalPages - 1, page + 1)),
                            disabled: page >= pagination.totalPages - 1,
                            custom_size: "small",
                            className: page >= pagination.totalPages - 1 ? "opacity-50" : "",
                            children: "Next"
                        })
                    ]
                })
            })
        ]
    });
}
function TimeFinderCard({ instance, onClick }) {
    // Format the last modified date
    const formattedDate = (0, _luxon.DateTime).fromJSDate(new Date(instance.lastModifiedAt)).toRelative();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-[160px] w-full cursor-pointer flex-col rounded-lg border-2 border-gray-700 bg-base-dark p-3 shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-sesh-primary hover:shadow-lg",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-calendar-check flex-shrink-0 text-xl text-sesh-primary"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "min-w-0 flex-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-1 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "mr-2 truncate text-base font-semibold text-sesh-primary",
                                        title: instance.title,
                                        children: instance.title
                                    }),
                                    instance.isPublic !== false && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-shrink-0 items-center rounded bg-green-900/40 px-1.5 py-0.5 text-[10px] font-medium text-green-300",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-globe mr-1"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Public"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-[48px] overflow-hidden",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "line-clamp-2 text-xs text-gray-300",
                                    children: instance.description || "No description"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-auto pt-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "h-px w-full bg-gradient-to-r from-transparent via-gray-600 to-transparent"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-2 flex justify-between text-xs text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-clock text-sesh-primary-lighter mr-1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "",
                                        children: formattedDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-users text-sesh-primary-lighter mr-1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            instance.responseCount,
                                            " ",
                                            instance.responseCount === 1 ? "response" : "responses"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function LoadingSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: shimmerAnimation
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "relative h-8 w-64 overflow-hidden rounded-md bg-gray-700",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "relative h-10 w-24 overflow-hidden rounded-md bg-gray-700",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
                children: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9
                ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-full rounded-lg border border-gray-700 bg-base-dark p-4 shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-start gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "relative h-6 w-6 flex-shrink-0 overflow-hidden rounded-md bg-gray-700",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "min-w-0 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-2 flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "relative h-6 w-3/5 overflow-hidden rounded-md bg-gray-700",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "relative h-4 w-16 overflow-hidden rounded-md bg-gray-700",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "relative mb-2 h-4 w-full overflow-hidden rounded-md bg-gray-700",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "relative mb-4 h-4 w-3/4 overflow-hidden rounded-md bg-gray-700",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "relative mt-2 h-px w-full overflow-hidden bg-gray-700",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-3 flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "relative h-4 w-20 overflow-hidden rounded-md bg-gray-700",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "relative h-4 w-20 overflow-hidden rounded-md bg-gray-700",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-gray-600/30 to-transparent"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, i))
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../utils/trpc":"dyYvM","../base_components/sesh_primary_button":"3QyI2","luxon":"fLWpi","../hooks/use_guild_data":"ljx0Q","react-router-dom":"djWTS","../../../../../../common/common_utils":"gACUC","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4s8RH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderView", ()=>TimeFinderView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _commonUtils = require("../../../../../../common/common_utils");
var _availabilityPoll = require("../../../../time-finder/components/availability-poll");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _useUserContext = require("../hooks/use_user_context");
var _memberDisplayNameWithTooltip = require("../member_display_name/member_display_name_with_tooltip");
var _memberDisplayNameWithTooltipDefault = parcelHelpers.interopDefault(_memberDisplayNameWithTooltip);
var _dashboardUtils = require("../../../dashboard_utils");
function TimeFinderView(props) {
    const history = (0, _reactRouter.useHistory)();
    const { server_id } = (0, _reactRouter.useParams)();
    const mutation = (0, _trpc.trpc).time_finder.updateAvailability.useMutation({
        onSuccess: ()=>{
            history.go(0);
        }
    });
    const deleteMutation = (0, _trpc.trpc).time_finder.delete.useMutation({
        onSuccess: ()=>{
            history.push((0, _commonUtils.common_utils).getTimeFinderURL({
                server_id: server_id,
                type: "base"
            }));
        }
    });
    const user = (0, _useUserContext.useUserContext)();
    const time_finder_query = (0, _trpc.trpc).time_finder.getById.useQuery({
        id: props.time_finder_id,
        guild_id: server_id
    });
    if (!time_finder_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    const handleEdit = ()=>{
        history.push((0, _commonUtils.common_utils).getTimeFinderURL({
            server_id: server_id,
            type: "edit",
            instance_id: props.time_finder_id
        }));
    };
    const handleDelete = async ()=>{
        const confirmation_result = await (0, _dashboardUtils.DashboardUtils).ShowDeleteConfirmAlert(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "Are you sure you want to permanently delete time finder",
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "has-text-weight-bold",
                    children: time_finder_query.data.title
                }),
                "?"
            ]
        }));
        if (!confirmation_result.isConfirmed) return;
        deleteMutation.mutate({
            id: props.time_finder_id,
            guild_id: server_id
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availabilityPoll.AvailabilityPollContent), {
        time_finder_instance: time_finder_query.data,
        UserRenderer: UserRenderer,
        onSubmit: (opts)=>mutation.mutate({
                ...opts,
                guild_id: server_id,
                id: props.time_finder_id
            }),
        is_loading: mutation.isLoading || mutation.isSuccess,
        user_id: user.id,
        create_new_poll_link: (0, _commonUtils.common_utils).getTimeFinderURL({
            server_id,
            type: "create"
        }),
        is_editable: true,
        onEdit: handleEdit,
        onDelete: time_finder_query.data.can_delete ? handleDelete : undefined,
        is_deleting: deleteMutation.isLoading,
        is_on_dashboard: true
    });
}
function UserRenderer(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _memberDisplayNameWithTooltipDefault.default), {
        user_id: props.user_id,
        include_avatar: true
    });
}

},{"react/jsx-runtime":"dpQXr","react-router":"djWTS","../../../../../../common/common_utils":"gACUC","../../../../time-finder/components/availability-poll":"b5ZPA","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","../hooks/use_user_context":"eU1k4","../member_display_name/member_display_name_with_tooltip":"7N9T1","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"b5ZPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PublicAvailabilityPoll", ()=>PublicAvailabilityPoll);
parcelHelpers.export(exports, "AvailabilityPollContent", ()=>AvailabilityPollContent);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _luxon = require("luxon");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../common/common_utils");
var _dashboardUtils = require("../../dashboard/dashboard_utils");
var _loadingThrobber = require("../../dashboard/forms/improved_components/base_components/loading_throbber");
var _seshPrimaryButton = require("../../dashboard/forms/improved_components/base_components/sesh_primary_button");
var _seshTextInput = require("../../dashboard/forms/improved_components/base_components/sesh_text_input");
var _withTooltipPortaled = require("../../dashboard/forms/improved_components/tooltips/with_tooltip_portaled");
var _trpc = require("../../dashboard/utils/trpc");
var _eligibleRolesIndicator = require("./eligible_roles_indicator");
var _inputSection = require("./input-section");
var _timeFinder = require("./time_finder");
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax";
}
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function JustCreatedModalContent(props) {
    const [showCopied, setShowCopied] = (0, _react.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(props.shareableUrl);
        setShowCopied(true);
        setTimeout(()=>{
            setShowCopied(false);
        }, 2000);
    };
    const handleClose = ()=>{
        props.onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-4",
                children: "Your Time Finder poll has been created! Share this link with others:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        readOnly: true,
                        value: props.shareableUrl,
                        className: "flex-1 rounded-md border border-base-light bg-base-dark p-2",
                        onClick: (e)=>e.currentTarget.select()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "rounded-md bg-sesh-primary p-2 text-black",
                                onClick: handleCopy,
                                title: "Copy to clipboard",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-copy"
                                })
                            }),
                            showCopied && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "absolute bottom-full left-1/2 mb-1 -translate-x-1/2 rounded bg-sesh-primary px-2 py-1 text-xs font-bold text-black",
                                children: [
                                    "Copied",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-sesh-primary"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 flex justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    onClick: handleClose,
                    children: "Got it"
                })
            })
        ]
    });
}
function PublicAvailabilityPoll() {
    const { timeFinderID: time_finder_id } = (0, _reactRouterDom.useParams)();
    const [isJustCreatedModalActive, setIsJustCreatedModalActive] = (0, _react.useState)(false);
    const [shareableUrl, setShareableUrl] = (0, _react.useState)("");
    const [userId, setUserId] = (0, _react.useState)(getCookie("time_finder_user_id"));
    const time_finder_query = (0, _trpc.trpc).time_finder.getByIdPublic.useQuery({
        id: time_finder_id,
        user_id: userId || undefined
    }, {
        onSuccess: (data)=>{
            setNameInputValue(data.availabilities.find((val)=>val.id === userId)?.username ?? "");
            // Check if there's a just_created query parameter and show the modal if it exists
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.get("just_created") === "true") {
                const url = (0, _commonUtils.common_utils).getTimeFinderURL({
                    server_id: data.guild_id || "",
                    type: "view",
                    instance_id: time_finder_id,
                    is_public: true
                });
                setShareableUrl(window.location.origin + url);
                setIsJustCreatedModalActive(true);
            }
        }
    });
    const [isNameModalActive, setIsNameModalActive] = (0, _react.useState)(false);
    const [nameInputValue, setNameInputValue] = (0, _react.useState)("");
    const [pendingAvailabilities, setPendingAvailabilities] = (0, _react.useState)(null);
    const history = (0, _reactRouterDom.useHistory)();
    const mutation = (0, _trpc.trpc).time_finder.updateAvailabilityPublic.useMutation({
        onSuccess: (data)=>{
            // Store the user ID in a cookie if it was returned
            if (data.userId) // Set cookie that expires in 1 year
            setCookie("time_finder_user_id", data.userId, 365);
            history.go(0);
        }
    });
    const handleSubmitFromPoll = (data)=>{
        // Otherwise handle it internally
        // Store the availabilities temporarily and show the name modal
        setPendingAvailabilities(data);
        setIsNameModalActive(true);
    };
    const handleNameSubmit = ()=>{
        if (!nameInputValue.trim() || !pendingAvailabilities) return;
        // Trim and ensure name doesn't exceed 32 characters
        const trimmedName = nameInputValue.trim().substring(0, 32);
        // Submit the stored availabilities along with the name
        mutation.mutate({
            id: time_finder_id,
            username: trimmedName,
            availabilities: pendingAvailabilities.availabilities,
            existingUserId: userId || undefined
        });
        // Close the modal
        setIsNameModalActive(false);
    };
    // Name input modal content
    const nameModalContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                label: "Your Name",
                input_props: {
                    type: "text",
                    value: nameInputValue,
                    onChange: (e)=>setNameInputValue(e.currentTarget.value),
                    placeholder: "Enter your name",
                    autoFocus: true,
                    className: "w-full",
                    maxLength: 32
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 flex justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    is_loading: mutation.isLoading,
                    onClick: handleNameSubmit,
                    children: "Submit"
                })
            })
        ]
    });
    // Just created modal content
    const justCreatedModalContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)(JustCreatedModalContent, {
        shareableUrl: shareableUrl,
        onClose: ()=>setIsJustCreatedModalActive(false)
    });
    if (!time_finder_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvailabilityPollContent, {
                is_editable: false,
                time_finder_instance: time_finder_query.data,
                onSubmit: handleSubmitFromPoll,
                is_loading: mutation.isLoading || mutation.isSuccess,
                create_new_poll_link: "/time-finder",
                user_id: userId || undefined,
                is_on_dashboard: false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: isNameModalActive,
                title: "Enter Your Name",
                content: nameModalContent,
                onClose: ()=>setIsNameModalActive(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: isJustCreatedModalActive,
                title: "Poll Created",
                content: justCreatedModalContent,
                onClose: ()=>{
                    const url = new URL(window.location.href);
                    url.searchParams.delete("just_created");
                    window.history.replaceState({}, document.title, url.toString());
                    setIsJustCreatedModalActive(false);
                }
            })
        ]
    });
}
function AvailabilityPollContent(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const [isJustCreatedModalActive, setIsJustCreatedModalActive] = (0, _react.useState)(false);
    const [shareableUrl, setShareableUrl] = (0, _react.useState)("");
    const [showCopied, setShowCopied] = (0, _react.useState)(false);
    // Check for just_created parameter on mount
    (0, _react.useEffect)(()=>{
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get("just_created") === "true" && props.time_finder_instance?.id) {
            const url = (0, _commonUtils.common_utils).getTimeFinderURL({
                server_id: props.time_finder_instance.guild_id || "",
                type: "view",
                instance_id: props.time_finder_instance.id,
                is_public: props.time_finder_instance.is_public
            });
            setShareableUrl(window.location.origin + url);
            setIsJustCreatedModalActive(true);
        } else if (props.time_finder_instance?.is_public && props.time_finder_instance?.id) {
            // Set the shareable URL for the public poll info section
            const url = (0, _commonUtils.common_utils).getTimeFinderURL({
                server_id: props.time_finder_instance.guild_id || "",
                type: "view",
                instance_id: props.time_finder_instance.id,
                is_public: true
            });
            setShareableUrl(window.location.origin + url);
        }
    }, [
        props.time_finder_instance
    ]);
    const handleCopyPublicLink = ()=>{
        navigator.clipboard.writeText(shareableUrl);
        setShowCopied(true);
        setTimeout(()=>{
            setShowCopied(false);
        }, 2000);
    };
    // State for editing mode
    const [isEditMode, setIsEditMode] = (0, _react.useState)(false);
    // State to control if the user's input row is visible
    const [isUserRowVisible, setIsUserRowVisible] = (0, _react.useState)(true);
    // State for new responses
    const [newResponses, setNewResponses] = (0, _react.useState)({});
    // Function to clear all selections
    const clearAllSelections = ()=>{
        setNewResponses({});
        // If we weren't in edit mode, this would have no visual effect,
        // so we need to force a re-render
        if (!isEditMode) {
            setIsEditMode(true);
            // Then immediately exit edit mode after a small delay
            setTimeout(()=>setIsEditMode(false), 50);
        }
    };
    // Check if current user has already submitted
    const userExists = props.user_id && props.time_finder_instance.availabilities.some((participant)=>participant.id === props.user_id);
    // Get existing user responses if available
    const getUserResponses = ()=>{
        if (props.user_id) {
            const participant = props.time_finder_instance.availabilities.find((p)=>p.id === props.user_id);
            if (participant) {
                const responses = {};
                participant.availability.forEach((item)=>{
                    responses[item.id] = item.status;
                });
                return responses;
            }
        }
        return {};
    };
    // Initialize edit mode with existing responses
    const startEditMode = ()=>{
        setNewResponses(getUserResponses());
        setIsEditMode(true);
    };
    // Handle response change for a specific date
    const handleResponseChange = (dateId, response)=>{
        setNewResponses((prev)=>({
                ...prev,
                [dateId]: response
            }));
    };
    // Cycle through response options
    const cycleResponse = (dateId)=>{
        const currentResponse = newResponses[dateId];
        let nextResponse;
        if (!currentResponse) nextResponse = "yes";
        else if (currentResponse === "yes") nextResponse = "maybe";
        else if (currentResponse === "maybe") nextResponse = "no";
        else nextResponse = "yes";
        handleResponseChange(dateId, nextResponse);
    };
    // Submit new participant
    const handleSubmit = (e)=>{
        e.preventDefault();
        // If user already exists and is not in edit mode, do nothing
        if (userExists && !isEditMode) return;
        // Call the onSubmit prop with the availabilities data
        props.onSubmit({
            availabilities: props.time_finder_instance.datetimes.map((dateOption)=>({
                    id: dateOption.id,
                    availability: newResponses[dateOption.id]
                })).filter((val)=>val.availability !== undefined)
        });
    };
    // Get response icon based on response type
    const getResponseIcon = (response)=>{
        let responseIcon = null;
        switch(response){
            case "yes":
                responseIcon = "\u2713";
                break;
            case "maybe":
                responseIcon = "?";
                break;
            case "no":
                responseIcon = "\u2717";
                break;
            default:
                responseIcon = null;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)("flex h-full w-[96px] flex-shrink-0 items-center justify-center border-r border-t border-base-light text-xl text-black", {
                "bg-green-500  font-bold ": response === "yes",
                "bg-yellow-500  font-bold ": response === "maybe",
                "bg-red-500  font-bold ": response === "no"
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: responseIcon
            })
        });
    };
    // Get response button class based on response
    const getResponseButtonClass = (dateId)=>{
        const response = newResponses[dateId];
        let baseClass = "flex flex-col items-center justify-center w-full h-12 rounded-md cursor-pointer transition-all duration-200 shadow-sm hover:shadow-md relative";
        if (!response) return baseClass + " border-2 border-dashed border-sesh-dark bg-base-dark hover:bg-base-light/10";
        switch(response){
            case "yes":
                return baseClass + " bg-green-500 text-black hover:bg-green-400";
            case "maybe":
                return baseClass + " bg-yellow-500 text-black hover:bg-yellow-400";
            case "no":
                return baseClass + " bg-red-500 text-black hover:bg-red-400";
            default:
                return baseClass + " border-2 border-dashed border-base-light bg-base-primary hover:bg-base-light/10";
        }
    };
    // Get response display content
    const getResponseContent = (dateId)=>{
        const response = newResponses[dateId];
        if (!response) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col items-center justify-center p-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-sm italic text-sesh-dark",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-plus-circle text-lg text-sesh-dark"
                })
            })
        });
        switch(response){
            case "yes":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-lg font-bold",
                            children: "\u2713"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-xs",
                            children: "Available"
                        })
                    ]
                });
            case "maybe":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-lg font-bold",
                            children: "?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-xs",
                            children: "Maybe"
                        })
                    ]
                });
            case "no":
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-lg font-bold",
                            children: "\u2717"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-xs",
                            children: "Unavailable"
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Select"
                });
        }
    };
    // Handle navigation to create new poll
    const handleCreateNewPoll = ()=>{
        history.push(props.create_new_poll_link);
    };
    // Format time to display
    const formatTime = (dateTime)=>{
        return dateTime.toFormat("h:mm a");
    };
    // Calculate and format duration between two DateTime objects
    const formatDuration = (start, end)=>{
        // Create new DateTime objects with only time components
        const startTime = (0, _luxon.DateTime).fromObject({
            hour: start.hour,
            minute: start.minute
        });
        let endTime = (0, _luxon.DateTime).fromObject({
            hour: end.hour,
            minute: end.minute
        });
        // If endTime is earlier than startTime, assume it's the next day
        if (endTime < startTime) endTime = endTime.plus({
            days: 1
        });
        const diff = endTime.diff(startTime, [
            "hours",
            "minutes"
        ]);
        const hours = Math.floor(diff.hours);
        const minutes = Math.floor(diff.minutes);
        let result = "";
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0 || hours === 0) result += `${minutes}m`;
        return result.trim();
    };
    const handleEditPoll = ()=>{
        if (props.onEdit) props.onEdit();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "availability-poll flex w-full flex-col",
        children: [
            props.time_finder_instance.is_public && shareableUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4 mt-2 rounded-md border border-base-light bg-base-dark/30 p-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 text-white",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-globe text-sesh-primary"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-medium",
                                children: "This is a public poll that anyone with the following link can access"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-2 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                readOnly: true,
                                value: shareableUrl,
                                className: "flex-1 rounded-md border border-base-light bg-base-dark p-2 text-sm",
                                onClick: (e)=>e.currentTarget.select()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "rounded-md bg-sesh-primary p-2 text-black",
                                        onClick: handleCopyPublicLink,
                                        title: "Copy to clipboard",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-copy"
                                        })
                                    }),
                                    showCopied && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "absolute bottom-full left-1/2 mb-1 -translate-x-1/2 rounded bg-sesh-primary px-2 py-1 text-xs font-bold text-black",
                                        children: [
                                            "Copied",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-sesh-primary"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !props.time_finder_instance.guild_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "my-2 mt-3 rounded-md border-sesh-primary/30 bg-base-primary/30 text-sm text-white",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            href: "/dashboard",
                            className: "flex items-center gap-2 font-medium hover:text-sesh-primary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-info-circle text-sesh-primary"
                                }),
                                "Use",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "sesh-text relative top-[1.5px] inline-block align-middle",
                                    children: "sesh"
                                }),
                                " ",
                                "to create private polls and events for your Discord community"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _inputSection.InputSection), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex w-full items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-calendar-check fa-lg mr-2"
                                }),
                                props.time_finder_instance.title
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto flex gap-1",
                            children: [
                                props.is_editable && props.onEdit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    onClick: handleEditPoll,
                                    className: "rounded bg-base-dark px-2 py-1 text-sm text-sesh-primary hover:bg-base-light",
                                    title: "Edit poll",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-edit mr-1"
                                        }),
                                        "Edit"
                                    ]
                                }),
                                props.onDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: props.onDelete,
                                    disabled: props.is_deleting,
                                    className: "rounded bg-base-dark px-2 py-1 text-sm text-red-400 hover:bg-base-light hover:text-red-300 disabled:opacity-50",
                                    title: "Delete poll",
                                    children: props.is_deleting ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-spinner fa-spin mr-1"
                                            }),
                                            "Deleting..."
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-trash mr-1"
                                            }),
                                            "Delete"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                children: [
                    props.time_finder_instance.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "py-3",
                        children: props.time_finder_instance.description
                    }),
                    (props.time_finder_instance.anonymous_voting || props.time_finder_instance.hide_votes || props.time_finder_instance.eligible_role_ids && props.time_finder_instance.eligible_role_ids.length > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-1 flex flex-wrap gap-2",
                        children: [
                            props.time_finder_instance.anonymous_voting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                                style: "Info",
                                tooltip: (0, _timeFinder.TIME_FINDER_SETTINGS).anonymous_voting.description,
                                no_delay: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "inline-flex items-center rounded-full bg-base-dark px-2 py-1 text-xs font-medium text-sesh-primary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-user-secret mr-1"
                                        }),
                                        (0, _timeFinder.TIME_FINDER_SETTINGS).anonymous_voting.title
                                    ]
                                })
                            }),
                            props.time_finder_instance.hide_votes && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                                style: "Info",
                                tooltip: (0, _timeFinder.TIME_FINDER_SETTINGS).hide_votes.description,
                                no_delay: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "inline-flex items-center rounded-full bg-base-dark px-2 py-1 text-xs font-medium text-sesh-primary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-eye-slash mr-1"
                                        }),
                                        (0, _timeFinder.TIME_FINDER_SETTINGS).hide_votes.title
                                    ]
                                })
                            }),
                            props.time_finder_instance.eligible_role_ids && props.time_finder_instance.eligible_role_ids.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eligibleRolesIndicator.EligibleRolesIndicator), {
                                eligibleRoleIds: props.time_finder_instance.eligible_role_ids
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: isJustCreatedModalActive,
                title: "Poll Created",
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(JustCreatedModalContent, {
                    shareableUrl: shareableUrl,
                    onClose: ()=>setIsJustCreatedModalActive(false)
                }),
                onClose: ()=>{
                    setIsJustCreatedModalActive(false);
                    const url = new URL(window.location.href);
                    url.searchParams.delete("just_created");
                    window.history.replaceState({}, document.title, url.toString());
                }
            }),
            props.time_finder_instance.hide_votes && !props.time_finder_instance.has_user_submitted && props.time_finder_instance.availabilities.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 rounded-b-md bg-base-semidark px-4 py-8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-eye-slash text-2xl text-sesh-primary"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-white",
                            children: "Other participants' votes are hidden until you submit your own response"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 w-fit max-w-full self-center overflow-hidden rounded-md border border-base-dark",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overflow-x-auto pb-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex min-w-max",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "left-0 z-20 w-[200px] flex-shrink-0 border-r border-base-light bg-base-dark p-3 font-bold text-white lg:sticky",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "truncate",
                                        children: "Name"
                                    })
                                }),
                                props.time_finder_instance.datetimes.map((dateOption)=>{
                                    const start_date = props.time_finder_instance.are_times_specified ? (0, _luxon.DateTime).fromMillis(dateOption.start_time).toLocal() : (0, _luxon.DateTime).fromMillis(dateOption.start_time).toUTC();
                                    const end_date = dateOption.end_time ? props.time_finder_instance.are_times_specified ? (0, _luxon.DateTime).fromMillis(dateOption.end_time).toLocal() : (0, _luxon.DateTime).fromMillis(dateOption.end_time).toUTC() : null;
                                    const tooltipText = props.time_finder_instance.are_times_specified ? `${formatTime(start_date)} - ${formatTime(end_date)}` : "";
                                    // Count people who selected 'yes' for this option
                                    const yesCount = props.time_finder_instance.availabilities.filter((participant)=>participant.availability.some((a)=>a.id === dateOption.id && a.status === "yes")).length;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
                                        style: "Info",
                                        no_delay: true,
                                        tooltip: props.time_finder_instance.guild_id ? "Create event at this time" : null,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group relative flex w-[96px] flex-shrink-0 cursor-pointer flex-col gap-1 border-r border-base-light bg-base-dark p-1 py-4 text-center text-white hover:bg-base-light",
                                            onClick: ()=>{
                                                if (!props.time_finder_instance.guild_id) return;
                                                const url = redirectToEventCreate({
                                                    event_title: props.time_finder_instance.title,
                                                    event_description: props.time_finder_instance.description,
                                                    guild_id: props.time_finder_instance.guild_id,
                                                    start_time: start_date,
                                                    end_time: end_date,
                                                    is_all_day: !props.time_finder_instance.are_times_specified
                                                });
                                                if (props.is_on_dashboard) history.push(url);
                                                else window.open(url);
                                            },
                                            children: [
                                                props.time_finder_instance.guild_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "absolute right-2 top-1 text-xs text-sesh-primary opacity-25 transition-all group-hover:opacity-100",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-plus-circle"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "whitespace-nowrap text-sm font-bold",
                                                    children: start_date.toFormat("EEE")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "whitespace-nowrap text-sm",
                                                    children: start_date.toFormat("MMM d")
                                                }),
                                                props.time_finder_instance.are_times_specified && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mt-1 whitespace-nowrap text-xs",
                                                            children: formatTime(start_date)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex cursor-help items-center justify-center gap-1 text-xs text-gray-300",
                                                            title: tooltipText,
                                                            "data-tooltip-instant": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                    className: "fas fa-clock text-xs"
                                                                }),
                                                                formatDuration(start_date, end_date)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "mt-1 flex items-center justify-center gap-1 rounded-full bg-base-light px-2 py-0.5 text-xs text-white",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                            className: "fas fa-user-check text-xs"
                                                        }),
                                                        yesCount
                                                    ]
                                                })
                                            ]
                                        }, dateOption.start_time)
                                    }, dateOption.id);
                                })
                            ]
                        }),
                        (!userExists || isEditMode && !props.user_id) && isUserRowVisible && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex min-w-max bg-base-light/5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "left-0 z-10 flex w-[200px] flex-shrink-0 items-center whitespace-nowrap border-l-4 border-r border-t border-base-light border-l-sesh-primary bg-base-primary p-3 font-medium lg:sticky",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "mr-auto flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "max-w-[160px] truncate font-semibold text-sesh-primary",
                                                    title: "Your availability",
                                                    children: "Your availability"
                                                }),
                                                isEditMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "ml-1 text-xs text-sesh-primary",
                                                    children: "(Editing)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>setIsUserRowVisible(false),
                                            className: "ml-1 flex items-center text-xs font-medium text-red-500 hover:text-red-400",
                                            title: "Remove your response",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-times"
                                            })
                                        })
                                    ]
                                }),
                                props.time_finder_instance.datetimes.map((dateOption)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "w-[96px] flex-shrink-0 border-r border-t border-base-light p-1 text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: getResponseButtonClass(dateOption.id),
                                            onClick: ()=>cycleResponse(dateOption.id),
                                            title: "Click to cycle through options",
                                            children: getResponseContent(dateOption.id)
                                        })
                                    }, dateOption.start_time))
                            ]
                        }),
                        props.time_finder_instance.availabilities.map((participant)=>{
                            // Check if this is the current user's row and they're in edit mode
                            const isCurrentUserEditing = isEditMode && props.user_id && props.user_id === participant.id;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _classnamesDefault.default)("flex w-max", {
                                    "hover:bg-base-light/10": !isCurrentUserEditing,
                                    "bg-base-light/20": isCurrentUserEditing
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "left-0 z-10 flex w-[200px] flex-shrink-0 items-center justify-between whitespace-nowrap border-r border-t border-base-light bg-base-primary p-3 font-medium lg:sticky",
                                        children: [
                                            props.UserRenderer && !props.time_finder_instance.anonymous_voting && participant.type === "discord" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(props.UserRenderer, {
                                                user_id: participant.id
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex min-w-0 items-center gap-1",
                                                children: [
                                                    participant.avatar_url ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: `https://cdn.discordapp.com/${participant.avatar_url}`,
                                                        alt: participant.username,
                                                        className: "mr-2 h-6 w-6 flex-shrink-0 rounded-full"
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.RandomAvatar), {
                                                        seed: participant.id,
                                                        size: 24,
                                                        className: "mr-2 flex-shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "truncate",
                                                        title: participant.username ?? participant.id,
                                                        children: participant.username ?? participant.id
                                                    })
                                                ]
                                            }),
                                            props.user_id && props.user_id === participant.id && !isEditMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: startEditMode,
                                                className: "ml-2 flex items-center text-xs font-medium text-sesh-primary hover:underline",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-edit mr-1"
                                                })
                                            })
                                        ]
                                    }),
                                    props.time_finder_instance.datetimes.map((dateOption)=>{
                                        // If user is editing this row, show the editable cells
                                        if (isCurrentUserEditing) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "w-[96px] flex-shrink-0 border-r border-t border-base-light p-1 text-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: getResponseButtonClass(dateOption.id),
                                                onClick: ()=>cycleResponse(dateOption.id),
                                                title: "Click to cycle through options",
                                                children: getResponseContent(dateOption.id)
                                            })
                                        }, dateOption.id);
                                        // Otherwise show the static response
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "w-[96px] flex-shrink-0 border-r border-t border-base-light",
                                            children: getResponseIcon(participant.availability.find((val)=>val.id === dateOption.id)?.status)
                                        }, dateOption.id);
                                    })
                                ]
                            }, participant.id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-4 flex flex-col items-end",
                children: [
                    (!userExists || isEditMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: isUserRowVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex w-fit gap-2",
                            children: [
                                isEditMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-fit",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                        onClick: ()=>setIsEditMode(false),
                                        className: " bg-gray-500 hover:bg-gray-600",
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-fit",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                        onClick: handleSubmit,
                                        is_loading: props.is_loading,
                                        children: isEditMode ? "Update Response" : "Submit Response"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-fit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                onClick: ()=>setIsUserRowVisible(true),
                                children: "Add Your Response"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mt-3 text-right",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            onClick: handleCreateNewPoll,
                            className: "cursor-pointer text-sm font-bold text-sesh-primary hover:underline",
                            children: "Create New Time Finder Poll"
                        })
                    })
                ]
            })
        ]
    });
}
function redirectToEventCreate(opts) {
    const start_time = opts.is_all_day ? opts.start_time.set({
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0
    }) : opts.start_time;
    const local_time = (0, _luxon.DateTime).local().set({
        hour: start_time.hour,
        minute: start_time.minute,
        second: start_time.second,
        millisecond: start_time.millisecond,
        day: start_time.day,
        month: start_time.month,
        year: start_time.year
    });
    const start_time_str = local_time.toISO().replaceAll("+", "%2b");
    return (0, _commonUtils.common_utils).getEventCreateURL(opts.guild_id, undefined, undefined, {
        date: encodeURIComponent(start_time_str),
        title: encodeURIComponent(opts.event_title),
        description: encodeURIComponent(opts.event_description)
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","luxon":"fLWpi","react":"IMRgT","react-router-dom":"djWTS","../../../../common/common_utils":"gACUC","../../dashboard/dashboard_utils":"jvA8A","../../dashboard/forms/improved_components/base_components/loading_throbber":"1I8d2","../../dashboard/forms/improved_components/base_components/sesh_primary_button":"3QyI2","../../dashboard/forms/improved_components/base_components/sesh_text_input":"befXR","../../dashboard/forms/improved_components/tooltips/with_tooltip_portaled":"6LBvw","../../dashboard/utils/trpc":"dyYvM","./eligible_roles_indicator":"dhU6Y","./input-section":"aaKad","./time_finder":"h3qmW","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dhU6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EligibleRolesIndicator", ()=>EligibleRolesIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _useRoles = require("../../dashboard/forms/improved_components/hooks/use_roles");
var _withTooltipPortaled = require("../../dashboard/forms/improved_components/tooltips/with_tooltip_portaled");
var _eligibleRolesSettingsItem = require("./eligible_roles_settings_item");
var _chromaJs = require("chroma-js");
var _chromaJsDefault = parcelHelpers.interopDefault(_chromaJs);
// Calculate if text should be black or white based on background color brightness
function getTextColor(backgroundColor) {
    const color = (0, _chromaJsDefault.default)(backgroundColor);
    const luminance = color.luminance();
    return luminance > 0.5 ? "black" : "white";
}
function RoleTag({ role }) {
    const roleColor = role.color ? `${role.color}` : "#99AAB5"; // Default Discord color
    const roleColorWithAlpha = (0, _chromaJsDefault.default)(roleColor).alpha(0.8);
    const bgColor = roleColorWithAlpha.css();
    const textColor = getTextColor(bgColor);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            style: {
                color: textColor,
                opacity: 0.6
            },
            className: "font-bold",
            children: [
                "@",
                role.name
            ]
        })
    });
}
function EligibleRolesIndicator({ eligibleRoleIds }) {
    const roles = (0, _useRoles.useRoles)();
    if (!eligibleRoleIds || eligibleRoleIds.length === 0) return null;
    const eligibleRoles = roles ? eligibleRoleIds.map((id)=>roles.find((role)=>role.id === id)).filter((role)=>role) // Filter out undefined roles
     : [];
    const roleNamesString = eligibleRoles.length > 0 ? eligibleRoles.map((role)=>role.name).join(", ") : "Loading roles...";
    // Create tooltip JSX content with colored role badges
    const tooltipContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-2",
                children: (0, _eligibleRolesSettingsItem.ELIGIBLE_ROLES_SETTINGS).description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1",
                children: "Restricted to roles:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-wrap items-center justify-center gap-1",
                children: eligibleRoles.map((role)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RoleTag, {
                        role: role
                    }, role.id))
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltipPortaled.WithTooltipPortaled), {
        style: "Info",
        tooltip: tooltipContent,
        no_delay: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: "inline-flex items-center rounded-full bg-base-dark px-2 py-1 text-xs font-medium text-sesh-primary",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-user-shield mr-1"
                }),
                (0, _eligibleRolesSettingsItem.ELIGIBLE_ROLES_SETTINGS).title
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../dashboard/forms/improved_components/hooks/use_roles":"b2XTr","../../dashboard/forms/improved_components/tooltips/with_tooltip_portaled":"6LBvw","./eligible_roles_settings_item":"j5iSo","chroma-js":"4nIac","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"154VM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFinderEdit", ()=>TimeFinderEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _timeFinder = require("../../../../time-finder/components/time_finder");
var _trpc = require("../../../utils/trpc");
var _loadingThrobber = require("../base_components/loading_throbber");
var _luxon = require("luxon");
var _commonUtils = require("../../../../../../common/common_utils");
var _useGuildData = require("../hooks/use_guild_data");
var _dashboardUtils = require("../../../dashboard_utils");
var _useRoles = require("../hooks/use_roles");
var _useChannelName = require("../hooks/use_channel_name");
function TimeFinderEdit(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const { server_id } = (0, _reactRouterDom.useParams)();
    const mutation = (0, _trpc.trpc).time_finder.updateTimeFinder.useMutation({
        onSuccess: ()=>{
            history.push((0, _commonUtils.common_utils).getTimeFinderURL({
                server_id: server_id,
                type: "view",
                instance_id: props.time_finder_id
            }));
        }
    });
    const time_finder_query = (0, _trpc.trpc).time_finder.getById.useQuery({
        id: props.time_finder_id,
        guild_id: server_id
    });
    const does_have_permission_query = (0, _trpc.trpc).members.doesUserHavePermission.useQuery({
        guild_id: server_id,
        permission: "create"
    }, {
        onSuccess: (val)=>{}
    });
    const guild = (0, _useGuildData.useCurrentGuildData)();
    const roles = (0, _useRoles.useRoles)();
    // Get channel name for the edit display - call before any conditional returns
    const channelName = (0, _useChannelName.useChannelName)(time_finder_query.data?.channel_id || "", true // include_hashtag
    );
    if (does_have_permission_query.isSuccess && !does_have_permission_query.data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-full  flex-col items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).RenderErrorContent, {
            text: "You must have 'create' permissions in order to create a time finder.",
            title: "Invalid Permissions"
        })
    });
    if (!time_finder_query.isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {});
    // Convert the server datetime format to the format expected by AppTimeFinder
    const convertToTimeFinderOption = ()=>{
        const dateMap = new Map();
        time_finder_query.data.datetimes.forEach((datetime)=>{
            const dt = (0, _luxon.DateTime).fromMillis(datetime.start_time).toUTC();
            const dateKey = `${dt.year}-${dt.month}-${dt.day}`;
            if (!dateMap.has(dateKey)) dateMap.set(dateKey, {
                date: {
                    day: dt.day,
                    month: dt.month,
                    year: dt.year
                },
                timeslots: []
            });
            // If this has end times, add them to timeslots
            if (time_finder_query.data.are_times_specified) {
                const startOfDay = dt.startOf("day");
                dateMap.get(dateKey).timeslots.push({
                    start_time: datetime.start_time,
                    end_time: datetime.end_time
                });
            }
        });
        return Array.from(dateMap.values());
    };
    const timeFinderOptions = convertToTimeFinderOption();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinder.AppTimeFinder), {
        onSubmit: (data)=>{
            mutation.mutate({
                id: props.time_finder_id,
                guild_id: server_id,
                title: data.title,
                description: data.description,
                selected_dates: data.selected_dates,
                are_times_specified: data.are_times_specified,
                is_public: data.is_public,
                anonymous_voting: data.anonymous_voting,
                hide_votes: data.hide_votes,
                eligible_role_ids: data.eligible_role_ids,
                user_mentions_on_create: data.user_mentions_on_create,
                role_mentions_on_create: data.role_mentions_on_create
            });
        },
        is_loading: mutation.isLoading,
        is_public: time_finder_query.data.is_public,
        is_on_dashboard: true,
        does_have_premium: guild?.is_premium,
        roles: roles,
        is_edit: true,
        initial_data: {
            title: time_finder_query.data.title,
            description: time_finder_query.data.description,
            selected_dates: timeFinderOptions,
            are_times_specified: time_finder_query.data.are_times_specified,
            anonymous_voting: time_finder_query.data.anonymous_voting,
            hide_votes: time_finder_query.data.hide_votes,
            eligible_role_ids: time_finder_query.data.eligible_role_ids || [],
            user_mentions_on_create: time_finder_query.data.user_mentions_on_create || [],
            role_mentions_on_create: time_finder_query.data.role_mentions_on_create || [],
            channel_id: time_finder_query.data.channel_id,
            channel_name: channelName
        }
    });
}

},{"react/jsx-runtime":"dpQXr","react-router-dom":"djWTS","../../../../time-finder/components/time_finder":"h3qmW","../../../utils/trpc":"dyYvM","../base_components/loading_throbber":"1I8d2","luxon":"fLWpi","../../../../../../common/common_utils":"gACUC","../hooks/use_guild_data":"ljx0Q","../../../dashboard_utils":"jvA8A","../hooks/use_roles":"b2XTr","../hooks/use_channel_name":"hA9Qq","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ij2CK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignUpOptionsForm", ()=>SignUpOptionsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("../../../common/constants");
var _rsvpOptions = require("./forms/rsvp_options");
var _rsvpOptionsDefault = parcelHelpers.interopDefault(_rsvpOptions);
var _fadeIn = require("../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _dashboardUtils = require("./dashboard_utils");
class SignUpOptionsForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let value = props.initial_value ? props.initial_value : (0, _constants.Constants).EMBED_COLOR;
        this.state = {
            color: value,
            intermediate_color: value
        };
    }
    handleChangeDrag(event) {
        this.setState({
            intermediate_color: event.hex
        });
    }
    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
            transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "columns is-centered",
                style: {
                    transition: "opacity 0.5s",
                    opacity: "1"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "column is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "title is-3",
                            children: "Edit Signup Option Presets"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rsvpOptionsDefault.default), {
                            is_premium: this.props.is_premium,
                            user_presets: this.props.user_presets,
                            user_id: this.props.user_id,
                            custom_emojis: this.props.custom_emojis,
                            all_guild_data: this.props.all_guild_data,
                            updateFunc: ()=>{},
                            dm_data: this.props.dm_data,
                            token_type: this.props.auth_token.token_type,
                            access_token: this.props.auth_token.access_token
                        })
                    ]
                })
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../common/constants":"lLiun","./forms/rsvp_options":"6SLLX","../../../src/vendored/FadeIn":"aMGHU","./dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"52Uq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kg9va":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"6RWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6RWgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5mymf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2OdDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eIHvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TIMESTAMP_TYPES", ()=>TIMESTAMP_TYPES);
var _luxon = require("luxon");
const TIMESTAMP_TYPES = {
    F: (d)=>d.toLocaleString({
            month: "long",
            weekday: "long",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    f: (d)=>d.toLocaleString({
            month: "long",
            year: "numeric",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric"
        }),
    D: (d)=>d.toLocaleString({
            month: "long",
            day: "2-digit",
            year: "numeric"
        }),
    d: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric"
        }),
    t: (d)=>d.toLocaleString({
            hour: "numeric",
            minute: "numeric"
        }),
    T: (d)=>d.toLocaleString((0, _luxon.DateTime).TIME_WITH_SECONDS),
    R: (d)=>d.toRelative({}),
    s: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    S: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        })
};

},{"luxon":"fLWpi","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},["7f1Tj"], "7f1Tj", "parcelRequire7ff5", {})

//# sourceMappingURL=dashboard.5ab27d3c.js.map
